import QuillDelta from "quill-delta";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type LocalizedString = { languageID: string; text: string; }[];
export type LocalizedAttributedString = { languageID: string; text: QuillDelta; }[]
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  LocalDate: { input: string; output: string; }
  LocalizedAttributedString: { input: LocalizedAttributedString; output: LocalizedAttributedString; }
  LocalizedString: { input: LocalizedString; output: LocalizedString; }
  QuillDelta: { input: any; output: any; }
  TimeZoneID: { input: any; output: any; }
};

export type AiChat = {
  __typename?: 'AIChat';
  id: Scalars['ID']['output'];
  messages: Array<AiChatMessage>;
};

export type AiChatMessage = {
  __typename?: 'AIChatMessage';
  sender: AiChatMessageSender;
  text: Scalars['String']['output'];
};

export enum AiChatMessageSender {
  Ai = 'AI',
  User = 'USER'
}

export type AiGeneratedCompetenciesResponse = {
  __typename?: 'AIGeneratedCompetenciesResponse';
  chat: AiChat;
  suggestion?: Maybe<Array<AiGeneratedCompetenciesSuggestion>>;
};

export type AiGeneratedCompetenciesSuggestion = {
  __typename?: 'AIGeneratedCompetenciesSuggestion';
  description: Scalars['String']['output'];
  levels: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type AiGeneratedGoalResponse = {
  __typename?: 'AIGeneratedGoalResponse';
  chat: AiChat;
  suggestion?: Maybe<AiGeneratedGoalSuggestion>;
};

export type AiGeneratedGoalSuggestion = {
  __typename?: 'AIGeneratedGoalSuggestion';
  description: Scalars['String']['output'];
  subgoals: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type AiMessage = {
  __typename?: 'AIMessage';
  text: Scalars['String']['output'];
};

export type AiResponse = {
  __typename?: 'AIResponse';
  messages: Array<AiMessage>;
};

export type ActivateJobPositionInput = {
  id: Scalars['ID']['input'];
};

export type ActivateJobPositionResponse = {
  __typename?: 'ActivateJobPositionResponse';
  jobPosition: JobPosition;
};

export type AdvanceAiChatInput = {
  chatID: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  userResponse: Scalars['String']['input'];
};

export type AgentChat = {
  __typename?: 'AgentChat';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  messages: Array<AgentChatMessage>;
  subject?: Maybe<User>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usage?: Maybe<AgentChatUsage>;
};

export type AgentChatMessage = {
  __typename?: 'AgentChatMessage';
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  role: AgentChatMessageRole;
  toolCallId?: Maybe<Scalars['ID']['output']>;
  toolCalls?: Maybe<Array<AgentChatToolCall>>;
};

export enum AgentChatMessageRole {
  Assistant = 'ASSISTANT',
  System = 'SYSTEM',
  Tool = 'TOOL',
  User = 'USER'
}

export type AgentChatToolCall = {
  __typename?: 'AgentChatToolCall';
  arguments?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AgentChatUsage = {
  __typename?: 'AgentChatUsage';
  cacheWriteTokens?: Maybe<Scalars['Int']['output']>;
  cachedInputTokens?: Maybe<Scalars['Int']['output']>;
  inputTokens?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
};

export type Analytics = {
  __typename?: 'Analytics';
  detail?: Maybe<AnalyticsDetail>;
  detailTableList: Array<AnalyticsDetailTableInfo>;
  metricGroup: AnalyticsMetricGroup;
  metricGroups: Array<AnalyticsMetricGroup>;
  totalUsers: Scalars['Int']['output'];
};


export type AnalyticsDetailArgs = {
  id: Scalars['ID']['input'];
  pageIndex?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<AnalyticsDetailSortOrder>;
  tableID?: InputMaybe<Scalars['ID']['input']>;
};


export type AnalyticsDetailTableListArgs = {
  id: Scalars['ID']['input'];
};


export type AnalyticsMetricGroupArgs = {
  id: Scalars['ID']['input'];
};

export enum AnalyticsBucketSize {
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK'
}

export type AnalyticsConversationTemplateMetric = {
  __typename?: 'AnalyticsConversationTemplateMetric';
  template: EvaluationForm;
  total: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export type AnalyticsConversationsMetric = {
  __typename?: 'AnalyticsConversationsMetric';
  id: Scalars['ID']['output'];
  templates: Array<AnalyticsConversationTemplateMetric>;
  threshold: Scalars['Float']['output'];
};

export type AnalyticsDetail = {
  __typename?: 'AnalyticsDetail';
  headers: Array<AnalyticsDetailHeader>;
  id: Scalars['ID']['output'];
  pageIndex: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  rows: Array<AnalyticsDetailRow>;
  sortBy: Scalars['String']['output'];
  sortOrder: AnalyticsDetailSortOrder;
  totalRows: Scalars['Int']['output'];
};

export type AnalyticsDetailColumn = {
  __typename?: 'AnalyticsDetailColumn';
  key: Scalars['String']['output'];
  value?: Maybe<AnalyticsDetailColumnValue>;
};

export type AnalyticsDetailColumnValue = AnalyticsDetailDate | AnalyticsDetailFloat | AnalyticsDetailFraction | AnalyticsDetailInt | AnalyticsDetailList | AnalyticsDetailPercentage | AnalyticsDetailText | EvaluationForm | EvaluationSubmission | FeedbackQuestionCategory | FeedbackRequest | Goal | Group | JobTitle | LearningEvent | User;

export type AnalyticsDetailDate = {
  __typename?: 'AnalyticsDetailDate';
  date: Scalars['DateTime']['output'];
};

export type AnalyticsDetailFloat = {
  __typename?: 'AnalyticsDetailFloat';
  float: Scalars['Float']['output'];
};

export type AnalyticsDetailFraction = {
  __typename?: 'AnalyticsDetailFraction';
  total: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export type AnalyticsDetailHeader = {
  __typename?: 'AnalyticsDetailHeader';
  detailViewOnly?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  sortable?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type AnalyticsDetailInt = {
  __typename?: 'AnalyticsDetailInt';
  integer: Scalars['Int']['output'];
};

export type AnalyticsDetailList = {
  __typename?: 'AnalyticsDetailList';
  items: Array<AnalyticsDetailColumnValue>;
};

export type AnalyticsDetailPercentage = {
  __typename?: 'AnalyticsDetailPercentage';
  percentage: Scalars['Float']['output'];
};

export type AnalyticsDetailRow = {
  __typename?: 'AnalyticsDetailRow';
  columns: Array<AnalyticsDetailColumn>;
};

export enum AnalyticsDetailSortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type AnalyticsDetailTableInfo = {
  __typename?: 'AnalyticsDetailTableInfo';
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type AnalyticsDetailText = {
  __typename?: 'AnalyticsDetailText';
  text: Scalars['String']['output'];
};

export type AnalyticsEngagementEnps = {
  __typename?: 'AnalyticsEngagementENPS';
  detractors?: Maybe<Scalars['Int']['output']>;
  passives?: Maybe<Scalars['Int']['output']>;
  promoters?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  totalRequestsCompleted?: Maybe<Scalars['Int']['output']>;
  totalRequestsSent?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsEngagementGroupEnps = {
  __typename?: 'AnalyticsEngagementGroupENPS';
  detractors?: Maybe<Scalars['Int']['output']>;
  group: Group;
  passives?: Maybe<Scalars['Int']['output']>;
  promoters?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  totalRequestsCompleted?: Maybe<Scalars['Int']['output']>;
  totalRequestsSent?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsEngagementGroupParticipation = {
  __typename?: 'AnalyticsEngagementGroupParticipation';
  delta?: Maybe<Scalars['Float']['output']>;
  group: Group;
  participation?: Maybe<Scalars['Float']['output']>;
};

export type AnalyticsEngagementGroupSubcategoryScore = {
  __typename?: 'AnalyticsEngagementGroupSubcategoryScore';
  delta?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<Group>;
  score?: Maybe<Scalars['Float']['output']>;
  subcategory?: Maybe<EngagementSubcategory>;
};

export type AnalyticsEngagementOpenQuestion = {
  __typename?: 'AnalyticsEngagementOpenQuestion';
  answers: Array<AnalyticsEngagementOpenQuestionAnswer>;
  question: EngagementQuestion;
};

export type AnalyticsEngagementOpenQuestionAnswer = {
  __typename?: 'AnalyticsEngagementOpenQuestionAnswer';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type AnalyticsEngagementParticipation = {
  __typename?: 'AnalyticsEngagementParticipation';
  average?: Maybe<Scalars['Float']['output']>;
  datapoints: Array<AnalyticsEngagementParticipationDatapoint>;
  delta?: Maybe<Scalars['Float']['output']>;
};

export type AnalyticsEngagementParticipationDatapoint = {
  __typename?: 'AnalyticsEngagementParticipationDatapoint';
  completed?: Maybe<Scalars['Int']['output']>;
  timestamp: Scalars['DateTime']['output'];
  total?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsEngagementQuestionScoreTrend = {
  __typename?: 'AnalyticsEngagementQuestionScoreTrend';
  datapoints: Array<AnalyticsEngagementScoreDatapoint>;
  delta?: Maybe<Scalars['Float']['output']>;
  question: EngagementQuestion;
};

export type AnalyticsEngagementScore = {
  __typename?: 'AnalyticsEngagementScore';
  datapoints: Array<AnalyticsEngagementScoreDatapoint>;
  delta?: Maybe<Scalars['Float']['output']>;
};

export type AnalyticsEngagementScoreDatapoint = {
  __typename?: 'AnalyticsEngagementScoreDatapoint';
  score?: Maybe<Scalars['Float']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type AnalyticsEngagementSubcategoryScoreOverTime = {
  __typename?: 'AnalyticsEngagementSubcategoryScoreOverTime';
  datapoints: Array<AnalyticsEngagementScoreDatapoint>;
  delta?: Maybe<Scalars['Float']['output']>;
  subcategory: EngagementSubcategory;
};

export type AnalyticsFilterGroup = {
  id: Scalars['ID']['input'];
  type: GroupType;
};

export type AnalyticsFilters = {
  endDate: Scalars['DateTime']['input'];
  engagementRequestID?: InputMaybe<Scalars['ID']['input']>;
  engagementTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Use `userFilter` instead. */
  excludeInactiveUsers?: InputMaybe<Scalars['Boolean']['input']>;
  groupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['DateTime']['input'];
  userFilter?: InputMaybe<AnalyticsUserFilter>;
  userIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AnalyticsFiltersV2 = {
  endDate: Scalars['DateTime']['input'];
  engagementOfficerMetricsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  engagementRequestID?: InputMaybe<Scalars['ID']['input']>;
  engagementTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Use `userFilter` instead. */
  excludeInactiveUsers?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<Array<AnalyticsFilterGroup>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  userFilter?: InputMaybe<AnalyticsUserFilter>;
};

export type AnalyticsFloatDatapoint = {
  __typename?: 'AnalyticsFloatDatapoint';
  timestamp: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type AnalyticsFloatMetric = {
  __typename?: 'AnalyticsFloatMetric';
  details: Array<Scalars['ID']['output']>;
  float?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  threshold: Scalars['Float']['output'];
};

export type AnalyticsFractionMetric = {
  __typename?: 'AnalyticsFractionMetric';
  details: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  threshold: Scalars['Float']['output'];
  total: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export type AnalyticsGraphMetric = {
  __typename?: 'AnalyticsGraphMetric';
  datapoints: Array<AnalyticsFloatDatapoint>;
  id: Scalars['ID']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type AnalyticsIntegerMetric = {
  __typename?: 'AnalyticsIntegerMetric';
  details: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  integer: Scalars['Int']['output'];
  threshold: Scalars['Float']['output'];
};

export type AnalyticsManager = {
  __typename?: 'AnalyticsManager';
  allowedUsers: Array<Scalars['ID']['output']>;
  snapshotId: Scalars['ID']['output'];
};

export type AnalyticsMetric = AnalyticsConversationsMetric | AnalyticsFloatMetric | AnalyticsFractionMetric | AnalyticsGraphMetric | AnalyticsIntegerMetric | AnalyticsPercentageMetric;

export type AnalyticsMetricGroup = {
  __typename?: 'AnalyticsMetricGroup';
  id: Scalars['ID']['output'];
  metric: AnalyticsMetric;
  metrics: Array<AnalyticsMetric>;
};


export type AnalyticsMetricGroupMetricArgs = {
  id: Scalars['ID']['input'];
};

export type AnalyticsPercentageMetric = {
  __typename?: 'AnalyticsPercentageMetric';
  details: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  threshold: Scalars['Float']['output'];
};

export type AnalyticsSnapshot = {
  __typename?: 'AnalyticsSnapshot';
  syncedAt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum AnalyticsType {
  Group = 'GROUP',
  User = 'USER',
  Workspace = 'WORKSPACE'
}

export enum AnalyticsUserFilter {
  ActiveAtEndDate = 'ACTIVE_AT_END_DATE'
}

export type AnalyticsWorkspaceSnapshot = {
  __typename?: 'AnalyticsWorkspaceSnapshot';
  alias: Scalars['String']['output'];
  syncedAt?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  workspaceID: Scalars['ID']['output'];
};

export type Announcement = {
  __typename?: 'Announcement';
  content: Scalars['LocalizedAttributedString']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  displayType: AnnouncementDisplayType;
  enabled: Scalars['Boolean']['output'];
  filters: AnnouncementFilters;
  headerImage?: Maybe<AnnouncementAsset>;
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['LocalizedString']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type AnnouncementAsset = {
  __typename?: 'AnnouncementAsset';
  id: Scalars['ID']['output'];
  source: AssetVariant;
};

export type AnnouncementConnection = {
  __typename?: 'AnnouncementConnection';
  edges: Array<AnnouncementEdge>;
  pageInfo: PageInfo;
};

export enum AnnouncementDisplayType {
  Banner = 'BANNER',
  Modal = 'MODAL'
}

export type AnnouncementEdge = {
  __typename?: 'AnnouncementEdge';
  cursor: Scalars['ID']['output'];
  node: Announcement;
};

export type AnnouncementFilters = {
  __typename?: 'AnnouncementFilters';
  excludedWorkspaces: Array<Workspace>;
  superUserOnly?: Maybe<Scalars['Boolean']['output']>;
  workspaces: Array<Workspace>;
};

export type AnnouncementFiltersInput = {
  excludedWorkspaceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  superUserOnly?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceIDs: Array<Scalars['ID']['input']>;
};

export type AnswerTalentReviewPlacementHelpInput = {
  answers: Array<TalentReviewPlacementHelpAnswerInput>;
  groupID: Scalars['ID']['input'];
  localDate: Scalars['LocalDate']['input'];
  templateID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type AnswerTalentReviewPlacementHelpResponse = {
  __typename?: 'AnswerTalentReviewPlacementHelpResponse';
  grid: TalentReviewGrid;
};

export type ApiTokenDescription = {
  __typename?: 'ApiTokenDescription';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type ApiTokenNotificationEmail = {
  __typename?: 'ApiTokenNotificationEmail';
  email: Scalars['String']['output'];
};

/**
 * A machine account that authenticates with a personal access token and is
 * restricted to an explicit permission whitelist. Invisible everywhere else.
 */
export type ApiUser = {
  __typename?: 'ApiUser';
  /** The Cognito username of the account; shown as the API Key. */
  apiKey: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Whitelisted `Type.capability` strings. Empty means the account can call nothing. */
  permissions: Array<Scalars['String']['output']>;
  /** When the current API secret was issued, or null if the account has none. */
  secretCreatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApiUserCredentials = {
  __typename?: 'ApiUserCredentials';
  /** The plaintext personal access token. Only ever returned once. */
  apiSecret: Scalars['String']['output'];
  user: ApiUser;
};

export type AppendTranscriptionInput = {
  /**
   * Length of the transcript the client believes is stored. The append is only
   * applied when it matches.
   */
  expectedLength: Scalars['Int']['input'];
  /**
   * Marks the first text of a new streaming session, which is preceded by a
   * <BREAK> line when the transcript is not empty.
   */
  newSession?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Replaces the transcript from this offset onward with the text instead of
   * appending, used to apply speaker revisions to the current session.
   */
  replaceFrom?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
  transcriptionID: Scalars['String']['input'];
};

export type AppendTranscriptionResponse = {
  __typename?: 'AppendTranscriptionResponse';
  applied: Scalars['Boolean']['output'];
  transcription: Transcription;
};

export type ApplyStyrJobMappingsInput = {
  mappings: Array<StyrJobMappingInput>;
};

export type ApproveFeatureConditionsInput = {
  conditionsVersion: Scalars['String']['input'];
  featureID: FeatureName;
};

export type ApproveFeatureConditionsResponse = {
  __typename?: 'ApproveFeatureConditionsResponse';
  approval: FeatureApproval;
  workspace: Workspace;
};

export type ArchiveCommentInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveCommentResponse = {
  __typename?: 'ArchiveCommentResponse';
  comment: Comment;
  /** @deprecated Use `comment` instead. */
  success: Scalars['Boolean']['output'];
};

export type ArchiveCompetencyBookmarkInput = {
  /** ID of the competency bookmark to archive. */
  competencyID: Scalars['ID']['input'];
  /** ID of the user that this competency belongs to. */
  userID: Scalars['ID']['input'];
};

export type ArchiveCompetencyBookmarkResponse = {
  __typename?: 'ArchiveCompetencyBookmarkResponse';
  /** Contains the archived competency bookmark. */
  competencyBookmark: CompetencyBookmark;
};

export type ArchiveCompetencyInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveCompetencyLevelSetInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveCompetencyLevelSetResponse = {
  __typename?: 'ArchiveCompetencyLevelSetResponse';
  competencyLevelSet: CompetencyLevelSet;
};

export type ArchiveCompetencyResponse = {
  __typename?: 'ArchiveCompetencyResponse';
  competency: Competency;
};

export type ArchiveComplimentInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveComplimentResponse = {
  __typename?: 'ArchiveComplimentResponse';
  compliment: Compliment;
};

export type ArchiveCycleTemplateInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveCycleTemplateResponse = {
  __typename?: 'ArchiveCycleTemplateResponse';
  cycleTemplate: CycleTemplate;
};

export type ArchiveEngagementCategoryInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveEngagementCategoryResponse = {
  __typename?: 'ArchiveEngagementCategoryResponse';
  category: EngagementCategory;
};

export type ArchiveEngagementQuestionInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveEngagementQuestionResponse = {
  __typename?: 'ArchiveEngagementQuestionResponse';
  question: EngagementQuestion;
};

export type ArchiveEngagementSubcategoryInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveEngagementSubcategoryResponse = {
  __typename?: 'ArchiveEngagementSubcategoryResponse';
  subcategory: EngagementSubcategory;
};

export type ArchiveEvaluationFormInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveEvaluationFormResponse = {
  __typename?: 'ArchiveEvaluationFormResponse';
  evaluationForm: EvaluationForm;
};

export type ArchiveEvaluationSubmissionInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveEvaluationSubmissionResponse = {
  __typename?: 'ArchiveEvaluationSubmissionResponse';
  evaluationSubmission: EvaluationSubmission;
};

export type ArchiveExpertiseInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveFeedbackQuestionCategoryInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveFeedbackQuestionCategoryResponse = {
  __typename?: 'ArchiveFeedbackQuestionCategoryResponse';
  feedbackQuestionCategory: FeedbackQuestionCategory;
};

export type ArchiveFeedbackQuestionInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveFeedbackQuestionResponse = {
  __typename?: 'ArchiveFeedbackQuestionResponse';
  feedbackQuestion: FeedbackQuestion;
};

export type ArchiveFeedbackRequestInput = {
  /** This is the ID of the request that should be archived. */
  id: Scalars['ID']['input'];
};

export type ArchiveFeedbackRequestResponse = {
  __typename?: 'ArchiveFeedbackRequestResponse';
  /** This field contains the archived feedback request. */
  feedbackRequest: FeedbackRequest;
};

export type ArchiveFeedbackResponseInput = {
  responseID: Scalars['ID']['input'];
};

export type ArchiveFeedbackResponseResponse = {
  __typename?: 'ArchiveFeedbackResponseResponse';
  feedbackResponse: FeedbackResponse;
};

export type ArchiveFeedbackTemplateInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveFeedbackTemplateResponse = {
  __typename?: 'ArchiveFeedbackTemplateResponse';
  feedbackTemplate: FeedbackTemplate;
};

export type ArchiveGoalDriverInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveGoalDriverResponse = {
  __typename?: 'ArchiveGoalDriverResponse';
  success: Scalars['Boolean']['output'];
};

export type ArchiveGoalInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveGoalResponse = {
  __typename?: 'ArchiveGoalResponse';
  goal: Goal;
};

export type ArchiveGoalTemplateInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveGoalTemplateResponse = {
  __typename?: 'ArchiveGoalTemplateResponse';
  goalTemplate: GoalTemplate;
};

export type ArchiveGroupInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveGroupResponse = {
  __typename?: 'ArchiveGroupResponse';
  group: Group;
};

export type ArchiveInboxTaskInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveInboxTaskResponse = {
  __typename?: 'ArchiveInboxTaskResponse';
  inboxTask: InboxTask;
};

export type ArchiveJobLevelInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveJobLevelResponse = {
  __typename?: 'ArchiveJobLevelResponse';
  jobLevel: JobLevel;
};

export type ArchiveJobPositionInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveJobPositionResponse = {
  __typename?: 'ArchiveJobPositionResponse';
  jobPosition: JobPosition;
};

export type ArchiveJobPositionSuccessorInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveJobPositionSuccessorResponse = {
  __typename?: 'ArchiveJobPositionSuccessorResponse';
  successor: JobPositionSuccessor;
};

export type ArchiveJobTitleInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveJobTitleResponse = {
  __typename?: 'ArchiveJobTitleResponse';
  jobTitle: JobTitle;
};

export type ArchiveLabelInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveLabelResponse = {
  __typename?: 'ArchiveLabelResponse';
  label: Label;
};

export type ArchiveLearningEventInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveLearningEventResponse = {
  __typename?: 'ArchiveLearningEventResponse';
  learningEvent: LearningEvent;
};

export type ArchiveLearningSubjectInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveLearningSubjectResponse = {
  __typename?: 'ArchiveLearningSubjectResponse';
  learningSubject: LearningSubject;
};

export type ArchiveLearningTypeInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveLearningTypeResponse = {
  __typename?: 'ArchiveLearningTypeResponse';
  learningType: LearningType;
};

export type ArchiveNoteInput = {
  noteID: Scalars['ID']['input'];
};

export type ArchiveNoteResponse = {
  __typename?: 'ArchiveNoteResponse';
  note: Note;
};

export type ArchiveTalentReviewInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveTalentReviewResponse = {
  __typename?: 'ArchiveTalentReviewResponse';
  talentReview: TalentReview;
};

export type ArchiveTalentReviewSnapshotInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveTalentReviewSnapshotResponse = {
  __typename?: 'ArchiveTalentReviewSnapshotResponse';
  snapshot: TalentReviewSnapshot;
};

export type ArchiveTalentReviewTemplateInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveTalentReviewTemplateResponse = {
  __typename?: 'ArchiveTalentReviewTemplateResponse';
  template: TalentReviewTemplate;
};

export type ArchiveUserInput = {
  id: Scalars['ID']['input'];
};

export type ArchiveUserResponse = {
  __typename?: 'ArchiveUserResponse';
  user: User;
};

export type ArchiveWorkspaceInput = {
  workspaceID: Scalars['String']['input'];
};

export type ArchiveWorkspaceResponse = {
  __typename?: 'ArchiveWorkspaceResponse';
  workspace: Workspace;
};

export type Asset = {
  __typename?: 'Asset';
  contentLength: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  externalReferenceID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  source: AssetVariant;
};

export type AssetUploadEndpoint = {
  __typename?: 'AssetUploadEndpoint';
  headers: Array<AssetUploadHeader>;
  url: Scalars['String']['output'];
};

export type AssetUploadHeader = {
  __typename?: 'AssetUploadHeader';
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type AssetVariant = {
  __typename?: 'AssetVariant';
  url: Scalars['String']['output'];
};

export type AssignRoleInput = {
  externalReferenceID?: InputMaybe<Scalars['String']['input']>;
  isIndirect: Scalars['Boolean']['input'];
  roleID: Scalars['ID']['input'];
  targetID: Scalars['ID']['input'];
  targetType: RoleTargetType;
  userID: Scalars['ID']['input'];
};

export type AssignRoleResponse = {
  __typename?: 'AssignRoleResponse';
  user: User;
};

export type AssociateAutoSelectedIdentityInput = {
  userID: Scalars['ID']['input'];
};

export type AssociateAutoSelectedIdentityResponse = {
  __typename?: 'AssociateAutoSelectedIdentityResponse';
  hasUpdatedIdentity: Scalars['Boolean']['output'];
  providerID?: Maybe<Scalars['ID']['output']>;
};

export type AssociateIdentityInput = {
  identityProviderID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  userID: Scalars['ID']['input'];
};

export type AssociateIdentityResponse = {
  __typename?: 'AssociateIdentityResponse';
  user: User;
};

export type AssociateTotpTokenInput = {
  session?: InputMaybe<Scalars['String']['input']>;
};

export type AssociateTotpTokenResponse = {
  __typename?: 'AssociateTotpTokenResponse';
  secretCode: Scalars['String']['output'];
  session?: Maybe<Scalars['String']['output']>;
};

export type AssociatedIdentity = {
  __typename?: 'AssociatedIdentity';
  identityProvider: IdentityProvider;
  name: Scalars['String']['output'];
};

export type AttachJobCompetencyInput = {
  competencyID: Scalars['ID']['input'];
  competencyLevel: Scalars['Int']['input'];
  jobLevelID?: InputMaybe<Scalars['ID']['input']>;
  jobTitleID: Scalars['ID']['input'];
};

export type AttachJobCompetencyResponse = {
  __typename?: 'AttachJobCompetencyResponse';
  jobTitle: JobTitle;
};

export type AttachJobGoalTemplateInput = {
  competency?: InputMaybe<CompetencyGoalInput>;
  description: Scalars['LocalizedAttributedString']['input'];
  jobLevelID?: InputMaybe<Scalars['ID']['input']>;
  jobTitleID: Scalars['ID']['input'];
  relativeDueDate?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['LocalizedString']['input'];
};

export type AttachJobGoalTemplateResponse = {
  __typename?: 'AttachJobGoalTemplateResponse';
  jobTitle: JobTitle;
};

export type AttachTalentReviewToMomentInput = {
  momentID: Scalars['ID']['input'];
  talentReviewID: Scalars['ID']['input'];
};

export type AttachTalentReviewToMomentResponse = {
  __typename?: 'AttachTalentReviewToMomentResponse';
  momentInstance: MomentInstance;
};

export type AttendeeProposal = {
  __typename?: 'AttendeeProposal';
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  startsAt: Scalars['DateTime']['output'];
};

export enum AttendeeStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  NeedsAction = 'NEEDS_ACTION',
  Tentative = 'TENTATIVE'
}

export type AuditTrail = {
  __typename?: 'AuditTrail';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  field: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  newValue?: Maybe<AuditValue>;
  oldValue?: Maybe<AuditValue>;
};

export type AuditTrailConnection = {
  __typename?: 'AuditTrailConnection';
  edges: Array<AuditTrailEdge>;
};

export type AuditTrailEdge = {
  __typename?: 'AuditTrailEdge';
  node: AuditTrail;
};

export type AuditValue = {
  __typename?: 'AuditValue';
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  dateValue?: Maybe<Scalars['DateTime']['output']>;
  localizedStringValue?: Maybe<Scalars['LocalizedString']['output']>;
  percentageValue?: Maybe<Scalars['Float']['output']>;
  quillValue?: Maybe<Scalars['QuillDelta']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
};

export type Auditable = {
  auditTrail: AuditTrailConnection;
};


export type AuditableAuditTrailArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AuthorizationStateInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  authorizingWorkspaceID: Scalars['String']['input'];
  workspaceID: Scalars['String']['input'];
};

export type AutoLinkSlackIdentitiesResponse = {
  __typename?: 'AutoLinkSlackIdentitiesResponse';
  success: Scalars['Boolean']['output'];
};

export enum BillingCollectionMethod {
  ChargeAutomatically = 'CHARGE_AUTOMATICALLY',
  SendInvoice = 'SEND_INVOICE'
}

export enum BillingInterval {
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export type CancelEngagementRequestInput = {
  id: Scalars['ID']['input'];
};

export type CancelEngagementRequestResponse = {
  __typename?: 'CancelEngagementRequestResponse';
  engagementRequest: EngagementRequest;
};

export type CancelLearningEventInput = {
  id: Scalars['ID']['input'];
};

export type CancelLearningEventResponse = {
  __typename?: 'CancelLearningEventResponse';
  learningEvent: LearningEvent;
};

export type CancelMeetingInput = {
  cancelSeries?: InputMaybe<Scalars['Boolean']['input']>;
  target: MeetingTargetInput;
};

export type CancelMeetingResponse = {
  __typename?: 'CancelMeetingResponse';
  meeting: Meeting;
};

export type Career = {
  __typename?: 'Career';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedByUserID?: Maybe<Scalars['ID']['output']>;
  expertise: Expertise;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  jobTitles: Array<JobTitle>;
  title: Scalars['LocalizedString']['output'];
  workspaceID: Scalars['ID']['output'];
};

export type CareerArchiveInput = {
  id: Scalars['ID']['input'];
};

export type CareerCreateInput = {
  expertiseID: Scalars['ID']['input'];
  jobTitleIDs: Array<Scalars['ID']['input']>;
  title: Scalars['LocalizedString']['input'];
};

export type CareerRestoreInput = {
  id: Scalars['ID']['input'];
};

export type CareerUpdateInput = {
  expertiseID: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  jobTitleIDs: Array<Scalars['ID']['input']>;
  title: Scalars['LocalizedString']['input'];
};

export type CareersConnection = {
  __typename?: 'CareersConnection';
  edges: Array<CareersEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CareersEdge = {
  __typename?: 'CareersEdge';
  cursor: Scalars['ID']['output'];
  node: Career;
};

export type Challenge = {
  __typename?: 'Challenge';
  context: Scalars['String']['output'];
  mfaSetup?: Maybe<MfaSetupChallenge>;
  newPasswordRequired?: Maybe<NewPasswordRequiredChallenge>;
  password?: Maybe<PasswordChallenge>;
  singleSignOn?: Maybe<SingleSignOnChallenge>;
  totpMfa?: Maybe<TotpMfaChallenge>;
};

export type ChallengeResponse = {
  context: Scalars['String']['input'];
  mfaSetup?: InputMaybe<MfaSetupChallengeResponse>;
  newPasswordRequired?: InputMaybe<NewPasswordRequiredChallengeResponse>;
  password?: InputMaybe<PasswordChallengeResponse>;
  totpMfa?: InputMaybe<TotpMfaChallengeResponse>;
};

export type ChangeConversationPartnerInput = {
  id: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type ChangeConversationPartnerResponse = {
  __typename?: 'ChangeConversationPartnerResponse';
  evaluationSubmission: EvaluationSubmission;
};

export type ChangeLearningEventCoverInput = {
  assetID: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type ChangeLearningEventCoverResponse = {
  __typename?: 'ChangeLearningEventCoverResponse';
  learningEvent: LearningEvent;
};

export type ChangeUserActivatedAtInput = {
  /** @deprecated Use `localActivatedAt` instead. */
  activatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  localActivatedAt?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type ChangeUserActivatedAtResponse = {
  __typename?: 'ChangeUserActivatedAtResponse';
  success: Scalars['Boolean']['output'];
};

export type CheckSuppressedEmailInput = {
  email: Scalars['String']['input'];
};

export type CheckSuppressedEmailResponse = {
  __typename?: 'CheckSuppressedEmailResponse';
  isEmailSuppressed: Scalars['Boolean']['output'];
};

export enum ChecklistItemStatus {
  Completed = 'COMPLETED',
  Todo = 'TODO'
}

export type Checkpoint = {
  __typename?: 'Checkpoint';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
};

export enum CheckpointTargetType {
  Workspace = 'WORKSPACE'
}

export type ClearTalentReviewGridInput = {
  groupID: Scalars['ID']['input'];
  localDate: Scalars['LocalDate']['input'];
  templateID: Scalars['ID']['input'];
};

export type ClearTalentReviewGridResponse = {
  __typename?: 'ClearTalentReviewGridResponse';
  grid: TalentReviewGrid;
};

export type CodeDelivery = {
  __typename?: 'CodeDelivery';
  deliveryMedium: CodeDeliveryMedium;
  destination: Scalars['String']['output'];
};

export enum CodeDeliveryMedium {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type Comment = {
  __typename?: 'Comment';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<User>;
  content?: Maybe<Scalars['QuillDelta']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  metadata?: Maybe<Array<CommentMetadata>>;
  target: CommentTarget;
  targetID: Scalars['ID']['output'];
  targetType: CommentTargetType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  viewerCanArchive: Scalars['Boolean']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
};

export type CommentMetadata = {
  __typename?: 'CommentMetadata';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CommentMetadataInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CommentTarget = {
  comments: Array<Comment>;
  viewerCanComment: Scalars['Boolean']['output'];
  viewerCanViewComments: Scalars['Boolean']['output'];
};


export type CommentTargetCommentsArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CommentTargetType {
  Compliment = 'COMPLIMENT',
  EvaluationSubmission = 'EVALUATION_SUBMISSION',
  FeedbackResponse = 'FEEDBACK_RESPONSE',
  Goal = 'GOAL',
  Note = 'NOTE'
}

export type Competency = {
  __typename?: 'Competency';
  /**
   * Appraisals per user for this competency. Pass `userID` to restrict the result to
   * one user rather than every appraised user in the workspace.
   */
  appraisals: Array<CompetencyAppraisal>;
  attachableToGoal: Scalars['Boolean']['output'];
  competencyLevelSet: CompetencyLevelSet;
  description?: Maybe<Scalars['LocalizedAttributedString']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  /**
   * Job competency links that carry a job-specific description for this competency.
   * Only links with a non-empty description are returned.
   */
  jobCompetencies: Array<JobCompetency>;
  jobTitles: Array<JobTitle>;
  label?: Maybe<Label>;
  levels: Array<CompetencyLevelOption>;
  /**
   * Styr `skillId` for Styr-sourced competencies, null otherwise. Its presence indicates the
   * competency originates from the Styr integration.
   */
  styrSkillID?: Maybe<Scalars['String']['output']>;
  title: Scalars['LocalizedString']['output'];
};


export type CompetencyAppraisalsArgs = {
  userID?: InputMaybe<Scalars['ID']['input']>;
};

export type CompetencyAppraisal = {
  __typename?: 'CompetencyAppraisal';
  competency: Competency;
  competencyLevelIndex: Scalars['Float']['output'];
  /**
   * Individual feedback scores for this appraisal. `startDate`/`endDate` bound the
   * result to scores recorded in that window; omit both for the full history.
   *
   * Null when the scores could not be read within the request's time budget; the
   * appraisal itself is still valid and the error is reported alongside.
   */
  feedbackScores?: Maybe<Array<CompetencyFeedbackScore>>;
  user: User;
};


export type CompetencyAppraisalFeedbackScoresArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * A competency bookmark enables users to manually track their progress on
 * competencies that might not necessarily be related to their job. For example,
 * they might want to track additional competencies to grow towards a different
 * job, or to satisfy personal goals. This feature gives users the opportunity to
 * select any competency and a corresponding desired level, and to subsequently ask
 * for and analyze feedback on these competencies similar to job-defined
 * competencies.
 */
export type CompetencyBookmark = {
  __typename?: 'CompetencyBookmark';
  /** Competency that the user wants to attain a certain level of. */
  competency: Competency;
  /** Index of the competency level that a user wants to attain. */
  competencyLevelIndex: Scalars['Int']['output'];
  /** Date at which this competency bookmark was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * User that created this competency bookmark. This is not necessarily the same
   * as `user` as managers are also allowed to create competency bookmarks on
   * behalf of the managees.
   */
  createdBy: User;
  /**
   * Unique ID for this competency bookmark. Technically, this is a deterministic
   * concatenation of the user ID and the competency ID. As such, there will only
   * be one unique bookmark per user/competency pair.
   */
  id: Scalars['ID']['output'];
  /** User that this competency bookmark was created by or on behalf of. */
  user: User;
};

export type CompetencyBookmarkConnection = {
  __typename?: 'CompetencyBookmarkConnection';
  edges: Array<CompetencyBookmarkEdge>;
};

export type CompetencyBookmarkEdge = {
  __typename?: 'CompetencyBookmarkEdge';
  node: CompetencyBookmark;
};

export type CompetencyConnection = {
  __typename?: 'CompetencyConnection';
  edges: Array<CompetencyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompetencyEdge = {
  __typename?: 'CompetencyEdge';
  cursor: Scalars['ID']['output'];
  node: Competency;
};

export type CompetencyFeedbackScore = {
  __typename?: 'CompetencyFeedbackScore';
  competencyLevelIndex: Scalars['Int']['output'];
  feedbackResponse: FeedbackResponse;
  giver: CompetencyFeedbackScoreGiver;
  timestamp: Scalars['DateTime']['output'];
};

export type CompetencyFeedbackScoreExternalGiver = {
  __typename?: 'CompetencyFeedbackScoreExternalGiver';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type CompetencyFeedbackScoreGiver = CompetencyFeedbackScoreExternalGiver | User;

export type CompetencyGoal = {
  __typename?: 'CompetencyGoal';
  appraisals: Array<CompetencyAppraisal>;
  competency: Competency;
  competencyLevelIndex: Scalars['Int']['output'];
};

export type CompetencyGoalInput = {
  competencyID: Scalars['ID']['input'];
  competencyLevelIndex: Scalars['Int']['input'];
};

export type CompetencyLevel = {
  __typename?: 'CompetencyLevel';
  id: Scalars['ID']['output'];
  title: Scalars['LocalizedString']['output'];
};

export type CompetencyLevelOption = {
  __typename?: 'CompetencyLevelOption';
  criteria?: Maybe<Scalars['LocalizedAttributedString']['output']>;
  enabled: Scalars['Boolean']['output'];
  level: CompetencyLevel;
};

export type CompetencyLevelOptionInput = {
  competencyLevelID: Scalars['ID']['input'];
  criteria?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  enabled: Scalars['Boolean']['input'];
};

export type CompetencyLevelSet = {
  __typename?: 'CompetencyLevelSet';
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  levels: Array<CompetencyLevel>;
  title: Scalars['LocalizedString']['output'];
};

export type CompetencyLevelSetConnection = {
  __typename?: 'CompetencyLevelSetConnection';
  edges: Array<CompetencyLevelSetEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompetencyLevelSetEdge = {
  __typename?: 'CompetencyLevelSetEdge';
  cursor: Scalars['ID']['output'];
  node: CompetencyLevelSet;
};

export type CompleteConversationInput = {
  id: Scalars['ID']['input'];
};

export type CompleteConversationResponse = {
  __typename?: 'CompleteConversationResponse';
  evaluationSubmission: EvaluationSubmission;
};

export type CompleteMomentInstanceInput = {
  id: Scalars['ID']['input'];
};

export type CompleteMomentInstanceResponse = {
  __typename?: 'CompleteMomentInstanceResponse';
  momentInstance: MomentInstance;
};

export type CompleteWorkspaceCheckpointInput = {
  key: Scalars['String']['input'];
  workspaceID: Scalars['String']['input'];
};

export type CompleteWorkspaceCheckpointResponse = {
  __typename?: 'CompleteWorkspaceCheckpointResponse';
  workspace: Workspace;
};

export type Compliment = CommentTarget & {
  __typename?: 'Compliment';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  comments: Array<Comment>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  recipient: User;
  sender: User;
  text: Scalars['QuillDelta']['output'];
  viewerCanComment: Scalars['Boolean']['output'];
  viewerCanViewComments: Scalars['Boolean']['output'];
};


export type ComplimentCommentsArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComplimentConnection = {
  __typename?: 'ComplimentConnection';
  edges: Array<ComplimentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ComplimentEdge = {
  __typename?: 'ComplimentEdge';
  cursor: Scalars['ID']['output'];
  node: Compliment;
};

export type ConfirmForgotPasswordInput = {
  confirmationCode: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type ConfirmForgotPasswordResponse = {
  __typename?: 'ConfirmForgotPasswordResponse';
  success: Scalars['Boolean']['output'];
};

export type Connector = {
  __typename?: 'Connector';
  authorizationInfo?: Maybe<Scalars['String']['output']>;
  authorizeUrl?: Maybe<Scalars['String']['output']>;
  config: Array<ConnectorConfigField>;
  dryRun: ConnectorDryRun;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isTwoWayAvailable: Scalars['Boolean']['output'];
  twoWay?: Maybe<ConnectorTwoWay>;
  type: ConnectorType;
};

export type ConnectorConfigField = ConnectorConfigFieldBoolean | ConnectorConfigFieldDate | ConnectorConfigFieldFilter | ConnectorConfigFieldMultiSelect | ConnectorConfigFieldOAuth2 | ConnectorConfigFieldSelect | ConnectorConfigFieldText;

export type ConnectorConfigFieldBoolean = {
  __typename?: 'ConnectorConfigFieldBoolean';
  id: Scalars['ID']['output'];
  isConfigured: Scalars['Boolean']['output'];
  isDangerous: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  type: ConnectorConfigFieldType;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type ConnectorConfigFieldDate = {
  __typename?: 'ConnectorConfigFieldDate';
  date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isConfigured: Scalars['Boolean']['output'];
  isDangerous: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  type: ConnectorConfigFieldType;
};

export type ConnectorConfigFieldFilter = {
  __typename?: 'ConnectorConfigFieldFilter';
  available: Array<ConnectorFilterAvailableRule>;
  configured: Array<ConnectorFilterRule>;
  id: Scalars['ID']['output'];
  isConfigured: Scalars['Boolean']['output'];
  isDangerous: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  type: ConnectorConfigFieldType;
  whitelist: Scalars['Boolean']['output'];
};

export type ConnectorConfigFieldMultiSelect = {
  __typename?: 'ConnectorConfigFieldMultiSelect';
  id: Scalars['ID']['output'];
  isConfigured: Scalars['Boolean']['output'];
  isDangerous: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  options?: Maybe<Array<ConnectorSelectOption>>;
  type: ConnectorConfigFieldType;
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type ConnectorConfigFieldOAuth2 = {
  __typename?: 'ConnectorConfigFieldOAuth2';
  authorizationInfo?: Maybe<Scalars['String']['output']>;
  authorizeUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isConfigured: Scalars['Boolean']['output'];
  isDangerous: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  type: ConnectorConfigFieldType;
};

export type ConnectorConfigFieldSelect = {
  __typename?: 'ConnectorConfigFieldSelect';
  id: Scalars['ID']['output'];
  isConfigured: Scalars['Boolean']['output'];
  isDangerous: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  options?: Maybe<Array<ConnectorSelectOption>>;
  type: ConnectorConfigFieldType;
  value?: Maybe<Scalars['String']['output']>;
};

export type ConnectorConfigFieldText = {
  __typename?: 'ConnectorConfigFieldText';
  id: Scalars['ID']['output'];
  isConfigured: Scalars['Boolean']['output'];
  isDangerous: Scalars['Boolean']['output'];
  isSecret: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
  type: ConnectorConfigFieldType;
};

export enum ConnectorConfigFieldType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Filter = 'FILTER',
  MultiSelect = 'MULTI_SELECT',
  Oauth2 = 'OAUTH2',
  Select = 'SELECT',
  Text = 'TEXT'
}

export type ConnectorConsumeOAuth2CodeInput = {
  code: Scalars['String']['input'];
  type: ConnectorType;
};

export type ConnectorDryRun = {
  __typename?: 'ConnectorDryRun';
  groups: ConnectorDryRunGroupConnection;
  jobPositions: ConnectorDryRunJobPositionConnection;
  jobTitles: ConnectorDryRunJobTitleConnection;
  userRoles: ConnectorDryRunUserRoleConnection;
  users: ConnectorDryRunUserConnection;
};


export type ConnectorDryRunGroupsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ConnectorDryRunJobPositionsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ConnectorDryRunJobTitlesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ConnectorDryRunUserRolesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ConnectorDryRunUsersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ConnectorDryRunGroup = {
  __typename?: 'ConnectorDryRunGroup';
  externalReferenceID: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentExternalReferenceID?: Maybe<Scalars['String']['output']>;
};

export type ConnectorDryRunGroupConnection = {
  __typename?: 'ConnectorDryRunGroupConnection';
  edges: Array<ConnectorDryRunGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConnectorDryRunGroupEdge = {
  __typename?: 'ConnectorDryRunGroupEdge';
  cursor: Scalars['ID']['output'];
  node: ConnectorDryRunGroup;
};

export type ConnectorDryRunJobPosition = {
  __typename?: 'ConnectorDryRunJobPosition';
  endDate?: Maybe<Scalars['String']['output']>;
  externalReferenceID: Scalars['String']['output'];
  jobTitleExternalReferenceID: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  userExternalReferenceID: Scalars['String']['output'];
};

export type ConnectorDryRunJobPositionConnection = {
  __typename?: 'ConnectorDryRunJobPositionConnection';
  edges: Array<ConnectorDryRunJobPositionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConnectorDryRunJobPositionEdge = {
  __typename?: 'ConnectorDryRunJobPositionEdge';
  cursor: Scalars['ID']['output'];
  node: ConnectorDryRunJobPosition;
};

export type ConnectorDryRunJobTitle = {
  __typename?: 'ConnectorDryRunJobTitle';
  externalReferenceID: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ConnectorDryRunJobTitleConnection = {
  __typename?: 'ConnectorDryRunJobTitleConnection';
  edges: Array<ConnectorDryRunJobTitleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConnectorDryRunJobTitleEdge = {
  __typename?: 'ConnectorDryRunJobTitleEdge';
  cursor: Scalars['ID']['output'];
  node: ConnectorDryRunJobTitle;
};

export type ConnectorDryRunUser = {
  __typename?: 'ConnectorDryRunUser';
  activatedAt?: Maybe<Scalars['String']['output']>;
  avatarID?: Maybe<Scalars['String']['output']>;
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalReferenceID: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  groupExternalReferenceID?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type ConnectorDryRunUserConnection = {
  __typename?: 'ConnectorDryRunUserConnection';
  edges: Array<ConnectorDryRunUserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConnectorDryRunUserEdge = {
  __typename?: 'ConnectorDryRunUserEdge';
  cursor: Scalars['ID']['output'];
  node: ConnectorDryRunUser;
};

export type ConnectorDryRunUserRole = {
  __typename?: 'ConnectorDryRunUserRole';
  externalReferenceID: Scalars['String']['output'];
  isIndirect?: Maybe<Scalars['Boolean']['output']>;
  roleID: Scalars['String']['output'];
  sourceExternalReferenceID: Scalars['String']['output'];
  targetExternalReferenceID: Scalars['String']['output'];
  targetType: Scalars['String']['output'];
};

export type ConnectorDryRunUserRoleConnection = {
  __typename?: 'ConnectorDryRunUserRoleConnection';
  edges: Array<ConnectorDryRunUserRoleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConnectorDryRunUserRoleEdge = {
  __typename?: 'ConnectorDryRunUserRoleEdge';
  cursor: Scalars['ID']['output'];
  node: ConnectorDryRunUserRole;
};

export enum ConnectorErrorType {
  UnknownError = 'UNKNOWN_ERROR',
  UserEmailTakenError = 'USER_EMAIL_TAKEN_ERROR',
  UserUsernameTakenError = 'USER_USERNAME_TAKEN_ERROR'
}

export type ConnectorFilterAvailableRule = {
  __typename?: 'ConnectorFilterAvailableRule';
  fields?: Maybe<Array<Scalars['String']['output']>>;
  options?: Maybe<Array<ConnectorSelectOption>>;
  type: ConnectorFilterRuleType;
};

export type ConnectorFilterRule = {
  __typename?: 'ConnectorFilterRule';
  field?: Maybe<Scalars['String']['output']>;
  type: ConnectorFilterRuleType;
  values: Array<Scalars['String']['output']>;
};

export type ConnectorFilterRuleInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  type: ConnectorFilterRuleType;
  values: Array<Scalars['String']['input']>;
};

export enum ConnectorFilterRuleType {
  Department = 'DEPARTMENT',
  EmailDomain = 'EMAIL_DOMAIN',
  ExactMatch = 'EXACT_MATCH',
  FunctionCodesExcludedFromManagementRole = 'FUNCTION_CODES_EXCLUDED_FROM_MANAGEMENT_ROLE',
  JobTitle = 'JOB_TITLE'
}

export type ConnectorLog = {
  __typename?: 'ConnectorLog';
  errorType?: Maybe<ConnectorErrorType>;
  id: Scalars['ID']['output'];
  logLevel: ConnectorLogLevel;
  message: Scalars['String']['output'];
  metadata?: Maybe<ConnectorLogMetadata>;
  timestamp: Scalars['DateTime']['output'];
};

export type ConnectorLogConnection = {
  __typename?: 'ConnectorLogConnection';
  edges: Array<ConnectorLogEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConnectorLogEdge = {
  __typename?: 'ConnectorLogEdge';
  cursor: Scalars['ID']['output'];
  node: ConnectorLog;
};

export enum ConnectorLogLevel {
  Error = 'ERROR',
  Info = 'INFO',
  Migrate = 'MIGRATE',
  Warning = 'WARNING'
}

export type ConnectorLogMetadata = {
  __typename?: 'ConnectorLogMetadata';
  user: ConnectorLogMetadataUser;
};

export type ConnectorLogMetadataInput = {
  user?: InputMaybe<ConnectorLogMetadataUserInput>;
};

export type ConnectorLogMetadataUser = {
  __typename?: 'ConnectorLogMetadataUser';
  email: Scalars['String']['output'];
  externalReferenceID: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type ConnectorLogMetadataUserInput = {
  email: Scalars['String']['input'];
  externalReferenceID: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type ConnectorSelectOption = {
  __typename?: 'ConnectorSelectOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ConnectorTask = {
  __typename?: 'ConnectorTask';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  errorReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: ConnectorTaskStatus;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};

export type ConnectorTaskConnection = {
  __typename?: 'ConnectorTaskConnection';
  edges: Array<ConnectorTaskEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConnectorTaskEdge = {
  __typename?: 'ConnectorTaskEdge';
  cursor: Scalars['ID']['output'];
  node: ConnectorTask;
};

export enum ConnectorTaskStatus {
  Error = 'ERROR',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type ConnectorTwoWay = {
  __typename?: 'ConnectorTwoWay';
  acceptedAt: Scalars['DateTime']['output'];
  acceptedBy: User;
};

export enum ConnectorType {
  Afas = 'AFAS',
  Cobra = 'COBRA',
  Employes = 'EMPLOYES',
  Goodhabitz = 'GOODHABITZ',
  Hooray = 'HOORAY',
  Hr2Day = 'HR2DAY',
  Loket = 'LOKET',
  Msf = 'MSF',
  Nmbrs = 'NMBRS',
  Scim = 'SCIM',
  Styr = 'STYR',
  Vismahrm = 'VISMAHRM',
  Youforce = 'YOUFORCE',
  Youserve = 'YOUSERVE'
}

export type ConnectorUpload = {
  __typename?: 'ConnectorUpload';
  createdAt: Scalars['DateTime']['output'];
  errorReason?: Maybe<Scalars['String']['output']>;
  fileExtension: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  status: ConnectorUploadStatus;
  title: Scalars['String']['output'];
  type: ConnectorUploadType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};

export type ConnectorUploadConnection = {
  __typename?: 'ConnectorUploadConnection';
  edges: Array<ConnectorUploadEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConnectorUploadEdge = {
  __typename?: 'ConnectorUploadEdge';
  cursor: Scalars['ID']['output'];
  node: ConnectorUpload;
};

export enum ConnectorUploadStatus {
  Error = 'ERROR',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum ConnectorUploadType {
  Conversation = 'CONVERSATION'
}

export type ConversationLearningRecommendationsInput = {
  evaluationSubmissionID: Scalars['ID']['input'];
};

export type ConversationPdfExportResult = {
  __typename?: 'ConversationPDFExportResult';
  url?: Maybe<Scalars['String']['output']>;
};

export type CopyWorkspaceInput = {
  source: Scalars['String']['input'];
  target: Scalars['String']['input'];
};

export type CopyWorkspaceResponse = {
  __typename?: 'CopyWorkspaceResponse';
  error: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  target: Scalars['String']['output'];
};

export type CorrectTalentReviewSnapshotInput = {
  /** Placements (re)written on the snapshot's grid day. */
  placements: Array<CorrectTalentReviewSnapshotPlacementInput>;
  /** Users removed from the grid on the snapshot's grid day. */
  removedUserIDs: Array<Scalars['ID']['input']>;
  snapshotID: Scalars['ID']['input'];
};

export type CorrectTalentReviewSnapshotPlacementInput = {
  column: Scalars['Int']['input'];
  motivation?: InputMaybe<Scalars['String']['input']>;
  /** Order within the cell; omit to append at the end (createdAt). */
  position?: InputMaybe<Scalars['Float']['input']>;
  retentionRisk?: InputMaybe<TalentReviewRetentionRisk>;
  row: Scalars['Int']['input'];
  score?: InputMaybe<TalentReviewPlacementScore>;
  userID: Scalars['ID']['input'];
};

export type CorrectTalentReviewSnapshotResponse = {
  __typename?: 'CorrectTalentReviewSnapshotResponse';
  snapshot: TalentReviewSnapshot;
};

export type CreateAgentChatInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAnnouncementInput = {
  content: Scalars['LocalizedAttributedString']['input'];
  displayType?: InputMaybe<AnnouncementDisplayType>;
  enabled: Scalars['Boolean']['input'];
  filters: AnnouncementFiltersInput;
  headerImageAssetID?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['LocalizedString']['input'];
};

export type CreateAnnouncementResponse = {
  __typename?: 'CreateAnnouncementResponse';
  announcement: Announcement;
};

export type CreateAssetInput = {
  contentLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  externalReferenceID?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAssetResponse = {
  __typename?: 'CreateAssetResponse';
  asset: Asset;
  uploadEndpoint: AssetUploadEndpoint;
};

export type CreateCommentInput = {
  content: Scalars['QuillDelta']['input'];
  metadata?: InputMaybe<Array<CommentMetadataInput>>;
  targetID: Scalars['ID']['input'];
  targetType: CommentTargetType;
};

export type CreateCommentResponse = {
  __typename?: 'CreateCommentResponse';
  comment: Comment;
};

export type CreateCompetencyBookmarkInput = {
  /** ID of the competency that should be bookmarked. */
  competencyID: Scalars['ID']['input'];
  /** Index of the competency level that the given user wants to attain. */
  competencyLevelIndex: Scalars['Int']['input'];
  /** ID of the user that this competency should be bookmarked for. */
  userID: Scalars['ID']['input'];
};

export type CreateCompetencyBookmarkResponse = {
  __typename?: 'CreateCompetencyBookmarkResponse';
  /** Contains the newly created competency bookmark. */
  competencyBookmark: CompetencyBookmark;
};

export type CreateCompetencyInput = {
  attachableToGoal?: InputMaybe<Scalars['Boolean']['input']>;
  competencyLevelSetID: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  jobTitleIDs: Array<Scalars['ID']['input']>;
  labelID?: InputMaybe<Scalars['ID']['input']>;
  levels: Array<CompetencyLevelOptionInput>;
  /**
   * Optional Styr `skillId`. Its presence marks the competency as Styr-sourced. Used by the
   * Styr sync to upsert imported skills.
   */
  styrSkillID?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['LocalizedString']['input'];
};

export type CreateCompetencyLevelInput = {
  title: Scalars['LocalizedString']['input'];
};

export type CreateCompetencyLevelSetInput = {
  levels: Array<CreateCompetencyLevelInput>;
  title: Scalars['LocalizedString']['input'];
};

export type CreateCompetencyLevelSetResponse = {
  __typename?: 'CreateCompetencyLevelSetResponse';
  competencyLevelSet: CompetencyLevelSet;
};

export type CreateCompetencyResponse = {
  __typename?: 'CreateCompetencyResponse';
  competency: Competency;
};

export type CreateComplimentInput = {
  text: Scalars['QuillDelta']['input'];
  userID: Scalars['ID']['input'];
};

export type CreateComplimentResponse = {
  __typename?: 'CreateComplimentResponse';
  compliment: Compliment;
};

export type CreateCycleInstanceInput = {
  activatesAt: Scalars['DateTime']['input'];
  cycleTemplateID: Scalars['ID']['input'];
  deactivatesAt?: InputMaybe<Scalars['DateTime']['input']>;
  localStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** @deprecated Use `localStartDate` instead. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userID: Scalars['ID']['input'];
};

export type CreateCycleInstanceResponse = {
  __typename?: 'CreateCycleInstanceResponse';
  cycleInstance: CycleInstance;
};

export type CreateCycleTemplateInput = {
  /**
   * Indicates whether this cycle template should be assigned automatically to
   * all new employees.
   */
  automatic?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  duration: Scalars['Int']['input'];
  /** If present, indicates that this cycle template should only be automatically applied to either external or internal users. */
  employmentType?: InputMaybe<EmploymentType>;
  /**
   * If present, indicates that this cycle template should not be automatically
   * applied to the groups with the given IDs.
   */
  excludedGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * If present, indicates that this cycle template should not be automatically
   * applied to the job titles with the given IDs.
   */
  excludedJobTitleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * If present, indicates that this cycle template should only be automatically
   * applied to the groups with the given IDs.
   */
  groupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * If present, indicates whether this cycle template should be wrapped to the
   * first day of a particular interval. For example, this field can make sure
   * that this cycle always starts at the first day of the year.
   */
  interval?: InputMaybe<CycleTemplateInterval>;
  /**
   * If present, indicates that this cycle template should only be automatically
   * applied to the job titles with the given IDs.
   */
  jobTitleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  moments: Array<MomentTemplateInput>;
  /** @deprecated Use `successorID` instead. */
  repeats?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Contains the ID of a cycle template that will replace this template after
   * the cycle finishes. Leave out if this cycle should not repeat. Set to
   * `$repeat` if you want this cycle to repeat itself.
   */
  successorID?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['LocalizedString']['input'];
};

export type CreateCycleTemplateResponse = {
  __typename?: 'CreateCycleTemplateResponse';
  cycleTemplate: CycleTemplate;
};

export type CreateEngagementCategoryInput = {
  title: Scalars['LocalizedString']['input'];
};

export type CreateEngagementCategoryResponse = {
  __typename?: 'CreateEngagementCategoryResponse';
  category: EngagementCategory;
};

export type CreateEngagementQuestionInput = {
  subcategoryID: Scalars['ID']['input'];
  title: Scalars['LocalizedString']['input'];
  typeID: Scalars['ID']['input'];
};

export type CreateEngagementQuestionResponse = {
  __typename?: 'CreateEngagementQuestionResponse';
  question: EngagementQuestion;
};

export type CreateEngagementReplyInput = {
  answerID: Scalars['ID']['input'];
  managerID?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};

export type CreateEngagementReplyResponse = {
  __typename?: 'CreateEngagementReplyResponse';
  reply: EngagementReply;
};

export type CreateEngagementRequestInput = {
  templateID: Scalars['ID']['input'];
};

export type CreateEngagementRequestResponse = {
  __typename?: 'CreateEngagementRequestResponse';
  engagementRequest: EngagementRequest;
};

export type CreateEngagementResponseInput = {
  groupIDs: Array<Scalars['ID']['input']>;
  jobTitleIDs: Array<Scalars['ID']['input']>;
  requestID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type CreateEngagementResponseResponse = {
  __typename?: 'CreateEngagementResponseResponse';
  engagementResponse: EngagementResponse;
};

export type CreateEngagementSubcategoryInput = {
  categoryID: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['LocalizedString']['input']>;
  title: Scalars['LocalizedString']['input'];
};

export type CreateEngagementSubcategoryResponse = {
  __typename?: 'CreateEngagementSubcategoryResponse';
  subcategory: EngagementSubcategory;
};

export type CreateEngagementTemplateInput = {
  anonymityThreshold?: InputMaybe<Scalars['Int']['input']>;
  categoryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  endPage?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  expiryInDays?: InputMaybe<Scalars['Int']['input']>;
  instruction?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  interval: EngagementInterval;
  maxOpenQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  reminderDaysInAdvance?: InputMaybe<Scalars['Int']['input']>;
  targetGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['LocalizedString']['input'];
  useAllQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  useNps?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateEngagementTemplateResponse = {
  __typename?: 'CreateEngagementTemplateResponse';
  template: EngagementTemplate;
};

export type CreateEvaluationFormInput = {
  description?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  jobTitleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  sections: Array<CreateEvaluationFormSectionInput>;
  showAnswersWhenAllUsersShared?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['LocalizedString']['input'];
  useOnlyInCycle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateEvaluationFormResponse = {
  __typename?: 'CreateEvaluationFormResponse';
  evaluationForm: EvaluationForm;
};

export type CreateEvaluationFormSectionInput = {
  items: Array<CreateEvaluationSectionItemInput>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateEvaluationSectionItemInput = {
  competency?: InputMaybe<EvaluationCompetencyItemInput>;
  developmentPlan?: InputMaybe<EvaluationDevelopmentPlanItemInput>;
  fillInBy: EvaluationFillInBy;
  finalScore?: InputMaybe<EvaluationFinalScoreItemInput>;
  multipleChoice?: InputMaybe<EvaluationMultipleChoiceItemInput>;
  openQuestion?: InputMaybe<EvaluationOpenQuestionItemInput>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  paragraph?: InputMaybe<EvaluationParagraphItemInput>;
  reviewGoals?: InputMaybe<EvaluationReviewGoalsItemInput>;
  sentiment?: InputMaybe<EvaluationSentimentItemInput>;
  setGoals?: InputMaybe<EvaluationSetGoalsItemInput>;
  signature?: InputMaybe<EvaluationSignatureItemInput>;
  stars?: InputMaybe<EvaluationStarsItemInput>;
  title?: InputMaybe<EvaluationTitleItemInput>;
  type: EvaluationSectionItemType;
};

export type CreateEvaluationSubmissionInput = {
  deadline: Scalars['DateTime']['input'];
  evaluationFormID: Scalars['ID']['input'];
  meeting?: InputMaybe<EvaluationSubmissionMeetingInput>;
  momentID?: InputMaybe<Scalars['ID']['input']>;
  userID: Scalars['ID']['input'];
};

export type CreateEvaluationSubmissionResponse = {
  __typename?: 'CreateEvaluationSubmissionResponse';
  evaluationSubmission: EvaluationSubmission;
};

/** Input for creating a new feature rating */
export type CreateFeatureRatingInput = {
  binaryValue?: InputMaybe<Scalars['Boolean']['input']>;
  featureName: FeatureName;
  targetID: Scalars['ID']['input'];
  targetType: FeatureRatingTargetType;
  text?: InputMaybe<Scalars['String']['input']>;
  viewerID: Scalars['ID']['input'];
};

/** Response from creating a feature rating */
export type CreateFeatureRatingResponse = {
  __typename?: 'CreateFeatureRatingResponse';
  featureRating: FeatureRating;
};

export type CreateFeedbackQuestionCategoryInput = {
  name: Scalars['LocalizedString']['input'];
};

export type CreateFeedbackQuestionCategoryResponse = {
  __typename?: 'CreateFeedbackQuestionCategoryResponse';
  feedbackQuestionCategory: FeedbackQuestionCategory;
};

export type CreateFeedbackQuestionInput = {
  additionalDetails?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  categoryID: Scalars['ID']['input'];
  options?: InputMaybe<Array<FeedbackQuestionOptionInput>>;
  subTitle?: InputMaybe<Scalars['LocalizedString']['input']>;
  text: Scalars['LocalizedString']['input'];
  type: FeedbackQuestionType;
};

export type CreateFeedbackQuestionResponse = {
  __typename?: 'CreateFeedbackQuestionResponse';
  feedbackQuestion: FeedbackQuestion;
};

export type CreateFeedbackRequestInput = {
  /**
   * This is the due date of this feedback request. Recipients won't be able to
   * respond after this point in time.
   */
  dueDate: Scalars['DateTime']['input'];
  /**
   * Optional feedback template ID this request was created from. When the
   * request is attached to a moment that prescribes a specific feedback
   * template, this must match the moment's template.
   */
  feedbackTemplateID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Instructional message that is sent to all recipients, regardless of
   * internal/external.
   */
  instruction?: InputMaybe<Scalars['QuillDelta']['input']>;
  /** Optional moment ID that this feedback request will be attached to. */
  momentID?: InputMaybe<Scalars['ID']['input']>;
  /** These are questions that will be sent to the recipients. */
  questions: Array<FeedbackRequestQuestionInput>;
  /**
   * Optional date before which submitted answers stay hidden from the feedback
   * subject. When the request is attached to a moment that prescribes a
   * release date, this must match the moment's release date.
   */
  releaseDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** This is the title override of this feedback request. This may be left empty. */
  title: Scalars['String']['input'];
  /**
   * This is the user's ID on whose behalf feedback is requested. This can also
   * be the viewer's ID.
   */
  userID: Scalars['ID']['input'];
};

export type CreateFeedbackRequestResponse = {
  __typename?: 'CreateFeedbackRequestResponse';
  /** This field contains the newly created feedback request. */
  feedbackRequest: FeedbackRequest;
};

export type CreateFeedbackTemplateInput = {
  description: Scalars['LocalizedAttributedString']['input'];
  instruction?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  /** @deprecated Use `roles = [CYCLES]` instead. */
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  questions: Array<FeedbackTemplateQuestionInput>;
  roles?: InputMaybe<Array<FeedbackTemplateRole>>;
  title: Scalars['LocalizedString']['input'];
};

export type CreateFeedbackTemplateResponse = {
  __typename?: 'CreateFeedbackTemplateResponse';
  feedbackTemplate: FeedbackTemplate;
};

export type CreateGoalChecklistItemInput = {
  description: Scalars['LocalizedAttributedString']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  learningCourseID?: InputMaybe<Scalars['ID']['input']>;
  progress: GoalChecklistItemProgressInput;
  title: Scalars['LocalizedString']['input'];
};

export type CreateGoalDriverInput = {
  title: Scalars['LocalizedString']['input'];
};

export type CreateGoalDriverResponse = {
  __typename?: 'CreateGoalDriverResponse';
  goalDriver: GoalDriver;
};

export type CreateGoalInput = {
  checklistItems?: InputMaybe<Array<CreateGoalChecklistItemInput>>;
  competency?: InputMaybe<CompetencyGoalInput>;
  description?: InputMaybe<Scalars['QuillDelta']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  feasibility?: InputMaybe<GoalFeasibility>;
  labelID?: InputMaybe<Scalars['ID']['input']>;
  linkedGoalDriverIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  linkedGoalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  momentID?: InputMaybe<Scalars['ID']['input']>;
  ownerID: Scalars['ID']['input'];
  ownerType: GoalOwnerType;
  progressOverride?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['LocalizedString']['input'];
  /**
   * Contains the visibility setting for this goal. Reflects whether the goal
   * should be visible to colleagues. For backwards compatibility, `PUBLIC` is
   * the default value if this field is not present.
   */
  visibility?: InputMaybe<GoalVisibility>;
};

export type CreateGoalResponse = {
  __typename?: 'CreateGoalResponse';
  goal: Goal;
};

export type CreateGoalTemplateInput = {
  competency?: InputMaybe<CompetencyGoalInput>;
  description: Scalars['LocalizedAttributedString']['input'];
  jobTitleIDs: Array<Scalars['ID']['input']>;
  labelID?: InputMaybe<Scalars['ID']['input']>;
  relativeDueDate?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['LocalizedString']['input'];
};

export type CreateGoalTemplateResponse = {
  __typename?: 'CreateGoalTemplateResponse';
  goalTemplate: GoalTemplate;
};

export type CreateGroupInput = {
  externalReferenceID?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parentID?: InputMaybe<Scalars['ID']['input']>;
  type: GroupType;
};

export type CreateGroupResponse = {
  __typename?: 'CreateGroupResponse';
  group: Group;
};

export type CreateIdentityProviderInput = {
  metadataFile?: InputMaybe<Scalars['String']['input']>;
  metadataURL?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIdentityProviderResponse = {
  __typename?: 'CreateIdentityProviderResponse';
  provider: IdentityProvider;
};

export type CreateJobLevelInput = {
  description?: InputMaybe<Scalars['LocalizedString']['input']>;
  externalReferenceID?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['LocalizedString']['input'];
};

export type CreateJobLevelResponse = {
  __typename?: 'CreateJobLevelResponse';
  jobLevel: JobLevel;
};

export type CreateJobPositionInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalReferenceID?: InputMaybe<Scalars['String']['input']>;
  jobLevelID?: InputMaybe<Scalars['ID']['input']>;
  jobTitleID: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  userID: Scalars['ID']['input'];
};

export type CreateJobPositionResponse = {
  __typename?: 'CreateJobPositionResponse';
  jobPosition: JobPosition;
};

export type CreateJobTitleInput = {
  description?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  externalReferenceID?: InputMaybe<Scalars['String']['input']>;
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  styrData?: InputMaybe<StyrDataInput>;
  title: Scalars['LocalizedString']['input'];
};

export type CreateJobTitleResponse = {
  __typename?: 'CreateJobTitleResponse';
  jobTitle: JobTitle;
};

export type CreateLabelInput = {
  description?: InputMaybe<Scalars['LocalizedString']['input']>;
  title: Scalars['LocalizedString']['input'];
  type: LabelType;
};

export type CreateLabelResponse = {
  __typename?: 'CreateLabelResponse';
  label: Label;
};

export type CreateLearningEventInput = {
  capacity: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  endDate: Scalars['DateTime']['input'];
  jobTitleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  languageID: Scalars['ID']['input'];
  learningSubjectIDs: Array<Scalars['ID']['input']>;
  learningTypeID: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['LocalizedString']['input'];
};

export type CreateLearningEventResponse = {
  __typename?: 'CreateLearningEventResponse';
  learningEvent: LearningEvent;
};

export type CreateLearningSubjectInput = {
  title: Scalars['LocalizedString']['input'];
};

export type CreateLearningSubjectResponse = {
  __typename?: 'CreateLearningSubjectResponse';
  learningSubject: LearningSubject;
};

export type CreateLearningTypeInput = {
  color: Scalars['String']['input'];
  title: Scalars['LocalizedString']['input'];
};

export type CreateLearningTypeResponse = {
  __typename?: 'CreateLearningTypeResponse';
  learningType: LearningType;
};

export type CreateMeetingInput = {
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  series?: InputMaybe<UpsertMeetingSeriesInput>;
  startsAt: Scalars['DateTime']['input'];
  target: MeetingTargetInput;
  timezone: Scalars['TimeZoneID']['input'];
};

export type CreateMeetingResponse = {
  __typename?: 'CreateMeetingResponse';
  meeting: Meeting;
};

export type CreateNoteInput = {
  content?: InputMaybe<Scalars['QuillDelta']['input']>;
  /** @deprecated Use `createMeeting` instead. */
  date?: InputMaybe<Scalars['String']['input']>;
  linkedEntities?: InputMaybe<Array<LinkedEntityInput>>;
  metadata?: InputMaybe<NoteMetadataInput>;
  noteType?: InputMaybe<NoteType>;
  subjectID?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNoteResponse = {
  __typename?: 'CreateNoteResponse';
  note: Note;
};

export type CreatePersonalAccessTokenResponse = {
  __typename?: 'CreatePersonalAccessTokenResponse';
  id: Scalars['ID']['output'];
  token: Scalars['String']['output'];
};

export type CreateSessionInput = {
  login: Scalars['String']['input'];
};

export type CreateSessionResponse = {
  __typename?: 'CreateSessionResponse';
  challenge?: Maybe<Challenge>;
};

export type CreateSubscriptionInput = {
  address?: InputMaybe<StripeCustomerAddressInfo>;
  collectionMethod: BillingCollectionMethod;
  email: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  workspaceID: Scalars['ID']['input'];
};

export type CreateSubscriptionResponse = {
  __typename?: 'CreateSubscriptionResponse';
  redirect?: Maybe<Scalars['String']['output']>;
};

export type CreateTalentReviewInput = {
  groupID: Scalars['ID']['input'];
  momentID?: InputMaybe<Scalars['ID']['input']>;
  templateID: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type CreateTalentReviewResponse = {
  __typename?: 'CreateTalentReviewResponse';
  talentReview: TalentReview;
};

export type CreateTalentReviewSnapshotInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupID: Scalars['ID']['input'];
  localDate: Scalars['LocalDate']['input'];
  momentID?: InputMaybe<Scalars['ID']['input']>;
  templateID: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type CreateTalentReviewSnapshotResponse = {
  __typename?: 'CreateTalentReviewSnapshotResponse';
  snapshot: TalentReviewSnapshot;
};

export type CreateTalentReviewTemplateInput = {
  cells: Array<Array<TalentReviewTemplateCellInput>>;
  description: Scalars['LocalizedAttributedString']['input'];
  hasNorm?: InputMaybe<Scalars['Boolean']['input']>;
  outdatedAfterDays?: InputMaybe<Scalars['Int']['input']>;
  placementHelpQuestions?: InputMaybe<Array<TalentReviewPlacementHelpQuestionInput>>;
  title: Scalars['LocalizedString']['input'];
  visibility: TalentReviewVisibility;
  xAxis: TalentReviewTemplateAxisInput;
  yAxis: TalentReviewTemplateAxisInput;
};

export type CreateTalentReviewTemplateResponse = {
  __typename?: 'CreateTalentReviewTemplateResponse';
  template: TalentReviewTemplate;
};

export type CreateTaskInput = {
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  subjectID: Scalars['ID']['input'];
  subjectType: TaskSubjectType;
  title: Scalars['String']['input'];
};

export type CreateTaskResponse = {
  __typename?: 'CreateTaskResponse';
  task: Task;
};

export type CreateTranscriptionInput = {
  contentLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  language: TranscriptionLanguage;
  targetID: Scalars['String']['input'];
  targetType: TranscriptionTargetType;
};

export type CreateTranscriptionResponse = {
  __typename?: 'CreateTranscriptionResponse';
  transcription: Transcription;
  uploadHeaders: Array<TranscriptionUploadHeader>;
  uploadURL: Scalars['String']['output'];
};

export type CreateUserDocumentV2DownloadUrlInput = {
  documentID: Scalars['ID']['input'];
};

export type CreateUserDocumentV2DownloadUrlResponse = {
  __typename?: 'CreateUserDocumentV2DownloadURLResponse';
  url: Scalars['String']['output'];
};

export type CreateUserDocumentV2Input = {
  contentLength: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  userID: Scalars['ID']['input'];
};

export type CreateUserDocumentV2Response = {
  __typename?: 'CreateUserDocumentV2Response';
  documentID: Scalars['String']['output'];
  uploadHeaders: Array<UserDocumentUploadHeader>;
  uploadUrl: Scalars['String']['output'];
};

export type CreateUserInput = {
  /** @deprecated Use `localActivatedAt` instead. */
  activatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Use `localDeactivatedAt` instead. */
  deactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  externalReferenceID?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  groupID: Scalars['ID']['input'];
  /**
   * An optional boolean that indicates if this user is considered an external
   * employee. The default value is false.
   */
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  localActivatedAt?: InputMaybe<Scalars['LocalDate']['input']>;
  localDeactivatedAt?: InputMaybe<Scalars['LocalDate']['input']>;
  locale: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CreateUserResponse = {
  __typename?: 'CreateUserResponse';
  user: User;
};

export type CreateWorkspaceCustomerInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CreateWorkspaceInput = {
  additionalUsers?: InputMaybe<Array<InputMaybe<CreateWorkspaceCustomerInput>>>;
  customer: CreateWorkspaceCustomerInput;
  /** @deprecated Use planType instead */
  featurePresetID?: InputMaybe<Scalars['ID']['input']>;
  hubSpotCompanyID?: InputMaybe<Scalars['String']['input']>;
  isOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  planType?: InputMaybe<WorkspacePlanType>;
  seedDummyData?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceID: Scalars['ID']['input'];
};

export type CreateWorkspacePlanInput = {
  type: WorkspacePlanType;
  workspaceID: Scalars['ID']['input'];
};

export type CreateWorkspacePlanResponse = {
  __typename?: 'CreateWorkspacePlanResponse';
  plan: WorkspacePlanV2;
};

export type CreateWorkspaceResponse = {
  __typename?: 'CreateWorkspaceResponse';
  workspace: Workspace;
};

export type CustomEmailDomain = {
  __typename?: 'CustomEmailDomain';
  dkimTokens: Array<Scalars['String']['output']>;
  dkimVerificationStatus: DomainVerificationStatus;
  domain: Scalars['String']['output'];
  emailDomain: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  mailFromDomain: Scalars['String']['output'];
  mailFromVerificationStatus: DomainVerificationStatus;
  senderAddress: Scalars['String']['output'];
  senderName: Scalars['String']['output'];
};

export type CycleInstance = {
  __typename?: 'CycleInstance';
  activatesAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByUser: User;
  cycleTemplate: CycleTemplate;
  deactivatesAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  localStartDate: Scalars['LocalDate']['output'];
  moments: Array<MomentInstance>;
  precededBy?: Maybe<CycleInstance>;
  skippedFutureMoments: Array<CycleInstanceSkippedMoment>;
  /** @deprecated Use `localStartDate` instead. */
  startDate: Scalars['DateTime']['output'];
  status: CycleStatus;
  succeededBy?: Maybe<CycleInstance>;
  user: User;
};


export type CycleInstanceMomentsArgs = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CycleInstanceConnection = {
  __typename?: 'CycleInstanceConnection';
  edges: Array<CycleInstanceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CycleInstanceEdge = {
  __typename?: 'CycleInstanceEdge';
  cursor: Scalars['ID']['output'];
  node: CycleInstance;
};

export type CycleInstanceSkippedMoment = {
  __typename?: 'CycleInstanceSkippedMoment';
  momentTemplateID: Scalars['String']['output'];
  skipReason: MomentSkipReason;
  skipReasonOther?: Maybe<Scalars['String']['output']>;
};

export type CycleManagerReminderManagerInput = {
  managerID: Scalars['ID']['input'];
  pendingEmployeeNames: Array<Scalars['String']['input']>;
};

export enum CycleStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Stopped = 'STOPPED'
}

export type CycleTemplate = {
  __typename?: 'CycleTemplate';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Indicates whether this cycle template should be assigned automatically to
   * all new employees.
   */
  automatic: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['LocalizedAttributedString']['output']>;
  /**
   * The duration of cycle templates in months.
   * Actual duration (in days) is `Math.floor((365 / 12) * duration)`
   */
  duration: Scalars['Int']['output'];
  /** If present, indicates that this cycle template should only be automatically applied to either external or internal users. */
  employmentType?: Maybe<EmploymentType>;
  /**
   * If present, indicates that this cycle template should not be automatically
   * applied to the given groups.
   */
  excludedGroups?: Maybe<Array<Group>>;
  /**
   * If present, indicates that this cycle template should not be automatically
   * applied to the given job titles.
   */
  excludedJobTitles?: Maybe<Array<JobTitle>>;
  /**
   * If present, indicates that this cycle template should only be automatically
   * applied to the given groups.
   */
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID']['output'];
  /**
   * If present, indicates whether this cycle template should be wrapped to the
   * first day of a particular interval. For example, this field can make sure
   * that this cycle always starts at the first day of the year.
   */
  interval?: Maybe<CycleTemplateInterval>;
  isArchived: Scalars['Boolean']['output'];
  /**
   * If present, indicates that this cycle template should only be automatically
   * applied to the given job titles.
   */
  jobTitles?: Maybe<Array<JobTitle>>;
  moments: Array<MomentTemplate>;
  /** @deprecated Use `successor` instead. */
  repeats: Scalars['Boolean']['output'];
  /**
   * Contains the cycle template that this cycle will be replaced with after it
   * finishes (if any). This supersedes the deprecated `repeats` field.
   */
  successor?: Maybe<CycleTemplate>;
  title: Scalars['LocalizedString']['output'];
};

export type CycleTemplateConnection = {
  __typename?: 'CycleTemplateConnection';
  edges: Array<CycleTemplateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CycleTemplateEdge = {
  __typename?: 'CycleTemplateEdge';
  cursor: Scalars['ID']['output'];
  node: CycleTemplate;
};

/** Represents commonly used intervals for cycle templates. */
export enum CycleTemplateInterval {
  /** Represents a cycle template that covers a year. */
  Year = 'YEAR'
}

export type DeactivateJobPositionInput = {
  id: Scalars['ID']['input'];
};

export type DeactivateJobPositionResponse = {
  __typename?: 'DeactivateJobPositionResponse';
  jobPosition: JobPosition;
};

export type DeleteAnnouncementInput = {
  announcementID: Scalars['ID']['input'];
};

export type DeleteAnnouncementResponse = {
  __typename?: 'DeleteAnnouncementResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteGroupInput = {
  id: Scalars['ID']['input'];
};

export type DeleteGroupResponse = {
  __typename?: 'DeleteGroupResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteIdentityProviderInput = {
  identityProviderID: Scalars['ID']['input'];
};

export type DeleteIdentityProviderResponse = {
  __typename?: 'DeleteIdentityProviderResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteTaskInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTaskResponse = {
  __typename?: 'DeleteTaskResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteUserDocumentV2Input = {
  documentID: Scalars['ID']['input'];
};

export type DeleteUserDocumentV2Response = {
  __typename?: 'DeleteUserDocumentV2Response';
  deleted: Scalars['Boolean']['output'];
  documentID: Scalars['ID']['output'];
};

export type DeleteUserDownloadInput = {
  id: Scalars['ID']['input'];
};

export type DeleteUserDownloadResponse = {
  __typename?: 'DeleteUserDownloadResponse';
  user: User;
};

export type DetachJobCompetencyInput = {
  competencyID: Scalars['ID']['input'];
  jobLevelID?: InputMaybe<Scalars['ID']['input']>;
  jobTitleID: Scalars['ID']['input'];
};

export type DetachJobCompetencyResponse = {
  __typename?: 'DetachJobCompetencyResponse';
  jobTitle: JobTitle;
};

export type DetachJobGoalTemplateInput = {
  goalTemplateID: Scalars['ID']['input'];
  jobTitleID: Scalars['ID']['input'];
};

export type DetachJobGoalTemplateResponse = {
  __typename?: 'DetachJobGoalTemplateResponse';
  jobTitle: JobTitle;
};

export type DisableEngagementTemplateInput = {
  id: Scalars['ID']['input'];
};

export type DisableEngagementTemplateResponse = {
  __typename?: 'DisableEngagementTemplateResponse';
  template: EngagementTemplate;
};

export type DisableMfaMethodInput = {
  method: MfaMethod;
};

export type DisableMfaMethodResponse = {
  __typename?: 'DisableMfaMethodResponse';
  mfaUserConfiguration?: Maybe<MfaUserConfiguration>;
};

export type DisassociateIdentityInput = {
  identityProviderID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  userID: Scalars['ID']['input'];
};

export type DisassociateIdentityResponse = {
  __typename?: 'DisassociateIdentityResponse';
  user: User;
};

export type DiscardAnswersFromPredecessorInput = {
  id: Scalars['ID']['input'];
};

export type DiscardAnswersFromPredecessorResponse = {
  __typename?: 'DiscardAnswersFromPredecessorResponse';
  evaluationSubmission: EvaluationSubmission;
};

export enum DomainVerificationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

export type EmployeeFeed = {
  __typename?: 'EmployeeFeed';
  /** This is the items per month. */
  itemsPerMonth: Array<Maybe<EmployeeFeedMonthItems>>;
};

export type EmployeeFeedItem = {
  __typename?: 'EmployeeFeedItem';
  /** This is the date of this item. */
  date: Scalars['DateTime']['output'];
  /** This is the ID of this item. */
  id: Scalars['ID']['output'];
  /** This is the title of this item. */
  title: Scalars['LocalizedString']['output'];
  /** This is the type of this item. */
  type: FeedItemType;
};

/** This is the items per month. */
export type EmployeeFeedMonthItems = {
  __typename?: 'EmployeeFeedMonthItems';
  /** This is the items of this month. */
  items: Array<EmployeeFeedItem>;
  /** This is the month of this month's items. */
  month: Scalars['String']['output'];
};

export enum EmploymentType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type EnableEngagementTemplateInput = {
  id: Scalars['ID']['input'];
};

export type EnableEngagementTemplateResponse = {
  __typename?: 'EnableEngagementTemplateResponse';
  template: EngagementTemplate;
};

export type EnableWorkspaceAiPlanResponse = {
  __typename?: 'EnableWorkspaceAiPlanResponse';
  plan: WorkspacePlanV2;
};

export type EngagementAnalytics = {
  __typename?: 'EngagementAnalytics';
  engagementENPS: AnalyticsEngagementEnps;
  engagementGroupsENPS: Array<AnalyticsEngagementGroupEnps>;
  engagementGroupsParticipation: Array<AnalyticsEngagementGroupParticipation>;
  engagementGroupsSubcategoriesScore: Array<AnalyticsEngagementGroupSubcategoryScore>;
  engagementOpenQuestions: Array<AnalyticsEngagementOpenQuestion>;
  engagementParticipationOverTime: AnalyticsEngagementParticipation;
  engagementQuestionsTrend: Array<AnalyticsEngagementQuestionScoreTrend>;
  engagementScoreOverTime: AnalyticsEngagementScore;
  engagementSubcategoriesTrend: Array<AnalyticsEngagementSubcategoryScoreOverTime>;
};


export type EngagementAnalyticsEngagementQuestionsTrendArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  thriving: Scalars['Boolean']['input'];
};


export type EngagementAnalyticsEngagementSubcategoriesTrendArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  thriving: Scalars['Boolean']['input'];
};

export type EngagementAnswer = {
  __typename?: 'EngagementAnswer';
  index?: Maybe<Scalars['Int']['output']>;
  questionID: Scalars['ID']['output'];
  skipped: Scalars['Boolean']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type EngagementCategory = {
  __typename?: 'EngagementCategory';
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  order: Scalars['Float']['output'];
  questions: EngagementQuestionConnection;
  subcategories: EngagementSubcategoryConnection;
  title: Scalars['LocalizedString']['output'];
};


export type EngagementCategoryQuestionsArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EngagementCategorySubcategoriesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type EngagementCategoryConnection = {
  __typename?: 'EngagementCategoryConnection';
  edges: Array<EngagementCategoryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EngagementCategoryEdge = {
  __typename?: 'EngagementCategoryEdge';
  cursor: Scalars['ID']['output'];
  node: EngagementCategory;
};

export enum EngagementEnpsType {
  American = 'AMERICAN',
  European = 'EUROPEAN'
}

export enum EngagementInterval {
  Bimonthly = 'BIMONTHLY',
  Biweekly = 'BIWEEKLY',
  HalfYearly = 'HALF_YEARLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type EngagementIntervalDefault = {
  __typename?: 'EngagementIntervalDefault';
  interval: EngagementInterval;
  maxOpenQuestions: Scalars['Int']['output'];
  maxQuestions: Scalars['Int']['output'];
};

export type EngagementQuestion = {
  __typename?: 'EngagementQuestion';
  category: EngagementCategory;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  order: Scalars['Float']['output'];
  subcategory: EngagementSubcategory;
  title: Scalars['LocalizedString']['output'];
  type: EngagementType;
};

export type EngagementQuestionConnection = {
  __typename?: 'EngagementQuestionConnection';
  edges: Array<EngagementQuestionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EngagementQuestionEdge = {
  __typename?: 'EngagementQuestionEdge';
  cursor: Scalars['ID']['output'];
  node: EngagementQuestion;
};

export type EngagementReply = {
  __typename?: 'EngagementReply';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  sender?: Maybe<User>;
  text: Scalars['String']['output'];
};

export type EngagementRequest = {
  __typename?: 'EngagementRequest';
  completed: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  enpsType: EngagementEnpsType;
  id: Scalars['ID']['output'];
  isCancelled: Scalars['Boolean']['output'];
  progress: Scalars['Float']['output'];
  questions: Array<EngagementQuestion>;
  sent: Scalars['Int']['output'];
  template?: Maybe<EngagementTemplate>;
};

export type EngagementRequestConnection = {
  __typename?: 'EngagementRequestConnection';
  edges: Array<EngagementRequestEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EngagementRequestEdge = {
  __typename?: 'EngagementRequestEdge';
  cursor: Scalars['ID']['output'];
  node: EngagementRequest;
};

export type EngagementRequestListingConnection = {
  __typename?: 'EngagementRequestListingConnection';
  edges: Array<EngagementRequestListingEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EngagementRequestListingEdge = {
  __typename?: 'EngagementRequestListingEdge';
  cursor: Scalars['ID']['output'];
  node: EngagementRequestListingNode;
};

export type EngagementRequestListingNode = {
  __typename?: 'EngagementRequestListingNode';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isCancelled: Scalars['Boolean']['output'];
  template?: Maybe<EngagementTemplateListingNode>;
};

export type EngagementResponse = {
  __typename?: 'EngagementResponse';
  answers: Array<EngagementAnswer>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isExpired: Scalars['Boolean']['output'];
  request: EngagementRequest;
  user: User;
};

export enum EngagementResponseType {
  Enps = 'ENPS',
  Face = 'FACE',
  Open = 'OPEN',
  PickOne = 'PICK_ONE'
}

export type EngagementSettings = {
  __typename?: 'EngagementSettings';
  enpsType: EngagementEnpsType;
};

export type EngagementSubcategory = {
  __typename?: 'EngagementSubcategory';
  category: EngagementCategory;
  description?: Maybe<Scalars['LocalizedString']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  order: Scalars['Float']['output'];
  questions: EngagementQuestionConnection;
  title: Scalars['LocalizedString']['output'];
};


export type EngagementSubcategoryQuestionsArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EngagementSubcategoryConnection = {
  __typename?: 'EngagementSubcategoryConnection';
  edges: Array<EngagementSubcategoryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EngagementSubcategoryEdge = {
  __typename?: 'EngagementSubcategoryEdge';
  cursor: Scalars['ID']['output'];
  node: EngagementSubcategory;
};

export type EngagementTemplate = {
  __typename?: 'EngagementTemplate';
  /**
   * Minimum number of responses required for anonymity in engagement surveys.
   * Must be between 1 and 5. Defaults to 5.
   */
  anonymityThreshold: Scalars['Int']['output'];
  categories?: Maybe<Array<EngagementCategory>>;
  endPage?: Maybe<Scalars['LocalizedAttributedString']['output']>;
  expiryInDays?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  instruction?: Maybe<Scalars['LocalizedAttributedString']['output']>;
  interval: EngagementInterval;
  isEnabled: Scalars['Boolean']['output'];
  isScheduled: Scalars['Boolean']['output'];
  maxOpenQuestions?: Maybe<Scalars['Int']['output']>;
  maxQuestions?: Maybe<Scalars['Int']['output']>;
  nextRequestAt?: Maybe<Scalars['DateTime']['output']>;
  reminderDaysInAdvance?: Maybe<Scalars['Int']['output']>;
  targetGroups: Array<Group>;
  targetUsers: Array<User>;
  title: Scalars['LocalizedString']['output'];
  useAllQuestions: Scalars['Boolean']['output'];
  useNps: Scalars['Boolean']['output'];
};


export type EngagementTemplateNextRequestAtArgs = {
  calculate?: InputMaybe<Scalars['Boolean']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EngagementTemplateConnection = {
  __typename?: 'EngagementTemplateConnection';
  edges: Array<EngagementTemplateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EngagementTemplateEdge = {
  __typename?: 'EngagementTemplateEdge';
  cursor: Scalars['ID']['output'];
  node: EngagementTemplate;
};

export type EngagementTemplateListingConnection = {
  __typename?: 'EngagementTemplateListingConnection';
  edges: Array<EngagementTemplateListingEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EngagementTemplateListingEdge = {
  __typename?: 'EngagementTemplateListingEdge';
  cursor: Scalars['ID']['output'];
  node: EngagementTemplateListingNode;
};

export type EngagementTemplateListingNode = {
  __typename?: 'EngagementTemplateListingNode';
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  title: Scalars['LocalizedString']['output'];
};

export type EngagementType = {
  __typename?: 'EngagementType';
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  options?: Maybe<Array<EngagementTypeOption>>;
  title: Scalars['LocalizedString']['output'];
  type: EngagementResponseType;
};

export type EngagementTypeConnection = {
  __typename?: 'EngagementTypeConnection';
  edges: Array<EngagementTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EngagementTypeEdge = {
  __typename?: 'EngagementTypeEdge';
  cursor: Scalars['ID']['output'];
  node: EngagementType;
};

export type EngagementTypeOption = {
  __typename?: 'EngagementTypeOption';
  title?: Maybe<Scalars['LocalizedString']['output']>;
};

export type EngagmentAnswerWithReplies = {
  __typename?: 'EngagmentAnswerWithReplies';
  id: Scalars['ID']['output'];
  owner?: Maybe<User>;
  question: EngagementQuestion;
  replies: Array<EngagementReply>;
  text: Scalars['String']['output'];
};

export type EnsureAssociatedIdentitiesInput = {
  identityProviderID: Scalars['ID']['input'];
  names: Array<Scalars['String']['input']>;
  replaceExisting?: InputMaybe<Scalars['Boolean']['input']>;
  userID: Scalars['ID']['input'];
};

export type EnsureAssociatedIdentitiesResponse = {
  __typename?: 'EnsureAssociatedIdentitiesResponse';
  user: User;
};

export type EnsureSupportAssociatedIdentitiesInput = {
  names: Array<Scalars['String']['input']>;
  userID: Scalars['ID']['input'];
  workspaceID: Scalars['ID']['input'];
};

export type EnsureSupportAssociatedIdentitiesResponse = {
  __typename?: 'EnsureSupportAssociatedIdentitiesResponse';
  workspace: Workspace;
};

export type EntityChangelog = {
  __typename?: 'EntityChangelog';
  changeDoneBy: User;
  changedFields: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  type: EntityChangelogType;
  workspaceID: Scalars['ID']['output'];
};

export type EntityChangelogConnection = {
  __typename?: 'EntityChangelogConnection';
  edges: Array<EntityChangelogEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EntityChangelogEdge = {
  __typename?: 'EntityChangelogEdge';
  cursor: Scalars['ID']['output'];
  node: EntityChangelog;
};

export enum EntityChangelogType {
  AssociatedIdentity = 'ASSOCIATED_IDENTITY',
  Group = 'GROUP',
  User = 'USER'
}

export type EvaluationCompetencyItem = {
  __typename?: 'EvaluationCompetencyItem';
  competency: Competency;
  weight: Scalars['Int']['output'];
};

export type EvaluationCompetencyItemInput = {
  competencyID: Scalars['ID']['input'];
  weight: Scalars['Int']['input'];
};

export type EvaluationDevelopmentPlanItem = {
  __typename?: 'EvaluationDevelopmentPlanItem';
  title: Scalars['LocalizedString']['output'];
};

export type EvaluationDevelopmentPlanItemInput = {
  title?: InputMaybe<Scalars['LocalizedString']['input']>;
};

export enum EvaluationFillInBy {
  Both = 'BOTH',
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER'
}

export enum EvaluationFinalScoreCalculationMethod {
  Average = 'AVERAGE',
  Maximum = 'MAXIMUM',
  Minimum = 'MINIMUM',
  Sum = 'SUM'
}

export enum EvaluationFinalScoreFormat {
  /** The final score is shown as a number with two decimals. */
  Decimal = 'DECIMAL',
  /** The final score is rounded to a level. Default for existing forms. */
  Integer = 'INTEGER'
}

export type EvaluationFinalScoreItem = {
  __typename?: 'EvaluationFinalScoreItem';
  calculationMethod: EvaluationFinalScoreCalculationMethod;
  competencyLevelSet: CompetencyLevelSet;
  displayLevelSet?: Maybe<CompetencyLevelSet>;
  includeReviewGoals: Scalars['Boolean']['output'];
  scoreFormat: EvaluationFinalScoreFormat;
  title?: Maybe<Scalars['LocalizedString']['output']>;
};

export type EvaluationFinalScoreItemInput = {
  calculationMethod: EvaluationFinalScoreCalculationMethod;
  competencyLevelSetID: Scalars['ID']['input'];
  displayLevelSetID?: InputMaybe<Scalars['ID']['input']>;
  includeReviewGoals?: InputMaybe<Scalars['Boolean']['input']>;
  scoreFormat?: InputMaybe<EvaluationFinalScoreFormat>;
  title?: InputMaybe<Scalars['LocalizedString']['input']>;
};

export type EvaluationForm = {
  __typename?: 'EvaluationForm';
  description?: Maybe<Scalars['LocalizedAttributedString']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  jobTitleIDs?: Maybe<Array<Scalars['ID']['output']>>;
  /**
   * Summary of the current live reveal upload of this template. Only visible
   * to superusers (and when the feature is enabled); null otherwise.
   */
  revealUpload?: Maybe<RevealUploadInfo>;
  sections: Array<EvaluationFormSection>;
  showAnswersWhenAllUsersShared?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['LocalizedString']['output'];
  useOnlyInCycle?: Maybe<Scalars['Boolean']['output']>;
};

export type EvaluationFormConnection = {
  __typename?: 'EvaluationFormConnection';
  edges: Array<EvaluationFormEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EvaluationFormEdge = {
  __typename?: 'EvaluationFormEdge';
  cursor: Scalars['ID']['output'];
  node: EvaluationForm;
};

export type EvaluationFormSection = {
  __typename?: 'EvaluationFormSection';
  items: Array<EvaluationSectionItem>;
  /**
   * Percentage (0-100) this section counts for in an averaged final score.
   * Null means neutral: neutral sections share the remainder of 100% equally.
   */
  weight?: Maybe<Scalars['Float']['output']>;
};

export type EvaluationMultipleChoiceItem = {
  __typename?: 'EvaluationMultipleChoiceItem';
  options: Array<EvaluationMultipleChoiceOption>;
  optionsMethod: EvaluationMultipleChoiceOptionsMethod;
  title: Scalars['LocalizedString']['output'];
};

export type EvaluationMultipleChoiceItemInput = {
  options: Array<EvaluationMultipleChoiceOptionInput>;
  optionsMethod: EvaluationMultipleChoiceOptionsMethod;
  title: Scalars['LocalizedString']['input'];
};

export type EvaluationMultipleChoiceOption = {
  __typename?: 'EvaluationMultipleChoiceOption';
  text: Scalars['LocalizedString']['output'];
};

export type EvaluationMultipleChoiceOptionInput = {
  text: Scalars['LocalizedString']['input'];
};

export enum EvaluationMultipleChoiceOptionsMethod {
  Multiple = 'MULTIPLE',
  Single = 'SINGLE'
}

export type EvaluationOpenQuestionItem = {
  __typename?: 'EvaluationOpenQuestionItem';
  title: Scalars['LocalizedString']['output'];
};

export type EvaluationOpenQuestionItemInput = {
  title: Scalars['LocalizedString']['input'];
};

export type EvaluationParagraphItem = {
  __typename?: 'EvaluationParagraphItem';
  text: Scalars['LocalizedAttributedString']['output'];
};

export type EvaluationParagraphItemInput = {
  text: Scalars['LocalizedAttributedString']['input'];
};

/** The reveal data shown for a single conversation. */
export type EvaluationReveal = {
  __typename?: 'EvaluationReveal';
  fields: Array<RevealField>;
  /** Whether the reveal is (already) visible to the employee of the conversation. */
  visibleToEmployee: Scalars['Boolean']['output'];
};

export type EvaluationReviewGoalsItem = {
  __typename?: 'EvaluationReviewGoalsItem';
  competencyLevelSet: CompetencyLevelSet;
  /**
   * Rich text that pre-fills the explanation field of every goal added to this
   * block, so respondents start from a template instead of an empty field.
   */
  defaultExplanation?: Maybe<Scalars['LocalizedAttributedString']['output']>;
};

export type EvaluationReviewGoalsItemInput = {
  competencyLevelSetID: Scalars['ID']['input'];
  defaultExplanation?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
};

export type EvaluationSectionItem = {
  __typename?: 'EvaluationSectionItem';
  competency?: Maybe<EvaluationCompetencyItem>;
  developmentPlan?: Maybe<EvaluationDevelopmentPlanItem>;
  fillInBy: EvaluationFillInBy;
  finalScore?: Maybe<EvaluationFinalScoreItem>;
  id: Scalars['ID']['output'];
  multipleChoice?: Maybe<EvaluationMultipleChoiceItem>;
  openQuestion?: Maybe<EvaluationOpenQuestionItem>;
  optional?: Maybe<Scalars['Boolean']['output']>;
  paragraph?: Maybe<EvaluationParagraphItem>;
  reviewGoals?: Maybe<EvaluationReviewGoalsItem>;
  sentiment?: Maybe<EvaluationSentimentItem>;
  setGoals?: Maybe<EvaluationSetGoalsItem>;
  signature?: Maybe<EvaluationSignatureItem>;
  stars?: Maybe<EvaluationStarsItem>;
  title?: Maybe<EvaluationTitleItem>;
  type: EvaluationSectionItemType;
};

export enum EvaluationSectionItemType {
  Competency = 'COMPETENCY',
  DevelopmentPlan = 'DEVELOPMENT_PLAN',
  FinalScore = 'FINAL_SCORE',
  MultipleChoice = 'MULTIPLE_CHOICE',
  OpenQuestion = 'OPEN_QUESTION',
  Paragraph = 'PARAGRAPH',
  ReviewGoals = 'REVIEW_GOALS',
  Sentiment = 'SENTIMENT',
  SetGoals = 'SET_GOALS',
  Signature = 'SIGNATURE',
  Stars = 'STARS',
  Title = 'TITLE'
}

export enum EvaluationSentimentDisplayMethod {
  Emoji = 'EMOJI',
  Text = 'TEXT'
}

export type EvaluationSentimentItem = {
  __typename?: 'EvaluationSentimentItem';
  displayMethod: EvaluationSentimentDisplayMethod;
  title: Scalars['LocalizedString']['output'];
};

export type EvaluationSentimentItemInput = {
  displayMethod: EvaluationSentimentDisplayMethod;
  title: Scalars['LocalizedString']['input'];
};

export type EvaluationSetGoalsItem = {
  __typename?: 'EvaluationSetGoalsItem';
  title: Scalars['LocalizedString']['output'];
};

export type EvaluationSetGoalsItemInput = {
  title?: InputMaybe<Scalars['LocalizedString']['input']>;
};

export type EvaluationSignatureItem = {
  __typename?: 'EvaluationSignatureItem';
  title?: Maybe<Scalars['LocalizedString']['output']>;
};

export type EvaluationSignatureItemInput = {
  title?: InputMaybe<Scalars['LocalizedString']['input']>;
};

export type EvaluationStarsItem = {
  __typename?: 'EvaluationStarsItem';
  title: Scalars['LocalizedString']['output'];
};

export type EvaluationStarsItemInput = {
  title: Scalars['LocalizedString']['input'];
};

export type EvaluationSubmission = CommentTarget & {
  __typename?: 'EvaluationSubmission';
  /**
   * Whether the employee of this evaluation submission has approved the
   * ConversationAiInsights feature conditions.
   */
  aiInsightsApproved: Scalars['Boolean']['output'];
  comments: Array<Comment>;
  createdAt: Scalars['DateTime']['output'];
  deadline: Scalars['DateTime']['output'];
  employee: EvaluationSubmissionResult;
  evaluationForm: EvaluationSubmissionForm;
  evaluationType?: Maybe<EvaluationType>;
  goals?: Maybe<Array<EvaluationSubmissionGoal>>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  manager: EvaluationSubmissionResult;
  meeting?: Maybe<EvaluationSubmissionMeeting>;
  moment?: Maybe<MomentInstance>;
  overrideReason?: Maybe<Scalars['String']['output']>;
  overrideScore?: Maybe<CompetencyLevel>;
  /**
   * True if the evaluation form contains at least one signature item
   * (i.e. either party still needs to sign at some point).
   *
   * Deprecated: use the party-scoped `viewer.requiresSignature`,
   * `employee.requiresSignature`, or `manager.requiresSignature` instead.
   * @deprecated Use viewer/employee/manager.requiresSignature for a party-scoped value.
   */
  requiresSignature: Scalars['Boolean']['output'];
  /**
   * Reveal data of this conversation. Resolves to null (rather than an error)
   * when the feature is disabled or the viewer may not see it, so conversation
   * queries never break on this field.
   */
  reveal?: Maybe<EvaluationReveal>;
  transcription?: Maybe<Transcription>;
  updatedAt: Scalars['DateTime']['output'];
  viewer: EvaluationSubmissionResult;
  viewerCanChangeConversationPartner: Scalars['Boolean']['output'];
  viewerCanComment: Scalars['Boolean']['output'];
  viewerCanDiscardAnswersFromPredecessor: Scalars['Boolean']['output'];
  viewerCanOverrideScore: Scalars['Boolean']['output'];
  viewerCanViewComments: Scalars['Boolean']['output'];
};


export type EvaluationSubmissionCommentsArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EvaluationSubmissionConnection = {
  __typename?: 'EvaluationSubmissionConnection';
  edges: Array<EvaluationSubmissionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EvaluationSubmissionEdge = {
  __typename?: 'EvaluationSubmissionEdge';
  cursor: Scalars['ID']['output'];
  node: EvaluationSubmission;
};

export type EvaluationSubmissionForm = {
  __typename?: 'EvaluationSubmissionForm';
  description?: Maybe<Scalars['LocalizedAttributedString']['output']>;
  id: Scalars['ID']['output'];
  sections: Array<EvaluationFormSection>;
  title: Scalars['LocalizedString']['output'];
};

export type EvaluationSubmissionGoal = {
  __typename?: 'EvaluationSubmissionGoal';
  competency?: Maybe<CompetencyGoal>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  goal: Goal;
  progress: Scalars['Float']['output'];
  status: GoalStatus;
  title: Scalars['LocalizedString']['output'];
};

export type EvaluationSubmissionItem = {
  __typename?: 'EvaluationSubmissionItem';
  competency?: Maybe<Scalars['Int']['output']>;
  developmentPlan?: Maybe<EvaluationSubmissionItemDevelopmentPlan>;
  multipleChoice?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  openQuestion?: Maybe<Scalars['QuillDelta']['output']>;
  reviewGoals?: Maybe<Array<EvaluationSubmissionItemReviewGoal>>;
  sentiment?: Maybe<Scalars['Int']['output']>;
  setGoals?: Maybe<EvaluationSubmissionItemSetGoals>;
  stars?: Maybe<Scalars['Int']['output']>;
  type: EvaluationSectionItemType;
  viewerCanView?: Maybe<Scalars['Boolean']['output']>;
};

export type EvaluationSubmissionItemDevelopmentPlan = {
  __typename?: 'EvaluationSubmissionItemDevelopmentPlan';
  title: Scalars['LocalizedString']['output'];
};

export type EvaluationSubmissionItemInput = {
  competency?: InputMaybe<Scalars['Int']['input']>;
  finalScore?: InputMaybe<Scalars['Float']['input']>;
  multipleChoice?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  openQuestion?: InputMaybe<Scalars['QuillDelta']['input']>;
  reviewGoals?: InputMaybe<Array<EvaluationSubmissionItemReviewGoalInput>>;
  sentiment?: InputMaybe<Scalars['Int']['input']>;
  stars?: InputMaybe<Scalars['Int']['input']>;
  type: EvaluationSectionItemType;
};

export type EvaluationSubmissionItemReviewGoal = {
  __typename?: 'EvaluationSubmissionItemReviewGoal';
  competency?: Maybe<Scalars['Int']['output']>;
  goalID: Scalars['ID']['output'];
  text: Scalars['QuillDelta']['output'];
};

export type EvaluationSubmissionItemReviewGoalInput = {
  competency?: InputMaybe<Scalars['Int']['input']>;
  goalID: Scalars['ID']['input'];
  text: Scalars['QuillDelta']['input'];
};

export type EvaluationSubmissionItemSetGoals = {
  __typename?: 'EvaluationSubmissionItemSetGoals';
  title: Scalars['LocalizedString']['output'];
};

export type EvaluationSubmissionMeeting = {
  __typename?: 'EvaluationSubmissionMeeting';
  duration: Scalars['Int']['output'];
  /** Calendar status of the employee-party in this conversation. */
  employee: EvaluationSubmissionMeetingStatus;
  link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  /** Calendar status of the manager-party in this conversation. */
  manager: EvaluationSubmissionMeetingStatus;
};

export type EvaluationSubmissionMeetingInput = {
  duration: Scalars['Int']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Calendar status of a participant of a conversation's meeting as reported by
 * their mail/calendar application. Specifically, this reflects whether they've
 * accepted the calendar invite.
 */
export enum EvaluationSubmissionMeetingStatus {
  /** Indicates that the party has accepted the RSVP. */
  Accepted = 'ACCEPTED',
  /** Indicates that the party has declined the RSVP. */
  Declined = 'DECLINED',
  /**
   * Initial status for invited parties. This indicates that the party hasn't
   * RSVP'ed yet.
   */
  NeedsAction = 'NEEDS_ACTION',
  /**
   * Indicates that the party has tentatively accepted the RSVP (i.e. 'Maybe' in
   * Google Calendar).
   */
  Tentative = 'TENTATIVE'
}

export enum EvaluationSubmissionParty {
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER'
}

export type EvaluationSubmissionResult = {
  __typename?: 'EvaluationSubmissionResult';
  finalScore?: Maybe<CompetencyLevel>;
  hasShared: Scalars['Boolean']['output'];
  hasSigned?: Maybe<Scalars['Boolean']['output']>;
  isArchived: Scalars['Boolean']['output'];
  isCompleted: Scalars['Boolean']['output'];
  party: EvaluationSubmissionParty;
  requiresInput: Scalars['Boolean']['output'];
  requiresSignature: Scalars['Boolean']['output'];
  sections: Array<EvaluationSubmissionSection>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  status: EvaluationSubmissionStatus;
  user: User;
  viewerCanArchive: Scalars['Boolean']['output'];
  viewerCanShare: Scalars['Boolean']['output'];
  viewerCanSign: Scalars['Boolean']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
  viewerCanViewAnswers: Scalars['Boolean']['output'];
};

export type EvaluationSubmissionSection = {
  __typename?: 'EvaluationSubmissionSection';
  items: Array<Maybe<EvaluationSubmissionItem>>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type EvaluationSubmissionSectionInput = {
  items: Array<InputMaybe<EvaluationSubmissionItemInput>>;
};

export enum EvaluationSubmissionStatus {
  Draft = 'DRAFT',
  Shared = 'SHARED',
  Signed = 'SIGNED'
}

export type EvaluationTitleItem = {
  __typename?: 'EvaluationTitleItem';
  text: Scalars['LocalizedString']['output'];
};

export type EvaluationTitleItemInput = {
  text: Scalars['LocalizedString']['input'];
};

/**
 * The type of a conversation. REVIEW marks a performance-review conversation
 * (used by the evaluation-reveal feature). A null value is a regular conversation.
 */
export enum EvaluationType {
  Review = 'REVIEW'
}

export type ExchangePersonalAccessTokenResponse = {
  __typename?: 'ExchangePersonalAccessTokenResponse';
  accessToken: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  refreshToken: Scalars['String']['output'];
  userID: Scalars['ID']['output'];
};

export type ExchangeSessionInput = {
  authorizationCode: Scalars['String']['input'];
  state: AuthorizationStateInput;
};

export type ExchangeSessionResponse = {
  __typename?: 'ExchangeSessionResponse';
  session: Session;
};

export type Expertise = {
  __typename?: 'Expertise';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedByUserID?: Maybe<Scalars['ID']['output']>;
  careers: Array<Career>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  title: Scalars['LocalizedString']['output'];
  workspaceID: Scalars['ID']['output'];
};

export type ExpertiseConnection = {
  __typename?: 'ExpertiseConnection';
  edges: Array<ExpertiseEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExpertiseCreateInput = {
  title: Scalars['LocalizedString']['input'];
};

export type ExpertiseEdge = {
  __typename?: 'ExpertiseEdge';
  cursor: Scalars['ID']['output'];
  node: Expertise;
};

export type ExpertiseUpdateInput = {
  id: Scalars['ID']['input'];
  title: Scalars['LocalizedString']['input'];
};

export type ExportConversationsTalentReviewsInput = {
  evaluationFormID: Scalars['ID']['input'];
  fromDate: Scalars['DateTime']['input'];
  talentReviewTemplateID: Scalars['ID']['input'];
  untilDate: Scalars['DateTime']['input'];
};

export type ExportConversationsTalentReviewsResponse = {
  __typename?: 'ExportConversationsTalentReviewsResponse';
  download: UserDownload;
};

/** Represents the file format of a user export. */
export enum ExportFormat {
  /** Returns the export as a CSV file. */
  Csv = 'Csv',
  /** Returns the export as an Excel sheet. */
  Excel = 'Excel'
}

export type ExportResponse = {
  __typename?: 'ExportResponse';
  /** Signed S3 GET URL for the generated file. Expires after one hour. */
  url: Scalars['String']['output'];
};

export type ExportUserDataInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  languageID: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  types: Array<UserExportType>;
  userIDs: Array<Scalars['ID']['input']>;
};

export type ExportUserDataResponse = {
  __typename?: 'ExportUserDataResponse';
  download: UserDownload;
};

export type ExportUsersInput = {
  /** If provided, used to filter conversations by their archived status. */
  archivedConversations?: InputMaybe<Scalars['Boolean']['input']>;
  /** If provided, used to narrow down any conversations (if applicable). */
  conversationTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If provided, used to narrow down any users by department. */
  departmentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * If provided, used to narrow down any talent reviews and conversations (if
   * applicable).
   */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * If provided, overrides the default export format (Excel) with any other
   * supported export format.
   */
  format?: InputMaybe<ExportFormat>;
  /**
   * If provided, used to determine whether multiple talent reviews/conversations
   * of the same user should be grouped in the same row (default: yes).
   */
  groupByUser?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If provided, used to determine whether the export should include the manager's
   * draft answers for conversations.
   */
  includeManagerDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  languageID: Scalars['ID']['input'];
  /**
   * If provided, used to narrow down any talent reviews and conversations (if
   * applicable).
   */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** If provided, used to narrow down any users by their status. */
  status?: InputMaybe<UserStatus>;
  /** If provided, used to narrow down any talent reviews (if applicable). */
  talentReviewTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ExternalKakapoFeedback = {
  __typename?: 'ExternalKakapoFeedback';
  responseID: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export type FailedSsoAttempt = {
  __typename?: 'FailedSsoAttempt';
  externalID: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
};

export type FailedSsoAttemptConnection = {
  __typename?: 'FailedSsoAttemptConnection';
  edges: Array<FailedSsoAttemptEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FailedSsoAttemptEdge = {
  __typename?: 'FailedSsoAttemptEdge';
  cursor: Scalars['ID']['output'];
  node: FailedSsoAttempt;
};

export type Feature = {
  __typename?: 'Feature';
  id: FeatureName;
  stability: FeatureStability;
};

export type FeatureApproval = {
  __typename?: 'FeatureApproval';
  approvedAt: Scalars['DateTime']['output'];
  approvedBy: User;
  conditionsVersion: Scalars['String']['output'];
  featureName: FeatureName;
  id: Scalars['ID']['output'];
  targetID: Scalars['ID']['output'];
  targetType: FeatureApprovalTargetType;
};

export type FeatureApprovalTarget = User | Workspace;

export enum FeatureApprovalTargetType {
  User = 'USER',
  Workspace = 'WORKSPACE'
}

export type FeatureConditions = {
  __typename?: 'FeatureConditions';
  currentVersion: Scalars['String']['output'];
  featureName: FeatureName;
  linkToConditions: Scalars['String']['output'];
  targetTypes: Array<FeatureApprovalTargetType>;
};

export enum FeatureName {
  AddGoalsToOrganisationGoals = 'ADD_GOALS_TO_ORGANISATION_GOALS',
  AdvancedAgent = 'ADVANCED_AGENT',
  Ai = 'AI',
  AiAgent = 'AI_AGENT',
  Analytics = 'ANALYTICS',
  AnalyticsFeedbackOnCompetencies = 'ANALYTICS_FEEDBACK_ON_COMPETENCIES',
  AnalyticsIncludeCompetenciesFromConversations = 'ANALYTICS_INCLUDE_COMPETENCIES_FROM_CONVERSATIONS',
  AnalyticsTeams = 'ANALYTICS_TEAMS',
  ApiPermissions = 'API_PERMISSIONS',
  AppraisalsIncludeCompetenciesFromConversations = 'APPRAISALS_INCLUDE_COMPETENCIES_FROM_CONVERSATIONS',
  Billing = 'BILLING',
  Checkpoints = 'CHECKPOINTS',
  CompetencyDetailScreen = 'COMPETENCY_DETAIL_SCREEN',
  CompetencyFeedbackNotObservedOption = 'COMPETENCY_FEEDBACK_NOT_OBSERVED_OPTION',
  CompetencyGoals = 'COMPETENCY_GOALS',
  Compliments = 'COMPLIMENTS',
  ConversationsOptionalQuestions = 'CONVERSATIONS_OPTIONAL_QUESTIONS',
  ConversationAiInsights = 'CONVERSATION_AI_INSIGHTS',
  ConversationOnlyWithManager = 'CONVERSATION_ONLY_WITH_MANAGER',
  ConversationPlanning = 'CONVERSATION_PLANNING',
  ConversationTranscriptions = 'CONVERSATION_TRANSCRIPTIONS',
  CustomEmailDomain = 'CUSTOM_EMAIL_DOMAIN',
  CustomEmailDomainOptionalMailfrom = 'CUSTOM_EMAIL_DOMAIN_OPTIONAL_MAILFROM',
  Cycles = 'CYCLES',
  CycleAnalytics = 'CYCLE_ANALYTICS',
  CycleCompletedOnDurationExceeded = 'CYCLE_COMPLETED_ON_DURATION_EXCEEDED',
  DevelopmentPlan = 'DEVELOPMENT_PLAN',
  EmailDelivery = 'EMAIL_DELIVERY',
  Engagement = 'ENGAGEMENT',
  EngagementEndPage = 'ENGAGEMENT_END_PAGE',
  EngagementReminder = 'ENGAGEMENT_REMINDER',
  EngagementReply = 'ENGAGEMENT_REPLY',
  Evaluations = 'EVALUATIONS',
  EvaluationsAdhoc = 'EVALUATIONS_ADHOC',
  EvaluationsContext = 'EVALUATIONS_CONTEXT',
  EvaluationsOverride = 'EVALUATIONS_OVERRIDE',
  EvaluationReveal = 'EVALUATION_REVEAL',
  ExternalMcp = 'EXTERNAL_MCP',
  Feedback = 'FEEDBACK',
  FeedbackAdhoc = 'FEEDBACK_ADHOC',
  FeedbackCompetencies = 'FEEDBACK_COMPETENCIES',
  FeedbackFixedCycleRelease = 'FEEDBACK_FIXED_CYCLE_RELEASE',
  FeedbackGoals = 'FEEDBACK_GOALS',
  FeedbackLockCycleTemplate = 'FEEDBACK_LOCK_CYCLE_TEMPLATE',
  FeedbackQuestionsVisibility = 'FEEDBACK_QUESTIONS_VISIBILITY',
  FeedbackReply = 'FEEDBACK_REPLY',
  FeedbackShare = 'FEEDBACK_SHARE',
  FeedbackSpontaneous = 'FEEDBACK_SPONTANEOUS',
  FeedbackVoiceMemos = 'FEEDBACK_VOICE_MEMOS',
  FinalScoreSumCalculation = 'FINAL_SCORE_SUM_CALCULATION',
  Goals = 'GOALS',
  GoalsAudit = 'GOALS_AUDIT',
  GoalsParentDepartmentGoals = 'GOALS_PARENT_DEPARTMENT_GOALS',
  GoalLabels = 'GOAL_LABELS',
  Goodhabitz = 'GOODHABITZ',
  GrowPath = 'GROW_PATH',
  Helicopter = 'HELICOPTER',
  HideConversationDeadlineConfig = 'HIDE_CONVERSATION_DEADLINE_CONFIG',
  HideOwnerInTalentReview = 'HIDE_OWNER_IN_TALENT_REVIEW',
  HideYouAsConversationPartner = 'HIDE_YOU_AS_CONVERSATION_PARTNER',
  HrBusinessPartnerRole = 'HR_BUSINESS_PARTNER_ROLE',
  JobCompetencies = 'JOB_COMPETENCIES',
  JobCompetenciesExplorer = 'JOB_COMPETENCIES_EXPLORER',
  JobGoalTemplates = 'JOB_GOAL_TEMPLATES',
  Learning = 'LEARNING',
  Mfa = 'MFA',
  ModuleSkills = 'MODULE_SKILLS',
  MultiRoleConversion = 'MULTI_ROLE_CONVERSION',
  Notes = 'NOTES',
  OneOnOnes = 'ONE_ON_ONES',
  OnlyAllowSigningWhenEmployeeHasSigned = 'ONLY_ALLOW_SIGNING_WHEN_EMPLOYEE_HAS_SIGNED',
  OrderedEngagementSurveys = 'ORDERED_ENGAGEMENT_SURVEYS',
  ProductBeamer = 'PRODUCT_BEAMER',
  QuillPhotoVideo = 'QUILL_PHOTO_VIDEO',
  ScimIncludeCustomSchemaPrefix = 'SCIM_INCLUDE_CUSTOM_SCHEMA_PREFIX',
  ScimSsoFix = 'SCIM_SSO_FIX',
  SearchOnSkills = 'SEARCH_ON_SKILLS',
  ShowRecommendPage = 'SHOW_RECOMMEND_PAGE',
  SoundRecorderV2 = 'SOUND_RECORDER_V2',
  Succession = 'SUCCESSION',
  TalentReviews = 'TALENT_REVIEWS',
  TalentReviewsScores = 'TALENT_REVIEWS_SCORES',
  TalentReviewsV2 = 'TALENT_REVIEWS_V2',
  TalentReviewAnalytics = 'TALENT_REVIEW_ANALYTICS',
  TeamGoals = 'TEAM_GOALS',
  TreamsScore = 'TREAMS_SCORE'
}

/**
 * A feature rating given by a user for a target.
 * Used to capture feedback on features like AI-generated insights.
 */
export type FeatureRating = {
  __typename?: 'FeatureRating';
  binaryValue?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  featureName: FeatureName;
  id: Scalars['ID']['output'];
  targetID: Scalars['ID']['output'];
  targetType: FeatureRatingTargetType;
  text?: Maybe<Scalars['String']['output']>;
  viewer: User;
  viewerID: Scalars['ID']['output'];
};

/** The type of the target that the rating is given for. */
export enum FeatureRatingTargetType {
  EvaluationSubmission = 'EVALUATION_SUBMISSION',
  NoteSummary = 'NOTE_SUMMARY',
  NoteTalkingPoints = 'NOTE_TALKING_POINTS'
}

export enum FeatureStability {
  Alpha = 'ALPHA',
  Beta = 'BETA',
  Stable = 'STABLE'
}

export type FeatureWorkspaceEntry = {
  __typename?: 'FeatureWorkspaceEntry';
  status: WorkspaceFeatureStatus;
  workspaceID: Scalars['ID']['output'];
};

export type FeatureWorkspaceOverview = {
  __typename?: 'FeatureWorkspaceOverview';
  featureName: FeatureName;
  stability: FeatureStability;
  workspaces: Array<FeatureWorkspaceEntry>;
};

export enum FeedItemType {
  Evaluation = 'EVALUATION',
  Feedback = 'FEEDBACK',
  Moment = 'MOMENT',
  Notes = 'NOTES',
  NoteConversation = 'NOTE_CONVERSATION'
}

export type FeedbackExternal = {
  __typename?: 'FeedbackExternal';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

/**
 * This represents the mode that this feedback request was created in. In
 * spontaneous mode, the feedback request is initiated by the respondent instead of
 * the recipient of the feedback.
 */
export enum FeedbackMode {
  Prompted = 'PROMPTED',
  Spontaneous = 'SPONTANEOUS'
}

export type FeedbackQuestion = {
  __typename?: 'FeedbackQuestion';
  additionalDetails: Scalars['LocalizedAttributedString']['output'];
  category: FeedbackQuestionCategory;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  options: Array<FeedbackQuestionOption>;
  order: Scalars['Float']['output'];
  subTitle: Scalars['LocalizedString']['output'];
  text: Scalars['LocalizedString']['output'];
  type: FeedbackQuestionType;
};

export type FeedbackQuestionCategory = {
  __typename?: 'FeedbackQuestionCategory';
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['LocalizedString']['output'];
  order: Scalars['Float']['output'];
};

export type FeedbackQuestionCategoryConnection = {
  __typename?: 'FeedbackQuestionCategoryConnection';
  edges: Array<FeedbackQuestionCategoryEdge>;
  pageInfo: PageInfo;
};

export type FeedbackQuestionCategoryEdge = {
  __typename?: 'FeedbackQuestionCategoryEdge';
  cursor: Scalars['ID']['output'];
  node: FeedbackQuestionCategory;
};

export type FeedbackQuestionConnection = {
  __typename?: 'FeedbackQuestionConnection';
  edges: Array<FeedbackQuestionEdge>;
  pageInfo: PageInfo;
};

export type FeedbackQuestionEdge = {
  __typename?: 'FeedbackQuestionEdge';
  cursor: Scalars['ID']['output'];
  node: FeedbackQuestion;
};

export type FeedbackQuestionOption = {
  __typename?: 'FeedbackQuestionOption';
  id: Scalars['ID']['output'];
  text: Scalars['LocalizedString']['output'];
};

export type FeedbackQuestionOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['LocalizedString']['input'];
};

export enum FeedbackQuestionType {
  Both = 'BOTH',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Stars = 'STARS',
  Text = 'TEXT'
}

export type FeedbackRecipient = FeedbackExternal | User;

/**
 * This represents a single feedback request that is sent to one or more
 * recipients.
 */
export type FeedbackRequest = {
  __typename?: 'FeedbackRequest';
  /** This is the creation date of this feedback request. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * This is the due date of this feedback request. Recipients won't be able to
   * respond after this point in time.
   */
  dueDate: Scalars['DateTime']['output'];
  /** This is the ID of this request. */
  id: Scalars['ID']['output'];
  /**
   * Instructional message that is sent to all recipients, regardless of
   * internal/external.
   */
  instruction?: Maybe<Scalars['QuillDelta']['output']>;
  /** Reflects whether this request has been archived by its owner. */
  isArchived: Scalars['Boolean']['output'];
  /** This is the feedback mode that this request was created in. */
  mode: FeedbackMode;
  /** These are the questions of this feedback request. */
  questions: Array<FeedbackRequestQuestion>;
  /**
   * If present, submitted answers stay hidden from the feedback subject until
   * this date. Responses submitted after this date are visible immediately.
   */
  releaseDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * This is a connection of responses. This will always contain one response for
   * each recipient, regardless of whether they have shared their response.
   */
  responses: FeedbackResponseConnection;
  sharedFeedback: SharedFeedbackConnection;
  /** This is the title of this feedback request. */
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /**
   * This is the user that is requesting feedback, or on whose behalf feedback is
   * requested.
   */
  user: User;
};


/**
 * This represents a single feedback request that is sent to one or more
 * recipients.
 */
export type FeedbackRequestResponsesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FeedbackRequestConnection = {
  __typename?: 'FeedbackRequestConnection';
  edges: Array<FeedbackRequestEdge>;
  pageInfo: PageInfo;
};

/** Represents a single edge in a feedback request connection. */
export type FeedbackRequestEdge = {
  __typename?: 'FeedbackRequestEdge';
  cursor: Scalars['ID']['output'];
  node: FeedbackRequest;
};

export type FeedbackRequestGoal = {
  __typename?: 'FeedbackRequestGoal';
  competency?: Maybe<CompetencyGoal>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  progress: Scalars['Float']['output'];
  status: GoalStatus;
  title: Scalars['LocalizedString']['output'];
};

/** This represents a question in a feedback request. */
export type FeedbackRequestQuestion = {
  __typename?: 'FeedbackRequestQuestion';
  /**
   * This field contains the rich-text context of this question, shown behind
   * the "More information" button.
   */
  additionalDetails?: Maybe<Scalars['QuillDelta']['output']>;
  /**
   * When true, the feedback subject and colleagues the feedback is shared with
   * can see answers to this question. When false, answers remain visible only
   * to the respondent, the subject's managers, and superusers/support.
   */
  canSubjectView: Scalars['Boolean']['output'];
  /**
   * This is the category of this question. This field is usually only present
   * for questions originating from a template.
   */
  category?: Maybe<FeedbackQuestionCategory>;
  competency?: Maybe<Competency>;
  goal?: Maybe<FeedbackRequestGoal>;
  goalRevision?: Maybe<GoalRevision>;
  /**
   * This is the ID of this question. This ID can be used to cross reference
   * questions in requests to answers in responses.
   */
  id: Scalars['ID']['output'];
  /** This field contains the localizable text of this question. */
  localizedText?: Maybe<Scalars['LocalizedString']['output']>;
  /**
   * This field contains the selectable options of this question. It is only
   * relevant for questions of type MULTIPLE_CHOICE.
   */
  options: Array<FeedbackQuestionOption>;
  /** This field contains the plain-text subtitle of this question. */
  subTitle?: Maybe<Scalars['String']['output']>;
  /** This field contains the non-localizable text of this ad-hoc question. */
  text: Scalars['String']['output'];
  /** This field contains the type of this question. */
  type: FeedbackQuestionType;
};

export type FeedbackRequestQuestionInput = {
  /**
   * This field contains the rich-text context of this question, shown behind
   * the "More information" button.
   */
  additionalDetails?: InputMaybe<Scalars['QuillDelta']['input']>;
  /**
   * When true, the feedback subject can see answers to this question. For
   * requests attached to a moment with a prescribed template, this must match
   * the template question's value.
   */
  canSubjectView?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * This field contains the ID of the category that this question may fall in
   * if it originates from a template.
   */
  categoryID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * This field contains the ID of the competency that this question is related
   * to.
   */
  competencyID?: InputMaybe<Scalars['ID']['input']>;
  /** This field contains the ID of the goal that this question is related to. */
  goalID?: InputMaybe<Scalars['ID']['input']>;
  /** The localizable text version of this question */
  localizedText?: InputMaybe<Scalars['LocalizedString']['input']>;
  /**
   * This field contains the selectable options of this question. It is only
   * relevant for questions of type MULTIPLE_CHOICE.
   */
  options?: InputMaybe<Array<FeedbackQuestionOptionInput>>;
  /** This field contains the plain-text subtitle of this question. */
  subTitle?: InputMaybe<Scalars['String']['input']>;
  /** This field contains the non-localizable text of this ad-hoc question. */
  text: Scalars['String']['input'];
  /** This field contains the type of this question. */
  type: FeedbackQuestionType;
};

export type FeedbackResponse = CommentTarget & {
  __typename?: 'FeedbackResponse';
  /**
   * These are the answers of this feedback response. This will be null when the
   * response hasn't been shared yet and the current user isn't allowed to view
   * the answers.
   */
  answers?: Maybe<Array<FeedbackResponseAnswer>>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  comments: Array<Comment>;
  createdAt: Scalars['DateTime']['output'];
  dueDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /**
   * Instructional message that is sent to all recipients, regardless of
   * internal/external.
   */
  instruction?: Maybe<Scalars['QuillDelta']['output']>;
  isArchived: Scalars['Boolean']['output'];
  /** These are the questions of this feedback request. */
  questions: Array<FeedbackRequestQuestion>;
  recipient: FeedbackRecipient;
  /**
   * If present, submitted answers stay hidden from the feedback subject until
   * this date. Respondents can keep editing their shared response until then.
   */
  releaseDate?: Maybe<Scalars['DateTime']['output']>;
  requestID: Scalars['ID']['output'];
  requestor: User;
  sharedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Represents the status of this response. */
  status: FeedbackResponseStatus;
  /** This is the title of this feedback request. */
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewerCanComment: Scalars['Boolean']['output'];
  viewerCanViewComments: Scalars['Boolean']['output'];
};


export type FeedbackResponseAnswersArgs = {
  secret?: InputMaybe<Scalars['String']['input']>;
};


export type FeedbackResponseCommentsArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeedbackResponseAnswer = {
  __typename?: 'FeedbackResponseAnswer';
  competencyLevelIndex?: Maybe<Scalars['Int']['output']>;
  questionID: Scalars['ID']['output'];
  selectedOptionID?: Maybe<Scalars['ID']['output']>;
  stars?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['QuillDelta']['output']>;
  voiceMemo?: Maybe<VoiceMemo>;
};

export type FeedbackResponseAnswerInput = {
  competencyLevelIndex?: InputMaybe<Scalars['Int']['input']>;
  questionID: Scalars['ID']['input'];
  selectedOptionID?: InputMaybe<Scalars['ID']['input']>;
  stars?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['QuillDelta']['input']>;
  voiceMemo?: InputMaybe<VoiceMemoInput>;
};

export type FeedbackResponseConnection = {
  __typename?: 'FeedbackResponseConnection';
  edges: Array<FeedbackResponseEdge>;
  pageInfo: PageInfo;
};

export type FeedbackResponseEdge = {
  __typename?: 'FeedbackResponseEdge';
  cursor: Scalars['ID']['output'];
  node: FeedbackResponse;
};

export enum FeedbackResponseStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Shared = 'SHARED'
}

export type FeedbackTemplate = {
  __typename?: 'FeedbackTemplate';
  description: Scalars['LocalizedAttributedString']['output'];
  id: Scalars['ID']['output'];
  instruction: Scalars['LocalizedAttributedString']['output'];
  isArchived: Scalars['Boolean']['output'];
  /** @deprecated Use `roles = [CYCLES]` instead. */
  isPrivate: Scalars['Boolean']['output'];
  jobTitleIDs?: Maybe<Array<Scalars['ID']['output']>>;
  questions: Array<FeedbackTemplateQuestion>;
  roles: Array<FeedbackTemplateRole>;
  title: Scalars['LocalizedString']['output'];
};

export type FeedbackTemplateConnection = {
  __typename?: 'FeedbackTemplateConnection';
  edges: Array<FeedbackTemplateEdge>;
  pageInfo: PageInfo;
};

export type FeedbackTemplateEdge = {
  __typename?: 'FeedbackTemplateEdge';
  cursor: Scalars['ID']['output'];
  node: FeedbackTemplate;
};

export type FeedbackTemplateFilters = {
  role?: InputMaybe<FeedbackTemplateRole>;
};

export type FeedbackTemplateQuestion = {
  __typename?: 'FeedbackTemplateQuestion';
  /**
   * When true, the feedback subject and colleagues the feedback is shared with
   * can see answers to this question. When false, answers remain visible only
   * to the respondent, the subject's managers, and superusers/support.
   */
  canSubjectView: Scalars['Boolean']['output'];
  instruction: Scalars['LocalizedAttributedString']['output'];
  question: FeedbackQuestion;
};

export type FeedbackTemplateQuestionInput = {
  canSubjectView?: InputMaybe<Scalars['Boolean']['input']>;
  instruction: Scalars['LocalizedAttributedString']['input'];
  questionID: Scalars['ID']['input'];
};

export enum FeedbackTemplateRole {
  /**
   * Indicates that this feedback template can be used in cycles. In this case,
   * a superuser can use this template for a feedback request moment in a cycle,
   * but the template cannot necessarily be used by individual employees (unless
   * one of the other roles is set).
   */
  Cycles = 'CYCLES',
  /**
   * Indicates that this feedback template can be used by individual employees to
   * receive feedback on their growth path competencies.
   */
  GrowthPath = 'GROWTH_PATH',
  /**
   * Indicates that this feedback template can be used by individual employees to
   * request feedback.
   */
  Request = 'REQUEST',
  /**
   * Indicates that this feedback template can be used by individual employees to
   * give spontaneous feedback.
   */
  Spontaneous = 'SPONTANEOUS'
}

export type FeedbackTipsInput = {
  answer: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type FinalizeTranscriptionUploadInput = {
  transcriptionID: Scalars['String']['input'];
};

export type FinalizeTranscriptionUploadResponse = {
  __typename?: 'FinalizeTranscriptionUploadResponse';
  transcriptionID: Scalars['String']['output'];
};

export type FinalizeUserDocumentV2UploadInput = {
  documentID: Scalars['ID']['input'];
};

export type FinalizeUserDocumentV2UploadResponse = {
  __typename?: 'FinalizeUserDocumentV2UploadResponse';
  documentID: Scalars['ID']['output'];
};

export type ForgotPasswordInput = {
  username: Scalars['String']['input'];
};

export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  delivery: CodeDelivery;
};

export type GenerateApiTokenResponse = {
  __typename?: 'GenerateApiTokenResponse';
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GetRevealUploadUrlResponse = {
  __typename?: 'GetRevealUploadUrlResponse';
  objectKey: Scalars['String']['output'];
  uploadHeaders: Array<RevealUploadHeader>;
  uploadUrl: Scalars['String']['output'];
};

export type Goal = Auditable & CommentTarget & {
  __typename?: 'Goal';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<User>;
  auditTrail: AuditTrailConnection;
  checklistItems: Array<GoalChecklistItem>;
  children: GoalConnection;
  comments: Array<Comment>;
  competency?: Maybe<CompetencyGoal>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  description: Scalars['QuillDelta']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  feasibility?: Maybe<GoalFeasibility>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  label?: Maybe<Label>;
  linkedGoalDrivers: Array<GoalDriver>;
  linkedGoals: Array<Goal>;
  moment?: Maybe<MomentInstance>;
  momentID?: Maybe<Scalars['ID']['output']>;
  order: Scalars['Float']['output'];
  owner: GoalOwner;
  ownerType: GoalOwnerType;
  parent?: Maybe<Goal>;
  progress: Scalars['Float']['output'];
  progressOverride?: Maybe<Scalars['Float']['output']>;
  status: GoalStatus;
  title: Scalars['LocalizedString']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  viewerCanComment: Scalars['Boolean']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
  viewerCanViewChildren: Scalars['Boolean']['output'];
  viewerCanViewComments: Scalars['Boolean']['output'];
  /**
   * Contains the visibility setting for this goal. Reflects whether the goal
   * should be visible to colleagues.
   */
  visibility: GoalVisibility;
};


export type GoalAuditTrailArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GoalCommentsArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GoalChecklistItem = {
  __typename?: 'GoalChecklistItem';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  description: Scalars['LocalizedAttributedString']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  learningCourse?: Maybe<LearningCourse>;
  learningCourseID?: Maybe<Scalars['ID']['output']>;
  progress: GoalChecklistItemProgress;
  status: ChecklistItemStatus;
  title: Scalars['LocalizedString']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type GoalChecklistItemProgress = {
  __typename?: 'GoalChecklistItemProgress';
  lower?: Maybe<Scalars['Float']['output']>;
  type: GoalChecklistItemType;
  upper?: Maybe<Scalars['Float']['output']>;
  value: Scalars['Float']['output'];
  valueNormalized: Scalars['Float']['output'];
};

export type GoalChecklistItemProgressInput = {
  lower?: InputMaybe<Scalars['Float']['input']>;
  type: GoalChecklistItemType;
  upper?: InputMaybe<Scalars['Float']['input']>;
  value: Scalars['Float']['input'];
};

export enum GoalChecklistItemType {
  Checkbox = 'CHECKBOX',
  Currency = 'CURRENCY',
  /**
   * A subgoal linked to a learning course. Progress will reflect course
   * completion; it is not user-editable.
   */
  Learning = 'LEARNING',
  Percentage = 'PERCENTAGE',
  Range = 'RANGE'
}

export type GoalConnection = {
  __typename?: 'GoalConnection';
  edges: Array<GoalEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GoalDriver = {
  __typename?: 'GoalDriver';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  order: Scalars['Float']['output'];
  title: Scalars['LocalizedString']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type GoalEdge = {
  __typename?: 'GoalEdge';
  cursor: Scalars['ID']['output'];
  node: Goal;
};

export enum GoalFeasibility {
  CloseCall = 'CLOSE_CALL',
  WillMakeIt = 'WILL_MAKE_IT',
  WontMakeIt = 'WONT_MAKE_IT'
}

export type GoalLearningRecommendationsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type GoalOwner = Group | User | Workspace;

export enum GoalOwnerType {
  Department = 'DEPARTMENT',
  Team = 'TEAM',
  User = 'USER',
  Workspace = 'WORKSPACE'
}

export type GoalRevision = {
  __typename?: 'GoalRevision';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  checklistItems: Array<GoalChecklistItem>;
  competency?: Maybe<CompetencyGoal>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['QuillDelta']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  feasibility?: Maybe<GoalFeasibility>;
  goalID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  label?: Maybe<Label>;
  progress: Scalars['Float']['output'];
  progressOverride?: Maybe<Scalars['Float']['output']>;
  revision: Scalars['String']['output'];
  secret: Scalars['String']['output'];
  status: GoalStatus;
  title: Scalars['LocalizedString']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum GoalStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED'
}

export type GoalTemplate = {
  __typename?: 'GoalTemplate';
  competency?: Maybe<CompetencyGoal>;
  description: Scalars['LocalizedAttributedString']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  jobTitles: Array<JobTitle>;
  label?: Maybe<Label>;
  relativeDueDate?: Maybe<Scalars['Int']['output']>;
  title: Scalars['LocalizedString']['output'];
};

export type GoalTemplateConnection = {
  __typename?: 'GoalTemplateConnection';
  edges: Array<GoalTemplateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GoalTemplateEdge = {
  __typename?: 'GoalTemplateEdge';
  cursor: Scalars['ID']['output'];
  node: GoalTemplate;
};

export enum GoalVisibility {
  /**
   * This option will prevent colleagues from viewing this goal. When assigning
   * the goal to a department parent goal, this option will still hide the goal
   * to colleagues on the department goals page.
   */
  Private = 'PRIVATE',
  /**
   * This option allows anyone with the URL to this goal to view it. Similarly,
   * when assigning the goal to a department parent goal, this option will show
   * the goal to colleagues on the department goals page.
   */
  Public = 'PUBLIC'
}

/**
 * The GoodHabitz learning connector for a workspace. The catalog options, API key and
 * `lastSyncedAt` are stored as a single `ConnectorConfig` item (`workspaceID/GOODHABITZ`, key
 * `goodhabitz`), while `enabled` reflects the `isActive` flag on the GoodHabitz row in the
 * `Connectors` table. The raw API key is never exposed through the API — only `hasApiKey`.
 */
export type GoodHabitzConfig = {
  __typename?: 'GoodHabitzConfig';
  enabled: Scalars['Boolean']['output'];
  /** Whether a per-workspace GoodHabitz API key is stored. The key itself is never returned. */
  hasApiKey: Scalars['Boolean']['output'];
  /**
   * Treams language IDs (e.g. "nl_NL") whose GoodHabitz content is synced for this workspace.
   * Empty means every language Treams supports.
   */
  languageIDs: Array<Scalars['String']['output']>;
  /**
   * ISO timestamp of the last successful GoodHabitz content sync, or null when the connector
   * has never synced.
   */
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
};

export type Group = {
  __typename?: 'Group';
  createdAt: Scalars['DateTime']['output'];
  externalReferenceID?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `goalsV2` instead. */
  goals: Array<Goal>;
  goalsV2: GoalConnection;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isRoot: Scalars['Boolean']['output'];
  managers: GroupManagerConnection;
  members: GroupMemberConnection;
  name: Scalars['String']['output'];
  parent?: Maybe<Group>;
  paths: Array<GroupPath>;
  /**
   * The viewer's talent review cycle moment for this group: the open
   * moment (if several: the earliest deadline, even if it has passed),
   * otherwise a submitted moment that can still be reverted. Managers of
   * the group and HR also see someone else's submitted moment, up to and
   * including the deadline. Null without a running cycle. Meant for a
   * single group, not for lists.
   */
  talentReviewCycleMoment?: Maybe<MomentInstance>;
  /** Latest placement write of this group. Null when there is no grid yet. */
  talentReviewLatestActivity?: Maybe<TalentReviewLatestActivity>;
  talentReviewSnapshots: TalentReviewSnapshotConnection;
  talentReviews: TalentReviewConnection;
  tasks: Array<Task>;
  type: GroupType;
  updatedAt: Scalars['DateTime']['output'];
  viewerCanCreateGoal: Scalars['Boolean']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
  viewerCanViewAnalytics: Scalars['Boolean']['output'];
  viewerCanViewArchivedGoals: Scalars['Boolean']['output'];
  viewerCanViewEngagementAnalytics: Scalars['Boolean']['output'];
  viewerCanViewGoalAuditTrail: Scalars['Boolean']['output'];
  viewerCanViewGoals: Scalars['Boolean']['output'];
  viewerCanViewTalentReviews: Scalars['Boolean']['output'];
};


export type GroupGoalsArgs = {
  status: GoalStatus;
};


export type GroupGoalsV2Args = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<GoalStatus>;
};


export type GroupManagersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GroupMembersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  roleTypes?: InputMaybe<Array<RoleType>>;
};


export type GroupTalentReviewSnapshotsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GroupTalentReviewsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  templateID?: InputMaybe<Scalars['ID']['input']>;
  untilDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GroupAnalytics = {
  __typename?: 'GroupAnalytics';
  engagementENPS: AnalyticsEngagementEnps;
  engagementGroupsENPS: Array<AnalyticsEngagementGroupEnps>;
  engagementGroupsParticipation: Array<AnalyticsEngagementGroupParticipation>;
  engagementGroupsSubcategoriesScore: Array<AnalyticsEngagementGroupSubcategoryScore>;
  engagementOpenQuestions: Array<AnalyticsEngagementOpenQuestion>;
  engagementParticipationOverTime: AnalyticsEngagementParticipation;
  engagementQuestionsTrend: Array<AnalyticsEngagementQuestionScoreTrend>;
  engagementScoreOverTime: AnalyticsEngagementScore;
  engagementSubcategoriesTrend: Array<AnalyticsEngagementSubcategoryScoreOverTime>;
};


export type GroupAnalyticsEngagementQuestionsTrendArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  thriving: Scalars['Boolean']['input'];
};


export type GroupAnalyticsEngagementSubcategoriesTrendArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  thriving: Scalars['Boolean']['input'];
};

export type GroupConnection = {
  __typename?: 'GroupConnection';
  edges: Array<GroupEdge>;
  pageInfo: PageInfo;
};

export type GroupEdge = {
  __typename?: 'GroupEdge';
  cursor: Scalars['ID']['output'];
  node: Group;
};

export type GroupManagerConnection = {
  __typename?: 'GroupManagerConnection';
  edges: Array<GroupManagerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupManagerEdge = {
  __typename?: 'GroupManagerEdge';
  cursor: Scalars['ID']['output'];
  node: User;
  role: Role;
};

export type GroupMemberConnection = {
  __typename?: 'GroupMemberConnection';
  edges: Array<GroupMemberEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupMemberEdge = {
  __typename?: 'GroupMemberEdge';
  cursor: Scalars['ID']['output'];
  node: User;
  role: Role;
};

export type GroupPath = {
  __typename?: 'GroupPath';
  groups: Array<Group>;
};

export enum GroupType {
  Department = 'DEPARTMENT',
  Region = 'REGION',
  Team = 'TEAM'
}

export type GroupsFilter = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<GroupType>>;
};

export type IdentityProvider = {
  __typename?: 'IdentityProvider';
  configuration?: Maybe<IdentityProviderConfiguration>;
  id: Scalars['ID']['output'];
  metadataFile?: Maybe<Scalars['String']['output']>;
  metadataURL?: Maybe<Scalars['String']['output']>;
};

export type IdentityProviderConfiguration = {
  __typename?: 'IdentityProviderConfiguration';
  domains?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ImpersonateSessionSlotInput = {
  userID: Scalars['String']['input'];
};

export type InboxTask = {
  __typename?: 'InboxTask';
  createdAt: Scalars['DateTime']['output'];
  evaluationSubmission?: Maybe<EvaluationSubmission>;
  feedbackResponse?: Maybe<FeedbackResponse>;
  id: Scalars['ID']['output'];
  moment?: Maybe<MomentInstance>;
  seen: Scalars['Boolean']['output'];
  status: InboxTaskStatus;
  type: InboxTaskType;
};

export enum InboxTaskStatus {
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  Open = 'OPEN'
}

export enum InboxTaskType {
  EvaluationSubmissionOpen = 'EVALUATION_SUBMISSION_OPEN',
  FeedbackRequestPending = 'FEEDBACK_REQUEST_PENDING',
  MomentStart = 'MOMENT_START'
}

export type IndexEvaluationSubmissionInput = {
  id: Scalars['ID']['input'];
};

export type IndexEvaluationSubmissionResponse = {
  __typename?: 'IndexEvaluationSubmissionResponse';
  evaluationSubmission: EvaluationSubmission;
};

export type IngestReleasedFeedbackResponseInput = {
  responseID: Scalars['ID']['input'];
};

export type IngestReleasedFeedbackResponseResponse = {
  __typename?: 'IngestReleasedFeedbackResponseResponse';
  feedbackResponse: FeedbackResponse;
};

export type InternalKakapoFeedback = {
  __typename?: 'InternalKakapoFeedback';
  responseID: Scalars['String']['output'];
};

export type JobCompetency = {
  __typename?: 'JobCompetency';
  competency: Competency;
  competencyLevel: Scalars['Int']['output'];
  /** Optional job-specific competency description for this competency on this job title. */
  description?: Maybe<Scalars['LocalizedAttributedString']['output']>;
  id: Scalars['ID']['output'];
  /** The job title this competency is linked to. */
  jobTitle: JobTitle;
  /**
   * Optional competency label for this competency on this job title (e.g. the Styr
   * skill type). Absent when the link was created manually.
   */
  label?: Maybe<Label>;
  level?: Maybe<JobLevel>;
  /**
   * Optional 0-based order of this competency on the job title, as provided by an
   * enrichment sync. Absent when the link was created manually.
   */
  order?: Maybe<Scalars['Int']['output']>;
};

export type JobGoalTemplate = {
  __typename?: 'JobGoalTemplate';
  competency?: Maybe<CompetencyGoal>;
  description: Scalars['LocalizedAttributedString']['output'];
  id: Scalars['ID']['output'];
  level?: Maybe<JobLevel>;
  relativeDueDate?: Maybe<Scalars['Int']['output']>;
  title: Scalars['LocalizedString']['output'];
};

export type JobLevel = {
  __typename?: 'JobLevel';
  description?: Maybe<Scalars['LocalizedString']['output']>;
  externalReferenceID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  title: Scalars['LocalizedString']['output'];
};

export type JobLevelConnection = {
  __typename?: 'JobLevelConnection';
  edges: Array<JobLevelEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type JobLevelEdge = {
  __typename?: 'JobLevelEdge';
  cursor: Scalars['ID']['output'];
  node: JobLevel;
};

export type JobPosition = {
  __typename?: 'JobPosition';
  appraisal: Array<CompetencyAppraisal>;
  competencies: Array<JobCompetency>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  externalReferenceID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  jobLevel?: Maybe<JobLevel>;
  jobTitle: JobTitle;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};

export type JobPositionConnection = {
  __typename?: 'JobPositionConnection';
  edges: Array<JobPositionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type JobPositionEdge = {
  __typename?: 'JobPositionEdge';
  cursor: Scalars['ID']['output'];
  node: JobPosition;
};

export enum JobPositionStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE'
}

/**
 * A nomination of a user as possible successor for a key position (sleutelrol).
 * One item per nomination: several managers can nominate the same user for the
 * same title, which is what "keer genoemd" counts.
 */
export type JobPositionSuccessor = {
  __typename?: 'JobPositionSuccessor';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  jobTitle: JobTitle;
  motivation: Scalars['QuillDelta']['output'];
  readiness: SuccessorReadiness;
  user: User;
  /** Only the nominator can withdraw (archive) a nomination. */
  viewerCanArchive: Scalars['Boolean']['output'];
};

export type JobTitle = {
  __typename?: 'JobTitle';
  appraisal: Array<CompetencyAppraisal>;
  competencies: Array<JobCompetency>;
  description?: Maybe<Scalars['LocalizedAttributedString']['output']>;
  externalReferenceID?: Maybe<Scalars['String']['output']>;
  goalTemplates: GoalTemplateConnection;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  /** Sleutelrol: this title is a key position for succession planning. */
  isKeyPosition: Scalars['Boolean']['output'];
  keyPositionMarkedAt?: Maybe<Scalars['DateTime']['output']>;
  keyPositionMarkedBy?: Maybe<User>;
  referenceCode?: Maybe<Scalars['String']['output']>;
  /** Styr-sourced data for this JobTitle, populated by the nightly Styr sync. Null until matched. */
  styrData?: Maybe<StyrData>;
  title: Scalars['LocalizedString']['output'];
  /** True when the viewer may mark this title as key position and nominate successors for it. */
  viewerCanManageSuccession: Scalars['Boolean']['output'];
};


export type JobTitleAppraisalArgs = {
  userID: Scalars['ID']['input'];
};


export type JobTitleGoalTemplatesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type JobTitleConnection = {
  __typename?: 'JobTitleConnection';
  edges: Array<JobTitleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type JobTitleEdge = {
  __typename?: 'JobTitleEdge';
  cursor: Scalars['ID']['output'];
  node: JobTitle;
};

/**
 * One job title on the succession board, with the nominations the viewer may see.
 * Titles without nominations are included so empty key positions stay visible.
 */
export type JobTitleSuccession = {
  __typename?: 'JobTitleSuccession';
  /** Users who currently hold this job title. */
  holders: Array<User>;
  jobTitle: JobTitle;
  successors: Array<JobPositionSuccessor>;
};

export type JoinLearningEventInput = {
  attendeeType: LearningEventAttendeeType;
  learningEventID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type JoinLearningEventResponse = {
  __typename?: 'JoinLearningEventResponse';
  learningEvent: LearningEvent;
};

export type KeepAnswersFromPredecessorInput = {
  id: Scalars['ID']['input'];
};

export type KeepAnswersFromPredecessorResponse = {
  __typename?: 'KeepAnswersFromPredecessorResponse';
  evaluationSubmission: EvaluationSubmission;
};

export type Label = {
  __typename?: 'Label';
  description?: Maybe<Scalars['LocalizedString']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  title: Scalars['LocalizedString']['output'];
  type: LabelType;
};

export type LabelConnection = {
  __typename?: 'LabelConnection';
  edges: Array<LabelEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LabelEdge = {
  __typename?: 'LabelEdge';
  cursor: Scalars['ID']['output'];
  node: Label;
};

export enum LabelType {
  Competency = 'COMPETENCY',
  Conversation = 'CONVERSATION',
  Goal = 'GOAL',
  JobPosition = 'JOB_POSITION',
  Note = 'NOTE'
}

export type LearningAttendeeEventConnection = {
  __typename?: 'LearningAttendeeEventConnection';
  edges: Array<LearningAttendeeEventEdge>;
  pageInfo: PageInfo;
};

export type LearningAttendeeEventEdge = {
  __typename?: 'LearningAttendeeEventEdge';
  attendeeType: LearningEventAttendeeType;
  cursor: Scalars['ID']['output'];
  node: LearningEvent;
};

/**
 * An external learning activity (training, assessment, lesson, ...) synced from an LMS provider
 * into the workspace's Learning library. Unlike a LearningEvent a course has no schedule or
 * capacity: it is always-on catalog content, launched at the provider via `launchUrl` (which
 * relies on the provider's SSO/LTI setup for authentication).
 */
export type LearningCourse = LearningItem & {
  __typename?: 'LearningCourse';
  description?: Maybe<Scalars['LocalizedAttributedString']['output']>;
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  externalReferenceID: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  languageID: Scalars['String']['output'];
  launchUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Per-language launch URLs. `text` is the URL so clients can `localize()` like titles.
   * Falls back to `launchUrl` when a course was synced before localizations were stored.
   */
  launchUrls?: Maybe<Scalars['LocalizedString']['output']>;
  learningSubjects: Array<LearningSubject>;
  learningType: LearningType;
  provider: LearningCourseProvider;
  syncedAt: Scalars['DateTime']['output'];
  title: Scalars['LocalizedString']['output'];
};

export type LearningCourseConnection = {
  __typename?: 'LearningCourseConnection';
  edges: Array<LearningCourseEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LearningCourseEdge = {
  __typename?: 'LearningCourseEdge';
  cursor: Scalars['ID']['output'];
  node: LearningCourse;
};

export type LearningCourseFilters = {
  languageIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  learningSubjectIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  learningTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  provider?: InputMaybe<LearningCourseProvider>;
  /** Case-insensitive match against the course title. */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** The external LMS a learning course originates from. GoodHabitz is the first provider. */
export enum LearningCourseProvider {
  Goodhabitz = 'GOODHABITZ'
}

export type LearningEvent = {
  __typename?: 'LearningEvent';
  attendeeCount: Scalars['Int']['output'];
  attendees: LearningEventAttendeeConnection;
  capacity: Scalars['Int']['output'];
  cover?: Maybe<Asset>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  description?: Maybe<Scalars['LocalizedAttributedString']['output']>;
  endDate: Scalars['DateTime']['output'];
  hosts: LearningEventAttendeeConnection;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isViewerAttending: Scalars['Boolean']['output'];
  jobTitles: Array<JobTitle>;
  languageID: Scalars['String']['output'];
  lastRejectedAt?: Maybe<Scalars['DateTime']['output']>;
  learningSubjects: Array<LearningSubject>;
  learningType: LearningType;
  location?: Maybe<Scalars['String']['output']>;
  meetingLink?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  status: LearningEventStatus;
  timezone?: Maybe<Scalars['String']['output']>;
  title: Scalars['LocalizedString']['output'];
  viewerCanJoin: Scalars['Boolean']['output'];
};


export type LearningEventAttendeesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type LearningEventHostsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LearningEventAttendeeConnection = {
  __typename?: 'LearningEventAttendeeConnection';
  edges: Array<LearningEventAttendeeEdge>;
  pageInfo: PageInfo;
};

export type LearningEventAttendeeEdge = {
  __typename?: 'LearningEventAttendeeEdge';
  attendeeType: LearningEventAttendeeType;
  cursor: Scalars['ID']['output'];
  node: User;
};

export enum LearningEventAttendeeType {
  Attendee = 'ATTENDEE',
  Host = 'HOST',
  HostOrganizer = 'HOST_ORGANIZER',
  Organizer = 'ORGANIZER'
}

export type LearningEventConnection = {
  __typename?: 'LearningEventConnection';
  edges: Array<LearningEventEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LearningEventEdge = {
  __typename?: 'LearningEventEdge';
  cursor: Scalars['ID']['output'];
  node: LearningEvent;
};

export type LearningEventFilters = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  learningSubjectIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  learningTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  statuses?: InputMaybe<Array<LearningEventStatus>>;
  untilDate?: InputMaybe<Scalars['DateTime']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

export enum LearningEventStatus {
  Cancelled = 'CANCELLED',
  Proposal = 'PROPOSAL',
  Published = 'PUBLISHED'
}

/**
 * Common shape of every item in the Learning module. Implemented by external `LearningCourse`
 * catalog content (and mirrored by the internal `LearningEvent` type) so the library UI and
 * recommendation tooling can render mixed lists off one contract.
 */
export type LearningItem = {
  description?: Maybe<Scalars['LocalizedAttributedString']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  languageID: Scalars['String']['output'];
  learningSubjects: Array<LearningSubject>;
  learningType: LearningType;
  title: Scalars['LocalizedString']['output'];
};

export type LearningRecommendation = {
  __typename?: 'LearningRecommendation';
  learningCourse: LearningCourse;
  reason?: Maybe<Scalars['String']['output']>;
};

export type LearningRecommendationsResponse = {
  __typename?: 'LearningRecommendationsResponse';
  recommendations: Array<LearningRecommendation>;
};

export type LearningSubject = {
  __typename?: 'LearningSubject';
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  title: Scalars['LocalizedString']['output'];
};

export type LearningSubjectConnection = {
  __typename?: 'LearningSubjectConnection';
  edges: Array<LearningSubjectEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LearningSubjectEdge = {
  __typename?: 'LearningSubjectEdge';
  cursor: Scalars['ID']['output'];
  node: LearningSubject;
};

export type LearningType = {
  __typename?: 'LearningType';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  title: Scalars['LocalizedString']['output'];
};

export type LearningTypeConnection = {
  __typename?: 'LearningTypeConnection';
  edges: Array<LearningTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LearningTypeEdge = {
  __typename?: 'LearningTypeEdge';
  cursor: Scalars['ID']['output'];
  node: LearningType;
};

export type LeaveLearningEventInput = {
  learningEventID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type LeaveLearningEventResponse = {
  __typename?: 'LeaveLearningEventResponse';
  learningEvent: LearningEvent;
};

export type LinkEntityToNoteInput = {
  entityID: Scalars['ID']['input'];
  entityType: LinkedEntityType;
  noteID: Scalars['ID']['input'];
};

export type LinkEntityToNoteResponse = {
  __typename?: 'LinkEntityToNoteResponse';
  note: Note;
};

export type LinkSlackIdentityInput = {
  slackID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type LinkSlackIdentityResponse = {
  __typename?: 'LinkSlackIdentityResponse';
  user: User;
};

export type LinkTranscriptionToEvaluationSubmissionInput = {
  evaluationSubmissionID: Scalars['ID']['input'];
  transcriptionID: Scalars['ID']['input'];
};

export type LinkTranscriptionToEvaluationSubmissionResponse = {
  __typename?: 'LinkTranscriptionToEvaluationSubmissionResponse';
  evaluationSubmission: EvaluationSubmission;
};

export type LinkedEntityInput = {
  entityID: Scalars['ID']['input'];
  entityType: LinkedEntityType;
};

export enum LinkedEntityType {
  EvaluationSubmission = 'EVALUATION_SUBMISSION',
  FeedbackRequest = 'FEEDBACK_REQUEST',
  Goal = 'GOAL',
  Transcription = 'TRANSCRIPTION'
}

export type LithoExportTypescript = {
  prepend?: InputMaybe<Scalars['String']['input']>;
  rewrite?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LithoImportHeader = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type MarkAnnouncementAsReadInput = {
  announcementID: Scalars['ID']['input'];
};

export type MarkAnnouncementAsReadResponse = {
  __typename?: 'MarkAnnouncementAsReadResponse';
  announcement?: Maybe<Announcement>;
};

export type MarkAnnouncementAsUnreadInput = {
  announcementID: Scalars['ID']['input'];
};

export type MarkAnnouncementAsUnreadResponse = {
  __typename?: 'MarkAnnouncementAsUnreadResponse';
  announcement?: Maybe<Announcement>;
};

export type MarkConversationExportUploadedInput = {
  id: Scalars['ID']['input'];
};

export type MarkConversationExportUploadedResponse = {
  __typename?: 'MarkConversationExportUploadedResponse';
  evaluationSubmission: EvaluationSubmission;
};

export type MarkEvaluationSubmissionSharedInput = {
  id: Scalars['ID']['input'];
};

export type MarkEvaluationSubmissionSharedResponse = {
  __typename?: 'MarkEvaluationSubmissionSharedResponse';
  evaluationSubmission: EvaluationSubmission;
};

export type MarkInboxTaskInput = {
  id: Scalars['ID']['input'];
};

export type MarkInboxTaskResponse = {
  __typename?: 'MarkInboxTaskResponse';
  inboxTask: InboxTask;
};

export type MarkNotificationStatusInput = {
  field: NotificationStatusField;
  notificationID: Scalars['ID']['input'];
  status: Scalars['Boolean']['input'];
};

export type MarkNotificationStatusResponse = {
  __typename?: 'MarkNotificationStatusResponse';
  notification: Notification;
};

export type MarkTranscriptionFollowupActedUponInput = {
  followupID: Scalars['String']['input'];
  transcriptionID: Scalars['String']['input'];
};

export type MarkTranscriptionUploadAsFailedInput = {
  transcriptionID: Scalars['String']['input'];
};

export type MarkTranscriptionUploadAsFailedResponse = {
  __typename?: 'MarkTranscriptionUploadAsFailedResponse';
  transcriptionID: Scalars['String']['output'];
};

export type McpRemoteSettings = {
  __typename?: 'McpRemoteSettings';
  /** The MCP endpoint URL to connect an MCP client to. */
  connectionUrl: Scalars['String']['output'];
  /** Whether the remote MCP connector is enabled for the workspace. */
  enabled: Scalars['Boolean']['output'];
};

export type Meeting = {
  __typename?: 'Meeting';
  attendees: Array<MeetingAttendee>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isCancelled: Scalars['Boolean']['output'];
  note?: Maybe<Note>;
  series?: Maybe<MeetingSeries>;
  startsAt: Scalars['DateTime']['output'];
  timezone: Scalars['TimeZoneID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MeetingAttendee = {
  __typename?: 'MeetingAttendee';
  id: Scalars['ID']['output'];
  proposal?: Maybe<AttendeeProposal>;
  status: AttendeeStatus;
  user: User;
};

export type MeetingAttendeeProposalInput = {
  email: Scalars['String']['input'];
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  startsAt: Scalars['DateTime']['input'];
};

export type MeetingAttendeeStatusInput = {
  email: Scalars['String']['input'];
  status: AttendeeStatus;
};

export type MeetingSeries = {
  __typename?: 'MeetingSeries';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  attendees: Array<User>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  duration: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  noteSeriesMetadata?: Maybe<NoteSeriesMetadata>;
  recurrenceFrequency?: Maybe<MeetingSeriesRecurrenceFrequency>;
  recurrenceRule: Scalars['String']['output'];
  timezone: Scalars['TimeZoneID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MeetingSeriesConnection = {
  __typename?: 'MeetingSeriesConnection';
  edges: Array<MeetingSeriesEdge>;
  pageInfo: PageInfo;
};

export type MeetingSeriesEdge = {
  __typename?: 'MeetingSeriesEdge';
  cursor: Scalars['ID']['output'];
  node: MeetingSeries;
};

export enum MeetingSeriesRecurrenceFrequency {
  Bimonthly = 'BIMONTHLY',
  Biweekly = 'BIWEEKLY',
  Hexweekly = 'HEXWEEKLY',
  Monthly = 'MONTHLY',
  Quadweekly = 'QUADWEEKLY',
  Quarterly = 'QUARTERLY',
  Triweekly = 'TRIWEEKLY',
  Weekly = 'WEEKLY'
}

export type MeetingTargetInput = {
  id: Scalars['ID']['input'];
  type: MeetingTargetType;
};

export enum MeetingTargetType {
  Note = 'NOTE'
}

export enum MfaMethod {
  Totp = 'TOTP'
}

export type MfaSetupChallenge = {
  __typename?: 'MfaSetupChallenge';
  allowedMethods: Array<MfaMethod>;
  username: Scalars['String']['output'];
};

export type MfaSetupChallengeResponse = {
  method: MfaMethod;
  username: Scalars['String']['input'];
};

export type MfaUserConfiguration = {
  __typename?: 'MfaUserConfiguration';
  enabled: Scalars['Boolean']['output'];
  enabledMethods?: Maybe<Array<MfaMethod>>;
  id: Scalars['ID']['output'];
  preferredMethod?: Maybe<MfaMethod>;
};

export type MicrosoftConfig = {
  __typename?: 'MicrosoftConfig';
  id: Scalars['ID']['output'];
  isConfigured: Scalars['Boolean']['output'];
  outlookConnected: Scalars['Boolean']['output'];
  outlookRequiresReconsent: Scalars['Boolean']['output'];
  teamsConnected: Scalars['Boolean']['output'];
  teamsRequiresReconsent: Scalars['Boolean']['output'];
  tenantId?: Maybe<Scalars['String']['output']>;
};

export enum MicrosoftIntegration {
  Outlook = 'OUTLOOK',
  Teams = 'TEAMS'
}

export type MomentEvaluation = {
  __typename?: 'MomentEvaluation';
  evaluationForm?: Maybe<EvaluationForm>;
};

export type MomentEvaluationInput = {
  evaluationFormID?: InputMaybe<Scalars['ID']['input']>;
};

export type MomentFeedback = {
  __typename?: 'MomentFeedback';
  feedbackTemplate?: Maybe<FeedbackTemplate>;
  maximumRecipients?: Maybe<Scalars['Int']['output']>;
  minimumQuestions?: Maybe<Scalars['Int']['output']>;
  minimumRecipients?: Maybe<Scalars['Int']['output']>;
  /**
   * If present, feedback responses submitted before this date are hidden from
   * the feedback subject until the date is reached.
   */
  releaseDate?: Maybe<Scalars['DateTime']['output']>;
};

export type MomentFeedbackInput = {
  feedbackTemplateID?: InputMaybe<Scalars['ID']['input']>;
  maximumRecipients?: InputMaybe<Scalars['Int']['input']>;
  minimumQuestions?: InputMaybe<Scalars['Int']['input']>;
  minimumRecipients?: InputMaybe<Scalars['Int']['input']>;
  releaseDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MomentGoals = {
  __typename?: 'MomentGoals';
  minimumCompetencyGoals?: Maybe<Scalars['Int']['output']>;
  minimumGoals?: Maybe<Scalars['Int']['output']>;
};

export type MomentGoalsInput = {
  minimumCompetencyGoals?: InputMaybe<Scalars['Int']['input']>;
  minimumGoals?: InputMaybe<Scalars['Int']['input']>;
};

export type MomentInstance = {
  __typename?: 'MomentInstance';
  cycleInstance: CycleInstance;
  cycleTemplate: CycleTemplate;
  endDate: Scalars['DateTime']['output'];
  evaluation?: Maybe<EvaluationSubmission>;
  feedbackRequest?: Maybe<FeedbackRequest>;
  goals?: Maybe<Array<Goal>>;
  id: Scalars['ID']['output'];
  momentTemplate: MomentTemplate;
  skipReason?: Maybe<MomentSkipReason>;
  skipReasonOther?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  status: MomentStatus;
  talentReview?: Maybe<TalentReview>;
  /**
   * People who will receive a share mail if this talent review is submitted
   * again on `templateID` for `localDate`. Null when it was never submitted
   * on that template. Empty when it was retracted and nothing changed, so
   * nobody is mailed.
   */
  talentReviewReshareRecipients?: Maybe<Array<User>>;
  talentReviewSnapshot?: Maybe<TalentReviewSnapshot>;
  /**
   * Whether the viewer may revert the submitted talent review of this moment:
   * the owner, a manager of the group or HR, up to and including the deadline.
   */
  talentReviewViewerCanRevert: Scalars['Boolean']['output'];
  user: User;
};


export type MomentInstanceTalentReviewReshareRecipientsArgs = {
  localDate: Scalars['LocalDate']['input'];
  templateID: Scalars['ID']['input'];
};

export type MomentNotification = {
  __typename?: 'MomentNotification';
  id: Scalars['ID']['output'];
  offset: Scalars['Int']['output'];
  type: MomentNotificationType;
};

export type MomentNotificationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  offset: Scalars['Int']['input'];
  type: MomentNotificationType;
};

export enum MomentNotificationType {
  AfterEnd = 'AFTER_END',
  BeforeEnd = 'BEFORE_END',
  BeforeStart = 'BEFORE_START'
}

export enum MomentSkipReason {
  Duplicate = 'DUPLICATE',
  Expired = 'EXPIRED',
  Illness = 'ILLNESS',
  Leave = 'LEAVE',
  NoLongerManager = 'NO_LONGER_MANAGER',
  Other = 'OTHER'
}

export enum MomentStatus {
  Completed = 'COMPLETED',
  Open = 'OPEN',
  Skipped = 'SKIPPED'
}

export type MomentTalentReview = {
  __typename?: 'MomentTalentReview';
  group?: Maybe<Group>;
  template?: Maybe<TalentReviewTemplate>;
};

export type MomentTalentReviewInput = {
  templateID?: InputMaybe<Scalars['ID']['input']>;
};

export type MomentTemplate = {
  __typename?: 'MomentTemplate';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['LocalizedAttributedString']['output']>;
  /** The duration of a moment in days. */
  duration: Scalars['Int']['output'];
  evaluation?: Maybe<MomentEvaluation>;
  feedback?: Maybe<MomentFeedback>;
  goals?: Maybe<MomentGoals>;
  id: Scalars['ID']['output'];
  instruction?: Maybe<Scalars['LocalizedAttributedString']['output']>;
  isArchived: Scalars['Boolean']['output'];
  notifications: Array<MomentNotification>;
  original?: Maybe<MomentTemplate>;
  showToUser: Scalars['Boolean']['output'];
  /** The start offset (in days) of a moment relative to the cycle's start date. */
  startOffset: Scalars['Int']['output'];
  talentReview?: Maybe<MomentTalentReview>;
  title: Scalars['LocalizedString']['output'];
  type: MomentType;
  variations?: Maybe<Array<MomentVariation>>;
};

export type MomentTemplateInput = {
  description?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  duration: Scalars['Int']['input'];
  evaluation?: InputMaybe<MomentEvaluationInput>;
  feedback?: InputMaybe<MomentFeedbackInput>;
  goals?: InputMaybe<MomentGoalsInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  instruction?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  notifications: Array<MomentNotificationInput>;
  showToUser: Scalars['Boolean']['input'];
  startOffset: Scalars['Int']['input'];
  talentReview?: InputMaybe<MomentTalentReviewInput>;
  title: Scalars['LocalizedString']['input'];
  type: MomentType;
  variations?: InputMaybe<Array<MomentVariationInput>>;
};

export enum MomentType {
  Evaluation = 'EVALUATION',
  Feedback = 'FEEDBACK',
  Goals = 'GOALS',
  Message = 'MESSAGE',
  TalentReview = 'TALENT_REVIEW'
}

export type MomentVariation = {
  __typename?: 'MomentVariation';
  evaluation?: Maybe<MomentEvaluation>;
  feedback?: Maybe<MomentFeedback>;
  goals?: Maybe<MomentGoals>;
  jobTitle?: Maybe<JobTitle>;
  roleType?: Maybe<RoleType>;
  talentReview?: Maybe<MomentTalentReview>;
};

export type MomentVariationInput = {
  evaluation?: InputMaybe<MomentEvaluationInput>;
  feedback?: InputMaybe<MomentFeedbackInput>;
  goals?: InputMaybe<MomentGoalsInput>;
  jobTitleID?: InputMaybe<Scalars['ID']['input']>;
  roleType?: InputMaybe<RoleType>;
  talentReview?: InputMaybe<MomentTalentReviewInput>;
};

export type MoveGoalInput = {
  goalID: Scalars['ID']['input'];
  parentID?: InputMaybe<Scalars['ID']['input']>;
};

export type MoveGoalResponse = {
  __typename?: 'MoveGoalResponse';
  goal: Goal;
};

export type MoveGroupInput = {
  id: Scalars['ID']['input'];
  newParentID?: InputMaybe<Scalars['ID']['input']>;
};

export type MoveGroupResponse = {
  __typename?: 'MoveGroupResponse';
  group: Group;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Sets this job position's status to ACTIVE and its startDate to Today. */
  activateJobPosition: ActivateJobPositionResponse;
  advanceAIGeneratedCompetenciesChat: AiGeneratedCompetenciesResponse;
  advanceAIGeneratedGoalChat: AiGeneratedGoalResponse;
  /**
   * Stores the placement helper answers for a user as an activity.
   * The questions live in the client; question and answer are stored
   * as text.
   */
  answerTalentReviewPlacementHelp: AnswerTalentReviewPlacementHelpResponse;
  appendTranscription: AppendTranscriptionResponse;
  /**
   * Applies manual Styr job mappings for the current workspace: links Styr jobs to existing
   * JobTitles or creates new ones (writing `styrData.jobID`), then enqueues a sync so the linked
   * titles are enriched. Returns true once applied and the sync is queued.
   */
  applyStyrJobMappings: Scalars['Boolean']['output'];
  approveFeatureForViewer: ApproveFeatureConditionsResponse;
  approveFeatureForWorkspace: ApproveFeatureConditionsResponse;
  archiveApiUser: Scalars['ID']['output'];
  archiveCareer: Career;
  archiveComment: ArchiveCommentResponse;
  archiveCompetency: ArchiveCompetencyResponse;
  /**
   * Archives a competency bookmark. After archiving, the competency will no
   * longer show up when asking for feedback on competencies. It will also no
   * longer show up in the skills analysis. However, this will not erase any past
   * results associated with the underlying competency.
   */
  archiveCompetencyBookmark: ArchiveCompetencyBookmarkResponse;
  archiveCompetencyLevelSet: ArchiveCompetencyLevelSetResponse;
  archiveCompliment: ArchiveComplimentResponse;
  archiveCycleTemplate: ArchiveCycleTemplateResponse;
  archiveEngagementCategory: ArchiveEngagementCategoryResponse;
  archiveEngagementQuestion: ArchiveEngagementQuestionResponse;
  archiveEngagementSubcategory: ArchiveEngagementSubcategoryResponse;
  archiveEvaluationForm: ArchiveEvaluationFormResponse;
  archiveEvaluationSubmission: ArchiveEvaluationSubmissionResponse;
  archiveExpertise: Expertise;
  archiveFeedbackQuestion: ArchiveFeedbackQuestionResponse;
  archiveFeedbackQuestionCategory: ArchiveFeedbackQuestionCategoryResponse;
  /** Archives an existing feedback request. */
  archiveFeedbackRequest: ArchiveFeedbackRequestResponse;
  archiveFeedbackResponse: ArchiveFeedbackResponseResponse;
  archiveFeedbackTemplate: ArchiveFeedbackTemplateResponse;
  archiveGoal: ArchiveGoalResponse;
  archiveGoalDriver: ArchiveGoalDriverResponse;
  archiveGoalTemplate: ArchiveGoalTemplateResponse;
  archiveGroup: ArchiveGroupResponse;
  archiveInboxTask: ArchiveInboxTaskResponse;
  archiveJobLevel: ArchiveJobLevelResponse;
  archiveJobPosition: ArchiveJobPositionResponse;
  archiveJobPositionSuccessor: ArchiveJobPositionSuccessorResponse;
  archiveJobTitle: ArchiveJobTitleResponse;
  archiveLabel: ArchiveLabelResponse;
  archiveLearningEvent: ArchiveLearningEventResponse;
  archiveLearningSubject: ArchiveLearningSubjectResponse;
  archiveLearningType: ArchiveLearningTypeResponse;
  archiveNote: ArchiveNoteResponse;
  archiveNoteTemplate: NoteTemplate;
  archiveNoteTemplateCategory: NoteTemplateCategory;
  archiveTalentReview: ArchiveTalentReviewResponse;
  archiveTalentReviewSnapshot: ArchiveTalentReviewSnapshotResponse;
  archiveTalentReviewTemplate: ArchiveTalentReviewTemplateResponse;
  archiveUser: ArchiveUserResponse;
  archiveWorkspace: ArchiveWorkspaceResponse;
  assignRole: AssignRoleResponse;
  associateAutoSelectedIdentity: AssociateAutoSelectedIdentityResponse;
  associateIdentity: AssociateIdentityResponse;
  associateTotpToken: AssociateTotpTokenResponse;
  attachJobCompetency: AttachJobCompetencyResponse;
  attachJobGoalTemplate: AttachJobGoalTemplateResponse;
  attachTalentReviewToMoment: AttachTalentReviewToMomentResponse;
  autoLinkSlackIdentities: AutoLinkSlackIdentitiesResponse;
  cancelEngagementRequest: CancelEngagementRequestResponse;
  cancelLearningEvent: CancelLearningEventResponse;
  cancelMeeting: CancelMeetingResponse;
  changeConversationPartner: ChangeConversationPartnerResponse;
  changeLearningEventCover: ChangeLearningEventCoverResponse;
  changeUserActivatedAt: ChangeUserActivatedAtResponse;
  checkSuppressedEmail: CheckSuppressedEmailResponse;
  /**
   * Removes everyone from the grid for this day (one remove per placed user,
   * same rules as removeTalentReviewGridPlacement) and logs a single
   * CLEARED activity.
   */
  clearTalentReviewGrid: ClearTalentReviewGridResponse;
  completeConversation: CompleteConversationResponse;
  completeMomentInstance: CompleteMomentInstanceResponse;
  completeWorkspaceCheckpoint: CompleteWorkspaceCheckpointResponse;
  confirmForgotPassword: ConfirmForgotPasswordResponse;
  connectorConsumeOAuth2Code: Connector;
  copyWorkspace: CopyWorkspaceResponse;
  /**
   * HR correction on a submitted snapshot: writes placements (and
   * tombstones for removed users) that only apply to this snapshot.
   * The current grid and the placement history stay unchanged.
   */
  correctTalentReviewSnapshot: CorrectTalentReviewSnapshotResponse;
  createAgentChat: AgentChat;
  createAnnouncement: CreateAnnouncementResponse;
  createApiUser: ApiUserCredentials;
  createAsset: CreateAssetResponse;
  createCareer: Career;
  createComment: CreateCommentResponse;
  createCompetency: CreateCompetencyResponse;
  /**
   * Creates a new competency bookmark with the given input. If a bookmark
   * already exists for the given user/competency pair, this will overwrite the
   * existing level with the given level. Any past results with the given
   * competency will automatically be included in the skills analysis (i.e. the
   * competency bookmark is applied retro-actively).
   */
  createCompetencyBookmark: CreateCompetencyBookmarkResponse;
  createCompetencyLevelSet: CreateCompetencyLevelSetResponse;
  createCompliment: CreateComplimentResponse;
  createCycleInstance: CreateCycleInstanceResponse;
  createCycleTemplate: CreateCycleTemplateResponse;
  createEngagementCategory: CreateEngagementCategoryResponse;
  createEngagementQuestion: CreateEngagementQuestionResponse;
  createEngagementReply: CreateEngagementReplyResponse;
  createEngagementRequest: CreateEngagementRequestResponse;
  createEngagementResponse: CreateEngagementResponseResponse;
  createEngagementSubcategory: CreateEngagementSubcategoryResponse;
  createEngagementTemplate: CreateEngagementTemplateResponse;
  createEvaluationForm: CreateEvaluationFormResponse;
  createEvaluationSubmission: CreateEvaluationSubmissionResponse;
  createExpertise: Expertise;
  /** Create a new feature rating */
  createFeatureRating: CreateFeatureRatingResponse;
  createFeedbackQuestion: CreateFeedbackQuestionResponse;
  createFeedbackQuestionCategory: CreateFeedbackQuestionCategoryResponse;
  /** Creates a new feedback request. */
  createFeedbackRequest: CreateFeedbackRequestResponse;
  createFeedbackTemplate: CreateFeedbackTemplateResponse;
  createGoal: CreateGoalResponse;
  createGoalDriver: CreateGoalDriverResponse;
  createGoalTemplate: CreateGoalTemplateResponse;
  createGroup: CreateGroupResponse;
  createIdentityProvider: CreateIdentityProviderResponse;
  createJobLevel: CreateJobLevelResponse;
  createJobPosition: CreateJobPositionResponse;
  createJobTitle: CreateJobTitleResponse;
  createLabel: CreateLabelResponse;
  createLearningEvent: CreateLearningEventResponse;
  createLearningSubject: CreateLearningSubjectResponse;
  createLearningType: CreateLearningTypeResponse;
  createMeeting: CreateMeetingResponse;
  createNote: CreateNoteResponse;
  createNoteTemplate: NoteTemplate;
  createNoteTemplateCategory: NoteTemplateCategory;
  createPersonalAccessToken: CreatePersonalAccessTokenResponse;
  createSession: CreateSessionResponse;
  createSubscription: CreateSubscriptionResponse;
  createTalentReview: CreateTalentReviewResponse;
  /**
   * Creates the snapshot and shares it immediately using the template
   * visibility. On a first submit, SELF and MEMBERS email every placed
   * user. After a retract, only people whose cell, motivation, or score
   * changed, or who were added, are emailed. MANAGER sends no email.
   */
  createTalentReviewSnapshot: CreateTalentReviewSnapshotResponse;
  createTalentReviewTemplate: CreateTalentReviewTemplateResponse;
  createTask: CreateTaskResponse;
  createTemporarySessionToken: TemporarySessionToken;
  createTranscription: CreateTranscriptionResponse;
  createUser: CreateUserResponse;
  createUserDocumentV2: CreateUserDocumentV2Response;
  createUserDocumentV2DownloadURL: CreateUserDocumentV2DownloadUrlResponse;
  createWorkspace: CreateWorkspaceResponse;
  createWorkspacePlan: CreateWorkspacePlanResponse;
  /** Sets this job position's status to INACTIVE and its endDate to Today. */
  deactivateJobPosition: DeactivateJobPositionResponse;
  deleteAgentChat: Scalars['Boolean']['output'];
  deleteAnnouncement: DeleteAnnouncementResponse;
  deleteIdentityProvider: DeleteIdentityProviderResponse;
  /**
   * Deletes the current reveal upload of one conversation template: removes
   * the live data and the field selection (superuser only). Snapshots of
   * already-shared conversations are kept, so what was communicated stays
   * visible.
   */
  deleteRevealUpload: Scalars['Boolean']['output'];
  deleteTask: DeleteTaskResponse;
  deleteUserDocumentV2: DeleteUserDocumentV2Response;
  deleteUserDownload: DeleteUserDownloadResponse;
  detachJobCompetency: DetachJobCompetencyResponse;
  detachJobGoalTemplate: DetachJobGoalTemplateResponse;
  disableEngagementTemplate: DisableEngagementTemplateResponse;
  disableMfaMethod: DisableMfaMethodResponse;
  disassociateIdentity: DisassociateIdentityResponse;
  discardAnswersFromPredecessor: DiscardAnswersFromPredecessorResponse;
  enableEngagementTemplate: EnableEngagementTemplateResponse;
  enableWorkspaceAiPlan: EnableWorkspaceAiPlanResponse;
  ensureAssociatedIdentities: EnsureAssociatedIdentitiesResponse;
  ensureSupportAssociatedIdentities: EnsureSupportAssociatedIdentitiesResponse;
  exchangePersonalAccessToken: ExchangePersonalAccessTokenResponse;
  exchangeSession: ExchangeSessionResponse;
  exportConversationsTalentReviews: ExportConversationsTalentReviewsResponse;
  exportToPDF: ConversationPdfExportResult;
  exportUserData: ExportUserDataResponse;
  finalizeTranscriptionUpload: FinalizeTranscriptionUploadResponse;
  finalizeUserDocumentV2Upload: FinalizeUserDocumentV2UploadResponse;
  forgotPassword: ForgotPasswordResponse;
  generateApiToken: GenerateApiTokenResponse;
  /** Returns a presigned PUT url to upload a reveal Excel to S3 (superuser only). */
  getRevealUploadUrl: GetRevealUploadUrlResponse;
  impersonateSessionSlot: SwitchSessionSlotResponse;
  indexEvaluationSubmission: IndexEvaluationSubmissionResponse;
  ingestReleasedFeedbackResponse: IngestReleasedFeedbackResponseResponse;
  joinLearningEvent: JoinLearningEventResponse;
  keepAnswersFromPredecessor: KeepAnswersFromPredecessorResponse;
  leaveLearningEvent: LeaveLearningEventResponse;
  linkEntityToNote: LinkEntityToNoteResponse;
  linkSlackIdentity: LinkSlackIdentityResponse;
  linkTranscriptionToEvaluationSubmission: LinkTranscriptionToEvaluationSubmissionResponse;
  markAnnouncementAsRead: MarkAnnouncementAsReadResponse;
  markAnnouncementAsUnread: MarkAnnouncementAsUnreadResponse;
  markConversationExportUploaded: MarkConversationExportUploadedResponse;
  markEvaluationSubmissionShared: MarkEvaluationSubmissionSharedResponse;
  markInboxTask: MarkInboxTaskResponse;
  markNotificationStatus: MarkNotificationStatusResponse;
  /** Marks the reveal of a conversation as seen by the employee. */
  markRevealSeen: Scalars['Boolean']['output'];
  markTranscriptionFollowupActedUpon: Transcription;
  markTranscriptionUploadAsFailed: MarkTranscriptionUploadAsFailedResponse;
  microsoftConnect: Scalars['String']['output'];
  microsoftDisconnect?: Maybe<MicrosoftConfig>;
  moveGoal: MoveGoalResponse;
  moveGroup: MoveGroupResponse;
  nominateJobPositionSuccessor: NominateJobPositionSuccessorResponse;
  obfuscateUser: ObfuscateUserResponse;
  overrideEvaluationSubmissionScore: OverrideEvaluationSubmissionScoreResponse;
  /** Parses an uploaded Excel synchronously and returns a preview (no commit). */
  parseRevealUpload: RevealMatchSummary;
  partialUpdateGoal: UpdateGoalResponse;
  prelogin: PreloginResponse;
  prepareTranscriptionUploadRetry: PrepareTranscriptionUploadRetryResponse;
  processCycleInstance: ProcessCycleInstanceResponse;
  processMeetingSeries: ProcessMeetingSeriesResponse;
  queueConnector: Scalars['Boolean']['output'];
  queueConnectorTwoWayRetrospect: Scalars['Boolean']['output'];
  redactAllUsers: RedactUserResponse;
  redactUser: RedactUserResponse;
  refreshAnalyticsSnapshot: RefreshAnalyticsSnapshotResponse;
  /** @deprecated Superseded by HttpOnly cookie sessions. */
  refreshSession: RefreshSessionResponse;
  refreshUserDocumentV2ScanStatus: Scalars['Boolean']['output'];
  regenerateApiUserSecret: ApiUserCredentials;
  regenerateTranscriptionSummary: RegenerateTranscriptionSummaryResponse;
  removeCycleInstance: RemoveCycleInstanceResponse;
  removeSuppressedEmail: RemoveSuppressedEmailResponse;
  removeTalentReviewGridPlacement: RemoveTalentReviewGridPlacementResponse;
  removeWorkspacePlan: RemoveWorkspacePlanResponse;
  renameAgentChat: AgentChat;
  renewPersonalAccessToken: CreatePersonalAccessTokenResponse;
  reorderEngagementCategory: ReorderEngagementCategoryResponse;
  reorderEngagementQuestion: ReorderEngagementQuestionResponse;
  reorderEngagementSubcategory: ReorderEngagementSubcategoryResponse;
  reorderFeedbackQuestion: ReorderFeedbackQuestionResponse;
  reorderFeedbackQuestionCategory: ReorderFeedbackQuestionCategoryResponse;
  reorderGoal: ReorderGoalResponse;
  reorderGoalDriver: ReorderGoalDriverResponse;
  reorderTask: ReorderTaskResponse;
  requestEvaluationSubmission: RequestEvaluationSubmissionResponse;
  requestExternalFeedback: RequestExternalFeedbackResponse;
  requestInternalFeedback: RequestInternalFeedbackResponse;
  requestWorkspace: RequestWorkspaceResponse;
  rescheduleEvaluationSubmission: RescheduleEvaluationSubmissionResponse;
  resendTemporaryPassword: ResendTemporaryPasswordResponse;
  resetCustomEmailDomain: UpdateCustomEmailDomainResponse;
  resetUserAvatar: ResetUserAvatarResponse;
  resetUserCover: ResetUserCoverResponse;
  resetWorkspaceBackground: ResetWorkspaceBackgroundResponse;
  resetWorkspaceLogo: ResetWorkspaceLogoResponse;
  restoreCareer: Career;
  restoreComment: RestoreCommentResponse;
  restoreCompetency: RestoreCompetencyResponse;
  /**
   * Restores a competency bookmark. After restoring, the competency will show up
   * again when asking for feedback on competencies. It will also show up again
   * in the skills analysis. Any past results associated with the underlying
   * competency will be included in this analysis.
   */
  restoreCompetencyBookmark: RestoreCompetencyBookmarkResponse;
  restoreCompetencyLevelSet: RestoreCompetencyLevelSetResponse;
  restoreCompliment: RestoreComplimentResponse;
  restoreCycleTemplate: RestoreCycleTemplateResponse;
  restoreEngagementCategory: RestoreEngagementCategoryResponse;
  restoreEngagementQuestion: RestoreEngagementQuestionResponse;
  restoreEngagementSubcategory: RestoreEngagementSubcategoryResponse;
  restoreEvaluationForm: RestoreEvaluationFormResponse;
  restoreEvaluationSubmission: RestoreEvaluationSubmissionResponse;
  restoreExpertise: Expertise;
  restoreFeedbackQuestion: RestoreFeedbackQuestionResponse;
  restoreFeedbackQuestionCategory: RestoreFeedbackQuestionCategoryResponse;
  /** Restores an archived feedback request. */
  restoreFeedbackRequest: RestoreFeedbackRequestResponse;
  restoreFeedbackResponse: RestoreFeedbackResponseResponse;
  restoreFeedbackTemplate: RestoreFeedbackTemplateResponse;
  restoreGoal: RestoreGoalResponse;
  restoreGoalDriver: RestoreGoalDriverResponse;
  restoreGoalTemplate: RestoreGoalTemplateResponse;
  restoreGroup: RestoreGroupResponse;
  restoreInboxTask: RestoreInboxTaskResponse;
  restoreJobLevel: RestoreJobLevelResponse;
  restoreJobPosition: RestoreJobPositionResponse;
  restoreJobTitle: RestoreJobTitleResponse;
  restoreLabel: RestoreLabelResponse;
  restoreLearningEvent: RestoreLearningEventResponse;
  restoreLearningSubject: RestoreLearningSubjectResponse;
  restoreLearningType: RestoreLearningTypeResponse;
  restoreMeeting: RestoreMeetingResponse;
  restoreNote: RestoreNoteResponse;
  restoreNoteTemplate: NoteTemplate;
  restoreNoteTemplateCategory: NoteTemplateCategory;
  restoreTalentReview: RestoreTalentReviewResponse;
  restoreTalentReviewTemplate: RestoreTalentReviewTemplateResponse;
  restoreUser: RestoreUserResponse;
  /**
   * Reverts a submitted talent review to draft: reopens the cycle moment
   * (and the inbox task) and archives the linked snapshot. Only by the
   * owner of the moment, until the deadline.
   */
  revertTalentReviewSubmission: RevertTalentReviewSubmissionResponse;
  reviewLearningEvent: ReviewLearningEventResponse;
  revokeApiToken: Scalars['ID']['output'];
  revokeFeatureApprovalForViewer: RevokeFeatureApprovalResponse;
  revokePersonalAccessToken: Scalars['ID']['output'];
  revokeRole: RevokeRoleResponse;
  revokeSharedFeedback: RevokeSharedFeedbackResponse;
  /**
   * Internal: runs the Styr enrichment sync in-process for the current workspace. Called by the
   * `SyncStyr` background job (nightly cron + on-demand); not intended for client use.
   */
  runStyrSync: Scalars['Boolean']['output'];
  /**
   * Parses + commits an uploaded Excel for one conversation template: matches
   * on employee number (externalReferenceID), writes live data, wipes previous
   * live data of that template and deletes the raw S3 object.
   */
  saveRevealUpload: RevealMatchSummary;
  seedWorkspace: SeedWorkspaceResponse;
  sendCycleMomentManagerReminders: SendCycleMomentManagerRemindersResponse;
  sendEngagementRequestReminders: SendEngagementRequestRemindersResponse;
  sendEngagementResponseReminder: Scalars['Boolean']['output'];
  sendEngagementTemplate: SendEngagementTemplateResponse;
  sendExpirationWarnings: Scalars['Boolean']['output'];
  sendFeedbackReminder: SendFeedbackReminderResponse;
  sendMomentReminder: SendMomentReminderResponse;
  sendNotification: SendNotificationResponse;
  sendSpontaneousFeedback: SendSpontaneousFeedbackResponse;
  sendTemporaryPassword: SendTemporaryPasswordResponse;
  setCustomEmailDomainEnabled: UpdateCustomEmailDomainResponse;
  /**
   * Self-service GoodHabitz setup for the current workspace: superusers/administrators
   * configure the connector (API key, enabled, languages) from the Integrations page.
   * Requires the GOODHABITZ feature flag.
   */
  setGoodHabitzConfig: GoodHabitzConfig;
  setJobTitleKeyPosition: SetJobTitleKeyPositionResponse;
  setPromptInstruction: SetPromptInstructionResponse;
  /**
   * Restricts which Styr languages are written during sync for the current workspace's Styr
   * connector. Languages not in the list are omitted from the localized values, so the
   * client-side language fallback shows the remaining language(s). An empty list restores the
   * default behaviour (all languages). Takes effect on the next sync.
   */
  setStyrSyncLanguages: Scalars['Boolean']['output'];
  setWorkspacePromptInstruction: SetPromptInstructionResponse;
  /**
   * Launch-only admin mutation: configures the Styr enrichment connector for the given workspace
   * by upserting the organisation details in the single `styr` item in `ConnectorConfig` and
   * mirroring `enabled` onto the Styr `Connectors` row (`isActive`). Clearing `organisationID`
   * deletes the config item and the connector row.
   */
  setWorkspaceStyrConfig: SetWorkspaceStyrConfigResponse;
  setupConnector: SetupConnectorResponse;
  setupConnectorTwoWay: SetupConnectorResponse;
  shareFeedbackRequest: ShareFeedbackRequestResponse;
  shareNote: ShareNoteResponse;
  shareTalentReview: ShareTalentReviewResponse;
  signEvaluationSubmission: SignEvaluationSubmissionResponse;
  signOutSession: SignOutSessionResponse;
  skipMomentInstance: SkipMomentInstanceResponse;
  skipMomentTemplate: SkipMomentTemplateResponse;
  slackConsumeOAuth2Code: SlackConsumeOAuth2CodeResponse;
  startAIGeneratedCompetenciesChat: AiGeneratedCompetenciesResponse;
  startAIGeneratedGoalChat: AiGeneratedGoalResponse;
  startStreamingTranscription: StartStreamingTranscriptionResponse;
  storeConnectorLog: StoreConnectorLogResponse;
  switchImpersonatedSessionSlot: SwitchSessionSlotResponse;
  switchSessionSlot: SwitchSessionSlotResponse;
  /**
   * Triggers an on-demand GoodHabitz content sync for the current user's workspace. Requires an
   * active GoodHabitz connector; returns true once the sync Lambda has accepted the request.
   */
  syncGoodHabitz: Scalars['Boolean']['output'];
  syncHubSpotCompanies: SyncHubSpotCompaniesResult;
  /**
   * Triggers an on-demand Styr enrichment sync for the current user's workspace. Requires an
   * enabled Styr config; returns true once the sync job is enqueued.
   */
  syncStyr: Scalars['Boolean']['output'];
  teardownConnector: TeardownConnectorResponse;
  uncompleteConversation: UncompleteConversationResponse;
  unlinkSlackIdentity: UnlinkSlackIdentityResponse;
  unlinkStripe: UnlinkStripeResponse;
  unlinkTranscriptionFromEvaluationSubmission: UnlinkTranscriptionFromEvaluationSubmissionResponse;
  unlinkTranscriptionFromNote: UnlinkTranscriptionFromNoteResponse;
  unshareNote: UnshareNoteResponse;
  unshareTalentReview: UnshareTalentReviewResponse;
  unsignEvaluationSubmission: UnsignEvaluationSubmissionResponse;
  updateAnnouncement: UpdateAnnouncementResponse;
  updateApiTokenNotificationEmail: Scalars['Boolean']['output'];
  updateApiUserPermissions: ApiUser;
  updateCareer: Career;
  updateComment: UpdateCommentResponse;
  updateCompetency: UpdateCompetencyResponse;
  /** Updates an existing competency bookmark with the given input. */
  updateCompetencyBookmark: UpdateCompetencyBookmarkResponse;
  updateCompetencyLevelSet: UpdateCompetencyLevelSetResponse;
  updateConnector: UpdateConnectorResponse;
  updateConnectorConfigField: UpdateConnectorConfigFieldResponse;
  updateConnectorTask: UpdateConnectorTaskResponse;
  updateConnectorUpload: UpdateConnectorUploadResponse;
  updateCustomEmailDomain: UpdateCustomEmailDomainResponse;
  updateCycleInstance: UpdateCycleInstanceResponse;
  updateCycleTemplate: UpdateCycleTemplateResponse;
  updateEngagementAnswer: UpdateEngagementAnswerResponse;
  updateEngagementCategory: UpdateEngagementCategoryResponse;
  updateEngagementQuestion: UpdateEngagementQuestionResponse;
  updateEngagementSettings: UpdateEngagementSettingsResponse;
  updateEngagementSubcategory: UpdateEngagementSubcategoryResponse;
  updateEngagementTemplate: UpdateEngagementTemplateResponse;
  updateEvaluationForm: UpdateEvaluationFormResponse;
  updateEvaluationSubmission: UpdateEvaluationSubmissionResponse;
  /**
   * Updates the meeting status for the currently authenticated user. Note that
   * this will also trigger an email to be sent to the other party. This mutation
   * is called from an SES-triggered lambda that listens to responses to the
   * original calendar invite. Specifically, when someone presses Accept in
   * Gmail, Google will send an email to our SES inbox, that will in turn call
   * this mutation to broadcast their response to the other party.
   */
  updateEvaluationSubmissionMeetingStatus: UpdateEvaluationSubmissionMeetingStatusResponse;
  updateExcludeAnalytics: UpdateExcludeAnalyticsResponse;
  updateExpertise: Expertise;
  updateExternalFeedback: UpdateExternalFeedbackResponse;
  /** Update an existing feature rating */
  updateFeatureRating: UpdateFeatureRatingResponse;
  updateFeedbackQuestion: UpdateFeedbackQuestionResponse;
  updateFeedbackQuestionCategory: UpdateFeedbackQuestionCategoryResponse;
  updateFeedbackTemplate: UpdateFeedbackTemplateResponse;
  updateGoal: UpdateGoalResponse;
  updateGoalDriver: UpdateGoalDriverResponse;
  updateGoalTemplate: UpdateGoalTemplateResponse;
  updateGroup: UpdateGroupResponse;
  updateIdentityProvider: UpdateIdentityProviderResponse;
  updateIdentityProviderConfiguration: UpdateIdentityProviderConfigurationResponse;
  updateInternalFeedback: UpdateInternalFeedbackResponse;
  updateInvoiceUserCount: UpdateInvoiceUserCountResponse;
  updateJobGoalTemplate: UpdateJobGoalTemplateResponse;
  updateJobLevel: UpdateJobLevelResponse;
  updateJobPosition: UpdateJobPositionResponse;
  /**
   * Edits a nomination: candidate, role, readiness and motivation.
   * Only the nominator can change it.
   */
  updateJobPositionSuccessor: UpdateJobPositionSuccessorResponse;
  updateJobTitle: UpdateJobTitleResponse;
  updateLabel: UpdateLabelResponse;
  updateLearningEvent: UpdateLearningEventResponse;
  updateLearningSubject: UpdateLearningSubjectResponse;
  updateLearningType: UpdateLearningTypeResponse;
  updateMcpRemoteSettings: McpRemoteSettings;
  updateMeeting: UpdateMeetingResponse;
  updateMeetingAttendeeProposal: ProcessMeetingSeriesResponse;
  updateMeetingAttendeeStatuses: ProcessMeetingSeriesResponse;
  updateMeetingSeriesAttendeeStatuses: ProcessMeetingSeriesResponse;
  updateNote: UpdateNoteResponse;
  updateNotePreparation: UpdateNotePreparationResponse;
  updateNoteTemplate: NoteTemplate;
  updateNotificationCustomization: UpdateNotificationCustomizationResponse;
  updateNotificationTemplate: UpdateNotificationTemplateResponse;
  updatePrivacyConsent: UpdatePrivacyConsentResponse;
  updateSession: UpdateSessionResponse;
  updateTalentReview: UpdateTalentReviewResponse;
  updateTalentReviewGridPlacement: UpdateTalentReviewGridPlacementResponse;
  updateTalentReviewSnapshot: UpdateTalentReviewSnapshotResponse;
  updateTalentReviewTemplate: UpdateTalentReviewTemplateResponse;
  updateTask: UpdateTaskResponse;
  updateTranscriptionSummary: UpdateTranscriptionSummaryResponse;
  updateUser: UpdateUserResponse;
  updateUserActivationDate: UpdateUserActivationDateResponse;
  updateUserAvatar: UpdateUserAvatarResponse;
  updateUserCover: UpdateUserCoverResponse;
  updateUserDownload: UpdateUserDownloadResponse;
  updateUserLocale: UpdateUserLocaleResponse;
  updateUserMission: UpdateUserMissionResponse;
  updateUserNotificationSetting: UpdateUserNotificationSettingResponse;
  updateWelcomeEmail: UpdateWelcomeEmailResponse;
  updateWorkspaceAlias: UpdateWorkspaceAliasResponse;
  updateWorkspaceBackground: UpdateWorkspaceBackgroundResponse;
  updateWorkspaceColors: UpdateWorkspaceColorsResponse;
  updateWorkspaceDisplayName: UpdateWorkspaceDisplayNameResponse;
  updateWorkspaceEmailDomains: UpdateWorkspaceEmailDomainsResponse;
  updateWorkspaceFeature: UpdateWorkspaceFeatureResponse;
  updateWorkspaceHubSpotCompanyID: UpdateWorkspaceHubSpotCompanyIdResponse;
  updateWorkspaceLanguages: UpdateWorkspaceLanguagesResponse;
  updateWorkspaceLogo: UpdateWorkspaceLogoResponse;
  updateWorkspaceMfaSettings: UpdateWorkspaceMfaSettingsResponse;
  updateWorkspaceNotificationSettings: UpdateWorkspaceNotificationSettingsResponse;
  /** @deprecated Use `createWorkspacePlan`/`updateWorkspacePlanV2`/`removeWorkspacePlan` instead. */
  updateWorkspacePlan: UpdateWorkspacePlanResponse;
  updateWorkspacePlanV2: UpdateWorkspacePlanV2Response;
  updateWorkspaceRetentionPeriod: UpdateWorkspaceRetentionPeriodResponse;
  updateWorkspaceSSOSettings: UpdateWorkspaceSsoSettingsResponse;
  updateWorkspaceStartDate: UpdateWorkspaceStartDateResponse;
  upsertPage: Page;
  /** @deprecated Superseded by HttpOnly cookie sessions. */
  verifySession: VerifySessionResponse;
  verifyTotpToken: VerifyTotpTokenResponse;
};


export type MutationActivateJobPositionArgs = {
  input: ActivateJobPositionInput;
};


export type MutationAdvanceAiGeneratedCompetenciesChatArgs = {
  input: AdvanceAiChatInput;
};


export type MutationAdvanceAiGeneratedGoalChatArgs = {
  input: AdvanceAiChatInput;
};


export type MutationAnswerTalentReviewPlacementHelpArgs = {
  input: AnswerTalentReviewPlacementHelpInput;
};


export type MutationAppendTranscriptionArgs = {
  input: AppendTranscriptionInput;
};


export type MutationApplyStyrJobMappingsArgs = {
  input: ApplyStyrJobMappingsInput;
};


export type MutationApproveFeatureForViewerArgs = {
  input: ApproveFeatureConditionsInput;
};


export type MutationApproveFeatureForWorkspaceArgs = {
  input: ApproveFeatureConditionsInput;
};


export type MutationArchiveApiUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveCareerArgs = {
  input: CareerArchiveInput;
};


export type MutationArchiveCommentArgs = {
  input: ArchiveCommentInput;
};


export type MutationArchiveCompetencyArgs = {
  input: ArchiveCompetencyInput;
};


export type MutationArchiveCompetencyBookmarkArgs = {
  input: ArchiveCompetencyBookmarkInput;
};


export type MutationArchiveCompetencyLevelSetArgs = {
  input: ArchiveCompetencyLevelSetInput;
};


export type MutationArchiveComplimentArgs = {
  input: ArchiveComplimentInput;
};


export type MutationArchiveCycleTemplateArgs = {
  input: ArchiveCycleTemplateInput;
};


export type MutationArchiveEngagementCategoryArgs = {
  input: ArchiveEngagementCategoryInput;
};


export type MutationArchiveEngagementQuestionArgs = {
  input: ArchiveEngagementQuestionInput;
};


export type MutationArchiveEngagementSubcategoryArgs = {
  input: ArchiveEngagementSubcategoryInput;
};


export type MutationArchiveEvaluationFormArgs = {
  input: ArchiveEvaluationFormInput;
};


export type MutationArchiveEvaluationSubmissionArgs = {
  input: ArchiveEvaluationSubmissionInput;
};


export type MutationArchiveExpertiseArgs = {
  input: ArchiveExpertiseInput;
};


export type MutationArchiveFeedbackQuestionArgs = {
  input: ArchiveFeedbackQuestionInput;
};


export type MutationArchiveFeedbackQuestionCategoryArgs = {
  input: ArchiveFeedbackQuestionCategoryInput;
};


export type MutationArchiveFeedbackRequestArgs = {
  input: ArchiveFeedbackRequestInput;
};


export type MutationArchiveFeedbackResponseArgs = {
  input: ArchiveFeedbackResponseInput;
};


export type MutationArchiveFeedbackTemplateArgs = {
  input: ArchiveFeedbackTemplateInput;
};


export type MutationArchiveGoalArgs = {
  input: ArchiveGoalInput;
};


export type MutationArchiveGoalDriverArgs = {
  input: ArchiveGoalDriverInput;
};


export type MutationArchiveGoalTemplateArgs = {
  input: ArchiveGoalTemplateInput;
};


export type MutationArchiveGroupArgs = {
  input: ArchiveGroupInput;
};


export type MutationArchiveInboxTaskArgs = {
  input: ArchiveInboxTaskInput;
};


export type MutationArchiveJobLevelArgs = {
  input: ArchiveJobLevelInput;
};


export type MutationArchiveJobPositionArgs = {
  input: ArchiveJobPositionInput;
};


export type MutationArchiveJobPositionSuccessorArgs = {
  input: ArchiveJobPositionSuccessorInput;
};


export type MutationArchiveJobTitleArgs = {
  input: ArchiveJobTitleInput;
};


export type MutationArchiveLabelArgs = {
  input: ArchiveLabelInput;
};


export type MutationArchiveLearningEventArgs = {
  input: ArchiveLearningEventInput;
};


export type MutationArchiveLearningSubjectArgs = {
  input: ArchiveLearningSubjectInput;
};


export type MutationArchiveLearningTypeArgs = {
  input: ArchiveLearningTypeInput;
};


export type MutationArchiveNoteArgs = {
  input: ArchiveNoteInput;
};


export type MutationArchiveNoteTemplateArgs = {
  input: NoteTemplateArchiveInput;
};


export type MutationArchiveNoteTemplateCategoryArgs = {
  input: NoteTemplateCategoryArchiveInput;
};


export type MutationArchiveTalentReviewArgs = {
  input: ArchiveTalentReviewInput;
};


export type MutationArchiveTalentReviewSnapshotArgs = {
  input: ArchiveTalentReviewSnapshotInput;
};


export type MutationArchiveTalentReviewTemplateArgs = {
  input: ArchiveTalentReviewTemplateInput;
};


export type MutationArchiveUserArgs = {
  input: ArchiveUserInput;
};


export type MutationArchiveWorkspaceArgs = {
  input: ArchiveWorkspaceInput;
};


export type MutationAssignRoleArgs = {
  input: AssignRoleInput;
};


export type MutationAssociateAutoSelectedIdentityArgs = {
  input: AssociateAutoSelectedIdentityInput;
};


export type MutationAssociateIdentityArgs = {
  input: AssociateIdentityInput;
};


export type MutationAssociateTotpTokenArgs = {
  input: AssociateTotpTokenInput;
};


export type MutationAttachJobCompetencyArgs = {
  input: AttachJobCompetencyInput;
};


export type MutationAttachJobGoalTemplateArgs = {
  input: AttachJobGoalTemplateInput;
};


export type MutationAttachTalentReviewToMomentArgs = {
  input: AttachTalentReviewToMomentInput;
};


export type MutationCancelEngagementRequestArgs = {
  input: CancelEngagementRequestInput;
};


export type MutationCancelLearningEventArgs = {
  input: CancelLearningEventInput;
};


export type MutationCancelMeetingArgs = {
  input: CancelMeetingInput;
};


export type MutationChangeConversationPartnerArgs = {
  input: ChangeConversationPartnerInput;
};


export type MutationChangeLearningEventCoverArgs = {
  input: ChangeLearningEventCoverInput;
};


export type MutationChangeUserActivatedAtArgs = {
  input: ChangeUserActivatedAtInput;
};


export type MutationCheckSuppressedEmailArgs = {
  input: CheckSuppressedEmailInput;
};


export type MutationClearTalentReviewGridArgs = {
  input: ClearTalentReviewGridInput;
};


export type MutationCompleteConversationArgs = {
  input: CompleteConversationInput;
};


export type MutationCompleteMomentInstanceArgs = {
  input: CompleteMomentInstanceInput;
};


export type MutationCompleteWorkspaceCheckpointArgs = {
  input: CompleteWorkspaceCheckpointInput;
};


export type MutationConfirmForgotPasswordArgs = {
  input: ConfirmForgotPasswordInput;
};


export type MutationConnectorConsumeOAuth2CodeArgs = {
  input: ConnectorConsumeOAuth2CodeInput;
};


export type MutationCopyWorkspaceArgs = {
  input: CopyWorkspaceInput;
};


export type MutationCorrectTalentReviewSnapshotArgs = {
  input: CorrectTalentReviewSnapshotInput;
};


export type MutationCreateAgentChatArgs = {
  input?: InputMaybe<CreateAgentChatInput>;
};


export type MutationCreateAnnouncementArgs = {
  input: CreateAnnouncementInput;
};


export type MutationCreateAssetArgs = {
  input: CreateAssetInput;
};


export type MutationCreateCareerArgs = {
  input: CareerCreateInput;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateCompetencyArgs = {
  input: CreateCompetencyInput;
};


export type MutationCreateCompetencyBookmarkArgs = {
  input: CreateCompetencyBookmarkInput;
};


export type MutationCreateCompetencyLevelSetArgs = {
  input: CreateCompetencyLevelSetInput;
};


export type MutationCreateComplimentArgs = {
  input: CreateComplimentInput;
};


export type MutationCreateCycleInstanceArgs = {
  input: CreateCycleInstanceInput;
};


export type MutationCreateCycleTemplateArgs = {
  input: CreateCycleTemplateInput;
};


export type MutationCreateEngagementCategoryArgs = {
  input: CreateEngagementCategoryInput;
};


export type MutationCreateEngagementQuestionArgs = {
  input: CreateEngagementQuestionInput;
};


export type MutationCreateEngagementReplyArgs = {
  input: CreateEngagementReplyInput;
};


export type MutationCreateEngagementRequestArgs = {
  input: CreateEngagementRequestInput;
};


export type MutationCreateEngagementResponseArgs = {
  input: CreateEngagementResponseInput;
};


export type MutationCreateEngagementSubcategoryArgs = {
  input: CreateEngagementSubcategoryInput;
};


export type MutationCreateEngagementTemplateArgs = {
  input: CreateEngagementTemplateInput;
};


export type MutationCreateEvaluationFormArgs = {
  input: CreateEvaluationFormInput;
};


export type MutationCreateEvaluationSubmissionArgs = {
  input: CreateEvaluationSubmissionInput;
};


export type MutationCreateExpertiseArgs = {
  input: ExpertiseCreateInput;
};


export type MutationCreateFeatureRatingArgs = {
  input: CreateFeatureRatingInput;
};


export type MutationCreateFeedbackQuestionArgs = {
  input: CreateFeedbackQuestionInput;
};


export type MutationCreateFeedbackQuestionCategoryArgs = {
  input: CreateFeedbackQuestionCategoryInput;
};


export type MutationCreateFeedbackRequestArgs = {
  input: CreateFeedbackRequestInput;
};


export type MutationCreateFeedbackTemplateArgs = {
  input: CreateFeedbackTemplateInput;
};


export type MutationCreateGoalArgs = {
  input: CreateGoalInput;
};


export type MutationCreateGoalDriverArgs = {
  input: CreateGoalDriverInput;
};


export type MutationCreateGoalTemplateArgs = {
  input: CreateGoalTemplateInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateIdentityProviderArgs = {
  input: CreateIdentityProviderInput;
};


export type MutationCreateJobLevelArgs = {
  input: CreateJobLevelInput;
};


export type MutationCreateJobPositionArgs = {
  input: CreateJobPositionInput;
};


export type MutationCreateJobTitleArgs = {
  input: CreateJobTitleInput;
};


export type MutationCreateLabelArgs = {
  input: CreateLabelInput;
};


export type MutationCreateLearningEventArgs = {
  input: CreateLearningEventInput;
};


export type MutationCreateLearningSubjectArgs = {
  input: CreateLearningSubjectInput;
};


export type MutationCreateLearningTypeArgs = {
  input: CreateLearningTypeInput;
};


export type MutationCreateMeetingArgs = {
  input: CreateMeetingInput;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationCreateNoteTemplateArgs = {
  input: NoteTemplateCreateInput;
};


export type MutationCreateNoteTemplateCategoryArgs = {
  input: NoteTemplateCategoryCreateInput;
};


export type MutationCreatePersonalAccessTokenArgs = {
  password: Scalars['String']['input'];
};


export type MutationCreateSessionArgs = {
  input: CreateSessionInput;
};


export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationCreateTalentReviewArgs = {
  input: CreateTalentReviewInput;
};


export type MutationCreateTalentReviewSnapshotArgs = {
  input: CreateTalentReviewSnapshotInput;
};


export type MutationCreateTalentReviewTemplateArgs = {
  input: CreateTalentReviewTemplateInput;
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


export type MutationCreateTemporarySessionTokenArgs = {
  input: TemporarySessionTokenInput;
};


export type MutationCreateTranscriptionArgs = {
  input: CreateTranscriptionInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateUserDocumentV2Args = {
  input: CreateUserDocumentV2Input;
};


export type MutationCreateUserDocumentV2DownloadUrlArgs = {
  input: CreateUserDocumentV2DownloadUrlInput;
};


export type MutationCreateWorkspaceArgs = {
  input: CreateWorkspaceInput;
};


export type MutationCreateWorkspacePlanArgs = {
  input: CreateWorkspacePlanInput;
};


export type MutationDeactivateJobPositionArgs = {
  input: DeactivateJobPositionInput;
};


export type MutationDeleteAgentChatArgs = {
  chatID: Scalars['ID']['input'];
};


export type MutationDeleteAnnouncementArgs = {
  input: DeleteAnnouncementInput;
};


export type MutationDeleteIdentityProviderArgs = {
  input: DeleteIdentityProviderInput;
};


export type MutationDeleteRevealUploadArgs = {
  evaluationFormID: Scalars['ID']['input'];
};


export type MutationDeleteTaskArgs = {
  input: DeleteTaskInput;
};


export type MutationDeleteUserDocumentV2Args = {
  input: DeleteUserDocumentV2Input;
};


export type MutationDeleteUserDownloadArgs = {
  input: DeleteUserDownloadInput;
};


export type MutationDetachJobCompetencyArgs = {
  input: DetachJobCompetencyInput;
};


export type MutationDetachJobGoalTemplateArgs = {
  input: DetachJobGoalTemplateInput;
};


export type MutationDisableEngagementTemplateArgs = {
  input: DisableEngagementTemplateInput;
};


export type MutationDisableMfaMethodArgs = {
  input: DisableMfaMethodInput;
};


export type MutationDisassociateIdentityArgs = {
  input: DisassociateIdentityInput;
};


export type MutationDiscardAnswersFromPredecessorArgs = {
  input: DiscardAnswersFromPredecessorInput;
};


export type MutationEnableEngagementTemplateArgs = {
  input: EnableEngagementTemplateInput;
};


export type MutationEnsureAssociatedIdentitiesArgs = {
  input: EnsureAssociatedIdentitiesInput;
};


export type MutationEnsureSupportAssociatedIdentitiesArgs = {
  input: EnsureSupportAssociatedIdentitiesInput;
};


export type MutationExchangePersonalAccessTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationExchangeSessionArgs = {
  input: ExchangeSessionInput;
};


export type MutationExportConversationsTalentReviewsArgs = {
  input: ExportConversationsTalentReviewsInput;
};


export type MutationExportToPdfArgs = {
  conversationID: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MutationExportUserDataArgs = {
  input: ExportUserDataInput;
};


export type MutationFinalizeTranscriptionUploadArgs = {
  input: FinalizeTranscriptionUploadInput;
};


export type MutationFinalizeUserDocumentV2UploadArgs = {
  input: FinalizeUserDocumentV2UploadInput;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationGenerateApiTokenArgs = {
  type: Scalars['String']['input'];
};


export type MutationGetRevealUploadUrlArgs = {
  contentLength: Scalars['Int']['input'];
};


export type MutationImpersonateSessionSlotArgs = {
  input: ImpersonateSessionSlotInput;
};


export type MutationIndexEvaluationSubmissionArgs = {
  input: IndexEvaluationSubmissionInput;
};


export type MutationIngestReleasedFeedbackResponseArgs = {
  input: IngestReleasedFeedbackResponseInput;
};


export type MutationJoinLearningEventArgs = {
  input: JoinLearningEventInput;
};


export type MutationKeepAnswersFromPredecessorArgs = {
  input: KeepAnswersFromPredecessorInput;
};


export type MutationLeaveLearningEventArgs = {
  input: LeaveLearningEventInput;
};


export type MutationLinkEntityToNoteArgs = {
  input: LinkEntityToNoteInput;
};


export type MutationLinkSlackIdentityArgs = {
  input: LinkSlackIdentityInput;
};


export type MutationLinkTranscriptionToEvaluationSubmissionArgs = {
  input: LinkTranscriptionToEvaluationSubmissionInput;
};


export type MutationMarkAnnouncementAsReadArgs = {
  input: MarkAnnouncementAsReadInput;
};


export type MutationMarkAnnouncementAsUnreadArgs = {
  input: MarkAnnouncementAsUnreadInput;
};


export type MutationMarkConversationExportUploadedArgs = {
  input: MarkConversationExportUploadedInput;
};


export type MutationMarkEvaluationSubmissionSharedArgs = {
  input: MarkEvaluationSubmissionSharedInput;
};


export type MutationMarkInboxTaskArgs = {
  input: MarkInboxTaskInput;
};


export type MutationMarkNotificationStatusArgs = {
  input: MarkNotificationStatusInput;
};


export type MutationMarkRevealSeenArgs = {
  submissionID: Scalars['ID']['input'];
};


export type MutationMarkTranscriptionFollowupActedUponArgs = {
  input: MarkTranscriptionFollowupActedUponInput;
};


export type MutationMarkTranscriptionUploadAsFailedArgs = {
  input: MarkTranscriptionUploadAsFailedInput;
};


export type MutationMicrosoftConnectArgs = {
  integration: MicrosoftIntegration;
};


export type MutationMicrosoftDisconnectArgs = {
  integration: MicrosoftIntegration;
};


export type MutationMoveGoalArgs = {
  input: MoveGoalInput;
};


export type MutationMoveGroupArgs = {
  input: MoveGroupInput;
};


export type MutationNominateJobPositionSuccessorArgs = {
  input: NominateJobPositionSuccessorInput;
};


export type MutationObfuscateUserArgs = {
  input: ObfuscateUserInput;
};


export type MutationOverrideEvaluationSubmissionScoreArgs = {
  input: OverrideEvaluationSubmissionScoreInput;
};


export type MutationParseRevealUploadArgs = {
  objectKey: Scalars['String']['input'];
};


export type MutationPartialUpdateGoalArgs = {
  input: PartialUpdateGoalInput;
};


export type MutationPreloginArgs = {
  input: PreloginInput;
};


export type MutationPrepareTranscriptionUploadRetryArgs = {
  input: PrepareTranscriptionUploadRetryInput;
};


export type MutationProcessCycleInstanceArgs = {
  groupIDs: Array<InputMaybe<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  jobTitleIDs: Array<InputMaybe<Scalars['ID']['input']>>;
  roleTypes?: InputMaybe<Array<RoleType>>;
};


export type MutationProcessMeetingSeriesArgs = {
  meetingSeriesID: Scalars['ID']['input'];
};


export type MutationRedactUserArgs = {
  input: RedactUserInput;
};


export type MutationRefreshSessionArgs = {
  input: RefreshSessionInput;
};


export type MutationRefreshUserDocumentV2ScanStatusArgs = {
  input: RefreshUserDocumentV2ScanStatusInput;
};


export type MutationRegenerateApiUserSecretArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRegenerateTranscriptionSummaryArgs = {
  input: RegenerateTranscriptionSummaryInput;
};


export type MutationRemoveCycleInstanceArgs = {
  input: RemoveCycleInstanceInput;
};


export type MutationRemoveSuppressedEmailArgs = {
  input: RemoveSuppressedEmailInput;
};


export type MutationRemoveTalentReviewGridPlacementArgs = {
  input: RemoveTalentReviewGridPlacementInput;
};


export type MutationRemoveWorkspacePlanArgs = {
  input: RemoveWorkspacePlanInput;
};


export type MutationRenameAgentChatArgs = {
  input: RenameAgentChatInput;
};


export type MutationRenewPersonalAccessTokenArgs = {
  password: Scalars['String']['input'];
};


export type MutationReorderEngagementCategoryArgs = {
  input: ReorderEngagementCategoryInput;
};


export type MutationReorderEngagementQuestionArgs = {
  input: ReorderEngagementQuestionInput;
};


export type MutationReorderEngagementSubcategoryArgs = {
  input: ReorderEngagementSubcategoryInput;
};


export type MutationReorderFeedbackQuestionArgs = {
  input: ReorderFeedbackQuestionInput;
};


export type MutationReorderFeedbackQuestionCategoryArgs = {
  input: ReorderFeedbackQuestionCategoryInput;
};


export type MutationReorderGoalArgs = {
  input: ReorderGoalInput;
};


export type MutationReorderGoalDriverArgs = {
  input: ReorderGoalDriverInput;
};


export type MutationReorderTaskArgs = {
  input: ReorderTaskInput;
};


export type MutationRequestEvaluationSubmissionArgs = {
  input: RequestEvaluationSubmissionInput;
};


export type MutationRequestExternalFeedbackArgs = {
  input: RequestExternalFeedbackInput;
};


export type MutationRequestInternalFeedbackArgs = {
  input: RequestInternalFeedbackInput;
};


export type MutationRequestWorkspaceArgs = {
  input: RequestWorkspaceInput;
};


export type MutationRescheduleEvaluationSubmissionArgs = {
  input: RescheduleEvaluationSubmissionInput;
};


export type MutationResendTemporaryPasswordArgs = {
  input: ResendTemporaryPasswordInput;
};


export type MutationResetUserAvatarArgs = {
  input: ResetUserAvatarInput;
};


export type MutationResetUserCoverArgs = {
  input: ResetUserCoverInput;
};


export type MutationRestoreCareerArgs = {
  input: CareerRestoreInput;
};


export type MutationRestoreCommentArgs = {
  input: RestoreCommentInput;
};


export type MutationRestoreCompetencyArgs = {
  input: RestoreCompetencyInput;
};


export type MutationRestoreCompetencyBookmarkArgs = {
  input: RestoreCompetencyBookmarkInput;
};


export type MutationRestoreCompetencyLevelSetArgs = {
  input: RestoreCompetencyLevelSetInput;
};


export type MutationRestoreComplimentArgs = {
  input: RestoreComplimentInput;
};


export type MutationRestoreCycleTemplateArgs = {
  input: RestoreCycleTemplateInput;
};


export type MutationRestoreEngagementCategoryArgs = {
  input: RestoreEngagementCategoryInput;
};


export type MutationRestoreEngagementQuestionArgs = {
  input: RestoreEngagementQuestionInput;
};


export type MutationRestoreEngagementSubcategoryArgs = {
  input: RestoreEngagementSubcategoryInput;
};


export type MutationRestoreEvaluationFormArgs = {
  input: RestoreEvaluationFormInput;
};


export type MutationRestoreEvaluationSubmissionArgs = {
  input: RestoreEvaluationSubmissionInput;
};


export type MutationRestoreExpertiseArgs = {
  input: RestoreExpertiseInput;
};


export type MutationRestoreFeedbackQuestionArgs = {
  input: RestoreFeedbackQuestionInput;
};


export type MutationRestoreFeedbackQuestionCategoryArgs = {
  input: RestoreFeedbackQuestionCategoryInput;
};


export type MutationRestoreFeedbackRequestArgs = {
  input: RestoreFeedbackRequestInput;
};


export type MutationRestoreFeedbackResponseArgs = {
  input: RestoreFeedbackResponseInput;
};


export type MutationRestoreFeedbackTemplateArgs = {
  input: RestoreFeedbackTemplateInput;
};


export type MutationRestoreGoalArgs = {
  input: RestoreGoalInput;
};


export type MutationRestoreGoalDriverArgs = {
  input: RestoreGoalDriverInput;
};


export type MutationRestoreGoalTemplateArgs = {
  input: RestoreGoalTemplateInput;
};


export type MutationRestoreGroupArgs = {
  input: RestoreGroupInput;
};


export type MutationRestoreInboxTaskArgs = {
  input: RestoreInboxTaskInput;
};


export type MutationRestoreJobLevelArgs = {
  input: RestoreJobLevelInput;
};


export type MutationRestoreJobPositionArgs = {
  input: RestoreJobPositionInput;
};


export type MutationRestoreJobTitleArgs = {
  input: RestoreJobTitleInput;
};


export type MutationRestoreLabelArgs = {
  input: RestoreLabelInput;
};


export type MutationRestoreLearningEventArgs = {
  input: RestoreLearningEventInput;
};


export type MutationRestoreLearningSubjectArgs = {
  input: RestoreLearningSubjectInput;
};


export type MutationRestoreLearningTypeArgs = {
  input: RestoreLearningTypeInput;
};


export type MutationRestoreMeetingArgs = {
  input: RestoreMeetingInput;
};


export type MutationRestoreNoteArgs = {
  input: RestoreNoteInput;
};


export type MutationRestoreNoteTemplateArgs = {
  input: NoteTemplateRestoreInput;
};


export type MutationRestoreNoteTemplateCategoryArgs = {
  input: NoteTemplateRestoreCategoryInput;
};


export type MutationRestoreTalentReviewArgs = {
  input: RestoreTalentReviewInput;
};


export type MutationRestoreTalentReviewTemplateArgs = {
  input: RestoreTalentReviewTemplateInput;
};


export type MutationRestoreUserArgs = {
  input: RestoreUserInput;
};


export type MutationRevertTalentReviewSubmissionArgs = {
  input: RevertTalentReviewSubmissionInput;
};


export type MutationReviewLearningEventArgs = {
  input: ReviewLearningEventInput;
};


export type MutationRevokeApiTokenArgs = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationRevokeFeatureApprovalForViewerArgs = {
  input: RevokeFeatureApprovalInput;
};


export type MutationRevokeRoleArgs = {
  input: RevokeRoleInput;
};


export type MutationRevokeSharedFeedbackArgs = {
  input: RevokeSharedFeedbackInput;
};


export type MutationSaveRevealUploadArgs = {
  evaluationFormID: Scalars['ID']['input'];
  excludedUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  fieldTypes?: InputMaybe<Array<RevealFieldTypeInput>>;
  objectKey: Scalars['String']['input'];
  selectedFields: Array<Scalars['String']['input']>;
};


export type MutationSeedWorkspaceArgs = {
  input: SeedWorkspaceInput;
};


export type MutationSendCycleMomentManagerRemindersArgs = {
  input: SendCycleMomentManagerRemindersInput;
};


export type MutationSendEngagementRequestRemindersArgs = {
  input: SendEngagementRequestRemindersInput;
};


export type MutationSendEngagementResponseReminderArgs = {
  input: SendEngagementResponseReminderInput;
};


export type MutationSendEngagementTemplateArgs = {
  input: SendEngagementTemplateInput;
};


export type MutationSendFeedbackReminderArgs = {
  input: SendFeedbackReminderInput;
};


export type MutationSendMomentReminderArgs = {
  input: SendMomentReminderInput;
};


export type MutationSendNotificationArgs = {
  input: SendNotificationInput;
};


export type MutationSendSpontaneousFeedbackArgs = {
  input: SendSpontaneousFeedbackInput;
};


export type MutationSendTemporaryPasswordArgs = {
  input: SendTemporaryPasswordInput;
};


export type MutationSetCustomEmailDomainEnabledArgs = {
  input: SetCustomEmailDomainEnabledInput;
};


export type MutationSetGoodHabitzConfigArgs = {
  input: SetGoodHabitzConfigInput;
};


export type MutationSetJobTitleKeyPositionArgs = {
  input: SetJobTitleKeyPositionInput;
};


export type MutationSetPromptInstructionArgs = {
  input: SetPromptInstructionInput;
};


export type MutationSetStyrSyncLanguagesArgs = {
  languageIDs: Array<Scalars['String']['input']>;
};


export type MutationSetWorkspacePromptInstructionArgs = {
  input: SetWorkspacePromptInstructionInput;
};


export type MutationSetWorkspaceStyrConfigArgs = {
  input: SetWorkspaceStyrConfigInput;
};


export type MutationSetupConnectorArgs = {
  input: SetupConnectorInput;
};


export type MutationSetupConnectorTwoWayArgs = {
  input: SetupConnectorTwoWayInput;
};


export type MutationShareFeedbackRequestArgs = {
  input: ShareFeedbackRequestInput;
};


export type MutationShareNoteArgs = {
  input: ShareNoteInput;
};


export type MutationShareTalentReviewArgs = {
  input: ShareTalentReviewInput;
};


export type MutationSignEvaluationSubmissionArgs = {
  input: SignEvaluationSubmissionInput;
};


export type MutationSkipMomentInstanceArgs = {
  input: SkipMomentInstanceInput;
};


export type MutationSkipMomentTemplateArgs = {
  input: SkipMomentTemplateInput;
};


export type MutationSlackConsumeOAuth2CodeArgs = {
  input: SlackConsumeOAuth2CodeInput;
};


export type MutationStartAiGeneratedCompetenciesChatArgs = {
  input: StartAiGeneratedCompetenciesChatInput;
};


export type MutationStartAiGeneratedGoalChatArgs = {
  input: StartAiGeneratedGoalChatInput;
};


export type MutationStartStreamingTranscriptionArgs = {
  input: StartStreamingTranscriptionInput;
};


export type MutationStoreConnectorLogArgs = {
  input: StoreConnectorLogInput;
};


export type MutationSwitchImpersonatedSessionSlotArgs = {
  input: SwitchSessionSlotInput;
};


export type MutationSwitchSessionSlotArgs = {
  input: SwitchSessionSlotInput;
};


export type MutationUncompleteConversationArgs = {
  input: UncompleteConversationInput;
};


export type MutationUnlinkSlackIdentityArgs = {
  input: UnlinkSlackIdentityInput;
};


export type MutationUnlinkStripeArgs = {
  workspaceID: Scalars['ID']['input'];
};


export type MutationUnlinkTranscriptionFromEvaluationSubmissionArgs = {
  input: UnlinkTranscriptionFromEvaluationSubmissionInput;
};


export type MutationUnlinkTranscriptionFromNoteArgs = {
  input: UnlinkTranscriptionFromNoteInput;
};


export type MutationUnshareNoteArgs = {
  input: UnshareNoteInput;
};


export type MutationUnshareTalentReviewArgs = {
  input: UnshareTalentReviewInput;
};


export type MutationUnsignEvaluationSubmissionArgs = {
  input: UnsignEvaluationSubmissionInput;
};


export type MutationUpdateAnnouncementArgs = {
  input: UpdateAnnouncementInput;
};


export type MutationUpdateApiTokenNotificationEmailArgs = {
  email: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationUpdateApiUserPermissionsArgs = {
  id: Scalars['ID']['input'];
  permissions: Array<Scalars['String']['input']>;
};


export type MutationUpdateCareerArgs = {
  input: CareerUpdateInput;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateCompetencyArgs = {
  input: UpdateCompetencyInput;
};


export type MutationUpdateCompetencyBookmarkArgs = {
  input: UpdateCompetencyBookmarkInput;
};


export type MutationUpdateCompetencyLevelSetArgs = {
  input: UpdateCompetencyLevelSetInput;
};


export type MutationUpdateConnectorArgs = {
  input: UpdateConnectorInput;
};


export type MutationUpdateConnectorConfigFieldArgs = {
  input: UpdateConnectorConfigFieldInput;
};


export type MutationUpdateConnectorTaskArgs = {
  input: UpdateConnectorTaskInput;
};


export type MutationUpdateConnectorUploadArgs = {
  input: UpdateConnectorUploadInput;
};


export type MutationUpdateCustomEmailDomainArgs = {
  input: UpdateCustomEmailDomainInput;
};


export type MutationUpdateCycleInstanceArgs = {
  input: UpdateCycleInstanceInput;
};


export type MutationUpdateCycleTemplateArgs = {
  input: UpdateCycleTemplateInput;
};


export type MutationUpdateEngagementAnswerArgs = {
  input: UpdateEngagementAnswerInput;
};


export type MutationUpdateEngagementCategoryArgs = {
  input: UpdateEngagementCategoryInput;
};


export type MutationUpdateEngagementQuestionArgs = {
  input: UpdateEngagementQuestionInput;
};


export type MutationUpdateEngagementSettingsArgs = {
  input: UpdateEngagementSettingsInput;
};


export type MutationUpdateEngagementSubcategoryArgs = {
  input: UpdateEngagementSubcategoryInput;
};


export type MutationUpdateEngagementTemplateArgs = {
  input: UpdateEngagementTemplateInput;
};


export type MutationUpdateEvaluationFormArgs = {
  input: UpdateEvaluationFormInput;
};


export type MutationUpdateEvaluationSubmissionArgs = {
  input: UpdateEvaluationSubmissionInput;
};


export type MutationUpdateEvaluationSubmissionMeetingStatusArgs = {
  input: UpdateEvaluationSubmissionMeetingStatusInput;
};


export type MutationUpdateExcludeAnalyticsArgs = {
  input: UpdateExcludeAnalyticsInput;
};


export type MutationUpdateExpertiseArgs = {
  input: ExpertiseUpdateInput;
};


export type MutationUpdateExternalFeedbackArgs = {
  input: UpdateExternalFeedbackInput;
};


export type MutationUpdateFeatureRatingArgs = {
  input: UpdateFeatureRatingInput;
};


export type MutationUpdateFeedbackQuestionArgs = {
  input: UpdateFeedbackQuestionInput;
};


export type MutationUpdateFeedbackQuestionCategoryArgs = {
  input: UpdateFeedbackQuestionCategoryInput;
};


export type MutationUpdateFeedbackTemplateArgs = {
  input: UpdateFeedbackTemplateInput;
};


export type MutationUpdateGoalArgs = {
  input: UpdateGoalInput;
};


export type MutationUpdateGoalDriverArgs = {
  input: UpdateGoalDriverInput;
};


export type MutationUpdateGoalTemplateArgs = {
  input: UpdateGoalTemplateInput;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateIdentityProviderArgs = {
  input: UpdateIdentityProviderInput;
};


export type MutationUpdateIdentityProviderConfigurationArgs = {
  input: UpdateIdentityProviderConfigurationInput;
};


export type MutationUpdateInternalFeedbackArgs = {
  input: UpdateInternalFeedbackInput;
};


export type MutationUpdateInvoiceUserCountArgs = {
  input: UpdateInvoiceUserCountInput;
};


export type MutationUpdateJobGoalTemplateArgs = {
  input: UpdateJobGoalTemplateInput;
};


export type MutationUpdateJobLevelArgs = {
  input: UpdateJobLevelInput;
};


export type MutationUpdateJobPositionArgs = {
  input: UpdateJobPositionInput;
};


export type MutationUpdateJobPositionSuccessorArgs = {
  input: UpdateJobPositionSuccessorInput;
};


export type MutationUpdateJobTitleArgs = {
  input: UpdateJobTitleInput;
};


export type MutationUpdateLabelArgs = {
  input: UpdateLabelInput;
};


export type MutationUpdateLearningEventArgs = {
  input: UpdateLearningEventInput;
};


export type MutationUpdateLearningSubjectArgs = {
  input: UpdateLearningSubjectInput;
};


export type MutationUpdateLearningTypeArgs = {
  input: UpdateLearningTypeInput;
};


export type MutationUpdateMcpRemoteSettingsArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationUpdateMeetingArgs = {
  input: UpdateMeetingInput;
};


export type MutationUpdateMeetingAttendeeProposalArgs = {
  attendeeProposal: MeetingAttendeeProposalInput;
  targetTypeID: Scalars['ID']['input'];
};


export type MutationUpdateMeetingAttendeeStatusesArgs = {
  attendeeStatuses: Array<MeetingAttendeeStatusInput>;
  targetTypeID: Scalars['ID']['input'];
};


export type MutationUpdateMeetingSeriesAttendeeStatusesArgs = {
  attendeeStatuses: Array<MeetingAttendeeStatusInput>;
  meetingSeriesID: Scalars['ID']['input'];
};


export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};


export type MutationUpdateNotePreparationArgs = {
  input: UpdateNotePreparationInput;
};


export type MutationUpdateNoteTemplateArgs = {
  input: NoteTemplateUpdateInput;
};


export type MutationUpdateNotificationCustomizationArgs = {
  input: UpdateNotificationCustomizationInput;
};


export type MutationUpdateNotificationTemplateArgs = {
  input: UpdateNotificationTemplateInput;
};


export type MutationUpdatePrivacyConsentArgs = {
  input: UpdatePrivacyConsentInput;
};


export type MutationUpdateSessionArgs = {
  input: UpdateSessionInput;
};


export type MutationUpdateTalentReviewArgs = {
  input: UpdateTalentReviewInput;
};


export type MutationUpdateTalentReviewGridPlacementArgs = {
  input: UpdateTalentReviewGridPlacementInput;
};


export type MutationUpdateTalentReviewSnapshotArgs = {
  input: UpdateTalentReviewSnapshotInput;
};


export type MutationUpdateTalentReviewTemplateArgs = {
  input: UpdateTalentReviewTemplateInput;
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationUpdateTranscriptionSummaryArgs = {
  input: UpdateTranscriptionSummaryInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserActivationDateArgs = {
  input: UpdateUserActivationDateInput;
};


export type MutationUpdateUserAvatarArgs = {
  input: UpdateUserAvatarInput;
};


export type MutationUpdateUserCoverArgs = {
  input: UpdateUserCoverInput;
};


export type MutationUpdateUserDownloadArgs = {
  input: UpdateUserDownloadInput;
};


export type MutationUpdateUserLocaleArgs = {
  input: UpdateUserLocaleInput;
};


export type MutationUpdateUserMissionArgs = {
  input: UpdateUserMissionInput;
};


export type MutationUpdateUserNotificationSettingArgs = {
  input: UpdateUserNotificationSettingInput;
};


export type MutationUpdateWelcomeEmailArgs = {
  input: UpdateWelcomeEmailInput;
};


export type MutationUpdateWorkspaceAliasArgs = {
  input: UpdateWorkspaceAliasInput;
};


export type MutationUpdateWorkspaceBackgroundArgs = {
  input: UpdateWorkspaceBackgroundInput;
};


export type MutationUpdateWorkspaceColorsArgs = {
  input: UpdateWorkspaceColorsInput;
};


export type MutationUpdateWorkspaceDisplayNameArgs = {
  input: UpdateWorkspaceDisplayNameInput;
};


export type MutationUpdateWorkspaceEmailDomainsArgs = {
  input: UpdateWorkspaceEmailDomainsInput;
};


export type MutationUpdateWorkspaceFeatureArgs = {
  input: UpdateWorkspaceFeatureInput;
};


export type MutationUpdateWorkspaceHubSpotCompanyIdArgs = {
  input: UpdateWorkspaceHubSpotCompanyIdInput;
};


export type MutationUpdateWorkspaceLanguagesArgs = {
  input: UpdateWorkspaceLanguagesInput;
};


export type MutationUpdateWorkspaceLogoArgs = {
  input: UpdateWorkspaceLogoInput;
};


export type MutationUpdateWorkspaceMfaSettingsArgs = {
  input: UpdateWorkspaceMfaSettingsInput;
};


export type MutationUpdateWorkspaceNotificationSettingsArgs = {
  input: UpdateWorkspaceNotificationSettingsInput;
};


export type MutationUpdateWorkspacePlanArgs = {
  input: UpdateWorkspacePlanInput;
};


export type MutationUpdateWorkspacePlanV2Args = {
  input: UpdateWorkspacePlanV2Input;
};


export type MutationUpdateWorkspaceRetentionPeriodArgs = {
  input: UpdateWorkspaceRetentionPeriodInput;
};


export type MutationUpdateWorkspaceSsoSettingsArgs = {
  input: UpdateWorkspaceSsoSettingsInput;
};


export type MutationUpdateWorkspaceStartDateArgs = {
  input: UpdateWorkspaceStartDateInput;
};


export type MutationUpsertPageArgs = {
  input: PageUpdateInput;
};


export type MutationVerifySessionArgs = {
  input: VerifySessionInput;
};


export type MutationVerifyTotpTokenArgs = {
  input: VerifyTotpTokenInput;
};

export type MutualNoteCollaborator = {
  __typename?: 'MutualNoteCollaborator';
  count: Scalars['Int']['output'];
  user: User;
};

export type MutualNotesFilters = {
  showArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewPasswordRequiredChallenge = {
  __typename?: 'NewPasswordRequiredChallenge';
  username: Scalars['String']['output'];
};

export type NewPasswordRequiredChallengeResponse = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type NominateJobPositionSuccessorInput = {
  jobTitleID: Scalars['ID']['input'];
  motivation: Scalars['QuillDelta']['input'];
  readiness: SuccessorReadiness;
  userID: Scalars['ID']['input'];
};

export type NominateJobPositionSuccessorResponse = {
  __typename?: 'NominateJobPositionSuccessorResponse';
  successor: JobPositionSuccessor;
};

export type Note = CommentTarget & {
  __typename?: 'Note';
  collaborators: NoteCollaboratorConnection;
  comments: Array<Comment>;
  content?: Maybe<Scalars['QuillDelta']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  /** @deprecated Use `meeting.startsAt` instead. */
  date: Scalars['String']['output'];
  evaluationSubmissions: Array<EvaluationSubmission>;
  feedbackRequests: Array<FeedbackRequest>;
  goals: Array<Goal>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  meeting?: Maybe<Meeting>;
  metadata?: Maybe<NoteMetadata>;
  noteType: NoteType;
  owner: User;
  preparation?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<User>;
  tasks: Array<Task>;
  title?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Transcription>;
  updatedAt: Scalars['DateTime']['output'];
  viewerCanArchive: Scalars['Boolean']['output'];
  viewerCanComment: Scalars['Boolean']['output'];
  viewerCanRestore: Scalars['Boolean']['output'];
  viewerCanShare: Scalars['Boolean']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
  viewerCanViewComments: Scalars['Boolean']['output'];
};


export type NoteCollaboratorsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type NoteCommentsArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NoteCollaboratorConnection = {
  __typename?: 'NoteCollaboratorConnection';
  edges: Array<NoteCollaboratorEdge>;
  pageInfo: PageInfo;
};

export type NoteCollaboratorEdge = {
  __typename?: 'NoteCollaboratorEdge';
  cursor: Scalars['ID']['output'];
  node: User;
};

export type NoteConnection = {
  __typename?: 'NoteConnection';
  edges: Array<NoteEdge>;
  pageInfo: PageInfo;
};

export type NoteEdge = {
  __typename?: 'NoteEdge';
  cursor: Scalars['ID']['output'];
  node: Note;
};

export type NoteMetadata = {
  __typename?: 'NoteMetadata';
  outlookItemId?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  teamsChatId?: Maybe<Scalars['String']['output']>;
  teamsMessageId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
};

export type NoteMetadataInput = {
  outlookItemId?: InputMaybe<Scalars['String']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  teamsChatId?: InputMaybe<Scalars['String']['input']>;
  teamsMessageId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type NoteSeriesMetadata = {
  __typename?: 'NoteSeriesMetadata';
  defaultTitle: Scalars['String']['output'];
  subjectID?: Maybe<Scalars['ID']['output']>;
};

export type NoteSeriesMetadataInput = {
  defaultTitle: Scalars['String']['input'];
  subjectID: Scalars['ID']['input'];
};

export type NoteTemplate = {
  __typename?: 'NoteTemplate';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedByUserID?: Maybe<Scalars['ID']['output']>;
  category: NoteTemplateCategory;
  description?: Maybe<Scalars['LocalizedAttributedString']['output']>;
  icon?: Maybe<NoteTemplateIcon>;
  iconColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  isArchived: Scalars['Boolean']['output'];
  subtitle: Scalars['LocalizedString']['output'];
  title: Scalars['LocalizedString']['output'];
  workspaceID: Scalars['ID']['output'];
};

export type NoteTemplateArchiveInput = {
  id: Scalars['ID']['input'];
};

export type NoteTemplateCategory = {
  __typename?: 'NoteTemplateCategory';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedByUserID?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  title: Scalars['LocalizedString']['output'];
  workspaceID: Scalars['ID']['output'];
};

export type NoteTemplateCategoryArchiveInput = {
  id: Scalars['ID']['input'];
};

export type NoteTemplateCategoryCreateInput = {
  title: Scalars['LocalizedString']['input'];
};

export type NoteTemplateCreateInput = {
  categoryID: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  icon?: InputMaybe<NoteTemplateIcon>;
  iconColor?: InputMaybe<Scalars['String']['input']>;
  subtitle: Scalars['LocalizedString']['input'];
  title: Scalars['LocalizedString']['input'];
};

export enum NoteTemplateIcon {
  Alert = 'ALERT',
  Compass = 'COMPASS',
  Conversation = 'CONVERSATION',
  Friends = 'FRIENDS',
  Gift = 'GIFT',
  Puzzle = 'PUZZLE',
  Sailboat = 'SAILBOAT',
  Search = 'SEARCH',
  Suitcase = 'SUITCASE',
  View = 'VIEW'
}

export type NoteTemplateRestoreCategoryInput = {
  id: Scalars['ID']['input'];
};

export type NoteTemplateRestoreInput = {
  id: Scalars['ID']['input'];
};

export type NoteTemplateTalkingPoints = {
  __typename?: 'NoteTemplateTalkingPoints';
  context: Scalars['QuillDelta']['output'];
  goal: Scalars['QuillDelta']['output'];
  talkingPoints: Scalars['QuillDelta']['output'];
};

export type NoteTemplateTalkingPointsInput = {
  locale: Scalars['String']['input'];
  noteID: Scalars['ID']['input'];
  noteTemplateID: Scalars['ID']['input'];
  subjectUserID: Scalars['ID']['input'];
};

export type NoteTemplateTalkingPointsResponse = {
  __typename?: 'NoteTemplateTalkingPointsResponse';
  noteTemplateTalkingPoints: NoteTemplateTalkingPoints;
};

export type NoteTemplateUpdateInput = {
  categoryID: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  icon?: InputMaybe<NoteTemplateIcon>;
  iconColor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  subtitle: Scalars['LocalizedString']['input'];
  title: Scalars['LocalizedString']['input'];
};

export type NoteTemplatesConnection = {
  __typename?: 'NoteTemplatesConnection';
  edges: Array<NoteTemplatesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NoteTemplatesEdge = {
  __typename?: 'NoteTemplatesEdge';
  cursor: Scalars['ID']['output'];
  node: NoteTemplate;
};

export enum NoteType {
  Conversation = 'CONVERSATION',
  Note = 'NOTE'
}

export enum NotesFilter {
  OwnedByMe = 'OWNED_BY_ME',
  SharedWithMe = 'SHARED_WITH_ME'
}

export type NotesFilters = {
  collaboratorIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasSubject?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  subjectID?: InputMaybe<Scalars['ID']['input']>;
};

export type NotesSummary = {
  __typename?: 'NotesSummary';
  bulletPoints?: Maybe<Scalars['QuillDelta']['output']>;
  sourceNotes: Array<Note>;
};

export type NotesSummaryInput = {
  locale: Scalars['String']['input'];
  subjectUserID: Scalars['ID']['input'];
};

export type NotesSummaryResponse = {
  __typename?: 'NotesSummaryResponse';
  notesSummary: NotesSummary;
};

export type Notification = {
  __typename?: 'Notification';
  attachments: Array<NotificationAttachment>;
  channels: Array<NotificationChannelMap>;
  firstDebouncedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  read: Scalars['Boolean']['output'];
  seen: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationAttachment = Comment | Compliment | EvaluationSubmission | FeedbackRequest | FeedbackResponse | Goal | User;

export enum NotificationChannel {
  Email = 'EMAIL',
  InApp = 'IN_APP',
  Slack = 'SLACK'
}

export type NotificationChannelMap = {
  __typename?: 'NotificationChannelMap';
  channel: NotificationChannel;
  frequency: NotificationFrequency;
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
};

export type NotificationCustomization = {
  __typename?: 'NotificationCustomization';
  content: Scalars['QuillDelta']['output'];
  event: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageID: Scalars['String']['output'];
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor: Scalars['ID']['output'];
  node: Notification;
};

export enum NotificationFrequency {
  Daily = 'DAILY',
  Disabled = 'DISABLED',
  Instant = 'INSTANT',
  Weekly = 'WEEKLY'
}

export enum NotificationStatusField {
  Read = 'READ',
  Seen = 'SEEN'
}

export type NotificationTemplate = {
  __typename?: 'NotificationTemplate';
  contentItem?: Maybe<NotificationTemplateContentItem>;
  contentItems: Array<NotificationTemplateContentItem>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  event: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  requiredPlaceholders: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  viewerCanUpdate: Scalars['Boolean']['output'];
};


export type NotificationTemplateContentItemArgs = {
  languageID?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationTemplateContentItem = {
  __typename?: 'NotificationTemplateContentItem';
  emailHTML?: Maybe<Scalars['String']['output']>;
  languageID: Scalars['String']['output'];
  longFormText?: Maybe<Scalars['QuillDelta']['output']>;
  shortFormText?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ObfuscateUserInput = {
  id: Scalars['ID']['input'];
  username: Scalars['String']['input'];
};

export type ObfuscateUserResponse = {
  __typename?: 'ObfuscateUserResponse';
  user: User;
};

export type OverrideEvaluationSubmissionScoreInput = {
  competencyLevelID?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type OverrideEvaluationSubmissionScoreResponse = {
  __typename?: 'OverrideEvaluationSubmissionScoreResponse';
  evaluationSubmission: EvaluationSubmission;
};

export type Page = {
  __typename?: 'Page';
  content: Scalars['LocalizedAttributedString']['output'];
  type: PageType;
  url?: Maybe<Scalars['LocalizedString']['output']>;
  workspaceID: Scalars['ID']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['ID']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['ID']['output']>;
};

export enum PageType {
  Compliments = 'COMPLIMENTS',
  ConversationsOutgoing = 'CONVERSATIONS_OUTGOING',
  ConversationsPersonal = 'CONVERSATIONS_PERSONAL',
  FeedbackGiven = 'FEEDBACK_GIVEN',
  FeedbackReceived = 'FEEDBACK_RECEIVED',
  FeedbackShared = 'FEEDBACK_SHARED',
  GoalsDepartment = 'GOALS_DEPARTMENT',
  GoalsOrganization = 'GOALS_ORGANIZATION',
  GoalsPersonal = 'GOALS_PERSONAL',
  Home = 'HOME',
  Manager = 'MANAGER',
  Notes = 'NOTES',
  Skills = 'SKILLS'
}

export type PageUpdateInput = {
  content: Scalars['QuillDelta']['input'];
  locale: Scalars['String']['input'];
  type: PageType;
  url?: InputMaybe<Scalars['LocalizedString']['input']>;
};

export type PartialUpdateGoalInput = {
  competency?: InputMaybe<CompetencyGoalInput>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  title: Scalars['LocalizedString']['input'];
};

export type PasswordChallenge = {
  __typename?: 'PasswordChallenge';
  username: Scalars['String']['output'];
};

export type PasswordChallengeResponse = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type PersonalAccessToken = {
  __typename?: 'PersonalAccessToken';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

export type PreloginInput = {
  login: Scalars['String']['input'];
};

export type PreloginResponse = {
  __typename?: 'PreloginResponse';
  url: Scalars['String']['output'];
};

export type PrepareTranscriptionUploadRetryInput = {
  transcriptionID: Scalars['String']['input'];
};

export type PrepareTranscriptionUploadRetryResponse = {
  __typename?: 'PrepareTranscriptionUploadRetryResponse';
  transcriptionID: Scalars['String']['output'];
  uploadHeaders: Array<TranscriptionUploadHeader>;
  uploadURL: Scalars['String']['output'];
};

export type PrivacyConsent = {
  __typename?: 'PrivacyConsent';
  createdAt: Scalars['DateTime']['output'];
  version: Scalars['ID']['output'];
};

export type ProcessCycleInstanceResponse = {
  __typename?: 'ProcessCycleInstanceResponse';
  success: Scalars['Boolean']['output'];
};

export type ProcessMeetingSeriesResponse = {
  __typename?: 'ProcessMeetingSeriesResponse';
  success: Scalars['Boolean']['output'];
};

export enum Prompt {
  All = 'ALL',
  ConversationInsightsEmployee = 'CONVERSATION_INSIGHTS_EMPLOYEE',
  ConversationInsightsManager = 'CONVERSATION_INSIGHTS_MANAGER',
  GoalsInsights = 'GOALS_INSIGHTS',
  OneOnOneRecap = 'ONE_ON_ONE_RECAP',
  TalentInsights = 'TALENT_INSIGHTS',
  TalkingPoints = 'TALKING_POINTS'
}

export type PromptHistory = {
  __typename?: 'PromptHistory';
  cacheWriteTokens?: Maybe<Scalars['Int']['output']>;
  cachedInputTokens?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  durationMs: Scalars['Int']['output'];
  featureRating?: Maybe<FeatureRating>;
  id: Scalars['ID']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  messages: Scalars['JSON']['output'];
  model?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  response: Scalars['JSON']['output'];
  target?: Maybe<PromptHistoryTarget>;
  targetDetails?: Maybe<PromptHistoryTargetDetails>;
  targetID?: Maybe<Scalars['String']['output']>;
  targetType: Scalars['String']['output'];
  toolCallCount: Scalars['Int']['output'];
  user?: Maybe<PromptHistoryUser>;
  workspaceID: Scalars['String']['output'];
};

export type PromptHistoryAnalytics = {
  __typename?: 'PromptHistoryAnalytics';
  byDay: Array<PromptHistoryAnalyticsDayBucket>;
  byMonth: Array<PromptHistoryAnalyticsMonthBucket>;
  byTargetType: Array<PromptHistoryTargetTypeCount>;
  byWeek: Array<PromptHistoryAnalyticsWeekBucket>;
  dateRange?: Maybe<PromptHistoryAnalyticsDateRange>;
  evaluationContext: PromptHistoryEvaluationContext;
  feedbackByTargetType: Array<PromptHistoryFeedbackByTarget>;
  /** Each thumbs or written rating once, dated when it was given (newest first, capped on the server). */
  feedbackDetails: Array<PromptHistoryAnalyticsFeedbackDetail>;
  feedbackDetailsTruncated: Scalars['Boolean']['output'];
  feedbackTotals: PromptHistoryFeedbackTotals;
  topWorkspaces: Array<PromptHistoryWorkspaceCount>;
  totalInteractions: Scalars['Int']['output'];
  uniqueUserCount: Scalars['Int']['output'];
  uniqueWorkspaceCount: Scalars['Int']['output'];
  usageByModel: Array<PromptHistoryModelUsage>;
  usageByWorkspace: Array<PromptHistoryWorkspaceUsage>;
};

export type PromptHistoryAnalyticsDateRange = {
  __typename?: 'PromptHistoryAnalyticsDateRange';
  max?: Maybe<Scalars['DateTime']['output']>;
  min?: Maybe<Scalars['DateTime']['output']>;
};

export type PromptHistoryAnalyticsDayBucket = {
  __typename?: 'PromptHistoryAnalyticsDayBucket';
  countsByTargetType: Array<PromptHistoryTargetTypeCountInWeek>;
  dayKey: Scalars['String']['output'];
  dayStart?: Maybe<Scalars['DateTime']['output']>;
};

export type PromptHistoryAnalyticsFeedbackDetail = {
  __typename?: 'PromptHistoryAnalyticsFeedbackDetail';
  interactionCreatedAt: Scalars['DateTime']['output'];
  targetID?: Maybe<Scalars['String']['output']>;
  targetType: Scalars['String']['output'];
  thumbsUp?: Maybe<Scalars['Boolean']['output']>;
  userID: Scalars['String']['output'];
  workspaceID: Scalars['String']['output'];
  writtenFeedback?: Maybe<Scalars['String']['output']>;
};

export type PromptHistoryAnalyticsMonthBucket = {
  __typename?: 'PromptHistoryAnalyticsMonthBucket';
  countsByTargetType: Array<PromptHistoryTargetTypeCountInWeek>;
  monthKey: Scalars['String']['output'];
  monthStart?: Maybe<Scalars['DateTime']['output']>;
};

export type PromptHistoryAnalyticsWeekBucket = {
  __typename?: 'PromptHistoryAnalyticsWeekBucket';
  countsByTargetType: Array<PromptHistoryTargetTypeCountInWeek>;
  weekKey: Scalars['String']['output'];
  weekStart?: Maybe<Scalars['DateTime']['output']>;
};

export type PromptHistoryAsset = {
  __typename?: 'PromptHistoryAsset';
  source: AssetVariant;
};

export type PromptHistoryConnection = {
  __typename?: 'PromptHistoryConnection';
  edges: Array<PromptHistoryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PromptHistoryEdge = {
  __typename?: 'PromptHistoryEdge';
  cursor: Scalars['ID']['output'];
  node: PromptHistory;
};

export type PromptHistoryEvaluationContext = {
  __typename?: 'PromptHistoryEvaluationContext';
  asEmployeeCount: Scalars['Int']['output'];
  asManagerCount: Scalars['Int']['output'];
  unknownCount: Scalars['Int']['output'];
};

export type PromptHistoryExportRow = {
  __typename?: 'PromptHistoryExportRow';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  targetType: Scalars['String']['output'];
  userID: Scalars['String']['output'];
  workspaceID: Scalars['String']['output'];
};

export type PromptHistoryFeedbackByTarget = {
  __typename?: 'PromptHistoryFeedbackByTarget';
  negativeCount: Scalars['Int']['output'];
  positiveCount: Scalars['Int']['output'];
  ratingWithoutWrittenFeedbackCount: Scalars['Int']['output'];
  targetType: Scalars['String']['output'];
  withWrittenFeedbackCount: Scalars['Int']['output'];
};

export type PromptHistoryFeedbackTotals = {
  __typename?: 'PromptHistoryFeedbackTotals';
  noRatingCount: Scalars['Int']['output'];
  ratingWithoutWrittenFeedbackCount: Scalars['Int']['output'];
  withWrittenFeedbackCount: Scalars['Int']['output'];
};

export type PromptHistoryFilters = {
  filter?: InputMaybe<Scalars['String']['input']>;
  includeDemoWorkspaces?: InputMaybe<Scalars['Boolean']['input']>;
  targetType?: InputMaybe<Scalars['String']['input']>;
};

/** Token totals for one model inside the filtered window. Costs are estimated in the client from these totals. */
export type PromptHistoryModelUsage = {
  __typename?: 'PromptHistoryModelUsage';
  cacheWriteTokens: Scalars['Float']['output'];
  cachedInputTokens: Scalars['Float']['output'];
  inputTokens: Scalars['Float']['output'];
  model?: Maybe<Scalars['String']['output']>;
  outputTokens: Scalars['Float']['output'];
  promptCount: Scalars['Int']['output'];
};

export type PromptHistoryTarget = EvaluationSubmission | Transcription;

export type PromptHistoryTargetDetails = {
  __typename?: 'PromptHistoryTargetDetails';
  employee?: Maybe<PromptHistoryUser>;
  evaluationFormTitle?: Maybe<Scalars['LocalizedString']['output']>;
  id: Scalars['ID']['output'];
  manager?: Maybe<PromptHistoryUser>;
  type: Scalars['String']['output'];
  workspaceID: Scalars['String']['output'];
};

export type PromptHistoryTargetTypeCount = {
  __typename?: 'PromptHistoryTargetTypeCount';
  count: Scalars['Int']['output'];
  targetType: Scalars['String']['output'];
};

export type PromptHistoryTargetTypeCountInWeek = {
  __typename?: 'PromptHistoryTargetTypeCountInWeek';
  count: Scalars['Int']['output'];
  targetType: Scalars['String']['output'];
};

export type PromptHistoryUser = {
  __typename?: 'PromptHistoryUser';
  avatar?: Maybe<PromptHistoryAsset>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type PromptHistoryWorkspaceCount = {
  __typename?: 'PromptHistoryWorkspaceCount';
  interactionCount: Scalars['Int']['output'];
  uniqueUserCount: Scalars['Int']['output'];
  workspaceID: Scalars['String']['output'];
};

export type PromptHistoryWorkspaceUsage = {
  __typename?: 'PromptHistoryWorkspaceUsage';
  byModel: Array<PromptHistoryModelUsage>;
  workspaceID: Scalars['String']['output'];
};

export type PromptInstruction = {
  __typename?: 'PromptInstruction';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  instructions: Scalars['String']['output'];
  promptInstructionID: Prompt;
  updatedAt: Scalars['DateTime']['output'];
  workspaceID: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  agentChat: AgentChat;
  agentChats: Array<AgentChat>;
  analytics: Analytics;
  analyticsManagerAllowedUsers: Array<AnalyticsManager>;
  analyticsPrimaryManagerIds: Array<Scalars['ID']['output']>;
  analyticsSnapshot: AnalyticsSnapshot;
  analyticsSnapshots: Array<AnalyticsWorkspaceSnapshot>;
  announcement?: Maybe<Announcement>;
  announcements: AnnouncementConnection;
  apiTokenDescriptions: Array<ApiTokenDescription>;
  apiTokenNotificationEmail: ApiTokenNotificationEmail;
  apiUsers: Array<ApiUser>;
  asset: Asset;
  assets: Array<Asset>;
  career: Career;
  careers: CareersConnection;
  comments: Array<Comment>;
  competencies: CompetencyConnection;
  competenciesByIDs: Array<Competency>;
  competency: Competency;
  competencyLevelSet: CompetencyLevelSet;
  competencyLevelSets: CompetencyLevelSetConnection;
  compliment: Compliment;
  connectorConfigField?: Maybe<ConnectorConfigField>;
  connectorLogs: ConnectorLogConnection;
  connectorTasks: ConnectorTaskConnection;
  connectorUploads: ConnectorUploadConnection;
  connectors: Array<Connector>;
  /**
   * Course recommendations based on the current conversation, using its form
   * and answers rather than a goal draft or the viewer's full profile.
   */
  conversationLearningRecommendations: LearningRecommendationsResponse;
  conversationsTwoWayReady: EvaluationSubmissionConnection;
  cycleInstance: CycleInstance;
  cycleInstancesForProcessing: CycleInstanceConnection;
  cycleTemplate: CycleTemplate;
  cycleTemplates: CycleTemplateConnection;
  engagementAnalytics: EngagementAnalytics;
  engagementCategories: EngagementCategoryConnection;
  engagementCategory: EngagementCategory;
  engagementIntervalDefaults: Array<EngagementIntervalDefault>;
  engagementQuestion: EngagementQuestion;
  engagementQuestions: EngagementQuestionConnection;
  engagementRequest: EngagementRequest;
  engagementRequestListing: EngagementRequestListingConnection;
  engagementRequests: EngagementRequestConnection;
  engagementResponse: EngagementResponse;
  engagementResponses: Array<EngagementResponse>;
  engagementTemplate: EngagementTemplate;
  engagementTemplateListing: EngagementTemplateListingConnection;
  engagementTemplates: EngagementTemplateConnection;
  engagementType: EngagementType;
  engagementTypes: EngagementTypeConnection;
  entityChangelogs: EntityChangelogConnection;
  evaluationForm: EvaluationForm;
  evaluationForms: EvaluationFormConnection;
  /** Returns the reveal data for a conversation, or null when not applicable. */
  evaluationReveal?: Maybe<EvaluationReveal>;
  evaluationSubmission: EvaluationSubmission;
  expertise: Expertise;
  /**
   * Builds a spreadsheet of users matching the given filters and returns a
   * short-lived signed download URL. Does not change any workspace data.
   */
  exportUsers: ExportResponse;
  externalFeedback: FeedbackResponse;
  /**
   * Returns a feedback request with the given ID for the external recipient with
   * the given ID. This bypasses some of the permission checks that regular
   * feedback requests go through to make them available to users without an
   * account.
   */
  externalFeedbackRequest: FeedbackRequest;
  externalKakapoFeedback: ExternalKakapoFeedback;
  failedSsoAttempts: FailedSsoAttemptConnection;
  /** Get all feature ratings for a specific feature */
  featureRatingsByFeature: Array<FeatureRating>;
  /** Get all feature ratings for a specific target */
  featureRatingsByTarget: Array<FeatureRating>;
  featureWorkspaceOverview: Array<FeatureWorkspaceOverview>;
  feedbackQuestion: FeedbackQuestion;
  feedbackQuestionCategories: FeedbackQuestionCategoryConnection;
  feedbackQuestionCategory: FeedbackQuestionCategory;
  feedbackQuestions: FeedbackQuestionConnection;
  /** Returns a feedback request with the given ID. */
  feedbackRequest: FeedbackRequest;
  feedbackResponse: FeedbackResponse;
  feedbackTemplate: FeedbackTemplate;
  feedbackTemplates: FeedbackTemplateConnection;
  goal: Goal;
  goalDrivers: Array<GoalDriver>;
  goalLearningRecommendations: LearningRecommendationsResponse;
  goalRevision: GoalRevision;
  goalTemplate: GoalTemplate;
  goalTemplates: GoalTemplateConnection;
  group: Group;
  groupAnalytics: GroupAnalytics;
  groups: GroupConnection;
  groupsByExternalReferenceID: Array<Group>;
  /**
   * Check if a viewer has submitted a rating for a feature.
   * If targetType is provided, only ratings for that target type are considered.
   * If targetID is provided (targetType is then required), checks if the viewer has rated that specific target for that feature.
   * If ratedAfter is provided, only ratings created after that date are considered.
   */
  hasViewerRated: Scalars['Boolean']['output'];
  identityProvider: IdentityProvider;
  identityProviderIDForEmailDomain?: Maybe<Scalars['ID']['output']>;
  identityProviders: Array<IdentityProvider>;
  internalFeedback: FeedbackResponse;
  internalKakapoFeedback: InternalKakapoFeedback;
  isWorkspaceSlugAvailable: Scalars['Boolean']['output'];
  jobLevel: JobLevel;
  jobLevels: JobLevelConnection;
  jobLevelsByExternalReferenceID: Array<JobLevel>;
  jobPosition: JobPosition;
  /**
   * All nominations for a job title, newest first. Archived (withdrawn)
   * nominations are left out unless `includeArchived` is set.
   */
  jobPositionSuccessors: Array<JobPositionSuccessor>;
  jobPositions: JobPositionConnection;
  jobPositionsByExternalReferenceID: Array<JobPosition>;
  jobTitle: JobTitle;
  jobTitleByReferenceCode?: Maybe<JobTitle>;
  /**
   * Active job titles the viewer may see succession for, each with its
   * active nominations (newest first). HR sees every title; a manager sees
   * the titles of people they manage, and a primary manager also sees the
   * titles held in departments below theirs.
   */
  jobTitleSuccessors: Array<JobTitleSuccession>;
  jobTitles: JobTitleConnection;
  jobTitlesByExternalReferenceID: Array<JobTitle>;
  label: Label;
  labels: Array<Label>;
  learningCourse: LearningCourse;
  /**
   * The workspace's external learning library. Only returns courses of providers whose
   * connector is currently active, so disabling a connector hides its content immediately.
   */
  learningCourses: LearningCourseConnection;
  learningEvent: LearningEvent;
  learningEventProposals: LearningEventConnection;
  learningEvents: LearningEventConnection;
  /**
   * Personalized course recommendations for the current user, based on their
   * goals, job, conversations and feedback rather than a specific goal draft.
   */
  learningRecommendations: LearningRecommendationsResponse;
  learningSubject: LearningSubject;
  learningSubjects: LearningSubjectConnection;
  learningType: LearningType;
  learningTypes: LearningTypeConnection;
  mcpRemoteSettings: McpRemoteSettings;
  meetingSeriesForProcessing: MeetingSeriesConnection;
  momentInstance: MomentInstance;
  mutualNoteCollaborators: Array<MutualNoteCollaborator>;
  note: Note;
  noteSubjectsWithCount: Array<UserWithCount>;
  noteTemplate: NoteTemplate;
  noteTemplateCategories: Array<Maybe<NoteTemplateCategory>>;
  noteTemplateCategory: NoteTemplateCategory;
  noteTemplates: NoteTemplatesConnection;
  notes: NoteConnection;
  /** @deprecated Use `notes(filters: NotesFilters)` instead. */
  notesBySubject: Array<Note>;
  notification: Notification;
  notificationCustomization?: Maybe<NotificationCustomization>;
  notificationTemplate: NotificationTemplate;
  notificationTemplates: Array<NotificationTemplate>;
  openQuestionAnswerWithReplies: EngagmentAnswerWithReplies;
  page?: Maybe<Page>;
  paginatedExpertises: ExpertiseConnection;
  paginatedLabels: LabelConnection;
  promptFeedbackTips: AiResponse;
  promptHistories: PromptHistoryConnection;
  promptHistory?: Maybe<PromptHistory>;
  promptHistoryAnalytics: PromptHistoryAnalytics;
  promptHistoryExport: Array<PromptHistoryExportRow>;
  promptInstruction?: Maybe<PromptInstruction>;
  promptNoteTemplateTalkingPoints: NoteTemplateTalkingPointsResponse;
  promptNotesSummary: NotesSummaryResponse;
  roles: Array<Role>;
  searchKey: SearchKey;
  sentEmails: SentEmailConnection;
  serviceProvider: ServiceProvider;
  sessionSlots: Array<SessionSlot>;
  singleSignOns: Array<SingleSignOn>;
  slackIdentities: SlackIdentityConnection;
  /**
   * Lists every Styr job from the last sync snapshot together with the Treams JobTitles it is
   * linked to (if any). Backs the manual job-mapping tool on the Styr page. Empty until a sync
   * has run (the snapshot is written each sync). One Styr job may be linked to many JobTitles.
   */
  styrJobMappings: Array<StyrJobMapping>;
  /**
   * Lists every Styr organisation visible to Treams. Used by the launch admin panel
   * dropdown so support can pick the right organisation by name rather than typing a
   * GUID. Launch-only; the customer-facing Styr page never calls this.
   */
  styrOrganisations: Array<StyrOrganisation>;
  supportEmailAddresses: Array<Scalars['String']['output']>;
  talentReview: TalentReview;
  talentReviewGrid: TalentReviewGrid;
  /**
   * Template of this group with the latest placement write; without writes,
   * the oldest non-archived template. Null only when the workspace has no
   * templates — the UI then shows the empty placeholder.
   */
  talentReviewLatestGrid?: Maybe<TalentReviewGrid>;
  talentReviewSnapshot: TalentReviewSnapshot;
  talentReviewTemplate: TalentReviewTemplate;
  talentReviewTemplates: TalentReviewTemplateConnection;
  /** Templates on which this group has at least one placement, latest write first. */
  talentReviewUsedTemplates: Array<TalentReviewTemplate>;
  task?: Maybe<Task>;
  temporarySessionToken?: Maybe<TemporarySessionToken>;
  timezones: Array<Timezone>;
  user: User;
  userDownload: UserDownload;
  userFile: Scalars['String']['output'];
  userRoles: UserRoleConnection;
  users: UserConnection;
  usersByExternalReferenceID: Array<User>;
  usersByIDs: Array<User>;
  usersReadyForRedact: Array<WorkspaceUserId>;
  viewer: User;
  workspace: Workspace;
  workspaceAlias: Workspace;
  workspaceAnalytics: WorkspaceAnalytics;
  workspacePromptInstruction?: Maybe<PromptInstruction>;
  workspaceStatistics: WorkspaceStatistic;
  workspaceUserCount: Scalars['Int']['output'];
  workspacesV2: WorkspaceConnection;
};


export type QueryAgentChatArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAnalyticsArgs = {
  filters: AnalyticsFiltersV2;
  type: AnalyticsType;
};


export type QueryAnalyticsManagerAllowedUsersArgs = {
  managerIds: Array<Scalars['ID']['input']>;
};


export type QueryAnnouncementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAnnouncementsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  displayType?: InputMaybe<AnnouncementDisplayType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryApiTokenDescriptionsArgs = {
  type: Scalars['String']['input'];
};


export type QueryApiTokenNotificationEmailArgs = {
  type: Scalars['String']['input'];
};


export type QueryAssetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssetsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCareerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCareersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCommentsArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  targetID: Scalars['ID']['input'];
  targetType: CommentTargetType;
};


export type QueryCompetenciesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived: Scalars['Boolean']['input'];
  jobTitleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompetenciesByIDsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCompetencyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompetencyLevelSetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompetencyLevelSetsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryComplimentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConnectorConfigFieldArgs = {
  connectorType: ConnectorType;
  key: Scalars['String']['input'];
};


export type QueryConnectorLogsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  date: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minimumLogLevel?: InputMaybe<ConnectorLogLevel>;
};


export type QueryConnectorTasksArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConnectorUploadsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConversationLearningRecommendationsArgs = {
  input: ConversationLearningRecommendationsInput;
};


export type QueryConversationsTwoWayReadyArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCycleInstanceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCycleInstancesForProcessingArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  cycleTemplateID?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCycleTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCycleTemplatesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEngagementAnalyticsArgs = {
  filters: AnalyticsFilters;
};


export type QueryEngagementCategoriesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  global: Scalars['Boolean']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEngagementCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEngagementQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEngagementQuestionsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  global: Scalars['Boolean']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEngagementRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEngagementRequestListingArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  templateID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEngagementRequestsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  templateID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEngagementResponseArgs = {
  id: Scalars['ID']['input'];
  secret?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEngagementResponsesArgs = {
  requestID: Scalars['ID']['input'];
};


export type QueryEngagementTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEngagementTemplateListingArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEngagementTemplatesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEngagementTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEngagementTypesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  global: Scalars['Boolean']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEntityChangelogsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  entityID: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEvaluationFormArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEvaluationFormsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEvaluationRevealArgs = {
  submissionID: Scalars['ID']['input'];
};


export type QueryEvaluationSubmissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExpertiseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportUsersArgs = {
  input: ExportUsersInput;
};


export type QueryExternalFeedbackArgs = {
  id: Scalars['ID']['input'];
  secret: Scalars['String']['input'];
};


export type QueryExternalFeedbackRequestArgs = {
  externalID: Scalars['ID']['input'];
  requestID: Scalars['ID']['input'];
};


export type QueryExternalKakapoFeedbackArgs = {
  secret: Scalars['String']['input'];
};


export type QueryFailedSsoAttemptsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  externalID?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFeatureRatingsByFeatureArgs = {
  featureName: FeatureName;
};


export type QueryFeatureRatingsByTargetArgs = {
  targetID: Scalars['ID']['input'];
  targetType: Scalars['String']['input'];
};


export type QueryFeedbackQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeedbackQuestionCategoriesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFeedbackQuestionCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeedbackQuestionsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFeedbackRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeedbackResponseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeedbackTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeedbackTemplatesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<FeedbackTemplateFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGoalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGoalDriversArgs = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGoalLearningRecommendationsArgs = {
  input: GoalLearningRecommendationsInput;
};


export type QueryGoalRevisionArgs = {
  id: Scalars['ID']['input'];
  revision: Scalars['String']['input'];
  secret?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGoalTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGoalTemplatesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived: Scalars['Boolean']['input'];
  jobTitleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGroupAnalyticsArgs = {
  filters: AnalyticsFilters;
};


export type QueryGroupsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<GroupsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGroupsByExternalReferenceIdArgs = {
  externalReferenceID: Scalars['String']['input'];
};


export type QueryHasViewerRatedArgs = {
  featureName: FeatureName;
  ratedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  targetID?: InputMaybe<Scalars['ID']['input']>;
  targetType?: InputMaybe<FeatureRatingTargetType>;
  viewerID: Scalars['ID']['input'];
};


export type QueryIdentityProviderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIdentityProviderIdForEmailDomainArgs = {
  emailDomain: Scalars['String']['input'];
};


export type QueryInternalFeedbackArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInternalKakapoFeedbackArgs = {
  requestID: Scalars['String']['input'];
};


export type QueryIsWorkspaceSlugAvailableArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobLevelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobLevelsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobLevelsByExternalReferenceIdArgs = {
  externalReferenceID: Scalars['String']['input'];
};


export type QueryJobPositionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobPositionSuccessorsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitleID: Scalars['ID']['input'];
};


export type QueryJobPositionsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<JobPositionStatus>;
};


export type QueryJobPositionsByExternalReferenceIdArgs = {
  externalReferenceID: Scalars['String']['input'];
};


export type QueryJobTitleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobTitleByReferenceCodeArgs = {
  referenceCode: Scalars['String']['input'];
};


export type QueryJobTitlesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobTitlesByExternalReferenceIdArgs = {
  externalReferenceID: Scalars['String']['input'];
};


export type QueryLabelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLabelsArgs = {
  isArchived: Scalars['Boolean']['input'];
};


export type QueryLearningCourseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLearningCoursesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<LearningCourseFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLearningEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLearningEventProposalsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLearningEventsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<LearningEventFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLearningSubjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLearningSubjectsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLearningTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLearningTypesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMeetingSeriesForProcessingArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryMomentInstanceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNoteTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNoteTemplateCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNoteTemplatesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  subjectID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNotesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<NotesFilter>;
  filters?: InputMaybe<NotesFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNotesBySubjectArgs = {
  subjectID: Scalars['ID']['input'];
};


export type QueryNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationCustomizationArgs = {
  event: Scalars['String']['input'];
  languageID: Scalars['String']['input'];
};


export type QueryNotificationTemplateArgs = {
  event: Scalars['String']['input'];
};


export type QueryOpenQuestionAnswerWithRepliesArgs = {
  id: Scalars['ID']['input'];
  managerID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPageArgs = {
  type: PageType;
};


export type QueryPaginatedExpertisesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaginatedLabelsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  type: LabelType;
};


export type QueryPromptFeedbackTipsArgs = {
  input: FeedbackTipsInput;
};


export type QueryPromptHistoriesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<PromptHistoryFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPromptHistoryArgs = {
  promptHistoryID: Scalars['ID']['input'];
  workspaceID: Scalars['ID']['input'];
};


export type QueryPromptHistoryAnalyticsArgs = {
  calendarTimeZone?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  filters: PromptHistoryFilters;
  startDate: Scalars['DateTime']['input'];
};


export type QueryPromptHistoryExportArgs = {
  endDate: Scalars['DateTime']['input'];
  filters: PromptHistoryFilters;
  startDate: Scalars['DateTime']['input'];
};


export type QueryPromptInstructionArgs = {
  promptInstructionID: Prompt;
  workspaceID: Scalars['ID']['input'];
};


export type QueryPromptNoteTemplateTalkingPointsArgs = {
  input: NoteTemplateTalkingPointsInput;
};


export type QueryPromptNotesSummaryArgs = {
  input: NotesSummaryInput;
};


export type QueryRolesArgs = {
  target?: InputMaybe<RoleTargetType>;
};


export type QuerySentEmailsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySlackIdentitiesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTalentReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTalentReviewGridArgs = {
  groupID: Scalars['ID']['input'];
  localDate: Scalars['LocalDate']['input'];
  templateID: Scalars['ID']['input'];
};


export type QueryTalentReviewLatestGridArgs = {
  groupID: Scalars['ID']['input'];
};


export type QueryTalentReviewSnapshotArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTalentReviewTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTalentReviewTemplatesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived: Scalars['Boolean']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTalentReviewUsedTemplatesArgs = {
  groupID: Scalars['ID']['input'];
};


export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTemporarySessionTokenArgs = {
  tokenID: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserDownloadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserFileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserRolesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  withExternalReferenceID?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<UserStatus>;
};


export type QueryUsersByExternalReferenceIdArgs = {
  externalReferenceID: Scalars['String']['input'];
};


export type QueryUsersByIDsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryUsersReadyForRedactArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkspaceAliasArgs = {
  alias: Scalars['String']['input'];
};


export type QueryWorkspaceAnalyticsArgs = {
  filters: AnalyticsFilters;
};


export type QueryWorkspaceStatisticsArgs = {
  workspaceID: Scalars['ID']['input'];
};


export type QueryWorkspacesV2Args = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filters: WorkspaceFilters;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type RedactUserInput = {
  userID: Scalars['ID']['input'];
};

export type RedactUserResponse = {
  __typename?: 'RedactUserResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RefreshAnalyticsSnapshotResponse = {
  __typename?: 'RefreshAnalyticsSnapshotResponse';
  success: Scalars['Boolean']['output'];
};

export type RefreshSessionInput = {
  refreshToken: Scalars['String']['input'];
  state?: InputMaybe<AuthorizationStateInput>;
};

export type RefreshSessionResponse = {
  __typename?: 'RefreshSessionResponse';
  challenge?: Maybe<Challenge>;
  session?: Maybe<Session>;
};

export type RefreshUserDocumentV2ScanStatusInput = {
  objectKey: Scalars['String']['input'];
};

export type RegenerateTranscriptionSummaryInput = {
  transcriptionID: Scalars['String']['input'];
};

export type RegenerateTranscriptionSummaryResponse = {
  __typename?: 'RegenerateTranscriptionSummaryResponse';
  transcription: Transcription;
};

export type RemoveCycleInstanceInput = {
  id: Scalars['ID']['input'];
};

export type RemoveCycleInstanceResponse = {
  __typename?: 'RemoveCycleInstanceResponse';
  success: Scalars['Boolean']['output'];
};

export type RemoveSuppressedEmailInput = {
  email: Scalars['String']['input'];
};

export type RemoveSuppressedEmailResponse = {
  __typename?: 'RemoveSuppressedEmailResponse';
  success: Scalars['Boolean']['output'];
};

export type RemoveTalentReviewGridPlacementInput = {
  groupID: Scalars['ID']['input'];
  localDate: Scalars['LocalDate']['input'];
  templateID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type RemoveTalentReviewGridPlacementResponse = {
  __typename?: 'RemoveTalentReviewGridPlacementResponse';
  grid: TalentReviewGrid;
};

export type RemoveWorkspacePlanInput = {
  planID: Scalars['ID']['input'];
  workspaceID: Scalars['ID']['input'];
};

export type RemoveWorkspacePlanResponse = {
  __typename?: 'RemoveWorkspacePlanResponse';
  success: Scalars['Boolean']['output'];
};

export type RenameAgentChatInput = {
  chatID: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type ReorderEngagementCategoryInput = {
  id: Scalars['ID']['input'];
  order: Scalars['Float']['input'];
};

export type ReorderEngagementCategoryResponse = {
  __typename?: 'ReorderEngagementCategoryResponse';
  category: EngagementCategory;
};

export type ReorderEngagementQuestionInput = {
  id: Scalars['ID']['input'];
  order: Scalars['Float']['input'];
  subcategoryID: Scalars['ID']['input'];
};

export type ReorderEngagementQuestionResponse = {
  __typename?: 'ReorderEngagementQuestionResponse';
  question: EngagementQuestion;
};

export type ReorderEngagementSubcategoryInput = {
  categoryID: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  order: Scalars['Float']['input'];
};

export type ReorderEngagementSubcategoryResponse = {
  __typename?: 'ReorderEngagementSubcategoryResponse';
  subcategory: EngagementSubcategory;
};

export type ReorderFeedbackQuestionCategoryInput = {
  id: Scalars['ID']['input'];
  order: Scalars['Float']['input'];
};

export type ReorderFeedbackQuestionCategoryResponse = {
  __typename?: 'ReorderFeedbackQuestionCategoryResponse';
  feedbackQuestionCategory: FeedbackQuestionCategory;
};

export type ReorderFeedbackQuestionInput = {
  categoryID: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  order: Scalars['Float']['input'];
};

export type ReorderFeedbackQuestionResponse = {
  __typename?: 'ReorderFeedbackQuestionResponse';
  feedbackQuestion: FeedbackQuestion;
};

export type ReorderGoalDriverInput = {
  id: Scalars['ID']['input'];
  order: Scalars['Float']['input'];
};

export type ReorderGoalDriverResponse = {
  __typename?: 'ReorderGoalDriverResponse';
  goalDriver: GoalDriver;
};

export type ReorderGoalInput = {
  goalID: Scalars['ID']['input'];
  order: Scalars['Float']['input'];
};

export type ReorderGoalResponse = {
  __typename?: 'ReorderGoalResponse';
  goal: Goal;
};

export type ReorderTaskInput = {
  id: Scalars['ID']['input'];
  order: Scalars['Float']['input'];
};

export type ReorderTaskResponse = {
  __typename?: 'ReorderTaskResponse';
  task: Task;
};

export type RequestEvaluationSubmissionInput = {
  deadline: Scalars['DateTime']['input'];
  evaluationFormID: Scalars['ID']['input'];
  meeting?: InputMaybe<EvaluationSubmissionMeetingInput>;
  momentID?: InputMaybe<Scalars['ID']['input']>;
  userID: Scalars['ID']['input'];
};

export type RequestEvaluationSubmissionResponse = {
  __typename?: 'RequestEvaluationSubmissionResponse';
  evaluationSubmission: EvaluationSubmission;
};

export type RequestExternalFeedbackInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  requestID: Scalars['ID']['input'];
};

export type RequestExternalFeedbackResponse = {
  __typename?: 'RequestExternalFeedbackResponse';
  feedbackRequest: FeedbackRequest;
};

export type RequestInternalFeedbackInput = {
  requestID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type RequestInternalFeedbackResponse = {
  __typename?: 'RequestInternalFeedbackResponse';
  feedbackRequest: FeedbackRequest;
};

export type RequestWorkspaceInput = {
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  /** @deprecated Use planType instead */
  featurePresetID?: InputMaybe<Scalars['ID']['input']>;
  locale: Scalars['String']['input'];
  planType?: InputMaybe<WorkspacePlanType>;
  userName: Scalars['String']['input'];
};

export type RequestWorkspaceResponse = {
  __typename?: 'RequestWorkspaceResponse';
  success: Scalars['Boolean']['output'];
};

export type RescheduleEvaluationSubmissionInput = {
  deadline: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  meeting: EvaluationSubmissionMeetingInput;
};

export type RescheduleEvaluationSubmissionResponse = {
  __typename?: 'RescheduleEvaluationSubmissionResponse';
  evaluationSubmission: EvaluationSubmission;
};

export type ResendTemporaryPasswordInput = {
  login: Scalars['String']['input'];
};

export type ResendTemporaryPasswordResponse = {
  __typename?: 'ResendTemporaryPasswordResponse';
  delivery: CodeDelivery;
};

export type ResetUserAvatarInput = {
  userID: Scalars['ID']['input'];
};

export type ResetUserAvatarResponse = {
  __typename?: 'ResetUserAvatarResponse';
  user: User;
};

export type ResetUserCoverInput = {
  userID: Scalars['ID']['input'];
};

export type ResetUserCoverResponse = {
  __typename?: 'ResetUserCoverResponse';
  user: User;
};

export type ResetWorkspaceBackgroundResponse = {
  __typename?: 'ResetWorkspaceBackgroundResponse';
  workspace: Workspace;
};

export type ResetWorkspaceLogoResponse = {
  __typename?: 'ResetWorkspaceLogoResponse';
  workspace: Workspace;
};

export type RestoreCommentInput = {
  id: Scalars['ID']['input'];
};

export type RestoreCommentResponse = {
  __typename?: 'RestoreCommentResponse';
  comment: Comment;
  /** @deprecated Use `comment` instead. */
  success: Scalars['Boolean']['output'];
};

export type RestoreCompetencyBookmarkInput = {
  /** ID of the competency bookmark to restore. */
  competencyID: Scalars['ID']['input'];
  /** ID of the user that this competency belongs to. */
  userID: Scalars['ID']['input'];
};

export type RestoreCompetencyBookmarkResponse = {
  __typename?: 'RestoreCompetencyBookmarkResponse';
  /** Contains the restored competency bookmark. */
  competencyBookmark: CompetencyBookmark;
};

export type RestoreCompetencyInput = {
  id: Scalars['ID']['input'];
};

export type RestoreCompetencyLevelSetInput = {
  id: Scalars['ID']['input'];
};

export type RestoreCompetencyLevelSetResponse = {
  __typename?: 'RestoreCompetencyLevelSetResponse';
  competencyLevelSet: CompetencyLevelSet;
};

export type RestoreCompetencyResponse = {
  __typename?: 'RestoreCompetencyResponse';
  competency: Competency;
};

export type RestoreComplimentInput = {
  id: Scalars['ID']['input'];
};

export type RestoreComplimentResponse = {
  __typename?: 'RestoreComplimentResponse';
  compliment: Compliment;
};

export type RestoreCycleTemplateInput = {
  id: Scalars['ID']['input'];
};

export type RestoreCycleTemplateResponse = {
  __typename?: 'RestoreCycleTemplateResponse';
  cycleTemplate: CycleTemplate;
};

export type RestoreEngagementCategoryInput = {
  id: Scalars['ID']['input'];
};

export type RestoreEngagementCategoryResponse = {
  __typename?: 'RestoreEngagementCategoryResponse';
  category: EngagementCategory;
};

export type RestoreEngagementQuestionInput = {
  id: Scalars['ID']['input'];
};

export type RestoreEngagementQuestionResponse = {
  __typename?: 'RestoreEngagementQuestionResponse';
  question: EngagementQuestion;
};

export type RestoreEngagementSubcategoryInput = {
  id: Scalars['ID']['input'];
};

export type RestoreEngagementSubcategoryResponse = {
  __typename?: 'RestoreEngagementSubcategoryResponse';
  subcategory: EngagementSubcategory;
};

export type RestoreEvaluationFormInput = {
  id: Scalars['ID']['input'];
};

export type RestoreEvaluationFormResponse = {
  __typename?: 'RestoreEvaluationFormResponse';
  evaluationForm: EvaluationForm;
};

export type RestoreEvaluationSubmissionInput = {
  id: Scalars['ID']['input'];
};

export type RestoreEvaluationSubmissionResponse = {
  __typename?: 'RestoreEvaluationSubmissionResponse';
  evaluationSubmission: EvaluationSubmission;
};

export type RestoreExpertiseInput = {
  id: Scalars['ID']['input'];
};

export type RestoreFeedbackQuestionCategoryInput = {
  id: Scalars['ID']['input'];
};

export type RestoreFeedbackQuestionCategoryResponse = {
  __typename?: 'RestoreFeedbackQuestionCategoryResponse';
  feedbackQuestionCategory: FeedbackQuestionCategory;
};

export type RestoreFeedbackQuestionInput = {
  id: Scalars['ID']['input'];
};

export type RestoreFeedbackQuestionResponse = {
  __typename?: 'RestoreFeedbackQuestionResponse';
  feedbackQuestion: FeedbackQuestion;
};

export type RestoreFeedbackRequestInput = {
  /** This is the ID of the archived request that should be restored. */
  id: Scalars['ID']['input'];
};

export type RestoreFeedbackRequestResponse = {
  __typename?: 'RestoreFeedbackRequestResponse';
  /** This field contains the restored feedback request. */
  feedbackRequest: FeedbackRequest;
};

export type RestoreFeedbackResponseInput = {
  responseID: Scalars['ID']['input'];
};

export type RestoreFeedbackResponseResponse = {
  __typename?: 'RestoreFeedbackResponseResponse';
  feedbackResponse: FeedbackResponse;
};

export type RestoreFeedbackTemplateInput = {
  id: Scalars['ID']['input'];
};

export type RestoreFeedbackTemplateResponse = {
  __typename?: 'RestoreFeedbackTemplateResponse';
  feedbackTemplate: FeedbackTemplate;
};

export type RestoreGoalDriverInput = {
  id: Scalars['ID']['input'];
};

export type RestoreGoalDriverResponse = {
  __typename?: 'RestoreGoalDriverResponse';
  success: Scalars['Boolean']['output'];
};

export type RestoreGoalInput = {
  id: Scalars['ID']['input'];
};

export type RestoreGoalResponse = {
  __typename?: 'RestoreGoalResponse';
  goal: Goal;
};

export type RestoreGoalTemplateInput = {
  id: Scalars['ID']['input'];
};

export type RestoreGoalTemplateResponse = {
  __typename?: 'RestoreGoalTemplateResponse';
  goalTemplate: GoalTemplate;
};

export type RestoreGroupInput = {
  id: Scalars['ID']['input'];
};

export type RestoreGroupResponse = {
  __typename?: 'RestoreGroupResponse';
  group: Group;
};

export type RestoreInboxTaskInput = {
  id: Scalars['ID']['input'];
};

export type RestoreInboxTaskResponse = {
  __typename?: 'RestoreInboxTaskResponse';
  inboxTask: InboxTask;
};

export type RestoreJobLevelInput = {
  id: Scalars['ID']['input'];
};

export type RestoreJobLevelResponse = {
  __typename?: 'RestoreJobLevelResponse';
  jobLevel: JobLevel;
};

export type RestoreJobPositionInput = {
  id: Scalars['ID']['input'];
};

export type RestoreJobPositionResponse = {
  __typename?: 'RestoreJobPositionResponse';
  jobPosition: JobPosition;
};

export type RestoreJobTitleInput = {
  id: Scalars['ID']['input'];
};

export type RestoreJobTitleResponse = {
  __typename?: 'RestoreJobTitleResponse';
  jobTitle: JobTitle;
};

export type RestoreLabelInput = {
  id: Scalars['ID']['input'];
};

export type RestoreLabelResponse = {
  __typename?: 'RestoreLabelResponse';
  label: Label;
};

export type RestoreLearningEventInput = {
  id: Scalars['ID']['input'];
};

export type RestoreLearningEventResponse = {
  __typename?: 'RestoreLearningEventResponse';
  learningEvent: LearningEvent;
};

export type RestoreLearningSubjectInput = {
  id: Scalars['ID']['input'];
};

export type RestoreLearningSubjectResponse = {
  __typename?: 'RestoreLearningSubjectResponse';
  learningSubject: LearningSubject;
};

export type RestoreLearningTypeInput = {
  id: Scalars['ID']['input'];
};

export type RestoreLearningTypeResponse = {
  __typename?: 'RestoreLearningTypeResponse';
  learningType: LearningType;
};

export type RestoreMeetingInput = {
  target: MeetingTargetInput;
};

export type RestoreMeetingResponse = {
  __typename?: 'RestoreMeetingResponse';
  meeting: Meeting;
};

export type RestoreNoteInput = {
  noteID: Scalars['ID']['input'];
};

export type RestoreNoteResponse = {
  __typename?: 'RestoreNoteResponse';
  note: Note;
};

export type RestoreTalentReviewInput = {
  id: Scalars['ID']['input'];
};

export type RestoreTalentReviewResponse = {
  __typename?: 'RestoreTalentReviewResponse';
  talentReview: TalentReview;
};

export type RestoreTalentReviewTemplateInput = {
  id: Scalars['ID']['input'];
};

export type RestoreTalentReviewTemplateResponse = {
  __typename?: 'RestoreTalentReviewTemplateResponse';
  template: TalentReviewTemplate;
};

export type RestoreUserInput = {
  id: Scalars['ID']['input'];
};

export type RestoreUserResponse = {
  __typename?: 'RestoreUserResponse';
  user: User;
};

/**
 * A single reveal field: the Excel column name as label and its value. Numeric
 * and currency values are normalized to a plain number string (e.g. "3400.00").
 */
export type RevealField = {
  __typename?: 'RevealField';
  label: Scalars['String']['output'];
  type: RevealFieldType;
  value: Scalars['String']['output'];
};

/**
 * A data column detected in a reveal upload, with its detected type and a
 * non-empty example value found in the file.
 */
export type RevealFieldPreview = {
  __typename?: 'RevealFieldPreview';
  example?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  type: RevealFieldType;
};

/**
 * How a reveal column is interpreted, detected from the uploaded values. The
 * type determines how the value is normalized on save and formatted on display.
 */
export enum RevealFieldType {
  Currency = 'CURRENCY',
  Numeric = 'NUMERIC',
  Text = 'TEXT'
}

/**
 * The type of one column, as chosen by the user in the upload modal. This is
 * the type the values are normalized and stored with.
 */
export type RevealFieldTypeInput = {
  label: Scalars['String']['input'];
  type: RevealFieldType;
};

/** Summary returned after parsing / saving a reveal upload. */
export type RevealMatchSummary = {
  __typename?: 'RevealMatchSummary';
  /** Column names detected in the uploaded file (excluding the employee number and email columns). */
  detectedFields: Array<Scalars['String']['output']>;
  /** The values of one matched row, to preview how the data will be shown. */
  exampleValues: Array<RevealField>;
  /** Detected columns with their type and an example value. */
  fieldPreviews: Array<RevealFieldPreview>;
  /** The header of the column rows were matched on, so a loose employee-number-header match is visible to the admin. */
  matchColumn: Scalars['String']['output'];
  /** Number of rows matched to a Treams user within the workspace. */
  matchedCount: Scalars['Int']['output'];
  /** The Treams users that were matched to a row in the uploaded file. */
  matchedUsers: Array<RevealMatchedUser>;
  /** Number of data rows that could not be matched to a Treams user. */
  skippedCount: Scalars['Int']['output'];
  /** The employee number values of rows that could not be matched to a Treams user. */
  skippedKeys: Array<Scalars['String']['output']>;
};

/** A user matched to a row in a reveal upload, with the row's non-empty values. */
export type RevealMatchedUser = {
  __typename?: 'RevealMatchedUser';
  user: User;
  values: Array<RevealField>;
};

export type RevealUploadHeader = {
  __typename?: 'RevealUploadHeader';
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

/**
 * Summary of the current live upload of one conversation template, shown on the
 * template edit page. Null when the template has no uploaded data.
 */
export type RevealUploadInfo = {
  __typename?: 'RevealUploadInfo';
  /** Number of employees matched in the current live data. */
  matchedCount: Scalars['Int']['output'];
  /**
   * The users matched in the current live data, with the values that will be
   * revealed (only the admin-selected columns). Used to preview the uploaded
   * data on the template edit page.
   */
  matchedUsers: Array<RevealMatchedUser>;
  /** The columns an admin selected to be visible in the reveal. */
  selectedFields: Array<Scalars['String']['output']>;
  /** When the current live data was uploaded. */
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RevertTalentReviewSubmissionInput = {
  momentID: Scalars['ID']['input'];
};

export type RevertTalentReviewSubmissionResponse = {
  __typename?: 'RevertTalentReviewSubmissionResponse';
  momentInstance: MomentInstance;
};

export type ReviewLearningEventInput = {
  approved: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type ReviewLearningEventResponse = {
  __typename?: 'ReviewLearningEventResponse';
  learningEvent: LearningEvent;
};

export type RevokeFeatureApprovalInput = {
  featureID: FeatureName;
};

export type RevokeFeatureApprovalResponse = {
  __typename?: 'RevokeFeatureApprovalResponse';
  success: Scalars['Boolean']['output'];
};

export type RevokeRoleInput = {
  roleID: Scalars['ID']['input'];
  targetID: Scalars['ID']['input'];
  targetType: RoleTargetType;
  userID: Scalars['ID']['input'];
};

export type RevokeRoleResponse = {
  __typename?: 'RevokeRoleResponse';
  user: User;
};

export type RevokeSharedFeedbackInput = {
  requestID: Scalars['ID']['input'];
  sharedWithID: Scalars['ID']['input'];
};

export type RevokeSharedFeedbackResponse = {
  __typename?: 'RevokeSharedFeedbackResponse';
  success: Scalars['Boolean']['output'];
};

export type Role = {
  __typename?: 'Role';
  externalReferenceID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  targets: Array<RoleTargetType>;
  type: RoleType;
};

export type RoleTarget = {
  __typename?: 'RoleTarget';
  targetID: Scalars['ID']['output'];
  type: RoleTargetType;
};

export enum RoleTargetType {
  Department = 'DEPARTMENT',
  Region = 'REGION',
  Team = 'TEAM',
  User = 'USER',
  Workspace = 'WORKSPACE'
}

export type RoleTargetV2 = Group | User;

export enum RoleType {
  Administrator = 'ADMINISTRATOR',
  Buddy = 'BUDDY',
  Coach = 'COACH',
  CollaborativeManager = 'COLLABORATIVE_MANAGER',
  Collaborator = 'COLLABORATOR',
  EngagementOfficer = 'ENGAGEMENT_OFFICER',
  HrBusinessPartner = 'HR_BUSINESS_PARTNER',
  LearningOfficer = 'LEARNING_OFFICER',
  Manager = 'MANAGER',
  Member = 'MEMBER',
  Owner = 'OWNER',
  PrimaryManager = 'PRIMARY_MANAGER',
  SuperUser = 'SUPER_USER'
}

export type SearchKey = {
  __typename?: 'SearchKey';
  appID: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  token: Scalars['String']['output'];
};

export type SeedWorkspaceInput = {
  workspaceID: Scalars['ID']['input'];
};

export type SeedWorkspaceResponse = {
  __typename?: 'SeedWorkspaceResponse';
  success: Scalars['Boolean']['output'];
};

export type SendCycleMomentManagerRemindersInput = {
  cycleTemplateID: Scalars['ID']['input'];
  managers: Array<CycleManagerReminderManagerInput>;
  momentTemplateID: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SendCycleMomentManagerRemindersResponse = {
  __typename?: 'SendCycleMomentManagerRemindersResponse';
  success: Scalars['Boolean']['output'];
};

export type SendEngagementRequestRemindersInput = {
  id: Scalars['ID']['input'];
};

export type SendEngagementRequestRemindersResponse = {
  __typename?: 'SendEngagementRequestRemindersResponse';
  engagementRequest: EngagementRequest;
};

export type SendEngagementResponseReminderInput = {
  responseID: Scalars['ID']['input'];
};

export type SendEngagementTemplateInput = {
  id: Scalars['ID']['input'];
};

export type SendEngagementTemplateResponse = {
  __typename?: 'SendEngagementTemplateResponse';
  template: EngagementTemplate;
};

export type SendFeedbackReminderInput = {
  responseID: Scalars['ID']['input'];
};

export type SendFeedbackReminderResponse = {
  __typename?: 'SendFeedbackReminderResponse';
  feedbackResponse: FeedbackResponse;
};

export type SendMomentReminderInput = {
  id: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SendMomentReminderResponse = {
  __typename?: 'SendMomentReminderResponse';
  momentInstance: MomentInstance;
};

export type SendNotificationInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  recipient: SendNotificationRecipientInput;
  senderID?: InputMaybe<Scalars['ID']['input']>;
  type: Scalars['String']['input'];
};

export type SendNotificationRecipientInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type SendNotificationResponse = {
  __typename?: 'SendNotificationResponse';
  success: Scalars['Boolean']['output'];
};

/** Input type for `Mutation.sendSpontaneousFeedback`. */
export type SendSpontaneousFeedbackInput = {
  /**
   * These are the answers that are given to the questions in this spontaneous
   * feedback response.
   */
  answers: Array<FeedbackResponseAnswerInput>;
  /**
   * Contains a short instruction that is shown to the recipient of this
   * spontaneous feedback.
   */
  instruction: Scalars['QuillDelta']['input'];
  /**
   * These are questions that have been answered in this spontaneous feedback
   * request.
   */
  questions: Array<FeedbackRequestQuestionInput>;
  /** This is the recipient of the spontaneous feedback. */
  recipientID: Scalars['ID']['input'];
  /** Contains the title of this spontaneous feedback. */
  title: Scalars['String']['input'];
};

/** Response type for `Mutation.sendSpontaneousFeedback`. */
export type SendSpontaneousFeedbackResponse = {
  __typename?: 'SendSpontaneousFeedbackResponse';
  /**
   * Response object that has been created for this instance of spontaneous
   * feedback.
   */
  feedbackResponse: FeedbackResponse;
};

export type SendTemporaryPasswordInput = {
  userID: Scalars['ID']['input'];
};

export type SendTemporaryPasswordResponse = {
  __typename?: 'SendTemporaryPasswordResponse';
  delivery: CodeDelivery;
};

export type SentEmail = {
  __typename?: 'SentEmail';
  id: Scalars['ID']['output'];
  recipientEmail: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  sentAt: Scalars['DateTime']['output'];
  subject: Scalars['String']['output'];
};

export type SentEmailConnection = {
  __typename?: 'SentEmailConnection';
  edges: Array<SentEmailEdge>;
  pageInfo: PageInfo;
};

export type SentEmailEdge = {
  __typename?: 'SentEmailEdge';
  cursor: Scalars['ID']['output'];
  node: SentEmail;
};

export type ServiceProvider = {
  __typename?: 'ServiceProvider';
  acsURL: Scalars['String']['output'];
  entityID: Scalars['String']['output'];
  metadataURL: Scalars['String']['output'];
};

export type Session = {
  __typename?: 'Session';
  expiresAt: Scalars['DateTime']['output'];
  userID: Scalars['String']['output'];
  workspaceID: Scalars['String']['output'];
};

export type SessionSlot = {
  __typename?: 'SessionSlot';
  active: Scalars['Boolean']['output'];
  impersonated?: Maybe<Scalars['Boolean']['output']>;
  user: User;
  userID: Scalars['String']['output'];
};

export type SetCustomEmailDomainEnabledInput = {
  enabled: Scalars['Boolean']['input'];
  senderAddress?: InputMaybe<Scalars['String']['input']>;
  senderName?: InputMaybe<Scalars['String']['input']>;
};

export type SetGoodHabitzConfigInput = {
  /**
   * New GoodHabitz Content API key for this workspace. Omit or leave empty to keep the
   * existing key.
   */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** Whether the nightly GoodHabitz content sync is enabled for the workspace. */
  enabled: Scalars['Boolean']['input'];
  /**
   * Treams language IDs to sync content for. Empty or omitted means every language Treams
   * supports.
   */
  languageIDs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SetJobTitleKeyPositionInput = {
  id: Scalars['ID']['input'];
  isKeyPosition: Scalars['Boolean']['input'];
};

export type SetJobTitleKeyPositionResponse = {
  __typename?: 'SetJobTitleKeyPositionResponse';
  jobTitle: JobTitle;
};

export type SetPromptInstructionInput = {
  instructions: Scalars['String']['input'];
  promptInstructionID: Prompt;
  workspaceID: Scalars['String']['input'];
};

export type SetPromptInstructionResponse = {
  __typename?: 'SetPromptInstructionResponse';
  promptInstruction: PromptInstruction;
};

export type SetWorkspacePromptInstructionInput = {
  instructions: Scalars['String']['input'];
};

export type SetWorkspaceStyrConfigInput = {
  /**
   * Whether the nightly and on-demand sync are enabled. Forced to false when `organisationID`
   * is empty.
   */
  enabled: Scalars['Boolean']['input'];
  /**
   * Styr organisation GUID, or an empty string to clear the connector (which deletes the
   * config item and forces `enabled` to false on the server side).
   */
  organisationID: Scalars['String']['input'];
  /**
   * Human-readable label captured from the dropdown selection at save time so the
   * customer-facing page can show "Topic" instead of the opaque GUID. Empty when the
   * organisation is cleared.
   */
  organisationLabel: Scalars['String']['input'];
  workspaceID: Scalars['String']['input'];
};

export type SetWorkspaceStyrConfigResponse = {
  __typename?: 'SetWorkspaceStyrConfigResponse';
  workspace: Workspace;
};

export type SetupConnectorInput = {
  type: ConnectorType;
};

export type SetupConnectorResponse = {
  __typename?: 'SetupConnectorResponse';
  workspace: Workspace;
};

export type SetupConnectorTwoWayInput = {
  type: ConnectorType;
};

export type SetupConnectorTwoWayResponse = {
  __typename?: 'SetupConnectorTwoWayResponse';
  workspace: Workspace;
};

export type ShareFeedbackRequestInput = {
  requestID: Scalars['ID']['input'];
  sharedWithID: Scalars['ID']['input'];
};

export type ShareFeedbackRequestResponse = {
  __typename?: 'ShareFeedbackRequestResponse';
  sharedFeedback: SharedFeedback;
};

export type ShareNoteInput = {
  noteID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type ShareNoteResponse = {
  __typename?: 'ShareNoteResponse';
  note: Note;
};

export type ShareTalentReviewInput = {
  id: Scalars['ID']['input'];
};

export type ShareTalentReviewResponse = {
  __typename?: 'ShareTalentReviewResponse';
  talentReview: TalentReview;
};

export type SharedFeedback = {
  __typename?: 'SharedFeedback';
  createdAt: Scalars['DateTime']['output'];
  request: FeedbackRequest;
  sharedBy: User;
  sharedWith: User;
};

export type SharedFeedbackConnection = {
  __typename?: 'SharedFeedbackConnection';
  edges: Array<SharedFeedbackEdge>;
  pageInfo: PageInfo;
};

export type SharedFeedbackEdge = {
  __typename?: 'SharedFeedbackEdge';
  cursor: Scalars['ID']['output'];
  node: SharedFeedback;
};

export type SignEvaluationSubmissionInput = {
  id: Scalars['ID']['input'];
  party: EvaluationSubmissionParty;
};

export type SignEvaluationSubmissionResponse = {
  __typename?: 'SignEvaluationSubmissionResponse';
  evaluationSubmission: EvaluationSubmission;
};

export type SignOutSessionInput = {
  refreshToken: Scalars['String']['input'];
};

export type SignOutSessionResponse = {
  __typename?: 'SignOutSessionResponse';
  success: Scalars['Boolean']['output'];
};

export type SignedEmail = {
  __typename?: 'SignedEmail';
  email: Scalars['String']['output'];
  hmac: Scalars['String']['output'];
};

export type SingleSignOn = {
  __typename?: 'SingleSignOn';
  identityProvider: IdentityProvider;
  url: Scalars['String']['output'];
};

export type SingleSignOnChallenge = {
  __typename?: 'SingleSignOnChallenge';
  url: Scalars['String']['output'];
};

export type SkipMomentInstanceInput = {
  id: Scalars['ID']['input'];
  skipReason: MomentSkipReason;
  skipReasonOther?: InputMaybe<Scalars['String']['input']>;
};

export type SkipMomentInstanceResponse = {
  __typename?: 'SkipMomentInstanceResponse';
  momentInstance: MomentInstance;
};

export type SkipMomentTemplateInput = {
  cycleInstanceID: Scalars['ID']['input'];
  momentTemplateID: Scalars['ID']['input'];
  skipReason: MomentSkipReason;
  skipReasonOther?: InputMaybe<Scalars['String']['input']>;
};

export type SkipMomentTemplateResponse = {
  __typename?: 'SkipMomentTemplateResponse';
  cycleInstance: CycleInstance;
};

export type SlackConfig = {
  __typename?: 'SlackConfig';
  authorizeUrl?: Maybe<Scalars['String']['output']>;
  configuredScopes: Array<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isConfigured: Scalars['Boolean']['output'];
  team?: Maybe<SlackTeam>;
  wantedScopes: Array<Scalars['String']['output']>;
};

export type SlackConsumeOAuth2CodeInput = {
  code: Scalars['String']['input'];
};

export type SlackConsumeOAuth2CodeResponse = {
  __typename?: 'SlackConsumeOAuth2CodeResponse';
  config: SlackConfig;
};

export type SlackIdentity = {
  __typename?: 'SlackIdentity';
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
  username: Scalars['String']['output'];
};

export type SlackIdentityConnection = {
  __typename?: 'SlackIdentityConnection';
  edges: Array<SlackIdentityEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SlackIdentityEdge = {
  __typename?: 'SlackIdentityEdge';
  cursor: Scalars['ID']['output'];
  node: SlackIdentity;
};

export type SlackTeam = {
  __typename?: 'SlackTeam';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type StartAiGeneratedCompetenciesChatInput = {
  jobTitleID: Scalars['ID']['input'];
  levelSetID: Scalars['ID']['input'];
  locale: Scalars['String']['input'];
  reset: Scalars['Boolean']['input'];
};

export type StartAiGeneratedGoalChatInput = {
  locale: Scalars['String']['input'];
  reset: Scalars['Boolean']['input'];
};

export type StartStreamingTranscriptionInput = {
  language: TranscriptionLanguage;
  /**
   * Clears the transcript, summary, speakers, and follow-ups before the new
   * session starts.
   */
  restart?: InputMaybe<Scalars['Boolean']['input']>;
  targetID: Scalars['String']['input'];
  targetType: TranscriptionTargetType;
  /** The transcription already linked to the target, if any. It is reused. */
  transcriptionID?: InputMaybe<Scalars['String']['input']>;
};

export type StartStreamingTranscriptionResponse = {
  __typename?: 'StartStreamingTranscriptionResponse';
  keyterms: Array<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  /** One-time AssemblyAI streaming token for a single WebSocket session. */
  token: Scalars['String']['output'];
  transcriptLength: Scalars['Int']['output'];
  transcription: Transcription;
};

export type StoreConnectorLogInput = {
  errorType?: InputMaybe<ConnectorErrorType>;
  logLevel: ConnectorLogLevel;
  message: Scalars['String']['input'];
  metadata?: InputMaybe<ConnectorLogMetadataInput>;
  timestamp: Scalars['DateTime']['input'];
};

export type StoreConnectorLogResponse = {
  __typename?: 'StoreConnectorLogResponse';
  connectorLog: ConnectorLog;
};

export type StripeCustomerAddressInfo = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
};

/**
 * The Styr enrichment connector for a workspace. The organisation details and `lastSyncedAt` are
 * stored as a single `ConnectorConfig` item (`workspaceID/STYR`, key `styr`), while `enabled`
 * reflects the `isActive` flag on the Styr row in the `Connectors` table.
 */
export type StyrConfig = {
  __typename?: 'StyrConfig';
  enabled: Scalars['Boolean']['output'];
  /**
   * Treams language ids (e.g. `en_US`) whose Styr translations are written during sync. Empty
   * means every language Styr provides (the default). Languages outside the list are omitted
   * from the localized values, so the client-side language fallback shows the remaining ones.
   */
  languageIDs?: Maybe<Array<Scalars['String']['output']>>;
  /** ISO timestamp of the last successful Styr sync, or null when the connector has never synced. */
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  organisationID: Scalars['String']['output'];
  organisationLabel: Scalars['String']['output'];
};

/**
 * Styr-sourced data for a JobTitle. Present once the nightly Styr sync has matched it to a Styr
 * job. Groups all Styr attributes so new ones can be added in one place.
 */
export type StyrData = {
  __typename?: 'StyrData';
  /** Informational Styr Group key (e.g. "STAFF"). Not used by evaluations. */
  groupKey?: Maybe<Scalars['String']['output']>;
  /**
   * Styr `jobId` linking this JobTitle to a Styr job catalog entry. Used to keep the
   * description and competency links in sync with Styr on subsequent runs. Treams owns the
   * JobTitle name; the Styr name is stored on `jobName`.
   */
  jobID: Scalars['String']['output'];
  /**
   * Language-neutral Styr job title (e.g. "SW/HW engineer"). Informational; Treams `title`
   * is not overwritten from this value.
   */
  jobName?: Maybe<Scalars['String']['output']>;
  /** Informational Styr Level (1-12). Not used by evaluations. */
  level?: Maybe<Scalars['Int']['output']>;
};

export type StyrDataInput = {
  groupKey?: InputMaybe<Scalars['String']['input']>;
  jobID: Scalars['String']['input'];
  jobName?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A Styr job from the last sync snapshot, joined with the Treams JobTitles linked to it (via
 * `styrData.jobID`). `linkedJobTitles` is empty when the Styr job has not been mapped yet.
 */
export type StyrJobMapping = {
  __typename?: 'StyrJobMapping';
  jobFamilyName?: Maybe<Scalars['String']['output']>;
  linkedJobTitles: Array<JobTitle>;
  styrJobID: Scalars['ID']['output'];
  styrJobName: Scalars['String']['output'];
  styrLevel?: Maybe<Scalars['Int']['output']>;
};

/**
 * How an unlinked Styr job should be mapped: linked to an existing Treams JobTitle, or used to
 * create a brand-new one.
 */
export enum StyrJobMappingAction {
  CreateNew = 'CREATE_NEW',
  LinkExisting = 'LINK_EXISTING'
}

export type StyrJobMappingInput = {
  action: StyrJobMappingAction;
  /** Target Treams JobTitle id. Required for LINK_EXISTING; ignored for CREATE_NEW. */
  jobTitleID?: InputMaybe<Scalars['ID']['input']>;
  styrJobID: Scalars['ID']['input'];
};

/**
 * A Styr organisation as exposed by the launch panel dropdown so support can pick the right
 * `styrOrganisationID` for a workspace.
 */
export type StyrOrganisation = {
  __typename?: 'StyrOrganisation';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** How soon a nominated successor could take over the key position. */
export enum SuccessorReadiness {
  /** Long term, 3-5 years. */
  LongTerm = 'LONG_TERM',
  /** Not ready yet. */
  NotReady = 'NOT_READY',
  /** Ready within 0-6 months. */
  ReadyNow = 'READY_NOW'
}

export type SwitchSessionSlotInput = {
  userID: Scalars['String']['input'];
};

export type SwitchSessionSlotResponse = {
  __typename?: 'SwitchSessionSlotResponse';
  success: Scalars['Boolean']['output'];
};

export type SyncHubSpotCompaniesResult = {
  __typename?: 'SyncHubSpotCompaniesResult';
  processed: Scalars['Int']['output'];
};

export type TalentReview = {
  __typename?: 'TalentReview';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  group: Group;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  placements: Array<TalentReviewPlacement>;
  status: TalentReviewStatus;
  template: TalentReviewTemplate;
  title: Scalars['String']['output'];
  updatedBy: User;
  viewerCanUpdate: Scalars['Boolean']['output'];
  visibility: TalentReviewVisibility;
};

/**
 * A single row in the activity list below the grid. MOVED and SUBMITTED are
 * derived (placement writes, snapshots); the other types are event rows in
 * the same table.
 */
export type TalentReviewActivity = {
  __typename?: 'TalentReviewActivity';
  /** Question/answer pairs of a PLACEMENT_HELP activity. */
  answers?: Maybe<Array<TalentReviewPlacementHelpAnswer>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  /** Active HRIS integration when the actor is the system user. */
  integration?: Maybe<ConnectorType>;
  /**
   * Collapsed placement write of a MOVED activity, with `previous`
   * (position before) and `removed` (taken off the grid).
   */
  placement?: Maybe<TalentReviewGridPlacement>;
  /** The new rating of a RETENTION_RISK_CHANGED activity. Null when it was cleared. */
  retentionRisk?: Maybe<TalentReviewRetentionRisk>;
  /** Snapshot for SUBMITTED, REVERTED and CORRECTED. */
  snapshot?: Maybe<TalentReviewSnapshot>;
  /** The nominated person of a SUCCESSOR_ADDED or SUCCESSOR_REMOVED activity. */
  successor?: Maybe<User>;
  type: TalentReviewActivityType;
  /**
   * Affected user (MOVED, MEMBER_ADDED, MEMBER_REMOVED, PLACEMENT_HELP,
   * RETENTION_RISK_CHANGED, SUCCESSOR_ADDED, SUCCESSOR_REMOVED).
   */
  user?: Maybe<User>;
};

export enum TalentReviewActivityType {
  Cleared = 'CLEARED',
  /** HR correction after submitting; one row per correction batch. */
  Corrected = 'CORRECTED',
  MemberAdded = 'MEMBER_ADDED',
  MemberRemoved = 'MEMBER_REMOVED',
  /** Manual move, placement or removal (placement write). */
  Moved = 'MOVED',
  PlacementHelp = 'PLACEMENT_HELP',
  /** The retention risk of a person was set, changed or cleared. */
  RetentionRiskChanged = 'RETENTION_RISK_CHANGED',
  Reverted = 'REVERTED',
  Submitted = 'SUBMITTED',
  /** A successor was nominated for the key position of a person. */
  SuccessorAdded = 'SUCCESSOR_ADDED',
  /** A successor nomination for the key position of a person was withdrawn. */
  SuccessorRemoved = 'SUCCESSOR_REMOVED'
}

export type TalentReviewConnection = {
  __typename?: 'TalentReviewConnection';
  edges: Array<TalentReviewEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TalentReviewEdge = {
  __typename?: 'TalentReviewEdge';
  cursor: Scalars['ID']['output'];
  node: TalentReview;
};

export type TalentReviewGrid = {
  __typename?: 'TalentReviewGrid';
  /** Activity list of this grid (template + group), latest first. */
  activity: Array<TalentReviewActivity>;
  group: Group;
  /**
   * Placement history of a single user within this template, latest first.
   * The table is append-only, but only effective changes show up here:
   * same-day corrections collapse into the last write of that day and
   * unchanged positions are hidden.
   */
  history: Array<TalentReviewGridPlacement>;
  localDate: Scalars['LocalDate']['output'];
  placements: Array<TalentReviewGridPlacement>;
  template: TalentReviewTemplate;
  viewerCanUpdate: Scalars['Boolean']['output'];
};


export type TalentReviewGridHistoryArgs = {
  userID: Scalars['ID']['input'];
};

export type TalentReviewGridPlacement = {
  __typename?: 'TalentReviewGridPlacement';
  column: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  /** Grid day this write applied to (may differ from createdAt). */
  localDate: Scalars['LocalDate']['output'];
  motivation?: Maybe<Scalars['String']['output']>;
  /**
   * Order within the cell (ascending). Null on older writes: sort by
   * createdAt in milliseconds instead, the same scale.
   */
  position?: Maybe<Scalars['Float']['output']>;
  /**
   * Position before the change on this grid day: the final write of the
   * last earlier day. Null when nothing changed on the viewed day or the
   * user was not on the grid before.
   */
  previous?: Maybe<TalentReviewGridPlacement>;
  /** Tombstone: user was removed from the grid at this point. */
  removed?: Maybe<Scalars['Boolean']['output']>;
  /** Optional. Always visible in the sidebar, not required. */
  retentionRisk?: Maybe<TalentReviewRetentionRisk>;
  row: Scalars['Int']['output'];
  score?: Maybe<TalentReviewPlacementScore>;
  user: User;
};

export type TalentReviewLatestActivity = {
  __typename?: 'TalentReviewLatestActivity';
  template: TalentReviewTemplate;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: User;
};

export type TalentReviewPlacement = {
  __typename?: 'TalentReviewPlacement';
  column: Scalars['Int']['output'];
  motivation?: Maybe<Scalars['String']['output']>;
  row: Scalars['Int']['output'];
  score?: Maybe<TalentReviewPlacementScore>;
  user: User;
};

export type TalentReviewPlacementHelpAnswer = {
  __typename?: 'TalentReviewPlacementHelpAnswer';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type TalentReviewPlacementHelpAnswerInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export enum TalentReviewPlacementHelpAxis {
  X = 'X',
  Y = 'Y'
}

export type TalentReviewPlacementHelpOption = {
  __typename?: 'TalentReviewPlacementHelpOption';
  id: Scalars['ID']['output'];
  label: Scalars['LocalizedString']['output'];
  tickIndex?: Maybe<Scalars['Int']['output']>;
};

export type TalentReviewPlacementHelpOptionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['LocalizedString']['input'];
  tickIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentReviewPlacementHelpQuestion = {
  __typename?: 'TalentReviewPlacementHelpQuestion';
  answers: Array<TalentReviewPlacementHelpOption>;
  axis: TalentReviewPlacementHelpAxis;
  id: Scalars['ID']['output'];
  question: Scalars['LocalizedString']['output'];
};

export type TalentReviewPlacementHelpQuestionInput = {
  answers: Array<TalentReviewPlacementHelpOptionInput>;
  axis: TalentReviewPlacementHelpAxis;
  id?: InputMaybe<Scalars['ID']['input']>;
  question: Scalars['LocalizedString']['input'];
};

export type TalentReviewPlacementInput = {
  column: Scalars['Int']['input'];
  motivation?: InputMaybe<Scalars['String']['input']>;
  row: Scalars['Int']['input'];
  score?: InputMaybe<TalentReviewPlacementScore>;
  userID: Scalars['ID']['input'];
};

export enum TalentReviewPlacementScore {
  CannotBeReviewed = 'CANNOT_BE_REVIEWED',
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Insufficient = 'INSUFFICIENT',
  RoomForImprovement = 'ROOM_FOR_IMPROVEMENT'
}

/** Optional retention risk for an employee in a talent review. */
export enum TalentReviewRetentionRisk {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type TalentReviewSnapshot = {
  __typename?: 'TalentReviewSnapshot';
  /**
   * Activities up to and including the moment of submitting, plus the
   * corrections and revert of this snapshot itself. Latest first. Filtered
   * like `placements`.
   */
  activity: Array<TalentReviewActivity>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<User>;
  /**
   * Corrections on this snapshot, latest first. Tombstones have `removed`.
   * Filtered like `placements`.
   */
  corrections: Array<TalentReviewGridPlacement>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  /** Cycle moment completed with this snapshot, if any. */
  cycleMoment?: Maybe<MomentInstance>;
  description?: Maybe<Scalars['String']['output']>;
  group: Group;
  id: Scalars['ID']['output'];
  localDate: Scalars['LocalDate']['output'];
  /**
   * Placements reconstructed as of localDate for this group. No nested
   * data in Dynamo (v1 mistake); purely a resolver over the placement
   * history. The email page filters by `visibility` for everyone.
   * `manage: true` returns the full grid when the viewer can manage the group.
   */
  placements: Array<TalentReviewGridPlacement>;
  /** When this snapshot was last shared with placed users. */
  sharedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Person who last shared this snapshot with placed users. Absent when the
   * snapshot was never shared with them (managers only, or the snapshot page
   * is not available).
   */
  sharedBy?: Maybe<User>;
  status: TalentReviewSnapshotStatus;
  template: TalentReviewTemplate;
  title: Scalars['String']['output'];
  /** Whether the viewer (HR) may correct this active snapshot. */
  viewerCanCorrect: Scalars['Boolean']['output'];
  /**
   * Whether this viewer may manage the snapshot's group. Includes management
   * inherited from a parent group, which the member list does not show.
   */
  viewerCanManage: Scalars['Boolean']['output'];
  /** Whether the viewer has a position on this snapshot's grid. */
  viewerIsPlaced: Scalars['Boolean']['output'];
  /**
   * Visibility frozen from the template at create. The email page follows
   * this for everyone. A manager opening the submitted grid passes
   * `manage: true` and then sees every placement.
   */
  visibility: TalentReviewVisibility;
};


export type TalentReviewSnapshotActivityArgs = {
  manage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TalentReviewSnapshotCorrectionsArgs = {
  manage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TalentReviewSnapshotPlacementsArgs = {
  manage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TalentReviewSnapshotConnection = {
  __typename?: 'TalentReviewSnapshotConnection';
  edges: Array<TalentReviewSnapshotEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TalentReviewSnapshotEdge = {
  __typename?: 'TalentReviewSnapshotEdge';
  cursor: Scalars['ID']['output'];
  node: TalentReviewSnapshot;
};

export enum TalentReviewSnapshotStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum TalentReviewStatus {
  Draft = 'DRAFT',
  Shared = 'SHARED'
}

export type TalentReviewTemplate = {
  __typename?: 'TalentReviewTemplate';
  cells: Array<Array<TalentReviewTemplateCell>>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['LocalizedAttributedString']['output'];
  hasNorm: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  outdatedAfterDays: Scalars['Int']['output'];
  placementHelpQuestions: Array<TalentReviewPlacementHelpQuestion>;
  title: Scalars['LocalizedString']['output'];
  visibility: TalentReviewVisibility;
  xAxis: TalentReviewTemplateAxis;
  yAxis: TalentReviewTemplateAxis;
};

export type TalentReviewTemplateAxis = {
  __typename?: 'TalentReviewTemplateAxis';
  label: Scalars['LocalizedString']['output'];
  ticks: Array<Scalars['LocalizedString']['output']>;
};

export type TalentReviewTemplateAxisInput = {
  label: Scalars['LocalizedString']['input'];
  ticks: Array<Scalars['LocalizedString']['input']>;
};

export type TalentReviewTemplateCell = {
  __typename?: 'TalentReviewTemplateCell';
  color: Scalars['Int']['output'];
  instruction: Scalars['LocalizedString']['output'];
  label: Scalars['LocalizedString']['output'];
  norm: Scalars['Int']['output'];
};

export type TalentReviewTemplateCellInput = {
  color: Scalars['Int']['input'];
  instruction: Scalars['LocalizedString']['input'];
  label: Scalars['LocalizedString']['input'];
  norm?: InputMaybe<Scalars['Int']['input']>;
};

export type TalentReviewTemplateConnection = {
  __typename?: 'TalentReviewTemplateConnection';
  edges: Array<TalentReviewTemplateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TalentReviewTemplateEdge = {
  __typename?: 'TalentReviewTemplateEdge';
  cursor: Scalars['ID']['output'];
  node: TalentReviewTemplate;
};

export enum TalentReviewVisibility {
  Manager = 'MANAGER',
  Members = 'MEMBERS',
  Self = 'SELF'
}

export type Task = {
  __typename?: 'Task';
  createdAt: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  order: Scalars['Float']['output'];
  owner: User;
  status: TaskStatus;
  subject?: Maybe<TaskSubject>;
  subjectType: TaskSubjectType;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum TaskStatus {
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  Todo = 'TODO'
}

export type TaskSubject = Group | Note | User;

export enum TaskSubjectType {
  Group = 'GROUP',
  Note = 'NOTE',
  User = 'USER'
}

export type TeardownConnectorResponse = {
  __typename?: 'TeardownConnectorResponse';
  workspace: Workspace;
};

export type TemporarySessionToken = {
  __typename?: 'TemporarySessionToken';
  expiresAt: Scalars['DateTime']['output'];
  tokenID: Scalars['ID']['output'];
  userID: Scalars['ID']['output'];
  workspaceID: Scalars['ID']['output'];
};

export type TemporarySessionTokenInput = {
  userID: Scalars['ID']['input'];
};

export type Timezone = {
  __typename?: 'Timezone';
  id: Scalars['ID']['output'];
};

export type TotpMfaChallenge = {
  __typename?: 'TotpMfaChallenge';
  username: Scalars['String']['output'];
};

export type TotpMfaChallengeResponse = {
  totp: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type Transcription = {
  __typename?: 'Transcription';
  audioUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  editableSummary?: Maybe<Scalars['QuillDelta']['output']>;
  followups?: Maybe<TranscriptionFollowups>;
  id: Scalars['String']['output'];
  language?: Maybe<TranscriptionLanguage>;
  speakers?: Maybe<Array<TranscriptionSpeaker>>;
  status: TranscriptionStatus;
  summary?: Maybe<Scalars['String']['output']>;
  target: TranscriptionTarget;
  targetID: Scalars['String']['output'];
  targetType: TranscriptionTargetType;
  transcript?: Maybe<Scalars['String']['output']>;
  uploadStatus: TranscriptionUploadStatus;
};

export type TranscriptionFollowupFeedbackRequestSuggestion = {
  __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion';
  actedUpon: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  instruction?: Maybe<Scalars['QuillDelta']['output']>;
  template?: Maybe<FeedbackTemplate>;
  title: Scalars['String']['output'];
};

export type TranscriptionFollowupGoalSuggestion = {
  __typename?: 'TranscriptionFollowupGoalSuggestion';
  /**
   * Indicates some action has been taken on the suggestion.
   * We cannot always know for sure if an action was completed,
   * but this field can be used to indicate that the suggestion has been acted upon.
   */
  actedUpon: Scalars['Boolean']['output'];
  description: Scalars['QuillDelta']['output'];
  id: Scalars['String']['output'];
  subgoals?: Maybe<Array<Scalars['String']['output']>>;
  targetUser: User;
  title: Scalars['String']['output'];
};

export type TranscriptionFollowups = {
  __typename?: 'TranscriptionFollowups';
  feedbackRequestSuggestions: Array<TranscriptionFollowupFeedbackRequestSuggestion>;
  goalSuggestions: Array<TranscriptionFollowupGoalSuggestion>;
};

export enum TranscriptionLanguage {
  Da = 'da',
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  It = 'it',
  Nl = 'nl',
  Pl = 'pl',
  Pt = 'pt',
  Sv = 'sv'
}

export type TranscriptionSpeaker = {
  __typename?: 'TranscriptionSpeaker';
  /**
   * Index of the transcript part (separated by <BREAK> lines) this prediction
   * applies to. Null means the whole transcript.
   */
  segmentIndex?: Maybe<Scalars['Int']['output']>;
  speakerNumber: Scalars['Int']['output'];
  user: User;
};

export enum TranscriptionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  SummaryFailed = 'SUMMARY_FAILED'
}

export type TranscriptionTarget = EvaluationSubmission | Note;

export enum TranscriptionTargetType {
  EvaluationSubmission = 'EVALUATION_SUBMISSION',
  Note = 'NOTE'
}

export type TranscriptionUploadHeader = {
  __typename?: 'TranscriptionUploadHeader';
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export enum TranscriptionUploadStatus {
  Failed = 'FAILED',
  Uploaded = 'UPLOADED',
  UploadPending = 'UPLOAD_PENDING'
}

export type UncompleteConversationInput = {
  id: Scalars['ID']['input'];
};

export type UncompleteConversationResponse = {
  __typename?: 'UncompleteConversationResponse';
  evaluationSubmission: EvaluationSubmission;
};

export type UnlinkSlackIdentityInput = {
  slackID?: InputMaybe<Scalars['ID']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

export type UnlinkSlackIdentityResponse = {
  __typename?: 'UnlinkSlackIdentityResponse';
  user: User;
};

export type UnlinkStripeResponse = {
  __typename?: 'UnlinkStripeResponse';
  success: Scalars['Boolean']['output'];
};

export type UnlinkTranscriptionFromEvaluationSubmissionInput = {
  evaluationSubmissionID: Scalars['ID']['input'];
  transcriptionID: Scalars['ID']['input'];
};

export type UnlinkTranscriptionFromEvaluationSubmissionResponse = {
  __typename?: 'UnlinkTranscriptionFromEvaluationSubmissionResponse';
  success: Scalars['Boolean']['output'];
};

export type UnlinkTranscriptionFromNoteInput = {
  noteID: Scalars['ID']['input'];
  /** When set, must match the note’s current linked transcription (stale client guard). */
  transcriptionID?: InputMaybe<Scalars['ID']['input']>;
};

export type UnlinkTranscriptionFromNoteResponse = {
  __typename?: 'UnlinkTranscriptionFromNoteResponse';
  success: Scalars['Boolean']['output'];
};

export type UnshareNoteInput = {
  noteID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type UnshareNoteResponse = {
  __typename?: 'UnshareNoteResponse';
  note: Note;
};

export type UnshareTalentReviewInput = {
  id: Scalars['ID']['input'];
};

export type UnshareTalentReviewResponse = {
  __typename?: 'UnshareTalentReviewResponse';
  talentReview: TalentReview;
};

export type UnsignEvaluationSubmissionInput = {
  id: Scalars['ID']['input'];
  party: EvaluationSubmissionParty;
};

export type UnsignEvaluationSubmissionResponse = {
  __typename?: 'UnsignEvaluationSubmissionResponse';
  evaluationSubmission: EvaluationSubmission;
};

export type UpdateAnnouncementInput = {
  announcementID: Scalars['ID']['input'];
  content?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  displayType?: InputMaybe<AnnouncementDisplayType>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<AnnouncementFiltersInput>;
  headerImageAssetID?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['LocalizedString']['input']>;
};

export type UpdateAnnouncementResponse = {
  __typename?: 'UpdateAnnouncementResponse';
  announcement: Announcement;
};

export type UpdateCommentInput = {
  content: Scalars['QuillDelta']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateCommentResponse = {
  __typename?: 'UpdateCommentResponse';
  comment: Comment;
};

export type UpdateCompetencyBookmarkInput = {
  /** ID of the competency to update. */
  competencyID: Scalars['ID']['input'];
  /** Index of the competency level that the bookmark's user wants to attain. */
  competencyLevelIndex: Scalars['Int']['input'];
  /** ID of the user that this competency belongs to. */
  userID: Scalars['ID']['input'];
};

export type UpdateCompetencyBookmarkResponse = {
  __typename?: 'UpdateCompetencyBookmarkResponse';
  /** Contains the updated competency bookmark. */
  competencyBookmark: CompetencyBookmark;
};

export type UpdateCompetencyInput = {
  attachableToGoal?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  id: Scalars['ID']['input'];
  jobTitleIDs: Array<Scalars['ID']['input']>;
  labelID?: InputMaybe<Scalars['ID']['input']>;
  levels: Array<CompetencyLevelOptionInput>;
  title: Scalars['LocalizedString']['input'];
};

export type UpdateCompetencyLevelInput = {
  id: Scalars['ID']['input'];
  title: Scalars['LocalizedString']['input'];
};

export type UpdateCompetencyLevelSetInput = {
  id: Scalars['ID']['input'];
  levels: Array<UpdateCompetencyLevelInput>;
  title: Scalars['LocalizedString']['input'];
};

export type UpdateCompetencyLevelSetResponse = {
  __typename?: 'UpdateCompetencyLevelSetResponse';
  competencyLevelSet: CompetencyLevelSet;
};

export type UpdateCompetencyResponse = {
  __typename?: 'UpdateCompetencyResponse';
  competency: Competency;
};

export type UpdateConnectorConfigFieldInput = {
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  connectorType: ConnectorType;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  key: Scalars['String']['input'];
  rules?: InputMaybe<Array<ConnectorFilterRuleInput>>;
  selectValue?: InputMaybe<Scalars['String']['input']>;
  selectValues?: InputMaybe<Array<Scalars['String']['input']>>;
  textValue?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConnectorConfigFieldResponse = {
  __typename?: 'UpdateConnectorConfigFieldResponse';
  workspace: Workspace;
};

export type UpdateConnectorInput = {
  isActive: Scalars['Boolean']['input'];
};

export type UpdateConnectorResponse = {
  __typename?: 'UpdateConnectorResponse';
  workspace: Workspace;
};

export type UpdateConnectorTaskInput = {
  errorReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  status: ConnectorTaskStatus;
};

export type UpdateConnectorTaskResponse = {
  __typename?: 'UpdateConnectorTaskResponse';
  task: ConnectorTask;
};

export type UpdateConnectorUploadInput = {
  errorReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  status: ConnectorUploadStatus;
};

export type UpdateConnectorUploadResponse = {
  __typename?: 'UpdateConnectorUploadResponse';
  upload: ConnectorUpload;
};

export type UpdateCustomEmailDomainInput = {
  domain: Scalars['String']['input'];
};

export type UpdateCustomEmailDomainResponse = {
  __typename?: 'UpdateCustomEmailDomainResponse';
  workspace: Workspace;
};

export type UpdateCycleInstanceInput = {
  activatesAt: Scalars['DateTime']['input'];
  deactivatesAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateCycleInstanceResponse = {
  __typename?: 'UpdateCycleInstanceResponse';
  cycleInstance: CycleInstance;
};

export type UpdateCycleTemplateInput = {
  /**
   * Indicates whether this cycle template should be assigned automatically to
   * all new employees.
   */
  automatic?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  duration: Scalars['Int']['input'];
  /** If present, indicates that this cycle template should only be automatically applied to either external or internal users. */
  employmentType?: InputMaybe<EmploymentType>;
  /**
   * If present, indicates that this cycle template should not be automatically
   * applied to the groups with the given IDs.
   */
  excludedGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * If present, indicates that this cycle template should not be automatically
   * applied to the job titles with the given IDs.
   */
  excludedJobTitleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * If present, indicates that this cycle template should only be automatically
   * applied to the groups with the given IDs.
   */
  groupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  /**
   * If present, indicates whether this cycle template should be wrapped to the
   * first day of a particular interval. For example, this field can make sure
   * that this cycle always starts at the first day of the year.
   */
  interval?: InputMaybe<CycleTemplateInterval>;
  /**
   * If present, indicates that this cycle template should only be automatically
   * applied to the job titles with the given IDs.
   */
  jobTitleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  moments: Array<MomentTemplateInput>;
  /** @deprecated Use `successorID` instead. */
  repeats?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Contains the ID of a cycle template that will replace this template after
   * the cycle finishes. Leave out if this cycle should not repeat.
   */
  successorID?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['LocalizedString']['input'];
};

export type UpdateCycleTemplateResponse = {
  __typename?: 'UpdateCycleTemplateResponse';
  cycleTemplate: CycleTemplate;
};

export type UpdateEngagementAnswerInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  questionID: Scalars['ID']['input'];
  responseID: Scalars['ID']['input'];
  secret?: InputMaybe<Scalars['String']['input']>;
  skipped: Scalars['Boolean']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEngagementAnswerResponse = {
  __typename?: 'UpdateEngagementAnswerResponse';
  engagementResponse: EngagementResponse;
};

export type UpdateEngagementCategoryInput = {
  id: Scalars['ID']['input'];
  title: Scalars['LocalizedString']['input'];
};

export type UpdateEngagementCategoryResponse = {
  __typename?: 'UpdateEngagementCategoryResponse';
  category: EngagementCategory;
};

export type UpdateEngagementQuestionInput = {
  id: Scalars['ID']['input'];
  title: Scalars['LocalizedString']['input'];
};

export type UpdateEngagementQuestionResponse = {
  __typename?: 'UpdateEngagementQuestionResponse';
  question: EngagementQuestion;
};

export type UpdateEngagementSettingsInput = {
  enpsType: EngagementEnpsType;
};

export type UpdateEngagementSettingsResponse = {
  __typename?: 'UpdateEngagementSettingsResponse';
  workspace: Workspace;
};

export type UpdateEngagementSubcategoryInput = {
  description?: InputMaybe<Scalars['LocalizedString']['input']>;
  id: Scalars['ID']['input'];
  title: Scalars['LocalizedString']['input'];
};

export type UpdateEngagementSubcategoryResponse = {
  __typename?: 'UpdateEngagementSubcategoryResponse';
  subcategory: EngagementSubcategory;
};

export type UpdateEngagementTemplateInput = {
  anonymityThreshold?: InputMaybe<Scalars['Int']['input']>;
  categoryIDs: Array<Scalars['ID']['input']>;
  endPage?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  expiryInDays?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  instruction?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  interval: EngagementInterval;
  maxOpenQuestions?: InputMaybe<Scalars['Int']['input']>;
  maxQuestions?: InputMaybe<Scalars['Int']['input']>;
  reminderDaysInAdvance?: InputMaybe<Scalars['Int']['input']>;
  targetGroupIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['LocalizedString']['input'];
  useAllQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  useNps?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEngagementTemplateResponse = {
  __typename?: 'UpdateEngagementTemplateResponse';
  template: EngagementTemplate;
};

export type UpdateEvaluationFormInput = {
  description?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  id: Scalars['ID']['input'];
  jobTitleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  sections: Array<UpdateEvaluationFormSectionInput>;
  showAnswersWhenAllUsersShared?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['LocalizedString']['input'];
  useOnlyInCycle?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEvaluationFormResponse = {
  __typename?: 'UpdateEvaluationFormResponse';
  evaluationForm: EvaluationForm;
};

export type UpdateEvaluationFormSectionInput = {
  items: Array<UpdateEvaluationSectionItemInput>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateEvaluationSectionItemInput = {
  competency?: InputMaybe<EvaluationCompetencyItemInput>;
  developmentPlan?: InputMaybe<EvaluationDevelopmentPlanItemInput>;
  fillInBy: EvaluationFillInBy;
  finalScore?: InputMaybe<EvaluationFinalScoreItemInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  multipleChoice?: InputMaybe<EvaluationMultipleChoiceItemInput>;
  openQuestion?: InputMaybe<EvaluationOpenQuestionItemInput>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  paragraph?: InputMaybe<EvaluationParagraphItemInput>;
  reviewGoals?: InputMaybe<EvaluationReviewGoalsItemInput>;
  sentiment?: InputMaybe<EvaluationSentimentItemInput>;
  setGoals?: InputMaybe<EvaluationSetGoalsItemInput>;
  signature?: InputMaybe<EvaluationSignatureItemInput>;
  stars?: InputMaybe<EvaluationStarsItemInput>;
  title?: InputMaybe<EvaluationTitleItemInput>;
  type: EvaluationSectionItemType;
};

export type UpdateEvaluationSubmissionInput = {
  id: Scalars['ID']['input'];
  sections: Array<EvaluationSubmissionSectionInput>;
  signed: Scalars['Boolean']['input'];
};

/**
 * Input object that is provided to the `updateEvaluationSubmissionMeetingStatus`
 * mutation.
 */
export type UpdateEvaluationSubmissionMeetingStatusInput = {
  /**
   * This is the ID of the conversation for which either party wants to update
   * their own status. Note that it's not possible to update this status on
   * someone else's behalf. The mutation will return an error if the
   * authenticated user isn't participating in this conversation.
   */
  id: Scalars['ID']['input'];
  /** This is the new status of the currently authenticated user. */
  status: EvaluationSubmissionMeetingStatus;
};

/**
 * Object that is returned by the `updateEvaluationSubmissionMeetingStatus`
 * mutation.
 */
export type UpdateEvaluationSubmissionMeetingStatusResponse = {
  __typename?: 'UpdateEvaluationSubmissionMeetingStatusResponse';
  /**
   * Updated conversation after changing the meeting status of the currently
   * authenticated user.
   */
  evaluationSubmission: EvaluationSubmission;
};

export type UpdateEvaluationSubmissionResponse = {
  __typename?: 'UpdateEvaluationSubmissionResponse';
  evaluationSubmission: EvaluationSubmission;
};

export type UpdateExcludeAnalyticsInput = {
  exclude: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateExcludeAnalyticsResponse = {
  __typename?: 'UpdateExcludeAnalyticsResponse';
  user: User;
};

export type UpdateExternalFeedbackInput = {
  answers: Array<FeedbackResponseAnswerInput>;
  responseID: Scalars['ID']['input'];
  secret: Scalars['String']['input'];
  status: FeedbackResponseStatus;
};

export type UpdateExternalFeedbackResponse = {
  __typename?: 'UpdateExternalFeedbackResponse';
  feedbackResponse: FeedbackResponse;
};

/** Input for updating an existing feature rating */
export type UpdateFeatureRatingInput = {
  binaryValue?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Response from updating a feature rating */
export type UpdateFeatureRatingResponse = {
  __typename?: 'UpdateFeatureRatingResponse';
  featureRating: FeatureRating;
};

export type UpdateFeedbackQuestionCategoryInput = {
  id: Scalars['ID']['input'];
  name: Scalars['LocalizedString']['input'];
};

export type UpdateFeedbackQuestionCategoryResponse = {
  __typename?: 'UpdateFeedbackQuestionCategoryResponse';
  feedbackQuestionCategory: FeedbackQuestionCategory;
};

export type UpdateFeedbackQuestionInput = {
  additionalDetails?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  /** @deprecated Use reorderFeedbackQuestion instead. */
  categoryID?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  options?: InputMaybe<Array<FeedbackQuestionOptionInput>>;
  subTitle?: InputMaybe<Scalars['LocalizedString']['input']>;
  text: Scalars['LocalizedString']['input'];
  type: FeedbackQuestionType;
};

export type UpdateFeedbackQuestionResponse = {
  __typename?: 'UpdateFeedbackQuestionResponse';
  feedbackQuestion: FeedbackQuestion;
};

export type UpdateFeedbackTemplateInput = {
  description: Scalars['LocalizedAttributedString']['input'];
  id: Scalars['ID']['input'];
  instruction?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  /** @deprecated Use `roles = [CYCLES]` instead. */
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  questions: Array<FeedbackTemplateQuestionInput>;
  roles?: InputMaybe<Array<FeedbackTemplateRole>>;
  title: Scalars['LocalizedString']['input'];
};

export type UpdateFeedbackTemplateResponse = {
  __typename?: 'UpdateFeedbackTemplateResponse';
  feedbackTemplate: FeedbackTemplate;
};

export type UpdateGoalChecklistItemInput = {
  description: Scalars['LocalizedAttributedString']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  learningCourseID?: InputMaybe<Scalars['ID']['input']>;
  progress: GoalChecklistItemProgressInput;
  title: Scalars['LocalizedString']['input'];
};

export type UpdateGoalDriverInput = {
  id: Scalars['ID']['input'];
  title: Scalars['LocalizedString']['input'];
};

export type UpdateGoalDriverResponse = {
  __typename?: 'UpdateGoalDriverResponse';
  goalDriver: GoalDriver;
};

export type UpdateGoalInput = {
  checklistItems?: InputMaybe<Array<UpdateGoalChecklistItemInput>>;
  competency?: InputMaybe<CompetencyGoalInput>;
  description: Scalars['QuillDelta']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  feasibility?: InputMaybe<GoalFeasibility>;
  id: Scalars['ID']['input'];
  labelID?: InputMaybe<Scalars['ID']['input']>;
  linkedGoalDriverIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  linkedGoalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  progressOverride?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['LocalizedString']['input'];
  /**
   * Contains the visibility setting for this goal. Reflects whether the goal
   * should be visible to colleagues. For backwards compatibility, `PUBLIC` is
   * the default value if this field is not present.
   */
  visibility?: InputMaybe<GoalVisibility>;
};

export type UpdateGoalResponse = {
  __typename?: 'UpdateGoalResponse';
  goal: Goal;
};

export type UpdateGoalTemplateInput = {
  competency?: InputMaybe<CompetencyGoalInput>;
  description: Scalars['LocalizedAttributedString']['input'];
  id: Scalars['ID']['input'];
  jobTitleIDs: Array<Scalars['ID']['input']>;
  labelID?: InputMaybe<Scalars['ID']['input']>;
  relativeDueDate?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['LocalizedString']['input'];
};

export type UpdateGoalTemplateResponse = {
  __typename?: 'UpdateGoalTemplateResponse';
  goalTemplate: GoalTemplate;
};

export type UpdateGroupInput = {
  externalReferenceID?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateGroupResponse = {
  __typename?: 'UpdateGroupResponse';
  group: Group;
};

export type UpdateIdentityProviderConfigurationInput = {
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  identityProviderID: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIdentityProviderConfigurationResponse = {
  __typename?: 'UpdateIdentityProviderConfigurationResponse';
  provider: IdentityProvider;
};

export type UpdateIdentityProviderInput = {
  identityProviderID: Scalars['ID']['input'];
  metadataFile?: InputMaybe<Scalars['String']['input']>;
  metadataURL?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIdentityProviderResponse = {
  __typename?: 'UpdateIdentityProviderResponse';
  provider: IdentityProvider;
};

export type UpdateInternalFeedbackInput = {
  answers: Array<FeedbackResponseAnswerInput>;
  responseID: Scalars['ID']['input'];
  status: FeedbackResponseStatus;
};

export type UpdateInternalFeedbackResponse = {
  __typename?: 'UpdateInternalFeedbackResponse';
  feedbackResponse: FeedbackResponse;
};

export type UpdateInvoiceUserCountInput = {
  stripeCustomerID: Scalars['String']['input'];
  workspaceID: Scalars['ID']['input'];
};

export type UpdateInvoiceUserCountResponse = {
  __typename?: 'UpdateInvoiceUserCountResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateJobGoalTemplateInput = {
  competency?: InputMaybe<CompetencyGoalInput>;
  description: Scalars['LocalizedAttributedString']['input'];
  goalTemplateID: Scalars['ID']['input'];
  jobLevelID?: InputMaybe<Scalars['ID']['input']>;
  jobTitleID: Scalars['ID']['input'];
  relativeDueDate?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['LocalizedString']['input'];
};

export type UpdateJobGoalTemplateResponse = {
  __typename?: 'UpdateJobGoalTemplateResponse';
  jobTitle: JobTitle;
};

export type UpdateJobLevelInput = {
  description?: InputMaybe<Scalars['LocalizedString']['input']>;
  externalReferenceID?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  title: Scalars['LocalizedString']['input'];
};

export type UpdateJobLevelResponse = {
  __typename?: 'UpdateJobLevelResponse';
  jobLevel: JobLevel;
};

export type UpdateJobPositionInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  externalReferenceID?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  jobLevelID?: InputMaybe<Scalars['ID']['input']>;
  jobTitleID: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  userID: Scalars['ID']['input'];
};

export type UpdateJobPositionResponse = {
  __typename?: 'UpdateJobPositionResponse';
  jobPosition: JobPosition;
};

export type UpdateJobPositionSuccessorInput = {
  id: Scalars['ID']['input'];
  jobTitleID: Scalars['ID']['input'];
  motivation: Scalars['QuillDelta']['input'];
  readiness: SuccessorReadiness;
  userID: Scalars['ID']['input'];
};

export type UpdateJobPositionSuccessorResponse = {
  __typename?: 'UpdateJobPositionSuccessorResponse';
  successor: JobPositionSuccessor;
};

export type UpdateJobTitleInput = {
  description?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  externalReferenceID?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  referenceCode?: InputMaybe<Scalars['String']['input']>;
  styrData?: InputMaybe<StyrDataInput>;
  title: Scalars['LocalizedString']['input'];
};

export type UpdateJobTitleResponse = {
  __typename?: 'UpdateJobTitleResponse';
  jobTitle: JobTitle;
};

export type UpdateLabelInput = {
  description?: InputMaybe<Scalars['LocalizedString']['input']>;
  id: Scalars['ID']['input'];
  title: Scalars['LocalizedString']['input'];
  type: LabelType;
};

export type UpdateLabelResponse = {
  __typename?: 'UpdateLabelResponse';
  label: Label;
};

export type UpdateLearningEventInput = {
  capacity: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['LocalizedAttributedString']['input']>;
  endDate: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  jobTitleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  languageID: Scalars['ID']['input'];
  learningSubjectIDs: Array<Scalars['ID']['input']>;
  learningTypeID: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['LocalizedString']['input'];
};

export type UpdateLearningEventResponse = {
  __typename?: 'UpdateLearningEventResponse';
  learningEvent: LearningEvent;
};

export type UpdateLearningSubjectInput = {
  id: Scalars['ID']['input'];
  title: Scalars['LocalizedString']['input'];
};

export type UpdateLearningSubjectResponse = {
  __typename?: 'UpdateLearningSubjectResponse';
  learningSubject: LearningSubject;
};

export type UpdateLearningTypeInput = {
  color: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  title: Scalars['LocalizedString']['input'];
};

export type UpdateLearningTypeResponse = {
  __typename?: 'UpdateLearningTypeResponse';
  learningType: LearningType;
};

export type UpdateMeetingInput = {
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  series?: InputMaybe<UpsertMeetingSeriesInput>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  target: MeetingTargetInput;
  timezone?: InputMaybe<Scalars['TimeZoneID']['input']>;
};

export type UpdateMeetingResponse = {
  __typename?: 'UpdateMeetingResponse';
  meeting: Meeting;
};

export type UpdateNoteInput = {
  content?: InputMaybe<Scalars['QuillDelta']['input']>;
  /** @deprecated Use `updateMeeting` instead. */
  date?: InputMaybe<Scalars['String']['input']>;
  linkedEntities?: InputMaybe<Array<LinkedEntityInput>>;
  noteID: Scalars['ID']['input'];
  noteType?: InputMaybe<NoteType>;
  subjectID?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  transcriptionID?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateNotePreparationInput = {
  noteID: Scalars['ID']['input'];
  preparation: Scalars['String']['input'];
};

export type UpdateNotePreparationResponse = {
  __typename?: 'UpdateNotePreparationResponse';
  note: Note;
};

export type UpdateNoteResponse = {
  __typename?: 'UpdateNoteResponse';
  note: Note;
};

export type UpdateNotificationCustomizationInput = {
  content: Scalars['QuillDelta']['input'];
  event: Scalars['String']['input'];
  languageID: Scalars['String']['input'];
};

export type UpdateNotificationCustomizationResponse = {
  __typename?: 'UpdateNotificationCustomizationResponse';
  customization: NotificationCustomization;
};

export type UpdateNotificationTemplateInput = {
  event: Scalars['String']['input'];
  languageID: Scalars['String']['input'];
  longFormText: Scalars['QuillDelta']['input'];
  shortFormText?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type UpdateNotificationTemplateResponse = {
  __typename?: 'UpdateNotificationTemplateResponse';
  notificationTemplate: NotificationTemplate;
};

export type UpdatePrivacyConsentInput = {
  allowsUsageStatistics?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePrivacyConsentResponse = {
  __typename?: 'UpdatePrivacyConsentResponse';
  user: User;
};

export type UpdateSessionInput = {
  response: ChallengeResponse;
};

export type UpdateSessionResponse = {
  __typename?: 'UpdateSessionResponse';
  challenge?: Maybe<Challenge>;
  session?: Maybe<Session>;
};

export type UpdateTalentReviewGridPlacementInput = {
  column: Scalars['Int']['input'];
  groupID: Scalars['ID']['input'];
  localDate: Scalars['LocalDate']['input'];
  motivation?: InputMaybe<Scalars['String']['input']>;
  /** Order within the cell; omit to append at the end (createdAt). */
  position?: InputMaybe<Scalars['Float']['input']>;
  /** Explicit null clears the rating; omitting it keeps the previous one. */
  retentionRisk?: InputMaybe<TalentReviewRetentionRisk>;
  row: Scalars['Int']['input'];
  score?: InputMaybe<TalentReviewPlacementScore>;
  templateID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type UpdateTalentReviewGridPlacementResponse = {
  __typename?: 'UpdateTalentReviewGridPlacementResponse';
  grid: TalentReviewGrid;
};

export type UpdateTalentReviewInput = {
  placements: Array<TalentReviewPlacementInput>;
  reviewID: Scalars['ID']['input'];
  status: TalentReviewStatus;
  title: Scalars['String']['input'];
};

export type UpdateTalentReviewResponse = {
  __typename?: 'UpdateTalentReviewResponse';
  talentReview: TalentReview;
};

export type UpdateTalentReviewSnapshotInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type UpdateTalentReviewSnapshotResponse = {
  __typename?: 'UpdateTalentReviewSnapshotResponse';
  snapshot: TalentReviewSnapshot;
};

export type UpdateTalentReviewTemplateInput = {
  cells: Array<Array<TalentReviewTemplateCellInput>>;
  description: Scalars['LocalizedAttributedString']['input'];
  hasNorm?: InputMaybe<Scalars['Boolean']['input']>;
  outdatedAfterDays?: InputMaybe<Scalars['Int']['input']>;
  placementHelpQuestions?: InputMaybe<Array<TalentReviewPlacementHelpQuestionInput>>;
  templateID: Scalars['ID']['input'];
  title: Scalars['LocalizedString']['input'];
  visibility: TalentReviewVisibility;
  xAxis: TalentReviewTemplateAxisInput;
  yAxis: TalentReviewTemplateAxisInput;
};

export type UpdateTalentReviewTemplateResponse = {
  __typename?: 'UpdateTalentReviewTemplateResponse';
  template: TalentReviewTemplate;
};

export type UpdateTaskInput = {
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  status?: InputMaybe<TaskStatus>;
  subjectID?: InputMaybe<Scalars['ID']['input']>;
  subjectType?: InputMaybe<TaskSubjectType>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaskResponse = {
  __typename?: 'UpdateTaskResponse';
  task: Task;
};

export type UpdateTranscriptionSummaryInput = {
  editableSummary: Scalars['QuillDelta']['input'];
  transcriptionID: Scalars['String']['input'];
};

export type UpdateTranscriptionSummaryResponse = {
  __typename?: 'UpdateTranscriptionSummaryResponse';
  transcription: Transcription;
};

export type UpdateUserActivationDateInput = {
  /** @deprecated Use `localActivatedAt` instead. */
  activatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  localActivatedAt?: InputMaybe<Scalars['LocalDate']['input']>;
  userID: Scalars['ID']['input'];
};

export type UpdateUserActivationDateResponse = {
  __typename?: 'UpdateUserActivationDateResponse';
  user: User;
};

export type UpdateUserAvatarInput = {
  assetID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type UpdateUserAvatarResponse = {
  __typename?: 'UpdateUserAvatarResponse';
  user: User;
};

export type UpdateUserCoverInput = {
  assetID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type UpdateUserCoverResponse = {
  __typename?: 'UpdateUserCoverResponse';
  user: User;
};

export type UpdateUserDownloadInput = {
  failedReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  progress?: InputMaybe<Scalars['Float']['input']>;
  status: UserDownloadStatus;
};

export type UpdateUserDownloadResponse = {
  __typename?: 'UpdateUserDownloadResponse';
  download: UserDownload;
};

export type UpdateUserInput = {
  /** @deprecated Use `localActivatedAt` instead. */
  activatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Use `localDeactivatedAt` instead. */
  deactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  externalReferenceID?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  groupID: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  /**
   * An optional boolean that indicates if this user is considered an external
   * employee. If this field is not present, it will remain unchanged.
   */
  isExternal?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  localActivatedAt?: InputMaybe<Scalars['LocalDate']['input']>;
  localDeactivatedAt?: InputMaybe<Scalars['LocalDate']['input']>;
  locale: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UpdateUserLocaleInput = {
  locale: Scalars['String']['input'];
  userID: Scalars['ID']['input'];
};

export type UpdateUserLocaleResponse = {
  __typename?: 'UpdateUserLocaleResponse';
  user: User;
};

export type UpdateUserMissionInput = {
  id: Scalars['ID']['input'];
  mission: Scalars['String']['input'];
};

export type UpdateUserMissionResponse = {
  __typename?: 'UpdateUserMissionResponse';
  user: User;
};

export type UpdateUserNotificationSettingInput = {
  channel: NotificationChannel;
  frequency?: InputMaybe<NotificationFrequency>;
  type: Scalars['String']['input'];
};

export type UpdateUserNotificationSettingResponse = {
  __typename?: 'UpdateUserNotificationSettingResponse';
  setting: UserNotificationSetting;
};

export type UpdateUserResponse = {
  __typename?: 'UpdateUserResponse';
  user: User;
};

export type UpdateWelcomeEmailInput = {
  body: Scalars['LocalizedAttributedString']['input'];
  subject: Scalars['LocalizedString']['input'];
};

export type UpdateWelcomeEmailResponse = {
  __typename?: 'UpdateWelcomeEmailResponse';
  workspace: Workspace;
};

export type UpdateWorkspaceAliasInput = {
  alias: Scalars['String']['input'];
  workspaceID: Scalars['String']['input'];
};

export type UpdateWorkspaceAliasResponse = {
  __typename?: 'UpdateWorkspaceAliasResponse';
  workspace: Workspace;
};

export type UpdateWorkspaceBackgroundInput = {
  assetID: Scalars['ID']['input'];
};

export type UpdateWorkspaceBackgroundResponse = {
  __typename?: 'UpdateWorkspaceBackgroundResponse';
  workspace: Workspace;
};

export type UpdateWorkspaceColorsInput = {
  linearGradientEnd?: InputMaybe<Scalars['String']['input']>;
  linearGradientStart?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  primaryColorDark?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkspaceColorsResponse = {
  __typename?: 'UpdateWorkspaceColorsResponse';
  workspace: Workspace;
};

export type UpdateWorkspaceDisplayNameInput = {
  displayName: Scalars['String']['input'];
  workspaceID: Scalars['String']['input'];
};

export type UpdateWorkspaceDisplayNameResponse = {
  __typename?: 'UpdateWorkspaceDisplayNameResponse';
  workspace: Workspace;
};

export type UpdateWorkspaceEmailDomainsInput = {
  emailDomains: Scalars['String']['input'];
  workspaceID: Scalars['String']['input'];
};

export type UpdateWorkspaceEmailDomainsResponse = {
  __typename?: 'UpdateWorkspaceEmailDomainsResponse';
  workspace: Workspace;
};

export type UpdateWorkspaceFeatureInput = {
  featureID: FeatureName;
  status: WorkspaceFeatureStatus;
};

export type UpdateWorkspaceFeatureResponse = {
  __typename?: 'UpdateWorkspaceFeatureResponse';
  workspace: Workspace;
};

export type UpdateWorkspaceHubSpotCompanyIdInput = {
  hubSpotCompanyID?: InputMaybe<Scalars['String']['input']>;
  workspaceID: Scalars['String']['input'];
};

export type UpdateWorkspaceHubSpotCompanyIdResponse = {
  __typename?: 'UpdateWorkspaceHubSpotCompanyIDResponse';
  workspace: Workspace;
};

export type UpdateWorkspaceLanguagesInput = {
  languageIDs: Array<Scalars['String']['input']>;
  workspaceID: Scalars['String']['input'];
};

export type UpdateWorkspaceLanguagesResponse = {
  __typename?: 'UpdateWorkspaceLanguagesResponse';
  workspace: Workspace;
};

export type UpdateWorkspaceLogoInput = {
  assetID: Scalars['ID']['input'];
};

export type UpdateWorkspaceLogoResponse = {
  __typename?: 'UpdateWorkspaceLogoResponse';
  workspace: Workspace;
};

export type UpdateWorkspaceMfaSettingsInput = {
  allowedMethods: Array<MfaMethod>;
  status: WorkspaceMfaStatus;
};

export type UpdateWorkspaceMfaSettingsResponse = {
  __typename?: 'UpdateWorkspaceMfaSettingsResponse';
  workspaceMfaSettings: WorkspaceMfaSettings;
};

export type UpdateWorkspaceNotificationSettingsInput = {
  footer: Scalars['LocalizedAttributedString']['input'];
  header: Scalars['LocalizedAttributedString']['input'];
};

export type UpdateWorkspaceNotificationSettingsResponse = {
  __typename?: 'UpdateWorkspaceNotificationSettingsResponse';
  workspace: Workspace;
};

export type UpdateWorkspacePlanInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  minimumUserCount?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  type: Scalars['String']['input'];
  workspaceID: Scalars['String']['input'];
};

export type UpdateWorkspacePlanResponse = {
  __typename?: 'UpdateWorkspacePlanResponse';
  workspace: Workspace;
};

export type UpdateWorkspacePlanV2Input = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isTrial: Scalars['Boolean']['input'];
  minimumUserCount?: InputMaybe<Scalars['Int']['input']>;
  planID: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  workspaceID: Scalars['String']['input'];
};

export type UpdateWorkspacePlanV2Response = {
  __typename?: 'UpdateWorkspacePlanV2Response';
  plan: WorkspacePlanV2;
};

export type UpdateWorkspaceRetentionPeriodInput = {
  retentionPeriodDays: Scalars['Int']['input'];
  workspaceID: Scalars['String']['input'];
};

export type UpdateWorkspaceRetentionPeriodResponse = {
  __typename?: 'UpdateWorkspaceRetentionPeriodResponse';
  workspace: Workspace;
};

export type UpdateWorkspaceSsoSettingsInput = {
  enforceSSO?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateWorkspaceSsoSettingsResponse = {
  __typename?: 'UpdateWorkspaceSSOSettingsResponse';
  workspace: Workspace;
};

export type UpdateWorkspaceStartDateInput = {
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  workspaceID: Scalars['String']['input'];
};

export type UpdateWorkspaceStartDateResponse = {
  __typename?: 'UpdateWorkspaceStartDateResponse';
  workspace: Workspace;
};

export type UpsertMeetingSeriesInput = {
  irregularOccurrence?: InputMaybe<Scalars['Boolean']['input']>;
  noteSeriesMetadata?: InputMaybe<NoteSeriesMetadataInput>;
  recurrenceFrequency: MeetingSeriesRecurrenceFrequency;
};

export type User = {
  __typename?: 'User';
  /** @deprecated Use `localActivatedAt` instead. */
  activatedAt: Scalars['DateTime']['output'];
  allowsUsageStatistics?: Maybe<Scalars['Boolean']['output']>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  associatedIdentities: Array<AssociatedIdentity>;
  attendingLearningEvents: LearningAttendeeEventConnection;
  avatar?: Maybe<Asset>;
  /**
   * Returns a connection of competency bookmarks that were created by or on
   * behalf of this user. If `isArchived` is not given, all bookmarks are
   * returned (including archived ones). If `isArchived` is false, only
   * non-archived bookmarks are returned. If `isArchived` is true, only archived
   * bookmarks are returned.
   */
  competencyBookmarks: CompetencyBookmarkConnection;
  compliments: ComplimentConnection;
  /**
   * Whether this user has approved the ConversationAiInsights feature
   * conditions, allowing their data to be used with AI.
   */
  conversationAiInsightsApproved: Scalars['Boolean']['output'];
  cover?: Maybe<Asset>;
  createdAt: Scalars['DateTime']['output'];
  createdTasks: Array<Task>;
  currentJobPosition?: Maybe<JobPosition>;
  cycles: CycleInstanceConnection;
  /** @deprecated Use `localDeactivatedAt` instead. */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  documentsV2: Array<UserDocumentV2>;
  downloads: Array<UserDownload>;
  email: Scalars['String']['output'];
  /** Returns a feed for the employee with notes, feedback requests, evaluation submissions and goals. */
  employeeFeed: EmployeeFeed;
  evaluationSubmissions: EvaluationSubmissionConnection;
  excludeAnalytics: Scalars['Boolean']['output'];
  externalReferenceID?: Maybe<Scalars['String']['output']>;
  /**
   * Returns a connection over all feedback requests for this user. Feedback
   * requests are sorted by creation date in descending order (most recently
   * created feedback requests are returned first).
   */
  feedbackRequests: FeedbackRequestConnection;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  givenCompliments: ComplimentConnection;
  /** @deprecated Use `goalsV2` instead. */
  goals: Array<Goal>;
  goalsV2: GoalConnection;
  group: Group;
  groups: Array<Group>;
  id: Scalars['ID']['output'];
  inboxTasks: Array<InboxTask>;
  individualManagers: Array<UserRole>;
  isArchived: Scalars['Boolean']['output'];
  isEmailSuppressed: Scalars['Boolean']['output'];
  /** Boolean that indicates if this user is considered an external employee. */
  isExternal: Scalars['Boolean']['output'];
  isRedacted: Scalars['Boolean']['output'];
  isViewer: Scalars['Boolean']['output'];
  jobPositions: Array<JobPosition>;
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  learningEventProposals: LearningEventConnection;
  localActivatedAt: Scalars['LocalDate']['output'];
  localDeactivatedAt?: Maybe<Scalars['LocalDate']['output']>;
  locale: Scalars['String']['output'];
  managees: Array<User>;
  managers: Array<UserRole>;
  mission: Scalars['String']['output'];
  moments: Array<MomentInstance>;
  mutualFeedbackResponses: FeedbackResponseConnection;
  mutualNotes: NoteConnection;
  normalizedName: Scalars['String']['output'];
  notificationSettings: Array<UserNotificationSetting>;
  notifications: NotificationConnection;
  /** @deprecated Use evaluationSubmissions instead. */
  outgoingEvaluationSubmissions: EvaluationSubmissionConnection;
  outgoingFeedbackResponses: FeedbackResponseConnection;
  personalAccessToken?: Maybe<PersonalAccessToken>;
  privacyConsent?: Maybe<PrivacyConsent>;
  redactedAt?: Maybe<Scalars['DateTime']['output']>;
  roles: Array<UserRole>;
  sentEmails: SentEmailConnection;
  sharedFeedback: SharedFeedbackConnection;
  signedEmail?: Maybe<SignedEmail>;
  slackIdentity?: Maybe<SlackIdentity>;
  status: UserStatus;
  tasks: Array<Task>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userMfaConfiguration: MfaUserConfiguration;
  username: Scalars['String']['output'];
  viewerCanCreateDocuments: Scalars['Boolean']['output'];
  viewerCanCreateGoal: Scalars['Boolean']['output'];
  /**
   * Returns a boolean that indicates if the viewer has permission to request
   * feedback on this user's behalf.
   */
  viewerCanRequestFeedback: Scalars['Boolean']['output'];
  viewerCanUpdate: Scalars['Boolean']['output'];
  viewerCanViewDevelopmentPlan: Scalars['Boolean']['output'];
  viewerCanViewDocuments: Scalars['Boolean']['output'];
  viewerCanViewEvaluations: Scalars['Boolean']['output'];
  /**
   * Returns a boolean that indicates if the viewer has permission to view
   * feedback of this user.
   */
  viewerCanViewFeedback: Scalars['Boolean']['output'];
  viewerCanViewGoals: Scalars['Boolean']['output'];
  viewerCanViewJourney: Scalars['Boolean']['output'];
  viewerGivenCompliments: ComplimentConnection;
  workspace: Workspace;
  workspaceRole?: Maybe<UserRole>;
};


export type UserAttendingLearningEventsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  afterDate?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  beforeDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserCompetencyBookmarksArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserComplimentsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserCyclesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<CycleStatus>>;
};


export type UserEmployeeFeedArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  filterOnType?: InputMaybe<Array<InputMaybe<FeedItemType>>>;
};


export type UserEvaluationSubmissionsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  formID?: InputMaybe<Scalars['ID']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  untilDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type UserFeedbackRequestsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserGivenComplimentsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserGoalsArgs = {
  hasCompetency?: InputMaybe<Scalars['Boolean']['input']>;
  status: GoalStatus;
};


export type UserGoalsV2Args = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasCompetency?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<GoalStatus>;
};


export type UserInboxTasksArgs = {
  status?: InputMaybe<InboxTaskStatus>;
  types?: InputMaybe<Array<InboxTaskType>>;
};


export type UserJobPositionsArgs = {
  status?: InputMaybe<JobPositionStatus>;
};


export type UserLearningEventProposalsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserManageesArgs = {
  recurse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserMomentsArgs = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<MomentStatus>;
  type?: InputMaybe<MomentType>;
};


export type UserMutualFeedbackResponsesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isRecipient?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserMutualNotesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<MutualNotesFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserNotificationsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  day?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  week?: InputMaybe<Scalars['String']['input']>;
};


export type UserOutgoingEvaluationSubmissionsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserOutgoingFeedbackResponsesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserSentEmailsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserViewerGivenComplimentsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserDocumentUploadHeader = {
  __typename?: 'UserDocumentUploadHeader';
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type UserDocumentV2 = {
  __typename?: 'UserDocumentV2';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: UserDocumentV2Status;
  viewerCanDelete: Scalars['Boolean']['output'];
};

export enum UserDocumentV2Status {
  PotentialMalwareFound = 'POTENTIAL_MALWARE_FOUND',
  Processing = 'PROCESSING',
  ProcessingError = 'PROCESSING_ERROR',
  ProcessingOk = 'PROCESSING_OK'
}

export type UserDownload = {
  __typename?: 'UserDownload';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['String']['output']>;
  downloadLink?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  failedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  progress: Scalars['Float']['output'];
  status: UserDownloadStatus;
  viewerCanDelete: Scalars['Boolean']['output'];
};

export enum UserDownloadStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Success = 'SUCCESS'
}

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['ID']['output'];
  node: User;
};

export enum UserExportType {
  Conversations = 'CONVERSATIONS',
  Feedback = 'FEEDBACK'
}

export type UserNotificationSetting = {
  __typename?: 'UserNotificationSetting';
  channels: Array<NotificationChannelMap>;
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type UserRole = {
  __typename?: 'UserRole';
  externalReferenceID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isIndirect: Scalars['Boolean']['output'];
  role: Role;
  source: User;
  target: RoleTarget;
  targetV2?: Maybe<RoleTargetV2>;
};

export type UserRoleConnection = {
  __typename?: 'UserRoleConnection';
  edges: Array<UserRoleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserRoleEdge = {
  __typename?: 'UserRoleEdge';
  cursor: Scalars['ID']['output'];
  node: UserRole;
};

export enum UserStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE'
}

export type UserWithCount = {
  __typename?: 'UserWithCount';
  count: Scalars['Int']['output'];
  user: User;
};

export type VerifySessionInput = {
  accessToken: Scalars['String']['input'];
};

export type VerifySessionResponse = {
  __typename?: 'VerifySessionResponse';
  user: User;
};

export type VerifyTotpTokenInput = {
  session?: InputMaybe<Scalars['String']['input']>;
  totp: Scalars['String']['input'];
};

export type VerifyTotpTokenResponse = {
  __typename?: 'VerifyTotpTokenResponse';
  mfaUserConfiguration?: Maybe<MfaUserConfiguration>;
  session?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type VoiceMemo = {
  __typename?: 'VoiceMemo';
  asset: Asset;
  sampleRate: Scalars['Float']['output'];
  samples: Array<Scalars['Float']['output']>;
};

export type VoiceMemoInput = {
  assetID: Scalars['ID']['input'];
  sampleRate: Scalars['Float']['input'];
  samples: Array<Scalars['Float']['input']>;
};

export type Workspace = {
  __typename?: 'Workspace';
  alias: Scalars['String']['output'];
  checkpoints?: Maybe<Array<Maybe<Checkpoint>>>;
  cognitoUsers: Array<Scalars['JSON']['output']>;
  connector?: Maybe<Connector>;
  connectorAdmin?: Maybe<Connector>;
  connectorUsers: Array<Scalars['JSON']['output']>;
  customEmailDomain?: Maybe<CustomEmailDomain>;
  displayName?: Maybe<Scalars['String']['output']>;
  emailDomains?: Maybe<Scalars['String']['output']>;
  engagementSettings: EngagementSettings;
  features: Array<WorkspaceFeature>;
  /** @deprecated Use `goalsV2` instead. */
  goals: Array<Goal>;
  goalsV2: GoalConnection;
  /**
   * GoodHabitz connector config for the current user's workspace, or null when GoodHabitz has
   * never been configured.
   */
  goodHabitzConfig?: Maybe<GoodHabitzConfig>;
  hubSpotCompanyID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isExpired: Scalars['Boolean']['output'];
  microsoftConfig?: Maybe<MicrosoftConfig>;
  notificationSettings: WorkspaceNotificationSettings;
  /** @deprecated Use `plans` instead. */
  plan?: Maybe<WorkspacePlan>;
  plans: Array<WorkspacePlanV2>;
  redirect?: Maybe<Scalars['String']['output']>;
  retentionPeriodDays: Scalars['Int']['output'];
  rootDepartment: Group;
  slackConfig?: Maybe<SlackConfig>;
  ssoSettings: WorkspaceSsoSettings;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use `plan.type` and `isArchived` instead. */
  status: WorkspaceStatus;
  stripeCollectionMethod?: Maybe<Scalars['String']['output']>;
  stripeCustomerID?: Maybe<Scalars['String']['output']>;
  /**
   * Styr enrichment connector config for the current user's workspace, or null when no Styr
   * organisation has been configured.
   */
  styrConfig?: Maybe<StyrConfig>;
  /**
   * Launch-only: Styr enrichment connector config for the queried workspace. Used by the
   * WorkspaceStyr admin panel.
   */
  styrConfigAdmin?: Maybe<StyrConfig>;
  supportedLanguageIDs: Array<Scalars['String']['output']>;
  theme: WorkspaceTheme;
  /** @deprecated Use `plan.endDate` instead. */
  trialExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  viewerCanCreateGoal: Scalars['Boolean']['output'];
  viewerCanCreateGoalDrivers: Scalars['Boolean']['output'];
  viewerCanViewArchivedGoals: Scalars['Boolean']['output'];
  viewerCanViewGoalAuditTrail: Scalars['Boolean']['output'];
  workspaceMfaSettings: WorkspaceMfaSettings;
};


export type WorkspaceGoalsArgs = {
  status: GoalStatus;
};


export type WorkspaceGoalsV2Args = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<GoalStatus>;
};


export type WorkspaceUserArgs = {
  username?: InputMaybe<Scalars['String']['input']>;
};

export type WorkspaceAnalytics = {
  __typename?: 'WorkspaceAnalytics';
  engagementENPS: AnalyticsEngagementEnps;
  engagementGroupsENPS: Array<AnalyticsEngagementGroupEnps>;
  engagementGroupsParticipation: Array<AnalyticsEngagementGroupParticipation>;
  engagementGroupsSubcategoriesScore: Array<AnalyticsEngagementGroupSubcategoryScore>;
  engagementOpenQuestions: Array<AnalyticsEngagementOpenQuestion>;
  engagementParticipationOverTime: AnalyticsEngagementParticipation;
  engagementQuestionsTrend: Array<AnalyticsEngagementQuestionScoreTrend>;
  engagementScoreOverTime: AnalyticsEngagementScore;
  engagementSubcategoriesTrend: Array<AnalyticsEngagementSubcategoryScoreOverTime>;
};


export type WorkspaceAnalyticsEngagementQuestionsTrendArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  thriving: Scalars['Boolean']['input'];
};


export type WorkspaceAnalyticsEngagementSubcategoriesTrendArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  thriving: Scalars['Boolean']['input'];
};

export type WorkspaceConnection = {
  __typename?: 'WorkspaceConnection';
  edges: Array<WorkspaceEdge>;
  pageInfo: PageInfo;
};

export type WorkspaceEdge = {
  __typename?: 'WorkspaceEdge';
  cursor: Scalars['ID']['output'];
  node: Workspace;
};

export type WorkspaceFeature = {
  __typename?: 'WorkspaceFeature';
  feature: Feature;
  id: Scalars['ID']['output'];
  inPlan: Scalars['Boolean']['output'];
  needsViewerApproval: Scalars['Boolean']['output'];
  needsWorkspaceApproval: Scalars['Boolean']['output'];
  requiredConditions?: Maybe<FeatureConditions>;
  status: WorkspaceFeatureStatus;
  viewerApproval?: Maybe<FeatureApproval>;
  workspaceApproval?: Maybe<FeatureApproval>;
};

export enum WorkspaceFeatureStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Restricted = 'RESTRICTED',
  Superuser = 'SUPERUSER'
}

export type WorkspaceFilters = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `isArchived` instead. */
  status?: InputMaybe<WorkspaceStatus>;
};

export type WorkspaceMfaSettings = {
  __typename?: 'WorkspaceMfaSettings';
  allowedMethods: Array<MfaMethod>;
  id: Scalars['ID']['output'];
  status: WorkspaceMfaStatus;
};

export enum WorkspaceMfaStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Required = 'REQUIRED'
}

export type WorkspaceNotificationSettings = {
  __typename?: 'WorkspaceNotificationSettings';
  footer: Scalars['LocalizedAttributedString']['output'];
  header: Scalars['LocalizedAttributedString']['output'];
  welcomeEmail: WorkspaceWelcomeEmail;
};

export type WorkspacePlan = {
  __typename?: 'WorkspacePlan';
  actualUserCount: Scalars['Int']['output'];
  defaultMinimumUserCount: Scalars['Int']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  minimumUserCount?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  type: Scalars['String']['output'];
};

export enum WorkspacePlanType {
  Ai = 'AI',
  Classic = 'CLASSIC',
  Conversations = 'CONVERSATIONS',
  Engage = 'ENGAGE',
  Pro = 'PRO'
}

export type WorkspacePlanV2 = {
  __typename?: 'WorkspacePlanV2';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isExpired: Scalars['Boolean']['output'];
  isTrial: Scalars['Boolean']['output'];
  minimumUserCount: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  type: WorkspacePlanType;
};

export type WorkspaceSsoSettings = {
  __typename?: 'WorkspaceSSOSettings';
  enforceSSO: Scalars['Boolean']['output'];
};

export type WorkspaceStatistic = {
  __typename?: 'WorkspaceStatistic';
  active: Scalars['Int']['output'];
  archived: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  deactivated: Scalars['Int']['output'];
  draft: Scalars['Int']['output'];
  workspaceID: Scalars['ID']['output'];
};

export enum WorkspaceStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type WorkspaceTheme = {
  __typename?: 'WorkspaceTheme';
  background?: Maybe<Asset>;
  linearGradientEnd?: Maybe<Scalars['String']['output']>;
  linearGradientStart?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Asset>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  primaryColorDark?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
};

export type WorkspaceUserId = {
  __typename?: 'WorkspaceUserID';
  userID: Scalars['ID']['output'];
  workspaceID: Scalars['ID']['output'];
};

export type WorkspaceWelcomeEmail = {
  __typename?: 'WorkspaceWelcomeEmail';
  body: Scalars['LocalizedAttributedString']['output'];
  subject: Scalars['LocalizedString']['output'];
};

export type CopyWorkspaceMutationVariables = Exact<{
  input: CopyWorkspaceInput;
}>;


export type CopyWorkspaceMutation = { __typename?: 'Mutation', copyWorkspace: { __typename?: 'CopyWorkspaceResponse', success: boolean, target: string, error: string } };

export type CheckWorkspaceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CheckWorkspaceQuery = { __typename?: 'Query', isWorkspaceSlugAvailable: boolean };

export type AgentChatMessageFragment = { __typename?: 'AgentChatMessage', id: string, role: AgentChatMessageRole, content?: string | null, toolCallId?: string | null, createdAt: any, toolCalls?: Array<{ __typename?: 'AgentChatToolCall', id: string, name: string, arguments?: any | null }> | null };

export type AgentChatToolCallFragment = { __typename?: 'AgentChatToolCall', id: string, name: string, arguments?: any | null };

export type CreateAgentChatMutationVariables = Exact<{
  input?: InputMaybe<CreateAgentChatInput>;
}>;


export type CreateAgentChatMutation = { __typename?: 'Mutation', createAgentChat: { __typename?: 'AgentChat', id: string, title: string, updatedAt: any } };

export type DeleteAgentChatMutationVariables = Exact<{
  chatID: Scalars['ID']['input'];
}>;


export type DeleteAgentChatMutation = { __typename?: 'Mutation', deleteAgentChat: boolean };

export type SetPromptInstructionMutationVariables = Exact<{
  input: SetPromptInstructionInput;
}>;


export type SetPromptInstructionMutation = { __typename?: 'Mutation', setPromptInstruction: { __typename?: 'SetPromptInstructionResponse', promptInstruction: { __typename?: 'PromptInstruction', id: string, workspaceID: string, promptInstructionID: Prompt, instructions: string } } };

export type SetWorkspacePromptInstructionMutationVariables = Exact<{
  input: SetWorkspacePromptInstructionInput;
}>;


export type SetWorkspacePromptInstructionMutation = { __typename?: 'Mutation', setWorkspacePromptInstruction: { __typename?: 'SetPromptInstructionResponse', promptInstruction: { __typename?: 'PromptInstruction', instructions: string } } };

export type AgentChatQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AgentChatQuery = { __typename?: 'Query', agentChat: { __typename?: 'AgentChat', id: string, title: string, locale?: string | null, createdAt: any, updatedAt: any, messages: Array<{ __typename?: 'AgentChatMessage', id: string, role: AgentChatMessageRole, content?: string | null, toolCallId?: string | null, createdAt: any, toolCalls?: Array<{ __typename?: 'AgentChatToolCall', id: string, name: string, arguments?: any | null }> | null }>, usage?: { __typename?: 'AgentChatUsage', model?: string | null, inputTokens?: number | null, cachedInputTokens?: number | null, cacheWriteTokens?: number | null, outputTokens?: number | null } | null } };

export type AgentChatUsageFragment = { __typename?: 'AgentChatUsage', model?: string | null, inputTokens?: number | null, cachedInputTokens?: number | null, cacheWriteTokens?: number | null, outputTokens?: number | null };

export type AgentChatsQueryVariables = Exact<{ [key: string]: never; }>;


export type AgentChatsQuery = { __typename?: 'Query', agentChats: Array<{ __typename?: 'AgentChat', id: string, title: string, updatedAt: any, subject?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null }> };

export type PromptHistoryQueryVariables = Exact<{
  workspaceID: Scalars['ID']['input'];
  promptHistoryID: Scalars['ID']['input'];
}>;


export type PromptHistoryQuery = { __typename?: 'Query', promptHistory?: { __typename?: 'PromptHistory', id: string, workspaceID: string, targetType: string, targetID?: string | null, messages: any, response: any, toolCallCount: number, durationMs: number, model?: string | null, inputTokens?: number | null, cachedInputTokens?: number | null, cacheWriteTokens?: number | null, outputTokens?: number | null, createdAt: any, user?: { __typename?: 'PromptHistoryUser', id: string, firstName?: string | null, lastName?: string | null, avatar?: { __typename?: 'PromptHistoryAsset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, target?: { __typename?: 'EvaluationSubmission' } | { __typename?: 'Transcription', targetID: string, targetType: TranscriptionTargetType, transcript?: string | null, audioUrl?: string | null } | null, targetDetails?: { __typename?: 'PromptHistoryTargetDetails', id: string, type: string, workspaceID: string, evaluationFormTitle?: LocalizedString | null, employee?: { __typename?: 'PromptHistoryUser', id: string, firstName?: string | null, lastName?: string | null, avatar?: { __typename?: 'PromptHistoryAsset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, manager?: { __typename?: 'PromptHistoryUser', id: string, firstName?: string | null, lastName?: string | null, avatar?: { __typename?: 'PromptHistoryAsset', source: { __typename?: 'AssetVariant', url: string } } | null } | null } | null, featureRating?: { __typename?: 'FeatureRating', id: string, binaryValue?: boolean | null, text?: string | null, createdAt: any } | null } | null };

export type PromptHistoriesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  includeDemoWorkspaces?: InputMaybe<Scalars['Boolean']['input']>;
  targetType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PromptHistoriesQuery = { __typename?: 'Query', promptHistories: { __typename?: 'PromptHistoryConnection', edges: Array<{ __typename?: 'PromptHistoryEdge', node: { __typename?: 'PromptHistory', id: string, workspaceID: string, targetType: string, createdAt: any, user?: { __typename?: 'PromptHistoryUser', id: string, firstName?: string | null, lastName?: string | null } | null, targetDetails?: { __typename?: 'PromptHistoryTargetDetails', employee?: { __typename?: 'PromptHistoryUser', id: string } | null } | null, featureRating?: { __typename?: 'FeatureRating', binaryValue?: boolean | null, text?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type PromptHistoryAnalyticsQueryVariables = Exact<{
  filters: PromptHistoryFilters;
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  calendarTimeZone?: InputMaybe<Scalars['String']['input']>;
}>;


export type PromptHistoryAnalyticsQuery = { __typename?: 'Query', promptHistoryAnalytics: { __typename?: 'PromptHistoryAnalytics', totalInteractions: number, uniqueUserCount: number, uniqueWorkspaceCount: number, feedbackDetailsTruncated: boolean, dateRange?: { __typename?: 'PromptHistoryAnalyticsDateRange', min?: any | null, max?: any | null } | null, byTargetType: Array<{ __typename?: 'PromptHistoryTargetTypeCount', targetType: string, count: number }>, byWeek: Array<{ __typename?: 'PromptHistoryAnalyticsWeekBucket', weekKey: string, weekStart?: any | null, countsByTargetType: Array<{ __typename?: 'PromptHistoryTargetTypeCountInWeek', targetType: string, count: number }> }>, byDay: Array<{ __typename?: 'PromptHistoryAnalyticsDayBucket', dayKey: string, dayStart?: any | null, countsByTargetType: Array<{ __typename?: 'PromptHistoryTargetTypeCountInWeek', targetType: string, count: number }> }>, byMonth: Array<{ __typename?: 'PromptHistoryAnalyticsMonthBucket', monthKey: string, monthStart?: any | null, countsByTargetType: Array<{ __typename?: 'PromptHistoryTargetTypeCountInWeek', targetType: string, count: number }> }>, evaluationContext: { __typename?: 'PromptHistoryEvaluationContext', asEmployeeCount: number, asManagerCount: number, unknownCount: number }, feedbackByTargetType: Array<{ __typename?: 'PromptHistoryFeedbackByTarget', targetType: string, positiveCount: number, negativeCount: number, withWrittenFeedbackCount: number, ratingWithoutWrittenFeedbackCount: number }>, feedbackTotals: { __typename?: 'PromptHistoryFeedbackTotals', noRatingCount: number, withWrittenFeedbackCount: number, ratingWithoutWrittenFeedbackCount: number }, feedbackDetails: Array<{ __typename?: 'PromptHistoryAnalyticsFeedbackDetail', workspaceID: string, targetType: string, targetID?: string | null, userID: string, interactionCreatedAt: any, thumbsUp?: boolean | null, writtenFeedback?: string | null }>, topWorkspaces: Array<{ __typename?: 'PromptHistoryWorkspaceCount', workspaceID: string, interactionCount: number, uniqueUserCount: number }>, usageByModel: Array<{ __typename?: 'PromptHistoryModelUsage', model?: string | null, promptCount: number, inputTokens: number, cachedInputTokens: number, cacheWriteTokens: number, outputTokens: number }>, usageByWorkspace: Array<{ __typename?: 'PromptHistoryWorkspaceUsage', workspaceID: string, byModel: Array<{ __typename?: 'PromptHistoryModelUsage', model?: string | null, promptCount: number, inputTokens: number, cachedInputTokens: number, cacheWriteTokens: number, outputTokens: number }> }> } };

export type PromptHistoryExportQueryVariables = Exact<{
  filters: PromptHistoryFilters;
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type PromptHistoryExportQuery = { __typename?: 'Query', promptHistoryExport: Array<{ __typename?: 'PromptHistoryExportRow', id: string, workspaceID: string, userID: string, targetType: string, model?: string | null, inputTokens?: number | null, outputTokens?: number | null, createdAt: any }> };

export type PromptInstructionQueryVariables = Exact<{
  workspaceID: Scalars['ID']['input'];
  promptInstructionID: Prompt;
}>;


export type PromptInstructionQuery = { __typename?: 'Query', promptInstruction?: { __typename?: 'PromptInstruction', id: string, workspaceID: string, promptInstructionID: Prompt, instructions: string } | null };

export type WorkspacePromptInstructionQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspacePromptInstructionQuery = { __typename?: 'Query', workspacePromptInstruction?: { __typename?: 'PromptInstruction', instructions: string } | null };

export type AnalyticsQueryVariables = Exact<{
  type: AnalyticsType;
  filters: AnalyticsFiltersV2;
}>;


export type AnalyticsQuery = { __typename?: 'Query', analytics: { __typename?: 'Analytics', totalUsers: number, metricGroups: Array<{ __typename?: 'AnalyticsMetricGroup', id: string, metrics: Array<{ __typename?: 'AnalyticsConversationsMetric', id: string, threshold: number, templates: Array<{ __typename?: 'AnalyticsConversationTemplateMetric', value: number, total: number, template: { __typename?: 'EvaluationForm', id: string, title: LocalizedString } }> } | { __typename?: 'AnalyticsFloatMetric', id: string, float?: number | null, threshold: number } | { __typename?: 'AnalyticsFractionMetric', id: string, value: number, total: number, threshold: number } | { __typename?: 'AnalyticsGraphMetric', id: string, min?: number | null, max?: number | null, datapoints: Array<{ __typename?: 'AnalyticsFloatDatapoint', timestamp: any, value?: number | null }> } | { __typename?: 'AnalyticsIntegerMetric', id: string, integer: number, threshold: number } | { __typename?: 'AnalyticsPercentageMetric', id: string, percentage?: number | null, threshold: number }> }> } };

export type AnalyticsMetricQueryVariables = Exact<{
  type: AnalyticsType;
  filters: AnalyticsFiltersV2;
  metricGroupID: Scalars['ID']['input'];
  metricID: Scalars['ID']['input'];
}>;


export type AnalyticsMetricQuery = { __typename?: 'Query', analytics: { __typename?: 'Analytics', totalUsers: number, metricGroup: { __typename?: 'AnalyticsMetricGroup', id: string, metric: { __typename?: 'AnalyticsConversationsMetric', id: string, threshold: number, templates: Array<{ __typename?: 'AnalyticsConversationTemplateMetric', value: number, total: number, template: { __typename?: 'EvaluationForm', id: string, title: LocalizedString } }> } | { __typename?: 'AnalyticsFloatMetric', id: string, details: Array<string>, float?: number | null, threshold: number } | { __typename?: 'AnalyticsFractionMetric', id: string, details: Array<string>, value: number, total: number, threshold: number } | { __typename?: 'AnalyticsGraphMetric', id: string, min?: number | null, max?: number | null, datapoints: Array<{ __typename?: 'AnalyticsFloatDatapoint', timestamp: any, value?: number | null }> } | { __typename?: 'AnalyticsIntegerMetric', id: string, details: Array<string>, integer: number, threshold: number } | { __typename?: 'AnalyticsPercentageMetric', id: string, details: Array<string>, percentage?: number | null, threshold: number } } } };

export type AnalyticsMetricDetailsQueryVariables = Exact<{
  type: AnalyticsType;
  filters: AnalyticsFiltersV2;
  id: Scalars['ID']['input'];
}>;


export type AnalyticsMetricDetailsQuery = { __typename?: 'Query', analytics: { __typename?: 'Analytics', detailTableList: Array<{ __typename?: 'AnalyticsDetailTableInfo', id: string, title?: string | null }> } };

export type AnalyticsMetricDetailsTableQueryVariables = Exact<{
  type: AnalyticsType;
  filters: AnalyticsFiltersV2;
  id: Scalars['ID']['input'];
  pageIndex: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<AnalyticsDetailSortOrder>;
  tableID: Scalars['ID']['input'];
}>;


export type AnalyticsMetricDetailsTableQuery = { __typename?: 'Query', analytics: { __typename?: 'Analytics', detail?: { __typename?: 'AnalyticsDetail', id: string, totalRows: number, pageIndex: number, pageSize: number, sortBy: string, sortOrder: AnalyticsDetailSortOrder, headers: Array<{ __typename?: 'AnalyticsDetailHeader', key: string, value: string, label?: string | null, type?: string | null, sortable?: boolean | null, detailViewOnly?: boolean | null }>, rows: Array<{ __typename?: 'AnalyticsDetailRow', columns: Array<{ __typename?: 'AnalyticsDetailColumn', key: string, value?: { __typename: 'AnalyticsDetailDate', date: any } | { __typename: 'AnalyticsDetailFloat', float: number } | { __typename: 'AnalyticsDetailFraction', value: number, total: number } | { __typename: 'AnalyticsDetailInt', integer: number } | { __typename: 'AnalyticsDetailList', items: Array<{ __typename: 'AnalyticsDetailDate', date: any } | { __typename: 'AnalyticsDetailFloat', float: number } | { __typename: 'AnalyticsDetailFraction', value: number, total: number } | { __typename: 'AnalyticsDetailInt', integer: number } | { __typename: 'AnalyticsDetailList' } | { __typename: 'AnalyticsDetailPercentage', percentage: number } | { __typename: 'AnalyticsDetailText', text: string } | { __typename: 'EvaluationForm', id: string, title: LocalizedString } | { __typename: 'EvaluationSubmission', id: string, createdAt: any } | { __typename: 'FeedbackQuestionCategory', id: string, categoryName: LocalizedString } | { __typename: 'FeedbackRequest', id: string, dueDate: any, createdAt: any, feedbackTitle: string } | { __typename: 'Goal', id: string, title: LocalizedString, createdAt: any } | { __typename: 'Group', id: string, name: string } | { __typename: 'JobTitle' } | { __typename: 'LearningEvent', id: string, title: LocalizedString, startDate: any, createdAt: any } | { __typename: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }> } | { __typename: 'AnalyticsDetailPercentage', percentage: number } | { __typename: 'AnalyticsDetailText', text: string } | { __typename: 'EvaluationForm', id: string, title: LocalizedString } | { __typename: 'EvaluationSubmission', id: string, createdAt: any } | { __typename: 'FeedbackQuestionCategory', id: string, categoryName: LocalizedString } | { __typename: 'FeedbackRequest', id: string, dueDate: any, createdAt: any, feedbackTitle: string } | { __typename: 'Goal', id: string, title: LocalizedString, createdAt: any } | { __typename: 'Group', id: string, name: string } | { __typename: 'JobTitle', id: string, title: LocalizedString } | { __typename: 'LearningEvent', id: string, title: LocalizedString, startDate: any, createdAt: any } | { __typename: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null }> }> } | null } };

export type AnnouncementFragmentFragment = { __typename?: 'Announcement', id: string, title: LocalizedString, enabled: boolean, content: LocalizedAttributedString, displayType: AnnouncementDisplayType, isRead: boolean, readAt?: any | null, createdAt: any, updatedAt?: any | null, headerImage?: { __typename?: 'AnnouncementAsset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, filters: { __typename?: 'AnnouncementFilters', superUserOnly?: boolean | null, workspaces: Array<{ __typename?: 'Workspace', id: string }>, excludedWorkspaces: Array<{ __typename?: 'Workspace', id: string }> } };

export type CreateAnnouncementMutationVariables = Exact<{
  input: CreateAnnouncementInput;
}>;


export type CreateAnnouncementMutation = { __typename?: 'Mutation', createAnnouncement: { __typename?: 'CreateAnnouncementResponse', announcement: { __typename?: 'Announcement', id: string, title: LocalizedString, enabled: boolean, content: LocalizedAttributedString, displayType: AnnouncementDisplayType, isRead: boolean, readAt?: any | null, createdAt: any, updatedAt?: any | null, headerImage?: { __typename?: 'AnnouncementAsset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, filters: { __typename?: 'AnnouncementFilters', superUserOnly?: boolean | null, workspaces: Array<{ __typename?: 'Workspace', id: string }>, excludedWorkspaces: Array<{ __typename?: 'Workspace', id: string }> } } } };

export type DeleteAnnouncementMutationVariables = Exact<{
  input: DeleteAnnouncementInput;
}>;


export type DeleteAnnouncementMutation = { __typename?: 'Mutation', deleteAnnouncement: { __typename?: 'DeleteAnnouncementResponse', success: boolean } };

export type MarkAnnouncementAsReadMutationVariables = Exact<{
  input: MarkAnnouncementAsReadInput;
}>;


export type MarkAnnouncementAsReadMutation = { __typename?: 'Mutation', markAnnouncementAsRead: { __typename?: 'MarkAnnouncementAsReadResponse', announcement?: { __typename?: 'Announcement', id: string, title: LocalizedString, enabled: boolean, content: LocalizedAttributedString, displayType: AnnouncementDisplayType, isRead: boolean, readAt?: any | null, createdAt: any, updatedAt?: any | null, headerImage?: { __typename?: 'AnnouncementAsset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, filters: { __typename?: 'AnnouncementFilters', superUserOnly?: boolean | null, workspaces: Array<{ __typename?: 'Workspace', id: string }>, excludedWorkspaces: Array<{ __typename?: 'Workspace', id: string }> } } | null } };

export type UpdateAnnouncementMutationVariables = Exact<{
  input: UpdateAnnouncementInput;
}>;


export type UpdateAnnouncementMutation = { __typename?: 'Mutation', updateAnnouncement: { __typename?: 'UpdateAnnouncementResponse', announcement: { __typename?: 'Announcement', id: string, title: LocalizedString, enabled: boolean, content: LocalizedAttributedString, displayType: AnnouncementDisplayType, isRead: boolean, readAt?: any | null, createdAt: any, updatedAt?: any | null, headerImage?: { __typename?: 'AnnouncementAsset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, filters: { __typename?: 'AnnouncementFilters', superUserOnly?: boolean | null, workspaces: Array<{ __typename?: 'Workspace', id: string }>, excludedWorkspaces: Array<{ __typename?: 'Workspace', id: string }> } } } };

export type AnnouncementQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AnnouncementQuery = { __typename?: 'Query', announcement?: { __typename?: 'Announcement', id: string, title: LocalizedString, enabled: boolean, content: LocalizedAttributedString, displayType: AnnouncementDisplayType, isRead: boolean, readAt?: any | null, createdAt: any, updatedAt?: any | null, headerImage?: { __typename?: 'AnnouncementAsset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, filters: { __typename?: 'AnnouncementFilters', superUserOnly?: boolean | null, workspaces: Array<{ __typename?: 'Workspace', id: string }>, excludedWorkspaces: Array<{ __typename?: 'Workspace', id: string }> } } | null };

export type AnnouncementsQueryVariables = Exact<{
  displayType?: InputMaybe<AnnouncementDisplayType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AnnouncementsQuery = { __typename?: 'Query', announcements: { __typename?: 'AnnouncementConnection', edges: Array<{ __typename?: 'AnnouncementEdge', cursor: string, node: { __typename?: 'Announcement', id: string, title: LocalizedString, enabled: boolean, content: LocalizedAttributedString, displayType: AnnouncementDisplayType, isRead: boolean, readAt?: any | null, createdAt: any, updatedAt?: any | null, headerImage?: { __typename?: 'AnnouncementAsset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, filters: { __typename?: 'AnnouncementFilters', superUserOnly?: boolean | null, workspaces: Array<{ __typename?: 'Workspace', id: string }>, excludedWorkspaces: Array<{ __typename?: 'Workspace', id: string }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type ChallengeFragment = { __typename?: 'Challenge', context: string, password?: { __typename?: 'PasswordChallenge', username: string } | null, newPasswordRequired?: { __typename?: 'NewPasswordRequiredChallenge', username: string } | null, singleSignOn?: { __typename?: 'SingleSignOnChallenge', url: string } | null, mfaSetup?: { __typename?: 'MfaSetupChallenge', username: string, allowedMethods: Array<MfaMethod> } | null, totpMfa?: { __typename?: 'TotpMfaChallenge', username: string } | null };

export type AssignRoleMutationVariables = Exact<{
  input: AssignRoleInput;
}>;


export type AssignRoleMutation = { __typename?: 'Mutation', assignRole: { __typename?: 'AssignRoleResponse', user: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', id: string, role: { __typename?: 'Role', id: string, type: RoleType }, target: { __typename?: 'RoleTarget', type: RoleTargetType, targetID: string } }> } } };

export type AssociateIdentityMutationVariables = Exact<{
  input: AssociateIdentityInput;
}>;


export type AssociateIdentityMutation = { __typename?: 'Mutation', associateIdentity: { __typename?: 'AssociateIdentityResponse', user: { __typename?: 'User', id: string, associatedIdentities: Array<{ __typename?: 'AssociatedIdentity', name: string, identityProvider: { __typename?: 'IdentityProvider', id: string } }> } } };

export type ConfirmForgotPasswordMutationVariables = Exact<{
  input: ConfirmForgotPasswordInput;
}>;


export type ConfirmForgotPasswordMutation = { __typename?: 'Mutation', confirmForgotPassword: { __typename?: 'ConfirmForgotPasswordResponse', success: boolean } };

export type ConsumeOAuth2CodeMutationVariables = Exact<{
  input: ConnectorConsumeOAuth2CodeInput;
}>;


export type ConsumeOAuth2CodeMutation = { __typename?: 'Mutation', connectorConsumeOAuth2Code: { __typename?: 'Connector', type: ConnectorType, isActive: boolean, authorizationInfo?: string | null, authorizeUrl?: string | null } };

export type CreateIdentityProviderMutationVariables = Exact<{
  input: CreateIdentityProviderInput;
}>;


export type CreateIdentityProviderMutation = { __typename?: 'Mutation', createIdentityProvider: { __typename?: 'CreateIdentityProviderResponse', provider: { __typename?: 'IdentityProvider', id: string } } };

export type CreatePersonalAccessTokenMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type CreatePersonalAccessTokenMutation = { __typename?: 'Mutation', createPersonalAccessToken: { __typename?: 'CreatePersonalAccessTokenResponse', id: string, token: string } };

export type CreateTemporarySessionTokenMutationVariables = Exact<{
  input: TemporarySessionTokenInput;
}>;


export type CreateTemporarySessionTokenMutation = { __typename?: 'Mutation', createTemporarySessionToken: { __typename?: 'TemporarySessionToken', workspaceID: string, userID: string, tokenID: string, expiresAt: any } };

export type DeleteIdentityProviderMutationVariables = Exact<{
  input: DeleteIdentityProviderInput;
}>;


export type DeleteIdentityProviderMutation = { __typename?: 'Mutation', deleteIdentityProvider: { __typename?: 'DeleteIdentityProviderResponse', success?: boolean | null } };

export type DisassociateIdentityMutationVariables = Exact<{
  input: DisassociateIdentityInput;
}>;


export type DisassociateIdentityMutation = { __typename?: 'Mutation', disassociateIdentity: { __typename?: 'DisassociateIdentityResponse', user: { __typename?: 'User', id: string, associatedIdentities: Array<{ __typename?: 'AssociatedIdentity', name: string, identityProvider: { __typename?: 'IdentityProvider', id: string } }> } } };

export type EnsureAssociatedIdentitiesMutationVariables = Exact<{
  input: EnsureAssociatedIdentitiesInput;
}>;


export type EnsureAssociatedIdentitiesMutation = { __typename?: 'Mutation', ensureAssociatedIdentities: { __typename?: 'EnsureAssociatedIdentitiesResponse', user: { __typename?: 'User', id: string, associatedIdentities: Array<{ __typename?: 'AssociatedIdentity', name: string, identityProvider: { __typename?: 'IdentityProvider', id: string } }> } } };

export type EnsureSupportAssociatedIdentitiesMutationVariables = Exact<{
  input: EnsureSupportAssociatedIdentitiesInput;
}>;


export type EnsureSupportAssociatedIdentitiesMutation = { __typename?: 'Mutation', ensureSupportAssociatedIdentities: { __typename?: 'EnsureSupportAssociatedIdentitiesResponse', workspace: { __typename?: 'Workspace', user?: { __typename?: 'User', id: string, associatedIdentities: Array<{ __typename?: 'AssociatedIdentity', name: string, identityProvider: { __typename?: 'IdentityProvider', id: string } }> } | null } } };

export type ExchangePersonalAccessTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ExchangePersonalAccessTokenMutation = { __typename?: 'Mutation', exchangePersonalAccessToken: { __typename?: 'ExchangePersonalAccessTokenResponse', accessToken: string, refreshToken: string, expiresAt: any, userID: string } };

export type ExchangeSessionMutationVariables = Exact<{
  input: ExchangeSessionInput;
}>;


export type ExchangeSessionMutation = { __typename?: 'Mutation', exchangeSession: { __typename?: 'ExchangeSessionResponse', session: { __typename?: 'Session', userID: string, workspaceID: string, expiresAt: any } } };

export type ForgotPasswordMutationVariables = Exact<{
  input: ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'ForgotPasswordResponse', delivery: { __typename?: 'CodeDelivery', deliveryMedium: CodeDeliveryMedium, destination: string } } };

export type ImpersonateSessionSlotMutationVariables = Exact<{
  input: ImpersonateSessionSlotInput;
}>;


export type ImpersonateSessionSlotMutation = { __typename?: 'Mutation', impersonateSessionSlot: { __typename?: 'SwitchSessionSlotResponse', success: boolean } };

export type LoginMutationVariables = Exact<{
  input: CreateSessionInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', createSession: { __typename?: 'CreateSessionResponse', challenge?: { __typename?: 'Challenge', context: string, password?: { __typename?: 'PasswordChallenge', username: string } | null, newPasswordRequired?: { __typename?: 'NewPasswordRequiredChallenge', username: string } | null, singleSignOn?: { __typename?: 'SingleSignOnChallenge', url: string } | null, mfaSetup?: { __typename?: 'MfaSetupChallenge', username: string, allowedMethods: Array<MfaMethod> } | null, totpMfa?: { __typename?: 'TotpMfaChallenge', username: string } | null } | null } };

export type MfaSetupChallengeMutationVariables = Exact<{
  input: UpdateSessionInput;
}>;


export type MfaSetupChallengeMutation = { __typename?: 'Mutation', updateSession: { __typename?: 'UpdateSessionResponse', challenge?: { __typename?: 'Challenge', context: string, password?: { __typename?: 'PasswordChallenge', username: string } | null, newPasswordRequired?: { __typename?: 'NewPasswordRequiredChallenge', username: string } | null, singleSignOn?: { __typename?: 'SingleSignOnChallenge', url: string } | null, mfaSetup?: { __typename?: 'MfaSetupChallenge', username: string, allowedMethods: Array<MfaMethod> } | null, totpMfa?: { __typename?: 'TotpMfaChallenge', username: string } | null } | null, session?: { __typename?: 'Session', userID: string, workspaceID: string, expiresAt: any } | null } };

export type NewPasswordRequiredChallengeMutationVariables = Exact<{
  input: UpdateSessionInput;
}>;


export type NewPasswordRequiredChallengeMutation = { __typename?: 'Mutation', updateSession: { __typename?: 'UpdateSessionResponse', challenge?: { __typename?: 'Challenge', context: string, password?: { __typename?: 'PasswordChallenge', username: string } | null, newPasswordRequired?: { __typename?: 'NewPasswordRequiredChallenge', username: string } | null, singleSignOn?: { __typename?: 'SingleSignOnChallenge', url: string } | null, mfaSetup?: { __typename?: 'MfaSetupChallenge', username: string, allowedMethods: Array<MfaMethod> } | null, totpMfa?: { __typename?: 'TotpMfaChallenge', username: string } | null } | null, session?: { __typename?: 'Session', userID: string, workspaceID: string, expiresAt: any } | null } };

export type PasswordChallengeMutationVariables = Exact<{
  input: UpdateSessionInput;
}>;


export type PasswordChallengeMutation = { __typename?: 'Mutation', updateSession: { __typename?: 'UpdateSessionResponse', challenge?: { __typename?: 'Challenge', context: string, password?: { __typename?: 'PasswordChallenge', username: string } | null, newPasswordRequired?: { __typename?: 'NewPasswordRequiredChallenge', username: string } | null, singleSignOn?: { __typename?: 'SingleSignOnChallenge', url: string } | null, mfaSetup?: { __typename?: 'MfaSetupChallenge', username: string, allowedMethods: Array<MfaMethod> } | null, totpMfa?: { __typename?: 'TotpMfaChallenge', username: string } | null } | null, session?: { __typename?: 'Session', userID: string, workspaceID: string, expiresAt: any } | null } };

export type PreloginMutationVariables = Exact<{
  input: PreloginInput;
}>;


export type PreloginMutation = { __typename?: 'Mutation', prelogin: { __typename?: 'PreloginResponse', url: string } };

export type RefreshSessionMutationVariables = Exact<{
  input: RefreshSessionInput;
}>;


export type RefreshSessionMutation = { __typename?: 'Mutation', refreshSession: { __typename?: 'RefreshSessionResponse', session?: { __typename?: 'Session', userID: string, workspaceID: string, expiresAt: any } | null } };

export type RenewPersonalAccessTokenMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type RenewPersonalAccessTokenMutation = { __typename?: 'Mutation', renewPersonalAccessToken: { __typename?: 'CreatePersonalAccessTokenResponse', id: string, token: string } };

export type ResendTemporaryPasswordMutationVariables = Exact<{
  input: ResendTemporaryPasswordInput;
}>;


export type ResendTemporaryPasswordMutation = { __typename?: 'Mutation', resendTemporaryPassword: { __typename?: 'ResendTemporaryPasswordResponse', delivery: { __typename?: 'CodeDelivery', deliveryMedium: CodeDeliveryMedium, destination: string } } };

export type RevokePersonalAccessTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RevokePersonalAccessTokenMutation = { __typename?: 'Mutation', revokePersonalAccessToken: string };

export type RevokeRoleMutationVariables = Exact<{
  input: RevokeRoleInput;
}>;


export type RevokeRoleMutation = { __typename?: 'Mutation', revokeRole: { __typename?: 'RevokeRoleResponse', user: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', id: string, role: { __typename?: 'Role', id: string, type: RoleType }, target: { __typename?: 'RoleTarget', type: RoleTargetType, targetID: string } }> } } };

export type SendTemporaryPasswordMutationVariables = Exact<{
  input: SendTemporaryPasswordInput;
}>;


export type SendTemporaryPasswordMutation = { __typename?: 'Mutation', sendTemporaryPassword: { __typename?: 'SendTemporaryPasswordResponse', delivery: { __typename?: 'CodeDelivery', deliveryMedium: CodeDeliveryMedium, destination: string } } };

export type SignOutSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type SignOutSessionMutation = { __typename?: 'Mutation', signOutSession: { __typename?: 'SignOutSessionResponse', success: boolean } };

export type SlackConsumeOAuth2CodeMutationVariables = Exact<{
  input: SlackConsumeOAuth2CodeInput;
}>;


export type SlackConsumeOAuth2CodeMutation = { __typename?: 'Mutation', slackConsumeOAuth2Code: { __typename?: 'SlackConsumeOAuth2CodeResponse', config: { __typename?: 'SlackConfig', id: string, isConfigured: boolean, authorizeUrl?: string | null, wantedScopes: Array<string>, configuredScopes: Array<string>, team?: { __typename?: 'SlackTeam', id: string, name: string } | null } } };

export type SwitchImpersonatedSessionSlotMutationVariables = Exact<{
  input: SwitchSessionSlotInput;
}>;


export type SwitchImpersonatedSessionSlotMutation = { __typename?: 'Mutation', switchImpersonatedSessionSlot: { __typename?: 'SwitchSessionSlotResponse', success: boolean } };

export type SwitchSessionSlotMutationVariables = Exact<{
  input: SwitchSessionSlotInput;
}>;


export type SwitchSessionSlotMutation = { __typename?: 'Mutation', switchSessionSlot: { __typename?: 'SwitchSessionSlotResponse', success: boolean } };

export type TotpMfaChallengeMutationVariables = Exact<{
  input: UpdateSessionInput;
}>;


export type TotpMfaChallengeMutation = { __typename?: 'Mutation', updateSession: { __typename?: 'UpdateSessionResponse', challenge?: { __typename?: 'Challenge', context: string, password?: { __typename?: 'PasswordChallenge', username: string } | null, newPasswordRequired?: { __typename?: 'NewPasswordRequiredChallenge', username: string } | null, singleSignOn?: { __typename?: 'SingleSignOnChallenge', url: string } | null, mfaSetup?: { __typename?: 'MfaSetupChallenge', username: string, allowedMethods: Array<MfaMethod> } | null, totpMfa?: { __typename?: 'TotpMfaChallenge', username: string } | null } | null, session?: { __typename?: 'Session', userID: string, workspaceID: string, expiresAt: any } | null } };

export type UpdateIdentityProviderMutationVariables = Exact<{
  input: UpdateIdentityProviderInput;
}>;


export type UpdateIdentityProviderMutation = { __typename?: 'Mutation', updateIdentityProvider: { __typename?: 'UpdateIdentityProviderResponse', provider: { __typename?: 'IdentityProvider', id: string } } };

export type UpdateIdentityProviderConfigurationMutationVariables = Exact<{
  input: UpdateIdentityProviderConfigurationInput;
}>;


export type UpdateIdentityProviderConfigurationMutation = { __typename?: 'Mutation', updateIdentityProviderConfiguration: { __typename?: 'UpdateIdentityProviderConfigurationResponse', provider: { __typename?: 'IdentityProvider', id: string, configuration?: { __typename?: 'IdentityProviderConfiguration', name?: string | null, domains?: Array<string> | null } | null } } };

export type VerifySessionMutationVariables = Exact<{
  input: VerifySessionInput;
}>;


export type VerifySessionMutation = { __typename?: 'Mutation', verifySession: { __typename?: 'VerifySessionResponse', user: { __typename?: 'User', id: string } } };

export type FailedSsoAttemptsQueryVariables = Exact<{
  externalID?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FailedSsoAttemptsQuery = { __typename?: 'Query', failedSsoAttempts: { __typename?: 'FailedSsoAttemptConnection', edges: Array<{ __typename?: 'FailedSsoAttemptEdge', cursor: string, node: { __typename?: 'FailedSsoAttempt', id: string, externalID: string, occurredAt: any } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type IdentityProviderSettingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IdentityProviderSettingsQuery = { __typename?: 'Query', identityProvider: { __typename?: 'IdentityProvider', id: string, metadataFile?: string | null, metadataURL?: string | null, configuration?: { __typename?: 'IdentityProviderConfiguration', name?: string | null, domains?: Array<string> | null } | null } };

export type IdentityProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentityProvidersQuery = { __typename?: 'Query', identityProviders: Array<{ __typename?: 'IdentityProvider', id: string, configuration?: { __typename?: 'IdentityProviderConfiguration', name?: string | null } | null }> };

export type IdentityProvidersSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentityProvidersSettingsQuery = { __typename?: 'Query', identityProviders: Array<{ __typename?: 'IdentityProvider', id: string, metadataFile?: string | null, metadataURL?: string | null, configuration?: { __typename?: 'IdentityProviderConfiguration', name?: string | null } | null }> };

export type PersonalAccessTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonalAccessTokenQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, personalAccessToken?: { __typename?: 'PersonalAccessToken', id: string, createdAt: any } | null } };

export type RolesQueryVariables = Exact<{
  target?: InputMaybe<RoleTargetType>;
}>;


export type RolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string }> };

export type SelfServiceIdentityProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type SelfServiceIdentityProvidersQuery = { __typename?: 'Query', identityProviders: Array<{ __typename?: 'IdentityProvider', id: string }>, serviceProvider: { __typename?: 'ServiceProvider', entityID: string, acsURL: string, metadataURL: string } };

export type SessionSlotsQueryVariables = Exact<{ [key: string]: never; }>;


export type SessionSlotsQuery = { __typename?: 'Query', sessionSlots: Array<{ __typename?: 'SessionSlot', userID: string, active: boolean, impersonated?: boolean | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } }> };

export type CareerPartialFragment = { __typename?: 'Career', id: string, title: LocalizedString, isArchived: boolean, expertise: { __typename?: 'Expertise', id: string, title: LocalizedString }, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null }> };

export type ExpertisePartialFragment = { __typename?: 'Expertise', id: string, title: LocalizedString, isArchived: boolean, careers: Array<{ __typename?: 'Career', id: string, title: LocalizedString }> };

export type JobCompetencyFragment = { __typename?: 'JobCompetency', id: string, competencyLevel: number, description?: LocalizedAttributedString | null, order?: number | null, level?: { __typename?: 'JobLevel', id: string, title: LocalizedString } | null, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> }, label?: { __typename?: 'Label', id: string, title: LocalizedString } | null };

export type ArchiveCareerMutationVariables = Exact<{
  input: CareerArchiveInput;
}>;


export type ArchiveCareerMutation = { __typename?: 'Mutation', archiveCareer: { __typename?: 'Career', id: string } };

export type ArchiveCompetencyMutationVariables = Exact<{
  input: ArchiveCompetencyInput;
}>;


export type ArchiveCompetencyMutation = { __typename?: 'Mutation', archiveCompetency: { __typename?: 'ArchiveCompetencyResponse', competency: { __typename?: 'Competency', id: string, isArchived: boolean } } };

export type ArchiveCompetencyLevelSetMutationVariables = Exact<{
  input: ArchiveCompetencyLevelSetInput;
}>;


export type ArchiveCompetencyLevelSetMutation = { __typename?: 'Mutation', archiveCompetencyLevelSet: { __typename?: 'ArchiveCompetencyLevelSetResponse', competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, isArchived: boolean } } };

export type ArchiveExpertiseMutationVariables = Exact<{
  input: ArchiveExpertiseInput;
}>;


export type ArchiveExpertiseMutation = { __typename?: 'Mutation', archiveExpertise: { __typename?: 'Expertise', id: string } };

export type ArchiveJobLevelMutationVariables = Exact<{
  input: ArchiveJobLevelInput;
}>;


export type ArchiveJobLevelMutation = { __typename?: 'Mutation', archiveJobLevel: { __typename?: 'ArchiveJobLevelResponse', jobLevel: { __typename?: 'JobLevel', id: string, isArchived: boolean } } };

export type AttachJobCompetencyMutationVariables = Exact<{
  input: AttachJobCompetencyInput;
}>;


export type AttachJobCompetencyMutation = { __typename?: 'Mutation', attachJobCompetency: { __typename?: 'AttachJobCompetencyResponse', jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, isArchived: boolean, externalReferenceID?: string | null, isKeyPosition: boolean, keyPositionMarkedAt?: any | null, viewerCanManageSuccession: boolean, keyPositionMarkedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, competencies: Array<{ __typename?: 'JobCompetency', id: string, competencyLevel: number, description?: LocalizedAttributedString | null, order?: number | null, level?: { __typename?: 'JobLevel', id: string, title: LocalizedString } | null, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> }, label?: { __typename?: 'Label', id: string, title: LocalizedString } | null }>, goalTemplates: { __typename?: 'GoalTemplateConnection', edges: Array<{ __typename?: 'GoalTemplateEdge', cursor: string, node: { __typename?: 'GoalTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, isArchived: boolean, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }> } }> } } } };

export type CreateCareerMutationVariables = Exact<{
  input: CareerCreateInput;
}>;


export type CreateCareerMutation = { __typename?: 'Mutation', createCareer: { __typename?: 'Career', id: string, title: LocalizedString, isArchived: boolean, expertise: { __typename?: 'Expertise', id: string, title: LocalizedString }, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null }> } };

export type CreateCompetencyMutationVariables = Exact<{
  input: CreateCompetencyInput;
}>;


export type CreateCompetencyMutation = { __typename?: 'Mutation', createCompetency: { __typename?: 'CreateCompetencyResponse', competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString }, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }> } } };

export type CreateCompetencyLevelSetMutationVariables = Exact<{
  input: CreateCompetencyLevelSetInput;
}>;


export type CreateCompetencyLevelSetMutation = { __typename?: 'Mutation', createCompetencyLevelSet: { __typename?: 'CreateCompetencyLevelSetResponse', competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } };

export type CreateExpertiseMutationVariables = Exact<{
  input: ExpertiseCreateInput;
}>;


export type CreateExpertiseMutation = { __typename?: 'Mutation', createExpertise: { __typename?: 'Expertise', id: string, title: LocalizedString, isArchived: boolean, careers: Array<{ __typename?: 'Career', id: string, title: LocalizedString }> } };

export type CreateJobLevelMutationVariables = Exact<{
  input: CreateJobLevelInput;
}>;


export type CreateJobLevelMutation = { __typename?: 'Mutation', createJobLevel: { __typename?: 'CreateJobLevelResponse', jobLevel: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } } };

export type DetachJobCompetencyMutationVariables = Exact<{
  input: DetachJobCompetencyInput;
}>;


export type DetachJobCompetencyMutation = { __typename?: 'Mutation', detachJobCompetency: { __typename?: 'DetachJobCompetencyResponse', jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, isArchived: boolean, externalReferenceID?: string | null, isKeyPosition: boolean, keyPositionMarkedAt?: any | null, viewerCanManageSuccession: boolean, keyPositionMarkedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, competencies: Array<{ __typename?: 'JobCompetency', id: string, competencyLevel: number, description?: LocalizedAttributedString | null, order?: number | null, level?: { __typename?: 'JobLevel', id: string, title: LocalizedString } | null, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> }, label?: { __typename?: 'Label', id: string, title: LocalizedString } | null }>, goalTemplates: { __typename?: 'GoalTemplateConnection', edges: Array<{ __typename?: 'GoalTemplateEdge', cursor: string, node: { __typename?: 'GoalTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, isArchived: boolean, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }> } }> } } } };

export type RestoreCareerMutationVariables = Exact<{
  input: CareerRestoreInput;
}>;


export type RestoreCareerMutation = { __typename?: 'Mutation', restoreCareer: { __typename?: 'Career', id: string, title: LocalizedString, isArchived: boolean, expertise: { __typename?: 'Expertise', id: string, title: LocalizedString }, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null }> } };

export type RestoreCompetencyMutationVariables = Exact<{
  input: RestoreCompetencyInput;
}>;


export type RestoreCompetencyMutation = { __typename?: 'Mutation', restoreCompetency: { __typename?: 'RestoreCompetencyResponse', competency: { __typename?: 'Competency', id: string, isArchived: boolean } } };

export type RestoreCompetencyLevelSetMutationVariables = Exact<{
  input: RestoreCompetencyLevelSetInput;
}>;


export type RestoreCompetencyLevelSetMutation = { __typename?: 'Mutation', restoreCompetencyLevelSet: { __typename?: 'RestoreCompetencyLevelSetResponse', competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, isArchived: boolean } } };

export type RestoreExpertiseMutationVariables = Exact<{
  input: RestoreExpertiseInput;
}>;


export type RestoreExpertiseMutation = { __typename?: 'Mutation', restoreExpertise: { __typename?: 'Expertise', id: string, title: LocalizedString, isArchived: boolean, careers: Array<{ __typename?: 'Career', id: string, title: LocalizedString }> } };

export type RestoreJobLevelMutationVariables = Exact<{
  input: RestoreJobLevelInput;
}>;


export type RestoreJobLevelMutation = { __typename?: 'Mutation', restoreJobLevel: { __typename?: 'RestoreJobLevelResponse', jobLevel: { __typename?: 'JobLevel', id: string, isArchived: boolean } } };

export type UpdateCareerMutationVariables = Exact<{
  input: CareerUpdateInput;
}>;


export type UpdateCareerMutation = { __typename?: 'Mutation', updateCareer: { __typename?: 'Career', id: string, title: LocalizedString, isArchived: boolean, expertise: { __typename?: 'Expertise', id: string, title: LocalizedString }, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null }> } };

export type UpdateCompetencyMutationVariables = Exact<{
  input: UpdateCompetencyInput;
}>;


export type UpdateCompetencyMutation = { __typename?: 'Mutation', updateCompetency: { __typename?: 'UpdateCompetencyResponse', competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, attachableToGoal: boolean, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean }, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }> } } };

export type UpdateCompetencyLevelSetMutationVariables = Exact<{
  input: UpdateCompetencyLevelSetInput;
}>;


export type UpdateCompetencyLevelSetMutation = { __typename?: 'Mutation', updateCompetencyLevelSet: { __typename?: 'UpdateCompetencyLevelSetResponse', competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } };

export type UpdateExpertiseMutationVariables = Exact<{
  input: ExpertiseUpdateInput;
}>;


export type UpdateExpertiseMutation = { __typename?: 'Mutation', updateExpertise: { __typename?: 'Expertise', id: string, title: LocalizedString, isArchived: boolean, careers: Array<{ __typename?: 'Career', id: string, title: LocalizedString }> } };

export type UpdateJobLevelMutationVariables = Exact<{
  input: UpdateJobLevelInput;
}>;


export type UpdateJobLevelMutation = { __typename?: 'Mutation', updateJobLevel: { __typename?: 'UpdateJobLevelResponse', jobLevel: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } } };

export type CareerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CareerQuery = { __typename?: 'Query', career: { __typename?: 'Career', id: string, title: LocalizedString, isArchived: boolean, expertise: { __typename?: 'Expertise', id: string, title: LocalizedString }, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null }> } };

export type CareersQueryVariables = Exact<{
  isArchived: Scalars['Boolean']['input'];
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CareersQuery = { __typename?: 'Query', careers: { __typename?: 'CareersConnection', edges: Array<{ __typename?: 'CareersEdge', cursor: string, node: { __typename?: 'Career', id: string, title: LocalizedString, isArchived: boolean, expertise: { __typename?: 'Expertise', id: string, title: LocalizedString }, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type CompetenciesWithLevelsQueryVariables = Exact<{
  isArchived: Scalars['Boolean']['input'];
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompetenciesWithLevelsQuery = { __typename?: 'Query', competencies: { __typename?: 'CompetencyConnection', edges: Array<{ __typename?: 'CompetencyEdge', cursor: string, node: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, attachableToGoal: boolean, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type CompetencyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompetencyQuery = { __typename?: 'Query', competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, attachableToGoal: boolean, isArchived: boolean, styrSkillID?: string | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }>, jobCompetencies: Array<{ __typename?: 'JobCompetency', id: string, description?: LocalizedAttributedString | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, styrData?: { __typename?: 'StyrData', jobID: string } | null } }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null } | null } };

export type CompetencyAppraisalsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompetencyAppraisalsQuery = { __typename?: 'Query', competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, appraisals: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number, user: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, group: { __typename?: 'Group', name: string }, jobPositions: Array<{ __typename?: 'JobPosition', jobTitle: { __typename?: 'JobTitle', title: LocalizedString } }> } }> } };

export type CompetencyLevelSetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CompetencyLevelSetQuery = { __typename?: 'Query', competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } };

export type CompetencyLevelSetsQueryVariables = Exact<{
  isArchived: Scalars['Boolean']['input'];
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompetencyLevelSetsQuery = { __typename?: 'Query', competencyLevelSets: { __typename?: 'CompetencyLevelSetConnection', edges: Array<{ __typename?: 'CompetencyLevelSetEdge', cursor: string, node: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type ExpertiseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ExpertiseQuery = { __typename?: 'Query', expertise: { __typename?: 'Expertise', id: string, title: LocalizedString, isArchived: boolean, careers: Array<{ __typename?: 'Career', id: string, title: LocalizedString }> } };

export type JobLevelQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type JobLevelQuery = { __typename?: 'Query', jobLevel: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } };

export type JobLevelsQueryVariables = Exact<{
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
}>;


export type JobLevelsQuery = { __typename?: 'Query', jobLevels: { __typename?: 'JobLevelConnection', edges: Array<{ __typename?: 'JobLevelEdge', cursor: string, node: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type PaginatedExpertisesQueryVariables = Exact<{
  isArchived: Scalars['Boolean']['input'];
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaginatedExpertisesQuery = { __typename?: 'Query', paginatedExpertises: { __typename?: 'ExpertiseConnection', edges: Array<{ __typename?: 'ExpertiseEdge', cursor: string, node: { __typename?: 'Expertise', id: string, title: LocalizedString, isArchived: boolean, careers: Array<{ __typename?: 'Career', id: string, title: LocalizedString }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type ApiUserFragment = { __typename?: 'ApiUser', id: string, apiKey: string, createdAt: any, secretCreatedAt?: any | null, permissions: Array<string> };

export type ConnectorWithConfigFragment = { __typename?: 'Connector', id: string, isActive: boolean, type: ConnectorType, config: Array<{ __typename?: 'ConnectorConfigFieldBoolean', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, isDangerous: boolean, boolean?: boolean | null } | { __typename?: 'ConnectorConfigFieldDate', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, date?: any | null } | { __typename?: 'ConnectorConfigFieldFilter', id: string, key: string, isConfigured: boolean, type: ConnectorConfigFieldType, whitelist: boolean } | { __typename?: 'ConnectorConfigFieldMultiSelect', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, values?: Array<string> | null, options?: Array<{ __typename?: 'ConnectorSelectOption', label: string, value: string }> | null } | { __typename?: 'ConnectorConfigFieldOAuth2', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, authorizeUrl: string, authorizationInfo?: string | null } | { __typename?: 'ConnectorConfigFieldSelect', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, value?: string | null } | { __typename?: 'ConnectorConfigFieldText', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, isSecret: boolean, text?: string | null }> };

export type ArchiveApiUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveApiUserMutation = { __typename?: 'Mutation', archiveApiUser: string };

export type AutoLinkSlackIdentitiesMutationVariables = Exact<{ [key: string]: never; }>;


export type AutoLinkSlackIdentitiesMutation = { __typename?: 'Mutation', autoLinkSlackIdentities: { __typename?: 'AutoLinkSlackIdentitiesResponse', success: boolean } };

export type CreateApiUserMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateApiUserMutation = { __typename?: 'Mutation', createApiUser: { __typename?: 'ApiUserCredentials', apiSecret: string, user: { __typename?: 'ApiUser', id: string, apiKey: string, createdAt: any, secretCreatedAt?: any | null, permissions: Array<string> } } };

export type MicrosoftConnectMutationVariables = Exact<{
  integration: MicrosoftIntegration;
}>;


export type MicrosoftConnectMutation = { __typename?: 'Mutation', microsoftConnect: string };

export type MicrosoftDisconnectMutationVariables = Exact<{
  integration: MicrosoftIntegration;
}>;


export type MicrosoftDisconnectMutation = { __typename?: 'Mutation', microsoftDisconnect?: { __typename?: 'MicrosoftConfig', id: string, isConfigured: boolean, tenantId?: string | null, teamsConnected: boolean, outlookConnected: boolean, teamsRequiresReconsent: boolean, outlookRequiresReconsent: boolean } | null };

export type QueueConnectorMutationVariables = Exact<{ [key: string]: never; }>;


export type QueueConnectorMutation = { __typename?: 'Mutation', queueConnector: boolean };

export type QueueConnectorTwoWayRetrospectMutationVariables = Exact<{ [key: string]: never; }>;


export type QueueConnectorTwoWayRetrospectMutation = { __typename?: 'Mutation', queueConnectorTwoWayRetrospect: boolean };

export type RegenerateApiUserSecretMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RegenerateApiUserSecretMutation = { __typename?: 'Mutation', regenerateApiUserSecret: { __typename?: 'ApiUserCredentials', apiSecret: string, user: { __typename?: 'ApiUser', id: string, apiKey: string, createdAt: any, secretCreatedAt?: any | null, permissions: Array<string> } } };

export type SetupConnectorMutationVariables = Exact<{
  input: SetupConnectorInput;
}>;


export type SetupConnectorMutation = { __typename?: 'Mutation', setupConnector: { __typename?: 'SetupConnectorResponse', workspace: { __typename?: 'Workspace', connector?: { __typename?: 'Connector', id: string, isActive: boolean, type: ConnectorType, config: Array<{ __typename?: 'ConnectorConfigFieldBoolean', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, isDangerous: boolean, boolean?: boolean | null } | { __typename?: 'ConnectorConfigFieldDate', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, date?: any | null } | { __typename?: 'ConnectorConfigFieldFilter', id: string, key: string, isConfigured: boolean, type: ConnectorConfigFieldType, whitelist: boolean } | { __typename?: 'ConnectorConfigFieldMultiSelect', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, values?: Array<string> | null, options?: Array<{ __typename?: 'ConnectorSelectOption', label: string, value: string }> | null } | { __typename?: 'ConnectorConfigFieldOAuth2', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, authorizeUrl: string, authorizationInfo?: string | null } | { __typename?: 'ConnectorConfigFieldSelect', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, value?: string | null } | { __typename?: 'ConnectorConfigFieldText', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, isSecret: boolean, text?: string | null }> } | null } } };

export type UpdateApiUserPermissionsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  permissions: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateApiUserPermissionsMutation = { __typename?: 'Mutation', updateApiUserPermissions: { __typename?: 'ApiUser', id: string, apiKey: string, createdAt: any, secretCreatedAt?: any | null, permissions: Array<string> } };

export type UpdateMcpRemoteSettingsMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
}>;


export type UpdateMcpRemoteSettingsMutation = { __typename?: 'Mutation', updateMcpRemoteSettings: { __typename?: 'McpRemoteSettings', enabled: boolean } };

export type ApiUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiUsersQuery = { __typename?: 'Query', apiUsers: Array<{ __typename?: 'ApiUser', id: string, apiKey: string, createdAt: any, secretCreatedAt?: any | null, permissions: Array<string> }> };

export type ConnectorConfigFieldQueryVariables = Exact<{
  connectorType: ConnectorType;
  key: Scalars['String']['input'];
}>;


export type ConnectorConfigFieldQuery = { __typename?: 'Query', connectorConfigField?: { __typename?: 'ConnectorConfigFieldBoolean', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, boolean?: boolean | null } | { __typename?: 'ConnectorConfigFieldDate', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, date?: any | null } | { __typename?: 'ConnectorConfigFieldFilter', id: string, key: string, isConfigured: boolean, type: ConnectorConfigFieldType, whitelist: boolean, available: Array<{ __typename?: 'ConnectorFilterAvailableRule', type: ConnectorFilterRuleType, fields?: Array<string> | null, options?: Array<{ __typename?: 'ConnectorSelectOption', label: string, value: string }> | null }>, configured: Array<{ __typename?: 'ConnectorFilterRule', type: ConnectorFilterRuleType, field?: string | null, values: Array<string> }> } | { __typename?: 'ConnectorConfigFieldMultiSelect', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, values?: Array<string> | null, options?: Array<{ __typename?: 'ConnectorSelectOption', label: string, value: string }> | null } | { __typename?: 'ConnectorConfigFieldOAuth2', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, authorizeUrl: string, authorizationInfo?: string | null } | { __typename?: 'ConnectorConfigFieldSelect', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, value?: string | null, options?: Array<{ __typename?: 'ConnectorSelectOption', label: string, value: string }> | null } | { __typename?: 'ConnectorConfigFieldText', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, isSecret: boolean, text?: string | null } | null };

export type ConnectorLogsQueryVariables = Exact<{
  date: Scalars['String']['input'];
  minimumLogLevel?: InputMaybe<ConnectorLogLevel>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ConnectorLogsQuery = { __typename?: 'Query', connectorLogs: { __typename?: 'ConnectorLogConnection', edges: Array<{ __typename?: 'ConnectorLogEdge', node: { __typename?: 'ConnectorLog', id: string, timestamp: any, logLevel: ConnectorLogLevel, message: string, errorType?: ConnectorErrorType | null, metadata?: { __typename?: 'ConnectorLogMetadata', user: { __typename?: 'ConnectorLogMetadataUser', externalReferenceID: string, username: string, email: string } } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type ConnectorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectorsQuery = { __typename?: 'Query', connectors: Array<{ __typename?: 'Connector', type: ConnectorType, isActive: boolean, authorizationInfo?: string | null, authorizeUrl?: string | null }> };

export type MarketplaceQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketplaceQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, workspace: { __typename?: 'Workspace', id: string, connector?: { __typename?: 'Connector', id: string, type: ConnectorType } | null, styrConfig?: { __typename?: 'StyrConfig', organisationID: string } | null, goodHabitzConfig?: { __typename?: 'GoodHabitzConfig', enabled: boolean } | null } } };

export type McpRemoteSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type McpRemoteSettingsQuery = { __typename?: 'Query', mcpRemoteSettings: { __typename?: 'McpRemoteSettings', enabled: boolean, connectionUrl: string } };

export type MicrosoftConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type MicrosoftConfigQuery = { __typename?: 'Query', viewer: { __typename?: 'User', workspace: { __typename?: 'Workspace', microsoftConfig?: { __typename?: 'MicrosoftConfig', id: string, isConfigured: boolean, tenantId?: string | null, teamsConnected: boolean, outlookConnected: boolean, teamsRequiresReconsent: boolean, outlookRequiresReconsent: boolean } | null } } };

export type SlackConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type SlackConfigQuery = { __typename?: 'Query', viewer: { __typename?: 'User', workspace: { __typename?: 'Workspace', slackConfig?: { __typename?: 'SlackConfig', id: string, isConfigured: boolean, authorizeUrl?: string | null, wantedScopes: Array<string>, configuredScopes: Array<string>, team?: { __typename?: 'SlackTeam', id: string, name: string } | null } | null } } };

export type StyrOrganisationsQueryVariables = Exact<{ [key: string]: never; }>;


export type StyrOrganisationsQuery = { __typename?: 'Query', styrOrganisations: Array<{ __typename?: 'StyrOrganisation', id: string, name: string }> };

export type EvaluationFormFragment = { __typename?: 'EvaluationForm', id: string, title: LocalizedString, description?: LocalizedAttributedString | null };

export type EvaluationFormEditorFragment = { __typename?: 'EvaluationForm', id: string, isArchived: boolean, title: LocalizedString, description?: LocalizedAttributedString | null, jobTitleIDs?: Array<string> | null, useOnlyInCycle?: boolean | null, showAnswersWhenAllUsersShared?: boolean | null, sections: Array<{ __typename?: 'EvaluationFormSection', weight?: number | null, items: Array<{ __typename?: 'EvaluationSectionItem', id: string, type: EvaluationSectionItemType, fillInBy: EvaluationFillInBy, optional?: boolean | null, title?: { __typename?: 'EvaluationTitleItem', text: LocalizedString } | null, paragraph?: { __typename?: 'EvaluationParagraphItem', text: LocalizedAttributedString } | null, stars?: { __typename?: 'EvaluationStarsItem', title: LocalizedString } | null, openQuestion?: { __typename?: 'EvaluationOpenQuestionItem', title: LocalizedString } | null, sentiment?: { __typename?: 'EvaluationSentimentItem', title: LocalizedString, displayMethod: EvaluationSentimentDisplayMethod } | null, developmentPlan?: { __typename?: 'EvaluationDevelopmentPlanItem', title: LocalizedString } | null, competency?: { __typename?: 'EvaluationCompetencyItem', weight: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean }, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, multipleChoice?: { __typename?: 'EvaluationMultipleChoiceItem', title: LocalizedString } | null, reviewGoals?: { __typename?: 'EvaluationReviewGoalsItem', defaultExplanation?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } | null, finalScore?: { __typename?: 'EvaluationFinalScoreItem', calculationMethod: EvaluationFinalScoreCalculationMethod, title?: LocalizedString | null, includeReviewGoals: boolean, scoreFormat: EvaluationFinalScoreFormat, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, displayLevelSet?: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } | null } | null, signature?: { __typename?: 'EvaluationSignatureItem', title?: LocalizedString | null } | null, setGoals?: { __typename?: 'EvaluationSetGoalsItem', title: LocalizedString } | null }> }> };

export type ArchiveEvaluationFormMutationVariables = Exact<{
  input: ArchiveEvaluationFormInput;
}>;


export type ArchiveEvaluationFormMutation = { __typename?: 'Mutation', archiveEvaluationForm: { __typename?: 'ArchiveEvaluationFormResponse', evaluationForm: { __typename?: 'EvaluationForm', id: string, isArchived: boolean, title: LocalizedString, description?: LocalizedAttributedString | null, jobTitleIDs?: Array<string> | null, useOnlyInCycle?: boolean | null, showAnswersWhenAllUsersShared?: boolean | null, sections: Array<{ __typename?: 'EvaluationFormSection', weight?: number | null, items: Array<{ __typename?: 'EvaluationSectionItem', id: string, type: EvaluationSectionItemType, fillInBy: EvaluationFillInBy, optional?: boolean | null, title?: { __typename?: 'EvaluationTitleItem', text: LocalizedString } | null, paragraph?: { __typename?: 'EvaluationParagraphItem', text: LocalizedAttributedString } | null, stars?: { __typename?: 'EvaluationStarsItem', title: LocalizedString } | null, openQuestion?: { __typename?: 'EvaluationOpenQuestionItem', title: LocalizedString } | null, sentiment?: { __typename?: 'EvaluationSentimentItem', title: LocalizedString, displayMethod: EvaluationSentimentDisplayMethod } | null, developmentPlan?: { __typename?: 'EvaluationDevelopmentPlanItem', title: LocalizedString } | null, competency?: { __typename?: 'EvaluationCompetencyItem', weight: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean }, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, multipleChoice?: { __typename?: 'EvaluationMultipleChoiceItem', title: LocalizedString } | null, reviewGoals?: { __typename?: 'EvaluationReviewGoalsItem', defaultExplanation?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } | null, finalScore?: { __typename?: 'EvaluationFinalScoreItem', calculationMethod: EvaluationFinalScoreCalculationMethod, title?: LocalizedString | null, includeReviewGoals: boolean, scoreFormat: EvaluationFinalScoreFormat, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, displayLevelSet?: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } | null } | null, signature?: { __typename?: 'EvaluationSignatureItem', title?: LocalizedString | null } | null, setGoals?: { __typename?: 'EvaluationSetGoalsItem', title: LocalizedString } | null }> }> } } };

export type ChangeConversationPartnerMutationVariables = Exact<{
  input: ChangeConversationPartnerInput;
}>;


export type ChangeConversationPartnerMutation = { __typename?: 'Mutation', changeConversationPartner: { __typename?: 'ChangeConversationPartnerResponse', evaluationSubmission: { __typename?: 'EvaluationSubmission', id: string, deadline: any, overrideReason?: string | null, viewerCanChangeConversationPartner: boolean, viewerCanDiscardAnswersFromPredecessor: boolean, viewerCanOverrideScore: boolean, isArchived: boolean, aiInsightsApproved: boolean, employee: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, manager: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, viewer: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString, description?: LocalizedAttributedString | null, sections: Array<{ __typename?: 'EvaluationFormSection', items: Array<{ __typename?: 'EvaluationSectionItem', id: string, type: EvaluationSectionItemType, fillInBy: EvaluationFillInBy, optional?: boolean | null, title?: { __typename?: 'EvaluationTitleItem', text: LocalizedString } | null, paragraph?: { __typename?: 'EvaluationParagraphItem', text: LocalizedAttributedString } | null, stars?: { __typename?: 'EvaluationStarsItem', title: LocalizedString } | null, openQuestion?: { __typename?: 'EvaluationOpenQuestionItem', title: LocalizedString } | null, developmentPlan?: { __typename?: 'EvaluationDevelopmentPlanItem', title: LocalizedString } | null, sentiment?: { __typename?: 'EvaluationSentimentItem', title: LocalizedString, displayMethod: EvaluationSentimentDisplayMethod } | null, competency?: { __typename?: 'EvaluationCompetencyItem', weight: number, competency: { __typename?: 'Competency', title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', title: LocalizedString } }> } } | null, multipleChoice?: { __typename?: 'EvaluationMultipleChoiceItem', title: LocalizedString } | null, finalScore?: { __typename?: 'EvaluationFinalScoreItem', title?: LocalizedString | null, calculationMethod: EvaluationFinalScoreCalculationMethod, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, displayLevelSet?: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } | null } | null, reviewGoals?: { __typename?: 'EvaluationReviewGoalsItem', defaultExplanation?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } | null, signature?: { __typename?: 'EvaluationSignatureItem', title?: LocalizedString | null } | null, setGoals?: { __typename?: 'EvaluationSetGoalsItem', title: LocalizedString } | null }> }> }, goals?: Array<{ __typename?: 'EvaluationSubmissionGoal', title: LocalizedString, dueDate?: any | null, progress: number, status: GoalStatus, goal: { __typename?: 'Goal', id: string }, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }>, meeting?: { __typename?: 'EvaluationSubmissionMeeting', duration: number, link?: string | null, location?: string | null } | null, moment?: { __typename?: 'MomentInstance', id: string, momentTemplate: { __typename?: 'MomentTemplate', id: string, title: LocalizedString } } | null, overrideScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null, transcription?: { __typename?: 'Transcription', id: string, status: TranscriptionStatus, uploadStatus: TranscriptionUploadStatus, transcript?: string | null, summary?: string | null, editableSummary?: any | null, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null } | null } } };

export type CompleteConversationMutationVariables = Exact<{
  input: CompleteConversationInput;
}>;


export type CompleteConversationMutation = { __typename?: 'Mutation', completeConversation: { __typename?: 'CompleteConversationResponse', evaluationSubmission: { __typename?: 'EvaluationSubmission', id: string, manager: { __typename?: 'EvaluationSubmissionResult', isCompleted: boolean } } } };

export type CreateEvaluationFormMutationVariables = Exact<{
  input: CreateEvaluationFormInput;
}>;


export type CreateEvaluationFormMutation = { __typename?: 'Mutation', createEvaluationForm: { __typename?: 'CreateEvaluationFormResponse', evaluationForm: { __typename?: 'EvaluationForm', id: string, title: LocalizedString, sections: Array<{ __typename?: 'EvaluationFormSection', items: Array<{ __typename?: 'EvaluationSectionItem', id: string }> }> } } };

export type DiscardAnswersFromPredecessorMutationVariables = Exact<{
  input: DiscardAnswersFromPredecessorInput;
}>;


export type DiscardAnswersFromPredecessorMutation = { __typename?: 'Mutation', discardAnswersFromPredecessor: { __typename?: 'DiscardAnswersFromPredecessorResponse', evaluationSubmission: { __typename?: 'EvaluationSubmission', id: string, deadline: any, overrideReason?: string | null, viewerCanChangeConversationPartner: boolean, viewerCanDiscardAnswersFromPredecessor: boolean, viewerCanOverrideScore: boolean, isArchived: boolean, aiInsightsApproved: boolean, employee: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, manager: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, viewer: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString, description?: LocalizedAttributedString | null, sections: Array<{ __typename?: 'EvaluationFormSection', items: Array<{ __typename?: 'EvaluationSectionItem', id: string, type: EvaluationSectionItemType, fillInBy: EvaluationFillInBy, optional?: boolean | null, title?: { __typename?: 'EvaluationTitleItem', text: LocalizedString } | null, paragraph?: { __typename?: 'EvaluationParagraphItem', text: LocalizedAttributedString } | null, stars?: { __typename?: 'EvaluationStarsItem', title: LocalizedString } | null, openQuestion?: { __typename?: 'EvaluationOpenQuestionItem', title: LocalizedString } | null, developmentPlan?: { __typename?: 'EvaluationDevelopmentPlanItem', title: LocalizedString } | null, sentiment?: { __typename?: 'EvaluationSentimentItem', title: LocalizedString, displayMethod: EvaluationSentimentDisplayMethod } | null, competency?: { __typename?: 'EvaluationCompetencyItem', weight: number, competency: { __typename?: 'Competency', title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', title: LocalizedString } }> } } | null, multipleChoice?: { __typename?: 'EvaluationMultipleChoiceItem', title: LocalizedString } | null, finalScore?: { __typename?: 'EvaluationFinalScoreItem', title?: LocalizedString | null, calculationMethod: EvaluationFinalScoreCalculationMethod, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, displayLevelSet?: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } | null } | null, reviewGoals?: { __typename?: 'EvaluationReviewGoalsItem', defaultExplanation?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } | null, signature?: { __typename?: 'EvaluationSignatureItem', title?: LocalizedString | null } | null, setGoals?: { __typename?: 'EvaluationSetGoalsItem', title: LocalizedString } | null }> }> }, goals?: Array<{ __typename?: 'EvaluationSubmissionGoal', title: LocalizedString, dueDate?: any | null, progress: number, status: GoalStatus, goal: { __typename?: 'Goal', id: string }, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }>, meeting?: { __typename?: 'EvaluationSubmissionMeeting', duration: number, link?: string | null, location?: string | null } | null, moment?: { __typename?: 'MomentInstance', id: string, momentTemplate: { __typename?: 'MomentTemplate', id: string, title: LocalizedString } } | null, overrideScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null, transcription?: { __typename?: 'Transcription', id: string, status: TranscriptionStatus, uploadStatus: TranscriptionUploadStatus, transcript?: string | null, summary?: string | null, editableSummary?: any | null, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null } | null } } };

export type ExportConversationToPdfMutationVariables = Exact<{
  conversationID: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExportConversationToPdfMutation = { __typename?: 'Mutation', exportToPDF: { __typename?: 'ConversationPDFExportResult', url?: string | null } };

export type KeepAnswersFromPredecessorMutationVariables = Exact<{
  input: KeepAnswersFromPredecessorInput;
}>;


export type KeepAnswersFromPredecessorMutation = { __typename?: 'Mutation', keepAnswersFromPredecessor: { __typename?: 'KeepAnswersFromPredecessorResponse', evaluationSubmission: { __typename?: 'EvaluationSubmission', id: string, deadline: any, overrideReason?: string | null, viewerCanChangeConversationPartner: boolean, viewerCanDiscardAnswersFromPredecessor: boolean, viewerCanOverrideScore: boolean, isArchived: boolean, aiInsightsApproved: boolean, employee: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, manager: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, viewer: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString, description?: LocalizedAttributedString | null, sections: Array<{ __typename?: 'EvaluationFormSection', items: Array<{ __typename?: 'EvaluationSectionItem', id: string, type: EvaluationSectionItemType, fillInBy: EvaluationFillInBy, optional?: boolean | null, title?: { __typename?: 'EvaluationTitleItem', text: LocalizedString } | null, paragraph?: { __typename?: 'EvaluationParagraphItem', text: LocalizedAttributedString } | null, stars?: { __typename?: 'EvaluationStarsItem', title: LocalizedString } | null, openQuestion?: { __typename?: 'EvaluationOpenQuestionItem', title: LocalizedString } | null, developmentPlan?: { __typename?: 'EvaluationDevelopmentPlanItem', title: LocalizedString } | null, sentiment?: { __typename?: 'EvaluationSentimentItem', title: LocalizedString, displayMethod: EvaluationSentimentDisplayMethod } | null, competency?: { __typename?: 'EvaluationCompetencyItem', weight: number, competency: { __typename?: 'Competency', title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', title: LocalizedString } }> } } | null, multipleChoice?: { __typename?: 'EvaluationMultipleChoiceItem', title: LocalizedString } | null, finalScore?: { __typename?: 'EvaluationFinalScoreItem', title?: LocalizedString | null, calculationMethod: EvaluationFinalScoreCalculationMethod, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, displayLevelSet?: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } | null } | null, reviewGoals?: { __typename?: 'EvaluationReviewGoalsItem', defaultExplanation?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } | null, signature?: { __typename?: 'EvaluationSignatureItem', title?: LocalizedString | null } | null, setGoals?: { __typename?: 'EvaluationSetGoalsItem', title: LocalizedString } | null }> }> }, goals?: Array<{ __typename?: 'EvaluationSubmissionGoal', title: LocalizedString, dueDate?: any | null, progress: number, status: GoalStatus, goal: { __typename?: 'Goal', id: string }, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }>, meeting?: { __typename?: 'EvaluationSubmissionMeeting', duration: number, link?: string | null, location?: string | null } | null, moment?: { __typename?: 'MomentInstance', id: string, momentTemplate: { __typename?: 'MomentTemplate', id: string, title: LocalizedString } } | null, overrideScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null, transcription?: { __typename?: 'Transcription', id: string, status: TranscriptionStatus, uploadStatus: TranscriptionUploadStatus, transcript?: string | null, summary?: string | null, editableSummary?: any | null, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null } | null } } };

export type RestoreEvaluationFormMutationVariables = Exact<{
  input: RestoreEvaluationFormInput;
}>;


export type RestoreEvaluationFormMutation = { __typename?: 'Mutation', restoreEvaluationForm: { __typename?: 'RestoreEvaluationFormResponse', evaluationForm: { __typename?: 'EvaluationForm', id: string, isArchived: boolean, title: LocalizedString, description?: LocalizedAttributedString | null, jobTitleIDs?: Array<string> | null, useOnlyInCycle?: boolean | null, showAnswersWhenAllUsersShared?: boolean | null, sections: Array<{ __typename?: 'EvaluationFormSection', weight?: number | null, items: Array<{ __typename?: 'EvaluationSectionItem', id: string, type: EvaluationSectionItemType, fillInBy: EvaluationFillInBy, optional?: boolean | null, title?: { __typename?: 'EvaluationTitleItem', text: LocalizedString } | null, paragraph?: { __typename?: 'EvaluationParagraphItem', text: LocalizedAttributedString } | null, stars?: { __typename?: 'EvaluationStarsItem', title: LocalizedString } | null, openQuestion?: { __typename?: 'EvaluationOpenQuestionItem', title: LocalizedString } | null, sentiment?: { __typename?: 'EvaluationSentimentItem', title: LocalizedString, displayMethod: EvaluationSentimentDisplayMethod } | null, developmentPlan?: { __typename?: 'EvaluationDevelopmentPlanItem', title: LocalizedString } | null, competency?: { __typename?: 'EvaluationCompetencyItem', weight: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean }, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, multipleChoice?: { __typename?: 'EvaluationMultipleChoiceItem', title: LocalizedString } | null, reviewGoals?: { __typename?: 'EvaluationReviewGoalsItem', defaultExplanation?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } | null, finalScore?: { __typename?: 'EvaluationFinalScoreItem', calculationMethod: EvaluationFinalScoreCalculationMethod, title?: LocalizedString | null, includeReviewGoals: boolean, scoreFormat: EvaluationFinalScoreFormat, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, displayLevelSet?: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } | null } | null, signature?: { __typename?: 'EvaluationSignatureItem', title?: LocalizedString | null } | null, setGoals?: { __typename?: 'EvaluationSetGoalsItem', title: LocalizedString } | null }> }> } } };

export type UncompleteConversationMutationVariables = Exact<{
  input: UncompleteConversationInput;
}>;


export type UncompleteConversationMutation = { __typename?: 'Mutation', uncompleteConversation: { __typename?: 'UncompleteConversationResponse', evaluationSubmission: { __typename?: 'EvaluationSubmission', id: string, manager: { __typename?: 'EvaluationSubmissionResult', isCompleted: boolean } } } };

export type UpdateEvaluationFormMutationVariables = Exact<{
  input: UpdateEvaluationFormInput;
}>;


export type UpdateEvaluationFormMutation = { __typename?: 'Mutation', updateEvaluationForm: { __typename?: 'UpdateEvaluationFormResponse', evaluationForm: { __typename?: 'EvaluationForm', id: string, isArchived: boolean, title: LocalizedString, description?: LocalizedAttributedString | null, jobTitleIDs?: Array<string> | null, useOnlyInCycle?: boolean | null, showAnswersWhenAllUsersShared?: boolean | null, sections: Array<{ __typename?: 'EvaluationFormSection', weight?: number | null, items: Array<{ __typename?: 'EvaluationSectionItem', id: string, type: EvaluationSectionItemType, fillInBy: EvaluationFillInBy, optional?: boolean | null, title?: { __typename?: 'EvaluationTitleItem', text: LocalizedString } | null, paragraph?: { __typename?: 'EvaluationParagraphItem', text: LocalizedAttributedString } | null, stars?: { __typename?: 'EvaluationStarsItem', title: LocalizedString } | null, openQuestion?: { __typename?: 'EvaluationOpenQuestionItem', title: LocalizedString } | null, sentiment?: { __typename?: 'EvaluationSentimentItem', title: LocalizedString, displayMethod: EvaluationSentimentDisplayMethod } | null, developmentPlan?: { __typename?: 'EvaluationDevelopmentPlanItem', title: LocalizedString } | null, competency?: { __typename?: 'EvaluationCompetencyItem', weight: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean }, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, multipleChoice?: { __typename?: 'EvaluationMultipleChoiceItem', title: LocalizedString } | null, reviewGoals?: { __typename?: 'EvaluationReviewGoalsItem', defaultExplanation?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } | null, finalScore?: { __typename?: 'EvaluationFinalScoreItem', calculationMethod: EvaluationFinalScoreCalculationMethod, title?: LocalizedString | null, includeReviewGoals: boolean, scoreFormat: EvaluationFinalScoreFormat, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, displayLevelSet?: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } | null } | null, signature?: { __typename?: 'EvaluationSignatureItem', title?: LocalizedString | null } | null, setGoals?: { __typename?: 'EvaluationSetGoalsItem', title: LocalizedString } | null }> }> } } };

export type EvaluationFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EvaluationFormQuery = { __typename?: 'Query', evaluationForm: { __typename?: 'EvaluationForm', id: string, isArchived: boolean, title: LocalizedString, description?: LocalizedAttributedString | null, jobTitleIDs?: Array<string> | null, useOnlyInCycle?: boolean | null, showAnswersWhenAllUsersShared?: boolean | null, sections: Array<{ __typename?: 'EvaluationFormSection', weight?: number | null, items: Array<{ __typename?: 'EvaluationSectionItem', id: string, type: EvaluationSectionItemType, fillInBy: EvaluationFillInBy, optional?: boolean | null, title?: { __typename?: 'EvaluationTitleItem', text: LocalizedString } | null, paragraph?: { __typename?: 'EvaluationParagraphItem', text: LocalizedAttributedString } | null, stars?: { __typename?: 'EvaluationStarsItem', title: LocalizedString } | null, openQuestion?: { __typename?: 'EvaluationOpenQuestionItem', title: LocalizedString } | null, sentiment?: { __typename?: 'EvaluationSentimentItem', title: LocalizedString, displayMethod: EvaluationSentimentDisplayMethod } | null, developmentPlan?: { __typename?: 'EvaluationDevelopmentPlanItem', title: LocalizedString } | null, competency?: { __typename?: 'EvaluationCompetencyItem', weight: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean }, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, multipleChoice?: { __typename?: 'EvaluationMultipleChoiceItem', title: LocalizedString } | null, reviewGoals?: { __typename?: 'EvaluationReviewGoalsItem', defaultExplanation?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } | null, finalScore?: { __typename?: 'EvaluationFinalScoreItem', calculationMethod: EvaluationFinalScoreCalculationMethod, title?: LocalizedString | null, includeReviewGoals: boolean, scoreFormat: EvaluationFinalScoreFormat, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, displayLevelSet?: { __typename?: 'CompetencyLevelSet', id: string, title: LocalizedString, isArchived: boolean, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } | null } | null, signature?: { __typename?: 'EvaluationSignatureItem', title?: LocalizedString | null } | null, setGoals?: { __typename?: 'EvaluationSetGoalsItem', title: LocalizedString } | null }> }> } };

export type EvaluationFormsQueryVariables = Exact<{
  isArchived: Scalars['Boolean']['input'];
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EvaluationFormsQuery = { __typename?: 'Query', evaluationForms: { __typename?: 'EvaluationFormConnection', edges: Array<{ __typename?: 'EvaluationFormEdge', cursor: string, node: { __typename?: 'EvaluationForm', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, jobTitleIDs?: Array<string> | null, useOnlyInCycle?: boolean | null, isArchived: boolean } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type SendCycleMomentManagerRemindersMutationVariables = Exact<{
  input: SendCycleMomentManagerRemindersInput;
}>;


export type SendCycleMomentManagerRemindersMutation = { __typename?: 'Mutation', sendCycleMomentManagerReminders: { __typename?: 'SendCycleMomentManagerRemindersResponse', success: boolean } };

export type EngagementCategoryFragment = { __typename?: 'EngagementCategory', id: string, title: LocalizedString, isArchived: boolean, subcategories: { __typename?: 'EngagementSubcategoryConnection', edges: Array<{ __typename?: 'EngagementSubcategoryEdge', node: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString } }> }, questions: { __typename?: 'EngagementQuestionConnection', totalCount: number } };

export type EngagementGroupsParticipationFragment = { __typename?: 'AnalyticsEngagementGroupParticipation', participation?: number | null, delta?: number | null, group: { __typename?: 'Group', id: string, name: string } };

export type EngagementGroupsSubcategoriesScoreFragment = { __typename?: 'AnalyticsEngagementGroupSubcategoryScore', score?: number | null, delta?: number | null, subcategory?: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null } | null, group?: { __typename?: 'Group', id: string, name: string, isArchived: boolean } | null };

export type EngagementOpenQuestionsFragment = { __typename?: 'AnalyticsEngagementOpenQuestion', question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString, category: { __typename?: 'EngagementCategory', id: string, title: LocalizedString }, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null } }, answers: Array<{ __typename?: 'AnalyticsEngagementOpenQuestionAnswer', timestamp: any, text: string, id: string }> };

export type EngagementParticipationOverTimeFragment = { __typename?: 'AnalyticsEngagementParticipation', delta?: number | null, average?: number | null, datapoints: Array<{ __typename?: 'AnalyticsEngagementParticipationDatapoint', timestamp: any, total?: number | null, completed?: number | null }> };

export type EngagementQuestionsOverTimeFragment = { __typename?: 'AnalyticsEngagementQuestionScoreTrend', delta?: number | null, question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> };

export type EngagementQuestionsOverTimeWithCategoryFragment = { __typename?: 'AnalyticsEngagementQuestionScoreTrend', delta?: number | null, question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString, category: { __typename?: 'EngagementCategory', id: string, title: LocalizedString }, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null } }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> };

export type EngagementReplyFragment = { __typename?: 'EngagementReply', id: string, text: string, createdAt: any, sender?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null };

export type EngagementResponseFragment = { __typename?: 'EngagementResponse', id: string, isCompleted: boolean, isExpired: boolean, request: { __typename?: 'EngagementRequest', id: string, template?: { __typename?: 'EngagementTemplate', id: string, anonymityThreshold: number, endPage?: LocalizedAttributedString | null } | null, questions: Array<{ __typename?: 'EngagementQuestion', id: string, title: LocalizedString, type: { __typename?: 'EngagementType', id: string, title: LocalizedString, type: EngagementResponseType, options?: Array<{ __typename?: 'EngagementTypeOption', title?: LocalizedString | null }> | null } }> }, answers: Array<{ __typename?: 'EngagementAnswer', questionID: string, skipped: boolean, index?: number | null, text?: string | null }> };

export type EngagementScoreOverTimeFragment = { __typename?: 'AnalyticsEngagementScore', delta?: number | null, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> };

export type EngagementSubcategoriesOverTimeFragment = { __typename?: 'AnalyticsEngagementSubcategoryScoreOverTime', delta?: number | null, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> };

export type EngagementSubcategoriesOverTimeWithCategoryFragment = { __typename?: 'AnalyticsEngagementSubcategoryScoreOverTime', delta?: number | null, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null, category: { __typename?: 'EngagementCategory', id: string, title: LocalizedString } }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> };

export type EngagementTemplateFragment = { __typename?: 'EngagementTemplate', id: string, title: LocalizedString, isEnabled: boolean, interval: EngagementInterval, useAllQuestions: boolean, maxOpenQuestions?: number | null, maxQuestions?: number | null, expiryInDays?: number | null, reminderDaysInAdvance?: number | null, useNps: boolean, instruction?: LocalizedAttributedString | null, endPage?: LocalizedAttributedString | null, anonymityThreshold: number, categories?: Array<{ __typename?: 'EngagementCategory', id: string, title: LocalizedString, isArchived: boolean, subcategories: { __typename?: 'EngagementSubcategoryConnection', edges: Array<{ __typename?: 'EngagementSubcategoryEdge', node: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString } }> }, questions: { __typename?: 'EngagementQuestionConnection', totalCount: number } }> | null, targetGroups: Array<{ __typename?: 'Group', id: string }>, targetUsers: Array<{ __typename?: 'User', id: string }> };

export type ArchiveEngagementCategoryMutationVariables = Exact<{
  input: ArchiveEngagementCategoryInput;
}>;


export type ArchiveEngagementCategoryMutation = { __typename?: 'Mutation', archiveEngagementCategory: { __typename?: 'ArchiveEngagementCategoryResponse', category: { __typename?: 'EngagementCategory', id: string, isArchived: boolean } } };

export type ArchiveEngagementQuestionMutationVariables = Exact<{
  input: ArchiveEngagementQuestionInput;
}>;


export type ArchiveEngagementQuestionMutation = { __typename?: 'Mutation', archiveEngagementQuestion: { __typename?: 'ArchiveEngagementQuestionResponse', question: { __typename?: 'EngagementQuestion', id: string, order: number, isArchived: boolean } } };

export type ArchiveEngagementSubcategoryMutationVariables = Exact<{
  input: ArchiveEngagementSubcategoryInput;
}>;


export type ArchiveEngagementSubcategoryMutation = { __typename?: 'Mutation', archiveEngagementSubcategory: { __typename?: 'ArchiveEngagementSubcategoryResponse', subcategory: { __typename?: 'EngagementSubcategory', id: string, order: number, isArchived: boolean } } };

export type CancelEngagementRequestMutationVariables = Exact<{
  input: CancelEngagementRequestInput;
}>;


export type CancelEngagementRequestMutation = { __typename?: 'Mutation', cancelEngagementRequest: { __typename?: 'CancelEngagementRequestResponse', engagementRequest: { __typename?: 'EngagementRequest', id: string, isCancelled: boolean } } };

export type CreateEngagementCategoryMutationVariables = Exact<{
  input: CreateEngagementCategoryInput;
}>;


export type CreateEngagementCategoryMutation = { __typename?: 'Mutation', createEngagementCategory: { __typename?: 'CreateEngagementCategoryResponse', category: { __typename?: 'EngagementCategory', id: string, order: number, title: LocalizedString, isArchived: boolean } } };

export type CreateEngagementQuestionMutationVariables = Exact<{
  input: CreateEngagementQuestionInput;
}>;


export type CreateEngagementQuestionMutation = { __typename?: 'Mutation', createEngagementQuestion: { __typename?: 'CreateEngagementQuestionResponse', question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString, order: number, isArchived: boolean, category: { __typename?: 'EngagementSubcategory', id: string }, type: { __typename?: 'EngagementType', id: string, type: EngagementResponseType } } } };

export type CreateEngagementReplyMutationVariables = Exact<{
  input: CreateEngagementReplyInput;
}>;


export type CreateEngagementReplyMutation = { __typename?: 'Mutation', createEngagementReply: { __typename?: 'CreateEngagementReplyResponse', reply: { __typename?: 'EngagementReply', id: string, text: string, createdAt: any, sender?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null } } };

export type CreateEngagementSubcategoryMutationVariables = Exact<{
  input: CreateEngagementSubcategoryInput;
}>;


export type CreateEngagementSubcategoryMutation = { __typename?: 'Mutation', createEngagementSubcategory: { __typename?: 'CreateEngagementSubcategoryResponse', subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, order: number, isArchived: boolean } } };

export type CreateEngagementTemplateMutationVariables = Exact<{
  input: CreateEngagementTemplateInput;
}>;


export type CreateEngagementTemplateMutation = { __typename?: 'Mutation', createEngagementTemplate: { __typename?: 'CreateEngagementTemplateResponse', template: { __typename?: 'EngagementTemplate', id: string, title: LocalizedString } } };

export type DisableEngagementTemplateMutationVariables = Exact<{
  input: DisableEngagementTemplateInput;
}>;


export type DisableEngagementTemplateMutation = { __typename?: 'Mutation', disableEngagementTemplate: { __typename?: 'DisableEngagementTemplateResponse', template: { __typename?: 'EngagementTemplate', id: string, title: LocalizedString, isEnabled: boolean, interval: EngagementInterval, useAllQuestions: boolean, maxOpenQuestions?: number | null, maxQuestions?: number | null, expiryInDays?: number | null, reminderDaysInAdvance?: number | null, useNps: boolean, instruction?: LocalizedAttributedString | null, endPage?: LocalizedAttributedString | null, anonymityThreshold: number, categories?: Array<{ __typename?: 'EngagementCategory', id: string, title: LocalizedString, isArchived: boolean, subcategories: { __typename?: 'EngagementSubcategoryConnection', edges: Array<{ __typename?: 'EngagementSubcategoryEdge', node: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString } }> }, questions: { __typename?: 'EngagementQuestionConnection', totalCount: number } }> | null, targetGroups: Array<{ __typename?: 'Group', id: string }>, targetUsers: Array<{ __typename?: 'User', id: string }> } } };

export type EnableEngagementTemplateMutationVariables = Exact<{
  input: EnableEngagementTemplateInput;
}>;


export type EnableEngagementTemplateMutation = { __typename?: 'Mutation', enableEngagementTemplate: { __typename?: 'EnableEngagementTemplateResponse', template: { __typename?: 'EngagementTemplate', id: string, title: LocalizedString, isEnabled: boolean, interval: EngagementInterval, useAllQuestions: boolean, maxOpenQuestions?: number | null, maxQuestions?: number | null, expiryInDays?: number | null, reminderDaysInAdvance?: number | null, useNps: boolean, instruction?: LocalizedAttributedString | null, endPage?: LocalizedAttributedString | null, anonymityThreshold: number, categories?: Array<{ __typename?: 'EngagementCategory', id: string, title: LocalizedString, isArchived: boolean, subcategories: { __typename?: 'EngagementSubcategoryConnection', edges: Array<{ __typename?: 'EngagementSubcategoryEdge', node: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString } }> }, questions: { __typename?: 'EngagementQuestionConnection', totalCount: number } }> | null, targetGroups: Array<{ __typename?: 'Group', id: string }>, targetUsers: Array<{ __typename?: 'User', id: string }> } } };

export type ReorderEngagementQuestionMutationVariables = Exact<{
  input: ReorderEngagementQuestionInput;
}>;


export type ReorderEngagementQuestionMutation = { __typename?: 'Mutation', reorderEngagementQuestion: { __typename?: 'ReorderEngagementQuestionResponse', question: { __typename?: 'EngagementQuestion', id: string, isArchived: boolean, order: number, category: { __typename?: 'EngagementSubcategory', id: string } } } };

export type ReorderEngagementSubcategoryMutationVariables = Exact<{
  input: ReorderEngagementSubcategoryInput;
}>;


export type ReorderEngagementSubcategoryMutation = { __typename?: 'Mutation', reorderEngagementSubcategory: { __typename?: 'ReorderEngagementSubcategoryResponse', subcategory: { __typename?: 'EngagementSubcategory', id: string, order: number, isArchived: boolean } } };

export type RestoreEngagementCategoryMutationVariables = Exact<{
  input: RestoreEngagementCategoryInput;
}>;


export type RestoreEngagementCategoryMutation = { __typename?: 'Mutation', restoreEngagementCategory: { __typename?: 'RestoreEngagementCategoryResponse', category: { __typename?: 'EngagementCategory', id: string, isArchived: boolean } } };

export type RestoreEngagementQuestionMutationVariables = Exact<{
  input: RestoreEngagementQuestionInput;
}>;


export type RestoreEngagementQuestionMutation = { __typename?: 'Mutation', restoreEngagementQuestion: { __typename?: 'RestoreEngagementQuestionResponse', question: { __typename?: 'EngagementQuestion', id: string, order: number, isArchived: boolean } } };

export type RestoreEngagementSubcategoryMutationVariables = Exact<{
  input: RestoreEngagementSubcategoryInput;
}>;


export type RestoreEngagementSubcategoryMutation = { __typename?: 'Mutation', restoreEngagementSubcategory: { __typename?: 'RestoreEngagementSubcategoryResponse', subcategory: { __typename?: 'EngagementSubcategory', id: string, order: number, isArchived: boolean } } };

export type SendEngagementRequestRemindersMutationVariables = Exact<{
  input: SendEngagementRequestRemindersInput;
}>;


export type SendEngagementRequestRemindersMutation = { __typename?: 'Mutation', sendEngagementRequestReminders: { __typename?: 'SendEngagementRequestRemindersResponse', engagementRequest: { __typename?: 'EngagementRequest', id: string } } };

export type SendEngagementTemplateMutationVariables = Exact<{
  input: SendEngagementTemplateInput;
}>;


export type SendEngagementTemplateMutation = { __typename?: 'Mutation', sendEngagementTemplate: { __typename?: 'SendEngagementTemplateResponse', template: { __typename?: 'EngagementTemplate', id: string, title: LocalizedString, isEnabled: boolean, interval: EngagementInterval, useAllQuestions: boolean, maxOpenQuestions?: number | null, maxQuestions?: number | null, expiryInDays?: number | null, reminderDaysInAdvance?: number | null, useNps: boolean, instruction?: LocalizedAttributedString | null, endPage?: LocalizedAttributedString | null, anonymityThreshold: number, categories?: Array<{ __typename?: 'EngagementCategory', id: string, title: LocalizedString, isArchived: boolean, subcategories: { __typename?: 'EngagementSubcategoryConnection', edges: Array<{ __typename?: 'EngagementSubcategoryEdge', node: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString } }> }, questions: { __typename?: 'EngagementQuestionConnection', totalCount: number } }> | null, targetGroups: Array<{ __typename?: 'Group', id: string }>, targetUsers: Array<{ __typename?: 'User', id: string }> } } };

export type UpdateEngagementAnswerMutationVariables = Exact<{
  input: UpdateEngagementAnswerInput;
}>;


export type UpdateEngagementAnswerMutation = { __typename?: 'Mutation', updateEngagementAnswer: { __typename?: 'UpdateEngagementAnswerResponse', engagementResponse: { __typename?: 'EngagementResponse', id: string, isCompleted: boolean, isExpired: boolean, request: { __typename?: 'EngagementRequest', id: string, template?: { __typename?: 'EngagementTemplate', id: string, anonymityThreshold: number, endPage?: LocalizedAttributedString | null } | null, questions: Array<{ __typename?: 'EngagementQuestion', id: string, title: LocalizedString, type: { __typename?: 'EngagementType', id: string, title: LocalizedString, type: EngagementResponseType, options?: Array<{ __typename?: 'EngagementTypeOption', title?: LocalizedString | null }> | null } }> }, answers: Array<{ __typename?: 'EngagementAnswer', questionID: string, skipped: boolean, index?: number | null, text?: string | null }> } } };

export type UpdateEngagementCategoryMutationVariables = Exact<{
  input: UpdateEngagementCategoryInput;
}>;


export type UpdateEngagementCategoryMutation = { __typename?: 'Mutation', updateEngagementCategory: { __typename?: 'UpdateEngagementCategoryResponse', category: { __typename?: 'EngagementCategory', id: string, title: LocalizedString, order: number, isArchived: boolean } } };

export type UpdateEngagementQuestionMutationVariables = Exact<{
  input: UpdateEngagementQuestionInput;
}>;


export type UpdateEngagementQuestionMutation = { __typename?: 'Mutation', updateEngagementQuestion: { __typename?: 'UpdateEngagementQuestionResponse', question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString, order: number, isArchived: boolean, category: { __typename?: 'EngagementSubcategory', id: string }, type: { __typename?: 'EngagementType', id: string, type: EngagementResponseType } } } };

export type UpdateEngagementSettingsMutationVariables = Exact<{
  input: UpdateEngagementSettingsInput;
}>;


export type UpdateEngagementSettingsMutation = { __typename?: 'Mutation', updateEngagementSettings: { __typename?: 'UpdateEngagementSettingsResponse', workspace: { __typename?: 'Workspace', id: string, engagementSettings: { __typename?: 'EngagementSettings', enpsType: EngagementEnpsType } } } };

export type UpdateEngagementSubcategoryMutationVariables = Exact<{
  input: UpdateEngagementSubcategoryInput;
}>;


export type UpdateEngagementSubcategoryMutation = { __typename?: 'Mutation', updateEngagementSubcategory: { __typename?: 'UpdateEngagementSubcategoryResponse', subcategory: { __typename?: 'EngagementSubcategory', id: string, order: number, title: LocalizedString } } };

export type UpdateEngagementTemplateMutationVariables = Exact<{
  input: UpdateEngagementTemplateInput;
}>;


export type UpdateEngagementTemplateMutation = { __typename?: 'Mutation', updateEngagementTemplate: { __typename?: 'UpdateEngagementTemplateResponse', template: { __typename?: 'EngagementTemplate', id: string, title: LocalizedString, isEnabled: boolean, interval: EngagementInterval, useAllQuestions: boolean, maxOpenQuestions?: number | null, maxQuestions?: number | null, expiryInDays?: number | null, reminderDaysInAdvance?: number | null, useNps: boolean, instruction?: LocalizedAttributedString | null, endPage?: LocalizedAttributedString | null, anonymityThreshold: number, categories?: Array<{ __typename?: 'EngagementCategory', id: string, title: LocalizedString, isArchived: boolean, subcategories: { __typename?: 'EngagementSubcategoryConnection', edges: Array<{ __typename?: 'EngagementSubcategoryEdge', node: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString } }> }, questions: { __typename?: 'EngagementQuestionConnection', totalCount: number } }> | null, targetGroups: Array<{ __typename?: 'Group', id: string }>, targetUsers: Array<{ __typename?: 'User', id: string }> } } };

export type EngagementAnswerWithRepliesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  managerID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type EngagementAnswerWithRepliesQuery = { __typename?: 'Query', openQuestionAnswerWithReplies: { __typename?: 'EngagmentAnswerWithReplies', id: string, text: string, question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString }, owner?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, replies: Array<{ __typename?: 'EngagementReply', id: string, text: string, createdAt: any, sender?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null }> } };

export type EngagementCategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EngagementCategoryQuery = { __typename?: 'Query', engagementCategory: { __typename?: 'EngagementCategory', id: string, title: LocalizedString, isArchived: boolean, subcategories: { __typename?: 'EngagementSubcategoryConnection', edges: Array<{ __typename?: 'EngagementSubcategoryEdge', node: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, order: number, isArchived: boolean } }> }, questions: { __typename?: 'EngagementQuestionConnection', edges: Array<{ __typename?: 'EngagementQuestionEdge', node: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString, order: number, isArchived: boolean, category: { __typename?: 'EngagementSubcategory', id: string, isArchived: boolean }, type: { __typename?: 'EngagementType', id: string, title: LocalizedString, type: EngagementResponseType, isArchived: boolean } } }> } }, engagementTypes: { __typename?: 'EngagementTypeConnection', edges: Array<{ __typename?: 'EngagementTypeEdge', node: { __typename?: 'EngagementType', id: string, title: LocalizedString, type: EngagementResponseType, isArchived: boolean } }> } };

export type EngagementNpsAnalyticsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type EngagementNpsAnalyticsQuery = { __typename?: 'Query', engagementAnalytics: { __typename?: 'EngagementAnalytics', engagementENPS: { __typename?: 'AnalyticsEngagementENPS', detractors?: number | null, passives?: number | null, promoters?: number | null, score?: number | null }, engagementGroupsENPS: Array<{ __typename?: 'AnalyticsEngagementGroupENPS', detractors?: number | null, passives?: number | null, promoters?: number | null, score?: number | null, group: { __typename?: 'Group', id: string, name: string } }> } };

export type EngagementOfficerMetricsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type EngagementOfficerMetricsQuery = { __typename?: 'Query', engagementAnalytics: { __typename?: 'EngagementAnalytics', engagementScoreOverTime: { __typename?: 'AnalyticsEngagementScore', delta?: number | null, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }, engagementParticipationOverTime: { __typename?: 'AnalyticsEngagementParticipation', delta?: number | null, average?: number | null, datapoints: Array<{ __typename?: 'AnalyticsEngagementParticipationDatapoint', timestamp: any, total?: number | null, completed?: number | null }> }, engagementThrivingSubcategories: Array<{ __typename?: 'AnalyticsEngagementSubcategoryScoreOverTime', delta?: number | null, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }>, engagementDecliningSubcategories: Array<{ __typename?: 'AnalyticsEngagementSubcategoryScoreOverTime', delta?: number | null, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }>, engagementGroupsSubcategoriesScore: Array<{ __typename?: 'AnalyticsEngagementGroupSubcategoryScore', score?: number | null, delta?: number | null, subcategory?: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null } | null, group?: { __typename?: 'Group', id: string, name: string, isArchived: boolean } | null }>, engagementGroupsParticipation: Array<{ __typename?: 'AnalyticsEngagementGroupParticipation', participation?: number | null, delta?: number | null, group: { __typename?: 'Group', id: string, name: string } }>, thrivingQuestions: Array<{ __typename?: 'AnalyticsEngagementQuestionScoreTrend', delta?: number | null, question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }>, decliningQuestions: Array<{ __typename?: 'AnalyticsEngagementQuestionScoreTrend', delta?: number | null, question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }> } };

export type EngagementOfficerQuestionsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type EngagementOfficerQuestionsQuery = { __typename?: 'Query', engagementAnalytics: { __typename?: 'EngagementAnalytics', engagementOpenQuestions: Array<{ __typename?: 'AnalyticsEngagementOpenQuestion', question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString, category: { __typename?: 'EngagementCategory', id: string, title: LocalizedString }, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null } }, answers: Array<{ __typename?: 'AnalyticsEngagementOpenQuestionAnswer', timestamp: any, text: string, id: string }> }>, engagementQuestionsTrend: Array<{ __typename?: 'AnalyticsEngagementQuestionScoreTrend', delta?: number | null, question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString, category: { __typename?: 'EngagementCategory', id: string, title: LocalizedString }, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null } }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }> } };

export type EngagementOfficerTopicsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type EngagementOfficerTopicsQuery = { __typename?: 'Query', engagementAnalytics: { __typename?: 'EngagementAnalytics', engagementScoreOverTime: { __typename?: 'AnalyticsEngagementScore', delta?: number | null, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }, engagementParticipationOverTime: { __typename?: 'AnalyticsEngagementParticipation', delta?: number | null, average?: number | null, datapoints: Array<{ __typename?: 'AnalyticsEngagementParticipationDatapoint', timestamp: any, total?: number | null, completed?: number | null }> }, engagementSubcategoriesTrend: Array<{ __typename?: 'AnalyticsEngagementSubcategoryScoreOverTime', delta?: number | null, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null, category: { __typename?: 'EngagementCategory', id: string, title: LocalizedString } }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }> } };

export type EngagementQuestionsByCategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EngagementQuestionsByCategoryQuery = { __typename?: 'Query', engagementCategory: { __typename?: 'EngagementCategory', questions: { __typename?: 'EngagementQuestionConnection', edges: Array<{ __typename?: 'EngagementQuestionEdge', node: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString, isArchived: boolean, order: number, category: { __typename?: 'EngagementSubcategory', id: string, isArchived: boolean }, type: { __typename?: 'EngagementType', id: string, title: LocalizedString, type: EngagementResponseType, isArchived: boolean } } }> } } };

export type EngagementRequestListingQueryVariables = Exact<{
  templateID?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
}>;


export type EngagementRequestListingQuery = { __typename?: 'Query', engagementRequestListing: { __typename?: 'EngagementRequestListingConnection', edges: Array<{ __typename?: 'EngagementRequestListingEdge', node: { __typename?: 'EngagementRequestListingNode', id: string, isCancelled: boolean, createdAt: any, template?: { __typename?: 'EngagementTemplateListingNode', id: string, title: LocalizedString } | null } }> } };

export type EngagementResponseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  secret?: InputMaybe<Scalars['String']['input']>;
}>;


export type EngagementResponseQuery = { __typename?: 'Query', engagementResponse: { __typename?: 'EngagementResponse', id: string, isCompleted: boolean, isExpired: boolean, request: { __typename?: 'EngagementRequest', id: string, template?: { __typename?: 'EngagementTemplate', id: string, anonymityThreshold: number, endPage?: LocalizedAttributedString | null } | null, questions: Array<{ __typename?: 'EngagementQuestion', id: string, title: LocalizedString, type: { __typename?: 'EngagementType', id: string, title: LocalizedString, type: EngagementResponseType, options?: Array<{ __typename?: 'EngagementTypeOption', title?: LocalizedString | null }> | null } }> }, answers: Array<{ __typename?: 'EngagementAnswer', questionID: string, skipped: boolean, index?: number | null, text?: string | null }> } };

export type EngagementSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type EngagementSettingsQuery = { __typename?: 'Query', builtinEngagementCategories: { __typename?: 'EngagementCategoryConnection', edges: Array<{ __typename?: 'EngagementCategoryEdge', node: { __typename?: 'EngagementCategory', id: string, title: LocalizedString, isArchived: boolean } }> }, engagementCategories: { __typename?: 'EngagementCategoryConnection', edges: Array<{ __typename?: 'EngagementCategoryEdge', node: { __typename?: 'EngagementCategory', id: string, title: LocalizedString, isArchived: boolean } }> }, engagementTemplates: { __typename?: 'EngagementTemplateConnection', edges: Array<{ __typename?: 'EngagementTemplateEdge', node: { __typename?: 'EngagementTemplate', id: string, title: LocalizedString, isEnabled: boolean, interval: EngagementInterval, nextRequestAt?: any | null } }> } };

export type EngagementTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EngagementTemplateQuery = { __typename?: 'Query', engagementIntervalDefaults: Array<{ __typename?: 'EngagementIntervalDefault', interval: EngagementInterval, maxOpenQuestions: number, maxQuestions: number }>, builtinEngagementCategories: { __typename?: 'EngagementCategoryConnection', edges: Array<{ __typename?: 'EngagementCategoryEdge', node: { __typename?: 'EngagementCategory', id: string, title: LocalizedString, isArchived: boolean, subcategories: { __typename?: 'EngagementSubcategoryConnection', edges: Array<{ __typename?: 'EngagementSubcategoryEdge', node: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString } }> }, questions: { __typename?: 'EngagementQuestionConnection', totalCount: number } } }> }, engagementCategories: { __typename?: 'EngagementCategoryConnection', edges: Array<{ __typename?: 'EngagementCategoryEdge', node: { __typename?: 'EngagementCategory', id: string, title: LocalizedString, isArchived: boolean, subcategories: { __typename?: 'EngagementSubcategoryConnection', edges: Array<{ __typename?: 'EngagementSubcategoryEdge', node: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString } }> }, questions: { __typename?: 'EngagementQuestionConnection', totalCount: number } } }> }, engagementTemplate: { __typename?: 'EngagementTemplate', id: string, title: LocalizedString, isEnabled: boolean, interval: EngagementInterval, useAllQuestions: boolean, maxOpenQuestions?: number | null, maxQuestions?: number | null, expiryInDays?: number | null, reminderDaysInAdvance?: number | null, useNps: boolean, instruction?: LocalizedAttributedString | null, endPage?: LocalizedAttributedString | null, anonymityThreshold: number, categories?: Array<{ __typename?: 'EngagementCategory', id: string, title: LocalizedString, isArchived: boolean, subcategories: { __typename?: 'EngagementSubcategoryConnection', edges: Array<{ __typename?: 'EngagementSubcategoryEdge', node: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString } }> }, questions: { __typename?: 'EngagementQuestionConnection', totalCount: number } }> | null, targetGroups: Array<{ __typename?: 'Group', id: string }>, targetUsers: Array<{ __typename?: 'User', id: string }> }, engagementRequests: { __typename?: 'EngagementRequestConnection', edges: Array<{ __typename?: 'EngagementRequestEdge', node: { __typename?: 'EngagementRequest', id: string, createdAt: any, completed: number, sent: number, progress: number, isCancelled: boolean, questions: Array<{ __typename?: 'EngagementQuestion', id: string }> } }> } };

export type EngagementTemplateListingQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
}>;


export type EngagementTemplateListingQuery = { __typename?: 'Query', engagementTemplateListing: { __typename?: 'EngagementTemplateListingConnection', edges: Array<{ __typename?: 'EngagementTemplateListingEdge', node: { __typename?: 'EngagementTemplateListingNode', id: string, title: LocalizedString } }> } };

export type GroupEngagementMetricsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type GroupEngagementMetricsQuery = { __typename?: 'Query', groupAnalytics: { __typename?: 'GroupAnalytics', engagementScoreOverTime: { __typename?: 'AnalyticsEngagementScore', delta?: number | null, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }, engagementParticipationOverTime: { __typename?: 'AnalyticsEngagementParticipation', delta?: number | null, average?: number | null, datapoints: Array<{ __typename?: 'AnalyticsEngagementParticipationDatapoint', timestamp: any, total?: number | null, completed?: number | null }> }, engagementThrivingSubcategories: Array<{ __typename?: 'AnalyticsEngagementSubcategoryScoreOverTime', delta?: number | null, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }>, engagementDecliningSubcategories: Array<{ __typename?: 'AnalyticsEngagementSubcategoryScoreOverTime', delta?: number | null, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }>, engagementGroupsSubcategoriesScore: Array<{ __typename?: 'AnalyticsEngagementGroupSubcategoryScore', score?: number | null, delta?: number | null, subcategory?: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null } | null, group?: { __typename?: 'Group', id: string, name: string, isArchived: boolean } | null }>, engagementGroupsParticipation: Array<{ __typename?: 'AnalyticsEngagementGroupParticipation', participation?: number | null, delta?: number | null, group: { __typename?: 'Group', id: string, name: string } }>, thrivingQuestions: Array<{ __typename?: 'AnalyticsEngagementQuestionScoreTrend', delta?: number | null, question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }>, decliningQuestions: Array<{ __typename?: 'AnalyticsEngagementQuestionScoreTrend', delta?: number | null, question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }> } };

export type GroupEngagementQuestionsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type GroupEngagementQuestionsQuery = { __typename?: 'Query', groupAnalytics: { __typename?: 'GroupAnalytics', engagementOpenQuestions: Array<{ __typename?: 'AnalyticsEngagementOpenQuestion', question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString, category: { __typename?: 'EngagementCategory', id: string, title: LocalizedString }, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null } }, answers: Array<{ __typename?: 'AnalyticsEngagementOpenQuestionAnswer', timestamp: any, text: string, id: string }> }>, engagementQuestionsTrend: Array<{ __typename?: 'AnalyticsEngagementQuestionScoreTrend', delta?: number | null, question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString, category: { __typename?: 'EngagementCategory', id: string, title: LocalizedString }, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null } }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }> } };

export type GroupEngagementTopicsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type GroupEngagementTopicsQuery = { __typename?: 'Query', groupAnalytics: { __typename?: 'GroupAnalytics', engagementScoreOverTime: { __typename?: 'AnalyticsEngagementScore', delta?: number | null, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }, engagementParticipationOverTime: { __typename?: 'AnalyticsEngagementParticipation', delta?: number | null, average?: number | null, datapoints: Array<{ __typename?: 'AnalyticsEngagementParticipationDatapoint', timestamp: any, total?: number | null, completed?: number | null }> }, engagementSubcategoriesTrend: Array<{ __typename?: 'AnalyticsEngagementSubcategoryScoreOverTime', delta?: number | null, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null, category: { __typename?: 'EngagementCategory', id: string, title: LocalizedString } }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }> } };

export type WorkspaceEngagementMetricsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type WorkspaceEngagementMetricsQuery = { __typename?: 'Query', workspaceAnalytics: { __typename?: 'WorkspaceAnalytics', engagementScoreOverTime: { __typename?: 'AnalyticsEngagementScore', delta?: number | null, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }, engagementParticipationOverTime: { __typename?: 'AnalyticsEngagementParticipation', delta?: number | null, average?: number | null, datapoints: Array<{ __typename?: 'AnalyticsEngagementParticipationDatapoint', timestamp: any, total?: number | null, completed?: number | null }> }, engagementThrivingSubcategories: Array<{ __typename?: 'AnalyticsEngagementSubcategoryScoreOverTime', delta?: number | null, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }>, engagementDecliningSubcategories: Array<{ __typename?: 'AnalyticsEngagementSubcategoryScoreOverTime', delta?: number | null, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }>, engagementGroupsSubcategoriesScore: Array<{ __typename?: 'AnalyticsEngagementGroupSubcategoryScore', score?: number | null, delta?: number | null, subcategory?: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null } | null, group?: { __typename?: 'Group', id: string, name: string, isArchived: boolean } | null }>, engagementGroupsParticipation: Array<{ __typename?: 'AnalyticsEngagementGroupParticipation', participation?: number | null, delta?: number | null, group: { __typename?: 'Group', id: string, name: string } }>, thrivingQuestions: Array<{ __typename?: 'AnalyticsEngagementQuestionScoreTrend', delta?: number | null, question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }>, decliningQuestions: Array<{ __typename?: 'AnalyticsEngagementQuestionScoreTrend', delta?: number | null, question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }> } };

export type WorkspaceEngagementQuestionsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type WorkspaceEngagementQuestionsQuery = { __typename?: 'Query', workspaceAnalytics: { __typename?: 'WorkspaceAnalytics', engagementOpenQuestions: Array<{ __typename?: 'AnalyticsEngagementOpenQuestion', question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString, category: { __typename?: 'EngagementCategory', id: string, title: LocalizedString }, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null } }, answers: Array<{ __typename?: 'AnalyticsEngagementOpenQuestionAnswer', timestamp: any, text: string, id: string }> }>, engagementQuestionsTrend: Array<{ __typename?: 'AnalyticsEngagementQuestionScoreTrend', delta?: number | null, question: { __typename?: 'EngagementQuestion', id: string, title: LocalizedString, category: { __typename?: 'EngagementCategory', id: string, title: LocalizedString }, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null } }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }> } };

export type WorkspaceEngagementTopicsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type WorkspaceEngagementTopicsQuery = { __typename?: 'Query', workspaceAnalytics: { __typename?: 'WorkspaceAnalytics', engagementScoreOverTime: { __typename?: 'AnalyticsEngagementScore', delta?: number | null, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }, engagementParticipationOverTime: { __typename?: 'AnalyticsEngagementParticipation', delta?: number | null, average?: number | null, datapoints: Array<{ __typename?: 'AnalyticsEngagementParticipationDatapoint', timestamp: any, total?: number | null, completed?: number | null }> }, engagementSubcategoriesTrend: Array<{ __typename?: 'AnalyticsEngagementSubcategoryScoreOverTime', delta?: number | null, subcategory: { __typename?: 'EngagementSubcategory', id: string, title: LocalizedString, description?: LocalizedString | null, category: { __typename?: 'EngagementCategory', id: string, title: LocalizedString } }, datapoints: Array<{ __typename?: 'AnalyticsEngagementScoreDatapoint', timestamp: any, score?: number | null }> }> } };

export type CreateFeatureRatingMutationVariables = Exact<{
  input: CreateFeatureRatingInput;
}>;


export type CreateFeatureRatingMutation = { __typename?: 'Mutation', createFeatureRating: { __typename?: 'CreateFeatureRatingResponse', featureRating: { __typename?: 'FeatureRating', id: string } } };

export type UpdateFeatureRatingMutationVariables = Exact<{
  input: UpdateFeatureRatingInput;
}>;


export type UpdateFeatureRatingMutation = { __typename?: 'Mutation', updateFeatureRating: { __typename?: 'UpdateFeatureRatingResponse', featureRating: { __typename?: 'FeatureRating', id: string } } };

export type HasViewerRatedQueryVariables = Exact<{
  viewerID: Scalars['ID']['input'];
  featureName: FeatureName;
  targetID?: InputMaybe<Scalars['ID']['input']>;
  targetType?: InputMaybe<FeatureRatingTargetType>;
  ratedAfter?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type HasViewerRatedQuery = { __typename?: 'Query', hasViewerRated: boolean };

export type AiGeneratedCompetenciesResponseFragment = { __typename?: 'AIGeneratedCompetenciesResponse', suggestion?: Array<{ __typename?: 'AIGeneratedCompetenciesSuggestion', title: string, description: string, levels: Array<string> }> | null, chat: { __typename?: 'AIChat', id: string, messages: Array<{ __typename?: 'AIChatMessage', text: string, sender: AiChatMessageSender }> } };

export type ComplimentSummaryFragment = { __typename?: 'Compliment', id: string, text: any, createdAt: any, sender: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, recipient: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } };

export type FeedbackRequestFragment = { __typename?: 'FeedbackRequest', id: string, title: string, isArchived: boolean, releaseDate?: any | null, createdAt: any, questions: Array<{ __typename?: 'FeedbackRequestQuestion', id: string, text: string, localizedText?: LocalizedString | null, subTitle?: string | null, additionalDetails?: any | null, type: FeedbackQuestionType, canSubjectView: boolean, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, goal?: { __typename?: 'FeedbackRequestGoal', title: LocalizedString, dueDate?: any | null, status: GoalStatus, progress: number, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null } | null, goalRevision?: { __typename?: 'GoalRevision', id: string, goalID: string, revision: string, title: LocalizedString, dueDate?: any | null, status: GoalStatus, progress: number, secret: string, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null } | null, competency?: { __typename?: 'Competency', id: string, title: LocalizedString, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } | null }>, responses: { __typename?: 'FeedbackResponseConnection', edges: Array<{ __typename?: 'FeedbackResponseEdge', node: { __typename?: 'FeedbackResponse', id: string, status: FeedbackResponseStatus, sharedAt?: any | null, createdAt: any, isArchived: boolean, viewerCanComment: boolean, viewerCanViewComments: boolean, recipient: { __typename?: 'FeedbackExternal', firstName: string, lastName: string, email: string } | { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, answers?: Array<{ __typename?: 'FeedbackResponseAnswer', questionID: string, text?: any | null, stars?: number | null, selectedOptionID?: string | null, competencyLevelIndex?: number | null, voiceMemo?: { __typename?: 'VoiceMemo', samples: Array<number>, sampleRate: number, asset: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }> } }> }, user: { __typename?: 'User', id: string, isViewer: boolean, viewerCanViewFeedback: boolean, managers: Array<{ __typename?: 'UserRole', id: string, source: { __typename?: 'User', id: string } }> } };

export type FeedbackResponseFragment = { __typename?: 'FeedbackResponse', id: string, status: FeedbackResponseStatus, sharedAt?: any | null, createdAt: any, isArchived: boolean, viewerCanComment: boolean, viewerCanViewComments: boolean, recipient: { __typename?: 'FeedbackExternal', firstName: string, lastName: string, email: string } | { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, answers?: Array<{ __typename?: 'FeedbackResponseAnswer', questionID: string, text?: any | null, stars?: number | null, selectedOptionID?: string | null, competencyLevelIndex?: number | null, voiceMemo?: { __typename?: 'VoiceMemo', samples: Array<number>, sampleRate: number, asset: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }> };

export type InternalFeedbackFragment = { __typename?: 'FeedbackResponse', id: string, title: string, instruction?: any | null, status: FeedbackResponseStatus, sharedAt?: any | null, releaseDate?: any | null, viewerCanComment: boolean, viewerCanViewComments: boolean, questions: Array<{ __typename?: 'FeedbackRequestQuestion', id: string, type: FeedbackQuestionType, text: string, localizedText?: LocalizedString | null, subTitle?: string | null, additionalDetails?: any | null, canSubjectView: boolean, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, goal?: { __typename?: 'FeedbackRequestGoal', title: LocalizedString, status: GoalStatus, dueDate?: any | null, progress: number, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null } | null, goalRevision?: { __typename?: 'GoalRevision', id: string, goalID: string, revision: string, title: LocalizedString, status: GoalStatus, dueDate?: any | null, progress: number, secret: string, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null } | null, competency?: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } | null }>, answers?: Array<{ __typename?: 'FeedbackResponseAnswer', questionID: string, text?: any | null, stars?: number | null, selectedOptionID?: string | null, competencyLevelIndex?: number | null, voiceMemo?: { __typename?: 'VoiceMemo', samples: Array<number>, sampleRate: number, asset: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } } | null }> | null, requestor: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, recipient: { __typename?: 'FeedbackExternal', firstName: string, lastName: string, email: string } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }> };

export type AdvanceAiGeneratedCompetenciesChatMutationVariables = Exact<{
  input: AdvanceAiChatInput;
}>;


export type AdvanceAiGeneratedCompetenciesChatMutation = { __typename?: 'Mutation', advanceAIGeneratedCompetenciesChat: { __typename?: 'AIGeneratedCompetenciesResponse', suggestion?: Array<{ __typename?: 'AIGeneratedCompetenciesSuggestion', title: string, description: string, levels: Array<string> }> | null, chat: { __typename?: 'AIChat', id: string, messages: Array<{ __typename?: 'AIChatMessage', text: string, sender: AiChatMessageSender }> } } };

export type ArchiveFeedbackQuestionMutationVariables = Exact<{
  input: ArchiveFeedbackQuestionInput;
}>;


export type ArchiveFeedbackQuestionMutation = { __typename?: 'Mutation', archiveFeedbackQuestion: { __typename?: 'ArchiveFeedbackQuestionResponse', feedbackQuestion: { __typename?: 'FeedbackQuestion', id: string, isArchived: boolean } } };

export type ArchiveFeedbackQuestionCategoryMutationVariables = Exact<{
  input: ArchiveFeedbackQuestionCategoryInput;
}>;


export type ArchiveFeedbackQuestionCategoryMutation = { __typename?: 'Mutation', archiveFeedbackQuestionCategory: { __typename?: 'ArchiveFeedbackQuestionCategoryResponse', feedbackQuestionCategory: { __typename?: 'FeedbackQuestionCategory', id: string, isArchived: boolean } } };

export type ArchiveFeedbackRequestMutationVariables = Exact<{
  input: ArchiveFeedbackRequestInput;
}>;


export type ArchiveFeedbackRequestMutation = { __typename?: 'Mutation', archiveFeedbackRequest: { __typename?: 'ArchiveFeedbackRequestResponse', feedbackRequest: { __typename?: 'FeedbackRequest', id: string, isArchived: boolean } } };

export type ArchiveFeedbackResponseMutationVariables = Exact<{
  input: ArchiveFeedbackResponseInput;
}>;


export type ArchiveFeedbackResponseMutation = { __typename?: 'Mutation', archiveFeedbackResponse: { __typename?: 'ArchiveFeedbackResponseResponse', feedbackResponse: { __typename?: 'FeedbackResponse', id: string, isArchived: boolean, status: FeedbackResponseStatus } } };

export type ArchiveFeedbackTemplateMutationVariables = Exact<{
  input: ArchiveFeedbackTemplateInput;
}>;


export type ArchiveFeedbackTemplateMutation = { __typename?: 'Mutation', archiveFeedbackTemplate: { __typename?: 'ArchiveFeedbackTemplateResponse', feedbackTemplate: { __typename?: 'FeedbackTemplate', id: string, isArchived: boolean } } };

export type CreateComplimentMutationVariables = Exact<{
  input: CreateComplimentInput;
}>;


export type CreateComplimentMutation = { __typename?: 'Mutation', createCompliment: { __typename?: 'CreateComplimentResponse', compliment: { __typename?: 'Compliment', id: string } } };

export type CreateFeedbackQuestionMutationVariables = Exact<{
  input: CreateFeedbackQuestionInput;
}>;


export type CreateFeedbackQuestionMutation = { __typename?: 'Mutation', createFeedbackQuestion: { __typename?: 'CreateFeedbackQuestionResponse', feedbackQuestion: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, order: number, isArchived: boolean, category: { __typename?: 'FeedbackQuestionCategory', id: string }, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }> } } };

export type CreateFeedbackQuestionCategoryMutationVariables = Exact<{
  input: CreateFeedbackQuestionCategoryInput;
}>;


export type CreateFeedbackQuestionCategoryMutation = { __typename?: 'Mutation', createFeedbackQuestionCategory: { __typename?: 'CreateFeedbackQuestionCategoryResponse', feedbackQuestionCategory: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString, order: number } } };

export type CreateFeedbackRequestMutationVariables = Exact<{
  input: CreateFeedbackRequestInput;
}>;


export type CreateFeedbackRequestMutation = { __typename?: 'Mutation', createFeedbackRequest: { __typename?: 'CreateFeedbackRequestResponse', feedbackRequest: { __typename?: 'FeedbackRequest', id: string } } };

export type CreateFeedbackTemplateMutationVariables = Exact<{
  input: CreateFeedbackTemplateInput;
}>;


export type CreateFeedbackTemplateMutation = { __typename?: 'Mutation', createFeedbackTemplate: { __typename?: 'CreateFeedbackTemplateResponse', feedbackTemplate: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, isPrivate: boolean, roles: Array<FeedbackTemplateRole>, jobTitleIDs?: Array<string> | null, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }> } }> } } };

export type ReorderFeedbackQuestionMutationVariables = Exact<{
  input: ReorderFeedbackQuestionInput;
}>;


export type ReorderFeedbackQuestionMutation = { __typename?: 'Mutation', reorderFeedbackQuestion: { __typename?: 'ReorderFeedbackQuestionResponse', feedbackQuestion: { __typename?: 'FeedbackQuestion', id: string, order: number } } };

export type ReorderFeedbackQuestionCategoryMutationVariables = Exact<{
  input: ReorderFeedbackQuestionCategoryInput;
}>;


export type ReorderFeedbackQuestionCategoryMutation = { __typename?: 'Mutation', reorderFeedbackQuestionCategory: { __typename?: 'ReorderFeedbackQuestionCategoryResponse', feedbackQuestionCategory: { __typename?: 'FeedbackQuestionCategory', id: string, order: number } } };

export type RequestAdditionalExternalFeedbackMutationVariables = Exact<{
  input: RequestExternalFeedbackInput;
}>;


export type RequestAdditionalExternalFeedbackMutation = { __typename?: 'Mutation', requestExternalFeedback: { __typename?: 'RequestExternalFeedbackResponse', feedbackRequest: { __typename?: 'FeedbackRequest', id: string, title: string, isArchived: boolean, releaseDate?: any | null, createdAt: any, questions: Array<{ __typename?: 'FeedbackRequestQuestion', id: string, text: string, localizedText?: LocalizedString | null, subTitle?: string | null, additionalDetails?: any | null, type: FeedbackQuestionType, canSubjectView: boolean, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, goal?: { __typename?: 'FeedbackRequestGoal', title: LocalizedString, dueDate?: any | null, status: GoalStatus, progress: number, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null } | null, goalRevision?: { __typename?: 'GoalRevision', id: string, goalID: string, revision: string, title: LocalizedString, dueDate?: any | null, status: GoalStatus, progress: number, secret: string, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null } | null, competency?: { __typename?: 'Competency', id: string, title: LocalizedString, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } | null }>, responses: { __typename?: 'FeedbackResponseConnection', edges: Array<{ __typename?: 'FeedbackResponseEdge', node: { __typename?: 'FeedbackResponse', id: string, status: FeedbackResponseStatus, sharedAt?: any | null, createdAt: any, isArchived: boolean, viewerCanComment: boolean, viewerCanViewComments: boolean, recipient: { __typename?: 'FeedbackExternal', firstName: string, lastName: string, email: string } | { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, answers?: Array<{ __typename?: 'FeedbackResponseAnswer', questionID: string, text?: any | null, stars?: number | null, selectedOptionID?: string | null, competencyLevelIndex?: number | null, voiceMemo?: { __typename?: 'VoiceMemo', samples: Array<number>, sampleRate: number, asset: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }> } }> }, user: { __typename?: 'User', id: string, isViewer: boolean, viewerCanViewFeedback: boolean, managers: Array<{ __typename?: 'UserRole', id: string, source: { __typename?: 'User', id: string } }> } } } };

export type RequestAdditionalInternalFeedbackMutationVariables = Exact<{
  input: RequestInternalFeedbackInput;
}>;


export type RequestAdditionalInternalFeedbackMutation = { __typename?: 'Mutation', requestInternalFeedback: { __typename?: 'RequestInternalFeedbackResponse', feedbackRequest: { __typename?: 'FeedbackRequest', id: string, title: string, isArchived: boolean, releaseDate?: any | null, createdAt: any, questions: Array<{ __typename?: 'FeedbackRequestQuestion', id: string, text: string, localizedText?: LocalizedString | null, subTitle?: string | null, additionalDetails?: any | null, type: FeedbackQuestionType, canSubjectView: boolean, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, goal?: { __typename?: 'FeedbackRequestGoal', title: LocalizedString, dueDate?: any | null, status: GoalStatus, progress: number, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null } | null, goalRevision?: { __typename?: 'GoalRevision', id: string, goalID: string, revision: string, title: LocalizedString, dueDate?: any | null, status: GoalStatus, progress: number, secret: string, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null } | null, competency?: { __typename?: 'Competency', id: string, title: LocalizedString, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } | null }>, responses: { __typename?: 'FeedbackResponseConnection', edges: Array<{ __typename?: 'FeedbackResponseEdge', node: { __typename?: 'FeedbackResponse', id: string, status: FeedbackResponseStatus, sharedAt?: any | null, createdAt: any, isArchived: boolean, viewerCanComment: boolean, viewerCanViewComments: boolean, recipient: { __typename?: 'FeedbackExternal', firstName: string, lastName: string, email: string } | { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, answers?: Array<{ __typename?: 'FeedbackResponseAnswer', questionID: string, text?: any | null, stars?: number | null, selectedOptionID?: string | null, competencyLevelIndex?: number | null, voiceMemo?: { __typename?: 'VoiceMemo', samples: Array<number>, sampleRate: number, asset: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }> } }> }, user: { __typename?: 'User', id: string, isViewer: boolean, viewerCanViewFeedback: boolean, managers: Array<{ __typename?: 'UserRole', id: string, source: { __typename?: 'User', id: string } }> } } } };

export type RequestExternalFeedbackMutationVariables = Exact<{
  input: RequestExternalFeedbackInput;
}>;


export type RequestExternalFeedbackMutation = { __typename?: 'Mutation', requestExternalFeedback: { __typename?: 'RequestExternalFeedbackResponse', feedbackRequest: { __typename?: 'FeedbackRequest', id: string } } };

export type RequestInternalFeedbackMutationVariables = Exact<{
  input: RequestInternalFeedbackInput;
}>;


export type RequestInternalFeedbackMutation = { __typename?: 'Mutation', requestInternalFeedback: { __typename?: 'RequestInternalFeedbackResponse', feedbackRequest: { __typename?: 'FeedbackRequest', id: string } } };

export type RestoreFeedbackQuestionMutationVariables = Exact<{
  input: RestoreFeedbackQuestionInput;
}>;


export type RestoreFeedbackQuestionMutation = { __typename?: 'Mutation', restoreFeedbackQuestion: { __typename?: 'RestoreFeedbackQuestionResponse', feedbackQuestion: { __typename?: 'FeedbackQuestion', id: string, isArchived: boolean } } };

export type RestoreFeedbackQuestionCategoryMutationVariables = Exact<{
  input: RestoreFeedbackQuestionCategoryInput;
}>;


export type RestoreFeedbackQuestionCategoryMutation = { __typename?: 'Mutation', restoreFeedbackQuestionCategory: { __typename?: 'RestoreFeedbackQuestionCategoryResponse', feedbackQuestionCategory: { __typename?: 'FeedbackQuestionCategory', id: string, isArchived: boolean } } };

export type RestoreFeedbackRequestMutationVariables = Exact<{
  input: RestoreFeedbackRequestInput;
}>;


export type RestoreFeedbackRequestMutation = { __typename?: 'Mutation', restoreFeedbackRequest: { __typename?: 'RestoreFeedbackRequestResponse', feedbackRequest: { __typename?: 'FeedbackRequest', id: string, isArchived: boolean } } };

export type RestoreFeedbackResponseMutationVariables = Exact<{
  input: RestoreFeedbackResponseInput;
}>;


export type RestoreFeedbackResponseMutation = { __typename?: 'Mutation', restoreFeedbackResponse: { __typename?: 'RestoreFeedbackResponseResponse', feedbackResponse: { __typename?: 'FeedbackResponse', id: string, isArchived: boolean, status: FeedbackResponseStatus } } };

export type RestoreFeedbackTemplateMutationVariables = Exact<{
  input: RestoreFeedbackTemplateInput;
}>;


export type RestoreFeedbackTemplateMutation = { __typename?: 'Mutation', restoreFeedbackTemplate: { __typename?: 'RestoreFeedbackTemplateResponse', feedbackTemplate: { __typename?: 'FeedbackTemplate', id: string, isArchived: boolean } } };

export type RevokeSharedFeedbackMutationVariables = Exact<{
  input: RevokeSharedFeedbackInput;
}>;


export type RevokeSharedFeedbackMutation = { __typename?: 'Mutation', revokeSharedFeedback: { __typename?: 'RevokeSharedFeedbackResponse', success: boolean } };

export type SendFeedbackMutationVariables = Exact<{
  input: SendSpontaneousFeedbackInput;
}>;


export type SendFeedbackMutation = { __typename?: 'Mutation', sendSpontaneousFeedback: { __typename?: 'SendSpontaneousFeedbackResponse', feedbackResponse: { __typename?: 'FeedbackResponse', id: string, title: string, instruction?: any | null, status: FeedbackResponseStatus, sharedAt?: any | null, releaseDate?: any | null, viewerCanComment: boolean, viewerCanViewComments: boolean, questions: Array<{ __typename?: 'FeedbackRequestQuestion', id: string, type: FeedbackQuestionType, text: string, localizedText?: LocalizedString | null, subTitle?: string | null, additionalDetails?: any | null, canSubjectView: boolean, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, goal?: { __typename?: 'FeedbackRequestGoal', title: LocalizedString, status: GoalStatus, dueDate?: any | null, progress: number, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null } | null, goalRevision?: { __typename?: 'GoalRevision', id: string, goalID: string, revision: string, title: LocalizedString, status: GoalStatus, dueDate?: any | null, progress: number, secret: string, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null } | null, competency?: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } | null }>, answers?: Array<{ __typename?: 'FeedbackResponseAnswer', questionID: string, text?: any | null, stars?: number | null, selectedOptionID?: string | null, competencyLevelIndex?: number | null, voiceMemo?: { __typename?: 'VoiceMemo', samples: Array<number>, sampleRate: number, asset: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } } | null }> | null, requestor: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, recipient: { __typename?: 'FeedbackExternal', firstName: string, lastName: string, email: string } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }> } } };

export type SendFeedbackReminderMutationVariables = Exact<{
  input: SendFeedbackReminderInput;
}>;


export type SendFeedbackReminderMutation = { __typename?: 'Mutation', sendFeedbackReminder: { __typename?: 'SendFeedbackReminderResponse', feedbackResponse: { __typename?: 'FeedbackResponse', id: string } } };

export type ShareFeedbackRequestMutationVariables = Exact<{
  input: ShareFeedbackRequestInput;
}>;


export type ShareFeedbackRequestMutation = { __typename?: 'Mutation', shareFeedbackRequest: { __typename?: 'ShareFeedbackRequestResponse', sharedFeedback: { __typename?: 'SharedFeedback', createdAt: any, sharedWith: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } } } };

export type StartAiGeneratedCompetenciesChatMutationVariables = Exact<{
  input: StartAiGeneratedCompetenciesChatInput;
}>;


export type StartAiGeneratedCompetenciesChatMutation = { __typename?: 'Mutation', startAIGeneratedCompetenciesChat: { __typename?: 'AIGeneratedCompetenciesResponse', suggestion?: Array<{ __typename?: 'AIGeneratedCompetenciesSuggestion', title: string, description: string, levels: Array<string> }> | null, chat: { __typename?: 'AIChat', id: string, messages: Array<{ __typename?: 'AIChatMessage', text: string, sender: AiChatMessageSender }> } } };

export type UpdateExternalFeedbackMutationVariables = Exact<{
  input: UpdateExternalFeedbackInput;
}>;


export type UpdateExternalFeedbackMutation = { __typename?: 'Mutation', updateExternalFeedback: { __typename?: 'UpdateExternalFeedbackResponse', feedbackResponse: { __typename?: 'FeedbackResponse', id: string, answers?: Array<{ __typename?: 'FeedbackResponseAnswer', questionID: string, text?: any | null, stars?: number | null, selectedOptionID?: string | null, voiceMemo?: { __typename?: 'VoiceMemo', samples: Array<number>, sampleRate: number, asset: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } } | null }> | null } } };

export type UpdateFeedbackQuestionMutationVariables = Exact<{
  input: UpdateFeedbackQuestionInput;
}>;


export type UpdateFeedbackQuestionMutation = { __typename?: 'Mutation', updateFeedbackQuestion: { __typename?: 'UpdateFeedbackQuestionResponse', feedbackQuestion: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, order: number, isArchived: boolean, category: { __typename?: 'FeedbackQuestionCategory', id: string }, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }> } } };

export type UpdateFeedbackQuestionCategoryMutationVariables = Exact<{
  input: UpdateFeedbackQuestionCategoryInput;
}>;


export type UpdateFeedbackQuestionCategoryMutation = { __typename?: 'Mutation', updateFeedbackQuestionCategory: { __typename?: 'UpdateFeedbackQuestionCategoryResponse', feedbackQuestionCategory: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } };

export type UpdateFeedbackTemplateMutationVariables = Exact<{
  input: UpdateFeedbackTemplateInput;
}>;


export type UpdateFeedbackTemplateMutation = { __typename?: 'Mutation', updateFeedbackTemplate: { __typename?: 'UpdateFeedbackTemplateResponse', feedbackTemplate: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, isPrivate: boolean, roles: Array<FeedbackTemplateRole>, jobTitleIDs?: Array<string> | null, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }> } }> } } };

export type UpdateInternalFeedbackMutationVariables = Exact<{
  input: UpdateInternalFeedbackInput;
}>;


export type UpdateInternalFeedbackMutation = { __typename?: 'Mutation', updateInternalFeedback: { __typename?: 'UpdateInternalFeedbackResponse', feedbackResponse: { __typename?: 'FeedbackResponse', id: string, answers?: Array<{ __typename?: 'FeedbackResponseAnswer', questionID: string, text?: any | null, stars?: number | null, selectedOptionID?: string | null, voiceMemo?: { __typename?: 'VoiceMemo', samples: Array<number>, sampleRate: number, asset: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } } | null }> | null } } };

export type ComplimentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ComplimentQuery = { __typename?: 'Query', compliment: { __typename?: 'Compliment', id: string, text: any, createdAt: any, viewerCanComment: boolean, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }>, sender: { __typename?: 'User', id: string, firstName: string, lastName: string, isViewer: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, recipient: { __typename?: 'User', id: string, firstName: string, lastName: string, isViewer: boolean, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } } };

export type ComplimentTargetsQueryVariables = Exact<{ [key: string]: never; }>;


export type ComplimentTargetsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', id: string, targetV2?: { __typename?: 'Group', id: string, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, isArchived: boolean, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString } }> } }> } } | { __typename?: 'User', id: string, firstName: string, lastName: string, isArchived: boolean, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | null }> } };

export type ComplimentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ComplimentsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, compliments: { __typename?: 'ComplimentConnection', edges: Array<{ __typename?: 'ComplimentEdge', node: { __typename?: 'Compliment', id: string, text: any, createdAt: any, sender: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } } }> } } };

export type ExternalFeedbackQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  secret: Scalars['String']['input'];
}>;


export type ExternalFeedbackQuery = { __typename?: 'Query', externalFeedback: { __typename?: 'FeedbackResponse', id: string, title: string, instruction?: any | null, status: FeedbackResponseStatus, questions: Array<{ __typename?: 'FeedbackRequestQuestion', id: string, type: FeedbackQuestionType, text: string, localizedText?: LocalizedString | null, subTitle?: string | null, additionalDetails?: any | null, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, goal?: { __typename?: 'FeedbackRequestGoal', title: LocalizedString, status: GoalStatus, dueDate?: any | null, progress: number, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null } | null, goalRevision?: { __typename?: 'GoalRevision', id: string, goalID: string, revision: string, title: LocalizedString, status: GoalStatus, dueDate?: any | null, progress: number, secret: string, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null } | null, competency?: { __typename?: 'Competency', id: string, title: LocalizedString, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } | null }>, answers?: Array<{ __typename?: 'FeedbackResponseAnswer', questionID: string, text?: any | null, stars?: number | null, selectedOptionID?: string | null, competencyLevelIndex?: number | null, voiceMemo?: { __typename?: 'VoiceMemo', samples: Array<number>, sampleRate: number, asset: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } } | null }> | null } };

export type FeedbackComposerCompetenciesQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
}>;


export type FeedbackComposerCompetenciesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, jobPositions: Array<{ __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString }, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString } | null, competencies: Array<{ __typename?: 'JobCompetency', id: string, competency: { __typename?: 'Competency', id: string, title: LocalizedString }, label?: { __typename?: 'Label', id: string, title: LocalizedString } | null }> }>, goals: Array<{ __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, archivedAt?: any | null, isArchived: boolean, createdAt: any, updatedAt?: any | null, completedAt?: any | null, viewerCanUpdate: boolean, order: number, viewerCanComment: boolean, viewerCanViewComments: boolean, visibility: GoalVisibility, completedBy?: { __typename?: 'User', id: string } | null, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } }, appraisals: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number }> } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, learningCourseID?: string | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, launchUrl?: string | null, launchUrls?: LocalizedString | null, learningType: { __typename?: 'LearningType', id: string, title: LocalizedString } } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, isArchived: boolean, viewerCanArchive: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, parent?: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null }, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } }> } };

export type FeedbackLibraryQueryVariables = Exact<{
  isArchived: Scalars['Boolean']['input'];
}>;


export type FeedbackLibraryQuery = { __typename?: 'Query', feedbackQuestionCategories: { __typename?: 'FeedbackQuestionCategoryConnection', edges: Array<{ __typename?: 'FeedbackQuestionCategoryEdge', node: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString, order: number, isArchived: boolean } }> }, feedbackQuestions: { __typename?: 'FeedbackQuestionConnection', edges: Array<{ __typename?: 'FeedbackQuestionEdge', node: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, order: number, isArchived: boolean, category: { __typename?: 'FeedbackQuestionCategory', id: string }, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }> } }> } };

export type FeedbackQuestionCategoriesQueryVariables = Exact<{
  isArchived: Scalars['Boolean']['input'];
}>;


export type FeedbackQuestionCategoriesQuery = { __typename?: 'Query', feedbackQuestionCategories: { __typename?: 'FeedbackQuestionCategoryConnection', edges: Array<{ __typename?: 'FeedbackQuestionCategoryEdge', node: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString, isArchived: boolean } }> } };

export type FeedbackQuestionsQueryVariables = Exact<{
  isArchived: Scalars['Boolean']['input'];
}>;


export type FeedbackQuestionsQuery = { __typename?: 'Query', feedbackQuestions: { __typename?: 'FeedbackQuestionConnection', edges: Array<{ __typename?: 'FeedbackQuestionEdge', node: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, isArchived: boolean, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string } } }> } };

export type FeedbackRequestsQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
  isArchived: Scalars['Boolean']['input'];
  before?: InputMaybe<Scalars['ID']['input']>;
  last: Scalars['Int']['input'];
}>;


export type FeedbackRequestsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, viewerCanRequestFeedback: boolean, feedbackRequests: { __typename?: 'FeedbackRequestConnection', edges: Array<{ __typename?: 'FeedbackRequestEdge', node: { __typename?: 'FeedbackRequest', id: string, title: string, createdAt: any, dueDate: any, isArchived: boolean, mode: FeedbackMode, instruction?: any | null, responses: { __typename?: 'FeedbackResponseConnection', edges: Array<{ __typename?: 'FeedbackResponseEdge', node: { __typename?: 'FeedbackResponse', id: string, status: FeedbackResponseStatus, recipient: { __typename?: 'FeedbackExternal', firstName: string, lastName: string } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } } }> } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } } };

export type FeedbackResultsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FeedbackResultsQuery = { __typename?: 'Query', feedbackRequest: { __typename?: 'FeedbackRequest', id: string, title: string, isArchived: boolean, releaseDate?: any | null, createdAt: any, questions: Array<{ __typename?: 'FeedbackRequestQuestion', id: string, text: string, localizedText?: LocalizedString | null, subTitle?: string | null, additionalDetails?: any | null, type: FeedbackQuestionType, canSubjectView: boolean, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, goal?: { __typename?: 'FeedbackRequestGoal', title: LocalizedString, dueDate?: any | null, status: GoalStatus, progress: number, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null } | null, goalRevision?: { __typename?: 'GoalRevision', id: string, goalID: string, revision: string, title: LocalizedString, dueDate?: any | null, status: GoalStatus, progress: number, secret: string, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null } | null, competency?: { __typename?: 'Competency', id: string, title: LocalizedString, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } | null }>, responses: { __typename?: 'FeedbackResponseConnection', edges: Array<{ __typename?: 'FeedbackResponseEdge', node: { __typename?: 'FeedbackResponse', id: string, status: FeedbackResponseStatus, sharedAt?: any | null, createdAt: any, isArchived: boolean, viewerCanComment: boolean, viewerCanViewComments: boolean, recipient: { __typename?: 'FeedbackExternal', firstName: string, lastName: string, email: string } | { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, answers?: Array<{ __typename?: 'FeedbackResponseAnswer', questionID: string, text?: any | null, stars?: number | null, selectedOptionID?: string | null, competencyLevelIndex?: number | null, voiceMemo?: { __typename?: 'VoiceMemo', samples: Array<number>, sampleRate: number, asset: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }> } }> }, user: { __typename?: 'User', id: string, isViewer: boolean, viewerCanViewFeedback: boolean, managers: Array<{ __typename?: 'UserRole', id: string, source: { __typename?: 'User', id: string } }> } } };

export type FeedbackTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FeedbackTemplateQuery = { __typename?: 'Query', feedbackTemplate: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, isArchived: boolean, isPrivate: boolean, jobTitleIDs?: Array<string> | null, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, type: FeedbackQuestionType, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }> } }> } };

export type FeedbackTemplateSelectorQueryVariables = Exact<{
  filters?: FeedbackTemplateFilters;
}>;


export type FeedbackTemplateSelectorQuery = { __typename?: 'Query', feedbackTemplates: { __typename?: 'FeedbackTemplateConnection', edges: Array<{ __typename?: 'FeedbackTemplateEdge', node: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, isPrivate: boolean, jobTitleIDs?: Array<string> | null, isArchived: boolean, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, type: FeedbackQuestionType, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string } } }> } }> } };

export type FeedbackTemplatesQueryVariables = Exact<{
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FeedbackTemplatesQuery = { __typename?: 'Query', feedbackTemplates: { __typename?: 'FeedbackTemplateConnection', edges: Array<{ __typename?: 'FeedbackTemplateEdge', node: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, isPrivate: boolean, isArchived: boolean } }> } };

export type GivenComplimentsQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GivenComplimentsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, givenCompliments: { __typename?: 'ComplimentConnection', edges: Array<{ __typename?: 'ComplimentEdge', node: { __typename?: 'Compliment', id: string, text: any, createdAt: any, sender: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, recipient: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type InternalFeedbackQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InternalFeedbackQuery = { __typename?: 'Query', internalFeedback: { __typename?: 'FeedbackResponse', id: string, title: string, instruction?: any | null, status: FeedbackResponseStatus, sharedAt?: any | null, releaseDate?: any | null, viewerCanComment: boolean, viewerCanViewComments: boolean, questions: Array<{ __typename?: 'FeedbackRequestQuestion', id: string, type: FeedbackQuestionType, text: string, localizedText?: LocalizedString | null, subTitle?: string | null, additionalDetails?: any | null, canSubjectView: boolean, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, goal?: { __typename?: 'FeedbackRequestGoal', title: LocalizedString, status: GoalStatus, dueDate?: any | null, progress: number, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null } | null, goalRevision?: { __typename?: 'GoalRevision', id: string, goalID: string, revision: string, title: LocalizedString, status: GoalStatus, dueDate?: any | null, progress: number, secret: string, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null } | null, competency?: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } | null }>, answers?: Array<{ __typename?: 'FeedbackResponseAnswer', questionID: string, text?: any | null, stars?: number | null, selectedOptionID?: string | null, competencyLevelIndex?: number | null, voiceMemo?: { __typename?: 'VoiceMemo', samples: Array<number>, sampleRate: number, asset: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } } | null }> | null, requestor: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, recipient: { __typename?: 'FeedbackExternal', firstName: string, lastName: string, email: string } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }> } };

export type InternalKakapoFeedbackQueryVariables = Exact<{
  requestID: Scalars['String']['input'];
}>;


export type InternalKakapoFeedbackQuery = { __typename?: 'Query', internalKakapoFeedback: { __typename?: 'InternalKakapoFeedback', responseID: string } };

export type OutgoingFeedbackResponsesQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
  before?: InputMaybe<Scalars['ID']['input']>;
  last: Scalars['Int']['input'];
}>;


export type OutgoingFeedbackResponsesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, viewerCanRequestFeedback: boolean, outgoingFeedbackResponses: { __typename?: 'FeedbackResponseConnection', edges: Array<{ __typename?: 'FeedbackResponseEdge', node: { __typename?: 'FeedbackResponse', id: string, title: string, dueDate: any, sharedAt?: any | null, requestor: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } } };

export type PromptFeedbackTipsQueryVariables = Exact<{
  input: FeedbackTipsInput;
}>;


export type PromptFeedbackTipsQuery = { __typename?: 'Query', promptFeedbackTips: { __typename?: 'AIResponse', messages: Array<{ __typename?: 'AIMessage', text: string }> } };

export type SharedFeedbackRequestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SharedFeedbackRequestQuery = { __typename?: 'Query', feedbackRequest: { __typename?: 'FeedbackRequest', sharedFeedback: { __typename?: 'SharedFeedbackConnection', edges: Array<{ __typename?: 'SharedFeedbackEdge', node: { __typename?: 'SharedFeedback', createdAt: any, sharedWith: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } } }> } } };

export type ViewerGivenComplimentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ViewerGivenComplimentsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, viewerGivenCompliments: { __typename?: 'ComplimentConnection', edges: Array<{ __typename?: 'ComplimentEdge', node: { __typename?: 'Compliment', id: string, text: any, createdAt: any, sender: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, recipient: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type CompetencyGoalFragment = { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } };

export type CycleTemplateMomentFragment = { __typename?: 'MomentTemplate', id: string, type: MomentType, startOffset: number, duration: number, title: LocalizedString, description?: LocalizedAttributedString | null, instruction?: LocalizedAttributedString | null, isArchived: boolean, archivedAt?: any | null, showToUser: boolean, variations?: Array<{ __typename?: 'MomentVariation', roleType?: RoleType | null, evaluation?: { __typename?: 'MomentEvaluation', evaluationForm?: { __typename?: 'EvaluationForm', id: string, title: LocalizedString } | null } | null, feedback?: { __typename?: 'MomentFeedback', feedbackTemplate?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString } | null } | null, jobTitle?: { __typename?: 'JobTitle', id: string, title: LocalizedString } | null }> | null, evaluation?: { __typename?: 'MomentEvaluation', evaluationForm?: { __typename?: 'EvaluationForm', id: string, title: LocalizedString } | null } | null, feedback?: { __typename?: 'MomentFeedback', minimumQuestions?: number | null, minimumRecipients?: number | null, maximumRecipients?: number | null, releaseDate?: any | null, feedbackTemplate?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString } | null } | null, goals?: { __typename?: 'MomentGoals', minimumGoals?: number | null, minimumCompetencyGoals?: number | null } | null, talentReview?: { __typename?: 'MomentTalentReview', template?: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString } | null } | null, notifications: Array<{ __typename?: 'MomentNotification', id: string, type: MomentNotificationType, offset: number }> };

export type GoalFragment = { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, archivedAt?: any | null, isArchived: boolean, createdAt: any, updatedAt?: any | null, completedAt?: any | null, viewerCanUpdate: boolean, order: number, viewerCanComment: boolean, viewerCanViewComments: boolean, visibility: GoalVisibility, completedBy?: { __typename?: 'User', id: string } | null, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } }, appraisals: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number }> } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, learningCourseID?: string | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, launchUrl?: string | null, launchUrls?: LocalizedString | null, learningType: { __typename?: 'LearningType', id: string, title: LocalizedString } } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, isArchived: boolean, viewerCanArchive: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, parent?: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null }, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } };

export type AiGeneratedGoalResponseFragment = { __typename?: 'AIGeneratedGoalResponse', suggestion?: { __typename?: 'AIGeneratedGoalSuggestion', title: string, description: string, subgoals: Array<string> } | null, chat: { __typename?: 'AIChat', id: string, messages: Array<{ __typename?: 'AIChatMessage', text: string, sender: AiChatMessageSender }> } };

export type GoalTemplateFragment = { __typename?: 'GoalTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, isArchived: boolean, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }> };

export type GoalWithOwnerFragment = { __typename?: 'Goal', owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } };

export type JobGoalTemplateFragment = { __typename?: 'JobGoalTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, level?: { __typename?: 'JobLevel', id: string, title: LocalizedString } | null, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null };

export type MetaGoalFragment = { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } };

export type AdvanceAiGeneratedGoalChatMutationVariables = Exact<{
  input: AdvanceAiChatInput;
}>;


export type AdvanceAiGeneratedGoalChatMutation = { __typename?: 'Mutation', advanceAIGeneratedGoalChat: { __typename?: 'AIGeneratedGoalResponse', suggestion?: { __typename?: 'AIGeneratedGoalSuggestion', title: string, description: string, subgoals: Array<string> } | null, chat: { __typename?: 'AIChat', id: string, messages: Array<{ __typename?: 'AIChatMessage', text: string, sender: AiChatMessageSender }> } } };

export type ArchiveGoalMutationVariables = Exact<{
  input: ArchiveGoalInput;
}>;


export type ArchiveGoalMutation = { __typename?: 'Mutation', archiveGoal: { __typename?: 'ArchiveGoalResponse', goal: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } } };

export type ArchiveGoalDriverMutationVariables = Exact<{
  input: ArchiveGoalDriverInput;
}>;


export type ArchiveGoalDriverMutation = { __typename?: 'Mutation', archiveGoalDriver: { __typename?: 'ArchiveGoalDriverResponse', success: boolean } };

export type ArchiveGoalTemplateMutationVariables = Exact<{
  input: ArchiveGoalTemplateInput;
}>;


export type ArchiveGoalTemplateMutation = { __typename?: 'Mutation', archiveGoalTemplate: { __typename?: 'ArchiveGoalTemplateResponse', goalTemplate: { __typename?: 'GoalTemplate', id: string, isArchived: boolean } } };

export type ArchiveIndividualGoalMutationVariables = Exact<{
  input: ArchiveGoalInput;
}>;


export type ArchiveIndividualGoalMutation = { __typename?: 'Mutation', archiveGoal: { __typename?: 'ArchiveGoalResponse', goal: { __typename?: 'Goal', id: string, isArchived: boolean } } };

export type CompleteMomentInstanceTaskMutationVariables = Exact<{
  input: CompleteMomentInstanceInput;
}>;


export type CompleteMomentInstanceTaskMutation = { __typename?: 'Mutation', completeMomentInstance: { __typename?: 'CompleteMomentInstanceResponse', momentInstance: { __typename?: 'MomentInstance', id: string, status: MomentStatus } } };

export type CreateGoalMutationVariables = Exact<{
  input: CreateGoalInput;
}>;


export type CreateGoalMutation = { __typename?: 'Mutation', createGoal: { __typename?: 'CreateGoalResponse', goal: { __typename?: 'Goal', id: string, title: LocalizedString, visibility: GoalVisibility, moment?: { __typename?: 'MomentInstance', id: string, status: MomentStatus, goals?: Array<{ __typename?: 'Goal', id: string }> | null } | null } } };

export type CreateGoalDriverMutationVariables = Exact<{
  input: CreateGoalDriverInput;
}>;


export type CreateGoalDriverMutation = { __typename?: 'Mutation', createGoalDriver: { __typename?: 'CreateGoalDriverResponse', goalDriver: { __typename?: 'GoalDriver', id: string } } };

export type CreateGoalTemplateMutationVariables = Exact<{
  input: CreateGoalTemplateInput;
}>;


export type CreateGoalTemplateMutation = { __typename?: 'Mutation', createGoalTemplate: { __typename?: 'CreateGoalTemplateResponse', goalTemplate: { __typename?: 'GoalTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, isArchived: boolean, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }> } } };

export type MoveGoalMutationVariables = Exact<{
  input: MoveGoalInput;
}>;


export type MoveGoalMutation = { __typename?: 'Mutation', moveGoal: { __typename?: 'MoveGoalResponse', goal: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, archivedAt?: any | null, isArchived: boolean, createdAt: any, updatedAt?: any | null, completedAt?: any | null, viewerCanUpdate: boolean, order: number, viewerCanComment: boolean, viewerCanViewComments: boolean, visibility: GoalVisibility, completedBy?: { __typename?: 'User', id: string } | null, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } }, appraisals: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number }> } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, learningCourseID?: string | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, launchUrl?: string | null, launchUrls?: LocalizedString | null, learningType: { __typename?: 'LearningType', id: string, title: LocalizedString } } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, isArchived: boolean, viewerCanArchive: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, parent?: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null }, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } } } };

export type PartialUpdateGoalMutationVariables = Exact<{
  input: PartialUpdateGoalInput;
}>;


export type PartialUpdateGoalMutation = { __typename?: 'Mutation', partialUpdateGoal: { __typename?: 'UpdateGoalResponse', goal: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, archivedAt?: any | null, isArchived: boolean, createdAt: any, updatedAt?: any | null, completedAt?: any | null, viewerCanUpdate: boolean, order: number, viewerCanComment: boolean, viewerCanViewComments: boolean, visibility: GoalVisibility, completedBy?: { __typename?: 'User', id: string } | null, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } }, appraisals: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number }> } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, learningCourseID?: string | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, launchUrl?: string | null, launchUrls?: LocalizedString | null, learningType: { __typename?: 'LearningType', id: string, title: LocalizedString } } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, isArchived: boolean, viewerCanArchive: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, parent?: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null }, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } } } };

export type ReorderGoalMutationVariables = Exact<{
  input: ReorderGoalInput;
}>;


export type ReorderGoalMutation = { __typename?: 'Mutation', reorderGoal: { __typename?: 'ReorderGoalResponse', goal: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } } };

export type ReorderGoalDriverMutationVariables = Exact<{
  input: ReorderGoalDriverInput;
}>;


export type ReorderGoalDriverMutation = { __typename?: 'Mutation', reorderGoalDriver: { __typename?: 'ReorderGoalDriverResponse', goalDriver: { __typename?: 'GoalDriver', id: string, order: number } } };

export type RestoreGoalMutationVariables = Exact<{
  input: RestoreGoalInput;
}>;


export type RestoreGoalMutation = { __typename?: 'Mutation', restoreGoal: { __typename?: 'RestoreGoalResponse', goal: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } } };

export type RestoreGoalDriverMutationVariables = Exact<{
  input: RestoreGoalDriverInput;
}>;


export type RestoreGoalDriverMutation = { __typename?: 'Mutation', restoreGoalDriver: { __typename?: 'RestoreGoalDriverResponse', success: boolean } };

export type RestoreGoalTemplateMutationVariables = Exact<{
  input: RestoreGoalTemplateInput;
}>;


export type RestoreGoalTemplateMutation = { __typename?: 'Mutation', restoreGoalTemplate: { __typename?: 'RestoreGoalTemplateResponse', goalTemplate: { __typename?: 'GoalTemplate', id: string, isArchived: boolean } } };

export type RestoreIndividualGoalMutationVariables = Exact<{
  input: RestoreGoalInput;
}>;


export type RestoreIndividualGoalMutation = { __typename?: 'Mutation', restoreGoal: { __typename?: 'RestoreGoalResponse', goal: { __typename?: 'Goal', id: string, isArchived: boolean } } };

export type SendMomentReminderMutationVariables = Exact<{
  input: SendMomentReminderInput;
}>;


export type SendMomentReminderMutation = { __typename?: 'Mutation', sendMomentReminder: { __typename?: 'SendMomentReminderResponse', momentInstance: { __typename?: 'MomentInstance', id: string } } };

export type SkipMomentInstanceMutationVariables = Exact<{
  input: SkipMomentInstanceInput;
}>;


export type SkipMomentInstanceMutation = { __typename?: 'Mutation', skipMomentInstance: { __typename?: 'SkipMomentInstanceResponse', momentInstance: { __typename?: 'MomentInstance', id: string, status: MomentStatus, skipReason?: MomentSkipReason | null, skipReasonOther?: string | null } } };

export type SkipMomentTemplateMutationVariables = Exact<{
  input: SkipMomentTemplateInput;
}>;


export type SkipMomentTemplateMutation = { __typename?: 'Mutation', skipMomentTemplate: { __typename?: 'SkipMomentTemplateResponse', cycleInstance: { __typename?: 'CycleInstance', id: string, skippedFutureMoments: Array<{ __typename?: 'CycleInstanceSkippedMoment', momentTemplateID: string, skipReason: MomentSkipReason, skipReasonOther?: string | null }> } } };

export type StartAiGeneratedGoalChatMutationVariables = Exact<{
  input: StartAiGeneratedGoalChatInput;
}>;


export type StartAiGeneratedGoalChatMutation = { __typename?: 'Mutation', startAIGeneratedGoalChat: { __typename?: 'AIGeneratedGoalResponse', suggestion?: { __typename?: 'AIGeneratedGoalSuggestion', title: string, description: string, subgoals: Array<string> } | null, chat: { __typename?: 'AIChat', id: string, messages: Array<{ __typename?: 'AIChatMessage', text: string, sender: AiChatMessageSender }> } } };

export type UpdateGoalMutationVariables = Exact<{
  input: UpdateGoalInput;
}>;


export type UpdateGoalMutation = { __typename?: 'Mutation', updateGoal: { __typename?: 'UpdateGoalResponse', goal: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } } };

export type UpdateGoalDriverMutationVariables = Exact<{
  input: UpdateGoalDriverInput;
}>;


export type UpdateGoalDriverMutation = { __typename?: 'Mutation', updateGoalDriver: { __typename?: 'UpdateGoalDriverResponse', goalDriver: { __typename?: 'GoalDriver', id: string } } };

export type UpdateGoalTemplateMutationVariables = Exact<{
  input: UpdateGoalTemplateInput;
}>;


export type UpdateGoalTemplateMutation = { __typename?: 'Mutation', updateGoalTemplate: { __typename?: 'UpdateGoalTemplateResponse', goalTemplate: { __typename?: 'GoalTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, isArchived: boolean, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }> } } };

export type UpdateIndividualGoalMutationVariables = Exact<{
  input: UpdateGoalInput;
}>;


export type UpdateIndividualGoalMutation = { __typename?: 'Mutation', updateGoal: { __typename?: 'UpdateGoalResponse', goal: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, archivedAt?: any | null, isArchived: boolean, createdAt: any, updatedAt?: any | null, completedAt?: any | null, viewerCanUpdate: boolean, order: number, viewerCanComment: boolean, viewerCanViewComments: boolean, visibility: GoalVisibility, completedBy?: { __typename?: 'User', id: string } | null, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } }, appraisals: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number }> } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, learningCourseID?: string | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, launchUrl?: string | null, launchUrls?: LocalizedString | null, learningType: { __typename?: 'LearningType', id: string, title: LocalizedString } } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, isArchived: boolean, viewerCanArchive: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, parent?: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null }, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } } } };

export type CycleMomentSelectorQueryVariables = Exact<{ [key: string]: never; }>;


export type CycleMomentSelectorQuery = { __typename?: 'Query', viewer: { __typename?: 'User', moments: Array<{ __typename?: 'MomentInstance', id: string, status: MomentStatus, startDate: any, endDate: any, momentTemplate: { __typename?: 'MomentTemplate', id: string, type: MomentType, title: LocalizedString, description?: LocalizedAttributedString | null }, cycleTemplate: { __typename?: 'CycleTemplate', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> } };

export type GoalQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GoalQuery = { __typename?: 'Query', goal: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, description: LocalizedAttributedString, title: LocalizedString, learningCourseID?: string | null, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', value: number, type: GoalChecklistItemType, lower?: number | null, upper?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, launchUrl?: string | null, launchUrls?: LocalizedString | null, provider: LearningCourseProvider, learningType: { __typename?: 'LearningType', id: string, title: LocalizedString } } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } };

export type GoalAuditTrailQueryVariables = Exact<{
  goalID: Scalars['ID']['input'];
}>;


export type GoalAuditTrailQuery = { __typename?: 'Query', goal: { __typename?: 'Goal', auditTrail: { __typename?: 'AuditTrailConnection', edges: Array<{ __typename?: 'AuditTrailEdge', node: { __typename?: 'AuditTrail', id: string, field: string, createdAt: any, oldValue?: { __typename?: 'AuditValue', booleanValue?: boolean | null, dateValue?: any | null, localizedStringValue?: LocalizedString | null, percentageValue?: number | null, quillValue?: any | null } | null, newValue?: { __typename?: 'AuditValue', booleanValue?: boolean | null, dateValue?: any | null, localizedStringValue?: LocalizedString | null, percentageValue?: number | null, quillValue?: any | null } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } } }> } } };

export type GoalAuditTrailGroupQueryVariables = Exact<{
  groupID: Scalars['ID']['input'];
}>;


export type GoalAuditTrailGroupQuery = { __typename?: 'Query', group: { __typename?: 'Group', viewerCanViewGoalAuditTrail: boolean } };

export type GoalAuditTrailWorkspaceQueryVariables = Exact<{
  workspaceID: Scalars['ID']['input'];
}>;


export type GoalAuditTrailWorkspaceQuery = { __typename?: 'Query', workspace: { __typename?: 'Workspace', viewerCanViewGoalAuditTrail: boolean } };

export type GoalChildrenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GoalChildrenQuery = { __typename?: 'Query', goal: { __typename?: 'Goal', id: string, children: { __typename?: 'GoalConnection', edges: Array<{ __typename?: 'GoalEdge', node: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null }, owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type GoalDriversQueryVariables = Exact<{
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GoalDriversQuery = { __typename?: 'Query', goalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString, archivedAt?: any | null, order: number }>, viewer: { __typename?: 'User', workspace: { __typename?: 'Workspace', id: string, viewerCanCreateGoalDrivers: boolean } } };

export type GoalLearningRecommendationsQueryVariables = Exact<{
  input: GoalLearningRecommendationsInput;
}>;


export type GoalLearningRecommendationsQuery = { __typename?: 'Query', goalLearningRecommendations: { __typename?: 'LearningRecommendationsResponse', recommendations: Array<{ __typename?: 'LearningRecommendation', reason?: string | null, learningCourse: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, title: LocalizedString, description?: LocalizedAttributedString | null, languageID: string, durationMinutes?: number | null, imageUrl?: string | null, launchUrl?: string | null, launchUrls?: LocalizedString | null, isArchived: boolean, learningType: { __typename?: 'LearningType', id: string, color: string, title: LocalizedString }, learningSubjects: Array<{ __typename?: 'LearningSubject', id: string, title: LocalizedString }> } }> } };

export type GoalMomentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GoalMomentsQuery = { __typename?: 'Query', user: { __typename?: 'User', moments: Array<{ __typename?: 'MomentInstance', id: string, status: MomentStatus, startDate: any, endDate: any, momentTemplate: { __typename?: 'MomentTemplate', id: string, type: MomentType, title: LocalizedString, description?: LocalizedAttributedString | null, goals?: { __typename?: 'MomentGoals', minimumGoals?: number | null, minimumCompetencyGoals?: number | null } | null }, goals?: Array<{ __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, archivedAt?: any | null, isArchived: boolean, createdAt: any, updatedAt?: any | null, completedAt?: any | null, viewerCanUpdate: boolean, order: number, viewerCanComment: boolean, viewerCanViewComments: boolean, visibility: GoalVisibility, completedBy?: { __typename?: 'User', id: string } | null, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } }, appraisals: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number }> } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, learningCourseID?: string | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, launchUrl?: string | null, launchUrls?: LocalizedString | null, learningType: { __typename?: 'LearningType', id: string, title: LocalizedString } } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, isArchived: boolean, viewerCanArchive: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, parent?: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null }, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } }> | null }> } };

export type GoalRevisionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  revision: Scalars['String']['input'];
  secret?: InputMaybe<Scalars['String']['input']>;
}>;


export type GoalRevisionQuery = { __typename?: 'Query', goalRevision: { __typename?: 'GoalRevision', id: string, title: LocalizedString, description: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, archivedAt?: any | null, isArchived: boolean, createdAt: any, updatedAt?: any | null, completedAt?: any | null, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }> } };

export type GoalTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GoalTemplateQuery = { __typename?: 'Query', goalTemplate: { __typename?: 'GoalTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, isArchived: boolean, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }> } };

export type GoalTemplatesQueryVariables = Exact<{
  isArchived: Scalars['Boolean']['input'];
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GoalTemplatesQuery = { __typename?: 'Query', goalTemplates: { __typename?: 'GoalTemplateConnection', edges: Array<{ __typename?: 'GoalTemplateEdge', cursor: string, node: { __typename?: 'GoalTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, isArchived: boolean } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GroupGoalCountsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GroupGoalCountsQuery = { __typename?: 'Query', group: { __typename?: 'Group', id: string, goals: Array<{ __typename?: 'Goal', id: string }> } };

export type GroupGoalsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  status: GoalStatus;
  roleTypes?: InputMaybe<Array<RoleType> | RoleType>;
  before?: InputMaybe<Scalars['ID']['input']>;
  last: Scalars['Int']['input'];
}>;


export type GroupGoalsQuery = { __typename?: 'Query', group: { __typename?: 'Group', id: string, name: string, type: GroupType, goalsV2: { __typename?: 'GoalConnection', edges: Array<{ __typename?: 'GoalEdge', node: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } }, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type GroupGoalsMetaQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GroupGoalsMetaQuery = { __typename?: 'Query', group: { __typename?: 'Group', id: string, name: string, type: GroupType, viewerCanCreateGoal: boolean, viewerCanViewArchivedGoals: boolean } };

export type IndividualGoalQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IndividualGoalQuery = { __typename?: 'Query', goal: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, archivedAt?: any | null, isArchived: boolean, createdAt: any, updatedAt?: any | null, completedAt?: any | null, viewerCanUpdate: boolean, order: number, viewerCanComment: boolean, viewerCanViewComments: boolean, visibility: GoalVisibility, linkedGoals: Array<{ __typename?: 'Goal', id: string }>, completedBy?: { __typename?: 'User', id: string } | null, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } }, appraisals: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number }> } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, learningCourseID?: string | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, launchUrl?: string | null, launchUrls?: LocalizedString | null, learningType: { __typename?: 'LearningType', id: string, title: LocalizedString } } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, isArchived: boolean, viewerCanArchive: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, parent?: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null }, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } } };

export type IndividualGoalsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  status: GoalStatus;
  before?: InputMaybe<Scalars['ID']['input']>;
  last: Scalars['Int']['input'];
}>;


export type IndividualGoalsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, goalsV2: { __typename?: 'GoalConnection', totalCount?: number | null, edges: Array<{ __typename?: 'GoalEdge', node: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null }, owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type MomentForEvaluationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MomentForEvaluationQuery = { __typename?: 'Query', momentInstance: { __typename?: 'MomentInstance', id: string, momentTemplate: { __typename?: 'MomentTemplate', title: LocalizedString, evaluation?: { __typename?: 'MomentEvaluation', evaluationForm?: { __typename?: 'EvaluationForm', id: string, title: LocalizedString } | null } | null } } };

export type MomentForFeedbackQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MomentForFeedbackQuery = { __typename?: 'Query', momentInstance: { __typename?: 'MomentInstance', id: string, momentTemplate: { __typename?: 'MomentTemplate', title: LocalizedString, feedback?: { __typename?: 'MomentFeedback', minimumRecipients?: number | null, maximumRecipients?: number | null, minimumQuestions?: number | null, releaseDate?: any | null, feedbackTemplate?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null } | null } } };

export type FeedbackTemplateForFeedbackFragment = { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> };

export type MomentForGoalsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MomentForGoalsQuery = { __typename?: 'Query', momentInstance: { __typename?: 'MomentInstance', id: string, momentTemplate: { __typename?: 'MomentTemplate', id: string, title: LocalizedString, goals?: { __typename?: 'MomentGoals', minimumGoals?: number | null, minimumCompetencyGoals?: number | null } | null }, goals?: Array<{ __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, archivedAt?: any | null, isArchived: boolean, createdAt: any, updatedAt?: any | null, completedAt?: any | null, viewerCanUpdate: boolean, order: number, viewerCanComment: boolean, viewerCanViewComments: boolean, visibility: GoalVisibility, completedBy?: { __typename?: 'User', id: string } | null, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } }, appraisals: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number }> } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, learningCourseID?: string | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, launchUrl?: string | null, launchUrls?: LocalizedString | null, learningType: { __typename?: 'LearningType', id: string, title: LocalizedString } } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, isArchived: boolean, viewerCanArchive: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, parent?: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null }, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } }> | null } };

export type WorkspaceGoalsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  status: GoalStatus;
  before?: InputMaybe<Scalars['ID']['input']>;
  last: Scalars['Int']['input'];
}>;


export type WorkspaceGoalsQuery = { __typename?: 'Query', workspace: { __typename?: 'Workspace', id: string, viewerCanCreateGoal: boolean, viewerCanViewArchivedGoals: boolean, goalsV2: { __typename?: 'GoalConnection', edges: Array<{ __typename?: 'GoalEdge', node: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type CompetencyFeedbackScoresQueryVariables = Exact<{
  competencyID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type CompetencyFeedbackScoresQuery = { __typename?: 'Query', competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, appraisals: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number, user: { __typename?: 'User', id: string, managers: Array<{ __typename?: 'UserRole', source: { __typename?: 'User', id: string } }> }, feedbackScores?: Array<{ __typename?: 'CompetencyFeedbackScore', competencyLevelIndex: number, timestamp: any, giver: { __typename?: 'CompetencyFeedbackScoreExternalGiver', firstName: string, lastName: string, email: string } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, feedbackResponse: { __typename?: 'FeedbackResponse', id: string, answers?: Array<{ __typename?: 'FeedbackResponseAnswer', questionID: string, text?: any | null, competencyLevelIndex?: number | null, voiceMemo?: { __typename?: 'VoiceMemo', samples: Array<number>, sampleRate: number, asset: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } } | null }> | null } }> | null }> } };

export type ArchiveInboxTaskMutationVariables = Exact<{
  input: ArchiveInboxTaskInput;
}>;


export type ArchiveInboxTaskMutation = { __typename?: 'Mutation', archiveInboxTask: { __typename?: 'ArchiveInboxTaskResponse', inboxTask: { __typename?: 'InboxTask', id: string } } };

export type MarkInboxTaskMutationVariables = Exact<{
  input: MarkInboxTaskInput;
}>;


export type MarkInboxTaskMutation = { __typename?: 'Mutation', markInboxTask: { __typename?: 'MarkInboxTaskResponse', inboxTask: { __typename?: 'InboxTask', id: string, type: InboxTaskType, status: InboxTaskStatus, createdAt: any, seen: boolean, evaluationSubmission?: { __typename?: 'EvaluationSubmission', id: string, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString }, employee: { __typename?: 'EvaluationSubmissionResult', requiresInput: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }, manager: { __typename?: 'EvaluationSubmissionResult', requiresInput: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } } } | null } } };

export type CheckpointsQueryVariables = Exact<{
  workspaceID: Scalars['ID']['input'];
}>;


export type CheckpointsQuery = { __typename?: 'Query', workspace: { __typename?: 'Workspace', id: string, checkpoints?: Array<{ __typename?: 'Checkpoint', id: string, key: string, completedAt?: any | null } | null> | null } };

export type InboxTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type InboxTasksQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, inboxTasks: Array<{ __typename?: 'InboxTask', id: string, type: InboxTaskType, status: InboxTaskStatus, createdAt: any, seen: boolean, evaluationSubmission?: { __typename?: 'EvaluationSubmission', id: string, deadline: any, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString }, employee: { __typename?: 'EvaluationSubmissionResult', requiresInput: boolean, status: EvaluationSubmissionStatus, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }, manager: { __typename?: 'EvaluationSubmissionResult', requiresInput: boolean, status: EvaluationSubmissionStatus, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }, moment?: { __typename?: 'MomentInstance', momentTemplate: { __typename?: 'MomentTemplate', title: LocalizedString } } | null } | null, feedbackResponse?: { __typename?: 'FeedbackResponse', id: string, title: string, dueDate: any, requestor: { __typename?: 'User', id: string, firstName: string, lastName: string } } | null, moment?: { __typename?: 'MomentInstance', id: string, endDate: any, momentTemplate: { __typename?: 'MomentTemplate', title: LocalizedString, description?: LocalizedAttributedString | null, type: MomentType, talentReview?: { __typename?: 'MomentTalentReview', template?: { __typename?: 'TalentReviewTemplate', id: string } | null, group?: { __typename?: 'Group', id: string, name: string } | null } | null } } | null }> } };

export type ManagerInboxQueryVariables = Exact<{
  recurse: Scalars['Boolean']['input'];
}>;


export type ManagerInboxQuery = { __typename?: 'Query', viewer: { __typename?: 'User', managees: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }> } };

export type ManagerInboxCsvExportQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type ManagerInboxCsvExportQuery = { __typename?: 'Query', usersByIDs: Array<{ __typename?: 'User', id: string, username: string, firstName: string, lastName: string, group: { __typename?: 'Group', id: string, name: string }, currentJobPosition?: { __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString } } | null, moments: Array<{ __typename?: 'MomentInstance', id: string, status: MomentStatus, startDate: any, endDate: any, user: { __typename?: 'User', id: string }, cycleInstance: { __typename?: 'CycleInstance', id: string }, cycleTemplate: { __typename?: 'CycleTemplate', id: string, title: LocalizedString }, momentTemplate: { __typename?: 'MomentTemplate', id: string, title: LocalizedString, type: MomentType, duration: number, evaluation?: { __typename?: 'MomentEvaluation', evaluationForm?: { __typename?: 'EvaluationForm', id: string, title: LocalizedString } | null } | null }, goals?: Array<{ __typename?: 'Goal', id: string, status: GoalStatus, progress: number }> | null, feedbackRequest?: { __typename?: 'FeedbackRequest', id: string, responses: { __typename?: 'FeedbackResponseConnection', edges: Array<{ __typename?: 'FeedbackResponseEdge', node: { __typename?: 'FeedbackResponse', id: string, status: FeedbackResponseStatus } }> } } | null, evaluation?: { __typename?: 'EvaluationSubmission', id: string, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString }, employee: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus }, manager: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus, requiresSignature: boolean, user: { __typename?: 'User', firstName: string, lastName: string } } } | null }> }> };

export type ManagerInboxDetailQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ManagerInboxDetailQuery = { __typename?: 'Query', usersByIDs: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, currentJobPosition?: { __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString } } | null, moments: Array<{ __typename?: 'MomentInstance', id: string, status: MomentStatus, startDate: any, endDate: any, skipReason?: MomentSkipReason | null, skipReasonOther?: string | null, user: { __typename?: 'User', id: string }, cycleInstance: { __typename?: 'CycleInstance', id: string }, cycleTemplate: { __typename?: 'CycleTemplate', id: string, title: LocalizedString }, momentTemplate: { __typename?: 'MomentTemplate', id: string, title: LocalizedString, type: MomentType, duration: number, showToUser: boolean, original?: { __typename?: 'MomentTemplate', id: string } | null, talentReview?: { __typename?: 'MomentTalentReview', template?: { __typename?: 'TalentReviewTemplate', id: string } | null, group?: { __typename?: 'Group', id: string } | null } | null }, evaluation?: { __typename?: 'EvaluationSubmission', id: string, viewer: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus, requiresSignature: boolean } } | null }>, cycles: { __typename?: 'CycleInstanceConnection', edges: Array<{ __typename?: 'CycleInstanceEdge', node: { __typename?: 'CycleInstance', id: string, startDate: any, activatesAt: any, deactivatesAt?: any | null, cycleTemplate: { __typename?: 'CycleTemplate', id: string, title: LocalizedString, repeats: boolean, duration: number, successor?: { __typename?: 'CycleTemplate', id: string } | null, moments: Array<{ __typename?: 'MomentTemplate', id: string, title: LocalizedString, startOffset: number, type: MomentType, duration: number, showToUser: boolean }> }, precededBy?: { __typename?: 'CycleInstance', id: string } | null, succeededBy?: { __typename?: 'CycleInstance', id: string } | null, skippedFutureMoments: Array<{ __typename?: 'CycleInstanceSkippedMoment', momentTemplateID: string, skipReason: MomentSkipReason, skipReasonOther?: string | null }> } }> } }> };

export type JobPositionFragment = { __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString }, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString } | null, competencies: Array<{ __typename?: 'JobCompetency', id: string, competency: { __typename?: 'Competency', id: string, title: LocalizedString }, label?: { __typename?: 'Label', id: string, title: LocalizedString } | null }> };

export type JobPositionSuccessorFragment = { __typename?: 'JobPositionSuccessor', id: string, readiness: SuccessorReadiness, motivation: any, createdAt: any, viewerCanArchive: boolean, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, user: { __typename?: 'User', id: string, firstName: string, lastName: string, status: UserStatus, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, currentJobPosition?: { __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString } } | null } };

export type JobTitleFragment = { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, isArchived: boolean, externalReferenceID?: string | null, isKeyPosition: boolean, keyPositionMarkedAt?: any | null, viewerCanManageSuccession: boolean, keyPositionMarkedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, competencies: Array<{ __typename?: 'JobCompetency', id: string, competencyLevel: number, description?: LocalizedAttributedString | null, order?: number | null, level?: { __typename?: 'JobLevel', id: string, title: LocalizedString } | null, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> }, label?: { __typename?: 'Label', id: string, title: LocalizedString } | null }>, goalTemplates: { __typename?: 'GoalTemplateConnection', edges: Array<{ __typename?: 'GoalTemplateEdge', cursor: string, node: { __typename?: 'GoalTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, isArchived: boolean, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }> } }> } };

export type JobTitleCompetenciesPartialFragment = { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, isArchived: boolean, appraisal: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string } }>, competencies: Array<{ __typename?: 'JobCompetency', id: string, competencyLevel: number, order?: number | null, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, label?: { __typename?: 'Label', id: string, title: LocalizedString } | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } }> };

export type ArchiveJobPositionMutationVariables = Exact<{
  input: ArchiveJobPositionInput;
}>;


export type ArchiveJobPositionMutation = { __typename?: 'Mutation', archiveJobPosition: { __typename?: 'ArchiveJobPositionResponse', jobPosition: { __typename?: 'JobPosition', id: string, isArchived: boolean } } };

export type ArchiveJobPositionSuccessorMutationVariables = Exact<{
  input: ArchiveJobPositionSuccessorInput;
}>;


export type ArchiveJobPositionSuccessorMutation = { __typename?: 'Mutation', archiveJobPositionSuccessor: { __typename?: 'ArchiveJobPositionSuccessorResponse', successor: { __typename?: 'JobPositionSuccessor', id: string, viewerCanArchive: boolean } } };

export type ArchiveJobTitleMutationVariables = Exact<{
  input: ArchiveJobTitleInput;
}>;


export type ArchiveJobTitleMutation = { __typename?: 'Mutation', archiveJobTitle: { __typename?: 'ArchiveJobTitleResponse', jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, isArchived: boolean, externalReferenceID?: string | null, isKeyPosition: boolean, keyPositionMarkedAt?: any | null, viewerCanManageSuccession: boolean, keyPositionMarkedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, competencies: Array<{ __typename?: 'JobCompetency', id: string, competencyLevel: number, description?: LocalizedAttributedString | null, order?: number | null, level?: { __typename?: 'JobLevel', id: string, title: LocalizedString } | null, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> }, label?: { __typename?: 'Label', id: string, title: LocalizedString } | null }>, goalTemplates: { __typename?: 'GoalTemplateConnection', edges: Array<{ __typename?: 'GoalTemplateEdge', cursor: string, node: { __typename?: 'GoalTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, isArchived: boolean, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }> } }> } } } };

export type CreateJobPositionMutationVariables = Exact<{
  input: CreateJobPositionInput;
}>;


export type CreateJobPositionMutation = { __typename?: 'Mutation', createJobPosition: { __typename?: 'CreateJobPositionResponse', jobPosition: { __typename?: 'JobPosition', id: string } } };

export type CreateJobTitleMutationVariables = Exact<{
  input: CreateJobTitleInput;
}>;


export type CreateJobTitleMutation = { __typename?: 'Mutation', createJobTitle: { __typename?: 'CreateJobTitleResponse', jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, isArchived: boolean, externalReferenceID?: string | null, isKeyPosition: boolean, keyPositionMarkedAt?: any | null, viewerCanManageSuccession: boolean, keyPositionMarkedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, competencies: Array<{ __typename?: 'JobCompetency', id: string, competencyLevel: number, description?: LocalizedAttributedString | null, order?: number | null, level?: { __typename?: 'JobLevel', id: string, title: LocalizedString } | null, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> }, label?: { __typename?: 'Label', id: string, title: LocalizedString } | null }>, goalTemplates: { __typename?: 'GoalTemplateConnection', edges: Array<{ __typename?: 'GoalTemplateEdge', cursor: string, node: { __typename?: 'GoalTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, isArchived: boolean, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }> } }> } } } };

export type NominateJobPositionSuccessorMutationVariables = Exact<{
  input: NominateJobPositionSuccessorInput;
}>;


export type NominateJobPositionSuccessorMutation = { __typename?: 'Mutation', nominateJobPositionSuccessor: { __typename?: 'NominateJobPositionSuccessorResponse', successor: { __typename?: 'JobPositionSuccessor', id: string, readiness: SuccessorReadiness, motivation: any, createdAt: any, viewerCanArchive: boolean, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, user: { __typename?: 'User', id: string, firstName: string, lastName: string, status: UserStatus, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, currentJobPosition?: { __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString } } | null } } } };

export type RestoreJobPositionMutationVariables = Exact<{
  input: RestoreJobPositionInput;
}>;


export type RestoreJobPositionMutation = { __typename?: 'Mutation', restoreJobPosition: { __typename?: 'RestoreJobPositionResponse', jobPosition: { __typename?: 'JobPosition', id: string, isArchived: boolean } } };

export type RestoreJobTitleMutationVariables = Exact<{
  input: RestoreJobTitleInput;
}>;


export type RestoreJobTitleMutation = { __typename?: 'Mutation', restoreJobTitle: { __typename?: 'RestoreJobTitleResponse', jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, isArchived: boolean, externalReferenceID?: string | null, isKeyPosition: boolean, keyPositionMarkedAt?: any | null, viewerCanManageSuccession: boolean, keyPositionMarkedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, competencies: Array<{ __typename?: 'JobCompetency', id: string, competencyLevel: number, description?: LocalizedAttributedString | null, order?: number | null, level?: { __typename?: 'JobLevel', id: string, title: LocalizedString } | null, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> }, label?: { __typename?: 'Label', id: string, title: LocalizedString } | null }>, goalTemplates: { __typename?: 'GoalTemplateConnection', edges: Array<{ __typename?: 'GoalTemplateEdge', cursor: string, node: { __typename?: 'GoalTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, isArchived: boolean, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }> } }> } } } };

export type SetJobTitleKeyPositionMutationVariables = Exact<{
  input: SetJobTitleKeyPositionInput;
}>;


export type SetJobTitleKeyPositionMutation = { __typename?: 'Mutation', setJobTitleKeyPosition: { __typename?: 'SetJobTitleKeyPositionResponse', jobTitle: { __typename?: 'JobTitle', id: string, isKeyPosition: boolean, keyPositionMarkedAt?: any | null, viewerCanManageSuccession: boolean, keyPositionMarkedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null } } };

export type UpdateJobPositionMutationVariables = Exact<{
  input: UpdateJobPositionInput;
}>;


export type UpdateJobPositionMutation = { __typename?: 'Mutation', updateJobPosition: { __typename?: 'UpdateJobPositionResponse', jobPosition: { __typename?: 'JobPosition', id: string, endDate?: any | null } } };

export type UpdateJobPositionSuccessorMutationVariables = Exact<{
  input: UpdateJobPositionSuccessorInput;
}>;


export type UpdateJobPositionSuccessorMutation = { __typename?: 'Mutation', updateJobPositionSuccessor: { __typename?: 'UpdateJobPositionSuccessorResponse', successor: { __typename?: 'JobPositionSuccessor', id: string, readiness: SuccessorReadiness, motivation: any, createdAt: any, viewerCanArchive: boolean, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, user: { __typename?: 'User', id: string, firstName: string, lastName: string, status: UserStatus, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, currentJobPosition?: { __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString } } | null } } } };

export type UpdateJobTitleMutationVariables = Exact<{
  input: UpdateJobTitleInput;
}>;


export type UpdateJobTitleMutation = { __typename?: 'Mutation', updateJobTitle: { __typename?: 'UpdateJobTitleResponse', jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, isArchived: boolean, externalReferenceID?: string | null, isKeyPosition: boolean, keyPositionMarkedAt?: any | null, viewerCanManageSuccession: boolean, keyPositionMarkedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, competencies: Array<{ __typename?: 'JobCompetency', id: string, competencyLevel: number, description?: LocalizedAttributedString | null, order?: number | null, level?: { __typename?: 'JobLevel', id: string, title: LocalizedString } | null, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> }, label?: { __typename?: 'Label', id: string, title: LocalizedString } | null }>, goalTemplates: { __typename?: 'GoalTemplateConnection', edges: Array<{ __typename?: 'GoalTemplateEdge', cursor: string, node: { __typename?: 'GoalTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, isArchived: boolean, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }> } }> } } } };

export type ConnectorDryRunJobTitlesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ConnectorDryRunJobTitlesQuery = { __typename?: 'Query', viewer: { __typename?: 'User', workspace: { __typename?: 'Workspace', connector?: { __typename?: 'Connector', id: string, dryRun: { __typename?: 'ConnectorDryRun', jobTitles: { __typename?: 'ConnectorDryRunJobTitleConnection', totalCount: number, edges: Array<{ __typename?: 'ConnectorDryRunJobTitleEdge', cursor: string, node: { __typename?: 'ConnectorDryRunJobTitle', title: string, externalReferenceID: string } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } } | null } } };

export type JobPositionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type JobPositionQuery = { __typename?: 'Query', jobPosition: { __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, isArchived: boolean, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, isKeyPosition: boolean, keyPositionMarkedAt?: any | null, viewerCanManageSuccession: boolean, keyPositionMarkedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, competencies: Array<{ __typename?: 'JobCompetency', id: string, competencyLevel: number, description?: LocalizedAttributedString | null, order?: number | null, level?: { __typename?: 'JobLevel', id: string, title: LocalizedString } | null, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> }, label?: { __typename?: 'Label', id: string, title: LocalizedString } | null }> } };

export type JobPositionSuccessorsQueryVariables = Exact<{
  jobTitleID: Scalars['ID']['input'];
}>;


export type JobPositionSuccessorsQuery = { __typename?: 'Query', jobPositionSuccessors: Array<{ __typename?: 'JobPositionSuccessor', id: string, readiness: SuccessorReadiness, motivation: any, createdAt: any, viewerCanArchive: boolean, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, user: { __typename?: 'User', id: string, firstName: string, lastName: string, status: UserStatus, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, currentJobPosition?: { __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString } } | null } }> };

export type JobPositionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  status?: InputMaybe<JobPositionStatus>;
}>;


export type JobPositionsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, externalReferenceID?: string | null, isArchived: boolean, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, isArchived: boolean }, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null }> } };

export type JobPositionsSettingsQueryVariables = Exact<{
  status?: InputMaybe<UserStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
}>;


export type JobPositionsSettingsQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, lastLoginAt?: any | null, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, externalReferenceID?: string | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString } }> } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type JobTitleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type JobTitleQuery = { __typename?: 'Query', jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, isArchived: boolean, externalReferenceID?: string | null, isKeyPosition: boolean, keyPositionMarkedAt?: any | null, viewerCanManageSuccession: boolean, keyPositionMarkedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null, competencies: Array<{ __typename?: 'JobCompetency', id: string, competencyLevel: number, description?: LocalizedAttributedString | null, order?: number | null, level?: { __typename?: 'JobLevel', id: string, title: LocalizedString } | null, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> }, label?: { __typename?: 'Label', id: string, title: LocalizedString } | null }>, goalTemplates: { __typename?: 'GoalTemplateConnection', edges: Array<{ __typename?: 'GoalTemplateEdge', cursor: string, node: { __typename?: 'GoalTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, isArchived: boolean, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }> } }> } } };

export type JobTitleCompetenciesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
}>;


export type JobTitleCompetenciesQuery = { __typename?: 'Query', jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, isArchived: boolean, appraisal: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string } }>, competencies: Array<{ __typename?: 'JobCompetency', id: string, competencyLevel: number, order?: number | null, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, label?: { __typename?: 'Label', id: string, title: LocalizedString } | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } }> } };

export type JobTitleSuccessorsQueryVariables = Exact<{ [key: string]: never; }>;


export type JobTitleSuccessorsQuery = { __typename?: 'Query', jobTitleSuccessors: Array<{ __typename?: 'JobTitleSuccession', jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, isKeyPosition: boolean, viewerCanManageSuccession: boolean }, holders: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, status: UserStatus, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }>, successors: Array<{ __typename?: 'JobPositionSuccessor', id: string, readiness: SuccessorReadiness, motivation: any, createdAt: any, viewerCanArchive: boolean, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, user: { __typename?: 'User', id: string, firstName: string, lastName: string, status: UserStatus, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, currentJobPosition?: { __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString } } | null } }> }> };

export type JobTitlesQueryVariables = Exact<{
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type JobTitlesQuery = { __typename?: 'Query', jobTitles: { __typename?: 'JobTitleConnection', edges: Array<{ __typename?: 'JobTitleEdge', cursor: string, node: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, isArchived: boolean, isKeyPosition: boolean, styrData?: { __typename?: 'StyrData', jobID: string, jobName?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type MigrationJobTitlesQueryVariables = Exact<{
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MigrationJobTitlesQuery = { __typename?: 'Query', jobTitles: { __typename?: 'JobTitleConnection', edges: Array<{ __typename?: 'JobTitleEdge', node: { __typename?: 'JobTitle', id: string, title: LocalizedString, externalReferenceID?: string | null } }> } };

export type LearningCourseFragment = { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, title: LocalizedString, description?: LocalizedAttributedString | null, languageID: string, durationMinutes?: number | null, imageUrl?: string | null, launchUrl?: string | null, launchUrls?: LocalizedString | null, isArchived: boolean, learningType: { __typename?: 'LearningType', id: string, color: string, title: LocalizedString }, learningSubjects: Array<{ __typename?: 'LearningSubject', id: string, title: LocalizedString }> };

export type LearningEventFragment = { __typename?: 'LearningEvent', id: string, status: LearningEventStatus, title: LocalizedString, description?: LocalizedAttributedString | null, startDate: any, endDate: any, timezone?: string | null, capacity: number, attendeeCount: number, meetingLink?: string | null, location?: string | null, languageID: string, isArchived: boolean, isViewerAttending: boolean, lastRejectedAt?: any | null, cover?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, learningType: { __typename?: 'LearningType', id: string, color: string, title: LocalizedString }, hosts: { __typename?: 'LearningEventAttendeeConnection', edges: Array<{ __typename?: 'LearningEventAttendeeEdge', attendeeType: LearningEventAttendeeType, node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }> }, attendees: { __typename?: 'LearningEventAttendeeConnection', edges: Array<{ __typename?: 'LearningEventAttendeeEdge', attendeeType: LearningEventAttendeeType, node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }> }, learningSubjects: Array<{ __typename?: 'LearningSubject', id: string, title: LocalizedString }>, createdBy: { __typename?: 'User', id: string } };

export type ArchiveLearningEventMutationVariables = Exact<{
  input: ArchiveLearningEventInput;
}>;


export type ArchiveLearningEventMutation = { __typename?: 'Mutation', archiveLearningEvent: { __typename?: 'ArchiveLearningEventResponse', learningEvent: { __typename?: 'LearningEvent', id: string, isArchived: boolean } } };

export type ArchiveLearningSubjectMutationVariables = Exact<{
  input: ArchiveLearningSubjectInput;
}>;


export type ArchiveLearningSubjectMutation = { __typename?: 'Mutation', archiveLearningSubject: { __typename?: 'ArchiveLearningSubjectResponse', learningSubject: { __typename?: 'LearningSubject', id: string, isArchived: boolean } } };

export type ArchiveLearningTypeMutationVariables = Exact<{
  input: ArchiveLearningTypeInput;
}>;


export type ArchiveLearningTypeMutation = { __typename?: 'Mutation', archiveLearningType: { __typename?: 'ArchiveLearningTypeResponse', learningType: { __typename?: 'LearningType', id: string, isArchived: boolean } } };

export type CancelLearningEventMutationVariables = Exact<{
  input: CancelLearningEventInput;
}>;


export type CancelLearningEventMutation = { __typename?: 'Mutation', cancelLearningEvent: { __typename?: 'CancelLearningEventResponse', learningEvent: { __typename?: 'LearningEvent', id: string, status: LearningEventStatus, title: LocalizedString, description?: LocalizedAttributedString | null, startDate: any, endDate: any, timezone?: string | null, capacity: number, attendeeCount: number, meetingLink?: string | null, location?: string | null, languageID: string, isArchived: boolean, isViewerAttending: boolean, lastRejectedAt?: any | null, cover?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, learningType: { __typename?: 'LearningType', id: string, color: string, title: LocalizedString }, hosts: { __typename?: 'LearningEventAttendeeConnection', edges: Array<{ __typename?: 'LearningEventAttendeeEdge', attendeeType: LearningEventAttendeeType, node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }> }, attendees: { __typename?: 'LearningEventAttendeeConnection', edges: Array<{ __typename?: 'LearningEventAttendeeEdge', attendeeType: LearningEventAttendeeType, node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }> }, learningSubjects: Array<{ __typename?: 'LearningSubject', id: string, title: LocalizedString }>, createdBy: { __typename?: 'User', id: string } } } };

export type CreateLearningEventMutationVariables = Exact<{
  input: CreateLearningEventInput;
}>;


export type CreateLearningEventMutation = { __typename?: 'Mutation', createLearningEvent: { __typename?: 'CreateLearningEventResponse', learningEvent: { __typename?: 'LearningEvent', id: string } } };

export type CreateLearningSubjectMutationVariables = Exact<{
  input: CreateLearningSubjectInput;
}>;


export type CreateLearningSubjectMutation = { __typename?: 'Mutation', createLearningSubject: { __typename?: 'CreateLearningSubjectResponse', learningSubject: { __typename?: 'LearningSubject', id: string } } };

export type CreateLearningTypeMutationVariables = Exact<{
  input: CreateLearningTypeInput;
}>;


export type CreateLearningTypeMutation = { __typename?: 'Mutation', createLearningType: { __typename?: 'CreateLearningTypeResponse', learningType: { __typename?: 'LearningType', id: string } } };

export type JoinLearningEventMutationVariables = Exact<{
  input: JoinLearningEventInput;
}>;


export type JoinLearningEventMutation = { __typename?: 'Mutation', joinLearningEvent: { __typename?: 'JoinLearningEventResponse', learningEvent: { __typename?: 'LearningEvent', id: string, isViewerAttending: boolean, hosts: { __typename?: 'LearningEventAttendeeConnection', edges: Array<{ __typename?: 'LearningEventAttendeeEdge', attendeeType: LearningEventAttendeeType, node: { __typename?: 'User', id: string, firstName: string, lastName: string } }> }, attendees: { __typename?: 'LearningEventAttendeeConnection', edges: Array<{ __typename?: 'LearningEventAttendeeEdge', attendeeType: LearningEventAttendeeType, node: { __typename?: 'User', id: string, firstName: string, lastName: string } }> } } } };

export type LeaveLearningEventMutationVariables = Exact<{
  input: LeaveLearningEventInput;
}>;


export type LeaveLearningEventMutation = { __typename?: 'Mutation', leaveLearningEvent: { __typename?: 'LeaveLearningEventResponse', learningEvent: { __typename?: 'LearningEvent', id: string, isViewerAttending: boolean, hosts: { __typename?: 'LearningEventAttendeeConnection', edges: Array<{ __typename?: 'LearningEventAttendeeEdge', attendeeType: LearningEventAttendeeType, node: { __typename?: 'User', id: string, firstName: string, lastName: string } }> }, attendees: { __typename?: 'LearningEventAttendeeConnection', edges: Array<{ __typename?: 'LearningEventAttendeeEdge', attendeeType: LearningEventAttendeeType, node: { __typename?: 'User', id: string, firstName: string, lastName: string } }> } } } };

export type RestoreLearningEventMutationVariables = Exact<{
  input: RestoreLearningEventInput;
}>;


export type RestoreLearningEventMutation = { __typename?: 'Mutation', restoreLearningEvent: { __typename?: 'RestoreLearningEventResponse', learningEvent: { __typename?: 'LearningEvent', id: string, isArchived: boolean } } };

export type RestoreLearningSubjectMutationVariables = Exact<{
  input: RestoreLearningSubjectInput;
}>;


export type RestoreLearningSubjectMutation = { __typename?: 'Mutation', restoreLearningSubject: { __typename?: 'RestoreLearningSubjectResponse', learningSubject: { __typename?: 'LearningSubject', id: string, isArchived: boolean } } };

export type RestoreLearningTypeMutationVariables = Exact<{
  input: RestoreLearningTypeInput;
}>;


export type RestoreLearningTypeMutation = { __typename?: 'Mutation', restoreLearningType: { __typename?: 'RestoreLearningTypeResponse', learningType: { __typename?: 'LearningType', id: string, isArchived: boolean } } };

export type ReviewLearningEventMutationVariables = Exact<{
  input: ReviewLearningEventInput;
}>;


export type ReviewLearningEventMutation = { __typename?: 'Mutation', reviewLearningEvent: { __typename?: 'ReviewLearningEventResponse', learningEvent: { __typename?: 'LearningEvent', id: string, status: LearningEventStatus, lastRejectedAt?: any | null, isArchived: boolean } } };

export type UpdateLearningEventMutationVariables = Exact<{
  input: UpdateLearningEventInput;
}>;


export type UpdateLearningEventMutation = { __typename?: 'Mutation', updateLearningEvent: { __typename?: 'UpdateLearningEventResponse', learningEvent: { __typename?: 'LearningEvent', id: string, status: LearningEventStatus, title: LocalizedString, description?: LocalizedAttributedString | null, startDate: any, endDate: any, timezone?: string | null, capacity: number, attendeeCount: number, meetingLink?: string | null, location?: string | null, languageID: string, isArchived: boolean, isViewerAttending: boolean, lastRejectedAt?: any | null, cover?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, learningType: { __typename?: 'LearningType', id: string, color: string, title: LocalizedString }, hosts: { __typename?: 'LearningEventAttendeeConnection', edges: Array<{ __typename?: 'LearningEventAttendeeEdge', attendeeType: LearningEventAttendeeType, node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }> }, attendees: { __typename?: 'LearningEventAttendeeConnection', edges: Array<{ __typename?: 'LearningEventAttendeeEdge', attendeeType: LearningEventAttendeeType, node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }> }, learningSubjects: Array<{ __typename?: 'LearningSubject', id: string, title: LocalizedString }>, createdBy: { __typename?: 'User', id: string } } } };

export type UpdateLearningSubjectMutationVariables = Exact<{
  input: UpdateLearningSubjectInput;
}>;


export type UpdateLearningSubjectMutation = { __typename?: 'Mutation', updateLearningSubject: { __typename?: 'UpdateLearningSubjectResponse', learningSubject: { __typename?: 'LearningSubject', id: string } } };

export type UpdateLearningTypeMutationVariables = Exact<{
  input: UpdateLearningTypeInput;
}>;


export type UpdateLearningTypeMutation = { __typename?: 'Mutation', updateLearningType: { __typename?: 'UpdateLearningTypeResponse', learningType: { __typename?: 'LearningType', id: string } } };

export type AttendedLearningEventsForJourneyQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
  now: Scalars['DateTime']['input'];
}>;


export type AttendedLearningEventsForJourneyQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, attendingLearningEvents: { __typename?: 'LearningAttendeeEventConnection', edges: Array<{ __typename?: 'LearningAttendeeEventEdge', node: { __typename?: 'LearningEvent', id: string, title: LocalizedString, createdOnDateTimeOffsetUtc: any, learningType: { __typename?: 'LearningType', id: string } } }> } } };

export type AttendingLearningEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type AttendingLearningEventsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', attendingLearningEvents: { __typename?: 'LearningAttendeeEventConnection', edges: Array<{ __typename?: 'LearningAttendeeEventEdge', attendeeType: LearningEventAttendeeType, node: { __typename?: 'LearningEvent', id: string, title: LocalizedString, startDate: any, endDate: any, isArchived: boolean, isViewerAttending: boolean, cover?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, learningType: { __typename?: 'LearningType', color: string } } }> } } };

export type ConversationLearningRecommendationsQueryVariables = Exact<{
  input: ConversationLearningRecommendationsInput;
}>;


export type ConversationLearningRecommendationsQuery = { __typename?: 'Query', conversationLearningRecommendations: { __typename?: 'LearningRecommendationsResponse', recommendations: Array<{ __typename?: 'LearningRecommendation', reason?: string | null, learningCourse: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, title: LocalizedString, description?: LocalizedAttributedString | null, languageID: string, durationMinutes?: number | null, imageUrl?: string | null, launchUrl?: string | null, launchUrls?: LocalizedString | null, isArchived: boolean, learningType: { __typename?: 'LearningType', id: string, color: string, title: LocalizedString }, learningSubjects: Array<{ __typename?: 'LearningSubject', id: string, title: LocalizedString }> } }> } };

export type LearningCourseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LearningCourseQuery = { __typename?: 'Query', learningCourse: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, title: LocalizedString, description?: LocalizedAttributedString | null, languageID: string, durationMinutes?: number | null, imageUrl?: string | null, launchUrl?: string | null, launchUrls?: LocalizedString | null, isArchived: boolean, learningType: { __typename?: 'LearningType', id: string, color: string, title: LocalizedString }, learningSubjects: Array<{ __typename?: 'LearningSubject', id: string, title: LocalizedString }> } };

export type LearningCoursesQueryVariables = Exact<{
  filters?: InputMaybe<LearningCourseFilters>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LearningCoursesQuery = { __typename?: 'Query', learningCourses: { __typename?: 'LearningCourseConnection', totalCount: number, edges: Array<{ __typename?: 'LearningCourseEdge', cursor: string, node: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, title: LocalizedString, description?: LocalizedAttributedString | null, languageID: string, durationMinutes?: number | null, imageUrl?: string | null, launchUrl?: string | null, launchUrls?: LocalizedString | null, isArchived: boolean, learningType: { __typename?: 'LearningType', id: string, color: string, title: LocalizedString }, learningSubjects: Array<{ __typename?: 'LearningSubject', id: string, title: LocalizedString }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type LearningEventQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LearningEventQuery = { __typename?: 'Query', learningEvent: { __typename?: 'LearningEvent', id: string, status: LearningEventStatus, title: LocalizedString, description?: LocalizedAttributedString | null, startDate: any, endDate: any, timezone?: string | null, capacity: number, attendeeCount: number, meetingLink?: string | null, location?: string | null, languageID: string, isArchived: boolean, isViewerAttending: boolean, lastRejectedAt?: any | null, cover?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, learningType: { __typename?: 'LearningType', id: string, color: string, title: LocalizedString }, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }>, hosts: { __typename?: 'LearningEventAttendeeConnection', edges: Array<{ __typename?: 'LearningEventAttendeeEdge', attendeeType: LearningEventAttendeeType, node: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString } }> } }> }, attendees: { __typename?: 'LearningEventAttendeeConnection', edges: Array<{ __typename?: 'LearningEventAttendeeEdge', attendeeType: LearningEventAttendeeType, node: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString } }> } }> }, learningSubjects: Array<{ __typename?: 'LearningSubject', id: string, title: LocalizedString }>, createdBy: { __typename?: 'User', id: string } } };

export type LearningEventProposalsQueryVariables = Exact<{
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LearningEventProposalsQuery = { __typename?: 'Query', learningEventProposals: { __typename?: 'LearningEventConnection', edges: Array<{ __typename?: 'LearningEventEdge', node: { __typename?: 'LearningEvent', id: string, title: LocalizedString, status: LearningEventStatus, startDate: any, endDate: any, isViewerAttending: boolean, cover?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, learningType: { __typename?: 'LearningType', color: string } } }> } };

export type LearningEventsQueryVariables = Exact<{
  filters?: InputMaybe<LearningEventFilters>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LearningEventsQuery = { __typename?: 'Query', learningEvents: { __typename?: 'LearningEventConnection', edges: Array<{ __typename?: 'LearningEventEdge', node: { __typename?: 'LearningEvent', id: string, title: LocalizedString, status: LearningEventStatus, startDate: any, endDate: any, isArchived: boolean, isViewerAttending: boolean, viewerCanJoin: boolean, cover?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, learningType: { __typename?: 'LearningType', color: string }, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }> } }> } };

export type LearningMyEventsQueryVariables = Exact<{
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LearningMyEventsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', learningEventProposals: { __typename?: 'LearningEventConnection', edges: Array<{ __typename?: 'LearningEventEdge', node: { __typename?: 'LearningEvent', id: string, title: LocalizedString, status: LearningEventStatus, startDate: any, endDate: any, isViewerAttending: boolean, cover?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, learningType: { __typename?: 'LearningType', color: string } } }> } } };

export type LearningRecommendationsQueryVariables = Exact<{ [key: string]: never; }>;


export type LearningRecommendationsQuery = { __typename?: 'Query', learningRecommendations: { __typename?: 'LearningRecommendationsResponse', recommendations: Array<{ __typename?: 'LearningRecommendation', reason?: string | null, learningCourse: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, title: LocalizedString, description?: LocalizedAttributedString | null, languageID: string, durationMinutes?: number | null, imageUrl?: string | null, launchUrl?: string | null, launchUrls?: LocalizedString | null, isArchived: boolean, learningType: { __typename?: 'LearningType', id: string, color: string, title: LocalizedString }, learningSubjects: Array<{ __typename?: 'LearningSubject', id: string, title: LocalizedString }> } }> } };

export type LearningSubjectsQueryVariables = Exact<{
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LearningSubjectsQuery = { __typename?: 'Query', learningSubjects: { __typename?: 'LearningSubjectConnection', edges: Array<{ __typename?: 'LearningSubjectEdge', node: { __typename?: 'LearningSubject', id: string, title: LocalizedString, isArchived: boolean } }> } };

export type LearningTypesQueryVariables = Exact<{
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LearningTypesQuery = { __typename?: 'Query', learningTypes: { __typename?: 'LearningTypeConnection', edges: Array<{ __typename?: 'LearningTypeEdge', node: { __typename?: 'LearningType', id: string, color: string, title: LocalizedString, isArchived: boolean } }> } };

export type CreateTaskMutationVariables = Exact<{
  input: CreateTaskInput;
}>;


export type CreateTaskMutation = { __typename?: 'Mutation', createTask: { __typename?: 'CreateTaskResponse', task: { __typename?: 'Task', id: string, title: string, createdAt: any, updatedAt: any, status: TaskStatus, dueDate?: any | null, subjectType: TaskSubjectType, subject?: { __typename: 'Group', id: string, name: string } | { __typename: 'Note', id: string, title?: string | null } | { __typename: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null } } };

export type DeleteTaskMutationVariables = Exact<{
  input: DeleteTaskInput;
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask: { __typename?: 'DeleteTaskResponse', success: boolean } };

export type DepartmentLastTalentReviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  isArchived: Scalars['Boolean']['input'];
}>;


export type DepartmentLastTalentReviewQuery = { __typename?: 'Query', group: { __typename?: 'Group', id: string, name: string, talentReviews: { __typename?: 'TalentReviewConnection', edges: Array<{ __typename?: 'TalentReviewEdge', node: { __typename?: 'TalentReview', id: string, title: string, createdAt: any, placements: Array<{ __typename?: 'TalentReviewPlacement', column: number, row: number }>, group: { __typename?: 'Group', members: { __typename?: 'GroupMemberConnection', totalCount: number } } } }> } } };

export type EmployeeFeedQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
  archived: Scalars['Boolean']['input'];
  filterOnType?: InputMaybe<Array<InputMaybe<FeedItemType>> | InputMaybe<FeedItemType>>;
}>;


export type EmployeeFeedQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, employeeFeed: { __typename?: 'EmployeeFeed', itemsPerMonth: Array<{ __typename?: 'EmployeeFeedMonthItems', month: string, items: Array<{ __typename?: 'EmployeeFeedItem', id: string, type: FeedItemType, title: LocalizedString, date: any }> } | null> } } };

export type EmployeeFeedFragment = { __typename?: 'EmployeeFeed', itemsPerMonth: Array<{ __typename?: 'EmployeeFeedMonthItems', month: string, items: Array<{ __typename?: 'EmployeeFeedItem', id: string, type: FeedItemType, title: LocalizedString, date: any }> } | null> };

export type EmployeeFeedMonthItemsFragment = { __typename?: 'EmployeeFeedMonthItems', month: string, items: Array<{ __typename?: 'EmployeeFeedItem', id: string, type: FeedItemType, title: LocalizedString, date: any }> };

export type EmployeeFeedItemFragment = { __typename?: 'EmployeeFeedItem', id: string, type: FeedItemType, title: LocalizedString, date: any };

export type EmployeeFeedHeaderQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
}>;


export type EmployeeFeedHeaderQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } };

export type GroupFeedQueryVariables = Exact<{
  groupID: Scalars['ID']['input'];
}>;


export type GroupFeedQuery = { __typename?: 'Query', group: { __typename?: 'Group', id: string, name: string } };

export type GroupTasksQueryVariables = Exact<{
  groupID: Scalars['ID']['input'];
}>;


export type GroupTasksQuery = { __typename?: 'Query', group: { __typename?: 'Group', id: string, tasks: Array<{ __typename?: 'Task', id: string, title: string, createdAt: any, updatedAt: any, status: TaskStatus, dueDate?: any | null, subjectType: TaskSubjectType, subject?: { __typename: 'Group', id: string, name: string } | { __typename: 'Note', id: string, title?: string | null } | { __typename: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null }> } };

export type ReorderTaskMutationVariables = Exact<{
  input: ReorderTaskInput;
}>;


export type ReorderTaskMutation = { __typename?: 'Mutation', reorderTask: { __typename?: 'ReorderTaskResponse', task: { __typename?: 'Task', id: string, order: number } } };

export type UpdateTaskMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type UpdateTaskMutation = { __typename?: 'Mutation', updateTask: { __typename?: 'UpdateTaskResponse', task: { __typename?: 'Task', id: string, title: string, createdAt: any, updatedAt: any, status: TaskStatus, dueDate?: any | null, subjectType: TaskSubjectType, subject?: { __typename: 'Group', id: string, name: string } | { __typename: 'Note', id: string, title?: string | null } | { __typename: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null } } };

export type UserDevelopmentItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  status: GoalStatus;
  isArchived: Scalars['Boolean']['input'];
  before?: InputMaybe<Scalars['ID']['input']>;
  last: Scalars['Int']['input'];
}>;


export type UserDevelopmentItemsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, feedbackRequests: { __typename?: 'FeedbackRequestConnection', edges: Array<{ __typename?: 'FeedbackRequestEdge', node: { __typename?: 'FeedbackRequest', id: string, title: string, createdAt: any, dueDate: any, isArchived: boolean, mode: FeedbackMode, instruction?: any | null, responses: { __typename?: 'FeedbackResponseConnection', edges: Array<{ __typename?: 'FeedbackResponseEdge', node: { __typename?: 'FeedbackResponse', id: string, status: FeedbackResponseStatus, recipient: { __typename?: 'FeedbackExternal', firstName: string, lastName: string } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } } }> } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } }, documentsV2: Array<{ __typename?: 'UserDocumentV2', id: string, name: string, createdAt: any, viewerCanDelete: boolean, status: UserDocumentV2Status, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, evaluationSubmissions: { __typename?: 'EvaluationSubmissionConnection', edges: Array<{ __typename?: 'EvaluationSubmissionEdge', node: { __typename?: 'EvaluationSubmission', id: string, createdAt: any, deadline: any, isArchived: boolean, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString }, manager: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus, requiresInput: boolean, requiresSignature: boolean, party: EvaluationSubmissionParty, isCompleted: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }, employee: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus, requiresInput: boolean, party: EvaluationSubmissionParty, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } }, goalsV2: { __typename?: 'GoalConnection', totalCount?: number | null, edges: Array<{ __typename?: 'GoalEdge', node: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null }, owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } }, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, externalReferenceID?: string | null, jobLevel?: { __typename?: 'JobLevel', id: string } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null }, appraisal: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string } }>, competencies: Array<{ __typename?: 'JobCompetency', id: string, competencyLevel: number, order?: number | null, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, label?: { __typename?: 'Label', id: string, title: LocalizedString } | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } }> }> } };

export type UserTasksQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
}>;


export type UserTasksQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, tasks: Array<{ __typename?: 'Task', id: string, title: string, createdAt: any, updatedAt: any, status: TaskStatus, dueDate?: any | null, subjectType: TaskSubjectType, subject?: { __typename: 'Group', id: string, name: string } | { __typename: 'Note', id: string, title?: string | null } | { __typename: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null }> } };

export type ViewerTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerTasksQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, createdTasks: Array<{ __typename?: 'Task', id: string, title: string, createdAt: any, updatedAt: any, status: TaskStatus, dueDate?: any | null, subjectType: TaskSubjectType, subject?: { __typename: 'Group', id: string, name: string } | { __typename: 'Note', id: string, title?: string | null } | { __typename: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null }> } };

export type TaskFragment = { __typename?: 'Task', id: string, title: string, createdAt: any, updatedAt: any, status: TaskStatus, dueDate?: any | null, subjectType: TaskSubjectType, subject?: { __typename: 'Group', id: string, name: string } | { __typename: 'Note', id: string, title?: string | null } | { __typename: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null };

export type MeetingFragment = { __typename?: 'Meeting', id: string, startsAt: any, endsAt?: any | null, timezone: any, isCancelled: boolean, updatedAt: any, attendees: Array<{ __typename?: 'MeetingAttendee', id: string, status: AttendeeStatus, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, proposal?: { __typename?: 'AttendeeProposal', startsAt: any, endsAt?: any | null } | null }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, series?: { __typename?: 'MeetingSeries', id: string, recurrenceFrequency?: MeetingSeriesRecurrenceFrequency | null, recurrenceRule: string, timezone: any, noteSeriesMetadata?: { __typename?: 'NoteSeriesMetadata', defaultTitle: string } | null } | null, note?: { __typename?: 'Note', id: string, meeting?: { __typename?: 'Meeting', id: string } | null } | null };

export type CancelMeetingMutationVariables = Exact<{
  input: CancelMeetingInput;
}>;


export type CancelMeetingMutation = { __typename?: 'Mutation', cancelMeeting: { __typename?: 'CancelMeetingResponse', meeting: { __typename?: 'Meeting', id: string, startsAt: any, endsAt?: any | null, timezone: any, isCancelled: boolean, updatedAt: any, attendees: Array<{ __typename?: 'MeetingAttendee', id: string, status: AttendeeStatus, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, proposal?: { __typename?: 'AttendeeProposal', startsAt: any, endsAt?: any | null } | null }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, series?: { __typename?: 'MeetingSeries', id: string, recurrenceFrequency?: MeetingSeriesRecurrenceFrequency | null, recurrenceRule: string, timezone: any, noteSeriesMetadata?: { __typename?: 'NoteSeriesMetadata', defaultTitle: string } | null } | null, note?: { __typename?: 'Note', id: string, meeting?: { __typename?: 'Meeting', id: string } | null } | null } } };

export type CreateMeetingMutationVariables = Exact<{
  input: CreateMeetingInput;
}>;


export type CreateMeetingMutation = { __typename?: 'Mutation', createMeeting: { __typename?: 'CreateMeetingResponse', meeting: { __typename?: 'Meeting', id: string, startsAt: any, endsAt?: any | null, timezone: any, isCancelled: boolean, updatedAt: any, attendees: Array<{ __typename?: 'MeetingAttendee', id: string, status: AttendeeStatus, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, proposal?: { __typename?: 'AttendeeProposal', startsAt: any, endsAt?: any | null } | null }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, series?: { __typename?: 'MeetingSeries', id: string, recurrenceFrequency?: MeetingSeriesRecurrenceFrequency | null, recurrenceRule: string, timezone: any, noteSeriesMetadata?: { __typename?: 'NoteSeriesMetadata', defaultTitle: string } | null } | null, note?: { __typename?: 'Note', id: string, meeting?: { __typename?: 'Meeting', id: string } | null } | null } } };

export type RestoreMeetingMutationVariables = Exact<{
  input: RestoreMeetingInput;
}>;


export type RestoreMeetingMutation = { __typename?: 'Mutation', restoreMeeting: { __typename?: 'RestoreMeetingResponse', meeting: { __typename?: 'Meeting', id: string, startsAt: any, endsAt?: any | null, timezone: any, isCancelled: boolean, updatedAt: any, attendees: Array<{ __typename?: 'MeetingAttendee', id: string, status: AttendeeStatus, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, proposal?: { __typename?: 'AttendeeProposal', startsAt: any, endsAt?: any | null } | null }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, series?: { __typename?: 'MeetingSeries', id: string, recurrenceFrequency?: MeetingSeriesRecurrenceFrequency | null, recurrenceRule: string, timezone: any, noteSeriesMetadata?: { __typename?: 'NoteSeriesMetadata', defaultTitle: string } | null } | null, note?: { __typename?: 'Note', id: string, meeting?: { __typename?: 'Meeting', id: string } | null } | null } } };

export type UpdateMeetingMutationVariables = Exact<{
  input: UpdateMeetingInput;
}>;


export type UpdateMeetingMutation = { __typename?: 'Mutation', updateMeeting: { __typename?: 'UpdateMeetingResponse', meeting: { __typename?: 'Meeting', id: string, startsAt: any, endsAt?: any | null, timezone: any, isCancelled: boolean, updatedAt: any, attendees: Array<{ __typename?: 'MeetingAttendee', id: string, status: AttendeeStatus, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, proposal?: { __typename?: 'AttendeeProposal', startsAt: any, endsAt?: any | null } | null }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, series?: { __typename?: 'MeetingSeries', id: string, recurrenceFrequency?: MeetingSeriesRecurrenceFrequency | null, recurrenceRule: string, timezone: any, noteSeriesMetadata?: { __typename?: 'NoteSeriesMetadata', defaultTitle: string } | null } | null, note?: { __typename?: 'Note', id: string, meeting?: { __typename?: 'Meeting', id: string } | null } | null } } };

export type CommentFragment = { __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null };

export type NoteFragment = { __typename?: 'Note', id: string, title?: string | null, content?: any | null, preparation?: string | null, date: string, isArchived: boolean, viewerCanArchive: boolean, viewerCanRestore: boolean, viewerCanComment: boolean, viewerCanShare: boolean, viewerCanUpdate: boolean, createdAt: any, updatedAt: any, noteType: NoteType, tasks: Array<{ __typename?: 'Task', id: string, title: string, status: TaskStatus, order: number }>, subject?: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | null, owner: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, collaborators: { __typename?: 'NoteCollaboratorConnection', edges: Array<{ __typename?: 'NoteCollaboratorEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } }> }, goals: Array<{ __typename?: 'Goal', id: string, title: LocalizedString, progress: number }>, feedbackRequests: Array<{ __typename?: 'FeedbackRequest', id: string, title: string }>, evaluationSubmissions: Array<{ __typename?: 'EvaluationSubmission', id: string, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString } }>, transcription?: { __typename?: 'Transcription', id: string, transcript?: string | null, summary?: string | null, editableSummary?: any | null, uploadStatus: TranscriptionUploadStatus, status: TranscriptionStatus, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } } | null, meeting?: { __typename?: 'Meeting', id: string, startsAt: any, endsAt?: any | null, timezone: any, isCancelled: boolean, updatedAt: any, attendees: Array<{ __typename?: 'MeetingAttendee', id: string, status: AttendeeStatus, user: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, proposal?: { __typename?: 'AttendeeProposal', startsAt: any, endsAt?: any | null } | null }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, series?: { __typename?: 'MeetingSeries', id: string, recurrenceFrequency?: MeetingSeriesRecurrenceFrequency | null, recurrenceRule: string, timezone: any, noteSeriesMetadata?: { __typename?: 'NoteSeriesMetadata', defaultTitle: string } | null } | null, note?: { __typename?: 'Note', id: string, meeting?: { __typename?: 'Meeting', id: string } | null } | null } | null, metadata?: { __typename?: 'NoteMetadata', source?: string | null, outlookItemId?: string | null, teamsChatId?: string | null, teamsMessageId?: string | null, tenantId?: string | null } | null };

export type NoteForCardFragment = { __typename?: 'Note', id: string, title?: string | null, date: string, createdAt: any, updatedAt: any, collaborators: { __typename?: 'NoteCollaboratorConnection', edges: Array<{ __typename?: 'NoteCollaboratorEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } }> }, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, subject?: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | null, meeting?: { __typename?: 'Meeting', startsAt: any, timezone: any, isCancelled: boolean, series?: { __typename?: 'MeetingSeries', id: string } | null } | null, metadata?: { __typename?: 'NoteMetadata', source?: string | null } | null };

export type NoteForOneOnOneOverviewFragment = { __typename?: 'Note', noteType: NoteType, content?: any | null, id: string, title?: string | null, date: string, createdAt: any, updatedAt: any, owner: { __typename?: 'User', id: string }, collaborators: { __typename?: 'NoteCollaboratorConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'NoteCollaboratorEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } }> }, metadata?: { __typename?: 'NoteMetadata', sender?: string | null, source?: string | null } | null, tasks: Array<{ __typename?: 'Task', id: string, title: string, status: TaskStatus, order: number }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, subject?: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | null, meeting?: { __typename?: 'Meeting', startsAt: any, timezone: any, isCancelled: boolean, series?: { __typename?: 'MeetingSeries', id: string } | null } | null };

export type NoteMeetingFragment = { __typename?: 'Meeting', id: string, startsAt: any, endsAt?: any | null, timezone: any, isCancelled: boolean, updatedAt: any, attendees: Array<{ __typename?: 'MeetingAttendee', id: string, status: AttendeeStatus, user: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, proposal?: { __typename?: 'AttendeeProposal', startsAt: any, endsAt?: any | null } | null }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, series?: { __typename?: 'MeetingSeries', id: string, recurrenceFrequency?: MeetingSeriesRecurrenceFrequency | null, recurrenceRule: string, timezone: any, noteSeriesMetadata?: { __typename?: 'NoteSeriesMetadata', defaultTitle: string } | null } | null, note?: { __typename?: 'Note', id: string, meeting?: { __typename?: 'Meeting', id: string } | null } | null };

export type NoteTaskFragment = { __typename?: 'Task', id: string, title: string, status: TaskStatus, order: number };

export type NoteUserFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null };

export type NotesSidebarUserFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null };

export type ArchiveCommentMutationVariables = Exact<{
  input: ArchiveCommentInput;
}>;


export type ArchiveCommentMutation = { __typename?: 'Mutation', archiveComment: { __typename?: 'ArchiveCommentResponse', comment: { __typename?: 'Comment', id: string, isArchived: boolean } } };

export type ArchiveNoteMutationVariables = Exact<{
  input: ArchiveNoteInput;
}>;


export type ArchiveNoteMutation = { __typename?: 'Mutation', archiveNote: { __typename?: 'ArchiveNoteResponse', note: { __typename?: 'Note', id: string, isArchived: boolean, viewerCanArchive: boolean, viewerCanRestore: boolean } } };

export type CommentMutationVariables = Exact<{
  input: UpdateCommentInput;
}>;


export type CommentMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'UpdateCommentResponse', comment: { __typename?: 'Comment', id: string, content?: any | null } } };

export type CreateCommentMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'CreateCommentResponse', comment: { __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, target: { __typename?: 'Compliment' } | { __typename?: 'EvaluationSubmission' } | { __typename?: 'FeedbackResponse', id: string, status: FeedbackResponseStatus, sharedAt?: any | null, createdAt: any, isArchived: boolean, viewerCanComment: boolean, viewerCanViewComments: boolean, recipient: { __typename?: 'FeedbackExternal', firstName: string, lastName: string, email: string } | { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, answers?: Array<{ __typename?: 'FeedbackResponseAnswer', questionID: string, text?: any | null, stars?: number | null, selectedOptionID?: string | null, competencyLevelIndex?: number | null, voiceMemo?: { __typename?: 'VoiceMemo', samples: Array<number>, sampleRate: number, asset: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }> } | { __typename?: 'Goal' } | { __typename?: 'Note' }, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null } } };

export type CreateNoteMutationVariables = Exact<{
  input: CreateNoteInput;
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote: { __typename?: 'CreateNoteResponse', note: { __typename?: 'Note', id: string, title?: string | null, content?: any | null, preparation?: string | null, date: string, isArchived: boolean, viewerCanArchive: boolean, viewerCanRestore: boolean, viewerCanComment: boolean, viewerCanShare: boolean, viewerCanUpdate: boolean, createdAt: any, updatedAt: any, noteType: NoteType, tasks: Array<{ __typename?: 'Task', id: string, title: string, status: TaskStatus, order: number }>, subject?: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | null, owner: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, collaborators: { __typename?: 'NoteCollaboratorConnection', edges: Array<{ __typename?: 'NoteCollaboratorEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } }> }, goals: Array<{ __typename?: 'Goal', id: string, title: LocalizedString, progress: number }>, feedbackRequests: Array<{ __typename?: 'FeedbackRequest', id: string, title: string }>, evaluationSubmissions: Array<{ __typename?: 'EvaluationSubmission', id: string, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString } }>, transcription?: { __typename?: 'Transcription', id: string, transcript?: string | null, summary?: string | null, editableSummary?: any | null, uploadStatus: TranscriptionUploadStatus, status: TranscriptionStatus, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } } | null, meeting?: { __typename?: 'Meeting', id: string, startsAt: any, endsAt?: any | null, timezone: any, isCancelled: boolean, updatedAt: any, attendees: Array<{ __typename?: 'MeetingAttendee', id: string, status: AttendeeStatus, user: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, proposal?: { __typename?: 'AttendeeProposal', startsAt: any, endsAt?: any | null } | null }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, series?: { __typename?: 'MeetingSeries', id: string, recurrenceFrequency?: MeetingSeriesRecurrenceFrequency | null, recurrenceRule: string, timezone: any, noteSeriesMetadata?: { __typename?: 'NoteSeriesMetadata', defaultTitle: string } | null } | null, note?: { __typename?: 'Note', id: string, meeting?: { __typename?: 'Meeting', id: string } | null } | null } | null, metadata?: { __typename?: 'NoteMetadata', source?: string | null, outlookItemId?: string | null, teamsChatId?: string | null, teamsMessageId?: string | null, tenantId?: string | null } | null } } };

export type LinkEntityToNoteMutationVariables = Exact<{
  input: LinkEntityToNoteInput;
}>;


export type LinkEntityToNoteMutation = { __typename?: 'Mutation', linkEntityToNote: { __typename?: 'LinkEntityToNoteResponse', note: { __typename?: 'Note', id: string, title?: string | null, content?: any | null, preparation?: string | null, date: string, isArchived: boolean, viewerCanArchive: boolean, viewerCanRestore: boolean, viewerCanComment: boolean, viewerCanShare: boolean, viewerCanUpdate: boolean, createdAt: any, updatedAt: any, noteType: NoteType, tasks: Array<{ __typename?: 'Task', id: string, title: string, status: TaskStatus, order: number }>, subject?: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | null, owner: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, collaborators: { __typename?: 'NoteCollaboratorConnection', edges: Array<{ __typename?: 'NoteCollaboratorEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } }> }, goals: Array<{ __typename?: 'Goal', id: string, title: LocalizedString, progress: number }>, feedbackRequests: Array<{ __typename?: 'FeedbackRequest', id: string, title: string }>, evaluationSubmissions: Array<{ __typename?: 'EvaluationSubmission', id: string, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString } }>, transcription?: { __typename?: 'Transcription', id: string, transcript?: string | null, summary?: string | null, editableSummary?: any | null, uploadStatus: TranscriptionUploadStatus, status: TranscriptionStatus, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } } | null, meeting?: { __typename?: 'Meeting', id: string, startsAt: any, endsAt?: any | null, timezone: any, isCancelled: boolean, updatedAt: any, attendees: Array<{ __typename?: 'MeetingAttendee', id: string, status: AttendeeStatus, user: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, proposal?: { __typename?: 'AttendeeProposal', startsAt: any, endsAt?: any | null } | null }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, series?: { __typename?: 'MeetingSeries', id: string, recurrenceFrequency?: MeetingSeriesRecurrenceFrequency | null, recurrenceRule: string, timezone: any, noteSeriesMetadata?: { __typename?: 'NoteSeriesMetadata', defaultTitle: string } | null } | null, note?: { __typename?: 'Note', id: string, meeting?: { __typename?: 'Meeting', id: string } | null } | null } | null, metadata?: { __typename?: 'NoteMetadata', source?: string | null, outlookItemId?: string | null, teamsChatId?: string | null, teamsMessageId?: string | null, tenantId?: string | null } | null } } };

export type RestoreNoteMutationVariables = Exact<{
  input: RestoreNoteInput;
}>;


export type RestoreNoteMutation = { __typename?: 'Mutation', restoreNote: { __typename?: 'RestoreNoteResponse', note: { __typename?: 'Note', id: string, isArchived: boolean, viewerCanArchive: boolean, viewerCanRestore: boolean } } };

export type ShareNoteMutationVariables = Exact<{
  input: ShareNoteInput;
}>;


export type ShareNoteMutation = { __typename?: 'Mutation', shareNote: { __typename?: 'ShareNoteResponse', note: { __typename?: 'Note', id: string, title?: string | null, content?: any | null, preparation?: string | null, date: string, isArchived: boolean, viewerCanArchive: boolean, viewerCanRestore: boolean, viewerCanComment: boolean, viewerCanShare: boolean, viewerCanUpdate: boolean, createdAt: any, updatedAt: any, noteType: NoteType, tasks: Array<{ __typename?: 'Task', id: string, title: string, status: TaskStatus, order: number }>, subject?: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | null, owner: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, collaborators: { __typename?: 'NoteCollaboratorConnection', edges: Array<{ __typename?: 'NoteCollaboratorEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } }> }, goals: Array<{ __typename?: 'Goal', id: string, title: LocalizedString, progress: number }>, feedbackRequests: Array<{ __typename?: 'FeedbackRequest', id: string, title: string }>, evaluationSubmissions: Array<{ __typename?: 'EvaluationSubmission', id: string, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString } }>, transcription?: { __typename?: 'Transcription', id: string, transcript?: string | null, summary?: string | null, editableSummary?: any | null, uploadStatus: TranscriptionUploadStatus, status: TranscriptionStatus, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } } | null, meeting?: { __typename?: 'Meeting', id: string, startsAt: any, endsAt?: any | null, timezone: any, isCancelled: boolean, updatedAt: any, attendees: Array<{ __typename?: 'MeetingAttendee', id: string, status: AttendeeStatus, user: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, proposal?: { __typename?: 'AttendeeProposal', startsAt: any, endsAt?: any | null } | null }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, series?: { __typename?: 'MeetingSeries', id: string, recurrenceFrequency?: MeetingSeriesRecurrenceFrequency | null, recurrenceRule: string, timezone: any, noteSeriesMetadata?: { __typename?: 'NoteSeriesMetadata', defaultTitle: string } | null } | null, note?: { __typename?: 'Note', id: string, meeting?: { __typename?: 'Meeting', id: string } | null } | null } | null, metadata?: { __typename?: 'NoteMetadata', source?: string | null, outlookItemId?: string | null, teamsChatId?: string | null, teamsMessageId?: string | null, tenantId?: string | null } | null } } };

export type UnlinkTranscriptionFromNoteMutationVariables = Exact<{
  input: UnlinkTranscriptionFromNoteInput;
}>;


export type UnlinkTranscriptionFromNoteMutation = { __typename?: 'Mutation', unlinkTranscriptionFromNote: { __typename?: 'UnlinkTranscriptionFromNoteResponse', success: boolean } };

export type UnshareNoteMutationVariables = Exact<{
  input: UnshareNoteInput;
}>;


export type UnshareNoteMutation = { __typename?: 'Mutation', unshareNote: { __typename?: 'UnshareNoteResponse', note: { __typename?: 'Note', id: string, title?: string | null, content?: any | null, preparation?: string | null, date: string, isArchived: boolean, viewerCanArchive: boolean, viewerCanRestore: boolean, viewerCanComment: boolean, viewerCanShare: boolean, viewerCanUpdate: boolean, createdAt: any, updatedAt: any, noteType: NoteType, tasks: Array<{ __typename?: 'Task', id: string, title: string, status: TaskStatus, order: number }>, subject?: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | null, owner: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, collaborators: { __typename?: 'NoteCollaboratorConnection', edges: Array<{ __typename?: 'NoteCollaboratorEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } }> }, goals: Array<{ __typename?: 'Goal', id: string, title: LocalizedString, progress: number }>, feedbackRequests: Array<{ __typename?: 'FeedbackRequest', id: string, title: string }>, evaluationSubmissions: Array<{ __typename?: 'EvaluationSubmission', id: string, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString } }>, transcription?: { __typename?: 'Transcription', id: string, transcript?: string | null, summary?: string | null, editableSummary?: any | null, uploadStatus: TranscriptionUploadStatus, status: TranscriptionStatus, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } } | null, meeting?: { __typename?: 'Meeting', id: string, startsAt: any, endsAt?: any | null, timezone: any, isCancelled: boolean, updatedAt: any, attendees: Array<{ __typename?: 'MeetingAttendee', id: string, status: AttendeeStatus, user: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, proposal?: { __typename?: 'AttendeeProposal', startsAt: any, endsAt?: any | null } | null }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, series?: { __typename?: 'MeetingSeries', id: string, recurrenceFrequency?: MeetingSeriesRecurrenceFrequency | null, recurrenceRule: string, timezone: any, noteSeriesMetadata?: { __typename?: 'NoteSeriesMetadata', defaultTitle: string } | null } | null, note?: { __typename?: 'Note', id: string, meeting?: { __typename?: 'Meeting', id: string } | null } | null } | null, metadata?: { __typename?: 'NoteMetadata', source?: string | null, outlookItemId?: string | null, teamsChatId?: string | null, teamsMessageId?: string | null, tenantId?: string | null } | null } } };

export type UpdateNoteMutationVariables = Exact<{
  input: UpdateNoteInput;
}>;


export type UpdateNoteMutation = { __typename?: 'Mutation', updateNote: { __typename?: 'UpdateNoteResponse', note: { __typename?: 'Note', id: string, title?: string | null, content?: any | null, preparation?: string | null, date: string, isArchived: boolean, viewerCanArchive: boolean, viewerCanRestore: boolean, viewerCanComment: boolean, viewerCanShare: boolean, viewerCanUpdate: boolean, createdAt: any, updatedAt: any, noteType: NoteType, tasks: Array<{ __typename?: 'Task', id: string, title: string, status: TaskStatus, order: number }>, subject?: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | null, owner: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, collaborators: { __typename?: 'NoteCollaboratorConnection', edges: Array<{ __typename?: 'NoteCollaboratorEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } }> }, goals: Array<{ __typename?: 'Goal', id: string, title: LocalizedString, progress: number }>, feedbackRequests: Array<{ __typename?: 'FeedbackRequest', id: string, title: string }>, evaluationSubmissions: Array<{ __typename?: 'EvaluationSubmission', id: string, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString } }>, transcription?: { __typename?: 'Transcription', id: string, transcript?: string | null, summary?: string | null, editableSummary?: any | null, uploadStatus: TranscriptionUploadStatus, status: TranscriptionStatus, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } } | null, meeting?: { __typename?: 'Meeting', id: string, startsAt: any, endsAt?: any | null, timezone: any, isCancelled: boolean, updatedAt: any, attendees: Array<{ __typename?: 'MeetingAttendee', id: string, status: AttendeeStatus, user: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, proposal?: { __typename?: 'AttendeeProposal', startsAt: any, endsAt?: any | null } | null }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, series?: { __typename?: 'MeetingSeries', id: string, recurrenceFrequency?: MeetingSeriesRecurrenceFrequency | null, recurrenceRule: string, timezone: any, noteSeriesMetadata?: { __typename?: 'NoteSeriesMetadata', defaultTitle: string } | null } | null, note?: { __typename?: 'Note', id: string, meeting?: { __typename?: 'Meeting', id: string } | null } | null } | null, metadata?: { __typename?: 'NoteMetadata', source?: string | null, outlookItemId?: string | null, teamsChatId?: string | null, teamsMessageId?: string | null, tenantId?: string | null } | null } } };

export type UpdateNotePreparationMutationVariables = Exact<{
  input: UpdateNotePreparationInput;
}>;


export type UpdateNotePreparationMutation = { __typename?: 'Mutation', updateNotePreparation: { __typename?: 'UpdateNotePreparationResponse', note: { __typename?: 'Note', id: string, preparation?: string | null } } };

export type CommentsQueryVariables = Exact<{
  targetID: Scalars['ID']['input'];
  targetType: CommentTargetType;
}>;


export type CommentsQuery = { __typename?: 'Query', comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }> };

export type MutualNoteCollaboratorsQueryVariables = Exact<{ [key: string]: never; }>;


export type MutualNoteCollaboratorsQuery = { __typename?: 'Query', mutualNoteCollaborators: Array<{ __typename?: 'MutualNoteCollaborator', count: number, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } }> };

export type MutualNotesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<MutualNotesFilters>;
}>;


export type MutualNotesQuery = { __typename?: 'Query', user: { __typename?: 'User', mutualNotes: { __typename?: 'NoteConnection', edges: Array<{ __typename?: 'NoteEdge', node: { __typename?: 'Note', id: string, title?: string | null, date: string, createdAt: any, updatedAt: any, collaborators: { __typename?: 'NoteCollaboratorConnection', edges: Array<{ __typename?: 'NoteCollaboratorEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } }> }, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, subject?: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | null, meeting?: { __typename?: 'Meeting', startsAt: any, timezone: any, isCancelled: boolean, series?: { __typename?: 'MeetingSeries', id: string } | null } | null, metadata?: { __typename?: 'NoteMetadata', source?: string | null } | null } }> } } };

export type NoteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NoteQuery = { __typename?: 'Query', note: { __typename?: 'Note', id: string, title?: string | null, content?: any | null, preparation?: string | null, date: string, isArchived: boolean, viewerCanArchive: boolean, viewerCanRestore: boolean, viewerCanComment: boolean, viewerCanShare: boolean, viewerCanUpdate: boolean, createdAt: any, updatedAt: any, noteType: NoteType, tasks: Array<{ __typename?: 'Task', id: string, title: string, status: TaskStatus, order: number }>, subject?: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | null, owner: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, collaborators: { __typename?: 'NoteCollaboratorConnection', edges: Array<{ __typename?: 'NoteCollaboratorEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } }> }, goals: Array<{ __typename?: 'Goal', id: string, title: LocalizedString, progress: number }>, feedbackRequests: Array<{ __typename?: 'FeedbackRequest', id: string, title: string }>, evaluationSubmissions: Array<{ __typename?: 'EvaluationSubmission', id: string, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString } }>, transcription?: { __typename?: 'Transcription', id: string, transcript?: string | null, summary?: string | null, editableSummary?: any | null, uploadStatus: TranscriptionUploadStatus, status: TranscriptionStatus, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } } | null, meeting?: { __typename?: 'Meeting', id: string, startsAt: any, endsAt?: any | null, timezone: any, isCancelled: boolean, updatedAt: any, attendees: Array<{ __typename?: 'MeetingAttendee', id: string, status: AttendeeStatus, user: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, proposal?: { __typename?: 'AttendeeProposal', startsAt: any, endsAt?: any | null } | null }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, series?: { __typename?: 'MeetingSeries', id: string, recurrenceFrequency?: MeetingSeriesRecurrenceFrequency | null, recurrenceRule: string, timezone: any, noteSeriesMetadata?: { __typename?: 'NoteSeriesMetadata', defaultTitle: string } | null } | null, note?: { __typename?: 'Note', id: string, meeting?: { __typename?: 'Meeting', id: string } | null } | null } | null, metadata?: { __typename?: 'NoteMetadata', source?: string | null, outlookItemId?: string | null, teamsChatId?: string | null, teamsMessageId?: string | null, tenantId?: string | null } | null } };

export type NotesQueryVariables = Exact<{
  filters?: InputMaybe<NotesFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
}>;


export type NotesQuery = { __typename?: 'Query', notes: { __typename?: 'NoteConnection', edges: Array<{ __typename?: 'NoteEdge', node: { __typename?: 'Note', noteType: NoteType, content?: any | null, id: string, title?: string | null, date: string, createdAt: any, updatedAt: any, owner: { __typename?: 'User', id: string }, collaborators: { __typename?: 'NoteCollaboratorConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'NoteCollaboratorEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } }> }, metadata?: { __typename?: 'NoteMetadata', sender?: string | null, source?: string | null } | null, tasks: Array<{ __typename?: 'Task', id: string, title: string, status: TaskStatus, order: number }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, subject?: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | null, meeting?: { __typename?: 'Meeting', startsAt: any, timezone: any, isCancelled: boolean, series?: { __typename?: 'MeetingSeries', id: string } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } };

export type NotesSidebarPeopleQueryVariables = Exact<{
  recurse: Scalars['Boolean']['input'];
}>;


export type NotesSidebarPeopleQuery = { __typename?: 'Query', viewer: { __typename?: 'User', managees: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }> }, noteSubjectsWithCount: Array<{ __typename?: 'UserWithCount', count: number, user: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }> };

export type PromptNotesSummaryQueryVariables = Exact<{
  input: NotesSummaryInput;
}>;


export type PromptNotesSummaryQuery = { __typename?: 'Query', promptNotesSummary: { __typename?: 'NotesSummaryResponse', notesSummary: { __typename?: 'NotesSummary', bulletPoints?: any | null, sourceNotes: Array<{ __typename?: 'Note', id: string, title?: string | null, subject?: { __typename?: 'User', id: string, firstName: string } | null }> } } };

export type WorkspaceConnectorAdminFragment = { __typename?: 'Connector', id: string, type: ConnectorType, isActive: boolean, authorizationInfo?: string | null, authorizeUrl?: string | null };

export type WorkspaceFeatureFragment = { __typename?: 'WorkspaceFeature', id: string, status: WorkspaceFeatureStatus, inPlan: boolean, needsWorkspaceApproval: boolean, needsViewerApproval: boolean, feature: { __typename?: 'Feature', id: FeatureName, stability: FeatureStability }, requiredConditions?: { __typename?: 'FeatureConditions', currentVersion: string, linkToConditions: string } | null, viewerApproval?: { __typename?: 'FeatureApproval', approvedAt: any, approvedBy: { __typename?: 'User', id: string, username: string } } | null, workspaceApproval?: { __typename?: 'FeatureApproval', approvedAt: any, approvedBy: { __typename?: 'User', id: string, username: string } } | null };

export type WorkspaceMfaSettingsFragment = { __typename?: 'WorkspaceMfaSettings', id: string, status: WorkspaceMfaStatus, allowedMethods: Array<MfaMethod> };

export type WorkspacePlanFragment = { __typename?: 'WorkspacePlanV2', id: string, type: WorkspacePlanType, startDate?: any | null, endDate?: any | null, isTrial: boolean, isExpired: boolean, minimumUserCount: number };

export type WorkspaceSsoSettingsFragment = { __typename?: 'WorkspaceSSOSettings', enforceSSO: boolean };

export type ApplyStyrJobMappingsMutationVariables = Exact<{
  input: ApplyStyrJobMappingsInput;
}>;


export type ApplyStyrJobMappingsMutation = { __typename?: 'Mutation', applyStyrJobMappings: boolean };

export type ApproveFeatureForViewerMutationVariables = Exact<{
  input: ApproveFeatureConditionsInput;
}>;


export type ApproveFeatureForViewerMutation = { __typename?: 'Mutation', approveFeatureForViewer: { __typename?: 'ApproveFeatureConditionsResponse', approval: { __typename?: 'FeatureApproval', featureName: FeatureName, approvedAt: any, approvedBy: { __typename?: 'User', id: string, username: string } } } };

export type ApproveFeatureForWorkspaceMutationVariables = Exact<{
  input: ApproveFeatureConditionsInput;
}>;


export type ApproveFeatureForWorkspaceMutation = { __typename?: 'Mutation', approveFeatureForWorkspace: { __typename?: 'ApproveFeatureConditionsResponse', approval: { __typename?: 'FeatureApproval', featureName: FeatureName, approvedAt: any, approvedBy: { __typename?: 'User', id: string, username: string } } } };

export type ArchiveGroupMutationVariables = Exact<{
  input: ArchiveGroupInput;
}>;


export type ArchiveGroupMutation = { __typename?: 'Mutation', archiveGroup: { __typename?: 'ArchiveGroupResponse', group: { __typename?: 'Group', id: string, isArchived: boolean } } };

export type ArchiveWorkspaceMutationVariables = Exact<{
  input: ArchiveWorkspaceInput;
}>;


export type ArchiveWorkspaceMutation = { __typename?: 'Mutation', archiveWorkspace: { __typename?: 'ArchiveWorkspaceResponse', workspace: { __typename?: 'Workspace', id: string, isArchived: boolean } } };

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup: { __typename?: 'CreateGroupResponse', group: { __typename?: 'Group', id: string, name: string, type: GroupType, externalReferenceID?: string | null } } };

export type CreateWorkspaceMutationVariables = Exact<{
  input: CreateWorkspaceInput;
}>;


export type CreateWorkspaceMutation = { __typename?: 'Mutation', createWorkspace: { __typename?: 'CreateWorkspaceResponse', workspace: { __typename?: 'Workspace', id: string, hubSpotCompanyID?: string | null } } };

export type CreateWorkspacePlanMutationVariables = Exact<{
  input: CreateWorkspacePlanInput;
}>;


export type CreateWorkspacePlanMutation = { __typename?: 'Mutation', createWorkspacePlan: { __typename?: 'CreateWorkspacePlanResponse', plan: { __typename?: 'WorkspacePlanV2', id: string, type: WorkspacePlanType, startDate?: any | null, endDate?: any | null, isTrial: boolean, isExpired: boolean, minimumUserCount: number } } };

export type EnableWorkspaceAiPlanMutationVariables = Exact<{ [key: string]: never; }>;


export type EnableWorkspaceAiPlanMutation = { __typename?: 'Mutation', enableWorkspaceAiPlan: { __typename?: 'EnableWorkspaceAiPlanResponse', plan: { __typename?: 'WorkspacePlanV2', id: string, type: WorkspacePlanType, startDate?: any | null, endDate?: any | null, isTrial: boolean, isExpired: boolean, minimumUserCount: number } } };

export type MoveGroupMutationVariables = Exact<{
  input: MoveGroupInput;
}>;


export type MoveGroupMutation = { __typename?: 'Mutation', moveGroup: { __typename?: 'MoveGroupResponse', group: { __typename?: 'Group', id: string, parent?: { __typename?: 'Group', id: string } | null } } };

export type RemoveWorkspacePlanMutationVariables = Exact<{
  input: RemoveWorkspacePlanInput;
}>;


export type RemoveWorkspacePlanMutation = { __typename?: 'Mutation', removeWorkspacePlan: { __typename?: 'RemoveWorkspacePlanResponse', success: boolean } };

export type ResetWorkspaceBackgroundMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetWorkspaceBackgroundMutation = { __typename?: 'Mutation', resetWorkspaceBackground: { __typename?: 'ResetWorkspaceBackgroundResponse', workspace: { __typename?: 'Workspace', id: string, theme: { __typename?: 'WorkspaceTheme', background?: { __typename?: 'Asset', id: string } | null } } } };

export type ResetWorkspaceCustomEmailDomainMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetWorkspaceCustomEmailDomainMutation = { __typename?: 'Mutation', resetCustomEmailDomain: { __typename?: 'UpdateCustomEmailDomainResponse', workspace: { __typename?: 'Workspace', id: string, customEmailDomain?: { __typename?: 'CustomEmailDomain', domain: string, emailDomain: string, mailFromDomain: string, enabled: boolean, dkimVerificationStatus: DomainVerificationStatus, dkimTokens: Array<string>, mailFromVerificationStatus: DomainVerificationStatus, senderName: string, senderAddress: string } | null } } };

export type ResetWorkspaceLogoMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetWorkspaceLogoMutation = { __typename?: 'Mutation', resetWorkspaceLogo: { __typename?: 'ResetWorkspaceLogoResponse', workspace: { __typename?: 'Workspace', id: string, theme: { __typename?: 'WorkspaceTheme', logo?: { __typename?: 'Asset', id: string } | null } } } };

export type RestoreGroupMutationVariables = Exact<{
  input: RestoreGroupInput;
}>;


export type RestoreGroupMutation = { __typename?: 'Mutation', restoreGroup: { __typename?: 'RestoreGroupResponse', group: { __typename?: 'Group', id: string, isArchived: boolean } } };

export type RevokeFeatureApprovalForViewerMutationVariables = Exact<{
  input: RevokeFeatureApprovalInput;
}>;


export type RevokeFeatureApprovalForViewerMutation = { __typename?: 'Mutation', revokeFeatureApprovalForViewer: { __typename?: 'RevokeFeatureApprovalResponse', success: boolean } };

export type SetGoodHabitzConfigMutationVariables = Exact<{
  input: SetGoodHabitzConfigInput;
}>;


export type SetGoodHabitzConfigMutation = { __typename?: 'Mutation', setGoodHabitzConfig: { __typename?: 'GoodHabitzConfig', enabled: boolean, languageIDs: Array<string>, hasApiKey: boolean, lastSyncedAt?: string | null } };

export type SetStyrSyncLanguagesMutationVariables = Exact<{
  languageIDs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SetStyrSyncLanguagesMutation = { __typename?: 'Mutation', setStyrSyncLanguages: boolean };

export type SetWorkspaceCustomEmailDomainEnabledMutationVariables = Exact<{
  input: SetCustomEmailDomainEnabledInput;
}>;


export type SetWorkspaceCustomEmailDomainEnabledMutation = { __typename?: 'Mutation', setCustomEmailDomainEnabled: { __typename?: 'UpdateCustomEmailDomainResponse', workspace: { __typename?: 'Workspace', id: string, customEmailDomain?: { __typename?: 'CustomEmailDomain', domain: string, emailDomain: string, mailFromDomain: string, enabled: boolean, dkimVerificationStatus: DomainVerificationStatus, dkimTokens: Array<string>, mailFromVerificationStatus: DomainVerificationStatus, senderName: string, senderAddress: string } | null } } };

export type SetWorkspaceStyrConfigMutationVariables = Exact<{
  input: SetWorkspaceStyrConfigInput;
}>;


export type SetWorkspaceStyrConfigMutation = { __typename?: 'Mutation', setWorkspaceStyrConfig: { __typename?: 'SetWorkspaceStyrConfigResponse', workspace: { __typename?: 'Workspace', id: string, styrConfigAdmin?: { __typename?: 'StyrConfig', organisationID: string, organisationLabel: string, enabled: boolean } | null } } };

export type SyncGoodHabitzMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncGoodHabitzMutation = { __typename?: 'Mutation', syncGoodHabitz: boolean };

export type SyncStyrMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncStyrMutation = { __typename?: 'Mutation', syncStyr: boolean };

export type UpdateGroupMutationVariables = Exact<{
  input: UpdateGroupInput;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateGroup: { __typename?: 'UpdateGroupResponse', group: { __typename?: 'Group', id: string, name: string, type: GroupType, externalReferenceID?: string | null } } };

export type UpdateWorkspaceAliasMutationVariables = Exact<{
  input: UpdateWorkspaceAliasInput;
}>;


export type UpdateWorkspaceAliasMutation = { __typename?: 'Mutation', updateWorkspaceAlias: { __typename?: 'UpdateWorkspaceAliasResponse', workspace: { __typename?: 'Workspace', id: string, alias: string } } };

export type UpdateWorkspaceBackgroundMutationVariables = Exact<{
  input: UpdateWorkspaceBackgroundInput;
}>;


export type UpdateWorkspaceBackgroundMutation = { __typename?: 'Mutation', updateWorkspaceBackground: { __typename?: 'UpdateWorkspaceBackgroundResponse', workspace: { __typename?: 'Workspace', id: string, theme: { __typename?: 'WorkspaceTheme', background?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } } } };

export type UpdateWorkspaceColorsMutationVariables = Exact<{
  input: UpdateWorkspaceColorsInput;
}>;


export type UpdateWorkspaceColorsMutation = { __typename?: 'Mutation', updateWorkspaceColors: { __typename?: 'UpdateWorkspaceColorsResponse', workspace: { __typename?: 'Workspace', id: string, theme: { __typename?: 'WorkspaceTheme', primaryColor?: string | null, primaryColorDark?: string | null, secondaryColor?: string | null, linearGradientStart?: string | null, linearGradientEnd?: string | null } } } };

export type UpdateWorkspaceCustomEmailDomainMutationVariables = Exact<{
  input: UpdateCustomEmailDomainInput;
}>;


export type UpdateWorkspaceCustomEmailDomainMutation = { __typename?: 'Mutation', updateCustomEmailDomain: { __typename?: 'UpdateCustomEmailDomainResponse', workspace: { __typename?: 'Workspace', id: string, customEmailDomain?: { __typename?: 'CustomEmailDomain', domain: string, emailDomain: string, mailFromDomain: string, enabled: boolean, dkimVerificationStatus: DomainVerificationStatus, dkimTokens: Array<string>, mailFromVerificationStatus: DomainVerificationStatus, senderName: string, senderAddress: string } | null } } };

export type UpdateWorkspaceDisplayNameMutationVariables = Exact<{
  input: UpdateWorkspaceDisplayNameInput;
}>;


export type UpdateWorkspaceDisplayNameMutation = { __typename?: 'Mutation', updateWorkspaceDisplayName: { __typename?: 'UpdateWorkspaceDisplayNameResponse', workspace: { __typename?: 'Workspace', id: string, displayName?: string | null } } };

export type UpdateWorkspaceEmailDomainsMutationVariables = Exact<{
  input: UpdateWorkspaceEmailDomainsInput;
}>;


export type UpdateWorkspaceEmailDomainsMutation = { __typename?: 'Mutation', updateWorkspaceEmailDomains: { __typename?: 'UpdateWorkspaceEmailDomainsResponse', workspace: { __typename?: 'Workspace', id: string, emailDomains?: string | null } } };

export type UpdateWorkspaceFeatureMutationVariables = Exact<{
  input: UpdateWorkspaceFeatureInput;
}>;


export type UpdateWorkspaceFeatureMutation = { __typename?: 'Mutation', updateWorkspaceFeature: { __typename?: 'UpdateWorkspaceFeatureResponse', workspace: { __typename?: 'Workspace', id: string, features: Array<{ __typename?: 'WorkspaceFeature', id: string, status: WorkspaceFeatureStatus }> } } };

export type UpdateWorkspaceHubSpotCompanyIdMutationVariables = Exact<{
  input: UpdateWorkspaceHubSpotCompanyIdInput;
}>;


export type UpdateWorkspaceHubSpotCompanyIdMutation = { __typename?: 'Mutation', updateWorkspaceHubSpotCompanyID: { __typename?: 'UpdateWorkspaceHubSpotCompanyIDResponse', workspace: { __typename?: 'Workspace', id: string, hubSpotCompanyID?: string | null } } };

export type UpdateWorkspaceLanguagesMutationVariables = Exact<{
  input: UpdateWorkspaceLanguagesInput;
}>;


export type UpdateWorkspaceLanguagesMutation = { __typename?: 'Mutation', updateWorkspaceLanguages: { __typename?: 'UpdateWorkspaceLanguagesResponse', workspace: { __typename?: 'Workspace', id: string, supportedLanguageIDs: Array<string> } } };

export type UpdateWorkspaceLogoMutationVariables = Exact<{
  input: UpdateWorkspaceLogoInput;
}>;


export type UpdateWorkspaceLogoMutation = { __typename?: 'Mutation', updateWorkspaceLogo: { __typename?: 'UpdateWorkspaceLogoResponse', workspace: { __typename?: 'Workspace', id: string, theme: { __typename?: 'WorkspaceTheme', logo?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } } } };

export type UpdateWorkspaceMfaSettingsMutationVariables = Exact<{
  input: UpdateWorkspaceMfaSettingsInput;
}>;


export type UpdateWorkspaceMfaSettingsMutation = { __typename?: 'Mutation', updateWorkspaceMfaSettings: { __typename?: 'UpdateWorkspaceMfaSettingsResponse', workspaceMfaSettings: { __typename?: 'WorkspaceMfaSettings', id: string, status: WorkspaceMfaStatus, allowedMethods: Array<MfaMethod> } } };

export type UpdateWorkspaceNotificationSettingsMutationVariables = Exact<{
  input: UpdateWorkspaceNotificationSettingsInput;
}>;


export type UpdateWorkspaceNotificationSettingsMutation = { __typename?: 'Mutation', updateWorkspaceNotificationSettings: { __typename?: 'UpdateWorkspaceNotificationSettingsResponse', workspace: { __typename?: 'Workspace', id: string, notificationSettings: { __typename?: 'WorkspaceNotificationSettings', header: LocalizedAttributedString, footer: LocalizedAttributedString, welcomeEmail: { __typename?: 'WorkspaceWelcomeEmail', body: LocalizedAttributedString, subject: LocalizedString } } } } };

export type UpdateWorkspacePlanMutationVariables = Exact<{
  input: UpdateWorkspacePlanV2Input;
}>;


export type UpdateWorkspacePlanMutation = { __typename?: 'Mutation', updateWorkspacePlanV2: { __typename?: 'UpdateWorkspacePlanV2Response', plan: { __typename?: 'WorkspacePlanV2', id: string, type: WorkspacePlanType, startDate?: any | null, endDate?: any | null, isTrial: boolean, isExpired: boolean, minimumUserCount: number } } };

export type UpdateWorkspaceRetentionPeriodMutationVariables = Exact<{
  input: UpdateWorkspaceRetentionPeriodInput;
}>;


export type UpdateWorkspaceRetentionPeriodMutation = { __typename?: 'Mutation', updateWorkspaceRetentionPeriod: { __typename?: 'UpdateWorkspaceRetentionPeriodResponse', workspace: { __typename?: 'Workspace', id: string, retentionPeriodDays: number } } };

export type UpdateWorkspaceSsoSettingsMutationVariables = Exact<{
  input: UpdateWorkspaceSsoSettingsInput;
}>;


export type UpdateWorkspaceSsoSettingsMutation = { __typename?: 'Mutation', updateWorkspaceSSOSettings: { __typename?: 'UpdateWorkspaceSSOSettingsResponse', workspace: { __typename?: 'Workspace', id: string, ssoSettings: { __typename?: 'WorkspaceSSOSettings', enforceSSO: boolean } } } };

export type UpdateWorkspaceStartDateMutationVariables = Exact<{
  input: UpdateWorkspaceStartDateInput;
}>;


export type UpdateWorkspaceStartDateMutation = { __typename?: 'Mutation', updateWorkspaceStartDate: { __typename?: 'UpdateWorkspaceStartDateResponse', workspace: { __typename?: 'Workspace', id: string, startDate?: any | null } } };

export type AdvancedWorkspaceSettingsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdvancedWorkspaceSettingsQuery = { __typename?: 'Query', workspace: { __typename?: 'Workspace', id: string, startDate?: any | null, supportedLanguageIDs: Array<string>, retentionPeriodDays: number, engagementSettings: { __typename?: 'EngagementSettings', enpsType: EngagementEnpsType }, workspaceMfaSettings: { __typename?: 'WorkspaceMfaSettings', id: string, status: WorkspaceMfaStatus, allowedMethods: Array<MfaMethod> }, ssoSettings: { __typename?: 'WorkspaceSSOSettings', enforceSSO: boolean } } };

export type ConnectorDryRunGroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ConnectorDryRunGroupsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', workspace: { __typename?: 'Workspace', connector?: { __typename?: 'Connector', id: string, dryRun: { __typename?: 'ConnectorDryRun', groups: { __typename?: 'ConnectorDryRunGroupConnection', totalCount: number, edges: Array<{ __typename?: 'ConnectorDryRunGroupEdge', cursor: string, node: { __typename?: 'ConnectorDryRunGroup', name: string, externalReferenceID: string, parentExternalReferenceID?: string | null } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } } | null } } };

export type DepartmentsQueryVariables = Exact<{
  isArchived: Scalars['Boolean']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DepartmentsQuery = { __typename?: 'Query', groups: { __typename?: 'GroupConnection', edges: Array<{ __typename?: 'GroupEdge', node: { __typename?: 'Group', id: string, name: string, isArchived: boolean } }> } };

export type DepartmentsWithParentsQueryVariables = Exact<{
  filter?: InputMaybe<GroupsFilter>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DepartmentsWithParentsQuery = { __typename?: 'Query', groups: { __typename?: 'GroupConnection', edges: Array<{ __typename?: 'GroupEdge', cursor: string, node: { __typename?: 'Group', id: string, name: string, viewerCanViewAnalytics: boolean, viewerCanViewEngagementAnalytics: boolean, parent?: { __typename?: 'Group', id: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type FeatureWorkspaceOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureWorkspaceOverviewQuery = { __typename?: 'Query', featureWorkspaceOverview: Array<{ __typename?: 'FeatureWorkspaceOverview', featureName: FeatureName, stability: FeatureStability, workspaces: Array<{ __typename?: 'FeatureWorkspaceEntry', workspaceID: string, status: WorkspaceFeatureStatus }> }> };

export type GroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  roleTypes?: InputMaybe<Array<RoleType> | RoleType>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GroupQuery = { __typename?: 'Query', group: { __typename?: 'Group', id: string, name: string, type: GroupType, externalReferenceID?: string | null, updatedAt: any, isArchived: boolean, viewerCanUpdate: boolean, parent?: { __typename?: 'Group', id: string, name: string, type: GroupType } | null, managers: { __typename?: 'GroupManagerConnection', edges: Array<{ __typename?: 'GroupManagerEdge', role: { __typename?: 'Role', id: string }, node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } }, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type GroupMembersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GroupMembersQuery = { __typename?: 'Query', group: { __typename?: 'Group', id: string, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, currentJobPosition?: { __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString } } | null }, role: { __typename?: 'Role', id: string, type: RoleType } }> } } };

export type GroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<GroupsFilter>;
}>;


export type GroupsQuery = { __typename?: 'Query', groups: { __typename?: 'GroupConnection', edges: Array<{ __typename?: 'GroupEdge', node: { __typename?: 'Group', id: string, type: GroupType, name: string, isArchived: boolean, viewerCanViewAnalytics: boolean, viewerCanCreateGoal: boolean, viewerCanViewArchivedGoals: boolean, viewerCanViewGoals: boolean, viewerCanViewTalentReviews: boolean, parent?: { __typename?: 'Group', id: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type IsWorkspaceSlugAvailableQueryVariables = Exact<{
  workspaceID: Scalars['ID']['input'];
}>;


export type IsWorkspaceSlugAvailableQuery = { __typename?: 'Query', isWorkspaceSlugAvailable: boolean };

export type MigrationDepartmentsQueryVariables = Exact<{
  filter?: InputMaybe<GroupsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MigrationDepartmentsQuery = { __typename?: 'Query', groups: { __typename?: 'GroupConnection', edges: Array<{ __typename?: 'GroupEdge', node: { __typename?: 'Group', id: string, name: string, externalReferenceID?: string | null } }> } };

export type OrganizationGroupsQueryVariables = Exact<{
  filter?: InputMaybe<GroupsFilter>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrganizationGroupsQuery = { __typename?: 'Query', groups: { __typename?: 'GroupConnection', edges: Array<{ __typename?: 'GroupEdge', cursor: string, node: { __typename?: 'Group', id: string, name: string, isArchived: boolean } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type StyrJobMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type StyrJobMappingsQuery = { __typename?: 'Query', styrJobMappings: Array<{ __typename?: 'StyrJobMapping', styrJobID: string, styrJobName: string, styrLevel?: number | null, jobFamilyName?: string | null, linkedJobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }> }> };

export type TeamsQueryVariables = Exact<{
  isArchived: Scalars['Boolean']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TeamsQuery = { __typename?: 'Query', groups: { __typename?: 'GroupConnection', edges: Array<{ __typename?: 'GroupEdge', node: { __typename?: 'Group', id: string, name: string, isArchived: boolean } }> } };

export type ViewerDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerDepartmentsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', targetV2?: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User' } | null, role: { __typename?: 'Role', id: string, type: RoleType } }> } };

export type ViewerGoodHabitzConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerGoodHabitzConfigQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, workspace: { __typename?: 'Workspace', id: string, goodHabitzConfig?: { __typename?: 'GoodHabitzConfig', enabled: boolean, languageIDs: Array<string>, hasApiKey: boolean, lastSyncedAt?: string | null } | null } } };

export type ViewerGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerGroupsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', targetV2?: { __typename?: 'Group', id: string, name: string, type: GroupType, isArchived: boolean } | { __typename?: 'User', id: string } | null, role: { __typename?: 'Role', id: string, type: RoleType } }> } };

export type ViewerParentGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerParentGroupsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', group: { __typename?: 'Group', id: string, name: string, paths: Array<{ __typename?: 'GroupPath', groups: Array<{ __typename?: 'Group', id: string, name: string }> }> } } };

export type ViewerStyrConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerStyrConfigQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, workspace: { __typename?: 'Workspace', id: string, styrConfig?: { __typename?: 'StyrConfig', organisationID: string, organisationLabel: string, enabled: boolean, lastSyncedAt?: string | null, languageIDs?: Array<string> | null } | null } } };

export type ViewerWorkspacePlanQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerWorkspacePlanQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, workspace: { __typename?: 'Workspace', id: string, isExpired: boolean, plans: Array<{ __typename?: 'WorkspacePlanV2', id: string, type: WorkspacePlanType, startDate?: any | null, endDate?: any | null, isTrial: boolean, isExpired: boolean, minimumUserCount: number }> } } };

export type WorkspaceAliasQueryVariables = Exact<{
  alias: Scalars['String']['input'];
}>;


export type WorkspaceAliasQuery = { __typename?: 'Query', workspaceAlias: { __typename?: 'Workspace', id: string } };

export type WorkspaceConnectorQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspaceConnectorQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, workspace: { __typename?: 'Workspace', id: string, connector?: { __typename?: 'Connector', id: string, type: ConnectorType } | null } } };

export type WorkspaceConnectorUsersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WorkspaceConnectorUsersQuery = { __typename?: 'Query', workspace: { __typename?: 'Workspace', id: string, connectorUsers: Array<any>, cognitoUsers: Array<any> } };

export type WorkspaceCustomEmailDomainQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspaceCustomEmailDomainQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, workspace: { __typename?: 'Workspace', id: string, customEmailDomain?: { __typename?: 'CustomEmailDomain', domain: string, emailDomain: string, mailFromDomain: string, enabled: boolean, dkimVerificationStatus: DomainVerificationStatus, dkimTokens: Array<string>, mailFromVerificationStatus: DomainVerificationStatus, senderName: string, senderAddress: string } | null } } };

export type WorkspaceFeaturesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WorkspaceFeaturesQuery = { __typename?: 'Query', workspace: { __typename?: 'Workspace', id: string, features: Array<{ __typename?: 'WorkspaceFeature', id: string, status: WorkspaceFeatureStatus, inPlan: boolean, needsWorkspaceApproval: boolean, needsViewerApproval: boolean, feature: { __typename?: 'Feature', id: FeatureName, stability: FeatureStability }, requiredConditions?: { __typename?: 'FeatureConditions', currentVersion: string, linkToConditions: string } | null, viewerApproval?: { __typename?: 'FeatureApproval', approvedAt: any, approvedBy: { __typename?: 'User', id: string, username: string } } | null, workspaceApproval?: { __typename?: 'FeatureApproval', approvedAt: any, approvedBy: { __typename?: 'User', id: string, username: string } } | null }> } };

export type WorkspaceNotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspaceNotificationSettingsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, workspace: { __typename?: 'Workspace', id: string, notificationSettings: { __typename?: 'WorkspaceNotificationSettings', header: LocalizedAttributedString, footer: LocalizedAttributedString, welcomeEmail: { __typename?: 'WorkspaceWelcomeEmail', body: LocalizedAttributedString, subject: LocalizedString } } } } };

export type WorkspaceNpsAnalyticsQueryVariables = Exact<{
  filters: AnalyticsFilters;
}>;


export type WorkspaceNpsAnalyticsQuery = { __typename?: 'Query', workspaceAnalytics: { __typename?: 'WorkspaceAnalytics', engagementENPS: { __typename?: 'AnalyticsEngagementENPS', detractors?: number | null, passives?: number | null, promoters?: number | null, score?: number | null, totalRequestsSent?: number | null, totalRequestsCompleted?: number | null }, engagementGroupsENPS: Array<{ __typename?: 'AnalyticsEngagementGroupENPS', detractors?: number | null, passives?: number | null, promoters?: number | null, score?: number | null, totalRequestsSent?: number | null, totalRequestsCompleted?: number | null, group: { __typename?: 'Group', id: string, name: string } }> } };

export type WorkspaceStatisticsQueryVariables = Exact<{
  workspaceID: Scalars['ID']['input'];
}>;


export type WorkspaceStatisticsQuery = { __typename?: 'Query', workspaceStatistics: { __typename?: 'WorkspaceStatistic', workspaceID: string, date: string, active: number, draft: number, archived: number, deactivated: number } };

export type WorkspaceStyrAdminQueryVariables = Exact<{
  workspaceID: Scalars['String']['input'];
}>;


export type WorkspaceStyrAdminQuery = { __typename?: 'Query', workspacesV2: { __typename?: 'WorkspaceConnection', edges: Array<{ __typename?: 'WorkspaceEdge', node: { __typename?: 'Workspace', id: string, alias: string, styrConfigAdmin?: { __typename?: 'StyrConfig', organisationID: string, organisationLabel: string, enabled: boolean, languageIDs?: Array<string> | null } | null } }> } };

export type WorkspaceThemeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WorkspaceThemeQuery = { __typename?: 'Query', workspace: { __typename?: 'Workspace', id: string, theme: { __typename?: 'WorkspaceTheme', primaryColor?: string | null, primaryColorDark?: string | null, secondaryColor?: string | null, linearGradientStart?: string | null, linearGradientEnd?: string | null, logo?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, background?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } } };

export type WorkspacesQueryVariables = Exact<{
  filters: WorkspaceFilters;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
}>;


export type WorkspacesQuery = { __typename?: 'Query', workspacesV2: { __typename?: 'WorkspaceConnection', edges: Array<{ __typename?: 'WorkspaceEdge', node: { __typename?: 'Workspace', id: string, alias: string, displayName?: string | null, emailDomains?: string | null, isArchived: boolean, hubSpotCompanyID?: string | null, stripeCustomerID?: string | null, stripeCollectionMethod?: string | null, plans: Array<{ __typename?: 'WorkspacePlanV2', id: string, type: WorkspacePlanType, startDate?: any | null, endDate?: any | null, isTrial: boolean, isExpired: boolean, minimumUserCount: number }>, connectorAdmin?: { __typename?: 'Connector', id: string, type: ConnectorType, isActive: boolean, authorizationInfo?: string | null, authorizeUrl?: string | null } | null, user?: { __typename?: 'User', id: string, username: string, email: string, firstName: string, lastName: string, associatedIdentities: Array<{ __typename?: 'AssociatedIdentity', name: string, identityProvider: { __typename?: 'IdentityProvider', id: string } }> } | null } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type WorkspacesBasicQueryVariables = Exact<{
  filters: WorkspaceFilters;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
}>;


export type WorkspacesBasicQuery = { __typename?: 'Query', workspacesV2: { __typename?: 'WorkspaceConnection', edges: Array<{ __typename?: 'WorkspaceEdge', node: { __typename?: 'Workspace', id: string, alias: string, isArchived: boolean, plans: Array<{ __typename?: 'WorkspacePlanV2', id: string, type: WorkspacePlanType, startDate?: any | null, endDate?: any | null, isTrial: boolean, isExpired: boolean, minimumUserCount: number }> } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type WorkspacesMinimalQueryVariables = Exact<{
  filters: WorkspaceFilters;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
}>;


export type WorkspacesMinimalQuery = { __typename?: 'Query', workspacesV2: { __typename?: 'WorkspaceConnection', edges: Array<{ __typename?: 'WorkspaceEdge', node: { __typename?: 'Workspace', id: string, alias: string } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type WorkspacesUsersQueryVariables = Exact<{
  filters: WorkspaceFilters;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
}>;


export type WorkspacesUsersQuery = { __typename?: 'Query', workspacesV2: { __typename?: 'WorkspaceConnection', edges: Array<{ __typename?: 'WorkspaceEdge', node: { __typename?: 'Workspace', id: string, connectorUsers: Array<any>, cognitoUsers: Array<any> } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type PageInfoFragment = { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null };

export type PageQueryVariables = Exact<{
  type: PageType;
}>;


export type PageQuery = { __typename?: 'Query', page?: { __typename?: 'Page', type: PageType, content: LocalizedAttributedString, url?: LocalizedString | null } | null };

export type UpdatePageMutationVariables = Exact<{
  input: PageUpdateInput;
}>;


export type UpdatePageMutation = { __typename?: 'Mutation', upsertPage: { __typename?: 'Page', type: PageType, content: LocalizedAttributedString, url?: LocalizedString | null } };

export type DeleteRevealUploadMutationVariables = Exact<{
  evaluationFormID: Scalars['ID']['input'];
}>;


export type DeleteRevealUploadMutation = { __typename?: 'Mutation', deleteRevealUpload: boolean };

export type GetRevealUploadUrlMutationVariables = Exact<{
  contentLength: Scalars['Int']['input'];
}>;


export type GetRevealUploadUrlMutation = { __typename?: 'Mutation', getRevealUploadUrl: { __typename?: 'GetRevealUploadUrlResponse', objectKey: string, uploadUrl: string, uploadHeaders: Array<{ __typename?: 'RevealUploadHeader', name: string, values: Array<string> }> } };

export type MarkRevealSeenMutationVariables = Exact<{
  submissionID: Scalars['ID']['input'];
}>;


export type MarkRevealSeenMutation = { __typename?: 'Mutation', markRevealSeen: boolean };

export type ParseRevealUploadMutationVariables = Exact<{
  objectKey: Scalars['String']['input'];
}>;


export type ParseRevealUploadMutation = { __typename?: 'Mutation', parseRevealUpload: { __typename?: 'RevealMatchSummary', matchedCount: number, skippedCount: number, matchColumn: string, detectedFields: Array<string>, skippedKeys: Array<string>, fieldPreviews: Array<{ __typename?: 'RevealFieldPreview', label: string, type: RevealFieldType, example?: string | null }>, matchedUsers: Array<{ __typename?: 'RevealMatchedUser', user: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, values: Array<{ __typename?: 'RevealField', label: string, value: string, type: RevealFieldType }> }> } };

export type SaveRevealUploadMutationVariables = Exact<{
  objectKey: Scalars['String']['input'];
  evaluationFormID: Scalars['ID']['input'];
  selectedFields: Array<Scalars['String']['input']> | Scalars['String']['input'];
  excludedUserIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  fieldTypes?: InputMaybe<Array<RevealFieldTypeInput> | RevealFieldTypeInput>;
}>;


export type SaveRevealUploadMutation = { __typename?: 'Mutation', saveRevealUpload: { __typename?: 'RevealMatchSummary', matchedCount: number, skippedCount: number } };

export type EvaluationFormRevealUploadQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EvaluationFormRevealUploadQuery = { __typename?: 'Query', evaluationForm: { __typename?: 'EvaluationForm', id: string, revealUpload?: { __typename?: 'RevealUploadInfo', selectedFields: Array<string>, uploadedAt?: any | null, matchedCount: number } | null } };

export type EvaluationFormRevealUploadDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EvaluationFormRevealUploadDataQuery = { __typename?: 'Query', evaluationForm: { __typename?: 'EvaluationForm', id: string, revealUpload?: { __typename?: 'RevealUploadInfo', selectedFields: Array<string>, uploadedAt?: any | null, matchedCount: number, matchedUsers: Array<{ __typename?: 'RevealMatchedUser', user: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, values: Array<{ __typename?: 'RevealField', label: string, value: string, type: RevealFieldType }> }> } | null } };

export type EvaluationRevealQueryVariables = Exact<{
  submissionID: Scalars['ID']['input'];
}>;


export type EvaluationRevealQuery = { __typename?: 'Query', evaluationReveal?: { __typename?: 'EvaluationReveal', visibleToEmployee: boolean, fields: Array<{ __typename?: 'RevealField', label: string, value: string, type: RevealFieldType }> } | null };

export type SearchKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchKeyQuery = { __typename?: 'Query', searchKey: { __typename?: 'SearchKey', appID: string, token: string, expiresAt: any } };

export type NoteTemplatePartialFragment = { __typename?: 'NoteTemplate', id: string, title: LocalizedString, subtitle: LocalizedString, icon?: NoteTemplateIcon | null, iconColor?: string | null, description?: LocalizedAttributedString | null, isArchived: boolean, index?: number | null, category: { __typename?: 'NoteTemplateCategory', id: string, title: LocalizedString } };

export type ArchiveNoteTemplateMutationVariables = Exact<{
  input: NoteTemplateArchiveInput;
}>;


export type ArchiveNoteTemplateMutation = { __typename?: 'Mutation', archiveNoteTemplate: { __typename?: 'NoteTemplate', id: string } };

export type CreateNoteTemplateMutationVariables = Exact<{
  input: NoteTemplateCreateInput;
}>;


export type CreateNoteTemplateMutation = { __typename?: 'Mutation', createNoteTemplate: { __typename?: 'NoteTemplate', id: string, title: LocalizedString, subtitle: LocalizedString, icon?: NoteTemplateIcon | null, iconColor?: string | null, description?: LocalizedAttributedString | null, isArchived: boolean, index?: number | null, category: { __typename?: 'NoteTemplateCategory', id: string, title: LocalizedString } } };

export type GenerateApiTokenMutationVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type GenerateApiTokenMutation = { __typename?: 'Mutation', generateApiToken: { __typename?: 'GenerateApiTokenResponse', id: string, type: string, value: string } };

export type RestoreNoteTemplateMutationVariables = Exact<{
  input: NoteTemplateRestoreInput;
}>;


export type RestoreNoteTemplateMutation = { __typename?: 'Mutation', restoreNoteTemplate: { __typename?: 'NoteTemplate', id: string, title: LocalizedString, subtitle: LocalizedString, icon?: NoteTemplateIcon | null, iconColor?: string | null, description?: LocalizedAttributedString | null, isArchived: boolean, index?: number | null, category: { __typename?: 'NoteTemplateCategory', id: string, title: LocalizedString } } };

export type RevokeApiTokenMutationVariables = Exact<{
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type RevokeApiTokenMutation = { __typename?: 'Mutation', revokeApiToken: string };

export type UpdateApiTokenNotificationEmailMutationVariables = Exact<{
  type: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type UpdateApiTokenNotificationEmailMutation = { __typename?: 'Mutation', updateApiTokenNotificationEmail: boolean };

export type UpdateNoteTemplateMutationVariables = Exact<{
  input: NoteTemplateUpdateInput;
}>;


export type UpdateNoteTemplateMutation = { __typename?: 'Mutation', updateNoteTemplate: { __typename?: 'NoteTemplate', id: string, title: LocalizedString, subtitle: LocalizedString, icon?: NoteTemplateIcon | null, iconColor?: string | null, description?: LocalizedAttributedString | null, isArchived: boolean, index?: number | null, category: { __typename?: 'NoteTemplateCategory', id: string, title: LocalizedString } } };

export type ApiTokenNotificationEmailQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type ApiTokenNotificationEmailQuery = { __typename?: 'Query', apiTokenNotificationEmail: { __typename?: 'ApiTokenNotificationEmail', email: string } };

export type ApiTokensQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type ApiTokensQuery = { __typename?: 'Query', apiTokenDescriptions: Array<{ __typename?: 'ApiTokenDescription', id: string, type: string, createdAt: any, expiresAt: any }> };

export type NoteTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NoteTemplateQuery = { __typename?: 'Query', noteTemplate: { __typename?: 'NoteTemplate', id: string, title: LocalizedString, subtitle: LocalizedString, icon?: NoteTemplateIcon | null, iconColor?: string | null, description?: LocalizedAttributedString | null, isArchived: boolean, index?: number | null, category: { __typename?: 'NoteTemplateCategory', id: string, title: LocalizedString } } };

export type NoteTemplatesQueryVariables = Exact<{
  isArchived: Scalars['Boolean']['input'];
  subjectID?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NoteTemplatesQuery = { __typename?: 'Query', noteTemplates: { __typename?: 'NoteTemplatesConnection', edges: Array<{ __typename?: 'NoteTemplatesEdge', cursor: string, node: { __typename?: 'NoteTemplate', id: string, title: LocalizedString, subtitle: LocalizedString, icon?: NoteTemplateIcon | null, iconColor?: string | null, description?: LocalizedAttributedString | null, isArchived: boolean, index?: number | null, category: { __typename?: 'NoteTemplateCategory', id: string, title: LocalizedString } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type CustomEmailDomainFragmentFragment = { __typename?: 'CustomEmailDomain', domain: string, emailDomain: string, mailFromDomain: string, enabled: boolean, dkimVerificationStatus: DomainVerificationStatus, dkimTokens: Array<string>, mailFromVerificationStatus: DomainVerificationStatus, senderName: string, senderAddress: string };

export type CycleTemplateEditorFragment = { __typename?: 'CycleTemplate', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, duration: number, isArchived: boolean, automatic: boolean, employmentType?: EmploymentType | null, interval?: CycleTemplateInterval | null, successor?: { __typename?: 'CycleTemplate', id: string } | null, groups?: Array<{ __typename?: 'Group', id: string }> | null, excludedGroups?: Array<{ __typename?: 'Group', id: string }> | null, jobTitles?: Array<{ __typename?: 'JobTitle', id: string }> | null, excludedJobTitles?: Array<{ __typename?: 'JobTitle', id: string }> | null, moments: Array<{ __typename?: 'MomentTemplate', id: string, type: MomentType, startOffset: number, duration: number, title: LocalizedString, description?: LocalizedAttributedString | null, instruction?: LocalizedAttributedString | null, isArchived: boolean, archivedAt?: any | null, showToUser: boolean, variations?: Array<{ __typename?: 'MomentVariation', roleType?: RoleType | null, evaluation?: { __typename?: 'MomentEvaluation', evaluationForm?: { __typename?: 'EvaluationForm', id: string, title: LocalizedString } | null } | null, feedback?: { __typename?: 'MomentFeedback', feedbackTemplate?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString } | null } | null, jobTitle?: { __typename?: 'JobTitle', id: string, title: LocalizedString } | null }> | null, evaluation?: { __typename?: 'MomentEvaluation', evaluationForm?: { __typename?: 'EvaluationForm', id: string, title: LocalizedString } | null } | null, feedback?: { __typename?: 'MomentFeedback', minimumQuestions?: number | null, minimumRecipients?: number | null, maximumRecipients?: number | null, releaseDate?: any | null, feedbackTemplate?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString } | null } | null, goals?: { __typename?: 'MomentGoals', minimumGoals?: number | null, minimumCompetencyGoals?: number | null } | null, talentReview?: { __typename?: 'MomentTalentReview', template?: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString } | null } | null, notifications: Array<{ __typename?: 'MomentNotification', id: string, type: MomentNotificationType, offset: number }> }> };

export type LabelFragment = { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, type: LabelType, isArchived: boolean };

export type SharedByFragment = { __typename?: 'SharedFeedback', createdAt: any, request: { __typename?: 'FeedbackRequest', id: string, title: string, createdAt: any }, sharedBy: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } };

export type SharedWithFragment = { __typename?: 'SharedFeedback', createdAt: any, sharedWith: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } };

export type ArchiveCycleTemplateMutationVariables = Exact<{
  input: ArchiveCycleTemplateInput;
}>;


export type ArchiveCycleTemplateMutation = { __typename?: 'Mutation', archiveCycleTemplate: { __typename?: 'ArchiveCycleTemplateResponse', cycleTemplate: { __typename?: 'CycleTemplate', id: string, isArchived: boolean } } };

export type ArchiveLabelMutationVariables = Exact<{
  input: ArchiveLabelInput;
}>;


export type ArchiveLabelMutation = { __typename?: 'Mutation', archiveLabel: { __typename?: 'ArchiveLabelResponse', label: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, type: LabelType, isArchived: boolean } } };

export type CheckSuppressedEmailMutationVariables = Exact<{
  input: CheckSuppressedEmailInput;
}>;


export type CheckSuppressedEmailMutation = { __typename?: 'Mutation', checkSuppressedEmail: { __typename?: 'CheckSuppressedEmailResponse', isEmailSuppressed: boolean } };

export type CreateAssetMutationVariables = Exact<{
  input: CreateAssetInput;
}>;


export type CreateAssetMutation = { __typename?: 'Mutation', createAsset: { __typename?: 'CreateAssetResponse', asset: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } }, uploadEndpoint: { __typename?: 'AssetUploadEndpoint', url: string, headers: Array<{ __typename?: 'AssetUploadHeader', name: string, values: Array<string> }> } } };

export type CreateCycleInstanceMutationVariables = Exact<{
  input: CreateCycleInstanceInput;
}>;


export type CreateCycleInstanceMutation = { __typename?: 'Mutation', createCycleInstance: { __typename?: 'CreateCycleInstanceResponse', cycleInstance: { __typename?: 'CycleInstance', id: string } } };

export type CreateCycleTemplateMutationVariables = Exact<{
  input: CreateCycleTemplateInput;
}>;


export type CreateCycleTemplateMutation = { __typename?: 'Mutation', createCycleTemplate: { __typename?: 'CreateCycleTemplateResponse', cycleTemplate: { __typename?: 'CycleTemplate', id: string } } };

export type CreateLabelMutationVariables = Exact<{
  input: CreateLabelInput;
}>;


export type CreateLabelMutation = { __typename?: 'Mutation', createLabel: { __typename?: 'CreateLabelResponse', label: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, type: LabelType, isArchived: boolean } } };

export type CreateSubscriptionMutationVariables = Exact<{
  input: CreateSubscriptionInput;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'CreateSubscriptionResponse', redirect?: string | null } };

export type RemoveCycleInstanceMutationVariables = Exact<{
  input: RemoveCycleInstanceInput;
}>;


export type RemoveCycleInstanceMutation = { __typename?: 'Mutation', removeCycleInstance: { __typename?: 'RemoveCycleInstanceResponse', success: boolean } };

export type RemoveSuppressedEmailMutationVariables = Exact<{
  input: RemoveSuppressedEmailInput;
}>;


export type RemoveSuppressedEmailMutation = { __typename?: 'Mutation', removeSuppressedEmail: { __typename?: 'RemoveSuppressedEmailResponse', success: boolean } };

export type RestoreCycleTemplateMutationVariables = Exact<{
  input: RestoreCycleTemplateInput;
}>;


export type RestoreCycleTemplateMutation = { __typename?: 'Mutation', restoreCycleTemplate: { __typename?: 'RestoreCycleTemplateResponse', cycleTemplate: { __typename?: 'CycleTemplate', id: string, isArchived: boolean } } };

export type RestoreLabelMutationVariables = Exact<{
  input: RestoreLabelInput;
}>;


export type RestoreLabelMutation = { __typename?: 'Mutation', restoreLabel: { __typename?: 'RestoreLabelResponse', label: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, type: LabelType, isArchived: boolean } } };

export type UnlinkStripeMutationVariables = Exact<{
  workspaceID: Scalars['ID']['input'];
}>;


export type UnlinkStripeMutation = { __typename?: 'Mutation', unlinkStripe: { __typename?: 'UnlinkStripeResponse', success: boolean } };

export type UpdateCycleTemplateMutationVariables = Exact<{
  input: UpdateCycleTemplateInput;
}>;


export type UpdateCycleTemplateMutation = { __typename?: 'Mutation', updateCycleTemplate: { __typename?: 'UpdateCycleTemplateResponse', cycleTemplate: { __typename?: 'CycleTemplate', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, duration: number, isArchived: boolean, automatic: boolean, employmentType?: EmploymentType | null, interval?: CycleTemplateInterval | null, successor?: { __typename?: 'CycleTemplate', id: string } | null, groups?: Array<{ __typename?: 'Group', id: string }> | null, excludedGroups?: Array<{ __typename?: 'Group', id: string }> | null, jobTitles?: Array<{ __typename?: 'JobTitle', id: string }> | null, excludedJobTitles?: Array<{ __typename?: 'JobTitle', id: string }> | null, moments: Array<{ __typename?: 'MomentTemplate', id: string, type: MomentType, startOffset: number, duration: number, title: LocalizedString, description?: LocalizedAttributedString | null, instruction?: LocalizedAttributedString | null, isArchived: boolean, archivedAt?: any | null, showToUser: boolean, variations?: Array<{ __typename?: 'MomentVariation', roleType?: RoleType | null, evaluation?: { __typename?: 'MomentEvaluation', evaluationForm?: { __typename?: 'EvaluationForm', id: string, title: LocalizedString } | null } | null, feedback?: { __typename?: 'MomentFeedback', feedbackTemplate?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString } | null } | null, jobTitle?: { __typename?: 'JobTitle', id: string, title: LocalizedString } | null }> | null, evaluation?: { __typename?: 'MomentEvaluation', evaluationForm?: { __typename?: 'EvaluationForm', id: string, title: LocalizedString } | null } | null, feedback?: { __typename?: 'MomentFeedback', minimumQuestions?: number | null, minimumRecipients?: number | null, maximumRecipients?: number | null, releaseDate?: any | null, feedbackTemplate?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString } | null } | null, goals?: { __typename?: 'MomentGoals', minimumGoals?: number | null, minimumCompetencyGoals?: number | null } | null, talentReview?: { __typename?: 'MomentTalentReview', template?: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString } | null } | null, notifications: Array<{ __typename?: 'MomentNotification', id: string, type: MomentNotificationType, offset: number }> }> } } };

export type UpdateLabelMutationVariables = Exact<{
  input: UpdateLabelInput;
}>;


export type UpdateLabelMutation = { __typename?: 'Mutation', updateLabel: { __typename?: 'UpdateLabelResponse', label: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, type: LabelType, isArchived: boolean } } };

export type UpdatePrivacyConsentMutationVariables = Exact<{
  input: UpdatePrivacyConsentInput;
}>;


export type UpdatePrivacyConsentMutation = { __typename?: 'Mutation', updatePrivacyConsent: { __typename?: 'UpdatePrivacyConsentResponse', user: { __typename?: 'User', id: string, allowsUsageStatistics?: boolean | null, privacyConsent?: { __typename?: 'PrivacyConsent', version: string } | null } } };

export type UpdateProductMutationVariables = Exact<{
  input: UpdateConnectorInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateConnector: { __typename?: 'UpdateConnectorResponse', workspace: { __typename?: 'Workspace', connector?: { __typename?: 'Connector', id: string, isActive: boolean } | null } } };

export type UpdateProductConfigurationMutationVariables = Exact<{
  input: UpdateConnectorConfigFieldInput;
}>;


export type UpdateProductConfigurationMutation = { __typename?: 'Mutation', updateConnectorConfigField: { __typename?: 'UpdateConnectorConfigFieldResponse', workspace: { __typename?: 'Workspace', connector?: { __typename?: 'Connector', id: string, isActive: boolean, type: ConnectorType, config: Array<{ __typename?: 'ConnectorConfigFieldBoolean', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, isDangerous: boolean, boolean?: boolean | null } | { __typename?: 'ConnectorConfigFieldDate', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, date?: any | null } | { __typename?: 'ConnectorConfigFieldFilter', id: string, key: string, isConfigured: boolean, type: ConnectorConfigFieldType, whitelist: boolean } | { __typename?: 'ConnectorConfigFieldMultiSelect', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, values?: Array<string> | null, options?: Array<{ __typename?: 'ConnectorSelectOption', label: string, value: string }> | null } | { __typename?: 'ConnectorConfigFieldOAuth2', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, authorizeUrl: string, authorizationInfo?: string | null } | { __typename?: 'ConnectorConfigFieldSelect', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, value?: string | null } | { __typename?: 'ConnectorConfigFieldText', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, isSecret: boolean, text?: string | null }> } | null } } };

export type UpdateWelcomeEmailMutationVariables = Exact<{
  input: UpdateWelcomeEmailInput;
}>;


export type UpdateWelcomeEmailMutation = { __typename?: 'Mutation', updateWelcomeEmail: { __typename?: 'UpdateWelcomeEmailResponse', workspace: { __typename?: 'Workspace', id: string, notificationSettings: { __typename?: 'WorkspaceNotificationSettings', header: LocalizedAttributedString, footer: LocalizedAttributedString, welcomeEmail: { __typename?: 'WorkspaceWelcomeEmail', body: LocalizedAttributedString, subject: LocalizedString } } } } };

export type AssetsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AssetsQuery = { __typename?: 'Query', assets: Array<{ __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } }> };

export type CompetenciesQueryVariables = Exact<{
  isArchived: Scalars['Boolean']['input'];
  jobTitleIDs?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompetenciesQuery = { __typename?: 'Query', competencies: { __typename?: 'CompetencyConnection', edges: Array<{ __typename?: 'CompetencyEdge', cursor: string, node: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, attachableToGoal: boolean, isArchived: boolean, styrSkillID?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type CycleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type CycleQuery = { __typename?: 'Query', cycleInstance: { __typename?: 'CycleInstance', id: string, startDate: any, activatesAt: any, deactivatesAt?: any | null, cycleTemplate: { __typename?: 'CycleTemplate', id: string, title: LocalizedString, repeats: boolean, duration: number, successor?: { __typename?: 'CycleTemplate', id: string } | null, moments: Array<{ __typename?: 'MomentTemplate', id: string, title: LocalizedString, startOffset: number, type: MomentType, duration: number, showToUser: boolean }> }, moments: Array<{ __typename?: 'MomentInstance', id: string, status: MomentStatus, startDate: any, endDate: any, skipReason?: MomentSkipReason | null, skipReasonOther?: string | null, user: { __typename?: 'User', id: string }, cycleInstance: { __typename?: 'CycleInstance', id: string }, cycleTemplate: { __typename?: 'CycleTemplate', id: string, title: LocalizedString }, momentTemplate: { __typename?: 'MomentTemplate', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, type: MomentType, duration: number, showToUser: boolean, original?: { __typename?: 'MomentTemplate', id: string } | null, talentReview?: { __typename?: 'MomentTalentReview', template?: { __typename?: 'TalentReviewTemplate', id: string } | null, group?: { __typename?: 'Group', id: string } | null } | null }, evaluation?: { __typename?: 'EvaluationSubmission', id: string, viewer: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus, requiresSignature: boolean }, employee: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus, requiresSignature: boolean } } | null }>, precededBy?: { __typename?: 'CycleInstance', id: string } | null, succeededBy?: { __typename?: 'CycleInstance', id: string } | null, skippedFutureMoments: Array<{ __typename?: 'CycleInstanceSkippedMoment', momentTemplateID: string, skipReason: MomentSkipReason, skipReasonOther?: string | null }> } };

export type CycleTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CycleTemplateQuery = { __typename?: 'Query', cycleTemplate: { __typename?: 'CycleTemplate', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, duration: number, isArchived: boolean, automatic: boolean, employmentType?: EmploymentType | null, interval?: CycleTemplateInterval | null, successor?: { __typename?: 'CycleTemplate', id: string } | null, groups?: Array<{ __typename?: 'Group', id: string }> | null, excludedGroups?: Array<{ __typename?: 'Group', id: string }> | null, jobTitles?: Array<{ __typename?: 'JobTitle', id: string }> | null, excludedJobTitles?: Array<{ __typename?: 'JobTitle', id: string }> | null, moments: Array<{ __typename?: 'MomentTemplate', id: string, type: MomentType, startOffset: number, duration: number, title: LocalizedString, description?: LocalizedAttributedString | null, instruction?: LocalizedAttributedString | null, isArchived: boolean, archivedAt?: any | null, showToUser: boolean, variations?: Array<{ __typename?: 'MomentVariation', roleType?: RoleType | null, evaluation?: { __typename?: 'MomentEvaluation', evaluationForm?: { __typename?: 'EvaluationForm', id: string, title: LocalizedString } | null } | null, feedback?: { __typename?: 'MomentFeedback', feedbackTemplate?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString } | null } | null, jobTitle?: { __typename?: 'JobTitle', id: string, title: LocalizedString } | null }> | null, evaluation?: { __typename?: 'MomentEvaluation', evaluationForm?: { __typename?: 'EvaluationForm', id: string, title: LocalizedString } | null } | null, feedback?: { __typename?: 'MomentFeedback', minimumQuestions?: number | null, minimumRecipients?: number | null, maximumRecipients?: number | null, releaseDate?: any | null, feedbackTemplate?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString } | null } | null, goals?: { __typename?: 'MomentGoals', minimumGoals?: number | null, minimumCompetencyGoals?: number | null } | null, talentReview?: { __typename?: 'MomentTalentReview', template?: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString } | null } | null, notifications: Array<{ __typename?: 'MomentNotification', id: string, type: MomentNotificationType, offset: number }> }> } };

export type CycleTemplatesQueryVariables = Exact<{
  isArchived: Scalars['Boolean']['input'];
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CycleTemplatesQuery = { __typename?: 'Query', cycleTemplates: { __typename?: 'CycleTemplateConnection', edges: Array<{ __typename?: 'CycleTemplateEdge', cursor: string, node: { __typename?: 'CycleTemplate', id: string, title: LocalizedString, isArchived: boolean, duration: number } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type DevelopmentPlanQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
}>;


export type DevelopmentPlanQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, currentJobPosition?: { __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } } | null, activeGoals: Array<{ __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, archivedAt?: any | null, isArchived: boolean, createdAt: any, updatedAt?: any | null, completedAt?: any | null, viewerCanUpdate: boolean, order: number, viewerCanComment: boolean, viewerCanViewComments: boolean, visibility: GoalVisibility, completedBy?: { __typename?: 'User', id: string } | null, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } }, appraisals: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number }> } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, learningCourseID?: string | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, launchUrl?: string | null, launchUrls?: LocalizedString | null, learningType: { __typename?: 'LearningType', id: string, title: LocalizedString } } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, isArchived: boolean, viewerCanArchive: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, parent?: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null }, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } }>, completedGoals: Array<{ __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, archivedAt?: any | null, isArchived: boolean, createdAt: any, updatedAt?: any | null, completedAt?: any | null, viewerCanUpdate: boolean, order: number, viewerCanComment: boolean, viewerCanViewComments: boolean, visibility: GoalVisibility, completedBy?: { __typename?: 'User', id: string } | null, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } }, appraisals: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number }> } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, learningCourseID?: string | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, launchUrl?: string | null, launchUrls?: LocalizedString | null, learningType: { __typename?: 'LearningType', id: string, title: LocalizedString } } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, isArchived: boolean, viewerCanArchive: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, parent?: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null }, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } }> } };

export type LabelQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LabelQuery = { __typename?: 'Query', label: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, type: LabelType, isArchived: boolean } };

export type PaginatedLabelsQueryVariables = Exact<{
  isArchived: Scalars['Boolean']['input'];
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  type: LabelType;
}>;


export type PaginatedLabelsQuery = { __typename?: 'Query', paginatedLabels: { __typename?: 'LabelConnection', edges: Array<{ __typename?: 'LabelEdge', cursor: string, node: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, type: LabelType, isArchived: boolean } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type ProductQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductQuery = { __typename?: 'Query', connectors: Array<{ __typename?: 'Connector', id: string, type: ConnectorType, isActive: boolean }>, viewer: { __typename?: 'User', id: string, workspace: { __typename?: 'Workspace', id: string, connector?: { __typename?: 'Connector', id: string, isActive: boolean, type: ConnectorType, config: Array<{ __typename?: 'ConnectorConfigFieldBoolean', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, isDangerous: boolean, boolean?: boolean | null } | { __typename?: 'ConnectorConfigFieldDate', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, date?: any | null } | { __typename?: 'ConnectorConfigFieldFilter', id: string, key: string, isConfigured: boolean, type: ConnectorConfigFieldType, whitelist: boolean } | { __typename?: 'ConnectorConfigFieldMultiSelect', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, values?: Array<string> | null, options?: Array<{ __typename?: 'ConnectorSelectOption', label: string, value: string }> | null } | { __typename?: 'ConnectorConfigFieldOAuth2', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, authorizeUrl: string, authorizationInfo?: string | null } | { __typename?: 'ConnectorConfigFieldSelect', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, value?: string | null } | { __typename?: 'ConnectorConfigFieldText', id: string, key: string, type: ConnectorConfigFieldType, isConfigured: boolean, isSecret: boolean, text?: string | null }> } | null } } };

export type SentEmailsQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SentEmailsQuery = { __typename?: 'Query', sentEmails: { __typename?: 'SentEmailConnection', edges: Array<{ __typename?: 'SentEmailEdge', cursor: string, node: { __typename?: 'SentEmail', id: string, recipientName: string, recipientEmail: string, subject: string, sentAt: any } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type ServiceProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type ServiceProvidersQuery = { __typename?: 'Query', serviceProvider: { __typename?: 'ServiceProvider', entityID: string, acsURL: string, metadataURL: string } };

export type SingleSignOnsQueryVariables = Exact<{ [key: string]: never; }>;


export type SingleSignOnsQuery = { __typename?: 'Query', singleSignOns: Array<{ __typename?: 'SingleSignOn', url: string, identityProvider: { __typename?: 'IdentityProvider', id: string } }> };

export type SupportEmailAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportEmailAddressesQuery = { __typename?: 'Query', supportEmailAddresses: Array<string> };

export type ViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, firstName: string, lastName: string, username: string, email: string, locale: string, allowsUsageStatistics?: boolean | null, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, privacyConsent?: { __typename?: 'PrivacyConsent', version: string } | null, signedEmail?: { __typename?: 'SignedEmail', email: string, hmac: string } | null } };

export type ViewerCompetenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerCompetenciesQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, jobPositions: Array<{ __typename?: 'JobPosition', jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString }, appraisal: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string } }>, competencies: Array<{ __typename?: 'JobCompetency', id: string, competencyLevel: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } }> }> } };

export type ViewerWithManagersQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerWithManagersQuery = { __typename?: 'Query', viewer: { __typename?: 'User', managers: Array<{ __typename?: 'UserRole', id: string, source: { __typename?: 'User', id: string, firstName: string, lastName: string, isArchived: boolean, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, role: { __typename?: 'Role', id: string } }> } };

export type ViewerWithManagersAndManageesQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerWithManagersAndManageesQuery = { __typename?: 'Query', viewer: { __typename?: 'User', managees: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, isArchived: boolean }>, managers: Array<{ __typename?: 'UserRole', id: string, source: { __typename?: 'User', id: string, firstName: string, lastName: string, isArchived: boolean } }> } };

export type TalentReviewFragment = { __typename?: 'TalentReview', id: string, title: string, visibility: TalentReviewVisibility, viewerCanUpdate: boolean, isArchived: boolean, status: TalentReviewStatus, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, visibility: TalentReviewVisibility, outdatedAfterDays: number, hasNorm: boolean, isArchived: boolean, xAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, yAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, cells: Array<Array<{ __typename?: 'TalentReviewTemplateCell', color: number, label: LocalizedString, instruction: LocalizedString, norm: number }>>, placementHelpQuestions: Array<{ __typename?: 'TalentReviewPlacementHelpQuestion', id: string, axis: TalentReviewPlacementHelpAxis, question: LocalizedString, answers: Array<{ __typename?: 'TalentReviewPlacementHelpOption', id: string, label: LocalizedString, tickIndex?: number | null }> }> }, group: { __typename?: 'Group', id: string, type: GroupType, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, role: { __typename?: 'Role', id: string, type: RoleType } }> } }, placements: Array<{ __typename?: 'TalentReviewPlacement', row: number, column: number, score?: TalentReviewPlacementScore | null, motivation?: string | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }> };

export type TalentReviewTemplateFragment = { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, visibility: TalentReviewVisibility, outdatedAfterDays: number, hasNorm: boolean, isArchived: boolean, xAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, yAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, cells: Array<Array<{ __typename?: 'TalentReviewTemplateCell', color: number, label: LocalizedString, instruction: LocalizedString, norm: number }>>, placementHelpQuestions: Array<{ __typename?: 'TalentReviewPlacementHelpQuestion', id: string, axis: TalentReviewPlacementHelpAxis, question: LocalizedString, answers: Array<{ __typename?: 'TalentReviewPlacementHelpOption', id: string, label: LocalizedString, tickIndex?: number | null }> }> };

export type ArchiveTalentReviewMutationVariables = Exact<{
  input: ArchiveTalentReviewInput;
}>;


export type ArchiveTalentReviewMutation = { __typename?: 'Mutation', archiveTalentReview: { __typename?: 'ArchiveTalentReviewResponse', talentReview: { __typename?: 'TalentReview', id: string, isArchived: boolean } } };

export type ArchiveTalentReviewTemplateMutationVariables = Exact<{
  input: ArchiveTalentReviewTemplateInput;
}>;


export type ArchiveTalentReviewTemplateMutation = { __typename?: 'Mutation', archiveTalentReviewTemplate: { __typename?: 'ArchiveTalentReviewTemplateResponse', template: { __typename?: 'TalentReviewTemplate', id: string, isArchived: boolean } } };

export type CreateTalentReviewMutationVariables = Exact<{
  input: CreateTalentReviewInput;
}>;


export type CreateTalentReviewMutation = { __typename?: 'Mutation', createTalentReview: { __typename?: 'CreateTalentReviewResponse', talentReview: { __typename?: 'TalentReview', id: string } } };

export type CreateTalentReviewTemplateMutationVariables = Exact<{
  input: CreateTalentReviewTemplateInput;
}>;


export type CreateTalentReviewTemplateMutation = { __typename?: 'Mutation', createTalentReviewTemplate: { __typename?: 'CreateTalentReviewTemplateResponse', template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, visibility: TalentReviewVisibility, outdatedAfterDays: number, hasNorm: boolean, isArchived: boolean, xAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, yAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, cells: Array<Array<{ __typename?: 'TalentReviewTemplateCell', color: number, label: LocalizedString, instruction: LocalizedString, norm: number }>>, placementHelpQuestions: Array<{ __typename?: 'TalentReviewPlacementHelpQuestion', id: string, axis: TalentReviewPlacementHelpAxis, question: LocalizedString, answers: Array<{ __typename?: 'TalentReviewPlacementHelpOption', id: string, label: LocalizedString, tickIndex?: number | null }> }> } } };

export type RestoreTalentReviewMutationVariables = Exact<{
  input: RestoreTalentReviewInput;
}>;


export type RestoreTalentReviewMutation = { __typename?: 'Mutation', restoreTalentReview: { __typename?: 'RestoreTalentReviewResponse', talentReview: { __typename?: 'TalentReview', id: string, isArchived: boolean } } };

export type RestoreTalentReviewTemplateMutationVariables = Exact<{
  input: RestoreTalentReviewTemplateInput;
}>;


export type RestoreTalentReviewTemplateMutation = { __typename?: 'Mutation', restoreTalentReviewTemplate: { __typename?: 'RestoreTalentReviewTemplateResponse', template: { __typename?: 'TalentReviewTemplate', id: string, isArchived: boolean } } };

export type UnShareTalentReviewMutationVariables = Exact<{
  input: UnshareTalentReviewInput;
}>;


export type UnShareTalentReviewMutation = { __typename?: 'Mutation', unshareTalentReview: { __typename?: 'UnshareTalentReviewResponse', talentReview: { __typename?: 'TalentReview', id: string, title: string, visibility: TalentReviewVisibility, viewerCanUpdate: boolean, isArchived: boolean, status: TalentReviewStatus, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, visibility: TalentReviewVisibility, outdatedAfterDays: number, hasNorm: boolean, isArchived: boolean, xAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, yAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, cells: Array<Array<{ __typename?: 'TalentReviewTemplateCell', color: number, label: LocalizedString, instruction: LocalizedString, norm: number }>>, placementHelpQuestions: Array<{ __typename?: 'TalentReviewPlacementHelpQuestion', id: string, axis: TalentReviewPlacementHelpAxis, question: LocalizedString, answers: Array<{ __typename?: 'TalentReviewPlacementHelpOption', id: string, label: LocalizedString, tickIndex?: number | null }> }> }, group: { __typename?: 'Group', id: string, type: GroupType, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, role: { __typename?: 'Role', id: string, type: RoleType } }> } }, placements: Array<{ __typename?: 'TalentReviewPlacement', row: number, column: number, score?: TalentReviewPlacementScore | null, motivation?: string | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }> } } };

export type UpdateTalentReviewMutationVariables = Exact<{
  input: UpdateTalentReviewInput;
}>;


export type UpdateTalentReviewMutation = { __typename?: 'Mutation', updateTalentReview: { __typename?: 'UpdateTalentReviewResponse', talentReview: { __typename?: 'TalentReview', id: string, title: string, visibility: TalentReviewVisibility, viewerCanUpdate: boolean, isArchived: boolean, status: TalentReviewStatus, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, visibility: TalentReviewVisibility, outdatedAfterDays: number, hasNorm: boolean, isArchived: boolean, xAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, yAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, cells: Array<Array<{ __typename?: 'TalentReviewTemplateCell', color: number, label: LocalizedString, instruction: LocalizedString, norm: number }>>, placementHelpQuestions: Array<{ __typename?: 'TalentReviewPlacementHelpQuestion', id: string, axis: TalentReviewPlacementHelpAxis, question: LocalizedString, answers: Array<{ __typename?: 'TalentReviewPlacementHelpOption', id: string, label: LocalizedString, tickIndex?: number | null }> }> }, group: { __typename?: 'Group', id: string, type: GroupType, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, role: { __typename?: 'Role', id: string, type: RoleType } }> } }, placements: Array<{ __typename?: 'TalentReviewPlacement', row: number, column: number, score?: TalentReviewPlacementScore | null, motivation?: string | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }> } } };

export type UpdateTalentReviewTemplateMutationVariables = Exact<{
  input: UpdateTalentReviewTemplateInput;
}>;


export type UpdateTalentReviewTemplateMutation = { __typename?: 'Mutation', updateTalentReviewTemplate: { __typename?: 'UpdateTalentReviewTemplateResponse', template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, visibility: TalentReviewVisibility, outdatedAfterDays: number, hasNorm: boolean, isArchived: boolean, xAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, yAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, cells: Array<Array<{ __typename?: 'TalentReviewTemplateCell', color: number, label: LocalizedString, instruction: LocalizedString, norm: number }>>, placementHelpQuestions: Array<{ __typename?: 'TalentReviewPlacementHelpQuestion', id: string, axis: TalentReviewPlacementHelpAxis, question: LocalizedString, answers: Array<{ __typename?: 'TalentReviewPlacementHelpOption', id: string, label: LocalizedString, tickIndex?: number | null }> }> } } };

export type TalentReviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TalentReviewQuery = { __typename?: 'Query', talentReview: { __typename?: 'TalentReview', id: string, title: string, visibility: TalentReviewVisibility, viewerCanUpdate: boolean, isArchived: boolean, status: TalentReviewStatus, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, visibility: TalentReviewVisibility, outdatedAfterDays: number, hasNorm: boolean, isArchived: boolean, xAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, yAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, cells: Array<Array<{ __typename?: 'TalentReviewTemplateCell', color: number, label: LocalizedString, instruction: LocalizedString, norm: number }>>, placementHelpQuestions: Array<{ __typename?: 'TalentReviewPlacementHelpQuestion', id: string, axis: TalentReviewPlacementHelpAxis, question: LocalizedString, answers: Array<{ __typename?: 'TalentReviewPlacementHelpOption', id: string, label: LocalizedString, tickIndex?: number | null }> }> }, group: { __typename?: 'Group', id: string, type: GroupType, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, role: { __typename?: 'Role', id: string, type: RoleType } }> } }, placements: Array<{ __typename?: 'TalentReviewPlacement', row: number, column: number, score?: TalentReviewPlacementScore | null, motivation?: string | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }> } };

export type TalentReviewAnalyticsGridQueryVariables = Exact<{
  templateID: Scalars['ID']['input'];
  groupID: Scalars['ID']['input'];
  localDate: Scalars['LocalDate']['input'];
}>;


export type TalentReviewAnalyticsGridQuery = { __typename?: 'Query', talentReviewGrid: { __typename?: 'TalentReviewGrid', placements: Array<{ __typename?: 'TalentReviewGridPlacement', row: number, column: number, removed?: boolean | null, user: { __typename?: 'User', id: string } }> } };

export type TalentReviewAnalyticsGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TalentReviewAnalyticsGroupQuery = { __typename?: 'Query', group: { __typename?: 'Group', id: string, name: string, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, currentJobPosition?: { __typename?: 'JobPosition', jobTitle: { __typename?: 'JobTitle', title: LocalizedString } } | null, individualManagers: Array<{ __typename?: 'UserRole', role: { __typename?: 'Role', id: string }, source: { __typename?: 'User', firstName: string, lastName: string } }> } }> }, managers: { __typename?: 'GroupManagerConnection', edges: Array<{ __typename?: 'GroupManagerEdge', role: { __typename?: 'Role', id: string }, node: { __typename?: 'User', id: string, firstName: string, lastName: string } }> } } };

export type TalentReviewTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TalentReviewTemplateQuery = { __typename?: 'Query', talentReviewTemplate: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, visibility: TalentReviewVisibility, outdatedAfterDays: number, hasNorm: boolean, isArchived: boolean, xAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, yAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, cells: Array<Array<{ __typename?: 'TalentReviewTemplateCell', color: number, label: LocalizedString, instruction: LocalizedString, norm: number }>>, placementHelpQuestions: Array<{ __typename?: 'TalentReviewPlacementHelpQuestion', id: string, axis: TalentReviewPlacementHelpAxis, question: LocalizedString, answers: Array<{ __typename?: 'TalentReviewPlacementHelpOption', id: string, label: LocalizedString, tickIndex?: number | null }> }> } };

export type TalentReviewTemplatesQueryVariables = Exact<{
  isArchived: Scalars['Boolean']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TalentReviewTemplatesQuery = { __typename?: 'Query', talentReviewTemplates: { __typename?: 'TalentReviewTemplateConnection', edges: Array<{ __typename?: 'TalentReviewTemplateEdge', node: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, isArchived: boolean, createdAt: any } }> } };

export type TalentReviewsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  isArchived: Scalars['Boolean']['input'];
}>;


export type TalentReviewsQuery = { __typename?: 'Query', group: { __typename?: 'Group', id: string, name: string, talentReviews: { __typename?: 'TalentReviewConnection', edges: Array<{ __typename?: 'TalentReviewEdge', node: { __typename?: 'TalentReview', id: string, title: string, createdAt: any, placements: Array<{ __typename?: 'TalentReviewPlacement', column: number, row: number }>, group: { __typename?: 'Group', members: { __typename?: 'GroupMemberConnection', totalCount: number, edges: Array<{ __typename?: 'GroupMemberEdge', role: { __typename?: 'Role', id: string, type: RoleType } }> } } } }> } } };

export type TalentReviewActivityFragment = { __typename?: 'TalentReviewActivity', id: string, type: TalentReviewActivityType, createdAt: any, integration?: ConnectorType | null, retentionRisk?: TalentReviewRetentionRisk | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, user?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, placement?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, motivation?: string | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, removed?: boolean | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number } | null } | null, answers?: Array<{ __typename?: 'TalentReviewPlacementHelpAnswer', question: string, answer: string }> | null, successor?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null };

export type TalentReviewCycleMomentFragment = { __typename?: 'MomentInstance', id: string, status: MomentStatus, endDate: any, talentReviewViewerCanRevert: boolean, user: { __typename?: 'User', id: string }, talentReviewSnapshot?: { __typename?: 'TalentReviewSnapshot', id: string, createdAt: any, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string } } | null, momentTemplate: { __typename?: 'MomentTemplate', title: LocalizedString, type: MomentType, talentReview?: { __typename?: 'MomentTalentReview', template?: { __typename?: 'TalentReviewTemplate', id: string } | null, group?: { __typename?: 'Group', id: string } | null } | null } };

export type TalentReviewGridFragment = { __typename?: 'TalentReviewGrid', localDate: string, viewerCanUpdate: boolean, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, visibility: TalentReviewVisibility, outdatedAfterDays: number, hasNorm: boolean, isArchived: boolean, xAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, yAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, cells: Array<Array<{ __typename?: 'TalentReviewTemplateCell', color: number, label: LocalizedString, instruction: LocalizedString, norm: number }>>, placementHelpQuestions: Array<{ __typename?: 'TalentReviewPlacementHelpQuestion', id: string, axis: TalentReviewPlacementHelpAxis, question: LocalizedString, answers: Array<{ __typename?: 'TalentReviewPlacementHelpOption', id: string, label: LocalizedString, tickIndex?: number | null }> }> }, group: { __typename?: 'Group', id: string, name: string, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, role: { __typename?: 'Role', type: RoleType } }> } }, placements: Array<{ __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, localDate: string, createdAt: any, motivation?: string | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null, motivation?: string | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }>, activity: Array<{ __typename?: 'TalentReviewActivity', id: string, type: TalentReviewActivityType, createdAt: any, integration?: ConnectorType | null, retentionRisk?: TalentReviewRetentionRisk | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, user?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, placement?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, motivation?: string | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, removed?: boolean | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number } | null } | null, answers?: Array<{ __typename?: 'TalentReviewPlacementHelpAnswer', question: string, answer: string }> | null, successor?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> };

export type TalentReviewSnapshotFragment = { __typename?: 'TalentReviewSnapshot', id: string, title: string, description?: string | null, localDate: string, status: TalentReviewSnapshotStatus, visibility: TalentReviewVisibility, createdAt: any, sharedAt?: any | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, sharedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString }, group: { __typename?: 'Group', id: string, name: string, type: GroupType } };

export type TalentReviewSnapshotGridFragment = { __typename?: 'TalentReviewSnapshot', viewerCanCorrect: boolean, viewerCanManage: boolean, id: string, title: string, description?: string | null, localDate: string, status: TalentReviewSnapshotStatus, visibility: TalentReviewVisibility, createdAt: any, sharedAt?: any | null, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, visibility: TalentReviewVisibility, outdatedAfterDays: number, hasNorm: boolean, isArchived: boolean, xAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, yAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, cells: Array<Array<{ __typename?: 'TalentReviewTemplateCell', color: number, label: LocalizedString, instruction: LocalizedString, norm: number }>>, placementHelpQuestions: Array<{ __typename?: 'TalentReviewPlacementHelpQuestion', id: string, axis: TalentReviewPlacementHelpAxis, question: LocalizedString, answers: Array<{ __typename?: 'TalentReviewPlacementHelpOption', id: string, label: LocalizedString, tickIndex?: number | null }> }> }, group: { __typename?: 'Group', id: string, name: string, type: GroupType, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, role: { __typename?: 'Role', type: RoleType } }> } }, placements: Array<{ __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, createdAt: any, motivation?: string | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }>, activity: Array<{ __typename?: 'TalentReviewActivity', id: string, type: TalentReviewActivityType, createdAt: any, integration?: ConnectorType | null, retentionRisk?: TalentReviewRetentionRisk | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, user?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, placement?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, motivation?: string | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, removed?: boolean | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number } | null } | null, answers?: Array<{ __typename?: 'TalentReviewPlacementHelpAnswer', question: string, answer: string }> | null, successor?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, sharedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null };

export type AnswerTalentReviewPlacementHelpMutationVariables = Exact<{
  input: AnswerTalentReviewPlacementHelpInput;
}>;


export type AnswerTalentReviewPlacementHelpMutation = { __typename?: 'Mutation', answerTalentReviewPlacementHelp: { __typename?: 'AnswerTalentReviewPlacementHelpResponse', grid: { __typename?: 'TalentReviewGrid', localDate: string, viewerCanUpdate: boolean, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, visibility: TalentReviewVisibility, outdatedAfterDays: number, hasNorm: boolean, isArchived: boolean, xAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, yAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, cells: Array<Array<{ __typename?: 'TalentReviewTemplateCell', color: number, label: LocalizedString, instruction: LocalizedString, norm: number }>>, placementHelpQuestions: Array<{ __typename?: 'TalentReviewPlacementHelpQuestion', id: string, axis: TalentReviewPlacementHelpAxis, question: LocalizedString, answers: Array<{ __typename?: 'TalentReviewPlacementHelpOption', id: string, label: LocalizedString, tickIndex?: number | null }> }> }, group: { __typename?: 'Group', id: string, name: string, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, role: { __typename?: 'Role', type: RoleType } }> } }, placements: Array<{ __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, localDate: string, createdAt: any, motivation?: string | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null, motivation?: string | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }>, activity: Array<{ __typename?: 'TalentReviewActivity', id: string, type: TalentReviewActivityType, createdAt: any, integration?: ConnectorType | null, retentionRisk?: TalentReviewRetentionRisk | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, user?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, placement?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, motivation?: string | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, removed?: boolean | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number } | null } | null, answers?: Array<{ __typename?: 'TalentReviewPlacementHelpAnswer', question: string, answer: string }> | null, successor?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> } } };

export type ArchiveTalentReviewSnapshotMutationVariables = Exact<{
  input: ArchiveTalentReviewSnapshotInput;
}>;


export type ArchiveTalentReviewSnapshotMutation = { __typename?: 'Mutation', archiveTalentReviewSnapshot: { __typename?: 'ArchiveTalentReviewSnapshotResponse', snapshot: { __typename?: 'TalentReviewSnapshot', id: string, title: string, description?: string | null, localDate: string, status: TalentReviewSnapshotStatus, visibility: TalentReviewVisibility, createdAt: any, sharedAt?: any | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, sharedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString }, group: { __typename?: 'Group', id: string, name: string, type: GroupType } } } };

export type ClearTalentReviewGridMutationVariables = Exact<{
  input: ClearTalentReviewGridInput;
}>;


export type ClearTalentReviewGridMutation = { __typename?: 'Mutation', clearTalentReviewGrid: { __typename?: 'ClearTalentReviewGridResponse', grid: { __typename?: 'TalentReviewGrid', localDate: string, viewerCanUpdate: boolean, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, visibility: TalentReviewVisibility, outdatedAfterDays: number, hasNorm: boolean, isArchived: boolean, xAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, yAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, cells: Array<Array<{ __typename?: 'TalentReviewTemplateCell', color: number, label: LocalizedString, instruction: LocalizedString, norm: number }>>, placementHelpQuestions: Array<{ __typename?: 'TalentReviewPlacementHelpQuestion', id: string, axis: TalentReviewPlacementHelpAxis, question: LocalizedString, answers: Array<{ __typename?: 'TalentReviewPlacementHelpOption', id: string, label: LocalizedString, tickIndex?: number | null }> }> }, group: { __typename?: 'Group', id: string, name: string, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, role: { __typename?: 'Role', type: RoleType } }> } }, placements: Array<{ __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, localDate: string, createdAt: any, motivation?: string | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null, motivation?: string | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }>, activity: Array<{ __typename?: 'TalentReviewActivity', id: string, type: TalentReviewActivityType, createdAt: any, integration?: ConnectorType | null, retentionRisk?: TalentReviewRetentionRisk | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, user?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, placement?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, motivation?: string | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, removed?: boolean | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number } | null } | null, answers?: Array<{ __typename?: 'TalentReviewPlacementHelpAnswer', question: string, answer: string }> | null, successor?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> } } };

export type CorrectTalentReviewSnapshotMutationVariables = Exact<{
  input: CorrectTalentReviewSnapshotInput;
  manage?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CorrectTalentReviewSnapshotMutation = { __typename?: 'Mutation', correctTalentReviewSnapshot: { __typename?: 'CorrectTalentReviewSnapshotResponse', snapshot: { __typename?: 'TalentReviewSnapshot', viewerCanCorrect: boolean, viewerCanManage: boolean, id: string, title: string, description?: string | null, localDate: string, status: TalentReviewSnapshotStatus, visibility: TalentReviewVisibility, createdAt: any, sharedAt?: any | null, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, visibility: TalentReviewVisibility, outdatedAfterDays: number, hasNorm: boolean, isArchived: boolean, xAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, yAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, cells: Array<Array<{ __typename?: 'TalentReviewTemplateCell', color: number, label: LocalizedString, instruction: LocalizedString, norm: number }>>, placementHelpQuestions: Array<{ __typename?: 'TalentReviewPlacementHelpQuestion', id: string, axis: TalentReviewPlacementHelpAxis, question: LocalizedString, answers: Array<{ __typename?: 'TalentReviewPlacementHelpOption', id: string, label: LocalizedString, tickIndex?: number | null }> }> }, group: { __typename?: 'Group', id: string, name: string, type: GroupType, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, role: { __typename?: 'Role', type: RoleType } }> } }, placements: Array<{ __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, createdAt: any, motivation?: string | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }>, activity: Array<{ __typename?: 'TalentReviewActivity', id: string, type: TalentReviewActivityType, createdAt: any, integration?: ConnectorType | null, retentionRisk?: TalentReviewRetentionRisk | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, user?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, placement?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, motivation?: string | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, removed?: boolean | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number } | null } | null, answers?: Array<{ __typename?: 'TalentReviewPlacementHelpAnswer', question: string, answer: string }> | null, successor?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, sharedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null } } };

export type CreateTalentReviewSnapshotMutationVariables = Exact<{
  input: CreateTalentReviewSnapshotInput;
}>;


export type CreateTalentReviewSnapshotMutation = { __typename?: 'Mutation', createTalentReviewSnapshot: { __typename?: 'CreateTalentReviewSnapshotResponse', snapshot: { __typename?: 'TalentReviewSnapshot', id: string, title: string, description?: string | null, localDate: string, status: TalentReviewSnapshotStatus, visibility: TalentReviewVisibility, createdAt: any, sharedAt?: any | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, sharedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString }, group: { __typename?: 'Group', id: string, name: string, type: GroupType } } } };

export type RemoveTalentReviewGridPlacementMutationVariables = Exact<{
  input: RemoveTalentReviewGridPlacementInput;
}>;


export type RemoveTalentReviewGridPlacementMutation = { __typename?: 'Mutation', removeTalentReviewGridPlacement: { __typename?: 'RemoveTalentReviewGridPlacementResponse', grid: { __typename?: 'TalentReviewGrid', localDate: string, viewerCanUpdate: boolean, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, visibility: TalentReviewVisibility, outdatedAfterDays: number, hasNorm: boolean, isArchived: boolean, xAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, yAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, cells: Array<Array<{ __typename?: 'TalentReviewTemplateCell', color: number, label: LocalizedString, instruction: LocalizedString, norm: number }>>, placementHelpQuestions: Array<{ __typename?: 'TalentReviewPlacementHelpQuestion', id: string, axis: TalentReviewPlacementHelpAxis, question: LocalizedString, answers: Array<{ __typename?: 'TalentReviewPlacementHelpOption', id: string, label: LocalizedString, tickIndex?: number | null }> }> }, group: { __typename?: 'Group', id: string, name: string, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, role: { __typename?: 'Role', type: RoleType } }> } }, placements: Array<{ __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, localDate: string, createdAt: any, motivation?: string | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null, motivation?: string | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }>, activity: Array<{ __typename?: 'TalentReviewActivity', id: string, type: TalentReviewActivityType, createdAt: any, integration?: ConnectorType | null, retentionRisk?: TalentReviewRetentionRisk | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, user?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, placement?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, motivation?: string | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, removed?: boolean | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number } | null } | null, answers?: Array<{ __typename?: 'TalentReviewPlacementHelpAnswer', question: string, answer: string }> | null, successor?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> } } };

export type RevertTalentReviewSubmissionMutationVariables = Exact<{
  input: RevertTalentReviewSubmissionInput;
}>;


export type RevertTalentReviewSubmissionMutation = { __typename?: 'Mutation', revertTalentReviewSubmission: { __typename?: 'RevertTalentReviewSubmissionResponse', momentInstance: { __typename?: 'MomentInstance', id: string, status: MomentStatus } } };

export type UpdateTalentReviewGridPlacementMutationVariables = Exact<{
  input: UpdateTalentReviewGridPlacementInput;
}>;


export type UpdateTalentReviewGridPlacementMutation = { __typename?: 'Mutation', updateTalentReviewGridPlacement: { __typename?: 'UpdateTalentReviewGridPlacementResponse', grid: { __typename?: 'TalentReviewGrid', localDate: string, viewerCanUpdate: boolean, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, visibility: TalentReviewVisibility, outdatedAfterDays: number, hasNorm: boolean, isArchived: boolean, xAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, yAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, cells: Array<Array<{ __typename?: 'TalentReviewTemplateCell', color: number, label: LocalizedString, instruction: LocalizedString, norm: number }>>, placementHelpQuestions: Array<{ __typename?: 'TalentReviewPlacementHelpQuestion', id: string, axis: TalentReviewPlacementHelpAxis, question: LocalizedString, answers: Array<{ __typename?: 'TalentReviewPlacementHelpOption', id: string, label: LocalizedString, tickIndex?: number | null }> }> }, group: { __typename?: 'Group', id: string, name: string, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, role: { __typename?: 'Role', type: RoleType } }> } }, placements: Array<{ __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, localDate: string, createdAt: any, motivation?: string | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null, motivation?: string | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }>, activity: Array<{ __typename?: 'TalentReviewActivity', id: string, type: TalentReviewActivityType, createdAt: any, integration?: ConnectorType | null, retentionRisk?: TalentReviewRetentionRisk | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, user?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, placement?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, motivation?: string | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, removed?: boolean | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number } | null } | null, answers?: Array<{ __typename?: 'TalentReviewPlacementHelpAnswer', question: string, answer: string }> | null, successor?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> } } };

export type UpdateTalentReviewSnapshotMutationVariables = Exact<{
  input: UpdateTalentReviewSnapshotInput;
}>;


export type UpdateTalentReviewSnapshotMutation = { __typename?: 'Mutation', updateTalentReviewSnapshot: { __typename?: 'UpdateTalentReviewSnapshotResponse', snapshot: { __typename?: 'TalentReviewSnapshot', id: string, title: string, description?: string | null, localDate: string, status: TalentReviewSnapshotStatus, visibility: TalentReviewVisibility, createdAt: any, sharedAt?: any | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, sharedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString }, group: { __typename?: 'Group', id: string, name: string, type: GroupType } } } };

export type MomentForTalentReviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MomentForTalentReviewQuery = { __typename?: 'Query', momentInstance: { __typename?: 'MomentInstance', id: string, status: MomentStatus, endDate: any, talentReviewViewerCanRevert: boolean, user: { __typename?: 'User', id: string }, talentReviewSnapshot?: { __typename?: 'TalentReviewSnapshot', id: string, createdAt: any, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string } } | null, momentTemplate: { __typename?: 'MomentTemplate', title: LocalizedString, type: MomentType, talentReview?: { __typename?: 'MomentTalentReview', template?: { __typename?: 'TalentReviewTemplate', id: string } | null, group?: { __typename?: 'Group', id: string } | null } | null } } };

export type TalentReviewCycleMomentQueryVariables = Exact<{
  groupID: Scalars['ID']['input'];
}>;


export type TalentReviewCycleMomentQuery = { __typename?: 'Query', group: { __typename?: 'Group', id: string, talentReviewCycleMoment?: { __typename?: 'MomentInstance', id: string, status: MomentStatus, endDate: any, talentReviewViewerCanRevert: boolean, user: { __typename?: 'User', id: string }, talentReviewSnapshot?: { __typename?: 'TalentReviewSnapshot', id: string, createdAt: any, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string } } | null, momentTemplate: { __typename?: 'MomentTemplate', title: LocalizedString, type: MomentType, talentReview?: { __typename?: 'MomentTalentReview', template?: { __typename?: 'TalentReviewTemplate', id: string } | null, group?: { __typename?: 'Group', id: string } | null } | null } } | null } };

export type TalentReviewGridQueryVariables = Exact<{
  templateID: Scalars['ID']['input'];
  groupID: Scalars['ID']['input'];
  localDate: Scalars['LocalDate']['input'];
}>;


export type TalentReviewGridQuery = { __typename?: 'Query', talentReviewGrid: { __typename?: 'TalentReviewGrid', localDate: string, viewerCanUpdate: boolean, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, visibility: TalentReviewVisibility, outdatedAfterDays: number, hasNorm: boolean, isArchived: boolean, xAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, yAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, cells: Array<Array<{ __typename?: 'TalentReviewTemplateCell', color: number, label: LocalizedString, instruction: LocalizedString, norm: number }>>, placementHelpQuestions: Array<{ __typename?: 'TalentReviewPlacementHelpQuestion', id: string, axis: TalentReviewPlacementHelpAxis, question: LocalizedString, answers: Array<{ __typename?: 'TalentReviewPlacementHelpOption', id: string, label: LocalizedString, tickIndex?: number | null }> }> }, group: { __typename?: 'Group', id: string, name: string, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, role: { __typename?: 'Role', type: RoleType } }> } }, placements: Array<{ __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, localDate: string, createdAt: any, motivation?: string | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null, motivation?: string | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }>, activity: Array<{ __typename?: 'TalentReviewActivity', id: string, type: TalentReviewActivityType, createdAt: any, integration?: ConnectorType | null, retentionRisk?: TalentReviewRetentionRisk | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, user?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, placement?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, motivation?: string | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, removed?: boolean | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number } | null } | null, answers?: Array<{ __typename?: 'TalentReviewPlacementHelpAnswer', question: string, answer: string }> | null, successor?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> } };

export type TalentReviewGroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<GroupsFilter>;
}>;


export type TalentReviewGroupsQuery = { __typename?: 'Query', groups: { __typename?: 'GroupConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'GroupEdge', node: { __typename?: 'Group', id: string, type: GroupType, name: string, viewerCanViewTalentReviews: boolean, members: { __typename?: 'GroupMemberConnection', totalCount: number, edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }> }, talentReviewLatestActivity?: { __typename?: 'TalentReviewLatestActivity', updatedAt: any, updatedBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString } } | null } }> } };

export type TalentReviewIndexMomentsQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
}>;


export type TalentReviewIndexMomentsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, moments: Array<{ __typename?: 'MomentInstance', id: string, status: MomentStatus, endDate: any, momentTemplate: { __typename?: 'MomentTemplate', id: string, type: MomentType, title: LocalizedString, talentReview?: { __typename?: 'MomentTalentReview', group?: { __typename?: 'Group', id: string } | null } | null } }> } };

export type TalentReviewLatestGridQueryVariables = Exact<{
  groupID: Scalars['ID']['input'];
}>;


export type TalentReviewLatestGridQuery = { __typename?: 'Query', talentReviewLatestGrid?: { __typename?: 'TalentReviewGrid', template: { __typename?: 'TalentReviewTemplate', id: string } } | null };

export type TalentReviewReshareRecipientsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  templateID: Scalars['ID']['input'];
  localDate: Scalars['LocalDate']['input'];
}>;


export type TalentReviewReshareRecipientsQuery = { __typename?: 'Query', momentInstance: { __typename?: 'MomentInstance', id: string, talentReviewReshareRecipients?: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string }> | null } };

export type TalentReviewSharedSnapshotsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TalentReviewSharedSnapshotsQuery = { __typename?: 'Query', group: { __typename?: 'Group', id: string, talentReviewSnapshots: { __typename?: 'TalentReviewSnapshotConnection', edges: Array<{ __typename?: 'TalentReviewSnapshotEdge', node: { __typename?: 'TalentReviewSnapshot', id: string, localDate: string, createdAt: any, visibility: TalentReviewVisibility, viewerIsPlaced: boolean, template: { __typename?: 'TalentReviewTemplate', id: string } } }> } } };

export type TalentReviewSnapshotQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  manage?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TalentReviewSnapshotQuery = { __typename?: 'Query', talentReviewSnapshot: { __typename?: 'TalentReviewSnapshot', viewerCanCorrect: boolean, viewerCanManage: boolean, id: string, title: string, description?: string | null, localDate: string, status: TalentReviewSnapshotStatus, visibility: TalentReviewVisibility, createdAt: any, sharedAt?: any | null, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, visibility: TalentReviewVisibility, outdatedAfterDays: number, hasNorm: boolean, isArchived: boolean, xAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, yAxis: { __typename?: 'TalentReviewTemplateAxis', label: LocalizedString, ticks: Array<LocalizedString> }, cells: Array<Array<{ __typename?: 'TalentReviewTemplateCell', color: number, label: LocalizedString, instruction: LocalizedString, norm: number }>>, placementHelpQuestions: Array<{ __typename?: 'TalentReviewPlacementHelpQuestion', id: string, axis: TalentReviewPlacementHelpAxis, question: LocalizedString, answers: Array<{ __typename?: 'TalentReviewPlacementHelpOption', id: string, label: LocalizedString, tickIndex?: number | null }> }> }, group: { __typename?: 'Group', id: string, name: string, type: GroupType, members: { __typename?: 'GroupMemberConnection', edges: Array<{ __typename?: 'GroupMemberEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, role: { __typename?: 'Role', type: RoleType } }> } }, placements: Array<{ __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, createdAt: any, motivation?: string | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, position?: number | null } | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }>, activity: Array<{ __typename?: 'TalentReviewActivity', id: string, type: TalentReviewActivityType, createdAt: any, integration?: ConnectorType | null, retentionRisk?: TalentReviewRetentionRisk | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, user?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, placement?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number, motivation?: string | null, score?: TalentReviewPlacementScore | null, retentionRisk?: TalentReviewRetentionRisk | null, removed?: boolean | null, previous?: { __typename?: 'TalentReviewGridPlacement', row: number, column: number } | null } | null, answers?: Array<{ __typename?: 'TalentReviewPlacementHelpAnswer', question: string, answer: string }> | null, successor?: { __typename?: 'User', id: string, firstName: string, lastName: string } | null }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, sharedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null } };

export type TalentReviewSnapshotsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  isArchived: Scalars['Boolean']['input'];
}>;


export type TalentReviewSnapshotsQuery = { __typename?: 'Query', group: { __typename?: 'Group', id: string, name: string, talentReviewSnapshots: { __typename?: 'TalentReviewSnapshotConnection', edges: Array<{ __typename?: 'TalentReviewSnapshotEdge', node: { __typename?: 'TalentReviewSnapshot', id: string, title: string, description?: string | null, localDate: string, status: TalentReviewSnapshotStatus, visibility: TalentReviewVisibility, createdAt: any, sharedAt?: any | null, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string }, sharedBy?: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } | null, template: { __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString }, group: { __typename?: 'Group', id: string, name: string, type: GroupType } } }> } } };

export type TalentReviewUsedTemplatesQueryVariables = Exact<{
  groupID: Scalars['ID']['input'];
}>;


export type TalentReviewUsedTemplatesQuery = { __typename?: 'Query', talentReviewUsedTemplates: Array<{ __typename?: 'TalentReviewTemplate', id: string, title: LocalizedString }> };

export type AppendTranscriptionMutationVariables = Exact<{
  input: AppendTranscriptionInput;
}>;


export type AppendTranscriptionMutation = { __typename?: 'Mutation', appendTranscription: { __typename?: 'AppendTranscriptionResponse', applied: boolean, transcription: { __typename?: 'Transcription', id: string, status: TranscriptionStatus, transcript?: string | null } } };

export type CreateTranscriptionMutationVariables = Exact<{
  input: CreateTranscriptionInput;
}>;


export type CreateTranscriptionMutation = { __typename?: 'Mutation', createTranscription: { __typename?: 'CreateTranscriptionResponse', uploadURL: string, transcription: { __typename?: 'Transcription', id: string, status: TranscriptionStatus }, uploadHeaders: Array<{ __typename?: 'TranscriptionUploadHeader', name: string, values: Array<string> }> } };

export type FinalizeTranscriptionUploadMutationVariables = Exact<{
  input: FinalizeTranscriptionUploadInput;
}>;


export type FinalizeTranscriptionUploadMutation = { __typename?: 'Mutation', finalizeTranscriptionUpload: { __typename?: 'FinalizeTranscriptionUploadResponse', transcriptionID: string } };

export type LinkTranscriptionToEvaluationSubmissionMutationVariables = Exact<{
  input: LinkTranscriptionToEvaluationSubmissionInput;
}>;


export type LinkTranscriptionToEvaluationSubmissionMutation = { __typename?: 'Mutation', linkTranscriptionToEvaluationSubmission: { __typename?: 'LinkTranscriptionToEvaluationSubmissionResponse', evaluationSubmission: { __typename?: 'EvaluationSubmission', id: string, transcription?: { __typename?: 'Transcription', id: string, status: TranscriptionStatus, uploadStatus: TranscriptionUploadStatus, transcript?: string | null, summary?: string | null, editableSummary?: any | null, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null } | null } } };

export type MarkTranscriptionFollowupActedUponMutationVariables = Exact<{
  input: MarkTranscriptionFollowupActedUponInput;
}>;


export type MarkTranscriptionFollowupActedUponMutation = { __typename?: 'Mutation', markTranscriptionFollowupActedUpon: { __typename?: 'Transcription', id: string, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null } };

export type MarkTranscriptionUploadAsFailedMutationVariables = Exact<{
  input: MarkTranscriptionUploadAsFailedInput;
}>;


export type MarkTranscriptionUploadAsFailedMutation = { __typename?: 'Mutation', markTranscriptionUploadAsFailed: { __typename?: 'MarkTranscriptionUploadAsFailedResponse', transcriptionID: string } };

export type PrepareTranscriptionUploadRetryMutationVariables = Exact<{
  input: PrepareTranscriptionUploadRetryInput;
}>;


export type PrepareTranscriptionUploadRetryMutation = { __typename?: 'Mutation', prepareTranscriptionUploadRetry: { __typename?: 'PrepareTranscriptionUploadRetryResponse', transcriptionID: string, uploadURL: string, uploadHeaders: Array<{ __typename?: 'TranscriptionUploadHeader', name: string, values: Array<string> }> } };

export type RegenerateTranscriptionSummaryMutationVariables = Exact<{
  input: RegenerateTranscriptionSummaryInput;
}>;


export type RegenerateTranscriptionSummaryMutation = { __typename?: 'Mutation', regenerateTranscriptionSummary: { __typename?: 'RegenerateTranscriptionSummaryResponse', transcription: { __typename?: 'Transcription', id: string, status: TranscriptionStatus, summary?: string | null, editableSummary?: any | null, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null } } };

export type StartStreamingTranscriptionMutationVariables = Exact<{
  input: StartStreamingTranscriptionInput;
}>;


export type StartStreamingTranscriptionMutation = { __typename?: 'Mutation', startStreamingTranscription: { __typename?: 'StartStreamingTranscriptionResponse', token: string, transcriptLength: number, prompt?: string | null, keyterms: Array<string>, transcription: { __typename?: 'Transcription', id: string, status: TranscriptionStatus, uploadStatus: TranscriptionUploadStatus, transcript?: string | null, summary?: string | null, editableSummary?: any | null, audioUrl?: string | null, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null } } };

export type UnlinkTranscriptionFromEvaluationSubmissionMutationVariables = Exact<{
  input: UnlinkTranscriptionFromEvaluationSubmissionInput;
}>;


export type UnlinkTranscriptionFromEvaluationSubmissionMutation = { __typename?: 'Mutation', unlinkTranscriptionFromEvaluationSubmission: { __typename?: 'UnlinkTranscriptionFromEvaluationSubmissionResponse', success: boolean } };

export type UpdateTranscriptionSummaryMutationVariables = Exact<{
  input: UpdateTranscriptionSummaryInput;
}>;


export type UpdateTranscriptionSummaryMutation = { __typename?: 'Mutation', updateTranscriptionSummary: { __typename?: 'UpdateTranscriptionSummaryResponse', transcription: { __typename?: 'Transcription', id: string, summary?: string | null, editableSummary?: any | null } } };

export type TranscriptionFollowupsFragment = { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> };

export type DevelopmentPlanUserFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, currentJobPosition?: { __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } } | null, activeGoals: Array<{ __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, archivedAt?: any | null, isArchived: boolean, createdAt: any, updatedAt?: any | null, completedAt?: any | null, viewerCanUpdate: boolean, order: number, viewerCanComment: boolean, viewerCanViewComments: boolean, visibility: GoalVisibility, completedBy?: { __typename?: 'User', id: string } | null, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } }, appraisals: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number }> } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, learningCourseID?: string | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, launchUrl?: string | null, launchUrls?: LocalizedString | null, learningType: { __typename?: 'LearningType', id: string, title: LocalizedString } } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, isArchived: boolean, viewerCanArchive: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, parent?: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null }, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } }>, completedGoals: Array<{ __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, archivedAt?: any | null, isArchived: boolean, createdAt: any, updatedAt?: any | null, completedAt?: any | null, viewerCanUpdate: boolean, order: number, viewerCanComment: boolean, viewerCanViewComments: boolean, visibility: GoalVisibility, completedBy?: { __typename?: 'User', id: string } | null, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }>, competencyLevelSet: { __typename?: 'CompetencyLevelSet', id: string, levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } }, appraisals: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number }> } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, learningCourseID?: string | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider, launchUrl?: string | null, launchUrls?: LocalizedString | null, learningType: { __typename?: 'LearningType', id: string, title: LocalizedString } } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, isArchived: boolean, viewerCanArchive: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, parent?: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null } } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null }, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } }> };

export type EngagementReplyUserFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null };

export type EvaluationSubmissionFragment = { __typename?: 'EvaluationSubmission', id: string, deadline: any, overrideReason?: string | null, viewerCanChangeConversationPartner: boolean, viewerCanDiscardAnswersFromPredecessor: boolean, viewerCanOverrideScore: boolean, isArchived: boolean, aiInsightsApproved: boolean, employee: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, manager: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, viewer: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString, description?: LocalizedAttributedString | null, sections: Array<{ __typename?: 'EvaluationFormSection', items: Array<{ __typename?: 'EvaluationSectionItem', id: string, type: EvaluationSectionItemType, fillInBy: EvaluationFillInBy, optional?: boolean | null, title?: { __typename?: 'EvaluationTitleItem', text: LocalizedString } | null, paragraph?: { __typename?: 'EvaluationParagraphItem', text: LocalizedAttributedString } | null, stars?: { __typename?: 'EvaluationStarsItem', title: LocalizedString } | null, openQuestion?: { __typename?: 'EvaluationOpenQuestionItem', title: LocalizedString } | null, developmentPlan?: { __typename?: 'EvaluationDevelopmentPlanItem', title: LocalizedString } | null, sentiment?: { __typename?: 'EvaluationSentimentItem', title: LocalizedString, displayMethod: EvaluationSentimentDisplayMethod } | null, competency?: { __typename?: 'EvaluationCompetencyItem', weight: number, competency: { __typename?: 'Competency', title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', title: LocalizedString } }> } } | null, multipleChoice?: { __typename?: 'EvaluationMultipleChoiceItem', title: LocalizedString } | null, finalScore?: { __typename?: 'EvaluationFinalScoreItem', title?: LocalizedString | null, calculationMethod: EvaluationFinalScoreCalculationMethod, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, displayLevelSet?: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } | null } | null, reviewGoals?: { __typename?: 'EvaluationReviewGoalsItem', defaultExplanation?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } | null, signature?: { __typename?: 'EvaluationSignatureItem', title?: LocalizedString | null } | null, setGoals?: { __typename?: 'EvaluationSetGoalsItem', title: LocalizedString } | null }> }> }, goals?: Array<{ __typename?: 'EvaluationSubmissionGoal', title: LocalizedString, dueDate?: any | null, progress: number, status: GoalStatus, goal: { __typename?: 'Goal', id: string }, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }>, meeting?: { __typename?: 'EvaluationSubmissionMeeting', duration: number, link?: string | null, location?: string | null } | null, moment?: { __typename?: 'MomentInstance', id: string, momentTemplate: { __typename?: 'MomentTemplate', id: string, title: LocalizedString } } | null, overrideScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null, transcription?: { __typename?: 'Transcription', id: string, status: TranscriptionStatus, uploadStatus: TranscriptionUploadStatus, transcript?: string | null, summary?: string | null, editableSummary?: any | null, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null } | null };

export type EvaluationSubmissionCardFragment = { __typename?: 'EvaluationSubmission', id: string, createdAt: any, deadline: any, isArchived: boolean, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString }, manager: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus, requiresInput: boolean, requiresSignature: boolean, party: EvaluationSubmissionParty, isCompleted: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }, employee: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus, requiresInput: boolean, party: EvaluationSubmissionParty, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } } };

export type EvaluationSubmissionResultFragment = { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null };

export type SharedByUserFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null };

export type SharedWithUserFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null };

export type UserCompetenciesPartialFragment = { __typename?: 'User', id: string, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, externalReferenceID?: string | null, jobLevel?: { __typename?: 'JobLevel', id: string } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null }, appraisal: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string } }>, competencies: Array<{ __typename?: 'JobCompetency', id: string, competencyLevel: number, order?: number | null, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, label?: { __typename?: 'Label', id: string, title: LocalizedString } | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } }> }> };

export type UserDocumentV2Fragment = { __typename?: 'UserDocumentV2', id: string, name: string, createdAt: any, viewerCanDelete: boolean, status: UserDocumentV2Status, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string } };

export type UserDownloadFragment = { __typename?: 'UserDownload', id: string, downloadLink?: string | null, name: string, progress: number, failedReason?: string | null, status: UserDownloadStatus, viewerCanDelete: boolean };

export type UserMfaConfigurationFragment = { __typename?: 'User', id: string, userMfaConfiguration: { __typename?: 'MfaUserConfiguration', id: string, enabled: boolean, enabledMethods?: Array<MfaMethod> | null, preferredMethod?: MfaMethod | null }, workspace: { __typename?: 'Workspace', workspaceMfaSettings: { __typename?: 'WorkspaceMfaSettings', id: string, status: WorkspaceMfaStatus, allowedMethods: Array<MfaMethod> } } };

export type MfaUserConfigurationFragment = { __typename?: 'MfaUserConfiguration', id: string, enabled: boolean, enabledMethods?: Array<MfaMethod> | null, preferredMethod?: MfaMethod | null };

export type ArchiveEvaluationSubmissionMutationVariables = Exact<{
  input: ArchiveEvaluationSubmissionInput;
}>;


export type ArchiveEvaluationSubmissionMutation = { __typename?: 'Mutation', archiveEvaluationSubmission: { __typename?: 'ArchiveEvaluationSubmissionResponse', evaluationSubmission: { __typename?: 'EvaluationSubmission', id: string, deadline: any, overrideReason?: string | null, viewerCanChangeConversationPartner: boolean, viewerCanDiscardAnswersFromPredecessor: boolean, viewerCanOverrideScore: boolean, isArchived: boolean, aiInsightsApproved: boolean, employee: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, manager: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, viewer: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString, description?: LocalizedAttributedString | null, sections: Array<{ __typename?: 'EvaluationFormSection', items: Array<{ __typename?: 'EvaluationSectionItem', id: string, type: EvaluationSectionItemType, fillInBy: EvaluationFillInBy, optional?: boolean | null, title?: { __typename?: 'EvaluationTitleItem', text: LocalizedString } | null, paragraph?: { __typename?: 'EvaluationParagraphItem', text: LocalizedAttributedString } | null, stars?: { __typename?: 'EvaluationStarsItem', title: LocalizedString } | null, openQuestion?: { __typename?: 'EvaluationOpenQuestionItem', title: LocalizedString } | null, developmentPlan?: { __typename?: 'EvaluationDevelopmentPlanItem', title: LocalizedString } | null, sentiment?: { __typename?: 'EvaluationSentimentItem', title: LocalizedString, displayMethod: EvaluationSentimentDisplayMethod } | null, competency?: { __typename?: 'EvaluationCompetencyItem', weight: number, competency: { __typename?: 'Competency', title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', title: LocalizedString } }> } } | null, multipleChoice?: { __typename?: 'EvaluationMultipleChoiceItem', title: LocalizedString } | null, finalScore?: { __typename?: 'EvaluationFinalScoreItem', title?: LocalizedString | null, calculationMethod: EvaluationFinalScoreCalculationMethod, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, displayLevelSet?: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } | null } | null, reviewGoals?: { __typename?: 'EvaluationReviewGoalsItem', defaultExplanation?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } | null, signature?: { __typename?: 'EvaluationSignatureItem', title?: LocalizedString | null } | null, setGoals?: { __typename?: 'EvaluationSetGoalsItem', title: LocalizedString } | null }> }> }, goals?: Array<{ __typename?: 'EvaluationSubmissionGoal', title: LocalizedString, dueDate?: any | null, progress: number, status: GoalStatus, goal: { __typename?: 'Goal', id: string }, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }>, meeting?: { __typename?: 'EvaluationSubmissionMeeting', duration: number, link?: string | null, location?: string | null } | null, moment?: { __typename?: 'MomentInstance', id: string, momentTemplate: { __typename?: 'MomentTemplate', id: string, title: LocalizedString } } | null, overrideScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null, transcription?: { __typename?: 'Transcription', id: string, status: TranscriptionStatus, uploadStatus: TranscriptionUploadStatus, transcript?: string | null, summary?: string | null, editableSummary?: any | null, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null } | null } } };

export type ArchiveUserMutationVariables = Exact<{
  input: ArchiveUserInput;
}>;


export type ArchiveUserMutation = { __typename?: 'Mutation', archiveUser: { __typename?: 'ArchiveUserResponse', user: { __typename?: 'User', id: string, isArchived: boolean } } };

export type AssociateTotpTokenMutationVariables = Exact<{
  input: AssociateTotpTokenInput;
}>;


export type AssociateTotpTokenMutation = { __typename?: 'Mutation', associateTotpToken: { __typename?: 'AssociateTotpTokenResponse', secretCode: string, session?: string | null } };

export type ChangeLearningEventCoverMutationVariables = Exact<{
  input: ChangeLearningEventCoverInput;
}>;


export type ChangeLearningEventCoverMutation = { __typename?: 'Mutation', changeLearningEventCover: { __typename?: 'ChangeLearningEventCoverResponse', learningEvent: { __typename?: 'LearningEvent', id: string, cover?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } } };

export type CreateEvaluationSubmissionMutationVariables = Exact<{
  input: CreateEvaluationSubmissionInput;
}>;


export type CreateEvaluationSubmissionMutation = { __typename?: 'Mutation', createEvaluationSubmission: { __typename?: 'CreateEvaluationSubmissionResponse', evaluationSubmission: { __typename?: 'EvaluationSubmission', id: string } } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'CreateUserResponse', user: { __typename?: 'User', id: string } } };

export type CreateUserDocumentMutationVariables = Exact<{
  input: CreateUserDocumentV2Input;
}>;


export type CreateUserDocumentMutation = { __typename?: 'Mutation', createUserDocumentV2: { __typename?: 'CreateUserDocumentV2Response', documentID: string, uploadUrl: string, uploadHeaders: Array<{ __typename?: 'UserDocumentUploadHeader', name: string, values: Array<string> }> } };

export type CreateUserDocumentDownloadUrlMutationVariables = Exact<{
  input: CreateUserDocumentV2DownloadUrlInput;
}>;


export type CreateUserDocumentDownloadUrlMutation = { __typename?: 'Mutation', createUserDocumentV2DownloadURL: { __typename?: 'CreateUserDocumentV2DownloadURLResponse', url: string } };

export type DeleteUserDocumentMutationVariables = Exact<{
  input: DeleteUserDocumentV2Input;
}>;


export type DeleteUserDocumentMutation = { __typename?: 'Mutation', deleteUserDocumentV2: { __typename?: 'DeleteUserDocumentV2Response', deleted: boolean } };

export type DeleteUserDownloadMutationVariables = Exact<{
  input: DeleteUserDownloadInput;
}>;


export type DeleteUserDownloadMutation = { __typename?: 'Mutation', deleteUserDownload: { __typename?: 'DeleteUserDownloadResponse', user: { __typename?: 'User', id: string, downloads: Array<{ __typename?: 'UserDownload', id: string, downloadLink?: string | null, name: string, progress: number, failedReason?: string | null, status: UserDownloadStatus, viewerCanDelete: boolean }> } } };

export type DisableMfaMethodMutationVariables = Exact<{
  input: DisableMfaMethodInput;
}>;


export type DisableMfaMethodMutation = { __typename?: 'Mutation', disableMfaMethod: { __typename?: 'DisableMfaMethodResponse', mfaUserConfiguration?: { __typename?: 'MfaUserConfiguration', id: string, enabled: boolean, enabledMethods?: Array<MfaMethod> | null, preferredMethod?: MfaMethod | null } | null } };

export type ExportUserDataMutationVariables = Exact<{
  input: ExportUserDataInput;
}>;


export type ExportUserDataMutation = { __typename?: 'Mutation', exportUserData: { __typename?: 'ExportUserDataResponse', download: { __typename?: 'UserDownload', id: string } } };

export type FinalizeUserDocumentUploadMutationVariables = Exact<{
  input: FinalizeUserDocumentV2UploadInput;
}>;


export type FinalizeUserDocumentUploadMutation = { __typename?: 'Mutation', finalizeUserDocumentV2Upload: { __typename?: 'FinalizeUserDocumentV2UploadResponse', documentID: string } };

export type MarkEvaluationSubmissionSharedMutationVariables = Exact<{
  input: MarkEvaluationSubmissionSharedInput;
}>;


export type MarkEvaluationSubmissionSharedMutation = { __typename?: 'Mutation', markEvaluationSubmissionShared: { __typename?: 'MarkEvaluationSubmissionSharedResponse', evaluationSubmission: { __typename?: 'EvaluationSubmission', id: string, deadline: any, overrideReason?: string | null, viewerCanChangeConversationPartner: boolean, viewerCanDiscardAnswersFromPredecessor: boolean, viewerCanOverrideScore: boolean, isArchived: boolean, aiInsightsApproved: boolean, employee: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, manager: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, viewer: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString, description?: LocalizedAttributedString | null, sections: Array<{ __typename?: 'EvaluationFormSection', items: Array<{ __typename?: 'EvaluationSectionItem', id: string, type: EvaluationSectionItemType, fillInBy: EvaluationFillInBy, optional?: boolean | null, title?: { __typename?: 'EvaluationTitleItem', text: LocalizedString } | null, paragraph?: { __typename?: 'EvaluationParagraphItem', text: LocalizedAttributedString } | null, stars?: { __typename?: 'EvaluationStarsItem', title: LocalizedString } | null, openQuestion?: { __typename?: 'EvaluationOpenQuestionItem', title: LocalizedString } | null, developmentPlan?: { __typename?: 'EvaluationDevelopmentPlanItem', title: LocalizedString } | null, sentiment?: { __typename?: 'EvaluationSentimentItem', title: LocalizedString, displayMethod: EvaluationSentimentDisplayMethod } | null, competency?: { __typename?: 'EvaluationCompetencyItem', weight: number, competency: { __typename?: 'Competency', title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', title: LocalizedString } }> } } | null, multipleChoice?: { __typename?: 'EvaluationMultipleChoiceItem', title: LocalizedString } | null, finalScore?: { __typename?: 'EvaluationFinalScoreItem', title?: LocalizedString | null, calculationMethod: EvaluationFinalScoreCalculationMethod, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, displayLevelSet?: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } | null } | null, reviewGoals?: { __typename?: 'EvaluationReviewGoalsItem', defaultExplanation?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } | null, signature?: { __typename?: 'EvaluationSignatureItem', title?: LocalizedString | null } | null, setGoals?: { __typename?: 'EvaluationSetGoalsItem', title: LocalizedString } | null }> }> }, goals?: Array<{ __typename?: 'EvaluationSubmissionGoal', title: LocalizedString, dueDate?: any | null, progress: number, status: GoalStatus, goal: { __typename?: 'Goal', id: string }, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }>, meeting?: { __typename?: 'EvaluationSubmissionMeeting', duration: number, link?: string | null, location?: string | null } | null, moment?: { __typename?: 'MomentInstance', id: string, momentTemplate: { __typename?: 'MomentTemplate', id: string, title: LocalizedString } } | null, overrideScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null, transcription?: { __typename?: 'Transcription', id: string, status: TranscriptionStatus, uploadStatus: TranscriptionUploadStatus, transcript?: string | null, summary?: string | null, editableSummary?: any | null, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null } | null } } };

export type ObfuscateUserMutationVariables = Exact<{
  input: ObfuscateUserInput;
}>;


export type ObfuscateUserMutation = { __typename?: 'Mutation', obfuscateUser: { __typename?: 'ObfuscateUserResponse', user: { __typename?: 'User', id: string } } };

export type OverrideEvaluationSubmissionScoreMutationVariables = Exact<{
  input: OverrideEvaluationSubmissionScoreInput;
}>;


export type OverrideEvaluationSubmissionScoreMutation = { __typename?: 'Mutation', overrideEvaluationSubmissionScore: { __typename?: 'OverrideEvaluationSubmissionScoreResponse', evaluationSubmission: { __typename?: 'EvaluationSubmission', id: string, overrideReason?: string | null, overrideScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null } } };

export type RequestEvaluationSubmissionMutationVariables = Exact<{
  input: RequestEvaluationSubmissionInput;
}>;


export type RequestEvaluationSubmissionMutation = { __typename?: 'Mutation', requestEvaluationSubmission: { __typename?: 'RequestEvaluationSubmissionResponse', evaluationSubmission: { __typename?: 'EvaluationSubmission', id: string } } };

export type RescheduleEvaluationSubmissionMutationVariables = Exact<{
  input: RescheduleEvaluationSubmissionInput;
}>;


export type RescheduleEvaluationSubmissionMutation = { __typename?: 'Mutation', rescheduleEvaluationSubmission: { __typename?: 'RescheduleEvaluationSubmissionResponse', evaluationSubmission: { __typename?: 'EvaluationSubmission', id: string, deadline: any, meeting?: { __typename?: 'EvaluationSubmissionMeeting', duration: number, link?: string | null, location?: string | null } | null } } };

export type RestoreEvaluationSubmissionMutationVariables = Exact<{
  input: RestoreEvaluationSubmissionInput;
}>;


export type RestoreEvaluationSubmissionMutation = { __typename?: 'Mutation', restoreEvaluationSubmission: { __typename?: 'RestoreEvaluationSubmissionResponse', evaluationSubmission: { __typename?: 'EvaluationSubmission', id: string, deadline: any, overrideReason?: string | null, viewerCanChangeConversationPartner: boolean, viewerCanDiscardAnswersFromPredecessor: boolean, viewerCanOverrideScore: boolean, isArchived: boolean, aiInsightsApproved: boolean, employee: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, manager: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, viewer: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString, description?: LocalizedAttributedString | null, sections: Array<{ __typename?: 'EvaluationFormSection', items: Array<{ __typename?: 'EvaluationSectionItem', id: string, type: EvaluationSectionItemType, fillInBy: EvaluationFillInBy, optional?: boolean | null, title?: { __typename?: 'EvaluationTitleItem', text: LocalizedString } | null, paragraph?: { __typename?: 'EvaluationParagraphItem', text: LocalizedAttributedString } | null, stars?: { __typename?: 'EvaluationStarsItem', title: LocalizedString } | null, openQuestion?: { __typename?: 'EvaluationOpenQuestionItem', title: LocalizedString } | null, developmentPlan?: { __typename?: 'EvaluationDevelopmentPlanItem', title: LocalizedString } | null, sentiment?: { __typename?: 'EvaluationSentimentItem', title: LocalizedString, displayMethod: EvaluationSentimentDisplayMethod } | null, competency?: { __typename?: 'EvaluationCompetencyItem', weight: number, competency: { __typename?: 'Competency', title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', title: LocalizedString } }> } } | null, multipleChoice?: { __typename?: 'EvaluationMultipleChoiceItem', title: LocalizedString } | null, finalScore?: { __typename?: 'EvaluationFinalScoreItem', title?: LocalizedString | null, calculationMethod: EvaluationFinalScoreCalculationMethod, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, displayLevelSet?: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } | null } | null, reviewGoals?: { __typename?: 'EvaluationReviewGoalsItem', defaultExplanation?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } | null, signature?: { __typename?: 'EvaluationSignatureItem', title?: LocalizedString | null } | null, setGoals?: { __typename?: 'EvaluationSetGoalsItem', title: LocalizedString } | null }> }> }, goals?: Array<{ __typename?: 'EvaluationSubmissionGoal', title: LocalizedString, dueDate?: any | null, progress: number, status: GoalStatus, goal: { __typename?: 'Goal', id: string }, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }>, meeting?: { __typename?: 'EvaluationSubmissionMeeting', duration: number, link?: string | null, location?: string | null } | null, moment?: { __typename?: 'MomentInstance', id: string, momentTemplate: { __typename?: 'MomentTemplate', id: string, title: LocalizedString } } | null, overrideScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null, transcription?: { __typename?: 'Transcription', id: string, status: TranscriptionStatus, uploadStatus: TranscriptionUploadStatus, transcript?: string | null, summary?: string | null, editableSummary?: any | null, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null } | null } } };

export type RestoreUserMutationVariables = Exact<{
  input: RestoreUserInput;
}>;


export type RestoreUserMutation = { __typename?: 'Mutation', restoreUser: { __typename?: 'RestoreUserResponse', user: { __typename?: 'User', id: string, isArchived: boolean } } };

export type RevokeUserRoleMutationVariables = Exact<{
  input: RevokeRoleInput;
}>;


export type RevokeUserRoleMutation = { __typename?: 'Mutation', revokeRole: { __typename?: 'RevokeRoleResponse', user: { __typename?: 'User', id: string } } };

export type SignEvaluationSubmissionMutationVariables = Exact<{
  input: SignEvaluationSubmissionInput;
}>;


export type SignEvaluationSubmissionMutation = { __typename?: 'Mutation', signEvaluationSubmission: { __typename?: 'SignEvaluationSubmissionResponse', evaluationSubmission: { __typename?: 'EvaluationSubmission', id: string, deadline: any, overrideReason?: string | null, viewerCanChangeConversationPartner: boolean, viewerCanDiscardAnswersFromPredecessor: boolean, viewerCanOverrideScore: boolean, isArchived: boolean, aiInsightsApproved: boolean, employee: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, manager: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, viewer: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString, description?: LocalizedAttributedString | null, sections: Array<{ __typename?: 'EvaluationFormSection', items: Array<{ __typename?: 'EvaluationSectionItem', id: string, type: EvaluationSectionItemType, fillInBy: EvaluationFillInBy, optional?: boolean | null, title?: { __typename?: 'EvaluationTitleItem', text: LocalizedString } | null, paragraph?: { __typename?: 'EvaluationParagraphItem', text: LocalizedAttributedString } | null, stars?: { __typename?: 'EvaluationStarsItem', title: LocalizedString } | null, openQuestion?: { __typename?: 'EvaluationOpenQuestionItem', title: LocalizedString } | null, developmentPlan?: { __typename?: 'EvaluationDevelopmentPlanItem', title: LocalizedString } | null, sentiment?: { __typename?: 'EvaluationSentimentItem', title: LocalizedString, displayMethod: EvaluationSentimentDisplayMethod } | null, competency?: { __typename?: 'EvaluationCompetencyItem', weight: number, competency: { __typename?: 'Competency', title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', title: LocalizedString } }> } } | null, multipleChoice?: { __typename?: 'EvaluationMultipleChoiceItem', title: LocalizedString } | null, finalScore?: { __typename?: 'EvaluationFinalScoreItem', title?: LocalizedString | null, calculationMethod: EvaluationFinalScoreCalculationMethod, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, displayLevelSet?: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } | null } | null, reviewGoals?: { __typename?: 'EvaluationReviewGoalsItem', defaultExplanation?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } | null, signature?: { __typename?: 'EvaluationSignatureItem', title?: LocalizedString | null } | null, setGoals?: { __typename?: 'EvaluationSetGoalsItem', title: LocalizedString } | null }> }> }, goals?: Array<{ __typename?: 'EvaluationSubmissionGoal', title: LocalizedString, dueDate?: any | null, progress: number, status: GoalStatus, goal: { __typename?: 'Goal', id: string }, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }>, meeting?: { __typename?: 'EvaluationSubmissionMeeting', duration: number, link?: string | null, location?: string | null } | null, moment?: { __typename?: 'MomentInstance', id: string, momentTemplate: { __typename?: 'MomentTemplate', id: string, title: LocalizedString } } | null, overrideScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null, transcription?: { __typename?: 'Transcription', id: string, status: TranscriptionStatus, uploadStatus: TranscriptionUploadStatus, transcript?: string | null, summary?: string | null, editableSummary?: any | null, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null } | null } } };

export type UnsignEvaluationSubmissionMutationVariables = Exact<{
  input: UnsignEvaluationSubmissionInput;
}>;


export type UnsignEvaluationSubmissionMutation = { __typename?: 'Mutation', unsignEvaluationSubmission: { __typename?: 'UnsignEvaluationSubmissionResponse', evaluationSubmission: { __typename?: 'EvaluationSubmission', id: string, deadline: any, overrideReason?: string | null, viewerCanChangeConversationPartner: boolean, viewerCanDiscardAnswersFromPredecessor: boolean, viewerCanOverrideScore: boolean, isArchived: boolean, aiInsightsApproved: boolean, employee: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, manager: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, viewer: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString, description?: LocalizedAttributedString | null, sections: Array<{ __typename?: 'EvaluationFormSection', items: Array<{ __typename?: 'EvaluationSectionItem', id: string, type: EvaluationSectionItemType, fillInBy: EvaluationFillInBy, optional?: boolean | null, title?: { __typename?: 'EvaluationTitleItem', text: LocalizedString } | null, paragraph?: { __typename?: 'EvaluationParagraphItem', text: LocalizedAttributedString } | null, stars?: { __typename?: 'EvaluationStarsItem', title: LocalizedString } | null, openQuestion?: { __typename?: 'EvaluationOpenQuestionItem', title: LocalizedString } | null, developmentPlan?: { __typename?: 'EvaluationDevelopmentPlanItem', title: LocalizedString } | null, sentiment?: { __typename?: 'EvaluationSentimentItem', title: LocalizedString, displayMethod: EvaluationSentimentDisplayMethod } | null, competency?: { __typename?: 'EvaluationCompetencyItem', weight: number, competency: { __typename?: 'Competency', title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', title: LocalizedString } }> } } | null, multipleChoice?: { __typename?: 'EvaluationMultipleChoiceItem', title: LocalizedString } | null, finalScore?: { __typename?: 'EvaluationFinalScoreItem', title?: LocalizedString | null, calculationMethod: EvaluationFinalScoreCalculationMethod, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, displayLevelSet?: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } | null } | null, reviewGoals?: { __typename?: 'EvaluationReviewGoalsItem', defaultExplanation?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } | null, signature?: { __typename?: 'EvaluationSignatureItem', title?: LocalizedString | null } | null, setGoals?: { __typename?: 'EvaluationSetGoalsItem', title: LocalizedString } | null }> }> }, goals?: Array<{ __typename?: 'EvaluationSubmissionGoal', title: LocalizedString, dueDate?: any | null, progress: number, status: GoalStatus, goal: { __typename?: 'Goal', id: string }, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }>, meeting?: { __typename?: 'EvaluationSubmissionMeeting', duration: number, link?: string | null, location?: string | null } | null, moment?: { __typename?: 'MomentInstance', id: string, momentTemplate: { __typename?: 'MomentTemplate', id: string, title: LocalizedString } } | null, overrideScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null, transcription?: { __typename?: 'Transcription', id: string, status: TranscriptionStatus, uploadStatus: TranscriptionUploadStatus, transcript?: string | null, summary?: string | null, editableSummary?: any | null, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null } | null } } };

export type UpdateEvaluationSubmissionMutationVariables = Exact<{
  input: UpdateEvaluationSubmissionInput;
}>;


export type UpdateEvaluationSubmissionMutation = { __typename?: 'Mutation', updateEvaluationSubmission: { __typename?: 'UpdateEvaluationSubmissionResponse', evaluationSubmission: { __typename?: 'EvaluationSubmission', id: string, deadline: any, overrideReason?: string | null, viewerCanChangeConversationPartner: boolean, viewerCanDiscardAnswersFromPredecessor: boolean, viewerCanOverrideScore: boolean, isArchived: boolean, aiInsightsApproved: boolean, employee: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, manager: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, viewer: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString, description?: LocalizedAttributedString | null, sections: Array<{ __typename?: 'EvaluationFormSection', items: Array<{ __typename?: 'EvaluationSectionItem', id: string, type: EvaluationSectionItemType, fillInBy: EvaluationFillInBy, optional?: boolean | null, title?: { __typename?: 'EvaluationTitleItem', text: LocalizedString } | null, paragraph?: { __typename?: 'EvaluationParagraphItem', text: LocalizedAttributedString } | null, stars?: { __typename?: 'EvaluationStarsItem', title: LocalizedString } | null, openQuestion?: { __typename?: 'EvaluationOpenQuestionItem', title: LocalizedString } | null, developmentPlan?: { __typename?: 'EvaluationDevelopmentPlanItem', title: LocalizedString } | null, sentiment?: { __typename?: 'EvaluationSentimentItem', title: LocalizedString, displayMethod: EvaluationSentimentDisplayMethod } | null, competency?: { __typename?: 'EvaluationCompetencyItem', weight: number, competency: { __typename?: 'Competency', title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', title: LocalizedString } }> } } | null, multipleChoice?: { __typename?: 'EvaluationMultipleChoiceItem', title: LocalizedString } | null, finalScore?: { __typename?: 'EvaluationFinalScoreItem', title?: LocalizedString | null, calculationMethod: EvaluationFinalScoreCalculationMethod, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, displayLevelSet?: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } | null } | null, reviewGoals?: { __typename?: 'EvaluationReviewGoalsItem', defaultExplanation?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } | null, signature?: { __typename?: 'EvaluationSignatureItem', title?: LocalizedString | null } | null, setGoals?: { __typename?: 'EvaluationSetGoalsItem', title: LocalizedString } | null }> }> }, goals?: Array<{ __typename?: 'EvaluationSubmissionGoal', title: LocalizedString, dueDate?: any | null, progress: number, status: GoalStatus, goal: { __typename?: 'Goal', id: string }, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }>, meeting?: { __typename?: 'EvaluationSubmissionMeeting', duration: number, link?: string | null, location?: string | null } | null, moment?: { __typename?: 'MomentInstance', id: string, momentTemplate: { __typename?: 'MomentTemplate', id: string, title: LocalizedString } } | null, overrideScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null, transcription?: { __typename?: 'Transcription', id: string, status: TranscriptionStatus, uploadStatus: TranscriptionUploadStatus, transcript?: string | null, summary?: string | null, editableSummary?: any | null, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null } | null } } };

export type UpdateInvoiceUserCountMutationVariables = Exact<{
  input: UpdateInvoiceUserCountInput;
}>;


export type UpdateInvoiceUserCountMutation = { __typename?: 'Mutation', updateInvoiceUserCount: { __typename?: 'UpdateInvoiceUserCountResponse', success: boolean } };

export type UpdatePersonalNotificationSettingMutationVariables = Exact<{
  input: UpdateUserNotificationSettingInput;
}>;


export type UpdatePersonalNotificationSettingMutation = { __typename?: 'Mutation', updateUserNotificationSetting: { __typename?: 'UpdateUserNotificationSettingResponse', setting: { __typename?: 'UserNotificationSetting', id: string, type: string, channels: Array<{ __typename?: 'NotificationChannelMap', channel: NotificationChannel, frequency: NotificationFrequency }> } } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserResponse', user: { __typename?: 'User', id: string, firstName: string, lastName: string, activatedAt: any, locale: string, username: string, email: string, externalReferenceID?: string | null, isExternal: boolean, group: { __typename?: 'Group', id: string } } } };

export type UpdateUserActivationDateMutationVariables = Exact<{
  input: UpdateUserActivationDateInput;
}>;


export type UpdateUserActivationDateMutation = { __typename?: 'Mutation', updateUserActivationDate: { __typename?: 'UpdateUserActivationDateResponse', user: { __typename?: 'User', id: string, activatedAt: any } } };

export type UpdateUserAvatarMutationVariables = Exact<{
  input: UpdateUserAvatarInput;
}>;


export type UpdateUserAvatarMutation = { __typename?: 'Mutation', updateUserAvatar: { __typename?: 'UpdateUserAvatarResponse', user: { __typename?: 'User', id: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } } };

export type UpdateUserCoverMutationVariables = Exact<{
  input: UpdateUserCoverInput;
}>;


export type UpdateUserCoverMutation = { __typename?: 'Mutation', updateUserCover: { __typename?: 'UpdateUserCoverResponse', user: { __typename?: 'User', id: string, cover?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } } };

export type UpdateUserLocaleMutationVariables = Exact<{
  input: UpdateUserLocaleInput;
}>;


export type UpdateUserLocaleMutation = { __typename?: 'Mutation', updateUserLocale: { __typename?: 'UpdateUserLocaleResponse', user: { __typename?: 'User', id: string, locale: string } } };

export type UserUpdateMissionMutationVariables = Exact<{
  input: UpdateUserMissionInput;
}>;


export type UserUpdateMissionMutation = { __typename?: 'Mutation', updateUserMission: { __typename?: 'UpdateUserMissionResponse', user: { __typename?: 'User', id: string, mission: string } } };

export type VerifyTotpTokenMutationVariables = Exact<{
  input: VerifyTotpTokenInput;
}>;


export type VerifyTotpTokenMutation = { __typename?: 'Mutation', verifyTotpToken: { __typename?: 'VerifyTotpTokenResponse', success: boolean, session?: string | null, mfaUserConfiguration?: { __typename?: 'MfaUserConfiguration', id: string, enabled: boolean, enabledMethods?: Array<MfaMethod> | null, preferredMethod?: MfaMethod | null } | null } };

export type ConnectorDryRunUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ConnectorDryRunUsersQuery = { __typename?: 'Query', viewer: { __typename?: 'User', workspace: { __typename?: 'Workspace', connector?: { __typename?: 'Connector', id: string, dryRun: { __typename?: 'ConnectorDryRun', users: { __typename?: 'ConnectorDryRunUserConnection', totalCount: number, edges: Array<{ __typename?: 'ConnectorDryRunUserEdge', cursor: string, node: { __typename?: 'ConnectorDryRunUser', firstName: string, lastName: string, email?: string | null, externalReferenceID: string } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } } | null } } };

export type EmployeeEvaluationSubmissionsQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
}>;


export type EmployeeEvaluationSubmissionsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, archivedEvaluationSubmissions: { __typename?: 'EvaluationSubmissionConnection', edges: Array<{ __typename?: 'EvaluationSubmissionEdge', node: { __typename?: 'EvaluationSubmission', id: string, createdOnDateTimeOffsetUtc: any, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString }, employee: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus } } }> }, evaluationSubmissions: { __typename?: 'EvaluationSubmissionConnection', edges: Array<{ __typename?: 'EvaluationSubmissionEdge', node: { __typename?: 'EvaluationSubmission', id: string, createdOnDateTimeOffsetUtc: any, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString }, employee: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus } } }> } } };

export type EmployeeGoalsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  status: GoalStatus;
  before?: InputMaybe<Scalars['ID']['input']>;
  last: Scalars['Int']['input'];
}>;


export type EmployeeGoalsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, goalsV2: { __typename?: 'GoalConnection', totalCount?: number | null, edges: Array<{ __typename?: 'GoalEdge', node: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null }, owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type EmployeeIncomingFeedbackRequestsQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
  isArchived: Scalars['Boolean']['input'];
  before?: InputMaybe<Scalars['ID']['input']>;
  last: Scalars['Int']['input'];
}>;


export type EmployeeIncomingFeedbackRequestsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, viewerCanRequestFeedback: boolean, feedbackRequests: { __typename?: 'FeedbackRequestConnection', edges: Array<{ __typename?: 'FeedbackRequestEdge', node: { __typename?: 'FeedbackRequest', id: string, title: string, createdAt: any, dueDate: any, isArchived: boolean } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } } };

export type EmployeeListExportQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type EmployeeListExportQuery = { __typename?: 'Query', usersByIDs: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, email: string, username: string, lastLoginAt?: any | null, externalReferenceID?: string | null, group: { __typename?: 'Group', id: string, name: string }, workspaceRole?: { __typename?: 'UserRole', id: string, role: { __typename?: 'Role', id: string } } | null }> };

export type EmployeeMomentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EmployeeMomentsQuery = { __typename?: 'Query', user: { __typename?: 'User', moments: Array<{ __typename?: 'MomentInstance', id: string, status: MomentStatus, startDate: any, endDate: any, momentTemplate: { __typename?: 'MomentTemplate', id: string, type: MomentType, title: LocalizedString, description?: LocalizedAttributedString | null } }> } };

export type EmployeeOutgoingFeedbackResponsesQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
  before?: InputMaybe<Scalars['ID']['input']>;
  last: Scalars['Int']['input'];
}>;


export type EmployeeOutgoingFeedbackResponsesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, viewerCanRequestFeedback: boolean, outgoingFeedbackResponses: { __typename?: 'FeedbackResponseConnection', edges: Array<{ __typename?: 'FeedbackResponseEdge', node: { __typename?: 'FeedbackResponse', id: string, title: string, dueDate: any, sharedAt?: any | null, requestor: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } } };

export type EvaluationSubmissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EvaluationSubmissionQuery = { __typename?: 'Query', evaluationSubmission: { __typename?: 'EvaluationSubmission', id: string, deadline: any, overrideReason?: string | null, viewerCanChangeConversationPartner: boolean, viewerCanDiscardAnswersFromPredecessor: boolean, viewerCanOverrideScore: boolean, isArchived: boolean, aiInsightsApproved: boolean, employee: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, manager: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, viewer: { __typename?: 'EvaluationSubmissionResult', party: EvaluationSubmissionParty, status: EvaluationSubmissionStatus, requiresInput: boolean, hasSigned?: boolean | null, signedAt?: any | null, hasShared: boolean, requiresSignature: boolean, viewerCanViewAnswers: boolean, viewerCanArchive: boolean, viewerCanUpdate: boolean, viewerCanShare: boolean, viewerCanSign: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, viewerCanViewGoals: boolean, viewerCanViewDevelopmentPlan: boolean, viewerCanViewFeedback: boolean, viewerCanViewEvaluations: boolean, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } }> }, sections: Array<{ __typename?: 'EvaluationSubmissionSection', score?: number | null, items: Array<{ __typename?: 'EvaluationSubmissionItem', type: EvaluationSectionItemType, stars?: number | null, openQuestion?: any | null, sentiment?: number | null, multipleChoice?: Array<number | null> | null, competency?: number | null, viewerCanView?: boolean | null, reviewGoals?: Array<{ __typename?: 'EvaluationSubmissionItemReviewGoal', goalID: string, competency?: number | null, text: any }> | null } | null> }>, finalScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null }, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString, description?: LocalizedAttributedString | null, sections: Array<{ __typename?: 'EvaluationFormSection', items: Array<{ __typename?: 'EvaluationSectionItem', id: string, type: EvaluationSectionItemType, fillInBy: EvaluationFillInBy, optional?: boolean | null, title?: { __typename?: 'EvaluationTitleItem', text: LocalizedString } | null, paragraph?: { __typename?: 'EvaluationParagraphItem', text: LocalizedAttributedString } | null, stars?: { __typename?: 'EvaluationStarsItem', title: LocalizedString } | null, openQuestion?: { __typename?: 'EvaluationOpenQuestionItem', title: LocalizedString } | null, developmentPlan?: { __typename?: 'EvaluationDevelopmentPlanItem', title: LocalizedString } | null, sentiment?: { __typename?: 'EvaluationSentimentItem', title: LocalizedString, displayMethod: EvaluationSentimentDisplayMethod } | null, competency?: { __typename?: 'EvaluationCompetencyItem', weight: number, competency: { __typename?: 'Competency', title: LocalizedString, description?: LocalizedAttributedString | null, styrSkillID?: string | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', title: LocalizedString } }> } } | null, multipleChoice?: { __typename?: 'EvaluationMultipleChoiceItem', title: LocalizedString } | null, finalScore?: { __typename?: 'EvaluationFinalScoreItem', title?: LocalizedString | null, calculationMethod: EvaluationFinalScoreCalculationMethod, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> }, displayLevelSet?: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } | null } | null, reviewGoals?: { __typename?: 'EvaluationReviewGoalsItem', defaultExplanation?: LocalizedAttributedString | null, competencyLevelSet: { __typename?: 'CompetencyLevelSet', levels: Array<{ __typename?: 'CompetencyLevel', id: string, title: LocalizedString }> } } | null, signature?: { __typename?: 'EvaluationSignatureItem', title?: LocalizedString | null } | null, setGoals?: { __typename?: 'EvaluationSetGoalsItem', title: LocalizedString } | null }> }> }, goals?: Array<{ __typename?: 'EvaluationSubmissionGoal', title: LocalizedString, dueDate?: any | null, progress: number, status: GoalStatus, goal: { __typename?: 'Goal', id: string }, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null }> | null, comments: Array<{ __typename?: 'Comment', id: string, content?: any | null, targetID: string, targetType: CommentTargetType, createdAt: any, viewerCanArchive: boolean, viewerCanUpdate: boolean, isArchived: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, metadata?: Array<{ __typename?: 'CommentMetadata', key: string, value: string }> | null }>, meeting?: { __typename?: 'EvaluationSubmissionMeeting', duration: number, link?: string | null, location?: string | null } | null, moment?: { __typename?: 'MomentInstance', id: string, momentTemplate: { __typename?: 'MomentTemplate', id: string, title: LocalizedString } } | null, overrideScore?: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } | null, transcription?: { __typename?: 'Transcription', id: string, status: TranscriptionStatus, uploadStatus: TranscriptionUploadStatus, transcript?: string | null, summary?: string | null, editableSummary?: any | null, audioUrl?: string | null, createdAt: any, speakers?: Array<{ __typename?: 'TranscriptionSpeaker', speakerNumber: number, segmentIndex?: number | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string } }> | null, followups?: { __typename?: 'TranscriptionFollowups', goalSuggestions: Array<{ __typename?: 'TranscriptionFollowupGoalSuggestion', id: string, title: string, description: any, subgoals?: Array<string> | null, actedUpon: boolean, targetUser: { __typename?: 'User', id: string, firstName: string } }>, feedbackRequestSuggestions: Array<{ __typename?: 'TranscriptionFollowupFeedbackRequestSuggestion', id: string, title: string, instruction?: any | null, actedUpon: boolean, template?: { __typename?: 'FeedbackTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, instruction: LocalizedAttributedString, roles: Array<FeedbackTemplateRole>, questions: Array<{ __typename?: 'FeedbackTemplateQuestion', instruction: LocalizedAttributedString, canSubjectView: boolean, question: { __typename?: 'FeedbackQuestion', id: string, text: LocalizedString, subTitle: LocalizedString, additionalDetails: LocalizedAttributedString, type: FeedbackQuestionType, options: Array<{ __typename?: 'FeedbackQuestionOption', id: string, text: LocalizedString }>, category: { __typename?: 'FeedbackQuestionCategory', id: string, name: LocalizedString } } }> } | null }> } | null } | null } };

export type EvaluationSubmissionsQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
  isArchived: Scalars['Boolean']['input'];
  before?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EvaluationSubmissionsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, evaluationSubmissions: { __typename?: 'EvaluationSubmissionConnection', edges: Array<{ __typename?: 'EvaluationSubmissionEdge', node: { __typename?: 'EvaluationSubmission', id: string, createdAt: any, deadline: any, isArchived: boolean, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString }, manager: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus, requiresInput: boolean, requiresSignature: boolean, party: EvaluationSubmissionParty, isCompleted: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }, employee: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus, requiresInput: boolean, party: EvaluationSubmissionParty, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } } };

export type EvaluationSubmissionsForJourneyQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
}>;


export type EvaluationSubmissionsForJourneyQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, evaluationSubmissions: { __typename?: 'EvaluationSubmissionConnection', edges: Array<{ __typename?: 'EvaluationSubmissionEdge', node: { __typename?: 'EvaluationSubmission', id: string, createdOnDateTimeOffsetUtc: any, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString }, employee: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus } } }> } } };

export type EvaluationSubmissionsFutureForecastQueryVariables = Exact<{
  isArchived: Scalars['Boolean']['input'];
  after?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type EvaluationSubmissionsFutureForecastQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, outgoingEvaluationSubmissions: { __typename?: 'EvaluationSubmissionConnection', edges: Array<{ __typename?: 'EvaluationSubmissionEdge', node: { __typename?: 'EvaluationSubmission', id: string, createdAt: any, deadline: any, isArchived: boolean, manager: { __typename?: 'EvaluationSubmissionResult', hasShared: boolean, status: EvaluationSubmissionStatus, requiresInput: boolean, requiresSignature: boolean, party: EvaluationSubmissionParty, isCompleted: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }, employee: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus, requiresInput: boolean, party: EvaluationSubmissionParty, user: { __typename?: 'User', id: string, firstName: string, lastName: string, currentJobPosition?: { __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString } } | null, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } }, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString } } }> }, managees: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, currentJobPosition?: { __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString } } | null, moments: Array<{ __typename?: 'MomentInstance', id: string, endDate: any, momentTemplate: { __typename?: 'MomentTemplate', id: string, evaluation?: { __typename?: 'MomentEvaluation', evaluationForm?: { __typename?: 'EvaluationForm', id: string, title: LocalizedString } | null } | null } }> }> } };

export type ExportUsersQueryVariables = Exact<{
  input: ExportUsersInput;
}>;


export type ExportUsersQuery = { __typename?: 'Query', exportUsers: { __typename?: 'ExportResponse', url: string } };

export type FeedbackSharedWithUserQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
}>;


export type FeedbackSharedWithUserQuery = { __typename?: 'Query', user: { __typename?: 'User', sharedFeedback: { __typename?: 'SharedFeedbackConnection', edges: Array<{ __typename?: 'SharedFeedbackEdge', node: { __typename?: 'SharedFeedback', createdAt: any, request: { __typename?: 'FeedbackRequest', id: string, title: string, createdAt: any }, sharedBy: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } } }> } } };

export type InboxPersonalInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type InboxPersonalInformationQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, firstName: string, lastName: string, mission: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null, currentJobPosition?: { __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null } } | null } };

export type ManagerEmployeeConversationsQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
  isArchived: Scalars['Boolean']['input'];
  before?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ManagerEmployeeConversationsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, evaluationSubmissions: { __typename?: 'EvaluationSubmissionConnection', edges: Array<{ __typename?: 'EvaluationSubmissionEdge', node: { __typename?: 'EvaluationSubmission', id: string, createdAt: any, deadline: any, isArchived: boolean, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString }, manager: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus, requiresInput: boolean, requiresSignature: boolean, party: EvaluationSubmissionParty, isCompleted: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }, employee: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus, requiresInput: boolean, party: EvaluationSubmissionParty, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } } };

export type ManagerEmployeeFeedbackRequestsQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
  isArchived: Scalars['Boolean']['input'];
  before?: InputMaybe<Scalars['ID']['input']>;
  last: Scalars['Int']['input'];
}>;


export type ManagerEmployeeFeedbackRequestsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, viewerCanRequestFeedback: boolean, feedbackRequests: { __typename?: 'FeedbackRequestConnection', edges: Array<{ __typename?: 'FeedbackRequestEdge', node: { __typename?: 'FeedbackRequest', id: string, title: string, createdAt: any, dueDate: any, isArchived: boolean, mode: FeedbackMode, instruction?: any | null, responses: { __typename?: 'FeedbackResponseConnection', edges: Array<{ __typename?: 'FeedbackResponseEdge', node: { __typename?: 'FeedbackResponse', id: string, status: FeedbackResponseStatus, recipient: { __typename?: 'FeedbackExternal', firstName: string, lastName: string } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } } }> } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } } };

export type ManagerEmployeeGoalsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  status: GoalStatus;
  before?: InputMaybe<Scalars['ID']['input']>;
  last: Scalars['Int']['input'];
}>;


export type ManagerEmployeeGoalsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, goalsV2: { __typename?: 'GoalConnection', totalCount?: number | null, edges: Array<{ __typename?: 'GoalEdge', node: { __typename?: 'Goal', id: string, ownerType: GoalOwnerType, title: LocalizedString, description: any, order: number, createdAt: any, dueDate?: any | null, progress: number, status: GoalStatus, feasibility?: GoalFeasibility | null, completedAt?: any | null, isArchived: boolean, viewerCanViewChildren: boolean, linkedGoalDrivers: Array<{ __typename?: 'GoalDriver', id: string, title: LocalizedString }>, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null, isArchived: boolean } | null, checklistItems: Array<{ __typename?: 'GoalChecklistItem', id: string, title: LocalizedString, description: LocalizedAttributedString, dueDate?: any | null, createdAt: any, updatedAt?: any | null, completedAt?: any | null, progress: { __typename?: 'GoalChecklistItemProgress', type: GoalChecklistItemType, value: number, upper?: number | null, lower?: number | null }, learningCourse?: { __typename?: 'LearningCourse', id: string, provider: LearningCourseProvider } | null, createdBy: { __typename?: 'User', id: string }, updatedBy?: { __typename?: 'User', id: string } | null, completedBy?: { __typename?: 'User', id: string } | null }>, completedBy?: { __typename?: 'User', id: string } | null, children: { __typename?: 'GoalConnection', totalCount?: number | null }, owner: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | { __typename?: 'Workspace', id: string } } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type MigrationEmployeesQueryVariables = Exact<{
  status?: InputMaybe<UserStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MigrationEmployeesQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, username: string, locale: string, externalReferenceID?: string | null, group: { __typename?: 'Group', id: string } } }> } };

export type OrganizationEmployeesQueryVariables = Exact<{
  status?: InputMaybe<UserStatus>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrganizationEmployeesQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', cursor: string, node: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, username: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type OutgoingEvaluationSubmissionsQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
  isArchived: Scalars['Boolean']['input'];
  before?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OutgoingEvaluationSubmissionsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, outgoingEvaluationSubmissions: { __typename?: 'EvaluationSubmissionConnection', edges: Array<{ __typename?: 'EvaluationSubmissionEdge', node: { __typename?: 'EvaluationSubmission', id: string, createdAt: any, deadline: any, isArchived: boolean, evaluationForm: { __typename?: 'EvaluationSubmissionForm', title: LocalizedString }, manager: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus, requiresInput: boolean, requiresSignature: boolean, party: EvaluationSubmissionParty, isCompleted: boolean, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } }, employee: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus, requiresInput: boolean, party: EvaluationSubmissionParty, user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } } } }>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean } } } };

export type PersonalNotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonalNotificationSettingsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, notificationSettings: Array<{ __typename?: 'UserNotificationSetting', id: string, type: string, channels: Array<{ __typename?: 'NotificationChannelMap', channel: NotificationChannel, frequency: NotificationFrequency }> }> } };

export type UserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, normalizedName: string, username: string, email: string, mission: string, locale: string, activatedAt: any, archivedAt?: any | null, lastLoginAt?: any | null, isArchived: boolean, isExternal: boolean, externalReferenceID?: string | null, createdAt: any, updatedAt?: any | null, isViewer: boolean, isEmailSuppressed: boolean, viewerCanCreateDocuments: boolean, viewerCanRequestFeedback: boolean, viewerCanUpdate: boolean, viewerCanViewDocuments: boolean, viewerCanViewEvaluations: boolean, viewerCanViewFeedback: boolean, viewerCanViewGoals: boolean, viewerCanCreateGoal: boolean, viewerCanViewJourney: boolean, conversationAiInsightsApproved: boolean, localDeactivatedAt?: string | null, group: { __typename?: 'Group', id: string, name: string }, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, cover?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, associatedIdentities: Array<{ __typename?: 'AssociatedIdentity', name: string, identityProvider: { __typename?: 'IdentityProvider', id: string } }>, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString }, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString } | null }>, currentJobPosition?: { __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString } } | null, roles: Array<{ __typename?: 'UserRole', id: string, role: { __typename?: 'Role', id: string, type: RoleType } }> } };

export type UserCompetenciesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserCompetenciesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, jobPositions: Array<{ __typename?: 'JobPosition', id: string, startDate?: any | null, endDate?: any | null, externalReferenceID?: string | null, jobLevel?: { __typename?: 'JobLevel', id: string } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, description?: LocalizedAttributedString | null }, appraisal: Array<{ __typename?: 'CompetencyAppraisal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string } }>, competencies: Array<{ __typename?: 'JobCompetency', id: string, competencyLevel: number, order?: number | null, competency: { __typename?: 'Competency', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, label?: { __typename?: 'Label', id: string, title: LocalizedString } | null, levels: Array<{ __typename?: 'CompetencyLevelOption', enabled: boolean, criteria?: LocalizedAttributedString | null, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } }> }> } };

export type UserComplimentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UserComplimentsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, compliments: { __typename?: 'ComplimentConnection', edges: Array<{ __typename?: 'ComplimentEdge', node: { __typename?: 'Compliment', id: string, text: any, createdAt: any, sender: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, recipient: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type UserCycleWithMomentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserCycleWithMomentsQuery = { __typename?: 'Query', cycleInstance: { __typename?: 'CycleInstance', id: string, moments: Array<{ __typename?: 'MomentInstance', status: MomentStatus, momentTemplate: { __typename?: 'MomentTemplate', type: MomentType } }> } };

export type UserCyclesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  status?: InputMaybe<Array<CycleStatus> | CycleStatus>;
}>;


export type UserCyclesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, cycles: { __typename?: 'CycleInstanceConnection', edges: Array<{ __typename?: 'CycleInstanceEdge', node: { __typename?: 'CycleInstance', id: string, startDate: any, activatesAt: any, deactivatesAt?: any | null, status: CycleStatus, createdAt: any, cycleTemplate: { __typename?: 'CycleTemplate', id: string, title: LocalizedString }, createdByUser: { __typename?: 'User', id: string, firstName: string, lastName: string } } }> } } };

export type UserDocumentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserDocumentsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, documentsV2: Array<{ __typename?: 'UserDocumentV2', id: string, name: string, createdAt: any, viewerCanDelete: boolean, status: UserDocumentV2Status, createdBy: { __typename?: 'User', id: string, firstName: string, lastName: string } }> } };

export type UserDownloadsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserDownloadsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, downloads: Array<{ __typename?: 'UserDownload', id: string, downloadLink?: string | null, name: string, progress: number, failedReason?: string | null, status: UserDownloadStatus, viewerCanDelete: boolean }> } };

export type UserGivenComplimentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UserGivenComplimentsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, givenCompliments: { __typename?: 'ComplimentConnection', edges: Array<{ __typename?: 'ComplimentEdge', node: { __typename?: 'Compliment', id: string, text: any, createdAt: any, sender: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null }, recipient: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', source: { __typename?: 'AssetVariant', url: string } } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type UserGoalTemplatesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserGoalTemplatesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, jobPositions: Array<{ __typename?: 'JobPosition', id: string, jobLevel?: { __typename?: 'JobLevel', id: string, title: LocalizedString } | null, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString, goalTemplates: { __typename?: 'GoalTemplateConnection', edges: Array<{ __typename?: 'GoalTemplateEdge', cursor: string, node: { __typename?: 'GoalTemplate', id: string, title: LocalizedString, description: LocalizedAttributedString, isArchived: boolean, competency?: { __typename?: 'CompetencyGoal', competencyLevelIndex: number, competency: { __typename?: 'Competency', id: string, title: LocalizedString, levels: Array<{ __typename?: 'CompetencyLevelOption', criteria?: LocalizedAttributedString | null, enabled: boolean, level: { __typename?: 'CompetencyLevel', id: string, title: LocalizedString } }> } } | null, label?: { __typename?: 'Label', id: string, title: LocalizedString, description?: LocalizedString | null } | null, jobTitles: Array<{ __typename?: 'JobTitle', id: string, title: LocalizedString }> } }> } } }> } };

export type UserGroupsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserGroupsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, groups: Array<{ __typename?: 'Group', id: string, name: string, type: GroupType, isArchived: boolean, parent?: { __typename?: 'Group', id: string } | null }> } };

export type UserManagersManageesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserManagersManageesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null, currentJobPosition?: { __typename?: 'JobPosition', id: string, jobTitle: { __typename?: 'JobTitle', id: string, title: LocalizedString } } | null, individualManagers: Array<{ __typename?: 'UserRole', id: string, externalReferenceID?: string | null, role: { __typename?: 'Role', id: string, type: RoleType }, source: { __typename?: 'User', id: string, firstName: string, lastName: string } }>, group: { __typename?: 'Group', id: string, managers: { __typename?: 'GroupManagerConnection', edges: Array<{ __typename?: 'GroupManagerEdge', role: { __typename?: 'Role', id: string, type: RoleType, externalReferenceID?: string | null }, node: { __typename?: 'User', id: string, firstName: string, lastName: string } }> } }, roles: Array<{ __typename?: 'UserRole', id: string, externalReferenceID?: string | null, isIndirect: boolean, role: { __typename?: 'Role', id: string, type: RoleType }, targetV2?: { __typename?: 'Group', id: string, name: string, type: GroupType } | { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> } };

export type UserMfaConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMfaConfigurationQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, userMfaConfiguration: { __typename?: 'MfaUserConfiguration', id: string, enabled: boolean, enabledMethods?: Array<MfaMethod> | null, preferredMethod?: MfaMethod | null }, workspace: { __typename?: 'Workspace', workspaceMfaSettings: { __typename?: 'WorkspaceMfaSettings', id: string, status: WorkspaceMfaStatus, allowedMethods: Array<MfaMethod> } } } };

export type UserRolesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UserRolesQuery = { __typename?: 'Query', userRoles: { __typename?: 'UserRoleConnection', edges: Array<{ __typename?: 'UserRoleEdge', node: { __typename?: 'UserRole', id: string, isIndirect: boolean, externalReferenceID?: string | null, role: { __typename?: 'Role', id: string, type: RoleType }, source: { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null }, target: { __typename?: 'RoleTarget', targetID: string, type: RoleTargetType }, targetV2?: { __typename?: 'Group', id: string, name: string } | { __typename?: 'User', id: string, firstName: string, lastName: string, avatar?: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } };

export type UserWithCyclesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  status?: InputMaybe<Array<CycleStatus> | CycleStatus>;
}>;


export type UserWithCyclesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, cycles: { __typename?: 'CycleInstanceConnection', edges: Array<{ __typename?: 'CycleInstanceEdge', node: { __typename?: 'CycleInstance', id: string, startDate: any, activatesAt: any, deactivatesAt?: any | null, cycleTemplate: { __typename?: 'CycleTemplate', id: string, title: LocalizedString, repeats: boolean, duration: number, successor?: { __typename?: 'CycleTemplate', id: string } | null, moments: Array<{ __typename?: 'MomentTemplate', id: string, title: LocalizedString, startOffset: number, type: MomentType, duration: number, showToUser: boolean }> }, precededBy?: { __typename?: 'CycleInstance', id: string } | null, succeededBy?: { __typename?: 'CycleInstance', id: string } | null, skippedFutureMoments: Array<{ __typename?: 'CycleInstanceSkippedMoment', momentTemplateID: string, skipReason: MomentSkipReason, skipReasonOther?: string | null }> } }> } } };

export type UserWithMomentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type UserWithMomentsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, moments: Array<{ __typename?: 'MomentInstance', id: string, status: MomentStatus, startDate: any, endDate: any, skipReason?: MomentSkipReason | null, skipReasonOther?: string | null, user: { __typename?: 'User', id: string }, cycleInstance: { __typename?: 'CycleInstance', id: string }, cycleTemplate: { __typename?: 'CycleTemplate', id: string, title: LocalizedString }, momentTemplate: { __typename?: 'MomentTemplate', id: string, title: LocalizedString, description?: LocalizedAttributedString | null, type: MomentType, duration: number, showToUser: boolean, original?: { __typename?: 'MomentTemplate', id: string } | null, talentReview?: { __typename?: 'MomentTalentReview', template?: { __typename?: 'TalentReviewTemplate', id: string } | null, group?: { __typename?: 'Group', id: string } | null } | null }, evaluation?: { __typename?: 'EvaluationSubmission', id: string, viewer: { __typename?: 'EvaluationSubmissionResult', status: EvaluationSubmissionStatus, requiresSignature: boolean } } | null }> } };

export type UserWithRolesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserWithRolesQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', id: string, isIndirect: boolean, role: { __typename?: 'Role', id: string, type: RoleType }, target: { __typename?: 'RoleTarget', type: RoleTargetType, targetID: string }, targetV2?: { __typename?: 'Group', id: string, name: string } | { __typename?: 'User', id: string, firstName: string, lastName: string } | null }> } };

export type UserWithSentEmailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UserWithSentEmailsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, sentEmails: { __typename?: 'SentEmailConnection', edges: Array<{ __typename?: 'SentEmailEdge', cursor: string, node: { __typename?: 'SentEmail', id: string, recipientName: string, recipientEmail: string, subject: string, sentAt: any } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type ViewerRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerRolesQuery = { __typename?: 'Query', viewer: { __typename?: 'User', id: string, roles: Array<{ __typename?: 'UserRole', target: { __typename?: 'RoleTarget', targetID: string, type: RoleTargetType }, targetV2?: { __typename?: 'Group', id: string, type: GroupType } | { __typename?: 'User', id: string } | null, role: { __typename?: 'Role', id: string, type: RoleType } }> } };

export type WorkspaceUserCountQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspaceUserCountQuery = { __typename?: 'Query', workspaceUserCount: number };

export type VoiceMemoFragment = { __typename?: 'VoiceMemo', samples: Array<number>, sampleRate: number, asset: { __typename?: 'Asset', id: string, source: { __typename?: 'AssetVariant', url: string } } };

export type CompleteWorkspaceCheckpointMutationVariables = Exact<{
  input: CompleteWorkspaceCheckpointInput;
}>;


export type CompleteWorkspaceCheckpointMutation = { __typename?: 'Mutation', completeWorkspaceCheckpoint: { __typename?: 'CompleteWorkspaceCheckpointResponse', workspace: { __typename?: 'Workspace', id: string, checkpoints?: Array<{ __typename?: 'Checkpoint', id: string, key: string, completedAt?: any | null } | null> | null } } };

export type FeaturesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FeaturesQuery = { __typename?: 'Query', workspace: { __typename?: 'Workspace', id: string, displayName?: string | null, features: Array<{ __typename?: 'WorkspaceFeature', id: string, status: WorkspaceFeatureStatus, inPlan: boolean, needsViewerApproval: boolean, feature: { __typename?: 'Feature', id: FeatureName, stability: FeatureStability }, requiredConditions?: { __typename?: 'FeatureConditions', currentVersion: string, linkToConditions: string } | null }> } };

export type SupportedLanguageIDsQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportedLanguageIDsQuery = { __typename?: 'Query', viewer: { __typename?: 'User', workspace: { __typename?: 'Workspace', supportedLanguageIDs: Array<string> } } };

export type SupportedLanguagesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SupportedLanguagesQuery = { __typename?: 'Query', workspace: { __typename?: 'Workspace', id: string, supportedLanguageIDs: Array<string> } };

export type WorkspaceConfigurationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WorkspaceConfigurationQuery = { __typename?: 'Query', workspace: { __typename?: 'Workspace', id: string, redirect?: string | null, startDate?: any | null, supportedLanguageIDs: Array<string>, plans: Array<{ __typename?: 'WorkspacePlanV2', id: string, type: WorkspacePlanType, startDate?: any | null, endDate?: any | null, isTrial: boolean, isExpired: boolean, minimumUserCount: number }> }, singleSignOns: Array<{ __typename?: 'SingleSignOn', url: string }> };

export type NoteTemplateCategoryPartialFragment = { __typename?: 'NoteTemplateCategory', id: string, title: LocalizedString, isArchived: boolean };

export type NoteTemplateCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type NoteTemplateCategoriesQuery = { __typename?: 'Query', noteTemplateCategories: Array<{ __typename?: 'NoteTemplateCategory', id: string, title: LocalizedString, isArchived: boolean } | null> };

export type CreateNoteTemplateCategoryMutationVariables = Exact<{
  input: NoteTemplateCategoryCreateInput;
}>;


export type CreateNoteTemplateCategoryMutation = { __typename?: 'Mutation', createNoteTemplateCategory: { __typename?: 'NoteTemplateCategory', id: string, title: LocalizedString, isArchived: boolean } };

export type ArchiveNoteTemplateCategoryMutationVariables = Exact<{
  input: NoteTemplateCategoryArchiveInput;
}>;


export type ArchiveNoteTemplateCategoryMutation = { __typename?: 'Mutation', archiveNoteTemplateCategory: { __typename?: 'NoteTemplateCategory', id: string } };

export type RestoreNoteTemplateCategoryMutationVariables = Exact<{
  input: NoteTemplateRestoreCategoryInput;
}>;


export type RestoreNoteTemplateCategoryMutation = { __typename?: 'Mutation', restoreNoteTemplateCategory: { __typename?: 'NoteTemplateCategory', id: string, title: LocalizedString, isArchived: boolean } };

export const AgentChatToolCallFragmentDoc = gql`
    fragment AgentChatToolCall on AgentChatToolCall {
  id
  name
  arguments
}
    `;
export const AgentChatMessageFragmentDoc = gql`
    fragment AgentChatMessage on AgentChatMessage {
  id
  role
  content
  toolCallId
  createdAt
  toolCalls {
    ...AgentChatToolCall
  }
}
    ${AgentChatToolCallFragmentDoc}`;
export const AgentChatUsageFragmentDoc = gql`
    fragment AgentChatUsage on AgentChatUsage {
  model
  inputTokens
  cachedInputTokens
  cacheWriteTokens
  outputTokens
}
    `;
export const AnnouncementFragmentFragmentDoc = gql`
    fragment AnnouncementFragment on Announcement {
  id
  title
  enabled
  content
  headerImage {
    id
    source {
      url
    }
  }
  displayType
  filters {
    workspaces {
      id
    }
    excludedWorkspaces {
      id
    }
    superUserOnly
  }
  isRead
  readAt
  createdAt
  updatedAt
}
    `;
export const ChallengeFragmentDoc = gql`
    fragment Challenge on Challenge {
  context
  password {
    username
  }
  newPasswordRequired {
    username
  }
  singleSignOn {
    url
  }
  mfaSetup {
    username
    allowedMethods
  }
  totpMfa {
    username
  }
}
    `;
export const CareerPartialFragmentDoc = gql`
    fragment CareerPartial on Career {
  id
  title
  expertise {
    id
    title
  }
  jobTitles {
    id
    title
    description
  }
  isArchived
}
    `;
export const ExpertisePartialFragmentDoc = gql`
    fragment ExpertisePartial on Expertise {
  id
  title
  careers {
    id
    title
  }
  isArchived
}
    `;
export const ApiUserFragmentDoc = gql`
    fragment ApiUser on ApiUser {
  id
  apiKey
  createdAt
  secretCreatedAt
  permissions
}
    `;
export const ConnectorWithConfigFragmentDoc = gql`
    fragment ConnectorWithConfig on Connector {
  id
  isActive
  type
  config {
    ... on ConnectorConfigFieldBoolean {
      id
      key
      type
      isConfigured
      isDangerous
      boolean: value
    }
    ... on ConnectorConfigFieldDate {
      id
      key
      type
      isConfigured
      date
    }
    ... on ConnectorConfigFieldText {
      id
      key
      type
      isConfigured
      isSecret
      text
    }
    ... on ConnectorConfigFieldMultiSelect {
      id
      key
      type
      isConfigured
      values
      options {
        label
        value
      }
    }
    ... on ConnectorConfigFieldOAuth2 {
      id
      key
      type
      isConfigured
      authorizeUrl
      authorizationInfo
    }
    ... on ConnectorConfigFieldSelect {
      id
      key
      type
      isConfigured
      value
    }
    ... on ConnectorConfigFieldFilter {
      id
      key
      isConfigured
      key
      type
      whitelist
    }
  }
}
    `;
export const EvaluationFormFragmentDoc = gql`
    fragment EvaluationForm on EvaluationForm {
  id
  title
  description
}
    `;
export const EvaluationFormEditorFragmentDoc = gql`
    fragment EvaluationFormEditor on EvaluationForm {
  id
  isArchived
  title
  description
  jobTitleIDs
  useOnlyInCycle
  showAnswersWhenAllUsersShared
  sections {
    weight
    items {
      id
      type
      fillInBy
      optional
      title {
        text
      }
      paragraph {
        text
      }
      stars {
        title
      }
      openQuestion {
        title
      }
      sentiment {
        title
        displayMethod
      }
      developmentPlan {
        title
      }
      competency {
        competency {
          id
          title
          competencyLevelSet {
            id
            title
            isArchived
          }
          levels {
            level {
              id
              title
            }
            enabled
            criteria
          }
        }
        weight
      }
      multipleChoice {
        title
      }
      reviewGoals {
        competencyLevelSet {
          id
          title
          isArchived
          levels {
            id
            title
          }
        }
        defaultExplanation
      }
      finalScore {
        calculationMethod
        title
        competencyLevelSet {
          id
          title
          isArchived
          levels {
            id
            title
          }
        }
        displayLevelSet {
          id
          title
          isArchived
          levels {
            id
            title
          }
        }
        includeReviewGoals
        scoreFormat
      }
      signature {
        title
      }
      setGoals {
        title
      }
    }
  }
}
    `;
export const EngagementGroupsParticipationFragmentDoc = gql`
    fragment EngagementGroupsParticipation on AnalyticsEngagementGroupParticipation {
  group {
    id
    name
  }
  participation
  delta
}
    `;
export const EngagementGroupsSubcategoriesScoreFragmentDoc = gql`
    fragment EngagementGroupsSubcategoriesScore on AnalyticsEngagementGroupSubcategoryScore {
  subcategory {
    id
    title
    description
  }
  group {
    id
    name
    isArchived
  }
  score
  delta
}
    `;
export const EngagementOpenQuestionsFragmentDoc = gql`
    fragment EngagementOpenQuestions on AnalyticsEngagementOpenQuestion {
  question {
    id
    title
    category {
      id
      title
    }
    subcategory {
      id
      title
      description
    }
  }
  answers {
    timestamp
    text
    id
  }
}
    `;
export const EngagementParticipationOverTimeFragmentDoc = gql`
    fragment EngagementParticipationOverTime on AnalyticsEngagementParticipation {
  delta
  average
  datapoints {
    timestamp
    total
    completed
  }
}
    `;
export const EngagementQuestionsOverTimeFragmentDoc = gql`
    fragment EngagementQuestionsOverTime on AnalyticsEngagementQuestionScoreTrend {
  question {
    id
    title
  }
  datapoints {
    timestamp
    score
  }
  delta
}
    `;
export const EngagementQuestionsOverTimeWithCategoryFragmentDoc = gql`
    fragment EngagementQuestionsOverTimeWithCategory on AnalyticsEngagementQuestionScoreTrend {
  question {
    id
    title
    category {
      id
      title
    }
    subcategory {
      id
      title
      description
    }
  }
  datapoints {
    timestamp
    score
  }
  delta
}
    `;
export const EngagementReplyUserFragmentDoc = gql`
    fragment EngagementReplyUser on User {
  id
  firstName
  lastName
  avatar {
    source {
      url
    }
  }
}
    `;
export const EngagementReplyFragmentDoc = gql`
    fragment EngagementReply on EngagementReply {
  id
  text
  sender {
    ...EngagementReplyUser
  }
  createdAt
}
    ${EngagementReplyUserFragmentDoc}`;
export const EngagementResponseFragmentDoc = gql`
    fragment EngagementResponse on EngagementResponse {
  id
  request {
    id
    template {
      id
      anonymityThreshold
      endPage
    }
    questions {
      id
      title
      type {
        id
        title
        type
        options {
          title
        }
      }
    }
  }
  answers {
    questionID
    skipped
    index
    text
  }
  isCompleted
  isExpired
}
    `;
export const EngagementScoreOverTimeFragmentDoc = gql`
    fragment EngagementScoreOverTime on AnalyticsEngagementScore {
  delta
  datapoints {
    timestamp
    score
  }
}
    `;
export const EngagementSubcategoriesOverTimeFragmentDoc = gql`
    fragment EngagementSubcategoriesOverTime on AnalyticsEngagementSubcategoryScoreOverTime {
  subcategory {
    id
    title
    description
  }
  delta
  datapoints {
    timestamp
    score
  }
}
    `;
export const EngagementSubcategoriesOverTimeWithCategoryFragmentDoc = gql`
    fragment EngagementSubcategoriesOverTimeWithCategory on AnalyticsEngagementSubcategoryScoreOverTime {
  subcategory {
    id
    title
    description
    category {
      id
      title
    }
  }
  delta
  datapoints {
    timestamp
    score
  }
}
    `;
export const EngagementCategoryFragmentDoc = gql`
    fragment EngagementCategory on EngagementCategory {
  id
  title
  subcategories {
    edges {
      node {
        id
        title
      }
    }
  }
  isArchived
  questions {
    totalCount
  }
}
    `;
export const EngagementTemplateFragmentDoc = gql`
    fragment EngagementTemplate on EngagementTemplate {
  id
  title
  isEnabled
  interval
  categories {
    ...EngagementCategory
  }
  useAllQuestions
  maxOpenQuestions
  maxQuestions
  expiryInDays
  reminderDaysInAdvance
  targetGroups {
    id
  }
  targetUsers {
    id
  }
  useNps
  instruction
  endPage
  anonymityThreshold
}
    ${EngagementCategoryFragmentDoc}`;
export const AiGeneratedCompetenciesResponseFragmentDoc = gql`
    fragment AIGeneratedCompetenciesResponse on AIGeneratedCompetenciesResponse {
  suggestion {
    title
    description
    levels
  }
  chat {
    id
    messages {
      text
      sender
    }
  }
}
    `;
export const ComplimentSummaryFragmentDoc = gql`
    fragment ComplimentSummary on Compliment {
  id
  text
  sender {
    id
    firstName
    lastName
    avatar {
      source {
        url
      }
    }
  }
  recipient {
    id
    firstName
    lastName
    avatar {
      source {
        url
      }
    }
  }
  createdAt
}
    `;
export const CompetencyGoalFragmentDoc = gql`
    fragment CompetencyGoal on CompetencyGoal {
  competency {
    id
    title
    levels {
      criteria
      level {
        id
        title
      }
    }
  }
  competencyLevelIndex
}
    `;
export const VoiceMemoFragmentDoc = gql`
    fragment VoiceMemo on VoiceMemo {
  asset {
    id
    source {
      url
    }
  }
  samples
  sampleRate
}
    `;
export const CommentFragmentDoc = gql`
    fragment Comment on Comment {
  id
  content
  user {
    id
    firstName
    lastName
    avatar {
      source {
        url
      }
    }
  }
  targetID
  targetType
  createdAt
  metadata {
    key
    value
  }
  viewerCanArchive
  viewerCanUpdate
  isArchived
}
    `;
export const FeedbackResponseFragmentDoc = gql`
    fragment FeedbackResponse on FeedbackResponse {
  id
  status
  sharedAt
  createdAt
  isArchived
  recipient {
    ... on User {
      id
      firstName
      lastName
      email
      avatar {
        id
        source {
          url
        }
      }
    }
    ... on FeedbackExternal {
      firstName
      lastName
      email
    }
  }
  answers {
    questionID
    text
    stars
    selectedOptionID
    competencyLevelIndex
    voiceMemo {
      ...VoiceMemo
    }
  }
  comments {
    ...Comment
  }
  viewerCanComment
  viewerCanViewComments
}
    ${VoiceMemoFragmentDoc}
${CommentFragmentDoc}`;
export const FeedbackRequestFragmentDoc = gql`
    fragment FeedbackRequest on FeedbackRequest {
  id
  title
  isArchived
  releaseDate
  questions {
    id
    id
    text
    localizedText
    subTitle
    additionalDetails
    type
    canSubjectView
    options {
      id
      text
    }
    goal {
      title
      dueDate
      status
      progress
      competency {
        ...CompetencyGoal
      }
    }
    goalRevision {
      id
      goalID
      revision
      title
      dueDate
      status
      progress
      competency {
        ...CompetencyGoal
      }
      secret
    }
    competency {
      id
      title
      competencyLevelSet {
        levels {
          id
          title
        }
      }
      levels {
        level {
          id
          title
        }
        criteria
        enabled
      }
    }
  }
  responses(first: 1000) {
    edges {
      node {
        ...FeedbackResponse
      }
    }
  }
  createdAt
  user {
    id
    managers {
      id
      source {
        id
      }
    }
    isViewer
    viewerCanViewFeedback
  }
}
    ${CompetencyGoalFragmentDoc}
${FeedbackResponseFragmentDoc}`;
export const InternalFeedbackFragmentDoc = gql`
    fragment InternalFeedback on FeedbackResponse {
  id
  title
  questions {
    id
    type
    text
    localizedText
    subTitle
    additionalDetails
    canSubjectView
    options {
      id
      text
    }
    goal {
      title
      status
      competency {
        ...CompetencyGoal
      }
      dueDate
      progress
    }
    goalRevision {
      id
      goalID
      revision
      title
      status
      competency {
        ...CompetencyGoal
      }
      dueDate
      progress
      secret
    }
    competency {
      id
      title
      description
      competencyLevelSet {
        levels {
          id
          title
        }
      }
      levels {
        level {
          id
          title
        }
        criteria
        enabled
      }
    }
  }
  answers {
    questionID
    text
    stars
    selectedOptionID
    competencyLevelIndex
    voiceMemo {
      ...VoiceMemo
    }
  }
  instruction
  status
  sharedAt
  releaseDate
  requestor {
    id
    firstName
    lastName
    avatar {
      source {
        url
      }
    }
  }
  recipient {
    ... on User {
      id
      firstName
      lastName
      avatar {
        source {
          url
        }
      }
    }
    ... on FeedbackExternal {
      firstName
      lastName
      email
    }
  }
  viewerCanComment
  viewerCanViewComments
  comments {
    ...Comment
  }
}
    ${CompetencyGoalFragmentDoc}
${VoiceMemoFragmentDoc}
${CommentFragmentDoc}`;
export const AiGeneratedGoalResponseFragmentDoc = gql`
    fragment AIGeneratedGoalResponse on AIGeneratedGoalResponse {
  suggestion {
    title
    description
    subgoals
  }
  chat {
    id
    messages {
      text
      sender
    }
  }
}
    `;
export const JobGoalTemplateFragmentDoc = gql`
    fragment JobGoalTemplate on JobGoalTemplate {
  id
  level {
    id
    title
  }
  title
  description
  competency {
    competency {
      id
      title
      levels {
        level {
          id
          title
        }
        criteria
        enabled
      }
    }
    competencyLevelIndex
  }
}
    `;
export const JobPositionFragmentDoc = gql`
    fragment JobPosition on JobPosition {
  id
  jobTitle {
    id
    title
  }
  jobLevel {
    id
    title
  }
  competencies {
    id
    competency {
      id
      title
    }
    label {
      id
      title
    }
  }
}
    `;
export const JobPositionSuccessorFragmentDoc = gql`
    fragment JobPositionSuccessor on JobPositionSuccessor {
  id
  readiness
  motivation
  createdAt
  viewerCanArchive
  createdBy {
    id
    firstName
    lastName
    avatar {
      source {
        url
      }
    }
  }
  user {
    id
    firstName
    lastName
    status
    avatar {
      source {
        url
      }
    }
    currentJobPosition {
      id
      jobTitle {
        id
        title
      }
    }
  }
}
    `;
export const JobCompetencyFragmentDoc = gql`
    fragment JobCompetency on JobCompetency {
  id
  level {
    id
    title
  }
  competency {
    id
    title
    description
    styrSkillID
    levels {
      level {
        id
        title
      }
      criteria
    }
  }
  competencyLevel
  description
  order
  label {
    id
    title
  }
}
    `;
export const GoalTemplateFragmentDoc = gql`
    fragment GoalTemplate on GoalTemplate {
  id
  title
  description
  competency {
    competency {
      id
      title
      levels {
        level {
          id
          title
        }
        criteria
        enabled
      }
    }
    competencyLevelIndex
  }
  label {
    id
    title
    description
  }
  jobTitles {
    id
    title
  }
  isArchived
}
    `;
export const JobTitleFragmentDoc = gql`
    fragment JobTitle on JobTitle {
  id
  title
  description
  isArchived
  externalReferenceID
  isKeyPosition
  keyPositionMarkedAt
  keyPositionMarkedBy {
    id
    firstName
    lastName
  }
  viewerCanManageSuccession
  competencies {
    ...JobCompetency
  }
  goalTemplates {
    edges {
      cursor
      node {
        ...GoalTemplate
      }
    }
  }
}
    ${JobCompetencyFragmentDoc}
${GoalTemplateFragmentDoc}`;
export const JobTitleCompetenciesPartialFragmentDoc = gql`
    fragment JobTitleCompetenciesPartial on JobTitle {
  id
  title
  description
  isArchived
  appraisal(userID: $userID) {
    competency {
      id
    }
    competencyLevelIndex
  }
  competencies {
    id
    competency {
      id
      title
      description
      label {
        id
        title
      }
      levels {
        enabled
        level {
          id
          title
        }
        criteria
      }
    }
    competencyLevel
    order
  }
}
    `;
export const LearningCourseFragmentDoc = gql`
    fragment LearningCourse on LearningCourse {
  id
  provider
  title
  description
  learningType {
    id
    color
    title
  }
  learningSubjects {
    id
    title
  }
  languageID
  durationMinutes
  imageUrl
  launchUrl
  launchUrls
  isArchived
}
    `;
export const LearningEventFragmentDoc = gql`
    fragment LearningEvent on LearningEvent {
  id
  status
  title
  description
  cover {
    id
    source {
      url
    }
  }
  startDate
  endDate
  timezone
  capacity
  attendeeCount
  meetingLink
  location
  learningType {
    id
    color
    title
  }
  hosts(first: 1000) {
    edges {
      node {
        id
        firstName
        lastName
        avatar {
          source {
            url
          }
        }
      }
      attendeeType
    }
  }
  attendees(first: 1000) {
    edges {
      node {
        id
        firstName
        lastName
        avatar {
          source {
            url
          }
        }
      }
      attendeeType
    }
  }
  learningSubjects {
    id
    title
  }
  languageID
  isArchived
  isViewerAttending
  lastRejectedAt
  createdBy {
    id
  }
}
    `;
export const EmployeeFeedItemFragmentDoc = gql`
    fragment EmployeeFeedItem on EmployeeFeedItem {
  id
  type
  title
  date
}
    `;
export const EmployeeFeedMonthItemsFragmentDoc = gql`
    fragment EmployeeFeedMonthItems on EmployeeFeedMonthItems {
  month
  items {
    ...EmployeeFeedItem
  }
}
    ${EmployeeFeedItemFragmentDoc}`;
export const EmployeeFeedFragmentDoc = gql`
    fragment EmployeeFeed on EmployeeFeed {
  itemsPerMonth {
    ...EmployeeFeedMonthItems
  }
}
    ${EmployeeFeedMonthItemsFragmentDoc}`;
export const TaskFragmentDoc = gql`
    fragment Task on Task {
  id
  title
  createdAt
  updatedAt
  status
  dueDate
  subjectType
  subject {
    __typename
    ... on User {
      id
      firstName
      lastName
      avatar {
        source {
          url
        }
      }
    }
    ... on Group {
      id
      name
    }
    ... on Note {
      id
      title
    }
  }
}
    `;
export const NoteTaskFragmentDoc = gql`
    fragment NoteTask on Task {
  id
  title
  status
  order
}
    `;
export const NoteUserFragmentDoc = gql`
    fragment NoteUser on User {
  id
  firstName
  lastName
  normalizedName
  avatar {
    id
    source {
      url
    }
  }
}
    `;
export const FeedbackTemplateForFeedbackFragmentDoc = gql`
    fragment FeedbackTemplateForFeedback on FeedbackTemplate {
  id
  title
  description
  instruction
  roles
  questions {
    question {
      id
      text
      subTitle
      additionalDetails
      type
      options {
        id
        text
      }
      category {
        id
        name
      }
    }
    instruction
    canSubjectView
  }
}
    `;
export const TranscriptionFollowupsFragmentDoc = gql`
    fragment TranscriptionFollowups on TranscriptionFollowups {
  goalSuggestions {
    id
    title
    description
    subgoals
    targetUser {
      id
      firstName
    }
    actedUpon
  }
  feedbackRequestSuggestions {
    id
    title
    instruction
    template {
      id
      title
      ...FeedbackTemplateForFeedback
    }
    actedUpon
  }
}
    ${FeedbackTemplateForFeedbackFragmentDoc}`;
export const SharedByUserFragmentDoc = gql`
    fragment SharedByUser on User {
  id
  firstName
  lastName
  fullName
  avatar {
    source {
      url
    }
  }
}
    `;
export const MeetingFragmentDoc = gql`
    fragment Meeting on Meeting {
  id
  startsAt
  endsAt
  timezone
  attendees {
    id
    user {
      id
      firstName
      lastName
      avatar {
        source {
          url
        }
      }
    }
    status
    proposal {
      startsAt
      endsAt
    }
  }
  createdBy {
    id
    ...SharedByUser
  }
  isCancelled
  series {
    id
    recurrenceFrequency
    recurrenceRule
    timezone
    noteSeriesMetadata {
      defaultTitle
    }
  }
  note {
    id
    meeting {
      id
    }
  }
  updatedAt
}
    ${SharedByUserFragmentDoc}`;
export const NoteMeetingFragmentDoc = gql`
    fragment NoteMeeting on Meeting {
  ...Meeting
  attendees {
    id
    user {
      ...NoteUser
    }
    status
  }
}
    ${MeetingFragmentDoc}
${NoteUserFragmentDoc}`;
export const NoteFragmentDoc = gql`
    fragment Note on Note {
  id
  title
  tasks {
    ...NoteTask
  }
  content
  preparation
  date
  isArchived
  subject {
    ...NoteUser
  }
  owner {
    ...NoteUser
  }
  collaborators(first: 1000) {
    edges {
      node {
        ...NoteUser
      }
    }
  }
  goals {
    id
    title
    progress
  }
  feedbackRequests {
    id
    title
  }
  evaluationSubmissions {
    id
    evaluationForm {
      title
    }
  }
  viewerCanArchive
  transcription {
    id
    transcript
    summary
    editableSummary
    uploadStatus
    status
    audioUrl
    speakers {
      speakerNumber
      segmentIndex
      user {
        id
        firstName
        lastName
      }
    }
    followups {
      ...TranscriptionFollowups
    }
    createdAt
    createdBy {
      ...NoteUser
    }
  }
  viewerCanRestore
  viewerCanComment
  viewerCanShare
  viewerCanUpdate
  createdAt
  updatedAt
  noteType
  meeting {
    ...NoteMeeting
  }
  metadata {
    source
    outlookItemId
    teamsChatId
    teamsMessageId
    tenantId
  }
}
    ${NoteTaskFragmentDoc}
${NoteUserFragmentDoc}
${TranscriptionFollowupsFragmentDoc}
${NoteMeetingFragmentDoc}`;
export const NoteForCardFragmentDoc = gql`
    fragment NoteForCard on Note {
  id
  title
  date
  collaborators {
    edges {
      node {
        ...NoteUser
      }
    }
  }
  createdBy {
    ...NoteUser
  }
  subject {
    ...NoteUser
  }
  createdAt
  updatedAt
  meeting {
    startsAt
    timezone
    isCancelled
    series {
      id
    }
  }
  metadata {
    source
  }
}
    ${NoteUserFragmentDoc}`;
export const NoteForOneOnOneOverviewFragmentDoc = gql`
    fragment NoteForOneOnOneOverview on Note {
  ...NoteForCard
  owner {
    id
  }
  collaborators {
    pageInfo {
      hasNextPage
    }
  }
  noteType
  content
  metadata {
    sender
  }
  tasks {
    ...NoteTask
  }
}
    ${NoteForCardFragmentDoc}
${NoteTaskFragmentDoc}`;
export const NotesSidebarUserFragmentDoc = gql`
    fragment NotesSidebarUser on User {
  id
  firstName
  lastName
  fullName
  avatar {
    source {
      url
    }
  }
}
    `;
export const WorkspaceConnectorAdminFragmentDoc = gql`
    fragment WorkspaceConnectorAdmin on Connector {
  id
  type
  isActive
  authorizationInfo
  authorizeUrl
}
    `;
export const WorkspaceFeatureFragmentDoc = gql`
    fragment WorkspaceFeature on WorkspaceFeature {
  id
  feature {
    id
    stability
  }
  status
  inPlan
  needsWorkspaceApproval
  needsViewerApproval
  requiredConditions {
    currentVersion
    linkToConditions
  }
  viewerApproval {
    approvedAt
    approvedBy {
      id
      username
    }
  }
  workspaceApproval {
    approvedAt
    approvedBy {
      id
      username
    }
  }
}
    `;
export const WorkspacePlanFragmentDoc = gql`
    fragment WorkspacePlan on WorkspacePlanV2 {
  id
  type
  startDate
  endDate
  isTrial
  isExpired
  minimumUserCount
}
    `;
export const WorkspaceSsoSettingsFragmentDoc = gql`
    fragment WorkspaceSSOSettings on WorkspaceSSOSettings {
  enforceSSO
}
    `;
export const PageInfoFragmentDoc = gql`
    fragment PageInfo on PageInfo {
  hasPreviousPage
  hasNextPage
  startCursor
  endCursor
}
    `;
export const NoteTemplatePartialFragmentDoc = gql`
    fragment NoteTemplatePartial on NoteTemplate {
  id
  title
  subtitle
  icon
  iconColor
  description
  category {
    id
    title
  }
  isArchived
  index
}
    `;
export const CustomEmailDomainFragmentFragmentDoc = gql`
    fragment CustomEmailDomainFragment on CustomEmailDomain {
  domain
  emailDomain
  mailFromDomain
  enabled
  dkimVerificationStatus
  dkimTokens
  mailFromVerificationStatus
  senderName
  senderAddress
}
    `;
export const CycleTemplateMomentFragmentDoc = gql`
    fragment CycleTemplateMoment on MomentTemplate {
  id
  type
  startOffset
  duration
  title
  description
  instruction
  isArchived
  archivedAt
  variations {
    evaluation {
      evaluationForm {
        id
        title
      }
    }
    feedback {
      feedbackTemplate {
        id
        title
      }
    }
    jobTitle {
      id
      title
    }
    roleType
  }
  evaluation {
    evaluationForm {
      id
      title
    }
  }
  feedback {
    minimumQuestions
    minimumRecipients
    maximumRecipients
    releaseDate
    feedbackTemplate {
      id
      title
    }
  }
  goals {
    minimumGoals
    minimumCompetencyGoals
  }
  talentReview {
    template {
      id
      title
    }
  }
  notifications {
    id
    type
    offset
  }
  showToUser
}
    `;
export const CycleTemplateEditorFragmentDoc = gql`
    fragment CycleTemplateEditor on CycleTemplate {
  id
  title
  description
  duration
  successor {
    id
  }
  isArchived
  automatic
  employmentType
  groups {
    id
  }
  excludedGroups {
    id
  }
  jobTitles {
    id
  }
  excludedJobTitles {
    id
  }
  interval
  moments {
    ...CycleTemplateMoment
  }
}
    ${CycleTemplateMomentFragmentDoc}`;
export const LabelFragmentDoc = gql`
    fragment Label on Label {
  id
  title
  description
  type
  isArchived
}
    `;
export const SharedByFragmentDoc = gql`
    fragment SharedBy on SharedFeedback {
  request {
    id
    title
    createdAt
  }
  sharedBy {
    ...SharedByUser
  }
  createdAt
}
    ${SharedByUserFragmentDoc}`;
export const SharedWithUserFragmentDoc = gql`
    fragment SharedWithUser on User {
  id
  firstName
  lastName
  fullName
  avatar {
    source {
      url
    }
  }
}
    `;
export const SharedWithFragmentDoc = gql`
    fragment SharedWith on SharedFeedback {
  sharedWith {
    ...SharedWithUser
  }
  createdAt
}
    ${SharedWithUserFragmentDoc}`;
export const TalentReviewTemplateFragmentDoc = gql`
    fragment TalentReviewTemplate on TalentReviewTemplate {
  id
  title
  description
  visibility
  outdatedAfterDays
  hasNorm
  xAxis {
    label
    ticks
  }
  yAxis {
    label
    ticks
  }
  cells {
    color
    label
    instruction
    norm
  }
  isArchived
  placementHelpQuestions {
    id
    axis
    question
    answers {
      id
      label
      tickIndex
    }
  }
}
    `;
export const TalentReviewFragmentDoc = gql`
    fragment TalentReview on TalentReview {
  id
  title
  template {
    ...TalentReviewTemplate
  }
  group {
    id
    type
    members(first: 1000) {
      edges {
        node {
          id
          firstName
          lastName
          avatar {
            source {
              url
            }
          }
        }
        role {
          id
          type
        }
      }
    }
  }
  placements {
    row
    column
    score
    user {
      id
      firstName
      lastName
      avatar {
        source {
          url
        }
      }
    }
    motivation
  }
  visibility
  viewerCanUpdate
  isArchived
  status
}
    ${TalentReviewTemplateFragmentDoc}`;
export const TalentReviewCycleMomentFragmentDoc = gql`
    fragment TalentReviewCycleMoment on MomentInstance {
  id
  status
  endDate
  talentReviewViewerCanRevert
  user {
    id
  }
  talentReviewSnapshot {
    id
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
  }
  momentTemplate {
    title
    type
    talentReview {
      template {
        id
      }
      group {
        id
      }
    }
  }
}
    `;
export const TalentReviewActivityFragmentDoc = gql`
    fragment TalentReviewActivity on TalentReviewActivity {
  id
  type
  createdAt
  integration
  createdBy {
    id
    firstName
    lastName
  }
  user {
    id
    firstName
    lastName
    avatar {
      source {
        url
      }
    }
  }
  placement {
    row
    column
    motivation
    score
    retentionRisk
    removed
    previous {
      row
      column
    }
  }
  answers {
    question
    answer
  }
  retentionRisk
  successor {
    id
    firstName
    lastName
  }
}
    `;
export const TalentReviewGridFragmentDoc = gql`
    fragment TalentReviewGrid on TalentReviewGrid {
  localDate
  viewerCanUpdate
  template {
    ...TalentReviewTemplate
  }
  group {
    id
    name
    members(first: 1000) {
      edges {
        node {
          id
          firstName
          lastName
          avatar {
            source {
              url
            }
          }
        }
        role {
          type
        }
      }
    }
  }
  placements {
    row
    column
    position
    score
    retentionRisk
    previous {
      row
      column
      position
      motivation
    }
    localDate
    createdAt
    user {
      id
      firstName
      lastName
      avatar {
        source {
          url
        }
      }
    }
    motivation
  }
  activity {
    ...TalentReviewActivity
  }
}
    ${TalentReviewTemplateFragmentDoc}
${TalentReviewActivityFragmentDoc}`;
export const TalentReviewSnapshotFragmentDoc = gql`
    fragment TalentReviewSnapshot on TalentReviewSnapshot {
  id
  title
  description
  localDate
  status
  visibility
  createdAt
  createdBy {
    id
    firstName
    lastName
  }
  sharedAt
  sharedBy {
    id
    firstName
    lastName
    avatar {
      source {
        url
      }
    }
  }
  template {
    id
    title
  }
  group {
    id
    name
    type
  }
}
    `;
export const TalentReviewSnapshotGridFragmentDoc = gql`
    fragment TalentReviewSnapshotGrid on TalentReviewSnapshot {
  ...TalentReviewSnapshot
  viewerCanCorrect
  viewerCanManage
  template {
    ...TalentReviewTemplate
  }
  group {
    id
    name
    type
    members(first: 1000) {
      edges {
        node {
          id
          firstName
          lastName
          avatar {
            source {
              url
            }
          }
        }
        role {
          type
        }
      }
    }
  }
  placements(manage: $manage) {
    row
    column
    position
    score
    retentionRisk
    previous {
      row
      column
      position
    }
    createdAt
    user {
      id
      firstName
      lastName
      avatar {
        source {
          url
        }
      }
    }
    motivation
  }
  activity(manage: $manage) {
    ...TalentReviewActivity
  }
}
    ${TalentReviewSnapshotFragmentDoc}
${TalentReviewTemplateFragmentDoc}
${TalentReviewActivityFragmentDoc}`;
export const GoalWithOwnerFragmentDoc = gql`
    fragment GoalWithOwner on Goal {
  owner {
    ... on User {
      id
      firstName
      lastName
      avatar {
        id
        source {
          url
        }
      }
    }
    ... on Group {
      id
      name
      type
    }
    ... on Workspace {
      id
    }
  }
}
    `;
export const MetaGoalFragmentDoc = gql`
    fragment MetaGoal on Goal {
  id
  ownerType
  title
  description
  order
  createdAt
  dueDate
  progress
  status
  feasibility
  linkedGoalDrivers {
    id
    title
  }
  label {
    id
    title
    description
    isArchived
  }
  checklistItems {
    id
    title
    description
    progress {
      type
      value
      upper
      lower
    }
    dueDate
    learningCourse {
      id
      provider
    }
    createdBy {
      id
    }
    createdAt
    updatedBy {
      id
    }
    updatedAt
    completedBy {
      id
    }
    completedAt
  }
  completedBy {
    id
  }
  completedAt
  isArchived
  children {
    totalCount
  }
  viewerCanViewChildren
}
    `;
export const GoalFragmentDoc = gql`
    fragment Goal on Goal {
  id
  ownerType
  title
  description
  dueDate
  progress
  status
  feasibility
  archivedAt
  isArchived
  createdAt
  updatedAt
  completedAt
  completedBy {
    id
  }
  competency {
    competency {
      id
      title
      description
      levels {
        criteria
        enabled
        level {
          id
          title
        }
      }
      competencyLevelSet {
        id
        levels {
          id
          title
        }
      }
    }
    competencyLevelIndex
    appraisals {
      competencyLevelIndex
    }
  }
  checklistItems {
    id
    title
    description
    progress {
      type
      value
      upper
      lower
    }
    dueDate
    learningCourseID
    learningCourse {
      id
      provider
      launchUrl
      launchUrls
      learningType {
        id
        title
      }
    }
    createdBy {
      id
    }
    createdAt
    updatedBy {
      id
    }
    updatedAt
    completedBy {
      id
    }
    completedAt
  }
  comments {
    id
    content
    user {
      id
      firstName
      lastName
    }
    targetID
    targetType
    createdAt
    isArchived
    viewerCanArchive
  }
  linkedGoalDrivers {
    id
    title
  }
  viewerCanUpdate
  ...GoalWithOwner
  order
  createdBy {
    id
    firstName
    lastName
    avatar {
      id
      source {
        url
      }
    }
  }
  parent {
    ...MetaGoal
  }
  children {
    totalCount
  }
  viewerCanComment
  viewerCanViewComments
  visibility
  label {
    id
    title
    description
    isArchived
  }
}
    ${GoalWithOwnerFragmentDoc}
${MetaGoalFragmentDoc}`;
export const DevelopmentPlanUserFragmentDoc = gql`
    fragment DevelopmentPlanUser on User {
  id
  avatar {
    id
    source {
      url
    }
  }
  firstName
  lastName
  currentJobPosition {
    id
    jobTitle {
      id
      title
      description
    }
  }
  activeGoals: goals(status: ACTIVE, hasCompetency: true) {
    ...Goal
  }
  completedGoals: goals(status: COMPLETED, hasCompetency: true) {
    ...Goal
  }
}
    ${GoalFragmentDoc}`;
export const EvaluationSubmissionResultFragmentDoc = gql`
    fragment EvaluationSubmissionResult on EvaluationSubmissionResult {
  party
  status
  requiresInput
  user {
    id
    firstName
    lastName
    avatar {
      source {
        url
      }
    }
    jobPositions {
      id
      startDate
      endDate
      jobLevel {
        id
        title
        description
      }
      jobTitle {
        id
        title
        description
      }
    }
    viewerCanViewGoals
    viewerCanViewDevelopmentPlan
    viewerCanViewFeedback
    viewerCanViewEvaluations
  }
  sections {
    items {
      type
      stars
      openQuestion
      sentiment
      multipleChoice
      competency
      reviewGoals {
        goalID
        competency
        text
      }
      viewerCanView
    }
    score
  }
  finalScore {
    id
    title
  }
  hasSigned
  signedAt
  hasShared
  requiresSignature
  viewerCanViewAnswers
  viewerCanArchive
  viewerCanUpdate
  viewerCanShare
  viewerCanSign
}
    `;
export const EvaluationSubmissionFragmentDoc = gql`
    fragment EvaluationSubmission on EvaluationSubmission {
  id
  deadline
  employee {
    ...EvaluationSubmissionResult
  }
  manager {
    ...EvaluationSubmissionResult
  }
  viewer {
    ...EvaluationSubmissionResult
  }
  evaluationForm {
    title
    description
    sections {
      items {
        id
        type
        fillInBy
        optional
        title {
          text
        }
        paragraph {
          text
        }
        stars {
          title
        }
        openQuestion {
          title
        }
        developmentPlan {
          title
        }
        sentiment {
          title
          displayMethod
        }
        competency {
          competency {
            title
            description
            styrSkillID
            levels {
              enabled
              criteria
              level {
                title
              }
            }
          }
          weight
        }
        multipleChoice {
          title
        }
        finalScore {
          title
          calculationMethod
          competencyLevelSet {
            levels {
              id
              title
            }
          }
          displayLevelSet {
            levels {
              id
              title
            }
          }
        }
        reviewGoals {
          competencyLevelSet {
            levels {
              id
              title
            }
          }
          defaultExplanation
        }
        signature {
          title
        }
        setGoals {
          title
        }
      }
    }
  }
  goals {
    goal {
      id
    }
    title
    dueDate
    progress
    status
    competency {
      ...CompetencyGoal
    }
  }
  comments {
    ...Comment
  }
  meeting {
    duration
    link
    location
  }
  moment {
    id
    momentTemplate {
      id
      title
    }
  }
  overrideScore {
    id
    title
  }
  transcription {
    id
    status
    uploadStatus
    transcript
    summary
    editableSummary
    audioUrl
    speakers {
      speakerNumber
      segmentIndex
      user {
        id
        firstName
        lastName
      }
    }
    followups {
      ...TranscriptionFollowups
    }
    createdAt
  }
  overrideReason
  viewerCanChangeConversationPartner
  viewerCanDiscardAnswersFromPredecessor
  viewerCanOverrideScore
  isArchived
  aiInsightsApproved
}
    ${EvaluationSubmissionResultFragmentDoc}
${CompetencyGoalFragmentDoc}
${CommentFragmentDoc}
${TranscriptionFollowupsFragmentDoc}`;
export const EvaluationSubmissionCardFragmentDoc = gql`
    fragment EvaluationSubmissionCard on EvaluationSubmission {
  id
  createdAt
  deadline
  evaluationForm {
    title
  }
  isArchived
  manager {
    status
    requiresInput
    requiresSignature
    party
    user {
      id
      firstName
      lastName
      avatar {
        source {
          url
        }
      }
    }
    isCompleted
  }
  employee {
    status
    requiresInput
    party
    user {
      id
      firstName
      lastName
      avatar {
        source {
          url
        }
      }
    }
  }
}
    `;
export const UserCompetenciesPartialFragmentDoc = gql`
    fragment UserCompetenciesPartial on User {
  id
  jobPositions(status: ACTIVE) {
    id
    startDate
    endDate
    externalReferenceID
    jobLevel {
      id
    }
    jobTitle {
      id
      title
      description
    }
    appraisal {
      competency {
        id
      }
      competencyLevelIndex
    }
    competencies {
      id
      competency {
        id
        title
        description
        label {
          id
          title
        }
        levels {
          enabled
          level {
            id
            title
          }
          criteria
        }
      }
      competencyLevel
      order
    }
  }
}
    `;
export const UserDocumentV2FragmentDoc = gql`
    fragment UserDocumentV2 on UserDocumentV2 {
  id
  name
  createdBy {
    id
    firstName
    lastName
  }
  createdAt
  viewerCanDelete
  status
}
    `;
export const UserDownloadFragmentDoc = gql`
    fragment UserDownload on UserDownload {
  id
  downloadLink
  name
  progress
  failedReason
  status
  viewerCanDelete
}
    `;
export const MfaUserConfigurationFragmentDoc = gql`
    fragment MfaUserConfiguration on MfaUserConfiguration {
  id
  enabled
  enabledMethods
  preferredMethod
}
    `;
export const WorkspaceMfaSettingsFragmentDoc = gql`
    fragment WorkspaceMfaSettings on WorkspaceMfaSettings {
  id
  status
  allowedMethods
}
    `;
export const UserMfaConfigurationFragmentDoc = gql`
    fragment UserMfaConfiguration on User {
  id
  userMfaConfiguration {
    ...MfaUserConfiguration
  }
  workspace {
    workspaceMfaSettings {
      ...WorkspaceMfaSettings
    }
  }
}
    ${MfaUserConfigurationFragmentDoc}
${WorkspaceMfaSettingsFragmentDoc}`;
export const NoteTemplateCategoryPartialFragmentDoc = gql`
    fragment NoteTemplateCategoryPartial on NoteTemplateCategory {
  id
  title
  isArchived
}
    `;
export const CopyWorkspaceDocument = gql`
    mutation CopyWorkspace($input: CopyWorkspaceInput!) {
  copyWorkspace(input: $input) {
    success
    target
    error
  }
}
    `;
export type CopyWorkspaceMutationFn = Apollo.MutationFunction<CopyWorkspaceMutation, CopyWorkspaceMutationVariables>;

/**
 * __useCopyWorkspaceMutation__
 *
 * To run a mutation, you first call `useCopyWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyWorkspaceMutation, { data, loading, error }] = useCopyWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<CopyWorkspaceMutation, CopyWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyWorkspaceMutation, CopyWorkspaceMutationVariables>(CopyWorkspaceDocument, options);
      }
export type CopyWorkspaceMutationHookResult = ReturnType<typeof useCopyWorkspaceMutation>;
export type CopyWorkspaceMutationResult = Apollo.MutationResult<CopyWorkspaceMutation>;
export type CopyWorkspaceMutationOptions = Apollo.BaseMutationOptions<CopyWorkspaceMutation, CopyWorkspaceMutationVariables>;
export const CheckWorkspaceDocument = gql`
    query CheckWorkspace($id: ID!) {
  isWorkspaceSlugAvailable(id: $id)
}
    `;

/**
 * __useCheckWorkspaceQuery__
 *
 * To run a query within a React component, call `useCheckWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckWorkspaceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<CheckWorkspaceQuery, CheckWorkspaceQueryVariables> & ({ variables: CheckWorkspaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckWorkspaceQuery, CheckWorkspaceQueryVariables>(CheckWorkspaceDocument, options);
      }
export function useCheckWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckWorkspaceQuery, CheckWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckWorkspaceQuery, CheckWorkspaceQueryVariables>(CheckWorkspaceDocument, options);
        }
// @ts-ignore
export function useCheckWorkspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckWorkspaceQuery, CheckWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<CheckWorkspaceQuery, CheckWorkspaceQueryVariables>;
export function useCheckWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckWorkspaceQuery, CheckWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<CheckWorkspaceQuery | undefined, CheckWorkspaceQueryVariables>;
export function useCheckWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckWorkspaceQuery, CheckWorkspaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckWorkspaceQuery, CheckWorkspaceQueryVariables>(CheckWorkspaceDocument, options);
        }
export type CheckWorkspaceQueryHookResult = ReturnType<typeof useCheckWorkspaceQuery>;
export type CheckWorkspaceLazyQueryHookResult = ReturnType<typeof useCheckWorkspaceLazyQuery>;
export type CheckWorkspaceSuspenseQueryHookResult = ReturnType<typeof useCheckWorkspaceSuspenseQuery>;
export type CheckWorkspaceQueryResult = Apollo.QueryResult<CheckWorkspaceQuery, CheckWorkspaceQueryVariables>;
export const CreateAgentChatDocument = gql`
    mutation CreateAgentChat($input: CreateAgentChatInput) {
  createAgentChat(input: $input) {
    id
    title
    updatedAt
  }
}
    `;
export type CreateAgentChatMutationFn = Apollo.MutationFunction<CreateAgentChatMutation, CreateAgentChatMutationVariables>;

/**
 * __useCreateAgentChatMutation__
 *
 * To run a mutation, you first call `useCreateAgentChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgentChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgentChatMutation, { data, loading, error }] = useCreateAgentChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgentChatMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgentChatMutation, CreateAgentChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgentChatMutation, CreateAgentChatMutationVariables>(CreateAgentChatDocument, options);
      }
export type CreateAgentChatMutationHookResult = ReturnType<typeof useCreateAgentChatMutation>;
export type CreateAgentChatMutationResult = Apollo.MutationResult<CreateAgentChatMutation>;
export type CreateAgentChatMutationOptions = Apollo.BaseMutationOptions<CreateAgentChatMutation, CreateAgentChatMutationVariables>;
export const DeleteAgentChatDocument = gql`
    mutation DeleteAgentChat($chatID: ID!) {
  deleteAgentChat(chatID: $chatID)
}
    `;
export type DeleteAgentChatMutationFn = Apollo.MutationFunction<DeleteAgentChatMutation, DeleteAgentChatMutationVariables>;

/**
 * __useDeleteAgentChatMutation__
 *
 * To run a mutation, you first call `useDeleteAgentChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgentChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgentChatMutation, { data, loading, error }] = useDeleteAgentChatMutation({
 *   variables: {
 *      chatID: // value for 'chatID'
 *   },
 * });
 */
export function useDeleteAgentChatMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAgentChatMutation, DeleteAgentChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAgentChatMutation, DeleteAgentChatMutationVariables>(DeleteAgentChatDocument, options);
      }
export type DeleteAgentChatMutationHookResult = ReturnType<typeof useDeleteAgentChatMutation>;
export type DeleteAgentChatMutationResult = Apollo.MutationResult<DeleteAgentChatMutation>;
export type DeleteAgentChatMutationOptions = Apollo.BaseMutationOptions<DeleteAgentChatMutation, DeleteAgentChatMutationVariables>;
export const SetPromptInstructionDocument = gql`
    mutation SetPromptInstruction($input: SetPromptInstructionInput!) {
  setPromptInstruction(input: $input) {
    promptInstruction {
      id
      workspaceID
      promptInstructionID
      instructions
    }
  }
}
    `;
export type SetPromptInstructionMutationFn = Apollo.MutationFunction<SetPromptInstructionMutation, SetPromptInstructionMutationVariables>;

/**
 * __useSetPromptInstructionMutation__
 *
 * To run a mutation, you first call `useSetPromptInstructionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPromptInstructionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPromptInstructionMutation, { data, loading, error }] = useSetPromptInstructionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPromptInstructionMutation(baseOptions?: Apollo.MutationHookOptions<SetPromptInstructionMutation, SetPromptInstructionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPromptInstructionMutation, SetPromptInstructionMutationVariables>(SetPromptInstructionDocument, options);
      }
export type SetPromptInstructionMutationHookResult = ReturnType<typeof useSetPromptInstructionMutation>;
export type SetPromptInstructionMutationResult = Apollo.MutationResult<SetPromptInstructionMutation>;
export type SetPromptInstructionMutationOptions = Apollo.BaseMutationOptions<SetPromptInstructionMutation, SetPromptInstructionMutationVariables>;
export const SetWorkspacePromptInstructionDocument = gql`
    mutation SetWorkspacePromptInstruction($input: SetWorkspacePromptInstructionInput!) {
  setWorkspacePromptInstruction(input: $input) {
    promptInstruction {
      instructions
    }
  }
}
    `;
export type SetWorkspacePromptInstructionMutationFn = Apollo.MutationFunction<SetWorkspacePromptInstructionMutation, SetWorkspacePromptInstructionMutationVariables>;

/**
 * __useSetWorkspacePromptInstructionMutation__
 *
 * To run a mutation, you first call `useSetWorkspacePromptInstructionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkspacePromptInstructionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkspacePromptInstructionMutation, { data, loading, error }] = useSetWorkspacePromptInstructionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWorkspacePromptInstructionMutation(baseOptions?: Apollo.MutationHookOptions<SetWorkspacePromptInstructionMutation, SetWorkspacePromptInstructionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWorkspacePromptInstructionMutation, SetWorkspacePromptInstructionMutationVariables>(SetWorkspacePromptInstructionDocument, options);
      }
export type SetWorkspacePromptInstructionMutationHookResult = ReturnType<typeof useSetWorkspacePromptInstructionMutation>;
export type SetWorkspacePromptInstructionMutationResult = Apollo.MutationResult<SetWorkspacePromptInstructionMutation>;
export type SetWorkspacePromptInstructionMutationOptions = Apollo.BaseMutationOptions<SetWorkspacePromptInstructionMutation, SetWorkspacePromptInstructionMutationVariables>;
export const AgentChatDocument = gql`
    query AgentChat($id: ID!) {
  agentChat(id: $id) {
    id
    title
    locale
    createdAt
    updatedAt
    messages {
      ...AgentChatMessage
    }
    usage {
      ...AgentChatUsage
    }
  }
}
    ${AgentChatMessageFragmentDoc}
${AgentChatUsageFragmentDoc}`;

/**
 * __useAgentChatQuery__
 *
 * To run a query within a React component, call `useAgentChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentChatQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgentChatQuery(baseOptions: Apollo.QueryHookOptions<AgentChatQuery, AgentChatQueryVariables> & ({ variables: AgentChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentChatQuery, AgentChatQueryVariables>(AgentChatDocument, options);
      }
export function useAgentChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentChatQuery, AgentChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentChatQuery, AgentChatQueryVariables>(AgentChatDocument, options);
        }
// @ts-ignore
export function useAgentChatSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentChatQuery, AgentChatQueryVariables>): Apollo.UseSuspenseQueryResult<AgentChatQuery, AgentChatQueryVariables>;
export function useAgentChatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentChatQuery, AgentChatQueryVariables>): Apollo.UseSuspenseQueryResult<AgentChatQuery | undefined, AgentChatQueryVariables>;
export function useAgentChatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentChatQuery, AgentChatQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentChatQuery, AgentChatQueryVariables>(AgentChatDocument, options);
        }
export type AgentChatQueryHookResult = ReturnType<typeof useAgentChatQuery>;
export type AgentChatLazyQueryHookResult = ReturnType<typeof useAgentChatLazyQuery>;
export type AgentChatSuspenseQueryHookResult = ReturnType<typeof useAgentChatSuspenseQuery>;
export type AgentChatQueryResult = Apollo.QueryResult<AgentChatQuery, AgentChatQueryVariables>;
export const AgentChatsDocument = gql`
    query AgentChats {
  agentChats {
    id
    title
    updatedAt
    subject {
      id
      firstName
      lastName
      avatar {
        source {
          url
        }
      }
    }
  }
}
    `;

/**
 * __useAgentChatsQuery__
 *
 * To run a query within a React component, call `useAgentChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentChatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgentChatsQuery(baseOptions?: Apollo.QueryHookOptions<AgentChatsQuery, AgentChatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentChatsQuery, AgentChatsQueryVariables>(AgentChatsDocument, options);
      }
export function useAgentChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentChatsQuery, AgentChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentChatsQuery, AgentChatsQueryVariables>(AgentChatsDocument, options);
        }
// @ts-ignore
export function useAgentChatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentChatsQuery, AgentChatsQueryVariables>): Apollo.UseSuspenseQueryResult<AgentChatsQuery, AgentChatsQueryVariables>;
export function useAgentChatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentChatsQuery, AgentChatsQueryVariables>): Apollo.UseSuspenseQueryResult<AgentChatsQuery | undefined, AgentChatsQueryVariables>;
export function useAgentChatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentChatsQuery, AgentChatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentChatsQuery, AgentChatsQueryVariables>(AgentChatsDocument, options);
        }
export type AgentChatsQueryHookResult = ReturnType<typeof useAgentChatsQuery>;
export type AgentChatsLazyQueryHookResult = ReturnType<typeof useAgentChatsLazyQuery>;
export type AgentChatsSuspenseQueryHookResult = ReturnType<typeof useAgentChatsSuspenseQuery>;
export type AgentChatsQueryResult = Apollo.QueryResult<AgentChatsQuery, AgentChatsQueryVariables>;
export const PromptHistoryDocument = gql`
    query PromptHistory($workspaceID: ID!, $promptHistoryID: ID!) {
  promptHistory(workspaceID: $workspaceID, promptHistoryID: $promptHistoryID) {
    id
    workspaceID
    user {
      id
      firstName
      lastName
      avatar {
        source {
          url
        }
      }
    }
    targetType
    targetID
    target {
      ... on Transcription {
        targetID
        targetType
        transcript
        audioUrl
      }
    }
    targetDetails {
      id
      type
      workspaceID
      evaluationFormTitle
      employee {
        id
        firstName
        lastName
        avatar {
          source {
            url
          }
        }
      }
      manager {
        id
        firstName
        lastName
        avatar {
          source {
            url
          }
        }
      }
    }
    messages
    response
    toolCallCount
    durationMs
    model
    inputTokens
    cachedInputTokens
    cacheWriteTokens
    outputTokens
    createdAt
    featureRating {
      id
      binaryValue
      text
      createdAt
    }
  }
}
    `;

/**
 * __usePromptHistoryQuery__
 *
 * To run a query within a React component, call `usePromptHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromptHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromptHistoryQuery({
 *   variables: {
 *      workspaceID: // value for 'workspaceID'
 *      promptHistoryID: // value for 'promptHistoryID'
 *   },
 * });
 */
export function usePromptHistoryQuery(baseOptions: Apollo.QueryHookOptions<PromptHistoryQuery, PromptHistoryQueryVariables> & ({ variables: PromptHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromptHistoryQuery, PromptHistoryQueryVariables>(PromptHistoryDocument, options);
      }
export function usePromptHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromptHistoryQuery, PromptHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromptHistoryQuery, PromptHistoryQueryVariables>(PromptHistoryDocument, options);
        }
// @ts-ignore
export function usePromptHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromptHistoryQuery, PromptHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<PromptHistoryQuery, PromptHistoryQueryVariables>;
export function usePromptHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromptHistoryQuery, PromptHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<PromptHistoryQuery | undefined, PromptHistoryQueryVariables>;
export function usePromptHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromptHistoryQuery, PromptHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromptHistoryQuery, PromptHistoryQueryVariables>(PromptHistoryDocument, options);
        }
export type PromptHistoryQueryHookResult = ReturnType<typeof usePromptHistoryQuery>;
export type PromptHistoryLazyQueryHookResult = ReturnType<typeof usePromptHistoryLazyQuery>;
export type PromptHistorySuspenseQueryHookResult = ReturnType<typeof usePromptHistorySuspenseQuery>;
export type PromptHistoryQueryResult = Apollo.QueryResult<PromptHistoryQuery, PromptHistoryQueryVariables>;
export const PromptHistoriesDocument = gql`
    query PromptHistories($filter: String, $includeDemoWorkspaces: Boolean, $targetType: String, $first: Int, $last: Int, $after: ID, $before: ID) {
  promptHistories(
    filters: {filter: $filter, includeDemoWorkspaces: $includeDemoWorkspaces, targetType: $targetType}
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    edges {
      node {
        id
        workspaceID
        user {
          id
          firstName
          lastName
        }
        targetType
        targetDetails {
          employee {
            id
          }
        }
        createdAt
        featureRating {
          binaryValue
          text
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __usePromptHistoriesQuery__
 *
 * To run a query within a React component, call `usePromptHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromptHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromptHistoriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      includeDemoWorkspaces: // value for 'includeDemoWorkspaces'
 *      targetType: // value for 'targetType'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function usePromptHistoriesQuery(baseOptions?: Apollo.QueryHookOptions<PromptHistoriesQuery, PromptHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromptHistoriesQuery, PromptHistoriesQueryVariables>(PromptHistoriesDocument, options);
      }
export function usePromptHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromptHistoriesQuery, PromptHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromptHistoriesQuery, PromptHistoriesQueryVariables>(PromptHistoriesDocument, options);
        }
// @ts-ignore
export function usePromptHistoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromptHistoriesQuery, PromptHistoriesQueryVariables>): Apollo.UseSuspenseQueryResult<PromptHistoriesQuery, PromptHistoriesQueryVariables>;
export function usePromptHistoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromptHistoriesQuery, PromptHistoriesQueryVariables>): Apollo.UseSuspenseQueryResult<PromptHistoriesQuery | undefined, PromptHistoriesQueryVariables>;
export function usePromptHistoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromptHistoriesQuery, PromptHistoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromptHistoriesQuery, PromptHistoriesQueryVariables>(PromptHistoriesDocument, options);
        }
export type PromptHistoriesQueryHookResult = ReturnType<typeof usePromptHistoriesQuery>;
export type PromptHistoriesLazyQueryHookResult = ReturnType<typeof usePromptHistoriesLazyQuery>;
export type PromptHistoriesSuspenseQueryHookResult = ReturnType<typeof usePromptHistoriesSuspenseQuery>;
export type PromptHistoriesQueryResult = Apollo.QueryResult<PromptHistoriesQuery, PromptHistoriesQueryVariables>;
export const PromptHistoryAnalyticsDocument = gql`
    query PromptHistoryAnalytics($filters: PromptHistoryFilters!, $startDate: DateTime!, $endDate: DateTime!, $calendarTimeZone: String) {
  promptHistoryAnalytics(
    filters: $filters
    startDate: $startDate
    endDate: $endDate
    calendarTimeZone: $calendarTimeZone
  ) {
    totalInteractions
    uniqueUserCount
    uniqueWorkspaceCount
    dateRange {
      min
      max
    }
    byTargetType {
      targetType
      count
    }
    byWeek {
      weekKey
      weekStart
      countsByTargetType {
        targetType
        count
      }
    }
    byDay {
      dayKey
      dayStart
      countsByTargetType {
        targetType
        count
      }
    }
    byMonth {
      monthKey
      monthStart
      countsByTargetType {
        targetType
        count
      }
    }
    evaluationContext {
      asEmployeeCount
      asManagerCount
      unknownCount
    }
    feedbackByTargetType {
      targetType
      positiveCount
      negativeCount
      withWrittenFeedbackCount
      ratingWithoutWrittenFeedbackCount
    }
    feedbackTotals {
      noRatingCount
      withWrittenFeedbackCount
      ratingWithoutWrittenFeedbackCount
    }
    feedbackDetails {
      workspaceID
      targetType
      targetID
      userID
      interactionCreatedAt
      thumbsUp
      writtenFeedback
    }
    feedbackDetailsTruncated
    topWorkspaces {
      workspaceID
      interactionCount
      uniqueUserCount
    }
    usageByModel {
      model
      promptCount
      inputTokens
      cachedInputTokens
      cacheWriteTokens
      outputTokens
    }
    usageByWorkspace {
      workspaceID
      byModel {
        model
        promptCount
        inputTokens
        cachedInputTokens
        cacheWriteTokens
        outputTokens
      }
    }
  }
}
    `;

/**
 * __usePromptHistoryAnalyticsQuery__
 *
 * To run a query within a React component, call `usePromptHistoryAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromptHistoryAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromptHistoryAnalyticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      calendarTimeZone: // value for 'calendarTimeZone'
 *   },
 * });
 */
export function usePromptHistoryAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<PromptHistoryAnalyticsQuery, PromptHistoryAnalyticsQueryVariables> & ({ variables: PromptHistoryAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromptHistoryAnalyticsQuery, PromptHistoryAnalyticsQueryVariables>(PromptHistoryAnalyticsDocument, options);
      }
export function usePromptHistoryAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromptHistoryAnalyticsQuery, PromptHistoryAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromptHistoryAnalyticsQuery, PromptHistoryAnalyticsQueryVariables>(PromptHistoryAnalyticsDocument, options);
        }
// @ts-ignore
export function usePromptHistoryAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromptHistoryAnalyticsQuery, PromptHistoryAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<PromptHistoryAnalyticsQuery, PromptHistoryAnalyticsQueryVariables>;
export function usePromptHistoryAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromptHistoryAnalyticsQuery, PromptHistoryAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<PromptHistoryAnalyticsQuery | undefined, PromptHistoryAnalyticsQueryVariables>;
export function usePromptHistoryAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromptHistoryAnalyticsQuery, PromptHistoryAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromptHistoryAnalyticsQuery, PromptHistoryAnalyticsQueryVariables>(PromptHistoryAnalyticsDocument, options);
        }
export type PromptHistoryAnalyticsQueryHookResult = ReturnType<typeof usePromptHistoryAnalyticsQuery>;
export type PromptHistoryAnalyticsLazyQueryHookResult = ReturnType<typeof usePromptHistoryAnalyticsLazyQuery>;
export type PromptHistoryAnalyticsSuspenseQueryHookResult = ReturnType<typeof usePromptHistoryAnalyticsSuspenseQuery>;
export type PromptHistoryAnalyticsQueryResult = Apollo.QueryResult<PromptHistoryAnalyticsQuery, PromptHistoryAnalyticsQueryVariables>;
export const PromptHistoryExportDocument = gql`
    query PromptHistoryExport($filters: PromptHistoryFilters!, $startDate: DateTime!, $endDate: DateTime!) {
  promptHistoryExport(filters: $filters, startDate: $startDate, endDate: $endDate) {
    id
    workspaceID
    userID
    targetType
    model
    inputTokens
    outputTokens
    createdAt
  }
}
    `;

/**
 * __usePromptHistoryExportQuery__
 *
 * To run a query within a React component, call `usePromptHistoryExportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromptHistoryExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromptHistoryExportQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function usePromptHistoryExportQuery(baseOptions: Apollo.QueryHookOptions<PromptHistoryExportQuery, PromptHistoryExportQueryVariables> & ({ variables: PromptHistoryExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromptHistoryExportQuery, PromptHistoryExportQueryVariables>(PromptHistoryExportDocument, options);
      }
export function usePromptHistoryExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromptHistoryExportQuery, PromptHistoryExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromptHistoryExportQuery, PromptHistoryExportQueryVariables>(PromptHistoryExportDocument, options);
        }
// @ts-ignore
export function usePromptHistoryExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromptHistoryExportQuery, PromptHistoryExportQueryVariables>): Apollo.UseSuspenseQueryResult<PromptHistoryExportQuery, PromptHistoryExportQueryVariables>;
export function usePromptHistoryExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromptHistoryExportQuery, PromptHistoryExportQueryVariables>): Apollo.UseSuspenseQueryResult<PromptHistoryExportQuery | undefined, PromptHistoryExportQueryVariables>;
export function usePromptHistoryExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromptHistoryExportQuery, PromptHistoryExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromptHistoryExportQuery, PromptHistoryExportQueryVariables>(PromptHistoryExportDocument, options);
        }
export type PromptHistoryExportQueryHookResult = ReturnType<typeof usePromptHistoryExportQuery>;
export type PromptHistoryExportLazyQueryHookResult = ReturnType<typeof usePromptHistoryExportLazyQuery>;
export type PromptHistoryExportSuspenseQueryHookResult = ReturnType<typeof usePromptHistoryExportSuspenseQuery>;
export type PromptHistoryExportQueryResult = Apollo.QueryResult<PromptHistoryExportQuery, PromptHistoryExportQueryVariables>;
export const PromptInstructionDocument = gql`
    query PromptInstruction($workspaceID: ID!, $promptInstructionID: Prompt!) {
  promptInstruction(
    workspaceID: $workspaceID
    promptInstructionID: $promptInstructionID
  ) {
    id
    workspaceID
    promptInstructionID
    instructions
  }
}
    `;

/**
 * __usePromptInstructionQuery__
 *
 * To run a query within a React component, call `usePromptInstructionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromptInstructionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromptInstructionQuery({
 *   variables: {
 *      workspaceID: // value for 'workspaceID'
 *      promptInstructionID: // value for 'promptInstructionID'
 *   },
 * });
 */
export function usePromptInstructionQuery(baseOptions: Apollo.QueryHookOptions<PromptInstructionQuery, PromptInstructionQueryVariables> & ({ variables: PromptInstructionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromptInstructionQuery, PromptInstructionQueryVariables>(PromptInstructionDocument, options);
      }
export function usePromptInstructionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromptInstructionQuery, PromptInstructionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromptInstructionQuery, PromptInstructionQueryVariables>(PromptInstructionDocument, options);
        }
// @ts-ignore
export function usePromptInstructionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromptInstructionQuery, PromptInstructionQueryVariables>): Apollo.UseSuspenseQueryResult<PromptInstructionQuery, PromptInstructionQueryVariables>;
export function usePromptInstructionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromptInstructionQuery, PromptInstructionQueryVariables>): Apollo.UseSuspenseQueryResult<PromptInstructionQuery | undefined, PromptInstructionQueryVariables>;
export function usePromptInstructionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromptInstructionQuery, PromptInstructionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromptInstructionQuery, PromptInstructionQueryVariables>(PromptInstructionDocument, options);
        }
export type PromptInstructionQueryHookResult = ReturnType<typeof usePromptInstructionQuery>;
export type PromptInstructionLazyQueryHookResult = ReturnType<typeof usePromptInstructionLazyQuery>;
export type PromptInstructionSuspenseQueryHookResult = ReturnType<typeof usePromptInstructionSuspenseQuery>;
export type PromptInstructionQueryResult = Apollo.QueryResult<PromptInstructionQuery, PromptInstructionQueryVariables>;
export const WorkspacePromptInstructionDocument = gql`
    query WorkspacePromptInstruction {
  workspacePromptInstruction {
    instructions
  }
}
    `;

/**
 * __useWorkspacePromptInstructionQuery__
 *
 * To run a query within a React component, call `useWorkspacePromptInstructionQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspacePromptInstructionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspacePromptInstructionQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspacePromptInstructionQuery(baseOptions?: Apollo.QueryHookOptions<WorkspacePromptInstructionQuery, WorkspacePromptInstructionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspacePromptInstructionQuery, WorkspacePromptInstructionQueryVariables>(WorkspacePromptInstructionDocument, options);
      }
export function useWorkspacePromptInstructionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspacePromptInstructionQuery, WorkspacePromptInstructionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspacePromptInstructionQuery, WorkspacePromptInstructionQueryVariables>(WorkspacePromptInstructionDocument, options);
        }
// @ts-ignore
export function useWorkspacePromptInstructionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspacePromptInstructionQuery, WorkspacePromptInstructionQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspacePromptInstructionQuery, WorkspacePromptInstructionQueryVariables>;
export function useWorkspacePromptInstructionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspacePromptInstructionQuery, WorkspacePromptInstructionQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspacePromptInstructionQuery | undefined, WorkspacePromptInstructionQueryVariables>;
export function useWorkspacePromptInstructionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspacePromptInstructionQuery, WorkspacePromptInstructionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspacePromptInstructionQuery, WorkspacePromptInstructionQueryVariables>(WorkspacePromptInstructionDocument, options);
        }
export type WorkspacePromptInstructionQueryHookResult = ReturnType<typeof useWorkspacePromptInstructionQuery>;
export type WorkspacePromptInstructionLazyQueryHookResult = ReturnType<typeof useWorkspacePromptInstructionLazyQuery>;
export type WorkspacePromptInstructionSuspenseQueryHookResult = ReturnType<typeof useWorkspacePromptInstructionSuspenseQuery>;
export type WorkspacePromptInstructionQueryResult = Apollo.QueryResult<WorkspacePromptInstructionQuery, WorkspacePromptInstructionQueryVariables>;
export const AnalyticsDocument = gql`
    query Analytics($type: AnalyticsType!, $filters: AnalyticsFiltersV2!) {
  analytics(type: $type, filters: $filters) {
    totalUsers
    metricGroups {
      id
      metrics {
        ... on AnalyticsFloatMetric {
          id
          float
          threshold
        }
        ... on AnalyticsIntegerMetric {
          id
          integer
          threshold
        }
        ... on AnalyticsPercentageMetric {
          id
          percentage
          threshold
        }
        ... on AnalyticsGraphMetric {
          id
          min
          max
          datapoints {
            timestamp
            value
          }
        }
        ... on AnalyticsFractionMetric {
          id
          value
          total
          threshold
        }
        ... on AnalyticsConversationsMetric {
          id
          threshold
          templates {
            template {
              id
              title
            }
            value
            total
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAnalyticsQuery__
 *
 * To run a query within a React component, call `useAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables> & ({ variables: AnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, options);
      }
export function useAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, options);
        }
// @ts-ignore
export function useAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsQuery, AnalyticsQueryVariables>;
export function useAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsQuery | undefined, AnalyticsQueryVariables>;
export function useAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, options);
        }
export type AnalyticsQueryHookResult = ReturnType<typeof useAnalyticsQuery>;
export type AnalyticsLazyQueryHookResult = ReturnType<typeof useAnalyticsLazyQuery>;
export type AnalyticsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsSuspenseQuery>;
export type AnalyticsQueryResult = Apollo.QueryResult<AnalyticsQuery, AnalyticsQueryVariables>;
export const AnalyticsMetricDocument = gql`
    query AnalyticsMetric($type: AnalyticsType!, $filters: AnalyticsFiltersV2!, $metricGroupID: ID!, $metricID: ID!) {
  analytics(type: $type, filters: $filters) {
    totalUsers
    metricGroup(id: $metricGroupID) {
      id
      metric(id: $metricID) {
        ... on AnalyticsFloatMetric {
          id
          details
          float
          threshold
        }
        ... on AnalyticsIntegerMetric {
          id
          details
          integer
          threshold
        }
        ... on AnalyticsPercentageMetric {
          id
          details
          percentage
          threshold
        }
        ... on AnalyticsGraphMetric {
          id
          min
          max
          datapoints {
            timestamp
            value
          }
        }
        ... on AnalyticsFractionMetric {
          id
          details
          value
          total
          threshold
        }
        ... on AnalyticsConversationsMetric {
          id
          threshold
          templates {
            template {
              id
              title
            }
            value
            total
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAnalyticsMetricQuery__
 *
 * To run a query within a React component, call `useAnalyticsMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsMetricQuery({
 *   variables: {
 *      type: // value for 'type'
 *      filters: // value for 'filters'
 *      metricGroupID: // value for 'metricGroupID'
 *      metricID: // value for 'metricID'
 *   },
 * });
 */
export function useAnalyticsMetricQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsMetricQuery, AnalyticsMetricQueryVariables> & ({ variables: AnalyticsMetricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsMetricQuery, AnalyticsMetricQueryVariables>(AnalyticsMetricDocument, options);
      }
export function useAnalyticsMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsMetricQuery, AnalyticsMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsMetricQuery, AnalyticsMetricQueryVariables>(AnalyticsMetricDocument, options);
        }
// @ts-ignore
export function useAnalyticsMetricSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AnalyticsMetricQuery, AnalyticsMetricQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsMetricQuery, AnalyticsMetricQueryVariables>;
export function useAnalyticsMetricSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsMetricQuery, AnalyticsMetricQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsMetricQuery | undefined, AnalyticsMetricQueryVariables>;
export function useAnalyticsMetricSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsMetricQuery, AnalyticsMetricQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsMetricQuery, AnalyticsMetricQueryVariables>(AnalyticsMetricDocument, options);
        }
export type AnalyticsMetricQueryHookResult = ReturnType<typeof useAnalyticsMetricQuery>;
export type AnalyticsMetricLazyQueryHookResult = ReturnType<typeof useAnalyticsMetricLazyQuery>;
export type AnalyticsMetricSuspenseQueryHookResult = ReturnType<typeof useAnalyticsMetricSuspenseQuery>;
export type AnalyticsMetricQueryResult = Apollo.QueryResult<AnalyticsMetricQuery, AnalyticsMetricQueryVariables>;
export const AnalyticsMetricDetailsDocument = gql`
    query AnalyticsMetricDetails($type: AnalyticsType!, $filters: AnalyticsFiltersV2!, $id: ID!) {
  analytics(type: $type, filters: $filters) {
    detailTableList(id: $id) {
      id
      title
    }
  }
}
    `;

/**
 * __useAnalyticsMetricDetailsQuery__
 *
 * To run a query within a React component, call `useAnalyticsMetricDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsMetricDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsMetricDetailsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      filters: // value for 'filters'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnalyticsMetricDetailsQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsMetricDetailsQuery, AnalyticsMetricDetailsQueryVariables> & ({ variables: AnalyticsMetricDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsMetricDetailsQuery, AnalyticsMetricDetailsQueryVariables>(AnalyticsMetricDetailsDocument, options);
      }
export function useAnalyticsMetricDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsMetricDetailsQuery, AnalyticsMetricDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsMetricDetailsQuery, AnalyticsMetricDetailsQueryVariables>(AnalyticsMetricDetailsDocument, options);
        }
// @ts-ignore
export function useAnalyticsMetricDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AnalyticsMetricDetailsQuery, AnalyticsMetricDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsMetricDetailsQuery, AnalyticsMetricDetailsQueryVariables>;
export function useAnalyticsMetricDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsMetricDetailsQuery, AnalyticsMetricDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsMetricDetailsQuery | undefined, AnalyticsMetricDetailsQueryVariables>;
export function useAnalyticsMetricDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsMetricDetailsQuery, AnalyticsMetricDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsMetricDetailsQuery, AnalyticsMetricDetailsQueryVariables>(AnalyticsMetricDetailsDocument, options);
        }
export type AnalyticsMetricDetailsQueryHookResult = ReturnType<typeof useAnalyticsMetricDetailsQuery>;
export type AnalyticsMetricDetailsLazyQueryHookResult = ReturnType<typeof useAnalyticsMetricDetailsLazyQuery>;
export type AnalyticsMetricDetailsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsMetricDetailsSuspenseQuery>;
export type AnalyticsMetricDetailsQueryResult = Apollo.QueryResult<AnalyticsMetricDetailsQuery, AnalyticsMetricDetailsQueryVariables>;
export const AnalyticsMetricDetailsTableDocument = gql`
    query AnalyticsMetricDetailsTable($type: AnalyticsType!, $filters: AnalyticsFiltersV2!, $id: ID!, $pageIndex: Int!, $pageSize: Int, $sortBy: String, $sortOrder: AnalyticsDetailSortOrder, $tableID: ID!) {
  analytics(type: $type, filters: $filters) {
    detail(
      id: $id
      pageIndex: $pageIndex
      pageSize: $pageSize
      sortBy: $sortBy
      sortOrder: $sortOrder
      tableID: $tableID
    ) {
      id
      headers {
        key
        value
        label
        type
        sortable
        detailViewOnly
      }
      rows {
        columns {
          key
          value {
            __typename
            ... on AnalyticsDetailInt {
              integer
            }
            ... on AnalyticsDetailFloat {
              float
            }
            ... on AnalyticsDetailPercentage {
              percentage
            }
            ... on AnalyticsDetailFraction {
              value
              total
            }
            ... on AnalyticsDetailText {
              text
            }
            ... on AnalyticsDetailDate {
              date
            }
            ... on User {
              id
              firstName
              lastName
              fullName
              avatar {
                source {
                  url
                }
              }
            }
            ... on Group {
              id
              name
            }
            ... on JobTitle {
              id
              title
            }
            ... on FeedbackRequest {
              id
              feedbackTitle: title
              dueDate
              createdAt
            }
            ... on FeedbackQuestionCategory {
              id
              categoryName: name
            }
            ... on Goal {
              id
              title
              createdAt
            }
            ... on EvaluationForm {
              id
              title
            }
            ... on EvaluationSubmission {
              id
              createdAt
            }
            ... on LearningEvent {
              id
              title
              startDate
              createdAt
            }
            ... on AnalyticsDetailList {
              items {
                __typename
                ... on AnalyticsDetailInt {
                  integer
                }
                ... on AnalyticsDetailFloat {
                  float
                }
                ... on AnalyticsDetailPercentage {
                  percentage
                }
                ... on AnalyticsDetailFraction {
                  value
                  total
                }
                ... on AnalyticsDetailText {
                  text
                }
                ... on AnalyticsDetailDate {
                  date
                }
                ... on User {
                  id
                  firstName
                  lastName
                  fullName
                  avatar {
                    source {
                      url
                    }
                  }
                }
                ... on Group {
                  id
                  name
                }
                ... on FeedbackRequest {
                  id
                  feedbackTitle: title
                  dueDate
                  createdAt
                }
                ... on FeedbackQuestionCategory {
                  id
                  categoryName: name
                }
                ... on Goal {
                  id
                  title
                  createdAt
                }
                ... on EvaluationForm {
                  id
                  title
                }
                ... on EvaluationSubmission {
                  id
                  createdAt
                }
                ... on LearningEvent {
                  id
                  title
                  startDate
                  createdAt
                }
              }
            }
          }
        }
      }
      totalRows
      pageIndex
      pageSize
      sortBy
      sortOrder
    }
  }
}
    `;

/**
 * __useAnalyticsMetricDetailsTableQuery__
 *
 * To run a query within a React component, call `useAnalyticsMetricDetailsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsMetricDetailsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsMetricDetailsTableQuery({
 *   variables: {
 *      type: // value for 'type'
 *      filters: // value for 'filters'
 *      id: // value for 'id'
 *      pageIndex: // value for 'pageIndex'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      tableID: // value for 'tableID'
 *   },
 * });
 */
export function useAnalyticsMetricDetailsTableQuery(baseOptions: Apollo.QueryHookOptions<AnalyticsMetricDetailsTableQuery, AnalyticsMetricDetailsTableQueryVariables> & ({ variables: AnalyticsMetricDetailsTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsMetricDetailsTableQuery, AnalyticsMetricDetailsTableQueryVariables>(AnalyticsMetricDetailsTableDocument, options);
      }
export function useAnalyticsMetricDetailsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsMetricDetailsTableQuery, AnalyticsMetricDetailsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsMetricDetailsTableQuery, AnalyticsMetricDetailsTableQueryVariables>(AnalyticsMetricDetailsTableDocument, options);
        }
// @ts-ignore
export function useAnalyticsMetricDetailsTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AnalyticsMetricDetailsTableQuery, AnalyticsMetricDetailsTableQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsMetricDetailsTableQuery, AnalyticsMetricDetailsTableQueryVariables>;
export function useAnalyticsMetricDetailsTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsMetricDetailsTableQuery, AnalyticsMetricDetailsTableQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyticsMetricDetailsTableQuery | undefined, AnalyticsMetricDetailsTableQueryVariables>;
export function useAnalyticsMetricDetailsTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsMetricDetailsTableQuery, AnalyticsMetricDetailsTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsMetricDetailsTableQuery, AnalyticsMetricDetailsTableQueryVariables>(AnalyticsMetricDetailsTableDocument, options);
        }
export type AnalyticsMetricDetailsTableQueryHookResult = ReturnType<typeof useAnalyticsMetricDetailsTableQuery>;
export type AnalyticsMetricDetailsTableLazyQueryHookResult = ReturnType<typeof useAnalyticsMetricDetailsTableLazyQuery>;
export type AnalyticsMetricDetailsTableSuspenseQueryHookResult = ReturnType<typeof useAnalyticsMetricDetailsTableSuspenseQuery>;
export type AnalyticsMetricDetailsTableQueryResult = Apollo.QueryResult<AnalyticsMetricDetailsTableQuery, AnalyticsMetricDetailsTableQueryVariables>;
export const CreateAnnouncementDocument = gql`
    mutation CreateAnnouncement($input: CreateAnnouncementInput!) {
  createAnnouncement(input: $input) {
    announcement {
      ...AnnouncementFragment
    }
  }
}
    ${AnnouncementFragmentFragmentDoc}`;
export type CreateAnnouncementMutationFn = Apollo.MutationFunction<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;

/**
 * __useCreateAnnouncementMutation__
 *
 * To run a mutation, you first call `useCreateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnouncementMutation, { data, loading, error }] = useCreateAnnouncementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>(CreateAnnouncementDocument, options);
      }
export type CreateAnnouncementMutationHookResult = ReturnType<typeof useCreateAnnouncementMutation>;
export type CreateAnnouncementMutationResult = Apollo.MutationResult<CreateAnnouncementMutation>;
export type CreateAnnouncementMutationOptions = Apollo.BaseMutationOptions<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;
export const DeleteAnnouncementDocument = gql`
    mutation DeleteAnnouncement($input: DeleteAnnouncementInput!) {
  deleteAnnouncement(input: $input) {
    success
  }
}
    `;
export type DeleteAnnouncementMutationFn = Apollo.MutationFunction<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>;

/**
 * __useDeleteAnnouncementMutation__
 *
 * To run a mutation, you first call `useDeleteAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnouncementMutation, { data, loading, error }] = useDeleteAnnouncementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>(DeleteAnnouncementDocument, options);
      }
export type DeleteAnnouncementMutationHookResult = ReturnType<typeof useDeleteAnnouncementMutation>;
export type DeleteAnnouncementMutationResult = Apollo.MutationResult<DeleteAnnouncementMutation>;
export type DeleteAnnouncementMutationOptions = Apollo.BaseMutationOptions<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>;
export const MarkAnnouncementAsReadDocument = gql`
    mutation MarkAnnouncementAsRead($input: MarkAnnouncementAsReadInput!) {
  markAnnouncementAsRead(input: $input) {
    announcement {
      ...AnnouncementFragment
    }
  }
}
    ${AnnouncementFragmentFragmentDoc}`;
export type MarkAnnouncementAsReadMutationFn = Apollo.MutationFunction<MarkAnnouncementAsReadMutation, MarkAnnouncementAsReadMutationVariables>;

/**
 * __useMarkAnnouncementAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAnnouncementAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAnnouncementAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAnnouncementAsReadMutation, { data, loading, error }] = useMarkAnnouncementAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkAnnouncementAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAnnouncementAsReadMutation, MarkAnnouncementAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAnnouncementAsReadMutation, MarkAnnouncementAsReadMutationVariables>(MarkAnnouncementAsReadDocument, options);
      }
export type MarkAnnouncementAsReadMutationHookResult = ReturnType<typeof useMarkAnnouncementAsReadMutation>;
export type MarkAnnouncementAsReadMutationResult = Apollo.MutationResult<MarkAnnouncementAsReadMutation>;
export type MarkAnnouncementAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAnnouncementAsReadMutation, MarkAnnouncementAsReadMutationVariables>;
export const UpdateAnnouncementDocument = gql`
    mutation UpdateAnnouncement($input: UpdateAnnouncementInput!) {
  updateAnnouncement(input: $input) {
    announcement {
      ...AnnouncementFragment
    }
  }
}
    ${AnnouncementFragmentFragmentDoc}`;
export type UpdateAnnouncementMutationFn = Apollo.MutationFunction<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>;

/**
 * __useUpdateAnnouncementMutation__
 *
 * To run a mutation, you first call `useUpdateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnnouncementMutation, { data, loading, error }] = useUpdateAnnouncementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>(UpdateAnnouncementDocument, options);
      }
export type UpdateAnnouncementMutationHookResult = ReturnType<typeof useUpdateAnnouncementMutation>;
export type UpdateAnnouncementMutationResult = Apollo.MutationResult<UpdateAnnouncementMutation>;
export type UpdateAnnouncementMutationOptions = Apollo.BaseMutationOptions<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>;
export const AnnouncementDocument = gql`
    query Announcement($id: ID!) {
  announcement(id: $id) {
    ...AnnouncementFragment
  }
}
    ${AnnouncementFragmentFragmentDoc}`;

/**
 * __useAnnouncementQuery__
 *
 * To run a query within a React component, call `useAnnouncementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnnouncementQuery(baseOptions: Apollo.QueryHookOptions<AnnouncementQuery, AnnouncementQueryVariables> & ({ variables: AnnouncementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnnouncementQuery, AnnouncementQueryVariables>(AnnouncementDocument, options);
      }
export function useAnnouncementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementQuery, AnnouncementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnnouncementQuery, AnnouncementQueryVariables>(AnnouncementDocument, options);
        }
// @ts-ignore
export function useAnnouncementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementQuery, AnnouncementQueryVariables>): Apollo.UseSuspenseQueryResult<AnnouncementQuery, AnnouncementQueryVariables>;
export function useAnnouncementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnnouncementQuery, AnnouncementQueryVariables>): Apollo.UseSuspenseQueryResult<AnnouncementQuery | undefined, AnnouncementQueryVariables>;
export function useAnnouncementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnnouncementQuery, AnnouncementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnnouncementQuery, AnnouncementQueryVariables>(AnnouncementDocument, options);
        }
export type AnnouncementQueryHookResult = ReturnType<typeof useAnnouncementQuery>;
export type AnnouncementLazyQueryHookResult = ReturnType<typeof useAnnouncementLazyQuery>;
export type AnnouncementSuspenseQueryHookResult = ReturnType<typeof useAnnouncementSuspenseQuery>;
export type AnnouncementQueryResult = Apollo.QueryResult<AnnouncementQuery, AnnouncementQueryVariables>;
export const AnnouncementsDocument = gql`
    query Announcements($displayType: AnnouncementDisplayType, $first: Int, $last: Int, $before: ID, $after: ID) {
  announcements(
    displayType: $displayType
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    edges {
      node {
        ...AnnouncementFragment
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${AnnouncementFragmentFragmentDoc}`;

/**
 * __useAnnouncementsQuery__
 *
 * To run a query within a React component, call `useAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementsQuery({
 *   variables: {
 *      displayType: // value for 'displayType'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAnnouncementsQuery(baseOptions?: Apollo.QueryHookOptions<AnnouncementsQuery, AnnouncementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnnouncementsQuery, AnnouncementsQueryVariables>(AnnouncementsDocument, options);
      }
export function useAnnouncementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementsQuery, AnnouncementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnnouncementsQuery, AnnouncementsQueryVariables>(AnnouncementsDocument, options);
        }
// @ts-ignore
export function useAnnouncementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementsQuery, AnnouncementsQueryVariables>): Apollo.UseSuspenseQueryResult<AnnouncementsQuery, AnnouncementsQueryVariables>;
export function useAnnouncementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnnouncementsQuery, AnnouncementsQueryVariables>): Apollo.UseSuspenseQueryResult<AnnouncementsQuery | undefined, AnnouncementsQueryVariables>;
export function useAnnouncementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnnouncementsQuery, AnnouncementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnnouncementsQuery, AnnouncementsQueryVariables>(AnnouncementsDocument, options);
        }
export type AnnouncementsQueryHookResult = ReturnType<typeof useAnnouncementsQuery>;
export type AnnouncementsLazyQueryHookResult = ReturnType<typeof useAnnouncementsLazyQuery>;
export type AnnouncementsSuspenseQueryHookResult = ReturnType<typeof useAnnouncementsSuspenseQuery>;
export type AnnouncementsQueryResult = Apollo.QueryResult<AnnouncementsQuery, AnnouncementsQueryVariables>;
export const AssignRoleDocument = gql`
    mutation AssignRole($input: AssignRoleInput!) {
  assignRole(input: $input) {
    user {
      id
      roles {
        id
        role {
          id
          type
        }
        target {
          type
          targetID
        }
      }
    }
  }
}
    `;
export type AssignRoleMutationFn = Apollo.MutationFunction<AssignRoleMutation, AssignRoleMutationVariables>;

/**
 * __useAssignRoleMutation__
 *
 * To run a mutation, you first call `useAssignRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignRoleMutation, { data, loading, error }] = useAssignRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignRoleMutation(baseOptions?: Apollo.MutationHookOptions<AssignRoleMutation, AssignRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignRoleMutation, AssignRoleMutationVariables>(AssignRoleDocument, options);
      }
export type AssignRoleMutationHookResult = ReturnType<typeof useAssignRoleMutation>;
export type AssignRoleMutationResult = Apollo.MutationResult<AssignRoleMutation>;
export type AssignRoleMutationOptions = Apollo.BaseMutationOptions<AssignRoleMutation, AssignRoleMutationVariables>;
export const AssociateIdentityDocument = gql`
    mutation AssociateIdentity($input: AssociateIdentityInput!) {
  associateIdentity(input: $input) {
    user {
      id
      associatedIdentities {
        identityProvider {
          id
        }
        name
      }
    }
  }
}
    `;
export type AssociateIdentityMutationFn = Apollo.MutationFunction<AssociateIdentityMutation, AssociateIdentityMutationVariables>;

/**
 * __useAssociateIdentityMutation__
 *
 * To run a mutation, you first call `useAssociateIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateIdentityMutation, { data, loading, error }] = useAssociateIdentityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssociateIdentityMutation(baseOptions?: Apollo.MutationHookOptions<AssociateIdentityMutation, AssociateIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateIdentityMutation, AssociateIdentityMutationVariables>(AssociateIdentityDocument, options);
      }
export type AssociateIdentityMutationHookResult = ReturnType<typeof useAssociateIdentityMutation>;
export type AssociateIdentityMutationResult = Apollo.MutationResult<AssociateIdentityMutation>;
export type AssociateIdentityMutationOptions = Apollo.BaseMutationOptions<AssociateIdentityMutation, AssociateIdentityMutationVariables>;
export const ConfirmForgotPasswordDocument = gql`
    mutation ConfirmForgotPassword($input: ConfirmForgotPasswordInput!) {
  confirmForgotPassword(input: $input) {
    success
  }
}
    `;
export type ConfirmForgotPasswordMutationFn = Apollo.MutationFunction<ConfirmForgotPasswordMutation, ConfirmForgotPasswordMutationVariables>;

/**
 * __useConfirmForgotPasswordMutation__
 *
 * To run a mutation, you first call `useConfirmForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmForgotPasswordMutation, { data, loading, error }] = useConfirmForgotPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmForgotPasswordMutation, ConfirmForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmForgotPasswordMutation, ConfirmForgotPasswordMutationVariables>(ConfirmForgotPasswordDocument, options);
      }
export type ConfirmForgotPasswordMutationHookResult = ReturnType<typeof useConfirmForgotPasswordMutation>;
export type ConfirmForgotPasswordMutationResult = Apollo.MutationResult<ConfirmForgotPasswordMutation>;
export type ConfirmForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ConfirmForgotPasswordMutation, ConfirmForgotPasswordMutationVariables>;
export const ConsumeOAuth2CodeDocument = gql`
    mutation ConsumeOAuth2Code($input: ConnectorConsumeOAuth2CodeInput!) {
  connectorConsumeOAuth2Code(input: $input) {
    type
    isActive
    authorizationInfo
    authorizeUrl
  }
}
    `;
export type ConsumeOAuth2CodeMutationFn = Apollo.MutationFunction<ConsumeOAuth2CodeMutation, ConsumeOAuth2CodeMutationVariables>;

/**
 * __useConsumeOAuth2CodeMutation__
 *
 * To run a mutation, you first call `useConsumeOAuth2CodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumeOAuth2CodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumeOAuth2CodeMutation, { data, loading, error }] = useConsumeOAuth2CodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsumeOAuth2CodeMutation(baseOptions?: Apollo.MutationHookOptions<ConsumeOAuth2CodeMutation, ConsumeOAuth2CodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumeOAuth2CodeMutation, ConsumeOAuth2CodeMutationVariables>(ConsumeOAuth2CodeDocument, options);
      }
export type ConsumeOAuth2CodeMutationHookResult = ReturnType<typeof useConsumeOAuth2CodeMutation>;
export type ConsumeOAuth2CodeMutationResult = Apollo.MutationResult<ConsumeOAuth2CodeMutation>;
export type ConsumeOAuth2CodeMutationOptions = Apollo.BaseMutationOptions<ConsumeOAuth2CodeMutation, ConsumeOAuth2CodeMutationVariables>;
export const CreateIdentityProviderDocument = gql`
    mutation CreateIdentityProvider($input: CreateIdentityProviderInput!) {
  createIdentityProvider(input: $input) {
    provider {
      id
    }
  }
}
    `;
export type CreateIdentityProviderMutationFn = Apollo.MutationFunction<CreateIdentityProviderMutation, CreateIdentityProviderMutationVariables>;

/**
 * __useCreateIdentityProviderMutation__
 *
 * To run a mutation, you first call `useCreateIdentityProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIdentityProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIdentityProviderMutation, { data, loading, error }] = useCreateIdentityProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIdentityProviderMutation(baseOptions?: Apollo.MutationHookOptions<CreateIdentityProviderMutation, CreateIdentityProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIdentityProviderMutation, CreateIdentityProviderMutationVariables>(CreateIdentityProviderDocument, options);
      }
export type CreateIdentityProviderMutationHookResult = ReturnType<typeof useCreateIdentityProviderMutation>;
export type CreateIdentityProviderMutationResult = Apollo.MutationResult<CreateIdentityProviderMutation>;
export type CreateIdentityProviderMutationOptions = Apollo.BaseMutationOptions<CreateIdentityProviderMutation, CreateIdentityProviderMutationVariables>;
export const CreatePersonalAccessTokenDocument = gql`
    mutation CreatePersonalAccessToken($password: String!) {
  createPersonalAccessToken(password: $password) {
    id
    token
  }
}
    `;
export type CreatePersonalAccessTokenMutationFn = Apollo.MutationFunction<CreatePersonalAccessTokenMutation, CreatePersonalAccessTokenMutationVariables>;

/**
 * __useCreatePersonalAccessTokenMutation__
 *
 * To run a mutation, you first call `useCreatePersonalAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonalAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonalAccessTokenMutation, { data, loading, error }] = useCreatePersonalAccessTokenMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCreatePersonalAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreatePersonalAccessTokenMutation, CreatePersonalAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePersonalAccessTokenMutation, CreatePersonalAccessTokenMutationVariables>(CreatePersonalAccessTokenDocument, options);
      }
export type CreatePersonalAccessTokenMutationHookResult = ReturnType<typeof useCreatePersonalAccessTokenMutation>;
export type CreatePersonalAccessTokenMutationResult = Apollo.MutationResult<CreatePersonalAccessTokenMutation>;
export type CreatePersonalAccessTokenMutationOptions = Apollo.BaseMutationOptions<CreatePersonalAccessTokenMutation, CreatePersonalAccessTokenMutationVariables>;
export const CreateTemporarySessionTokenDocument = gql`
    mutation CreateTemporarySessionToken($input: TemporarySessionTokenInput!) {
  createTemporarySessionToken(input: $input) {
    workspaceID
    userID
    tokenID
    expiresAt
  }
}
    `;
export type CreateTemporarySessionTokenMutationFn = Apollo.MutationFunction<CreateTemporarySessionTokenMutation, CreateTemporarySessionTokenMutationVariables>;

/**
 * __useCreateTemporarySessionTokenMutation__
 *
 * To run a mutation, you first call `useCreateTemporarySessionTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemporarySessionTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemporarySessionTokenMutation, { data, loading, error }] = useCreateTemporarySessionTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTemporarySessionTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemporarySessionTokenMutation, CreateTemporarySessionTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemporarySessionTokenMutation, CreateTemporarySessionTokenMutationVariables>(CreateTemporarySessionTokenDocument, options);
      }
export type CreateTemporarySessionTokenMutationHookResult = ReturnType<typeof useCreateTemporarySessionTokenMutation>;
export type CreateTemporarySessionTokenMutationResult = Apollo.MutationResult<CreateTemporarySessionTokenMutation>;
export type CreateTemporarySessionTokenMutationOptions = Apollo.BaseMutationOptions<CreateTemporarySessionTokenMutation, CreateTemporarySessionTokenMutationVariables>;
export const DeleteIdentityProviderDocument = gql`
    mutation DeleteIdentityProvider($input: DeleteIdentityProviderInput!) {
  deleteIdentityProvider(input: $input) {
    success
  }
}
    `;
export type DeleteIdentityProviderMutationFn = Apollo.MutationFunction<DeleteIdentityProviderMutation, DeleteIdentityProviderMutationVariables>;

/**
 * __useDeleteIdentityProviderMutation__
 *
 * To run a mutation, you first call `useDeleteIdentityProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIdentityProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIdentityProviderMutation, { data, loading, error }] = useDeleteIdentityProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteIdentityProviderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIdentityProviderMutation, DeleteIdentityProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIdentityProviderMutation, DeleteIdentityProviderMutationVariables>(DeleteIdentityProviderDocument, options);
      }
export type DeleteIdentityProviderMutationHookResult = ReturnType<typeof useDeleteIdentityProviderMutation>;
export type DeleteIdentityProviderMutationResult = Apollo.MutationResult<DeleteIdentityProviderMutation>;
export type DeleteIdentityProviderMutationOptions = Apollo.BaseMutationOptions<DeleteIdentityProviderMutation, DeleteIdentityProviderMutationVariables>;
export const DisassociateIdentityDocument = gql`
    mutation DisassociateIdentity($input: DisassociateIdentityInput!) {
  disassociateIdentity(input: $input) {
    user {
      id
      associatedIdentities {
        identityProvider {
          id
        }
        name
      }
    }
  }
}
    `;
export type DisassociateIdentityMutationFn = Apollo.MutationFunction<DisassociateIdentityMutation, DisassociateIdentityMutationVariables>;

/**
 * __useDisassociateIdentityMutation__
 *
 * To run a mutation, you first call `useDisassociateIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisassociateIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disassociateIdentityMutation, { data, loading, error }] = useDisassociateIdentityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisassociateIdentityMutation(baseOptions?: Apollo.MutationHookOptions<DisassociateIdentityMutation, DisassociateIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisassociateIdentityMutation, DisassociateIdentityMutationVariables>(DisassociateIdentityDocument, options);
      }
export type DisassociateIdentityMutationHookResult = ReturnType<typeof useDisassociateIdentityMutation>;
export type DisassociateIdentityMutationResult = Apollo.MutationResult<DisassociateIdentityMutation>;
export type DisassociateIdentityMutationOptions = Apollo.BaseMutationOptions<DisassociateIdentityMutation, DisassociateIdentityMutationVariables>;
export const EnsureAssociatedIdentitiesDocument = gql`
    mutation EnsureAssociatedIdentities($input: EnsureAssociatedIdentitiesInput!) {
  ensureAssociatedIdentities(input: $input) {
    user {
      id
      associatedIdentities {
        identityProvider {
          id
        }
        name
      }
    }
  }
}
    `;
export type EnsureAssociatedIdentitiesMutationFn = Apollo.MutationFunction<EnsureAssociatedIdentitiesMutation, EnsureAssociatedIdentitiesMutationVariables>;

/**
 * __useEnsureAssociatedIdentitiesMutation__
 *
 * To run a mutation, you first call `useEnsureAssociatedIdentitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnsureAssociatedIdentitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ensureAssociatedIdentitiesMutation, { data, loading, error }] = useEnsureAssociatedIdentitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnsureAssociatedIdentitiesMutation(baseOptions?: Apollo.MutationHookOptions<EnsureAssociatedIdentitiesMutation, EnsureAssociatedIdentitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnsureAssociatedIdentitiesMutation, EnsureAssociatedIdentitiesMutationVariables>(EnsureAssociatedIdentitiesDocument, options);
      }
export type EnsureAssociatedIdentitiesMutationHookResult = ReturnType<typeof useEnsureAssociatedIdentitiesMutation>;
export type EnsureAssociatedIdentitiesMutationResult = Apollo.MutationResult<EnsureAssociatedIdentitiesMutation>;
export type EnsureAssociatedIdentitiesMutationOptions = Apollo.BaseMutationOptions<EnsureAssociatedIdentitiesMutation, EnsureAssociatedIdentitiesMutationVariables>;
export const EnsureSupportAssociatedIdentitiesDocument = gql`
    mutation EnsureSupportAssociatedIdentities($input: EnsureSupportAssociatedIdentitiesInput!) {
  ensureSupportAssociatedIdentities(input: $input) {
    workspace {
      user(username: "support") {
        id
        associatedIdentities {
          identityProvider {
            id
          }
          name
        }
      }
    }
  }
}
    `;
export type EnsureSupportAssociatedIdentitiesMutationFn = Apollo.MutationFunction<EnsureSupportAssociatedIdentitiesMutation, EnsureSupportAssociatedIdentitiesMutationVariables>;

/**
 * __useEnsureSupportAssociatedIdentitiesMutation__
 *
 * To run a mutation, you first call `useEnsureSupportAssociatedIdentitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnsureSupportAssociatedIdentitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ensureSupportAssociatedIdentitiesMutation, { data, loading, error }] = useEnsureSupportAssociatedIdentitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnsureSupportAssociatedIdentitiesMutation(baseOptions?: Apollo.MutationHookOptions<EnsureSupportAssociatedIdentitiesMutation, EnsureSupportAssociatedIdentitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnsureSupportAssociatedIdentitiesMutation, EnsureSupportAssociatedIdentitiesMutationVariables>(EnsureSupportAssociatedIdentitiesDocument, options);
      }
export type EnsureSupportAssociatedIdentitiesMutationHookResult = ReturnType<typeof useEnsureSupportAssociatedIdentitiesMutation>;
export type EnsureSupportAssociatedIdentitiesMutationResult = Apollo.MutationResult<EnsureSupportAssociatedIdentitiesMutation>;
export type EnsureSupportAssociatedIdentitiesMutationOptions = Apollo.BaseMutationOptions<EnsureSupportAssociatedIdentitiesMutation, EnsureSupportAssociatedIdentitiesMutationVariables>;
export const ExchangePersonalAccessTokenDocument = gql`
    mutation ExchangePersonalAccessToken($token: String!) {
  exchangePersonalAccessToken(token: $token) {
    accessToken
    refreshToken
    expiresAt
    userID
  }
}
    `;
export type ExchangePersonalAccessTokenMutationFn = Apollo.MutationFunction<ExchangePersonalAccessTokenMutation, ExchangePersonalAccessTokenMutationVariables>;

/**
 * __useExchangePersonalAccessTokenMutation__
 *
 * To run a mutation, you first call `useExchangePersonalAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangePersonalAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangePersonalAccessTokenMutation, { data, loading, error }] = useExchangePersonalAccessTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useExchangePersonalAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<ExchangePersonalAccessTokenMutation, ExchangePersonalAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExchangePersonalAccessTokenMutation, ExchangePersonalAccessTokenMutationVariables>(ExchangePersonalAccessTokenDocument, options);
      }
export type ExchangePersonalAccessTokenMutationHookResult = ReturnType<typeof useExchangePersonalAccessTokenMutation>;
export type ExchangePersonalAccessTokenMutationResult = Apollo.MutationResult<ExchangePersonalAccessTokenMutation>;
export type ExchangePersonalAccessTokenMutationOptions = Apollo.BaseMutationOptions<ExchangePersonalAccessTokenMutation, ExchangePersonalAccessTokenMutationVariables>;
export const ExchangeSessionDocument = gql`
    mutation ExchangeSession($input: ExchangeSessionInput!) {
  exchangeSession(input: $input) {
    session {
      userID
      workspaceID
      expiresAt
    }
  }
}
    `;
export type ExchangeSessionMutationFn = Apollo.MutationFunction<ExchangeSessionMutation, ExchangeSessionMutationVariables>;

/**
 * __useExchangeSessionMutation__
 *
 * To run a mutation, you first call `useExchangeSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeSessionMutation, { data, loading, error }] = useExchangeSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExchangeSessionMutation(baseOptions?: Apollo.MutationHookOptions<ExchangeSessionMutation, ExchangeSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExchangeSessionMutation, ExchangeSessionMutationVariables>(ExchangeSessionDocument, options);
      }
export type ExchangeSessionMutationHookResult = ReturnType<typeof useExchangeSessionMutation>;
export type ExchangeSessionMutationResult = Apollo.MutationResult<ExchangeSessionMutation>;
export type ExchangeSessionMutationOptions = Apollo.BaseMutationOptions<ExchangeSessionMutation, ExchangeSessionMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($input: ForgotPasswordInput!) {
  forgotPassword(input: $input) {
    delivery {
      deliveryMedium
      destination
    }
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ImpersonateSessionSlotDocument = gql`
    mutation ImpersonateSessionSlot($input: ImpersonateSessionSlotInput!) {
  impersonateSessionSlot(input: $input) {
    success
  }
}
    `;
export type ImpersonateSessionSlotMutationFn = Apollo.MutationFunction<ImpersonateSessionSlotMutation, ImpersonateSessionSlotMutationVariables>;

/**
 * __useImpersonateSessionSlotMutation__
 *
 * To run a mutation, you first call `useImpersonateSessionSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImpersonateSessionSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [impersonateSessionSlotMutation, { data, loading, error }] = useImpersonateSessionSlotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImpersonateSessionSlotMutation(baseOptions?: Apollo.MutationHookOptions<ImpersonateSessionSlotMutation, ImpersonateSessionSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImpersonateSessionSlotMutation, ImpersonateSessionSlotMutationVariables>(ImpersonateSessionSlotDocument, options);
      }
export type ImpersonateSessionSlotMutationHookResult = ReturnType<typeof useImpersonateSessionSlotMutation>;
export type ImpersonateSessionSlotMutationResult = Apollo.MutationResult<ImpersonateSessionSlotMutation>;
export type ImpersonateSessionSlotMutationOptions = Apollo.BaseMutationOptions<ImpersonateSessionSlotMutation, ImpersonateSessionSlotMutationVariables>;
export const LoginDocument = gql`
    mutation Login($input: CreateSessionInput!) {
  createSession(input: $input) {
    challenge {
      ...Challenge
    }
  }
}
    ${ChallengeFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const MfaSetupChallengeDocument = gql`
    mutation MfaSetupChallenge($input: UpdateSessionInput!) {
  updateSession(input: $input) {
    challenge {
      ...Challenge
    }
    session {
      userID
      workspaceID
      expiresAt
    }
  }
}
    ${ChallengeFragmentDoc}`;
export type MfaSetupChallengeMutationFn = Apollo.MutationFunction<MfaSetupChallengeMutation, MfaSetupChallengeMutationVariables>;

/**
 * __useMfaSetupChallengeMutation__
 *
 * To run a mutation, you first call `useMfaSetupChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMfaSetupChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mfaSetupChallengeMutation, { data, loading, error }] = useMfaSetupChallengeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMfaSetupChallengeMutation(baseOptions?: Apollo.MutationHookOptions<MfaSetupChallengeMutation, MfaSetupChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MfaSetupChallengeMutation, MfaSetupChallengeMutationVariables>(MfaSetupChallengeDocument, options);
      }
export type MfaSetupChallengeMutationHookResult = ReturnType<typeof useMfaSetupChallengeMutation>;
export type MfaSetupChallengeMutationResult = Apollo.MutationResult<MfaSetupChallengeMutation>;
export type MfaSetupChallengeMutationOptions = Apollo.BaseMutationOptions<MfaSetupChallengeMutation, MfaSetupChallengeMutationVariables>;
export const NewPasswordRequiredChallengeDocument = gql`
    mutation NewPasswordRequiredChallenge($input: UpdateSessionInput!) {
  updateSession(input: $input) {
    challenge {
      ...Challenge
    }
    session {
      userID
      workspaceID
      expiresAt
    }
  }
}
    ${ChallengeFragmentDoc}`;
export type NewPasswordRequiredChallengeMutationFn = Apollo.MutationFunction<NewPasswordRequiredChallengeMutation, NewPasswordRequiredChallengeMutationVariables>;

/**
 * __useNewPasswordRequiredChallengeMutation__
 *
 * To run a mutation, you first call `useNewPasswordRequiredChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewPasswordRequiredChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newPasswordRequiredChallengeMutation, { data, loading, error }] = useNewPasswordRequiredChallengeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewPasswordRequiredChallengeMutation(baseOptions?: Apollo.MutationHookOptions<NewPasswordRequiredChallengeMutation, NewPasswordRequiredChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewPasswordRequiredChallengeMutation, NewPasswordRequiredChallengeMutationVariables>(NewPasswordRequiredChallengeDocument, options);
      }
export type NewPasswordRequiredChallengeMutationHookResult = ReturnType<typeof useNewPasswordRequiredChallengeMutation>;
export type NewPasswordRequiredChallengeMutationResult = Apollo.MutationResult<NewPasswordRequiredChallengeMutation>;
export type NewPasswordRequiredChallengeMutationOptions = Apollo.BaseMutationOptions<NewPasswordRequiredChallengeMutation, NewPasswordRequiredChallengeMutationVariables>;
export const PasswordChallengeDocument = gql`
    mutation PasswordChallenge($input: UpdateSessionInput!) {
  updateSession(input: $input) {
    challenge {
      ...Challenge
    }
    session {
      userID
      workspaceID
      expiresAt
    }
  }
}
    ${ChallengeFragmentDoc}`;
export type PasswordChallengeMutationFn = Apollo.MutationFunction<PasswordChallengeMutation, PasswordChallengeMutationVariables>;

/**
 * __usePasswordChallengeMutation__
 *
 * To run a mutation, you first call `usePasswordChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordChallengeMutation, { data, loading, error }] = usePasswordChallengeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePasswordChallengeMutation(baseOptions?: Apollo.MutationHookOptions<PasswordChallengeMutation, PasswordChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasswordChallengeMutation, PasswordChallengeMutationVariables>(PasswordChallengeDocument, options);
      }
export type PasswordChallengeMutationHookResult = ReturnType<typeof usePasswordChallengeMutation>;
export type PasswordChallengeMutationResult = Apollo.MutationResult<PasswordChallengeMutation>;
export type PasswordChallengeMutationOptions = Apollo.BaseMutationOptions<PasswordChallengeMutation, PasswordChallengeMutationVariables>;
export const PreloginDocument = gql`
    mutation Prelogin($input: PreloginInput!) {
  prelogin(input: $input) {
    url
  }
}
    `;
export type PreloginMutationFn = Apollo.MutationFunction<PreloginMutation, PreloginMutationVariables>;

/**
 * __usePreloginMutation__
 *
 * To run a mutation, you first call `usePreloginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreloginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preloginMutation, { data, loading, error }] = usePreloginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreloginMutation(baseOptions?: Apollo.MutationHookOptions<PreloginMutation, PreloginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreloginMutation, PreloginMutationVariables>(PreloginDocument, options);
      }
export type PreloginMutationHookResult = ReturnType<typeof usePreloginMutation>;
export type PreloginMutationResult = Apollo.MutationResult<PreloginMutation>;
export type PreloginMutationOptions = Apollo.BaseMutationOptions<PreloginMutation, PreloginMutationVariables>;
export const RefreshSessionDocument = gql`
    mutation RefreshSession($input: RefreshSessionInput!) {
  refreshSession(input: $input) {
    session {
      userID
      workspaceID
      expiresAt
    }
  }
}
    `;
export type RefreshSessionMutationFn = Apollo.MutationFunction<RefreshSessionMutation, RefreshSessionMutationVariables>;

/**
 * __useRefreshSessionMutation__
 *
 * To run a mutation, you first call `useRefreshSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshSessionMutation, { data, loading, error }] = useRefreshSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshSessionMutation(baseOptions?: Apollo.MutationHookOptions<RefreshSessionMutation, RefreshSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshSessionMutation, RefreshSessionMutationVariables>(RefreshSessionDocument, options);
      }
export type RefreshSessionMutationHookResult = ReturnType<typeof useRefreshSessionMutation>;
export type RefreshSessionMutationResult = Apollo.MutationResult<RefreshSessionMutation>;
export type RefreshSessionMutationOptions = Apollo.BaseMutationOptions<RefreshSessionMutation, RefreshSessionMutationVariables>;
export const RenewPersonalAccessTokenDocument = gql`
    mutation RenewPersonalAccessToken($password: String!) {
  renewPersonalAccessToken(password: $password) {
    id
    token
  }
}
    `;
export type RenewPersonalAccessTokenMutationFn = Apollo.MutationFunction<RenewPersonalAccessTokenMutation, RenewPersonalAccessTokenMutationVariables>;

/**
 * __useRenewPersonalAccessTokenMutation__
 *
 * To run a mutation, you first call `useRenewPersonalAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewPersonalAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewPersonalAccessTokenMutation, { data, loading, error }] = useRenewPersonalAccessTokenMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useRenewPersonalAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<RenewPersonalAccessTokenMutation, RenewPersonalAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewPersonalAccessTokenMutation, RenewPersonalAccessTokenMutationVariables>(RenewPersonalAccessTokenDocument, options);
      }
export type RenewPersonalAccessTokenMutationHookResult = ReturnType<typeof useRenewPersonalAccessTokenMutation>;
export type RenewPersonalAccessTokenMutationResult = Apollo.MutationResult<RenewPersonalAccessTokenMutation>;
export type RenewPersonalAccessTokenMutationOptions = Apollo.BaseMutationOptions<RenewPersonalAccessTokenMutation, RenewPersonalAccessTokenMutationVariables>;
export const ResendTemporaryPasswordDocument = gql`
    mutation ResendTemporaryPassword($input: ResendTemporaryPasswordInput!) {
  resendTemporaryPassword(input: $input) {
    delivery {
      deliveryMedium
      destination
    }
  }
}
    `;
export type ResendTemporaryPasswordMutationFn = Apollo.MutationFunction<ResendTemporaryPasswordMutation, ResendTemporaryPasswordMutationVariables>;

/**
 * __useResendTemporaryPasswordMutation__
 *
 * To run a mutation, you first call `useResendTemporaryPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendTemporaryPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendTemporaryPasswordMutation, { data, loading, error }] = useResendTemporaryPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendTemporaryPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResendTemporaryPasswordMutation, ResendTemporaryPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendTemporaryPasswordMutation, ResendTemporaryPasswordMutationVariables>(ResendTemporaryPasswordDocument, options);
      }
export type ResendTemporaryPasswordMutationHookResult = ReturnType<typeof useResendTemporaryPasswordMutation>;
export type ResendTemporaryPasswordMutationResult = Apollo.MutationResult<ResendTemporaryPasswordMutation>;
export type ResendTemporaryPasswordMutationOptions = Apollo.BaseMutationOptions<ResendTemporaryPasswordMutation, ResendTemporaryPasswordMutationVariables>;
export const RevokePersonalAccessTokenDocument = gql`
    mutation RevokePersonalAccessToken {
  revokePersonalAccessToken
}
    `;
export type RevokePersonalAccessTokenMutationFn = Apollo.MutationFunction<RevokePersonalAccessTokenMutation, RevokePersonalAccessTokenMutationVariables>;

/**
 * __useRevokePersonalAccessTokenMutation__
 *
 * To run a mutation, you first call `useRevokePersonalAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokePersonalAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokePersonalAccessTokenMutation, { data, loading, error }] = useRevokePersonalAccessTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRevokePersonalAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<RevokePersonalAccessTokenMutation, RevokePersonalAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokePersonalAccessTokenMutation, RevokePersonalAccessTokenMutationVariables>(RevokePersonalAccessTokenDocument, options);
      }
export type RevokePersonalAccessTokenMutationHookResult = ReturnType<typeof useRevokePersonalAccessTokenMutation>;
export type RevokePersonalAccessTokenMutationResult = Apollo.MutationResult<RevokePersonalAccessTokenMutation>;
export type RevokePersonalAccessTokenMutationOptions = Apollo.BaseMutationOptions<RevokePersonalAccessTokenMutation, RevokePersonalAccessTokenMutationVariables>;
export const RevokeRoleDocument = gql`
    mutation RevokeRole($input: RevokeRoleInput!) {
  revokeRole(input: $input) {
    user {
      id
      roles {
        id
        role {
          id
          type
        }
        target {
          type
          targetID
        }
      }
    }
  }
}
    `;
export type RevokeRoleMutationFn = Apollo.MutationFunction<RevokeRoleMutation, RevokeRoleMutationVariables>;

/**
 * __useRevokeRoleMutation__
 *
 * To run a mutation, you first call `useRevokeRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeRoleMutation, { data, loading, error }] = useRevokeRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeRoleMutation(baseOptions?: Apollo.MutationHookOptions<RevokeRoleMutation, RevokeRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeRoleMutation, RevokeRoleMutationVariables>(RevokeRoleDocument, options);
      }
export type RevokeRoleMutationHookResult = ReturnType<typeof useRevokeRoleMutation>;
export type RevokeRoleMutationResult = Apollo.MutationResult<RevokeRoleMutation>;
export type RevokeRoleMutationOptions = Apollo.BaseMutationOptions<RevokeRoleMutation, RevokeRoleMutationVariables>;
export const SendTemporaryPasswordDocument = gql`
    mutation SendTemporaryPassword($input: SendTemporaryPasswordInput!) {
  sendTemporaryPassword(input: $input) {
    delivery {
      deliveryMedium
      destination
    }
  }
}
    `;
export type SendTemporaryPasswordMutationFn = Apollo.MutationFunction<SendTemporaryPasswordMutation, SendTemporaryPasswordMutationVariables>;

/**
 * __useSendTemporaryPasswordMutation__
 *
 * To run a mutation, you first call `useSendTemporaryPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTemporaryPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTemporaryPasswordMutation, { data, loading, error }] = useSendTemporaryPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendTemporaryPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SendTemporaryPasswordMutation, SendTemporaryPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTemporaryPasswordMutation, SendTemporaryPasswordMutationVariables>(SendTemporaryPasswordDocument, options);
      }
export type SendTemporaryPasswordMutationHookResult = ReturnType<typeof useSendTemporaryPasswordMutation>;
export type SendTemporaryPasswordMutationResult = Apollo.MutationResult<SendTemporaryPasswordMutation>;
export type SendTemporaryPasswordMutationOptions = Apollo.BaseMutationOptions<SendTemporaryPasswordMutation, SendTemporaryPasswordMutationVariables>;
export const SignOutSessionDocument = gql`
    mutation SignOutSession {
  signOutSession {
    success
  }
}
    `;
export type SignOutSessionMutationFn = Apollo.MutationFunction<SignOutSessionMutation, SignOutSessionMutationVariables>;

/**
 * __useSignOutSessionMutation__
 *
 * To run a mutation, you first call `useSignOutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutSessionMutation, { data, loading, error }] = useSignOutSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutSessionMutation(baseOptions?: Apollo.MutationHookOptions<SignOutSessionMutation, SignOutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignOutSessionMutation, SignOutSessionMutationVariables>(SignOutSessionDocument, options);
      }
export type SignOutSessionMutationHookResult = ReturnType<typeof useSignOutSessionMutation>;
export type SignOutSessionMutationResult = Apollo.MutationResult<SignOutSessionMutation>;
export type SignOutSessionMutationOptions = Apollo.BaseMutationOptions<SignOutSessionMutation, SignOutSessionMutationVariables>;
export const SlackConsumeOAuth2CodeDocument = gql`
    mutation SlackConsumeOAuth2Code($input: SlackConsumeOAuth2CodeInput!) {
  slackConsumeOAuth2Code(input: $input) {
    config {
      id
      isConfigured
      authorizeUrl
      wantedScopes
      configuredScopes
      team {
        id
        name
      }
    }
  }
}
    `;
export type SlackConsumeOAuth2CodeMutationFn = Apollo.MutationFunction<SlackConsumeOAuth2CodeMutation, SlackConsumeOAuth2CodeMutationVariables>;

/**
 * __useSlackConsumeOAuth2CodeMutation__
 *
 * To run a mutation, you first call `useSlackConsumeOAuth2CodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSlackConsumeOAuth2CodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [slackConsumeOAuth2CodeMutation, { data, loading, error }] = useSlackConsumeOAuth2CodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSlackConsumeOAuth2CodeMutation(baseOptions?: Apollo.MutationHookOptions<SlackConsumeOAuth2CodeMutation, SlackConsumeOAuth2CodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SlackConsumeOAuth2CodeMutation, SlackConsumeOAuth2CodeMutationVariables>(SlackConsumeOAuth2CodeDocument, options);
      }
export type SlackConsumeOAuth2CodeMutationHookResult = ReturnType<typeof useSlackConsumeOAuth2CodeMutation>;
export type SlackConsumeOAuth2CodeMutationResult = Apollo.MutationResult<SlackConsumeOAuth2CodeMutation>;
export type SlackConsumeOAuth2CodeMutationOptions = Apollo.BaseMutationOptions<SlackConsumeOAuth2CodeMutation, SlackConsumeOAuth2CodeMutationVariables>;
export const SwitchImpersonatedSessionSlotDocument = gql`
    mutation SwitchImpersonatedSessionSlot($input: SwitchSessionSlotInput!) {
  switchImpersonatedSessionSlot(input: $input) {
    success
  }
}
    `;
export type SwitchImpersonatedSessionSlotMutationFn = Apollo.MutationFunction<SwitchImpersonatedSessionSlotMutation, SwitchImpersonatedSessionSlotMutationVariables>;

/**
 * __useSwitchImpersonatedSessionSlotMutation__
 *
 * To run a mutation, you first call `useSwitchImpersonatedSessionSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchImpersonatedSessionSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchImpersonatedSessionSlotMutation, { data, loading, error }] = useSwitchImpersonatedSessionSlotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchImpersonatedSessionSlotMutation(baseOptions?: Apollo.MutationHookOptions<SwitchImpersonatedSessionSlotMutation, SwitchImpersonatedSessionSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchImpersonatedSessionSlotMutation, SwitchImpersonatedSessionSlotMutationVariables>(SwitchImpersonatedSessionSlotDocument, options);
      }
export type SwitchImpersonatedSessionSlotMutationHookResult = ReturnType<typeof useSwitchImpersonatedSessionSlotMutation>;
export type SwitchImpersonatedSessionSlotMutationResult = Apollo.MutationResult<SwitchImpersonatedSessionSlotMutation>;
export type SwitchImpersonatedSessionSlotMutationOptions = Apollo.BaseMutationOptions<SwitchImpersonatedSessionSlotMutation, SwitchImpersonatedSessionSlotMutationVariables>;
export const SwitchSessionSlotDocument = gql`
    mutation SwitchSessionSlot($input: SwitchSessionSlotInput!) {
  switchSessionSlot(input: $input) {
    success
  }
}
    `;
export type SwitchSessionSlotMutationFn = Apollo.MutationFunction<SwitchSessionSlotMutation, SwitchSessionSlotMutationVariables>;

/**
 * __useSwitchSessionSlotMutation__
 *
 * To run a mutation, you first call `useSwitchSessionSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchSessionSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchSessionSlotMutation, { data, loading, error }] = useSwitchSessionSlotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchSessionSlotMutation(baseOptions?: Apollo.MutationHookOptions<SwitchSessionSlotMutation, SwitchSessionSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchSessionSlotMutation, SwitchSessionSlotMutationVariables>(SwitchSessionSlotDocument, options);
      }
export type SwitchSessionSlotMutationHookResult = ReturnType<typeof useSwitchSessionSlotMutation>;
export type SwitchSessionSlotMutationResult = Apollo.MutationResult<SwitchSessionSlotMutation>;
export type SwitchSessionSlotMutationOptions = Apollo.BaseMutationOptions<SwitchSessionSlotMutation, SwitchSessionSlotMutationVariables>;
export const TotpMfaChallengeDocument = gql`
    mutation TotpMfaChallenge($input: UpdateSessionInput!) {
  updateSession(input: $input) {
    challenge {
      ...Challenge
    }
    session {
      userID
      workspaceID
      expiresAt
    }
  }
}
    ${ChallengeFragmentDoc}`;
export type TotpMfaChallengeMutationFn = Apollo.MutationFunction<TotpMfaChallengeMutation, TotpMfaChallengeMutationVariables>;

/**
 * __useTotpMfaChallengeMutation__
 *
 * To run a mutation, you first call `useTotpMfaChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTotpMfaChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [totpMfaChallengeMutation, { data, loading, error }] = useTotpMfaChallengeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTotpMfaChallengeMutation(baseOptions?: Apollo.MutationHookOptions<TotpMfaChallengeMutation, TotpMfaChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TotpMfaChallengeMutation, TotpMfaChallengeMutationVariables>(TotpMfaChallengeDocument, options);
      }
export type TotpMfaChallengeMutationHookResult = ReturnType<typeof useTotpMfaChallengeMutation>;
export type TotpMfaChallengeMutationResult = Apollo.MutationResult<TotpMfaChallengeMutation>;
export type TotpMfaChallengeMutationOptions = Apollo.BaseMutationOptions<TotpMfaChallengeMutation, TotpMfaChallengeMutationVariables>;
export const UpdateIdentityProviderDocument = gql`
    mutation UpdateIdentityProvider($input: UpdateIdentityProviderInput!) {
  updateIdentityProvider(input: $input) {
    provider {
      id
    }
  }
}
    `;
export type UpdateIdentityProviderMutationFn = Apollo.MutationFunction<UpdateIdentityProviderMutation, UpdateIdentityProviderMutationVariables>;

/**
 * __useUpdateIdentityProviderMutation__
 *
 * To run a mutation, you first call `useUpdateIdentityProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdentityProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIdentityProviderMutation, { data, loading, error }] = useUpdateIdentityProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIdentityProviderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIdentityProviderMutation, UpdateIdentityProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIdentityProviderMutation, UpdateIdentityProviderMutationVariables>(UpdateIdentityProviderDocument, options);
      }
export type UpdateIdentityProviderMutationHookResult = ReturnType<typeof useUpdateIdentityProviderMutation>;
export type UpdateIdentityProviderMutationResult = Apollo.MutationResult<UpdateIdentityProviderMutation>;
export type UpdateIdentityProviderMutationOptions = Apollo.BaseMutationOptions<UpdateIdentityProviderMutation, UpdateIdentityProviderMutationVariables>;
export const UpdateIdentityProviderConfigurationDocument = gql`
    mutation UpdateIdentityProviderConfiguration($input: UpdateIdentityProviderConfigurationInput!) {
  updateIdentityProviderConfiguration(input: $input) {
    provider {
      id
      configuration {
        name
        domains
      }
    }
  }
}
    `;
export type UpdateIdentityProviderConfigurationMutationFn = Apollo.MutationFunction<UpdateIdentityProviderConfigurationMutation, UpdateIdentityProviderConfigurationMutationVariables>;

/**
 * __useUpdateIdentityProviderConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateIdentityProviderConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdentityProviderConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIdentityProviderConfigurationMutation, { data, loading, error }] = useUpdateIdentityProviderConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIdentityProviderConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIdentityProviderConfigurationMutation, UpdateIdentityProviderConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIdentityProviderConfigurationMutation, UpdateIdentityProviderConfigurationMutationVariables>(UpdateIdentityProviderConfigurationDocument, options);
      }
export type UpdateIdentityProviderConfigurationMutationHookResult = ReturnType<typeof useUpdateIdentityProviderConfigurationMutation>;
export type UpdateIdentityProviderConfigurationMutationResult = Apollo.MutationResult<UpdateIdentityProviderConfigurationMutation>;
export type UpdateIdentityProviderConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateIdentityProviderConfigurationMutation, UpdateIdentityProviderConfigurationMutationVariables>;
export const VerifySessionDocument = gql`
    mutation VerifySession($input: VerifySessionInput!) {
  verifySession(input: $input) {
    user {
      id
    }
  }
}
    `;
export type VerifySessionMutationFn = Apollo.MutationFunction<VerifySessionMutation, VerifySessionMutationVariables>;

/**
 * __useVerifySessionMutation__
 *
 * To run a mutation, you first call `useVerifySessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifySessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifySessionMutation, { data, loading, error }] = useVerifySessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifySessionMutation(baseOptions?: Apollo.MutationHookOptions<VerifySessionMutation, VerifySessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifySessionMutation, VerifySessionMutationVariables>(VerifySessionDocument, options);
      }
export type VerifySessionMutationHookResult = ReturnType<typeof useVerifySessionMutation>;
export type VerifySessionMutationResult = Apollo.MutationResult<VerifySessionMutation>;
export type VerifySessionMutationOptions = Apollo.BaseMutationOptions<VerifySessionMutation, VerifySessionMutationVariables>;
export const FailedSsoAttemptsDocument = gql`
    query FailedSsoAttempts($externalID: String, $after: ID, $before: ID, $last: Int, $first: Int) {
  failedSsoAttempts(
    externalID: $externalID
    after: $after
    before: $before
    last: $last
    first: $first
  ) {
    edges {
      cursor
      node {
        id
        externalID
        occurredAt
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useFailedSsoAttemptsQuery__
 *
 * To run a query within a React component, call `useFailedSsoAttemptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFailedSsoAttemptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFailedSsoAttemptsQuery({
 *   variables: {
 *      externalID: // value for 'externalID'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFailedSsoAttemptsQuery(baseOptions?: Apollo.QueryHookOptions<FailedSsoAttemptsQuery, FailedSsoAttemptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FailedSsoAttemptsQuery, FailedSsoAttemptsQueryVariables>(FailedSsoAttemptsDocument, options);
      }
export function useFailedSsoAttemptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FailedSsoAttemptsQuery, FailedSsoAttemptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FailedSsoAttemptsQuery, FailedSsoAttemptsQueryVariables>(FailedSsoAttemptsDocument, options);
        }
// @ts-ignore
export function useFailedSsoAttemptsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FailedSsoAttemptsQuery, FailedSsoAttemptsQueryVariables>): Apollo.UseSuspenseQueryResult<FailedSsoAttemptsQuery, FailedSsoAttemptsQueryVariables>;
export function useFailedSsoAttemptsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FailedSsoAttemptsQuery, FailedSsoAttemptsQueryVariables>): Apollo.UseSuspenseQueryResult<FailedSsoAttemptsQuery | undefined, FailedSsoAttemptsQueryVariables>;
export function useFailedSsoAttemptsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FailedSsoAttemptsQuery, FailedSsoAttemptsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FailedSsoAttemptsQuery, FailedSsoAttemptsQueryVariables>(FailedSsoAttemptsDocument, options);
        }
export type FailedSsoAttemptsQueryHookResult = ReturnType<typeof useFailedSsoAttemptsQuery>;
export type FailedSsoAttemptsLazyQueryHookResult = ReturnType<typeof useFailedSsoAttemptsLazyQuery>;
export type FailedSsoAttemptsSuspenseQueryHookResult = ReturnType<typeof useFailedSsoAttemptsSuspenseQuery>;
export type FailedSsoAttemptsQueryResult = Apollo.QueryResult<FailedSsoAttemptsQuery, FailedSsoAttemptsQueryVariables>;
export const IdentityProviderSettingsDocument = gql`
    query IdentityProviderSettings($id: ID!) {
  identityProvider(id: $id) {
    id
    metadataFile
    metadataURL
    configuration {
      name
      domains
    }
  }
}
    `;

/**
 * __useIdentityProviderSettingsQuery__
 *
 * To run a query within a React component, call `useIdentityProviderSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentityProviderSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdentityProviderSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIdentityProviderSettingsQuery(baseOptions: Apollo.QueryHookOptions<IdentityProviderSettingsQuery, IdentityProviderSettingsQueryVariables> & ({ variables: IdentityProviderSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdentityProviderSettingsQuery, IdentityProviderSettingsQueryVariables>(IdentityProviderSettingsDocument, options);
      }
export function useIdentityProviderSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdentityProviderSettingsQuery, IdentityProviderSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdentityProviderSettingsQuery, IdentityProviderSettingsQueryVariables>(IdentityProviderSettingsDocument, options);
        }
// @ts-ignore
export function useIdentityProviderSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IdentityProviderSettingsQuery, IdentityProviderSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<IdentityProviderSettingsQuery, IdentityProviderSettingsQueryVariables>;
export function useIdentityProviderSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdentityProviderSettingsQuery, IdentityProviderSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<IdentityProviderSettingsQuery | undefined, IdentityProviderSettingsQueryVariables>;
export function useIdentityProviderSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdentityProviderSettingsQuery, IdentityProviderSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdentityProviderSettingsQuery, IdentityProviderSettingsQueryVariables>(IdentityProviderSettingsDocument, options);
        }
export type IdentityProviderSettingsQueryHookResult = ReturnType<typeof useIdentityProviderSettingsQuery>;
export type IdentityProviderSettingsLazyQueryHookResult = ReturnType<typeof useIdentityProviderSettingsLazyQuery>;
export type IdentityProviderSettingsSuspenseQueryHookResult = ReturnType<typeof useIdentityProviderSettingsSuspenseQuery>;
export type IdentityProviderSettingsQueryResult = Apollo.QueryResult<IdentityProviderSettingsQuery, IdentityProviderSettingsQueryVariables>;
export const IdentityProvidersDocument = gql`
    query IdentityProviders {
  identityProviders {
    id
    configuration {
      name
    }
  }
}
    `;

/**
 * __useIdentityProvidersQuery__
 *
 * To run a query within a React component, call `useIdentityProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentityProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdentityProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useIdentityProvidersQuery(baseOptions?: Apollo.QueryHookOptions<IdentityProvidersQuery, IdentityProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdentityProvidersQuery, IdentityProvidersQueryVariables>(IdentityProvidersDocument, options);
      }
export function useIdentityProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdentityProvidersQuery, IdentityProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdentityProvidersQuery, IdentityProvidersQueryVariables>(IdentityProvidersDocument, options);
        }
// @ts-ignore
export function useIdentityProvidersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IdentityProvidersQuery, IdentityProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<IdentityProvidersQuery, IdentityProvidersQueryVariables>;
export function useIdentityProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdentityProvidersQuery, IdentityProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<IdentityProvidersQuery | undefined, IdentityProvidersQueryVariables>;
export function useIdentityProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdentityProvidersQuery, IdentityProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdentityProvidersQuery, IdentityProvidersQueryVariables>(IdentityProvidersDocument, options);
        }
export type IdentityProvidersQueryHookResult = ReturnType<typeof useIdentityProvidersQuery>;
export type IdentityProvidersLazyQueryHookResult = ReturnType<typeof useIdentityProvidersLazyQuery>;
export type IdentityProvidersSuspenseQueryHookResult = ReturnType<typeof useIdentityProvidersSuspenseQuery>;
export type IdentityProvidersQueryResult = Apollo.QueryResult<IdentityProvidersQuery, IdentityProvidersQueryVariables>;
export const IdentityProvidersSettingsDocument = gql`
    query IdentityProvidersSettings {
  identityProviders {
    id
    metadataFile
    metadataURL
    configuration {
      name
    }
  }
}
    `;

/**
 * __useIdentityProvidersSettingsQuery__
 *
 * To run a query within a React component, call `useIdentityProvidersSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentityProvidersSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdentityProvidersSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useIdentityProvidersSettingsQuery(baseOptions?: Apollo.QueryHookOptions<IdentityProvidersSettingsQuery, IdentityProvidersSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdentityProvidersSettingsQuery, IdentityProvidersSettingsQueryVariables>(IdentityProvidersSettingsDocument, options);
      }
export function useIdentityProvidersSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdentityProvidersSettingsQuery, IdentityProvidersSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdentityProvidersSettingsQuery, IdentityProvidersSettingsQueryVariables>(IdentityProvidersSettingsDocument, options);
        }
// @ts-ignore
export function useIdentityProvidersSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IdentityProvidersSettingsQuery, IdentityProvidersSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<IdentityProvidersSettingsQuery, IdentityProvidersSettingsQueryVariables>;
export function useIdentityProvidersSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdentityProvidersSettingsQuery, IdentityProvidersSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<IdentityProvidersSettingsQuery | undefined, IdentityProvidersSettingsQueryVariables>;
export function useIdentityProvidersSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdentityProvidersSettingsQuery, IdentityProvidersSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdentityProvidersSettingsQuery, IdentityProvidersSettingsQueryVariables>(IdentityProvidersSettingsDocument, options);
        }
export type IdentityProvidersSettingsQueryHookResult = ReturnType<typeof useIdentityProvidersSettingsQuery>;
export type IdentityProvidersSettingsLazyQueryHookResult = ReturnType<typeof useIdentityProvidersSettingsLazyQuery>;
export type IdentityProvidersSettingsSuspenseQueryHookResult = ReturnType<typeof useIdentityProvidersSettingsSuspenseQuery>;
export type IdentityProvidersSettingsQueryResult = Apollo.QueryResult<IdentityProvidersSettingsQuery, IdentityProvidersSettingsQueryVariables>;
export const PersonalAccessTokenDocument = gql`
    query PersonalAccessToken {
  viewer {
    id
    personalAccessToken {
      id
      createdAt
    }
  }
}
    `;

/**
 * __usePersonalAccessTokenQuery__
 *
 * To run a query within a React component, call `usePersonalAccessTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalAccessTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalAccessTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function usePersonalAccessTokenQuery(baseOptions?: Apollo.QueryHookOptions<PersonalAccessTokenQuery, PersonalAccessTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonalAccessTokenQuery, PersonalAccessTokenQueryVariables>(PersonalAccessTokenDocument, options);
      }
export function usePersonalAccessTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonalAccessTokenQuery, PersonalAccessTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonalAccessTokenQuery, PersonalAccessTokenQueryVariables>(PersonalAccessTokenDocument, options);
        }
// @ts-ignore
export function usePersonalAccessTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PersonalAccessTokenQuery, PersonalAccessTokenQueryVariables>): Apollo.UseSuspenseQueryResult<PersonalAccessTokenQuery, PersonalAccessTokenQueryVariables>;
export function usePersonalAccessTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonalAccessTokenQuery, PersonalAccessTokenQueryVariables>): Apollo.UseSuspenseQueryResult<PersonalAccessTokenQuery | undefined, PersonalAccessTokenQueryVariables>;
export function usePersonalAccessTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonalAccessTokenQuery, PersonalAccessTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonalAccessTokenQuery, PersonalAccessTokenQueryVariables>(PersonalAccessTokenDocument, options);
        }
export type PersonalAccessTokenQueryHookResult = ReturnType<typeof usePersonalAccessTokenQuery>;
export type PersonalAccessTokenLazyQueryHookResult = ReturnType<typeof usePersonalAccessTokenLazyQuery>;
export type PersonalAccessTokenSuspenseQueryHookResult = ReturnType<typeof usePersonalAccessTokenSuspenseQuery>;
export type PersonalAccessTokenQueryResult = Apollo.QueryResult<PersonalAccessTokenQuery, PersonalAccessTokenQueryVariables>;
export const RolesDocument = gql`
    query Roles($target: RoleTargetType) {
  roles(target: $target) {
    id
  }
}
    `;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *      target: // value for 'target'
 *   },
 * });
 */
export function useRolesQuery(baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
      }
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
// @ts-ignore
export function useRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RolesQuery, RolesQueryVariables>): Apollo.UseSuspenseQueryResult<RolesQuery, RolesQueryVariables>;
export function useRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RolesQuery, RolesQueryVariables>): Apollo.UseSuspenseQueryResult<RolesQuery | undefined, RolesQueryVariables>;
export function useRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesSuspenseQueryHookResult = ReturnType<typeof useRolesSuspenseQuery>;
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>;
export const SelfServiceIdentityProvidersDocument = gql`
    query SelfServiceIdentityProviders {
  identityProviders {
    id
  }
  serviceProvider {
    entityID
    acsURL
    metadataURL
  }
}
    `;

/**
 * __useSelfServiceIdentityProvidersQuery__
 *
 * To run a query within a React component, call `useSelfServiceIdentityProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfServiceIdentityProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfServiceIdentityProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelfServiceIdentityProvidersQuery(baseOptions?: Apollo.QueryHookOptions<SelfServiceIdentityProvidersQuery, SelfServiceIdentityProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfServiceIdentityProvidersQuery, SelfServiceIdentityProvidersQueryVariables>(SelfServiceIdentityProvidersDocument, options);
      }
export function useSelfServiceIdentityProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfServiceIdentityProvidersQuery, SelfServiceIdentityProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfServiceIdentityProvidersQuery, SelfServiceIdentityProvidersQueryVariables>(SelfServiceIdentityProvidersDocument, options);
        }
// @ts-ignore
export function useSelfServiceIdentityProvidersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SelfServiceIdentityProvidersQuery, SelfServiceIdentityProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<SelfServiceIdentityProvidersQuery, SelfServiceIdentityProvidersQueryVariables>;
export function useSelfServiceIdentityProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfServiceIdentityProvidersQuery, SelfServiceIdentityProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<SelfServiceIdentityProvidersQuery | undefined, SelfServiceIdentityProvidersQueryVariables>;
export function useSelfServiceIdentityProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfServiceIdentityProvidersQuery, SelfServiceIdentityProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelfServiceIdentityProvidersQuery, SelfServiceIdentityProvidersQueryVariables>(SelfServiceIdentityProvidersDocument, options);
        }
export type SelfServiceIdentityProvidersQueryHookResult = ReturnType<typeof useSelfServiceIdentityProvidersQuery>;
export type SelfServiceIdentityProvidersLazyQueryHookResult = ReturnType<typeof useSelfServiceIdentityProvidersLazyQuery>;
export type SelfServiceIdentityProvidersSuspenseQueryHookResult = ReturnType<typeof useSelfServiceIdentityProvidersSuspenseQuery>;
export type SelfServiceIdentityProvidersQueryResult = Apollo.QueryResult<SelfServiceIdentityProvidersQuery, SelfServiceIdentityProvidersQueryVariables>;
export const SessionSlotsDocument = gql`
    query SessionSlots {
  sessionSlots {
    userID
    active
    impersonated
    user {
      id
      firstName
      lastName
      avatar {
        id
        source {
          url
        }
      }
    }
  }
}
    `;

/**
 * __useSessionSlotsQuery__
 *
 * To run a query within a React component, call `useSessionSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionSlotsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSessionSlotsQuery(baseOptions?: Apollo.QueryHookOptions<SessionSlotsQuery, SessionSlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionSlotsQuery, SessionSlotsQueryVariables>(SessionSlotsDocument, options);
      }
export function useSessionSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionSlotsQuery, SessionSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionSlotsQuery, SessionSlotsQueryVariables>(SessionSlotsDocument, options);
        }
// @ts-ignore
export function useSessionSlotsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SessionSlotsQuery, SessionSlotsQueryVariables>): Apollo.UseSuspenseQueryResult<SessionSlotsQuery, SessionSlotsQueryVariables>;
export function useSessionSlotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SessionSlotsQuery, SessionSlotsQueryVariables>): Apollo.UseSuspenseQueryResult<SessionSlotsQuery | undefined, SessionSlotsQueryVariables>;
export function useSessionSlotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SessionSlotsQuery, SessionSlotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SessionSlotsQuery, SessionSlotsQueryVariables>(SessionSlotsDocument, options);
        }
export type SessionSlotsQueryHookResult = ReturnType<typeof useSessionSlotsQuery>;
export type SessionSlotsLazyQueryHookResult = ReturnType<typeof useSessionSlotsLazyQuery>;
export type SessionSlotsSuspenseQueryHookResult = ReturnType<typeof useSessionSlotsSuspenseQuery>;
export type SessionSlotsQueryResult = Apollo.QueryResult<SessionSlotsQuery, SessionSlotsQueryVariables>;
export const ArchiveCareerDocument = gql`
    mutation ArchiveCareer($input: CareerArchiveInput!) {
  archiveCareer(input: $input) {
    id
  }
}
    `;
export type ArchiveCareerMutationFn = Apollo.MutationFunction<ArchiveCareerMutation, ArchiveCareerMutationVariables>;

/**
 * __useArchiveCareerMutation__
 *
 * To run a mutation, you first call `useArchiveCareerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCareerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCareerMutation, { data, loading, error }] = useArchiveCareerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveCareerMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCareerMutation, ArchiveCareerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCareerMutation, ArchiveCareerMutationVariables>(ArchiveCareerDocument, options);
      }
export type ArchiveCareerMutationHookResult = ReturnType<typeof useArchiveCareerMutation>;
export type ArchiveCareerMutationResult = Apollo.MutationResult<ArchiveCareerMutation>;
export type ArchiveCareerMutationOptions = Apollo.BaseMutationOptions<ArchiveCareerMutation, ArchiveCareerMutationVariables>;
export const ArchiveCompetencyDocument = gql`
    mutation ArchiveCompetency($input: ArchiveCompetencyInput!) {
  archiveCompetency(input: $input) {
    competency {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveCompetencyMutationFn = Apollo.MutationFunction<ArchiveCompetencyMutation, ArchiveCompetencyMutationVariables>;

/**
 * __useArchiveCompetencyMutation__
 *
 * To run a mutation, you first call `useArchiveCompetencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCompetencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCompetencyMutation, { data, loading, error }] = useArchiveCompetencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveCompetencyMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCompetencyMutation, ArchiveCompetencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCompetencyMutation, ArchiveCompetencyMutationVariables>(ArchiveCompetencyDocument, options);
      }
export type ArchiveCompetencyMutationHookResult = ReturnType<typeof useArchiveCompetencyMutation>;
export type ArchiveCompetencyMutationResult = Apollo.MutationResult<ArchiveCompetencyMutation>;
export type ArchiveCompetencyMutationOptions = Apollo.BaseMutationOptions<ArchiveCompetencyMutation, ArchiveCompetencyMutationVariables>;
export const ArchiveCompetencyLevelSetDocument = gql`
    mutation ArchiveCompetencyLevelSet($input: ArchiveCompetencyLevelSetInput!) {
  archiveCompetencyLevelSet(input: $input) {
    competencyLevelSet {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveCompetencyLevelSetMutationFn = Apollo.MutationFunction<ArchiveCompetencyLevelSetMutation, ArchiveCompetencyLevelSetMutationVariables>;

/**
 * __useArchiveCompetencyLevelSetMutation__
 *
 * To run a mutation, you first call `useArchiveCompetencyLevelSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCompetencyLevelSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCompetencyLevelSetMutation, { data, loading, error }] = useArchiveCompetencyLevelSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveCompetencyLevelSetMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCompetencyLevelSetMutation, ArchiveCompetencyLevelSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCompetencyLevelSetMutation, ArchiveCompetencyLevelSetMutationVariables>(ArchiveCompetencyLevelSetDocument, options);
      }
export type ArchiveCompetencyLevelSetMutationHookResult = ReturnType<typeof useArchiveCompetencyLevelSetMutation>;
export type ArchiveCompetencyLevelSetMutationResult = Apollo.MutationResult<ArchiveCompetencyLevelSetMutation>;
export type ArchiveCompetencyLevelSetMutationOptions = Apollo.BaseMutationOptions<ArchiveCompetencyLevelSetMutation, ArchiveCompetencyLevelSetMutationVariables>;
export const ArchiveExpertiseDocument = gql`
    mutation ArchiveExpertise($input: ArchiveExpertiseInput!) {
  archiveExpertise(input: $input) {
    id
  }
}
    `;
export type ArchiveExpertiseMutationFn = Apollo.MutationFunction<ArchiveExpertiseMutation, ArchiveExpertiseMutationVariables>;

/**
 * __useArchiveExpertiseMutation__
 *
 * To run a mutation, you first call `useArchiveExpertiseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveExpertiseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveExpertiseMutation, { data, loading, error }] = useArchiveExpertiseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveExpertiseMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveExpertiseMutation, ArchiveExpertiseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveExpertiseMutation, ArchiveExpertiseMutationVariables>(ArchiveExpertiseDocument, options);
      }
export type ArchiveExpertiseMutationHookResult = ReturnType<typeof useArchiveExpertiseMutation>;
export type ArchiveExpertiseMutationResult = Apollo.MutationResult<ArchiveExpertiseMutation>;
export type ArchiveExpertiseMutationOptions = Apollo.BaseMutationOptions<ArchiveExpertiseMutation, ArchiveExpertiseMutationVariables>;
export const ArchiveJobLevelDocument = gql`
    mutation ArchiveJobLevel($input: ArchiveJobLevelInput!) {
  archiveJobLevel(input: $input) {
    jobLevel {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveJobLevelMutationFn = Apollo.MutationFunction<ArchiveJobLevelMutation, ArchiveJobLevelMutationVariables>;

/**
 * __useArchiveJobLevelMutation__
 *
 * To run a mutation, you first call `useArchiveJobLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveJobLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveJobLevelMutation, { data, loading, error }] = useArchiveJobLevelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveJobLevelMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveJobLevelMutation, ArchiveJobLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveJobLevelMutation, ArchiveJobLevelMutationVariables>(ArchiveJobLevelDocument, options);
      }
export type ArchiveJobLevelMutationHookResult = ReturnType<typeof useArchiveJobLevelMutation>;
export type ArchiveJobLevelMutationResult = Apollo.MutationResult<ArchiveJobLevelMutation>;
export type ArchiveJobLevelMutationOptions = Apollo.BaseMutationOptions<ArchiveJobLevelMutation, ArchiveJobLevelMutationVariables>;
export const AttachJobCompetencyDocument = gql`
    mutation AttachJobCompetency($input: AttachJobCompetencyInput!) {
  attachJobCompetency(input: $input) {
    jobTitle {
      ...JobTitle
    }
  }
}
    ${JobTitleFragmentDoc}`;
export type AttachJobCompetencyMutationFn = Apollo.MutationFunction<AttachJobCompetencyMutation, AttachJobCompetencyMutationVariables>;

/**
 * __useAttachJobCompetencyMutation__
 *
 * To run a mutation, you first call `useAttachJobCompetencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachJobCompetencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachJobCompetencyMutation, { data, loading, error }] = useAttachJobCompetencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttachJobCompetencyMutation(baseOptions?: Apollo.MutationHookOptions<AttachJobCompetencyMutation, AttachJobCompetencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachJobCompetencyMutation, AttachJobCompetencyMutationVariables>(AttachJobCompetencyDocument, options);
      }
export type AttachJobCompetencyMutationHookResult = ReturnType<typeof useAttachJobCompetencyMutation>;
export type AttachJobCompetencyMutationResult = Apollo.MutationResult<AttachJobCompetencyMutation>;
export type AttachJobCompetencyMutationOptions = Apollo.BaseMutationOptions<AttachJobCompetencyMutation, AttachJobCompetencyMutationVariables>;
export const CreateCareerDocument = gql`
    mutation CreateCareer($input: CareerCreateInput!) {
  createCareer(input: $input) {
    ...CareerPartial
  }
}
    ${CareerPartialFragmentDoc}`;
export type CreateCareerMutationFn = Apollo.MutationFunction<CreateCareerMutation, CreateCareerMutationVariables>;

/**
 * __useCreateCareerMutation__
 *
 * To run a mutation, you first call `useCreateCareerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCareerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCareerMutation, { data, loading, error }] = useCreateCareerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCareerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCareerMutation, CreateCareerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCareerMutation, CreateCareerMutationVariables>(CreateCareerDocument, options);
      }
export type CreateCareerMutationHookResult = ReturnType<typeof useCreateCareerMutation>;
export type CreateCareerMutationResult = Apollo.MutationResult<CreateCareerMutation>;
export type CreateCareerMutationOptions = Apollo.BaseMutationOptions<CreateCareerMutation, CreateCareerMutationVariables>;
export const CreateCompetencyDocument = gql`
    mutation CreateCompetency($input: CreateCompetencyInput!) {
  createCompetency(input: $input) {
    competency {
      id
      title
      description
      competencyLevelSet {
        id
        title
      }
      levels {
        level {
          id
          title
        }
        enabled
        criteria
      }
      jobTitles {
        id
        title
      }
    }
  }
}
    `;
export type CreateCompetencyMutationFn = Apollo.MutationFunction<CreateCompetencyMutation, CreateCompetencyMutationVariables>;

/**
 * __useCreateCompetencyMutation__
 *
 * To run a mutation, you first call `useCreateCompetencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompetencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompetencyMutation, { data, loading, error }] = useCreateCompetencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompetencyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompetencyMutation, CreateCompetencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompetencyMutation, CreateCompetencyMutationVariables>(CreateCompetencyDocument, options);
      }
export type CreateCompetencyMutationHookResult = ReturnType<typeof useCreateCompetencyMutation>;
export type CreateCompetencyMutationResult = Apollo.MutationResult<CreateCompetencyMutation>;
export type CreateCompetencyMutationOptions = Apollo.BaseMutationOptions<CreateCompetencyMutation, CreateCompetencyMutationVariables>;
export const CreateCompetencyLevelSetDocument = gql`
    mutation CreateCompetencyLevelSet($input: CreateCompetencyLevelSetInput!) {
  createCompetencyLevelSet(input: $input) {
    competencyLevelSet {
      id
      title
      levels {
        id
        title
      }
    }
  }
}
    `;
export type CreateCompetencyLevelSetMutationFn = Apollo.MutationFunction<CreateCompetencyLevelSetMutation, CreateCompetencyLevelSetMutationVariables>;

/**
 * __useCreateCompetencyLevelSetMutation__
 *
 * To run a mutation, you first call `useCreateCompetencyLevelSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompetencyLevelSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompetencyLevelSetMutation, { data, loading, error }] = useCreateCompetencyLevelSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompetencyLevelSetMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompetencyLevelSetMutation, CreateCompetencyLevelSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompetencyLevelSetMutation, CreateCompetencyLevelSetMutationVariables>(CreateCompetencyLevelSetDocument, options);
      }
export type CreateCompetencyLevelSetMutationHookResult = ReturnType<typeof useCreateCompetencyLevelSetMutation>;
export type CreateCompetencyLevelSetMutationResult = Apollo.MutationResult<CreateCompetencyLevelSetMutation>;
export type CreateCompetencyLevelSetMutationOptions = Apollo.BaseMutationOptions<CreateCompetencyLevelSetMutation, CreateCompetencyLevelSetMutationVariables>;
export const CreateExpertiseDocument = gql`
    mutation CreateExpertise($input: ExpertiseCreateInput!) {
  createExpertise(input: $input) {
    ...ExpertisePartial
  }
}
    ${ExpertisePartialFragmentDoc}`;
export type CreateExpertiseMutationFn = Apollo.MutationFunction<CreateExpertiseMutation, CreateExpertiseMutationVariables>;

/**
 * __useCreateExpertiseMutation__
 *
 * To run a mutation, you first call `useCreateExpertiseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpertiseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExpertiseMutation, { data, loading, error }] = useCreateExpertiseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExpertiseMutation(baseOptions?: Apollo.MutationHookOptions<CreateExpertiseMutation, CreateExpertiseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExpertiseMutation, CreateExpertiseMutationVariables>(CreateExpertiseDocument, options);
      }
export type CreateExpertiseMutationHookResult = ReturnType<typeof useCreateExpertiseMutation>;
export type CreateExpertiseMutationResult = Apollo.MutationResult<CreateExpertiseMutation>;
export type CreateExpertiseMutationOptions = Apollo.BaseMutationOptions<CreateExpertiseMutation, CreateExpertiseMutationVariables>;
export const CreateJobLevelDocument = gql`
    mutation CreateJobLevel($input: CreateJobLevelInput!) {
  createJobLevel(input: $input) {
    jobLevel {
      id
      title
      description
    }
  }
}
    `;
export type CreateJobLevelMutationFn = Apollo.MutationFunction<CreateJobLevelMutation, CreateJobLevelMutationVariables>;

/**
 * __useCreateJobLevelMutation__
 *
 * To run a mutation, you first call `useCreateJobLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobLevelMutation, { data, loading, error }] = useCreateJobLevelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobLevelMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobLevelMutation, CreateJobLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobLevelMutation, CreateJobLevelMutationVariables>(CreateJobLevelDocument, options);
      }
export type CreateJobLevelMutationHookResult = ReturnType<typeof useCreateJobLevelMutation>;
export type CreateJobLevelMutationResult = Apollo.MutationResult<CreateJobLevelMutation>;
export type CreateJobLevelMutationOptions = Apollo.BaseMutationOptions<CreateJobLevelMutation, CreateJobLevelMutationVariables>;
export const DetachJobCompetencyDocument = gql`
    mutation DetachJobCompetency($input: DetachJobCompetencyInput!) {
  detachJobCompetency(input: $input) {
    jobTitle {
      ...JobTitle
    }
  }
}
    ${JobTitleFragmentDoc}`;
export type DetachJobCompetencyMutationFn = Apollo.MutationFunction<DetachJobCompetencyMutation, DetachJobCompetencyMutationVariables>;

/**
 * __useDetachJobCompetencyMutation__
 *
 * To run a mutation, you first call `useDetachJobCompetencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachJobCompetencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachJobCompetencyMutation, { data, loading, error }] = useDetachJobCompetencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDetachJobCompetencyMutation(baseOptions?: Apollo.MutationHookOptions<DetachJobCompetencyMutation, DetachJobCompetencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetachJobCompetencyMutation, DetachJobCompetencyMutationVariables>(DetachJobCompetencyDocument, options);
      }
export type DetachJobCompetencyMutationHookResult = ReturnType<typeof useDetachJobCompetencyMutation>;
export type DetachJobCompetencyMutationResult = Apollo.MutationResult<DetachJobCompetencyMutation>;
export type DetachJobCompetencyMutationOptions = Apollo.BaseMutationOptions<DetachJobCompetencyMutation, DetachJobCompetencyMutationVariables>;
export const RestoreCareerDocument = gql`
    mutation RestoreCareer($input: CareerRestoreInput!) {
  restoreCareer(input: $input) {
    ...CareerPartial
  }
}
    ${CareerPartialFragmentDoc}`;
export type RestoreCareerMutationFn = Apollo.MutationFunction<RestoreCareerMutation, RestoreCareerMutationVariables>;

/**
 * __useRestoreCareerMutation__
 *
 * To run a mutation, you first call `useRestoreCareerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCareerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCareerMutation, { data, loading, error }] = useRestoreCareerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreCareerMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCareerMutation, RestoreCareerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCareerMutation, RestoreCareerMutationVariables>(RestoreCareerDocument, options);
      }
export type RestoreCareerMutationHookResult = ReturnType<typeof useRestoreCareerMutation>;
export type RestoreCareerMutationResult = Apollo.MutationResult<RestoreCareerMutation>;
export type RestoreCareerMutationOptions = Apollo.BaseMutationOptions<RestoreCareerMutation, RestoreCareerMutationVariables>;
export const RestoreCompetencyDocument = gql`
    mutation RestoreCompetency($input: RestoreCompetencyInput!) {
  restoreCompetency(input: $input) {
    competency {
      id
      isArchived
    }
  }
}
    `;
export type RestoreCompetencyMutationFn = Apollo.MutationFunction<RestoreCompetencyMutation, RestoreCompetencyMutationVariables>;

/**
 * __useRestoreCompetencyMutation__
 *
 * To run a mutation, you first call `useRestoreCompetencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCompetencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCompetencyMutation, { data, loading, error }] = useRestoreCompetencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreCompetencyMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCompetencyMutation, RestoreCompetencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCompetencyMutation, RestoreCompetencyMutationVariables>(RestoreCompetencyDocument, options);
      }
export type RestoreCompetencyMutationHookResult = ReturnType<typeof useRestoreCompetencyMutation>;
export type RestoreCompetencyMutationResult = Apollo.MutationResult<RestoreCompetencyMutation>;
export type RestoreCompetencyMutationOptions = Apollo.BaseMutationOptions<RestoreCompetencyMutation, RestoreCompetencyMutationVariables>;
export const RestoreCompetencyLevelSetDocument = gql`
    mutation RestoreCompetencyLevelSet($input: RestoreCompetencyLevelSetInput!) {
  restoreCompetencyLevelSet(input: $input) {
    competencyLevelSet {
      id
      isArchived
    }
  }
}
    `;
export type RestoreCompetencyLevelSetMutationFn = Apollo.MutationFunction<RestoreCompetencyLevelSetMutation, RestoreCompetencyLevelSetMutationVariables>;

/**
 * __useRestoreCompetencyLevelSetMutation__
 *
 * To run a mutation, you first call `useRestoreCompetencyLevelSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCompetencyLevelSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCompetencyLevelSetMutation, { data, loading, error }] = useRestoreCompetencyLevelSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreCompetencyLevelSetMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCompetencyLevelSetMutation, RestoreCompetencyLevelSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCompetencyLevelSetMutation, RestoreCompetencyLevelSetMutationVariables>(RestoreCompetencyLevelSetDocument, options);
      }
export type RestoreCompetencyLevelSetMutationHookResult = ReturnType<typeof useRestoreCompetencyLevelSetMutation>;
export type RestoreCompetencyLevelSetMutationResult = Apollo.MutationResult<RestoreCompetencyLevelSetMutation>;
export type RestoreCompetencyLevelSetMutationOptions = Apollo.BaseMutationOptions<RestoreCompetencyLevelSetMutation, RestoreCompetencyLevelSetMutationVariables>;
export const RestoreExpertiseDocument = gql`
    mutation RestoreExpertise($input: RestoreExpertiseInput!) {
  restoreExpertise(input: $input) {
    ...ExpertisePartial
  }
}
    ${ExpertisePartialFragmentDoc}`;
export type RestoreExpertiseMutationFn = Apollo.MutationFunction<RestoreExpertiseMutation, RestoreExpertiseMutationVariables>;

/**
 * __useRestoreExpertiseMutation__
 *
 * To run a mutation, you first call `useRestoreExpertiseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreExpertiseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreExpertiseMutation, { data, loading, error }] = useRestoreExpertiseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreExpertiseMutation(baseOptions?: Apollo.MutationHookOptions<RestoreExpertiseMutation, RestoreExpertiseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreExpertiseMutation, RestoreExpertiseMutationVariables>(RestoreExpertiseDocument, options);
      }
export type RestoreExpertiseMutationHookResult = ReturnType<typeof useRestoreExpertiseMutation>;
export type RestoreExpertiseMutationResult = Apollo.MutationResult<RestoreExpertiseMutation>;
export type RestoreExpertiseMutationOptions = Apollo.BaseMutationOptions<RestoreExpertiseMutation, RestoreExpertiseMutationVariables>;
export const RestoreJobLevelDocument = gql`
    mutation RestoreJobLevel($input: RestoreJobLevelInput!) {
  restoreJobLevel(input: $input) {
    jobLevel {
      id
      isArchived
    }
  }
}
    `;
export type RestoreJobLevelMutationFn = Apollo.MutationFunction<RestoreJobLevelMutation, RestoreJobLevelMutationVariables>;

/**
 * __useRestoreJobLevelMutation__
 *
 * To run a mutation, you first call `useRestoreJobLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreJobLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreJobLevelMutation, { data, loading, error }] = useRestoreJobLevelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreJobLevelMutation(baseOptions?: Apollo.MutationHookOptions<RestoreJobLevelMutation, RestoreJobLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreJobLevelMutation, RestoreJobLevelMutationVariables>(RestoreJobLevelDocument, options);
      }
export type RestoreJobLevelMutationHookResult = ReturnType<typeof useRestoreJobLevelMutation>;
export type RestoreJobLevelMutationResult = Apollo.MutationResult<RestoreJobLevelMutation>;
export type RestoreJobLevelMutationOptions = Apollo.BaseMutationOptions<RestoreJobLevelMutation, RestoreJobLevelMutationVariables>;
export const UpdateCareerDocument = gql`
    mutation UpdateCareer($input: CareerUpdateInput!) {
  updateCareer(input: $input) {
    ...CareerPartial
  }
}
    ${CareerPartialFragmentDoc}`;
export type UpdateCareerMutationFn = Apollo.MutationFunction<UpdateCareerMutation, UpdateCareerMutationVariables>;

/**
 * __useUpdateCareerMutation__
 *
 * To run a mutation, you first call `useUpdateCareerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCareerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCareerMutation, { data, loading, error }] = useUpdateCareerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCareerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCareerMutation, UpdateCareerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCareerMutation, UpdateCareerMutationVariables>(UpdateCareerDocument, options);
      }
export type UpdateCareerMutationHookResult = ReturnType<typeof useUpdateCareerMutation>;
export type UpdateCareerMutationResult = Apollo.MutationResult<UpdateCareerMutation>;
export type UpdateCareerMutationOptions = Apollo.BaseMutationOptions<UpdateCareerMutation, UpdateCareerMutationVariables>;
export const UpdateCompetencyDocument = gql`
    mutation UpdateCompetency($input: UpdateCompetencyInput!) {
  updateCompetency(input: $input) {
    competency {
      id
      title
      description
      competencyLevelSet {
        id
        title
        isArchived
      }
      levels {
        level {
          id
          title
        }
        enabled
        criteria
      }
      jobTitles {
        id
        title
      }
      attachableToGoal
    }
  }
}
    `;
export type UpdateCompetencyMutationFn = Apollo.MutationFunction<UpdateCompetencyMutation, UpdateCompetencyMutationVariables>;

/**
 * __useUpdateCompetencyMutation__
 *
 * To run a mutation, you first call `useUpdateCompetencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompetencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompetencyMutation, { data, loading, error }] = useUpdateCompetencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompetencyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompetencyMutation, UpdateCompetencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompetencyMutation, UpdateCompetencyMutationVariables>(UpdateCompetencyDocument, options);
      }
export type UpdateCompetencyMutationHookResult = ReturnType<typeof useUpdateCompetencyMutation>;
export type UpdateCompetencyMutationResult = Apollo.MutationResult<UpdateCompetencyMutation>;
export type UpdateCompetencyMutationOptions = Apollo.BaseMutationOptions<UpdateCompetencyMutation, UpdateCompetencyMutationVariables>;
export const UpdateCompetencyLevelSetDocument = gql`
    mutation UpdateCompetencyLevelSet($input: UpdateCompetencyLevelSetInput!) {
  updateCompetencyLevelSet(input: $input) {
    competencyLevelSet {
      id
      title
      levels {
        id
        title
      }
      isArchived
    }
  }
}
    `;
export type UpdateCompetencyLevelSetMutationFn = Apollo.MutationFunction<UpdateCompetencyLevelSetMutation, UpdateCompetencyLevelSetMutationVariables>;

/**
 * __useUpdateCompetencyLevelSetMutation__
 *
 * To run a mutation, you first call `useUpdateCompetencyLevelSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompetencyLevelSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompetencyLevelSetMutation, { data, loading, error }] = useUpdateCompetencyLevelSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompetencyLevelSetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompetencyLevelSetMutation, UpdateCompetencyLevelSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompetencyLevelSetMutation, UpdateCompetencyLevelSetMutationVariables>(UpdateCompetencyLevelSetDocument, options);
      }
export type UpdateCompetencyLevelSetMutationHookResult = ReturnType<typeof useUpdateCompetencyLevelSetMutation>;
export type UpdateCompetencyLevelSetMutationResult = Apollo.MutationResult<UpdateCompetencyLevelSetMutation>;
export type UpdateCompetencyLevelSetMutationOptions = Apollo.BaseMutationOptions<UpdateCompetencyLevelSetMutation, UpdateCompetencyLevelSetMutationVariables>;
export const UpdateExpertiseDocument = gql`
    mutation UpdateExpertise($input: ExpertiseUpdateInput!) {
  updateExpertise(input: $input) {
    ...ExpertisePartial
  }
}
    ${ExpertisePartialFragmentDoc}`;
export type UpdateExpertiseMutationFn = Apollo.MutationFunction<UpdateExpertiseMutation, UpdateExpertiseMutationVariables>;

/**
 * __useUpdateExpertiseMutation__
 *
 * To run a mutation, you first call `useUpdateExpertiseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpertiseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpertiseMutation, { data, loading, error }] = useUpdateExpertiseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExpertiseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpertiseMutation, UpdateExpertiseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExpertiseMutation, UpdateExpertiseMutationVariables>(UpdateExpertiseDocument, options);
      }
export type UpdateExpertiseMutationHookResult = ReturnType<typeof useUpdateExpertiseMutation>;
export type UpdateExpertiseMutationResult = Apollo.MutationResult<UpdateExpertiseMutation>;
export type UpdateExpertiseMutationOptions = Apollo.BaseMutationOptions<UpdateExpertiseMutation, UpdateExpertiseMutationVariables>;
export const UpdateJobLevelDocument = gql`
    mutation UpdateJobLevel($input: UpdateJobLevelInput!) {
  updateJobLevel(input: $input) {
    jobLevel {
      id
      title
      description
    }
  }
}
    `;
export type UpdateJobLevelMutationFn = Apollo.MutationFunction<UpdateJobLevelMutation, UpdateJobLevelMutationVariables>;

/**
 * __useUpdateJobLevelMutation__
 *
 * To run a mutation, you first call `useUpdateJobLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobLevelMutation, { data, loading, error }] = useUpdateJobLevelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobLevelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobLevelMutation, UpdateJobLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobLevelMutation, UpdateJobLevelMutationVariables>(UpdateJobLevelDocument, options);
      }
export type UpdateJobLevelMutationHookResult = ReturnType<typeof useUpdateJobLevelMutation>;
export type UpdateJobLevelMutationResult = Apollo.MutationResult<UpdateJobLevelMutation>;
export type UpdateJobLevelMutationOptions = Apollo.BaseMutationOptions<UpdateJobLevelMutation, UpdateJobLevelMutationVariables>;
export const CareerDocument = gql`
    query Career($id: ID!) {
  career(id: $id) {
    ...CareerPartial
  }
}
    ${CareerPartialFragmentDoc}`;

/**
 * __useCareerQuery__
 *
 * To run a query within a React component, call `useCareerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCareerQuery(baseOptions: Apollo.QueryHookOptions<CareerQuery, CareerQueryVariables> & ({ variables: CareerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CareerQuery, CareerQueryVariables>(CareerDocument, options);
      }
export function useCareerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareerQuery, CareerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CareerQuery, CareerQueryVariables>(CareerDocument, options);
        }
// @ts-ignore
export function useCareerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CareerQuery, CareerQueryVariables>): Apollo.UseSuspenseQueryResult<CareerQuery, CareerQueryVariables>;
export function useCareerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CareerQuery, CareerQueryVariables>): Apollo.UseSuspenseQueryResult<CareerQuery | undefined, CareerQueryVariables>;
export function useCareerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CareerQuery, CareerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CareerQuery, CareerQueryVariables>(CareerDocument, options);
        }
export type CareerQueryHookResult = ReturnType<typeof useCareerQuery>;
export type CareerLazyQueryHookResult = ReturnType<typeof useCareerLazyQuery>;
export type CareerSuspenseQueryHookResult = ReturnType<typeof useCareerSuspenseQuery>;
export type CareerQueryResult = Apollo.QueryResult<CareerQuery, CareerQueryVariables>;
export const CareersDocument = gql`
    query Careers($isArchived: Boolean!, $before: ID, $after: ID, $first: Int, $last: Int) {
  careers(
    isArchived: $isArchived
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        ...CareerPartial
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${CareerPartialFragmentDoc}`;

/**
 * __useCareersQuery__
 *
 * To run a query within a React component, call `useCareersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareersQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useCareersQuery(baseOptions: Apollo.QueryHookOptions<CareersQuery, CareersQueryVariables> & ({ variables: CareersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CareersQuery, CareersQueryVariables>(CareersDocument, options);
      }
export function useCareersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareersQuery, CareersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CareersQuery, CareersQueryVariables>(CareersDocument, options);
        }
// @ts-ignore
export function useCareersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CareersQuery, CareersQueryVariables>): Apollo.UseSuspenseQueryResult<CareersQuery, CareersQueryVariables>;
export function useCareersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CareersQuery, CareersQueryVariables>): Apollo.UseSuspenseQueryResult<CareersQuery | undefined, CareersQueryVariables>;
export function useCareersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CareersQuery, CareersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CareersQuery, CareersQueryVariables>(CareersDocument, options);
        }
export type CareersQueryHookResult = ReturnType<typeof useCareersQuery>;
export type CareersLazyQueryHookResult = ReturnType<typeof useCareersLazyQuery>;
export type CareersSuspenseQueryHookResult = ReturnType<typeof useCareersSuspenseQuery>;
export type CareersQueryResult = Apollo.QueryResult<CareersQuery, CareersQueryVariables>;
export const CompetenciesWithLevelsDocument = gql`
    query CompetenciesWithLevels($isArchived: Boolean!, $before: ID, $after: ID, $first: Int, $last: Int) {
  competencies(
    isArchived: $isArchived
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        id
        title
        description
        attachableToGoal
        isArchived
        levels {
          enabled
          criteria
          level {
            id
            title
          }
        }
        competencyLevelSet {
          id
          title
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useCompetenciesWithLevelsQuery__
 *
 * To run a query within a React component, call `useCompetenciesWithLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetenciesWithLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetenciesWithLevelsQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useCompetenciesWithLevelsQuery(baseOptions: Apollo.QueryHookOptions<CompetenciesWithLevelsQuery, CompetenciesWithLevelsQueryVariables> & ({ variables: CompetenciesWithLevelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetenciesWithLevelsQuery, CompetenciesWithLevelsQueryVariables>(CompetenciesWithLevelsDocument, options);
      }
export function useCompetenciesWithLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetenciesWithLevelsQuery, CompetenciesWithLevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetenciesWithLevelsQuery, CompetenciesWithLevelsQueryVariables>(CompetenciesWithLevelsDocument, options);
        }
// @ts-ignore
export function useCompetenciesWithLevelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompetenciesWithLevelsQuery, CompetenciesWithLevelsQueryVariables>): Apollo.UseSuspenseQueryResult<CompetenciesWithLevelsQuery, CompetenciesWithLevelsQueryVariables>;
export function useCompetenciesWithLevelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetenciesWithLevelsQuery, CompetenciesWithLevelsQueryVariables>): Apollo.UseSuspenseQueryResult<CompetenciesWithLevelsQuery | undefined, CompetenciesWithLevelsQueryVariables>;
export function useCompetenciesWithLevelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetenciesWithLevelsQuery, CompetenciesWithLevelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetenciesWithLevelsQuery, CompetenciesWithLevelsQueryVariables>(CompetenciesWithLevelsDocument, options);
        }
export type CompetenciesWithLevelsQueryHookResult = ReturnType<typeof useCompetenciesWithLevelsQuery>;
export type CompetenciesWithLevelsLazyQueryHookResult = ReturnType<typeof useCompetenciesWithLevelsLazyQuery>;
export type CompetenciesWithLevelsSuspenseQueryHookResult = ReturnType<typeof useCompetenciesWithLevelsSuspenseQuery>;
export type CompetenciesWithLevelsQueryResult = Apollo.QueryResult<CompetenciesWithLevelsQuery, CompetenciesWithLevelsQueryVariables>;
export const CompetencyDocument = gql`
    query Competency($id: ID!) {
  competency(id: $id) {
    id
    title
    description
    competencyLevelSet {
      id
      title
      levels {
        id
        title
      }
      isArchived
    }
    levels {
      level {
        id
        title
      }
      enabled
      criteria
    }
    jobTitles {
      id
      title
    }
    jobCompetencies {
      id
      jobTitle {
        id
        title
        styrData {
          jobID
        }
      }
      description
    }
    label {
      id
      title
      description
    }
    attachableToGoal
    isArchived
    styrSkillID
  }
}
    `;

/**
 * __useCompetencyQuery__
 *
 * To run a query within a React component, call `useCompetencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetencyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompetencyQuery(baseOptions: Apollo.QueryHookOptions<CompetencyQuery, CompetencyQueryVariables> & ({ variables: CompetencyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetencyQuery, CompetencyQueryVariables>(CompetencyDocument, options);
      }
export function useCompetencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetencyQuery, CompetencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetencyQuery, CompetencyQueryVariables>(CompetencyDocument, options);
        }
// @ts-ignore
export function useCompetencySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompetencyQuery, CompetencyQueryVariables>): Apollo.UseSuspenseQueryResult<CompetencyQuery, CompetencyQueryVariables>;
export function useCompetencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetencyQuery, CompetencyQueryVariables>): Apollo.UseSuspenseQueryResult<CompetencyQuery | undefined, CompetencyQueryVariables>;
export function useCompetencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetencyQuery, CompetencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetencyQuery, CompetencyQueryVariables>(CompetencyDocument, options);
        }
export type CompetencyQueryHookResult = ReturnType<typeof useCompetencyQuery>;
export type CompetencyLazyQueryHookResult = ReturnType<typeof useCompetencyLazyQuery>;
export type CompetencySuspenseQueryHookResult = ReturnType<typeof useCompetencySuspenseQuery>;
export type CompetencyQueryResult = Apollo.QueryResult<CompetencyQuery, CompetencyQueryVariables>;
export const CompetencyAppraisalsDocument = gql`
    query CompetencyAppraisals($id: ID!) {
  competency(id: $id) {
    id
    title
    description
    levels {
      level {
        id
        title
      }
      enabled
      criteria
    }
    appraisals {
      user {
        id
        firstName
        lastName
        email
        avatar {
          source {
            url
          }
        }
        group {
          name
        }
        jobPositions(status: ACTIVE) {
          jobTitle {
            title
          }
        }
      }
      competencyLevelIndex
    }
  }
}
    `;

/**
 * __useCompetencyAppraisalsQuery__
 *
 * To run a query within a React component, call `useCompetencyAppraisalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetencyAppraisalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetencyAppraisalsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompetencyAppraisalsQuery(baseOptions: Apollo.QueryHookOptions<CompetencyAppraisalsQuery, CompetencyAppraisalsQueryVariables> & ({ variables: CompetencyAppraisalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetencyAppraisalsQuery, CompetencyAppraisalsQueryVariables>(CompetencyAppraisalsDocument, options);
      }
export function useCompetencyAppraisalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetencyAppraisalsQuery, CompetencyAppraisalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetencyAppraisalsQuery, CompetencyAppraisalsQueryVariables>(CompetencyAppraisalsDocument, options);
        }
// @ts-ignore
export function useCompetencyAppraisalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompetencyAppraisalsQuery, CompetencyAppraisalsQueryVariables>): Apollo.UseSuspenseQueryResult<CompetencyAppraisalsQuery, CompetencyAppraisalsQueryVariables>;
export function useCompetencyAppraisalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetencyAppraisalsQuery, CompetencyAppraisalsQueryVariables>): Apollo.UseSuspenseQueryResult<CompetencyAppraisalsQuery | undefined, CompetencyAppraisalsQueryVariables>;
export function useCompetencyAppraisalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetencyAppraisalsQuery, CompetencyAppraisalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetencyAppraisalsQuery, CompetencyAppraisalsQueryVariables>(CompetencyAppraisalsDocument, options);
        }
export type CompetencyAppraisalsQueryHookResult = ReturnType<typeof useCompetencyAppraisalsQuery>;
export type CompetencyAppraisalsLazyQueryHookResult = ReturnType<typeof useCompetencyAppraisalsLazyQuery>;
export type CompetencyAppraisalsSuspenseQueryHookResult = ReturnType<typeof useCompetencyAppraisalsSuspenseQuery>;
export type CompetencyAppraisalsQueryResult = Apollo.QueryResult<CompetencyAppraisalsQuery, CompetencyAppraisalsQueryVariables>;
export const CompetencyLevelSetDocument = gql`
    query CompetencyLevelSet($id: ID!) {
  competencyLevelSet(id: $id) {
    id
    title
    levels {
      id
      title
    }
    isArchived
  }
}
    `;

/**
 * __useCompetencyLevelSetQuery__
 *
 * To run a query within a React component, call `useCompetencyLevelSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetencyLevelSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetencyLevelSetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompetencyLevelSetQuery(baseOptions: Apollo.QueryHookOptions<CompetencyLevelSetQuery, CompetencyLevelSetQueryVariables> & ({ variables: CompetencyLevelSetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetencyLevelSetQuery, CompetencyLevelSetQueryVariables>(CompetencyLevelSetDocument, options);
      }
export function useCompetencyLevelSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetencyLevelSetQuery, CompetencyLevelSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetencyLevelSetQuery, CompetencyLevelSetQueryVariables>(CompetencyLevelSetDocument, options);
        }
// @ts-ignore
export function useCompetencyLevelSetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompetencyLevelSetQuery, CompetencyLevelSetQueryVariables>): Apollo.UseSuspenseQueryResult<CompetencyLevelSetQuery, CompetencyLevelSetQueryVariables>;
export function useCompetencyLevelSetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetencyLevelSetQuery, CompetencyLevelSetQueryVariables>): Apollo.UseSuspenseQueryResult<CompetencyLevelSetQuery | undefined, CompetencyLevelSetQueryVariables>;
export function useCompetencyLevelSetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetencyLevelSetQuery, CompetencyLevelSetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetencyLevelSetQuery, CompetencyLevelSetQueryVariables>(CompetencyLevelSetDocument, options);
        }
export type CompetencyLevelSetQueryHookResult = ReturnType<typeof useCompetencyLevelSetQuery>;
export type CompetencyLevelSetLazyQueryHookResult = ReturnType<typeof useCompetencyLevelSetLazyQuery>;
export type CompetencyLevelSetSuspenseQueryHookResult = ReturnType<typeof useCompetencyLevelSetSuspenseQuery>;
export type CompetencyLevelSetQueryResult = Apollo.QueryResult<CompetencyLevelSetQuery, CompetencyLevelSetQueryVariables>;
export const CompetencyLevelSetsDocument = gql`
    query CompetencyLevelSets($isArchived: Boolean!, $before: ID, $after: ID, $first: Int, $last: Int) {
  competencyLevelSets(
    isArchived: $isArchived
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        id
        title
        levels {
          id
          title
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useCompetencyLevelSetsQuery__
 *
 * To run a query within a React component, call `useCompetencyLevelSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetencyLevelSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetencyLevelSetsQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useCompetencyLevelSetsQuery(baseOptions: Apollo.QueryHookOptions<CompetencyLevelSetsQuery, CompetencyLevelSetsQueryVariables> & ({ variables: CompetencyLevelSetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetencyLevelSetsQuery, CompetencyLevelSetsQueryVariables>(CompetencyLevelSetsDocument, options);
      }
export function useCompetencyLevelSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetencyLevelSetsQuery, CompetencyLevelSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetencyLevelSetsQuery, CompetencyLevelSetsQueryVariables>(CompetencyLevelSetsDocument, options);
        }
// @ts-ignore
export function useCompetencyLevelSetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompetencyLevelSetsQuery, CompetencyLevelSetsQueryVariables>): Apollo.UseSuspenseQueryResult<CompetencyLevelSetsQuery, CompetencyLevelSetsQueryVariables>;
export function useCompetencyLevelSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetencyLevelSetsQuery, CompetencyLevelSetsQueryVariables>): Apollo.UseSuspenseQueryResult<CompetencyLevelSetsQuery | undefined, CompetencyLevelSetsQueryVariables>;
export function useCompetencyLevelSetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetencyLevelSetsQuery, CompetencyLevelSetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetencyLevelSetsQuery, CompetencyLevelSetsQueryVariables>(CompetencyLevelSetsDocument, options);
        }
export type CompetencyLevelSetsQueryHookResult = ReturnType<typeof useCompetencyLevelSetsQuery>;
export type CompetencyLevelSetsLazyQueryHookResult = ReturnType<typeof useCompetencyLevelSetsLazyQuery>;
export type CompetencyLevelSetsSuspenseQueryHookResult = ReturnType<typeof useCompetencyLevelSetsSuspenseQuery>;
export type CompetencyLevelSetsQueryResult = Apollo.QueryResult<CompetencyLevelSetsQuery, CompetencyLevelSetsQueryVariables>;
export const ExpertiseDocument = gql`
    query Expertise($id: ID!) {
  expertise(id: $id) {
    ...ExpertisePartial
  }
}
    ${ExpertisePartialFragmentDoc}`;

/**
 * __useExpertiseQuery__
 *
 * To run a query within a React component, call `useExpertiseQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpertiseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpertiseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExpertiseQuery(baseOptions: Apollo.QueryHookOptions<ExpertiseQuery, ExpertiseQueryVariables> & ({ variables: ExpertiseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExpertiseQuery, ExpertiseQueryVariables>(ExpertiseDocument, options);
      }
export function useExpertiseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExpertiseQuery, ExpertiseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExpertiseQuery, ExpertiseQueryVariables>(ExpertiseDocument, options);
        }
// @ts-ignore
export function useExpertiseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExpertiseQuery, ExpertiseQueryVariables>): Apollo.UseSuspenseQueryResult<ExpertiseQuery, ExpertiseQueryVariables>;
export function useExpertiseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExpertiseQuery, ExpertiseQueryVariables>): Apollo.UseSuspenseQueryResult<ExpertiseQuery | undefined, ExpertiseQueryVariables>;
export function useExpertiseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExpertiseQuery, ExpertiseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExpertiseQuery, ExpertiseQueryVariables>(ExpertiseDocument, options);
        }
export type ExpertiseQueryHookResult = ReturnType<typeof useExpertiseQuery>;
export type ExpertiseLazyQueryHookResult = ReturnType<typeof useExpertiseLazyQuery>;
export type ExpertiseSuspenseQueryHookResult = ReturnType<typeof useExpertiseSuspenseQuery>;
export type ExpertiseQueryResult = Apollo.QueryResult<ExpertiseQuery, ExpertiseQueryVariables>;
export const JobLevelDocument = gql`
    query JobLevel($id: ID!) {
  jobLevel(id: $id) {
    id
    title
    description
    isArchived
  }
}
    `;

/**
 * __useJobLevelQuery__
 *
 * To run a query within a React component, call `useJobLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobLevelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobLevelQuery(baseOptions: Apollo.QueryHookOptions<JobLevelQuery, JobLevelQueryVariables> & ({ variables: JobLevelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobLevelQuery, JobLevelQueryVariables>(JobLevelDocument, options);
      }
export function useJobLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobLevelQuery, JobLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobLevelQuery, JobLevelQueryVariables>(JobLevelDocument, options);
        }
// @ts-ignore
export function useJobLevelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobLevelQuery, JobLevelQueryVariables>): Apollo.UseSuspenseQueryResult<JobLevelQuery, JobLevelQueryVariables>;
export function useJobLevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobLevelQuery, JobLevelQueryVariables>): Apollo.UseSuspenseQueryResult<JobLevelQuery | undefined, JobLevelQueryVariables>;
export function useJobLevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobLevelQuery, JobLevelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobLevelQuery, JobLevelQueryVariables>(JobLevelDocument, options);
        }
export type JobLevelQueryHookResult = ReturnType<typeof useJobLevelQuery>;
export type JobLevelLazyQueryHookResult = ReturnType<typeof useJobLevelLazyQuery>;
export type JobLevelSuspenseQueryHookResult = ReturnType<typeof useJobLevelSuspenseQuery>;
export type JobLevelQueryResult = Apollo.QueryResult<JobLevelQuery, JobLevelQueryVariables>;
export const JobLevelsDocument = gql`
    query JobLevels($isArchived: Boolean, $first: Int, $last: Int, $before: ID, $after: ID) {
  jobLevels(
    isArchived: $isArchived
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        title
        description
        isArchived
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useJobLevelsQuery__
 *
 * To run a query within a React component, call `useJobLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobLevelsQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useJobLevelsQuery(baseOptions?: Apollo.QueryHookOptions<JobLevelsQuery, JobLevelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobLevelsQuery, JobLevelsQueryVariables>(JobLevelsDocument, options);
      }
export function useJobLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobLevelsQuery, JobLevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobLevelsQuery, JobLevelsQueryVariables>(JobLevelsDocument, options);
        }
// @ts-ignore
export function useJobLevelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobLevelsQuery, JobLevelsQueryVariables>): Apollo.UseSuspenseQueryResult<JobLevelsQuery, JobLevelsQueryVariables>;
export function useJobLevelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobLevelsQuery, JobLevelsQueryVariables>): Apollo.UseSuspenseQueryResult<JobLevelsQuery | undefined, JobLevelsQueryVariables>;
export function useJobLevelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobLevelsQuery, JobLevelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobLevelsQuery, JobLevelsQueryVariables>(JobLevelsDocument, options);
        }
export type JobLevelsQueryHookResult = ReturnType<typeof useJobLevelsQuery>;
export type JobLevelsLazyQueryHookResult = ReturnType<typeof useJobLevelsLazyQuery>;
export type JobLevelsSuspenseQueryHookResult = ReturnType<typeof useJobLevelsSuspenseQuery>;
export type JobLevelsQueryResult = Apollo.QueryResult<JobLevelsQuery, JobLevelsQueryVariables>;
export const PaginatedExpertisesDocument = gql`
    query PaginatedExpertises($isArchived: Boolean!, $before: ID, $after: ID, $first: Int, $last: Int) {
  paginatedExpertises(
    isArchived: $isArchived
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        ...ExpertisePartial
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${ExpertisePartialFragmentDoc}`;

/**
 * __usePaginatedExpertisesQuery__
 *
 * To run a query within a React component, call `usePaginatedExpertisesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedExpertisesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedExpertisesQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function usePaginatedExpertisesQuery(baseOptions: Apollo.QueryHookOptions<PaginatedExpertisesQuery, PaginatedExpertisesQueryVariables> & ({ variables: PaginatedExpertisesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedExpertisesQuery, PaginatedExpertisesQueryVariables>(PaginatedExpertisesDocument, options);
      }
export function usePaginatedExpertisesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedExpertisesQuery, PaginatedExpertisesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedExpertisesQuery, PaginatedExpertisesQueryVariables>(PaginatedExpertisesDocument, options);
        }
// @ts-ignore
export function usePaginatedExpertisesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaginatedExpertisesQuery, PaginatedExpertisesQueryVariables>): Apollo.UseSuspenseQueryResult<PaginatedExpertisesQuery, PaginatedExpertisesQueryVariables>;
export function usePaginatedExpertisesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaginatedExpertisesQuery, PaginatedExpertisesQueryVariables>): Apollo.UseSuspenseQueryResult<PaginatedExpertisesQuery | undefined, PaginatedExpertisesQueryVariables>;
export function usePaginatedExpertisesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaginatedExpertisesQuery, PaginatedExpertisesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaginatedExpertisesQuery, PaginatedExpertisesQueryVariables>(PaginatedExpertisesDocument, options);
        }
export type PaginatedExpertisesQueryHookResult = ReturnType<typeof usePaginatedExpertisesQuery>;
export type PaginatedExpertisesLazyQueryHookResult = ReturnType<typeof usePaginatedExpertisesLazyQuery>;
export type PaginatedExpertisesSuspenseQueryHookResult = ReturnType<typeof usePaginatedExpertisesSuspenseQuery>;
export type PaginatedExpertisesQueryResult = Apollo.QueryResult<PaginatedExpertisesQuery, PaginatedExpertisesQueryVariables>;
export const ArchiveApiUserDocument = gql`
    mutation ArchiveApiUser($id: ID!) {
  archiveApiUser(id: $id)
}
    `;
export type ArchiveApiUserMutationFn = Apollo.MutationFunction<ArchiveApiUserMutation, ArchiveApiUserMutationVariables>;

/**
 * __useArchiveApiUserMutation__
 *
 * To run a mutation, you first call `useArchiveApiUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveApiUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveApiUserMutation, { data, loading, error }] = useArchiveApiUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveApiUserMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveApiUserMutation, ArchiveApiUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveApiUserMutation, ArchiveApiUserMutationVariables>(ArchiveApiUserDocument, options);
      }
export type ArchiveApiUserMutationHookResult = ReturnType<typeof useArchiveApiUserMutation>;
export type ArchiveApiUserMutationResult = Apollo.MutationResult<ArchiveApiUserMutation>;
export type ArchiveApiUserMutationOptions = Apollo.BaseMutationOptions<ArchiveApiUserMutation, ArchiveApiUserMutationVariables>;
export const AutoLinkSlackIdentitiesDocument = gql`
    mutation AutoLinkSlackIdentities {
  autoLinkSlackIdentities {
    success
  }
}
    `;
export type AutoLinkSlackIdentitiesMutationFn = Apollo.MutationFunction<AutoLinkSlackIdentitiesMutation, AutoLinkSlackIdentitiesMutationVariables>;

/**
 * __useAutoLinkSlackIdentitiesMutation__
 *
 * To run a mutation, you first call `useAutoLinkSlackIdentitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoLinkSlackIdentitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoLinkSlackIdentitiesMutation, { data, loading, error }] = useAutoLinkSlackIdentitiesMutation({
 *   variables: {
 *   },
 * });
 */
export function useAutoLinkSlackIdentitiesMutation(baseOptions?: Apollo.MutationHookOptions<AutoLinkSlackIdentitiesMutation, AutoLinkSlackIdentitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutoLinkSlackIdentitiesMutation, AutoLinkSlackIdentitiesMutationVariables>(AutoLinkSlackIdentitiesDocument, options);
      }
export type AutoLinkSlackIdentitiesMutationHookResult = ReturnType<typeof useAutoLinkSlackIdentitiesMutation>;
export type AutoLinkSlackIdentitiesMutationResult = Apollo.MutationResult<AutoLinkSlackIdentitiesMutation>;
export type AutoLinkSlackIdentitiesMutationOptions = Apollo.BaseMutationOptions<AutoLinkSlackIdentitiesMutation, AutoLinkSlackIdentitiesMutationVariables>;
export const CreateApiUserDocument = gql`
    mutation CreateApiUser {
  createApiUser {
    user {
      ...ApiUser
    }
    apiSecret
  }
}
    ${ApiUserFragmentDoc}`;
export type CreateApiUserMutationFn = Apollo.MutationFunction<CreateApiUserMutation, CreateApiUserMutationVariables>;

/**
 * __useCreateApiUserMutation__
 *
 * To run a mutation, you first call `useCreateApiUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiUserMutation, { data, loading, error }] = useCreateApiUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateApiUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiUserMutation, CreateApiUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiUserMutation, CreateApiUserMutationVariables>(CreateApiUserDocument, options);
      }
export type CreateApiUserMutationHookResult = ReturnType<typeof useCreateApiUserMutation>;
export type CreateApiUserMutationResult = Apollo.MutationResult<CreateApiUserMutation>;
export type CreateApiUserMutationOptions = Apollo.BaseMutationOptions<CreateApiUserMutation, CreateApiUserMutationVariables>;
export const MicrosoftConnectDocument = gql`
    mutation MicrosoftConnect($integration: MicrosoftIntegration!) {
  microsoftConnect(integration: $integration)
}
    `;
export type MicrosoftConnectMutationFn = Apollo.MutationFunction<MicrosoftConnectMutation, MicrosoftConnectMutationVariables>;

/**
 * __useMicrosoftConnectMutation__
 *
 * To run a mutation, you first call `useMicrosoftConnectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMicrosoftConnectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [microsoftConnectMutation, { data, loading, error }] = useMicrosoftConnectMutation({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useMicrosoftConnectMutation(baseOptions?: Apollo.MutationHookOptions<MicrosoftConnectMutation, MicrosoftConnectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MicrosoftConnectMutation, MicrosoftConnectMutationVariables>(MicrosoftConnectDocument, options);
      }
export type MicrosoftConnectMutationHookResult = ReturnType<typeof useMicrosoftConnectMutation>;
export type MicrosoftConnectMutationResult = Apollo.MutationResult<MicrosoftConnectMutation>;
export type MicrosoftConnectMutationOptions = Apollo.BaseMutationOptions<MicrosoftConnectMutation, MicrosoftConnectMutationVariables>;
export const MicrosoftDisconnectDocument = gql`
    mutation MicrosoftDisconnect($integration: MicrosoftIntegration!) {
  microsoftDisconnect(integration: $integration) {
    id
    isConfigured
    tenantId
    teamsConnected
    outlookConnected
    teamsRequiresReconsent
    outlookRequiresReconsent
  }
}
    `;
export type MicrosoftDisconnectMutationFn = Apollo.MutationFunction<MicrosoftDisconnectMutation, MicrosoftDisconnectMutationVariables>;

/**
 * __useMicrosoftDisconnectMutation__
 *
 * To run a mutation, you first call `useMicrosoftDisconnectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMicrosoftDisconnectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [microsoftDisconnectMutation, { data, loading, error }] = useMicrosoftDisconnectMutation({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useMicrosoftDisconnectMutation(baseOptions?: Apollo.MutationHookOptions<MicrosoftDisconnectMutation, MicrosoftDisconnectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MicrosoftDisconnectMutation, MicrosoftDisconnectMutationVariables>(MicrosoftDisconnectDocument, options);
      }
export type MicrosoftDisconnectMutationHookResult = ReturnType<typeof useMicrosoftDisconnectMutation>;
export type MicrosoftDisconnectMutationResult = Apollo.MutationResult<MicrosoftDisconnectMutation>;
export type MicrosoftDisconnectMutationOptions = Apollo.BaseMutationOptions<MicrosoftDisconnectMutation, MicrosoftDisconnectMutationVariables>;
export const QueueConnectorDocument = gql`
    mutation QueueConnector {
  queueConnector
}
    `;
export type QueueConnectorMutationFn = Apollo.MutationFunction<QueueConnectorMutation, QueueConnectorMutationVariables>;

/**
 * __useQueueConnectorMutation__
 *
 * To run a mutation, you first call `useQueueConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueConnectorMutation, { data, loading, error }] = useQueueConnectorMutation({
 *   variables: {
 *   },
 * });
 */
export function useQueueConnectorMutation(baseOptions?: Apollo.MutationHookOptions<QueueConnectorMutation, QueueConnectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QueueConnectorMutation, QueueConnectorMutationVariables>(QueueConnectorDocument, options);
      }
export type QueueConnectorMutationHookResult = ReturnType<typeof useQueueConnectorMutation>;
export type QueueConnectorMutationResult = Apollo.MutationResult<QueueConnectorMutation>;
export type QueueConnectorMutationOptions = Apollo.BaseMutationOptions<QueueConnectorMutation, QueueConnectorMutationVariables>;
export const QueueConnectorTwoWayRetrospectDocument = gql`
    mutation QueueConnectorTwoWayRetrospect {
  queueConnectorTwoWayRetrospect
}
    `;
export type QueueConnectorTwoWayRetrospectMutationFn = Apollo.MutationFunction<QueueConnectorTwoWayRetrospectMutation, QueueConnectorTwoWayRetrospectMutationVariables>;

/**
 * __useQueueConnectorTwoWayRetrospectMutation__
 *
 * To run a mutation, you first call `useQueueConnectorTwoWayRetrospectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueConnectorTwoWayRetrospectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueConnectorTwoWayRetrospectMutation, { data, loading, error }] = useQueueConnectorTwoWayRetrospectMutation({
 *   variables: {
 *   },
 * });
 */
export function useQueueConnectorTwoWayRetrospectMutation(baseOptions?: Apollo.MutationHookOptions<QueueConnectorTwoWayRetrospectMutation, QueueConnectorTwoWayRetrospectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QueueConnectorTwoWayRetrospectMutation, QueueConnectorTwoWayRetrospectMutationVariables>(QueueConnectorTwoWayRetrospectDocument, options);
      }
export type QueueConnectorTwoWayRetrospectMutationHookResult = ReturnType<typeof useQueueConnectorTwoWayRetrospectMutation>;
export type QueueConnectorTwoWayRetrospectMutationResult = Apollo.MutationResult<QueueConnectorTwoWayRetrospectMutation>;
export type QueueConnectorTwoWayRetrospectMutationOptions = Apollo.BaseMutationOptions<QueueConnectorTwoWayRetrospectMutation, QueueConnectorTwoWayRetrospectMutationVariables>;
export const RegenerateApiUserSecretDocument = gql`
    mutation RegenerateApiUserSecret($id: ID!) {
  regenerateApiUserSecret(id: $id) {
    user {
      ...ApiUser
    }
    apiSecret
  }
}
    ${ApiUserFragmentDoc}`;
export type RegenerateApiUserSecretMutationFn = Apollo.MutationFunction<RegenerateApiUserSecretMutation, RegenerateApiUserSecretMutationVariables>;

/**
 * __useRegenerateApiUserSecretMutation__
 *
 * To run a mutation, you first call `useRegenerateApiUserSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateApiUserSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateApiUserSecretMutation, { data, loading, error }] = useRegenerateApiUserSecretMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegenerateApiUserSecretMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateApiUserSecretMutation, RegenerateApiUserSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateApiUserSecretMutation, RegenerateApiUserSecretMutationVariables>(RegenerateApiUserSecretDocument, options);
      }
export type RegenerateApiUserSecretMutationHookResult = ReturnType<typeof useRegenerateApiUserSecretMutation>;
export type RegenerateApiUserSecretMutationResult = Apollo.MutationResult<RegenerateApiUserSecretMutation>;
export type RegenerateApiUserSecretMutationOptions = Apollo.BaseMutationOptions<RegenerateApiUserSecretMutation, RegenerateApiUserSecretMutationVariables>;
export const SetupConnectorDocument = gql`
    mutation SetupConnector($input: SetupConnectorInput!) {
  setupConnector(input: $input) {
    workspace {
      connector {
        ...ConnectorWithConfig
      }
    }
  }
}
    ${ConnectorWithConfigFragmentDoc}`;
export type SetupConnectorMutationFn = Apollo.MutationFunction<SetupConnectorMutation, SetupConnectorMutationVariables>;

/**
 * __useSetupConnectorMutation__
 *
 * To run a mutation, you first call `useSetupConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupConnectorMutation, { data, loading, error }] = useSetupConnectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetupConnectorMutation(baseOptions?: Apollo.MutationHookOptions<SetupConnectorMutation, SetupConnectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupConnectorMutation, SetupConnectorMutationVariables>(SetupConnectorDocument, options);
      }
export type SetupConnectorMutationHookResult = ReturnType<typeof useSetupConnectorMutation>;
export type SetupConnectorMutationResult = Apollo.MutationResult<SetupConnectorMutation>;
export type SetupConnectorMutationOptions = Apollo.BaseMutationOptions<SetupConnectorMutation, SetupConnectorMutationVariables>;
export const UpdateApiUserPermissionsDocument = gql`
    mutation UpdateApiUserPermissions($id: ID!, $permissions: [String!]!) {
  updateApiUserPermissions(id: $id, permissions: $permissions) {
    ...ApiUser
  }
}
    ${ApiUserFragmentDoc}`;
export type UpdateApiUserPermissionsMutationFn = Apollo.MutationFunction<UpdateApiUserPermissionsMutation, UpdateApiUserPermissionsMutationVariables>;

/**
 * __useUpdateApiUserPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateApiUserPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApiUserPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApiUserPermissionsMutation, { data, loading, error }] = useUpdateApiUserPermissionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useUpdateApiUserPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApiUserPermissionsMutation, UpdateApiUserPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApiUserPermissionsMutation, UpdateApiUserPermissionsMutationVariables>(UpdateApiUserPermissionsDocument, options);
      }
export type UpdateApiUserPermissionsMutationHookResult = ReturnType<typeof useUpdateApiUserPermissionsMutation>;
export type UpdateApiUserPermissionsMutationResult = Apollo.MutationResult<UpdateApiUserPermissionsMutation>;
export type UpdateApiUserPermissionsMutationOptions = Apollo.BaseMutationOptions<UpdateApiUserPermissionsMutation, UpdateApiUserPermissionsMutationVariables>;
export const UpdateMcpRemoteSettingsDocument = gql`
    mutation UpdateMcpRemoteSettings($enabled: Boolean!) {
  updateMcpRemoteSettings(enabled: $enabled) {
    enabled
  }
}
    `;
export type UpdateMcpRemoteSettingsMutationFn = Apollo.MutationFunction<UpdateMcpRemoteSettingsMutation, UpdateMcpRemoteSettingsMutationVariables>;

/**
 * __useUpdateMcpRemoteSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateMcpRemoteSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMcpRemoteSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMcpRemoteSettingsMutation, { data, loading, error }] = useUpdateMcpRemoteSettingsMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateMcpRemoteSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMcpRemoteSettingsMutation, UpdateMcpRemoteSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMcpRemoteSettingsMutation, UpdateMcpRemoteSettingsMutationVariables>(UpdateMcpRemoteSettingsDocument, options);
      }
export type UpdateMcpRemoteSettingsMutationHookResult = ReturnType<typeof useUpdateMcpRemoteSettingsMutation>;
export type UpdateMcpRemoteSettingsMutationResult = Apollo.MutationResult<UpdateMcpRemoteSettingsMutation>;
export type UpdateMcpRemoteSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateMcpRemoteSettingsMutation, UpdateMcpRemoteSettingsMutationVariables>;
export const ApiUsersDocument = gql`
    query ApiUsers {
  apiUsers {
    ...ApiUser
  }
}
    ${ApiUserFragmentDoc}`;

/**
 * __useApiUsersQuery__
 *
 * To run a query within a React component, call `useApiUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiUsersQuery(baseOptions?: Apollo.QueryHookOptions<ApiUsersQuery, ApiUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiUsersQuery, ApiUsersQueryVariables>(ApiUsersDocument, options);
      }
export function useApiUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiUsersQuery, ApiUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiUsersQuery, ApiUsersQueryVariables>(ApiUsersDocument, options);
        }
// @ts-ignore
export function useApiUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApiUsersQuery, ApiUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ApiUsersQuery, ApiUsersQueryVariables>;
export function useApiUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiUsersQuery, ApiUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ApiUsersQuery | undefined, ApiUsersQueryVariables>;
export function useApiUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiUsersQuery, ApiUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiUsersQuery, ApiUsersQueryVariables>(ApiUsersDocument, options);
        }
export type ApiUsersQueryHookResult = ReturnType<typeof useApiUsersQuery>;
export type ApiUsersLazyQueryHookResult = ReturnType<typeof useApiUsersLazyQuery>;
export type ApiUsersSuspenseQueryHookResult = ReturnType<typeof useApiUsersSuspenseQuery>;
export type ApiUsersQueryResult = Apollo.QueryResult<ApiUsersQuery, ApiUsersQueryVariables>;
export const ConnectorConfigFieldDocument = gql`
    query ConnectorConfigField($connectorType: ConnectorType!, $key: String!) {
  connectorConfigField(connectorType: $connectorType, key: $key) {
    ... on ConnectorConfigFieldBoolean {
      id
      key
      type
      isConfigured
      boolean: value
    }
    ... on ConnectorConfigFieldDate {
      id
      key
      type
      isConfigured
      date
    }
    ... on ConnectorConfigFieldText {
      id
      key
      type
      isConfigured
      isSecret
      text
    }
    ... on ConnectorConfigFieldMultiSelect {
      id
      key
      type
      isConfigured
      options {
        label
        value
      }
      values
    }
    ... on ConnectorConfigFieldOAuth2 {
      id
      key
      type
      isConfigured
      authorizeUrl
      authorizationInfo
    }
    ... on ConnectorConfigFieldSelect {
      id
      key
      type
      isConfigured
      options {
        label
        value
      }
      value
    }
    ... on ConnectorConfigFieldFilter {
      id
      key
      isConfigured
      key
      type
      whitelist
      available {
        type
        fields
        options {
          label
          value
        }
      }
      configured {
        type
        field
        values
      }
    }
  }
}
    `;

/**
 * __useConnectorConfigFieldQuery__
 *
 * To run a query within a React component, call `useConnectorConfigFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectorConfigFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectorConfigFieldQuery({
 *   variables: {
 *      connectorType: // value for 'connectorType'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useConnectorConfigFieldQuery(baseOptions: Apollo.QueryHookOptions<ConnectorConfigFieldQuery, ConnectorConfigFieldQueryVariables> & ({ variables: ConnectorConfigFieldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectorConfigFieldQuery, ConnectorConfigFieldQueryVariables>(ConnectorConfigFieldDocument, options);
      }
export function useConnectorConfigFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectorConfigFieldQuery, ConnectorConfigFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectorConfigFieldQuery, ConnectorConfigFieldQueryVariables>(ConnectorConfigFieldDocument, options);
        }
// @ts-ignore
export function useConnectorConfigFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectorConfigFieldQuery, ConnectorConfigFieldQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorConfigFieldQuery, ConnectorConfigFieldQueryVariables>;
export function useConnectorConfigFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorConfigFieldQuery, ConnectorConfigFieldQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorConfigFieldQuery | undefined, ConnectorConfigFieldQueryVariables>;
export function useConnectorConfigFieldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorConfigFieldQuery, ConnectorConfigFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectorConfigFieldQuery, ConnectorConfigFieldQueryVariables>(ConnectorConfigFieldDocument, options);
        }
export type ConnectorConfigFieldQueryHookResult = ReturnType<typeof useConnectorConfigFieldQuery>;
export type ConnectorConfigFieldLazyQueryHookResult = ReturnType<typeof useConnectorConfigFieldLazyQuery>;
export type ConnectorConfigFieldSuspenseQueryHookResult = ReturnType<typeof useConnectorConfigFieldSuspenseQuery>;
export type ConnectorConfigFieldQueryResult = Apollo.QueryResult<ConnectorConfigFieldQuery, ConnectorConfigFieldQueryVariables>;
export const ConnectorLogsDocument = gql`
    query ConnectorLogs($date: String!, $minimumLogLevel: ConnectorLogLevel, $after: ID, $first: Int) {
  connectorLogs(
    date: $date
    minimumLogLevel: $minimumLogLevel
    after: $after
    first: $first
  ) {
    edges {
      node {
        id
        timestamp
        logLevel
        message
        errorType
        metadata {
          user {
            externalReferenceID
            username
            email
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useConnectorLogsQuery__
 *
 * To run a query within a React component, call `useConnectorLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectorLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectorLogsQuery({
 *   variables: {
 *      date: // value for 'date'
 *      minimumLogLevel: // value for 'minimumLogLevel'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useConnectorLogsQuery(baseOptions: Apollo.QueryHookOptions<ConnectorLogsQuery, ConnectorLogsQueryVariables> & ({ variables: ConnectorLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectorLogsQuery, ConnectorLogsQueryVariables>(ConnectorLogsDocument, options);
      }
export function useConnectorLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectorLogsQuery, ConnectorLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectorLogsQuery, ConnectorLogsQueryVariables>(ConnectorLogsDocument, options);
        }
// @ts-ignore
export function useConnectorLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectorLogsQuery, ConnectorLogsQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorLogsQuery, ConnectorLogsQueryVariables>;
export function useConnectorLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorLogsQuery, ConnectorLogsQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorLogsQuery | undefined, ConnectorLogsQueryVariables>;
export function useConnectorLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorLogsQuery, ConnectorLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectorLogsQuery, ConnectorLogsQueryVariables>(ConnectorLogsDocument, options);
        }
export type ConnectorLogsQueryHookResult = ReturnType<typeof useConnectorLogsQuery>;
export type ConnectorLogsLazyQueryHookResult = ReturnType<typeof useConnectorLogsLazyQuery>;
export type ConnectorLogsSuspenseQueryHookResult = ReturnType<typeof useConnectorLogsSuspenseQuery>;
export type ConnectorLogsQueryResult = Apollo.QueryResult<ConnectorLogsQuery, ConnectorLogsQueryVariables>;
export const ConnectorsDocument = gql`
    query Connectors {
  connectors {
    type
    isActive
    authorizationInfo
    authorizeUrl
  }
}
    `;

/**
 * __useConnectorsQuery__
 *
 * To run a query within a React component, call `useConnectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConnectorsQuery(baseOptions?: Apollo.QueryHookOptions<ConnectorsQuery, ConnectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectorsQuery, ConnectorsQueryVariables>(ConnectorsDocument, options);
      }
export function useConnectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectorsQuery, ConnectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectorsQuery, ConnectorsQueryVariables>(ConnectorsDocument, options);
        }
// @ts-ignore
export function useConnectorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectorsQuery, ConnectorsQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorsQuery, ConnectorsQueryVariables>;
export function useConnectorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorsQuery, ConnectorsQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorsQuery | undefined, ConnectorsQueryVariables>;
export function useConnectorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorsQuery, ConnectorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectorsQuery, ConnectorsQueryVariables>(ConnectorsDocument, options);
        }
export type ConnectorsQueryHookResult = ReturnType<typeof useConnectorsQuery>;
export type ConnectorsLazyQueryHookResult = ReturnType<typeof useConnectorsLazyQuery>;
export type ConnectorsSuspenseQueryHookResult = ReturnType<typeof useConnectorsSuspenseQuery>;
export type ConnectorsQueryResult = Apollo.QueryResult<ConnectorsQuery, ConnectorsQueryVariables>;
export const MarketplaceDocument = gql`
    query Marketplace {
  viewer {
    id
    workspace {
      id
      connector {
        id
        type
      }
      styrConfig {
        organisationID
      }
      goodHabitzConfig {
        enabled
      }
    }
  }
}
    `;

/**
 * __useMarketplaceQuery__
 *
 * To run a query within a React component, call `useMarketplaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarketplaceQuery(baseOptions?: Apollo.QueryHookOptions<MarketplaceQuery, MarketplaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceQuery, MarketplaceQueryVariables>(MarketplaceDocument, options);
      }
export function useMarketplaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceQuery, MarketplaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceQuery, MarketplaceQueryVariables>(MarketplaceDocument, options);
        }
// @ts-ignore
export function useMarketplaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MarketplaceQuery, MarketplaceQueryVariables>): Apollo.UseSuspenseQueryResult<MarketplaceQuery, MarketplaceQueryVariables>;
export function useMarketplaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarketplaceQuery, MarketplaceQueryVariables>): Apollo.UseSuspenseQueryResult<MarketplaceQuery | undefined, MarketplaceQueryVariables>;
export function useMarketplaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MarketplaceQuery, MarketplaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MarketplaceQuery, MarketplaceQueryVariables>(MarketplaceDocument, options);
        }
export type MarketplaceQueryHookResult = ReturnType<typeof useMarketplaceQuery>;
export type MarketplaceLazyQueryHookResult = ReturnType<typeof useMarketplaceLazyQuery>;
export type MarketplaceSuspenseQueryHookResult = ReturnType<typeof useMarketplaceSuspenseQuery>;
export type MarketplaceQueryResult = Apollo.QueryResult<MarketplaceQuery, MarketplaceQueryVariables>;
export const McpRemoteSettingsDocument = gql`
    query McpRemoteSettings {
  mcpRemoteSettings {
    enabled
    connectionUrl
  }
}
    `;

/**
 * __useMcpRemoteSettingsQuery__
 *
 * To run a query within a React component, call `useMcpRemoteSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcpRemoteSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcpRemoteSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMcpRemoteSettingsQuery(baseOptions?: Apollo.QueryHookOptions<McpRemoteSettingsQuery, McpRemoteSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<McpRemoteSettingsQuery, McpRemoteSettingsQueryVariables>(McpRemoteSettingsDocument, options);
      }
export function useMcpRemoteSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<McpRemoteSettingsQuery, McpRemoteSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<McpRemoteSettingsQuery, McpRemoteSettingsQueryVariables>(McpRemoteSettingsDocument, options);
        }
// @ts-ignore
export function useMcpRemoteSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<McpRemoteSettingsQuery, McpRemoteSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<McpRemoteSettingsQuery, McpRemoteSettingsQueryVariables>;
export function useMcpRemoteSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McpRemoteSettingsQuery, McpRemoteSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<McpRemoteSettingsQuery | undefined, McpRemoteSettingsQueryVariables>;
export function useMcpRemoteSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McpRemoteSettingsQuery, McpRemoteSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<McpRemoteSettingsQuery, McpRemoteSettingsQueryVariables>(McpRemoteSettingsDocument, options);
        }
export type McpRemoteSettingsQueryHookResult = ReturnType<typeof useMcpRemoteSettingsQuery>;
export type McpRemoteSettingsLazyQueryHookResult = ReturnType<typeof useMcpRemoteSettingsLazyQuery>;
export type McpRemoteSettingsSuspenseQueryHookResult = ReturnType<typeof useMcpRemoteSettingsSuspenseQuery>;
export type McpRemoteSettingsQueryResult = Apollo.QueryResult<McpRemoteSettingsQuery, McpRemoteSettingsQueryVariables>;
export const MicrosoftConfigDocument = gql`
    query MicrosoftConfig {
  viewer {
    workspace {
      microsoftConfig {
        id
        isConfigured
        tenantId
        teamsConnected
        outlookConnected
        teamsRequiresReconsent
        outlookRequiresReconsent
      }
    }
  }
}
    `;

/**
 * __useMicrosoftConfigQuery__
 *
 * To run a query within a React component, call `useMicrosoftConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useMicrosoftConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMicrosoftConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useMicrosoftConfigQuery(baseOptions?: Apollo.QueryHookOptions<MicrosoftConfigQuery, MicrosoftConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MicrosoftConfigQuery, MicrosoftConfigQueryVariables>(MicrosoftConfigDocument, options);
      }
export function useMicrosoftConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MicrosoftConfigQuery, MicrosoftConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MicrosoftConfigQuery, MicrosoftConfigQueryVariables>(MicrosoftConfigDocument, options);
        }
// @ts-ignore
export function useMicrosoftConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MicrosoftConfigQuery, MicrosoftConfigQueryVariables>): Apollo.UseSuspenseQueryResult<MicrosoftConfigQuery, MicrosoftConfigQueryVariables>;
export function useMicrosoftConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MicrosoftConfigQuery, MicrosoftConfigQueryVariables>): Apollo.UseSuspenseQueryResult<MicrosoftConfigQuery | undefined, MicrosoftConfigQueryVariables>;
export function useMicrosoftConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MicrosoftConfigQuery, MicrosoftConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MicrosoftConfigQuery, MicrosoftConfigQueryVariables>(MicrosoftConfigDocument, options);
        }
export type MicrosoftConfigQueryHookResult = ReturnType<typeof useMicrosoftConfigQuery>;
export type MicrosoftConfigLazyQueryHookResult = ReturnType<typeof useMicrosoftConfigLazyQuery>;
export type MicrosoftConfigSuspenseQueryHookResult = ReturnType<typeof useMicrosoftConfigSuspenseQuery>;
export type MicrosoftConfigQueryResult = Apollo.QueryResult<MicrosoftConfigQuery, MicrosoftConfigQueryVariables>;
export const SlackConfigDocument = gql`
    query SlackConfig {
  viewer {
    workspace {
      slackConfig {
        id
        isConfigured
        authorizeUrl
        wantedScopes
        configuredScopes
        team {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useSlackConfigQuery__
 *
 * To run a query within a React component, call `useSlackConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlackConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlackConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useSlackConfigQuery(baseOptions?: Apollo.QueryHookOptions<SlackConfigQuery, SlackConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SlackConfigQuery, SlackConfigQueryVariables>(SlackConfigDocument, options);
      }
export function useSlackConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SlackConfigQuery, SlackConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SlackConfigQuery, SlackConfigQueryVariables>(SlackConfigDocument, options);
        }
// @ts-ignore
export function useSlackConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SlackConfigQuery, SlackConfigQueryVariables>): Apollo.UseSuspenseQueryResult<SlackConfigQuery, SlackConfigQueryVariables>;
export function useSlackConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SlackConfigQuery, SlackConfigQueryVariables>): Apollo.UseSuspenseQueryResult<SlackConfigQuery | undefined, SlackConfigQueryVariables>;
export function useSlackConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SlackConfigQuery, SlackConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SlackConfigQuery, SlackConfigQueryVariables>(SlackConfigDocument, options);
        }
export type SlackConfigQueryHookResult = ReturnType<typeof useSlackConfigQuery>;
export type SlackConfigLazyQueryHookResult = ReturnType<typeof useSlackConfigLazyQuery>;
export type SlackConfigSuspenseQueryHookResult = ReturnType<typeof useSlackConfigSuspenseQuery>;
export type SlackConfigQueryResult = Apollo.QueryResult<SlackConfigQuery, SlackConfigQueryVariables>;
export const StyrOrganisationsDocument = gql`
    query StyrOrganisations {
  styrOrganisations {
    id
    name
  }
}
    `;

/**
 * __useStyrOrganisationsQuery__
 *
 * To run a query within a React component, call `useStyrOrganisationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStyrOrganisationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStyrOrganisationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStyrOrganisationsQuery(baseOptions?: Apollo.QueryHookOptions<StyrOrganisationsQuery, StyrOrganisationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StyrOrganisationsQuery, StyrOrganisationsQueryVariables>(StyrOrganisationsDocument, options);
      }
export function useStyrOrganisationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StyrOrganisationsQuery, StyrOrganisationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StyrOrganisationsQuery, StyrOrganisationsQueryVariables>(StyrOrganisationsDocument, options);
        }
// @ts-ignore
export function useStyrOrganisationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StyrOrganisationsQuery, StyrOrganisationsQueryVariables>): Apollo.UseSuspenseQueryResult<StyrOrganisationsQuery, StyrOrganisationsQueryVariables>;
export function useStyrOrganisationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StyrOrganisationsQuery, StyrOrganisationsQueryVariables>): Apollo.UseSuspenseQueryResult<StyrOrganisationsQuery | undefined, StyrOrganisationsQueryVariables>;
export function useStyrOrganisationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StyrOrganisationsQuery, StyrOrganisationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StyrOrganisationsQuery, StyrOrganisationsQueryVariables>(StyrOrganisationsDocument, options);
        }
export type StyrOrganisationsQueryHookResult = ReturnType<typeof useStyrOrganisationsQuery>;
export type StyrOrganisationsLazyQueryHookResult = ReturnType<typeof useStyrOrganisationsLazyQuery>;
export type StyrOrganisationsSuspenseQueryHookResult = ReturnType<typeof useStyrOrganisationsSuspenseQuery>;
export type StyrOrganisationsQueryResult = Apollo.QueryResult<StyrOrganisationsQuery, StyrOrganisationsQueryVariables>;
export const ArchiveEvaluationFormDocument = gql`
    mutation ArchiveEvaluationForm($input: ArchiveEvaluationFormInput!) {
  archiveEvaluationForm(input: $input) {
    evaluationForm {
      ...EvaluationFormEditor
    }
  }
}
    ${EvaluationFormEditorFragmentDoc}`;
export type ArchiveEvaluationFormMutationFn = Apollo.MutationFunction<ArchiveEvaluationFormMutation, ArchiveEvaluationFormMutationVariables>;

/**
 * __useArchiveEvaluationFormMutation__
 *
 * To run a mutation, you first call `useArchiveEvaluationFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveEvaluationFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveEvaluationFormMutation, { data, loading, error }] = useArchiveEvaluationFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveEvaluationFormMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveEvaluationFormMutation, ArchiveEvaluationFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveEvaluationFormMutation, ArchiveEvaluationFormMutationVariables>(ArchiveEvaluationFormDocument, options);
      }
export type ArchiveEvaluationFormMutationHookResult = ReturnType<typeof useArchiveEvaluationFormMutation>;
export type ArchiveEvaluationFormMutationResult = Apollo.MutationResult<ArchiveEvaluationFormMutation>;
export type ArchiveEvaluationFormMutationOptions = Apollo.BaseMutationOptions<ArchiveEvaluationFormMutation, ArchiveEvaluationFormMutationVariables>;
export const ChangeConversationPartnerDocument = gql`
    mutation ChangeConversationPartner($input: ChangeConversationPartnerInput!) {
  changeConversationPartner(input: $input) {
    evaluationSubmission {
      ...EvaluationSubmission
    }
  }
}
    ${EvaluationSubmissionFragmentDoc}`;
export type ChangeConversationPartnerMutationFn = Apollo.MutationFunction<ChangeConversationPartnerMutation, ChangeConversationPartnerMutationVariables>;

/**
 * __useChangeConversationPartnerMutation__
 *
 * To run a mutation, you first call `useChangeConversationPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeConversationPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeConversationPartnerMutation, { data, loading, error }] = useChangeConversationPartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeConversationPartnerMutation(baseOptions?: Apollo.MutationHookOptions<ChangeConversationPartnerMutation, ChangeConversationPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeConversationPartnerMutation, ChangeConversationPartnerMutationVariables>(ChangeConversationPartnerDocument, options);
      }
export type ChangeConversationPartnerMutationHookResult = ReturnType<typeof useChangeConversationPartnerMutation>;
export type ChangeConversationPartnerMutationResult = Apollo.MutationResult<ChangeConversationPartnerMutation>;
export type ChangeConversationPartnerMutationOptions = Apollo.BaseMutationOptions<ChangeConversationPartnerMutation, ChangeConversationPartnerMutationVariables>;
export const CompleteConversationDocument = gql`
    mutation CompleteConversation($input: CompleteConversationInput!) {
  completeConversation(input: $input) {
    evaluationSubmission {
      id
      manager {
        isCompleted
      }
    }
  }
}
    `;
export type CompleteConversationMutationFn = Apollo.MutationFunction<CompleteConversationMutation, CompleteConversationMutationVariables>;

/**
 * __useCompleteConversationMutation__
 *
 * To run a mutation, you first call `useCompleteConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeConversationMutation, { data, loading, error }] = useCompleteConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteConversationMutation(baseOptions?: Apollo.MutationHookOptions<CompleteConversationMutation, CompleteConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteConversationMutation, CompleteConversationMutationVariables>(CompleteConversationDocument, options);
      }
export type CompleteConversationMutationHookResult = ReturnType<typeof useCompleteConversationMutation>;
export type CompleteConversationMutationResult = Apollo.MutationResult<CompleteConversationMutation>;
export type CompleteConversationMutationOptions = Apollo.BaseMutationOptions<CompleteConversationMutation, CompleteConversationMutationVariables>;
export const CreateEvaluationFormDocument = gql`
    mutation CreateEvaluationForm($input: CreateEvaluationFormInput!) {
  createEvaluationForm(input: $input) {
    evaluationForm {
      id
      title
      sections {
        items {
          id
        }
      }
    }
  }
}
    `;
export type CreateEvaluationFormMutationFn = Apollo.MutationFunction<CreateEvaluationFormMutation, CreateEvaluationFormMutationVariables>;

/**
 * __useCreateEvaluationFormMutation__
 *
 * To run a mutation, you first call `useCreateEvaluationFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEvaluationFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEvaluationFormMutation, { data, loading, error }] = useCreateEvaluationFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEvaluationFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateEvaluationFormMutation, CreateEvaluationFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEvaluationFormMutation, CreateEvaluationFormMutationVariables>(CreateEvaluationFormDocument, options);
      }
export type CreateEvaluationFormMutationHookResult = ReturnType<typeof useCreateEvaluationFormMutation>;
export type CreateEvaluationFormMutationResult = Apollo.MutationResult<CreateEvaluationFormMutation>;
export type CreateEvaluationFormMutationOptions = Apollo.BaseMutationOptions<CreateEvaluationFormMutation, CreateEvaluationFormMutationVariables>;
export const DiscardAnswersFromPredecessorDocument = gql`
    mutation DiscardAnswersFromPredecessor($input: DiscardAnswersFromPredecessorInput!) {
  discardAnswersFromPredecessor(input: $input) {
    evaluationSubmission {
      ...EvaluationSubmission
    }
  }
}
    ${EvaluationSubmissionFragmentDoc}`;
export type DiscardAnswersFromPredecessorMutationFn = Apollo.MutationFunction<DiscardAnswersFromPredecessorMutation, DiscardAnswersFromPredecessorMutationVariables>;

/**
 * __useDiscardAnswersFromPredecessorMutation__
 *
 * To run a mutation, you first call `useDiscardAnswersFromPredecessorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardAnswersFromPredecessorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardAnswersFromPredecessorMutation, { data, loading, error }] = useDiscardAnswersFromPredecessorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDiscardAnswersFromPredecessorMutation(baseOptions?: Apollo.MutationHookOptions<DiscardAnswersFromPredecessorMutation, DiscardAnswersFromPredecessorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscardAnswersFromPredecessorMutation, DiscardAnswersFromPredecessorMutationVariables>(DiscardAnswersFromPredecessorDocument, options);
      }
export type DiscardAnswersFromPredecessorMutationHookResult = ReturnType<typeof useDiscardAnswersFromPredecessorMutation>;
export type DiscardAnswersFromPredecessorMutationResult = Apollo.MutationResult<DiscardAnswersFromPredecessorMutation>;
export type DiscardAnswersFromPredecessorMutationOptions = Apollo.BaseMutationOptions<DiscardAnswersFromPredecessorMutation, DiscardAnswersFromPredecessorMutationVariables>;
export const ExportConversationToPdfDocument = gql`
    mutation ExportConversationToPDF($conversationID: ID!, $locale: String) {
  exportToPDF(conversationID: $conversationID, locale: $locale) {
    url
  }
}
    `;
export type ExportConversationToPdfMutationFn = Apollo.MutationFunction<ExportConversationToPdfMutation, ExportConversationToPdfMutationVariables>;

/**
 * __useExportConversationToPdfMutation__
 *
 * To run a mutation, you first call `useExportConversationToPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportConversationToPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportConversationToPdfMutation, { data, loading, error }] = useExportConversationToPdfMutation({
 *   variables: {
 *      conversationID: // value for 'conversationID'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useExportConversationToPdfMutation(baseOptions?: Apollo.MutationHookOptions<ExportConversationToPdfMutation, ExportConversationToPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportConversationToPdfMutation, ExportConversationToPdfMutationVariables>(ExportConversationToPdfDocument, options);
      }
export type ExportConversationToPdfMutationHookResult = ReturnType<typeof useExportConversationToPdfMutation>;
export type ExportConversationToPdfMutationResult = Apollo.MutationResult<ExportConversationToPdfMutation>;
export type ExportConversationToPdfMutationOptions = Apollo.BaseMutationOptions<ExportConversationToPdfMutation, ExportConversationToPdfMutationVariables>;
export const KeepAnswersFromPredecessorDocument = gql`
    mutation KeepAnswersFromPredecessor($input: KeepAnswersFromPredecessorInput!) {
  keepAnswersFromPredecessor(input: $input) {
    evaluationSubmission {
      ...EvaluationSubmission
    }
  }
}
    ${EvaluationSubmissionFragmentDoc}`;
export type KeepAnswersFromPredecessorMutationFn = Apollo.MutationFunction<KeepAnswersFromPredecessorMutation, KeepAnswersFromPredecessorMutationVariables>;

/**
 * __useKeepAnswersFromPredecessorMutation__
 *
 * To run a mutation, you first call `useKeepAnswersFromPredecessorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKeepAnswersFromPredecessorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [keepAnswersFromPredecessorMutation, { data, loading, error }] = useKeepAnswersFromPredecessorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKeepAnswersFromPredecessorMutation(baseOptions?: Apollo.MutationHookOptions<KeepAnswersFromPredecessorMutation, KeepAnswersFromPredecessorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KeepAnswersFromPredecessorMutation, KeepAnswersFromPredecessorMutationVariables>(KeepAnswersFromPredecessorDocument, options);
      }
export type KeepAnswersFromPredecessorMutationHookResult = ReturnType<typeof useKeepAnswersFromPredecessorMutation>;
export type KeepAnswersFromPredecessorMutationResult = Apollo.MutationResult<KeepAnswersFromPredecessorMutation>;
export type KeepAnswersFromPredecessorMutationOptions = Apollo.BaseMutationOptions<KeepAnswersFromPredecessorMutation, KeepAnswersFromPredecessorMutationVariables>;
export const RestoreEvaluationFormDocument = gql`
    mutation RestoreEvaluationForm($input: RestoreEvaluationFormInput!) {
  restoreEvaluationForm(input: $input) {
    evaluationForm {
      ...EvaluationFormEditor
    }
  }
}
    ${EvaluationFormEditorFragmentDoc}`;
export type RestoreEvaluationFormMutationFn = Apollo.MutationFunction<RestoreEvaluationFormMutation, RestoreEvaluationFormMutationVariables>;

/**
 * __useRestoreEvaluationFormMutation__
 *
 * To run a mutation, you first call `useRestoreEvaluationFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreEvaluationFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreEvaluationFormMutation, { data, loading, error }] = useRestoreEvaluationFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreEvaluationFormMutation(baseOptions?: Apollo.MutationHookOptions<RestoreEvaluationFormMutation, RestoreEvaluationFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreEvaluationFormMutation, RestoreEvaluationFormMutationVariables>(RestoreEvaluationFormDocument, options);
      }
export type RestoreEvaluationFormMutationHookResult = ReturnType<typeof useRestoreEvaluationFormMutation>;
export type RestoreEvaluationFormMutationResult = Apollo.MutationResult<RestoreEvaluationFormMutation>;
export type RestoreEvaluationFormMutationOptions = Apollo.BaseMutationOptions<RestoreEvaluationFormMutation, RestoreEvaluationFormMutationVariables>;
export const UncompleteConversationDocument = gql`
    mutation UncompleteConversation($input: UncompleteConversationInput!) {
  uncompleteConversation(input: $input) {
    evaluationSubmission {
      id
      manager {
        isCompleted
      }
    }
  }
}
    `;
export type UncompleteConversationMutationFn = Apollo.MutationFunction<UncompleteConversationMutation, UncompleteConversationMutationVariables>;

/**
 * __useUncompleteConversationMutation__
 *
 * To run a mutation, you first call `useUncompleteConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUncompleteConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uncompleteConversationMutation, { data, loading, error }] = useUncompleteConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUncompleteConversationMutation(baseOptions?: Apollo.MutationHookOptions<UncompleteConversationMutation, UncompleteConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UncompleteConversationMutation, UncompleteConversationMutationVariables>(UncompleteConversationDocument, options);
      }
export type UncompleteConversationMutationHookResult = ReturnType<typeof useUncompleteConversationMutation>;
export type UncompleteConversationMutationResult = Apollo.MutationResult<UncompleteConversationMutation>;
export type UncompleteConversationMutationOptions = Apollo.BaseMutationOptions<UncompleteConversationMutation, UncompleteConversationMutationVariables>;
export const UpdateEvaluationFormDocument = gql`
    mutation UpdateEvaluationForm($input: UpdateEvaluationFormInput!) {
  updateEvaluationForm(input: $input) {
    evaluationForm {
      ...EvaluationFormEditor
    }
  }
}
    ${EvaluationFormEditorFragmentDoc}`;
export type UpdateEvaluationFormMutationFn = Apollo.MutationFunction<UpdateEvaluationFormMutation, UpdateEvaluationFormMutationVariables>;

/**
 * __useUpdateEvaluationFormMutation__
 *
 * To run a mutation, you first call `useUpdateEvaluationFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEvaluationFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEvaluationFormMutation, { data, loading, error }] = useUpdateEvaluationFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEvaluationFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEvaluationFormMutation, UpdateEvaluationFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEvaluationFormMutation, UpdateEvaluationFormMutationVariables>(UpdateEvaluationFormDocument, options);
      }
export type UpdateEvaluationFormMutationHookResult = ReturnType<typeof useUpdateEvaluationFormMutation>;
export type UpdateEvaluationFormMutationResult = Apollo.MutationResult<UpdateEvaluationFormMutation>;
export type UpdateEvaluationFormMutationOptions = Apollo.BaseMutationOptions<UpdateEvaluationFormMutation, UpdateEvaluationFormMutationVariables>;
export const EvaluationFormDocument = gql`
    query EvaluationForm($id: ID!) {
  evaluationForm(id: $id) {
    ...EvaluationFormEditor
  }
}
    ${EvaluationFormEditorFragmentDoc}`;

/**
 * __useEvaluationFormQuery__
 *
 * To run a query within a React component, call `useEvaluationFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluationFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluationFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEvaluationFormQuery(baseOptions: Apollo.QueryHookOptions<EvaluationFormQuery, EvaluationFormQueryVariables> & ({ variables: EvaluationFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvaluationFormQuery, EvaluationFormQueryVariables>(EvaluationFormDocument, options);
      }
export function useEvaluationFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EvaluationFormQuery, EvaluationFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvaluationFormQuery, EvaluationFormQueryVariables>(EvaluationFormDocument, options);
        }
// @ts-ignore
export function useEvaluationFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EvaluationFormQuery, EvaluationFormQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationFormQuery, EvaluationFormQueryVariables>;
export function useEvaluationFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationFormQuery, EvaluationFormQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationFormQuery | undefined, EvaluationFormQueryVariables>;
export function useEvaluationFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationFormQuery, EvaluationFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EvaluationFormQuery, EvaluationFormQueryVariables>(EvaluationFormDocument, options);
        }
export type EvaluationFormQueryHookResult = ReturnType<typeof useEvaluationFormQuery>;
export type EvaluationFormLazyQueryHookResult = ReturnType<typeof useEvaluationFormLazyQuery>;
export type EvaluationFormSuspenseQueryHookResult = ReturnType<typeof useEvaluationFormSuspenseQuery>;
export type EvaluationFormQueryResult = Apollo.QueryResult<EvaluationFormQuery, EvaluationFormQueryVariables>;
export const EvaluationFormsDocument = gql`
    query EvaluationForms($isArchived: Boolean!, $before: ID, $after: ID, $first: Int, $last: Int) {
  evaluationForms(
    isArchived: $isArchived
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        id
        title
        description
        jobTitleIDs
        useOnlyInCycle
        isArchived
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useEvaluationFormsQuery__
 *
 * To run a query within a React component, call `useEvaluationFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluationFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluationFormsQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useEvaluationFormsQuery(baseOptions: Apollo.QueryHookOptions<EvaluationFormsQuery, EvaluationFormsQueryVariables> & ({ variables: EvaluationFormsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvaluationFormsQuery, EvaluationFormsQueryVariables>(EvaluationFormsDocument, options);
      }
export function useEvaluationFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EvaluationFormsQuery, EvaluationFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvaluationFormsQuery, EvaluationFormsQueryVariables>(EvaluationFormsDocument, options);
        }
// @ts-ignore
export function useEvaluationFormsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EvaluationFormsQuery, EvaluationFormsQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationFormsQuery, EvaluationFormsQueryVariables>;
export function useEvaluationFormsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationFormsQuery, EvaluationFormsQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationFormsQuery | undefined, EvaluationFormsQueryVariables>;
export function useEvaluationFormsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationFormsQuery, EvaluationFormsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EvaluationFormsQuery, EvaluationFormsQueryVariables>(EvaluationFormsDocument, options);
        }
export type EvaluationFormsQueryHookResult = ReturnType<typeof useEvaluationFormsQuery>;
export type EvaluationFormsLazyQueryHookResult = ReturnType<typeof useEvaluationFormsLazyQuery>;
export type EvaluationFormsSuspenseQueryHookResult = ReturnType<typeof useEvaluationFormsSuspenseQuery>;
export type EvaluationFormsQueryResult = Apollo.QueryResult<EvaluationFormsQuery, EvaluationFormsQueryVariables>;
export const SendCycleMomentManagerRemindersDocument = gql`
    mutation SendCycleMomentManagerReminders($input: SendCycleMomentManagerRemindersInput!) {
  sendCycleMomentManagerReminders(input: $input) {
    success
  }
}
    `;
export type SendCycleMomentManagerRemindersMutationFn = Apollo.MutationFunction<SendCycleMomentManagerRemindersMutation, SendCycleMomentManagerRemindersMutationVariables>;

/**
 * __useSendCycleMomentManagerRemindersMutation__
 *
 * To run a mutation, you first call `useSendCycleMomentManagerRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCycleMomentManagerRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCycleMomentManagerRemindersMutation, { data, loading, error }] = useSendCycleMomentManagerRemindersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCycleMomentManagerRemindersMutation(baseOptions?: Apollo.MutationHookOptions<SendCycleMomentManagerRemindersMutation, SendCycleMomentManagerRemindersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCycleMomentManagerRemindersMutation, SendCycleMomentManagerRemindersMutationVariables>(SendCycleMomentManagerRemindersDocument, options);
      }
export type SendCycleMomentManagerRemindersMutationHookResult = ReturnType<typeof useSendCycleMomentManagerRemindersMutation>;
export type SendCycleMomentManagerRemindersMutationResult = Apollo.MutationResult<SendCycleMomentManagerRemindersMutation>;
export type SendCycleMomentManagerRemindersMutationOptions = Apollo.BaseMutationOptions<SendCycleMomentManagerRemindersMutation, SendCycleMomentManagerRemindersMutationVariables>;
export const ArchiveEngagementCategoryDocument = gql`
    mutation ArchiveEngagementCategory($input: ArchiveEngagementCategoryInput!) {
  archiveEngagementCategory(input: $input) {
    category {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveEngagementCategoryMutationFn = Apollo.MutationFunction<ArchiveEngagementCategoryMutation, ArchiveEngagementCategoryMutationVariables>;

/**
 * __useArchiveEngagementCategoryMutation__
 *
 * To run a mutation, you first call `useArchiveEngagementCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveEngagementCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveEngagementCategoryMutation, { data, loading, error }] = useArchiveEngagementCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveEngagementCategoryMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveEngagementCategoryMutation, ArchiveEngagementCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveEngagementCategoryMutation, ArchiveEngagementCategoryMutationVariables>(ArchiveEngagementCategoryDocument, options);
      }
export type ArchiveEngagementCategoryMutationHookResult = ReturnType<typeof useArchiveEngagementCategoryMutation>;
export type ArchiveEngagementCategoryMutationResult = Apollo.MutationResult<ArchiveEngagementCategoryMutation>;
export type ArchiveEngagementCategoryMutationOptions = Apollo.BaseMutationOptions<ArchiveEngagementCategoryMutation, ArchiveEngagementCategoryMutationVariables>;
export const ArchiveEngagementQuestionDocument = gql`
    mutation ArchiveEngagementQuestion($input: ArchiveEngagementQuestionInput!) {
  archiveEngagementQuestion(input: $input) {
    question {
      id
      order
      isArchived
    }
  }
}
    `;
export type ArchiveEngagementQuestionMutationFn = Apollo.MutationFunction<ArchiveEngagementQuestionMutation, ArchiveEngagementQuestionMutationVariables>;

/**
 * __useArchiveEngagementQuestionMutation__
 *
 * To run a mutation, you first call `useArchiveEngagementQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveEngagementQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveEngagementQuestionMutation, { data, loading, error }] = useArchiveEngagementQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveEngagementQuestionMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveEngagementQuestionMutation, ArchiveEngagementQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveEngagementQuestionMutation, ArchiveEngagementQuestionMutationVariables>(ArchiveEngagementQuestionDocument, options);
      }
export type ArchiveEngagementQuestionMutationHookResult = ReturnType<typeof useArchiveEngagementQuestionMutation>;
export type ArchiveEngagementQuestionMutationResult = Apollo.MutationResult<ArchiveEngagementQuestionMutation>;
export type ArchiveEngagementQuestionMutationOptions = Apollo.BaseMutationOptions<ArchiveEngagementQuestionMutation, ArchiveEngagementQuestionMutationVariables>;
export const ArchiveEngagementSubcategoryDocument = gql`
    mutation ArchiveEngagementSubcategory($input: ArchiveEngagementSubcategoryInput!) {
  archiveEngagementSubcategory(input: $input) {
    subcategory {
      id
      order
      isArchived
    }
  }
}
    `;
export type ArchiveEngagementSubcategoryMutationFn = Apollo.MutationFunction<ArchiveEngagementSubcategoryMutation, ArchiveEngagementSubcategoryMutationVariables>;

/**
 * __useArchiveEngagementSubcategoryMutation__
 *
 * To run a mutation, you first call `useArchiveEngagementSubcategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveEngagementSubcategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveEngagementSubcategoryMutation, { data, loading, error }] = useArchiveEngagementSubcategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveEngagementSubcategoryMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveEngagementSubcategoryMutation, ArchiveEngagementSubcategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveEngagementSubcategoryMutation, ArchiveEngagementSubcategoryMutationVariables>(ArchiveEngagementSubcategoryDocument, options);
      }
export type ArchiveEngagementSubcategoryMutationHookResult = ReturnType<typeof useArchiveEngagementSubcategoryMutation>;
export type ArchiveEngagementSubcategoryMutationResult = Apollo.MutationResult<ArchiveEngagementSubcategoryMutation>;
export type ArchiveEngagementSubcategoryMutationOptions = Apollo.BaseMutationOptions<ArchiveEngagementSubcategoryMutation, ArchiveEngagementSubcategoryMutationVariables>;
export const CancelEngagementRequestDocument = gql`
    mutation CancelEngagementRequest($input: CancelEngagementRequestInput!) {
  cancelEngagementRequest(input: $input) {
    engagementRequest {
      id
      isCancelled
    }
  }
}
    `;
export type CancelEngagementRequestMutationFn = Apollo.MutationFunction<CancelEngagementRequestMutation, CancelEngagementRequestMutationVariables>;

/**
 * __useCancelEngagementRequestMutation__
 *
 * To run a mutation, you first call `useCancelEngagementRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelEngagementRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelEngagementRequestMutation, { data, loading, error }] = useCancelEngagementRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelEngagementRequestMutation(baseOptions?: Apollo.MutationHookOptions<CancelEngagementRequestMutation, CancelEngagementRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelEngagementRequestMutation, CancelEngagementRequestMutationVariables>(CancelEngagementRequestDocument, options);
      }
export type CancelEngagementRequestMutationHookResult = ReturnType<typeof useCancelEngagementRequestMutation>;
export type CancelEngagementRequestMutationResult = Apollo.MutationResult<CancelEngagementRequestMutation>;
export type CancelEngagementRequestMutationOptions = Apollo.BaseMutationOptions<CancelEngagementRequestMutation, CancelEngagementRequestMutationVariables>;
export const CreateEngagementCategoryDocument = gql`
    mutation CreateEngagementCategory($input: CreateEngagementCategoryInput!) {
  createEngagementCategory(input: $input) {
    category {
      id
      order
      title
      isArchived
    }
  }
}
    `;
export type CreateEngagementCategoryMutationFn = Apollo.MutationFunction<CreateEngagementCategoryMutation, CreateEngagementCategoryMutationVariables>;

/**
 * __useCreateEngagementCategoryMutation__
 *
 * To run a mutation, you first call `useCreateEngagementCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEngagementCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEngagementCategoryMutation, { data, loading, error }] = useCreateEngagementCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEngagementCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateEngagementCategoryMutation, CreateEngagementCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEngagementCategoryMutation, CreateEngagementCategoryMutationVariables>(CreateEngagementCategoryDocument, options);
      }
export type CreateEngagementCategoryMutationHookResult = ReturnType<typeof useCreateEngagementCategoryMutation>;
export type CreateEngagementCategoryMutationResult = Apollo.MutationResult<CreateEngagementCategoryMutation>;
export type CreateEngagementCategoryMutationOptions = Apollo.BaseMutationOptions<CreateEngagementCategoryMutation, CreateEngagementCategoryMutationVariables>;
export const CreateEngagementQuestionDocument = gql`
    mutation CreateEngagementQuestion($input: CreateEngagementQuestionInput!) {
  createEngagementQuestion(input: $input) {
    question {
      id
      category: subcategory {
        id
      }
      type {
        id
        type
      }
      title
      order
      isArchived
    }
  }
}
    `;
export type CreateEngagementQuestionMutationFn = Apollo.MutationFunction<CreateEngagementQuestionMutation, CreateEngagementQuestionMutationVariables>;

/**
 * __useCreateEngagementQuestionMutation__
 *
 * To run a mutation, you first call `useCreateEngagementQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEngagementQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEngagementQuestionMutation, { data, loading, error }] = useCreateEngagementQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEngagementQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateEngagementQuestionMutation, CreateEngagementQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEngagementQuestionMutation, CreateEngagementQuestionMutationVariables>(CreateEngagementQuestionDocument, options);
      }
export type CreateEngagementQuestionMutationHookResult = ReturnType<typeof useCreateEngagementQuestionMutation>;
export type CreateEngagementQuestionMutationResult = Apollo.MutationResult<CreateEngagementQuestionMutation>;
export type CreateEngagementQuestionMutationOptions = Apollo.BaseMutationOptions<CreateEngagementQuestionMutation, CreateEngagementQuestionMutationVariables>;
export const CreateEngagementReplyDocument = gql`
    mutation CreateEngagementReply($input: CreateEngagementReplyInput!) {
  createEngagementReply(input: $input) {
    reply {
      ...EngagementReply
    }
  }
}
    ${EngagementReplyFragmentDoc}`;
export type CreateEngagementReplyMutationFn = Apollo.MutationFunction<CreateEngagementReplyMutation, CreateEngagementReplyMutationVariables>;

/**
 * __useCreateEngagementReplyMutation__
 *
 * To run a mutation, you first call `useCreateEngagementReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEngagementReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEngagementReplyMutation, { data, loading, error }] = useCreateEngagementReplyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEngagementReplyMutation(baseOptions?: Apollo.MutationHookOptions<CreateEngagementReplyMutation, CreateEngagementReplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEngagementReplyMutation, CreateEngagementReplyMutationVariables>(CreateEngagementReplyDocument, options);
      }
export type CreateEngagementReplyMutationHookResult = ReturnType<typeof useCreateEngagementReplyMutation>;
export type CreateEngagementReplyMutationResult = Apollo.MutationResult<CreateEngagementReplyMutation>;
export type CreateEngagementReplyMutationOptions = Apollo.BaseMutationOptions<CreateEngagementReplyMutation, CreateEngagementReplyMutationVariables>;
export const CreateEngagementSubcategoryDocument = gql`
    mutation CreateEngagementSubcategory($input: CreateEngagementSubcategoryInput!) {
  createEngagementSubcategory(input: $input) {
    subcategory {
      id
      title
      order
      isArchived
    }
  }
}
    `;
export type CreateEngagementSubcategoryMutationFn = Apollo.MutationFunction<CreateEngagementSubcategoryMutation, CreateEngagementSubcategoryMutationVariables>;

/**
 * __useCreateEngagementSubcategoryMutation__
 *
 * To run a mutation, you first call `useCreateEngagementSubcategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEngagementSubcategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEngagementSubcategoryMutation, { data, loading, error }] = useCreateEngagementSubcategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEngagementSubcategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateEngagementSubcategoryMutation, CreateEngagementSubcategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEngagementSubcategoryMutation, CreateEngagementSubcategoryMutationVariables>(CreateEngagementSubcategoryDocument, options);
      }
export type CreateEngagementSubcategoryMutationHookResult = ReturnType<typeof useCreateEngagementSubcategoryMutation>;
export type CreateEngagementSubcategoryMutationResult = Apollo.MutationResult<CreateEngagementSubcategoryMutation>;
export type CreateEngagementSubcategoryMutationOptions = Apollo.BaseMutationOptions<CreateEngagementSubcategoryMutation, CreateEngagementSubcategoryMutationVariables>;
export const CreateEngagementTemplateDocument = gql`
    mutation CreateEngagementTemplate($input: CreateEngagementTemplateInput!) {
  createEngagementTemplate(input: $input) {
    template {
      id
      title
    }
  }
}
    `;
export type CreateEngagementTemplateMutationFn = Apollo.MutationFunction<CreateEngagementTemplateMutation, CreateEngagementTemplateMutationVariables>;

/**
 * __useCreateEngagementTemplateMutation__
 *
 * To run a mutation, you first call `useCreateEngagementTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEngagementTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEngagementTemplateMutation, { data, loading, error }] = useCreateEngagementTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEngagementTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateEngagementTemplateMutation, CreateEngagementTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEngagementTemplateMutation, CreateEngagementTemplateMutationVariables>(CreateEngagementTemplateDocument, options);
      }
export type CreateEngagementTemplateMutationHookResult = ReturnType<typeof useCreateEngagementTemplateMutation>;
export type CreateEngagementTemplateMutationResult = Apollo.MutationResult<CreateEngagementTemplateMutation>;
export type CreateEngagementTemplateMutationOptions = Apollo.BaseMutationOptions<CreateEngagementTemplateMutation, CreateEngagementTemplateMutationVariables>;
export const DisableEngagementTemplateDocument = gql`
    mutation DisableEngagementTemplate($input: DisableEngagementTemplateInput!) {
  disableEngagementTemplate(input: $input) {
    template {
      ...EngagementTemplate
    }
  }
}
    ${EngagementTemplateFragmentDoc}`;
export type DisableEngagementTemplateMutationFn = Apollo.MutationFunction<DisableEngagementTemplateMutation, DisableEngagementTemplateMutationVariables>;

/**
 * __useDisableEngagementTemplateMutation__
 *
 * To run a mutation, you first call `useDisableEngagementTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableEngagementTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableEngagementTemplateMutation, { data, loading, error }] = useDisableEngagementTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableEngagementTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DisableEngagementTemplateMutation, DisableEngagementTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableEngagementTemplateMutation, DisableEngagementTemplateMutationVariables>(DisableEngagementTemplateDocument, options);
      }
export type DisableEngagementTemplateMutationHookResult = ReturnType<typeof useDisableEngagementTemplateMutation>;
export type DisableEngagementTemplateMutationResult = Apollo.MutationResult<DisableEngagementTemplateMutation>;
export type DisableEngagementTemplateMutationOptions = Apollo.BaseMutationOptions<DisableEngagementTemplateMutation, DisableEngagementTemplateMutationVariables>;
export const EnableEngagementTemplateDocument = gql`
    mutation EnableEngagementTemplate($input: EnableEngagementTemplateInput!) {
  enableEngagementTemplate(input: $input) {
    template {
      ...EngagementTemplate
    }
  }
}
    ${EngagementTemplateFragmentDoc}`;
export type EnableEngagementTemplateMutationFn = Apollo.MutationFunction<EnableEngagementTemplateMutation, EnableEngagementTemplateMutationVariables>;

/**
 * __useEnableEngagementTemplateMutation__
 *
 * To run a mutation, you first call `useEnableEngagementTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableEngagementTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableEngagementTemplateMutation, { data, loading, error }] = useEnableEngagementTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableEngagementTemplateMutation(baseOptions?: Apollo.MutationHookOptions<EnableEngagementTemplateMutation, EnableEngagementTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableEngagementTemplateMutation, EnableEngagementTemplateMutationVariables>(EnableEngagementTemplateDocument, options);
      }
export type EnableEngagementTemplateMutationHookResult = ReturnType<typeof useEnableEngagementTemplateMutation>;
export type EnableEngagementTemplateMutationResult = Apollo.MutationResult<EnableEngagementTemplateMutation>;
export type EnableEngagementTemplateMutationOptions = Apollo.BaseMutationOptions<EnableEngagementTemplateMutation, EnableEngagementTemplateMutationVariables>;
export const ReorderEngagementQuestionDocument = gql`
    mutation ReorderEngagementQuestion($input: ReorderEngagementQuestionInput!) {
  reorderEngagementQuestion(input: $input) {
    question {
      id
      isArchived
      category: subcategory {
        id
      }
      order
    }
  }
}
    `;
export type ReorderEngagementQuestionMutationFn = Apollo.MutationFunction<ReorderEngagementQuestionMutation, ReorderEngagementQuestionMutationVariables>;

/**
 * __useReorderEngagementQuestionMutation__
 *
 * To run a mutation, you first call `useReorderEngagementQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderEngagementQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderEngagementQuestionMutation, { data, loading, error }] = useReorderEngagementQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderEngagementQuestionMutation(baseOptions?: Apollo.MutationHookOptions<ReorderEngagementQuestionMutation, ReorderEngagementQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderEngagementQuestionMutation, ReorderEngagementQuestionMutationVariables>(ReorderEngagementQuestionDocument, options);
      }
export type ReorderEngagementQuestionMutationHookResult = ReturnType<typeof useReorderEngagementQuestionMutation>;
export type ReorderEngagementQuestionMutationResult = Apollo.MutationResult<ReorderEngagementQuestionMutation>;
export type ReorderEngagementQuestionMutationOptions = Apollo.BaseMutationOptions<ReorderEngagementQuestionMutation, ReorderEngagementQuestionMutationVariables>;
export const ReorderEngagementSubcategoryDocument = gql`
    mutation ReorderEngagementSubcategory($input: ReorderEngagementSubcategoryInput!) {
  reorderEngagementSubcategory(input: $input) {
    subcategory {
      id
      order
      isArchived
    }
  }
}
    `;
export type ReorderEngagementSubcategoryMutationFn = Apollo.MutationFunction<ReorderEngagementSubcategoryMutation, ReorderEngagementSubcategoryMutationVariables>;

/**
 * __useReorderEngagementSubcategoryMutation__
 *
 * To run a mutation, you first call `useReorderEngagementSubcategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderEngagementSubcategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderEngagementSubcategoryMutation, { data, loading, error }] = useReorderEngagementSubcategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderEngagementSubcategoryMutation(baseOptions?: Apollo.MutationHookOptions<ReorderEngagementSubcategoryMutation, ReorderEngagementSubcategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderEngagementSubcategoryMutation, ReorderEngagementSubcategoryMutationVariables>(ReorderEngagementSubcategoryDocument, options);
      }
export type ReorderEngagementSubcategoryMutationHookResult = ReturnType<typeof useReorderEngagementSubcategoryMutation>;
export type ReorderEngagementSubcategoryMutationResult = Apollo.MutationResult<ReorderEngagementSubcategoryMutation>;
export type ReorderEngagementSubcategoryMutationOptions = Apollo.BaseMutationOptions<ReorderEngagementSubcategoryMutation, ReorderEngagementSubcategoryMutationVariables>;
export const RestoreEngagementCategoryDocument = gql`
    mutation RestoreEngagementCategory($input: RestoreEngagementCategoryInput!) {
  restoreEngagementCategory(input: $input) {
    category {
      id
      isArchived
    }
  }
}
    `;
export type RestoreEngagementCategoryMutationFn = Apollo.MutationFunction<RestoreEngagementCategoryMutation, RestoreEngagementCategoryMutationVariables>;

/**
 * __useRestoreEngagementCategoryMutation__
 *
 * To run a mutation, you first call `useRestoreEngagementCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreEngagementCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreEngagementCategoryMutation, { data, loading, error }] = useRestoreEngagementCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreEngagementCategoryMutation(baseOptions?: Apollo.MutationHookOptions<RestoreEngagementCategoryMutation, RestoreEngagementCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreEngagementCategoryMutation, RestoreEngagementCategoryMutationVariables>(RestoreEngagementCategoryDocument, options);
      }
export type RestoreEngagementCategoryMutationHookResult = ReturnType<typeof useRestoreEngagementCategoryMutation>;
export type RestoreEngagementCategoryMutationResult = Apollo.MutationResult<RestoreEngagementCategoryMutation>;
export type RestoreEngagementCategoryMutationOptions = Apollo.BaseMutationOptions<RestoreEngagementCategoryMutation, RestoreEngagementCategoryMutationVariables>;
export const RestoreEngagementQuestionDocument = gql`
    mutation RestoreEngagementQuestion($input: RestoreEngagementQuestionInput!) {
  restoreEngagementQuestion(input: $input) {
    question {
      id
      order
      isArchived
    }
  }
}
    `;
export type RestoreEngagementQuestionMutationFn = Apollo.MutationFunction<RestoreEngagementQuestionMutation, RestoreEngagementQuestionMutationVariables>;

/**
 * __useRestoreEngagementQuestionMutation__
 *
 * To run a mutation, you first call `useRestoreEngagementQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreEngagementQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreEngagementQuestionMutation, { data, loading, error }] = useRestoreEngagementQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreEngagementQuestionMutation(baseOptions?: Apollo.MutationHookOptions<RestoreEngagementQuestionMutation, RestoreEngagementQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreEngagementQuestionMutation, RestoreEngagementQuestionMutationVariables>(RestoreEngagementQuestionDocument, options);
      }
export type RestoreEngagementQuestionMutationHookResult = ReturnType<typeof useRestoreEngagementQuestionMutation>;
export type RestoreEngagementQuestionMutationResult = Apollo.MutationResult<RestoreEngagementQuestionMutation>;
export type RestoreEngagementQuestionMutationOptions = Apollo.BaseMutationOptions<RestoreEngagementQuestionMutation, RestoreEngagementQuestionMutationVariables>;
export const RestoreEngagementSubcategoryDocument = gql`
    mutation RestoreEngagementSubcategory($input: RestoreEngagementSubcategoryInput!) {
  restoreEngagementSubcategory(input: $input) {
    subcategory {
      id
      order
      isArchived
    }
  }
}
    `;
export type RestoreEngagementSubcategoryMutationFn = Apollo.MutationFunction<RestoreEngagementSubcategoryMutation, RestoreEngagementSubcategoryMutationVariables>;

/**
 * __useRestoreEngagementSubcategoryMutation__
 *
 * To run a mutation, you first call `useRestoreEngagementSubcategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreEngagementSubcategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreEngagementSubcategoryMutation, { data, loading, error }] = useRestoreEngagementSubcategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreEngagementSubcategoryMutation(baseOptions?: Apollo.MutationHookOptions<RestoreEngagementSubcategoryMutation, RestoreEngagementSubcategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreEngagementSubcategoryMutation, RestoreEngagementSubcategoryMutationVariables>(RestoreEngagementSubcategoryDocument, options);
      }
export type RestoreEngagementSubcategoryMutationHookResult = ReturnType<typeof useRestoreEngagementSubcategoryMutation>;
export type RestoreEngagementSubcategoryMutationResult = Apollo.MutationResult<RestoreEngagementSubcategoryMutation>;
export type RestoreEngagementSubcategoryMutationOptions = Apollo.BaseMutationOptions<RestoreEngagementSubcategoryMutation, RestoreEngagementSubcategoryMutationVariables>;
export const SendEngagementRequestRemindersDocument = gql`
    mutation SendEngagementRequestReminders($input: SendEngagementRequestRemindersInput!) {
  sendEngagementRequestReminders(input: $input) {
    engagementRequest {
      id
    }
  }
}
    `;
export type SendEngagementRequestRemindersMutationFn = Apollo.MutationFunction<SendEngagementRequestRemindersMutation, SendEngagementRequestRemindersMutationVariables>;

/**
 * __useSendEngagementRequestRemindersMutation__
 *
 * To run a mutation, you first call `useSendEngagementRequestRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEngagementRequestRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEngagementRequestRemindersMutation, { data, loading, error }] = useSendEngagementRequestRemindersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendEngagementRequestRemindersMutation(baseOptions?: Apollo.MutationHookOptions<SendEngagementRequestRemindersMutation, SendEngagementRequestRemindersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEngagementRequestRemindersMutation, SendEngagementRequestRemindersMutationVariables>(SendEngagementRequestRemindersDocument, options);
      }
export type SendEngagementRequestRemindersMutationHookResult = ReturnType<typeof useSendEngagementRequestRemindersMutation>;
export type SendEngagementRequestRemindersMutationResult = Apollo.MutationResult<SendEngagementRequestRemindersMutation>;
export type SendEngagementRequestRemindersMutationOptions = Apollo.BaseMutationOptions<SendEngagementRequestRemindersMutation, SendEngagementRequestRemindersMutationVariables>;
export const SendEngagementTemplateDocument = gql`
    mutation SendEngagementTemplate($input: SendEngagementTemplateInput!) {
  sendEngagementTemplate(input: $input) {
    template {
      ...EngagementTemplate
    }
  }
}
    ${EngagementTemplateFragmentDoc}`;
export type SendEngagementTemplateMutationFn = Apollo.MutationFunction<SendEngagementTemplateMutation, SendEngagementTemplateMutationVariables>;

/**
 * __useSendEngagementTemplateMutation__
 *
 * To run a mutation, you first call `useSendEngagementTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEngagementTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEngagementTemplateMutation, { data, loading, error }] = useSendEngagementTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendEngagementTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SendEngagementTemplateMutation, SendEngagementTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEngagementTemplateMutation, SendEngagementTemplateMutationVariables>(SendEngagementTemplateDocument, options);
      }
export type SendEngagementTemplateMutationHookResult = ReturnType<typeof useSendEngagementTemplateMutation>;
export type SendEngagementTemplateMutationResult = Apollo.MutationResult<SendEngagementTemplateMutation>;
export type SendEngagementTemplateMutationOptions = Apollo.BaseMutationOptions<SendEngagementTemplateMutation, SendEngagementTemplateMutationVariables>;
export const UpdateEngagementAnswerDocument = gql`
    mutation UpdateEngagementAnswer($input: UpdateEngagementAnswerInput!) {
  updateEngagementAnswer(input: $input) {
    engagementResponse {
      ...EngagementResponse
    }
  }
}
    ${EngagementResponseFragmentDoc}`;
export type UpdateEngagementAnswerMutationFn = Apollo.MutationFunction<UpdateEngagementAnswerMutation, UpdateEngagementAnswerMutationVariables>;

/**
 * __useUpdateEngagementAnswerMutation__
 *
 * To run a mutation, you first call `useUpdateEngagementAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEngagementAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEngagementAnswerMutation, { data, loading, error }] = useUpdateEngagementAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEngagementAnswerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEngagementAnswerMutation, UpdateEngagementAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEngagementAnswerMutation, UpdateEngagementAnswerMutationVariables>(UpdateEngagementAnswerDocument, options);
      }
export type UpdateEngagementAnswerMutationHookResult = ReturnType<typeof useUpdateEngagementAnswerMutation>;
export type UpdateEngagementAnswerMutationResult = Apollo.MutationResult<UpdateEngagementAnswerMutation>;
export type UpdateEngagementAnswerMutationOptions = Apollo.BaseMutationOptions<UpdateEngagementAnswerMutation, UpdateEngagementAnswerMutationVariables>;
export const UpdateEngagementCategoryDocument = gql`
    mutation UpdateEngagementCategory($input: UpdateEngagementCategoryInput!) {
  updateEngagementCategory(input: $input) {
    category {
      id
      title
      order
      isArchived
    }
  }
}
    `;
export type UpdateEngagementCategoryMutationFn = Apollo.MutationFunction<UpdateEngagementCategoryMutation, UpdateEngagementCategoryMutationVariables>;

/**
 * __useUpdateEngagementCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateEngagementCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEngagementCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEngagementCategoryMutation, { data, loading, error }] = useUpdateEngagementCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEngagementCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEngagementCategoryMutation, UpdateEngagementCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEngagementCategoryMutation, UpdateEngagementCategoryMutationVariables>(UpdateEngagementCategoryDocument, options);
      }
export type UpdateEngagementCategoryMutationHookResult = ReturnType<typeof useUpdateEngagementCategoryMutation>;
export type UpdateEngagementCategoryMutationResult = Apollo.MutationResult<UpdateEngagementCategoryMutation>;
export type UpdateEngagementCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateEngagementCategoryMutation, UpdateEngagementCategoryMutationVariables>;
export const UpdateEngagementQuestionDocument = gql`
    mutation UpdateEngagementQuestion($input: UpdateEngagementQuestionInput!) {
  updateEngagementQuestion(input: $input) {
    question {
      id
      category: subcategory {
        id
      }
      type {
        id
        type
      }
      title
      order
      isArchived
    }
  }
}
    `;
export type UpdateEngagementQuestionMutationFn = Apollo.MutationFunction<UpdateEngagementQuestionMutation, UpdateEngagementQuestionMutationVariables>;

/**
 * __useUpdateEngagementQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateEngagementQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEngagementQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEngagementQuestionMutation, { data, loading, error }] = useUpdateEngagementQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEngagementQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEngagementQuestionMutation, UpdateEngagementQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEngagementQuestionMutation, UpdateEngagementQuestionMutationVariables>(UpdateEngagementQuestionDocument, options);
      }
export type UpdateEngagementQuestionMutationHookResult = ReturnType<typeof useUpdateEngagementQuestionMutation>;
export type UpdateEngagementQuestionMutationResult = Apollo.MutationResult<UpdateEngagementQuestionMutation>;
export type UpdateEngagementQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateEngagementQuestionMutation, UpdateEngagementQuestionMutationVariables>;
export const UpdateEngagementSettingsDocument = gql`
    mutation UpdateEngagementSettings($input: UpdateEngagementSettingsInput!) {
  updateEngagementSettings(input: $input) {
    workspace {
      id
      engagementSettings {
        enpsType
      }
    }
  }
}
    `;
export type UpdateEngagementSettingsMutationFn = Apollo.MutationFunction<UpdateEngagementSettingsMutation, UpdateEngagementSettingsMutationVariables>;

/**
 * __useUpdateEngagementSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEngagementSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEngagementSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEngagementSettingsMutation, { data, loading, error }] = useUpdateEngagementSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEngagementSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEngagementSettingsMutation, UpdateEngagementSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEngagementSettingsMutation, UpdateEngagementSettingsMutationVariables>(UpdateEngagementSettingsDocument, options);
      }
export type UpdateEngagementSettingsMutationHookResult = ReturnType<typeof useUpdateEngagementSettingsMutation>;
export type UpdateEngagementSettingsMutationResult = Apollo.MutationResult<UpdateEngagementSettingsMutation>;
export type UpdateEngagementSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateEngagementSettingsMutation, UpdateEngagementSettingsMutationVariables>;
export const UpdateEngagementSubcategoryDocument = gql`
    mutation UpdateEngagementSubcategory($input: UpdateEngagementSubcategoryInput!) {
  updateEngagementSubcategory(input: $input) {
    subcategory {
      id
      order
      title
    }
  }
}
    `;
export type UpdateEngagementSubcategoryMutationFn = Apollo.MutationFunction<UpdateEngagementSubcategoryMutation, UpdateEngagementSubcategoryMutationVariables>;

/**
 * __useUpdateEngagementSubcategoryMutation__
 *
 * To run a mutation, you first call `useUpdateEngagementSubcategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEngagementSubcategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEngagementSubcategoryMutation, { data, loading, error }] = useUpdateEngagementSubcategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEngagementSubcategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEngagementSubcategoryMutation, UpdateEngagementSubcategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEngagementSubcategoryMutation, UpdateEngagementSubcategoryMutationVariables>(UpdateEngagementSubcategoryDocument, options);
      }
export type UpdateEngagementSubcategoryMutationHookResult = ReturnType<typeof useUpdateEngagementSubcategoryMutation>;
export type UpdateEngagementSubcategoryMutationResult = Apollo.MutationResult<UpdateEngagementSubcategoryMutation>;
export type UpdateEngagementSubcategoryMutationOptions = Apollo.BaseMutationOptions<UpdateEngagementSubcategoryMutation, UpdateEngagementSubcategoryMutationVariables>;
export const UpdateEngagementTemplateDocument = gql`
    mutation UpdateEngagementTemplate($input: UpdateEngagementTemplateInput!) {
  updateEngagementTemplate(input: $input) {
    template {
      ...EngagementTemplate
    }
  }
}
    ${EngagementTemplateFragmentDoc}`;
export type UpdateEngagementTemplateMutationFn = Apollo.MutationFunction<UpdateEngagementTemplateMutation, UpdateEngagementTemplateMutationVariables>;

/**
 * __useUpdateEngagementTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateEngagementTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEngagementTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEngagementTemplateMutation, { data, loading, error }] = useUpdateEngagementTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEngagementTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEngagementTemplateMutation, UpdateEngagementTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEngagementTemplateMutation, UpdateEngagementTemplateMutationVariables>(UpdateEngagementTemplateDocument, options);
      }
export type UpdateEngagementTemplateMutationHookResult = ReturnType<typeof useUpdateEngagementTemplateMutation>;
export type UpdateEngagementTemplateMutationResult = Apollo.MutationResult<UpdateEngagementTemplateMutation>;
export type UpdateEngagementTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateEngagementTemplateMutation, UpdateEngagementTemplateMutationVariables>;
export const EngagementAnswerWithRepliesDocument = gql`
    query EngagementAnswerWithReplies($id: ID!, $managerID: ID) {
  openQuestionAnswerWithReplies(id: $id, managerID: $managerID) {
    id
    text
    question {
      id
      title
    }
    owner {
      ...EngagementReplyUser
    }
    replies {
      ...EngagementReply
    }
  }
}
    ${EngagementReplyUserFragmentDoc}
${EngagementReplyFragmentDoc}`;

/**
 * __useEngagementAnswerWithRepliesQuery__
 *
 * To run a query within a React component, call `useEngagementAnswerWithRepliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementAnswerWithRepliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementAnswerWithRepliesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      managerID: // value for 'managerID'
 *   },
 * });
 */
export function useEngagementAnswerWithRepliesQuery(baseOptions: Apollo.QueryHookOptions<EngagementAnswerWithRepliesQuery, EngagementAnswerWithRepliesQueryVariables> & ({ variables: EngagementAnswerWithRepliesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EngagementAnswerWithRepliesQuery, EngagementAnswerWithRepliesQueryVariables>(EngagementAnswerWithRepliesDocument, options);
      }
export function useEngagementAnswerWithRepliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EngagementAnswerWithRepliesQuery, EngagementAnswerWithRepliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EngagementAnswerWithRepliesQuery, EngagementAnswerWithRepliesQueryVariables>(EngagementAnswerWithRepliesDocument, options);
        }
// @ts-ignore
export function useEngagementAnswerWithRepliesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EngagementAnswerWithRepliesQuery, EngagementAnswerWithRepliesQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementAnswerWithRepliesQuery, EngagementAnswerWithRepliesQueryVariables>;
export function useEngagementAnswerWithRepliesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementAnswerWithRepliesQuery, EngagementAnswerWithRepliesQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementAnswerWithRepliesQuery | undefined, EngagementAnswerWithRepliesQueryVariables>;
export function useEngagementAnswerWithRepliesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementAnswerWithRepliesQuery, EngagementAnswerWithRepliesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EngagementAnswerWithRepliesQuery, EngagementAnswerWithRepliesQueryVariables>(EngagementAnswerWithRepliesDocument, options);
        }
export type EngagementAnswerWithRepliesQueryHookResult = ReturnType<typeof useEngagementAnswerWithRepliesQuery>;
export type EngagementAnswerWithRepliesLazyQueryHookResult = ReturnType<typeof useEngagementAnswerWithRepliesLazyQuery>;
export type EngagementAnswerWithRepliesSuspenseQueryHookResult = ReturnType<typeof useEngagementAnswerWithRepliesSuspenseQuery>;
export type EngagementAnswerWithRepliesQueryResult = Apollo.QueryResult<EngagementAnswerWithRepliesQuery, EngagementAnswerWithRepliesQueryVariables>;
export const EngagementCategoryDocument = gql`
    query EngagementCategory($id: ID!, $isArchived: Boolean) {
  engagementCategory(id: $id) {
    id
    title
    isArchived
    subcategories(first: 1000, isArchived: $isArchived) {
      edges {
        node {
          id
          title
          order
          isArchived
        }
      }
    }
    questions {
      edges {
        node {
          id
          category: subcategory {
            id
            isArchived
          }
          title
          type {
            id
            title
            type
            isArchived
          }
          order
          isArchived
        }
      }
    }
  }
  engagementTypes(global: true, isArchived: false, first: 1000) {
    edges {
      node {
        id
        title
        type
        isArchived
      }
    }
  }
}
    `;

/**
 * __useEngagementCategoryQuery__
 *
 * To run a query within a React component, call `useEngagementCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useEngagementCategoryQuery(baseOptions: Apollo.QueryHookOptions<EngagementCategoryQuery, EngagementCategoryQueryVariables> & ({ variables: EngagementCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EngagementCategoryQuery, EngagementCategoryQueryVariables>(EngagementCategoryDocument, options);
      }
export function useEngagementCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EngagementCategoryQuery, EngagementCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EngagementCategoryQuery, EngagementCategoryQueryVariables>(EngagementCategoryDocument, options);
        }
// @ts-ignore
export function useEngagementCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EngagementCategoryQuery, EngagementCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementCategoryQuery, EngagementCategoryQueryVariables>;
export function useEngagementCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementCategoryQuery, EngagementCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementCategoryQuery | undefined, EngagementCategoryQueryVariables>;
export function useEngagementCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementCategoryQuery, EngagementCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EngagementCategoryQuery, EngagementCategoryQueryVariables>(EngagementCategoryDocument, options);
        }
export type EngagementCategoryQueryHookResult = ReturnType<typeof useEngagementCategoryQuery>;
export type EngagementCategoryLazyQueryHookResult = ReturnType<typeof useEngagementCategoryLazyQuery>;
export type EngagementCategorySuspenseQueryHookResult = ReturnType<typeof useEngagementCategorySuspenseQuery>;
export type EngagementCategoryQueryResult = Apollo.QueryResult<EngagementCategoryQuery, EngagementCategoryQueryVariables>;
export const EngagementNpsAnalyticsDocument = gql`
    query EngagementNpsAnalytics($filters: AnalyticsFilters!) {
  engagementAnalytics(filters: $filters) {
    engagementENPS {
      detractors
      passives
      promoters
      score
    }
    engagementGroupsENPS {
      group {
        id
        name
      }
      detractors
      passives
      promoters
      score
    }
  }
}
    `;

/**
 * __useEngagementNpsAnalyticsQuery__
 *
 * To run a query within a React component, call `useEngagementNpsAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementNpsAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementNpsAnalyticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEngagementNpsAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<EngagementNpsAnalyticsQuery, EngagementNpsAnalyticsQueryVariables> & ({ variables: EngagementNpsAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EngagementNpsAnalyticsQuery, EngagementNpsAnalyticsQueryVariables>(EngagementNpsAnalyticsDocument, options);
      }
export function useEngagementNpsAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EngagementNpsAnalyticsQuery, EngagementNpsAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EngagementNpsAnalyticsQuery, EngagementNpsAnalyticsQueryVariables>(EngagementNpsAnalyticsDocument, options);
        }
// @ts-ignore
export function useEngagementNpsAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EngagementNpsAnalyticsQuery, EngagementNpsAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementNpsAnalyticsQuery, EngagementNpsAnalyticsQueryVariables>;
export function useEngagementNpsAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementNpsAnalyticsQuery, EngagementNpsAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementNpsAnalyticsQuery | undefined, EngagementNpsAnalyticsQueryVariables>;
export function useEngagementNpsAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementNpsAnalyticsQuery, EngagementNpsAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EngagementNpsAnalyticsQuery, EngagementNpsAnalyticsQueryVariables>(EngagementNpsAnalyticsDocument, options);
        }
export type EngagementNpsAnalyticsQueryHookResult = ReturnType<typeof useEngagementNpsAnalyticsQuery>;
export type EngagementNpsAnalyticsLazyQueryHookResult = ReturnType<typeof useEngagementNpsAnalyticsLazyQuery>;
export type EngagementNpsAnalyticsSuspenseQueryHookResult = ReturnType<typeof useEngagementNpsAnalyticsSuspenseQuery>;
export type EngagementNpsAnalyticsQueryResult = Apollo.QueryResult<EngagementNpsAnalyticsQuery, EngagementNpsAnalyticsQueryVariables>;
export const EngagementOfficerMetricsDocument = gql`
    query EngagementOfficerMetrics($filters: AnalyticsFilters!) {
  engagementAnalytics(filters: $filters) {
    engagementScoreOverTime {
      ...EngagementScoreOverTime
    }
    engagementParticipationOverTime {
      ...EngagementParticipationOverTime
    }
    engagementThrivingSubcategories: engagementSubcategoriesTrend(
      thriving: true
      count: 2
    ) {
      ...EngagementSubcategoriesOverTime
    }
    engagementDecliningSubcategories: engagementSubcategoriesTrend(
      thriving: false
      count: 2
    ) {
      ...EngagementSubcategoriesOverTime
    }
    engagementGroupsSubcategoriesScore {
      ...EngagementGroupsSubcategoriesScore
    }
    engagementGroupsParticipation {
      ...EngagementGroupsParticipation
    }
    thrivingQuestions: engagementQuestionsTrend(thriving: true) {
      ...EngagementQuestionsOverTime
    }
    decliningQuestions: engagementQuestionsTrend(thriving: false) {
      ...EngagementQuestionsOverTime
    }
  }
}
    ${EngagementScoreOverTimeFragmentDoc}
${EngagementParticipationOverTimeFragmentDoc}
${EngagementSubcategoriesOverTimeFragmentDoc}
${EngagementGroupsSubcategoriesScoreFragmentDoc}
${EngagementGroupsParticipationFragmentDoc}
${EngagementQuestionsOverTimeFragmentDoc}`;

/**
 * __useEngagementOfficerMetricsQuery__
 *
 * To run a query within a React component, call `useEngagementOfficerMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementOfficerMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementOfficerMetricsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEngagementOfficerMetricsQuery(baseOptions: Apollo.QueryHookOptions<EngagementOfficerMetricsQuery, EngagementOfficerMetricsQueryVariables> & ({ variables: EngagementOfficerMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EngagementOfficerMetricsQuery, EngagementOfficerMetricsQueryVariables>(EngagementOfficerMetricsDocument, options);
      }
export function useEngagementOfficerMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EngagementOfficerMetricsQuery, EngagementOfficerMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EngagementOfficerMetricsQuery, EngagementOfficerMetricsQueryVariables>(EngagementOfficerMetricsDocument, options);
        }
// @ts-ignore
export function useEngagementOfficerMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EngagementOfficerMetricsQuery, EngagementOfficerMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementOfficerMetricsQuery, EngagementOfficerMetricsQueryVariables>;
export function useEngagementOfficerMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementOfficerMetricsQuery, EngagementOfficerMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementOfficerMetricsQuery | undefined, EngagementOfficerMetricsQueryVariables>;
export function useEngagementOfficerMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementOfficerMetricsQuery, EngagementOfficerMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EngagementOfficerMetricsQuery, EngagementOfficerMetricsQueryVariables>(EngagementOfficerMetricsDocument, options);
        }
export type EngagementOfficerMetricsQueryHookResult = ReturnType<typeof useEngagementOfficerMetricsQuery>;
export type EngagementOfficerMetricsLazyQueryHookResult = ReturnType<typeof useEngagementOfficerMetricsLazyQuery>;
export type EngagementOfficerMetricsSuspenseQueryHookResult = ReturnType<typeof useEngagementOfficerMetricsSuspenseQuery>;
export type EngagementOfficerMetricsQueryResult = Apollo.QueryResult<EngagementOfficerMetricsQuery, EngagementOfficerMetricsQueryVariables>;
export const EngagementOfficerQuestionsDocument = gql`
    query EngagementOfficerQuestions($filters: AnalyticsFilters!) {
  engagementAnalytics(filters: $filters) {
    engagementOpenQuestions {
      ...EngagementOpenQuestions
    }
    engagementQuestionsTrend(thriving: true, count: 10000) {
      ...EngagementQuestionsOverTimeWithCategory
    }
  }
}
    ${EngagementOpenQuestionsFragmentDoc}
${EngagementQuestionsOverTimeWithCategoryFragmentDoc}`;

/**
 * __useEngagementOfficerQuestionsQuery__
 *
 * To run a query within a React component, call `useEngagementOfficerQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementOfficerQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementOfficerQuestionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEngagementOfficerQuestionsQuery(baseOptions: Apollo.QueryHookOptions<EngagementOfficerQuestionsQuery, EngagementOfficerQuestionsQueryVariables> & ({ variables: EngagementOfficerQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EngagementOfficerQuestionsQuery, EngagementOfficerQuestionsQueryVariables>(EngagementOfficerQuestionsDocument, options);
      }
export function useEngagementOfficerQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EngagementOfficerQuestionsQuery, EngagementOfficerQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EngagementOfficerQuestionsQuery, EngagementOfficerQuestionsQueryVariables>(EngagementOfficerQuestionsDocument, options);
        }
// @ts-ignore
export function useEngagementOfficerQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EngagementOfficerQuestionsQuery, EngagementOfficerQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementOfficerQuestionsQuery, EngagementOfficerQuestionsQueryVariables>;
export function useEngagementOfficerQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementOfficerQuestionsQuery, EngagementOfficerQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementOfficerQuestionsQuery | undefined, EngagementOfficerQuestionsQueryVariables>;
export function useEngagementOfficerQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementOfficerQuestionsQuery, EngagementOfficerQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EngagementOfficerQuestionsQuery, EngagementOfficerQuestionsQueryVariables>(EngagementOfficerQuestionsDocument, options);
        }
export type EngagementOfficerQuestionsQueryHookResult = ReturnType<typeof useEngagementOfficerQuestionsQuery>;
export type EngagementOfficerQuestionsLazyQueryHookResult = ReturnType<typeof useEngagementOfficerQuestionsLazyQuery>;
export type EngagementOfficerQuestionsSuspenseQueryHookResult = ReturnType<typeof useEngagementOfficerQuestionsSuspenseQuery>;
export type EngagementOfficerQuestionsQueryResult = Apollo.QueryResult<EngagementOfficerQuestionsQuery, EngagementOfficerQuestionsQueryVariables>;
export const EngagementOfficerTopicsDocument = gql`
    query EngagementOfficerTopics($filters: AnalyticsFilters!) {
  engagementAnalytics(filters: $filters) {
    engagementScoreOverTime {
      ...EngagementScoreOverTime
    }
    engagementParticipationOverTime {
      ...EngagementParticipationOverTime
    }
    engagementSubcategoriesTrend(thriving: true, count: 10000) {
      ...EngagementSubcategoriesOverTimeWithCategory
    }
  }
}
    ${EngagementScoreOverTimeFragmentDoc}
${EngagementParticipationOverTimeFragmentDoc}
${EngagementSubcategoriesOverTimeWithCategoryFragmentDoc}`;

/**
 * __useEngagementOfficerTopicsQuery__
 *
 * To run a query within a React component, call `useEngagementOfficerTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementOfficerTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementOfficerTopicsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEngagementOfficerTopicsQuery(baseOptions: Apollo.QueryHookOptions<EngagementOfficerTopicsQuery, EngagementOfficerTopicsQueryVariables> & ({ variables: EngagementOfficerTopicsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EngagementOfficerTopicsQuery, EngagementOfficerTopicsQueryVariables>(EngagementOfficerTopicsDocument, options);
      }
export function useEngagementOfficerTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EngagementOfficerTopicsQuery, EngagementOfficerTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EngagementOfficerTopicsQuery, EngagementOfficerTopicsQueryVariables>(EngagementOfficerTopicsDocument, options);
        }
// @ts-ignore
export function useEngagementOfficerTopicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EngagementOfficerTopicsQuery, EngagementOfficerTopicsQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementOfficerTopicsQuery, EngagementOfficerTopicsQueryVariables>;
export function useEngagementOfficerTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementOfficerTopicsQuery, EngagementOfficerTopicsQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementOfficerTopicsQuery | undefined, EngagementOfficerTopicsQueryVariables>;
export function useEngagementOfficerTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementOfficerTopicsQuery, EngagementOfficerTopicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EngagementOfficerTopicsQuery, EngagementOfficerTopicsQueryVariables>(EngagementOfficerTopicsDocument, options);
        }
export type EngagementOfficerTopicsQueryHookResult = ReturnType<typeof useEngagementOfficerTopicsQuery>;
export type EngagementOfficerTopicsLazyQueryHookResult = ReturnType<typeof useEngagementOfficerTopicsLazyQuery>;
export type EngagementOfficerTopicsSuspenseQueryHookResult = ReturnType<typeof useEngagementOfficerTopicsSuspenseQuery>;
export type EngagementOfficerTopicsQueryResult = Apollo.QueryResult<EngagementOfficerTopicsQuery, EngagementOfficerTopicsQueryVariables>;
export const EngagementQuestionsByCategoryDocument = gql`
    query EngagementQuestionsByCategory($id: ID!, $isArchived: Boolean) {
  engagementCategory(id: $id) {
    questions(isArchived: $isArchived) {
      edges {
        node {
          id
          category: subcategory {
            id
            isArchived
          }
          title
          type {
            id
            title
            type
            isArchived
          }
          isArchived
          order
        }
      }
    }
  }
}
    `;

/**
 * __useEngagementQuestionsByCategoryQuery__
 *
 * To run a query within a React component, call `useEngagementQuestionsByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementQuestionsByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementQuestionsByCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useEngagementQuestionsByCategoryQuery(baseOptions: Apollo.QueryHookOptions<EngagementQuestionsByCategoryQuery, EngagementQuestionsByCategoryQueryVariables> & ({ variables: EngagementQuestionsByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EngagementQuestionsByCategoryQuery, EngagementQuestionsByCategoryQueryVariables>(EngagementQuestionsByCategoryDocument, options);
      }
export function useEngagementQuestionsByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EngagementQuestionsByCategoryQuery, EngagementQuestionsByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EngagementQuestionsByCategoryQuery, EngagementQuestionsByCategoryQueryVariables>(EngagementQuestionsByCategoryDocument, options);
        }
// @ts-ignore
export function useEngagementQuestionsByCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EngagementQuestionsByCategoryQuery, EngagementQuestionsByCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementQuestionsByCategoryQuery, EngagementQuestionsByCategoryQueryVariables>;
export function useEngagementQuestionsByCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementQuestionsByCategoryQuery, EngagementQuestionsByCategoryQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementQuestionsByCategoryQuery | undefined, EngagementQuestionsByCategoryQueryVariables>;
export function useEngagementQuestionsByCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementQuestionsByCategoryQuery, EngagementQuestionsByCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EngagementQuestionsByCategoryQuery, EngagementQuestionsByCategoryQueryVariables>(EngagementQuestionsByCategoryDocument, options);
        }
export type EngagementQuestionsByCategoryQueryHookResult = ReturnType<typeof useEngagementQuestionsByCategoryQuery>;
export type EngagementQuestionsByCategoryLazyQueryHookResult = ReturnType<typeof useEngagementQuestionsByCategoryLazyQuery>;
export type EngagementQuestionsByCategorySuspenseQueryHookResult = ReturnType<typeof useEngagementQuestionsByCategorySuspenseQuery>;
export type EngagementQuestionsByCategoryQueryResult = Apollo.QueryResult<EngagementQuestionsByCategoryQuery, EngagementQuestionsByCategoryQueryVariables>;
export const EngagementRequestListingDocument = gql`
    query EngagementRequestListing($templateID: ID, $first: Int, $last: Int, $before: ID, $after: ID) {
  engagementRequestListing(
    templateID: $templateID
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    edges {
      node {
        id
        template {
          id
          title
        }
        isCancelled
        createdAt
      }
    }
  }
}
    `;

/**
 * __useEngagementRequestListingQuery__
 *
 * To run a query within a React component, call `useEngagementRequestListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementRequestListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementRequestListingQuery({
 *   variables: {
 *      templateID: // value for 'templateID'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEngagementRequestListingQuery(baseOptions?: Apollo.QueryHookOptions<EngagementRequestListingQuery, EngagementRequestListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EngagementRequestListingQuery, EngagementRequestListingQueryVariables>(EngagementRequestListingDocument, options);
      }
export function useEngagementRequestListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EngagementRequestListingQuery, EngagementRequestListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EngagementRequestListingQuery, EngagementRequestListingQueryVariables>(EngagementRequestListingDocument, options);
        }
// @ts-ignore
export function useEngagementRequestListingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EngagementRequestListingQuery, EngagementRequestListingQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementRequestListingQuery, EngagementRequestListingQueryVariables>;
export function useEngagementRequestListingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementRequestListingQuery, EngagementRequestListingQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementRequestListingQuery | undefined, EngagementRequestListingQueryVariables>;
export function useEngagementRequestListingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementRequestListingQuery, EngagementRequestListingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EngagementRequestListingQuery, EngagementRequestListingQueryVariables>(EngagementRequestListingDocument, options);
        }
export type EngagementRequestListingQueryHookResult = ReturnType<typeof useEngagementRequestListingQuery>;
export type EngagementRequestListingLazyQueryHookResult = ReturnType<typeof useEngagementRequestListingLazyQuery>;
export type EngagementRequestListingSuspenseQueryHookResult = ReturnType<typeof useEngagementRequestListingSuspenseQuery>;
export type EngagementRequestListingQueryResult = Apollo.QueryResult<EngagementRequestListingQuery, EngagementRequestListingQueryVariables>;
export const EngagementResponseDocument = gql`
    query EngagementResponse($id: ID!, $secret: String) {
  engagementResponse(id: $id, secret: $secret) {
    ...EngagementResponse
  }
}
    ${EngagementResponseFragmentDoc}`;

/**
 * __useEngagementResponseQuery__
 *
 * To run a query within a React component, call `useEngagementResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementResponseQuery({
 *   variables: {
 *      id: // value for 'id'
 *      secret: // value for 'secret'
 *   },
 * });
 */
export function useEngagementResponseQuery(baseOptions: Apollo.QueryHookOptions<EngagementResponseQuery, EngagementResponseQueryVariables> & ({ variables: EngagementResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EngagementResponseQuery, EngagementResponseQueryVariables>(EngagementResponseDocument, options);
      }
export function useEngagementResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EngagementResponseQuery, EngagementResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EngagementResponseQuery, EngagementResponseQueryVariables>(EngagementResponseDocument, options);
        }
// @ts-ignore
export function useEngagementResponseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EngagementResponseQuery, EngagementResponseQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementResponseQuery, EngagementResponseQueryVariables>;
export function useEngagementResponseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementResponseQuery, EngagementResponseQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementResponseQuery | undefined, EngagementResponseQueryVariables>;
export function useEngagementResponseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementResponseQuery, EngagementResponseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EngagementResponseQuery, EngagementResponseQueryVariables>(EngagementResponseDocument, options);
        }
export type EngagementResponseQueryHookResult = ReturnType<typeof useEngagementResponseQuery>;
export type EngagementResponseLazyQueryHookResult = ReturnType<typeof useEngagementResponseLazyQuery>;
export type EngagementResponseSuspenseQueryHookResult = ReturnType<typeof useEngagementResponseSuspenseQuery>;
export type EngagementResponseQueryResult = Apollo.QueryResult<EngagementResponseQuery, EngagementResponseQueryVariables>;
export const EngagementSettingsDocument = gql`
    query EngagementSettings {
  builtinEngagementCategories: engagementCategories(global: true, first: 1000) {
    edges {
      node {
        id
        title
        isArchived
      }
    }
  }
  engagementCategories(global: false, first: 1000) {
    edges {
      node {
        id
        title
        isArchived
      }
    }
  }
  engagementTemplates(first: 1000) {
    edges {
      node {
        id
        title
        isEnabled
        interval
        nextRequestAt
      }
    }
  }
}
    `;

/**
 * __useEngagementSettingsQuery__
 *
 * To run a query within a React component, call `useEngagementSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEngagementSettingsQuery(baseOptions?: Apollo.QueryHookOptions<EngagementSettingsQuery, EngagementSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EngagementSettingsQuery, EngagementSettingsQueryVariables>(EngagementSettingsDocument, options);
      }
export function useEngagementSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EngagementSettingsQuery, EngagementSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EngagementSettingsQuery, EngagementSettingsQueryVariables>(EngagementSettingsDocument, options);
        }
// @ts-ignore
export function useEngagementSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EngagementSettingsQuery, EngagementSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementSettingsQuery, EngagementSettingsQueryVariables>;
export function useEngagementSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementSettingsQuery, EngagementSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementSettingsQuery | undefined, EngagementSettingsQueryVariables>;
export function useEngagementSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementSettingsQuery, EngagementSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EngagementSettingsQuery, EngagementSettingsQueryVariables>(EngagementSettingsDocument, options);
        }
export type EngagementSettingsQueryHookResult = ReturnType<typeof useEngagementSettingsQuery>;
export type EngagementSettingsLazyQueryHookResult = ReturnType<typeof useEngagementSettingsLazyQuery>;
export type EngagementSettingsSuspenseQueryHookResult = ReturnType<typeof useEngagementSettingsSuspenseQuery>;
export type EngagementSettingsQueryResult = Apollo.QueryResult<EngagementSettingsQuery, EngagementSettingsQueryVariables>;
export const EngagementTemplateDocument = gql`
    query EngagementTemplate($id: ID!) {
  engagementIntervalDefaults {
    interval
    maxOpenQuestions
    maxQuestions
  }
  builtinEngagementCategories: engagementCategories(
    global: true
    isArchived: false
    first: 1000
  ) {
    edges {
      node {
        ...EngagementCategory
      }
    }
  }
  engagementCategories(global: false, isArchived: false, first: 1000) {
    edges {
      node {
        ...EngagementCategory
      }
    }
  }
  engagementTemplate(id: $id) {
    ...EngagementTemplate
  }
  engagementRequests(templateID: $id, last: 10) {
    edges {
      node {
        id
        createdAt
        completed
        sent
        progress
        isCancelled
        questions {
          id
        }
      }
    }
  }
}
    ${EngagementCategoryFragmentDoc}
${EngagementTemplateFragmentDoc}`;

/**
 * __useEngagementTemplateQuery__
 *
 * To run a query within a React component, call `useEngagementTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEngagementTemplateQuery(baseOptions: Apollo.QueryHookOptions<EngagementTemplateQuery, EngagementTemplateQueryVariables> & ({ variables: EngagementTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EngagementTemplateQuery, EngagementTemplateQueryVariables>(EngagementTemplateDocument, options);
      }
export function useEngagementTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EngagementTemplateQuery, EngagementTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EngagementTemplateQuery, EngagementTemplateQueryVariables>(EngagementTemplateDocument, options);
        }
// @ts-ignore
export function useEngagementTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EngagementTemplateQuery, EngagementTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementTemplateQuery, EngagementTemplateQueryVariables>;
export function useEngagementTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementTemplateQuery, EngagementTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementTemplateQuery | undefined, EngagementTemplateQueryVariables>;
export function useEngagementTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementTemplateQuery, EngagementTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EngagementTemplateQuery, EngagementTemplateQueryVariables>(EngagementTemplateDocument, options);
        }
export type EngagementTemplateQueryHookResult = ReturnType<typeof useEngagementTemplateQuery>;
export type EngagementTemplateLazyQueryHookResult = ReturnType<typeof useEngagementTemplateLazyQuery>;
export type EngagementTemplateSuspenseQueryHookResult = ReturnType<typeof useEngagementTemplateSuspenseQuery>;
export type EngagementTemplateQueryResult = Apollo.QueryResult<EngagementTemplateQuery, EngagementTemplateQueryVariables>;
export const EngagementTemplateListingDocument = gql`
    query EngagementTemplateListing($first: Int, $last: Int, $before: ID, $after: ID) {
  engagementTemplateListing(
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    edges {
      node {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useEngagementTemplateListingQuery__
 *
 * To run a query within a React component, call `useEngagementTemplateListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementTemplateListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementTemplateListingQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEngagementTemplateListingQuery(baseOptions?: Apollo.QueryHookOptions<EngagementTemplateListingQuery, EngagementTemplateListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EngagementTemplateListingQuery, EngagementTemplateListingQueryVariables>(EngagementTemplateListingDocument, options);
      }
export function useEngagementTemplateListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EngagementTemplateListingQuery, EngagementTemplateListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EngagementTemplateListingQuery, EngagementTemplateListingQueryVariables>(EngagementTemplateListingDocument, options);
        }
// @ts-ignore
export function useEngagementTemplateListingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EngagementTemplateListingQuery, EngagementTemplateListingQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementTemplateListingQuery, EngagementTemplateListingQueryVariables>;
export function useEngagementTemplateListingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementTemplateListingQuery, EngagementTemplateListingQueryVariables>): Apollo.UseSuspenseQueryResult<EngagementTemplateListingQuery | undefined, EngagementTemplateListingQueryVariables>;
export function useEngagementTemplateListingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EngagementTemplateListingQuery, EngagementTemplateListingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EngagementTemplateListingQuery, EngagementTemplateListingQueryVariables>(EngagementTemplateListingDocument, options);
        }
export type EngagementTemplateListingQueryHookResult = ReturnType<typeof useEngagementTemplateListingQuery>;
export type EngagementTemplateListingLazyQueryHookResult = ReturnType<typeof useEngagementTemplateListingLazyQuery>;
export type EngagementTemplateListingSuspenseQueryHookResult = ReturnType<typeof useEngagementTemplateListingSuspenseQuery>;
export type EngagementTemplateListingQueryResult = Apollo.QueryResult<EngagementTemplateListingQuery, EngagementTemplateListingQueryVariables>;
export const GroupEngagementMetricsDocument = gql`
    query GroupEngagementMetrics($filters: AnalyticsFilters!) {
  groupAnalytics(filters: $filters) {
    engagementScoreOverTime {
      ...EngagementScoreOverTime
    }
    engagementParticipationOverTime {
      ...EngagementParticipationOverTime
    }
    engagementThrivingSubcategories: engagementSubcategoriesTrend(
      thriving: true
      count: 2
    ) {
      ...EngagementSubcategoriesOverTime
    }
    engagementDecliningSubcategories: engagementSubcategoriesTrend(
      thriving: false
      count: 2
    ) {
      ...EngagementSubcategoriesOverTime
    }
    engagementGroupsSubcategoriesScore {
      ...EngagementGroupsSubcategoriesScore
    }
    engagementGroupsParticipation {
      ...EngagementGroupsParticipation
    }
    thrivingQuestions: engagementQuestionsTrend(thriving: true) {
      ...EngagementQuestionsOverTime
    }
    decliningQuestions: engagementQuestionsTrend(thriving: false) {
      ...EngagementQuestionsOverTime
    }
  }
}
    ${EngagementScoreOverTimeFragmentDoc}
${EngagementParticipationOverTimeFragmentDoc}
${EngagementSubcategoriesOverTimeFragmentDoc}
${EngagementGroupsSubcategoriesScoreFragmentDoc}
${EngagementGroupsParticipationFragmentDoc}
${EngagementQuestionsOverTimeFragmentDoc}`;

/**
 * __useGroupEngagementMetricsQuery__
 *
 * To run a query within a React component, call `useGroupEngagementMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupEngagementMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupEngagementMetricsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGroupEngagementMetricsQuery(baseOptions: Apollo.QueryHookOptions<GroupEngagementMetricsQuery, GroupEngagementMetricsQueryVariables> & ({ variables: GroupEngagementMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupEngagementMetricsQuery, GroupEngagementMetricsQueryVariables>(GroupEngagementMetricsDocument, options);
      }
export function useGroupEngagementMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupEngagementMetricsQuery, GroupEngagementMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupEngagementMetricsQuery, GroupEngagementMetricsQueryVariables>(GroupEngagementMetricsDocument, options);
        }
// @ts-ignore
export function useGroupEngagementMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupEngagementMetricsQuery, GroupEngagementMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupEngagementMetricsQuery, GroupEngagementMetricsQueryVariables>;
export function useGroupEngagementMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupEngagementMetricsQuery, GroupEngagementMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupEngagementMetricsQuery | undefined, GroupEngagementMetricsQueryVariables>;
export function useGroupEngagementMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupEngagementMetricsQuery, GroupEngagementMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupEngagementMetricsQuery, GroupEngagementMetricsQueryVariables>(GroupEngagementMetricsDocument, options);
        }
export type GroupEngagementMetricsQueryHookResult = ReturnType<typeof useGroupEngagementMetricsQuery>;
export type GroupEngagementMetricsLazyQueryHookResult = ReturnType<typeof useGroupEngagementMetricsLazyQuery>;
export type GroupEngagementMetricsSuspenseQueryHookResult = ReturnType<typeof useGroupEngagementMetricsSuspenseQuery>;
export type GroupEngagementMetricsQueryResult = Apollo.QueryResult<GroupEngagementMetricsQuery, GroupEngagementMetricsQueryVariables>;
export const GroupEngagementQuestionsDocument = gql`
    query GroupEngagementQuestions($filters: AnalyticsFilters!) {
  groupAnalytics(filters: $filters) {
    engagementOpenQuestions {
      ...EngagementOpenQuestions
    }
    engagementQuestionsTrend(thriving: true, count: 10000) {
      ...EngagementQuestionsOverTimeWithCategory
    }
  }
}
    ${EngagementOpenQuestionsFragmentDoc}
${EngagementQuestionsOverTimeWithCategoryFragmentDoc}`;

/**
 * __useGroupEngagementQuestionsQuery__
 *
 * To run a query within a React component, call `useGroupEngagementQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupEngagementQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupEngagementQuestionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGroupEngagementQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GroupEngagementQuestionsQuery, GroupEngagementQuestionsQueryVariables> & ({ variables: GroupEngagementQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupEngagementQuestionsQuery, GroupEngagementQuestionsQueryVariables>(GroupEngagementQuestionsDocument, options);
      }
export function useGroupEngagementQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupEngagementQuestionsQuery, GroupEngagementQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupEngagementQuestionsQuery, GroupEngagementQuestionsQueryVariables>(GroupEngagementQuestionsDocument, options);
        }
// @ts-ignore
export function useGroupEngagementQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupEngagementQuestionsQuery, GroupEngagementQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupEngagementQuestionsQuery, GroupEngagementQuestionsQueryVariables>;
export function useGroupEngagementQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupEngagementQuestionsQuery, GroupEngagementQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupEngagementQuestionsQuery | undefined, GroupEngagementQuestionsQueryVariables>;
export function useGroupEngagementQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupEngagementQuestionsQuery, GroupEngagementQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupEngagementQuestionsQuery, GroupEngagementQuestionsQueryVariables>(GroupEngagementQuestionsDocument, options);
        }
export type GroupEngagementQuestionsQueryHookResult = ReturnType<typeof useGroupEngagementQuestionsQuery>;
export type GroupEngagementQuestionsLazyQueryHookResult = ReturnType<typeof useGroupEngagementQuestionsLazyQuery>;
export type GroupEngagementQuestionsSuspenseQueryHookResult = ReturnType<typeof useGroupEngagementQuestionsSuspenseQuery>;
export type GroupEngagementQuestionsQueryResult = Apollo.QueryResult<GroupEngagementQuestionsQuery, GroupEngagementQuestionsQueryVariables>;
export const GroupEngagementTopicsDocument = gql`
    query GroupEngagementTopics($filters: AnalyticsFilters!) {
  groupAnalytics(filters: $filters) {
    engagementScoreOverTime {
      ...EngagementScoreOverTime
    }
    engagementParticipationOverTime {
      ...EngagementParticipationOverTime
    }
    engagementSubcategoriesTrend(thriving: true, count: 10000) {
      ...EngagementSubcategoriesOverTimeWithCategory
    }
  }
}
    ${EngagementScoreOverTimeFragmentDoc}
${EngagementParticipationOverTimeFragmentDoc}
${EngagementSubcategoriesOverTimeWithCategoryFragmentDoc}`;

/**
 * __useGroupEngagementTopicsQuery__
 *
 * To run a query within a React component, call `useGroupEngagementTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupEngagementTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupEngagementTopicsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGroupEngagementTopicsQuery(baseOptions: Apollo.QueryHookOptions<GroupEngagementTopicsQuery, GroupEngagementTopicsQueryVariables> & ({ variables: GroupEngagementTopicsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupEngagementTopicsQuery, GroupEngagementTopicsQueryVariables>(GroupEngagementTopicsDocument, options);
      }
export function useGroupEngagementTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupEngagementTopicsQuery, GroupEngagementTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupEngagementTopicsQuery, GroupEngagementTopicsQueryVariables>(GroupEngagementTopicsDocument, options);
        }
// @ts-ignore
export function useGroupEngagementTopicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupEngagementTopicsQuery, GroupEngagementTopicsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupEngagementTopicsQuery, GroupEngagementTopicsQueryVariables>;
export function useGroupEngagementTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupEngagementTopicsQuery, GroupEngagementTopicsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupEngagementTopicsQuery | undefined, GroupEngagementTopicsQueryVariables>;
export function useGroupEngagementTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupEngagementTopicsQuery, GroupEngagementTopicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupEngagementTopicsQuery, GroupEngagementTopicsQueryVariables>(GroupEngagementTopicsDocument, options);
        }
export type GroupEngagementTopicsQueryHookResult = ReturnType<typeof useGroupEngagementTopicsQuery>;
export type GroupEngagementTopicsLazyQueryHookResult = ReturnType<typeof useGroupEngagementTopicsLazyQuery>;
export type GroupEngagementTopicsSuspenseQueryHookResult = ReturnType<typeof useGroupEngagementTopicsSuspenseQuery>;
export type GroupEngagementTopicsQueryResult = Apollo.QueryResult<GroupEngagementTopicsQuery, GroupEngagementTopicsQueryVariables>;
export const WorkspaceEngagementMetricsDocument = gql`
    query WorkspaceEngagementMetrics($filters: AnalyticsFilters!) {
  workspaceAnalytics(filters: $filters) {
    engagementScoreOverTime {
      ...EngagementScoreOverTime
    }
    engagementParticipationOverTime {
      ...EngagementParticipationOverTime
    }
    engagementThrivingSubcategories: engagementSubcategoriesTrend(
      thriving: true
      count: 2
    ) {
      ...EngagementSubcategoriesOverTime
    }
    engagementDecliningSubcategories: engagementSubcategoriesTrend(
      thriving: false
      count: 2
    ) {
      ...EngagementSubcategoriesOverTime
    }
    engagementGroupsSubcategoriesScore {
      ...EngagementGroupsSubcategoriesScore
    }
    engagementGroupsParticipation {
      ...EngagementGroupsParticipation
    }
    thrivingQuestions: engagementQuestionsTrend(thriving: true) {
      ...EngagementQuestionsOverTime
    }
    decliningQuestions: engagementQuestionsTrend(thriving: false) {
      ...EngagementQuestionsOverTime
    }
  }
}
    ${EngagementScoreOverTimeFragmentDoc}
${EngagementParticipationOverTimeFragmentDoc}
${EngagementSubcategoriesOverTimeFragmentDoc}
${EngagementGroupsSubcategoriesScoreFragmentDoc}
${EngagementGroupsParticipationFragmentDoc}
${EngagementQuestionsOverTimeFragmentDoc}`;

/**
 * __useWorkspaceEngagementMetricsQuery__
 *
 * To run a query within a React component, call `useWorkspaceEngagementMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceEngagementMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceEngagementMetricsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useWorkspaceEngagementMetricsQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceEngagementMetricsQuery, WorkspaceEngagementMetricsQueryVariables> & ({ variables: WorkspaceEngagementMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceEngagementMetricsQuery, WorkspaceEngagementMetricsQueryVariables>(WorkspaceEngagementMetricsDocument, options);
      }
export function useWorkspaceEngagementMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceEngagementMetricsQuery, WorkspaceEngagementMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceEngagementMetricsQuery, WorkspaceEngagementMetricsQueryVariables>(WorkspaceEngagementMetricsDocument, options);
        }
// @ts-ignore
export function useWorkspaceEngagementMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceEngagementMetricsQuery, WorkspaceEngagementMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceEngagementMetricsQuery, WorkspaceEngagementMetricsQueryVariables>;
export function useWorkspaceEngagementMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceEngagementMetricsQuery, WorkspaceEngagementMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceEngagementMetricsQuery | undefined, WorkspaceEngagementMetricsQueryVariables>;
export function useWorkspaceEngagementMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceEngagementMetricsQuery, WorkspaceEngagementMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceEngagementMetricsQuery, WorkspaceEngagementMetricsQueryVariables>(WorkspaceEngagementMetricsDocument, options);
        }
export type WorkspaceEngagementMetricsQueryHookResult = ReturnType<typeof useWorkspaceEngagementMetricsQuery>;
export type WorkspaceEngagementMetricsLazyQueryHookResult = ReturnType<typeof useWorkspaceEngagementMetricsLazyQuery>;
export type WorkspaceEngagementMetricsSuspenseQueryHookResult = ReturnType<typeof useWorkspaceEngagementMetricsSuspenseQuery>;
export type WorkspaceEngagementMetricsQueryResult = Apollo.QueryResult<WorkspaceEngagementMetricsQuery, WorkspaceEngagementMetricsQueryVariables>;
export const WorkspaceEngagementQuestionsDocument = gql`
    query WorkspaceEngagementQuestions($filters: AnalyticsFilters!) {
  workspaceAnalytics(filters: $filters) {
    engagementOpenQuestions {
      ...EngagementOpenQuestions
    }
    engagementQuestionsTrend(thriving: true, count: 10000) {
      ...EngagementQuestionsOverTimeWithCategory
    }
  }
}
    ${EngagementOpenQuestionsFragmentDoc}
${EngagementQuestionsOverTimeWithCategoryFragmentDoc}`;

/**
 * __useWorkspaceEngagementQuestionsQuery__
 *
 * To run a query within a React component, call `useWorkspaceEngagementQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceEngagementQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceEngagementQuestionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useWorkspaceEngagementQuestionsQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceEngagementQuestionsQuery, WorkspaceEngagementQuestionsQueryVariables> & ({ variables: WorkspaceEngagementQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceEngagementQuestionsQuery, WorkspaceEngagementQuestionsQueryVariables>(WorkspaceEngagementQuestionsDocument, options);
      }
export function useWorkspaceEngagementQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceEngagementQuestionsQuery, WorkspaceEngagementQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceEngagementQuestionsQuery, WorkspaceEngagementQuestionsQueryVariables>(WorkspaceEngagementQuestionsDocument, options);
        }
// @ts-ignore
export function useWorkspaceEngagementQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceEngagementQuestionsQuery, WorkspaceEngagementQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceEngagementQuestionsQuery, WorkspaceEngagementQuestionsQueryVariables>;
export function useWorkspaceEngagementQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceEngagementQuestionsQuery, WorkspaceEngagementQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceEngagementQuestionsQuery | undefined, WorkspaceEngagementQuestionsQueryVariables>;
export function useWorkspaceEngagementQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceEngagementQuestionsQuery, WorkspaceEngagementQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceEngagementQuestionsQuery, WorkspaceEngagementQuestionsQueryVariables>(WorkspaceEngagementQuestionsDocument, options);
        }
export type WorkspaceEngagementQuestionsQueryHookResult = ReturnType<typeof useWorkspaceEngagementQuestionsQuery>;
export type WorkspaceEngagementQuestionsLazyQueryHookResult = ReturnType<typeof useWorkspaceEngagementQuestionsLazyQuery>;
export type WorkspaceEngagementQuestionsSuspenseQueryHookResult = ReturnType<typeof useWorkspaceEngagementQuestionsSuspenseQuery>;
export type WorkspaceEngagementQuestionsQueryResult = Apollo.QueryResult<WorkspaceEngagementQuestionsQuery, WorkspaceEngagementQuestionsQueryVariables>;
export const WorkspaceEngagementTopicsDocument = gql`
    query WorkspaceEngagementTopics($filters: AnalyticsFilters!) {
  workspaceAnalytics(filters: $filters) {
    engagementScoreOverTime {
      ...EngagementScoreOverTime
    }
    engagementParticipationOverTime {
      ...EngagementParticipationOverTime
    }
    engagementSubcategoriesTrend(thriving: true, count: 10000) {
      ...EngagementSubcategoriesOverTimeWithCategory
    }
  }
}
    ${EngagementScoreOverTimeFragmentDoc}
${EngagementParticipationOverTimeFragmentDoc}
${EngagementSubcategoriesOverTimeWithCategoryFragmentDoc}`;

/**
 * __useWorkspaceEngagementTopicsQuery__
 *
 * To run a query within a React component, call `useWorkspaceEngagementTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceEngagementTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceEngagementTopicsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useWorkspaceEngagementTopicsQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceEngagementTopicsQuery, WorkspaceEngagementTopicsQueryVariables> & ({ variables: WorkspaceEngagementTopicsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceEngagementTopicsQuery, WorkspaceEngagementTopicsQueryVariables>(WorkspaceEngagementTopicsDocument, options);
      }
export function useWorkspaceEngagementTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceEngagementTopicsQuery, WorkspaceEngagementTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceEngagementTopicsQuery, WorkspaceEngagementTopicsQueryVariables>(WorkspaceEngagementTopicsDocument, options);
        }
// @ts-ignore
export function useWorkspaceEngagementTopicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceEngagementTopicsQuery, WorkspaceEngagementTopicsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceEngagementTopicsQuery, WorkspaceEngagementTopicsQueryVariables>;
export function useWorkspaceEngagementTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceEngagementTopicsQuery, WorkspaceEngagementTopicsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceEngagementTopicsQuery | undefined, WorkspaceEngagementTopicsQueryVariables>;
export function useWorkspaceEngagementTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceEngagementTopicsQuery, WorkspaceEngagementTopicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceEngagementTopicsQuery, WorkspaceEngagementTopicsQueryVariables>(WorkspaceEngagementTopicsDocument, options);
        }
export type WorkspaceEngagementTopicsQueryHookResult = ReturnType<typeof useWorkspaceEngagementTopicsQuery>;
export type WorkspaceEngagementTopicsLazyQueryHookResult = ReturnType<typeof useWorkspaceEngagementTopicsLazyQuery>;
export type WorkspaceEngagementTopicsSuspenseQueryHookResult = ReturnType<typeof useWorkspaceEngagementTopicsSuspenseQuery>;
export type WorkspaceEngagementTopicsQueryResult = Apollo.QueryResult<WorkspaceEngagementTopicsQuery, WorkspaceEngagementTopicsQueryVariables>;
export const CreateFeatureRatingDocument = gql`
    mutation CreateFeatureRating($input: CreateFeatureRatingInput!) {
  createFeatureRating(input: $input) {
    featureRating {
      id
    }
  }
}
    `;
export type CreateFeatureRatingMutationFn = Apollo.MutationFunction<CreateFeatureRatingMutation, CreateFeatureRatingMutationVariables>;

/**
 * __useCreateFeatureRatingMutation__
 *
 * To run a mutation, you first call `useCreateFeatureRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeatureRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeatureRatingMutation, { data, loading, error }] = useCreateFeatureRatingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeatureRatingMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeatureRatingMutation, CreateFeatureRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeatureRatingMutation, CreateFeatureRatingMutationVariables>(CreateFeatureRatingDocument, options);
      }
export type CreateFeatureRatingMutationHookResult = ReturnType<typeof useCreateFeatureRatingMutation>;
export type CreateFeatureRatingMutationResult = Apollo.MutationResult<CreateFeatureRatingMutation>;
export type CreateFeatureRatingMutationOptions = Apollo.BaseMutationOptions<CreateFeatureRatingMutation, CreateFeatureRatingMutationVariables>;
export const UpdateFeatureRatingDocument = gql`
    mutation UpdateFeatureRating($input: UpdateFeatureRatingInput!) {
  updateFeatureRating(input: $input) {
    featureRating {
      id
    }
  }
}
    `;
export type UpdateFeatureRatingMutationFn = Apollo.MutationFunction<UpdateFeatureRatingMutation, UpdateFeatureRatingMutationVariables>;

/**
 * __useUpdateFeatureRatingMutation__
 *
 * To run a mutation, you first call `useUpdateFeatureRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeatureRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeatureRatingMutation, { data, loading, error }] = useUpdateFeatureRatingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeatureRatingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeatureRatingMutation, UpdateFeatureRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeatureRatingMutation, UpdateFeatureRatingMutationVariables>(UpdateFeatureRatingDocument, options);
      }
export type UpdateFeatureRatingMutationHookResult = ReturnType<typeof useUpdateFeatureRatingMutation>;
export type UpdateFeatureRatingMutationResult = Apollo.MutationResult<UpdateFeatureRatingMutation>;
export type UpdateFeatureRatingMutationOptions = Apollo.BaseMutationOptions<UpdateFeatureRatingMutation, UpdateFeatureRatingMutationVariables>;
export const HasViewerRatedDocument = gql`
    query HasViewerRated($viewerID: ID!, $featureName: FeatureName!, $targetID: ID, $targetType: FeatureRatingTargetType, $ratedAfter: DateTime) {
  hasViewerRated(
    viewerID: $viewerID
    featureName: $featureName
    targetID: $targetID
    targetType: $targetType
    ratedAfter: $ratedAfter
  )
}
    `;

/**
 * __useHasViewerRatedQuery__
 *
 * To run a query within a React component, call `useHasViewerRatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasViewerRatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasViewerRatedQuery({
 *   variables: {
 *      viewerID: // value for 'viewerID'
 *      featureName: // value for 'featureName'
 *      targetID: // value for 'targetID'
 *      targetType: // value for 'targetType'
 *      ratedAfter: // value for 'ratedAfter'
 *   },
 * });
 */
export function useHasViewerRatedQuery(baseOptions: Apollo.QueryHookOptions<HasViewerRatedQuery, HasViewerRatedQueryVariables> & ({ variables: HasViewerRatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasViewerRatedQuery, HasViewerRatedQueryVariables>(HasViewerRatedDocument, options);
      }
export function useHasViewerRatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasViewerRatedQuery, HasViewerRatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasViewerRatedQuery, HasViewerRatedQueryVariables>(HasViewerRatedDocument, options);
        }
// @ts-ignore
export function useHasViewerRatedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HasViewerRatedQuery, HasViewerRatedQueryVariables>): Apollo.UseSuspenseQueryResult<HasViewerRatedQuery, HasViewerRatedQueryVariables>;
export function useHasViewerRatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HasViewerRatedQuery, HasViewerRatedQueryVariables>): Apollo.UseSuspenseQueryResult<HasViewerRatedQuery | undefined, HasViewerRatedQueryVariables>;
export function useHasViewerRatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HasViewerRatedQuery, HasViewerRatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HasViewerRatedQuery, HasViewerRatedQueryVariables>(HasViewerRatedDocument, options);
        }
export type HasViewerRatedQueryHookResult = ReturnType<typeof useHasViewerRatedQuery>;
export type HasViewerRatedLazyQueryHookResult = ReturnType<typeof useHasViewerRatedLazyQuery>;
export type HasViewerRatedSuspenseQueryHookResult = ReturnType<typeof useHasViewerRatedSuspenseQuery>;
export type HasViewerRatedQueryResult = Apollo.QueryResult<HasViewerRatedQuery, HasViewerRatedQueryVariables>;
export const AdvanceAiGeneratedCompetenciesChatDocument = gql`
    mutation AdvanceAIGeneratedCompetenciesChat($input: AdvanceAIChatInput!) {
  advanceAIGeneratedCompetenciesChat(input: $input) {
    ...AIGeneratedCompetenciesResponse
  }
}
    ${AiGeneratedCompetenciesResponseFragmentDoc}`;
export type AdvanceAiGeneratedCompetenciesChatMutationFn = Apollo.MutationFunction<AdvanceAiGeneratedCompetenciesChatMutation, AdvanceAiGeneratedCompetenciesChatMutationVariables>;

/**
 * __useAdvanceAiGeneratedCompetenciesChatMutation__
 *
 * To run a mutation, you first call `useAdvanceAiGeneratedCompetenciesChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdvanceAiGeneratedCompetenciesChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [advanceAiGeneratedCompetenciesChatMutation, { data, loading, error }] = useAdvanceAiGeneratedCompetenciesChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdvanceAiGeneratedCompetenciesChatMutation(baseOptions?: Apollo.MutationHookOptions<AdvanceAiGeneratedCompetenciesChatMutation, AdvanceAiGeneratedCompetenciesChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdvanceAiGeneratedCompetenciesChatMutation, AdvanceAiGeneratedCompetenciesChatMutationVariables>(AdvanceAiGeneratedCompetenciesChatDocument, options);
      }
export type AdvanceAiGeneratedCompetenciesChatMutationHookResult = ReturnType<typeof useAdvanceAiGeneratedCompetenciesChatMutation>;
export type AdvanceAiGeneratedCompetenciesChatMutationResult = Apollo.MutationResult<AdvanceAiGeneratedCompetenciesChatMutation>;
export type AdvanceAiGeneratedCompetenciesChatMutationOptions = Apollo.BaseMutationOptions<AdvanceAiGeneratedCompetenciesChatMutation, AdvanceAiGeneratedCompetenciesChatMutationVariables>;
export const ArchiveFeedbackQuestionDocument = gql`
    mutation ArchiveFeedbackQuestion($input: ArchiveFeedbackQuestionInput!) {
  archiveFeedbackQuestion(input: $input) {
    feedbackQuestion {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveFeedbackQuestionMutationFn = Apollo.MutationFunction<ArchiveFeedbackQuestionMutation, ArchiveFeedbackQuestionMutationVariables>;

/**
 * __useArchiveFeedbackQuestionMutation__
 *
 * To run a mutation, you first call `useArchiveFeedbackQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFeedbackQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveFeedbackQuestionMutation, { data, loading, error }] = useArchiveFeedbackQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveFeedbackQuestionMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveFeedbackQuestionMutation, ArchiveFeedbackQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveFeedbackQuestionMutation, ArchiveFeedbackQuestionMutationVariables>(ArchiveFeedbackQuestionDocument, options);
      }
export type ArchiveFeedbackQuestionMutationHookResult = ReturnType<typeof useArchiveFeedbackQuestionMutation>;
export type ArchiveFeedbackQuestionMutationResult = Apollo.MutationResult<ArchiveFeedbackQuestionMutation>;
export type ArchiveFeedbackQuestionMutationOptions = Apollo.BaseMutationOptions<ArchiveFeedbackQuestionMutation, ArchiveFeedbackQuestionMutationVariables>;
export const ArchiveFeedbackQuestionCategoryDocument = gql`
    mutation ArchiveFeedbackQuestionCategory($input: ArchiveFeedbackQuestionCategoryInput!) {
  archiveFeedbackQuestionCategory(input: $input) {
    feedbackQuestionCategory {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveFeedbackQuestionCategoryMutationFn = Apollo.MutationFunction<ArchiveFeedbackQuestionCategoryMutation, ArchiveFeedbackQuestionCategoryMutationVariables>;

/**
 * __useArchiveFeedbackQuestionCategoryMutation__
 *
 * To run a mutation, you first call `useArchiveFeedbackQuestionCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFeedbackQuestionCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveFeedbackQuestionCategoryMutation, { data, loading, error }] = useArchiveFeedbackQuestionCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveFeedbackQuestionCategoryMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveFeedbackQuestionCategoryMutation, ArchiveFeedbackQuestionCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveFeedbackQuestionCategoryMutation, ArchiveFeedbackQuestionCategoryMutationVariables>(ArchiveFeedbackQuestionCategoryDocument, options);
      }
export type ArchiveFeedbackQuestionCategoryMutationHookResult = ReturnType<typeof useArchiveFeedbackQuestionCategoryMutation>;
export type ArchiveFeedbackQuestionCategoryMutationResult = Apollo.MutationResult<ArchiveFeedbackQuestionCategoryMutation>;
export type ArchiveFeedbackQuestionCategoryMutationOptions = Apollo.BaseMutationOptions<ArchiveFeedbackQuestionCategoryMutation, ArchiveFeedbackQuestionCategoryMutationVariables>;
export const ArchiveFeedbackRequestDocument = gql`
    mutation ArchiveFeedbackRequest($input: ArchiveFeedbackRequestInput!) {
  archiveFeedbackRequest(input: $input) {
    feedbackRequest {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveFeedbackRequestMutationFn = Apollo.MutationFunction<ArchiveFeedbackRequestMutation, ArchiveFeedbackRequestMutationVariables>;

/**
 * __useArchiveFeedbackRequestMutation__
 *
 * To run a mutation, you first call `useArchiveFeedbackRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFeedbackRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveFeedbackRequestMutation, { data, loading, error }] = useArchiveFeedbackRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveFeedbackRequestMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveFeedbackRequestMutation, ArchiveFeedbackRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveFeedbackRequestMutation, ArchiveFeedbackRequestMutationVariables>(ArchiveFeedbackRequestDocument, options);
      }
export type ArchiveFeedbackRequestMutationHookResult = ReturnType<typeof useArchiveFeedbackRequestMutation>;
export type ArchiveFeedbackRequestMutationResult = Apollo.MutationResult<ArchiveFeedbackRequestMutation>;
export type ArchiveFeedbackRequestMutationOptions = Apollo.BaseMutationOptions<ArchiveFeedbackRequestMutation, ArchiveFeedbackRequestMutationVariables>;
export const ArchiveFeedbackResponseDocument = gql`
    mutation ArchiveFeedbackResponse($input: ArchiveFeedbackResponseInput!) {
  archiveFeedbackResponse(input: $input) {
    feedbackResponse {
      id
      isArchived
      status
    }
  }
}
    `;
export type ArchiveFeedbackResponseMutationFn = Apollo.MutationFunction<ArchiveFeedbackResponseMutation, ArchiveFeedbackResponseMutationVariables>;

/**
 * __useArchiveFeedbackResponseMutation__
 *
 * To run a mutation, you first call `useArchiveFeedbackResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFeedbackResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveFeedbackResponseMutation, { data, loading, error }] = useArchiveFeedbackResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveFeedbackResponseMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveFeedbackResponseMutation, ArchiveFeedbackResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveFeedbackResponseMutation, ArchiveFeedbackResponseMutationVariables>(ArchiveFeedbackResponseDocument, options);
      }
export type ArchiveFeedbackResponseMutationHookResult = ReturnType<typeof useArchiveFeedbackResponseMutation>;
export type ArchiveFeedbackResponseMutationResult = Apollo.MutationResult<ArchiveFeedbackResponseMutation>;
export type ArchiveFeedbackResponseMutationOptions = Apollo.BaseMutationOptions<ArchiveFeedbackResponseMutation, ArchiveFeedbackResponseMutationVariables>;
export const ArchiveFeedbackTemplateDocument = gql`
    mutation ArchiveFeedbackTemplate($input: ArchiveFeedbackTemplateInput!) {
  archiveFeedbackTemplate(input: $input) {
    feedbackTemplate {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveFeedbackTemplateMutationFn = Apollo.MutationFunction<ArchiveFeedbackTemplateMutation, ArchiveFeedbackTemplateMutationVariables>;

/**
 * __useArchiveFeedbackTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveFeedbackTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFeedbackTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveFeedbackTemplateMutation, { data, loading, error }] = useArchiveFeedbackTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveFeedbackTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveFeedbackTemplateMutation, ArchiveFeedbackTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveFeedbackTemplateMutation, ArchiveFeedbackTemplateMutationVariables>(ArchiveFeedbackTemplateDocument, options);
      }
export type ArchiveFeedbackTemplateMutationHookResult = ReturnType<typeof useArchiveFeedbackTemplateMutation>;
export type ArchiveFeedbackTemplateMutationResult = Apollo.MutationResult<ArchiveFeedbackTemplateMutation>;
export type ArchiveFeedbackTemplateMutationOptions = Apollo.BaseMutationOptions<ArchiveFeedbackTemplateMutation, ArchiveFeedbackTemplateMutationVariables>;
export const CreateComplimentDocument = gql`
    mutation CreateCompliment($input: CreateComplimentInput!) {
  createCompliment(input: $input) {
    compliment {
      id
    }
  }
}
    `;
export type CreateComplimentMutationFn = Apollo.MutationFunction<CreateComplimentMutation, CreateComplimentMutationVariables>;

/**
 * __useCreateComplimentMutation__
 *
 * To run a mutation, you first call `useCreateComplimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateComplimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createComplimentMutation, { data, loading, error }] = useCreateComplimentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateComplimentMutation(baseOptions?: Apollo.MutationHookOptions<CreateComplimentMutation, CreateComplimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateComplimentMutation, CreateComplimentMutationVariables>(CreateComplimentDocument, options);
      }
export type CreateComplimentMutationHookResult = ReturnType<typeof useCreateComplimentMutation>;
export type CreateComplimentMutationResult = Apollo.MutationResult<CreateComplimentMutation>;
export type CreateComplimentMutationOptions = Apollo.BaseMutationOptions<CreateComplimentMutation, CreateComplimentMutationVariables>;
export const CreateFeedbackQuestionDocument = gql`
    mutation CreateFeedbackQuestion($input: CreateFeedbackQuestionInput!) {
  createFeedbackQuestion(input: $input) {
    feedbackQuestion {
      id
      category {
        id
      }
      text
      subTitle
      additionalDetails
      type
      options {
        id
        text
      }
      order
      isArchived
    }
  }
}
    `;
export type CreateFeedbackQuestionMutationFn = Apollo.MutationFunction<CreateFeedbackQuestionMutation, CreateFeedbackQuestionMutationVariables>;

/**
 * __useCreateFeedbackQuestionMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackQuestionMutation, { data, loading, error }] = useCreateFeedbackQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeedbackQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedbackQuestionMutation, CreateFeedbackQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedbackQuestionMutation, CreateFeedbackQuestionMutationVariables>(CreateFeedbackQuestionDocument, options);
      }
export type CreateFeedbackQuestionMutationHookResult = ReturnType<typeof useCreateFeedbackQuestionMutation>;
export type CreateFeedbackQuestionMutationResult = Apollo.MutationResult<CreateFeedbackQuestionMutation>;
export type CreateFeedbackQuestionMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackQuestionMutation, CreateFeedbackQuestionMutationVariables>;
export const CreateFeedbackQuestionCategoryDocument = gql`
    mutation CreateFeedbackQuestionCategory($input: CreateFeedbackQuestionCategoryInput!) {
  createFeedbackQuestionCategory(input: $input) {
    feedbackQuestionCategory {
      id
      name
      order
    }
  }
}
    `;
export type CreateFeedbackQuestionCategoryMutationFn = Apollo.MutationFunction<CreateFeedbackQuestionCategoryMutation, CreateFeedbackQuestionCategoryMutationVariables>;

/**
 * __useCreateFeedbackQuestionCategoryMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackQuestionCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackQuestionCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackQuestionCategoryMutation, { data, loading, error }] = useCreateFeedbackQuestionCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeedbackQuestionCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedbackQuestionCategoryMutation, CreateFeedbackQuestionCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedbackQuestionCategoryMutation, CreateFeedbackQuestionCategoryMutationVariables>(CreateFeedbackQuestionCategoryDocument, options);
      }
export type CreateFeedbackQuestionCategoryMutationHookResult = ReturnType<typeof useCreateFeedbackQuestionCategoryMutation>;
export type CreateFeedbackQuestionCategoryMutationResult = Apollo.MutationResult<CreateFeedbackQuestionCategoryMutation>;
export type CreateFeedbackQuestionCategoryMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackQuestionCategoryMutation, CreateFeedbackQuestionCategoryMutationVariables>;
export const CreateFeedbackRequestDocument = gql`
    mutation CreateFeedbackRequest($input: CreateFeedbackRequestInput!) {
  createFeedbackRequest(input: $input) {
    feedbackRequest {
      id
    }
  }
}
    `;
export type CreateFeedbackRequestMutationFn = Apollo.MutationFunction<CreateFeedbackRequestMutation, CreateFeedbackRequestMutationVariables>;

/**
 * __useCreateFeedbackRequestMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackRequestMutation, { data, loading, error }] = useCreateFeedbackRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeedbackRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedbackRequestMutation, CreateFeedbackRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedbackRequestMutation, CreateFeedbackRequestMutationVariables>(CreateFeedbackRequestDocument, options);
      }
export type CreateFeedbackRequestMutationHookResult = ReturnType<typeof useCreateFeedbackRequestMutation>;
export type CreateFeedbackRequestMutationResult = Apollo.MutationResult<CreateFeedbackRequestMutation>;
export type CreateFeedbackRequestMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackRequestMutation, CreateFeedbackRequestMutationVariables>;
export const CreateFeedbackTemplateDocument = gql`
    mutation CreateFeedbackTemplate($input: CreateFeedbackTemplateInput!) {
  createFeedbackTemplate(input: $input) {
    feedbackTemplate {
      id
      title
      description
      instruction
      isPrivate
      roles
      jobTitleIDs
      questions {
        question {
          id
          text
          type
          options {
            id
            text
          }
        }
        instruction
        canSubjectView
      }
    }
  }
}
    `;
export type CreateFeedbackTemplateMutationFn = Apollo.MutationFunction<CreateFeedbackTemplateMutation, CreateFeedbackTemplateMutationVariables>;

/**
 * __useCreateFeedbackTemplateMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackTemplateMutation, { data, loading, error }] = useCreateFeedbackTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeedbackTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedbackTemplateMutation, CreateFeedbackTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedbackTemplateMutation, CreateFeedbackTemplateMutationVariables>(CreateFeedbackTemplateDocument, options);
      }
export type CreateFeedbackTemplateMutationHookResult = ReturnType<typeof useCreateFeedbackTemplateMutation>;
export type CreateFeedbackTemplateMutationResult = Apollo.MutationResult<CreateFeedbackTemplateMutation>;
export type CreateFeedbackTemplateMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackTemplateMutation, CreateFeedbackTemplateMutationVariables>;
export const ReorderFeedbackQuestionDocument = gql`
    mutation ReorderFeedbackQuestion($input: ReorderFeedbackQuestionInput!) {
  reorderFeedbackQuestion(input: $input) {
    feedbackQuestion {
      id
      order
    }
  }
}
    `;
export type ReorderFeedbackQuestionMutationFn = Apollo.MutationFunction<ReorderFeedbackQuestionMutation, ReorderFeedbackQuestionMutationVariables>;

/**
 * __useReorderFeedbackQuestionMutation__
 *
 * To run a mutation, you first call `useReorderFeedbackQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderFeedbackQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderFeedbackQuestionMutation, { data, loading, error }] = useReorderFeedbackQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderFeedbackQuestionMutation(baseOptions?: Apollo.MutationHookOptions<ReorderFeedbackQuestionMutation, ReorderFeedbackQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderFeedbackQuestionMutation, ReorderFeedbackQuestionMutationVariables>(ReorderFeedbackQuestionDocument, options);
      }
export type ReorderFeedbackQuestionMutationHookResult = ReturnType<typeof useReorderFeedbackQuestionMutation>;
export type ReorderFeedbackQuestionMutationResult = Apollo.MutationResult<ReorderFeedbackQuestionMutation>;
export type ReorderFeedbackQuestionMutationOptions = Apollo.BaseMutationOptions<ReorderFeedbackQuestionMutation, ReorderFeedbackQuestionMutationVariables>;
export const ReorderFeedbackQuestionCategoryDocument = gql`
    mutation ReorderFeedbackQuestionCategory($input: ReorderFeedbackQuestionCategoryInput!) {
  reorderFeedbackQuestionCategory(input: $input) {
    feedbackQuestionCategory {
      id
      order
    }
  }
}
    `;
export type ReorderFeedbackQuestionCategoryMutationFn = Apollo.MutationFunction<ReorderFeedbackQuestionCategoryMutation, ReorderFeedbackQuestionCategoryMutationVariables>;

/**
 * __useReorderFeedbackQuestionCategoryMutation__
 *
 * To run a mutation, you first call `useReorderFeedbackQuestionCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderFeedbackQuestionCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderFeedbackQuestionCategoryMutation, { data, loading, error }] = useReorderFeedbackQuestionCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderFeedbackQuestionCategoryMutation(baseOptions?: Apollo.MutationHookOptions<ReorderFeedbackQuestionCategoryMutation, ReorderFeedbackQuestionCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderFeedbackQuestionCategoryMutation, ReorderFeedbackQuestionCategoryMutationVariables>(ReorderFeedbackQuestionCategoryDocument, options);
      }
export type ReorderFeedbackQuestionCategoryMutationHookResult = ReturnType<typeof useReorderFeedbackQuestionCategoryMutation>;
export type ReorderFeedbackQuestionCategoryMutationResult = Apollo.MutationResult<ReorderFeedbackQuestionCategoryMutation>;
export type ReorderFeedbackQuestionCategoryMutationOptions = Apollo.BaseMutationOptions<ReorderFeedbackQuestionCategoryMutation, ReorderFeedbackQuestionCategoryMutationVariables>;
export const RequestAdditionalExternalFeedbackDocument = gql`
    mutation RequestAdditionalExternalFeedback($input: RequestExternalFeedbackInput!) {
  requestExternalFeedback(input: $input) {
    feedbackRequest {
      ...FeedbackRequest
    }
  }
}
    ${FeedbackRequestFragmentDoc}`;
export type RequestAdditionalExternalFeedbackMutationFn = Apollo.MutationFunction<RequestAdditionalExternalFeedbackMutation, RequestAdditionalExternalFeedbackMutationVariables>;

/**
 * __useRequestAdditionalExternalFeedbackMutation__
 *
 * To run a mutation, you first call `useRequestAdditionalExternalFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAdditionalExternalFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAdditionalExternalFeedbackMutation, { data, loading, error }] = useRequestAdditionalExternalFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestAdditionalExternalFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<RequestAdditionalExternalFeedbackMutation, RequestAdditionalExternalFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAdditionalExternalFeedbackMutation, RequestAdditionalExternalFeedbackMutationVariables>(RequestAdditionalExternalFeedbackDocument, options);
      }
export type RequestAdditionalExternalFeedbackMutationHookResult = ReturnType<typeof useRequestAdditionalExternalFeedbackMutation>;
export type RequestAdditionalExternalFeedbackMutationResult = Apollo.MutationResult<RequestAdditionalExternalFeedbackMutation>;
export type RequestAdditionalExternalFeedbackMutationOptions = Apollo.BaseMutationOptions<RequestAdditionalExternalFeedbackMutation, RequestAdditionalExternalFeedbackMutationVariables>;
export const RequestAdditionalInternalFeedbackDocument = gql`
    mutation RequestAdditionalInternalFeedback($input: RequestInternalFeedbackInput!) {
  requestInternalFeedback(input: $input) {
    feedbackRequest {
      ...FeedbackRequest
    }
  }
}
    ${FeedbackRequestFragmentDoc}`;
export type RequestAdditionalInternalFeedbackMutationFn = Apollo.MutationFunction<RequestAdditionalInternalFeedbackMutation, RequestAdditionalInternalFeedbackMutationVariables>;

/**
 * __useRequestAdditionalInternalFeedbackMutation__
 *
 * To run a mutation, you first call `useRequestAdditionalInternalFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAdditionalInternalFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAdditionalInternalFeedbackMutation, { data, loading, error }] = useRequestAdditionalInternalFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestAdditionalInternalFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<RequestAdditionalInternalFeedbackMutation, RequestAdditionalInternalFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAdditionalInternalFeedbackMutation, RequestAdditionalInternalFeedbackMutationVariables>(RequestAdditionalInternalFeedbackDocument, options);
      }
export type RequestAdditionalInternalFeedbackMutationHookResult = ReturnType<typeof useRequestAdditionalInternalFeedbackMutation>;
export type RequestAdditionalInternalFeedbackMutationResult = Apollo.MutationResult<RequestAdditionalInternalFeedbackMutation>;
export type RequestAdditionalInternalFeedbackMutationOptions = Apollo.BaseMutationOptions<RequestAdditionalInternalFeedbackMutation, RequestAdditionalInternalFeedbackMutationVariables>;
export const RequestExternalFeedbackDocument = gql`
    mutation RequestExternalFeedback($input: RequestExternalFeedbackInput!) {
  requestExternalFeedback(input: $input) {
    feedbackRequest {
      id
    }
  }
}
    `;
export type RequestExternalFeedbackMutationFn = Apollo.MutationFunction<RequestExternalFeedbackMutation, RequestExternalFeedbackMutationVariables>;

/**
 * __useRequestExternalFeedbackMutation__
 *
 * To run a mutation, you first call `useRequestExternalFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestExternalFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestExternalFeedbackMutation, { data, loading, error }] = useRequestExternalFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestExternalFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<RequestExternalFeedbackMutation, RequestExternalFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestExternalFeedbackMutation, RequestExternalFeedbackMutationVariables>(RequestExternalFeedbackDocument, options);
      }
export type RequestExternalFeedbackMutationHookResult = ReturnType<typeof useRequestExternalFeedbackMutation>;
export type RequestExternalFeedbackMutationResult = Apollo.MutationResult<RequestExternalFeedbackMutation>;
export type RequestExternalFeedbackMutationOptions = Apollo.BaseMutationOptions<RequestExternalFeedbackMutation, RequestExternalFeedbackMutationVariables>;
export const RequestInternalFeedbackDocument = gql`
    mutation RequestInternalFeedback($input: RequestInternalFeedbackInput!) {
  requestInternalFeedback(input: $input) {
    feedbackRequest {
      id
    }
  }
}
    `;
export type RequestInternalFeedbackMutationFn = Apollo.MutationFunction<RequestInternalFeedbackMutation, RequestInternalFeedbackMutationVariables>;

/**
 * __useRequestInternalFeedbackMutation__
 *
 * To run a mutation, you first call `useRequestInternalFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestInternalFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestInternalFeedbackMutation, { data, loading, error }] = useRequestInternalFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestInternalFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<RequestInternalFeedbackMutation, RequestInternalFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestInternalFeedbackMutation, RequestInternalFeedbackMutationVariables>(RequestInternalFeedbackDocument, options);
      }
export type RequestInternalFeedbackMutationHookResult = ReturnType<typeof useRequestInternalFeedbackMutation>;
export type RequestInternalFeedbackMutationResult = Apollo.MutationResult<RequestInternalFeedbackMutation>;
export type RequestInternalFeedbackMutationOptions = Apollo.BaseMutationOptions<RequestInternalFeedbackMutation, RequestInternalFeedbackMutationVariables>;
export const RestoreFeedbackQuestionDocument = gql`
    mutation RestoreFeedbackQuestion($input: RestoreFeedbackQuestionInput!) {
  restoreFeedbackQuestion(input: $input) {
    feedbackQuestion {
      id
      isArchived
    }
  }
}
    `;
export type RestoreFeedbackQuestionMutationFn = Apollo.MutationFunction<RestoreFeedbackQuestionMutation, RestoreFeedbackQuestionMutationVariables>;

/**
 * __useRestoreFeedbackQuestionMutation__
 *
 * To run a mutation, you first call `useRestoreFeedbackQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreFeedbackQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreFeedbackQuestionMutation, { data, loading, error }] = useRestoreFeedbackQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreFeedbackQuestionMutation(baseOptions?: Apollo.MutationHookOptions<RestoreFeedbackQuestionMutation, RestoreFeedbackQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreFeedbackQuestionMutation, RestoreFeedbackQuestionMutationVariables>(RestoreFeedbackQuestionDocument, options);
      }
export type RestoreFeedbackQuestionMutationHookResult = ReturnType<typeof useRestoreFeedbackQuestionMutation>;
export type RestoreFeedbackQuestionMutationResult = Apollo.MutationResult<RestoreFeedbackQuestionMutation>;
export type RestoreFeedbackQuestionMutationOptions = Apollo.BaseMutationOptions<RestoreFeedbackQuestionMutation, RestoreFeedbackQuestionMutationVariables>;
export const RestoreFeedbackQuestionCategoryDocument = gql`
    mutation RestoreFeedbackQuestionCategory($input: RestoreFeedbackQuestionCategoryInput!) {
  restoreFeedbackQuestionCategory(input: $input) {
    feedbackQuestionCategory {
      id
      isArchived
    }
  }
}
    `;
export type RestoreFeedbackQuestionCategoryMutationFn = Apollo.MutationFunction<RestoreFeedbackQuestionCategoryMutation, RestoreFeedbackQuestionCategoryMutationVariables>;

/**
 * __useRestoreFeedbackQuestionCategoryMutation__
 *
 * To run a mutation, you first call `useRestoreFeedbackQuestionCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreFeedbackQuestionCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreFeedbackQuestionCategoryMutation, { data, loading, error }] = useRestoreFeedbackQuestionCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreFeedbackQuestionCategoryMutation(baseOptions?: Apollo.MutationHookOptions<RestoreFeedbackQuestionCategoryMutation, RestoreFeedbackQuestionCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreFeedbackQuestionCategoryMutation, RestoreFeedbackQuestionCategoryMutationVariables>(RestoreFeedbackQuestionCategoryDocument, options);
      }
export type RestoreFeedbackQuestionCategoryMutationHookResult = ReturnType<typeof useRestoreFeedbackQuestionCategoryMutation>;
export type RestoreFeedbackQuestionCategoryMutationResult = Apollo.MutationResult<RestoreFeedbackQuestionCategoryMutation>;
export type RestoreFeedbackQuestionCategoryMutationOptions = Apollo.BaseMutationOptions<RestoreFeedbackQuestionCategoryMutation, RestoreFeedbackQuestionCategoryMutationVariables>;
export const RestoreFeedbackRequestDocument = gql`
    mutation RestoreFeedbackRequest($input: RestoreFeedbackRequestInput!) {
  restoreFeedbackRequest(input: $input) {
    feedbackRequest {
      id
      isArchived
    }
  }
}
    `;
export type RestoreFeedbackRequestMutationFn = Apollo.MutationFunction<RestoreFeedbackRequestMutation, RestoreFeedbackRequestMutationVariables>;

/**
 * __useRestoreFeedbackRequestMutation__
 *
 * To run a mutation, you first call `useRestoreFeedbackRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreFeedbackRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreFeedbackRequestMutation, { data, loading, error }] = useRestoreFeedbackRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreFeedbackRequestMutation(baseOptions?: Apollo.MutationHookOptions<RestoreFeedbackRequestMutation, RestoreFeedbackRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreFeedbackRequestMutation, RestoreFeedbackRequestMutationVariables>(RestoreFeedbackRequestDocument, options);
      }
export type RestoreFeedbackRequestMutationHookResult = ReturnType<typeof useRestoreFeedbackRequestMutation>;
export type RestoreFeedbackRequestMutationResult = Apollo.MutationResult<RestoreFeedbackRequestMutation>;
export type RestoreFeedbackRequestMutationOptions = Apollo.BaseMutationOptions<RestoreFeedbackRequestMutation, RestoreFeedbackRequestMutationVariables>;
export const RestoreFeedbackResponseDocument = gql`
    mutation RestoreFeedbackResponse($input: RestoreFeedbackResponseInput!) {
  restoreFeedbackResponse(input: $input) {
    feedbackResponse {
      id
      isArchived
      status
    }
  }
}
    `;
export type RestoreFeedbackResponseMutationFn = Apollo.MutationFunction<RestoreFeedbackResponseMutation, RestoreFeedbackResponseMutationVariables>;

/**
 * __useRestoreFeedbackResponseMutation__
 *
 * To run a mutation, you first call `useRestoreFeedbackResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreFeedbackResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreFeedbackResponseMutation, { data, loading, error }] = useRestoreFeedbackResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreFeedbackResponseMutation(baseOptions?: Apollo.MutationHookOptions<RestoreFeedbackResponseMutation, RestoreFeedbackResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreFeedbackResponseMutation, RestoreFeedbackResponseMutationVariables>(RestoreFeedbackResponseDocument, options);
      }
export type RestoreFeedbackResponseMutationHookResult = ReturnType<typeof useRestoreFeedbackResponseMutation>;
export type RestoreFeedbackResponseMutationResult = Apollo.MutationResult<RestoreFeedbackResponseMutation>;
export type RestoreFeedbackResponseMutationOptions = Apollo.BaseMutationOptions<RestoreFeedbackResponseMutation, RestoreFeedbackResponseMutationVariables>;
export const RestoreFeedbackTemplateDocument = gql`
    mutation RestoreFeedbackTemplate($input: RestoreFeedbackTemplateInput!) {
  restoreFeedbackTemplate(input: $input) {
    feedbackTemplate {
      id
      isArchived
    }
  }
}
    `;
export type RestoreFeedbackTemplateMutationFn = Apollo.MutationFunction<RestoreFeedbackTemplateMutation, RestoreFeedbackTemplateMutationVariables>;

/**
 * __useRestoreFeedbackTemplateMutation__
 *
 * To run a mutation, you first call `useRestoreFeedbackTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreFeedbackTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreFeedbackTemplateMutation, { data, loading, error }] = useRestoreFeedbackTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreFeedbackTemplateMutation(baseOptions?: Apollo.MutationHookOptions<RestoreFeedbackTemplateMutation, RestoreFeedbackTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreFeedbackTemplateMutation, RestoreFeedbackTemplateMutationVariables>(RestoreFeedbackTemplateDocument, options);
      }
export type RestoreFeedbackTemplateMutationHookResult = ReturnType<typeof useRestoreFeedbackTemplateMutation>;
export type RestoreFeedbackTemplateMutationResult = Apollo.MutationResult<RestoreFeedbackTemplateMutation>;
export type RestoreFeedbackTemplateMutationOptions = Apollo.BaseMutationOptions<RestoreFeedbackTemplateMutation, RestoreFeedbackTemplateMutationVariables>;
export const RevokeSharedFeedbackDocument = gql`
    mutation RevokeSharedFeedback($input: RevokeSharedFeedbackInput!) {
  revokeSharedFeedback(input: $input) {
    success
  }
}
    `;
export type RevokeSharedFeedbackMutationFn = Apollo.MutationFunction<RevokeSharedFeedbackMutation, RevokeSharedFeedbackMutationVariables>;

/**
 * __useRevokeSharedFeedbackMutation__
 *
 * To run a mutation, you first call `useRevokeSharedFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeSharedFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeSharedFeedbackMutation, { data, loading, error }] = useRevokeSharedFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeSharedFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<RevokeSharedFeedbackMutation, RevokeSharedFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeSharedFeedbackMutation, RevokeSharedFeedbackMutationVariables>(RevokeSharedFeedbackDocument, options);
      }
export type RevokeSharedFeedbackMutationHookResult = ReturnType<typeof useRevokeSharedFeedbackMutation>;
export type RevokeSharedFeedbackMutationResult = Apollo.MutationResult<RevokeSharedFeedbackMutation>;
export type RevokeSharedFeedbackMutationOptions = Apollo.BaseMutationOptions<RevokeSharedFeedbackMutation, RevokeSharedFeedbackMutationVariables>;
export const SendFeedbackDocument = gql`
    mutation SendFeedback($input: SendSpontaneousFeedbackInput!) {
  sendSpontaneousFeedback(input: $input) {
    feedbackResponse {
      ...InternalFeedback
    }
  }
}
    ${InternalFeedbackFragmentDoc}`;
export type SendFeedbackMutationFn = Apollo.MutationFunction<SendFeedbackMutation, SendFeedbackMutationVariables>;

/**
 * __useSendFeedbackMutation__
 *
 * To run a mutation, you first call `useSendFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFeedbackMutation, { data, loading, error }] = useSendFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SendFeedbackMutation, SendFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFeedbackMutation, SendFeedbackMutationVariables>(SendFeedbackDocument, options);
      }
export type SendFeedbackMutationHookResult = ReturnType<typeof useSendFeedbackMutation>;
export type SendFeedbackMutationResult = Apollo.MutationResult<SendFeedbackMutation>;
export type SendFeedbackMutationOptions = Apollo.BaseMutationOptions<SendFeedbackMutation, SendFeedbackMutationVariables>;
export const SendFeedbackReminderDocument = gql`
    mutation SendFeedbackReminder($input: SendFeedbackReminderInput!) {
  sendFeedbackReminder(input: $input) {
    feedbackResponse {
      id
    }
  }
}
    `;
export type SendFeedbackReminderMutationFn = Apollo.MutationFunction<SendFeedbackReminderMutation, SendFeedbackReminderMutationVariables>;

/**
 * __useSendFeedbackReminderMutation__
 *
 * To run a mutation, you first call `useSendFeedbackReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFeedbackReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFeedbackReminderMutation, { data, loading, error }] = useSendFeedbackReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendFeedbackReminderMutation(baseOptions?: Apollo.MutationHookOptions<SendFeedbackReminderMutation, SendFeedbackReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFeedbackReminderMutation, SendFeedbackReminderMutationVariables>(SendFeedbackReminderDocument, options);
      }
export type SendFeedbackReminderMutationHookResult = ReturnType<typeof useSendFeedbackReminderMutation>;
export type SendFeedbackReminderMutationResult = Apollo.MutationResult<SendFeedbackReminderMutation>;
export type SendFeedbackReminderMutationOptions = Apollo.BaseMutationOptions<SendFeedbackReminderMutation, SendFeedbackReminderMutationVariables>;
export const ShareFeedbackRequestDocument = gql`
    mutation ShareFeedbackRequest($input: ShareFeedbackRequestInput!) {
  shareFeedbackRequest(input: $input) {
    sharedFeedback {
      ...SharedWith
    }
  }
}
    ${SharedWithFragmentDoc}`;
export type ShareFeedbackRequestMutationFn = Apollo.MutationFunction<ShareFeedbackRequestMutation, ShareFeedbackRequestMutationVariables>;

/**
 * __useShareFeedbackRequestMutation__
 *
 * To run a mutation, you first call `useShareFeedbackRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareFeedbackRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareFeedbackRequestMutation, { data, loading, error }] = useShareFeedbackRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareFeedbackRequestMutation(baseOptions?: Apollo.MutationHookOptions<ShareFeedbackRequestMutation, ShareFeedbackRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareFeedbackRequestMutation, ShareFeedbackRequestMutationVariables>(ShareFeedbackRequestDocument, options);
      }
export type ShareFeedbackRequestMutationHookResult = ReturnType<typeof useShareFeedbackRequestMutation>;
export type ShareFeedbackRequestMutationResult = Apollo.MutationResult<ShareFeedbackRequestMutation>;
export type ShareFeedbackRequestMutationOptions = Apollo.BaseMutationOptions<ShareFeedbackRequestMutation, ShareFeedbackRequestMutationVariables>;
export const StartAiGeneratedCompetenciesChatDocument = gql`
    mutation startAIGeneratedCompetenciesChat($input: StartAIGeneratedCompetenciesChatInput!) {
  startAIGeneratedCompetenciesChat(input: $input) {
    ...AIGeneratedCompetenciesResponse
  }
}
    ${AiGeneratedCompetenciesResponseFragmentDoc}`;
export type StartAiGeneratedCompetenciesChatMutationFn = Apollo.MutationFunction<StartAiGeneratedCompetenciesChatMutation, StartAiGeneratedCompetenciesChatMutationVariables>;

/**
 * __useStartAiGeneratedCompetenciesChatMutation__
 *
 * To run a mutation, you first call `useStartAiGeneratedCompetenciesChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAiGeneratedCompetenciesChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAiGeneratedCompetenciesChatMutation, { data, loading, error }] = useStartAiGeneratedCompetenciesChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartAiGeneratedCompetenciesChatMutation(baseOptions?: Apollo.MutationHookOptions<StartAiGeneratedCompetenciesChatMutation, StartAiGeneratedCompetenciesChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAiGeneratedCompetenciesChatMutation, StartAiGeneratedCompetenciesChatMutationVariables>(StartAiGeneratedCompetenciesChatDocument, options);
      }
export type StartAiGeneratedCompetenciesChatMutationHookResult = ReturnType<typeof useStartAiGeneratedCompetenciesChatMutation>;
export type StartAiGeneratedCompetenciesChatMutationResult = Apollo.MutationResult<StartAiGeneratedCompetenciesChatMutation>;
export type StartAiGeneratedCompetenciesChatMutationOptions = Apollo.BaseMutationOptions<StartAiGeneratedCompetenciesChatMutation, StartAiGeneratedCompetenciesChatMutationVariables>;
export const UpdateExternalFeedbackDocument = gql`
    mutation UpdateExternalFeedback($input: UpdateExternalFeedbackInput!) {
  updateExternalFeedback(input: $input) {
    feedbackResponse {
      id
      answers {
        questionID
        text
        stars
        selectedOptionID
        voiceMemo {
          ...VoiceMemo
        }
      }
    }
  }
}
    ${VoiceMemoFragmentDoc}`;
export type UpdateExternalFeedbackMutationFn = Apollo.MutationFunction<UpdateExternalFeedbackMutation, UpdateExternalFeedbackMutationVariables>;

/**
 * __useUpdateExternalFeedbackMutation__
 *
 * To run a mutation, you first call `useUpdateExternalFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExternalFeedbackMutation, { data, loading, error }] = useUpdateExternalFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExternalFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExternalFeedbackMutation, UpdateExternalFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExternalFeedbackMutation, UpdateExternalFeedbackMutationVariables>(UpdateExternalFeedbackDocument, options);
      }
export type UpdateExternalFeedbackMutationHookResult = ReturnType<typeof useUpdateExternalFeedbackMutation>;
export type UpdateExternalFeedbackMutationResult = Apollo.MutationResult<UpdateExternalFeedbackMutation>;
export type UpdateExternalFeedbackMutationOptions = Apollo.BaseMutationOptions<UpdateExternalFeedbackMutation, UpdateExternalFeedbackMutationVariables>;
export const UpdateFeedbackQuestionDocument = gql`
    mutation UpdateFeedbackQuestion($input: UpdateFeedbackQuestionInput!) {
  updateFeedbackQuestion(input: $input) {
    feedbackQuestion {
      id
      category {
        id
      }
      text
      subTitle
      additionalDetails
      type
      options {
        id
        text
      }
      order
      isArchived
    }
  }
}
    `;
export type UpdateFeedbackQuestionMutationFn = Apollo.MutationFunction<UpdateFeedbackQuestionMutation, UpdateFeedbackQuestionMutationVariables>;

/**
 * __useUpdateFeedbackQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackQuestionMutation, { data, loading, error }] = useUpdateFeedbackQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeedbackQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeedbackQuestionMutation, UpdateFeedbackQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeedbackQuestionMutation, UpdateFeedbackQuestionMutationVariables>(UpdateFeedbackQuestionDocument, options);
      }
export type UpdateFeedbackQuestionMutationHookResult = ReturnType<typeof useUpdateFeedbackQuestionMutation>;
export type UpdateFeedbackQuestionMutationResult = Apollo.MutationResult<UpdateFeedbackQuestionMutation>;
export type UpdateFeedbackQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateFeedbackQuestionMutation, UpdateFeedbackQuestionMutationVariables>;
export const UpdateFeedbackQuestionCategoryDocument = gql`
    mutation UpdateFeedbackQuestionCategory($input: UpdateFeedbackQuestionCategoryInput!) {
  updateFeedbackQuestionCategory(input: $input) {
    feedbackQuestionCategory {
      id
      name
    }
  }
}
    `;
export type UpdateFeedbackQuestionCategoryMutationFn = Apollo.MutationFunction<UpdateFeedbackQuestionCategoryMutation, UpdateFeedbackQuestionCategoryMutationVariables>;

/**
 * __useUpdateFeedbackQuestionCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackQuestionCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackQuestionCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackQuestionCategoryMutation, { data, loading, error }] = useUpdateFeedbackQuestionCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeedbackQuestionCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeedbackQuestionCategoryMutation, UpdateFeedbackQuestionCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeedbackQuestionCategoryMutation, UpdateFeedbackQuestionCategoryMutationVariables>(UpdateFeedbackQuestionCategoryDocument, options);
      }
export type UpdateFeedbackQuestionCategoryMutationHookResult = ReturnType<typeof useUpdateFeedbackQuestionCategoryMutation>;
export type UpdateFeedbackQuestionCategoryMutationResult = Apollo.MutationResult<UpdateFeedbackQuestionCategoryMutation>;
export type UpdateFeedbackQuestionCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateFeedbackQuestionCategoryMutation, UpdateFeedbackQuestionCategoryMutationVariables>;
export const UpdateFeedbackTemplateDocument = gql`
    mutation UpdateFeedbackTemplate($input: UpdateFeedbackTemplateInput!) {
  updateFeedbackTemplate(input: $input) {
    feedbackTemplate {
      id
      title
      description
      instruction
      isPrivate
      roles
      jobTitleIDs
      questions {
        question {
          id
          text
          type
          options {
            id
            text
          }
        }
        instruction
        canSubjectView
      }
    }
  }
}
    `;
export type UpdateFeedbackTemplateMutationFn = Apollo.MutationFunction<UpdateFeedbackTemplateMutation, UpdateFeedbackTemplateMutationVariables>;

/**
 * __useUpdateFeedbackTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateFeedbackTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedbackTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedbackTemplateMutation, { data, loading, error }] = useUpdateFeedbackTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeedbackTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeedbackTemplateMutation, UpdateFeedbackTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeedbackTemplateMutation, UpdateFeedbackTemplateMutationVariables>(UpdateFeedbackTemplateDocument, options);
      }
export type UpdateFeedbackTemplateMutationHookResult = ReturnType<typeof useUpdateFeedbackTemplateMutation>;
export type UpdateFeedbackTemplateMutationResult = Apollo.MutationResult<UpdateFeedbackTemplateMutation>;
export type UpdateFeedbackTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateFeedbackTemplateMutation, UpdateFeedbackTemplateMutationVariables>;
export const UpdateInternalFeedbackDocument = gql`
    mutation UpdateInternalFeedback($input: UpdateInternalFeedbackInput!) {
  updateInternalFeedback(input: $input) {
    feedbackResponse {
      id
      answers {
        questionID
        text
        stars
        selectedOptionID
        voiceMemo {
          ...VoiceMemo
        }
      }
    }
  }
}
    ${VoiceMemoFragmentDoc}`;
export type UpdateInternalFeedbackMutationFn = Apollo.MutationFunction<UpdateInternalFeedbackMutation, UpdateInternalFeedbackMutationVariables>;

/**
 * __useUpdateInternalFeedbackMutation__
 *
 * To run a mutation, you first call `useUpdateInternalFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInternalFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInternalFeedbackMutation, { data, loading, error }] = useUpdateInternalFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInternalFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInternalFeedbackMutation, UpdateInternalFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInternalFeedbackMutation, UpdateInternalFeedbackMutationVariables>(UpdateInternalFeedbackDocument, options);
      }
export type UpdateInternalFeedbackMutationHookResult = ReturnType<typeof useUpdateInternalFeedbackMutation>;
export type UpdateInternalFeedbackMutationResult = Apollo.MutationResult<UpdateInternalFeedbackMutation>;
export type UpdateInternalFeedbackMutationOptions = Apollo.BaseMutationOptions<UpdateInternalFeedbackMutation, UpdateInternalFeedbackMutationVariables>;
export const ComplimentDocument = gql`
    query Compliment($id: ID!) {
  compliment(id: $id) {
    id
    text
    createdAt
    comments {
      ...Comment
    }
    viewerCanComment
    sender {
      id
      firstName
      lastName
      avatar {
        source {
          url
        }
      }
      isViewer
    }
    recipient {
      ... on User {
        id
        firstName
        lastName
        avatar {
          id
          source {
            url
          }
        }
        isViewer
      }
    }
  }
}
    ${CommentFragmentDoc}`;

/**
 * __useComplimentQuery__
 *
 * To run a query within a React component, call `useComplimentQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplimentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplimentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useComplimentQuery(baseOptions: Apollo.QueryHookOptions<ComplimentQuery, ComplimentQueryVariables> & ({ variables: ComplimentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplimentQuery, ComplimentQueryVariables>(ComplimentDocument, options);
      }
export function useComplimentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplimentQuery, ComplimentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplimentQuery, ComplimentQueryVariables>(ComplimentDocument, options);
        }
// @ts-ignore
export function useComplimentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComplimentQuery, ComplimentQueryVariables>): Apollo.UseSuspenseQueryResult<ComplimentQuery, ComplimentQueryVariables>;
export function useComplimentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplimentQuery, ComplimentQueryVariables>): Apollo.UseSuspenseQueryResult<ComplimentQuery | undefined, ComplimentQueryVariables>;
export function useComplimentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplimentQuery, ComplimentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComplimentQuery, ComplimentQueryVariables>(ComplimentDocument, options);
        }
export type ComplimentQueryHookResult = ReturnType<typeof useComplimentQuery>;
export type ComplimentLazyQueryHookResult = ReturnType<typeof useComplimentLazyQuery>;
export type ComplimentSuspenseQueryHookResult = ReturnType<typeof useComplimentSuspenseQuery>;
export type ComplimentQueryResult = Apollo.QueryResult<ComplimentQuery, ComplimentQueryVariables>;
export const ComplimentTargetsDocument = gql`
    query ComplimentTargets {
  viewer {
    id
    roles {
      id
      targetV2 {
        ... on Group {
          id
          members {
            edges {
              node {
                id
                firstName
                lastName
                avatar {
                  id
                  source {
                    url
                  }
                }
                jobPositions(status: ACTIVE) {
                  id
                  jobTitle {
                    id
                    title
                  }
                }
                isArchived
              }
            }
          }
        }
        ... on User {
          id
          firstName
          lastName
          avatar {
            id
            source {
              url
            }
          }
          isArchived
        }
      }
    }
  }
}
    `;

/**
 * __useComplimentTargetsQuery__
 *
 * To run a query within a React component, call `useComplimentTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplimentTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplimentTargetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useComplimentTargetsQuery(baseOptions?: Apollo.QueryHookOptions<ComplimentTargetsQuery, ComplimentTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplimentTargetsQuery, ComplimentTargetsQueryVariables>(ComplimentTargetsDocument, options);
      }
export function useComplimentTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplimentTargetsQuery, ComplimentTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplimentTargetsQuery, ComplimentTargetsQueryVariables>(ComplimentTargetsDocument, options);
        }
// @ts-ignore
export function useComplimentTargetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComplimentTargetsQuery, ComplimentTargetsQueryVariables>): Apollo.UseSuspenseQueryResult<ComplimentTargetsQuery, ComplimentTargetsQueryVariables>;
export function useComplimentTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplimentTargetsQuery, ComplimentTargetsQueryVariables>): Apollo.UseSuspenseQueryResult<ComplimentTargetsQuery | undefined, ComplimentTargetsQueryVariables>;
export function useComplimentTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplimentTargetsQuery, ComplimentTargetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComplimentTargetsQuery, ComplimentTargetsQueryVariables>(ComplimentTargetsDocument, options);
        }
export type ComplimentTargetsQueryHookResult = ReturnType<typeof useComplimentTargetsQuery>;
export type ComplimentTargetsLazyQueryHookResult = ReturnType<typeof useComplimentTargetsLazyQuery>;
export type ComplimentTargetsSuspenseQueryHookResult = ReturnType<typeof useComplimentTargetsSuspenseQuery>;
export type ComplimentTargetsQueryResult = Apollo.QueryResult<ComplimentTargetsQuery, ComplimentTargetsQueryVariables>;
export const ComplimentsDocument = gql`
    query Compliments($id: ID!, $last: Int = 100) {
  user(id: $id) {
    id
    compliments(isArchived: false, last: $last) {
      edges {
        node {
          id
          text
          sender {
            id
            firstName
            lastName
            avatar {
              source {
                url
              }
            }
          }
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useComplimentsQuery__
 *
 * To run a query within a React component, call `useComplimentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplimentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplimentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useComplimentsQuery(baseOptions: Apollo.QueryHookOptions<ComplimentsQuery, ComplimentsQueryVariables> & ({ variables: ComplimentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplimentsQuery, ComplimentsQueryVariables>(ComplimentsDocument, options);
      }
export function useComplimentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplimentsQuery, ComplimentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplimentsQuery, ComplimentsQueryVariables>(ComplimentsDocument, options);
        }
// @ts-ignore
export function useComplimentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ComplimentsQuery, ComplimentsQueryVariables>): Apollo.UseSuspenseQueryResult<ComplimentsQuery, ComplimentsQueryVariables>;
export function useComplimentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplimentsQuery, ComplimentsQueryVariables>): Apollo.UseSuspenseQueryResult<ComplimentsQuery | undefined, ComplimentsQueryVariables>;
export function useComplimentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplimentsQuery, ComplimentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComplimentsQuery, ComplimentsQueryVariables>(ComplimentsDocument, options);
        }
export type ComplimentsQueryHookResult = ReturnType<typeof useComplimentsQuery>;
export type ComplimentsLazyQueryHookResult = ReturnType<typeof useComplimentsLazyQuery>;
export type ComplimentsSuspenseQueryHookResult = ReturnType<typeof useComplimentsSuspenseQuery>;
export type ComplimentsQueryResult = Apollo.QueryResult<ComplimentsQuery, ComplimentsQueryVariables>;
export const ExternalFeedbackDocument = gql`
    query ExternalFeedback($id: ID!, $secret: String!) {
  externalFeedback(id: $id, secret: $secret) {
    id
    title
    questions {
      id
      type
      text
      localizedText
      subTitle
      additionalDetails
      options {
        id
        text
      }
      goal {
        title
        status
        competency {
          ...CompetencyGoal
        }
        dueDate
        progress
      }
      goalRevision {
        id
        goalID
        revision
        title
        status
        competency {
          ...CompetencyGoal
        }
        dueDate
        progress
        secret
      }
      competency {
        id
        title
        competencyLevelSet {
          levels {
            id
            title
          }
        }
        levels {
          level {
            id
            title
          }
          criteria
          enabled
        }
      }
    }
    answers(secret: $secret) {
      questionID
      text
      stars
      selectedOptionID
      competencyLevelIndex
      voiceMemo {
        ...VoiceMemo
      }
    }
    instruction
    status
  }
}
    ${CompetencyGoalFragmentDoc}
${VoiceMemoFragmentDoc}`;

/**
 * __useExternalFeedbackQuery__
 *
 * To run a query within a React component, call `useExternalFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalFeedbackQuery({
 *   variables: {
 *      id: // value for 'id'
 *      secret: // value for 'secret'
 *   },
 * });
 */
export function useExternalFeedbackQuery(baseOptions: Apollo.QueryHookOptions<ExternalFeedbackQuery, ExternalFeedbackQueryVariables> & ({ variables: ExternalFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalFeedbackQuery, ExternalFeedbackQueryVariables>(ExternalFeedbackDocument, options);
      }
export function useExternalFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalFeedbackQuery, ExternalFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalFeedbackQuery, ExternalFeedbackQueryVariables>(ExternalFeedbackDocument, options);
        }
// @ts-ignore
export function useExternalFeedbackSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExternalFeedbackQuery, ExternalFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<ExternalFeedbackQuery, ExternalFeedbackQueryVariables>;
export function useExternalFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExternalFeedbackQuery, ExternalFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<ExternalFeedbackQuery | undefined, ExternalFeedbackQueryVariables>;
export function useExternalFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExternalFeedbackQuery, ExternalFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExternalFeedbackQuery, ExternalFeedbackQueryVariables>(ExternalFeedbackDocument, options);
        }
export type ExternalFeedbackQueryHookResult = ReturnType<typeof useExternalFeedbackQuery>;
export type ExternalFeedbackLazyQueryHookResult = ReturnType<typeof useExternalFeedbackLazyQuery>;
export type ExternalFeedbackSuspenseQueryHookResult = ReturnType<typeof useExternalFeedbackSuspenseQuery>;
export type ExternalFeedbackQueryResult = Apollo.QueryResult<ExternalFeedbackQuery, ExternalFeedbackQueryVariables>;
export const FeedbackComposerCompetenciesDocument = gql`
    query FeedbackComposerCompetencies($userID: ID!) {
  user(id: $userID) {
    id
    jobPositions(status: ACTIVE) {
      ...JobPosition
    }
    goals(status: ACTIVE, hasCompetency: true) {
      ...Goal
    }
  }
}
    ${JobPositionFragmentDoc}
${GoalFragmentDoc}`;

/**
 * __useFeedbackComposerCompetenciesQuery__
 *
 * To run a query within a React component, call `useFeedbackComposerCompetenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackComposerCompetenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackComposerCompetenciesQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useFeedbackComposerCompetenciesQuery(baseOptions: Apollo.QueryHookOptions<FeedbackComposerCompetenciesQuery, FeedbackComposerCompetenciesQueryVariables> & ({ variables: FeedbackComposerCompetenciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackComposerCompetenciesQuery, FeedbackComposerCompetenciesQueryVariables>(FeedbackComposerCompetenciesDocument, options);
      }
export function useFeedbackComposerCompetenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackComposerCompetenciesQuery, FeedbackComposerCompetenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackComposerCompetenciesQuery, FeedbackComposerCompetenciesQueryVariables>(FeedbackComposerCompetenciesDocument, options);
        }
// @ts-ignore
export function useFeedbackComposerCompetenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeedbackComposerCompetenciesQuery, FeedbackComposerCompetenciesQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackComposerCompetenciesQuery, FeedbackComposerCompetenciesQueryVariables>;
export function useFeedbackComposerCompetenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackComposerCompetenciesQuery, FeedbackComposerCompetenciesQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackComposerCompetenciesQuery | undefined, FeedbackComposerCompetenciesQueryVariables>;
export function useFeedbackComposerCompetenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackComposerCompetenciesQuery, FeedbackComposerCompetenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedbackComposerCompetenciesQuery, FeedbackComposerCompetenciesQueryVariables>(FeedbackComposerCompetenciesDocument, options);
        }
export type FeedbackComposerCompetenciesQueryHookResult = ReturnType<typeof useFeedbackComposerCompetenciesQuery>;
export type FeedbackComposerCompetenciesLazyQueryHookResult = ReturnType<typeof useFeedbackComposerCompetenciesLazyQuery>;
export type FeedbackComposerCompetenciesSuspenseQueryHookResult = ReturnType<typeof useFeedbackComposerCompetenciesSuspenseQuery>;
export type FeedbackComposerCompetenciesQueryResult = Apollo.QueryResult<FeedbackComposerCompetenciesQuery, FeedbackComposerCompetenciesQueryVariables>;
export const FeedbackLibraryDocument = gql`
    query FeedbackLibrary($isArchived: Boolean!) {
  feedbackQuestionCategories(first: 1000, isArchived: $isArchived) {
    edges {
      node {
        id
        name
        order
        isArchived
      }
    }
  }
  feedbackQuestions(first: 1000, isArchived: $isArchived) {
    edges {
      node {
        id
        category {
          id
        }
        text
        subTitle
        additionalDetails
        type
        options {
          id
          text
        }
        order
        isArchived
      }
    }
  }
}
    `;

/**
 * __useFeedbackLibraryQuery__
 *
 * To run a query within a React component, call `useFeedbackLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackLibraryQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useFeedbackLibraryQuery(baseOptions: Apollo.QueryHookOptions<FeedbackLibraryQuery, FeedbackLibraryQueryVariables> & ({ variables: FeedbackLibraryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackLibraryQuery, FeedbackLibraryQueryVariables>(FeedbackLibraryDocument, options);
      }
export function useFeedbackLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackLibraryQuery, FeedbackLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackLibraryQuery, FeedbackLibraryQueryVariables>(FeedbackLibraryDocument, options);
        }
// @ts-ignore
export function useFeedbackLibrarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeedbackLibraryQuery, FeedbackLibraryQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackLibraryQuery, FeedbackLibraryQueryVariables>;
export function useFeedbackLibrarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackLibraryQuery, FeedbackLibraryQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackLibraryQuery | undefined, FeedbackLibraryQueryVariables>;
export function useFeedbackLibrarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackLibraryQuery, FeedbackLibraryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedbackLibraryQuery, FeedbackLibraryQueryVariables>(FeedbackLibraryDocument, options);
        }
export type FeedbackLibraryQueryHookResult = ReturnType<typeof useFeedbackLibraryQuery>;
export type FeedbackLibraryLazyQueryHookResult = ReturnType<typeof useFeedbackLibraryLazyQuery>;
export type FeedbackLibrarySuspenseQueryHookResult = ReturnType<typeof useFeedbackLibrarySuspenseQuery>;
export type FeedbackLibraryQueryResult = Apollo.QueryResult<FeedbackLibraryQuery, FeedbackLibraryQueryVariables>;
export const FeedbackQuestionCategoriesDocument = gql`
    query FeedbackQuestionCategories($isArchived: Boolean!) {
  feedbackQuestionCategories(isArchived: $isArchived, first: 1000) {
    edges {
      node {
        id
        name
        isArchived
      }
    }
  }
}
    `;

/**
 * __useFeedbackQuestionCategoriesQuery__
 *
 * To run a query within a React component, call `useFeedbackQuestionCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackQuestionCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackQuestionCategoriesQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useFeedbackQuestionCategoriesQuery(baseOptions: Apollo.QueryHookOptions<FeedbackQuestionCategoriesQuery, FeedbackQuestionCategoriesQueryVariables> & ({ variables: FeedbackQuestionCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackQuestionCategoriesQuery, FeedbackQuestionCategoriesQueryVariables>(FeedbackQuestionCategoriesDocument, options);
      }
export function useFeedbackQuestionCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackQuestionCategoriesQuery, FeedbackQuestionCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackQuestionCategoriesQuery, FeedbackQuestionCategoriesQueryVariables>(FeedbackQuestionCategoriesDocument, options);
        }
// @ts-ignore
export function useFeedbackQuestionCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeedbackQuestionCategoriesQuery, FeedbackQuestionCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackQuestionCategoriesQuery, FeedbackQuestionCategoriesQueryVariables>;
export function useFeedbackQuestionCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackQuestionCategoriesQuery, FeedbackQuestionCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackQuestionCategoriesQuery | undefined, FeedbackQuestionCategoriesQueryVariables>;
export function useFeedbackQuestionCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackQuestionCategoriesQuery, FeedbackQuestionCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedbackQuestionCategoriesQuery, FeedbackQuestionCategoriesQueryVariables>(FeedbackQuestionCategoriesDocument, options);
        }
export type FeedbackQuestionCategoriesQueryHookResult = ReturnType<typeof useFeedbackQuestionCategoriesQuery>;
export type FeedbackQuestionCategoriesLazyQueryHookResult = ReturnType<typeof useFeedbackQuestionCategoriesLazyQuery>;
export type FeedbackQuestionCategoriesSuspenseQueryHookResult = ReturnType<typeof useFeedbackQuestionCategoriesSuspenseQuery>;
export type FeedbackQuestionCategoriesQueryResult = Apollo.QueryResult<FeedbackQuestionCategoriesQuery, FeedbackQuestionCategoriesQueryVariables>;
export const FeedbackQuestionsDocument = gql`
    query FeedbackQuestions($isArchived: Boolean!) {
  feedbackQuestions(isArchived: $isArchived, first: 1000) {
    edges {
      node {
        id
        text
        subTitle
        additionalDetails
        type
        options {
          id
          text
        }
        category {
          id
        }
        isArchived
      }
    }
  }
}
    `;

/**
 * __useFeedbackQuestionsQuery__
 *
 * To run a query within a React component, call `useFeedbackQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackQuestionsQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useFeedbackQuestionsQuery(baseOptions: Apollo.QueryHookOptions<FeedbackQuestionsQuery, FeedbackQuestionsQueryVariables> & ({ variables: FeedbackQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackQuestionsQuery, FeedbackQuestionsQueryVariables>(FeedbackQuestionsDocument, options);
      }
export function useFeedbackQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackQuestionsQuery, FeedbackQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackQuestionsQuery, FeedbackQuestionsQueryVariables>(FeedbackQuestionsDocument, options);
        }
// @ts-ignore
export function useFeedbackQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeedbackQuestionsQuery, FeedbackQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackQuestionsQuery, FeedbackQuestionsQueryVariables>;
export function useFeedbackQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackQuestionsQuery, FeedbackQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackQuestionsQuery | undefined, FeedbackQuestionsQueryVariables>;
export function useFeedbackQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackQuestionsQuery, FeedbackQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedbackQuestionsQuery, FeedbackQuestionsQueryVariables>(FeedbackQuestionsDocument, options);
        }
export type FeedbackQuestionsQueryHookResult = ReturnType<typeof useFeedbackQuestionsQuery>;
export type FeedbackQuestionsLazyQueryHookResult = ReturnType<typeof useFeedbackQuestionsLazyQuery>;
export type FeedbackQuestionsSuspenseQueryHookResult = ReturnType<typeof useFeedbackQuestionsSuspenseQuery>;
export type FeedbackQuestionsQueryResult = Apollo.QueryResult<FeedbackQuestionsQuery, FeedbackQuestionsQueryVariables>;
export const FeedbackRequestsDocument = gql`
    query FeedbackRequests($userID: ID!, $isArchived: Boolean!, $before: ID, $last: Int!) {
  user(id: $userID) {
    id
    firstName
    viewerCanRequestFeedback
    feedbackRequests(isArchived: $isArchived, before: $before, last: $last) {
      edges {
        node {
          id
          title
          createdAt
          dueDate
          isArchived
          mode
          instruction
          responses(isArchived: false, first: 1000) {
            edges {
              node {
                id
                status
                recipient {
                  ... on User {
                    id
                    firstName
                    lastName
                    avatar {
                      id
                      source {
                        url
                      }
                    }
                  }
                  ... on FeedbackExternal {
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useFeedbackRequestsQuery__
 *
 * To run a query within a React component, call `useFeedbackRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackRequestsQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useFeedbackRequestsQuery(baseOptions: Apollo.QueryHookOptions<FeedbackRequestsQuery, FeedbackRequestsQueryVariables> & ({ variables: FeedbackRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackRequestsQuery, FeedbackRequestsQueryVariables>(FeedbackRequestsDocument, options);
      }
export function useFeedbackRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackRequestsQuery, FeedbackRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackRequestsQuery, FeedbackRequestsQueryVariables>(FeedbackRequestsDocument, options);
        }
// @ts-ignore
export function useFeedbackRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeedbackRequestsQuery, FeedbackRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackRequestsQuery, FeedbackRequestsQueryVariables>;
export function useFeedbackRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackRequestsQuery, FeedbackRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackRequestsQuery | undefined, FeedbackRequestsQueryVariables>;
export function useFeedbackRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackRequestsQuery, FeedbackRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedbackRequestsQuery, FeedbackRequestsQueryVariables>(FeedbackRequestsDocument, options);
        }
export type FeedbackRequestsQueryHookResult = ReturnType<typeof useFeedbackRequestsQuery>;
export type FeedbackRequestsLazyQueryHookResult = ReturnType<typeof useFeedbackRequestsLazyQuery>;
export type FeedbackRequestsSuspenseQueryHookResult = ReturnType<typeof useFeedbackRequestsSuspenseQuery>;
export type FeedbackRequestsQueryResult = Apollo.QueryResult<FeedbackRequestsQuery, FeedbackRequestsQueryVariables>;
export const FeedbackResultsDocument = gql`
    query FeedbackResults($id: ID!) {
  feedbackRequest(id: $id) {
    ...FeedbackRequest
  }
}
    ${FeedbackRequestFragmentDoc}`;

/**
 * __useFeedbackResultsQuery__
 *
 * To run a query within a React component, call `useFeedbackResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackResultsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeedbackResultsQuery(baseOptions: Apollo.QueryHookOptions<FeedbackResultsQuery, FeedbackResultsQueryVariables> & ({ variables: FeedbackResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackResultsQuery, FeedbackResultsQueryVariables>(FeedbackResultsDocument, options);
      }
export function useFeedbackResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackResultsQuery, FeedbackResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackResultsQuery, FeedbackResultsQueryVariables>(FeedbackResultsDocument, options);
        }
// @ts-ignore
export function useFeedbackResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeedbackResultsQuery, FeedbackResultsQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackResultsQuery, FeedbackResultsQueryVariables>;
export function useFeedbackResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackResultsQuery, FeedbackResultsQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackResultsQuery | undefined, FeedbackResultsQueryVariables>;
export function useFeedbackResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackResultsQuery, FeedbackResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedbackResultsQuery, FeedbackResultsQueryVariables>(FeedbackResultsDocument, options);
        }
export type FeedbackResultsQueryHookResult = ReturnType<typeof useFeedbackResultsQuery>;
export type FeedbackResultsLazyQueryHookResult = ReturnType<typeof useFeedbackResultsLazyQuery>;
export type FeedbackResultsSuspenseQueryHookResult = ReturnType<typeof useFeedbackResultsSuspenseQuery>;
export type FeedbackResultsQueryResult = Apollo.QueryResult<FeedbackResultsQuery, FeedbackResultsQueryVariables>;
export const FeedbackTemplateDocument = gql`
    query FeedbackTemplate($id: ID!) {
  feedbackTemplate(id: $id) {
    id
    title
    description
    instruction
    roles
    isArchived
    isPrivate
    jobTitleIDs
    questions {
      question {
        id
        type
        text
        subTitle
        additionalDetails
        options {
          id
          text
        }
      }
      instruction
      canSubjectView
    }
  }
}
    `;

/**
 * __useFeedbackTemplateQuery__
 *
 * To run a query within a React component, call `useFeedbackTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeedbackTemplateQuery(baseOptions: Apollo.QueryHookOptions<FeedbackTemplateQuery, FeedbackTemplateQueryVariables> & ({ variables: FeedbackTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackTemplateQuery, FeedbackTemplateQueryVariables>(FeedbackTemplateDocument, options);
      }
export function useFeedbackTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackTemplateQuery, FeedbackTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackTemplateQuery, FeedbackTemplateQueryVariables>(FeedbackTemplateDocument, options);
        }
// @ts-ignore
export function useFeedbackTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeedbackTemplateQuery, FeedbackTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackTemplateQuery, FeedbackTemplateQueryVariables>;
export function useFeedbackTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackTemplateQuery, FeedbackTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackTemplateQuery | undefined, FeedbackTemplateQueryVariables>;
export function useFeedbackTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackTemplateQuery, FeedbackTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedbackTemplateQuery, FeedbackTemplateQueryVariables>(FeedbackTemplateDocument, options);
        }
export type FeedbackTemplateQueryHookResult = ReturnType<typeof useFeedbackTemplateQuery>;
export type FeedbackTemplateLazyQueryHookResult = ReturnType<typeof useFeedbackTemplateLazyQuery>;
export type FeedbackTemplateSuspenseQueryHookResult = ReturnType<typeof useFeedbackTemplateSuspenseQuery>;
export type FeedbackTemplateQueryResult = Apollo.QueryResult<FeedbackTemplateQuery, FeedbackTemplateQueryVariables>;
export const FeedbackTemplateSelectorDocument = gql`
    query FeedbackTemplateSelector($filters: FeedbackTemplateFilters! = {role: REQUEST}) {
  feedbackTemplates(isArchived: false, first: 1000, filters: $filters) {
    edges {
      node {
        id
        title
        description
        instruction
        isPrivate
        jobTitleIDs
        questions {
          question {
            id
            type
            text
            subTitle
            additionalDetails
            options {
              id
              text
            }
            category {
              id
            }
          }
          instruction
          canSubjectView
        }
        isArchived
      }
    }
  }
}
    `;

/**
 * __useFeedbackTemplateSelectorQuery__
 *
 * To run a query within a React component, call `useFeedbackTemplateSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackTemplateSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackTemplateSelectorQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFeedbackTemplateSelectorQuery(baseOptions?: Apollo.QueryHookOptions<FeedbackTemplateSelectorQuery, FeedbackTemplateSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackTemplateSelectorQuery, FeedbackTemplateSelectorQueryVariables>(FeedbackTemplateSelectorDocument, options);
      }
export function useFeedbackTemplateSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackTemplateSelectorQuery, FeedbackTemplateSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackTemplateSelectorQuery, FeedbackTemplateSelectorQueryVariables>(FeedbackTemplateSelectorDocument, options);
        }
// @ts-ignore
export function useFeedbackTemplateSelectorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeedbackTemplateSelectorQuery, FeedbackTemplateSelectorQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackTemplateSelectorQuery, FeedbackTemplateSelectorQueryVariables>;
export function useFeedbackTemplateSelectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackTemplateSelectorQuery, FeedbackTemplateSelectorQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackTemplateSelectorQuery | undefined, FeedbackTemplateSelectorQueryVariables>;
export function useFeedbackTemplateSelectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackTemplateSelectorQuery, FeedbackTemplateSelectorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedbackTemplateSelectorQuery, FeedbackTemplateSelectorQueryVariables>(FeedbackTemplateSelectorDocument, options);
        }
export type FeedbackTemplateSelectorQueryHookResult = ReturnType<typeof useFeedbackTemplateSelectorQuery>;
export type FeedbackTemplateSelectorLazyQueryHookResult = ReturnType<typeof useFeedbackTemplateSelectorLazyQuery>;
export type FeedbackTemplateSelectorSuspenseQueryHookResult = ReturnType<typeof useFeedbackTemplateSelectorSuspenseQuery>;
export type FeedbackTemplateSelectorQueryResult = Apollo.QueryResult<FeedbackTemplateSelectorQuery, FeedbackTemplateSelectorQueryVariables>;
export const FeedbackTemplatesDocument = gql`
    query FeedbackTemplates($isArchived: Boolean) {
  feedbackTemplates(isArchived: $isArchived, first: 1000) {
    edges {
      node {
        id
        title
        description
        isPrivate
        isArchived
      }
    }
  }
}
    `;

/**
 * __useFeedbackTemplatesQuery__
 *
 * To run a query within a React component, call `useFeedbackTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackTemplatesQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useFeedbackTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<FeedbackTemplatesQuery, FeedbackTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackTemplatesQuery, FeedbackTemplatesQueryVariables>(FeedbackTemplatesDocument, options);
      }
export function useFeedbackTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackTemplatesQuery, FeedbackTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackTemplatesQuery, FeedbackTemplatesQueryVariables>(FeedbackTemplatesDocument, options);
        }
// @ts-ignore
export function useFeedbackTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeedbackTemplatesQuery, FeedbackTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackTemplatesQuery, FeedbackTemplatesQueryVariables>;
export function useFeedbackTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackTemplatesQuery, FeedbackTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackTemplatesQuery | undefined, FeedbackTemplatesQueryVariables>;
export function useFeedbackTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackTemplatesQuery, FeedbackTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedbackTemplatesQuery, FeedbackTemplatesQueryVariables>(FeedbackTemplatesDocument, options);
        }
export type FeedbackTemplatesQueryHookResult = ReturnType<typeof useFeedbackTemplatesQuery>;
export type FeedbackTemplatesLazyQueryHookResult = ReturnType<typeof useFeedbackTemplatesLazyQuery>;
export type FeedbackTemplatesSuspenseQueryHookResult = ReturnType<typeof useFeedbackTemplatesSuspenseQuery>;
export type FeedbackTemplatesQueryResult = Apollo.QueryResult<FeedbackTemplatesQuery, FeedbackTemplatesQueryVariables>;
export const GivenComplimentsDocument = gql`
    query GivenCompliments($last: Int, $before: ID) {
  viewer {
    id
    givenCompliments(last: $last, before: $before) {
      edges {
        node {
          id
          text
          sender {
            id
            firstName
            lastName
            avatar {
              source {
                url
              }
            }
          }
          recipient {
            id
            firstName
            lastName
            avatar {
              source {
                url
              }
            }
          }
          createdAt
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useGivenComplimentsQuery__
 *
 * To run a query within a React component, call `useGivenComplimentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGivenComplimentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGivenComplimentsQuery({
 *   variables: {
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGivenComplimentsQuery(baseOptions?: Apollo.QueryHookOptions<GivenComplimentsQuery, GivenComplimentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GivenComplimentsQuery, GivenComplimentsQueryVariables>(GivenComplimentsDocument, options);
      }
export function useGivenComplimentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GivenComplimentsQuery, GivenComplimentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GivenComplimentsQuery, GivenComplimentsQueryVariables>(GivenComplimentsDocument, options);
        }
// @ts-ignore
export function useGivenComplimentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GivenComplimentsQuery, GivenComplimentsQueryVariables>): Apollo.UseSuspenseQueryResult<GivenComplimentsQuery, GivenComplimentsQueryVariables>;
export function useGivenComplimentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GivenComplimentsQuery, GivenComplimentsQueryVariables>): Apollo.UseSuspenseQueryResult<GivenComplimentsQuery | undefined, GivenComplimentsQueryVariables>;
export function useGivenComplimentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GivenComplimentsQuery, GivenComplimentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GivenComplimentsQuery, GivenComplimentsQueryVariables>(GivenComplimentsDocument, options);
        }
export type GivenComplimentsQueryHookResult = ReturnType<typeof useGivenComplimentsQuery>;
export type GivenComplimentsLazyQueryHookResult = ReturnType<typeof useGivenComplimentsLazyQuery>;
export type GivenComplimentsSuspenseQueryHookResult = ReturnType<typeof useGivenComplimentsSuspenseQuery>;
export type GivenComplimentsQueryResult = Apollo.QueryResult<GivenComplimentsQuery, GivenComplimentsQueryVariables>;
export const InternalFeedbackDocument = gql`
    query InternalFeedback($id: ID!) {
  internalFeedback(id: $id) {
    ...InternalFeedback
  }
}
    ${InternalFeedbackFragmentDoc}`;

/**
 * __useInternalFeedbackQuery__
 *
 * To run a query within a React component, call `useInternalFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalFeedbackQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInternalFeedbackQuery(baseOptions: Apollo.QueryHookOptions<InternalFeedbackQuery, InternalFeedbackQueryVariables> & ({ variables: InternalFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InternalFeedbackQuery, InternalFeedbackQueryVariables>(InternalFeedbackDocument, options);
      }
export function useInternalFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InternalFeedbackQuery, InternalFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InternalFeedbackQuery, InternalFeedbackQueryVariables>(InternalFeedbackDocument, options);
        }
// @ts-ignore
export function useInternalFeedbackSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InternalFeedbackQuery, InternalFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<InternalFeedbackQuery, InternalFeedbackQueryVariables>;
export function useInternalFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InternalFeedbackQuery, InternalFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<InternalFeedbackQuery | undefined, InternalFeedbackQueryVariables>;
export function useInternalFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InternalFeedbackQuery, InternalFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InternalFeedbackQuery, InternalFeedbackQueryVariables>(InternalFeedbackDocument, options);
        }
export type InternalFeedbackQueryHookResult = ReturnType<typeof useInternalFeedbackQuery>;
export type InternalFeedbackLazyQueryHookResult = ReturnType<typeof useInternalFeedbackLazyQuery>;
export type InternalFeedbackSuspenseQueryHookResult = ReturnType<typeof useInternalFeedbackSuspenseQuery>;
export type InternalFeedbackQueryResult = Apollo.QueryResult<InternalFeedbackQuery, InternalFeedbackQueryVariables>;
export const InternalKakapoFeedbackDocument = gql`
    query InternalKakapoFeedback($requestID: String!) {
  internalKakapoFeedback(requestID: $requestID) {
    responseID
  }
}
    `;

/**
 * __useInternalKakapoFeedbackQuery__
 *
 * To run a query within a React component, call `useInternalKakapoFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalKakapoFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalKakapoFeedbackQuery({
 *   variables: {
 *      requestID: // value for 'requestID'
 *   },
 * });
 */
export function useInternalKakapoFeedbackQuery(baseOptions: Apollo.QueryHookOptions<InternalKakapoFeedbackQuery, InternalKakapoFeedbackQueryVariables> & ({ variables: InternalKakapoFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InternalKakapoFeedbackQuery, InternalKakapoFeedbackQueryVariables>(InternalKakapoFeedbackDocument, options);
      }
export function useInternalKakapoFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InternalKakapoFeedbackQuery, InternalKakapoFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InternalKakapoFeedbackQuery, InternalKakapoFeedbackQueryVariables>(InternalKakapoFeedbackDocument, options);
        }
// @ts-ignore
export function useInternalKakapoFeedbackSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InternalKakapoFeedbackQuery, InternalKakapoFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<InternalKakapoFeedbackQuery, InternalKakapoFeedbackQueryVariables>;
export function useInternalKakapoFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InternalKakapoFeedbackQuery, InternalKakapoFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<InternalKakapoFeedbackQuery | undefined, InternalKakapoFeedbackQueryVariables>;
export function useInternalKakapoFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InternalKakapoFeedbackQuery, InternalKakapoFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InternalKakapoFeedbackQuery, InternalKakapoFeedbackQueryVariables>(InternalKakapoFeedbackDocument, options);
        }
export type InternalKakapoFeedbackQueryHookResult = ReturnType<typeof useInternalKakapoFeedbackQuery>;
export type InternalKakapoFeedbackLazyQueryHookResult = ReturnType<typeof useInternalKakapoFeedbackLazyQuery>;
export type InternalKakapoFeedbackSuspenseQueryHookResult = ReturnType<typeof useInternalKakapoFeedbackSuspenseQuery>;
export type InternalKakapoFeedbackQueryResult = Apollo.QueryResult<InternalKakapoFeedbackQuery, InternalKakapoFeedbackQueryVariables>;
export const OutgoingFeedbackResponsesDocument = gql`
    query OutgoingFeedbackResponses($userID: ID!, $before: ID, $last: Int!) {
  user(id: $userID) {
    id
    firstName
    viewerCanRequestFeedback
    outgoingFeedbackResponses(before: $before, last: $last) {
      edges {
        node {
          id
          title
          dueDate
          sharedAt
          requestor {
            id
            firstName
            lastName
            avatar {
              source {
                url
              }
            }
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useOutgoingFeedbackResponsesQuery__
 *
 * To run a query within a React component, call `useOutgoingFeedbackResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutgoingFeedbackResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutgoingFeedbackResponsesQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useOutgoingFeedbackResponsesQuery(baseOptions: Apollo.QueryHookOptions<OutgoingFeedbackResponsesQuery, OutgoingFeedbackResponsesQueryVariables> & ({ variables: OutgoingFeedbackResponsesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutgoingFeedbackResponsesQuery, OutgoingFeedbackResponsesQueryVariables>(OutgoingFeedbackResponsesDocument, options);
      }
export function useOutgoingFeedbackResponsesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutgoingFeedbackResponsesQuery, OutgoingFeedbackResponsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutgoingFeedbackResponsesQuery, OutgoingFeedbackResponsesQueryVariables>(OutgoingFeedbackResponsesDocument, options);
        }
// @ts-ignore
export function useOutgoingFeedbackResponsesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OutgoingFeedbackResponsesQuery, OutgoingFeedbackResponsesQueryVariables>): Apollo.UseSuspenseQueryResult<OutgoingFeedbackResponsesQuery, OutgoingFeedbackResponsesQueryVariables>;
export function useOutgoingFeedbackResponsesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OutgoingFeedbackResponsesQuery, OutgoingFeedbackResponsesQueryVariables>): Apollo.UseSuspenseQueryResult<OutgoingFeedbackResponsesQuery | undefined, OutgoingFeedbackResponsesQueryVariables>;
export function useOutgoingFeedbackResponsesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OutgoingFeedbackResponsesQuery, OutgoingFeedbackResponsesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OutgoingFeedbackResponsesQuery, OutgoingFeedbackResponsesQueryVariables>(OutgoingFeedbackResponsesDocument, options);
        }
export type OutgoingFeedbackResponsesQueryHookResult = ReturnType<typeof useOutgoingFeedbackResponsesQuery>;
export type OutgoingFeedbackResponsesLazyQueryHookResult = ReturnType<typeof useOutgoingFeedbackResponsesLazyQuery>;
export type OutgoingFeedbackResponsesSuspenseQueryHookResult = ReturnType<typeof useOutgoingFeedbackResponsesSuspenseQuery>;
export type OutgoingFeedbackResponsesQueryResult = Apollo.QueryResult<OutgoingFeedbackResponsesQuery, OutgoingFeedbackResponsesQueryVariables>;
export const PromptFeedbackTipsDocument = gql`
    query PromptFeedbackTips($input: FeedbackTipsInput!) {
  promptFeedbackTips(input: $input) {
    messages {
      text
    }
  }
}
    `;

/**
 * __usePromptFeedbackTipsQuery__
 *
 * To run a query within a React component, call `usePromptFeedbackTipsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromptFeedbackTipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromptFeedbackTipsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePromptFeedbackTipsQuery(baseOptions: Apollo.QueryHookOptions<PromptFeedbackTipsQuery, PromptFeedbackTipsQueryVariables> & ({ variables: PromptFeedbackTipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromptFeedbackTipsQuery, PromptFeedbackTipsQueryVariables>(PromptFeedbackTipsDocument, options);
      }
export function usePromptFeedbackTipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromptFeedbackTipsQuery, PromptFeedbackTipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromptFeedbackTipsQuery, PromptFeedbackTipsQueryVariables>(PromptFeedbackTipsDocument, options);
        }
// @ts-ignore
export function usePromptFeedbackTipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromptFeedbackTipsQuery, PromptFeedbackTipsQueryVariables>): Apollo.UseSuspenseQueryResult<PromptFeedbackTipsQuery, PromptFeedbackTipsQueryVariables>;
export function usePromptFeedbackTipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromptFeedbackTipsQuery, PromptFeedbackTipsQueryVariables>): Apollo.UseSuspenseQueryResult<PromptFeedbackTipsQuery | undefined, PromptFeedbackTipsQueryVariables>;
export function usePromptFeedbackTipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromptFeedbackTipsQuery, PromptFeedbackTipsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromptFeedbackTipsQuery, PromptFeedbackTipsQueryVariables>(PromptFeedbackTipsDocument, options);
        }
export type PromptFeedbackTipsQueryHookResult = ReturnType<typeof usePromptFeedbackTipsQuery>;
export type PromptFeedbackTipsLazyQueryHookResult = ReturnType<typeof usePromptFeedbackTipsLazyQuery>;
export type PromptFeedbackTipsSuspenseQueryHookResult = ReturnType<typeof usePromptFeedbackTipsSuspenseQuery>;
export type PromptFeedbackTipsQueryResult = Apollo.QueryResult<PromptFeedbackTipsQuery, PromptFeedbackTipsQueryVariables>;
export const SharedFeedbackRequestDocument = gql`
    query SharedFeedbackRequest($id: ID!) {
  feedbackRequest(id: $id) {
    sharedFeedback {
      edges {
        node {
          ...SharedWith
        }
      }
    }
  }
}
    ${SharedWithFragmentDoc}`;

/**
 * __useSharedFeedbackRequestQuery__
 *
 * To run a query within a React component, call `useSharedFeedbackRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedFeedbackRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedFeedbackRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSharedFeedbackRequestQuery(baseOptions: Apollo.QueryHookOptions<SharedFeedbackRequestQuery, SharedFeedbackRequestQueryVariables> & ({ variables: SharedFeedbackRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedFeedbackRequestQuery, SharedFeedbackRequestQueryVariables>(SharedFeedbackRequestDocument, options);
      }
export function useSharedFeedbackRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedFeedbackRequestQuery, SharedFeedbackRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedFeedbackRequestQuery, SharedFeedbackRequestQueryVariables>(SharedFeedbackRequestDocument, options);
        }
// @ts-ignore
export function useSharedFeedbackRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SharedFeedbackRequestQuery, SharedFeedbackRequestQueryVariables>): Apollo.UseSuspenseQueryResult<SharedFeedbackRequestQuery, SharedFeedbackRequestQueryVariables>;
export function useSharedFeedbackRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharedFeedbackRequestQuery, SharedFeedbackRequestQueryVariables>): Apollo.UseSuspenseQueryResult<SharedFeedbackRequestQuery | undefined, SharedFeedbackRequestQueryVariables>;
export function useSharedFeedbackRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SharedFeedbackRequestQuery, SharedFeedbackRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SharedFeedbackRequestQuery, SharedFeedbackRequestQueryVariables>(SharedFeedbackRequestDocument, options);
        }
export type SharedFeedbackRequestQueryHookResult = ReturnType<typeof useSharedFeedbackRequestQuery>;
export type SharedFeedbackRequestLazyQueryHookResult = ReturnType<typeof useSharedFeedbackRequestLazyQuery>;
export type SharedFeedbackRequestSuspenseQueryHookResult = ReturnType<typeof useSharedFeedbackRequestSuspenseQuery>;
export type SharedFeedbackRequestQueryResult = Apollo.QueryResult<SharedFeedbackRequestQuery, SharedFeedbackRequestQueryVariables>;
export const ViewerGivenComplimentsDocument = gql`
    query ViewerGivenCompliments($id: ID!, $last: Int, $before: ID) {
  user(id: $id) {
    id
    firstName
    viewerGivenCompliments(last: $last, before: $before) {
      edges {
        node {
          ...ComplimentSummary
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
}
    ${ComplimentSummaryFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useViewerGivenComplimentsQuery__
 *
 * To run a query within a React component, call `useViewerGivenComplimentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerGivenComplimentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerGivenComplimentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useViewerGivenComplimentsQuery(baseOptions: Apollo.QueryHookOptions<ViewerGivenComplimentsQuery, ViewerGivenComplimentsQueryVariables> & ({ variables: ViewerGivenComplimentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerGivenComplimentsQuery, ViewerGivenComplimentsQueryVariables>(ViewerGivenComplimentsDocument, options);
      }
export function useViewerGivenComplimentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerGivenComplimentsQuery, ViewerGivenComplimentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerGivenComplimentsQuery, ViewerGivenComplimentsQueryVariables>(ViewerGivenComplimentsDocument, options);
        }
// @ts-ignore
export function useViewerGivenComplimentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerGivenComplimentsQuery, ViewerGivenComplimentsQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerGivenComplimentsQuery, ViewerGivenComplimentsQueryVariables>;
export function useViewerGivenComplimentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerGivenComplimentsQuery, ViewerGivenComplimentsQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerGivenComplimentsQuery | undefined, ViewerGivenComplimentsQueryVariables>;
export function useViewerGivenComplimentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerGivenComplimentsQuery, ViewerGivenComplimentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewerGivenComplimentsQuery, ViewerGivenComplimentsQueryVariables>(ViewerGivenComplimentsDocument, options);
        }
export type ViewerGivenComplimentsQueryHookResult = ReturnType<typeof useViewerGivenComplimentsQuery>;
export type ViewerGivenComplimentsLazyQueryHookResult = ReturnType<typeof useViewerGivenComplimentsLazyQuery>;
export type ViewerGivenComplimentsSuspenseQueryHookResult = ReturnType<typeof useViewerGivenComplimentsSuspenseQuery>;
export type ViewerGivenComplimentsQueryResult = Apollo.QueryResult<ViewerGivenComplimentsQuery, ViewerGivenComplimentsQueryVariables>;
export const AdvanceAiGeneratedGoalChatDocument = gql`
    mutation AdvanceAIGeneratedGoalChat($input: AdvanceAIChatInput!) {
  advanceAIGeneratedGoalChat(input: $input) {
    ...AIGeneratedGoalResponse
  }
}
    ${AiGeneratedGoalResponseFragmentDoc}`;
export type AdvanceAiGeneratedGoalChatMutationFn = Apollo.MutationFunction<AdvanceAiGeneratedGoalChatMutation, AdvanceAiGeneratedGoalChatMutationVariables>;

/**
 * __useAdvanceAiGeneratedGoalChatMutation__
 *
 * To run a mutation, you first call `useAdvanceAiGeneratedGoalChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdvanceAiGeneratedGoalChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [advanceAiGeneratedGoalChatMutation, { data, loading, error }] = useAdvanceAiGeneratedGoalChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdvanceAiGeneratedGoalChatMutation(baseOptions?: Apollo.MutationHookOptions<AdvanceAiGeneratedGoalChatMutation, AdvanceAiGeneratedGoalChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdvanceAiGeneratedGoalChatMutation, AdvanceAiGeneratedGoalChatMutationVariables>(AdvanceAiGeneratedGoalChatDocument, options);
      }
export type AdvanceAiGeneratedGoalChatMutationHookResult = ReturnType<typeof useAdvanceAiGeneratedGoalChatMutation>;
export type AdvanceAiGeneratedGoalChatMutationResult = Apollo.MutationResult<AdvanceAiGeneratedGoalChatMutation>;
export type AdvanceAiGeneratedGoalChatMutationOptions = Apollo.BaseMutationOptions<AdvanceAiGeneratedGoalChatMutation, AdvanceAiGeneratedGoalChatMutationVariables>;
export const ArchiveGoalDocument = gql`
    mutation ArchiveGoal($input: ArchiveGoalInput!) {
  archiveGoal(input: $input) {
    goal {
      ...MetaGoal
    }
  }
}
    ${MetaGoalFragmentDoc}`;
export type ArchiveGoalMutationFn = Apollo.MutationFunction<ArchiveGoalMutation, ArchiveGoalMutationVariables>;

/**
 * __useArchiveGoalMutation__
 *
 * To run a mutation, you first call `useArchiveGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveGoalMutation, { data, loading, error }] = useArchiveGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveGoalMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveGoalMutation, ArchiveGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveGoalMutation, ArchiveGoalMutationVariables>(ArchiveGoalDocument, options);
      }
export type ArchiveGoalMutationHookResult = ReturnType<typeof useArchiveGoalMutation>;
export type ArchiveGoalMutationResult = Apollo.MutationResult<ArchiveGoalMutation>;
export type ArchiveGoalMutationOptions = Apollo.BaseMutationOptions<ArchiveGoalMutation, ArchiveGoalMutationVariables>;
export const ArchiveGoalDriverDocument = gql`
    mutation ArchiveGoalDriver($input: ArchiveGoalDriverInput!) {
  archiveGoalDriver(input: $input) {
    success
  }
}
    `;
export type ArchiveGoalDriverMutationFn = Apollo.MutationFunction<ArchiveGoalDriverMutation, ArchiveGoalDriverMutationVariables>;

/**
 * __useArchiveGoalDriverMutation__
 *
 * To run a mutation, you first call `useArchiveGoalDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveGoalDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveGoalDriverMutation, { data, loading, error }] = useArchiveGoalDriverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveGoalDriverMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveGoalDriverMutation, ArchiveGoalDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveGoalDriverMutation, ArchiveGoalDriverMutationVariables>(ArchiveGoalDriverDocument, options);
      }
export type ArchiveGoalDriverMutationHookResult = ReturnType<typeof useArchiveGoalDriverMutation>;
export type ArchiveGoalDriverMutationResult = Apollo.MutationResult<ArchiveGoalDriverMutation>;
export type ArchiveGoalDriverMutationOptions = Apollo.BaseMutationOptions<ArchiveGoalDriverMutation, ArchiveGoalDriverMutationVariables>;
export const ArchiveGoalTemplateDocument = gql`
    mutation ArchiveGoalTemplate($input: ArchiveGoalTemplateInput!) {
  archiveGoalTemplate(input: $input) {
    goalTemplate {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveGoalTemplateMutationFn = Apollo.MutationFunction<ArchiveGoalTemplateMutation, ArchiveGoalTemplateMutationVariables>;

/**
 * __useArchiveGoalTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveGoalTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveGoalTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveGoalTemplateMutation, { data, loading, error }] = useArchiveGoalTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveGoalTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveGoalTemplateMutation, ArchiveGoalTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveGoalTemplateMutation, ArchiveGoalTemplateMutationVariables>(ArchiveGoalTemplateDocument, options);
      }
export type ArchiveGoalTemplateMutationHookResult = ReturnType<typeof useArchiveGoalTemplateMutation>;
export type ArchiveGoalTemplateMutationResult = Apollo.MutationResult<ArchiveGoalTemplateMutation>;
export type ArchiveGoalTemplateMutationOptions = Apollo.BaseMutationOptions<ArchiveGoalTemplateMutation, ArchiveGoalTemplateMutationVariables>;
export const ArchiveIndividualGoalDocument = gql`
    mutation ArchiveIndividualGoal($input: ArchiveGoalInput!) {
  archiveGoal(input: $input) {
    goal {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveIndividualGoalMutationFn = Apollo.MutationFunction<ArchiveIndividualGoalMutation, ArchiveIndividualGoalMutationVariables>;

/**
 * __useArchiveIndividualGoalMutation__
 *
 * To run a mutation, you first call `useArchiveIndividualGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveIndividualGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveIndividualGoalMutation, { data, loading, error }] = useArchiveIndividualGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveIndividualGoalMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveIndividualGoalMutation, ArchiveIndividualGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveIndividualGoalMutation, ArchiveIndividualGoalMutationVariables>(ArchiveIndividualGoalDocument, options);
      }
export type ArchiveIndividualGoalMutationHookResult = ReturnType<typeof useArchiveIndividualGoalMutation>;
export type ArchiveIndividualGoalMutationResult = Apollo.MutationResult<ArchiveIndividualGoalMutation>;
export type ArchiveIndividualGoalMutationOptions = Apollo.BaseMutationOptions<ArchiveIndividualGoalMutation, ArchiveIndividualGoalMutationVariables>;
export const CompleteMomentInstanceTaskDocument = gql`
    mutation CompleteMomentInstanceTask($input: CompleteMomentInstanceInput!) {
  completeMomentInstance(input: $input) {
    momentInstance {
      id
      status
    }
  }
}
    `;
export type CompleteMomentInstanceTaskMutationFn = Apollo.MutationFunction<CompleteMomentInstanceTaskMutation, CompleteMomentInstanceTaskMutationVariables>;

/**
 * __useCompleteMomentInstanceTaskMutation__
 *
 * To run a mutation, you first call `useCompleteMomentInstanceTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteMomentInstanceTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeMomentInstanceTaskMutation, { data, loading, error }] = useCompleteMomentInstanceTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteMomentInstanceTaskMutation(baseOptions?: Apollo.MutationHookOptions<CompleteMomentInstanceTaskMutation, CompleteMomentInstanceTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteMomentInstanceTaskMutation, CompleteMomentInstanceTaskMutationVariables>(CompleteMomentInstanceTaskDocument, options);
      }
export type CompleteMomentInstanceTaskMutationHookResult = ReturnType<typeof useCompleteMomentInstanceTaskMutation>;
export type CompleteMomentInstanceTaskMutationResult = Apollo.MutationResult<CompleteMomentInstanceTaskMutation>;
export type CompleteMomentInstanceTaskMutationOptions = Apollo.BaseMutationOptions<CompleteMomentInstanceTaskMutation, CompleteMomentInstanceTaskMutationVariables>;
export const CreateGoalDocument = gql`
    mutation CreateGoal($input: CreateGoalInput!) {
  createGoal(input: $input) {
    goal {
      id
      title
      moment {
        id
        status
        goals {
          id
        }
      }
      visibility
    }
  }
}
    `;
export type CreateGoalMutationFn = Apollo.MutationFunction<CreateGoalMutation, CreateGoalMutationVariables>;

/**
 * __useCreateGoalMutation__
 *
 * To run a mutation, you first call `useCreateGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGoalMutation, { data, loading, error }] = useCreateGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGoalMutation(baseOptions?: Apollo.MutationHookOptions<CreateGoalMutation, CreateGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGoalMutation, CreateGoalMutationVariables>(CreateGoalDocument, options);
      }
export type CreateGoalMutationHookResult = ReturnType<typeof useCreateGoalMutation>;
export type CreateGoalMutationResult = Apollo.MutationResult<CreateGoalMutation>;
export type CreateGoalMutationOptions = Apollo.BaseMutationOptions<CreateGoalMutation, CreateGoalMutationVariables>;
export const CreateGoalDriverDocument = gql`
    mutation CreateGoalDriver($input: CreateGoalDriverInput!) {
  createGoalDriver(input: $input) {
    goalDriver {
      id
    }
  }
}
    `;
export type CreateGoalDriverMutationFn = Apollo.MutationFunction<CreateGoalDriverMutation, CreateGoalDriverMutationVariables>;

/**
 * __useCreateGoalDriverMutation__
 *
 * To run a mutation, you first call `useCreateGoalDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGoalDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGoalDriverMutation, { data, loading, error }] = useCreateGoalDriverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGoalDriverMutation(baseOptions?: Apollo.MutationHookOptions<CreateGoalDriverMutation, CreateGoalDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGoalDriverMutation, CreateGoalDriverMutationVariables>(CreateGoalDriverDocument, options);
      }
export type CreateGoalDriverMutationHookResult = ReturnType<typeof useCreateGoalDriverMutation>;
export type CreateGoalDriverMutationResult = Apollo.MutationResult<CreateGoalDriverMutation>;
export type CreateGoalDriverMutationOptions = Apollo.BaseMutationOptions<CreateGoalDriverMutation, CreateGoalDriverMutationVariables>;
export const CreateGoalTemplateDocument = gql`
    mutation CreateGoalTemplate($input: CreateGoalTemplateInput!) {
  createGoalTemplate(input: $input) {
    goalTemplate {
      ...GoalTemplate
    }
  }
}
    ${GoalTemplateFragmentDoc}`;
export type CreateGoalTemplateMutationFn = Apollo.MutationFunction<CreateGoalTemplateMutation, CreateGoalTemplateMutationVariables>;

/**
 * __useCreateGoalTemplateMutation__
 *
 * To run a mutation, you first call `useCreateGoalTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGoalTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGoalTemplateMutation, { data, loading, error }] = useCreateGoalTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGoalTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateGoalTemplateMutation, CreateGoalTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGoalTemplateMutation, CreateGoalTemplateMutationVariables>(CreateGoalTemplateDocument, options);
      }
export type CreateGoalTemplateMutationHookResult = ReturnType<typeof useCreateGoalTemplateMutation>;
export type CreateGoalTemplateMutationResult = Apollo.MutationResult<CreateGoalTemplateMutation>;
export type CreateGoalTemplateMutationOptions = Apollo.BaseMutationOptions<CreateGoalTemplateMutation, CreateGoalTemplateMutationVariables>;
export const MoveGoalDocument = gql`
    mutation MoveGoal($input: MoveGoalInput!) {
  moveGoal(input: $input) {
    goal {
      ...Goal
    }
  }
}
    ${GoalFragmentDoc}`;
export type MoveGoalMutationFn = Apollo.MutationFunction<MoveGoalMutation, MoveGoalMutationVariables>;

/**
 * __useMoveGoalMutation__
 *
 * To run a mutation, you first call `useMoveGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveGoalMutation, { data, loading, error }] = useMoveGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveGoalMutation(baseOptions?: Apollo.MutationHookOptions<MoveGoalMutation, MoveGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveGoalMutation, MoveGoalMutationVariables>(MoveGoalDocument, options);
      }
export type MoveGoalMutationHookResult = ReturnType<typeof useMoveGoalMutation>;
export type MoveGoalMutationResult = Apollo.MutationResult<MoveGoalMutation>;
export type MoveGoalMutationOptions = Apollo.BaseMutationOptions<MoveGoalMutation, MoveGoalMutationVariables>;
export const PartialUpdateGoalDocument = gql`
    mutation PartialUpdateGoal($input: PartialUpdateGoalInput!) {
  partialUpdateGoal(input: $input) {
    goal {
      ...Goal
    }
  }
}
    ${GoalFragmentDoc}`;
export type PartialUpdateGoalMutationFn = Apollo.MutationFunction<PartialUpdateGoalMutation, PartialUpdateGoalMutationVariables>;

/**
 * __usePartialUpdateGoalMutation__
 *
 * To run a mutation, you first call `usePartialUpdateGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartialUpdateGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partialUpdateGoalMutation, { data, loading, error }] = usePartialUpdateGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartialUpdateGoalMutation(baseOptions?: Apollo.MutationHookOptions<PartialUpdateGoalMutation, PartialUpdateGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartialUpdateGoalMutation, PartialUpdateGoalMutationVariables>(PartialUpdateGoalDocument, options);
      }
export type PartialUpdateGoalMutationHookResult = ReturnType<typeof usePartialUpdateGoalMutation>;
export type PartialUpdateGoalMutationResult = Apollo.MutationResult<PartialUpdateGoalMutation>;
export type PartialUpdateGoalMutationOptions = Apollo.BaseMutationOptions<PartialUpdateGoalMutation, PartialUpdateGoalMutationVariables>;
export const ReorderGoalDocument = gql`
    mutation ReorderGoal($input: ReorderGoalInput!) {
  reorderGoal(input: $input) {
    goal {
      ...MetaGoal
    }
  }
}
    ${MetaGoalFragmentDoc}`;
export type ReorderGoalMutationFn = Apollo.MutationFunction<ReorderGoalMutation, ReorderGoalMutationVariables>;

/**
 * __useReorderGoalMutation__
 *
 * To run a mutation, you first call `useReorderGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderGoalMutation, { data, loading, error }] = useReorderGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderGoalMutation(baseOptions?: Apollo.MutationHookOptions<ReorderGoalMutation, ReorderGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderGoalMutation, ReorderGoalMutationVariables>(ReorderGoalDocument, options);
      }
export type ReorderGoalMutationHookResult = ReturnType<typeof useReorderGoalMutation>;
export type ReorderGoalMutationResult = Apollo.MutationResult<ReorderGoalMutation>;
export type ReorderGoalMutationOptions = Apollo.BaseMutationOptions<ReorderGoalMutation, ReorderGoalMutationVariables>;
export const ReorderGoalDriverDocument = gql`
    mutation ReorderGoalDriver($input: ReorderGoalDriverInput!) {
  reorderGoalDriver(input: $input) {
    goalDriver {
      id
      order
    }
  }
}
    `;
export type ReorderGoalDriverMutationFn = Apollo.MutationFunction<ReorderGoalDriverMutation, ReorderGoalDriverMutationVariables>;

/**
 * __useReorderGoalDriverMutation__
 *
 * To run a mutation, you first call `useReorderGoalDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderGoalDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderGoalDriverMutation, { data, loading, error }] = useReorderGoalDriverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderGoalDriverMutation(baseOptions?: Apollo.MutationHookOptions<ReorderGoalDriverMutation, ReorderGoalDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderGoalDriverMutation, ReorderGoalDriverMutationVariables>(ReorderGoalDriverDocument, options);
      }
export type ReorderGoalDriverMutationHookResult = ReturnType<typeof useReorderGoalDriverMutation>;
export type ReorderGoalDriverMutationResult = Apollo.MutationResult<ReorderGoalDriverMutation>;
export type ReorderGoalDriverMutationOptions = Apollo.BaseMutationOptions<ReorderGoalDriverMutation, ReorderGoalDriverMutationVariables>;
export const RestoreGoalDocument = gql`
    mutation RestoreGoal($input: RestoreGoalInput!) {
  restoreGoal(input: $input) {
    goal {
      ...MetaGoal
    }
  }
}
    ${MetaGoalFragmentDoc}`;
export type RestoreGoalMutationFn = Apollo.MutationFunction<RestoreGoalMutation, RestoreGoalMutationVariables>;

/**
 * __useRestoreGoalMutation__
 *
 * To run a mutation, you first call `useRestoreGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreGoalMutation, { data, loading, error }] = useRestoreGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreGoalMutation(baseOptions?: Apollo.MutationHookOptions<RestoreGoalMutation, RestoreGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreGoalMutation, RestoreGoalMutationVariables>(RestoreGoalDocument, options);
      }
export type RestoreGoalMutationHookResult = ReturnType<typeof useRestoreGoalMutation>;
export type RestoreGoalMutationResult = Apollo.MutationResult<RestoreGoalMutation>;
export type RestoreGoalMutationOptions = Apollo.BaseMutationOptions<RestoreGoalMutation, RestoreGoalMutationVariables>;
export const RestoreGoalDriverDocument = gql`
    mutation RestoreGoalDriver($input: RestoreGoalDriverInput!) {
  restoreGoalDriver(input: $input) {
    success
  }
}
    `;
export type RestoreGoalDriverMutationFn = Apollo.MutationFunction<RestoreGoalDriverMutation, RestoreGoalDriverMutationVariables>;

/**
 * __useRestoreGoalDriverMutation__
 *
 * To run a mutation, you first call `useRestoreGoalDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreGoalDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreGoalDriverMutation, { data, loading, error }] = useRestoreGoalDriverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreGoalDriverMutation(baseOptions?: Apollo.MutationHookOptions<RestoreGoalDriverMutation, RestoreGoalDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreGoalDriverMutation, RestoreGoalDriverMutationVariables>(RestoreGoalDriverDocument, options);
      }
export type RestoreGoalDriverMutationHookResult = ReturnType<typeof useRestoreGoalDriverMutation>;
export type RestoreGoalDriverMutationResult = Apollo.MutationResult<RestoreGoalDriverMutation>;
export type RestoreGoalDriverMutationOptions = Apollo.BaseMutationOptions<RestoreGoalDriverMutation, RestoreGoalDriverMutationVariables>;
export const RestoreGoalTemplateDocument = gql`
    mutation RestoreGoalTemplate($input: RestoreGoalTemplateInput!) {
  restoreGoalTemplate(input: $input) {
    goalTemplate {
      id
      isArchived
    }
  }
}
    `;
export type RestoreGoalTemplateMutationFn = Apollo.MutationFunction<RestoreGoalTemplateMutation, RestoreGoalTemplateMutationVariables>;

/**
 * __useRestoreGoalTemplateMutation__
 *
 * To run a mutation, you first call `useRestoreGoalTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreGoalTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreGoalTemplateMutation, { data, loading, error }] = useRestoreGoalTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreGoalTemplateMutation(baseOptions?: Apollo.MutationHookOptions<RestoreGoalTemplateMutation, RestoreGoalTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreGoalTemplateMutation, RestoreGoalTemplateMutationVariables>(RestoreGoalTemplateDocument, options);
      }
export type RestoreGoalTemplateMutationHookResult = ReturnType<typeof useRestoreGoalTemplateMutation>;
export type RestoreGoalTemplateMutationResult = Apollo.MutationResult<RestoreGoalTemplateMutation>;
export type RestoreGoalTemplateMutationOptions = Apollo.BaseMutationOptions<RestoreGoalTemplateMutation, RestoreGoalTemplateMutationVariables>;
export const RestoreIndividualGoalDocument = gql`
    mutation RestoreIndividualGoal($input: RestoreGoalInput!) {
  restoreGoal(input: $input) {
    goal {
      id
      isArchived
    }
  }
}
    `;
export type RestoreIndividualGoalMutationFn = Apollo.MutationFunction<RestoreIndividualGoalMutation, RestoreIndividualGoalMutationVariables>;

/**
 * __useRestoreIndividualGoalMutation__
 *
 * To run a mutation, you first call `useRestoreIndividualGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreIndividualGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreIndividualGoalMutation, { data, loading, error }] = useRestoreIndividualGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreIndividualGoalMutation(baseOptions?: Apollo.MutationHookOptions<RestoreIndividualGoalMutation, RestoreIndividualGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreIndividualGoalMutation, RestoreIndividualGoalMutationVariables>(RestoreIndividualGoalDocument, options);
      }
export type RestoreIndividualGoalMutationHookResult = ReturnType<typeof useRestoreIndividualGoalMutation>;
export type RestoreIndividualGoalMutationResult = Apollo.MutationResult<RestoreIndividualGoalMutation>;
export type RestoreIndividualGoalMutationOptions = Apollo.BaseMutationOptions<RestoreIndividualGoalMutation, RestoreIndividualGoalMutationVariables>;
export const SendMomentReminderDocument = gql`
    mutation SendMomentReminder($input: SendMomentReminderInput!) {
  sendMomentReminder(input: $input) {
    momentInstance {
      id
    }
  }
}
    `;
export type SendMomentReminderMutationFn = Apollo.MutationFunction<SendMomentReminderMutation, SendMomentReminderMutationVariables>;

/**
 * __useSendMomentReminderMutation__
 *
 * To run a mutation, you first call `useSendMomentReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMomentReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMomentReminderMutation, { data, loading, error }] = useSendMomentReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendMomentReminderMutation(baseOptions?: Apollo.MutationHookOptions<SendMomentReminderMutation, SendMomentReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMomentReminderMutation, SendMomentReminderMutationVariables>(SendMomentReminderDocument, options);
      }
export type SendMomentReminderMutationHookResult = ReturnType<typeof useSendMomentReminderMutation>;
export type SendMomentReminderMutationResult = Apollo.MutationResult<SendMomentReminderMutation>;
export type SendMomentReminderMutationOptions = Apollo.BaseMutationOptions<SendMomentReminderMutation, SendMomentReminderMutationVariables>;
export const SkipMomentInstanceDocument = gql`
    mutation SkipMomentInstance($input: SkipMomentInstanceInput!) {
  skipMomentInstance(input: $input) {
    momentInstance {
      id
      status
      skipReason
      skipReasonOther
    }
  }
}
    `;
export type SkipMomentInstanceMutationFn = Apollo.MutationFunction<SkipMomentInstanceMutation, SkipMomentInstanceMutationVariables>;

/**
 * __useSkipMomentInstanceMutation__
 *
 * To run a mutation, you first call `useSkipMomentInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipMomentInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipMomentInstanceMutation, { data, loading, error }] = useSkipMomentInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSkipMomentInstanceMutation(baseOptions?: Apollo.MutationHookOptions<SkipMomentInstanceMutation, SkipMomentInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkipMomentInstanceMutation, SkipMomentInstanceMutationVariables>(SkipMomentInstanceDocument, options);
      }
export type SkipMomentInstanceMutationHookResult = ReturnType<typeof useSkipMomentInstanceMutation>;
export type SkipMomentInstanceMutationResult = Apollo.MutationResult<SkipMomentInstanceMutation>;
export type SkipMomentInstanceMutationOptions = Apollo.BaseMutationOptions<SkipMomentInstanceMutation, SkipMomentInstanceMutationVariables>;
export const SkipMomentTemplateDocument = gql`
    mutation SkipMomentTemplate($input: SkipMomentTemplateInput!) {
  skipMomentTemplate(input: $input) {
    cycleInstance {
      id
      skippedFutureMoments {
        momentTemplateID
        skipReason
        skipReasonOther
      }
    }
  }
}
    `;
export type SkipMomentTemplateMutationFn = Apollo.MutationFunction<SkipMomentTemplateMutation, SkipMomentTemplateMutationVariables>;

/**
 * __useSkipMomentTemplateMutation__
 *
 * To run a mutation, you first call `useSkipMomentTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipMomentTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipMomentTemplateMutation, { data, loading, error }] = useSkipMomentTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSkipMomentTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SkipMomentTemplateMutation, SkipMomentTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkipMomentTemplateMutation, SkipMomentTemplateMutationVariables>(SkipMomentTemplateDocument, options);
      }
export type SkipMomentTemplateMutationHookResult = ReturnType<typeof useSkipMomentTemplateMutation>;
export type SkipMomentTemplateMutationResult = Apollo.MutationResult<SkipMomentTemplateMutation>;
export type SkipMomentTemplateMutationOptions = Apollo.BaseMutationOptions<SkipMomentTemplateMutation, SkipMomentTemplateMutationVariables>;
export const StartAiGeneratedGoalChatDocument = gql`
    mutation StartAIGeneratedGoalChat($input: StartAIGeneratedGoalChatInput!) {
  startAIGeneratedGoalChat(input: $input) {
    ...AIGeneratedGoalResponse
  }
}
    ${AiGeneratedGoalResponseFragmentDoc}`;
export type StartAiGeneratedGoalChatMutationFn = Apollo.MutationFunction<StartAiGeneratedGoalChatMutation, StartAiGeneratedGoalChatMutationVariables>;

/**
 * __useStartAiGeneratedGoalChatMutation__
 *
 * To run a mutation, you first call `useStartAiGeneratedGoalChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAiGeneratedGoalChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAiGeneratedGoalChatMutation, { data, loading, error }] = useStartAiGeneratedGoalChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartAiGeneratedGoalChatMutation(baseOptions?: Apollo.MutationHookOptions<StartAiGeneratedGoalChatMutation, StartAiGeneratedGoalChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAiGeneratedGoalChatMutation, StartAiGeneratedGoalChatMutationVariables>(StartAiGeneratedGoalChatDocument, options);
      }
export type StartAiGeneratedGoalChatMutationHookResult = ReturnType<typeof useStartAiGeneratedGoalChatMutation>;
export type StartAiGeneratedGoalChatMutationResult = Apollo.MutationResult<StartAiGeneratedGoalChatMutation>;
export type StartAiGeneratedGoalChatMutationOptions = Apollo.BaseMutationOptions<StartAiGeneratedGoalChatMutation, StartAiGeneratedGoalChatMutationVariables>;
export const UpdateGoalDocument = gql`
    mutation UpdateGoal($input: UpdateGoalInput!) {
  updateGoal(input: $input) {
    goal {
      ...MetaGoal
    }
  }
}
    ${MetaGoalFragmentDoc}`;
export type UpdateGoalMutationFn = Apollo.MutationFunction<UpdateGoalMutation, UpdateGoalMutationVariables>;

/**
 * __useUpdateGoalMutation__
 *
 * To run a mutation, you first call `useUpdateGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGoalMutation, { data, loading, error }] = useUpdateGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGoalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGoalMutation, UpdateGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGoalMutation, UpdateGoalMutationVariables>(UpdateGoalDocument, options);
      }
export type UpdateGoalMutationHookResult = ReturnType<typeof useUpdateGoalMutation>;
export type UpdateGoalMutationResult = Apollo.MutationResult<UpdateGoalMutation>;
export type UpdateGoalMutationOptions = Apollo.BaseMutationOptions<UpdateGoalMutation, UpdateGoalMutationVariables>;
export const UpdateGoalDriverDocument = gql`
    mutation UpdateGoalDriver($input: UpdateGoalDriverInput!) {
  updateGoalDriver(input: $input) {
    goalDriver {
      id
    }
  }
}
    `;
export type UpdateGoalDriverMutationFn = Apollo.MutationFunction<UpdateGoalDriverMutation, UpdateGoalDriverMutationVariables>;

/**
 * __useUpdateGoalDriverMutation__
 *
 * To run a mutation, you first call `useUpdateGoalDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGoalDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGoalDriverMutation, { data, loading, error }] = useUpdateGoalDriverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGoalDriverMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGoalDriverMutation, UpdateGoalDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGoalDriverMutation, UpdateGoalDriverMutationVariables>(UpdateGoalDriverDocument, options);
      }
export type UpdateGoalDriverMutationHookResult = ReturnType<typeof useUpdateGoalDriverMutation>;
export type UpdateGoalDriverMutationResult = Apollo.MutationResult<UpdateGoalDriverMutation>;
export type UpdateGoalDriverMutationOptions = Apollo.BaseMutationOptions<UpdateGoalDriverMutation, UpdateGoalDriverMutationVariables>;
export const UpdateGoalTemplateDocument = gql`
    mutation UpdateGoalTemplate($input: UpdateGoalTemplateInput!) {
  updateGoalTemplate(input: $input) {
    goalTemplate {
      ...GoalTemplate
    }
  }
}
    ${GoalTemplateFragmentDoc}`;
export type UpdateGoalTemplateMutationFn = Apollo.MutationFunction<UpdateGoalTemplateMutation, UpdateGoalTemplateMutationVariables>;

/**
 * __useUpdateGoalTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateGoalTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGoalTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGoalTemplateMutation, { data, loading, error }] = useUpdateGoalTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGoalTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGoalTemplateMutation, UpdateGoalTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGoalTemplateMutation, UpdateGoalTemplateMutationVariables>(UpdateGoalTemplateDocument, options);
      }
export type UpdateGoalTemplateMutationHookResult = ReturnType<typeof useUpdateGoalTemplateMutation>;
export type UpdateGoalTemplateMutationResult = Apollo.MutationResult<UpdateGoalTemplateMutation>;
export type UpdateGoalTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateGoalTemplateMutation, UpdateGoalTemplateMutationVariables>;
export const UpdateIndividualGoalDocument = gql`
    mutation UpdateIndividualGoal($input: UpdateGoalInput!) {
  updateGoal(input: $input) {
    goal {
      ...Goal
    }
  }
}
    ${GoalFragmentDoc}`;
export type UpdateIndividualGoalMutationFn = Apollo.MutationFunction<UpdateIndividualGoalMutation, UpdateIndividualGoalMutationVariables>;

/**
 * __useUpdateIndividualGoalMutation__
 *
 * To run a mutation, you first call `useUpdateIndividualGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndividualGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndividualGoalMutation, { data, loading, error }] = useUpdateIndividualGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIndividualGoalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndividualGoalMutation, UpdateIndividualGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndividualGoalMutation, UpdateIndividualGoalMutationVariables>(UpdateIndividualGoalDocument, options);
      }
export type UpdateIndividualGoalMutationHookResult = ReturnType<typeof useUpdateIndividualGoalMutation>;
export type UpdateIndividualGoalMutationResult = Apollo.MutationResult<UpdateIndividualGoalMutation>;
export type UpdateIndividualGoalMutationOptions = Apollo.BaseMutationOptions<UpdateIndividualGoalMutation, UpdateIndividualGoalMutationVariables>;
export const CycleMomentSelectorDocument = gql`
    query CycleMomentSelector {
  viewer {
    moments {
      id
      status
      startDate
      endDate
      momentTemplate {
        id
        type
        title
        description
      }
      cycleTemplate {
        id
        title
        description
      }
    }
  }
}
    `;

/**
 * __useCycleMomentSelectorQuery__
 *
 * To run a query within a React component, call `useCycleMomentSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCycleMomentSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCycleMomentSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useCycleMomentSelectorQuery(baseOptions?: Apollo.QueryHookOptions<CycleMomentSelectorQuery, CycleMomentSelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CycleMomentSelectorQuery, CycleMomentSelectorQueryVariables>(CycleMomentSelectorDocument, options);
      }
export function useCycleMomentSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CycleMomentSelectorQuery, CycleMomentSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CycleMomentSelectorQuery, CycleMomentSelectorQueryVariables>(CycleMomentSelectorDocument, options);
        }
// @ts-ignore
export function useCycleMomentSelectorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CycleMomentSelectorQuery, CycleMomentSelectorQueryVariables>): Apollo.UseSuspenseQueryResult<CycleMomentSelectorQuery, CycleMomentSelectorQueryVariables>;
export function useCycleMomentSelectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CycleMomentSelectorQuery, CycleMomentSelectorQueryVariables>): Apollo.UseSuspenseQueryResult<CycleMomentSelectorQuery | undefined, CycleMomentSelectorQueryVariables>;
export function useCycleMomentSelectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CycleMomentSelectorQuery, CycleMomentSelectorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CycleMomentSelectorQuery, CycleMomentSelectorQueryVariables>(CycleMomentSelectorDocument, options);
        }
export type CycleMomentSelectorQueryHookResult = ReturnType<typeof useCycleMomentSelectorQuery>;
export type CycleMomentSelectorLazyQueryHookResult = ReturnType<typeof useCycleMomentSelectorLazyQuery>;
export type CycleMomentSelectorSuspenseQueryHookResult = ReturnType<typeof useCycleMomentSelectorSuspenseQuery>;
export type CycleMomentSelectorQueryResult = Apollo.QueryResult<CycleMomentSelectorQuery, CycleMomentSelectorQueryVariables>;
export const GoalDocument = gql`
    query Goal($id: ID!) {
  goal(id: $id) {
    ...MetaGoal
    comments {
      id
      content
      user {
        id
        firstName
        lastName
      }
      targetID
      targetType
      createdAt
    }
    checklistItems {
      id
      description
      title
      progress {
        value
        type
        lower
        upper
      }
      learningCourseID
      learningCourse {
        id
        launchUrl
        launchUrls
        learningType {
          id
          title
        }
      }
    }
    linkedGoalDrivers {
      id
      title
    }
    createdBy {
      id
      firstName
      lastName
      avatar {
        id
        source {
          url
        }
      }
    }
  }
}
    ${MetaGoalFragmentDoc}`;

/**
 * __useGoalQuery__
 *
 * To run a query within a React component, call `useGoalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGoalQuery(baseOptions: Apollo.QueryHookOptions<GoalQuery, GoalQueryVariables> & ({ variables: GoalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalQuery, GoalQueryVariables>(GoalDocument, options);
      }
export function useGoalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalQuery, GoalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalQuery, GoalQueryVariables>(GoalDocument, options);
        }
// @ts-ignore
export function useGoalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoalQuery, GoalQueryVariables>): Apollo.UseSuspenseQueryResult<GoalQuery, GoalQueryVariables>;
export function useGoalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalQuery, GoalQueryVariables>): Apollo.UseSuspenseQueryResult<GoalQuery | undefined, GoalQueryVariables>;
export function useGoalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalQuery, GoalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoalQuery, GoalQueryVariables>(GoalDocument, options);
        }
export type GoalQueryHookResult = ReturnType<typeof useGoalQuery>;
export type GoalLazyQueryHookResult = ReturnType<typeof useGoalLazyQuery>;
export type GoalSuspenseQueryHookResult = ReturnType<typeof useGoalSuspenseQuery>;
export type GoalQueryResult = Apollo.QueryResult<GoalQuery, GoalQueryVariables>;
export const GoalAuditTrailDocument = gql`
    query GoalAuditTrail($goalID: ID!) {
  goal(id: $goalID) {
    auditTrail(last: 100) {
      edges {
        node {
          id
          field
          oldValue {
            booleanValue
            dateValue
            localizedStringValue
            percentageValue
            quillValue
          }
          newValue {
            booleanValue
            dateValue
            localizedStringValue
            percentageValue
            quillValue
          }
          createdAt
          createdBy {
            id
            firstName
            lastName
            avatar {
              source {
                url
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGoalAuditTrailQuery__
 *
 * To run a query within a React component, call `useGoalAuditTrailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalAuditTrailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalAuditTrailQuery({
 *   variables: {
 *      goalID: // value for 'goalID'
 *   },
 * });
 */
export function useGoalAuditTrailQuery(baseOptions: Apollo.QueryHookOptions<GoalAuditTrailQuery, GoalAuditTrailQueryVariables> & ({ variables: GoalAuditTrailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalAuditTrailQuery, GoalAuditTrailQueryVariables>(GoalAuditTrailDocument, options);
      }
export function useGoalAuditTrailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalAuditTrailQuery, GoalAuditTrailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalAuditTrailQuery, GoalAuditTrailQueryVariables>(GoalAuditTrailDocument, options);
        }
// @ts-ignore
export function useGoalAuditTrailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoalAuditTrailQuery, GoalAuditTrailQueryVariables>): Apollo.UseSuspenseQueryResult<GoalAuditTrailQuery, GoalAuditTrailQueryVariables>;
export function useGoalAuditTrailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalAuditTrailQuery, GoalAuditTrailQueryVariables>): Apollo.UseSuspenseQueryResult<GoalAuditTrailQuery | undefined, GoalAuditTrailQueryVariables>;
export function useGoalAuditTrailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalAuditTrailQuery, GoalAuditTrailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoalAuditTrailQuery, GoalAuditTrailQueryVariables>(GoalAuditTrailDocument, options);
        }
export type GoalAuditTrailQueryHookResult = ReturnType<typeof useGoalAuditTrailQuery>;
export type GoalAuditTrailLazyQueryHookResult = ReturnType<typeof useGoalAuditTrailLazyQuery>;
export type GoalAuditTrailSuspenseQueryHookResult = ReturnType<typeof useGoalAuditTrailSuspenseQuery>;
export type GoalAuditTrailQueryResult = Apollo.QueryResult<GoalAuditTrailQuery, GoalAuditTrailQueryVariables>;
export const GoalAuditTrailGroupDocument = gql`
    query GoalAuditTrailGroup($groupID: ID!) {
  group(id: $groupID) {
    viewerCanViewGoalAuditTrail
  }
}
    `;

/**
 * __useGoalAuditTrailGroupQuery__
 *
 * To run a query within a React component, call `useGoalAuditTrailGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalAuditTrailGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalAuditTrailGroupQuery({
 *   variables: {
 *      groupID: // value for 'groupID'
 *   },
 * });
 */
export function useGoalAuditTrailGroupQuery(baseOptions: Apollo.QueryHookOptions<GoalAuditTrailGroupQuery, GoalAuditTrailGroupQueryVariables> & ({ variables: GoalAuditTrailGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalAuditTrailGroupQuery, GoalAuditTrailGroupQueryVariables>(GoalAuditTrailGroupDocument, options);
      }
export function useGoalAuditTrailGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalAuditTrailGroupQuery, GoalAuditTrailGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalAuditTrailGroupQuery, GoalAuditTrailGroupQueryVariables>(GoalAuditTrailGroupDocument, options);
        }
// @ts-ignore
export function useGoalAuditTrailGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoalAuditTrailGroupQuery, GoalAuditTrailGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GoalAuditTrailGroupQuery, GoalAuditTrailGroupQueryVariables>;
export function useGoalAuditTrailGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalAuditTrailGroupQuery, GoalAuditTrailGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GoalAuditTrailGroupQuery | undefined, GoalAuditTrailGroupQueryVariables>;
export function useGoalAuditTrailGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalAuditTrailGroupQuery, GoalAuditTrailGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoalAuditTrailGroupQuery, GoalAuditTrailGroupQueryVariables>(GoalAuditTrailGroupDocument, options);
        }
export type GoalAuditTrailGroupQueryHookResult = ReturnType<typeof useGoalAuditTrailGroupQuery>;
export type GoalAuditTrailGroupLazyQueryHookResult = ReturnType<typeof useGoalAuditTrailGroupLazyQuery>;
export type GoalAuditTrailGroupSuspenseQueryHookResult = ReturnType<typeof useGoalAuditTrailGroupSuspenseQuery>;
export type GoalAuditTrailGroupQueryResult = Apollo.QueryResult<GoalAuditTrailGroupQuery, GoalAuditTrailGroupQueryVariables>;
export const GoalAuditTrailWorkspaceDocument = gql`
    query GoalAuditTrailWorkspace($workspaceID: ID!) {
  workspace(id: $workspaceID) {
    viewerCanViewGoalAuditTrail
  }
}
    `;

/**
 * __useGoalAuditTrailWorkspaceQuery__
 *
 * To run a query within a React component, call `useGoalAuditTrailWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalAuditTrailWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalAuditTrailWorkspaceQuery({
 *   variables: {
 *      workspaceID: // value for 'workspaceID'
 *   },
 * });
 */
export function useGoalAuditTrailWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<GoalAuditTrailWorkspaceQuery, GoalAuditTrailWorkspaceQueryVariables> & ({ variables: GoalAuditTrailWorkspaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalAuditTrailWorkspaceQuery, GoalAuditTrailWorkspaceQueryVariables>(GoalAuditTrailWorkspaceDocument, options);
      }
export function useGoalAuditTrailWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalAuditTrailWorkspaceQuery, GoalAuditTrailWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalAuditTrailWorkspaceQuery, GoalAuditTrailWorkspaceQueryVariables>(GoalAuditTrailWorkspaceDocument, options);
        }
// @ts-ignore
export function useGoalAuditTrailWorkspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoalAuditTrailWorkspaceQuery, GoalAuditTrailWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GoalAuditTrailWorkspaceQuery, GoalAuditTrailWorkspaceQueryVariables>;
export function useGoalAuditTrailWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalAuditTrailWorkspaceQuery, GoalAuditTrailWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GoalAuditTrailWorkspaceQuery | undefined, GoalAuditTrailWorkspaceQueryVariables>;
export function useGoalAuditTrailWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalAuditTrailWorkspaceQuery, GoalAuditTrailWorkspaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoalAuditTrailWorkspaceQuery, GoalAuditTrailWorkspaceQueryVariables>(GoalAuditTrailWorkspaceDocument, options);
        }
export type GoalAuditTrailWorkspaceQueryHookResult = ReturnType<typeof useGoalAuditTrailWorkspaceQuery>;
export type GoalAuditTrailWorkspaceLazyQueryHookResult = ReturnType<typeof useGoalAuditTrailWorkspaceLazyQuery>;
export type GoalAuditTrailWorkspaceSuspenseQueryHookResult = ReturnType<typeof useGoalAuditTrailWorkspaceSuspenseQuery>;
export type GoalAuditTrailWorkspaceQueryResult = Apollo.QueryResult<GoalAuditTrailWorkspaceQuery, GoalAuditTrailWorkspaceQueryVariables>;
export const GoalChildrenDocument = gql`
    query GoalChildren($id: ID!) {
  goal(id: $id) {
    id
    children {
      edges {
        node {
          ...MetaGoal
          ...GoalWithOwner
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${MetaGoalFragmentDoc}
${GoalWithOwnerFragmentDoc}`;

/**
 * __useGoalChildrenQuery__
 *
 * To run a query within a React component, call `useGoalChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalChildrenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGoalChildrenQuery(baseOptions: Apollo.QueryHookOptions<GoalChildrenQuery, GoalChildrenQueryVariables> & ({ variables: GoalChildrenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalChildrenQuery, GoalChildrenQueryVariables>(GoalChildrenDocument, options);
      }
export function useGoalChildrenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalChildrenQuery, GoalChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalChildrenQuery, GoalChildrenQueryVariables>(GoalChildrenDocument, options);
        }
// @ts-ignore
export function useGoalChildrenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoalChildrenQuery, GoalChildrenQueryVariables>): Apollo.UseSuspenseQueryResult<GoalChildrenQuery, GoalChildrenQueryVariables>;
export function useGoalChildrenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalChildrenQuery, GoalChildrenQueryVariables>): Apollo.UseSuspenseQueryResult<GoalChildrenQuery | undefined, GoalChildrenQueryVariables>;
export function useGoalChildrenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalChildrenQuery, GoalChildrenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoalChildrenQuery, GoalChildrenQueryVariables>(GoalChildrenDocument, options);
        }
export type GoalChildrenQueryHookResult = ReturnType<typeof useGoalChildrenQuery>;
export type GoalChildrenLazyQueryHookResult = ReturnType<typeof useGoalChildrenLazyQuery>;
export type GoalChildrenSuspenseQueryHookResult = ReturnType<typeof useGoalChildrenSuspenseQuery>;
export type GoalChildrenQueryResult = Apollo.QueryResult<GoalChildrenQuery, GoalChildrenQueryVariables>;
export const GoalDriversDocument = gql`
    query GoalDrivers($isArchived: Boolean) {
  goalDrivers(isArchived: $isArchived) {
    id
    title
    archivedAt
    order
  }
  viewer {
    workspace {
      id
      viewerCanCreateGoalDrivers
    }
  }
}
    `;

/**
 * __useGoalDriversQuery__
 *
 * To run a query within a React component, call `useGoalDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalDriversQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useGoalDriversQuery(baseOptions?: Apollo.QueryHookOptions<GoalDriversQuery, GoalDriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalDriversQuery, GoalDriversQueryVariables>(GoalDriversDocument, options);
      }
export function useGoalDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalDriversQuery, GoalDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalDriversQuery, GoalDriversQueryVariables>(GoalDriversDocument, options);
        }
// @ts-ignore
export function useGoalDriversSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoalDriversQuery, GoalDriversQueryVariables>): Apollo.UseSuspenseQueryResult<GoalDriversQuery, GoalDriversQueryVariables>;
export function useGoalDriversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalDriversQuery, GoalDriversQueryVariables>): Apollo.UseSuspenseQueryResult<GoalDriversQuery | undefined, GoalDriversQueryVariables>;
export function useGoalDriversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalDriversQuery, GoalDriversQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoalDriversQuery, GoalDriversQueryVariables>(GoalDriversDocument, options);
        }
export type GoalDriversQueryHookResult = ReturnType<typeof useGoalDriversQuery>;
export type GoalDriversLazyQueryHookResult = ReturnType<typeof useGoalDriversLazyQuery>;
export type GoalDriversSuspenseQueryHookResult = ReturnType<typeof useGoalDriversSuspenseQuery>;
export type GoalDriversQueryResult = Apollo.QueryResult<GoalDriversQuery, GoalDriversQueryVariables>;
export const GoalLearningRecommendationsDocument = gql`
    query GoalLearningRecommendations($input: GoalLearningRecommendationsInput!) {
  goalLearningRecommendations(input: $input) {
    recommendations {
      reason
      learningCourse {
        ...LearningCourse
      }
    }
  }
}
    ${LearningCourseFragmentDoc}`;

/**
 * __useGoalLearningRecommendationsQuery__
 *
 * To run a query within a React component, call `useGoalLearningRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalLearningRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalLearningRecommendationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGoalLearningRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<GoalLearningRecommendationsQuery, GoalLearningRecommendationsQueryVariables> & ({ variables: GoalLearningRecommendationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalLearningRecommendationsQuery, GoalLearningRecommendationsQueryVariables>(GoalLearningRecommendationsDocument, options);
      }
export function useGoalLearningRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalLearningRecommendationsQuery, GoalLearningRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalLearningRecommendationsQuery, GoalLearningRecommendationsQueryVariables>(GoalLearningRecommendationsDocument, options);
        }
// @ts-ignore
export function useGoalLearningRecommendationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoalLearningRecommendationsQuery, GoalLearningRecommendationsQueryVariables>): Apollo.UseSuspenseQueryResult<GoalLearningRecommendationsQuery, GoalLearningRecommendationsQueryVariables>;
export function useGoalLearningRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalLearningRecommendationsQuery, GoalLearningRecommendationsQueryVariables>): Apollo.UseSuspenseQueryResult<GoalLearningRecommendationsQuery | undefined, GoalLearningRecommendationsQueryVariables>;
export function useGoalLearningRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalLearningRecommendationsQuery, GoalLearningRecommendationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoalLearningRecommendationsQuery, GoalLearningRecommendationsQueryVariables>(GoalLearningRecommendationsDocument, options);
        }
export type GoalLearningRecommendationsQueryHookResult = ReturnType<typeof useGoalLearningRecommendationsQuery>;
export type GoalLearningRecommendationsLazyQueryHookResult = ReturnType<typeof useGoalLearningRecommendationsLazyQuery>;
export type GoalLearningRecommendationsSuspenseQueryHookResult = ReturnType<typeof useGoalLearningRecommendationsSuspenseQuery>;
export type GoalLearningRecommendationsQueryResult = Apollo.QueryResult<GoalLearningRecommendationsQuery, GoalLearningRecommendationsQueryVariables>;
export const GoalMomentsDocument = gql`
    query GoalMoments($id: ID!) {
  user(id: $id) {
    moments {
      id
      status
      startDate
      endDate
      momentTemplate {
        id
        type
        title
        description
        goals {
          minimumGoals
          minimumCompetencyGoals
        }
      }
      goals {
        ...Goal
      }
    }
  }
}
    ${GoalFragmentDoc}`;

/**
 * __useGoalMomentsQuery__
 *
 * To run a query within a React component, call `useGoalMomentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalMomentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalMomentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGoalMomentsQuery(baseOptions: Apollo.QueryHookOptions<GoalMomentsQuery, GoalMomentsQueryVariables> & ({ variables: GoalMomentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalMomentsQuery, GoalMomentsQueryVariables>(GoalMomentsDocument, options);
      }
export function useGoalMomentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalMomentsQuery, GoalMomentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalMomentsQuery, GoalMomentsQueryVariables>(GoalMomentsDocument, options);
        }
// @ts-ignore
export function useGoalMomentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoalMomentsQuery, GoalMomentsQueryVariables>): Apollo.UseSuspenseQueryResult<GoalMomentsQuery, GoalMomentsQueryVariables>;
export function useGoalMomentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalMomentsQuery, GoalMomentsQueryVariables>): Apollo.UseSuspenseQueryResult<GoalMomentsQuery | undefined, GoalMomentsQueryVariables>;
export function useGoalMomentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalMomentsQuery, GoalMomentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoalMomentsQuery, GoalMomentsQueryVariables>(GoalMomentsDocument, options);
        }
export type GoalMomentsQueryHookResult = ReturnType<typeof useGoalMomentsQuery>;
export type GoalMomentsLazyQueryHookResult = ReturnType<typeof useGoalMomentsLazyQuery>;
export type GoalMomentsSuspenseQueryHookResult = ReturnType<typeof useGoalMomentsSuspenseQuery>;
export type GoalMomentsQueryResult = Apollo.QueryResult<GoalMomentsQuery, GoalMomentsQueryVariables>;
export const GoalRevisionDocument = gql`
    query GoalRevision($id: ID!, $revision: String!, $secret: String) {
  goalRevision(id: $id, revision: $revision, secret: $secret) {
    id
    title
    description
    dueDate
    progress
    status
    feasibility
    archivedAt
    isArchived
    createdAt
    updatedAt
    completedAt
    competency {
      competency {
        id
        title
        levels {
          criteria
          enabled
          level {
            id
            title
          }
        }
      }
      competencyLevelIndex
    }
    checklistItems {
      id
      title
      description
      progress {
        type
        value
        upper
        lower
      }
      dueDate
      createdBy {
        id
      }
      createdAt
      updatedBy {
        id
      }
      updatedAt
      completedBy {
        id
      }
      completedAt
    }
  }
}
    `;

/**
 * __useGoalRevisionQuery__
 *
 * To run a query within a React component, call `useGoalRevisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalRevisionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalRevisionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      revision: // value for 'revision'
 *      secret: // value for 'secret'
 *   },
 * });
 */
export function useGoalRevisionQuery(baseOptions: Apollo.QueryHookOptions<GoalRevisionQuery, GoalRevisionQueryVariables> & ({ variables: GoalRevisionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalRevisionQuery, GoalRevisionQueryVariables>(GoalRevisionDocument, options);
      }
export function useGoalRevisionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalRevisionQuery, GoalRevisionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalRevisionQuery, GoalRevisionQueryVariables>(GoalRevisionDocument, options);
        }
// @ts-ignore
export function useGoalRevisionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoalRevisionQuery, GoalRevisionQueryVariables>): Apollo.UseSuspenseQueryResult<GoalRevisionQuery, GoalRevisionQueryVariables>;
export function useGoalRevisionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalRevisionQuery, GoalRevisionQueryVariables>): Apollo.UseSuspenseQueryResult<GoalRevisionQuery | undefined, GoalRevisionQueryVariables>;
export function useGoalRevisionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalRevisionQuery, GoalRevisionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoalRevisionQuery, GoalRevisionQueryVariables>(GoalRevisionDocument, options);
        }
export type GoalRevisionQueryHookResult = ReturnType<typeof useGoalRevisionQuery>;
export type GoalRevisionLazyQueryHookResult = ReturnType<typeof useGoalRevisionLazyQuery>;
export type GoalRevisionSuspenseQueryHookResult = ReturnType<typeof useGoalRevisionSuspenseQuery>;
export type GoalRevisionQueryResult = Apollo.QueryResult<GoalRevisionQuery, GoalRevisionQueryVariables>;
export const GoalTemplateDocument = gql`
    query GoalTemplate($id: ID!) {
  goalTemplate(id: $id) {
    ...GoalTemplate
  }
}
    ${GoalTemplateFragmentDoc}`;

/**
 * __useGoalTemplateQuery__
 *
 * To run a query within a React component, call `useGoalTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGoalTemplateQuery(baseOptions: Apollo.QueryHookOptions<GoalTemplateQuery, GoalTemplateQueryVariables> & ({ variables: GoalTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalTemplateQuery, GoalTemplateQueryVariables>(GoalTemplateDocument, options);
      }
export function useGoalTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalTemplateQuery, GoalTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalTemplateQuery, GoalTemplateQueryVariables>(GoalTemplateDocument, options);
        }
// @ts-ignore
export function useGoalTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoalTemplateQuery, GoalTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GoalTemplateQuery, GoalTemplateQueryVariables>;
export function useGoalTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalTemplateQuery, GoalTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GoalTemplateQuery | undefined, GoalTemplateQueryVariables>;
export function useGoalTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalTemplateQuery, GoalTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoalTemplateQuery, GoalTemplateQueryVariables>(GoalTemplateDocument, options);
        }
export type GoalTemplateQueryHookResult = ReturnType<typeof useGoalTemplateQuery>;
export type GoalTemplateLazyQueryHookResult = ReturnType<typeof useGoalTemplateLazyQuery>;
export type GoalTemplateSuspenseQueryHookResult = ReturnType<typeof useGoalTemplateSuspenseQuery>;
export type GoalTemplateQueryResult = Apollo.QueryResult<GoalTemplateQuery, GoalTemplateQueryVariables>;
export const GoalTemplatesDocument = gql`
    query GoalTemplates($isArchived: Boolean!, $before: ID, $after: ID, $first: Int, $last: Int) {
  goalTemplates(
    isArchived: $isArchived
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        id
        title
        description
        isArchived
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGoalTemplatesQuery__
 *
 * To run a query within a React component, call `useGoalTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalTemplatesQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGoalTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GoalTemplatesQuery, GoalTemplatesQueryVariables> & ({ variables: GoalTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalTemplatesQuery, GoalTemplatesQueryVariables>(GoalTemplatesDocument, options);
      }
export function useGoalTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalTemplatesQuery, GoalTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalTemplatesQuery, GoalTemplatesQueryVariables>(GoalTemplatesDocument, options);
        }
// @ts-ignore
export function useGoalTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoalTemplatesQuery, GoalTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GoalTemplatesQuery, GoalTemplatesQueryVariables>;
export function useGoalTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalTemplatesQuery, GoalTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GoalTemplatesQuery | undefined, GoalTemplatesQueryVariables>;
export function useGoalTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoalTemplatesQuery, GoalTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoalTemplatesQuery, GoalTemplatesQueryVariables>(GoalTemplatesDocument, options);
        }
export type GoalTemplatesQueryHookResult = ReturnType<typeof useGoalTemplatesQuery>;
export type GoalTemplatesLazyQueryHookResult = ReturnType<typeof useGoalTemplatesLazyQuery>;
export type GoalTemplatesSuspenseQueryHookResult = ReturnType<typeof useGoalTemplatesSuspenseQuery>;
export type GoalTemplatesQueryResult = Apollo.QueryResult<GoalTemplatesQuery, GoalTemplatesQueryVariables>;
export const GroupGoalCountsDocument = gql`
    query GroupGoalCounts($id: ID!) {
  group(id: $id) {
    id
    goals(status: ACTIVE) {
      id
    }
  }
}
    `;

/**
 * __useGroupGoalCountsQuery__
 *
 * To run a query within a React component, call `useGroupGoalCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupGoalCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupGoalCountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupGoalCountsQuery(baseOptions: Apollo.QueryHookOptions<GroupGoalCountsQuery, GroupGoalCountsQueryVariables> & ({ variables: GroupGoalCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupGoalCountsQuery, GroupGoalCountsQueryVariables>(GroupGoalCountsDocument, options);
      }
export function useGroupGoalCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupGoalCountsQuery, GroupGoalCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupGoalCountsQuery, GroupGoalCountsQueryVariables>(GroupGoalCountsDocument, options);
        }
// @ts-ignore
export function useGroupGoalCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupGoalCountsQuery, GroupGoalCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupGoalCountsQuery, GroupGoalCountsQueryVariables>;
export function useGroupGoalCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupGoalCountsQuery, GroupGoalCountsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupGoalCountsQuery | undefined, GroupGoalCountsQueryVariables>;
export function useGroupGoalCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupGoalCountsQuery, GroupGoalCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupGoalCountsQuery, GroupGoalCountsQueryVariables>(GroupGoalCountsDocument, options);
        }
export type GroupGoalCountsQueryHookResult = ReturnType<typeof useGroupGoalCountsQuery>;
export type GroupGoalCountsLazyQueryHookResult = ReturnType<typeof useGroupGoalCountsLazyQuery>;
export type GroupGoalCountsSuspenseQueryHookResult = ReturnType<typeof useGroupGoalCountsSuspenseQuery>;
export type GroupGoalCountsQueryResult = Apollo.QueryResult<GroupGoalCountsQuery, GroupGoalCountsQueryVariables>;
export const GroupGoalsDocument = gql`
    query GroupGoals($id: ID!, $status: GoalStatus!, $roleTypes: [RoleType!], $before: ID, $last: Int!) {
  group(id: $id) {
    id
    name
    type
    goalsV2(status: $status, before: $before, last: $last) {
      edges {
        node {
          ...MetaGoal
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
    members(roleTypes: $roleTypes) {
      edges {
        node {
          id
          firstName
          lastName
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
    ${MetaGoalFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useGroupGoalsQuery__
 *
 * To run a query within a React component, call `useGroupGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupGoalsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      roleTypes: // value for 'roleTypes'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGroupGoalsQuery(baseOptions: Apollo.QueryHookOptions<GroupGoalsQuery, GroupGoalsQueryVariables> & ({ variables: GroupGoalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupGoalsQuery, GroupGoalsQueryVariables>(GroupGoalsDocument, options);
      }
export function useGroupGoalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupGoalsQuery, GroupGoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupGoalsQuery, GroupGoalsQueryVariables>(GroupGoalsDocument, options);
        }
// @ts-ignore
export function useGroupGoalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupGoalsQuery, GroupGoalsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupGoalsQuery, GroupGoalsQueryVariables>;
export function useGroupGoalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupGoalsQuery, GroupGoalsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupGoalsQuery | undefined, GroupGoalsQueryVariables>;
export function useGroupGoalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupGoalsQuery, GroupGoalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupGoalsQuery, GroupGoalsQueryVariables>(GroupGoalsDocument, options);
        }
export type GroupGoalsQueryHookResult = ReturnType<typeof useGroupGoalsQuery>;
export type GroupGoalsLazyQueryHookResult = ReturnType<typeof useGroupGoalsLazyQuery>;
export type GroupGoalsSuspenseQueryHookResult = ReturnType<typeof useGroupGoalsSuspenseQuery>;
export type GroupGoalsQueryResult = Apollo.QueryResult<GroupGoalsQuery, GroupGoalsQueryVariables>;
export const GroupGoalsMetaDocument = gql`
    query GroupGoalsMeta($id: ID!) {
  group(id: $id) {
    id
    name
    type
    viewerCanCreateGoal
    viewerCanViewArchivedGoals
  }
}
    `;

/**
 * __useGroupGoalsMetaQuery__
 *
 * To run a query within a React component, call `useGroupGoalsMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupGoalsMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupGoalsMetaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupGoalsMetaQuery(baseOptions: Apollo.QueryHookOptions<GroupGoalsMetaQuery, GroupGoalsMetaQueryVariables> & ({ variables: GroupGoalsMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupGoalsMetaQuery, GroupGoalsMetaQueryVariables>(GroupGoalsMetaDocument, options);
      }
export function useGroupGoalsMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupGoalsMetaQuery, GroupGoalsMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupGoalsMetaQuery, GroupGoalsMetaQueryVariables>(GroupGoalsMetaDocument, options);
        }
// @ts-ignore
export function useGroupGoalsMetaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupGoalsMetaQuery, GroupGoalsMetaQueryVariables>): Apollo.UseSuspenseQueryResult<GroupGoalsMetaQuery, GroupGoalsMetaQueryVariables>;
export function useGroupGoalsMetaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupGoalsMetaQuery, GroupGoalsMetaQueryVariables>): Apollo.UseSuspenseQueryResult<GroupGoalsMetaQuery | undefined, GroupGoalsMetaQueryVariables>;
export function useGroupGoalsMetaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupGoalsMetaQuery, GroupGoalsMetaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupGoalsMetaQuery, GroupGoalsMetaQueryVariables>(GroupGoalsMetaDocument, options);
        }
export type GroupGoalsMetaQueryHookResult = ReturnType<typeof useGroupGoalsMetaQuery>;
export type GroupGoalsMetaLazyQueryHookResult = ReturnType<typeof useGroupGoalsMetaLazyQuery>;
export type GroupGoalsMetaSuspenseQueryHookResult = ReturnType<typeof useGroupGoalsMetaSuspenseQuery>;
export type GroupGoalsMetaQueryResult = Apollo.QueryResult<GroupGoalsMetaQuery, GroupGoalsMetaQueryVariables>;
export const IndividualGoalDocument = gql`
    query IndividualGoal($id: ID!) {
  goal(id: $id) {
    ...Goal
    linkedGoals {
      id
    }
  }
}
    ${GoalFragmentDoc}`;

/**
 * __useIndividualGoalQuery__
 *
 * To run a query within a React component, call `useIndividualGoalQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndividualGoalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndividualGoalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIndividualGoalQuery(baseOptions: Apollo.QueryHookOptions<IndividualGoalQuery, IndividualGoalQueryVariables> & ({ variables: IndividualGoalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndividualGoalQuery, IndividualGoalQueryVariables>(IndividualGoalDocument, options);
      }
export function useIndividualGoalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndividualGoalQuery, IndividualGoalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndividualGoalQuery, IndividualGoalQueryVariables>(IndividualGoalDocument, options);
        }
// @ts-ignore
export function useIndividualGoalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IndividualGoalQuery, IndividualGoalQueryVariables>): Apollo.UseSuspenseQueryResult<IndividualGoalQuery, IndividualGoalQueryVariables>;
export function useIndividualGoalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IndividualGoalQuery, IndividualGoalQueryVariables>): Apollo.UseSuspenseQueryResult<IndividualGoalQuery | undefined, IndividualGoalQueryVariables>;
export function useIndividualGoalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IndividualGoalQuery, IndividualGoalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndividualGoalQuery, IndividualGoalQueryVariables>(IndividualGoalDocument, options);
        }
export type IndividualGoalQueryHookResult = ReturnType<typeof useIndividualGoalQuery>;
export type IndividualGoalLazyQueryHookResult = ReturnType<typeof useIndividualGoalLazyQuery>;
export type IndividualGoalSuspenseQueryHookResult = ReturnType<typeof useIndividualGoalSuspenseQuery>;
export type IndividualGoalQueryResult = Apollo.QueryResult<IndividualGoalQuery, IndividualGoalQueryVariables>;
export const IndividualGoalsDocument = gql`
    query IndividualGoals($id: ID!, $status: GoalStatus!, $before: ID, $last: Int!) {
  user(id: $id) {
    id
    goalsV2(status: $status, before: $before, last: $last) {
      edges {
        node {
          ...MetaGoal
          ...GoalWithOwner
        }
      }
      pageInfo {
        ...PageInfo
      }
      totalCount
    }
  }
}
    ${MetaGoalFragmentDoc}
${GoalWithOwnerFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useIndividualGoalsQuery__
 *
 * To run a query within a React component, call `useIndividualGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndividualGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndividualGoalsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useIndividualGoalsQuery(baseOptions: Apollo.QueryHookOptions<IndividualGoalsQuery, IndividualGoalsQueryVariables> & ({ variables: IndividualGoalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndividualGoalsQuery, IndividualGoalsQueryVariables>(IndividualGoalsDocument, options);
      }
export function useIndividualGoalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndividualGoalsQuery, IndividualGoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndividualGoalsQuery, IndividualGoalsQueryVariables>(IndividualGoalsDocument, options);
        }
// @ts-ignore
export function useIndividualGoalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IndividualGoalsQuery, IndividualGoalsQueryVariables>): Apollo.UseSuspenseQueryResult<IndividualGoalsQuery, IndividualGoalsQueryVariables>;
export function useIndividualGoalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IndividualGoalsQuery, IndividualGoalsQueryVariables>): Apollo.UseSuspenseQueryResult<IndividualGoalsQuery | undefined, IndividualGoalsQueryVariables>;
export function useIndividualGoalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IndividualGoalsQuery, IndividualGoalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndividualGoalsQuery, IndividualGoalsQueryVariables>(IndividualGoalsDocument, options);
        }
export type IndividualGoalsQueryHookResult = ReturnType<typeof useIndividualGoalsQuery>;
export type IndividualGoalsLazyQueryHookResult = ReturnType<typeof useIndividualGoalsLazyQuery>;
export type IndividualGoalsSuspenseQueryHookResult = ReturnType<typeof useIndividualGoalsSuspenseQuery>;
export type IndividualGoalsQueryResult = Apollo.QueryResult<IndividualGoalsQuery, IndividualGoalsQueryVariables>;
export const MomentForEvaluationDocument = gql`
    query MomentForEvaluation($id: ID!) {
  momentInstance(id: $id) {
    id
    momentTemplate {
      title
      evaluation {
        evaluationForm {
          id
          title
        }
      }
    }
  }
}
    `;

/**
 * __useMomentForEvaluationQuery__
 *
 * To run a query within a React component, call `useMomentForEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMomentForEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMomentForEvaluationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMomentForEvaluationQuery(baseOptions: Apollo.QueryHookOptions<MomentForEvaluationQuery, MomentForEvaluationQueryVariables> & ({ variables: MomentForEvaluationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MomentForEvaluationQuery, MomentForEvaluationQueryVariables>(MomentForEvaluationDocument, options);
      }
export function useMomentForEvaluationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MomentForEvaluationQuery, MomentForEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MomentForEvaluationQuery, MomentForEvaluationQueryVariables>(MomentForEvaluationDocument, options);
        }
// @ts-ignore
export function useMomentForEvaluationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MomentForEvaluationQuery, MomentForEvaluationQueryVariables>): Apollo.UseSuspenseQueryResult<MomentForEvaluationQuery, MomentForEvaluationQueryVariables>;
export function useMomentForEvaluationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MomentForEvaluationQuery, MomentForEvaluationQueryVariables>): Apollo.UseSuspenseQueryResult<MomentForEvaluationQuery | undefined, MomentForEvaluationQueryVariables>;
export function useMomentForEvaluationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MomentForEvaluationQuery, MomentForEvaluationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MomentForEvaluationQuery, MomentForEvaluationQueryVariables>(MomentForEvaluationDocument, options);
        }
export type MomentForEvaluationQueryHookResult = ReturnType<typeof useMomentForEvaluationQuery>;
export type MomentForEvaluationLazyQueryHookResult = ReturnType<typeof useMomentForEvaluationLazyQuery>;
export type MomentForEvaluationSuspenseQueryHookResult = ReturnType<typeof useMomentForEvaluationSuspenseQuery>;
export type MomentForEvaluationQueryResult = Apollo.QueryResult<MomentForEvaluationQuery, MomentForEvaluationQueryVariables>;
export const MomentForFeedbackDocument = gql`
    query MomentForFeedback($id: ID!) {
  momentInstance(id: $id) {
    id
    momentTemplate {
      title
      feedback {
        minimumRecipients
        maximumRecipients
        minimumQuestions
        releaseDate
        feedbackTemplate {
          ...FeedbackTemplateForFeedback
        }
      }
    }
  }
}
    ${FeedbackTemplateForFeedbackFragmentDoc}`;

/**
 * __useMomentForFeedbackQuery__
 *
 * To run a query within a React component, call `useMomentForFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useMomentForFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMomentForFeedbackQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMomentForFeedbackQuery(baseOptions: Apollo.QueryHookOptions<MomentForFeedbackQuery, MomentForFeedbackQueryVariables> & ({ variables: MomentForFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MomentForFeedbackQuery, MomentForFeedbackQueryVariables>(MomentForFeedbackDocument, options);
      }
export function useMomentForFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MomentForFeedbackQuery, MomentForFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MomentForFeedbackQuery, MomentForFeedbackQueryVariables>(MomentForFeedbackDocument, options);
        }
// @ts-ignore
export function useMomentForFeedbackSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MomentForFeedbackQuery, MomentForFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<MomentForFeedbackQuery, MomentForFeedbackQueryVariables>;
export function useMomentForFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MomentForFeedbackQuery, MomentForFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<MomentForFeedbackQuery | undefined, MomentForFeedbackQueryVariables>;
export function useMomentForFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MomentForFeedbackQuery, MomentForFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MomentForFeedbackQuery, MomentForFeedbackQueryVariables>(MomentForFeedbackDocument, options);
        }
export type MomentForFeedbackQueryHookResult = ReturnType<typeof useMomentForFeedbackQuery>;
export type MomentForFeedbackLazyQueryHookResult = ReturnType<typeof useMomentForFeedbackLazyQuery>;
export type MomentForFeedbackSuspenseQueryHookResult = ReturnType<typeof useMomentForFeedbackSuspenseQuery>;
export type MomentForFeedbackQueryResult = Apollo.QueryResult<MomentForFeedbackQuery, MomentForFeedbackQueryVariables>;
export const MomentForGoalsDocument = gql`
    query MomentForGoals($id: ID!) {
  momentInstance(id: $id) {
    id
    momentTemplate {
      id
      title
      goals {
        minimumGoals
        minimumCompetencyGoals
      }
    }
    goals {
      ...Goal
    }
  }
}
    ${GoalFragmentDoc}`;

/**
 * __useMomentForGoalsQuery__
 *
 * To run a query within a React component, call `useMomentForGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMomentForGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMomentForGoalsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMomentForGoalsQuery(baseOptions: Apollo.QueryHookOptions<MomentForGoalsQuery, MomentForGoalsQueryVariables> & ({ variables: MomentForGoalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MomentForGoalsQuery, MomentForGoalsQueryVariables>(MomentForGoalsDocument, options);
      }
export function useMomentForGoalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MomentForGoalsQuery, MomentForGoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MomentForGoalsQuery, MomentForGoalsQueryVariables>(MomentForGoalsDocument, options);
        }
// @ts-ignore
export function useMomentForGoalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MomentForGoalsQuery, MomentForGoalsQueryVariables>): Apollo.UseSuspenseQueryResult<MomentForGoalsQuery, MomentForGoalsQueryVariables>;
export function useMomentForGoalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MomentForGoalsQuery, MomentForGoalsQueryVariables>): Apollo.UseSuspenseQueryResult<MomentForGoalsQuery | undefined, MomentForGoalsQueryVariables>;
export function useMomentForGoalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MomentForGoalsQuery, MomentForGoalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MomentForGoalsQuery, MomentForGoalsQueryVariables>(MomentForGoalsDocument, options);
        }
export type MomentForGoalsQueryHookResult = ReturnType<typeof useMomentForGoalsQuery>;
export type MomentForGoalsLazyQueryHookResult = ReturnType<typeof useMomentForGoalsLazyQuery>;
export type MomentForGoalsSuspenseQueryHookResult = ReturnType<typeof useMomentForGoalsSuspenseQuery>;
export type MomentForGoalsQueryResult = Apollo.QueryResult<MomentForGoalsQuery, MomentForGoalsQueryVariables>;
export const WorkspaceGoalsDocument = gql`
    query WorkspaceGoals($id: ID!, $status: GoalStatus!, $before: ID, $last: Int!) {
  workspace(id: $id) {
    id
    goalsV2(status: $status, before: $before, last: $last) {
      edges {
        node {
          ...MetaGoal
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
    viewerCanCreateGoal
    viewerCanViewArchivedGoals
  }
}
    ${MetaGoalFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useWorkspaceGoalsQuery__
 *
 * To run a query within a React component, call `useWorkspaceGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceGoalsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useWorkspaceGoalsQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceGoalsQuery, WorkspaceGoalsQueryVariables> & ({ variables: WorkspaceGoalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceGoalsQuery, WorkspaceGoalsQueryVariables>(WorkspaceGoalsDocument, options);
      }
export function useWorkspaceGoalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceGoalsQuery, WorkspaceGoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceGoalsQuery, WorkspaceGoalsQueryVariables>(WorkspaceGoalsDocument, options);
        }
// @ts-ignore
export function useWorkspaceGoalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceGoalsQuery, WorkspaceGoalsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceGoalsQuery, WorkspaceGoalsQueryVariables>;
export function useWorkspaceGoalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceGoalsQuery, WorkspaceGoalsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceGoalsQuery | undefined, WorkspaceGoalsQueryVariables>;
export function useWorkspaceGoalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceGoalsQuery, WorkspaceGoalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceGoalsQuery, WorkspaceGoalsQueryVariables>(WorkspaceGoalsDocument, options);
        }
export type WorkspaceGoalsQueryHookResult = ReturnType<typeof useWorkspaceGoalsQuery>;
export type WorkspaceGoalsLazyQueryHookResult = ReturnType<typeof useWorkspaceGoalsLazyQuery>;
export type WorkspaceGoalsSuspenseQueryHookResult = ReturnType<typeof useWorkspaceGoalsSuspenseQuery>;
export type WorkspaceGoalsQueryResult = Apollo.QueryResult<WorkspaceGoalsQuery, WorkspaceGoalsQueryVariables>;
export const CompetencyFeedbackScoresDocument = gql`
    query CompetencyFeedbackScores($competencyID: ID!, $userID: ID!, $startDate: DateTime, $endDate: DateTime) {
  competency(id: $competencyID) {
    id
    title
    description
    levels {
      level {
        id
        title
      }
      enabled
      criteria
    }
    appraisals(userID: $userID) {
      user {
        id
        managers {
          source {
            id
          }
        }
      }
      competencyLevelIndex
      feedbackScores(startDate: $startDate, endDate: $endDate) {
        competencyLevelIndex
        timestamp
        giver {
          ... on User {
            id
            firstName
            lastName
            avatar {
              id
              source {
                url
              }
            }
          }
          ... on CompetencyFeedbackScoreExternalGiver {
            firstName
            lastName
            email
          }
        }
        feedbackResponse {
          id
          answers {
            questionID
            text
            competencyLevelIndex
            voiceMemo {
              ...VoiceMemo
            }
          }
        }
      }
    }
  }
}
    ${VoiceMemoFragmentDoc}`;

/**
 * __useCompetencyFeedbackScoresQuery__
 *
 * To run a query within a React component, call `useCompetencyFeedbackScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetencyFeedbackScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetencyFeedbackScoresQuery({
 *   variables: {
 *      competencyID: // value for 'competencyID'
 *      userID: // value for 'userID'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCompetencyFeedbackScoresQuery(baseOptions: Apollo.QueryHookOptions<CompetencyFeedbackScoresQuery, CompetencyFeedbackScoresQueryVariables> & ({ variables: CompetencyFeedbackScoresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetencyFeedbackScoresQuery, CompetencyFeedbackScoresQueryVariables>(CompetencyFeedbackScoresDocument, options);
      }
export function useCompetencyFeedbackScoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetencyFeedbackScoresQuery, CompetencyFeedbackScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetencyFeedbackScoresQuery, CompetencyFeedbackScoresQueryVariables>(CompetencyFeedbackScoresDocument, options);
        }
// @ts-ignore
export function useCompetencyFeedbackScoresSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompetencyFeedbackScoresQuery, CompetencyFeedbackScoresQueryVariables>): Apollo.UseSuspenseQueryResult<CompetencyFeedbackScoresQuery, CompetencyFeedbackScoresQueryVariables>;
export function useCompetencyFeedbackScoresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetencyFeedbackScoresQuery, CompetencyFeedbackScoresQueryVariables>): Apollo.UseSuspenseQueryResult<CompetencyFeedbackScoresQuery | undefined, CompetencyFeedbackScoresQueryVariables>;
export function useCompetencyFeedbackScoresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetencyFeedbackScoresQuery, CompetencyFeedbackScoresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetencyFeedbackScoresQuery, CompetencyFeedbackScoresQueryVariables>(CompetencyFeedbackScoresDocument, options);
        }
export type CompetencyFeedbackScoresQueryHookResult = ReturnType<typeof useCompetencyFeedbackScoresQuery>;
export type CompetencyFeedbackScoresLazyQueryHookResult = ReturnType<typeof useCompetencyFeedbackScoresLazyQuery>;
export type CompetencyFeedbackScoresSuspenseQueryHookResult = ReturnType<typeof useCompetencyFeedbackScoresSuspenseQuery>;
export type CompetencyFeedbackScoresQueryResult = Apollo.QueryResult<CompetencyFeedbackScoresQuery, CompetencyFeedbackScoresQueryVariables>;
export const ArchiveInboxTaskDocument = gql`
    mutation ArchiveInboxTask($input: ArchiveInboxTaskInput!) {
  archiveInboxTask(input: $input) {
    inboxTask {
      id
    }
  }
}
    `;
export type ArchiveInboxTaskMutationFn = Apollo.MutationFunction<ArchiveInboxTaskMutation, ArchiveInboxTaskMutationVariables>;

/**
 * __useArchiveInboxTaskMutation__
 *
 * To run a mutation, you first call `useArchiveInboxTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveInboxTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveInboxTaskMutation, { data, loading, error }] = useArchiveInboxTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveInboxTaskMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveInboxTaskMutation, ArchiveInboxTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveInboxTaskMutation, ArchiveInboxTaskMutationVariables>(ArchiveInboxTaskDocument, options);
      }
export type ArchiveInboxTaskMutationHookResult = ReturnType<typeof useArchiveInboxTaskMutation>;
export type ArchiveInboxTaskMutationResult = Apollo.MutationResult<ArchiveInboxTaskMutation>;
export type ArchiveInboxTaskMutationOptions = Apollo.BaseMutationOptions<ArchiveInboxTaskMutation, ArchiveInboxTaskMutationVariables>;
export const MarkInboxTaskDocument = gql`
    mutation MarkInboxTask($input: MarkInboxTaskInput!) {
  markInboxTask(input: $input) {
    inboxTask {
      id
      type
      status
      createdAt
      seen
      evaluationSubmission {
        id
        evaluationForm {
          title
        }
        employee {
          user {
            id
            firstName
            lastName
          }
          requiresInput
        }
        manager {
          user {
            id
            firstName
            lastName
          }
          requiresInput
        }
      }
    }
  }
}
    `;
export type MarkInboxTaskMutationFn = Apollo.MutationFunction<MarkInboxTaskMutation, MarkInboxTaskMutationVariables>;

/**
 * __useMarkInboxTaskMutation__
 *
 * To run a mutation, you first call `useMarkInboxTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInboxTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInboxTaskMutation, { data, loading, error }] = useMarkInboxTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkInboxTaskMutation(baseOptions?: Apollo.MutationHookOptions<MarkInboxTaskMutation, MarkInboxTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInboxTaskMutation, MarkInboxTaskMutationVariables>(MarkInboxTaskDocument, options);
      }
export type MarkInboxTaskMutationHookResult = ReturnType<typeof useMarkInboxTaskMutation>;
export type MarkInboxTaskMutationResult = Apollo.MutationResult<MarkInboxTaskMutation>;
export type MarkInboxTaskMutationOptions = Apollo.BaseMutationOptions<MarkInboxTaskMutation, MarkInboxTaskMutationVariables>;
export const CheckpointsDocument = gql`
    query Checkpoints($workspaceID: ID!) {
  workspace(id: $workspaceID) {
    id
    checkpoints {
      id
      key
      completedAt
    }
  }
}
    `;

/**
 * __useCheckpointsQuery__
 *
 * To run a query within a React component, call `useCheckpointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckpointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckpointsQuery({
 *   variables: {
 *      workspaceID: // value for 'workspaceID'
 *   },
 * });
 */
export function useCheckpointsQuery(baseOptions: Apollo.QueryHookOptions<CheckpointsQuery, CheckpointsQueryVariables> & ({ variables: CheckpointsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckpointsQuery, CheckpointsQueryVariables>(CheckpointsDocument, options);
      }
export function useCheckpointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckpointsQuery, CheckpointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckpointsQuery, CheckpointsQueryVariables>(CheckpointsDocument, options);
        }
// @ts-ignore
export function useCheckpointsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckpointsQuery, CheckpointsQueryVariables>): Apollo.UseSuspenseQueryResult<CheckpointsQuery, CheckpointsQueryVariables>;
export function useCheckpointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckpointsQuery, CheckpointsQueryVariables>): Apollo.UseSuspenseQueryResult<CheckpointsQuery | undefined, CheckpointsQueryVariables>;
export function useCheckpointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckpointsQuery, CheckpointsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckpointsQuery, CheckpointsQueryVariables>(CheckpointsDocument, options);
        }
export type CheckpointsQueryHookResult = ReturnType<typeof useCheckpointsQuery>;
export type CheckpointsLazyQueryHookResult = ReturnType<typeof useCheckpointsLazyQuery>;
export type CheckpointsSuspenseQueryHookResult = ReturnType<typeof useCheckpointsSuspenseQuery>;
export type CheckpointsQueryResult = Apollo.QueryResult<CheckpointsQuery, CheckpointsQueryVariables>;
export const InboxTasksDocument = gql`
    query InboxTasks {
  viewer {
    id
    inboxTasks {
      id
      type
      status
      createdAt
      seen
      evaluationSubmission {
        id
        deadline
        evaluationForm {
          title
        }
        employee {
          user {
            id
            firstName
            lastName
          }
          requiresInput
          status
          viewerCanSign
        }
        manager {
          user {
            id
            firstName
            lastName
          }
          requiresInput
          status
          viewerCanSign
        }
        moment {
          momentTemplate {
            title
          }
        }
      }
      feedbackResponse {
        id
        title
        dueDate
        requestor {
          id
          firstName
          lastName
        }
      }
      moment {
        id
        endDate
        momentTemplate {
          title
          description
          type
          talentReview {
            template {
              id
            }
            group {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useInboxTasksQuery__
 *
 * To run a query within a React component, call `useInboxTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useInboxTasksQuery(baseOptions?: Apollo.QueryHookOptions<InboxTasksQuery, InboxTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxTasksQuery, InboxTasksQueryVariables>(InboxTasksDocument, options);
      }
export function useInboxTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxTasksQuery, InboxTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxTasksQuery, InboxTasksQueryVariables>(InboxTasksDocument, options);
        }
// @ts-ignore
export function useInboxTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InboxTasksQuery, InboxTasksQueryVariables>): Apollo.UseSuspenseQueryResult<InboxTasksQuery, InboxTasksQueryVariables>;
export function useInboxTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InboxTasksQuery, InboxTasksQueryVariables>): Apollo.UseSuspenseQueryResult<InboxTasksQuery | undefined, InboxTasksQueryVariables>;
export function useInboxTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InboxTasksQuery, InboxTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InboxTasksQuery, InboxTasksQueryVariables>(InboxTasksDocument, options);
        }
export type InboxTasksQueryHookResult = ReturnType<typeof useInboxTasksQuery>;
export type InboxTasksLazyQueryHookResult = ReturnType<typeof useInboxTasksLazyQuery>;
export type InboxTasksSuspenseQueryHookResult = ReturnType<typeof useInboxTasksSuspenseQuery>;
export type InboxTasksQueryResult = Apollo.QueryResult<InboxTasksQuery, InboxTasksQueryVariables>;
export const ManagerInboxDocument = gql`
    query ManagerInbox($recurse: Boolean!) {
  viewer {
    managees(recurse: $recurse) {
      id
      firstName
      lastName
      avatar {
        source {
          url
        }
      }
    }
  }
}
    `;

/**
 * __useManagerInboxQuery__
 *
 * To run a query within a React component, call `useManagerInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagerInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagerInboxQuery({
 *   variables: {
 *      recurse: // value for 'recurse'
 *   },
 * });
 */
export function useManagerInboxQuery(baseOptions: Apollo.QueryHookOptions<ManagerInboxQuery, ManagerInboxQueryVariables> & ({ variables: ManagerInboxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagerInboxQuery, ManagerInboxQueryVariables>(ManagerInboxDocument, options);
      }
export function useManagerInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagerInboxQuery, ManagerInboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagerInboxQuery, ManagerInboxQueryVariables>(ManagerInboxDocument, options);
        }
// @ts-ignore
export function useManagerInboxSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ManagerInboxQuery, ManagerInboxQueryVariables>): Apollo.UseSuspenseQueryResult<ManagerInboxQuery, ManagerInboxQueryVariables>;
export function useManagerInboxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ManagerInboxQuery, ManagerInboxQueryVariables>): Apollo.UseSuspenseQueryResult<ManagerInboxQuery | undefined, ManagerInboxQueryVariables>;
export function useManagerInboxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ManagerInboxQuery, ManagerInboxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ManagerInboxQuery, ManagerInboxQueryVariables>(ManagerInboxDocument, options);
        }
export type ManagerInboxQueryHookResult = ReturnType<typeof useManagerInboxQuery>;
export type ManagerInboxLazyQueryHookResult = ReturnType<typeof useManagerInboxLazyQuery>;
export type ManagerInboxSuspenseQueryHookResult = ReturnType<typeof useManagerInboxSuspenseQuery>;
export type ManagerInboxQueryResult = Apollo.QueryResult<ManagerInboxQuery, ManagerInboxQueryVariables>;
export const ManagerInboxCsvExportDocument = gql`
    query ManagerInboxCsvExport($ids: [ID!]!, $startDate: DateTime!, $endDate: DateTime!) {
  usersByIDs(ids: $ids) {
    id
    username
    firstName
    lastName
    group {
      id
      name
    }
    currentJobPosition {
      id
      jobTitle {
        id
        title
      }
    }
    moments(after: $startDate, before: $endDate) {
      id
      user {
        id
      }
      status
      startDate
      endDate
      cycleInstance {
        id
      }
      cycleTemplate {
        id
        title
      }
      momentTemplate {
        id
        title
        type
        duration
        evaluation {
          evaluationForm {
            id
            title
          }
        }
      }
      goals {
        id
        status
        progress
      }
      feedbackRequest {
        id
        responses(first: 1000) {
          edges {
            node {
              id
              status
            }
          }
        }
      }
      evaluation {
        id
        evaluationForm {
          title
        }
        employee {
          status
        }
        manager {
          status
          requiresSignature
          user {
            firstName
            lastName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useManagerInboxCsvExportQuery__
 *
 * To run a query within a React component, call `useManagerInboxCsvExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagerInboxCsvExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagerInboxCsvExportQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useManagerInboxCsvExportQuery(baseOptions: Apollo.QueryHookOptions<ManagerInboxCsvExportQuery, ManagerInboxCsvExportQueryVariables> & ({ variables: ManagerInboxCsvExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagerInboxCsvExportQuery, ManagerInboxCsvExportQueryVariables>(ManagerInboxCsvExportDocument, options);
      }
export function useManagerInboxCsvExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagerInboxCsvExportQuery, ManagerInboxCsvExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagerInboxCsvExportQuery, ManagerInboxCsvExportQueryVariables>(ManagerInboxCsvExportDocument, options);
        }
// @ts-ignore
export function useManagerInboxCsvExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ManagerInboxCsvExportQuery, ManagerInboxCsvExportQueryVariables>): Apollo.UseSuspenseQueryResult<ManagerInboxCsvExportQuery, ManagerInboxCsvExportQueryVariables>;
export function useManagerInboxCsvExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ManagerInboxCsvExportQuery, ManagerInboxCsvExportQueryVariables>): Apollo.UseSuspenseQueryResult<ManagerInboxCsvExportQuery | undefined, ManagerInboxCsvExportQueryVariables>;
export function useManagerInboxCsvExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ManagerInboxCsvExportQuery, ManagerInboxCsvExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ManagerInboxCsvExportQuery, ManagerInboxCsvExportQueryVariables>(ManagerInboxCsvExportDocument, options);
        }
export type ManagerInboxCsvExportQueryHookResult = ReturnType<typeof useManagerInboxCsvExportQuery>;
export type ManagerInboxCsvExportLazyQueryHookResult = ReturnType<typeof useManagerInboxCsvExportLazyQuery>;
export type ManagerInboxCsvExportSuspenseQueryHookResult = ReturnType<typeof useManagerInboxCsvExportSuspenseQuery>;
export type ManagerInboxCsvExportQueryResult = Apollo.QueryResult<ManagerInboxCsvExportQuery, ManagerInboxCsvExportQueryVariables>;
export const ManagerInboxDetailDocument = gql`
    query ManagerInboxDetail($ids: [ID!]!) {
  usersByIDs(ids: $ids) {
    id
    firstName
    lastName
    avatar {
      source {
        url
      }
    }
    currentJobPosition {
      id
      jobTitle {
        id
        title
      }
    }
    moments {
      id
      user {
        id
      }
      status
      startDate
      endDate
      skipReason
      skipReasonOther
      cycleInstance {
        id
      }
      cycleTemplate {
        id
        title
      }
      momentTemplate {
        id
        title
        type
        duration
        original {
          id
        }
        showToUser
        talentReview {
          template {
            id
          }
          group {
            id
          }
        }
      }
      evaluation {
        id
        viewer {
          status
          requiresSignature
        }
      }
    }
    cycles {
      edges {
        node {
          id
          startDate
          activatesAt
          deactivatesAt
          cycleTemplate {
            id
            title
            repeats
            duration
            successor {
              id
            }
            moments {
              id
              title
              startOffset
              type
              duration
              showToUser
            }
          }
          precededBy {
            id
          }
          succeededBy {
            id
          }
          skippedFutureMoments {
            momentTemplateID
            skipReason
            skipReasonOther
          }
        }
      }
    }
  }
}
    `;

/**
 * __useManagerInboxDetailQuery__
 *
 * To run a query within a React component, call `useManagerInboxDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagerInboxDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagerInboxDetailQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useManagerInboxDetailQuery(baseOptions: Apollo.QueryHookOptions<ManagerInboxDetailQuery, ManagerInboxDetailQueryVariables> & ({ variables: ManagerInboxDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagerInboxDetailQuery, ManagerInboxDetailQueryVariables>(ManagerInboxDetailDocument, options);
      }
export function useManagerInboxDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagerInboxDetailQuery, ManagerInboxDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagerInboxDetailQuery, ManagerInboxDetailQueryVariables>(ManagerInboxDetailDocument, options);
        }
// @ts-ignore
export function useManagerInboxDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ManagerInboxDetailQuery, ManagerInboxDetailQueryVariables>): Apollo.UseSuspenseQueryResult<ManagerInboxDetailQuery, ManagerInboxDetailQueryVariables>;
export function useManagerInboxDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ManagerInboxDetailQuery, ManagerInboxDetailQueryVariables>): Apollo.UseSuspenseQueryResult<ManagerInboxDetailQuery | undefined, ManagerInboxDetailQueryVariables>;
export function useManagerInboxDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ManagerInboxDetailQuery, ManagerInboxDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ManagerInboxDetailQuery, ManagerInboxDetailQueryVariables>(ManagerInboxDetailDocument, options);
        }
export type ManagerInboxDetailQueryHookResult = ReturnType<typeof useManagerInboxDetailQuery>;
export type ManagerInboxDetailLazyQueryHookResult = ReturnType<typeof useManagerInboxDetailLazyQuery>;
export type ManagerInboxDetailSuspenseQueryHookResult = ReturnType<typeof useManagerInboxDetailSuspenseQuery>;
export type ManagerInboxDetailQueryResult = Apollo.QueryResult<ManagerInboxDetailQuery, ManagerInboxDetailQueryVariables>;
export const ArchiveJobPositionDocument = gql`
    mutation ArchiveJobPosition($input: ArchiveJobPositionInput!) {
  archiveJobPosition(input: $input) {
    jobPosition {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveJobPositionMutationFn = Apollo.MutationFunction<ArchiveJobPositionMutation, ArchiveJobPositionMutationVariables>;

/**
 * __useArchiveJobPositionMutation__
 *
 * To run a mutation, you first call `useArchiveJobPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveJobPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveJobPositionMutation, { data, loading, error }] = useArchiveJobPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveJobPositionMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveJobPositionMutation, ArchiveJobPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveJobPositionMutation, ArchiveJobPositionMutationVariables>(ArchiveJobPositionDocument, options);
      }
export type ArchiveJobPositionMutationHookResult = ReturnType<typeof useArchiveJobPositionMutation>;
export type ArchiveJobPositionMutationResult = Apollo.MutationResult<ArchiveJobPositionMutation>;
export type ArchiveJobPositionMutationOptions = Apollo.BaseMutationOptions<ArchiveJobPositionMutation, ArchiveJobPositionMutationVariables>;
export const ArchiveJobPositionSuccessorDocument = gql`
    mutation ArchiveJobPositionSuccessor($input: ArchiveJobPositionSuccessorInput!) {
  archiveJobPositionSuccessor(input: $input) {
    successor {
      id
      viewerCanArchive
    }
  }
}
    `;
export type ArchiveJobPositionSuccessorMutationFn = Apollo.MutationFunction<ArchiveJobPositionSuccessorMutation, ArchiveJobPositionSuccessorMutationVariables>;

/**
 * __useArchiveJobPositionSuccessorMutation__
 *
 * To run a mutation, you first call `useArchiveJobPositionSuccessorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveJobPositionSuccessorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveJobPositionSuccessorMutation, { data, loading, error }] = useArchiveJobPositionSuccessorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveJobPositionSuccessorMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveJobPositionSuccessorMutation, ArchiveJobPositionSuccessorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveJobPositionSuccessorMutation, ArchiveJobPositionSuccessorMutationVariables>(ArchiveJobPositionSuccessorDocument, options);
      }
export type ArchiveJobPositionSuccessorMutationHookResult = ReturnType<typeof useArchiveJobPositionSuccessorMutation>;
export type ArchiveJobPositionSuccessorMutationResult = Apollo.MutationResult<ArchiveJobPositionSuccessorMutation>;
export type ArchiveJobPositionSuccessorMutationOptions = Apollo.BaseMutationOptions<ArchiveJobPositionSuccessorMutation, ArchiveJobPositionSuccessorMutationVariables>;
export const ArchiveJobTitleDocument = gql`
    mutation ArchiveJobTitle($input: ArchiveJobTitleInput!) {
  archiveJobTitle(input: $input) {
    jobTitle {
      ...JobTitle
    }
  }
}
    ${JobTitleFragmentDoc}`;
export type ArchiveJobTitleMutationFn = Apollo.MutationFunction<ArchiveJobTitleMutation, ArchiveJobTitleMutationVariables>;

/**
 * __useArchiveJobTitleMutation__
 *
 * To run a mutation, you first call `useArchiveJobTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveJobTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveJobTitleMutation, { data, loading, error }] = useArchiveJobTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveJobTitleMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveJobTitleMutation, ArchiveJobTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveJobTitleMutation, ArchiveJobTitleMutationVariables>(ArchiveJobTitleDocument, options);
      }
export type ArchiveJobTitleMutationHookResult = ReturnType<typeof useArchiveJobTitleMutation>;
export type ArchiveJobTitleMutationResult = Apollo.MutationResult<ArchiveJobTitleMutation>;
export type ArchiveJobTitleMutationOptions = Apollo.BaseMutationOptions<ArchiveJobTitleMutation, ArchiveJobTitleMutationVariables>;
export const CreateJobPositionDocument = gql`
    mutation CreateJobPosition($input: CreateJobPositionInput!) {
  createJobPosition(input: $input) {
    jobPosition {
      id
    }
  }
}
    `;
export type CreateJobPositionMutationFn = Apollo.MutationFunction<CreateJobPositionMutation, CreateJobPositionMutationVariables>;

/**
 * __useCreateJobPositionMutation__
 *
 * To run a mutation, you first call `useCreateJobPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobPositionMutation, { data, loading, error }] = useCreateJobPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobPositionMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobPositionMutation, CreateJobPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobPositionMutation, CreateJobPositionMutationVariables>(CreateJobPositionDocument, options);
      }
export type CreateJobPositionMutationHookResult = ReturnType<typeof useCreateJobPositionMutation>;
export type CreateJobPositionMutationResult = Apollo.MutationResult<CreateJobPositionMutation>;
export type CreateJobPositionMutationOptions = Apollo.BaseMutationOptions<CreateJobPositionMutation, CreateJobPositionMutationVariables>;
export const CreateJobTitleDocument = gql`
    mutation CreateJobTitle($input: CreateJobTitleInput!) {
  createJobTitle(input: $input) {
    jobTitle {
      ...JobTitle
    }
  }
}
    ${JobTitleFragmentDoc}`;
export type CreateJobTitleMutationFn = Apollo.MutationFunction<CreateJobTitleMutation, CreateJobTitleMutationVariables>;

/**
 * __useCreateJobTitleMutation__
 *
 * To run a mutation, you first call `useCreateJobTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobTitleMutation, { data, loading, error }] = useCreateJobTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobTitleMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobTitleMutation, CreateJobTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobTitleMutation, CreateJobTitleMutationVariables>(CreateJobTitleDocument, options);
      }
export type CreateJobTitleMutationHookResult = ReturnType<typeof useCreateJobTitleMutation>;
export type CreateJobTitleMutationResult = Apollo.MutationResult<CreateJobTitleMutation>;
export type CreateJobTitleMutationOptions = Apollo.BaseMutationOptions<CreateJobTitleMutation, CreateJobTitleMutationVariables>;
export const NominateJobPositionSuccessorDocument = gql`
    mutation NominateJobPositionSuccessor($input: NominateJobPositionSuccessorInput!) {
  nominateJobPositionSuccessor(input: $input) {
    successor {
      ...JobPositionSuccessor
    }
  }
}
    ${JobPositionSuccessorFragmentDoc}`;
export type NominateJobPositionSuccessorMutationFn = Apollo.MutationFunction<NominateJobPositionSuccessorMutation, NominateJobPositionSuccessorMutationVariables>;

/**
 * __useNominateJobPositionSuccessorMutation__
 *
 * To run a mutation, you first call `useNominateJobPositionSuccessorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNominateJobPositionSuccessorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nominateJobPositionSuccessorMutation, { data, loading, error }] = useNominateJobPositionSuccessorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNominateJobPositionSuccessorMutation(baseOptions?: Apollo.MutationHookOptions<NominateJobPositionSuccessorMutation, NominateJobPositionSuccessorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NominateJobPositionSuccessorMutation, NominateJobPositionSuccessorMutationVariables>(NominateJobPositionSuccessorDocument, options);
      }
export type NominateJobPositionSuccessorMutationHookResult = ReturnType<typeof useNominateJobPositionSuccessorMutation>;
export type NominateJobPositionSuccessorMutationResult = Apollo.MutationResult<NominateJobPositionSuccessorMutation>;
export type NominateJobPositionSuccessorMutationOptions = Apollo.BaseMutationOptions<NominateJobPositionSuccessorMutation, NominateJobPositionSuccessorMutationVariables>;
export const RestoreJobPositionDocument = gql`
    mutation RestoreJobPosition($input: RestoreJobPositionInput!) {
  restoreJobPosition(input: $input) {
    jobPosition {
      id
      isArchived
    }
  }
}
    `;
export type RestoreJobPositionMutationFn = Apollo.MutationFunction<RestoreJobPositionMutation, RestoreJobPositionMutationVariables>;

/**
 * __useRestoreJobPositionMutation__
 *
 * To run a mutation, you first call `useRestoreJobPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreJobPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreJobPositionMutation, { data, loading, error }] = useRestoreJobPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreJobPositionMutation(baseOptions?: Apollo.MutationHookOptions<RestoreJobPositionMutation, RestoreJobPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreJobPositionMutation, RestoreJobPositionMutationVariables>(RestoreJobPositionDocument, options);
      }
export type RestoreJobPositionMutationHookResult = ReturnType<typeof useRestoreJobPositionMutation>;
export type RestoreJobPositionMutationResult = Apollo.MutationResult<RestoreJobPositionMutation>;
export type RestoreJobPositionMutationOptions = Apollo.BaseMutationOptions<RestoreJobPositionMutation, RestoreJobPositionMutationVariables>;
export const RestoreJobTitleDocument = gql`
    mutation RestoreJobTitle($input: RestoreJobTitleInput!) {
  restoreJobTitle(input: $input) {
    jobTitle {
      ...JobTitle
    }
  }
}
    ${JobTitleFragmentDoc}`;
export type RestoreJobTitleMutationFn = Apollo.MutationFunction<RestoreJobTitleMutation, RestoreJobTitleMutationVariables>;

/**
 * __useRestoreJobTitleMutation__
 *
 * To run a mutation, you first call `useRestoreJobTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreJobTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreJobTitleMutation, { data, loading, error }] = useRestoreJobTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreJobTitleMutation(baseOptions?: Apollo.MutationHookOptions<RestoreJobTitleMutation, RestoreJobTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreJobTitleMutation, RestoreJobTitleMutationVariables>(RestoreJobTitleDocument, options);
      }
export type RestoreJobTitleMutationHookResult = ReturnType<typeof useRestoreJobTitleMutation>;
export type RestoreJobTitleMutationResult = Apollo.MutationResult<RestoreJobTitleMutation>;
export type RestoreJobTitleMutationOptions = Apollo.BaseMutationOptions<RestoreJobTitleMutation, RestoreJobTitleMutationVariables>;
export const SetJobTitleKeyPositionDocument = gql`
    mutation SetJobTitleKeyPosition($input: SetJobTitleKeyPositionInput!) {
  setJobTitleKeyPosition(input: $input) {
    jobTitle {
      id
      isKeyPosition
      keyPositionMarkedAt
      keyPositionMarkedBy {
        id
        firstName
        lastName
      }
      viewerCanManageSuccession
    }
  }
}
    `;
export type SetJobTitleKeyPositionMutationFn = Apollo.MutationFunction<SetJobTitleKeyPositionMutation, SetJobTitleKeyPositionMutationVariables>;

/**
 * __useSetJobTitleKeyPositionMutation__
 *
 * To run a mutation, you first call `useSetJobTitleKeyPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetJobTitleKeyPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setJobTitleKeyPositionMutation, { data, loading, error }] = useSetJobTitleKeyPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetJobTitleKeyPositionMutation(baseOptions?: Apollo.MutationHookOptions<SetJobTitleKeyPositionMutation, SetJobTitleKeyPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetJobTitleKeyPositionMutation, SetJobTitleKeyPositionMutationVariables>(SetJobTitleKeyPositionDocument, options);
      }
export type SetJobTitleKeyPositionMutationHookResult = ReturnType<typeof useSetJobTitleKeyPositionMutation>;
export type SetJobTitleKeyPositionMutationResult = Apollo.MutationResult<SetJobTitleKeyPositionMutation>;
export type SetJobTitleKeyPositionMutationOptions = Apollo.BaseMutationOptions<SetJobTitleKeyPositionMutation, SetJobTitleKeyPositionMutationVariables>;
export const UpdateJobPositionDocument = gql`
    mutation UpdateJobPosition($input: UpdateJobPositionInput!) {
  updateJobPosition(input: $input) {
    jobPosition {
      id
      endDate
    }
  }
}
    `;
export type UpdateJobPositionMutationFn = Apollo.MutationFunction<UpdateJobPositionMutation, UpdateJobPositionMutationVariables>;

/**
 * __useUpdateJobPositionMutation__
 *
 * To run a mutation, you first call `useUpdateJobPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobPositionMutation, { data, loading, error }] = useUpdateJobPositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobPositionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobPositionMutation, UpdateJobPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobPositionMutation, UpdateJobPositionMutationVariables>(UpdateJobPositionDocument, options);
      }
export type UpdateJobPositionMutationHookResult = ReturnType<typeof useUpdateJobPositionMutation>;
export type UpdateJobPositionMutationResult = Apollo.MutationResult<UpdateJobPositionMutation>;
export type UpdateJobPositionMutationOptions = Apollo.BaseMutationOptions<UpdateJobPositionMutation, UpdateJobPositionMutationVariables>;
export const UpdateJobPositionSuccessorDocument = gql`
    mutation UpdateJobPositionSuccessor($input: UpdateJobPositionSuccessorInput!) {
  updateJobPositionSuccessor(input: $input) {
    successor {
      ...JobPositionSuccessor
    }
  }
}
    ${JobPositionSuccessorFragmentDoc}`;
export type UpdateJobPositionSuccessorMutationFn = Apollo.MutationFunction<UpdateJobPositionSuccessorMutation, UpdateJobPositionSuccessorMutationVariables>;

/**
 * __useUpdateJobPositionSuccessorMutation__
 *
 * To run a mutation, you first call `useUpdateJobPositionSuccessorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobPositionSuccessorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobPositionSuccessorMutation, { data, loading, error }] = useUpdateJobPositionSuccessorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobPositionSuccessorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobPositionSuccessorMutation, UpdateJobPositionSuccessorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobPositionSuccessorMutation, UpdateJobPositionSuccessorMutationVariables>(UpdateJobPositionSuccessorDocument, options);
      }
export type UpdateJobPositionSuccessorMutationHookResult = ReturnType<typeof useUpdateJobPositionSuccessorMutation>;
export type UpdateJobPositionSuccessorMutationResult = Apollo.MutationResult<UpdateJobPositionSuccessorMutation>;
export type UpdateJobPositionSuccessorMutationOptions = Apollo.BaseMutationOptions<UpdateJobPositionSuccessorMutation, UpdateJobPositionSuccessorMutationVariables>;
export const UpdateJobTitleDocument = gql`
    mutation UpdateJobTitle($input: UpdateJobTitleInput!) {
  updateJobTitle(input: $input) {
    jobTitle {
      ...JobTitle
    }
  }
}
    ${JobTitleFragmentDoc}`;
export type UpdateJobTitleMutationFn = Apollo.MutationFunction<UpdateJobTitleMutation, UpdateJobTitleMutationVariables>;

/**
 * __useUpdateJobTitleMutation__
 *
 * To run a mutation, you first call `useUpdateJobTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobTitleMutation, { data, loading, error }] = useUpdateJobTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobTitleMutation, UpdateJobTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobTitleMutation, UpdateJobTitleMutationVariables>(UpdateJobTitleDocument, options);
      }
export type UpdateJobTitleMutationHookResult = ReturnType<typeof useUpdateJobTitleMutation>;
export type UpdateJobTitleMutationResult = Apollo.MutationResult<UpdateJobTitleMutation>;
export type UpdateJobTitleMutationOptions = Apollo.BaseMutationOptions<UpdateJobTitleMutation, UpdateJobTitleMutationVariables>;
export const ConnectorDryRunJobTitlesDocument = gql`
    query ConnectorDryRunJobTitles($first: Int, $after: ID, $last: Int, $before: ID) {
  viewer {
    workspace {
      connector {
        id
        dryRun {
          jobTitles(first: $first, after: $after, last: $last, before: $before) {
            edges {
              node {
                title
                externalReferenceID
              }
              cursor
            }
            pageInfo {
              startCursor
              endCursor
              hasNextPage
              hasPreviousPage
            }
            totalCount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useConnectorDryRunJobTitlesQuery__
 *
 * To run a query within a React component, call `useConnectorDryRunJobTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectorDryRunJobTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectorDryRunJobTitlesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useConnectorDryRunJobTitlesQuery(baseOptions?: Apollo.QueryHookOptions<ConnectorDryRunJobTitlesQuery, ConnectorDryRunJobTitlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectorDryRunJobTitlesQuery, ConnectorDryRunJobTitlesQueryVariables>(ConnectorDryRunJobTitlesDocument, options);
      }
export function useConnectorDryRunJobTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectorDryRunJobTitlesQuery, ConnectorDryRunJobTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectorDryRunJobTitlesQuery, ConnectorDryRunJobTitlesQueryVariables>(ConnectorDryRunJobTitlesDocument, options);
        }
// @ts-ignore
export function useConnectorDryRunJobTitlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectorDryRunJobTitlesQuery, ConnectorDryRunJobTitlesQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorDryRunJobTitlesQuery, ConnectorDryRunJobTitlesQueryVariables>;
export function useConnectorDryRunJobTitlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorDryRunJobTitlesQuery, ConnectorDryRunJobTitlesQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorDryRunJobTitlesQuery | undefined, ConnectorDryRunJobTitlesQueryVariables>;
export function useConnectorDryRunJobTitlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorDryRunJobTitlesQuery, ConnectorDryRunJobTitlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectorDryRunJobTitlesQuery, ConnectorDryRunJobTitlesQueryVariables>(ConnectorDryRunJobTitlesDocument, options);
        }
export type ConnectorDryRunJobTitlesQueryHookResult = ReturnType<typeof useConnectorDryRunJobTitlesQuery>;
export type ConnectorDryRunJobTitlesLazyQueryHookResult = ReturnType<typeof useConnectorDryRunJobTitlesLazyQuery>;
export type ConnectorDryRunJobTitlesSuspenseQueryHookResult = ReturnType<typeof useConnectorDryRunJobTitlesSuspenseQuery>;
export type ConnectorDryRunJobTitlesQueryResult = Apollo.QueryResult<ConnectorDryRunJobTitlesQuery, ConnectorDryRunJobTitlesQueryVariables>;
export const JobPositionDocument = gql`
    query JobPosition($id: ID!) {
  jobPosition(id: $id) {
    id
    jobTitle {
      id
      title
      description
      isKeyPosition
      keyPositionMarkedAt
      keyPositionMarkedBy {
        id
        firstName
        lastName
      }
      viewerCanManageSuccession
    }
    jobLevel {
      id
      title
      description
    }
    competencies {
      ...JobCompetency
    }
    startDate
    endDate
    isArchived
  }
}
    ${JobCompetencyFragmentDoc}`;

/**
 * __useJobPositionQuery__
 *
 * To run a query within a React component, call `useJobPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobPositionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobPositionQuery(baseOptions: Apollo.QueryHookOptions<JobPositionQuery, JobPositionQueryVariables> & ({ variables: JobPositionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobPositionQuery, JobPositionQueryVariables>(JobPositionDocument, options);
      }
export function useJobPositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobPositionQuery, JobPositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobPositionQuery, JobPositionQueryVariables>(JobPositionDocument, options);
        }
// @ts-ignore
export function useJobPositionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobPositionQuery, JobPositionQueryVariables>): Apollo.UseSuspenseQueryResult<JobPositionQuery, JobPositionQueryVariables>;
export function useJobPositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobPositionQuery, JobPositionQueryVariables>): Apollo.UseSuspenseQueryResult<JobPositionQuery | undefined, JobPositionQueryVariables>;
export function useJobPositionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobPositionQuery, JobPositionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobPositionQuery, JobPositionQueryVariables>(JobPositionDocument, options);
        }
export type JobPositionQueryHookResult = ReturnType<typeof useJobPositionQuery>;
export type JobPositionLazyQueryHookResult = ReturnType<typeof useJobPositionLazyQuery>;
export type JobPositionSuspenseQueryHookResult = ReturnType<typeof useJobPositionSuspenseQuery>;
export type JobPositionQueryResult = Apollo.QueryResult<JobPositionQuery, JobPositionQueryVariables>;
export const JobPositionSuccessorsDocument = gql`
    query JobPositionSuccessors($jobTitleID: ID!) {
  jobPositionSuccessors(jobTitleID: $jobTitleID) {
    ...JobPositionSuccessor
  }
}
    ${JobPositionSuccessorFragmentDoc}`;

/**
 * __useJobPositionSuccessorsQuery__
 *
 * To run a query within a React component, call `useJobPositionSuccessorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobPositionSuccessorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobPositionSuccessorsQuery({
 *   variables: {
 *      jobTitleID: // value for 'jobTitleID'
 *   },
 * });
 */
export function useJobPositionSuccessorsQuery(baseOptions: Apollo.QueryHookOptions<JobPositionSuccessorsQuery, JobPositionSuccessorsQueryVariables> & ({ variables: JobPositionSuccessorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobPositionSuccessorsQuery, JobPositionSuccessorsQueryVariables>(JobPositionSuccessorsDocument, options);
      }
export function useJobPositionSuccessorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobPositionSuccessorsQuery, JobPositionSuccessorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobPositionSuccessorsQuery, JobPositionSuccessorsQueryVariables>(JobPositionSuccessorsDocument, options);
        }
// @ts-ignore
export function useJobPositionSuccessorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobPositionSuccessorsQuery, JobPositionSuccessorsQueryVariables>): Apollo.UseSuspenseQueryResult<JobPositionSuccessorsQuery, JobPositionSuccessorsQueryVariables>;
export function useJobPositionSuccessorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobPositionSuccessorsQuery, JobPositionSuccessorsQueryVariables>): Apollo.UseSuspenseQueryResult<JobPositionSuccessorsQuery | undefined, JobPositionSuccessorsQueryVariables>;
export function useJobPositionSuccessorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobPositionSuccessorsQuery, JobPositionSuccessorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobPositionSuccessorsQuery, JobPositionSuccessorsQueryVariables>(JobPositionSuccessorsDocument, options);
        }
export type JobPositionSuccessorsQueryHookResult = ReturnType<typeof useJobPositionSuccessorsQuery>;
export type JobPositionSuccessorsLazyQueryHookResult = ReturnType<typeof useJobPositionSuccessorsLazyQuery>;
export type JobPositionSuccessorsSuspenseQueryHookResult = ReturnType<typeof useJobPositionSuccessorsSuspenseQuery>;
export type JobPositionSuccessorsQueryResult = Apollo.QueryResult<JobPositionSuccessorsQuery, JobPositionSuccessorsQueryVariables>;
export const JobPositionsDocument = gql`
    query JobPositions($id: ID!, $status: JobPositionStatus) {
  user(id: $id) {
    id
    firstName
    jobPositions(status: $status) {
      id
      jobTitle {
        id
        title
        description
        isArchived
      }
      jobLevel {
        id
        title
        description
        isArchived
      }
      startDate
      endDate
      externalReferenceID
      isArchived
    }
  }
}
    `;

/**
 * __useJobPositionsQuery__
 *
 * To run a query within a React component, call `useJobPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobPositionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useJobPositionsQuery(baseOptions: Apollo.QueryHookOptions<JobPositionsQuery, JobPositionsQueryVariables> & ({ variables: JobPositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobPositionsQuery, JobPositionsQueryVariables>(JobPositionsDocument, options);
      }
export function useJobPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobPositionsQuery, JobPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobPositionsQuery, JobPositionsQueryVariables>(JobPositionsDocument, options);
        }
// @ts-ignore
export function useJobPositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobPositionsQuery, JobPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<JobPositionsQuery, JobPositionsQueryVariables>;
export function useJobPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobPositionsQuery, JobPositionsQueryVariables>): Apollo.UseSuspenseQueryResult<JobPositionsQuery | undefined, JobPositionsQueryVariables>;
export function useJobPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobPositionsQuery, JobPositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobPositionsQuery, JobPositionsQueryVariables>(JobPositionsDocument, options);
        }
export type JobPositionsQueryHookResult = ReturnType<typeof useJobPositionsQuery>;
export type JobPositionsLazyQueryHookResult = ReturnType<typeof useJobPositionsLazyQuery>;
export type JobPositionsSuspenseQueryHookResult = ReturnType<typeof useJobPositionsSuspenseQuery>;
export type JobPositionsQueryResult = Apollo.QueryResult<JobPositionsQuery, JobPositionsQueryVariables>;
export const JobPositionsSettingsDocument = gql`
    query JobPositionsSettings($status: UserStatus, $first: Int, $last: Int, $before: ID, $after: ID) {
  users(
    status: $status
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    edges {
      node {
        id
        firstName
        lastName
        lastLoginAt
        avatar {
          source {
            url
          }
        }
        jobPositions(status: ACTIVE) {
          id
          jobTitle {
            id
            title
          }
          startDate
          endDate
          externalReferenceID
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useJobPositionsSettingsQuery__
 *
 * To run a query within a React component, call `useJobPositionsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobPositionsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobPositionsSettingsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useJobPositionsSettingsQuery(baseOptions?: Apollo.QueryHookOptions<JobPositionsSettingsQuery, JobPositionsSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobPositionsSettingsQuery, JobPositionsSettingsQueryVariables>(JobPositionsSettingsDocument, options);
      }
export function useJobPositionsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobPositionsSettingsQuery, JobPositionsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobPositionsSettingsQuery, JobPositionsSettingsQueryVariables>(JobPositionsSettingsDocument, options);
        }
// @ts-ignore
export function useJobPositionsSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobPositionsSettingsQuery, JobPositionsSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<JobPositionsSettingsQuery, JobPositionsSettingsQueryVariables>;
export function useJobPositionsSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobPositionsSettingsQuery, JobPositionsSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<JobPositionsSettingsQuery | undefined, JobPositionsSettingsQueryVariables>;
export function useJobPositionsSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobPositionsSettingsQuery, JobPositionsSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobPositionsSettingsQuery, JobPositionsSettingsQueryVariables>(JobPositionsSettingsDocument, options);
        }
export type JobPositionsSettingsQueryHookResult = ReturnType<typeof useJobPositionsSettingsQuery>;
export type JobPositionsSettingsLazyQueryHookResult = ReturnType<typeof useJobPositionsSettingsLazyQuery>;
export type JobPositionsSettingsSuspenseQueryHookResult = ReturnType<typeof useJobPositionsSettingsSuspenseQuery>;
export type JobPositionsSettingsQueryResult = Apollo.QueryResult<JobPositionsSettingsQuery, JobPositionsSettingsQueryVariables>;
export const JobTitleDocument = gql`
    query JobTitle($id: ID!) {
  jobTitle(id: $id) {
    ...JobTitle
  }
}
    ${JobTitleFragmentDoc}`;

/**
 * __useJobTitleQuery__
 *
 * To run a query within a React component, call `useJobTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobTitleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobTitleQuery(baseOptions: Apollo.QueryHookOptions<JobTitleQuery, JobTitleQueryVariables> & ({ variables: JobTitleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobTitleQuery, JobTitleQueryVariables>(JobTitleDocument, options);
      }
export function useJobTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobTitleQuery, JobTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobTitleQuery, JobTitleQueryVariables>(JobTitleDocument, options);
        }
// @ts-ignore
export function useJobTitleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobTitleQuery, JobTitleQueryVariables>): Apollo.UseSuspenseQueryResult<JobTitleQuery, JobTitleQueryVariables>;
export function useJobTitleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobTitleQuery, JobTitleQueryVariables>): Apollo.UseSuspenseQueryResult<JobTitleQuery | undefined, JobTitleQueryVariables>;
export function useJobTitleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobTitleQuery, JobTitleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobTitleQuery, JobTitleQueryVariables>(JobTitleDocument, options);
        }
export type JobTitleQueryHookResult = ReturnType<typeof useJobTitleQuery>;
export type JobTitleLazyQueryHookResult = ReturnType<typeof useJobTitleLazyQuery>;
export type JobTitleSuspenseQueryHookResult = ReturnType<typeof useJobTitleSuspenseQuery>;
export type JobTitleQueryResult = Apollo.QueryResult<JobTitleQuery, JobTitleQueryVariables>;
export const JobTitleCompetenciesDocument = gql`
    query JobTitleCompetencies($id: ID!, $userID: ID!) {
  jobTitle(id: $id) {
    ...JobTitleCompetenciesPartial
  }
}
    ${JobTitleCompetenciesPartialFragmentDoc}`;

/**
 * __useJobTitleCompetenciesQuery__
 *
 * To run a query within a React component, call `useJobTitleCompetenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobTitleCompetenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobTitleCompetenciesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useJobTitleCompetenciesQuery(baseOptions: Apollo.QueryHookOptions<JobTitleCompetenciesQuery, JobTitleCompetenciesQueryVariables> & ({ variables: JobTitleCompetenciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobTitleCompetenciesQuery, JobTitleCompetenciesQueryVariables>(JobTitleCompetenciesDocument, options);
      }
export function useJobTitleCompetenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobTitleCompetenciesQuery, JobTitleCompetenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobTitleCompetenciesQuery, JobTitleCompetenciesQueryVariables>(JobTitleCompetenciesDocument, options);
        }
// @ts-ignore
export function useJobTitleCompetenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobTitleCompetenciesQuery, JobTitleCompetenciesQueryVariables>): Apollo.UseSuspenseQueryResult<JobTitleCompetenciesQuery, JobTitleCompetenciesQueryVariables>;
export function useJobTitleCompetenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobTitleCompetenciesQuery, JobTitleCompetenciesQueryVariables>): Apollo.UseSuspenseQueryResult<JobTitleCompetenciesQuery | undefined, JobTitleCompetenciesQueryVariables>;
export function useJobTitleCompetenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobTitleCompetenciesQuery, JobTitleCompetenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobTitleCompetenciesQuery, JobTitleCompetenciesQueryVariables>(JobTitleCompetenciesDocument, options);
        }
export type JobTitleCompetenciesQueryHookResult = ReturnType<typeof useJobTitleCompetenciesQuery>;
export type JobTitleCompetenciesLazyQueryHookResult = ReturnType<typeof useJobTitleCompetenciesLazyQuery>;
export type JobTitleCompetenciesSuspenseQueryHookResult = ReturnType<typeof useJobTitleCompetenciesSuspenseQuery>;
export type JobTitleCompetenciesQueryResult = Apollo.QueryResult<JobTitleCompetenciesQuery, JobTitleCompetenciesQueryVariables>;
export const JobTitleSuccessorsDocument = gql`
    query JobTitleSuccessors {
  jobTitleSuccessors {
    jobTitle {
      id
      title
      isKeyPosition
      viewerCanManageSuccession
    }
    holders {
      id
      firstName
      lastName
      status
      avatar {
        source {
          url
        }
      }
    }
    successors {
      ...JobPositionSuccessor
    }
  }
}
    ${JobPositionSuccessorFragmentDoc}`;

/**
 * __useJobTitleSuccessorsQuery__
 *
 * To run a query within a React component, call `useJobTitleSuccessorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobTitleSuccessorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobTitleSuccessorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobTitleSuccessorsQuery(baseOptions?: Apollo.QueryHookOptions<JobTitleSuccessorsQuery, JobTitleSuccessorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobTitleSuccessorsQuery, JobTitleSuccessorsQueryVariables>(JobTitleSuccessorsDocument, options);
      }
export function useJobTitleSuccessorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobTitleSuccessorsQuery, JobTitleSuccessorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobTitleSuccessorsQuery, JobTitleSuccessorsQueryVariables>(JobTitleSuccessorsDocument, options);
        }
// @ts-ignore
export function useJobTitleSuccessorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobTitleSuccessorsQuery, JobTitleSuccessorsQueryVariables>): Apollo.UseSuspenseQueryResult<JobTitleSuccessorsQuery, JobTitleSuccessorsQueryVariables>;
export function useJobTitleSuccessorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobTitleSuccessorsQuery, JobTitleSuccessorsQueryVariables>): Apollo.UseSuspenseQueryResult<JobTitleSuccessorsQuery | undefined, JobTitleSuccessorsQueryVariables>;
export function useJobTitleSuccessorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobTitleSuccessorsQuery, JobTitleSuccessorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobTitleSuccessorsQuery, JobTitleSuccessorsQueryVariables>(JobTitleSuccessorsDocument, options);
        }
export type JobTitleSuccessorsQueryHookResult = ReturnType<typeof useJobTitleSuccessorsQuery>;
export type JobTitleSuccessorsLazyQueryHookResult = ReturnType<typeof useJobTitleSuccessorsLazyQuery>;
export type JobTitleSuccessorsSuspenseQueryHookResult = ReturnType<typeof useJobTitleSuccessorsSuspenseQuery>;
export type JobTitleSuccessorsQueryResult = Apollo.QueryResult<JobTitleSuccessorsQuery, JobTitleSuccessorsQueryVariables>;
export const JobTitlesDocument = gql`
    query JobTitles($isArchived: Boolean, $before: ID, $after: ID, $first: Int, $last: Int) {
  jobTitles(
    isArchived: $isArchived
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        id
        title
        description
        isArchived
        isKeyPosition
        styrData {
          jobID
          jobName
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useJobTitlesQuery__
 *
 * To run a query within a React component, call `useJobTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobTitlesQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useJobTitlesQuery(baseOptions?: Apollo.QueryHookOptions<JobTitlesQuery, JobTitlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobTitlesQuery, JobTitlesQueryVariables>(JobTitlesDocument, options);
      }
export function useJobTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobTitlesQuery, JobTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobTitlesQuery, JobTitlesQueryVariables>(JobTitlesDocument, options);
        }
// @ts-ignore
export function useJobTitlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobTitlesQuery, JobTitlesQueryVariables>): Apollo.UseSuspenseQueryResult<JobTitlesQuery, JobTitlesQueryVariables>;
export function useJobTitlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobTitlesQuery, JobTitlesQueryVariables>): Apollo.UseSuspenseQueryResult<JobTitlesQuery | undefined, JobTitlesQueryVariables>;
export function useJobTitlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobTitlesQuery, JobTitlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobTitlesQuery, JobTitlesQueryVariables>(JobTitlesDocument, options);
        }
export type JobTitlesQueryHookResult = ReturnType<typeof useJobTitlesQuery>;
export type JobTitlesLazyQueryHookResult = ReturnType<typeof useJobTitlesLazyQuery>;
export type JobTitlesSuspenseQueryHookResult = ReturnType<typeof useJobTitlesSuspenseQuery>;
export type JobTitlesQueryResult = Apollo.QueryResult<JobTitlesQuery, JobTitlesQueryVariables>;
export const MigrationJobTitlesDocument = gql`
    query MigrationJobTitles($isArchived: Boolean, $first: Int) {
  jobTitles(isArchived: $isArchived, first: $first) {
    edges {
      node {
        id
        title
        externalReferenceID
      }
    }
  }
}
    `;

/**
 * __useMigrationJobTitlesQuery__
 *
 * To run a query within a React component, call `useMigrationJobTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMigrationJobTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMigrationJobTitlesQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useMigrationJobTitlesQuery(baseOptions?: Apollo.QueryHookOptions<MigrationJobTitlesQuery, MigrationJobTitlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MigrationJobTitlesQuery, MigrationJobTitlesQueryVariables>(MigrationJobTitlesDocument, options);
      }
export function useMigrationJobTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MigrationJobTitlesQuery, MigrationJobTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MigrationJobTitlesQuery, MigrationJobTitlesQueryVariables>(MigrationJobTitlesDocument, options);
        }
// @ts-ignore
export function useMigrationJobTitlesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MigrationJobTitlesQuery, MigrationJobTitlesQueryVariables>): Apollo.UseSuspenseQueryResult<MigrationJobTitlesQuery, MigrationJobTitlesQueryVariables>;
export function useMigrationJobTitlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MigrationJobTitlesQuery, MigrationJobTitlesQueryVariables>): Apollo.UseSuspenseQueryResult<MigrationJobTitlesQuery | undefined, MigrationJobTitlesQueryVariables>;
export function useMigrationJobTitlesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MigrationJobTitlesQuery, MigrationJobTitlesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MigrationJobTitlesQuery, MigrationJobTitlesQueryVariables>(MigrationJobTitlesDocument, options);
        }
export type MigrationJobTitlesQueryHookResult = ReturnType<typeof useMigrationJobTitlesQuery>;
export type MigrationJobTitlesLazyQueryHookResult = ReturnType<typeof useMigrationJobTitlesLazyQuery>;
export type MigrationJobTitlesSuspenseQueryHookResult = ReturnType<typeof useMigrationJobTitlesSuspenseQuery>;
export type MigrationJobTitlesQueryResult = Apollo.QueryResult<MigrationJobTitlesQuery, MigrationJobTitlesQueryVariables>;
export const ArchiveLearningEventDocument = gql`
    mutation ArchiveLearningEvent($input: ArchiveLearningEventInput!) {
  archiveLearningEvent(input: $input) {
    learningEvent {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveLearningEventMutationFn = Apollo.MutationFunction<ArchiveLearningEventMutation, ArchiveLearningEventMutationVariables>;

/**
 * __useArchiveLearningEventMutation__
 *
 * To run a mutation, you first call `useArchiveLearningEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveLearningEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveLearningEventMutation, { data, loading, error }] = useArchiveLearningEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveLearningEventMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveLearningEventMutation, ArchiveLearningEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveLearningEventMutation, ArchiveLearningEventMutationVariables>(ArchiveLearningEventDocument, options);
      }
export type ArchiveLearningEventMutationHookResult = ReturnType<typeof useArchiveLearningEventMutation>;
export type ArchiveLearningEventMutationResult = Apollo.MutationResult<ArchiveLearningEventMutation>;
export type ArchiveLearningEventMutationOptions = Apollo.BaseMutationOptions<ArchiveLearningEventMutation, ArchiveLearningEventMutationVariables>;
export const ArchiveLearningSubjectDocument = gql`
    mutation ArchiveLearningSubject($input: ArchiveLearningSubjectInput!) {
  archiveLearningSubject(input: $input) {
    learningSubject {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveLearningSubjectMutationFn = Apollo.MutationFunction<ArchiveLearningSubjectMutation, ArchiveLearningSubjectMutationVariables>;

/**
 * __useArchiveLearningSubjectMutation__
 *
 * To run a mutation, you first call `useArchiveLearningSubjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveLearningSubjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveLearningSubjectMutation, { data, loading, error }] = useArchiveLearningSubjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveLearningSubjectMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveLearningSubjectMutation, ArchiveLearningSubjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveLearningSubjectMutation, ArchiveLearningSubjectMutationVariables>(ArchiveLearningSubjectDocument, options);
      }
export type ArchiveLearningSubjectMutationHookResult = ReturnType<typeof useArchiveLearningSubjectMutation>;
export type ArchiveLearningSubjectMutationResult = Apollo.MutationResult<ArchiveLearningSubjectMutation>;
export type ArchiveLearningSubjectMutationOptions = Apollo.BaseMutationOptions<ArchiveLearningSubjectMutation, ArchiveLearningSubjectMutationVariables>;
export const ArchiveLearningTypeDocument = gql`
    mutation ArchiveLearningType($input: ArchiveLearningTypeInput!) {
  archiveLearningType(input: $input) {
    learningType {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveLearningTypeMutationFn = Apollo.MutationFunction<ArchiveLearningTypeMutation, ArchiveLearningTypeMutationVariables>;

/**
 * __useArchiveLearningTypeMutation__
 *
 * To run a mutation, you first call `useArchiveLearningTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveLearningTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveLearningTypeMutation, { data, loading, error }] = useArchiveLearningTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveLearningTypeMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveLearningTypeMutation, ArchiveLearningTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveLearningTypeMutation, ArchiveLearningTypeMutationVariables>(ArchiveLearningTypeDocument, options);
      }
export type ArchiveLearningTypeMutationHookResult = ReturnType<typeof useArchiveLearningTypeMutation>;
export type ArchiveLearningTypeMutationResult = Apollo.MutationResult<ArchiveLearningTypeMutation>;
export type ArchiveLearningTypeMutationOptions = Apollo.BaseMutationOptions<ArchiveLearningTypeMutation, ArchiveLearningTypeMutationVariables>;
export const CancelLearningEventDocument = gql`
    mutation CancelLearningEvent($input: CancelLearningEventInput!) {
  cancelLearningEvent(input: $input) {
    learningEvent {
      ...LearningEvent
    }
  }
}
    ${LearningEventFragmentDoc}`;
export type CancelLearningEventMutationFn = Apollo.MutationFunction<CancelLearningEventMutation, CancelLearningEventMutationVariables>;

/**
 * __useCancelLearningEventMutation__
 *
 * To run a mutation, you first call `useCancelLearningEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelLearningEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelLearningEventMutation, { data, loading, error }] = useCancelLearningEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelLearningEventMutation(baseOptions?: Apollo.MutationHookOptions<CancelLearningEventMutation, CancelLearningEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelLearningEventMutation, CancelLearningEventMutationVariables>(CancelLearningEventDocument, options);
      }
export type CancelLearningEventMutationHookResult = ReturnType<typeof useCancelLearningEventMutation>;
export type CancelLearningEventMutationResult = Apollo.MutationResult<CancelLearningEventMutation>;
export type CancelLearningEventMutationOptions = Apollo.BaseMutationOptions<CancelLearningEventMutation, CancelLearningEventMutationVariables>;
export const CreateLearningEventDocument = gql`
    mutation CreateLearningEvent($input: CreateLearningEventInput!) {
  createLearningEvent(input: $input) {
    learningEvent {
      id
    }
  }
}
    `;
export type CreateLearningEventMutationFn = Apollo.MutationFunction<CreateLearningEventMutation, CreateLearningEventMutationVariables>;

/**
 * __useCreateLearningEventMutation__
 *
 * To run a mutation, you first call `useCreateLearningEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningEventMutation, { data, loading, error }] = useCreateLearningEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLearningEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateLearningEventMutation, CreateLearningEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLearningEventMutation, CreateLearningEventMutationVariables>(CreateLearningEventDocument, options);
      }
export type CreateLearningEventMutationHookResult = ReturnType<typeof useCreateLearningEventMutation>;
export type CreateLearningEventMutationResult = Apollo.MutationResult<CreateLearningEventMutation>;
export type CreateLearningEventMutationOptions = Apollo.BaseMutationOptions<CreateLearningEventMutation, CreateLearningEventMutationVariables>;
export const CreateLearningSubjectDocument = gql`
    mutation CreateLearningSubject($input: CreateLearningSubjectInput!) {
  createLearningSubject(input: $input) {
    learningSubject {
      id
    }
  }
}
    `;
export type CreateLearningSubjectMutationFn = Apollo.MutationFunction<CreateLearningSubjectMutation, CreateLearningSubjectMutationVariables>;

/**
 * __useCreateLearningSubjectMutation__
 *
 * To run a mutation, you first call `useCreateLearningSubjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningSubjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningSubjectMutation, { data, loading, error }] = useCreateLearningSubjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLearningSubjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateLearningSubjectMutation, CreateLearningSubjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLearningSubjectMutation, CreateLearningSubjectMutationVariables>(CreateLearningSubjectDocument, options);
      }
export type CreateLearningSubjectMutationHookResult = ReturnType<typeof useCreateLearningSubjectMutation>;
export type CreateLearningSubjectMutationResult = Apollo.MutationResult<CreateLearningSubjectMutation>;
export type CreateLearningSubjectMutationOptions = Apollo.BaseMutationOptions<CreateLearningSubjectMutation, CreateLearningSubjectMutationVariables>;
export const CreateLearningTypeDocument = gql`
    mutation CreateLearningType($input: CreateLearningTypeInput!) {
  createLearningType(input: $input) {
    learningType {
      id
    }
  }
}
    `;
export type CreateLearningTypeMutationFn = Apollo.MutationFunction<CreateLearningTypeMutation, CreateLearningTypeMutationVariables>;

/**
 * __useCreateLearningTypeMutation__
 *
 * To run a mutation, you first call `useCreateLearningTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningTypeMutation, { data, loading, error }] = useCreateLearningTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLearningTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateLearningTypeMutation, CreateLearningTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLearningTypeMutation, CreateLearningTypeMutationVariables>(CreateLearningTypeDocument, options);
      }
export type CreateLearningTypeMutationHookResult = ReturnType<typeof useCreateLearningTypeMutation>;
export type CreateLearningTypeMutationResult = Apollo.MutationResult<CreateLearningTypeMutation>;
export type CreateLearningTypeMutationOptions = Apollo.BaseMutationOptions<CreateLearningTypeMutation, CreateLearningTypeMutationVariables>;
export const JoinLearningEventDocument = gql`
    mutation JoinLearningEvent($input: JoinLearningEventInput!) {
  joinLearningEvent(input: $input) {
    learningEvent {
      id
      isViewerAttending
      hosts(first: 1000) {
        edges {
          node {
            id
            firstName
            lastName
          }
          attendeeType
        }
      }
      attendees(first: 1000) {
        edges {
          node {
            id
            firstName
            lastName
          }
          attendeeType
        }
      }
    }
  }
}
    `;
export type JoinLearningEventMutationFn = Apollo.MutationFunction<JoinLearningEventMutation, JoinLearningEventMutationVariables>;

/**
 * __useJoinLearningEventMutation__
 *
 * To run a mutation, you first call `useJoinLearningEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinLearningEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinLearningEventMutation, { data, loading, error }] = useJoinLearningEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJoinLearningEventMutation(baseOptions?: Apollo.MutationHookOptions<JoinLearningEventMutation, JoinLearningEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinLearningEventMutation, JoinLearningEventMutationVariables>(JoinLearningEventDocument, options);
      }
export type JoinLearningEventMutationHookResult = ReturnType<typeof useJoinLearningEventMutation>;
export type JoinLearningEventMutationResult = Apollo.MutationResult<JoinLearningEventMutation>;
export type JoinLearningEventMutationOptions = Apollo.BaseMutationOptions<JoinLearningEventMutation, JoinLearningEventMutationVariables>;
export const LeaveLearningEventDocument = gql`
    mutation LeaveLearningEvent($input: LeaveLearningEventInput!) {
  leaveLearningEvent(input: $input) {
    learningEvent {
      id
      isViewerAttending
      hosts(first: 1000) {
        edges {
          node {
            id
            firstName
            lastName
          }
          attendeeType
        }
      }
      attendees(first: 1000) {
        edges {
          node {
            id
            firstName
            lastName
          }
          attendeeType
        }
      }
    }
  }
}
    `;
export type LeaveLearningEventMutationFn = Apollo.MutationFunction<LeaveLearningEventMutation, LeaveLearningEventMutationVariables>;

/**
 * __useLeaveLearningEventMutation__
 *
 * To run a mutation, you first call `useLeaveLearningEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveLearningEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveLearningEventMutation, { data, loading, error }] = useLeaveLearningEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLeaveLearningEventMutation(baseOptions?: Apollo.MutationHookOptions<LeaveLearningEventMutation, LeaveLearningEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveLearningEventMutation, LeaveLearningEventMutationVariables>(LeaveLearningEventDocument, options);
      }
export type LeaveLearningEventMutationHookResult = ReturnType<typeof useLeaveLearningEventMutation>;
export type LeaveLearningEventMutationResult = Apollo.MutationResult<LeaveLearningEventMutation>;
export type LeaveLearningEventMutationOptions = Apollo.BaseMutationOptions<LeaveLearningEventMutation, LeaveLearningEventMutationVariables>;
export const RestoreLearningEventDocument = gql`
    mutation RestoreLearningEvent($input: RestoreLearningEventInput!) {
  restoreLearningEvent(input: $input) {
    learningEvent {
      id
      isArchived
    }
  }
}
    `;
export type RestoreLearningEventMutationFn = Apollo.MutationFunction<RestoreLearningEventMutation, RestoreLearningEventMutationVariables>;

/**
 * __useRestoreLearningEventMutation__
 *
 * To run a mutation, you first call `useRestoreLearningEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreLearningEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreLearningEventMutation, { data, loading, error }] = useRestoreLearningEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreLearningEventMutation(baseOptions?: Apollo.MutationHookOptions<RestoreLearningEventMutation, RestoreLearningEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreLearningEventMutation, RestoreLearningEventMutationVariables>(RestoreLearningEventDocument, options);
      }
export type RestoreLearningEventMutationHookResult = ReturnType<typeof useRestoreLearningEventMutation>;
export type RestoreLearningEventMutationResult = Apollo.MutationResult<RestoreLearningEventMutation>;
export type RestoreLearningEventMutationOptions = Apollo.BaseMutationOptions<RestoreLearningEventMutation, RestoreLearningEventMutationVariables>;
export const RestoreLearningSubjectDocument = gql`
    mutation RestoreLearningSubject($input: RestoreLearningSubjectInput!) {
  restoreLearningSubject(input: $input) {
    learningSubject {
      id
      isArchived
    }
  }
}
    `;
export type RestoreLearningSubjectMutationFn = Apollo.MutationFunction<RestoreLearningSubjectMutation, RestoreLearningSubjectMutationVariables>;

/**
 * __useRestoreLearningSubjectMutation__
 *
 * To run a mutation, you first call `useRestoreLearningSubjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreLearningSubjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreLearningSubjectMutation, { data, loading, error }] = useRestoreLearningSubjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreLearningSubjectMutation(baseOptions?: Apollo.MutationHookOptions<RestoreLearningSubjectMutation, RestoreLearningSubjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreLearningSubjectMutation, RestoreLearningSubjectMutationVariables>(RestoreLearningSubjectDocument, options);
      }
export type RestoreLearningSubjectMutationHookResult = ReturnType<typeof useRestoreLearningSubjectMutation>;
export type RestoreLearningSubjectMutationResult = Apollo.MutationResult<RestoreLearningSubjectMutation>;
export type RestoreLearningSubjectMutationOptions = Apollo.BaseMutationOptions<RestoreLearningSubjectMutation, RestoreLearningSubjectMutationVariables>;
export const RestoreLearningTypeDocument = gql`
    mutation RestoreLearningType($input: RestoreLearningTypeInput!) {
  restoreLearningType(input: $input) {
    learningType {
      id
      isArchived
    }
  }
}
    `;
export type RestoreLearningTypeMutationFn = Apollo.MutationFunction<RestoreLearningTypeMutation, RestoreLearningTypeMutationVariables>;

/**
 * __useRestoreLearningTypeMutation__
 *
 * To run a mutation, you first call `useRestoreLearningTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreLearningTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreLearningTypeMutation, { data, loading, error }] = useRestoreLearningTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreLearningTypeMutation(baseOptions?: Apollo.MutationHookOptions<RestoreLearningTypeMutation, RestoreLearningTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreLearningTypeMutation, RestoreLearningTypeMutationVariables>(RestoreLearningTypeDocument, options);
      }
export type RestoreLearningTypeMutationHookResult = ReturnType<typeof useRestoreLearningTypeMutation>;
export type RestoreLearningTypeMutationResult = Apollo.MutationResult<RestoreLearningTypeMutation>;
export type RestoreLearningTypeMutationOptions = Apollo.BaseMutationOptions<RestoreLearningTypeMutation, RestoreLearningTypeMutationVariables>;
export const ReviewLearningEventDocument = gql`
    mutation ReviewLearningEvent($input: ReviewLearningEventInput!) {
  reviewLearningEvent(input: $input) {
    learningEvent {
      id
      status
      lastRejectedAt
      isArchived
    }
  }
}
    `;
export type ReviewLearningEventMutationFn = Apollo.MutationFunction<ReviewLearningEventMutation, ReviewLearningEventMutationVariables>;

/**
 * __useReviewLearningEventMutation__
 *
 * To run a mutation, you first call `useReviewLearningEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewLearningEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewLearningEventMutation, { data, loading, error }] = useReviewLearningEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewLearningEventMutation(baseOptions?: Apollo.MutationHookOptions<ReviewLearningEventMutation, ReviewLearningEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewLearningEventMutation, ReviewLearningEventMutationVariables>(ReviewLearningEventDocument, options);
      }
export type ReviewLearningEventMutationHookResult = ReturnType<typeof useReviewLearningEventMutation>;
export type ReviewLearningEventMutationResult = Apollo.MutationResult<ReviewLearningEventMutation>;
export type ReviewLearningEventMutationOptions = Apollo.BaseMutationOptions<ReviewLearningEventMutation, ReviewLearningEventMutationVariables>;
export const UpdateLearningEventDocument = gql`
    mutation UpdateLearningEvent($input: UpdateLearningEventInput!) {
  updateLearningEvent(input: $input) {
    learningEvent {
      ...LearningEvent
    }
  }
}
    ${LearningEventFragmentDoc}`;
export type UpdateLearningEventMutationFn = Apollo.MutationFunction<UpdateLearningEventMutation, UpdateLearningEventMutationVariables>;

/**
 * __useUpdateLearningEventMutation__
 *
 * To run a mutation, you first call `useUpdateLearningEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearningEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearningEventMutation, { data, loading, error }] = useUpdateLearningEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLearningEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLearningEventMutation, UpdateLearningEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLearningEventMutation, UpdateLearningEventMutationVariables>(UpdateLearningEventDocument, options);
      }
export type UpdateLearningEventMutationHookResult = ReturnType<typeof useUpdateLearningEventMutation>;
export type UpdateLearningEventMutationResult = Apollo.MutationResult<UpdateLearningEventMutation>;
export type UpdateLearningEventMutationOptions = Apollo.BaseMutationOptions<UpdateLearningEventMutation, UpdateLearningEventMutationVariables>;
export const UpdateLearningSubjectDocument = gql`
    mutation UpdateLearningSubject($input: UpdateLearningSubjectInput!) {
  updateLearningSubject(input: $input) {
    learningSubject {
      id
    }
  }
}
    `;
export type UpdateLearningSubjectMutationFn = Apollo.MutationFunction<UpdateLearningSubjectMutation, UpdateLearningSubjectMutationVariables>;

/**
 * __useUpdateLearningSubjectMutation__
 *
 * To run a mutation, you first call `useUpdateLearningSubjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearningSubjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearningSubjectMutation, { data, loading, error }] = useUpdateLearningSubjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLearningSubjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLearningSubjectMutation, UpdateLearningSubjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLearningSubjectMutation, UpdateLearningSubjectMutationVariables>(UpdateLearningSubjectDocument, options);
      }
export type UpdateLearningSubjectMutationHookResult = ReturnType<typeof useUpdateLearningSubjectMutation>;
export type UpdateLearningSubjectMutationResult = Apollo.MutationResult<UpdateLearningSubjectMutation>;
export type UpdateLearningSubjectMutationOptions = Apollo.BaseMutationOptions<UpdateLearningSubjectMutation, UpdateLearningSubjectMutationVariables>;
export const UpdateLearningTypeDocument = gql`
    mutation UpdateLearningType($input: UpdateLearningTypeInput!) {
  updateLearningType(input: $input) {
    learningType {
      id
    }
  }
}
    `;
export type UpdateLearningTypeMutationFn = Apollo.MutationFunction<UpdateLearningTypeMutation, UpdateLearningTypeMutationVariables>;

/**
 * __useUpdateLearningTypeMutation__
 *
 * To run a mutation, you first call `useUpdateLearningTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearningTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearningTypeMutation, { data, loading, error }] = useUpdateLearningTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLearningTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLearningTypeMutation, UpdateLearningTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLearningTypeMutation, UpdateLearningTypeMutationVariables>(UpdateLearningTypeDocument, options);
      }
export type UpdateLearningTypeMutationHookResult = ReturnType<typeof useUpdateLearningTypeMutation>;
export type UpdateLearningTypeMutationResult = Apollo.MutationResult<UpdateLearningTypeMutation>;
export type UpdateLearningTypeMutationOptions = Apollo.BaseMutationOptions<UpdateLearningTypeMutation, UpdateLearningTypeMutationVariables>;
export const AttendedLearningEventsForJourneyDocument = gql`
    query AttendedLearningEventsForJourney($userID: ID!, $now: DateTime!) {
  user(id: $userID) {
    id
    attendingLearningEvents(beforeDate: $now, first: 10) {
      edges {
        node {
          id
          title
          learningType {
            id
          }
          createdOnDateTimeOffsetUtc: startDate
        }
      }
    }
  }
}
    `;

/**
 * __useAttendedLearningEventsForJourneyQuery__
 *
 * To run a query within a React component, call `useAttendedLearningEventsForJourneyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendedLearningEventsForJourneyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendedLearningEventsForJourneyQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *      now: // value for 'now'
 *   },
 * });
 */
export function useAttendedLearningEventsForJourneyQuery(baseOptions: Apollo.QueryHookOptions<AttendedLearningEventsForJourneyQuery, AttendedLearningEventsForJourneyQueryVariables> & ({ variables: AttendedLearningEventsForJourneyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttendedLearningEventsForJourneyQuery, AttendedLearningEventsForJourneyQueryVariables>(AttendedLearningEventsForJourneyDocument, options);
      }
export function useAttendedLearningEventsForJourneyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttendedLearningEventsForJourneyQuery, AttendedLearningEventsForJourneyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttendedLearningEventsForJourneyQuery, AttendedLearningEventsForJourneyQueryVariables>(AttendedLearningEventsForJourneyDocument, options);
        }
// @ts-ignore
export function useAttendedLearningEventsForJourneySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AttendedLearningEventsForJourneyQuery, AttendedLearningEventsForJourneyQueryVariables>): Apollo.UseSuspenseQueryResult<AttendedLearningEventsForJourneyQuery, AttendedLearningEventsForJourneyQueryVariables>;
export function useAttendedLearningEventsForJourneySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttendedLearningEventsForJourneyQuery, AttendedLearningEventsForJourneyQueryVariables>): Apollo.UseSuspenseQueryResult<AttendedLearningEventsForJourneyQuery | undefined, AttendedLearningEventsForJourneyQueryVariables>;
export function useAttendedLearningEventsForJourneySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttendedLearningEventsForJourneyQuery, AttendedLearningEventsForJourneyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AttendedLearningEventsForJourneyQuery, AttendedLearningEventsForJourneyQueryVariables>(AttendedLearningEventsForJourneyDocument, options);
        }
export type AttendedLearningEventsForJourneyQueryHookResult = ReturnType<typeof useAttendedLearningEventsForJourneyQuery>;
export type AttendedLearningEventsForJourneyLazyQueryHookResult = ReturnType<typeof useAttendedLearningEventsForJourneyLazyQuery>;
export type AttendedLearningEventsForJourneySuspenseQueryHookResult = ReturnType<typeof useAttendedLearningEventsForJourneySuspenseQuery>;
export type AttendedLearningEventsForJourneyQueryResult = Apollo.QueryResult<AttendedLearningEventsForJourneyQuery, AttendedLearningEventsForJourneyQueryVariables>;
export const AttendingLearningEventsDocument = gql`
    query AttendingLearningEvents {
  viewer {
    attendingLearningEvents {
      edges {
        node {
          id
          cover {
            id
            source {
              url
            }
          }
          title
          learningType {
            color
          }
          startDate
          endDate
          isArchived
          isViewerAttending
        }
        attendeeType
      }
    }
  }
}
    `;

/**
 * __useAttendingLearningEventsQuery__
 *
 * To run a query within a React component, call `useAttendingLearningEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendingLearningEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttendingLearningEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAttendingLearningEventsQuery(baseOptions?: Apollo.QueryHookOptions<AttendingLearningEventsQuery, AttendingLearningEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttendingLearningEventsQuery, AttendingLearningEventsQueryVariables>(AttendingLearningEventsDocument, options);
      }
export function useAttendingLearningEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttendingLearningEventsQuery, AttendingLearningEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttendingLearningEventsQuery, AttendingLearningEventsQueryVariables>(AttendingLearningEventsDocument, options);
        }
// @ts-ignore
export function useAttendingLearningEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AttendingLearningEventsQuery, AttendingLearningEventsQueryVariables>): Apollo.UseSuspenseQueryResult<AttendingLearningEventsQuery, AttendingLearningEventsQueryVariables>;
export function useAttendingLearningEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttendingLearningEventsQuery, AttendingLearningEventsQueryVariables>): Apollo.UseSuspenseQueryResult<AttendingLearningEventsQuery | undefined, AttendingLearningEventsQueryVariables>;
export function useAttendingLearningEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttendingLearningEventsQuery, AttendingLearningEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AttendingLearningEventsQuery, AttendingLearningEventsQueryVariables>(AttendingLearningEventsDocument, options);
        }
export type AttendingLearningEventsQueryHookResult = ReturnType<typeof useAttendingLearningEventsQuery>;
export type AttendingLearningEventsLazyQueryHookResult = ReturnType<typeof useAttendingLearningEventsLazyQuery>;
export type AttendingLearningEventsSuspenseQueryHookResult = ReturnType<typeof useAttendingLearningEventsSuspenseQuery>;
export type AttendingLearningEventsQueryResult = Apollo.QueryResult<AttendingLearningEventsQuery, AttendingLearningEventsQueryVariables>;
export const ConversationLearningRecommendationsDocument = gql`
    query ConversationLearningRecommendations($input: ConversationLearningRecommendationsInput!) {
  conversationLearningRecommendations(input: $input) {
    recommendations {
      reason
      learningCourse {
        ...LearningCourse
      }
    }
  }
}
    ${LearningCourseFragmentDoc}`;

/**
 * __useConversationLearningRecommendationsQuery__
 *
 * To run a query within a React component, call `useConversationLearningRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationLearningRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationLearningRecommendationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConversationLearningRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<ConversationLearningRecommendationsQuery, ConversationLearningRecommendationsQueryVariables> & ({ variables: ConversationLearningRecommendationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationLearningRecommendationsQuery, ConversationLearningRecommendationsQueryVariables>(ConversationLearningRecommendationsDocument, options);
      }
export function useConversationLearningRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationLearningRecommendationsQuery, ConversationLearningRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationLearningRecommendationsQuery, ConversationLearningRecommendationsQueryVariables>(ConversationLearningRecommendationsDocument, options);
        }
// @ts-ignore
export function useConversationLearningRecommendationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConversationLearningRecommendationsQuery, ConversationLearningRecommendationsQueryVariables>): Apollo.UseSuspenseQueryResult<ConversationLearningRecommendationsQuery, ConversationLearningRecommendationsQueryVariables>;
export function useConversationLearningRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConversationLearningRecommendationsQuery, ConversationLearningRecommendationsQueryVariables>): Apollo.UseSuspenseQueryResult<ConversationLearningRecommendationsQuery | undefined, ConversationLearningRecommendationsQueryVariables>;
export function useConversationLearningRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConversationLearningRecommendationsQuery, ConversationLearningRecommendationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConversationLearningRecommendationsQuery, ConversationLearningRecommendationsQueryVariables>(ConversationLearningRecommendationsDocument, options);
        }
export type ConversationLearningRecommendationsQueryHookResult = ReturnType<typeof useConversationLearningRecommendationsQuery>;
export type ConversationLearningRecommendationsLazyQueryHookResult = ReturnType<typeof useConversationLearningRecommendationsLazyQuery>;
export type ConversationLearningRecommendationsSuspenseQueryHookResult = ReturnType<typeof useConversationLearningRecommendationsSuspenseQuery>;
export type ConversationLearningRecommendationsQueryResult = Apollo.QueryResult<ConversationLearningRecommendationsQuery, ConversationLearningRecommendationsQueryVariables>;
export const LearningCourseDocument = gql`
    query LearningCourse($id: ID!) {
  learningCourse(id: $id) {
    ...LearningCourse
  }
}
    ${LearningCourseFragmentDoc}`;

/**
 * __useLearningCourseQuery__
 *
 * To run a query within a React component, call `useLearningCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningCourseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningCourseQuery(baseOptions: Apollo.QueryHookOptions<LearningCourseQuery, LearningCourseQueryVariables> & ({ variables: LearningCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningCourseQuery, LearningCourseQueryVariables>(LearningCourseDocument, options);
      }
export function useLearningCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningCourseQuery, LearningCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningCourseQuery, LearningCourseQueryVariables>(LearningCourseDocument, options);
        }
// @ts-ignore
export function useLearningCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LearningCourseQuery, LearningCourseQueryVariables>): Apollo.UseSuspenseQueryResult<LearningCourseQuery, LearningCourseQueryVariables>;
export function useLearningCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningCourseQuery, LearningCourseQueryVariables>): Apollo.UseSuspenseQueryResult<LearningCourseQuery | undefined, LearningCourseQueryVariables>;
export function useLearningCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningCourseQuery, LearningCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningCourseQuery, LearningCourseQueryVariables>(LearningCourseDocument, options);
        }
export type LearningCourseQueryHookResult = ReturnType<typeof useLearningCourseQuery>;
export type LearningCourseLazyQueryHookResult = ReturnType<typeof useLearningCourseLazyQuery>;
export type LearningCourseSuspenseQueryHookResult = ReturnType<typeof useLearningCourseSuspenseQuery>;
export type LearningCourseQueryResult = Apollo.QueryResult<LearningCourseQuery, LearningCourseQueryVariables>;
export const LearningCoursesDocument = gql`
    query LearningCourses($filters: LearningCourseFilters, $before: ID, $after: ID, $first: Int, $last: Int) {
  learningCourses(
    filters: $filters
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    totalCount
    edges {
      node {
        ...LearningCourse
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${LearningCourseFragmentDoc}`;

/**
 * __useLearningCoursesQuery__
 *
 * To run a query within a React component, call `useLearningCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningCoursesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useLearningCoursesQuery(baseOptions?: Apollo.QueryHookOptions<LearningCoursesQuery, LearningCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningCoursesQuery, LearningCoursesQueryVariables>(LearningCoursesDocument, options);
      }
export function useLearningCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningCoursesQuery, LearningCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningCoursesQuery, LearningCoursesQueryVariables>(LearningCoursesDocument, options);
        }
// @ts-ignore
export function useLearningCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LearningCoursesQuery, LearningCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<LearningCoursesQuery, LearningCoursesQueryVariables>;
export function useLearningCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningCoursesQuery, LearningCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<LearningCoursesQuery | undefined, LearningCoursesQueryVariables>;
export function useLearningCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningCoursesQuery, LearningCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningCoursesQuery, LearningCoursesQueryVariables>(LearningCoursesDocument, options);
        }
export type LearningCoursesQueryHookResult = ReturnType<typeof useLearningCoursesQuery>;
export type LearningCoursesLazyQueryHookResult = ReturnType<typeof useLearningCoursesLazyQuery>;
export type LearningCoursesSuspenseQueryHookResult = ReturnType<typeof useLearningCoursesSuspenseQuery>;
export type LearningCoursesQueryResult = Apollo.QueryResult<LearningCoursesQuery, LearningCoursesQueryVariables>;
export const LearningEventDocument = gql`
    query LearningEvent($id: ID!) {
  learningEvent(id: $id) {
    id
    status
    title
    description
    cover {
      id
      source {
        url
      }
    }
    status
    startDate
    endDate
    timezone
    capacity
    attendeeCount
    meetingLink
    location
    learningType {
      id
      color
      title
    }
    jobTitles {
      id
      title
    }
    hosts(first: 1000) {
      edges {
        node {
          id
          firstName
          lastName
          email
          avatar {
            source {
              url
            }
          }
          jobPositions {
            jobTitle {
              id
              title
            }
          }
        }
        attendeeType
      }
    }
    attendees(first: 1000) {
      edges {
        node {
          id
          firstName
          lastName
          email
          avatar {
            source {
              url
            }
          }
          jobPositions {
            jobTitle {
              id
              title
            }
          }
        }
        attendeeType
      }
    }
    learningSubjects {
      id
      title
    }
    languageID
    isArchived
    isViewerAttending
    lastRejectedAt
    createdBy {
      id
    }
  }
}
    `;

/**
 * __useLearningEventQuery__
 *
 * To run a query within a React component, call `useLearningEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningEventQuery(baseOptions: Apollo.QueryHookOptions<LearningEventQuery, LearningEventQueryVariables> & ({ variables: LearningEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningEventQuery, LearningEventQueryVariables>(LearningEventDocument, options);
      }
export function useLearningEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningEventQuery, LearningEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningEventQuery, LearningEventQueryVariables>(LearningEventDocument, options);
        }
// @ts-ignore
export function useLearningEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LearningEventQuery, LearningEventQueryVariables>): Apollo.UseSuspenseQueryResult<LearningEventQuery, LearningEventQueryVariables>;
export function useLearningEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningEventQuery, LearningEventQueryVariables>): Apollo.UseSuspenseQueryResult<LearningEventQuery | undefined, LearningEventQueryVariables>;
export function useLearningEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningEventQuery, LearningEventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningEventQuery, LearningEventQueryVariables>(LearningEventDocument, options);
        }
export type LearningEventQueryHookResult = ReturnType<typeof useLearningEventQuery>;
export type LearningEventLazyQueryHookResult = ReturnType<typeof useLearningEventLazyQuery>;
export type LearningEventSuspenseQueryHookResult = ReturnType<typeof useLearningEventSuspenseQuery>;
export type LearningEventQueryResult = Apollo.QueryResult<LearningEventQuery, LearningEventQueryVariables>;
export const LearningEventProposalsDocument = gql`
    query LearningEventProposals($before: ID, $after: ID, $first: Int, $last: Int) {
  learningEventProposals(
    isArchived: false
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      node {
        id
        title
        cover {
          id
          source {
            url
          }
        }
        learningType {
          color
        }
        status
        startDate
        endDate
        isViewerAttending
      }
    }
  }
}
    `;

/**
 * __useLearningEventProposalsQuery__
 *
 * To run a query within a React component, call `useLearningEventProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningEventProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningEventProposalsQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useLearningEventProposalsQuery(baseOptions?: Apollo.QueryHookOptions<LearningEventProposalsQuery, LearningEventProposalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningEventProposalsQuery, LearningEventProposalsQueryVariables>(LearningEventProposalsDocument, options);
      }
export function useLearningEventProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningEventProposalsQuery, LearningEventProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningEventProposalsQuery, LearningEventProposalsQueryVariables>(LearningEventProposalsDocument, options);
        }
// @ts-ignore
export function useLearningEventProposalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LearningEventProposalsQuery, LearningEventProposalsQueryVariables>): Apollo.UseSuspenseQueryResult<LearningEventProposalsQuery, LearningEventProposalsQueryVariables>;
export function useLearningEventProposalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningEventProposalsQuery, LearningEventProposalsQueryVariables>): Apollo.UseSuspenseQueryResult<LearningEventProposalsQuery | undefined, LearningEventProposalsQueryVariables>;
export function useLearningEventProposalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningEventProposalsQuery, LearningEventProposalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningEventProposalsQuery, LearningEventProposalsQueryVariables>(LearningEventProposalsDocument, options);
        }
export type LearningEventProposalsQueryHookResult = ReturnType<typeof useLearningEventProposalsQuery>;
export type LearningEventProposalsLazyQueryHookResult = ReturnType<typeof useLearningEventProposalsLazyQuery>;
export type LearningEventProposalsSuspenseQueryHookResult = ReturnType<typeof useLearningEventProposalsSuspenseQuery>;
export type LearningEventProposalsQueryResult = Apollo.QueryResult<LearningEventProposalsQuery, LearningEventProposalsQueryVariables>;
export const LearningEventsDocument = gql`
    query LearningEvents($filters: LearningEventFilters, $before: ID, $after: ID, $first: Int, $last: Int) {
  learningEvents(
    filters: $filters
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      node {
        id
        title
        cover {
          id
          source {
            url
          }
        }
        learningType {
          color
        }
        jobTitles {
          id
          title
        }
        status
        startDate
        endDate
        isArchived
        isViewerAttending
        viewerCanJoin
      }
    }
  }
}
    `;

/**
 * __useLearningEventsQuery__
 *
 * To run a query within a React component, call `useLearningEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningEventsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useLearningEventsQuery(baseOptions?: Apollo.QueryHookOptions<LearningEventsQuery, LearningEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningEventsQuery, LearningEventsQueryVariables>(LearningEventsDocument, options);
      }
export function useLearningEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningEventsQuery, LearningEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningEventsQuery, LearningEventsQueryVariables>(LearningEventsDocument, options);
        }
// @ts-ignore
export function useLearningEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LearningEventsQuery, LearningEventsQueryVariables>): Apollo.UseSuspenseQueryResult<LearningEventsQuery, LearningEventsQueryVariables>;
export function useLearningEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningEventsQuery, LearningEventsQueryVariables>): Apollo.UseSuspenseQueryResult<LearningEventsQuery | undefined, LearningEventsQueryVariables>;
export function useLearningEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningEventsQuery, LearningEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningEventsQuery, LearningEventsQueryVariables>(LearningEventsDocument, options);
        }
export type LearningEventsQueryHookResult = ReturnType<typeof useLearningEventsQuery>;
export type LearningEventsLazyQueryHookResult = ReturnType<typeof useLearningEventsLazyQuery>;
export type LearningEventsSuspenseQueryHookResult = ReturnType<typeof useLearningEventsSuspenseQuery>;
export type LearningEventsQueryResult = Apollo.QueryResult<LearningEventsQuery, LearningEventsQueryVariables>;
export const LearningMyEventsDocument = gql`
    query LearningMyEvents($before: ID, $after: ID, $first: Int, $last: Int) {
  viewer {
    learningEventProposals(
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      edges {
        node {
          id
          title
          cover {
            id
            source {
              url
            }
          }
          learningType {
            color
          }
          status
          startDate
          endDate
          isViewerAttending
        }
      }
    }
  }
}
    `;

/**
 * __useLearningMyEventsQuery__
 *
 * To run a query within a React component, call `useLearningMyEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningMyEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningMyEventsQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useLearningMyEventsQuery(baseOptions?: Apollo.QueryHookOptions<LearningMyEventsQuery, LearningMyEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningMyEventsQuery, LearningMyEventsQueryVariables>(LearningMyEventsDocument, options);
      }
export function useLearningMyEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningMyEventsQuery, LearningMyEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningMyEventsQuery, LearningMyEventsQueryVariables>(LearningMyEventsDocument, options);
        }
// @ts-ignore
export function useLearningMyEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LearningMyEventsQuery, LearningMyEventsQueryVariables>): Apollo.UseSuspenseQueryResult<LearningMyEventsQuery, LearningMyEventsQueryVariables>;
export function useLearningMyEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningMyEventsQuery, LearningMyEventsQueryVariables>): Apollo.UseSuspenseQueryResult<LearningMyEventsQuery | undefined, LearningMyEventsQueryVariables>;
export function useLearningMyEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningMyEventsQuery, LearningMyEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningMyEventsQuery, LearningMyEventsQueryVariables>(LearningMyEventsDocument, options);
        }
export type LearningMyEventsQueryHookResult = ReturnType<typeof useLearningMyEventsQuery>;
export type LearningMyEventsLazyQueryHookResult = ReturnType<typeof useLearningMyEventsLazyQuery>;
export type LearningMyEventsSuspenseQueryHookResult = ReturnType<typeof useLearningMyEventsSuspenseQuery>;
export type LearningMyEventsQueryResult = Apollo.QueryResult<LearningMyEventsQuery, LearningMyEventsQueryVariables>;
export const LearningRecommendationsDocument = gql`
    query LearningRecommendations {
  learningRecommendations {
    recommendations {
      reason
      learningCourse {
        ...LearningCourse
      }
    }
  }
}
    ${LearningCourseFragmentDoc}`;

/**
 * __useLearningRecommendationsQuery__
 *
 * To run a query within a React component, call `useLearningRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningRecommendationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLearningRecommendationsQuery(baseOptions?: Apollo.QueryHookOptions<LearningRecommendationsQuery, LearningRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningRecommendationsQuery, LearningRecommendationsQueryVariables>(LearningRecommendationsDocument, options);
      }
export function useLearningRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningRecommendationsQuery, LearningRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningRecommendationsQuery, LearningRecommendationsQueryVariables>(LearningRecommendationsDocument, options);
        }
// @ts-ignore
export function useLearningRecommendationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LearningRecommendationsQuery, LearningRecommendationsQueryVariables>): Apollo.UseSuspenseQueryResult<LearningRecommendationsQuery, LearningRecommendationsQueryVariables>;
export function useLearningRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningRecommendationsQuery, LearningRecommendationsQueryVariables>): Apollo.UseSuspenseQueryResult<LearningRecommendationsQuery | undefined, LearningRecommendationsQueryVariables>;
export function useLearningRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningRecommendationsQuery, LearningRecommendationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningRecommendationsQuery, LearningRecommendationsQueryVariables>(LearningRecommendationsDocument, options);
        }
export type LearningRecommendationsQueryHookResult = ReturnType<typeof useLearningRecommendationsQuery>;
export type LearningRecommendationsLazyQueryHookResult = ReturnType<typeof useLearningRecommendationsLazyQuery>;
export type LearningRecommendationsSuspenseQueryHookResult = ReturnType<typeof useLearningRecommendationsSuspenseQuery>;
export type LearningRecommendationsQueryResult = Apollo.QueryResult<LearningRecommendationsQuery, LearningRecommendationsQueryVariables>;
export const LearningSubjectsDocument = gql`
    query LearningSubjects($isArchived: Boolean, $before: ID, $after: ID, $first: Int, $last: Int) {
  learningSubjects(
    isArchived: $isArchived
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      node {
        id
        title
        isArchived
      }
    }
  }
}
    `;

/**
 * __useLearningSubjectsQuery__
 *
 * To run a query within a React component, call `useLearningSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningSubjectsQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useLearningSubjectsQuery(baseOptions?: Apollo.QueryHookOptions<LearningSubjectsQuery, LearningSubjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningSubjectsQuery, LearningSubjectsQueryVariables>(LearningSubjectsDocument, options);
      }
export function useLearningSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningSubjectsQuery, LearningSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningSubjectsQuery, LearningSubjectsQueryVariables>(LearningSubjectsDocument, options);
        }
// @ts-ignore
export function useLearningSubjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LearningSubjectsQuery, LearningSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<LearningSubjectsQuery, LearningSubjectsQueryVariables>;
export function useLearningSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningSubjectsQuery, LearningSubjectsQueryVariables>): Apollo.UseSuspenseQueryResult<LearningSubjectsQuery | undefined, LearningSubjectsQueryVariables>;
export function useLearningSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningSubjectsQuery, LearningSubjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningSubjectsQuery, LearningSubjectsQueryVariables>(LearningSubjectsDocument, options);
        }
export type LearningSubjectsQueryHookResult = ReturnType<typeof useLearningSubjectsQuery>;
export type LearningSubjectsLazyQueryHookResult = ReturnType<typeof useLearningSubjectsLazyQuery>;
export type LearningSubjectsSuspenseQueryHookResult = ReturnType<typeof useLearningSubjectsSuspenseQuery>;
export type LearningSubjectsQueryResult = Apollo.QueryResult<LearningSubjectsQuery, LearningSubjectsQueryVariables>;
export const LearningTypesDocument = gql`
    query LearningTypes($isArchived: Boolean, $before: ID, $after: ID, $first: Int, $last: Int) {
  learningTypes(
    isArchived: $isArchived
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      node {
        id
        color
        title
        isArchived
      }
    }
  }
}
    `;

/**
 * __useLearningTypesQuery__
 *
 * To run a query within a React component, call `useLearningTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningTypesQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useLearningTypesQuery(baseOptions?: Apollo.QueryHookOptions<LearningTypesQuery, LearningTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningTypesQuery, LearningTypesQueryVariables>(LearningTypesDocument, options);
      }
export function useLearningTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningTypesQuery, LearningTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningTypesQuery, LearningTypesQueryVariables>(LearningTypesDocument, options);
        }
// @ts-ignore
export function useLearningTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LearningTypesQuery, LearningTypesQueryVariables>): Apollo.UseSuspenseQueryResult<LearningTypesQuery, LearningTypesQueryVariables>;
export function useLearningTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningTypesQuery, LearningTypesQueryVariables>): Apollo.UseSuspenseQueryResult<LearningTypesQuery | undefined, LearningTypesQueryVariables>;
export function useLearningTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningTypesQuery, LearningTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningTypesQuery, LearningTypesQueryVariables>(LearningTypesDocument, options);
        }
export type LearningTypesQueryHookResult = ReturnType<typeof useLearningTypesQuery>;
export type LearningTypesLazyQueryHookResult = ReturnType<typeof useLearningTypesLazyQuery>;
export type LearningTypesSuspenseQueryHookResult = ReturnType<typeof useLearningTypesSuspenseQuery>;
export type LearningTypesQueryResult = Apollo.QueryResult<LearningTypesQuery, LearningTypesQueryVariables>;
export const CreateTaskDocument = gql`
    mutation CreateTask($input: CreateTaskInput!) {
  createTask(input: $input) {
    task {
      ...Task
    }
  }
}
    ${TaskFragmentDoc}`;
export type CreateTaskMutationFn = Apollo.MutationFunction<CreateTaskMutation, CreateTaskMutationVariables>;

/**
 * __useCreateTaskMutation__
 *
 * To run a mutation, you first call `useCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskMutation, { data, loading, error }] = useCreateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskMutation, CreateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskMutation, CreateTaskMutationVariables>(CreateTaskDocument, options);
      }
export type CreateTaskMutationHookResult = ReturnType<typeof useCreateTaskMutation>;
export type CreateTaskMutationResult = Apollo.MutationResult<CreateTaskMutation>;
export type CreateTaskMutationOptions = Apollo.BaseMutationOptions<CreateTaskMutation, CreateTaskMutationVariables>;
export const DeleteTaskDocument = gql`
    mutation DeleteTask($input: DeleteTaskInput!) {
  deleteTask(input: $input) {
    success
  }
}
    `;
export type DeleteTaskMutationFn = Apollo.MutationFunction<DeleteTaskMutation, DeleteTaskMutationVariables>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskMutation, DeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, options);
      }
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>;
export type DeleteTaskMutationResult = Apollo.MutationResult<DeleteTaskMutation>;
export type DeleteTaskMutationOptions = Apollo.BaseMutationOptions<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const DepartmentLastTalentReviewDocument = gql`
    query DepartmentLastTalentReview($id: ID!, $isArchived: Boolean!) {
  group(id: $id) {
    id
    name
    talentReviews(isArchived: $isArchived, last: 1) {
      edges {
        node {
          id
          title
          placements {
            column
            row
          }
          group {
            members {
              totalCount
            }
          }
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useDepartmentLastTalentReviewQuery__
 *
 * To run a query within a React component, call `useDepartmentLastTalentReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentLastTalentReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentLastTalentReviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useDepartmentLastTalentReviewQuery(baseOptions: Apollo.QueryHookOptions<DepartmentLastTalentReviewQuery, DepartmentLastTalentReviewQueryVariables> & ({ variables: DepartmentLastTalentReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DepartmentLastTalentReviewQuery, DepartmentLastTalentReviewQueryVariables>(DepartmentLastTalentReviewDocument, options);
      }
export function useDepartmentLastTalentReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepartmentLastTalentReviewQuery, DepartmentLastTalentReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DepartmentLastTalentReviewQuery, DepartmentLastTalentReviewQueryVariables>(DepartmentLastTalentReviewDocument, options);
        }
// @ts-ignore
export function useDepartmentLastTalentReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DepartmentLastTalentReviewQuery, DepartmentLastTalentReviewQueryVariables>): Apollo.UseSuspenseQueryResult<DepartmentLastTalentReviewQuery, DepartmentLastTalentReviewQueryVariables>;
export function useDepartmentLastTalentReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DepartmentLastTalentReviewQuery, DepartmentLastTalentReviewQueryVariables>): Apollo.UseSuspenseQueryResult<DepartmentLastTalentReviewQuery | undefined, DepartmentLastTalentReviewQueryVariables>;
export function useDepartmentLastTalentReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DepartmentLastTalentReviewQuery, DepartmentLastTalentReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DepartmentLastTalentReviewQuery, DepartmentLastTalentReviewQueryVariables>(DepartmentLastTalentReviewDocument, options);
        }
export type DepartmentLastTalentReviewQueryHookResult = ReturnType<typeof useDepartmentLastTalentReviewQuery>;
export type DepartmentLastTalentReviewLazyQueryHookResult = ReturnType<typeof useDepartmentLastTalentReviewLazyQuery>;
export type DepartmentLastTalentReviewSuspenseQueryHookResult = ReturnType<typeof useDepartmentLastTalentReviewSuspenseQuery>;
export type DepartmentLastTalentReviewQueryResult = Apollo.QueryResult<DepartmentLastTalentReviewQuery, DepartmentLastTalentReviewQueryVariables>;
export const EmployeeFeedDocument = gql`
    query EmployeeFeed($userID: ID!, $archived: Boolean!, $filterOnType: [FeedItemType]) {
  user(id: $userID) {
    id
    firstName
    lastName
    avatar {
      source {
        url
      }
    }
    employeeFeed(archived: $archived, filterOnType: $filterOnType) {
      ...EmployeeFeed
    }
  }
}
    ${EmployeeFeedFragmentDoc}`;

/**
 * __useEmployeeFeedQuery__
 *
 * To run a query within a React component, call `useEmployeeFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeFeedQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *      archived: // value for 'archived'
 *      filterOnType: // value for 'filterOnType'
 *   },
 * });
 */
export function useEmployeeFeedQuery(baseOptions: Apollo.QueryHookOptions<EmployeeFeedQuery, EmployeeFeedQueryVariables> & ({ variables: EmployeeFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeFeedQuery, EmployeeFeedQueryVariables>(EmployeeFeedDocument, options);
      }
export function useEmployeeFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeFeedQuery, EmployeeFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeFeedQuery, EmployeeFeedQueryVariables>(EmployeeFeedDocument, options);
        }
// @ts-ignore
export function useEmployeeFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeFeedQuery, EmployeeFeedQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeFeedQuery, EmployeeFeedQueryVariables>;
export function useEmployeeFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeFeedQuery, EmployeeFeedQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeFeedQuery | undefined, EmployeeFeedQueryVariables>;
export function useEmployeeFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeFeedQuery, EmployeeFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeFeedQuery, EmployeeFeedQueryVariables>(EmployeeFeedDocument, options);
        }
export type EmployeeFeedQueryHookResult = ReturnType<typeof useEmployeeFeedQuery>;
export type EmployeeFeedLazyQueryHookResult = ReturnType<typeof useEmployeeFeedLazyQuery>;
export type EmployeeFeedSuspenseQueryHookResult = ReturnType<typeof useEmployeeFeedSuspenseQuery>;
export type EmployeeFeedQueryResult = Apollo.QueryResult<EmployeeFeedQuery, EmployeeFeedQueryVariables>;
export const EmployeeFeedHeaderDocument = gql`
    query EmployeeFeedHeader($userID: ID!) {
  user(id: $userID) {
    id
    firstName
    lastName
    avatar {
      source {
        url
      }
    }
  }
}
    `;

/**
 * __useEmployeeFeedHeaderQuery__
 *
 * To run a query within a React component, call `useEmployeeFeedHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeFeedHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeFeedHeaderQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useEmployeeFeedHeaderQuery(baseOptions: Apollo.QueryHookOptions<EmployeeFeedHeaderQuery, EmployeeFeedHeaderQueryVariables> & ({ variables: EmployeeFeedHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeFeedHeaderQuery, EmployeeFeedHeaderQueryVariables>(EmployeeFeedHeaderDocument, options);
      }
export function useEmployeeFeedHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeFeedHeaderQuery, EmployeeFeedHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeFeedHeaderQuery, EmployeeFeedHeaderQueryVariables>(EmployeeFeedHeaderDocument, options);
        }
// @ts-ignore
export function useEmployeeFeedHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeFeedHeaderQuery, EmployeeFeedHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeFeedHeaderQuery, EmployeeFeedHeaderQueryVariables>;
export function useEmployeeFeedHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeFeedHeaderQuery, EmployeeFeedHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeFeedHeaderQuery | undefined, EmployeeFeedHeaderQueryVariables>;
export function useEmployeeFeedHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeFeedHeaderQuery, EmployeeFeedHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeFeedHeaderQuery, EmployeeFeedHeaderQueryVariables>(EmployeeFeedHeaderDocument, options);
        }
export type EmployeeFeedHeaderQueryHookResult = ReturnType<typeof useEmployeeFeedHeaderQuery>;
export type EmployeeFeedHeaderLazyQueryHookResult = ReturnType<typeof useEmployeeFeedHeaderLazyQuery>;
export type EmployeeFeedHeaderSuspenseQueryHookResult = ReturnType<typeof useEmployeeFeedHeaderSuspenseQuery>;
export type EmployeeFeedHeaderQueryResult = Apollo.QueryResult<EmployeeFeedHeaderQuery, EmployeeFeedHeaderQueryVariables>;
export const GroupFeedDocument = gql`
    query GroupFeed($groupID: ID!) {
  group(id: $groupID) {
    id
    name
  }
}
    `;

/**
 * __useGroupFeedQuery__
 *
 * To run a query within a React component, call `useGroupFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupFeedQuery({
 *   variables: {
 *      groupID: // value for 'groupID'
 *   },
 * });
 */
export function useGroupFeedQuery(baseOptions: Apollo.QueryHookOptions<GroupFeedQuery, GroupFeedQueryVariables> & ({ variables: GroupFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupFeedQuery, GroupFeedQueryVariables>(GroupFeedDocument, options);
      }
export function useGroupFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupFeedQuery, GroupFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupFeedQuery, GroupFeedQueryVariables>(GroupFeedDocument, options);
        }
// @ts-ignore
export function useGroupFeedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupFeedQuery, GroupFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GroupFeedQuery, GroupFeedQueryVariables>;
export function useGroupFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupFeedQuery, GroupFeedQueryVariables>): Apollo.UseSuspenseQueryResult<GroupFeedQuery | undefined, GroupFeedQueryVariables>;
export function useGroupFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupFeedQuery, GroupFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupFeedQuery, GroupFeedQueryVariables>(GroupFeedDocument, options);
        }
export type GroupFeedQueryHookResult = ReturnType<typeof useGroupFeedQuery>;
export type GroupFeedLazyQueryHookResult = ReturnType<typeof useGroupFeedLazyQuery>;
export type GroupFeedSuspenseQueryHookResult = ReturnType<typeof useGroupFeedSuspenseQuery>;
export type GroupFeedQueryResult = Apollo.QueryResult<GroupFeedQuery, GroupFeedQueryVariables>;
export const GroupTasksDocument = gql`
    query GroupTasks($groupID: ID!) {
  group(id: $groupID) {
    id
    tasks {
      ...Task
    }
  }
}
    ${TaskFragmentDoc}`;

/**
 * __useGroupTasksQuery__
 *
 * To run a query within a React component, call `useGroupTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupTasksQuery({
 *   variables: {
 *      groupID: // value for 'groupID'
 *   },
 * });
 */
export function useGroupTasksQuery(baseOptions: Apollo.QueryHookOptions<GroupTasksQuery, GroupTasksQueryVariables> & ({ variables: GroupTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupTasksQuery, GroupTasksQueryVariables>(GroupTasksDocument, options);
      }
export function useGroupTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupTasksQuery, GroupTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupTasksQuery, GroupTasksQueryVariables>(GroupTasksDocument, options);
        }
// @ts-ignore
export function useGroupTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupTasksQuery, GroupTasksQueryVariables>): Apollo.UseSuspenseQueryResult<GroupTasksQuery, GroupTasksQueryVariables>;
export function useGroupTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupTasksQuery, GroupTasksQueryVariables>): Apollo.UseSuspenseQueryResult<GroupTasksQuery | undefined, GroupTasksQueryVariables>;
export function useGroupTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupTasksQuery, GroupTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupTasksQuery, GroupTasksQueryVariables>(GroupTasksDocument, options);
        }
export type GroupTasksQueryHookResult = ReturnType<typeof useGroupTasksQuery>;
export type GroupTasksLazyQueryHookResult = ReturnType<typeof useGroupTasksLazyQuery>;
export type GroupTasksSuspenseQueryHookResult = ReturnType<typeof useGroupTasksSuspenseQuery>;
export type GroupTasksQueryResult = Apollo.QueryResult<GroupTasksQuery, GroupTasksQueryVariables>;
export const ReorderTaskDocument = gql`
    mutation ReorderTask($input: ReorderTaskInput!) {
  reorderTask(input: $input) {
    task {
      id
      order
    }
  }
}
    `;
export type ReorderTaskMutationFn = Apollo.MutationFunction<ReorderTaskMutation, ReorderTaskMutationVariables>;

/**
 * __useReorderTaskMutation__
 *
 * To run a mutation, you first call `useReorderTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderTaskMutation, { data, loading, error }] = useReorderTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderTaskMutation(baseOptions?: Apollo.MutationHookOptions<ReorderTaskMutation, ReorderTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderTaskMutation, ReorderTaskMutationVariables>(ReorderTaskDocument, options);
      }
export type ReorderTaskMutationHookResult = ReturnType<typeof useReorderTaskMutation>;
export type ReorderTaskMutationResult = Apollo.MutationResult<ReorderTaskMutation>;
export type ReorderTaskMutationOptions = Apollo.BaseMutationOptions<ReorderTaskMutation, ReorderTaskMutationVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($input: UpdateTaskInput!) {
  updateTask(input: $input) {
    task {
      ...Task
    }
  }
}
    ${TaskFragmentDoc}`;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const UserDevelopmentItemsDocument = gql`
    query UserDevelopmentItems($id: ID!, $status: GoalStatus!, $isArchived: Boolean!, $before: ID, $last: Int!) {
  user(id: $id) {
    id
    firstName
    lastName
    feedbackRequests(isArchived: $isArchived, before: $before, last: $last) {
      edges {
        node {
          id
          title
          createdAt
          dueDate
          isArchived
          mode
          instruction
          responses(isArchived: false, first: 1000) {
            edges {
              node {
                id
                status
                recipient {
                  ... on User {
                    id
                    firstName
                    lastName
                    avatar {
                      id
                      source {
                        url
                      }
                    }
                  }
                  ... on FeedbackExternal {
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
    documentsV2 {
      ...UserDocumentV2
    }
    evaluationSubmissions(isArchived: $isArchived, before: $before, last: $last) {
      edges {
        node {
          ...EvaluationSubmissionCard
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
    goalsV2(status: $status, before: $before, last: $last) {
      edges {
        node {
          ...MetaGoal
          ...GoalWithOwner
        }
      }
      pageInfo {
        ...PageInfo
      }
      totalCount
    }
    ...UserCompetenciesPartial
  }
}
    ${UserDocumentV2FragmentDoc}
${EvaluationSubmissionCardFragmentDoc}
${MetaGoalFragmentDoc}
${GoalWithOwnerFragmentDoc}
${PageInfoFragmentDoc}
${UserCompetenciesPartialFragmentDoc}`;

/**
 * __useUserDevelopmentItemsQuery__
 *
 * To run a query within a React component, call `useUserDevelopmentItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDevelopmentItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDevelopmentItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useUserDevelopmentItemsQuery(baseOptions: Apollo.QueryHookOptions<UserDevelopmentItemsQuery, UserDevelopmentItemsQueryVariables> & ({ variables: UserDevelopmentItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDevelopmentItemsQuery, UserDevelopmentItemsQueryVariables>(UserDevelopmentItemsDocument, options);
      }
export function useUserDevelopmentItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDevelopmentItemsQuery, UserDevelopmentItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDevelopmentItemsQuery, UserDevelopmentItemsQueryVariables>(UserDevelopmentItemsDocument, options);
        }
// @ts-ignore
export function useUserDevelopmentItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserDevelopmentItemsQuery, UserDevelopmentItemsQueryVariables>): Apollo.UseSuspenseQueryResult<UserDevelopmentItemsQuery, UserDevelopmentItemsQueryVariables>;
export function useUserDevelopmentItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDevelopmentItemsQuery, UserDevelopmentItemsQueryVariables>): Apollo.UseSuspenseQueryResult<UserDevelopmentItemsQuery | undefined, UserDevelopmentItemsQueryVariables>;
export function useUserDevelopmentItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDevelopmentItemsQuery, UserDevelopmentItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserDevelopmentItemsQuery, UserDevelopmentItemsQueryVariables>(UserDevelopmentItemsDocument, options);
        }
export type UserDevelopmentItemsQueryHookResult = ReturnType<typeof useUserDevelopmentItemsQuery>;
export type UserDevelopmentItemsLazyQueryHookResult = ReturnType<typeof useUserDevelopmentItemsLazyQuery>;
export type UserDevelopmentItemsSuspenseQueryHookResult = ReturnType<typeof useUserDevelopmentItemsSuspenseQuery>;
export type UserDevelopmentItemsQueryResult = Apollo.QueryResult<UserDevelopmentItemsQuery, UserDevelopmentItemsQueryVariables>;
export const UserTasksDocument = gql`
    query UserTasks($userID: ID!) {
  user(id: $userID) {
    id
    tasks {
      ...Task
    }
  }
}
    ${TaskFragmentDoc}`;

/**
 * __useUserTasksQuery__
 *
 * To run a query within a React component, call `useUserTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTasksQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useUserTasksQuery(baseOptions: Apollo.QueryHookOptions<UserTasksQuery, UserTasksQueryVariables> & ({ variables: UserTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTasksQuery, UserTasksQueryVariables>(UserTasksDocument, options);
      }
export function useUserTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTasksQuery, UserTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTasksQuery, UserTasksQueryVariables>(UserTasksDocument, options);
        }
// @ts-ignore
export function useUserTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserTasksQuery, UserTasksQueryVariables>): Apollo.UseSuspenseQueryResult<UserTasksQuery, UserTasksQueryVariables>;
export function useUserTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserTasksQuery, UserTasksQueryVariables>): Apollo.UseSuspenseQueryResult<UserTasksQuery | undefined, UserTasksQueryVariables>;
export function useUserTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserTasksQuery, UserTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserTasksQuery, UserTasksQueryVariables>(UserTasksDocument, options);
        }
export type UserTasksQueryHookResult = ReturnType<typeof useUserTasksQuery>;
export type UserTasksLazyQueryHookResult = ReturnType<typeof useUserTasksLazyQuery>;
export type UserTasksSuspenseQueryHookResult = ReturnType<typeof useUserTasksSuspenseQuery>;
export type UserTasksQueryResult = Apollo.QueryResult<UserTasksQuery, UserTasksQueryVariables>;
export const ViewerTasksDocument = gql`
    query ViewerTasks {
  viewer {
    id
    firstName
    lastName
    avatar {
      source {
        url
      }
    }
    createdTasks {
      ...Task
    }
  }
}
    ${TaskFragmentDoc}`;

/**
 * __useViewerTasksQuery__
 *
 * To run a query within a React component, call `useViewerTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerTasksQuery(baseOptions?: Apollo.QueryHookOptions<ViewerTasksQuery, ViewerTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerTasksQuery, ViewerTasksQueryVariables>(ViewerTasksDocument, options);
      }
export function useViewerTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerTasksQuery, ViewerTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerTasksQuery, ViewerTasksQueryVariables>(ViewerTasksDocument, options);
        }
// @ts-ignore
export function useViewerTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerTasksQuery, ViewerTasksQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerTasksQuery, ViewerTasksQueryVariables>;
export function useViewerTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerTasksQuery, ViewerTasksQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerTasksQuery | undefined, ViewerTasksQueryVariables>;
export function useViewerTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerTasksQuery, ViewerTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewerTasksQuery, ViewerTasksQueryVariables>(ViewerTasksDocument, options);
        }
export type ViewerTasksQueryHookResult = ReturnType<typeof useViewerTasksQuery>;
export type ViewerTasksLazyQueryHookResult = ReturnType<typeof useViewerTasksLazyQuery>;
export type ViewerTasksSuspenseQueryHookResult = ReturnType<typeof useViewerTasksSuspenseQuery>;
export type ViewerTasksQueryResult = Apollo.QueryResult<ViewerTasksQuery, ViewerTasksQueryVariables>;
export const CancelMeetingDocument = gql`
    mutation CancelMeeting($input: CancelMeetingInput!) {
  cancelMeeting(input: $input) {
    meeting {
      ...Meeting
    }
  }
}
    ${MeetingFragmentDoc}`;
export type CancelMeetingMutationFn = Apollo.MutationFunction<CancelMeetingMutation, CancelMeetingMutationVariables>;

/**
 * __useCancelMeetingMutation__
 *
 * To run a mutation, you first call `useCancelMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMeetingMutation, { data, loading, error }] = useCancelMeetingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelMeetingMutation(baseOptions?: Apollo.MutationHookOptions<CancelMeetingMutation, CancelMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMeetingMutation, CancelMeetingMutationVariables>(CancelMeetingDocument, options);
      }
export type CancelMeetingMutationHookResult = ReturnType<typeof useCancelMeetingMutation>;
export type CancelMeetingMutationResult = Apollo.MutationResult<CancelMeetingMutation>;
export type CancelMeetingMutationOptions = Apollo.BaseMutationOptions<CancelMeetingMutation, CancelMeetingMutationVariables>;
export const CreateMeetingDocument = gql`
    mutation CreateMeeting($input: CreateMeetingInput!) {
  createMeeting(input: $input) {
    meeting {
      ...Meeting
    }
  }
}
    ${MeetingFragmentDoc}`;
export type CreateMeetingMutationFn = Apollo.MutationFunction<CreateMeetingMutation, CreateMeetingMutationVariables>;

/**
 * __useCreateMeetingMutation__
 *
 * To run a mutation, you first call `useCreateMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeetingMutation, { data, loading, error }] = useCreateMeetingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMeetingMutation(baseOptions?: Apollo.MutationHookOptions<CreateMeetingMutation, CreateMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMeetingMutation, CreateMeetingMutationVariables>(CreateMeetingDocument, options);
      }
export type CreateMeetingMutationHookResult = ReturnType<typeof useCreateMeetingMutation>;
export type CreateMeetingMutationResult = Apollo.MutationResult<CreateMeetingMutation>;
export type CreateMeetingMutationOptions = Apollo.BaseMutationOptions<CreateMeetingMutation, CreateMeetingMutationVariables>;
export const RestoreMeetingDocument = gql`
    mutation RestoreMeeting($input: RestoreMeetingInput!) {
  restoreMeeting(input: $input) {
    meeting {
      ...Meeting
    }
  }
}
    ${MeetingFragmentDoc}`;
export type RestoreMeetingMutationFn = Apollo.MutationFunction<RestoreMeetingMutation, RestoreMeetingMutationVariables>;

/**
 * __useRestoreMeetingMutation__
 *
 * To run a mutation, you first call `useRestoreMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreMeetingMutation, { data, loading, error }] = useRestoreMeetingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreMeetingMutation(baseOptions?: Apollo.MutationHookOptions<RestoreMeetingMutation, RestoreMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreMeetingMutation, RestoreMeetingMutationVariables>(RestoreMeetingDocument, options);
      }
export type RestoreMeetingMutationHookResult = ReturnType<typeof useRestoreMeetingMutation>;
export type RestoreMeetingMutationResult = Apollo.MutationResult<RestoreMeetingMutation>;
export type RestoreMeetingMutationOptions = Apollo.BaseMutationOptions<RestoreMeetingMutation, RestoreMeetingMutationVariables>;
export const UpdateMeetingDocument = gql`
    mutation UpdateMeeting($input: UpdateMeetingInput!) {
  updateMeeting(input: $input) {
    meeting {
      ...Meeting
    }
  }
}
    ${MeetingFragmentDoc}`;
export type UpdateMeetingMutationFn = Apollo.MutationFunction<UpdateMeetingMutation, UpdateMeetingMutationVariables>;

/**
 * __useUpdateMeetingMutation__
 *
 * To run a mutation, you first call `useUpdateMeetingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeetingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeetingMutation, { data, loading, error }] = useUpdateMeetingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMeetingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeetingMutation, UpdateMeetingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeetingMutation, UpdateMeetingMutationVariables>(UpdateMeetingDocument, options);
      }
export type UpdateMeetingMutationHookResult = ReturnType<typeof useUpdateMeetingMutation>;
export type UpdateMeetingMutationResult = Apollo.MutationResult<UpdateMeetingMutation>;
export type UpdateMeetingMutationOptions = Apollo.BaseMutationOptions<UpdateMeetingMutation, UpdateMeetingMutationVariables>;
export const ArchiveCommentDocument = gql`
    mutation ArchiveComment($input: ArchiveCommentInput!) {
  archiveComment(input: $input) {
    comment {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveCommentMutationFn = Apollo.MutationFunction<ArchiveCommentMutation, ArchiveCommentMutationVariables>;

/**
 * __useArchiveCommentMutation__
 *
 * To run a mutation, you first call `useArchiveCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCommentMutation, { data, loading, error }] = useArchiveCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveCommentMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCommentMutation, ArchiveCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCommentMutation, ArchiveCommentMutationVariables>(ArchiveCommentDocument, options);
      }
export type ArchiveCommentMutationHookResult = ReturnType<typeof useArchiveCommentMutation>;
export type ArchiveCommentMutationResult = Apollo.MutationResult<ArchiveCommentMutation>;
export type ArchiveCommentMutationOptions = Apollo.BaseMutationOptions<ArchiveCommentMutation, ArchiveCommentMutationVariables>;
export const ArchiveNoteDocument = gql`
    mutation ArchiveNote($input: ArchiveNoteInput!) {
  archiveNote(input: $input) {
    note {
      id
      isArchived
      viewerCanArchive
      viewerCanRestore
    }
  }
}
    `;
export type ArchiveNoteMutationFn = Apollo.MutationFunction<ArchiveNoteMutation, ArchiveNoteMutationVariables>;

/**
 * __useArchiveNoteMutation__
 *
 * To run a mutation, you first call `useArchiveNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveNoteMutation, { data, loading, error }] = useArchiveNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveNoteMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveNoteMutation, ArchiveNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveNoteMutation, ArchiveNoteMutationVariables>(ArchiveNoteDocument, options);
      }
export type ArchiveNoteMutationHookResult = ReturnType<typeof useArchiveNoteMutation>;
export type ArchiveNoteMutationResult = Apollo.MutationResult<ArchiveNoteMutation>;
export type ArchiveNoteMutationOptions = Apollo.BaseMutationOptions<ArchiveNoteMutation, ArchiveNoteMutationVariables>;
export const CommentDocument = gql`
    mutation Comment($input: UpdateCommentInput!) {
  updateComment(input: $input) {
    comment {
      id
      content
    }
  }
}
    `;
export type CommentMutationFn = Apollo.MutationFunction<CommentMutation, CommentMutationVariables>;

/**
 * __useCommentMutation__
 *
 * To run a mutation, you first call `useCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentMutation, { data, loading, error }] = useCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommentMutation(baseOptions?: Apollo.MutationHookOptions<CommentMutation, CommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommentMutation, CommentMutationVariables>(CommentDocument, options);
      }
export type CommentMutationHookResult = ReturnType<typeof useCommentMutation>;
export type CommentMutationResult = Apollo.MutationResult<CommentMutation>;
export type CommentMutationOptions = Apollo.BaseMutationOptions<CommentMutation, CommentMutationVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($input: CreateCommentInput!) {
  createComment(input: $input) {
    comment {
      ...Comment
      target {
        ... on FeedbackResponse {
          ...FeedbackResponse
        }
      }
    }
  }
}
    ${CommentFragmentDoc}
${FeedbackResponseFragmentDoc}`;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const CreateNoteDocument = gql`
    mutation CreateNote($input: CreateNoteInput!) {
  createNote(input: $input) {
    note {
      ...Note
    }
  }
}
    ${NoteFragmentDoc}`;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const LinkEntityToNoteDocument = gql`
    mutation LinkEntityToNote($input: LinkEntityToNoteInput!) {
  linkEntityToNote(input: $input) {
    note {
      ...Note
    }
  }
}
    ${NoteFragmentDoc}`;
export type LinkEntityToNoteMutationFn = Apollo.MutationFunction<LinkEntityToNoteMutation, LinkEntityToNoteMutationVariables>;

/**
 * __useLinkEntityToNoteMutation__
 *
 * To run a mutation, you first call `useLinkEntityToNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkEntityToNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkEntityToNoteMutation, { data, loading, error }] = useLinkEntityToNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkEntityToNoteMutation(baseOptions?: Apollo.MutationHookOptions<LinkEntityToNoteMutation, LinkEntityToNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkEntityToNoteMutation, LinkEntityToNoteMutationVariables>(LinkEntityToNoteDocument, options);
      }
export type LinkEntityToNoteMutationHookResult = ReturnType<typeof useLinkEntityToNoteMutation>;
export type LinkEntityToNoteMutationResult = Apollo.MutationResult<LinkEntityToNoteMutation>;
export type LinkEntityToNoteMutationOptions = Apollo.BaseMutationOptions<LinkEntityToNoteMutation, LinkEntityToNoteMutationVariables>;
export const RestoreNoteDocument = gql`
    mutation RestoreNote($input: RestoreNoteInput!) {
  restoreNote(input: $input) {
    note {
      id
      isArchived
      viewerCanArchive
      viewerCanRestore
    }
  }
}
    `;
export type RestoreNoteMutationFn = Apollo.MutationFunction<RestoreNoteMutation, RestoreNoteMutationVariables>;

/**
 * __useRestoreNoteMutation__
 *
 * To run a mutation, you first call `useRestoreNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreNoteMutation, { data, loading, error }] = useRestoreNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreNoteMutation(baseOptions?: Apollo.MutationHookOptions<RestoreNoteMutation, RestoreNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreNoteMutation, RestoreNoteMutationVariables>(RestoreNoteDocument, options);
      }
export type RestoreNoteMutationHookResult = ReturnType<typeof useRestoreNoteMutation>;
export type RestoreNoteMutationResult = Apollo.MutationResult<RestoreNoteMutation>;
export type RestoreNoteMutationOptions = Apollo.BaseMutationOptions<RestoreNoteMutation, RestoreNoteMutationVariables>;
export const ShareNoteDocument = gql`
    mutation ShareNote($input: ShareNoteInput!) {
  shareNote(input: $input) {
    note {
      ...Note
    }
  }
}
    ${NoteFragmentDoc}`;
export type ShareNoteMutationFn = Apollo.MutationFunction<ShareNoteMutation, ShareNoteMutationVariables>;

/**
 * __useShareNoteMutation__
 *
 * To run a mutation, you first call `useShareNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareNoteMutation, { data, loading, error }] = useShareNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareNoteMutation(baseOptions?: Apollo.MutationHookOptions<ShareNoteMutation, ShareNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareNoteMutation, ShareNoteMutationVariables>(ShareNoteDocument, options);
      }
export type ShareNoteMutationHookResult = ReturnType<typeof useShareNoteMutation>;
export type ShareNoteMutationResult = Apollo.MutationResult<ShareNoteMutation>;
export type ShareNoteMutationOptions = Apollo.BaseMutationOptions<ShareNoteMutation, ShareNoteMutationVariables>;
export const UnlinkTranscriptionFromNoteDocument = gql`
    mutation UnlinkTranscriptionFromNote($input: UnlinkTranscriptionFromNoteInput!) {
  unlinkTranscriptionFromNote(input: $input) {
    success
  }
}
    `;
export type UnlinkTranscriptionFromNoteMutationFn = Apollo.MutationFunction<UnlinkTranscriptionFromNoteMutation, UnlinkTranscriptionFromNoteMutationVariables>;

/**
 * __useUnlinkTranscriptionFromNoteMutation__
 *
 * To run a mutation, you first call `useUnlinkTranscriptionFromNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkTranscriptionFromNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkTranscriptionFromNoteMutation, { data, loading, error }] = useUnlinkTranscriptionFromNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkTranscriptionFromNoteMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkTranscriptionFromNoteMutation, UnlinkTranscriptionFromNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkTranscriptionFromNoteMutation, UnlinkTranscriptionFromNoteMutationVariables>(UnlinkTranscriptionFromNoteDocument, options);
      }
export type UnlinkTranscriptionFromNoteMutationHookResult = ReturnType<typeof useUnlinkTranscriptionFromNoteMutation>;
export type UnlinkTranscriptionFromNoteMutationResult = Apollo.MutationResult<UnlinkTranscriptionFromNoteMutation>;
export type UnlinkTranscriptionFromNoteMutationOptions = Apollo.BaseMutationOptions<UnlinkTranscriptionFromNoteMutation, UnlinkTranscriptionFromNoteMutationVariables>;
export const UnshareNoteDocument = gql`
    mutation UnshareNote($input: UnshareNoteInput!) {
  unshareNote(input: $input) {
    note {
      ...Note
    }
  }
}
    ${NoteFragmentDoc}`;
export type UnshareNoteMutationFn = Apollo.MutationFunction<UnshareNoteMutation, UnshareNoteMutationVariables>;

/**
 * __useUnshareNoteMutation__
 *
 * To run a mutation, you first call `useUnshareNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnshareNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unshareNoteMutation, { data, loading, error }] = useUnshareNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnshareNoteMutation(baseOptions?: Apollo.MutationHookOptions<UnshareNoteMutation, UnshareNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnshareNoteMutation, UnshareNoteMutationVariables>(UnshareNoteDocument, options);
      }
export type UnshareNoteMutationHookResult = ReturnType<typeof useUnshareNoteMutation>;
export type UnshareNoteMutationResult = Apollo.MutationResult<UnshareNoteMutation>;
export type UnshareNoteMutationOptions = Apollo.BaseMutationOptions<UnshareNoteMutation, UnshareNoteMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation UpdateNote($input: UpdateNoteInput!) {
  updateNote(input: $input) {
    note {
      ...Note
    }
  }
}
    ${NoteFragmentDoc}`;
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const UpdateNotePreparationDocument = gql`
    mutation UpdateNotePreparation($input: UpdateNotePreparationInput!) {
  updateNotePreparation(input: $input) {
    note {
      id
      preparation
    }
  }
}
    `;
export type UpdateNotePreparationMutationFn = Apollo.MutationFunction<UpdateNotePreparationMutation, UpdateNotePreparationMutationVariables>;

/**
 * __useUpdateNotePreparationMutation__
 *
 * To run a mutation, you first call `useUpdateNotePreparationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotePreparationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotePreparationMutation, { data, loading, error }] = useUpdateNotePreparationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotePreparationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotePreparationMutation, UpdateNotePreparationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotePreparationMutation, UpdateNotePreparationMutationVariables>(UpdateNotePreparationDocument, options);
      }
export type UpdateNotePreparationMutationHookResult = ReturnType<typeof useUpdateNotePreparationMutation>;
export type UpdateNotePreparationMutationResult = Apollo.MutationResult<UpdateNotePreparationMutation>;
export type UpdateNotePreparationMutationOptions = Apollo.BaseMutationOptions<UpdateNotePreparationMutation, UpdateNotePreparationMutationVariables>;
export const CommentsDocument = gql`
    query Comments($targetID: ID!, $targetType: CommentTargetType!) {
  comments(targetID: $targetID, targetType: $targetType) {
    ...Comment
  }
}
    ${CommentFragmentDoc}`;

/**
 * __useCommentsQuery__
 *
 * To run a query within a React component, call `useCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentsQuery({
 *   variables: {
 *      targetID: // value for 'targetID'
 *      targetType: // value for 'targetType'
 *   },
 * });
 */
export function useCommentsQuery(baseOptions: Apollo.QueryHookOptions<CommentsQuery, CommentsQueryVariables> & ({ variables: CommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
      }
export function useCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
        }
// @ts-ignore
export function useCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommentsQuery, CommentsQueryVariables>): Apollo.UseSuspenseQueryResult<CommentsQuery, CommentsQueryVariables>;
export function useCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommentsQuery, CommentsQueryVariables>): Apollo.UseSuspenseQueryResult<CommentsQuery | undefined, CommentsQueryVariables>;
export function useCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
        }
export type CommentsQueryHookResult = ReturnType<typeof useCommentsQuery>;
export type CommentsLazyQueryHookResult = ReturnType<typeof useCommentsLazyQuery>;
export type CommentsSuspenseQueryHookResult = ReturnType<typeof useCommentsSuspenseQuery>;
export type CommentsQueryResult = Apollo.QueryResult<CommentsQuery, CommentsQueryVariables>;
export const MutualNoteCollaboratorsDocument = gql`
    query MutualNoteCollaborators {
  mutualNoteCollaborators {
    user {
      id
      avatar {
        id
        source {
          url
        }
      }
      firstName
      lastName
    }
    count
  }
}
    `;

/**
 * __useMutualNoteCollaboratorsQuery__
 *
 * To run a query within a React component, call `useMutualNoteCollaboratorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMutualNoteCollaboratorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMutualNoteCollaboratorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMutualNoteCollaboratorsQuery(baseOptions?: Apollo.QueryHookOptions<MutualNoteCollaboratorsQuery, MutualNoteCollaboratorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MutualNoteCollaboratorsQuery, MutualNoteCollaboratorsQueryVariables>(MutualNoteCollaboratorsDocument, options);
      }
export function useMutualNoteCollaboratorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MutualNoteCollaboratorsQuery, MutualNoteCollaboratorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MutualNoteCollaboratorsQuery, MutualNoteCollaboratorsQueryVariables>(MutualNoteCollaboratorsDocument, options);
        }
// @ts-ignore
export function useMutualNoteCollaboratorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MutualNoteCollaboratorsQuery, MutualNoteCollaboratorsQueryVariables>): Apollo.UseSuspenseQueryResult<MutualNoteCollaboratorsQuery, MutualNoteCollaboratorsQueryVariables>;
export function useMutualNoteCollaboratorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MutualNoteCollaboratorsQuery, MutualNoteCollaboratorsQueryVariables>): Apollo.UseSuspenseQueryResult<MutualNoteCollaboratorsQuery | undefined, MutualNoteCollaboratorsQueryVariables>;
export function useMutualNoteCollaboratorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MutualNoteCollaboratorsQuery, MutualNoteCollaboratorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MutualNoteCollaboratorsQuery, MutualNoteCollaboratorsQueryVariables>(MutualNoteCollaboratorsDocument, options);
        }
export type MutualNoteCollaboratorsQueryHookResult = ReturnType<typeof useMutualNoteCollaboratorsQuery>;
export type MutualNoteCollaboratorsLazyQueryHookResult = ReturnType<typeof useMutualNoteCollaboratorsLazyQuery>;
export type MutualNoteCollaboratorsSuspenseQueryHookResult = ReturnType<typeof useMutualNoteCollaboratorsSuspenseQuery>;
export type MutualNoteCollaboratorsQueryResult = Apollo.QueryResult<MutualNoteCollaboratorsQuery, MutualNoteCollaboratorsQueryVariables>;
export const MutualNotesDocument = gql`
    query MutualNotes($id: ID!, $first: Int, $last: Int, $before: ID, $after: ID, $filters: MutualNotesFilters) {
  user(id: $id) {
    mutualNotes(
      first: $first
      last: $last
      before: $before
      after: $after
      filters: $filters
    ) {
      edges {
        node {
          ...NoteForCard
        }
      }
    }
  }
}
    ${NoteForCardFragmentDoc}`;

/**
 * __useMutualNotesQuery__
 *
 * To run a query within a React component, call `useMutualNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMutualNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMutualNotesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useMutualNotesQuery(baseOptions: Apollo.QueryHookOptions<MutualNotesQuery, MutualNotesQueryVariables> & ({ variables: MutualNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MutualNotesQuery, MutualNotesQueryVariables>(MutualNotesDocument, options);
      }
export function useMutualNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MutualNotesQuery, MutualNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MutualNotesQuery, MutualNotesQueryVariables>(MutualNotesDocument, options);
        }
// @ts-ignore
export function useMutualNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MutualNotesQuery, MutualNotesQueryVariables>): Apollo.UseSuspenseQueryResult<MutualNotesQuery, MutualNotesQueryVariables>;
export function useMutualNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MutualNotesQuery, MutualNotesQueryVariables>): Apollo.UseSuspenseQueryResult<MutualNotesQuery | undefined, MutualNotesQueryVariables>;
export function useMutualNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MutualNotesQuery, MutualNotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MutualNotesQuery, MutualNotesQueryVariables>(MutualNotesDocument, options);
        }
export type MutualNotesQueryHookResult = ReturnType<typeof useMutualNotesQuery>;
export type MutualNotesLazyQueryHookResult = ReturnType<typeof useMutualNotesLazyQuery>;
export type MutualNotesSuspenseQueryHookResult = ReturnType<typeof useMutualNotesSuspenseQuery>;
export type MutualNotesQueryResult = Apollo.QueryResult<MutualNotesQuery, MutualNotesQueryVariables>;
export const NoteDocument = gql`
    query Note($id: ID!) {
  note(id: $id) {
    ...Note
  }
}
    ${NoteFragmentDoc}`;

/**
 * __useNoteQuery__
 *
 * To run a query within a React component, call `useNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNoteQuery(baseOptions: Apollo.QueryHookOptions<NoteQuery, NoteQueryVariables> & ({ variables: NoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoteQuery, NoteQueryVariables>(NoteDocument, options);
      }
export function useNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoteQuery, NoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoteQuery, NoteQueryVariables>(NoteDocument, options);
        }
// @ts-ignore
export function useNoteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NoteQuery, NoteQueryVariables>): Apollo.UseSuspenseQueryResult<NoteQuery, NoteQueryVariables>;
export function useNoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NoteQuery, NoteQueryVariables>): Apollo.UseSuspenseQueryResult<NoteQuery | undefined, NoteQueryVariables>;
export function useNoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NoteQuery, NoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NoteQuery, NoteQueryVariables>(NoteDocument, options);
        }
export type NoteQueryHookResult = ReturnType<typeof useNoteQuery>;
export type NoteLazyQueryHookResult = ReturnType<typeof useNoteLazyQuery>;
export type NoteSuspenseQueryHookResult = ReturnType<typeof useNoteSuspenseQuery>;
export type NoteQueryResult = Apollo.QueryResult<NoteQuery, NoteQueryVariables>;
export const NotesDocument = gql`
    query Notes($filters: NotesFilters, $first: Int, $last: Int, $before: ID, $after: ID) {
  notes(
    filters: $filters
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    edges {
      node {
        ...NoteForOneOnOneOverview
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
    ${NoteForOneOnOneOverviewFragmentDoc}`;

/**
 * __useNotesQuery__
 *
 * To run a query within a React component, call `useNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useNotesQuery(baseOptions?: Apollo.QueryHookOptions<NotesQuery, NotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options);
      }
export function useNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesQuery, NotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options);
        }
// @ts-ignore
export function useNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotesQuery, NotesQueryVariables>): Apollo.UseSuspenseQueryResult<NotesQuery, NotesQueryVariables>;
export function useNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotesQuery, NotesQueryVariables>): Apollo.UseSuspenseQueryResult<NotesQuery | undefined, NotesQueryVariables>;
export function useNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotesQuery, NotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotesQuery, NotesQueryVariables>(NotesDocument, options);
        }
export type NotesQueryHookResult = ReturnType<typeof useNotesQuery>;
export type NotesLazyQueryHookResult = ReturnType<typeof useNotesLazyQuery>;
export type NotesSuspenseQueryHookResult = ReturnType<typeof useNotesSuspenseQuery>;
export type NotesQueryResult = Apollo.QueryResult<NotesQuery, NotesQueryVariables>;
export const NotesSidebarPeopleDocument = gql`
    query NotesSidebarPeople($recurse: Boolean!) {
  viewer {
    managees(recurse: $recurse) {
      id
      ...NotesSidebarUser
    }
  }
  noteSubjectsWithCount {
    user {
      ...NotesSidebarUser
    }
    count
  }
}
    ${NotesSidebarUserFragmentDoc}`;

/**
 * __useNotesSidebarPeopleQuery__
 *
 * To run a query within a React component, call `useNotesSidebarPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesSidebarPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesSidebarPeopleQuery({
 *   variables: {
 *      recurse: // value for 'recurse'
 *   },
 * });
 */
export function useNotesSidebarPeopleQuery(baseOptions: Apollo.QueryHookOptions<NotesSidebarPeopleQuery, NotesSidebarPeopleQueryVariables> & ({ variables: NotesSidebarPeopleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesSidebarPeopleQuery, NotesSidebarPeopleQueryVariables>(NotesSidebarPeopleDocument, options);
      }
export function useNotesSidebarPeopleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesSidebarPeopleQuery, NotesSidebarPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesSidebarPeopleQuery, NotesSidebarPeopleQueryVariables>(NotesSidebarPeopleDocument, options);
        }
// @ts-ignore
export function useNotesSidebarPeopleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotesSidebarPeopleQuery, NotesSidebarPeopleQueryVariables>): Apollo.UseSuspenseQueryResult<NotesSidebarPeopleQuery, NotesSidebarPeopleQueryVariables>;
export function useNotesSidebarPeopleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotesSidebarPeopleQuery, NotesSidebarPeopleQueryVariables>): Apollo.UseSuspenseQueryResult<NotesSidebarPeopleQuery | undefined, NotesSidebarPeopleQueryVariables>;
export function useNotesSidebarPeopleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotesSidebarPeopleQuery, NotesSidebarPeopleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotesSidebarPeopleQuery, NotesSidebarPeopleQueryVariables>(NotesSidebarPeopleDocument, options);
        }
export type NotesSidebarPeopleQueryHookResult = ReturnType<typeof useNotesSidebarPeopleQuery>;
export type NotesSidebarPeopleLazyQueryHookResult = ReturnType<typeof useNotesSidebarPeopleLazyQuery>;
export type NotesSidebarPeopleSuspenseQueryHookResult = ReturnType<typeof useNotesSidebarPeopleSuspenseQuery>;
export type NotesSidebarPeopleQueryResult = Apollo.QueryResult<NotesSidebarPeopleQuery, NotesSidebarPeopleQueryVariables>;
export const PromptNotesSummaryDocument = gql`
    query PromptNotesSummary($input: NotesSummaryInput!) {
  promptNotesSummary(input: $input) {
    notesSummary {
      bulletPoints
      sourceNotes {
        id
        title
        subject {
          id
          firstName
        }
      }
    }
  }
}
    `;

/**
 * __usePromptNotesSummaryQuery__
 *
 * To run a query within a React component, call `usePromptNotesSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromptNotesSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromptNotesSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePromptNotesSummaryQuery(baseOptions: Apollo.QueryHookOptions<PromptNotesSummaryQuery, PromptNotesSummaryQueryVariables> & ({ variables: PromptNotesSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromptNotesSummaryQuery, PromptNotesSummaryQueryVariables>(PromptNotesSummaryDocument, options);
      }
export function usePromptNotesSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromptNotesSummaryQuery, PromptNotesSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromptNotesSummaryQuery, PromptNotesSummaryQueryVariables>(PromptNotesSummaryDocument, options);
        }
// @ts-ignore
export function usePromptNotesSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromptNotesSummaryQuery, PromptNotesSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<PromptNotesSummaryQuery, PromptNotesSummaryQueryVariables>;
export function usePromptNotesSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromptNotesSummaryQuery, PromptNotesSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<PromptNotesSummaryQuery | undefined, PromptNotesSummaryQueryVariables>;
export function usePromptNotesSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PromptNotesSummaryQuery, PromptNotesSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromptNotesSummaryQuery, PromptNotesSummaryQueryVariables>(PromptNotesSummaryDocument, options);
        }
export type PromptNotesSummaryQueryHookResult = ReturnType<typeof usePromptNotesSummaryQuery>;
export type PromptNotesSummaryLazyQueryHookResult = ReturnType<typeof usePromptNotesSummaryLazyQuery>;
export type PromptNotesSummarySuspenseQueryHookResult = ReturnType<typeof usePromptNotesSummarySuspenseQuery>;
export type PromptNotesSummaryQueryResult = Apollo.QueryResult<PromptNotesSummaryQuery, PromptNotesSummaryQueryVariables>;
export const ApplyStyrJobMappingsDocument = gql`
    mutation ApplyStyrJobMappings($input: ApplyStyrJobMappingsInput!) {
  applyStyrJobMappings(input: $input)
}
    `;
export type ApplyStyrJobMappingsMutationFn = Apollo.MutationFunction<ApplyStyrJobMappingsMutation, ApplyStyrJobMappingsMutationVariables>;

/**
 * __useApplyStyrJobMappingsMutation__
 *
 * To run a mutation, you first call `useApplyStyrJobMappingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyStyrJobMappingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyStyrJobMappingsMutation, { data, loading, error }] = useApplyStyrJobMappingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyStyrJobMappingsMutation(baseOptions?: Apollo.MutationHookOptions<ApplyStyrJobMappingsMutation, ApplyStyrJobMappingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyStyrJobMappingsMutation, ApplyStyrJobMappingsMutationVariables>(ApplyStyrJobMappingsDocument, options);
      }
export type ApplyStyrJobMappingsMutationHookResult = ReturnType<typeof useApplyStyrJobMappingsMutation>;
export type ApplyStyrJobMappingsMutationResult = Apollo.MutationResult<ApplyStyrJobMappingsMutation>;
export type ApplyStyrJobMappingsMutationOptions = Apollo.BaseMutationOptions<ApplyStyrJobMappingsMutation, ApplyStyrJobMappingsMutationVariables>;
export const ApproveFeatureForViewerDocument = gql`
    mutation ApproveFeatureForViewer($input: ApproveFeatureConditionsInput!) {
  approveFeatureForViewer(input: $input) {
    approval {
      featureName
      approvedAt
      approvedBy {
        id
        username
      }
    }
  }
}
    `;
export type ApproveFeatureForViewerMutationFn = Apollo.MutationFunction<ApproveFeatureForViewerMutation, ApproveFeatureForViewerMutationVariables>;

/**
 * __useApproveFeatureForViewerMutation__
 *
 * To run a mutation, you first call `useApproveFeatureForViewerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveFeatureForViewerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveFeatureForViewerMutation, { data, loading, error }] = useApproveFeatureForViewerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveFeatureForViewerMutation(baseOptions?: Apollo.MutationHookOptions<ApproveFeatureForViewerMutation, ApproveFeatureForViewerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveFeatureForViewerMutation, ApproveFeatureForViewerMutationVariables>(ApproveFeatureForViewerDocument, options);
      }
export type ApproveFeatureForViewerMutationHookResult = ReturnType<typeof useApproveFeatureForViewerMutation>;
export type ApproveFeatureForViewerMutationResult = Apollo.MutationResult<ApproveFeatureForViewerMutation>;
export type ApproveFeatureForViewerMutationOptions = Apollo.BaseMutationOptions<ApproveFeatureForViewerMutation, ApproveFeatureForViewerMutationVariables>;
export const ApproveFeatureForWorkspaceDocument = gql`
    mutation ApproveFeatureForWorkspace($input: ApproveFeatureConditionsInput!) {
  approveFeatureForWorkspace(input: $input) {
    approval {
      featureName
      approvedAt
      approvedBy {
        id
        username
      }
    }
  }
}
    `;
export type ApproveFeatureForWorkspaceMutationFn = Apollo.MutationFunction<ApproveFeatureForWorkspaceMutation, ApproveFeatureForWorkspaceMutationVariables>;

/**
 * __useApproveFeatureForWorkspaceMutation__
 *
 * To run a mutation, you first call `useApproveFeatureForWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveFeatureForWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveFeatureForWorkspaceMutation, { data, loading, error }] = useApproveFeatureForWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveFeatureForWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<ApproveFeatureForWorkspaceMutation, ApproveFeatureForWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveFeatureForWorkspaceMutation, ApproveFeatureForWorkspaceMutationVariables>(ApproveFeatureForWorkspaceDocument, options);
      }
export type ApproveFeatureForWorkspaceMutationHookResult = ReturnType<typeof useApproveFeatureForWorkspaceMutation>;
export type ApproveFeatureForWorkspaceMutationResult = Apollo.MutationResult<ApproveFeatureForWorkspaceMutation>;
export type ApproveFeatureForWorkspaceMutationOptions = Apollo.BaseMutationOptions<ApproveFeatureForWorkspaceMutation, ApproveFeatureForWorkspaceMutationVariables>;
export const ArchiveGroupDocument = gql`
    mutation ArchiveGroup($input: ArchiveGroupInput!) {
  archiveGroup(input: $input) {
    group {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveGroupMutationFn = Apollo.MutationFunction<ArchiveGroupMutation, ArchiveGroupMutationVariables>;

/**
 * __useArchiveGroupMutation__
 *
 * To run a mutation, you first call `useArchiveGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveGroupMutation, { data, loading, error }] = useArchiveGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveGroupMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveGroupMutation, ArchiveGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveGroupMutation, ArchiveGroupMutationVariables>(ArchiveGroupDocument, options);
      }
export type ArchiveGroupMutationHookResult = ReturnType<typeof useArchiveGroupMutation>;
export type ArchiveGroupMutationResult = Apollo.MutationResult<ArchiveGroupMutation>;
export type ArchiveGroupMutationOptions = Apollo.BaseMutationOptions<ArchiveGroupMutation, ArchiveGroupMutationVariables>;
export const ArchiveWorkspaceDocument = gql`
    mutation ArchiveWorkspace($input: ArchiveWorkspaceInput!) {
  archiveWorkspace(input: $input) {
    workspace {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveWorkspaceMutationFn = Apollo.MutationFunction<ArchiveWorkspaceMutation, ArchiveWorkspaceMutationVariables>;

/**
 * __useArchiveWorkspaceMutation__
 *
 * To run a mutation, you first call `useArchiveWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveWorkspaceMutation, { data, loading, error }] = useArchiveWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveWorkspaceMutation, ArchiveWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveWorkspaceMutation, ArchiveWorkspaceMutationVariables>(ArchiveWorkspaceDocument, options);
      }
export type ArchiveWorkspaceMutationHookResult = ReturnType<typeof useArchiveWorkspaceMutation>;
export type ArchiveWorkspaceMutationResult = Apollo.MutationResult<ArchiveWorkspaceMutation>;
export type ArchiveWorkspaceMutationOptions = Apollo.BaseMutationOptions<ArchiveWorkspaceMutation, ArchiveWorkspaceMutationVariables>;
export const CreateGroupDocument = gql`
    mutation CreateGroup($input: CreateGroupInput!) {
  createGroup(input: $input) {
    group {
      id
      name
      type
      externalReferenceID
    }
  }
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const CreateWorkspaceDocument = gql`
    mutation CreateWorkspace($input: CreateWorkspaceInput!) {
  createWorkspace(input: $input) {
    workspace {
      id
      hubSpotCompanyID
    }
  }
}
    `;
export type CreateWorkspaceMutationFn = Apollo.MutationFunction<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;

/**
 * __useCreateWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceMutation, { data, loading, error }] = useCreateWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>(CreateWorkspaceDocument, options);
      }
export type CreateWorkspaceMutationHookResult = ReturnType<typeof useCreateWorkspaceMutation>;
export type CreateWorkspaceMutationResult = Apollo.MutationResult<CreateWorkspaceMutation>;
export type CreateWorkspaceMutationOptions = Apollo.BaseMutationOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;
export const CreateWorkspacePlanDocument = gql`
    mutation CreateWorkspacePlan($input: CreateWorkspacePlanInput!) {
  createWorkspacePlan(input: $input) {
    plan {
      ...WorkspacePlan
    }
  }
}
    ${WorkspacePlanFragmentDoc}`;
export type CreateWorkspacePlanMutationFn = Apollo.MutationFunction<CreateWorkspacePlanMutation, CreateWorkspacePlanMutationVariables>;

/**
 * __useCreateWorkspacePlanMutation__
 *
 * To run a mutation, you first call `useCreateWorkspacePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspacePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspacePlanMutation, { data, loading, error }] = useCreateWorkspacePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkspacePlanMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkspacePlanMutation, CreateWorkspacePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkspacePlanMutation, CreateWorkspacePlanMutationVariables>(CreateWorkspacePlanDocument, options);
      }
export type CreateWorkspacePlanMutationHookResult = ReturnType<typeof useCreateWorkspacePlanMutation>;
export type CreateWorkspacePlanMutationResult = Apollo.MutationResult<CreateWorkspacePlanMutation>;
export type CreateWorkspacePlanMutationOptions = Apollo.BaseMutationOptions<CreateWorkspacePlanMutation, CreateWorkspacePlanMutationVariables>;
export const EnableWorkspaceAiPlanDocument = gql`
    mutation EnableWorkspaceAiPlan {
  enableWorkspaceAiPlan {
    plan {
      ...WorkspacePlan
    }
  }
}
    ${WorkspacePlanFragmentDoc}`;
export type EnableWorkspaceAiPlanMutationFn = Apollo.MutationFunction<EnableWorkspaceAiPlanMutation, EnableWorkspaceAiPlanMutationVariables>;

/**
 * __useEnableWorkspaceAiPlanMutation__
 *
 * To run a mutation, you first call `useEnableWorkspaceAiPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableWorkspaceAiPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableWorkspaceAiPlanMutation, { data, loading, error }] = useEnableWorkspaceAiPlanMutation({
 *   variables: {
 *   },
 * });
 */
export function useEnableWorkspaceAiPlanMutation(baseOptions?: Apollo.MutationHookOptions<EnableWorkspaceAiPlanMutation, EnableWorkspaceAiPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableWorkspaceAiPlanMutation, EnableWorkspaceAiPlanMutationVariables>(EnableWorkspaceAiPlanDocument, options);
      }
export type EnableWorkspaceAiPlanMutationHookResult = ReturnType<typeof useEnableWorkspaceAiPlanMutation>;
export type EnableWorkspaceAiPlanMutationResult = Apollo.MutationResult<EnableWorkspaceAiPlanMutation>;
export type EnableWorkspaceAiPlanMutationOptions = Apollo.BaseMutationOptions<EnableWorkspaceAiPlanMutation, EnableWorkspaceAiPlanMutationVariables>;
export const MoveGroupDocument = gql`
    mutation MoveGroup($input: MoveGroupInput!) {
  moveGroup(input: $input) {
    group {
      id
      parent {
        id
      }
    }
  }
}
    `;
export type MoveGroupMutationFn = Apollo.MutationFunction<MoveGroupMutation, MoveGroupMutationVariables>;

/**
 * __useMoveGroupMutation__
 *
 * To run a mutation, you first call `useMoveGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveGroupMutation, { data, loading, error }] = useMoveGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveGroupMutation(baseOptions?: Apollo.MutationHookOptions<MoveGroupMutation, MoveGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveGroupMutation, MoveGroupMutationVariables>(MoveGroupDocument, options);
      }
export type MoveGroupMutationHookResult = ReturnType<typeof useMoveGroupMutation>;
export type MoveGroupMutationResult = Apollo.MutationResult<MoveGroupMutation>;
export type MoveGroupMutationOptions = Apollo.BaseMutationOptions<MoveGroupMutation, MoveGroupMutationVariables>;
export const RemoveWorkspacePlanDocument = gql`
    mutation RemoveWorkspacePlan($input: RemoveWorkspacePlanInput!) {
  removeWorkspacePlan(input: $input) {
    success
  }
}
    `;
export type RemoveWorkspacePlanMutationFn = Apollo.MutationFunction<RemoveWorkspacePlanMutation, RemoveWorkspacePlanMutationVariables>;

/**
 * __useRemoveWorkspacePlanMutation__
 *
 * To run a mutation, you first call `useRemoveWorkspacePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkspacePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkspacePlanMutation, { data, loading, error }] = useRemoveWorkspacePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveWorkspacePlanMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWorkspacePlanMutation, RemoveWorkspacePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWorkspacePlanMutation, RemoveWorkspacePlanMutationVariables>(RemoveWorkspacePlanDocument, options);
      }
export type RemoveWorkspacePlanMutationHookResult = ReturnType<typeof useRemoveWorkspacePlanMutation>;
export type RemoveWorkspacePlanMutationResult = Apollo.MutationResult<RemoveWorkspacePlanMutation>;
export type RemoveWorkspacePlanMutationOptions = Apollo.BaseMutationOptions<RemoveWorkspacePlanMutation, RemoveWorkspacePlanMutationVariables>;
export const ResetWorkspaceBackgroundDocument = gql`
    mutation ResetWorkspaceBackground {
  resetWorkspaceBackground {
    workspace {
      id
      theme {
        background {
          id
        }
      }
    }
  }
}
    `;
export type ResetWorkspaceBackgroundMutationFn = Apollo.MutationFunction<ResetWorkspaceBackgroundMutation, ResetWorkspaceBackgroundMutationVariables>;

/**
 * __useResetWorkspaceBackgroundMutation__
 *
 * To run a mutation, you first call `useResetWorkspaceBackgroundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetWorkspaceBackgroundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetWorkspaceBackgroundMutation, { data, loading, error }] = useResetWorkspaceBackgroundMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetWorkspaceBackgroundMutation(baseOptions?: Apollo.MutationHookOptions<ResetWorkspaceBackgroundMutation, ResetWorkspaceBackgroundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetWorkspaceBackgroundMutation, ResetWorkspaceBackgroundMutationVariables>(ResetWorkspaceBackgroundDocument, options);
      }
export type ResetWorkspaceBackgroundMutationHookResult = ReturnType<typeof useResetWorkspaceBackgroundMutation>;
export type ResetWorkspaceBackgroundMutationResult = Apollo.MutationResult<ResetWorkspaceBackgroundMutation>;
export type ResetWorkspaceBackgroundMutationOptions = Apollo.BaseMutationOptions<ResetWorkspaceBackgroundMutation, ResetWorkspaceBackgroundMutationVariables>;
export const ResetWorkspaceCustomEmailDomainDocument = gql`
    mutation ResetWorkspaceCustomEmailDomain {
  resetCustomEmailDomain {
    workspace {
      id
      customEmailDomain {
        ...CustomEmailDomainFragment
      }
    }
  }
}
    ${CustomEmailDomainFragmentFragmentDoc}`;
export type ResetWorkspaceCustomEmailDomainMutationFn = Apollo.MutationFunction<ResetWorkspaceCustomEmailDomainMutation, ResetWorkspaceCustomEmailDomainMutationVariables>;

/**
 * __useResetWorkspaceCustomEmailDomainMutation__
 *
 * To run a mutation, you first call `useResetWorkspaceCustomEmailDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetWorkspaceCustomEmailDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetWorkspaceCustomEmailDomainMutation, { data, loading, error }] = useResetWorkspaceCustomEmailDomainMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetWorkspaceCustomEmailDomainMutation(baseOptions?: Apollo.MutationHookOptions<ResetWorkspaceCustomEmailDomainMutation, ResetWorkspaceCustomEmailDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetWorkspaceCustomEmailDomainMutation, ResetWorkspaceCustomEmailDomainMutationVariables>(ResetWorkspaceCustomEmailDomainDocument, options);
      }
export type ResetWorkspaceCustomEmailDomainMutationHookResult = ReturnType<typeof useResetWorkspaceCustomEmailDomainMutation>;
export type ResetWorkspaceCustomEmailDomainMutationResult = Apollo.MutationResult<ResetWorkspaceCustomEmailDomainMutation>;
export type ResetWorkspaceCustomEmailDomainMutationOptions = Apollo.BaseMutationOptions<ResetWorkspaceCustomEmailDomainMutation, ResetWorkspaceCustomEmailDomainMutationVariables>;
export const ResetWorkspaceLogoDocument = gql`
    mutation ResetWorkspaceLogo {
  resetWorkspaceLogo {
    workspace {
      id
      theme {
        logo {
          id
        }
      }
    }
  }
}
    `;
export type ResetWorkspaceLogoMutationFn = Apollo.MutationFunction<ResetWorkspaceLogoMutation, ResetWorkspaceLogoMutationVariables>;

/**
 * __useResetWorkspaceLogoMutation__
 *
 * To run a mutation, you first call `useResetWorkspaceLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetWorkspaceLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetWorkspaceLogoMutation, { data, loading, error }] = useResetWorkspaceLogoMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetWorkspaceLogoMutation(baseOptions?: Apollo.MutationHookOptions<ResetWorkspaceLogoMutation, ResetWorkspaceLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetWorkspaceLogoMutation, ResetWorkspaceLogoMutationVariables>(ResetWorkspaceLogoDocument, options);
      }
export type ResetWorkspaceLogoMutationHookResult = ReturnType<typeof useResetWorkspaceLogoMutation>;
export type ResetWorkspaceLogoMutationResult = Apollo.MutationResult<ResetWorkspaceLogoMutation>;
export type ResetWorkspaceLogoMutationOptions = Apollo.BaseMutationOptions<ResetWorkspaceLogoMutation, ResetWorkspaceLogoMutationVariables>;
export const RestoreGroupDocument = gql`
    mutation RestoreGroup($input: RestoreGroupInput!) {
  restoreGroup(input: $input) {
    group {
      id
      isArchived
    }
  }
}
    `;
export type RestoreGroupMutationFn = Apollo.MutationFunction<RestoreGroupMutation, RestoreGroupMutationVariables>;

/**
 * __useRestoreGroupMutation__
 *
 * To run a mutation, you first call `useRestoreGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreGroupMutation, { data, loading, error }] = useRestoreGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreGroupMutation(baseOptions?: Apollo.MutationHookOptions<RestoreGroupMutation, RestoreGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreGroupMutation, RestoreGroupMutationVariables>(RestoreGroupDocument, options);
      }
export type RestoreGroupMutationHookResult = ReturnType<typeof useRestoreGroupMutation>;
export type RestoreGroupMutationResult = Apollo.MutationResult<RestoreGroupMutation>;
export type RestoreGroupMutationOptions = Apollo.BaseMutationOptions<RestoreGroupMutation, RestoreGroupMutationVariables>;
export const RevokeFeatureApprovalForViewerDocument = gql`
    mutation RevokeFeatureApprovalForViewer($input: RevokeFeatureApprovalInput!) {
  revokeFeatureApprovalForViewer(input: $input) {
    success
  }
}
    `;
export type RevokeFeatureApprovalForViewerMutationFn = Apollo.MutationFunction<RevokeFeatureApprovalForViewerMutation, RevokeFeatureApprovalForViewerMutationVariables>;

/**
 * __useRevokeFeatureApprovalForViewerMutation__
 *
 * To run a mutation, you first call `useRevokeFeatureApprovalForViewerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeFeatureApprovalForViewerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeFeatureApprovalForViewerMutation, { data, loading, error }] = useRevokeFeatureApprovalForViewerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeFeatureApprovalForViewerMutation(baseOptions?: Apollo.MutationHookOptions<RevokeFeatureApprovalForViewerMutation, RevokeFeatureApprovalForViewerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeFeatureApprovalForViewerMutation, RevokeFeatureApprovalForViewerMutationVariables>(RevokeFeatureApprovalForViewerDocument, options);
      }
export type RevokeFeatureApprovalForViewerMutationHookResult = ReturnType<typeof useRevokeFeatureApprovalForViewerMutation>;
export type RevokeFeatureApprovalForViewerMutationResult = Apollo.MutationResult<RevokeFeatureApprovalForViewerMutation>;
export type RevokeFeatureApprovalForViewerMutationOptions = Apollo.BaseMutationOptions<RevokeFeatureApprovalForViewerMutation, RevokeFeatureApprovalForViewerMutationVariables>;
export const SetGoodHabitzConfigDocument = gql`
    mutation SetGoodHabitzConfig($input: SetGoodHabitzConfigInput!) {
  setGoodHabitzConfig(input: $input) {
    enabled
    languageIDs
    hasApiKey
    lastSyncedAt
  }
}
    `;
export type SetGoodHabitzConfigMutationFn = Apollo.MutationFunction<SetGoodHabitzConfigMutation, SetGoodHabitzConfigMutationVariables>;

/**
 * __useSetGoodHabitzConfigMutation__
 *
 * To run a mutation, you first call `useSetGoodHabitzConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGoodHabitzConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGoodHabitzConfigMutation, { data, loading, error }] = useSetGoodHabitzConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetGoodHabitzConfigMutation(baseOptions?: Apollo.MutationHookOptions<SetGoodHabitzConfigMutation, SetGoodHabitzConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetGoodHabitzConfigMutation, SetGoodHabitzConfigMutationVariables>(SetGoodHabitzConfigDocument, options);
      }
export type SetGoodHabitzConfigMutationHookResult = ReturnType<typeof useSetGoodHabitzConfigMutation>;
export type SetGoodHabitzConfigMutationResult = Apollo.MutationResult<SetGoodHabitzConfigMutation>;
export type SetGoodHabitzConfigMutationOptions = Apollo.BaseMutationOptions<SetGoodHabitzConfigMutation, SetGoodHabitzConfigMutationVariables>;
export const SetStyrSyncLanguagesDocument = gql`
    mutation SetStyrSyncLanguages($languageIDs: [String!]!) {
  setStyrSyncLanguages(languageIDs: $languageIDs)
}
    `;
export type SetStyrSyncLanguagesMutationFn = Apollo.MutationFunction<SetStyrSyncLanguagesMutation, SetStyrSyncLanguagesMutationVariables>;

/**
 * __useSetStyrSyncLanguagesMutation__
 *
 * To run a mutation, you first call `useSetStyrSyncLanguagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStyrSyncLanguagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStyrSyncLanguagesMutation, { data, loading, error }] = useSetStyrSyncLanguagesMutation({
 *   variables: {
 *      languageIDs: // value for 'languageIDs'
 *   },
 * });
 */
export function useSetStyrSyncLanguagesMutation(baseOptions?: Apollo.MutationHookOptions<SetStyrSyncLanguagesMutation, SetStyrSyncLanguagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetStyrSyncLanguagesMutation, SetStyrSyncLanguagesMutationVariables>(SetStyrSyncLanguagesDocument, options);
      }
export type SetStyrSyncLanguagesMutationHookResult = ReturnType<typeof useSetStyrSyncLanguagesMutation>;
export type SetStyrSyncLanguagesMutationResult = Apollo.MutationResult<SetStyrSyncLanguagesMutation>;
export type SetStyrSyncLanguagesMutationOptions = Apollo.BaseMutationOptions<SetStyrSyncLanguagesMutation, SetStyrSyncLanguagesMutationVariables>;
export const SetWorkspaceCustomEmailDomainEnabledDocument = gql`
    mutation SetWorkspaceCustomEmailDomainEnabled($input: SetCustomEmailDomainEnabledInput!) {
  setCustomEmailDomainEnabled(input: $input) {
    workspace {
      id
      customEmailDomain {
        ...CustomEmailDomainFragment
      }
    }
  }
}
    ${CustomEmailDomainFragmentFragmentDoc}`;
export type SetWorkspaceCustomEmailDomainEnabledMutationFn = Apollo.MutationFunction<SetWorkspaceCustomEmailDomainEnabledMutation, SetWorkspaceCustomEmailDomainEnabledMutationVariables>;

/**
 * __useSetWorkspaceCustomEmailDomainEnabledMutation__
 *
 * To run a mutation, you first call `useSetWorkspaceCustomEmailDomainEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkspaceCustomEmailDomainEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkspaceCustomEmailDomainEnabledMutation, { data, loading, error }] = useSetWorkspaceCustomEmailDomainEnabledMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWorkspaceCustomEmailDomainEnabledMutation(baseOptions?: Apollo.MutationHookOptions<SetWorkspaceCustomEmailDomainEnabledMutation, SetWorkspaceCustomEmailDomainEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWorkspaceCustomEmailDomainEnabledMutation, SetWorkspaceCustomEmailDomainEnabledMutationVariables>(SetWorkspaceCustomEmailDomainEnabledDocument, options);
      }
export type SetWorkspaceCustomEmailDomainEnabledMutationHookResult = ReturnType<typeof useSetWorkspaceCustomEmailDomainEnabledMutation>;
export type SetWorkspaceCustomEmailDomainEnabledMutationResult = Apollo.MutationResult<SetWorkspaceCustomEmailDomainEnabledMutation>;
export type SetWorkspaceCustomEmailDomainEnabledMutationOptions = Apollo.BaseMutationOptions<SetWorkspaceCustomEmailDomainEnabledMutation, SetWorkspaceCustomEmailDomainEnabledMutationVariables>;
export const SetWorkspaceStyrConfigDocument = gql`
    mutation SetWorkspaceStyrConfig($input: SetWorkspaceStyrConfigInput!) {
  setWorkspaceStyrConfig(input: $input) {
    workspace {
      id
      styrConfigAdmin {
        organisationID
        organisationLabel
        enabled
      }
    }
  }
}
    `;
export type SetWorkspaceStyrConfigMutationFn = Apollo.MutationFunction<SetWorkspaceStyrConfigMutation, SetWorkspaceStyrConfigMutationVariables>;

/**
 * __useSetWorkspaceStyrConfigMutation__
 *
 * To run a mutation, you first call `useSetWorkspaceStyrConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWorkspaceStyrConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWorkspaceStyrConfigMutation, { data, loading, error }] = useSetWorkspaceStyrConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWorkspaceStyrConfigMutation(baseOptions?: Apollo.MutationHookOptions<SetWorkspaceStyrConfigMutation, SetWorkspaceStyrConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWorkspaceStyrConfigMutation, SetWorkspaceStyrConfigMutationVariables>(SetWorkspaceStyrConfigDocument, options);
      }
export type SetWorkspaceStyrConfigMutationHookResult = ReturnType<typeof useSetWorkspaceStyrConfigMutation>;
export type SetWorkspaceStyrConfigMutationResult = Apollo.MutationResult<SetWorkspaceStyrConfigMutation>;
export type SetWorkspaceStyrConfigMutationOptions = Apollo.BaseMutationOptions<SetWorkspaceStyrConfigMutation, SetWorkspaceStyrConfigMutationVariables>;
export const SyncGoodHabitzDocument = gql`
    mutation SyncGoodHabitz {
  syncGoodHabitz
}
    `;
export type SyncGoodHabitzMutationFn = Apollo.MutationFunction<SyncGoodHabitzMutation, SyncGoodHabitzMutationVariables>;

/**
 * __useSyncGoodHabitzMutation__
 *
 * To run a mutation, you first call `useSyncGoodHabitzMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncGoodHabitzMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncGoodHabitzMutation, { data, loading, error }] = useSyncGoodHabitzMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncGoodHabitzMutation(baseOptions?: Apollo.MutationHookOptions<SyncGoodHabitzMutation, SyncGoodHabitzMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncGoodHabitzMutation, SyncGoodHabitzMutationVariables>(SyncGoodHabitzDocument, options);
      }
export type SyncGoodHabitzMutationHookResult = ReturnType<typeof useSyncGoodHabitzMutation>;
export type SyncGoodHabitzMutationResult = Apollo.MutationResult<SyncGoodHabitzMutation>;
export type SyncGoodHabitzMutationOptions = Apollo.BaseMutationOptions<SyncGoodHabitzMutation, SyncGoodHabitzMutationVariables>;
export const SyncStyrDocument = gql`
    mutation SyncStyr {
  syncStyr
}
    `;
export type SyncStyrMutationFn = Apollo.MutationFunction<SyncStyrMutation, SyncStyrMutationVariables>;

/**
 * __useSyncStyrMutation__
 *
 * To run a mutation, you first call `useSyncStyrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncStyrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncStyrMutation, { data, loading, error }] = useSyncStyrMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncStyrMutation(baseOptions?: Apollo.MutationHookOptions<SyncStyrMutation, SyncStyrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncStyrMutation, SyncStyrMutationVariables>(SyncStyrDocument, options);
      }
export type SyncStyrMutationHookResult = ReturnType<typeof useSyncStyrMutation>;
export type SyncStyrMutationResult = Apollo.MutationResult<SyncStyrMutation>;
export type SyncStyrMutationOptions = Apollo.BaseMutationOptions<SyncStyrMutation, SyncStyrMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($input: UpdateGroupInput!) {
  updateGroup(input: $input) {
    group {
      id
      name
      type
      externalReferenceID
    }
  }
}
    `;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const UpdateWorkspaceAliasDocument = gql`
    mutation UpdateWorkspaceAlias($input: UpdateWorkspaceAliasInput!) {
  updateWorkspaceAlias(input: $input) {
    workspace {
      id
      alias
    }
  }
}
    `;
export type UpdateWorkspaceAliasMutationFn = Apollo.MutationFunction<UpdateWorkspaceAliasMutation, UpdateWorkspaceAliasMutationVariables>;

/**
 * __useUpdateWorkspaceAliasMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceAliasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceAliasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceAliasMutation, { data, loading, error }] = useUpdateWorkspaceAliasMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceAliasMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceAliasMutation, UpdateWorkspaceAliasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceAliasMutation, UpdateWorkspaceAliasMutationVariables>(UpdateWorkspaceAliasDocument, options);
      }
export type UpdateWorkspaceAliasMutationHookResult = ReturnType<typeof useUpdateWorkspaceAliasMutation>;
export type UpdateWorkspaceAliasMutationResult = Apollo.MutationResult<UpdateWorkspaceAliasMutation>;
export type UpdateWorkspaceAliasMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceAliasMutation, UpdateWorkspaceAliasMutationVariables>;
export const UpdateWorkspaceBackgroundDocument = gql`
    mutation UpdateWorkspaceBackground($input: UpdateWorkspaceBackgroundInput!) {
  updateWorkspaceBackground(input: $input) {
    workspace {
      id
      theme {
        background {
          id
          source {
            url
          }
        }
      }
    }
  }
}
    `;
export type UpdateWorkspaceBackgroundMutationFn = Apollo.MutationFunction<UpdateWorkspaceBackgroundMutation, UpdateWorkspaceBackgroundMutationVariables>;

/**
 * __useUpdateWorkspaceBackgroundMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceBackgroundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceBackgroundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceBackgroundMutation, { data, loading, error }] = useUpdateWorkspaceBackgroundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceBackgroundMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceBackgroundMutation, UpdateWorkspaceBackgroundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceBackgroundMutation, UpdateWorkspaceBackgroundMutationVariables>(UpdateWorkspaceBackgroundDocument, options);
      }
export type UpdateWorkspaceBackgroundMutationHookResult = ReturnType<typeof useUpdateWorkspaceBackgroundMutation>;
export type UpdateWorkspaceBackgroundMutationResult = Apollo.MutationResult<UpdateWorkspaceBackgroundMutation>;
export type UpdateWorkspaceBackgroundMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceBackgroundMutation, UpdateWorkspaceBackgroundMutationVariables>;
export const UpdateWorkspaceColorsDocument = gql`
    mutation UpdateWorkspaceColors($input: UpdateWorkspaceColorsInput!) {
  updateWorkspaceColors(input: $input) {
    workspace {
      id
      theme {
        primaryColor
        primaryColorDark
        secondaryColor
        linearGradientStart
        linearGradientEnd
      }
    }
  }
}
    `;
export type UpdateWorkspaceColorsMutationFn = Apollo.MutationFunction<UpdateWorkspaceColorsMutation, UpdateWorkspaceColorsMutationVariables>;

/**
 * __useUpdateWorkspaceColorsMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceColorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceColorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceColorsMutation, { data, loading, error }] = useUpdateWorkspaceColorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceColorsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceColorsMutation, UpdateWorkspaceColorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceColorsMutation, UpdateWorkspaceColorsMutationVariables>(UpdateWorkspaceColorsDocument, options);
      }
export type UpdateWorkspaceColorsMutationHookResult = ReturnType<typeof useUpdateWorkspaceColorsMutation>;
export type UpdateWorkspaceColorsMutationResult = Apollo.MutationResult<UpdateWorkspaceColorsMutation>;
export type UpdateWorkspaceColorsMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceColorsMutation, UpdateWorkspaceColorsMutationVariables>;
export const UpdateWorkspaceCustomEmailDomainDocument = gql`
    mutation UpdateWorkspaceCustomEmailDomain($input: UpdateCustomEmailDomainInput!) {
  updateCustomEmailDomain(input: $input) {
    workspace {
      id
      customEmailDomain {
        ...CustomEmailDomainFragment
      }
    }
  }
}
    ${CustomEmailDomainFragmentFragmentDoc}`;
export type UpdateWorkspaceCustomEmailDomainMutationFn = Apollo.MutationFunction<UpdateWorkspaceCustomEmailDomainMutation, UpdateWorkspaceCustomEmailDomainMutationVariables>;

/**
 * __useUpdateWorkspaceCustomEmailDomainMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceCustomEmailDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceCustomEmailDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceCustomEmailDomainMutation, { data, loading, error }] = useUpdateWorkspaceCustomEmailDomainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceCustomEmailDomainMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceCustomEmailDomainMutation, UpdateWorkspaceCustomEmailDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceCustomEmailDomainMutation, UpdateWorkspaceCustomEmailDomainMutationVariables>(UpdateWorkspaceCustomEmailDomainDocument, options);
      }
export type UpdateWorkspaceCustomEmailDomainMutationHookResult = ReturnType<typeof useUpdateWorkspaceCustomEmailDomainMutation>;
export type UpdateWorkspaceCustomEmailDomainMutationResult = Apollo.MutationResult<UpdateWorkspaceCustomEmailDomainMutation>;
export type UpdateWorkspaceCustomEmailDomainMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceCustomEmailDomainMutation, UpdateWorkspaceCustomEmailDomainMutationVariables>;
export const UpdateWorkspaceDisplayNameDocument = gql`
    mutation UpdateWorkspaceDisplayName($input: UpdateWorkspaceDisplayNameInput!) {
  updateWorkspaceDisplayName(input: $input) {
    workspace {
      id
      displayName
    }
  }
}
    `;
export type UpdateWorkspaceDisplayNameMutationFn = Apollo.MutationFunction<UpdateWorkspaceDisplayNameMutation, UpdateWorkspaceDisplayNameMutationVariables>;

/**
 * __useUpdateWorkspaceDisplayNameMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceDisplayNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceDisplayNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceDisplayNameMutation, { data, loading, error }] = useUpdateWorkspaceDisplayNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceDisplayNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceDisplayNameMutation, UpdateWorkspaceDisplayNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceDisplayNameMutation, UpdateWorkspaceDisplayNameMutationVariables>(UpdateWorkspaceDisplayNameDocument, options);
      }
export type UpdateWorkspaceDisplayNameMutationHookResult = ReturnType<typeof useUpdateWorkspaceDisplayNameMutation>;
export type UpdateWorkspaceDisplayNameMutationResult = Apollo.MutationResult<UpdateWorkspaceDisplayNameMutation>;
export type UpdateWorkspaceDisplayNameMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceDisplayNameMutation, UpdateWorkspaceDisplayNameMutationVariables>;
export const UpdateWorkspaceEmailDomainsDocument = gql`
    mutation UpdateWorkspaceEmailDomains($input: UpdateWorkspaceEmailDomainsInput!) {
  updateWorkspaceEmailDomains(input: $input) {
    workspace {
      id
      emailDomains
    }
  }
}
    `;
export type UpdateWorkspaceEmailDomainsMutationFn = Apollo.MutationFunction<UpdateWorkspaceEmailDomainsMutation, UpdateWorkspaceEmailDomainsMutationVariables>;

/**
 * __useUpdateWorkspaceEmailDomainsMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceEmailDomainsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceEmailDomainsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceEmailDomainsMutation, { data, loading, error }] = useUpdateWorkspaceEmailDomainsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceEmailDomainsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceEmailDomainsMutation, UpdateWorkspaceEmailDomainsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceEmailDomainsMutation, UpdateWorkspaceEmailDomainsMutationVariables>(UpdateWorkspaceEmailDomainsDocument, options);
      }
export type UpdateWorkspaceEmailDomainsMutationHookResult = ReturnType<typeof useUpdateWorkspaceEmailDomainsMutation>;
export type UpdateWorkspaceEmailDomainsMutationResult = Apollo.MutationResult<UpdateWorkspaceEmailDomainsMutation>;
export type UpdateWorkspaceEmailDomainsMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceEmailDomainsMutation, UpdateWorkspaceEmailDomainsMutationVariables>;
export const UpdateWorkspaceFeatureDocument = gql`
    mutation UpdateWorkspaceFeature($input: UpdateWorkspaceFeatureInput!) {
  updateWorkspaceFeature(input: $input) {
    workspace {
      id
      features {
        id
        status
      }
    }
  }
}
    `;
export type UpdateWorkspaceFeatureMutationFn = Apollo.MutationFunction<UpdateWorkspaceFeatureMutation, UpdateWorkspaceFeatureMutationVariables>;

/**
 * __useUpdateWorkspaceFeatureMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceFeatureMutation, { data, loading, error }] = useUpdateWorkspaceFeatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceFeatureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceFeatureMutation, UpdateWorkspaceFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceFeatureMutation, UpdateWorkspaceFeatureMutationVariables>(UpdateWorkspaceFeatureDocument, options);
      }
export type UpdateWorkspaceFeatureMutationHookResult = ReturnType<typeof useUpdateWorkspaceFeatureMutation>;
export type UpdateWorkspaceFeatureMutationResult = Apollo.MutationResult<UpdateWorkspaceFeatureMutation>;
export type UpdateWorkspaceFeatureMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceFeatureMutation, UpdateWorkspaceFeatureMutationVariables>;
export const UpdateWorkspaceHubSpotCompanyIdDocument = gql`
    mutation UpdateWorkspaceHubSpotCompanyID($input: UpdateWorkspaceHubSpotCompanyIDInput!) {
  updateWorkspaceHubSpotCompanyID(input: $input) {
    workspace {
      id
      hubSpotCompanyID
    }
  }
}
    `;
export type UpdateWorkspaceHubSpotCompanyIdMutationFn = Apollo.MutationFunction<UpdateWorkspaceHubSpotCompanyIdMutation, UpdateWorkspaceHubSpotCompanyIdMutationVariables>;

/**
 * __useUpdateWorkspaceHubSpotCompanyIdMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceHubSpotCompanyIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceHubSpotCompanyIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceHubSpotCompanyIdMutation, { data, loading, error }] = useUpdateWorkspaceHubSpotCompanyIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceHubSpotCompanyIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceHubSpotCompanyIdMutation, UpdateWorkspaceHubSpotCompanyIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceHubSpotCompanyIdMutation, UpdateWorkspaceHubSpotCompanyIdMutationVariables>(UpdateWorkspaceHubSpotCompanyIdDocument, options);
      }
export type UpdateWorkspaceHubSpotCompanyIdMutationHookResult = ReturnType<typeof useUpdateWorkspaceHubSpotCompanyIdMutation>;
export type UpdateWorkspaceHubSpotCompanyIdMutationResult = Apollo.MutationResult<UpdateWorkspaceHubSpotCompanyIdMutation>;
export type UpdateWorkspaceHubSpotCompanyIdMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceHubSpotCompanyIdMutation, UpdateWorkspaceHubSpotCompanyIdMutationVariables>;
export const UpdateWorkspaceLanguagesDocument = gql`
    mutation UpdateWorkspaceLanguages($input: UpdateWorkspaceLanguagesInput!) {
  updateWorkspaceLanguages(input: $input) {
    workspace {
      id
      supportedLanguageIDs
    }
  }
}
    `;
export type UpdateWorkspaceLanguagesMutationFn = Apollo.MutationFunction<UpdateWorkspaceLanguagesMutation, UpdateWorkspaceLanguagesMutationVariables>;

/**
 * __useUpdateWorkspaceLanguagesMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceLanguagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceLanguagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceLanguagesMutation, { data, loading, error }] = useUpdateWorkspaceLanguagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceLanguagesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceLanguagesMutation, UpdateWorkspaceLanguagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceLanguagesMutation, UpdateWorkspaceLanguagesMutationVariables>(UpdateWorkspaceLanguagesDocument, options);
      }
export type UpdateWorkspaceLanguagesMutationHookResult = ReturnType<typeof useUpdateWorkspaceLanguagesMutation>;
export type UpdateWorkspaceLanguagesMutationResult = Apollo.MutationResult<UpdateWorkspaceLanguagesMutation>;
export type UpdateWorkspaceLanguagesMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceLanguagesMutation, UpdateWorkspaceLanguagesMutationVariables>;
export const UpdateWorkspaceLogoDocument = gql`
    mutation UpdateWorkspaceLogo($input: UpdateWorkspaceLogoInput!) {
  updateWorkspaceLogo(input: $input) {
    workspace {
      id
      theme {
        logo {
          id
          source {
            url
          }
        }
      }
    }
  }
}
    `;
export type UpdateWorkspaceLogoMutationFn = Apollo.MutationFunction<UpdateWorkspaceLogoMutation, UpdateWorkspaceLogoMutationVariables>;

/**
 * __useUpdateWorkspaceLogoMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceLogoMutation, { data, loading, error }] = useUpdateWorkspaceLogoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceLogoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceLogoMutation, UpdateWorkspaceLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceLogoMutation, UpdateWorkspaceLogoMutationVariables>(UpdateWorkspaceLogoDocument, options);
      }
export type UpdateWorkspaceLogoMutationHookResult = ReturnType<typeof useUpdateWorkspaceLogoMutation>;
export type UpdateWorkspaceLogoMutationResult = Apollo.MutationResult<UpdateWorkspaceLogoMutation>;
export type UpdateWorkspaceLogoMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceLogoMutation, UpdateWorkspaceLogoMutationVariables>;
export const UpdateWorkspaceMfaSettingsDocument = gql`
    mutation UpdateWorkspaceMfaSettings($input: UpdateWorkspaceMfaSettingsInput!) {
  updateWorkspaceMfaSettings(input: $input) {
    workspaceMfaSettings {
      ...WorkspaceMfaSettings
    }
  }
}
    ${WorkspaceMfaSettingsFragmentDoc}`;
export type UpdateWorkspaceMfaSettingsMutationFn = Apollo.MutationFunction<UpdateWorkspaceMfaSettingsMutation, UpdateWorkspaceMfaSettingsMutationVariables>;

/**
 * __useUpdateWorkspaceMfaSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceMfaSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceMfaSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceMfaSettingsMutation, { data, loading, error }] = useUpdateWorkspaceMfaSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceMfaSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceMfaSettingsMutation, UpdateWorkspaceMfaSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceMfaSettingsMutation, UpdateWorkspaceMfaSettingsMutationVariables>(UpdateWorkspaceMfaSettingsDocument, options);
      }
export type UpdateWorkspaceMfaSettingsMutationHookResult = ReturnType<typeof useUpdateWorkspaceMfaSettingsMutation>;
export type UpdateWorkspaceMfaSettingsMutationResult = Apollo.MutationResult<UpdateWorkspaceMfaSettingsMutation>;
export type UpdateWorkspaceMfaSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceMfaSettingsMutation, UpdateWorkspaceMfaSettingsMutationVariables>;
export const UpdateWorkspaceNotificationSettingsDocument = gql`
    mutation UpdateWorkspaceNotificationSettings($input: UpdateWorkspaceNotificationSettingsInput!) {
  updateWorkspaceNotificationSettings(input: $input) {
    workspace {
      id
      notificationSettings {
        header
        footer
        welcomeEmail {
          body
          subject
        }
      }
    }
  }
}
    `;
export type UpdateWorkspaceNotificationSettingsMutationFn = Apollo.MutationFunction<UpdateWorkspaceNotificationSettingsMutation, UpdateWorkspaceNotificationSettingsMutationVariables>;

/**
 * __useUpdateWorkspaceNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceNotificationSettingsMutation, { data, loading, error }] = useUpdateWorkspaceNotificationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceNotificationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceNotificationSettingsMutation, UpdateWorkspaceNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceNotificationSettingsMutation, UpdateWorkspaceNotificationSettingsMutationVariables>(UpdateWorkspaceNotificationSettingsDocument, options);
      }
export type UpdateWorkspaceNotificationSettingsMutationHookResult = ReturnType<typeof useUpdateWorkspaceNotificationSettingsMutation>;
export type UpdateWorkspaceNotificationSettingsMutationResult = Apollo.MutationResult<UpdateWorkspaceNotificationSettingsMutation>;
export type UpdateWorkspaceNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceNotificationSettingsMutation, UpdateWorkspaceNotificationSettingsMutationVariables>;
export const UpdateWorkspacePlanDocument = gql`
    mutation UpdateWorkspacePlan($input: UpdateWorkspacePlanV2Input!) {
  updateWorkspacePlanV2(input: $input) {
    plan {
      ...WorkspacePlan
    }
  }
}
    ${WorkspacePlanFragmentDoc}`;
export type UpdateWorkspacePlanMutationFn = Apollo.MutationFunction<UpdateWorkspacePlanMutation, UpdateWorkspacePlanMutationVariables>;

/**
 * __useUpdateWorkspacePlanMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspacePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspacePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspacePlanMutation, { data, loading, error }] = useUpdateWorkspacePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspacePlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspacePlanMutation, UpdateWorkspacePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspacePlanMutation, UpdateWorkspacePlanMutationVariables>(UpdateWorkspacePlanDocument, options);
      }
export type UpdateWorkspacePlanMutationHookResult = ReturnType<typeof useUpdateWorkspacePlanMutation>;
export type UpdateWorkspacePlanMutationResult = Apollo.MutationResult<UpdateWorkspacePlanMutation>;
export type UpdateWorkspacePlanMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspacePlanMutation, UpdateWorkspacePlanMutationVariables>;
export const UpdateWorkspaceRetentionPeriodDocument = gql`
    mutation UpdateWorkspaceRetentionPeriod($input: UpdateWorkspaceRetentionPeriodInput!) {
  updateWorkspaceRetentionPeriod(input: $input) {
    workspace {
      id
      retentionPeriodDays
    }
  }
}
    `;
export type UpdateWorkspaceRetentionPeriodMutationFn = Apollo.MutationFunction<UpdateWorkspaceRetentionPeriodMutation, UpdateWorkspaceRetentionPeriodMutationVariables>;

/**
 * __useUpdateWorkspaceRetentionPeriodMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceRetentionPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceRetentionPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceRetentionPeriodMutation, { data, loading, error }] = useUpdateWorkspaceRetentionPeriodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceRetentionPeriodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceRetentionPeriodMutation, UpdateWorkspaceRetentionPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceRetentionPeriodMutation, UpdateWorkspaceRetentionPeriodMutationVariables>(UpdateWorkspaceRetentionPeriodDocument, options);
      }
export type UpdateWorkspaceRetentionPeriodMutationHookResult = ReturnType<typeof useUpdateWorkspaceRetentionPeriodMutation>;
export type UpdateWorkspaceRetentionPeriodMutationResult = Apollo.MutationResult<UpdateWorkspaceRetentionPeriodMutation>;
export type UpdateWorkspaceRetentionPeriodMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceRetentionPeriodMutation, UpdateWorkspaceRetentionPeriodMutationVariables>;
export const UpdateWorkspaceSsoSettingsDocument = gql`
    mutation UpdateWorkspaceSSOSettings($input: UpdateWorkspaceSSOSettingsInput!) {
  updateWorkspaceSSOSettings(input: $input) {
    workspace {
      id
      ssoSettings {
        ...WorkspaceSSOSettings
      }
    }
  }
}
    ${WorkspaceSsoSettingsFragmentDoc}`;
export type UpdateWorkspaceSsoSettingsMutationFn = Apollo.MutationFunction<UpdateWorkspaceSsoSettingsMutation, UpdateWorkspaceSsoSettingsMutationVariables>;

/**
 * __useUpdateWorkspaceSsoSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceSsoSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceSsoSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceSsoSettingsMutation, { data, loading, error }] = useUpdateWorkspaceSsoSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceSsoSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceSsoSettingsMutation, UpdateWorkspaceSsoSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceSsoSettingsMutation, UpdateWorkspaceSsoSettingsMutationVariables>(UpdateWorkspaceSsoSettingsDocument, options);
      }
export type UpdateWorkspaceSsoSettingsMutationHookResult = ReturnType<typeof useUpdateWorkspaceSsoSettingsMutation>;
export type UpdateWorkspaceSsoSettingsMutationResult = Apollo.MutationResult<UpdateWorkspaceSsoSettingsMutation>;
export type UpdateWorkspaceSsoSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceSsoSettingsMutation, UpdateWorkspaceSsoSettingsMutationVariables>;
export const UpdateWorkspaceStartDateDocument = gql`
    mutation UpdateWorkspaceStartDate($input: UpdateWorkspaceStartDateInput!) {
  updateWorkspaceStartDate(input: $input) {
    workspace {
      id
      startDate
    }
  }
}
    `;
export type UpdateWorkspaceStartDateMutationFn = Apollo.MutationFunction<UpdateWorkspaceStartDateMutation, UpdateWorkspaceStartDateMutationVariables>;

/**
 * __useUpdateWorkspaceStartDateMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceStartDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceStartDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceStartDateMutation, { data, loading, error }] = useUpdateWorkspaceStartDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceStartDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceStartDateMutation, UpdateWorkspaceStartDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceStartDateMutation, UpdateWorkspaceStartDateMutationVariables>(UpdateWorkspaceStartDateDocument, options);
      }
export type UpdateWorkspaceStartDateMutationHookResult = ReturnType<typeof useUpdateWorkspaceStartDateMutation>;
export type UpdateWorkspaceStartDateMutationResult = Apollo.MutationResult<UpdateWorkspaceStartDateMutation>;
export type UpdateWorkspaceStartDateMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceStartDateMutation, UpdateWorkspaceStartDateMutationVariables>;
export const AdvancedWorkspaceSettingsDocument = gql`
    query AdvancedWorkspaceSettings($id: ID!) {
  workspace(id: $id) {
    id
    startDate
    supportedLanguageIDs
    retentionPeriodDays
    engagementSettings {
      enpsType
    }
    workspaceMfaSettings {
      ...WorkspaceMfaSettings
    }
    ssoSettings {
      ...WorkspaceSSOSettings
    }
  }
}
    ${WorkspaceMfaSettingsFragmentDoc}
${WorkspaceSsoSettingsFragmentDoc}`;

/**
 * __useAdvancedWorkspaceSettingsQuery__
 *
 * To run a query within a React component, call `useAdvancedWorkspaceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvancedWorkspaceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvancedWorkspaceSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdvancedWorkspaceSettingsQuery(baseOptions: Apollo.QueryHookOptions<AdvancedWorkspaceSettingsQuery, AdvancedWorkspaceSettingsQueryVariables> & ({ variables: AdvancedWorkspaceSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvancedWorkspaceSettingsQuery, AdvancedWorkspaceSettingsQueryVariables>(AdvancedWorkspaceSettingsDocument, options);
      }
export function useAdvancedWorkspaceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvancedWorkspaceSettingsQuery, AdvancedWorkspaceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvancedWorkspaceSettingsQuery, AdvancedWorkspaceSettingsQueryVariables>(AdvancedWorkspaceSettingsDocument, options);
        }
// @ts-ignore
export function useAdvancedWorkspaceSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdvancedWorkspaceSettingsQuery, AdvancedWorkspaceSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<AdvancedWorkspaceSettingsQuery, AdvancedWorkspaceSettingsQueryVariables>;
export function useAdvancedWorkspaceSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdvancedWorkspaceSettingsQuery, AdvancedWorkspaceSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<AdvancedWorkspaceSettingsQuery | undefined, AdvancedWorkspaceSettingsQueryVariables>;
export function useAdvancedWorkspaceSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdvancedWorkspaceSettingsQuery, AdvancedWorkspaceSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdvancedWorkspaceSettingsQuery, AdvancedWorkspaceSettingsQueryVariables>(AdvancedWorkspaceSettingsDocument, options);
        }
export type AdvancedWorkspaceSettingsQueryHookResult = ReturnType<typeof useAdvancedWorkspaceSettingsQuery>;
export type AdvancedWorkspaceSettingsLazyQueryHookResult = ReturnType<typeof useAdvancedWorkspaceSettingsLazyQuery>;
export type AdvancedWorkspaceSettingsSuspenseQueryHookResult = ReturnType<typeof useAdvancedWorkspaceSettingsSuspenseQuery>;
export type AdvancedWorkspaceSettingsQueryResult = Apollo.QueryResult<AdvancedWorkspaceSettingsQuery, AdvancedWorkspaceSettingsQueryVariables>;
export const ConnectorDryRunGroupsDocument = gql`
    query ConnectorDryRunGroups($first: Int, $after: ID, $last: Int, $before: ID) {
  viewer {
    workspace {
      connector {
        id
        dryRun {
          groups(first: $first, after: $after, last: $last, before: $before) {
            edges {
              node {
                name
                externalReferenceID
                parentExternalReferenceID
              }
              cursor
            }
            pageInfo {
              startCursor
              endCursor
              hasNextPage
              hasPreviousPage
            }
            totalCount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useConnectorDryRunGroupsQuery__
 *
 * To run a query within a React component, call `useConnectorDryRunGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectorDryRunGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectorDryRunGroupsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useConnectorDryRunGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ConnectorDryRunGroupsQuery, ConnectorDryRunGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectorDryRunGroupsQuery, ConnectorDryRunGroupsQueryVariables>(ConnectorDryRunGroupsDocument, options);
      }
export function useConnectorDryRunGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectorDryRunGroupsQuery, ConnectorDryRunGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectorDryRunGroupsQuery, ConnectorDryRunGroupsQueryVariables>(ConnectorDryRunGroupsDocument, options);
        }
// @ts-ignore
export function useConnectorDryRunGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectorDryRunGroupsQuery, ConnectorDryRunGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorDryRunGroupsQuery, ConnectorDryRunGroupsQueryVariables>;
export function useConnectorDryRunGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorDryRunGroupsQuery, ConnectorDryRunGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorDryRunGroupsQuery | undefined, ConnectorDryRunGroupsQueryVariables>;
export function useConnectorDryRunGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorDryRunGroupsQuery, ConnectorDryRunGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectorDryRunGroupsQuery, ConnectorDryRunGroupsQueryVariables>(ConnectorDryRunGroupsDocument, options);
        }
export type ConnectorDryRunGroupsQueryHookResult = ReturnType<typeof useConnectorDryRunGroupsQuery>;
export type ConnectorDryRunGroupsLazyQueryHookResult = ReturnType<typeof useConnectorDryRunGroupsLazyQuery>;
export type ConnectorDryRunGroupsSuspenseQueryHookResult = ReturnType<typeof useConnectorDryRunGroupsSuspenseQuery>;
export type ConnectorDryRunGroupsQueryResult = Apollo.QueryResult<ConnectorDryRunGroupsQuery, ConnectorDryRunGroupsQueryVariables>;
export const DepartmentsDocument = gql`
    query Departments($isArchived: Boolean!, $first: Int) {
  groups(filter: {isArchived: $isArchived, types: [DEPARTMENT]}, first: $first) {
    edges {
      node {
        id
        name
        isArchived
      }
    }
  }
}
    `;

/**
 * __useDepartmentsQuery__
 *
 * To run a query within a React component, call `useDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentsQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useDepartmentsQuery(baseOptions: Apollo.QueryHookOptions<DepartmentsQuery, DepartmentsQueryVariables> & ({ variables: DepartmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DepartmentsQuery, DepartmentsQueryVariables>(DepartmentsDocument, options);
      }
export function useDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepartmentsQuery, DepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DepartmentsQuery, DepartmentsQueryVariables>(DepartmentsDocument, options);
        }
// @ts-ignore
export function useDepartmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DepartmentsQuery, DepartmentsQueryVariables>): Apollo.UseSuspenseQueryResult<DepartmentsQuery, DepartmentsQueryVariables>;
export function useDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DepartmentsQuery, DepartmentsQueryVariables>): Apollo.UseSuspenseQueryResult<DepartmentsQuery | undefined, DepartmentsQueryVariables>;
export function useDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DepartmentsQuery, DepartmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DepartmentsQuery, DepartmentsQueryVariables>(DepartmentsDocument, options);
        }
export type DepartmentsQueryHookResult = ReturnType<typeof useDepartmentsQuery>;
export type DepartmentsLazyQueryHookResult = ReturnType<typeof useDepartmentsLazyQuery>;
export type DepartmentsSuspenseQueryHookResult = ReturnType<typeof useDepartmentsSuspenseQuery>;
export type DepartmentsQueryResult = Apollo.QueryResult<DepartmentsQuery, DepartmentsQueryVariables>;
export const DepartmentsWithParentsDocument = gql`
    query DepartmentsWithParents($filter: GroupsFilter, $before: ID, $after: ID, $first: Int, $last: Int) {
  groups(
    filter: $filter
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        id
        name
        parent {
          id
        }
        viewerCanViewAnalytics
        viewerCanViewEngagementAnalytics
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useDepartmentsWithParentsQuery__
 *
 * To run a query within a React component, call `useDepartmentsWithParentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentsWithParentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentsWithParentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useDepartmentsWithParentsQuery(baseOptions?: Apollo.QueryHookOptions<DepartmentsWithParentsQuery, DepartmentsWithParentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DepartmentsWithParentsQuery, DepartmentsWithParentsQueryVariables>(DepartmentsWithParentsDocument, options);
      }
export function useDepartmentsWithParentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepartmentsWithParentsQuery, DepartmentsWithParentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DepartmentsWithParentsQuery, DepartmentsWithParentsQueryVariables>(DepartmentsWithParentsDocument, options);
        }
// @ts-ignore
export function useDepartmentsWithParentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DepartmentsWithParentsQuery, DepartmentsWithParentsQueryVariables>): Apollo.UseSuspenseQueryResult<DepartmentsWithParentsQuery, DepartmentsWithParentsQueryVariables>;
export function useDepartmentsWithParentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DepartmentsWithParentsQuery, DepartmentsWithParentsQueryVariables>): Apollo.UseSuspenseQueryResult<DepartmentsWithParentsQuery | undefined, DepartmentsWithParentsQueryVariables>;
export function useDepartmentsWithParentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DepartmentsWithParentsQuery, DepartmentsWithParentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DepartmentsWithParentsQuery, DepartmentsWithParentsQueryVariables>(DepartmentsWithParentsDocument, options);
        }
export type DepartmentsWithParentsQueryHookResult = ReturnType<typeof useDepartmentsWithParentsQuery>;
export type DepartmentsWithParentsLazyQueryHookResult = ReturnType<typeof useDepartmentsWithParentsLazyQuery>;
export type DepartmentsWithParentsSuspenseQueryHookResult = ReturnType<typeof useDepartmentsWithParentsSuspenseQuery>;
export type DepartmentsWithParentsQueryResult = Apollo.QueryResult<DepartmentsWithParentsQuery, DepartmentsWithParentsQueryVariables>;
export const FeatureWorkspaceOverviewDocument = gql`
    query FeatureWorkspaceOverview {
  featureWorkspaceOverview {
    featureName
    stability
    workspaces {
      workspaceID
      status
    }
  }
}
    `;

/**
 * __useFeatureWorkspaceOverviewQuery__
 *
 * To run a query within a React component, call `useFeatureWorkspaceOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureWorkspaceOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureWorkspaceOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureWorkspaceOverviewQuery(baseOptions?: Apollo.QueryHookOptions<FeatureWorkspaceOverviewQuery, FeatureWorkspaceOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureWorkspaceOverviewQuery, FeatureWorkspaceOverviewQueryVariables>(FeatureWorkspaceOverviewDocument, options);
      }
export function useFeatureWorkspaceOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureWorkspaceOverviewQuery, FeatureWorkspaceOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureWorkspaceOverviewQuery, FeatureWorkspaceOverviewQueryVariables>(FeatureWorkspaceOverviewDocument, options);
        }
// @ts-ignore
export function useFeatureWorkspaceOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeatureWorkspaceOverviewQuery, FeatureWorkspaceOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<FeatureWorkspaceOverviewQuery, FeatureWorkspaceOverviewQueryVariables>;
export function useFeatureWorkspaceOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeatureWorkspaceOverviewQuery, FeatureWorkspaceOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<FeatureWorkspaceOverviewQuery | undefined, FeatureWorkspaceOverviewQueryVariables>;
export function useFeatureWorkspaceOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeatureWorkspaceOverviewQuery, FeatureWorkspaceOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeatureWorkspaceOverviewQuery, FeatureWorkspaceOverviewQueryVariables>(FeatureWorkspaceOverviewDocument, options);
        }
export type FeatureWorkspaceOverviewQueryHookResult = ReturnType<typeof useFeatureWorkspaceOverviewQuery>;
export type FeatureWorkspaceOverviewLazyQueryHookResult = ReturnType<typeof useFeatureWorkspaceOverviewLazyQuery>;
export type FeatureWorkspaceOverviewSuspenseQueryHookResult = ReturnType<typeof useFeatureWorkspaceOverviewSuspenseQuery>;
export type FeatureWorkspaceOverviewQueryResult = Apollo.QueryResult<FeatureWorkspaceOverviewQuery, FeatureWorkspaceOverviewQueryVariables>;
export const GroupDocument = gql`
    query Group($id: ID!, $roleTypes: [RoleType!], $before: ID, $after: ID, $first: Int, $last: Int) {
  group(id: $id) {
    id
    name
    type
    externalReferenceID
    updatedAt
    isArchived
    parent {
      id
      name
      type
    }
    managers(first: 100) {
      edges {
        role {
          id
        }
        node {
          id
          firstName
          lastName
          avatar {
            source {
              url
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
    members(
      roleTypes: $roleTypes
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      edges {
        node {
          id
          firstName
          lastName
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
    viewerCanUpdate
  }
}
    `;

/**
 * __useGroupQuery__
 *
 * To run a query within a React component, call `useGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *      roleTypes: // value for 'roleTypes'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGroupQuery(baseOptions: Apollo.QueryHookOptions<GroupQuery, GroupQueryVariables> & ({ variables: GroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
      }
export function useGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupQuery, GroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
        }
// @ts-ignore
export function useGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupQuery, GroupQueryVariables>): Apollo.UseSuspenseQueryResult<GroupQuery, GroupQueryVariables>;
export function useGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupQuery, GroupQueryVariables>): Apollo.UseSuspenseQueryResult<GroupQuery | undefined, GroupQueryVariables>;
export function useGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupQuery, GroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
        }
export type GroupQueryHookResult = ReturnType<typeof useGroupQuery>;
export type GroupLazyQueryHookResult = ReturnType<typeof useGroupLazyQuery>;
export type GroupSuspenseQueryHookResult = ReturnType<typeof useGroupSuspenseQuery>;
export type GroupQueryResult = Apollo.QueryResult<GroupQuery, GroupQueryVariables>;
export const GroupMembersDocument = gql`
    query GroupMembers($id: ID!) {
  group(id: $id) {
    id
    members(first: 1000) {
      edges {
        node {
          id
          firstName
          lastName
          avatar {
            source {
              url
            }
          }
          currentJobPosition {
            id
            jobTitle {
              id
              title
            }
          }
        }
        role {
          id
          type
        }
      }
    }
  }
}
    `;

/**
 * __useGroupMembersQuery__
 *
 * To run a query within a React component, call `useGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupMembersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupMembersQuery(baseOptions: Apollo.QueryHookOptions<GroupMembersQuery, GroupMembersQueryVariables> & ({ variables: GroupMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupMembersQuery, GroupMembersQueryVariables>(GroupMembersDocument, options);
      }
export function useGroupMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupMembersQuery, GroupMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupMembersQuery, GroupMembersQueryVariables>(GroupMembersDocument, options);
        }
// @ts-ignore
export function useGroupMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupMembersQuery, GroupMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GroupMembersQuery, GroupMembersQueryVariables>;
export function useGroupMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupMembersQuery, GroupMembersQueryVariables>): Apollo.UseSuspenseQueryResult<GroupMembersQuery | undefined, GroupMembersQueryVariables>;
export function useGroupMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupMembersQuery, GroupMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupMembersQuery, GroupMembersQueryVariables>(GroupMembersDocument, options);
        }
export type GroupMembersQueryHookResult = ReturnType<typeof useGroupMembersQuery>;
export type GroupMembersLazyQueryHookResult = ReturnType<typeof useGroupMembersLazyQuery>;
export type GroupMembersSuspenseQueryHookResult = ReturnType<typeof useGroupMembersSuspenseQuery>;
export type GroupMembersQueryResult = Apollo.QueryResult<GroupMembersQuery, GroupMembersQueryVariables>;
export const GroupsDocument = gql`
    query Groups($first: Int, $after: ID, $filter: GroupsFilter) {
  groups(first: $first, after: $after, filter: $filter) {
    edges {
      node {
        id
        type
        name
        isArchived
        parent {
          id
        }
        viewerCanViewAnalytics
        viewerCanCreateGoal
        viewerCanViewArchivedGoals
        viewerCanViewGoals
        viewerCanViewTalentReviews
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useGroupsQuery__
 *
 * To run a query within a React component, call `useGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
      }
export function useGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
        }
// @ts-ignore
export function useGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GroupsQuery, GroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupsQuery, GroupsQueryVariables>;
export function useGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupsQuery, GroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GroupsQuery | undefined, GroupsQueryVariables>;
export function useGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
        }
export type GroupsQueryHookResult = ReturnType<typeof useGroupsQuery>;
export type GroupsLazyQueryHookResult = ReturnType<typeof useGroupsLazyQuery>;
export type GroupsSuspenseQueryHookResult = ReturnType<typeof useGroupsSuspenseQuery>;
export type GroupsQueryResult = Apollo.QueryResult<GroupsQuery, GroupsQueryVariables>;
export const IsWorkspaceSlugAvailableDocument = gql`
    query IsWorkspaceSlugAvailable($workspaceID: ID!) {
  isWorkspaceSlugAvailable(id: $workspaceID)
}
    `;

/**
 * __useIsWorkspaceSlugAvailableQuery__
 *
 * To run a query within a React component, call `useIsWorkspaceSlugAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsWorkspaceSlugAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsWorkspaceSlugAvailableQuery({
 *   variables: {
 *      workspaceID: // value for 'workspaceID'
 *   },
 * });
 */
export function useIsWorkspaceSlugAvailableQuery(baseOptions: Apollo.QueryHookOptions<IsWorkspaceSlugAvailableQuery, IsWorkspaceSlugAvailableQueryVariables> & ({ variables: IsWorkspaceSlugAvailableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsWorkspaceSlugAvailableQuery, IsWorkspaceSlugAvailableQueryVariables>(IsWorkspaceSlugAvailableDocument, options);
      }
export function useIsWorkspaceSlugAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsWorkspaceSlugAvailableQuery, IsWorkspaceSlugAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsWorkspaceSlugAvailableQuery, IsWorkspaceSlugAvailableQueryVariables>(IsWorkspaceSlugAvailableDocument, options);
        }
// @ts-ignore
export function useIsWorkspaceSlugAvailableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsWorkspaceSlugAvailableQuery, IsWorkspaceSlugAvailableQueryVariables>): Apollo.UseSuspenseQueryResult<IsWorkspaceSlugAvailableQuery, IsWorkspaceSlugAvailableQueryVariables>;
export function useIsWorkspaceSlugAvailableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsWorkspaceSlugAvailableQuery, IsWorkspaceSlugAvailableQueryVariables>): Apollo.UseSuspenseQueryResult<IsWorkspaceSlugAvailableQuery | undefined, IsWorkspaceSlugAvailableQueryVariables>;
export function useIsWorkspaceSlugAvailableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsWorkspaceSlugAvailableQuery, IsWorkspaceSlugAvailableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsWorkspaceSlugAvailableQuery, IsWorkspaceSlugAvailableQueryVariables>(IsWorkspaceSlugAvailableDocument, options);
        }
export type IsWorkspaceSlugAvailableQueryHookResult = ReturnType<typeof useIsWorkspaceSlugAvailableQuery>;
export type IsWorkspaceSlugAvailableLazyQueryHookResult = ReturnType<typeof useIsWorkspaceSlugAvailableLazyQuery>;
export type IsWorkspaceSlugAvailableSuspenseQueryHookResult = ReturnType<typeof useIsWorkspaceSlugAvailableSuspenseQuery>;
export type IsWorkspaceSlugAvailableQueryResult = Apollo.QueryResult<IsWorkspaceSlugAvailableQuery, IsWorkspaceSlugAvailableQueryVariables>;
export const MigrationDepartmentsDocument = gql`
    query MigrationDepartments($filter: GroupsFilter, $first: Int) {
  groups(filter: $filter, first: $first) {
    edges {
      node {
        id
        name
        externalReferenceID
      }
    }
  }
}
    `;

/**
 * __useMigrationDepartmentsQuery__
 *
 * To run a query within a React component, call `useMigrationDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMigrationDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMigrationDepartmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useMigrationDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<MigrationDepartmentsQuery, MigrationDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MigrationDepartmentsQuery, MigrationDepartmentsQueryVariables>(MigrationDepartmentsDocument, options);
      }
export function useMigrationDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MigrationDepartmentsQuery, MigrationDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MigrationDepartmentsQuery, MigrationDepartmentsQueryVariables>(MigrationDepartmentsDocument, options);
        }
// @ts-ignore
export function useMigrationDepartmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MigrationDepartmentsQuery, MigrationDepartmentsQueryVariables>): Apollo.UseSuspenseQueryResult<MigrationDepartmentsQuery, MigrationDepartmentsQueryVariables>;
export function useMigrationDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MigrationDepartmentsQuery, MigrationDepartmentsQueryVariables>): Apollo.UseSuspenseQueryResult<MigrationDepartmentsQuery | undefined, MigrationDepartmentsQueryVariables>;
export function useMigrationDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MigrationDepartmentsQuery, MigrationDepartmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MigrationDepartmentsQuery, MigrationDepartmentsQueryVariables>(MigrationDepartmentsDocument, options);
        }
export type MigrationDepartmentsQueryHookResult = ReturnType<typeof useMigrationDepartmentsQuery>;
export type MigrationDepartmentsLazyQueryHookResult = ReturnType<typeof useMigrationDepartmentsLazyQuery>;
export type MigrationDepartmentsSuspenseQueryHookResult = ReturnType<typeof useMigrationDepartmentsSuspenseQuery>;
export type MigrationDepartmentsQueryResult = Apollo.QueryResult<MigrationDepartmentsQuery, MigrationDepartmentsQueryVariables>;
export const OrganizationGroupsDocument = gql`
    query OrganizationGroups($filter: GroupsFilter, $before: ID, $after: ID, $first: Int, $last: Int) {
  groups(
    filter: $filter
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        id
        name
        isArchived
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useOrganizationGroupsQuery__
 *
 * To run a query within a React component, call `useOrganizationGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationGroupsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useOrganizationGroupsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationGroupsQuery, OrganizationGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationGroupsQuery, OrganizationGroupsQueryVariables>(OrganizationGroupsDocument, options);
      }
export function useOrganizationGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationGroupsQuery, OrganizationGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationGroupsQuery, OrganizationGroupsQueryVariables>(OrganizationGroupsDocument, options);
        }
// @ts-ignore
export function useOrganizationGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationGroupsQuery, OrganizationGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationGroupsQuery, OrganizationGroupsQueryVariables>;
export function useOrganizationGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationGroupsQuery, OrganizationGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationGroupsQuery | undefined, OrganizationGroupsQueryVariables>;
export function useOrganizationGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationGroupsQuery, OrganizationGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationGroupsQuery, OrganizationGroupsQueryVariables>(OrganizationGroupsDocument, options);
        }
export type OrganizationGroupsQueryHookResult = ReturnType<typeof useOrganizationGroupsQuery>;
export type OrganizationGroupsLazyQueryHookResult = ReturnType<typeof useOrganizationGroupsLazyQuery>;
export type OrganizationGroupsSuspenseQueryHookResult = ReturnType<typeof useOrganizationGroupsSuspenseQuery>;
export type OrganizationGroupsQueryResult = Apollo.QueryResult<OrganizationGroupsQuery, OrganizationGroupsQueryVariables>;
export const StyrJobMappingsDocument = gql`
    query StyrJobMappings {
  styrJobMappings {
    styrJobID
    styrJobName
    styrLevel
    jobFamilyName
    linkedJobTitles {
      id
      title
    }
  }
}
    `;

/**
 * __useStyrJobMappingsQuery__
 *
 * To run a query within a React component, call `useStyrJobMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStyrJobMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStyrJobMappingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStyrJobMappingsQuery(baseOptions?: Apollo.QueryHookOptions<StyrJobMappingsQuery, StyrJobMappingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StyrJobMappingsQuery, StyrJobMappingsQueryVariables>(StyrJobMappingsDocument, options);
      }
export function useStyrJobMappingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StyrJobMappingsQuery, StyrJobMappingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StyrJobMappingsQuery, StyrJobMappingsQueryVariables>(StyrJobMappingsDocument, options);
        }
// @ts-ignore
export function useStyrJobMappingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StyrJobMappingsQuery, StyrJobMappingsQueryVariables>): Apollo.UseSuspenseQueryResult<StyrJobMappingsQuery, StyrJobMappingsQueryVariables>;
export function useStyrJobMappingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StyrJobMappingsQuery, StyrJobMappingsQueryVariables>): Apollo.UseSuspenseQueryResult<StyrJobMappingsQuery | undefined, StyrJobMappingsQueryVariables>;
export function useStyrJobMappingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StyrJobMappingsQuery, StyrJobMappingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StyrJobMappingsQuery, StyrJobMappingsQueryVariables>(StyrJobMappingsDocument, options);
        }
export type StyrJobMappingsQueryHookResult = ReturnType<typeof useStyrJobMappingsQuery>;
export type StyrJobMappingsLazyQueryHookResult = ReturnType<typeof useStyrJobMappingsLazyQuery>;
export type StyrJobMappingsSuspenseQueryHookResult = ReturnType<typeof useStyrJobMappingsSuspenseQuery>;
export type StyrJobMappingsQueryResult = Apollo.QueryResult<StyrJobMappingsQuery, StyrJobMappingsQueryVariables>;
export const TeamsDocument = gql`
    query Teams($isArchived: Boolean!, $first: Int) {
  groups(filter: {isArchived: $isArchived, types: [TEAM]}, first: $first) {
    edges {
      node {
        id
        name
        isArchived
      }
    }
  }
}
    `;

/**
 * __useTeamsQuery__
 *
 * To run a query within a React component, call `useTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useTeamsQuery(baseOptions: Apollo.QueryHookOptions<TeamsQuery, TeamsQueryVariables> & ({ variables: TeamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
      }
export function useTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
        }
// @ts-ignore
export function useTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeamsQuery, TeamsQueryVariables>): Apollo.UseSuspenseQueryResult<TeamsQuery, TeamsQueryVariables>;
export function useTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamsQuery, TeamsQueryVariables>): Apollo.UseSuspenseQueryResult<TeamsQuery | undefined, TeamsQueryVariables>;
export function useTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
        }
export type TeamsQueryHookResult = ReturnType<typeof useTeamsQuery>;
export type TeamsLazyQueryHookResult = ReturnType<typeof useTeamsLazyQuery>;
export type TeamsSuspenseQueryHookResult = ReturnType<typeof useTeamsSuspenseQuery>;
export type TeamsQueryResult = Apollo.QueryResult<TeamsQuery, TeamsQueryVariables>;
export const ViewerDepartmentsDocument = gql`
    query ViewerDepartments {
  viewer {
    id
    roles {
      targetV2 {
        ... on Group {
          id
          name
          type
        }
      }
      role {
        id
        type
      }
    }
  }
}
    `;

/**
 * __useViewerDepartmentsQuery__
 *
 * To run a query within a React component, call `useViewerDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<ViewerDepartmentsQuery, ViewerDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerDepartmentsQuery, ViewerDepartmentsQueryVariables>(ViewerDepartmentsDocument, options);
      }
export function useViewerDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerDepartmentsQuery, ViewerDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerDepartmentsQuery, ViewerDepartmentsQueryVariables>(ViewerDepartmentsDocument, options);
        }
// @ts-ignore
export function useViewerDepartmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerDepartmentsQuery, ViewerDepartmentsQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerDepartmentsQuery, ViewerDepartmentsQueryVariables>;
export function useViewerDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerDepartmentsQuery, ViewerDepartmentsQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerDepartmentsQuery | undefined, ViewerDepartmentsQueryVariables>;
export function useViewerDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerDepartmentsQuery, ViewerDepartmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewerDepartmentsQuery, ViewerDepartmentsQueryVariables>(ViewerDepartmentsDocument, options);
        }
export type ViewerDepartmentsQueryHookResult = ReturnType<typeof useViewerDepartmentsQuery>;
export type ViewerDepartmentsLazyQueryHookResult = ReturnType<typeof useViewerDepartmentsLazyQuery>;
export type ViewerDepartmentsSuspenseQueryHookResult = ReturnType<typeof useViewerDepartmentsSuspenseQuery>;
export type ViewerDepartmentsQueryResult = Apollo.QueryResult<ViewerDepartmentsQuery, ViewerDepartmentsQueryVariables>;
export const ViewerGoodHabitzConfigDocument = gql`
    query ViewerGoodHabitzConfig {
  viewer {
    id
    workspace {
      id
      goodHabitzConfig {
        enabled
        languageIDs
        hasApiKey
        lastSyncedAt
      }
    }
  }
}
    `;

/**
 * __useViewerGoodHabitzConfigQuery__
 *
 * To run a query within a React component, call `useViewerGoodHabitzConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerGoodHabitzConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerGoodHabitzConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerGoodHabitzConfigQuery(baseOptions?: Apollo.QueryHookOptions<ViewerGoodHabitzConfigQuery, ViewerGoodHabitzConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerGoodHabitzConfigQuery, ViewerGoodHabitzConfigQueryVariables>(ViewerGoodHabitzConfigDocument, options);
      }
export function useViewerGoodHabitzConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerGoodHabitzConfigQuery, ViewerGoodHabitzConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerGoodHabitzConfigQuery, ViewerGoodHabitzConfigQueryVariables>(ViewerGoodHabitzConfigDocument, options);
        }
// @ts-ignore
export function useViewerGoodHabitzConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerGoodHabitzConfigQuery, ViewerGoodHabitzConfigQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerGoodHabitzConfigQuery, ViewerGoodHabitzConfigQueryVariables>;
export function useViewerGoodHabitzConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerGoodHabitzConfigQuery, ViewerGoodHabitzConfigQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerGoodHabitzConfigQuery | undefined, ViewerGoodHabitzConfigQueryVariables>;
export function useViewerGoodHabitzConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerGoodHabitzConfigQuery, ViewerGoodHabitzConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewerGoodHabitzConfigQuery, ViewerGoodHabitzConfigQueryVariables>(ViewerGoodHabitzConfigDocument, options);
        }
export type ViewerGoodHabitzConfigQueryHookResult = ReturnType<typeof useViewerGoodHabitzConfigQuery>;
export type ViewerGoodHabitzConfigLazyQueryHookResult = ReturnType<typeof useViewerGoodHabitzConfigLazyQuery>;
export type ViewerGoodHabitzConfigSuspenseQueryHookResult = ReturnType<typeof useViewerGoodHabitzConfigSuspenseQuery>;
export type ViewerGoodHabitzConfigQueryResult = Apollo.QueryResult<ViewerGoodHabitzConfigQuery, ViewerGoodHabitzConfigQueryVariables>;
export const ViewerGroupsDocument = gql`
    query ViewerGroups {
  viewer {
    id
    roles {
      targetV2 {
        ... on User {
          id
        }
        ... on Group {
          id
          name
          type
          isArchived
        }
      }
      role {
        id
        type
      }
    }
  }
}
    `;

/**
 * __useViewerGroupsQuery__
 *
 * To run a query within a React component, call `useViewerGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ViewerGroupsQuery, ViewerGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerGroupsQuery, ViewerGroupsQueryVariables>(ViewerGroupsDocument, options);
      }
export function useViewerGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerGroupsQuery, ViewerGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerGroupsQuery, ViewerGroupsQueryVariables>(ViewerGroupsDocument, options);
        }
// @ts-ignore
export function useViewerGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerGroupsQuery, ViewerGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerGroupsQuery, ViewerGroupsQueryVariables>;
export function useViewerGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerGroupsQuery, ViewerGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerGroupsQuery | undefined, ViewerGroupsQueryVariables>;
export function useViewerGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerGroupsQuery, ViewerGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewerGroupsQuery, ViewerGroupsQueryVariables>(ViewerGroupsDocument, options);
        }
export type ViewerGroupsQueryHookResult = ReturnType<typeof useViewerGroupsQuery>;
export type ViewerGroupsLazyQueryHookResult = ReturnType<typeof useViewerGroupsLazyQuery>;
export type ViewerGroupsSuspenseQueryHookResult = ReturnType<typeof useViewerGroupsSuspenseQuery>;
export type ViewerGroupsQueryResult = Apollo.QueryResult<ViewerGroupsQuery, ViewerGroupsQueryVariables>;
export const ViewerParentGroupsDocument = gql`
    query ViewerParentGroups {
  viewer {
    group {
      id
      name
      paths {
        groups {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useViewerParentGroupsQuery__
 *
 * To run a query within a React component, call `useViewerParentGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerParentGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerParentGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerParentGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ViewerParentGroupsQuery, ViewerParentGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerParentGroupsQuery, ViewerParentGroupsQueryVariables>(ViewerParentGroupsDocument, options);
      }
export function useViewerParentGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerParentGroupsQuery, ViewerParentGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerParentGroupsQuery, ViewerParentGroupsQueryVariables>(ViewerParentGroupsDocument, options);
        }
// @ts-ignore
export function useViewerParentGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerParentGroupsQuery, ViewerParentGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerParentGroupsQuery, ViewerParentGroupsQueryVariables>;
export function useViewerParentGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerParentGroupsQuery, ViewerParentGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerParentGroupsQuery | undefined, ViewerParentGroupsQueryVariables>;
export function useViewerParentGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerParentGroupsQuery, ViewerParentGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewerParentGroupsQuery, ViewerParentGroupsQueryVariables>(ViewerParentGroupsDocument, options);
        }
export type ViewerParentGroupsQueryHookResult = ReturnType<typeof useViewerParentGroupsQuery>;
export type ViewerParentGroupsLazyQueryHookResult = ReturnType<typeof useViewerParentGroupsLazyQuery>;
export type ViewerParentGroupsSuspenseQueryHookResult = ReturnType<typeof useViewerParentGroupsSuspenseQuery>;
export type ViewerParentGroupsQueryResult = Apollo.QueryResult<ViewerParentGroupsQuery, ViewerParentGroupsQueryVariables>;
export const ViewerStyrConfigDocument = gql`
    query ViewerStyrConfig {
  viewer {
    id
    workspace {
      id
      styrConfig {
        organisationID
        organisationLabel
        enabled
        lastSyncedAt
        languageIDs
      }
    }
  }
}
    `;

/**
 * __useViewerStyrConfigQuery__
 *
 * To run a query within a React component, call `useViewerStyrConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerStyrConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerStyrConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerStyrConfigQuery(baseOptions?: Apollo.QueryHookOptions<ViewerStyrConfigQuery, ViewerStyrConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerStyrConfigQuery, ViewerStyrConfigQueryVariables>(ViewerStyrConfigDocument, options);
      }
export function useViewerStyrConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerStyrConfigQuery, ViewerStyrConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerStyrConfigQuery, ViewerStyrConfigQueryVariables>(ViewerStyrConfigDocument, options);
        }
// @ts-ignore
export function useViewerStyrConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerStyrConfigQuery, ViewerStyrConfigQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerStyrConfigQuery, ViewerStyrConfigQueryVariables>;
export function useViewerStyrConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerStyrConfigQuery, ViewerStyrConfigQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerStyrConfigQuery | undefined, ViewerStyrConfigQueryVariables>;
export function useViewerStyrConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerStyrConfigQuery, ViewerStyrConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewerStyrConfigQuery, ViewerStyrConfigQueryVariables>(ViewerStyrConfigDocument, options);
        }
export type ViewerStyrConfigQueryHookResult = ReturnType<typeof useViewerStyrConfigQuery>;
export type ViewerStyrConfigLazyQueryHookResult = ReturnType<typeof useViewerStyrConfigLazyQuery>;
export type ViewerStyrConfigSuspenseQueryHookResult = ReturnType<typeof useViewerStyrConfigSuspenseQuery>;
export type ViewerStyrConfigQueryResult = Apollo.QueryResult<ViewerStyrConfigQuery, ViewerStyrConfigQueryVariables>;
export const ViewerWorkspacePlanDocument = gql`
    query ViewerWorkspacePlan {
  viewer {
    id
    workspace {
      id
      plans {
        ...WorkspacePlan
      }
      isExpired
    }
  }
}
    ${WorkspacePlanFragmentDoc}`;

/**
 * __useViewerWorkspacePlanQuery__
 *
 * To run a query within a React component, call `useViewerWorkspacePlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerWorkspacePlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerWorkspacePlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerWorkspacePlanQuery(baseOptions?: Apollo.QueryHookOptions<ViewerWorkspacePlanQuery, ViewerWorkspacePlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerWorkspacePlanQuery, ViewerWorkspacePlanQueryVariables>(ViewerWorkspacePlanDocument, options);
      }
export function useViewerWorkspacePlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerWorkspacePlanQuery, ViewerWorkspacePlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerWorkspacePlanQuery, ViewerWorkspacePlanQueryVariables>(ViewerWorkspacePlanDocument, options);
        }
// @ts-ignore
export function useViewerWorkspacePlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerWorkspacePlanQuery, ViewerWorkspacePlanQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerWorkspacePlanQuery, ViewerWorkspacePlanQueryVariables>;
export function useViewerWorkspacePlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerWorkspacePlanQuery, ViewerWorkspacePlanQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerWorkspacePlanQuery | undefined, ViewerWorkspacePlanQueryVariables>;
export function useViewerWorkspacePlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerWorkspacePlanQuery, ViewerWorkspacePlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewerWorkspacePlanQuery, ViewerWorkspacePlanQueryVariables>(ViewerWorkspacePlanDocument, options);
        }
export type ViewerWorkspacePlanQueryHookResult = ReturnType<typeof useViewerWorkspacePlanQuery>;
export type ViewerWorkspacePlanLazyQueryHookResult = ReturnType<typeof useViewerWorkspacePlanLazyQuery>;
export type ViewerWorkspacePlanSuspenseQueryHookResult = ReturnType<typeof useViewerWorkspacePlanSuspenseQuery>;
export type ViewerWorkspacePlanQueryResult = Apollo.QueryResult<ViewerWorkspacePlanQuery, ViewerWorkspacePlanQueryVariables>;
export const WorkspaceAliasDocument = gql`
    query WorkspaceAlias($alias: String!) {
  workspaceAlias(alias: $alias) {
    id
  }
}
    `;

/**
 * __useWorkspaceAliasQuery__
 *
 * To run a query within a React component, call `useWorkspaceAliasQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceAliasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceAliasQuery({
 *   variables: {
 *      alias: // value for 'alias'
 *   },
 * });
 */
export function useWorkspaceAliasQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceAliasQuery, WorkspaceAliasQueryVariables> & ({ variables: WorkspaceAliasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceAliasQuery, WorkspaceAliasQueryVariables>(WorkspaceAliasDocument, options);
      }
export function useWorkspaceAliasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceAliasQuery, WorkspaceAliasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceAliasQuery, WorkspaceAliasQueryVariables>(WorkspaceAliasDocument, options);
        }
// @ts-ignore
export function useWorkspaceAliasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceAliasQuery, WorkspaceAliasQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceAliasQuery, WorkspaceAliasQueryVariables>;
export function useWorkspaceAliasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceAliasQuery, WorkspaceAliasQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceAliasQuery | undefined, WorkspaceAliasQueryVariables>;
export function useWorkspaceAliasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceAliasQuery, WorkspaceAliasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceAliasQuery, WorkspaceAliasQueryVariables>(WorkspaceAliasDocument, options);
        }
export type WorkspaceAliasQueryHookResult = ReturnType<typeof useWorkspaceAliasQuery>;
export type WorkspaceAliasLazyQueryHookResult = ReturnType<typeof useWorkspaceAliasLazyQuery>;
export type WorkspaceAliasSuspenseQueryHookResult = ReturnType<typeof useWorkspaceAliasSuspenseQuery>;
export type WorkspaceAliasQueryResult = Apollo.QueryResult<WorkspaceAliasQuery, WorkspaceAliasQueryVariables>;
export const WorkspaceConnectorDocument = gql`
    query WorkspaceConnector {
  viewer {
    id
    workspace {
      id
      connector {
        id
        type
      }
    }
  }
}
    `;

/**
 * __useWorkspaceConnectorQuery__
 *
 * To run a query within a React component, call `useWorkspaceConnectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceConnectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceConnectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceConnectorQuery(baseOptions?: Apollo.QueryHookOptions<WorkspaceConnectorQuery, WorkspaceConnectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceConnectorQuery, WorkspaceConnectorQueryVariables>(WorkspaceConnectorDocument, options);
      }
export function useWorkspaceConnectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceConnectorQuery, WorkspaceConnectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceConnectorQuery, WorkspaceConnectorQueryVariables>(WorkspaceConnectorDocument, options);
        }
// @ts-ignore
export function useWorkspaceConnectorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceConnectorQuery, WorkspaceConnectorQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceConnectorQuery, WorkspaceConnectorQueryVariables>;
export function useWorkspaceConnectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceConnectorQuery, WorkspaceConnectorQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceConnectorQuery | undefined, WorkspaceConnectorQueryVariables>;
export function useWorkspaceConnectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceConnectorQuery, WorkspaceConnectorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceConnectorQuery, WorkspaceConnectorQueryVariables>(WorkspaceConnectorDocument, options);
        }
export type WorkspaceConnectorQueryHookResult = ReturnType<typeof useWorkspaceConnectorQuery>;
export type WorkspaceConnectorLazyQueryHookResult = ReturnType<typeof useWorkspaceConnectorLazyQuery>;
export type WorkspaceConnectorSuspenseQueryHookResult = ReturnType<typeof useWorkspaceConnectorSuspenseQuery>;
export type WorkspaceConnectorQueryResult = Apollo.QueryResult<WorkspaceConnectorQuery, WorkspaceConnectorQueryVariables>;
export const WorkspaceConnectorUsersDocument = gql`
    query WorkspaceConnectorUsers($id: ID!) {
  workspace(id: $id) {
    id
    connectorUsers
    cognitoUsers
  }
}
    `;

/**
 * __useWorkspaceConnectorUsersQuery__
 *
 * To run a query within a React component, call `useWorkspaceConnectorUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceConnectorUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceConnectorUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkspaceConnectorUsersQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceConnectorUsersQuery, WorkspaceConnectorUsersQueryVariables> & ({ variables: WorkspaceConnectorUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceConnectorUsersQuery, WorkspaceConnectorUsersQueryVariables>(WorkspaceConnectorUsersDocument, options);
      }
export function useWorkspaceConnectorUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceConnectorUsersQuery, WorkspaceConnectorUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceConnectorUsersQuery, WorkspaceConnectorUsersQueryVariables>(WorkspaceConnectorUsersDocument, options);
        }
// @ts-ignore
export function useWorkspaceConnectorUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceConnectorUsersQuery, WorkspaceConnectorUsersQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceConnectorUsersQuery, WorkspaceConnectorUsersQueryVariables>;
export function useWorkspaceConnectorUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceConnectorUsersQuery, WorkspaceConnectorUsersQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceConnectorUsersQuery | undefined, WorkspaceConnectorUsersQueryVariables>;
export function useWorkspaceConnectorUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceConnectorUsersQuery, WorkspaceConnectorUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceConnectorUsersQuery, WorkspaceConnectorUsersQueryVariables>(WorkspaceConnectorUsersDocument, options);
        }
export type WorkspaceConnectorUsersQueryHookResult = ReturnType<typeof useWorkspaceConnectorUsersQuery>;
export type WorkspaceConnectorUsersLazyQueryHookResult = ReturnType<typeof useWorkspaceConnectorUsersLazyQuery>;
export type WorkspaceConnectorUsersSuspenseQueryHookResult = ReturnType<typeof useWorkspaceConnectorUsersSuspenseQuery>;
export type WorkspaceConnectorUsersQueryResult = Apollo.QueryResult<WorkspaceConnectorUsersQuery, WorkspaceConnectorUsersQueryVariables>;
export const WorkspaceCustomEmailDomainDocument = gql`
    query WorkspaceCustomEmailDomain {
  viewer {
    id
    workspace {
      id
      customEmailDomain {
        ...CustomEmailDomainFragment
      }
    }
  }
}
    ${CustomEmailDomainFragmentFragmentDoc}`;

/**
 * __useWorkspaceCustomEmailDomainQuery__
 *
 * To run a query within a React component, call `useWorkspaceCustomEmailDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceCustomEmailDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceCustomEmailDomainQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceCustomEmailDomainQuery(baseOptions?: Apollo.QueryHookOptions<WorkspaceCustomEmailDomainQuery, WorkspaceCustomEmailDomainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceCustomEmailDomainQuery, WorkspaceCustomEmailDomainQueryVariables>(WorkspaceCustomEmailDomainDocument, options);
      }
export function useWorkspaceCustomEmailDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceCustomEmailDomainQuery, WorkspaceCustomEmailDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceCustomEmailDomainQuery, WorkspaceCustomEmailDomainQueryVariables>(WorkspaceCustomEmailDomainDocument, options);
        }
// @ts-ignore
export function useWorkspaceCustomEmailDomainSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceCustomEmailDomainQuery, WorkspaceCustomEmailDomainQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceCustomEmailDomainQuery, WorkspaceCustomEmailDomainQueryVariables>;
export function useWorkspaceCustomEmailDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceCustomEmailDomainQuery, WorkspaceCustomEmailDomainQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceCustomEmailDomainQuery | undefined, WorkspaceCustomEmailDomainQueryVariables>;
export function useWorkspaceCustomEmailDomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceCustomEmailDomainQuery, WorkspaceCustomEmailDomainQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceCustomEmailDomainQuery, WorkspaceCustomEmailDomainQueryVariables>(WorkspaceCustomEmailDomainDocument, options);
        }
export type WorkspaceCustomEmailDomainQueryHookResult = ReturnType<typeof useWorkspaceCustomEmailDomainQuery>;
export type WorkspaceCustomEmailDomainLazyQueryHookResult = ReturnType<typeof useWorkspaceCustomEmailDomainLazyQuery>;
export type WorkspaceCustomEmailDomainSuspenseQueryHookResult = ReturnType<typeof useWorkspaceCustomEmailDomainSuspenseQuery>;
export type WorkspaceCustomEmailDomainQueryResult = Apollo.QueryResult<WorkspaceCustomEmailDomainQuery, WorkspaceCustomEmailDomainQueryVariables>;
export const WorkspaceFeaturesDocument = gql`
    query WorkspaceFeatures($id: ID!) {
  workspace(id: $id) {
    id
    features {
      ...WorkspaceFeature
    }
  }
}
    ${WorkspaceFeatureFragmentDoc}`;

/**
 * __useWorkspaceFeaturesQuery__
 *
 * To run a query within a React component, call `useWorkspaceFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceFeaturesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkspaceFeaturesQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceFeaturesQuery, WorkspaceFeaturesQueryVariables> & ({ variables: WorkspaceFeaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceFeaturesQuery, WorkspaceFeaturesQueryVariables>(WorkspaceFeaturesDocument, options);
      }
export function useWorkspaceFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceFeaturesQuery, WorkspaceFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceFeaturesQuery, WorkspaceFeaturesQueryVariables>(WorkspaceFeaturesDocument, options);
        }
// @ts-ignore
export function useWorkspaceFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceFeaturesQuery, WorkspaceFeaturesQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceFeaturesQuery, WorkspaceFeaturesQueryVariables>;
export function useWorkspaceFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceFeaturesQuery, WorkspaceFeaturesQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceFeaturesQuery | undefined, WorkspaceFeaturesQueryVariables>;
export function useWorkspaceFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceFeaturesQuery, WorkspaceFeaturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceFeaturesQuery, WorkspaceFeaturesQueryVariables>(WorkspaceFeaturesDocument, options);
        }
export type WorkspaceFeaturesQueryHookResult = ReturnType<typeof useWorkspaceFeaturesQuery>;
export type WorkspaceFeaturesLazyQueryHookResult = ReturnType<typeof useWorkspaceFeaturesLazyQuery>;
export type WorkspaceFeaturesSuspenseQueryHookResult = ReturnType<typeof useWorkspaceFeaturesSuspenseQuery>;
export type WorkspaceFeaturesQueryResult = Apollo.QueryResult<WorkspaceFeaturesQuery, WorkspaceFeaturesQueryVariables>;
export const WorkspaceNotificationSettingsDocument = gql`
    query WorkspaceNotificationSettings {
  viewer {
    id
    workspace {
      id
      notificationSettings {
        header
        footer
        welcomeEmail {
          body
          subject
        }
      }
    }
  }
}
    `;

/**
 * __useWorkspaceNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useWorkspaceNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceNotificationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceNotificationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<WorkspaceNotificationSettingsQuery, WorkspaceNotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceNotificationSettingsQuery, WorkspaceNotificationSettingsQueryVariables>(WorkspaceNotificationSettingsDocument, options);
      }
export function useWorkspaceNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceNotificationSettingsQuery, WorkspaceNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceNotificationSettingsQuery, WorkspaceNotificationSettingsQueryVariables>(WorkspaceNotificationSettingsDocument, options);
        }
// @ts-ignore
export function useWorkspaceNotificationSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceNotificationSettingsQuery, WorkspaceNotificationSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceNotificationSettingsQuery, WorkspaceNotificationSettingsQueryVariables>;
export function useWorkspaceNotificationSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceNotificationSettingsQuery, WorkspaceNotificationSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceNotificationSettingsQuery | undefined, WorkspaceNotificationSettingsQueryVariables>;
export function useWorkspaceNotificationSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceNotificationSettingsQuery, WorkspaceNotificationSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceNotificationSettingsQuery, WorkspaceNotificationSettingsQueryVariables>(WorkspaceNotificationSettingsDocument, options);
        }
export type WorkspaceNotificationSettingsQueryHookResult = ReturnType<typeof useWorkspaceNotificationSettingsQuery>;
export type WorkspaceNotificationSettingsLazyQueryHookResult = ReturnType<typeof useWorkspaceNotificationSettingsLazyQuery>;
export type WorkspaceNotificationSettingsSuspenseQueryHookResult = ReturnType<typeof useWorkspaceNotificationSettingsSuspenseQuery>;
export type WorkspaceNotificationSettingsQueryResult = Apollo.QueryResult<WorkspaceNotificationSettingsQuery, WorkspaceNotificationSettingsQueryVariables>;
export const WorkspaceNpsAnalyticsDocument = gql`
    query WorkspaceNpsAnalytics($filters: AnalyticsFilters!) {
  workspaceAnalytics(filters: $filters) {
    engagementENPS {
      detractors
      passives
      promoters
      score
      totalRequestsSent
      totalRequestsCompleted
    }
    engagementGroupsENPS {
      group {
        id
        name
      }
      detractors
      passives
      promoters
      score
      totalRequestsSent
      totalRequestsCompleted
    }
  }
}
    `;

/**
 * __useWorkspaceNpsAnalyticsQuery__
 *
 * To run a query within a React component, call `useWorkspaceNpsAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceNpsAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceNpsAnalyticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useWorkspaceNpsAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceNpsAnalyticsQuery, WorkspaceNpsAnalyticsQueryVariables> & ({ variables: WorkspaceNpsAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceNpsAnalyticsQuery, WorkspaceNpsAnalyticsQueryVariables>(WorkspaceNpsAnalyticsDocument, options);
      }
export function useWorkspaceNpsAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceNpsAnalyticsQuery, WorkspaceNpsAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceNpsAnalyticsQuery, WorkspaceNpsAnalyticsQueryVariables>(WorkspaceNpsAnalyticsDocument, options);
        }
// @ts-ignore
export function useWorkspaceNpsAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceNpsAnalyticsQuery, WorkspaceNpsAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceNpsAnalyticsQuery, WorkspaceNpsAnalyticsQueryVariables>;
export function useWorkspaceNpsAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceNpsAnalyticsQuery, WorkspaceNpsAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceNpsAnalyticsQuery | undefined, WorkspaceNpsAnalyticsQueryVariables>;
export function useWorkspaceNpsAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceNpsAnalyticsQuery, WorkspaceNpsAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceNpsAnalyticsQuery, WorkspaceNpsAnalyticsQueryVariables>(WorkspaceNpsAnalyticsDocument, options);
        }
export type WorkspaceNpsAnalyticsQueryHookResult = ReturnType<typeof useWorkspaceNpsAnalyticsQuery>;
export type WorkspaceNpsAnalyticsLazyQueryHookResult = ReturnType<typeof useWorkspaceNpsAnalyticsLazyQuery>;
export type WorkspaceNpsAnalyticsSuspenseQueryHookResult = ReturnType<typeof useWorkspaceNpsAnalyticsSuspenseQuery>;
export type WorkspaceNpsAnalyticsQueryResult = Apollo.QueryResult<WorkspaceNpsAnalyticsQuery, WorkspaceNpsAnalyticsQueryVariables>;
export const WorkspaceStatisticsDocument = gql`
    query WorkspaceStatistics($workspaceID: ID!) {
  workspaceStatistics(workspaceID: $workspaceID) {
    workspaceID
    date
    active
    draft
    archived
    deactivated
  }
}
    `;

/**
 * __useWorkspaceStatisticsQuery__
 *
 * To run a query within a React component, call `useWorkspaceStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceStatisticsQuery({
 *   variables: {
 *      workspaceID: // value for 'workspaceID'
 *   },
 * });
 */
export function useWorkspaceStatisticsQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceStatisticsQuery, WorkspaceStatisticsQueryVariables> & ({ variables: WorkspaceStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceStatisticsQuery, WorkspaceStatisticsQueryVariables>(WorkspaceStatisticsDocument, options);
      }
export function useWorkspaceStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceStatisticsQuery, WorkspaceStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceStatisticsQuery, WorkspaceStatisticsQueryVariables>(WorkspaceStatisticsDocument, options);
        }
// @ts-ignore
export function useWorkspaceStatisticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceStatisticsQuery, WorkspaceStatisticsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceStatisticsQuery, WorkspaceStatisticsQueryVariables>;
export function useWorkspaceStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceStatisticsQuery, WorkspaceStatisticsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceStatisticsQuery | undefined, WorkspaceStatisticsQueryVariables>;
export function useWorkspaceStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceStatisticsQuery, WorkspaceStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceStatisticsQuery, WorkspaceStatisticsQueryVariables>(WorkspaceStatisticsDocument, options);
        }
export type WorkspaceStatisticsQueryHookResult = ReturnType<typeof useWorkspaceStatisticsQuery>;
export type WorkspaceStatisticsLazyQueryHookResult = ReturnType<typeof useWorkspaceStatisticsLazyQuery>;
export type WorkspaceStatisticsSuspenseQueryHookResult = ReturnType<typeof useWorkspaceStatisticsSuspenseQuery>;
export type WorkspaceStatisticsQueryResult = Apollo.QueryResult<WorkspaceStatisticsQuery, WorkspaceStatisticsQueryVariables>;
export const WorkspaceStyrAdminDocument = gql`
    query WorkspaceStyrAdmin($workspaceID: String!) {
  workspacesV2(filters: {prefix: $workspaceID}) {
    edges {
      node {
        id
        alias
        styrConfigAdmin {
          organisationID
          organisationLabel
          enabled
          languageIDs
        }
      }
    }
  }
}
    `;

/**
 * __useWorkspaceStyrAdminQuery__
 *
 * To run a query within a React component, call `useWorkspaceStyrAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceStyrAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceStyrAdminQuery({
 *   variables: {
 *      workspaceID: // value for 'workspaceID'
 *   },
 * });
 */
export function useWorkspaceStyrAdminQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceStyrAdminQuery, WorkspaceStyrAdminQueryVariables> & ({ variables: WorkspaceStyrAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceStyrAdminQuery, WorkspaceStyrAdminQueryVariables>(WorkspaceStyrAdminDocument, options);
      }
export function useWorkspaceStyrAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceStyrAdminQuery, WorkspaceStyrAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceStyrAdminQuery, WorkspaceStyrAdminQueryVariables>(WorkspaceStyrAdminDocument, options);
        }
// @ts-ignore
export function useWorkspaceStyrAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceStyrAdminQuery, WorkspaceStyrAdminQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceStyrAdminQuery, WorkspaceStyrAdminQueryVariables>;
export function useWorkspaceStyrAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceStyrAdminQuery, WorkspaceStyrAdminQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceStyrAdminQuery | undefined, WorkspaceStyrAdminQueryVariables>;
export function useWorkspaceStyrAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceStyrAdminQuery, WorkspaceStyrAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceStyrAdminQuery, WorkspaceStyrAdminQueryVariables>(WorkspaceStyrAdminDocument, options);
        }
export type WorkspaceStyrAdminQueryHookResult = ReturnType<typeof useWorkspaceStyrAdminQuery>;
export type WorkspaceStyrAdminLazyQueryHookResult = ReturnType<typeof useWorkspaceStyrAdminLazyQuery>;
export type WorkspaceStyrAdminSuspenseQueryHookResult = ReturnType<typeof useWorkspaceStyrAdminSuspenseQuery>;
export type WorkspaceStyrAdminQueryResult = Apollo.QueryResult<WorkspaceStyrAdminQuery, WorkspaceStyrAdminQueryVariables>;
export const WorkspaceThemeDocument = gql`
    query WorkspaceTheme($id: ID!) {
  workspace(id: $id) {
    id
    theme {
      logo {
        source {
          url
        }
      }
      background {
        source {
          url
        }
      }
      primaryColor
      primaryColorDark
      secondaryColor
      linearGradientStart
      linearGradientEnd
    }
  }
}
    `;

/**
 * __useWorkspaceThemeQuery__
 *
 * To run a query within a React component, call `useWorkspaceThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceThemeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkspaceThemeQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceThemeQuery, WorkspaceThemeQueryVariables> & ({ variables: WorkspaceThemeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceThemeQuery, WorkspaceThemeQueryVariables>(WorkspaceThemeDocument, options);
      }
export function useWorkspaceThemeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceThemeQuery, WorkspaceThemeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceThemeQuery, WorkspaceThemeQueryVariables>(WorkspaceThemeDocument, options);
        }
// @ts-ignore
export function useWorkspaceThemeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceThemeQuery, WorkspaceThemeQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceThemeQuery, WorkspaceThemeQueryVariables>;
export function useWorkspaceThemeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceThemeQuery, WorkspaceThemeQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceThemeQuery | undefined, WorkspaceThemeQueryVariables>;
export function useWorkspaceThemeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceThemeQuery, WorkspaceThemeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceThemeQuery, WorkspaceThemeQueryVariables>(WorkspaceThemeDocument, options);
        }
export type WorkspaceThemeQueryHookResult = ReturnType<typeof useWorkspaceThemeQuery>;
export type WorkspaceThemeLazyQueryHookResult = ReturnType<typeof useWorkspaceThemeLazyQuery>;
export type WorkspaceThemeSuspenseQueryHookResult = ReturnType<typeof useWorkspaceThemeSuspenseQuery>;
export type WorkspaceThemeQueryResult = Apollo.QueryResult<WorkspaceThemeQuery, WorkspaceThemeQueryVariables>;
export const WorkspacesDocument = gql`
    query Workspaces($filters: WorkspaceFilters!, $first: Int, $last: Int, $after: ID, $before: ID) {
  workspacesV2(
    filters: $filters
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    edges {
      node {
        id
        alias
        displayName
        emailDomains
        isArchived
        hubSpotCompanyID
        plans {
          ...WorkspacePlan
        }
        connectorAdmin {
          ...WorkspaceConnectorAdmin
        }
        stripeCustomerID
        stripeCollectionMethod
        user(username: "support") {
          id
          username
          email
          firstName
          lastName
          associatedIdentities {
            identityProvider {
              id
            }
            name
          }
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${WorkspacePlanFragmentDoc}
${WorkspaceConnectorAdminFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useWorkspacesQuery__
 *
 * To run a query within a React component, call `useWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspacesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useWorkspacesQuery(baseOptions: Apollo.QueryHookOptions<WorkspacesQuery, WorkspacesQueryVariables> & ({ variables: WorkspacesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspacesQuery, WorkspacesQueryVariables>(WorkspacesDocument, options);
      }
export function useWorkspacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspacesQuery, WorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspacesQuery, WorkspacesQueryVariables>(WorkspacesDocument, options);
        }
// @ts-ignore
export function useWorkspacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspacesQuery, WorkspacesQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspacesQuery, WorkspacesQueryVariables>;
export function useWorkspacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspacesQuery, WorkspacesQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspacesQuery | undefined, WorkspacesQueryVariables>;
export function useWorkspacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspacesQuery, WorkspacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspacesQuery, WorkspacesQueryVariables>(WorkspacesDocument, options);
        }
export type WorkspacesQueryHookResult = ReturnType<typeof useWorkspacesQuery>;
export type WorkspacesLazyQueryHookResult = ReturnType<typeof useWorkspacesLazyQuery>;
export type WorkspacesSuspenseQueryHookResult = ReturnType<typeof useWorkspacesSuspenseQuery>;
export type WorkspacesQueryResult = Apollo.QueryResult<WorkspacesQuery, WorkspacesQueryVariables>;
export const WorkspacesBasicDocument = gql`
    query WorkspacesBasic($filters: WorkspaceFilters!, $first: Int, $last: Int, $after: ID, $before: ID) {
  workspacesV2(
    filters: $filters
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    edges {
      node {
        id
        alias
        isArchived
        plans {
          ...WorkspacePlan
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${WorkspacePlanFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useWorkspacesBasicQuery__
 *
 * To run a query within a React component, call `useWorkspacesBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspacesBasicQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useWorkspacesBasicQuery(baseOptions: Apollo.QueryHookOptions<WorkspacesBasicQuery, WorkspacesBasicQueryVariables> & ({ variables: WorkspacesBasicQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspacesBasicQuery, WorkspacesBasicQueryVariables>(WorkspacesBasicDocument, options);
      }
export function useWorkspacesBasicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspacesBasicQuery, WorkspacesBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspacesBasicQuery, WorkspacesBasicQueryVariables>(WorkspacesBasicDocument, options);
        }
// @ts-ignore
export function useWorkspacesBasicSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspacesBasicQuery, WorkspacesBasicQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspacesBasicQuery, WorkspacesBasicQueryVariables>;
export function useWorkspacesBasicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspacesBasicQuery, WorkspacesBasicQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspacesBasicQuery | undefined, WorkspacesBasicQueryVariables>;
export function useWorkspacesBasicSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspacesBasicQuery, WorkspacesBasicQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspacesBasicQuery, WorkspacesBasicQueryVariables>(WorkspacesBasicDocument, options);
        }
export type WorkspacesBasicQueryHookResult = ReturnType<typeof useWorkspacesBasicQuery>;
export type WorkspacesBasicLazyQueryHookResult = ReturnType<typeof useWorkspacesBasicLazyQuery>;
export type WorkspacesBasicSuspenseQueryHookResult = ReturnType<typeof useWorkspacesBasicSuspenseQuery>;
export type WorkspacesBasicQueryResult = Apollo.QueryResult<WorkspacesBasicQuery, WorkspacesBasicQueryVariables>;
export const WorkspacesMinimalDocument = gql`
    query WorkspacesMinimal($filters: WorkspaceFilters!, $first: Int, $last: Int, $after: ID, $before: ID) {
  workspacesV2(
    filters: $filters
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    edges {
      node {
        id
        alias
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useWorkspacesMinimalQuery__
 *
 * To run a query within a React component, call `useWorkspacesMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspacesMinimalQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useWorkspacesMinimalQuery(baseOptions: Apollo.QueryHookOptions<WorkspacesMinimalQuery, WorkspacesMinimalQueryVariables> & ({ variables: WorkspacesMinimalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspacesMinimalQuery, WorkspacesMinimalQueryVariables>(WorkspacesMinimalDocument, options);
      }
export function useWorkspacesMinimalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspacesMinimalQuery, WorkspacesMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspacesMinimalQuery, WorkspacesMinimalQueryVariables>(WorkspacesMinimalDocument, options);
        }
// @ts-ignore
export function useWorkspacesMinimalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspacesMinimalQuery, WorkspacesMinimalQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspacesMinimalQuery, WorkspacesMinimalQueryVariables>;
export function useWorkspacesMinimalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspacesMinimalQuery, WorkspacesMinimalQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspacesMinimalQuery | undefined, WorkspacesMinimalQueryVariables>;
export function useWorkspacesMinimalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspacesMinimalQuery, WorkspacesMinimalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspacesMinimalQuery, WorkspacesMinimalQueryVariables>(WorkspacesMinimalDocument, options);
        }
export type WorkspacesMinimalQueryHookResult = ReturnType<typeof useWorkspacesMinimalQuery>;
export type WorkspacesMinimalLazyQueryHookResult = ReturnType<typeof useWorkspacesMinimalLazyQuery>;
export type WorkspacesMinimalSuspenseQueryHookResult = ReturnType<typeof useWorkspacesMinimalSuspenseQuery>;
export type WorkspacesMinimalQueryResult = Apollo.QueryResult<WorkspacesMinimalQuery, WorkspacesMinimalQueryVariables>;
export const WorkspacesUsersDocument = gql`
    query WorkspacesUsers($filters: WorkspaceFilters!, $first: Int, $last: Int, $after: ID, $before: ID) {
  workspacesV2(
    filters: $filters
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    edges {
      node {
        id
        connectorUsers
        cognitoUsers
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useWorkspacesUsersQuery__
 *
 * To run a query within a React component, call `useWorkspacesUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspacesUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useWorkspacesUsersQuery(baseOptions: Apollo.QueryHookOptions<WorkspacesUsersQuery, WorkspacesUsersQueryVariables> & ({ variables: WorkspacesUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspacesUsersQuery, WorkspacesUsersQueryVariables>(WorkspacesUsersDocument, options);
      }
export function useWorkspacesUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspacesUsersQuery, WorkspacesUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspacesUsersQuery, WorkspacesUsersQueryVariables>(WorkspacesUsersDocument, options);
        }
// @ts-ignore
export function useWorkspacesUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspacesUsersQuery, WorkspacesUsersQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspacesUsersQuery, WorkspacesUsersQueryVariables>;
export function useWorkspacesUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspacesUsersQuery, WorkspacesUsersQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspacesUsersQuery | undefined, WorkspacesUsersQueryVariables>;
export function useWorkspacesUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspacesUsersQuery, WorkspacesUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspacesUsersQuery, WorkspacesUsersQueryVariables>(WorkspacesUsersDocument, options);
        }
export type WorkspacesUsersQueryHookResult = ReturnType<typeof useWorkspacesUsersQuery>;
export type WorkspacesUsersLazyQueryHookResult = ReturnType<typeof useWorkspacesUsersLazyQuery>;
export type WorkspacesUsersSuspenseQueryHookResult = ReturnType<typeof useWorkspacesUsersSuspenseQuery>;
export type WorkspacesUsersQueryResult = Apollo.QueryResult<WorkspacesUsersQuery, WorkspacesUsersQueryVariables>;
export const PageDocument = gql`
    query Page($type: PageType!) {
  page(type: $type) {
    type
    content
    url
  }
}
    `;

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePageQuery(baseOptions: Apollo.QueryHookOptions<PageQuery, PageQueryVariables> & ({ variables: PageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageQuery, PageQueryVariables>(PageDocument, options);
      }
export function usePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageQuery, PageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageQuery, PageQueryVariables>(PageDocument, options);
        }
// @ts-ignore
export function usePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageQuery, PageQueryVariables>): Apollo.UseSuspenseQueryResult<PageQuery, PageQueryVariables>;
export function usePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageQuery, PageQueryVariables>): Apollo.UseSuspenseQueryResult<PageQuery | undefined, PageQueryVariables>;
export function usePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageQuery, PageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageQuery, PageQueryVariables>(PageDocument, options);
        }
export type PageQueryHookResult = ReturnType<typeof usePageQuery>;
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>;
export type PageSuspenseQueryHookResult = ReturnType<typeof usePageSuspenseQuery>;
export type PageQueryResult = Apollo.QueryResult<PageQuery, PageQueryVariables>;
export const UpdatePageDocument = gql`
    mutation UpdatePage($input: PageUpdateInput!) {
  upsertPage(input: $input) {
    type
    content
    url
  }
}
    `;
export type UpdatePageMutationFn = Apollo.MutationFunction<UpdatePageMutation, UpdatePageMutationVariables>;

/**
 * __useUpdatePageMutation__
 *
 * To run a mutation, you first call `useUpdatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageMutation, { data, loading, error }] = useUpdatePageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageMutation, UpdatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageMutation, UpdatePageMutationVariables>(UpdatePageDocument, options);
      }
export type UpdatePageMutationHookResult = ReturnType<typeof useUpdatePageMutation>;
export type UpdatePageMutationResult = Apollo.MutationResult<UpdatePageMutation>;
export type UpdatePageMutationOptions = Apollo.BaseMutationOptions<UpdatePageMutation, UpdatePageMutationVariables>;
export const DeleteRevealUploadDocument = gql`
    mutation DeleteRevealUpload($evaluationFormID: ID!) {
  deleteRevealUpload(evaluationFormID: $evaluationFormID)
}
    `;
export type DeleteRevealUploadMutationFn = Apollo.MutationFunction<DeleteRevealUploadMutation, DeleteRevealUploadMutationVariables>;

/**
 * __useDeleteRevealUploadMutation__
 *
 * To run a mutation, you first call `useDeleteRevealUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRevealUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRevealUploadMutation, { data, loading, error }] = useDeleteRevealUploadMutation({
 *   variables: {
 *      evaluationFormID: // value for 'evaluationFormID'
 *   },
 * });
 */
export function useDeleteRevealUploadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRevealUploadMutation, DeleteRevealUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRevealUploadMutation, DeleteRevealUploadMutationVariables>(DeleteRevealUploadDocument, options);
      }
export type DeleteRevealUploadMutationHookResult = ReturnType<typeof useDeleteRevealUploadMutation>;
export type DeleteRevealUploadMutationResult = Apollo.MutationResult<DeleteRevealUploadMutation>;
export type DeleteRevealUploadMutationOptions = Apollo.BaseMutationOptions<DeleteRevealUploadMutation, DeleteRevealUploadMutationVariables>;
export const GetRevealUploadUrlDocument = gql`
    mutation GetRevealUploadUrl($contentLength: Int!) {
  getRevealUploadUrl(contentLength: $contentLength) {
    objectKey
    uploadUrl
    uploadHeaders {
      name
      values
    }
  }
}
    `;
export type GetRevealUploadUrlMutationFn = Apollo.MutationFunction<GetRevealUploadUrlMutation, GetRevealUploadUrlMutationVariables>;

/**
 * __useGetRevealUploadUrlMutation__
 *
 * To run a mutation, you first call `useGetRevealUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetRevealUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getRevealUploadUrlMutation, { data, loading, error }] = useGetRevealUploadUrlMutation({
 *   variables: {
 *      contentLength: // value for 'contentLength'
 *   },
 * });
 */
export function useGetRevealUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetRevealUploadUrlMutation, GetRevealUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetRevealUploadUrlMutation, GetRevealUploadUrlMutationVariables>(GetRevealUploadUrlDocument, options);
      }
export type GetRevealUploadUrlMutationHookResult = ReturnType<typeof useGetRevealUploadUrlMutation>;
export type GetRevealUploadUrlMutationResult = Apollo.MutationResult<GetRevealUploadUrlMutation>;
export type GetRevealUploadUrlMutationOptions = Apollo.BaseMutationOptions<GetRevealUploadUrlMutation, GetRevealUploadUrlMutationVariables>;
export const MarkRevealSeenDocument = gql`
    mutation MarkRevealSeen($submissionID: ID!) {
  markRevealSeen(submissionID: $submissionID)
}
    `;
export type MarkRevealSeenMutationFn = Apollo.MutationFunction<MarkRevealSeenMutation, MarkRevealSeenMutationVariables>;

/**
 * __useMarkRevealSeenMutation__
 *
 * To run a mutation, you first call `useMarkRevealSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkRevealSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markRevealSeenMutation, { data, loading, error }] = useMarkRevealSeenMutation({
 *   variables: {
 *      submissionID: // value for 'submissionID'
 *   },
 * });
 */
export function useMarkRevealSeenMutation(baseOptions?: Apollo.MutationHookOptions<MarkRevealSeenMutation, MarkRevealSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkRevealSeenMutation, MarkRevealSeenMutationVariables>(MarkRevealSeenDocument, options);
      }
export type MarkRevealSeenMutationHookResult = ReturnType<typeof useMarkRevealSeenMutation>;
export type MarkRevealSeenMutationResult = Apollo.MutationResult<MarkRevealSeenMutation>;
export type MarkRevealSeenMutationOptions = Apollo.BaseMutationOptions<MarkRevealSeenMutation, MarkRevealSeenMutationVariables>;
export const ParseRevealUploadDocument = gql`
    mutation ParseRevealUpload($objectKey: String!) {
  parseRevealUpload(objectKey: $objectKey) {
    matchedCount
    skippedCount
    matchColumn
    detectedFields
    fieldPreviews {
      label
      type
      example
    }
    skippedKeys
    matchedUsers {
      user {
        id
        firstName
        lastName
        fullName
        avatar {
          source {
            url
          }
        }
      }
      values {
        label
        value
        type
      }
    }
  }
}
    `;
export type ParseRevealUploadMutationFn = Apollo.MutationFunction<ParseRevealUploadMutation, ParseRevealUploadMutationVariables>;

/**
 * __useParseRevealUploadMutation__
 *
 * To run a mutation, you first call `useParseRevealUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParseRevealUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parseRevealUploadMutation, { data, loading, error }] = useParseRevealUploadMutation({
 *   variables: {
 *      objectKey: // value for 'objectKey'
 *   },
 * });
 */
export function useParseRevealUploadMutation(baseOptions?: Apollo.MutationHookOptions<ParseRevealUploadMutation, ParseRevealUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ParseRevealUploadMutation, ParseRevealUploadMutationVariables>(ParseRevealUploadDocument, options);
      }
export type ParseRevealUploadMutationHookResult = ReturnType<typeof useParseRevealUploadMutation>;
export type ParseRevealUploadMutationResult = Apollo.MutationResult<ParseRevealUploadMutation>;
export type ParseRevealUploadMutationOptions = Apollo.BaseMutationOptions<ParseRevealUploadMutation, ParseRevealUploadMutationVariables>;
export const SaveRevealUploadDocument = gql`
    mutation SaveRevealUpload($objectKey: String!, $evaluationFormID: ID!, $selectedFields: [String!]!, $excludedUserIDs: [ID!], $fieldTypes: [RevealFieldTypeInput!]) {
  saveRevealUpload(
    objectKey: $objectKey
    evaluationFormID: $evaluationFormID
    selectedFields: $selectedFields
    excludedUserIDs: $excludedUserIDs
    fieldTypes: $fieldTypes
  ) {
    matchedCount
    skippedCount
  }
}
    `;
export type SaveRevealUploadMutationFn = Apollo.MutationFunction<SaveRevealUploadMutation, SaveRevealUploadMutationVariables>;

/**
 * __useSaveRevealUploadMutation__
 *
 * To run a mutation, you first call `useSaveRevealUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRevealUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRevealUploadMutation, { data, loading, error }] = useSaveRevealUploadMutation({
 *   variables: {
 *      objectKey: // value for 'objectKey'
 *      evaluationFormID: // value for 'evaluationFormID'
 *      selectedFields: // value for 'selectedFields'
 *      excludedUserIDs: // value for 'excludedUserIDs'
 *      fieldTypes: // value for 'fieldTypes'
 *   },
 * });
 */
export function useSaveRevealUploadMutation(baseOptions?: Apollo.MutationHookOptions<SaveRevealUploadMutation, SaveRevealUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveRevealUploadMutation, SaveRevealUploadMutationVariables>(SaveRevealUploadDocument, options);
      }
export type SaveRevealUploadMutationHookResult = ReturnType<typeof useSaveRevealUploadMutation>;
export type SaveRevealUploadMutationResult = Apollo.MutationResult<SaveRevealUploadMutation>;
export type SaveRevealUploadMutationOptions = Apollo.BaseMutationOptions<SaveRevealUploadMutation, SaveRevealUploadMutationVariables>;
export const EvaluationFormRevealUploadDocument = gql`
    query EvaluationFormRevealUpload($id: ID!) {
  evaluationForm(id: $id) {
    id
    revealUpload {
      selectedFields
      uploadedAt
      matchedCount
    }
  }
}
    `;

/**
 * __useEvaluationFormRevealUploadQuery__
 *
 * To run a query within a React component, call `useEvaluationFormRevealUploadQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluationFormRevealUploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluationFormRevealUploadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEvaluationFormRevealUploadQuery(baseOptions: Apollo.QueryHookOptions<EvaluationFormRevealUploadQuery, EvaluationFormRevealUploadQueryVariables> & ({ variables: EvaluationFormRevealUploadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvaluationFormRevealUploadQuery, EvaluationFormRevealUploadQueryVariables>(EvaluationFormRevealUploadDocument, options);
      }
export function useEvaluationFormRevealUploadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EvaluationFormRevealUploadQuery, EvaluationFormRevealUploadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvaluationFormRevealUploadQuery, EvaluationFormRevealUploadQueryVariables>(EvaluationFormRevealUploadDocument, options);
        }
// @ts-ignore
export function useEvaluationFormRevealUploadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EvaluationFormRevealUploadQuery, EvaluationFormRevealUploadQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationFormRevealUploadQuery, EvaluationFormRevealUploadQueryVariables>;
export function useEvaluationFormRevealUploadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationFormRevealUploadQuery, EvaluationFormRevealUploadQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationFormRevealUploadQuery | undefined, EvaluationFormRevealUploadQueryVariables>;
export function useEvaluationFormRevealUploadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationFormRevealUploadQuery, EvaluationFormRevealUploadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EvaluationFormRevealUploadQuery, EvaluationFormRevealUploadQueryVariables>(EvaluationFormRevealUploadDocument, options);
        }
export type EvaluationFormRevealUploadQueryHookResult = ReturnType<typeof useEvaluationFormRevealUploadQuery>;
export type EvaluationFormRevealUploadLazyQueryHookResult = ReturnType<typeof useEvaluationFormRevealUploadLazyQuery>;
export type EvaluationFormRevealUploadSuspenseQueryHookResult = ReturnType<typeof useEvaluationFormRevealUploadSuspenseQuery>;
export type EvaluationFormRevealUploadQueryResult = Apollo.QueryResult<EvaluationFormRevealUploadQuery, EvaluationFormRevealUploadQueryVariables>;
export const EvaluationFormRevealUploadDataDocument = gql`
    query EvaluationFormRevealUploadData($id: ID!) {
  evaluationForm(id: $id) {
    id
    revealUpload {
      selectedFields
      uploadedAt
      matchedCount
      matchedUsers {
        user {
          id
          firstName
          lastName
          fullName
          avatar {
            source {
              url
            }
          }
        }
        values {
          label
          value
          type
        }
      }
    }
  }
}
    `;

/**
 * __useEvaluationFormRevealUploadDataQuery__
 *
 * To run a query within a React component, call `useEvaluationFormRevealUploadDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluationFormRevealUploadDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluationFormRevealUploadDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEvaluationFormRevealUploadDataQuery(baseOptions: Apollo.QueryHookOptions<EvaluationFormRevealUploadDataQuery, EvaluationFormRevealUploadDataQueryVariables> & ({ variables: EvaluationFormRevealUploadDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvaluationFormRevealUploadDataQuery, EvaluationFormRevealUploadDataQueryVariables>(EvaluationFormRevealUploadDataDocument, options);
      }
export function useEvaluationFormRevealUploadDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EvaluationFormRevealUploadDataQuery, EvaluationFormRevealUploadDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvaluationFormRevealUploadDataQuery, EvaluationFormRevealUploadDataQueryVariables>(EvaluationFormRevealUploadDataDocument, options);
        }
// @ts-ignore
export function useEvaluationFormRevealUploadDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EvaluationFormRevealUploadDataQuery, EvaluationFormRevealUploadDataQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationFormRevealUploadDataQuery, EvaluationFormRevealUploadDataQueryVariables>;
export function useEvaluationFormRevealUploadDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationFormRevealUploadDataQuery, EvaluationFormRevealUploadDataQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationFormRevealUploadDataQuery | undefined, EvaluationFormRevealUploadDataQueryVariables>;
export function useEvaluationFormRevealUploadDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationFormRevealUploadDataQuery, EvaluationFormRevealUploadDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EvaluationFormRevealUploadDataQuery, EvaluationFormRevealUploadDataQueryVariables>(EvaluationFormRevealUploadDataDocument, options);
        }
export type EvaluationFormRevealUploadDataQueryHookResult = ReturnType<typeof useEvaluationFormRevealUploadDataQuery>;
export type EvaluationFormRevealUploadDataLazyQueryHookResult = ReturnType<typeof useEvaluationFormRevealUploadDataLazyQuery>;
export type EvaluationFormRevealUploadDataSuspenseQueryHookResult = ReturnType<typeof useEvaluationFormRevealUploadDataSuspenseQuery>;
export type EvaluationFormRevealUploadDataQueryResult = Apollo.QueryResult<EvaluationFormRevealUploadDataQuery, EvaluationFormRevealUploadDataQueryVariables>;
export const EvaluationRevealDocument = gql`
    query EvaluationReveal($submissionID: ID!) {
  evaluationReveal(submissionID: $submissionID) {
    fields {
      label
      value
      type
    }
    visibleToEmployee
  }
}
    `;

/**
 * __useEvaluationRevealQuery__
 *
 * To run a query within a React component, call `useEvaluationRevealQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluationRevealQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluationRevealQuery({
 *   variables: {
 *      submissionID: // value for 'submissionID'
 *   },
 * });
 */
export function useEvaluationRevealQuery(baseOptions: Apollo.QueryHookOptions<EvaluationRevealQuery, EvaluationRevealQueryVariables> & ({ variables: EvaluationRevealQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvaluationRevealQuery, EvaluationRevealQueryVariables>(EvaluationRevealDocument, options);
      }
export function useEvaluationRevealLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EvaluationRevealQuery, EvaluationRevealQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvaluationRevealQuery, EvaluationRevealQueryVariables>(EvaluationRevealDocument, options);
        }
// @ts-ignore
export function useEvaluationRevealSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EvaluationRevealQuery, EvaluationRevealQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationRevealQuery, EvaluationRevealQueryVariables>;
export function useEvaluationRevealSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationRevealQuery, EvaluationRevealQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationRevealQuery | undefined, EvaluationRevealQueryVariables>;
export function useEvaluationRevealSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationRevealQuery, EvaluationRevealQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EvaluationRevealQuery, EvaluationRevealQueryVariables>(EvaluationRevealDocument, options);
        }
export type EvaluationRevealQueryHookResult = ReturnType<typeof useEvaluationRevealQuery>;
export type EvaluationRevealLazyQueryHookResult = ReturnType<typeof useEvaluationRevealLazyQuery>;
export type EvaluationRevealSuspenseQueryHookResult = ReturnType<typeof useEvaluationRevealSuspenseQuery>;
export type EvaluationRevealQueryResult = Apollo.QueryResult<EvaluationRevealQuery, EvaluationRevealQueryVariables>;
export const SearchKeyDocument = gql`
    query SearchKey {
  searchKey {
    appID
    token
    expiresAt
  }
}
    `;

/**
 * __useSearchKeyQuery__
 *
 * To run a query within a React component, call `useSearchKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchKeyQuery(baseOptions?: Apollo.QueryHookOptions<SearchKeyQuery, SearchKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchKeyQuery, SearchKeyQueryVariables>(SearchKeyDocument, options);
      }
export function useSearchKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchKeyQuery, SearchKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchKeyQuery, SearchKeyQueryVariables>(SearchKeyDocument, options);
        }
// @ts-ignore
export function useSearchKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchKeyQuery, SearchKeyQueryVariables>): Apollo.UseSuspenseQueryResult<SearchKeyQuery, SearchKeyQueryVariables>;
export function useSearchKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchKeyQuery, SearchKeyQueryVariables>): Apollo.UseSuspenseQueryResult<SearchKeyQuery | undefined, SearchKeyQueryVariables>;
export function useSearchKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchKeyQuery, SearchKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchKeyQuery, SearchKeyQueryVariables>(SearchKeyDocument, options);
        }
export type SearchKeyQueryHookResult = ReturnType<typeof useSearchKeyQuery>;
export type SearchKeyLazyQueryHookResult = ReturnType<typeof useSearchKeyLazyQuery>;
export type SearchKeySuspenseQueryHookResult = ReturnType<typeof useSearchKeySuspenseQuery>;
export type SearchKeyQueryResult = Apollo.QueryResult<SearchKeyQuery, SearchKeyQueryVariables>;
export const ArchiveNoteTemplateDocument = gql`
    mutation ArchiveNoteTemplate($input: NoteTemplateArchiveInput!) {
  archiveNoteTemplate(input: $input) {
    id
  }
}
    `;
export type ArchiveNoteTemplateMutationFn = Apollo.MutationFunction<ArchiveNoteTemplateMutation, ArchiveNoteTemplateMutationVariables>;

/**
 * __useArchiveNoteTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveNoteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveNoteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveNoteTemplateMutation, { data, loading, error }] = useArchiveNoteTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveNoteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveNoteTemplateMutation, ArchiveNoteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveNoteTemplateMutation, ArchiveNoteTemplateMutationVariables>(ArchiveNoteTemplateDocument, options);
      }
export type ArchiveNoteTemplateMutationHookResult = ReturnType<typeof useArchiveNoteTemplateMutation>;
export type ArchiveNoteTemplateMutationResult = Apollo.MutationResult<ArchiveNoteTemplateMutation>;
export type ArchiveNoteTemplateMutationOptions = Apollo.BaseMutationOptions<ArchiveNoteTemplateMutation, ArchiveNoteTemplateMutationVariables>;
export const CreateNoteTemplateDocument = gql`
    mutation CreateNoteTemplate($input: NoteTemplateCreateInput!) {
  createNoteTemplate(input: $input) {
    ...NoteTemplatePartial
  }
}
    ${NoteTemplatePartialFragmentDoc}`;
export type CreateNoteTemplateMutationFn = Apollo.MutationFunction<CreateNoteTemplateMutation, CreateNoteTemplateMutationVariables>;

/**
 * __useCreateNoteTemplateMutation__
 *
 * To run a mutation, you first call `useCreateNoteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteTemplateMutation, { data, loading, error }] = useCreateNoteTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteTemplateMutation, CreateNoteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteTemplateMutation, CreateNoteTemplateMutationVariables>(CreateNoteTemplateDocument, options);
      }
export type CreateNoteTemplateMutationHookResult = ReturnType<typeof useCreateNoteTemplateMutation>;
export type CreateNoteTemplateMutationResult = Apollo.MutationResult<CreateNoteTemplateMutation>;
export type CreateNoteTemplateMutationOptions = Apollo.BaseMutationOptions<CreateNoteTemplateMutation, CreateNoteTemplateMutationVariables>;
export const GenerateApiTokenDocument = gql`
    mutation GenerateApiToken($type: String!) {
  generateApiToken(type: $type) {
    id
    type
    value
  }
}
    `;
export type GenerateApiTokenMutationFn = Apollo.MutationFunction<GenerateApiTokenMutation, GenerateApiTokenMutationVariables>;

/**
 * __useGenerateApiTokenMutation__
 *
 * To run a mutation, you first call `useGenerateApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateApiTokenMutation, { data, loading, error }] = useGenerateApiTokenMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGenerateApiTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateApiTokenMutation, GenerateApiTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateApiTokenMutation, GenerateApiTokenMutationVariables>(GenerateApiTokenDocument, options);
      }
export type GenerateApiTokenMutationHookResult = ReturnType<typeof useGenerateApiTokenMutation>;
export type GenerateApiTokenMutationResult = Apollo.MutationResult<GenerateApiTokenMutation>;
export type GenerateApiTokenMutationOptions = Apollo.BaseMutationOptions<GenerateApiTokenMutation, GenerateApiTokenMutationVariables>;
export const RestoreNoteTemplateDocument = gql`
    mutation RestoreNoteTemplate($input: NoteTemplateRestoreInput!) {
  restoreNoteTemplate(input: $input) {
    ...NoteTemplatePartial
  }
}
    ${NoteTemplatePartialFragmentDoc}`;
export type RestoreNoteTemplateMutationFn = Apollo.MutationFunction<RestoreNoteTemplateMutation, RestoreNoteTemplateMutationVariables>;

/**
 * __useRestoreNoteTemplateMutation__
 *
 * To run a mutation, you first call `useRestoreNoteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreNoteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreNoteTemplateMutation, { data, loading, error }] = useRestoreNoteTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreNoteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<RestoreNoteTemplateMutation, RestoreNoteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreNoteTemplateMutation, RestoreNoteTemplateMutationVariables>(RestoreNoteTemplateDocument, options);
      }
export type RestoreNoteTemplateMutationHookResult = ReturnType<typeof useRestoreNoteTemplateMutation>;
export type RestoreNoteTemplateMutationResult = Apollo.MutationResult<RestoreNoteTemplateMutation>;
export type RestoreNoteTemplateMutationOptions = Apollo.BaseMutationOptions<RestoreNoteTemplateMutation, RestoreNoteTemplateMutationVariables>;
export const RevokeApiTokenDocument = gql`
    mutation RevokeApiToken($id: String!, $type: String!) {
  revokeApiToken(id: $id, type: $type)
}
    `;
export type RevokeApiTokenMutationFn = Apollo.MutationFunction<RevokeApiTokenMutation, RevokeApiTokenMutationVariables>;

/**
 * __useRevokeApiTokenMutation__
 *
 * To run a mutation, you first call `useRevokeApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeApiTokenMutation, { data, loading, error }] = useRevokeApiTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useRevokeApiTokenMutation(baseOptions?: Apollo.MutationHookOptions<RevokeApiTokenMutation, RevokeApiTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeApiTokenMutation, RevokeApiTokenMutationVariables>(RevokeApiTokenDocument, options);
      }
export type RevokeApiTokenMutationHookResult = ReturnType<typeof useRevokeApiTokenMutation>;
export type RevokeApiTokenMutationResult = Apollo.MutationResult<RevokeApiTokenMutation>;
export type RevokeApiTokenMutationOptions = Apollo.BaseMutationOptions<RevokeApiTokenMutation, RevokeApiTokenMutationVariables>;
export const UpdateApiTokenNotificationEmailDocument = gql`
    mutation UpdateApiTokenNotificationEmail($type: String!, $email: String!) {
  updateApiTokenNotificationEmail(type: $type, email: $email)
}
    `;
export type UpdateApiTokenNotificationEmailMutationFn = Apollo.MutationFunction<UpdateApiTokenNotificationEmailMutation, UpdateApiTokenNotificationEmailMutationVariables>;

/**
 * __useUpdateApiTokenNotificationEmailMutation__
 *
 * To run a mutation, you first call `useUpdateApiTokenNotificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApiTokenNotificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApiTokenNotificationEmailMutation, { data, loading, error }] = useUpdateApiTokenNotificationEmailMutation({
 *   variables: {
 *      type: // value for 'type'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdateApiTokenNotificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApiTokenNotificationEmailMutation, UpdateApiTokenNotificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApiTokenNotificationEmailMutation, UpdateApiTokenNotificationEmailMutationVariables>(UpdateApiTokenNotificationEmailDocument, options);
      }
export type UpdateApiTokenNotificationEmailMutationHookResult = ReturnType<typeof useUpdateApiTokenNotificationEmailMutation>;
export type UpdateApiTokenNotificationEmailMutationResult = Apollo.MutationResult<UpdateApiTokenNotificationEmailMutation>;
export type UpdateApiTokenNotificationEmailMutationOptions = Apollo.BaseMutationOptions<UpdateApiTokenNotificationEmailMutation, UpdateApiTokenNotificationEmailMutationVariables>;
export const UpdateNoteTemplateDocument = gql`
    mutation UpdateNoteTemplate($input: NoteTemplateUpdateInput!) {
  updateNoteTemplate(input: $input) {
    ...NoteTemplatePartial
  }
}
    ${NoteTemplatePartialFragmentDoc}`;
export type UpdateNoteTemplateMutationFn = Apollo.MutationFunction<UpdateNoteTemplateMutation, UpdateNoteTemplateMutationVariables>;

/**
 * __useUpdateNoteTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateNoteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteTemplateMutation, { data, loading, error }] = useUpdateNoteTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNoteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteTemplateMutation, UpdateNoteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteTemplateMutation, UpdateNoteTemplateMutationVariables>(UpdateNoteTemplateDocument, options);
      }
export type UpdateNoteTemplateMutationHookResult = ReturnType<typeof useUpdateNoteTemplateMutation>;
export type UpdateNoteTemplateMutationResult = Apollo.MutationResult<UpdateNoteTemplateMutation>;
export type UpdateNoteTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateNoteTemplateMutation, UpdateNoteTemplateMutationVariables>;
export const ApiTokenNotificationEmailDocument = gql`
    query ApiTokenNotificationEmail($type: String!) {
  apiTokenNotificationEmail(type: $type) {
    email
  }
}
    `;

/**
 * __useApiTokenNotificationEmailQuery__
 *
 * To run a query within a React component, call `useApiTokenNotificationEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiTokenNotificationEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiTokenNotificationEmailQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useApiTokenNotificationEmailQuery(baseOptions: Apollo.QueryHookOptions<ApiTokenNotificationEmailQuery, ApiTokenNotificationEmailQueryVariables> & ({ variables: ApiTokenNotificationEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiTokenNotificationEmailQuery, ApiTokenNotificationEmailQueryVariables>(ApiTokenNotificationEmailDocument, options);
      }
export function useApiTokenNotificationEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiTokenNotificationEmailQuery, ApiTokenNotificationEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiTokenNotificationEmailQuery, ApiTokenNotificationEmailQueryVariables>(ApiTokenNotificationEmailDocument, options);
        }
// @ts-ignore
export function useApiTokenNotificationEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApiTokenNotificationEmailQuery, ApiTokenNotificationEmailQueryVariables>): Apollo.UseSuspenseQueryResult<ApiTokenNotificationEmailQuery, ApiTokenNotificationEmailQueryVariables>;
export function useApiTokenNotificationEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiTokenNotificationEmailQuery, ApiTokenNotificationEmailQueryVariables>): Apollo.UseSuspenseQueryResult<ApiTokenNotificationEmailQuery | undefined, ApiTokenNotificationEmailQueryVariables>;
export function useApiTokenNotificationEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiTokenNotificationEmailQuery, ApiTokenNotificationEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiTokenNotificationEmailQuery, ApiTokenNotificationEmailQueryVariables>(ApiTokenNotificationEmailDocument, options);
        }
export type ApiTokenNotificationEmailQueryHookResult = ReturnType<typeof useApiTokenNotificationEmailQuery>;
export type ApiTokenNotificationEmailLazyQueryHookResult = ReturnType<typeof useApiTokenNotificationEmailLazyQuery>;
export type ApiTokenNotificationEmailSuspenseQueryHookResult = ReturnType<typeof useApiTokenNotificationEmailSuspenseQuery>;
export type ApiTokenNotificationEmailQueryResult = Apollo.QueryResult<ApiTokenNotificationEmailQuery, ApiTokenNotificationEmailQueryVariables>;
export const ApiTokensDocument = gql`
    query ApiTokens($type: String!) {
  apiTokenDescriptions(type: $type) {
    id
    type
    createdAt
    expiresAt
  }
}
    `;

/**
 * __useApiTokensQuery__
 *
 * To run a query within a React component, call `useApiTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiTokensQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useApiTokensQuery(baseOptions: Apollo.QueryHookOptions<ApiTokensQuery, ApiTokensQueryVariables> & ({ variables: ApiTokensQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiTokensQuery, ApiTokensQueryVariables>(ApiTokensDocument, options);
      }
export function useApiTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiTokensQuery, ApiTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiTokensQuery, ApiTokensQueryVariables>(ApiTokensDocument, options);
        }
// @ts-ignore
export function useApiTokensSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApiTokensQuery, ApiTokensQueryVariables>): Apollo.UseSuspenseQueryResult<ApiTokensQuery, ApiTokensQueryVariables>;
export function useApiTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiTokensQuery, ApiTokensQueryVariables>): Apollo.UseSuspenseQueryResult<ApiTokensQuery | undefined, ApiTokensQueryVariables>;
export function useApiTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiTokensQuery, ApiTokensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiTokensQuery, ApiTokensQueryVariables>(ApiTokensDocument, options);
        }
export type ApiTokensQueryHookResult = ReturnType<typeof useApiTokensQuery>;
export type ApiTokensLazyQueryHookResult = ReturnType<typeof useApiTokensLazyQuery>;
export type ApiTokensSuspenseQueryHookResult = ReturnType<typeof useApiTokensSuspenseQuery>;
export type ApiTokensQueryResult = Apollo.QueryResult<ApiTokensQuery, ApiTokensQueryVariables>;
export const NoteTemplateDocument = gql`
    query NoteTemplate($id: ID!) {
  noteTemplate(id: $id) {
    ...NoteTemplatePartial
  }
}
    ${NoteTemplatePartialFragmentDoc}`;

/**
 * __useNoteTemplateQuery__
 *
 * To run a query within a React component, call `useNoteTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoteTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoteTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNoteTemplateQuery(baseOptions: Apollo.QueryHookOptions<NoteTemplateQuery, NoteTemplateQueryVariables> & ({ variables: NoteTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoteTemplateQuery, NoteTemplateQueryVariables>(NoteTemplateDocument, options);
      }
export function useNoteTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoteTemplateQuery, NoteTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoteTemplateQuery, NoteTemplateQueryVariables>(NoteTemplateDocument, options);
        }
// @ts-ignore
export function useNoteTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NoteTemplateQuery, NoteTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<NoteTemplateQuery, NoteTemplateQueryVariables>;
export function useNoteTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NoteTemplateQuery, NoteTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<NoteTemplateQuery | undefined, NoteTemplateQueryVariables>;
export function useNoteTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NoteTemplateQuery, NoteTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NoteTemplateQuery, NoteTemplateQueryVariables>(NoteTemplateDocument, options);
        }
export type NoteTemplateQueryHookResult = ReturnType<typeof useNoteTemplateQuery>;
export type NoteTemplateLazyQueryHookResult = ReturnType<typeof useNoteTemplateLazyQuery>;
export type NoteTemplateSuspenseQueryHookResult = ReturnType<typeof useNoteTemplateSuspenseQuery>;
export type NoteTemplateQueryResult = Apollo.QueryResult<NoteTemplateQuery, NoteTemplateQueryVariables>;
export const NoteTemplatesDocument = gql`
    query NoteTemplates($isArchived: Boolean!, $subjectID: ID, $before: ID, $after: ID, $first: Int, $last: Int) {
  noteTemplates(
    isArchived: $isArchived
    subjectID: $subjectID
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        ...NoteTemplatePartial
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${NoteTemplatePartialFragmentDoc}`;

/**
 * __useNoteTemplatesQuery__
 *
 * To run a query within a React component, call `useNoteTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoteTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoteTemplatesQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      subjectID: // value for 'subjectID'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useNoteTemplatesQuery(baseOptions: Apollo.QueryHookOptions<NoteTemplatesQuery, NoteTemplatesQueryVariables> & ({ variables: NoteTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoteTemplatesQuery, NoteTemplatesQueryVariables>(NoteTemplatesDocument, options);
      }
export function useNoteTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoteTemplatesQuery, NoteTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoteTemplatesQuery, NoteTemplatesQueryVariables>(NoteTemplatesDocument, options);
        }
// @ts-ignore
export function useNoteTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NoteTemplatesQuery, NoteTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<NoteTemplatesQuery, NoteTemplatesQueryVariables>;
export function useNoteTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NoteTemplatesQuery, NoteTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<NoteTemplatesQuery | undefined, NoteTemplatesQueryVariables>;
export function useNoteTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NoteTemplatesQuery, NoteTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NoteTemplatesQuery, NoteTemplatesQueryVariables>(NoteTemplatesDocument, options);
        }
export type NoteTemplatesQueryHookResult = ReturnType<typeof useNoteTemplatesQuery>;
export type NoteTemplatesLazyQueryHookResult = ReturnType<typeof useNoteTemplatesLazyQuery>;
export type NoteTemplatesSuspenseQueryHookResult = ReturnType<typeof useNoteTemplatesSuspenseQuery>;
export type NoteTemplatesQueryResult = Apollo.QueryResult<NoteTemplatesQuery, NoteTemplatesQueryVariables>;
export const ArchiveCycleTemplateDocument = gql`
    mutation ArchiveCycleTemplate($input: ArchiveCycleTemplateInput!) {
  archiveCycleTemplate(input: $input) {
    cycleTemplate {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveCycleTemplateMutationFn = Apollo.MutationFunction<ArchiveCycleTemplateMutation, ArchiveCycleTemplateMutationVariables>;

/**
 * __useArchiveCycleTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveCycleTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCycleTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCycleTemplateMutation, { data, loading, error }] = useArchiveCycleTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveCycleTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCycleTemplateMutation, ArchiveCycleTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCycleTemplateMutation, ArchiveCycleTemplateMutationVariables>(ArchiveCycleTemplateDocument, options);
      }
export type ArchiveCycleTemplateMutationHookResult = ReturnType<typeof useArchiveCycleTemplateMutation>;
export type ArchiveCycleTemplateMutationResult = Apollo.MutationResult<ArchiveCycleTemplateMutation>;
export type ArchiveCycleTemplateMutationOptions = Apollo.BaseMutationOptions<ArchiveCycleTemplateMutation, ArchiveCycleTemplateMutationVariables>;
export const ArchiveLabelDocument = gql`
    mutation ArchiveLabel($input: ArchiveLabelInput!) {
  archiveLabel(input: $input) {
    label {
      ...Label
    }
  }
}
    ${LabelFragmentDoc}`;
export type ArchiveLabelMutationFn = Apollo.MutationFunction<ArchiveLabelMutation, ArchiveLabelMutationVariables>;

/**
 * __useArchiveLabelMutation__
 *
 * To run a mutation, you first call `useArchiveLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveLabelMutation, { data, loading, error }] = useArchiveLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveLabelMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveLabelMutation, ArchiveLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveLabelMutation, ArchiveLabelMutationVariables>(ArchiveLabelDocument, options);
      }
export type ArchiveLabelMutationHookResult = ReturnType<typeof useArchiveLabelMutation>;
export type ArchiveLabelMutationResult = Apollo.MutationResult<ArchiveLabelMutation>;
export type ArchiveLabelMutationOptions = Apollo.BaseMutationOptions<ArchiveLabelMutation, ArchiveLabelMutationVariables>;
export const CheckSuppressedEmailDocument = gql`
    mutation CheckSuppressedEmail($input: CheckSuppressedEmailInput!) {
  checkSuppressedEmail(input: $input) {
    isEmailSuppressed
  }
}
    `;
export type CheckSuppressedEmailMutationFn = Apollo.MutationFunction<CheckSuppressedEmailMutation, CheckSuppressedEmailMutationVariables>;

/**
 * __useCheckSuppressedEmailMutation__
 *
 * To run a mutation, you first call `useCheckSuppressedEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckSuppressedEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkSuppressedEmailMutation, { data, loading, error }] = useCheckSuppressedEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckSuppressedEmailMutation(baseOptions?: Apollo.MutationHookOptions<CheckSuppressedEmailMutation, CheckSuppressedEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckSuppressedEmailMutation, CheckSuppressedEmailMutationVariables>(CheckSuppressedEmailDocument, options);
      }
export type CheckSuppressedEmailMutationHookResult = ReturnType<typeof useCheckSuppressedEmailMutation>;
export type CheckSuppressedEmailMutationResult = Apollo.MutationResult<CheckSuppressedEmailMutation>;
export type CheckSuppressedEmailMutationOptions = Apollo.BaseMutationOptions<CheckSuppressedEmailMutation, CheckSuppressedEmailMutationVariables>;
export const CreateAssetDocument = gql`
    mutation CreateAsset($input: CreateAssetInput!) {
  createAsset(input: $input) {
    asset {
      id
      source {
        url
      }
    }
    uploadEndpoint {
      url
      headers {
        name
        values
      }
    }
  }
}
    `;
export type CreateAssetMutationFn = Apollo.MutationFunction<CreateAssetMutation, CreateAssetMutationVariables>;

/**
 * __useCreateAssetMutation__
 *
 * To run a mutation, you first call `useCreateAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetMutation, { data, loading, error }] = useCreateAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssetMutation, CreateAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssetMutation, CreateAssetMutationVariables>(CreateAssetDocument, options);
      }
export type CreateAssetMutationHookResult = ReturnType<typeof useCreateAssetMutation>;
export type CreateAssetMutationResult = Apollo.MutationResult<CreateAssetMutation>;
export type CreateAssetMutationOptions = Apollo.BaseMutationOptions<CreateAssetMutation, CreateAssetMutationVariables>;
export const CreateCycleInstanceDocument = gql`
    mutation CreateCycleInstance($input: CreateCycleInstanceInput!) {
  createCycleInstance(input: $input) {
    cycleInstance {
      id
    }
  }
}
    `;
export type CreateCycleInstanceMutationFn = Apollo.MutationFunction<CreateCycleInstanceMutation, CreateCycleInstanceMutationVariables>;

/**
 * __useCreateCycleInstanceMutation__
 *
 * To run a mutation, you first call `useCreateCycleInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCycleInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCycleInstanceMutation, { data, loading, error }] = useCreateCycleInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCycleInstanceMutation(baseOptions?: Apollo.MutationHookOptions<CreateCycleInstanceMutation, CreateCycleInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCycleInstanceMutation, CreateCycleInstanceMutationVariables>(CreateCycleInstanceDocument, options);
      }
export type CreateCycleInstanceMutationHookResult = ReturnType<typeof useCreateCycleInstanceMutation>;
export type CreateCycleInstanceMutationResult = Apollo.MutationResult<CreateCycleInstanceMutation>;
export type CreateCycleInstanceMutationOptions = Apollo.BaseMutationOptions<CreateCycleInstanceMutation, CreateCycleInstanceMutationVariables>;
export const CreateCycleTemplateDocument = gql`
    mutation CreateCycleTemplate($input: CreateCycleTemplateInput!) {
  createCycleTemplate(input: $input) {
    cycleTemplate {
      id
    }
  }
}
    `;
export type CreateCycleTemplateMutationFn = Apollo.MutationFunction<CreateCycleTemplateMutation, CreateCycleTemplateMutationVariables>;

/**
 * __useCreateCycleTemplateMutation__
 *
 * To run a mutation, you first call `useCreateCycleTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCycleTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCycleTemplateMutation, { data, loading, error }] = useCreateCycleTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCycleTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateCycleTemplateMutation, CreateCycleTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCycleTemplateMutation, CreateCycleTemplateMutationVariables>(CreateCycleTemplateDocument, options);
      }
export type CreateCycleTemplateMutationHookResult = ReturnType<typeof useCreateCycleTemplateMutation>;
export type CreateCycleTemplateMutationResult = Apollo.MutationResult<CreateCycleTemplateMutation>;
export type CreateCycleTemplateMutationOptions = Apollo.BaseMutationOptions<CreateCycleTemplateMutation, CreateCycleTemplateMutationVariables>;
export const CreateLabelDocument = gql`
    mutation CreateLabel($input: CreateLabelInput!) {
  createLabel(input: $input) {
    label {
      ...Label
    }
  }
}
    ${LabelFragmentDoc}`;
export type CreateLabelMutationFn = Apollo.MutationFunction<CreateLabelMutation, CreateLabelMutationVariables>;

/**
 * __useCreateLabelMutation__
 *
 * To run a mutation, you first call `useCreateLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLabelMutation, { data, loading, error }] = useCreateLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLabelMutation(baseOptions?: Apollo.MutationHookOptions<CreateLabelMutation, CreateLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLabelMutation, CreateLabelMutationVariables>(CreateLabelDocument, options);
      }
export type CreateLabelMutationHookResult = ReturnType<typeof useCreateLabelMutation>;
export type CreateLabelMutationResult = Apollo.MutationResult<CreateLabelMutation>;
export type CreateLabelMutationOptions = Apollo.BaseMutationOptions<CreateLabelMutation, CreateLabelMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($input: CreateSubscriptionInput!) {
  createSubscription(input: $input) {
    redirect
  }
}
    `;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const RemoveCycleInstanceDocument = gql`
    mutation RemoveCycleInstance($input: RemoveCycleInstanceInput!) {
  removeCycleInstance(input: $input) {
    success
  }
}
    `;
export type RemoveCycleInstanceMutationFn = Apollo.MutationFunction<RemoveCycleInstanceMutation, RemoveCycleInstanceMutationVariables>;

/**
 * __useRemoveCycleInstanceMutation__
 *
 * To run a mutation, you first call `useRemoveCycleInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCycleInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCycleInstanceMutation, { data, loading, error }] = useRemoveCycleInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCycleInstanceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCycleInstanceMutation, RemoveCycleInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCycleInstanceMutation, RemoveCycleInstanceMutationVariables>(RemoveCycleInstanceDocument, options);
      }
export type RemoveCycleInstanceMutationHookResult = ReturnType<typeof useRemoveCycleInstanceMutation>;
export type RemoveCycleInstanceMutationResult = Apollo.MutationResult<RemoveCycleInstanceMutation>;
export type RemoveCycleInstanceMutationOptions = Apollo.BaseMutationOptions<RemoveCycleInstanceMutation, RemoveCycleInstanceMutationVariables>;
export const RemoveSuppressedEmailDocument = gql`
    mutation RemoveSuppressedEmail($input: RemoveSuppressedEmailInput!) {
  removeSuppressedEmail(input: $input) {
    success
  }
}
    `;
export type RemoveSuppressedEmailMutationFn = Apollo.MutationFunction<RemoveSuppressedEmailMutation, RemoveSuppressedEmailMutationVariables>;

/**
 * __useRemoveSuppressedEmailMutation__
 *
 * To run a mutation, you first call `useRemoveSuppressedEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSuppressedEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSuppressedEmailMutation, { data, loading, error }] = useRemoveSuppressedEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveSuppressedEmailMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSuppressedEmailMutation, RemoveSuppressedEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSuppressedEmailMutation, RemoveSuppressedEmailMutationVariables>(RemoveSuppressedEmailDocument, options);
      }
export type RemoveSuppressedEmailMutationHookResult = ReturnType<typeof useRemoveSuppressedEmailMutation>;
export type RemoveSuppressedEmailMutationResult = Apollo.MutationResult<RemoveSuppressedEmailMutation>;
export type RemoveSuppressedEmailMutationOptions = Apollo.BaseMutationOptions<RemoveSuppressedEmailMutation, RemoveSuppressedEmailMutationVariables>;
export const RestoreCycleTemplateDocument = gql`
    mutation RestoreCycleTemplate($input: RestoreCycleTemplateInput!) {
  restoreCycleTemplate(input: $input) {
    cycleTemplate {
      id
      isArchived
    }
  }
}
    `;
export type RestoreCycleTemplateMutationFn = Apollo.MutationFunction<RestoreCycleTemplateMutation, RestoreCycleTemplateMutationVariables>;

/**
 * __useRestoreCycleTemplateMutation__
 *
 * To run a mutation, you first call `useRestoreCycleTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCycleTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCycleTemplateMutation, { data, loading, error }] = useRestoreCycleTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreCycleTemplateMutation(baseOptions?: Apollo.MutationHookOptions<RestoreCycleTemplateMutation, RestoreCycleTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreCycleTemplateMutation, RestoreCycleTemplateMutationVariables>(RestoreCycleTemplateDocument, options);
      }
export type RestoreCycleTemplateMutationHookResult = ReturnType<typeof useRestoreCycleTemplateMutation>;
export type RestoreCycleTemplateMutationResult = Apollo.MutationResult<RestoreCycleTemplateMutation>;
export type RestoreCycleTemplateMutationOptions = Apollo.BaseMutationOptions<RestoreCycleTemplateMutation, RestoreCycleTemplateMutationVariables>;
export const RestoreLabelDocument = gql`
    mutation RestoreLabel($input: RestoreLabelInput!) {
  restoreLabel(input: $input) {
    label {
      ...Label
    }
  }
}
    ${LabelFragmentDoc}`;
export type RestoreLabelMutationFn = Apollo.MutationFunction<RestoreLabelMutation, RestoreLabelMutationVariables>;

/**
 * __useRestoreLabelMutation__
 *
 * To run a mutation, you first call `useRestoreLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreLabelMutation, { data, loading, error }] = useRestoreLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreLabelMutation(baseOptions?: Apollo.MutationHookOptions<RestoreLabelMutation, RestoreLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreLabelMutation, RestoreLabelMutationVariables>(RestoreLabelDocument, options);
      }
export type RestoreLabelMutationHookResult = ReturnType<typeof useRestoreLabelMutation>;
export type RestoreLabelMutationResult = Apollo.MutationResult<RestoreLabelMutation>;
export type RestoreLabelMutationOptions = Apollo.BaseMutationOptions<RestoreLabelMutation, RestoreLabelMutationVariables>;
export const UnlinkStripeDocument = gql`
    mutation UnlinkStripe($workspaceID: ID!) {
  unlinkStripe(workspaceID: $workspaceID) {
    success
  }
}
    `;
export type UnlinkStripeMutationFn = Apollo.MutationFunction<UnlinkStripeMutation, UnlinkStripeMutationVariables>;

/**
 * __useUnlinkStripeMutation__
 *
 * To run a mutation, you first call `useUnlinkStripeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkStripeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkStripeMutation, { data, loading, error }] = useUnlinkStripeMutation({
 *   variables: {
 *      workspaceID: // value for 'workspaceID'
 *   },
 * });
 */
export function useUnlinkStripeMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkStripeMutation, UnlinkStripeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkStripeMutation, UnlinkStripeMutationVariables>(UnlinkStripeDocument, options);
      }
export type UnlinkStripeMutationHookResult = ReturnType<typeof useUnlinkStripeMutation>;
export type UnlinkStripeMutationResult = Apollo.MutationResult<UnlinkStripeMutation>;
export type UnlinkStripeMutationOptions = Apollo.BaseMutationOptions<UnlinkStripeMutation, UnlinkStripeMutationVariables>;
export const UpdateCycleTemplateDocument = gql`
    mutation UpdateCycleTemplate($input: UpdateCycleTemplateInput!) {
  updateCycleTemplate(input: $input) {
    cycleTemplate {
      ...CycleTemplateEditor
    }
  }
}
    ${CycleTemplateEditorFragmentDoc}`;
export type UpdateCycleTemplateMutationFn = Apollo.MutationFunction<UpdateCycleTemplateMutation, UpdateCycleTemplateMutationVariables>;

/**
 * __useUpdateCycleTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateCycleTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCycleTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCycleTemplateMutation, { data, loading, error }] = useUpdateCycleTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCycleTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCycleTemplateMutation, UpdateCycleTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCycleTemplateMutation, UpdateCycleTemplateMutationVariables>(UpdateCycleTemplateDocument, options);
      }
export type UpdateCycleTemplateMutationHookResult = ReturnType<typeof useUpdateCycleTemplateMutation>;
export type UpdateCycleTemplateMutationResult = Apollo.MutationResult<UpdateCycleTemplateMutation>;
export type UpdateCycleTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateCycleTemplateMutation, UpdateCycleTemplateMutationVariables>;
export const UpdateLabelDocument = gql`
    mutation UpdateLabel($input: UpdateLabelInput!) {
  updateLabel(input: $input) {
    label {
      ...Label
    }
  }
}
    ${LabelFragmentDoc}`;
export type UpdateLabelMutationFn = Apollo.MutationFunction<UpdateLabelMutation, UpdateLabelMutationVariables>;

/**
 * __useUpdateLabelMutation__
 *
 * To run a mutation, you first call `useUpdateLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLabelMutation, { data, loading, error }] = useUpdateLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLabelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLabelMutation, UpdateLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLabelMutation, UpdateLabelMutationVariables>(UpdateLabelDocument, options);
      }
export type UpdateLabelMutationHookResult = ReturnType<typeof useUpdateLabelMutation>;
export type UpdateLabelMutationResult = Apollo.MutationResult<UpdateLabelMutation>;
export type UpdateLabelMutationOptions = Apollo.BaseMutationOptions<UpdateLabelMutation, UpdateLabelMutationVariables>;
export const UpdatePrivacyConsentDocument = gql`
    mutation UpdatePrivacyConsent($input: UpdatePrivacyConsentInput!) {
  updatePrivacyConsent(input: $input) {
    user {
      id
      allowsUsageStatistics
      privacyConsent {
        version
      }
    }
  }
}
    `;
export type UpdatePrivacyConsentMutationFn = Apollo.MutationFunction<UpdatePrivacyConsentMutation, UpdatePrivacyConsentMutationVariables>;

/**
 * __useUpdatePrivacyConsentMutation__
 *
 * To run a mutation, you first call `useUpdatePrivacyConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrivacyConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrivacyConsentMutation, { data, loading, error }] = useUpdatePrivacyConsentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePrivacyConsentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrivacyConsentMutation, UpdatePrivacyConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrivacyConsentMutation, UpdatePrivacyConsentMutationVariables>(UpdatePrivacyConsentDocument, options);
      }
export type UpdatePrivacyConsentMutationHookResult = ReturnType<typeof useUpdatePrivacyConsentMutation>;
export type UpdatePrivacyConsentMutationResult = Apollo.MutationResult<UpdatePrivacyConsentMutation>;
export type UpdatePrivacyConsentMutationOptions = Apollo.BaseMutationOptions<UpdatePrivacyConsentMutation, UpdatePrivacyConsentMutationVariables>;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($input: UpdateConnectorInput!) {
  updateConnector(input: $input) {
    workspace {
      connector {
        id
        isActive
      }
    }
  }
}
    `;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const UpdateProductConfigurationDocument = gql`
    mutation UpdateProductConfiguration($input: UpdateConnectorConfigFieldInput!) {
  updateConnectorConfigField(input: $input) {
    workspace {
      connector {
        ...ConnectorWithConfig
      }
    }
  }
}
    ${ConnectorWithConfigFragmentDoc}`;
export type UpdateProductConfigurationMutationFn = Apollo.MutationFunction<UpdateProductConfigurationMutation, UpdateProductConfigurationMutationVariables>;

/**
 * __useUpdateProductConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateProductConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductConfigurationMutation, { data, loading, error }] = useUpdateProductConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductConfigurationMutation, UpdateProductConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductConfigurationMutation, UpdateProductConfigurationMutationVariables>(UpdateProductConfigurationDocument, options);
      }
export type UpdateProductConfigurationMutationHookResult = ReturnType<typeof useUpdateProductConfigurationMutation>;
export type UpdateProductConfigurationMutationResult = Apollo.MutationResult<UpdateProductConfigurationMutation>;
export type UpdateProductConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateProductConfigurationMutation, UpdateProductConfigurationMutationVariables>;
export const UpdateWelcomeEmailDocument = gql`
    mutation UpdateWelcomeEmail($input: UpdateWelcomeEmailInput!) {
  updateWelcomeEmail(input: $input) {
    workspace {
      id
      notificationSettings {
        header
        footer
        welcomeEmail {
          body
          subject
        }
      }
    }
  }
}
    `;
export type UpdateWelcomeEmailMutationFn = Apollo.MutationFunction<UpdateWelcomeEmailMutation, UpdateWelcomeEmailMutationVariables>;

/**
 * __useUpdateWelcomeEmailMutation__
 *
 * To run a mutation, you first call `useUpdateWelcomeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWelcomeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWelcomeEmailMutation, { data, loading, error }] = useUpdateWelcomeEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWelcomeEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWelcomeEmailMutation, UpdateWelcomeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWelcomeEmailMutation, UpdateWelcomeEmailMutationVariables>(UpdateWelcomeEmailDocument, options);
      }
export type UpdateWelcomeEmailMutationHookResult = ReturnType<typeof useUpdateWelcomeEmailMutation>;
export type UpdateWelcomeEmailMutationResult = Apollo.MutationResult<UpdateWelcomeEmailMutation>;
export type UpdateWelcomeEmailMutationOptions = Apollo.BaseMutationOptions<UpdateWelcomeEmailMutation, UpdateWelcomeEmailMutationVariables>;
export const AssetsDocument = gql`
    query Assets($ids: [ID!]!) {
  assets(ids: $ids) {
    id
    source {
      url
    }
  }
}
    `;

/**
 * __useAssetsQuery__
 *
 * To run a query within a React component, call `useAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAssetsQuery(baseOptions: Apollo.QueryHookOptions<AssetsQuery, AssetsQueryVariables> & ({ variables: AssetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetsQuery, AssetsQueryVariables>(AssetsDocument, options);
      }
export function useAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetsQuery, AssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetsQuery, AssetsQueryVariables>(AssetsDocument, options);
        }
// @ts-ignore
export function useAssetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AssetsQuery, AssetsQueryVariables>): Apollo.UseSuspenseQueryResult<AssetsQuery, AssetsQueryVariables>;
export function useAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssetsQuery, AssetsQueryVariables>): Apollo.UseSuspenseQueryResult<AssetsQuery | undefined, AssetsQueryVariables>;
export function useAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssetsQuery, AssetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssetsQuery, AssetsQueryVariables>(AssetsDocument, options);
        }
export type AssetsQueryHookResult = ReturnType<typeof useAssetsQuery>;
export type AssetsLazyQueryHookResult = ReturnType<typeof useAssetsLazyQuery>;
export type AssetsSuspenseQueryHookResult = ReturnType<typeof useAssetsSuspenseQuery>;
export type AssetsQueryResult = Apollo.QueryResult<AssetsQuery, AssetsQueryVariables>;
export const CompetenciesDocument = gql`
    query Competencies($isArchived: Boolean!, $jobTitleIDs: [ID!], $before: ID, $after: ID, $first: Int, $last: Int) {
  competencies(
    isArchived: $isArchived
    jobTitleIDs: $jobTitleIDs
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        id
        title
        description
        attachableToGoal
        isArchived
        styrSkillID
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useCompetenciesQuery__
 *
 * To run a query within a React component, call `useCompetenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompetenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompetenciesQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      jobTitleIDs: // value for 'jobTitleIDs'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useCompetenciesQuery(baseOptions: Apollo.QueryHookOptions<CompetenciesQuery, CompetenciesQueryVariables> & ({ variables: CompetenciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompetenciesQuery, CompetenciesQueryVariables>(CompetenciesDocument, options);
      }
export function useCompetenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompetenciesQuery, CompetenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompetenciesQuery, CompetenciesQueryVariables>(CompetenciesDocument, options);
        }
// @ts-ignore
export function useCompetenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompetenciesQuery, CompetenciesQueryVariables>): Apollo.UseSuspenseQueryResult<CompetenciesQuery, CompetenciesQueryVariables>;
export function useCompetenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetenciesQuery, CompetenciesQueryVariables>): Apollo.UseSuspenseQueryResult<CompetenciesQuery | undefined, CompetenciesQueryVariables>;
export function useCompetenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompetenciesQuery, CompetenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompetenciesQuery, CompetenciesQueryVariables>(CompetenciesDocument, options);
        }
export type CompetenciesQueryHookResult = ReturnType<typeof useCompetenciesQuery>;
export type CompetenciesLazyQueryHookResult = ReturnType<typeof useCompetenciesLazyQuery>;
export type CompetenciesSuspenseQueryHookResult = ReturnType<typeof useCompetenciesSuspenseQuery>;
export type CompetenciesQueryResult = Apollo.QueryResult<CompetenciesQuery, CompetenciesQueryVariables>;
export const CycleDocument = gql`
    query Cycle($id: ID!, $after: DateTime, $before: DateTime) {
  cycleInstance(id: $id) {
    id
    startDate
    activatesAt
    deactivatesAt
    cycleTemplate {
      id
      title
      repeats
      duration
      successor {
        id
      }
      moments {
        id
        title
        startOffset
        type
        duration
        showToUser
      }
    }
    moments(after: $after, before: $before) {
      id
      user {
        id
      }
      status
      startDate
      endDate
      skipReason
      skipReasonOther
      cycleInstance {
        id
      }
      cycleTemplate {
        id
        title
      }
      momentTemplate {
        id
        title
        description
        type
        duration
        original {
          id
        }
        showToUser
        talentReview {
          template {
            id
          }
          group {
            id
          }
        }
      }
      evaluation {
        id
        viewer {
          status
          requiresSignature
        }
        employee {
          status
          requiresSignature
        }
      }
    }
    precededBy {
      id
    }
    succeededBy {
      id
    }
    skippedFutureMoments {
      momentTemplateID
      skipReason
      skipReasonOther
    }
  }
}
    `;

/**
 * __useCycleQuery__
 *
 * To run a query within a React component, call `useCycleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCycleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCycleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useCycleQuery(baseOptions: Apollo.QueryHookOptions<CycleQuery, CycleQueryVariables> & ({ variables: CycleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CycleQuery, CycleQueryVariables>(CycleDocument, options);
      }
export function useCycleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CycleQuery, CycleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CycleQuery, CycleQueryVariables>(CycleDocument, options);
        }
// @ts-ignore
export function useCycleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CycleQuery, CycleQueryVariables>): Apollo.UseSuspenseQueryResult<CycleQuery, CycleQueryVariables>;
export function useCycleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CycleQuery, CycleQueryVariables>): Apollo.UseSuspenseQueryResult<CycleQuery | undefined, CycleQueryVariables>;
export function useCycleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CycleQuery, CycleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CycleQuery, CycleQueryVariables>(CycleDocument, options);
        }
export type CycleQueryHookResult = ReturnType<typeof useCycleQuery>;
export type CycleLazyQueryHookResult = ReturnType<typeof useCycleLazyQuery>;
export type CycleSuspenseQueryHookResult = ReturnType<typeof useCycleSuspenseQuery>;
export type CycleQueryResult = Apollo.QueryResult<CycleQuery, CycleQueryVariables>;
export const CycleTemplateDocument = gql`
    query CycleTemplate($id: ID!) {
  cycleTemplate(id: $id) {
    ...CycleTemplateEditor
  }
}
    ${CycleTemplateEditorFragmentDoc}`;

/**
 * __useCycleTemplateQuery__
 *
 * To run a query within a React component, call `useCycleTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCycleTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCycleTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCycleTemplateQuery(baseOptions: Apollo.QueryHookOptions<CycleTemplateQuery, CycleTemplateQueryVariables> & ({ variables: CycleTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CycleTemplateQuery, CycleTemplateQueryVariables>(CycleTemplateDocument, options);
      }
export function useCycleTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CycleTemplateQuery, CycleTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CycleTemplateQuery, CycleTemplateQueryVariables>(CycleTemplateDocument, options);
        }
// @ts-ignore
export function useCycleTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CycleTemplateQuery, CycleTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<CycleTemplateQuery, CycleTemplateQueryVariables>;
export function useCycleTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CycleTemplateQuery, CycleTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<CycleTemplateQuery | undefined, CycleTemplateQueryVariables>;
export function useCycleTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CycleTemplateQuery, CycleTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CycleTemplateQuery, CycleTemplateQueryVariables>(CycleTemplateDocument, options);
        }
export type CycleTemplateQueryHookResult = ReturnType<typeof useCycleTemplateQuery>;
export type CycleTemplateLazyQueryHookResult = ReturnType<typeof useCycleTemplateLazyQuery>;
export type CycleTemplateSuspenseQueryHookResult = ReturnType<typeof useCycleTemplateSuspenseQuery>;
export type CycleTemplateQueryResult = Apollo.QueryResult<CycleTemplateQuery, CycleTemplateQueryVariables>;
export const CycleTemplatesDocument = gql`
    query CycleTemplates($isArchived: Boolean!, $before: ID, $after: ID, $first: Int, $last: Int) {
  cycleTemplates(
    isArchived: $isArchived
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        id
        title
        isArchived
        duration
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useCycleTemplatesQuery__
 *
 * To run a query within a React component, call `useCycleTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCycleTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCycleTemplatesQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useCycleTemplatesQuery(baseOptions: Apollo.QueryHookOptions<CycleTemplatesQuery, CycleTemplatesQueryVariables> & ({ variables: CycleTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CycleTemplatesQuery, CycleTemplatesQueryVariables>(CycleTemplatesDocument, options);
      }
export function useCycleTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CycleTemplatesQuery, CycleTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CycleTemplatesQuery, CycleTemplatesQueryVariables>(CycleTemplatesDocument, options);
        }
// @ts-ignore
export function useCycleTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CycleTemplatesQuery, CycleTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<CycleTemplatesQuery, CycleTemplatesQueryVariables>;
export function useCycleTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CycleTemplatesQuery, CycleTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<CycleTemplatesQuery | undefined, CycleTemplatesQueryVariables>;
export function useCycleTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CycleTemplatesQuery, CycleTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CycleTemplatesQuery, CycleTemplatesQueryVariables>(CycleTemplatesDocument, options);
        }
export type CycleTemplatesQueryHookResult = ReturnType<typeof useCycleTemplatesQuery>;
export type CycleTemplatesLazyQueryHookResult = ReturnType<typeof useCycleTemplatesLazyQuery>;
export type CycleTemplatesSuspenseQueryHookResult = ReturnType<typeof useCycleTemplatesSuspenseQuery>;
export type CycleTemplatesQueryResult = Apollo.QueryResult<CycleTemplatesQuery, CycleTemplatesQueryVariables>;
export const DevelopmentPlanDocument = gql`
    query DevelopmentPlan($userID: ID!) {
  user(id: $userID) {
    ...DevelopmentPlanUser
  }
}
    ${DevelopmentPlanUserFragmentDoc}`;

/**
 * __useDevelopmentPlanQuery__
 *
 * To run a query within a React component, call `useDevelopmentPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentPlanQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useDevelopmentPlanQuery(baseOptions: Apollo.QueryHookOptions<DevelopmentPlanQuery, DevelopmentPlanQueryVariables> & ({ variables: DevelopmentPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevelopmentPlanQuery, DevelopmentPlanQueryVariables>(DevelopmentPlanDocument, options);
      }
export function useDevelopmentPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevelopmentPlanQuery, DevelopmentPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevelopmentPlanQuery, DevelopmentPlanQueryVariables>(DevelopmentPlanDocument, options);
        }
// @ts-ignore
export function useDevelopmentPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DevelopmentPlanQuery, DevelopmentPlanQueryVariables>): Apollo.UseSuspenseQueryResult<DevelopmentPlanQuery, DevelopmentPlanQueryVariables>;
export function useDevelopmentPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevelopmentPlanQuery, DevelopmentPlanQueryVariables>): Apollo.UseSuspenseQueryResult<DevelopmentPlanQuery | undefined, DevelopmentPlanQueryVariables>;
export function useDevelopmentPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevelopmentPlanQuery, DevelopmentPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DevelopmentPlanQuery, DevelopmentPlanQueryVariables>(DevelopmentPlanDocument, options);
        }
export type DevelopmentPlanQueryHookResult = ReturnType<typeof useDevelopmentPlanQuery>;
export type DevelopmentPlanLazyQueryHookResult = ReturnType<typeof useDevelopmentPlanLazyQuery>;
export type DevelopmentPlanSuspenseQueryHookResult = ReturnType<typeof useDevelopmentPlanSuspenseQuery>;
export type DevelopmentPlanQueryResult = Apollo.QueryResult<DevelopmentPlanQuery, DevelopmentPlanQueryVariables>;
export const LabelDocument = gql`
    query Label($id: ID!) {
  label(id: $id) {
    ...Label
  }
}
    ${LabelFragmentDoc}`;

/**
 * __useLabelQuery__
 *
 * To run a query within a React component, call `useLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLabelQuery(baseOptions: Apollo.QueryHookOptions<LabelQuery, LabelQueryVariables> & ({ variables: LabelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabelQuery, LabelQueryVariables>(LabelDocument, options);
      }
export function useLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabelQuery, LabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabelQuery, LabelQueryVariables>(LabelDocument, options);
        }
// @ts-ignore
export function useLabelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LabelQuery, LabelQueryVariables>): Apollo.UseSuspenseQueryResult<LabelQuery, LabelQueryVariables>;
export function useLabelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LabelQuery, LabelQueryVariables>): Apollo.UseSuspenseQueryResult<LabelQuery | undefined, LabelQueryVariables>;
export function useLabelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LabelQuery, LabelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LabelQuery, LabelQueryVariables>(LabelDocument, options);
        }
export type LabelQueryHookResult = ReturnType<typeof useLabelQuery>;
export type LabelLazyQueryHookResult = ReturnType<typeof useLabelLazyQuery>;
export type LabelSuspenseQueryHookResult = ReturnType<typeof useLabelSuspenseQuery>;
export type LabelQueryResult = Apollo.QueryResult<LabelQuery, LabelQueryVariables>;
export const PaginatedLabelsDocument = gql`
    query PaginatedLabels($isArchived: Boolean!, $before: ID, $after: ID, $first: Int, $last: Int, $type: LabelType!) {
  paginatedLabels(
    isArchived: $isArchived
    before: $before
    after: $after
    first: $first
    last: $last
    type: $type
  ) {
    edges {
      cursor
      node {
        ...Label
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${LabelFragmentDoc}`;

/**
 * __usePaginatedLabelsQuery__
 *
 * To run a query within a React component, call `usePaginatedLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedLabelsQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePaginatedLabelsQuery(baseOptions: Apollo.QueryHookOptions<PaginatedLabelsQuery, PaginatedLabelsQueryVariables> & ({ variables: PaginatedLabelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedLabelsQuery, PaginatedLabelsQueryVariables>(PaginatedLabelsDocument, options);
      }
export function usePaginatedLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedLabelsQuery, PaginatedLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedLabelsQuery, PaginatedLabelsQueryVariables>(PaginatedLabelsDocument, options);
        }
// @ts-ignore
export function usePaginatedLabelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaginatedLabelsQuery, PaginatedLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<PaginatedLabelsQuery, PaginatedLabelsQueryVariables>;
export function usePaginatedLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaginatedLabelsQuery, PaginatedLabelsQueryVariables>): Apollo.UseSuspenseQueryResult<PaginatedLabelsQuery | undefined, PaginatedLabelsQueryVariables>;
export function usePaginatedLabelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaginatedLabelsQuery, PaginatedLabelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaginatedLabelsQuery, PaginatedLabelsQueryVariables>(PaginatedLabelsDocument, options);
        }
export type PaginatedLabelsQueryHookResult = ReturnType<typeof usePaginatedLabelsQuery>;
export type PaginatedLabelsLazyQueryHookResult = ReturnType<typeof usePaginatedLabelsLazyQuery>;
export type PaginatedLabelsSuspenseQueryHookResult = ReturnType<typeof usePaginatedLabelsSuspenseQuery>;
export type PaginatedLabelsQueryResult = Apollo.QueryResult<PaginatedLabelsQuery, PaginatedLabelsQueryVariables>;
export const ProductDocument = gql`
    query Product {
  connectors {
    id
    type
    isActive
  }
  viewer {
    id
    workspace {
      id
      connector {
        ...ConnectorWithConfig
      }
    }
  }
}
    ${ConnectorWithConfigFragmentDoc}`;

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductQuery(baseOptions?: Apollo.QueryHookOptions<ProductQuery, ProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
      }
export function useProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
// @ts-ignore
export function useProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductQuery, ProductQueryVariables>): Apollo.UseSuspenseQueryResult<ProductQuery, ProductQueryVariables>;
export function useProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductQuery, ProductQueryVariables>): Apollo.UseSuspenseQueryResult<ProductQuery | undefined, ProductQueryVariables>;
export function useProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductSuspenseQueryHookResult = ReturnType<typeof useProductSuspenseQuery>;
export type ProductQueryResult = Apollo.QueryResult<ProductQuery, ProductQueryVariables>;
export const SentEmailsDocument = gql`
    query SentEmails($email: String, $after: ID, $before: ID, $last: Int, $first: Int) {
  sentEmails(
    email: $email
    after: $after
    before: $before
    last: $last
    first: $first
  ) {
    edges {
      cursor
      node {
        id
        recipientName
        recipientEmail
        subject
        sentAt
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useSentEmailsQuery__
 *
 * To run a query within a React component, call `useSentEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSentEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSentEmailsQuery({
 *   variables: {
 *      email: // value for 'email'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSentEmailsQuery(baseOptions?: Apollo.QueryHookOptions<SentEmailsQuery, SentEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SentEmailsQuery, SentEmailsQueryVariables>(SentEmailsDocument, options);
      }
export function useSentEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SentEmailsQuery, SentEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SentEmailsQuery, SentEmailsQueryVariables>(SentEmailsDocument, options);
        }
// @ts-ignore
export function useSentEmailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SentEmailsQuery, SentEmailsQueryVariables>): Apollo.UseSuspenseQueryResult<SentEmailsQuery, SentEmailsQueryVariables>;
export function useSentEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SentEmailsQuery, SentEmailsQueryVariables>): Apollo.UseSuspenseQueryResult<SentEmailsQuery | undefined, SentEmailsQueryVariables>;
export function useSentEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SentEmailsQuery, SentEmailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SentEmailsQuery, SentEmailsQueryVariables>(SentEmailsDocument, options);
        }
export type SentEmailsQueryHookResult = ReturnType<typeof useSentEmailsQuery>;
export type SentEmailsLazyQueryHookResult = ReturnType<typeof useSentEmailsLazyQuery>;
export type SentEmailsSuspenseQueryHookResult = ReturnType<typeof useSentEmailsSuspenseQuery>;
export type SentEmailsQueryResult = Apollo.QueryResult<SentEmailsQuery, SentEmailsQueryVariables>;
export const ServiceProvidersDocument = gql`
    query ServiceProviders {
  serviceProvider {
    entityID
    acsURL
    metadataURL
  }
}
    `;

/**
 * __useServiceProvidersQuery__
 *
 * To run a query within a React component, call `useServiceProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useServiceProvidersQuery(baseOptions?: Apollo.QueryHookOptions<ServiceProvidersQuery, ServiceProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceProvidersQuery, ServiceProvidersQueryVariables>(ServiceProvidersDocument, options);
      }
export function useServiceProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceProvidersQuery, ServiceProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceProvidersQuery, ServiceProvidersQueryVariables>(ServiceProvidersDocument, options);
        }
// @ts-ignore
export function useServiceProvidersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceProvidersQuery, ServiceProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<ServiceProvidersQuery, ServiceProvidersQueryVariables>;
export function useServiceProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ServiceProvidersQuery, ServiceProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<ServiceProvidersQuery | undefined, ServiceProvidersQueryVariables>;
export function useServiceProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ServiceProvidersQuery, ServiceProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceProvidersQuery, ServiceProvidersQueryVariables>(ServiceProvidersDocument, options);
        }
export type ServiceProvidersQueryHookResult = ReturnType<typeof useServiceProvidersQuery>;
export type ServiceProvidersLazyQueryHookResult = ReturnType<typeof useServiceProvidersLazyQuery>;
export type ServiceProvidersSuspenseQueryHookResult = ReturnType<typeof useServiceProvidersSuspenseQuery>;
export type ServiceProvidersQueryResult = Apollo.QueryResult<ServiceProvidersQuery, ServiceProvidersQueryVariables>;
export const SingleSignOnsDocument = gql`
    query SingleSignOns {
  singleSignOns {
    identityProvider {
      id
    }
    url
  }
}
    `;

/**
 * __useSingleSignOnsQuery__
 *
 * To run a query within a React component, call `useSingleSignOnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleSignOnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleSignOnsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSingleSignOnsQuery(baseOptions?: Apollo.QueryHookOptions<SingleSignOnsQuery, SingleSignOnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleSignOnsQuery, SingleSignOnsQueryVariables>(SingleSignOnsDocument, options);
      }
export function useSingleSignOnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleSignOnsQuery, SingleSignOnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleSignOnsQuery, SingleSignOnsQueryVariables>(SingleSignOnsDocument, options);
        }
// @ts-ignore
export function useSingleSignOnsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SingleSignOnsQuery, SingleSignOnsQueryVariables>): Apollo.UseSuspenseQueryResult<SingleSignOnsQuery, SingleSignOnsQueryVariables>;
export function useSingleSignOnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SingleSignOnsQuery, SingleSignOnsQueryVariables>): Apollo.UseSuspenseQueryResult<SingleSignOnsQuery | undefined, SingleSignOnsQueryVariables>;
export function useSingleSignOnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SingleSignOnsQuery, SingleSignOnsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleSignOnsQuery, SingleSignOnsQueryVariables>(SingleSignOnsDocument, options);
        }
export type SingleSignOnsQueryHookResult = ReturnType<typeof useSingleSignOnsQuery>;
export type SingleSignOnsLazyQueryHookResult = ReturnType<typeof useSingleSignOnsLazyQuery>;
export type SingleSignOnsSuspenseQueryHookResult = ReturnType<typeof useSingleSignOnsSuspenseQuery>;
export type SingleSignOnsQueryResult = Apollo.QueryResult<SingleSignOnsQuery, SingleSignOnsQueryVariables>;
export const SupportEmailAddressesDocument = gql`
    query SupportEmailAddresses {
  supportEmailAddresses
}
    `;

/**
 * __useSupportEmailAddressesQuery__
 *
 * To run a query within a React component, call `useSupportEmailAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportEmailAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportEmailAddressesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupportEmailAddressesQuery(baseOptions?: Apollo.QueryHookOptions<SupportEmailAddressesQuery, SupportEmailAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportEmailAddressesQuery, SupportEmailAddressesQueryVariables>(SupportEmailAddressesDocument, options);
      }
export function useSupportEmailAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportEmailAddressesQuery, SupportEmailAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportEmailAddressesQuery, SupportEmailAddressesQueryVariables>(SupportEmailAddressesDocument, options);
        }
// @ts-ignore
export function useSupportEmailAddressesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupportEmailAddressesQuery, SupportEmailAddressesQueryVariables>): Apollo.UseSuspenseQueryResult<SupportEmailAddressesQuery, SupportEmailAddressesQueryVariables>;
export function useSupportEmailAddressesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupportEmailAddressesQuery, SupportEmailAddressesQueryVariables>): Apollo.UseSuspenseQueryResult<SupportEmailAddressesQuery | undefined, SupportEmailAddressesQueryVariables>;
export function useSupportEmailAddressesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupportEmailAddressesQuery, SupportEmailAddressesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupportEmailAddressesQuery, SupportEmailAddressesQueryVariables>(SupportEmailAddressesDocument, options);
        }
export type SupportEmailAddressesQueryHookResult = ReturnType<typeof useSupportEmailAddressesQuery>;
export type SupportEmailAddressesLazyQueryHookResult = ReturnType<typeof useSupportEmailAddressesLazyQuery>;
export type SupportEmailAddressesSuspenseQueryHookResult = ReturnType<typeof useSupportEmailAddressesSuspenseQuery>;
export type SupportEmailAddressesQueryResult = Apollo.QueryResult<SupportEmailAddressesQuery, SupportEmailAddressesQueryVariables>;
export const ViewerDocument = gql`
    query Viewer {
  viewer {
    id
    firstName
    lastName
    username
    email
    locale
    avatar {
      source {
        url
      }
    }
    allowsUsageStatistics
    privacyConsent {
      version
    }
    signedEmail {
      email
      hmac
    }
  }
}
    `;

/**
 * __useViewerQuery__
 *
 * To run a query within a React component, call `useViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerQuery(baseOptions?: Apollo.QueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
      }
export function useViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
        }
// @ts-ignore
export function useViewerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerQuery, ViewerQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerQuery, ViewerQueryVariables>;
export function useViewerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerQuery, ViewerQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerQuery | undefined, ViewerQueryVariables>;
export function useViewerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
        }
export type ViewerQueryHookResult = ReturnType<typeof useViewerQuery>;
export type ViewerLazyQueryHookResult = ReturnType<typeof useViewerLazyQuery>;
export type ViewerSuspenseQueryHookResult = ReturnType<typeof useViewerSuspenseQuery>;
export type ViewerQueryResult = Apollo.QueryResult<ViewerQuery, ViewerQueryVariables>;
export const ViewerCompetenciesDocument = gql`
    query ViewerCompetencies {
  viewer {
    id
    jobPositions(status: ACTIVE) {
      jobTitle {
        id
        title
      }
      appraisal {
        competency {
          id
        }
        competencyLevelIndex
      }
      competencies {
        id
        competency {
          id
          title
          description
          levels {
            enabled
            level {
              id
              title
            }
            criteria
          }
        }
        competencyLevel
      }
    }
  }
}
    `;

/**
 * __useViewerCompetenciesQuery__
 *
 * To run a query within a React component, call `useViewerCompetenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerCompetenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerCompetenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerCompetenciesQuery(baseOptions?: Apollo.QueryHookOptions<ViewerCompetenciesQuery, ViewerCompetenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerCompetenciesQuery, ViewerCompetenciesQueryVariables>(ViewerCompetenciesDocument, options);
      }
export function useViewerCompetenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerCompetenciesQuery, ViewerCompetenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerCompetenciesQuery, ViewerCompetenciesQueryVariables>(ViewerCompetenciesDocument, options);
        }
// @ts-ignore
export function useViewerCompetenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerCompetenciesQuery, ViewerCompetenciesQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerCompetenciesQuery, ViewerCompetenciesQueryVariables>;
export function useViewerCompetenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerCompetenciesQuery, ViewerCompetenciesQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerCompetenciesQuery | undefined, ViewerCompetenciesQueryVariables>;
export function useViewerCompetenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerCompetenciesQuery, ViewerCompetenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewerCompetenciesQuery, ViewerCompetenciesQueryVariables>(ViewerCompetenciesDocument, options);
        }
export type ViewerCompetenciesQueryHookResult = ReturnType<typeof useViewerCompetenciesQuery>;
export type ViewerCompetenciesLazyQueryHookResult = ReturnType<typeof useViewerCompetenciesLazyQuery>;
export type ViewerCompetenciesSuspenseQueryHookResult = ReturnType<typeof useViewerCompetenciesSuspenseQuery>;
export type ViewerCompetenciesQueryResult = Apollo.QueryResult<ViewerCompetenciesQuery, ViewerCompetenciesQueryVariables>;
export const ViewerWithManagersDocument = gql`
    query ViewerWithManagers {
  viewer {
    managers {
      id
      source {
        id
        firstName
        lastName
        isArchived
        avatar {
          id
          source {
            url
          }
        }
      }
      role {
        id
      }
    }
  }
}
    `;

/**
 * __useViewerWithManagersQuery__
 *
 * To run a query within a React component, call `useViewerWithManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerWithManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerWithManagersQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerWithManagersQuery(baseOptions?: Apollo.QueryHookOptions<ViewerWithManagersQuery, ViewerWithManagersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerWithManagersQuery, ViewerWithManagersQueryVariables>(ViewerWithManagersDocument, options);
      }
export function useViewerWithManagersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerWithManagersQuery, ViewerWithManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerWithManagersQuery, ViewerWithManagersQueryVariables>(ViewerWithManagersDocument, options);
        }
// @ts-ignore
export function useViewerWithManagersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerWithManagersQuery, ViewerWithManagersQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerWithManagersQuery, ViewerWithManagersQueryVariables>;
export function useViewerWithManagersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerWithManagersQuery, ViewerWithManagersQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerWithManagersQuery | undefined, ViewerWithManagersQueryVariables>;
export function useViewerWithManagersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerWithManagersQuery, ViewerWithManagersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewerWithManagersQuery, ViewerWithManagersQueryVariables>(ViewerWithManagersDocument, options);
        }
export type ViewerWithManagersQueryHookResult = ReturnType<typeof useViewerWithManagersQuery>;
export type ViewerWithManagersLazyQueryHookResult = ReturnType<typeof useViewerWithManagersLazyQuery>;
export type ViewerWithManagersSuspenseQueryHookResult = ReturnType<typeof useViewerWithManagersSuspenseQuery>;
export type ViewerWithManagersQueryResult = Apollo.QueryResult<ViewerWithManagersQuery, ViewerWithManagersQueryVariables>;
export const ViewerWithManagersAndManageesDocument = gql`
    query ViewerWithManagersAndManagees {
  viewer {
    managees {
      id
      firstName
      lastName
      isArchived
    }
    managers {
      id
      source {
        id
        firstName
        lastName
        isArchived
      }
    }
  }
}
    `;

/**
 * __useViewerWithManagersAndManageesQuery__
 *
 * To run a query within a React component, call `useViewerWithManagersAndManageesQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerWithManagersAndManageesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerWithManagersAndManageesQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerWithManagersAndManageesQuery(baseOptions?: Apollo.QueryHookOptions<ViewerWithManagersAndManageesQuery, ViewerWithManagersAndManageesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerWithManagersAndManageesQuery, ViewerWithManagersAndManageesQueryVariables>(ViewerWithManagersAndManageesDocument, options);
      }
export function useViewerWithManagersAndManageesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerWithManagersAndManageesQuery, ViewerWithManagersAndManageesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerWithManagersAndManageesQuery, ViewerWithManagersAndManageesQueryVariables>(ViewerWithManagersAndManageesDocument, options);
        }
// @ts-ignore
export function useViewerWithManagersAndManageesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerWithManagersAndManageesQuery, ViewerWithManagersAndManageesQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerWithManagersAndManageesQuery, ViewerWithManagersAndManageesQueryVariables>;
export function useViewerWithManagersAndManageesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerWithManagersAndManageesQuery, ViewerWithManagersAndManageesQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerWithManagersAndManageesQuery | undefined, ViewerWithManagersAndManageesQueryVariables>;
export function useViewerWithManagersAndManageesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerWithManagersAndManageesQuery, ViewerWithManagersAndManageesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewerWithManagersAndManageesQuery, ViewerWithManagersAndManageesQueryVariables>(ViewerWithManagersAndManageesDocument, options);
        }
export type ViewerWithManagersAndManageesQueryHookResult = ReturnType<typeof useViewerWithManagersAndManageesQuery>;
export type ViewerWithManagersAndManageesLazyQueryHookResult = ReturnType<typeof useViewerWithManagersAndManageesLazyQuery>;
export type ViewerWithManagersAndManageesSuspenseQueryHookResult = ReturnType<typeof useViewerWithManagersAndManageesSuspenseQuery>;
export type ViewerWithManagersAndManageesQueryResult = Apollo.QueryResult<ViewerWithManagersAndManageesQuery, ViewerWithManagersAndManageesQueryVariables>;
export const ArchiveTalentReviewDocument = gql`
    mutation ArchiveTalentReview($input: ArchiveTalentReviewInput!) {
  archiveTalentReview(input: $input) {
    talentReview {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveTalentReviewMutationFn = Apollo.MutationFunction<ArchiveTalentReviewMutation, ArchiveTalentReviewMutationVariables>;

/**
 * __useArchiveTalentReviewMutation__
 *
 * To run a mutation, you first call `useArchiveTalentReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTalentReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTalentReviewMutation, { data, loading, error }] = useArchiveTalentReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveTalentReviewMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTalentReviewMutation, ArchiveTalentReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTalentReviewMutation, ArchiveTalentReviewMutationVariables>(ArchiveTalentReviewDocument, options);
      }
export type ArchiveTalentReviewMutationHookResult = ReturnType<typeof useArchiveTalentReviewMutation>;
export type ArchiveTalentReviewMutationResult = Apollo.MutationResult<ArchiveTalentReviewMutation>;
export type ArchiveTalentReviewMutationOptions = Apollo.BaseMutationOptions<ArchiveTalentReviewMutation, ArchiveTalentReviewMutationVariables>;
export const ArchiveTalentReviewTemplateDocument = gql`
    mutation ArchiveTalentReviewTemplate($input: ArchiveTalentReviewTemplateInput!) {
  archiveTalentReviewTemplate(input: $input) {
    template {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveTalentReviewTemplateMutationFn = Apollo.MutationFunction<ArchiveTalentReviewTemplateMutation, ArchiveTalentReviewTemplateMutationVariables>;

/**
 * __useArchiveTalentReviewTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveTalentReviewTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTalentReviewTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTalentReviewTemplateMutation, { data, loading, error }] = useArchiveTalentReviewTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveTalentReviewTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTalentReviewTemplateMutation, ArchiveTalentReviewTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTalentReviewTemplateMutation, ArchiveTalentReviewTemplateMutationVariables>(ArchiveTalentReviewTemplateDocument, options);
      }
export type ArchiveTalentReviewTemplateMutationHookResult = ReturnType<typeof useArchiveTalentReviewTemplateMutation>;
export type ArchiveTalentReviewTemplateMutationResult = Apollo.MutationResult<ArchiveTalentReviewTemplateMutation>;
export type ArchiveTalentReviewTemplateMutationOptions = Apollo.BaseMutationOptions<ArchiveTalentReviewTemplateMutation, ArchiveTalentReviewTemplateMutationVariables>;
export const CreateTalentReviewDocument = gql`
    mutation CreateTalentReview($input: CreateTalentReviewInput!) {
  createTalentReview(input: $input) {
    talentReview {
      id
    }
  }
}
    `;
export type CreateTalentReviewMutationFn = Apollo.MutationFunction<CreateTalentReviewMutation, CreateTalentReviewMutationVariables>;

/**
 * __useCreateTalentReviewMutation__
 *
 * To run a mutation, you first call `useCreateTalentReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTalentReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTalentReviewMutation, { data, loading, error }] = useCreateTalentReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTalentReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateTalentReviewMutation, CreateTalentReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTalentReviewMutation, CreateTalentReviewMutationVariables>(CreateTalentReviewDocument, options);
      }
export type CreateTalentReviewMutationHookResult = ReturnType<typeof useCreateTalentReviewMutation>;
export type CreateTalentReviewMutationResult = Apollo.MutationResult<CreateTalentReviewMutation>;
export type CreateTalentReviewMutationOptions = Apollo.BaseMutationOptions<CreateTalentReviewMutation, CreateTalentReviewMutationVariables>;
export const CreateTalentReviewTemplateDocument = gql`
    mutation CreateTalentReviewTemplate($input: CreateTalentReviewTemplateInput!) {
  createTalentReviewTemplate(input: $input) {
    template {
      ...TalentReviewTemplate
    }
  }
}
    ${TalentReviewTemplateFragmentDoc}`;
export type CreateTalentReviewTemplateMutationFn = Apollo.MutationFunction<CreateTalentReviewTemplateMutation, CreateTalentReviewTemplateMutationVariables>;

/**
 * __useCreateTalentReviewTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTalentReviewTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTalentReviewTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTalentReviewTemplateMutation, { data, loading, error }] = useCreateTalentReviewTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTalentReviewTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateTalentReviewTemplateMutation, CreateTalentReviewTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTalentReviewTemplateMutation, CreateTalentReviewTemplateMutationVariables>(CreateTalentReviewTemplateDocument, options);
      }
export type CreateTalentReviewTemplateMutationHookResult = ReturnType<typeof useCreateTalentReviewTemplateMutation>;
export type CreateTalentReviewTemplateMutationResult = Apollo.MutationResult<CreateTalentReviewTemplateMutation>;
export type CreateTalentReviewTemplateMutationOptions = Apollo.BaseMutationOptions<CreateTalentReviewTemplateMutation, CreateTalentReviewTemplateMutationVariables>;
export const RestoreTalentReviewDocument = gql`
    mutation RestoreTalentReview($input: RestoreTalentReviewInput!) {
  restoreTalentReview(input: $input) {
    talentReview {
      id
      isArchived
    }
  }
}
    `;
export type RestoreTalentReviewMutationFn = Apollo.MutationFunction<RestoreTalentReviewMutation, RestoreTalentReviewMutationVariables>;

/**
 * __useRestoreTalentReviewMutation__
 *
 * To run a mutation, you first call `useRestoreTalentReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreTalentReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreTalentReviewMutation, { data, loading, error }] = useRestoreTalentReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreTalentReviewMutation(baseOptions?: Apollo.MutationHookOptions<RestoreTalentReviewMutation, RestoreTalentReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreTalentReviewMutation, RestoreTalentReviewMutationVariables>(RestoreTalentReviewDocument, options);
      }
export type RestoreTalentReviewMutationHookResult = ReturnType<typeof useRestoreTalentReviewMutation>;
export type RestoreTalentReviewMutationResult = Apollo.MutationResult<RestoreTalentReviewMutation>;
export type RestoreTalentReviewMutationOptions = Apollo.BaseMutationOptions<RestoreTalentReviewMutation, RestoreTalentReviewMutationVariables>;
export const RestoreTalentReviewTemplateDocument = gql`
    mutation RestoreTalentReviewTemplate($input: RestoreTalentReviewTemplateInput!) {
  restoreTalentReviewTemplate(input: $input) {
    template {
      id
      isArchived
    }
  }
}
    `;
export type RestoreTalentReviewTemplateMutationFn = Apollo.MutationFunction<RestoreTalentReviewTemplateMutation, RestoreTalentReviewTemplateMutationVariables>;

/**
 * __useRestoreTalentReviewTemplateMutation__
 *
 * To run a mutation, you first call `useRestoreTalentReviewTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreTalentReviewTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreTalentReviewTemplateMutation, { data, loading, error }] = useRestoreTalentReviewTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreTalentReviewTemplateMutation(baseOptions?: Apollo.MutationHookOptions<RestoreTalentReviewTemplateMutation, RestoreTalentReviewTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreTalentReviewTemplateMutation, RestoreTalentReviewTemplateMutationVariables>(RestoreTalentReviewTemplateDocument, options);
      }
export type RestoreTalentReviewTemplateMutationHookResult = ReturnType<typeof useRestoreTalentReviewTemplateMutation>;
export type RestoreTalentReviewTemplateMutationResult = Apollo.MutationResult<RestoreTalentReviewTemplateMutation>;
export type RestoreTalentReviewTemplateMutationOptions = Apollo.BaseMutationOptions<RestoreTalentReviewTemplateMutation, RestoreTalentReviewTemplateMutationVariables>;
export const UnShareTalentReviewDocument = gql`
    mutation UnShareTalentReview($input: UnshareTalentReviewInput!) {
  unshareTalentReview(input: $input) {
    talentReview {
      ...TalentReview
    }
  }
}
    ${TalentReviewFragmentDoc}`;
export type UnShareTalentReviewMutationFn = Apollo.MutationFunction<UnShareTalentReviewMutation, UnShareTalentReviewMutationVariables>;

/**
 * __useUnShareTalentReviewMutation__
 *
 * To run a mutation, you first call `useUnShareTalentReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnShareTalentReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unShareTalentReviewMutation, { data, loading, error }] = useUnShareTalentReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnShareTalentReviewMutation(baseOptions?: Apollo.MutationHookOptions<UnShareTalentReviewMutation, UnShareTalentReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnShareTalentReviewMutation, UnShareTalentReviewMutationVariables>(UnShareTalentReviewDocument, options);
      }
export type UnShareTalentReviewMutationHookResult = ReturnType<typeof useUnShareTalentReviewMutation>;
export type UnShareTalentReviewMutationResult = Apollo.MutationResult<UnShareTalentReviewMutation>;
export type UnShareTalentReviewMutationOptions = Apollo.BaseMutationOptions<UnShareTalentReviewMutation, UnShareTalentReviewMutationVariables>;
export const UpdateTalentReviewDocument = gql`
    mutation UpdateTalentReview($input: UpdateTalentReviewInput!) {
  updateTalentReview(input: $input) {
    talentReview {
      ...TalentReview
    }
  }
}
    ${TalentReviewFragmentDoc}`;
export type UpdateTalentReviewMutationFn = Apollo.MutationFunction<UpdateTalentReviewMutation, UpdateTalentReviewMutationVariables>;

/**
 * __useUpdateTalentReviewMutation__
 *
 * To run a mutation, you first call `useUpdateTalentReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTalentReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTalentReviewMutation, { data, loading, error }] = useUpdateTalentReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTalentReviewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTalentReviewMutation, UpdateTalentReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTalentReviewMutation, UpdateTalentReviewMutationVariables>(UpdateTalentReviewDocument, options);
      }
export type UpdateTalentReviewMutationHookResult = ReturnType<typeof useUpdateTalentReviewMutation>;
export type UpdateTalentReviewMutationResult = Apollo.MutationResult<UpdateTalentReviewMutation>;
export type UpdateTalentReviewMutationOptions = Apollo.BaseMutationOptions<UpdateTalentReviewMutation, UpdateTalentReviewMutationVariables>;
export const UpdateTalentReviewTemplateDocument = gql`
    mutation UpdateTalentReviewTemplate($input: UpdateTalentReviewTemplateInput!) {
  updateTalentReviewTemplate(input: $input) {
    template {
      ...TalentReviewTemplate
    }
  }
}
    ${TalentReviewTemplateFragmentDoc}`;
export type UpdateTalentReviewTemplateMutationFn = Apollo.MutationFunction<UpdateTalentReviewTemplateMutation, UpdateTalentReviewTemplateMutationVariables>;

/**
 * __useUpdateTalentReviewTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTalentReviewTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTalentReviewTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTalentReviewTemplateMutation, { data, loading, error }] = useUpdateTalentReviewTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTalentReviewTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTalentReviewTemplateMutation, UpdateTalentReviewTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTalentReviewTemplateMutation, UpdateTalentReviewTemplateMutationVariables>(UpdateTalentReviewTemplateDocument, options);
      }
export type UpdateTalentReviewTemplateMutationHookResult = ReturnType<typeof useUpdateTalentReviewTemplateMutation>;
export type UpdateTalentReviewTemplateMutationResult = Apollo.MutationResult<UpdateTalentReviewTemplateMutation>;
export type UpdateTalentReviewTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateTalentReviewTemplateMutation, UpdateTalentReviewTemplateMutationVariables>;
export const TalentReviewDocument = gql`
    query TalentReview($id: ID!) {
  talentReview(id: $id) {
    ...TalentReview
  }
}
    ${TalentReviewFragmentDoc}`;

/**
 * __useTalentReviewQuery__
 *
 * To run a query within a React component, call `useTalentReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentReviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTalentReviewQuery(baseOptions: Apollo.QueryHookOptions<TalentReviewQuery, TalentReviewQueryVariables> & ({ variables: TalentReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentReviewQuery, TalentReviewQueryVariables>(TalentReviewDocument, options);
      }
export function useTalentReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentReviewQuery, TalentReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentReviewQuery, TalentReviewQueryVariables>(TalentReviewDocument, options);
        }
// @ts-ignore
export function useTalentReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentReviewQuery, TalentReviewQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewQuery, TalentReviewQueryVariables>;
export function useTalentReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewQuery, TalentReviewQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewQuery | undefined, TalentReviewQueryVariables>;
export function useTalentReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewQuery, TalentReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentReviewQuery, TalentReviewQueryVariables>(TalentReviewDocument, options);
        }
export type TalentReviewQueryHookResult = ReturnType<typeof useTalentReviewQuery>;
export type TalentReviewLazyQueryHookResult = ReturnType<typeof useTalentReviewLazyQuery>;
export type TalentReviewSuspenseQueryHookResult = ReturnType<typeof useTalentReviewSuspenseQuery>;
export type TalentReviewQueryResult = Apollo.QueryResult<TalentReviewQuery, TalentReviewQueryVariables>;
export const TalentReviewAnalyticsGridDocument = gql`
    query TalentReviewAnalyticsGrid($templateID: ID!, $groupID: ID!, $localDate: LocalDate!) {
  talentReviewGrid(
    templateID: $templateID
    groupID: $groupID
    localDate: $localDate
  ) {
    placements {
      user {
        id
      }
      row
      column
      removed
    }
  }
}
    `;

/**
 * __useTalentReviewAnalyticsGridQuery__
 *
 * To run a query within a React component, call `useTalentReviewAnalyticsGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentReviewAnalyticsGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentReviewAnalyticsGridQuery({
 *   variables: {
 *      templateID: // value for 'templateID'
 *      groupID: // value for 'groupID'
 *      localDate: // value for 'localDate'
 *   },
 * });
 */
export function useTalentReviewAnalyticsGridQuery(baseOptions: Apollo.QueryHookOptions<TalentReviewAnalyticsGridQuery, TalentReviewAnalyticsGridQueryVariables> & ({ variables: TalentReviewAnalyticsGridQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentReviewAnalyticsGridQuery, TalentReviewAnalyticsGridQueryVariables>(TalentReviewAnalyticsGridDocument, options);
      }
export function useTalentReviewAnalyticsGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentReviewAnalyticsGridQuery, TalentReviewAnalyticsGridQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentReviewAnalyticsGridQuery, TalentReviewAnalyticsGridQueryVariables>(TalentReviewAnalyticsGridDocument, options);
        }
// @ts-ignore
export function useTalentReviewAnalyticsGridSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentReviewAnalyticsGridQuery, TalentReviewAnalyticsGridQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewAnalyticsGridQuery, TalentReviewAnalyticsGridQueryVariables>;
export function useTalentReviewAnalyticsGridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewAnalyticsGridQuery, TalentReviewAnalyticsGridQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewAnalyticsGridQuery | undefined, TalentReviewAnalyticsGridQueryVariables>;
export function useTalentReviewAnalyticsGridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewAnalyticsGridQuery, TalentReviewAnalyticsGridQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentReviewAnalyticsGridQuery, TalentReviewAnalyticsGridQueryVariables>(TalentReviewAnalyticsGridDocument, options);
        }
export type TalentReviewAnalyticsGridQueryHookResult = ReturnType<typeof useTalentReviewAnalyticsGridQuery>;
export type TalentReviewAnalyticsGridLazyQueryHookResult = ReturnType<typeof useTalentReviewAnalyticsGridLazyQuery>;
export type TalentReviewAnalyticsGridSuspenseQueryHookResult = ReturnType<typeof useTalentReviewAnalyticsGridSuspenseQuery>;
export type TalentReviewAnalyticsGridQueryResult = Apollo.QueryResult<TalentReviewAnalyticsGridQuery, TalentReviewAnalyticsGridQueryVariables>;
export const TalentReviewAnalyticsGroupDocument = gql`
    query TalentReviewAnalyticsGroup($id: ID!) {
  group(id: $id) {
    id
    name
    members(first: 1000) {
      edges {
        node {
          id
          firstName
          lastName
          avatar {
            source {
              url
            }
          }
          currentJobPosition {
            jobTitle {
              title
            }
          }
          individualManagers {
            role {
              id
            }
            source {
              firstName
              lastName
            }
          }
        }
      }
    }
    managers(first: 100) {
      edges {
        role {
          id
        }
        node {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useTalentReviewAnalyticsGroupQuery__
 *
 * To run a query within a React component, call `useTalentReviewAnalyticsGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentReviewAnalyticsGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentReviewAnalyticsGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTalentReviewAnalyticsGroupQuery(baseOptions: Apollo.QueryHookOptions<TalentReviewAnalyticsGroupQuery, TalentReviewAnalyticsGroupQueryVariables> & ({ variables: TalentReviewAnalyticsGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentReviewAnalyticsGroupQuery, TalentReviewAnalyticsGroupQueryVariables>(TalentReviewAnalyticsGroupDocument, options);
      }
export function useTalentReviewAnalyticsGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentReviewAnalyticsGroupQuery, TalentReviewAnalyticsGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentReviewAnalyticsGroupQuery, TalentReviewAnalyticsGroupQueryVariables>(TalentReviewAnalyticsGroupDocument, options);
        }
// @ts-ignore
export function useTalentReviewAnalyticsGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentReviewAnalyticsGroupQuery, TalentReviewAnalyticsGroupQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewAnalyticsGroupQuery, TalentReviewAnalyticsGroupQueryVariables>;
export function useTalentReviewAnalyticsGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewAnalyticsGroupQuery, TalentReviewAnalyticsGroupQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewAnalyticsGroupQuery | undefined, TalentReviewAnalyticsGroupQueryVariables>;
export function useTalentReviewAnalyticsGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewAnalyticsGroupQuery, TalentReviewAnalyticsGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentReviewAnalyticsGroupQuery, TalentReviewAnalyticsGroupQueryVariables>(TalentReviewAnalyticsGroupDocument, options);
        }
export type TalentReviewAnalyticsGroupQueryHookResult = ReturnType<typeof useTalentReviewAnalyticsGroupQuery>;
export type TalentReviewAnalyticsGroupLazyQueryHookResult = ReturnType<typeof useTalentReviewAnalyticsGroupLazyQuery>;
export type TalentReviewAnalyticsGroupSuspenseQueryHookResult = ReturnType<typeof useTalentReviewAnalyticsGroupSuspenseQuery>;
export type TalentReviewAnalyticsGroupQueryResult = Apollo.QueryResult<TalentReviewAnalyticsGroupQuery, TalentReviewAnalyticsGroupQueryVariables>;
export const TalentReviewTemplateDocument = gql`
    query TalentReviewTemplate($id: ID!) {
  talentReviewTemplate(id: $id) {
    ...TalentReviewTemplate
  }
}
    ${TalentReviewTemplateFragmentDoc}`;

/**
 * __useTalentReviewTemplateQuery__
 *
 * To run a query within a React component, call `useTalentReviewTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentReviewTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentReviewTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTalentReviewTemplateQuery(baseOptions: Apollo.QueryHookOptions<TalentReviewTemplateQuery, TalentReviewTemplateQueryVariables> & ({ variables: TalentReviewTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentReviewTemplateQuery, TalentReviewTemplateQueryVariables>(TalentReviewTemplateDocument, options);
      }
export function useTalentReviewTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentReviewTemplateQuery, TalentReviewTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentReviewTemplateQuery, TalentReviewTemplateQueryVariables>(TalentReviewTemplateDocument, options);
        }
// @ts-ignore
export function useTalentReviewTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentReviewTemplateQuery, TalentReviewTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewTemplateQuery, TalentReviewTemplateQueryVariables>;
export function useTalentReviewTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewTemplateQuery, TalentReviewTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewTemplateQuery | undefined, TalentReviewTemplateQueryVariables>;
export function useTalentReviewTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewTemplateQuery, TalentReviewTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentReviewTemplateQuery, TalentReviewTemplateQueryVariables>(TalentReviewTemplateDocument, options);
        }
export type TalentReviewTemplateQueryHookResult = ReturnType<typeof useTalentReviewTemplateQuery>;
export type TalentReviewTemplateLazyQueryHookResult = ReturnType<typeof useTalentReviewTemplateLazyQuery>;
export type TalentReviewTemplateSuspenseQueryHookResult = ReturnType<typeof useTalentReviewTemplateSuspenseQuery>;
export type TalentReviewTemplateQueryResult = Apollo.QueryResult<TalentReviewTemplateQuery, TalentReviewTemplateQueryVariables>;
export const TalentReviewTemplatesDocument = gql`
    query TalentReviewTemplates($isArchived: Boolean!, $first: Int, $after: ID) {
  talentReviewTemplates(isArchived: $isArchived, first: $first, after: $after) {
    edges {
      node {
        id
        title
        description
        isArchived
        createdAt
      }
    }
  }
}
    `;

/**
 * __useTalentReviewTemplatesQuery__
 *
 * To run a query within a React component, call `useTalentReviewTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentReviewTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentReviewTemplatesQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTalentReviewTemplatesQuery(baseOptions: Apollo.QueryHookOptions<TalentReviewTemplatesQuery, TalentReviewTemplatesQueryVariables> & ({ variables: TalentReviewTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentReviewTemplatesQuery, TalentReviewTemplatesQueryVariables>(TalentReviewTemplatesDocument, options);
      }
export function useTalentReviewTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentReviewTemplatesQuery, TalentReviewTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentReviewTemplatesQuery, TalentReviewTemplatesQueryVariables>(TalentReviewTemplatesDocument, options);
        }
// @ts-ignore
export function useTalentReviewTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentReviewTemplatesQuery, TalentReviewTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewTemplatesQuery, TalentReviewTemplatesQueryVariables>;
export function useTalentReviewTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewTemplatesQuery, TalentReviewTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewTemplatesQuery | undefined, TalentReviewTemplatesQueryVariables>;
export function useTalentReviewTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewTemplatesQuery, TalentReviewTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentReviewTemplatesQuery, TalentReviewTemplatesQueryVariables>(TalentReviewTemplatesDocument, options);
        }
export type TalentReviewTemplatesQueryHookResult = ReturnType<typeof useTalentReviewTemplatesQuery>;
export type TalentReviewTemplatesLazyQueryHookResult = ReturnType<typeof useTalentReviewTemplatesLazyQuery>;
export type TalentReviewTemplatesSuspenseQueryHookResult = ReturnType<typeof useTalentReviewTemplatesSuspenseQuery>;
export type TalentReviewTemplatesQueryResult = Apollo.QueryResult<TalentReviewTemplatesQuery, TalentReviewTemplatesQueryVariables>;
export const TalentReviewsDocument = gql`
    query TalentReviews($id: ID!, $isArchived: Boolean!) {
  group(id: $id) {
    id
    name
    talentReviews(isArchived: $isArchived) {
      edges {
        node {
          id
          title
          placements {
            column
            row
          }
          group {
            members {
              totalCount
              edges {
                role {
                  id
                  type
                }
              }
            }
          }
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useTalentReviewsQuery__
 *
 * To run a query within a React component, call `useTalentReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentReviewsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useTalentReviewsQuery(baseOptions: Apollo.QueryHookOptions<TalentReviewsQuery, TalentReviewsQueryVariables> & ({ variables: TalentReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentReviewsQuery, TalentReviewsQueryVariables>(TalentReviewsDocument, options);
      }
export function useTalentReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentReviewsQuery, TalentReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentReviewsQuery, TalentReviewsQueryVariables>(TalentReviewsDocument, options);
        }
// @ts-ignore
export function useTalentReviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentReviewsQuery, TalentReviewsQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewsQuery, TalentReviewsQueryVariables>;
export function useTalentReviewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewsQuery, TalentReviewsQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewsQuery | undefined, TalentReviewsQueryVariables>;
export function useTalentReviewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewsQuery, TalentReviewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentReviewsQuery, TalentReviewsQueryVariables>(TalentReviewsDocument, options);
        }
export type TalentReviewsQueryHookResult = ReturnType<typeof useTalentReviewsQuery>;
export type TalentReviewsLazyQueryHookResult = ReturnType<typeof useTalentReviewsLazyQuery>;
export type TalentReviewsSuspenseQueryHookResult = ReturnType<typeof useTalentReviewsSuspenseQuery>;
export type TalentReviewsQueryResult = Apollo.QueryResult<TalentReviewsQuery, TalentReviewsQueryVariables>;
export const AnswerTalentReviewPlacementHelpDocument = gql`
    mutation AnswerTalentReviewPlacementHelp($input: AnswerTalentReviewPlacementHelpInput!) {
  answerTalentReviewPlacementHelp(input: $input) {
    grid {
      ...TalentReviewGrid
    }
  }
}
    ${TalentReviewGridFragmentDoc}`;
export type AnswerTalentReviewPlacementHelpMutationFn = Apollo.MutationFunction<AnswerTalentReviewPlacementHelpMutation, AnswerTalentReviewPlacementHelpMutationVariables>;

/**
 * __useAnswerTalentReviewPlacementHelpMutation__
 *
 * To run a mutation, you first call `useAnswerTalentReviewPlacementHelpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerTalentReviewPlacementHelpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerTalentReviewPlacementHelpMutation, { data, loading, error }] = useAnswerTalentReviewPlacementHelpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerTalentReviewPlacementHelpMutation(baseOptions?: Apollo.MutationHookOptions<AnswerTalentReviewPlacementHelpMutation, AnswerTalentReviewPlacementHelpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerTalentReviewPlacementHelpMutation, AnswerTalentReviewPlacementHelpMutationVariables>(AnswerTalentReviewPlacementHelpDocument, options);
      }
export type AnswerTalentReviewPlacementHelpMutationHookResult = ReturnType<typeof useAnswerTalentReviewPlacementHelpMutation>;
export type AnswerTalentReviewPlacementHelpMutationResult = Apollo.MutationResult<AnswerTalentReviewPlacementHelpMutation>;
export type AnswerTalentReviewPlacementHelpMutationOptions = Apollo.BaseMutationOptions<AnswerTalentReviewPlacementHelpMutation, AnswerTalentReviewPlacementHelpMutationVariables>;
export const ArchiveTalentReviewSnapshotDocument = gql`
    mutation ArchiveTalentReviewSnapshot($input: ArchiveTalentReviewSnapshotInput!) {
  archiveTalentReviewSnapshot(input: $input) {
    snapshot {
      ...TalentReviewSnapshot
    }
  }
}
    ${TalentReviewSnapshotFragmentDoc}`;
export type ArchiveTalentReviewSnapshotMutationFn = Apollo.MutationFunction<ArchiveTalentReviewSnapshotMutation, ArchiveTalentReviewSnapshotMutationVariables>;

/**
 * __useArchiveTalentReviewSnapshotMutation__
 *
 * To run a mutation, you first call `useArchiveTalentReviewSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTalentReviewSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTalentReviewSnapshotMutation, { data, loading, error }] = useArchiveTalentReviewSnapshotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveTalentReviewSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTalentReviewSnapshotMutation, ArchiveTalentReviewSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTalentReviewSnapshotMutation, ArchiveTalentReviewSnapshotMutationVariables>(ArchiveTalentReviewSnapshotDocument, options);
      }
export type ArchiveTalentReviewSnapshotMutationHookResult = ReturnType<typeof useArchiveTalentReviewSnapshotMutation>;
export type ArchiveTalentReviewSnapshotMutationResult = Apollo.MutationResult<ArchiveTalentReviewSnapshotMutation>;
export type ArchiveTalentReviewSnapshotMutationOptions = Apollo.BaseMutationOptions<ArchiveTalentReviewSnapshotMutation, ArchiveTalentReviewSnapshotMutationVariables>;
export const ClearTalentReviewGridDocument = gql`
    mutation ClearTalentReviewGrid($input: ClearTalentReviewGridInput!) {
  clearTalentReviewGrid(input: $input) {
    grid {
      ...TalentReviewGrid
    }
  }
}
    ${TalentReviewGridFragmentDoc}`;
export type ClearTalentReviewGridMutationFn = Apollo.MutationFunction<ClearTalentReviewGridMutation, ClearTalentReviewGridMutationVariables>;

/**
 * __useClearTalentReviewGridMutation__
 *
 * To run a mutation, you first call `useClearTalentReviewGridMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearTalentReviewGridMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearTalentReviewGridMutation, { data, loading, error }] = useClearTalentReviewGridMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearTalentReviewGridMutation(baseOptions?: Apollo.MutationHookOptions<ClearTalentReviewGridMutation, ClearTalentReviewGridMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearTalentReviewGridMutation, ClearTalentReviewGridMutationVariables>(ClearTalentReviewGridDocument, options);
      }
export type ClearTalentReviewGridMutationHookResult = ReturnType<typeof useClearTalentReviewGridMutation>;
export type ClearTalentReviewGridMutationResult = Apollo.MutationResult<ClearTalentReviewGridMutation>;
export type ClearTalentReviewGridMutationOptions = Apollo.BaseMutationOptions<ClearTalentReviewGridMutation, ClearTalentReviewGridMutationVariables>;
export const CorrectTalentReviewSnapshotDocument = gql`
    mutation CorrectTalentReviewSnapshot($input: CorrectTalentReviewSnapshotInput!, $manage: Boolean = true) {
  correctTalentReviewSnapshot(input: $input) {
    snapshot {
      ...TalentReviewSnapshotGrid
    }
  }
}
    ${TalentReviewSnapshotGridFragmentDoc}`;
export type CorrectTalentReviewSnapshotMutationFn = Apollo.MutationFunction<CorrectTalentReviewSnapshotMutation, CorrectTalentReviewSnapshotMutationVariables>;

/**
 * __useCorrectTalentReviewSnapshotMutation__
 *
 * To run a mutation, you first call `useCorrectTalentReviewSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCorrectTalentReviewSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [correctTalentReviewSnapshotMutation, { data, loading, error }] = useCorrectTalentReviewSnapshotMutation({
 *   variables: {
 *      input: // value for 'input'
 *      manage: // value for 'manage'
 *   },
 * });
 */
export function useCorrectTalentReviewSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<CorrectTalentReviewSnapshotMutation, CorrectTalentReviewSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CorrectTalentReviewSnapshotMutation, CorrectTalentReviewSnapshotMutationVariables>(CorrectTalentReviewSnapshotDocument, options);
      }
export type CorrectTalentReviewSnapshotMutationHookResult = ReturnType<typeof useCorrectTalentReviewSnapshotMutation>;
export type CorrectTalentReviewSnapshotMutationResult = Apollo.MutationResult<CorrectTalentReviewSnapshotMutation>;
export type CorrectTalentReviewSnapshotMutationOptions = Apollo.BaseMutationOptions<CorrectTalentReviewSnapshotMutation, CorrectTalentReviewSnapshotMutationVariables>;
export const CreateTalentReviewSnapshotDocument = gql`
    mutation CreateTalentReviewSnapshot($input: CreateTalentReviewSnapshotInput!) {
  createTalentReviewSnapshot(input: $input) {
    snapshot {
      ...TalentReviewSnapshot
    }
  }
}
    ${TalentReviewSnapshotFragmentDoc}`;
export type CreateTalentReviewSnapshotMutationFn = Apollo.MutationFunction<CreateTalentReviewSnapshotMutation, CreateTalentReviewSnapshotMutationVariables>;

/**
 * __useCreateTalentReviewSnapshotMutation__
 *
 * To run a mutation, you first call `useCreateTalentReviewSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTalentReviewSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTalentReviewSnapshotMutation, { data, loading, error }] = useCreateTalentReviewSnapshotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTalentReviewSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<CreateTalentReviewSnapshotMutation, CreateTalentReviewSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTalentReviewSnapshotMutation, CreateTalentReviewSnapshotMutationVariables>(CreateTalentReviewSnapshotDocument, options);
      }
export type CreateTalentReviewSnapshotMutationHookResult = ReturnType<typeof useCreateTalentReviewSnapshotMutation>;
export type CreateTalentReviewSnapshotMutationResult = Apollo.MutationResult<CreateTalentReviewSnapshotMutation>;
export type CreateTalentReviewSnapshotMutationOptions = Apollo.BaseMutationOptions<CreateTalentReviewSnapshotMutation, CreateTalentReviewSnapshotMutationVariables>;
export const RemoveTalentReviewGridPlacementDocument = gql`
    mutation RemoveTalentReviewGridPlacement($input: RemoveTalentReviewGridPlacementInput!) {
  removeTalentReviewGridPlacement(input: $input) {
    grid {
      ...TalentReviewGrid
    }
  }
}
    ${TalentReviewGridFragmentDoc}`;
export type RemoveTalentReviewGridPlacementMutationFn = Apollo.MutationFunction<RemoveTalentReviewGridPlacementMutation, RemoveTalentReviewGridPlacementMutationVariables>;

/**
 * __useRemoveTalentReviewGridPlacementMutation__
 *
 * To run a mutation, you first call `useRemoveTalentReviewGridPlacementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTalentReviewGridPlacementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTalentReviewGridPlacementMutation, { data, loading, error }] = useRemoveTalentReviewGridPlacementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTalentReviewGridPlacementMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTalentReviewGridPlacementMutation, RemoveTalentReviewGridPlacementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTalentReviewGridPlacementMutation, RemoveTalentReviewGridPlacementMutationVariables>(RemoveTalentReviewGridPlacementDocument, options);
      }
export type RemoveTalentReviewGridPlacementMutationHookResult = ReturnType<typeof useRemoveTalentReviewGridPlacementMutation>;
export type RemoveTalentReviewGridPlacementMutationResult = Apollo.MutationResult<RemoveTalentReviewGridPlacementMutation>;
export type RemoveTalentReviewGridPlacementMutationOptions = Apollo.BaseMutationOptions<RemoveTalentReviewGridPlacementMutation, RemoveTalentReviewGridPlacementMutationVariables>;
export const RevertTalentReviewSubmissionDocument = gql`
    mutation RevertTalentReviewSubmission($input: RevertTalentReviewSubmissionInput!) {
  revertTalentReviewSubmission(input: $input) {
    momentInstance {
      id
      status
    }
  }
}
    `;
export type RevertTalentReviewSubmissionMutationFn = Apollo.MutationFunction<RevertTalentReviewSubmissionMutation, RevertTalentReviewSubmissionMutationVariables>;

/**
 * __useRevertTalentReviewSubmissionMutation__
 *
 * To run a mutation, you first call `useRevertTalentReviewSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertTalentReviewSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertTalentReviewSubmissionMutation, { data, loading, error }] = useRevertTalentReviewSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevertTalentReviewSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<RevertTalentReviewSubmissionMutation, RevertTalentReviewSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertTalentReviewSubmissionMutation, RevertTalentReviewSubmissionMutationVariables>(RevertTalentReviewSubmissionDocument, options);
      }
export type RevertTalentReviewSubmissionMutationHookResult = ReturnType<typeof useRevertTalentReviewSubmissionMutation>;
export type RevertTalentReviewSubmissionMutationResult = Apollo.MutationResult<RevertTalentReviewSubmissionMutation>;
export type RevertTalentReviewSubmissionMutationOptions = Apollo.BaseMutationOptions<RevertTalentReviewSubmissionMutation, RevertTalentReviewSubmissionMutationVariables>;
export const UpdateTalentReviewGridPlacementDocument = gql`
    mutation UpdateTalentReviewGridPlacement($input: UpdateTalentReviewGridPlacementInput!) {
  updateTalentReviewGridPlacement(input: $input) {
    grid {
      ...TalentReviewGrid
    }
  }
}
    ${TalentReviewGridFragmentDoc}`;
export type UpdateTalentReviewGridPlacementMutationFn = Apollo.MutationFunction<UpdateTalentReviewGridPlacementMutation, UpdateTalentReviewGridPlacementMutationVariables>;

/**
 * __useUpdateTalentReviewGridPlacementMutation__
 *
 * To run a mutation, you first call `useUpdateTalentReviewGridPlacementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTalentReviewGridPlacementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTalentReviewGridPlacementMutation, { data, loading, error }] = useUpdateTalentReviewGridPlacementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTalentReviewGridPlacementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTalentReviewGridPlacementMutation, UpdateTalentReviewGridPlacementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTalentReviewGridPlacementMutation, UpdateTalentReviewGridPlacementMutationVariables>(UpdateTalentReviewGridPlacementDocument, options);
      }
export type UpdateTalentReviewGridPlacementMutationHookResult = ReturnType<typeof useUpdateTalentReviewGridPlacementMutation>;
export type UpdateTalentReviewGridPlacementMutationResult = Apollo.MutationResult<UpdateTalentReviewGridPlacementMutation>;
export type UpdateTalentReviewGridPlacementMutationOptions = Apollo.BaseMutationOptions<UpdateTalentReviewGridPlacementMutation, UpdateTalentReviewGridPlacementMutationVariables>;
export const UpdateTalentReviewSnapshotDocument = gql`
    mutation UpdateTalentReviewSnapshot($input: UpdateTalentReviewSnapshotInput!) {
  updateTalentReviewSnapshot(input: $input) {
    snapshot {
      ...TalentReviewSnapshot
    }
  }
}
    ${TalentReviewSnapshotFragmentDoc}`;
export type UpdateTalentReviewSnapshotMutationFn = Apollo.MutationFunction<UpdateTalentReviewSnapshotMutation, UpdateTalentReviewSnapshotMutationVariables>;

/**
 * __useUpdateTalentReviewSnapshotMutation__
 *
 * To run a mutation, you first call `useUpdateTalentReviewSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTalentReviewSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTalentReviewSnapshotMutation, { data, loading, error }] = useUpdateTalentReviewSnapshotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTalentReviewSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTalentReviewSnapshotMutation, UpdateTalentReviewSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTalentReviewSnapshotMutation, UpdateTalentReviewSnapshotMutationVariables>(UpdateTalentReviewSnapshotDocument, options);
      }
export type UpdateTalentReviewSnapshotMutationHookResult = ReturnType<typeof useUpdateTalentReviewSnapshotMutation>;
export type UpdateTalentReviewSnapshotMutationResult = Apollo.MutationResult<UpdateTalentReviewSnapshotMutation>;
export type UpdateTalentReviewSnapshotMutationOptions = Apollo.BaseMutationOptions<UpdateTalentReviewSnapshotMutation, UpdateTalentReviewSnapshotMutationVariables>;
export const MomentForTalentReviewDocument = gql`
    query MomentForTalentReview($id: ID!) {
  momentInstance(id: $id) {
    ...TalentReviewCycleMoment
  }
}
    ${TalentReviewCycleMomentFragmentDoc}`;

/**
 * __useMomentForTalentReviewQuery__
 *
 * To run a query within a React component, call `useMomentForTalentReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMomentForTalentReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMomentForTalentReviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMomentForTalentReviewQuery(baseOptions: Apollo.QueryHookOptions<MomentForTalentReviewQuery, MomentForTalentReviewQueryVariables> & ({ variables: MomentForTalentReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MomentForTalentReviewQuery, MomentForTalentReviewQueryVariables>(MomentForTalentReviewDocument, options);
      }
export function useMomentForTalentReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MomentForTalentReviewQuery, MomentForTalentReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MomentForTalentReviewQuery, MomentForTalentReviewQueryVariables>(MomentForTalentReviewDocument, options);
        }
// @ts-ignore
export function useMomentForTalentReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MomentForTalentReviewQuery, MomentForTalentReviewQueryVariables>): Apollo.UseSuspenseQueryResult<MomentForTalentReviewQuery, MomentForTalentReviewQueryVariables>;
export function useMomentForTalentReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MomentForTalentReviewQuery, MomentForTalentReviewQueryVariables>): Apollo.UseSuspenseQueryResult<MomentForTalentReviewQuery | undefined, MomentForTalentReviewQueryVariables>;
export function useMomentForTalentReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MomentForTalentReviewQuery, MomentForTalentReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MomentForTalentReviewQuery, MomentForTalentReviewQueryVariables>(MomentForTalentReviewDocument, options);
        }
export type MomentForTalentReviewQueryHookResult = ReturnType<typeof useMomentForTalentReviewQuery>;
export type MomentForTalentReviewLazyQueryHookResult = ReturnType<typeof useMomentForTalentReviewLazyQuery>;
export type MomentForTalentReviewSuspenseQueryHookResult = ReturnType<typeof useMomentForTalentReviewSuspenseQuery>;
export type MomentForTalentReviewQueryResult = Apollo.QueryResult<MomentForTalentReviewQuery, MomentForTalentReviewQueryVariables>;
export const TalentReviewCycleMomentDocument = gql`
    query TalentReviewCycleMoment($groupID: ID!) {
  group(id: $groupID) {
    id
    talentReviewCycleMoment {
      ...TalentReviewCycleMoment
    }
  }
}
    ${TalentReviewCycleMomentFragmentDoc}`;

/**
 * __useTalentReviewCycleMomentQuery__
 *
 * To run a query within a React component, call `useTalentReviewCycleMomentQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentReviewCycleMomentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentReviewCycleMomentQuery({
 *   variables: {
 *      groupID: // value for 'groupID'
 *   },
 * });
 */
export function useTalentReviewCycleMomentQuery(baseOptions: Apollo.QueryHookOptions<TalentReviewCycleMomentQuery, TalentReviewCycleMomentQueryVariables> & ({ variables: TalentReviewCycleMomentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentReviewCycleMomentQuery, TalentReviewCycleMomentQueryVariables>(TalentReviewCycleMomentDocument, options);
      }
export function useTalentReviewCycleMomentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentReviewCycleMomentQuery, TalentReviewCycleMomentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentReviewCycleMomentQuery, TalentReviewCycleMomentQueryVariables>(TalentReviewCycleMomentDocument, options);
        }
// @ts-ignore
export function useTalentReviewCycleMomentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentReviewCycleMomentQuery, TalentReviewCycleMomentQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewCycleMomentQuery, TalentReviewCycleMomentQueryVariables>;
export function useTalentReviewCycleMomentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewCycleMomentQuery, TalentReviewCycleMomentQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewCycleMomentQuery | undefined, TalentReviewCycleMomentQueryVariables>;
export function useTalentReviewCycleMomentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewCycleMomentQuery, TalentReviewCycleMomentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentReviewCycleMomentQuery, TalentReviewCycleMomentQueryVariables>(TalentReviewCycleMomentDocument, options);
        }
export type TalentReviewCycleMomentQueryHookResult = ReturnType<typeof useTalentReviewCycleMomentQuery>;
export type TalentReviewCycleMomentLazyQueryHookResult = ReturnType<typeof useTalentReviewCycleMomentLazyQuery>;
export type TalentReviewCycleMomentSuspenseQueryHookResult = ReturnType<typeof useTalentReviewCycleMomentSuspenseQuery>;
export type TalentReviewCycleMomentQueryResult = Apollo.QueryResult<TalentReviewCycleMomentQuery, TalentReviewCycleMomentQueryVariables>;
export const TalentReviewGridDocument = gql`
    query TalentReviewGrid($templateID: ID!, $groupID: ID!, $localDate: LocalDate!) {
  talentReviewGrid(
    templateID: $templateID
    groupID: $groupID
    localDate: $localDate
  ) {
    ...TalentReviewGrid
  }
}
    ${TalentReviewGridFragmentDoc}`;

/**
 * __useTalentReviewGridQuery__
 *
 * To run a query within a React component, call `useTalentReviewGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentReviewGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentReviewGridQuery({
 *   variables: {
 *      templateID: // value for 'templateID'
 *      groupID: // value for 'groupID'
 *      localDate: // value for 'localDate'
 *   },
 * });
 */
export function useTalentReviewGridQuery(baseOptions: Apollo.QueryHookOptions<TalentReviewGridQuery, TalentReviewGridQueryVariables> & ({ variables: TalentReviewGridQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentReviewGridQuery, TalentReviewGridQueryVariables>(TalentReviewGridDocument, options);
      }
export function useTalentReviewGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentReviewGridQuery, TalentReviewGridQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentReviewGridQuery, TalentReviewGridQueryVariables>(TalentReviewGridDocument, options);
        }
// @ts-ignore
export function useTalentReviewGridSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentReviewGridQuery, TalentReviewGridQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewGridQuery, TalentReviewGridQueryVariables>;
export function useTalentReviewGridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewGridQuery, TalentReviewGridQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewGridQuery | undefined, TalentReviewGridQueryVariables>;
export function useTalentReviewGridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewGridQuery, TalentReviewGridQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentReviewGridQuery, TalentReviewGridQueryVariables>(TalentReviewGridDocument, options);
        }
export type TalentReviewGridQueryHookResult = ReturnType<typeof useTalentReviewGridQuery>;
export type TalentReviewGridLazyQueryHookResult = ReturnType<typeof useTalentReviewGridLazyQuery>;
export type TalentReviewGridSuspenseQueryHookResult = ReturnType<typeof useTalentReviewGridSuspenseQuery>;
export type TalentReviewGridQueryResult = Apollo.QueryResult<TalentReviewGridQuery, TalentReviewGridQueryVariables>;
export const TalentReviewGroupsDocument = gql`
    query TalentReviewGroups($first: Int, $after: ID, $filter: GroupsFilter) {
  groups(first: $first, after: $after, filter: $filter) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        type
        name
        viewerCanViewTalentReviews
        members(first: 9) {
          totalCount
          edges {
            node {
              id
              firstName
              lastName
              avatar {
                source {
                  url
                }
              }
            }
          }
        }
        talentReviewLatestActivity {
          updatedAt
          updatedBy {
            id
            firstName
            lastName
          }
          template {
            id
            title
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTalentReviewGroupsQuery__
 *
 * To run a query within a React component, call `useTalentReviewGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentReviewGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentReviewGroupsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTalentReviewGroupsQuery(baseOptions?: Apollo.QueryHookOptions<TalentReviewGroupsQuery, TalentReviewGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentReviewGroupsQuery, TalentReviewGroupsQueryVariables>(TalentReviewGroupsDocument, options);
      }
export function useTalentReviewGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentReviewGroupsQuery, TalentReviewGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentReviewGroupsQuery, TalentReviewGroupsQueryVariables>(TalentReviewGroupsDocument, options);
        }
// @ts-ignore
export function useTalentReviewGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentReviewGroupsQuery, TalentReviewGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewGroupsQuery, TalentReviewGroupsQueryVariables>;
export function useTalentReviewGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewGroupsQuery, TalentReviewGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewGroupsQuery | undefined, TalentReviewGroupsQueryVariables>;
export function useTalentReviewGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewGroupsQuery, TalentReviewGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentReviewGroupsQuery, TalentReviewGroupsQueryVariables>(TalentReviewGroupsDocument, options);
        }
export type TalentReviewGroupsQueryHookResult = ReturnType<typeof useTalentReviewGroupsQuery>;
export type TalentReviewGroupsLazyQueryHookResult = ReturnType<typeof useTalentReviewGroupsLazyQuery>;
export type TalentReviewGroupsSuspenseQueryHookResult = ReturnType<typeof useTalentReviewGroupsSuspenseQuery>;
export type TalentReviewGroupsQueryResult = Apollo.QueryResult<TalentReviewGroupsQuery, TalentReviewGroupsQueryVariables>;
export const TalentReviewIndexMomentsDocument = gql`
    query TalentReviewIndexMoments($userID: ID!) {
  user(id: $userID) {
    id
    moments(type: TALENT_REVIEW) {
      id
      status
      endDate
      momentTemplate {
        id
        type
        title
        talentReview {
          group {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTalentReviewIndexMomentsQuery__
 *
 * To run a query within a React component, call `useTalentReviewIndexMomentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentReviewIndexMomentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentReviewIndexMomentsQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useTalentReviewIndexMomentsQuery(baseOptions: Apollo.QueryHookOptions<TalentReviewIndexMomentsQuery, TalentReviewIndexMomentsQueryVariables> & ({ variables: TalentReviewIndexMomentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentReviewIndexMomentsQuery, TalentReviewIndexMomentsQueryVariables>(TalentReviewIndexMomentsDocument, options);
      }
export function useTalentReviewIndexMomentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentReviewIndexMomentsQuery, TalentReviewIndexMomentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentReviewIndexMomentsQuery, TalentReviewIndexMomentsQueryVariables>(TalentReviewIndexMomentsDocument, options);
        }
// @ts-ignore
export function useTalentReviewIndexMomentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentReviewIndexMomentsQuery, TalentReviewIndexMomentsQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewIndexMomentsQuery, TalentReviewIndexMomentsQueryVariables>;
export function useTalentReviewIndexMomentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewIndexMomentsQuery, TalentReviewIndexMomentsQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewIndexMomentsQuery | undefined, TalentReviewIndexMomentsQueryVariables>;
export function useTalentReviewIndexMomentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewIndexMomentsQuery, TalentReviewIndexMomentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentReviewIndexMomentsQuery, TalentReviewIndexMomentsQueryVariables>(TalentReviewIndexMomentsDocument, options);
        }
export type TalentReviewIndexMomentsQueryHookResult = ReturnType<typeof useTalentReviewIndexMomentsQuery>;
export type TalentReviewIndexMomentsLazyQueryHookResult = ReturnType<typeof useTalentReviewIndexMomentsLazyQuery>;
export type TalentReviewIndexMomentsSuspenseQueryHookResult = ReturnType<typeof useTalentReviewIndexMomentsSuspenseQuery>;
export type TalentReviewIndexMomentsQueryResult = Apollo.QueryResult<TalentReviewIndexMomentsQuery, TalentReviewIndexMomentsQueryVariables>;
export const TalentReviewLatestGridDocument = gql`
    query TalentReviewLatestGrid($groupID: ID!) {
  talentReviewLatestGrid(groupID: $groupID) {
    template {
      id
    }
  }
}
    `;

/**
 * __useTalentReviewLatestGridQuery__
 *
 * To run a query within a React component, call `useTalentReviewLatestGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentReviewLatestGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentReviewLatestGridQuery({
 *   variables: {
 *      groupID: // value for 'groupID'
 *   },
 * });
 */
export function useTalentReviewLatestGridQuery(baseOptions: Apollo.QueryHookOptions<TalentReviewLatestGridQuery, TalentReviewLatestGridQueryVariables> & ({ variables: TalentReviewLatestGridQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentReviewLatestGridQuery, TalentReviewLatestGridQueryVariables>(TalentReviewLatestGridDocument, options);
      }
export function useTalentReviewLatestGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentReviewLatestGridQuery, TalentReviewLatestGridQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentReviewLatestGridQuery, TalentReviewLatestGridQueryVariables>(TalentReviewLatestGridDocument, options);
        }
// @ts-ignore
export function useTalentReviewLatestGridSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentReviewLatestGridQuery, TalentReviewLatestGridQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewLatestGridQuery, TalentReviewLatestGridQueryVariables>;
export function useTalentReviewLatestGridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewLatestGridQuery, TalentReviewLatestGridQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewLatestGridQuery | undefined, TalentReviewLatestGridQueryVariables>;
export function useTalentReviewLatestGridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewLatestGridQuery, TalentReviewLatestGridQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentReviewLatestGridQuery, TalentReviewLatestGridQueryVariables>(TalentReviewLatestGridDocument, options);
        }
export type TalentReviewLatestGridQueryHookResult = ReturnType<typeof useTalentReviewLatestGridQuery>;
export type TalentReviewLatestGridLazyQueryHookResult = ReturnType<typeof useTalentReviewLatestGridLazyQuery>;
export type TalentReviewLatestGridSuspenseQueryHookResult = ReturnType<typeof useTalentReviewLatestGridSuspenseQuery>;
export type TalentReviewLatestGridQueryResult = Apollo.QueryResult<TalentReviewLatestGridQuery, TalentReviewLatestGridQueryVariables>;
export const TalentReviewReshareRecipientsDocument = gql`
    query TalentReviewReshareRecipients($id: ID!, $templateID: ID!, $localDate: LocalDate!) {
  momentInstance(id: $id) {
    id
    talentReviewReshareRecipients(templateID: $templateID, localDate: $localDate) {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useTalentReviewReshareRecipientsQuery__
 *
 * To run a query within a React component, call `useTalentReviewReshareRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentReviewReshareRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentReviewReshareRecipientsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      templateID: // value for 'templateID'
 *      localDate: // value for 'localDate'
 *   },
 * });
 */
export function useTalentReviewReshareRecipientsQuery(baseOptions: Apollo.QueryHookOptions<TalentReviewReshareRecipientsQuery, TalentReviewReshareRecipientsQueryVariables> & ({ variables: TalentReviewReshareRecipientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentReviewReshareRecipientsQuery, TalentReviewReshareRecipientsQueryVariables>(TalentReviewReshareRecipientsDocument, options);
      }
export function useTalentReviewReshareRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentReviewReshareRecipientsQuery, TalentReviewReshareRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentReviewReshareRecipientsQuery, TalentReviewReshareRecipientsQueryVariables>(TalentReviewReshareRecipientsDocument, options);
        }
// @ts-ignore
export function useTalentReviewReshareRecipientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentReviewReshareRecipientsQuery, TalentReviewReshareRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewReshareRecipientsQuery, TalentReviewReshareRecipientsQueryVariables>;
export function useTalentReviewReshareRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewReshareRecipientsQuery, TalentReviewReshareRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewReshareRecipientsQuery | undefined, TalentReviewReshareRecipientsQueryVariables>;
export function useTalentReviewReshareRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewReshareRecipientsQuery, TalentReviewReshareRecipientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentReviewReshareRecipientsQuery, TalentReviewReshareRecipientsQueryVariables>(TalentReviewReshareRecipientsDocument, options);
        }
export type TalentReviewReshareRecipientsQueryHookResult = ReturnType<typeof useTalentReviewReshareRecipientsQuery>;
export type TalentReviewReshareRecipientsLazyQueryHookResult = ReturnType<typeof useTalentReviewReshareRecipientsLazyQuery>;
export type TalentReviewReshareRecipientsSuspenseQueryHookResult = ReturnType<typeof useTalentReviewReshareRecipientsSuspenseQuery>;
export type TalentReviewReshareRecipientsQueryResult = Apollo.QueryResult<TalentReviewReshareRecipientsQuery, TalentReviewReshareRecipientsQueryVariables>;
export const TalentReviewSharedSnapshotsDocument = gql`
    query TalentReviewSharedSnapshots($id: ID!) {
  group(id: $id) {
    id
    talentReviewSnapshots(isArchived: false, first: 1000) {
      edges {
        node {
          id
          localDate
          createdAt
          visibility
          viewerIsPlaced
          template {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTalentReviewSharedSnapshotsQuery__
 *
 * To run a query within a React component, call `useTalentReviewSharedSnapshotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentReviewSharedSnapshotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentReviewSharedSnapshotsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTalentReviewSharedSnapshotsQuery(baseOptions: Apollo.QueryHookOptions<TalentReviewSharedSnapshotsQuery, TalentReviewSharedSnapshotsQueryVariables> & ({ variables: TalentReviewSharedSnapshotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentReviewSharedSnapshotsQuery, TalentReviewSharedSnapshotsQueryVariables>(TalentReviewSharedSnapshotsDocument, options);
      }
export function useTalentReviewSharedSnapshotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentReviewSharedSnapshotsQuery, TalentReviewSharedSnapshotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentReviewSharedSnapshotsQuery, TalentReviewSharedSnapshotsQueryVariables>(TalentReviewSharedSnapshotsDocument, options);
        }
// @ts-ignore
export function useTalentReviewSharedSnapshotsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentReviewSharedSnapshotsQuery, TalentReviewSharedSnapshotsQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewSharedSnapshotsQuery, TalentReviewSharedSnapshotsQueryVariables>;
export function useTalentReviewSharedSnapshotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewSharedSnapshotsQuery, TalentReviewSharedSnapshotsQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewSharedSnapshotsQuery | undefined, TalentReviewSharedSnapshotsQueryVariables>;
export function useTalentReviewSharedSnapshotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewSharedSnapshotsQuery, TalentReviewSharedSnapshotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentReviewSharedSnapshotsQuery, TalentReviewSharedSnapshotsQueryVariables>(TalentReviewSharedSnapshotsDocument, options);
        }
export type TalentReviewSharedSnapshotsQueryHookResult = ReturnType<typeof useTalentReviewSharedSnapshotsQuery>;
export type TalentReviewSharedSnapshotsLazyQueryHookResult = ReturnType<typeof useTalentReviewSharedSnapshotsLazyQuery>;
export type TalentReviewSharedSnapshotsSuspenseQueryHookResult = ReturnType<typeof useTalentReviewSharedSnapshotsSuspenseQuery>;
export type TalentReviewSharedSnapshotsQueryResult = Apollo.QueryResult<TalentReviewSharedSnapshotsQuery, TalentReviewSharedSnapshotsQueryVariables>;
export const TalentReviewSnapshotDocument = gql`
    query TalentReviewSnapshot($id: ID!, $manage: Boolean = false) {
  talentReviewSnapshot(id: $id) {
    ...TalentReviewSnapshotGrid
  }
}
    ${TalentReviewSnapshotGridFragmentDoc}`;

/**
 * __useTalentReviewSnapshotQuery__
 *
 * To run a query within a React component, call `useTalentReviewSnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentReviewSnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentReviewSnapshotQuery({
 *   variables: {
 *      id: // value for 'id'
 *      manage: // value for 'manage'
 *   },
 * });
 */
export function useTalentReviewSnapshotQuery(baseOptions: Apollo.QueryHookOptions<TalentReviewSnapshotQuery, TalentReviewSnapshotQueryVariables> & ({ variables: TalentReviewSnapshotQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentReviewSnapshotQuery, TalentReviewSnapshotQueryVariables>(TalentReviewSnapshotDocument, options);
      }
export function useTalentReviewSnapshotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentReviewSnapshotQuery, TalentReviewSnapshotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentReviewSnapshotQuery, TalentReviewSnapshotQueryVariables>(TalentReviewSnapshotDocument, options);
        }
// @ts-ignore
export function useTalentReviewSnapshotSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentReviewSnapshotQuery, TalentReviewSnapshotQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewSnapshotQuery, TalentReviewSnapshotQueryVariables>;
export function useTalentReviewSnapshotSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewSnapshotQuery, TalentReviewSnapshotQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewSnapshotQuery | undefined, TalentReviewSnapshotQueryVariables>;
export function useTalentReviewSnapshotSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewSnapshotQuery, TalentReviewSnapshotQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentReviewSnapshotQuery, TalentReviewSnapshotQueryVariables>(TalentReviewSnapshotDocument, options);
        }
export type TalentReviewSnapshotQueryHookResult = ReturnType<typeof useTalentReviewSnapshotQuery>;
export type TalentReviewSnapshotLazyQueryHookResult = ReturnType<typeof useTalentReviewSnapshotLazyQuery>;
export type TalentReviewSnapshotSuspenseQueryHookResult = ReturnType<typeof useTalentReviewSnapshotSuspenseQuery>;
export type TalentReviewSnapshotQueryResult = Apollo.QueryResult<TalentReviewSnapshotQuery, TalentReviewSnapshotQueryVariables>;
export const TalentReviewSnapshotsDocument = gql`
    query TalentReviewSnapshots($id: ID!, $isArchived: Boolean!) {
  group(id: $id) {
    id
    name
    talentReviewSnapshots(isArchived: $isArchived, first: 1000) {
      edges {
        node {
          ...TalentReviewSnapshot
        }
      }
    }
  }
}
    ${TalentReviewSnapshotFragmentDoc}`;

/**
 * __useTalentReviewSnapshotsQuery__
 *
 * To run a query within a React component, call `useTalentReviewSnapshotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentReviewSnapshotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentReviewSnapshotsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useTalentReviewSnapshotsQuery(baseOptions: Apollo.QueryHookOptions<TalentReviewSnapshotsQuery, TalentReviewSnapshotsQueryVariables> & ({ variables: TalentReviewSnapshotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentReviewSnapshotsQuery, TalentReviewSnapshotsQueryVariables>(TalentReviewSnapshotsDocument, options);
      }
export function useTalentReviewSnapshotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentReviewSnapshotsQuery, TalentReviewSnapshotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentReviewSnapshotsQuery, TalentReviewSnapshotsQueryVariables>(TalentReviewSnapshotsDocument, options);
        }
// @ts-ignore
export function useTalentReviewSnapshotsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentReviewSnapshotsQuery, TalentReviewSnapshotsQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewSnapshotsQuery, TalentReviewSnapshotsQueryVariables>;
export function useTalentReviewSnapshotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewSnapshotsQuery, TalentReviewSnapshotsQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewSnapshotsQuery | undefined, TalentReviewSnapshotsQueryVariables>;
export function useTalentReviewSnapshotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewSnapshotsQuery, TalentReviewSnapshotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentReviewSnapshotsQuery, TalentReviewSnapshotsQueryVariables>(TalentReviewSnapshotsDocument, options);
        }
export type TalentReviewSnapshotsQueryHookResult = ReturnType<typeof useTalentReviewSnapshotsQuery>;
export type TalentReviewSnapshotsLazyQueryHookResult = ReturnType<typeof useTalentReviewSnapshotsLazyQuery>;
export type TalentReviewSnapshotsSuspenseQueryHookResult = ReturnType<typeof useTalentReviewSnapshotsSuspenseQuery>;
export type TalentReviewSnapshotsQueryResult = Apollo.QueryResult<TalentReviewSnapshotsQuery, TalentReviewSnapshotsQueryVariables>;
export const TalentReviewUsedTemplatesDocument = gql`
    query TalentReviewUsedTemplates($groupID: ID!) {
  talentReviewUsedTemplates(groupID: $groupID) {
    id
    title
  }
}
    `;

/**
 * __useTalentReviewUsedTemplatesQuery__
 *
 * To run a query within a React component, call `useTalentReviewUsedTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentReviewUsedTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentReviewUsedTemplatesQuery({
 *   variables: {
 *      groupID: // value for 'groupID'
 *   },
 * });
 */
export function useTalentReviewUsedTemplatesQuery(baseOptions: Apollo.QueryHookOptions<TalentReviewUsedTemplatesQuery, TalentReviewUsedTemplatesQueryVariables> & ({ variables: TalentReviewUsedTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentReviewUsedTemplatesQuery, TalentReviewUsedTemplatesQueryVariables>(TalentReviewUsedTemplatesDocument, options);
      }
export function useTalentReviewUsedTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentReviewUsedTemplatesQuery, TalentReviewUsedTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentReviewUsedTemplatesQuery, TalentReviewUsedTemplatesQueryVariables>(TalentReviewUsedTemplatesDocument, options);
        }
// @ts-ignore
export function useTalentReviewUsedTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TalentReviewUsedTemplatesQuery, TalentReviewUsedTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewUsedTemplatesQuery, TalentReviewUsedTemplatesQueryVariables>;
export function useTalentReviewUsedTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewUsedTemplatesQuery, TalentReviewUsedTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<TalentReviewUsedTemplatesQuery | undefined, TalentReviewUsedTemplatesQueryVariables>;
export function useTalentReviewUsedTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalentReviewUsedTemplatesQuery, TalentReviewUsedTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalentReviewUsedTemplatesQuery, TalentReviewUsedTemplatesQueryVariables>(TalentReviewUsedTemplatesDocument, options);
        }
export type TalentReviewUsedTemplatesQueryHookResult = ReturnType<typeof useTalentReviewUsedTemplatesQuery>;
export type TalentReviewUsedTemplatesLazyQueryHookResult = ReturnType<typeof useTalentReviewUsedTemplatesLazyQuery>;
export type TalentReviewUsedTemplatesSuspenseQueryHookResult = ReturnType<typeof useTalentReviewUsedTemplatesSuspenseQuery>;
export type TalentReviewUsedTemplatesQueryResult = Apollo.QueryResult<TalentReviewUsedTemplatesQuery, TalentReviewUsedTemplatesQueryVariables>;
export const AppendTranscriptionDocument = gql`
    mutation AppendTranscription($input: AppendTranscriptionInput!) {
  appendTranscription(input: $input) {
    transcription {
      id
      status
      transcript
    }
    applied
  }
}
    `;
export type AppendTranscriptionMutationFn = Apollo.MutationFunction<AppendTranscriptionMutation, AppendTranscriptionMutationVariables>;

/**
 * __useAppendTranscriptionMutation__
 *
 * To run a mutation, you first call `useAppendTranscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppendTranscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendTranscriptionMutation, { data, loading, error }] = useAppendTranscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppendTranscriptionMutation(baseOptions?: Apollo.MutationHookOptions<AppendTranscriptionMutation, AppendTranscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppendTranscriptionMutation, AppendTranscriptionMutationVariables>(AppendTranscriptionDocument, options);
      }
export type AppendTranscriptionMutationHookResult = ReturnType<typeof useAppendTranscriptionMutation>;
export type AppendTranscriptionMutationResult = Apollo.MutationResult<AppendTranscriptionMutation>;
export type AppendTranscriptionMutationOptions = Apollo.BaseMutationOptions<AppendTranscriptionMutation, AppendTranscriptionMutationVariables>;
export const CreateTranscriptionDocument = gql`
    mutation CreateTranscription($input: CreateTranscriptionInput!) {
  createTranscription(input: $input) {
    transcription {
      id
      status
    }
    uploadURL
    uploadHeaders {
      name
      values
    }
  }
}
    `;
export type CreateTranscriptionMutationFn = Apollo.MutationFunction<CreateTranscriptionMutation, CreateTranscriptionMutationVariables>;

/**
 * __useCreateTranscriptionMutation__
 *
 * To run a mutation, you first call `useCreateTranscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTranscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTranscriptionMutation, { data, loading, error }] = useCreateTranscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTranscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTranscriptionMutation, CreateTranscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTranscriptionMutation, CreateTranscriptionMutationVariables>(CreateTranscriptionDocument, options);
      }
export type CreateTranscriptionMutationHookResult = ReturnType<typeof useCreateTranscriptionMutation>;
export type CreateTranscriptionMutationResult = Apollo.MutationResult<CreateTranscriptionMutation>;
export type CreateTranscriptionMutationOptions = Apollo.BaseMutationOptions<CreateTranscriptionMutation, CreateTranscriptionMutationVariables>;
export const FinalizeTranscriptionUploadDocument = gql`
    mutation FinalizeTranscriptionUpload($input: FinalizeTranscriptionUploadInput!) {
  finalizeTranscriptionUpload(input: $input) {
    transcriptionID
  }
}
    `;
export type FinalizeTranscriptionUploadMutationFn = Apollo.MutationFunction<FinalizeTranscriptionUploadMutation, FinalizeTranscriptionUploadMutationVariables>;

/**
 * __useFinalizeTranscriptionUploadMutation__
 *
 * To run a mutation, you first call `useFinalizeTranscriptionUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeTranscriptionUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeTranscriptionUploadMutation, { data, loading, error }] = useFinalizeTranscriptionUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinalizeTranscriptionUploadMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeTranscriptionUploadMutation, FinalizeTranscriptionUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeTranscriptionUploadMutation, FinalizeTranscriptionUploadMutationVariables>(FinalizeTranscriptionUploadDocument, options);
      }
export type FinalizeTranscriptionUploadMutationHookResult = ReturnType<typeof useFinalizeTranscriptionUploadMutation>;
export type FinalizeTranscriptionUploadMutationResult = Apollo.MutationResult<FinalizeTranscriptionUploadMutation>;
export type FinalizeTranscriptionUploadMutationOptions = Apollo.BaseMutationOptions<FinalizeTranscriptionUploadMutation, FinalizeTranscriptionUploadMutationVariables>;
export const LinkTranscriptionToEvaluationSubmissionDocument = gql`
    mutation LinkTranscriptionToEvaluationSubmission($input: LinkTranscriptionToEvaluationSubmissionInput!) {
  linkTranscriptionToEvaluationSubmission(input: $input) {
    evaluationSubmission {
      id
      transcription {
        id
        status
        uploadStatus
        transcript
        summary
        editableSummary
        audioUrl
        speakers {
          speakerNumber
          segmentIndex
          user {
            id
            firstName
            lastName
          }
        }
        createdAt
      }
    }
  }
}
    `;
export type LinkTranscriptionToEvaluationSubmissionMutationFn = Apollo.MutationFunction<LinkTranscriptionToEvaluationSubmissionMutation, LinkTranscriptionToEvaluationSubmissionMutationVariables>;

/**
 * __useLinkTranscriptionToEvaluationSubmissionMutation__
 *
 * To run a mutation, you first call `useLinkTranscriptionToEvaluationSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkTranscriptionToEvaluationSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkTranscriptionToEvaluationSubmissionMutation, { data, loading, error }] = useLinkTranscriptionToEvaluationSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkTranscriptionToEvaluationSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<LinkTranscriptionToEvaluationSubmissionMutation, LinkTranscriptionToEvaluationSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkTranscriptionToEvaluationSubmissionMutation, LinkTranscriptionToEvaluationSubmissionMutationVariables>(LinkTranscriptionToEvaluationSubmissionDocument, options);
      }
export type LinkTranscriptionToEvaluationSubmissionMutationHookResult = ReturnType<typeof useLinkTranscriptionToEvaluationSubmissionMutation>;
export type LinkTranscriptionToEvaluationSubmissionMutationResult = Apollo.MutationResult<LinkTranscriptionToEvaluationSubmissionMutation>;
export type LinkTranscriptionToEvaluationSubmissionMutationOptions = Apollo.BaseMutationOptions<LinkTranscriptionToEvaluationSubmissionMutation, LinkTranscriptionToEvaluationSubmissionMutationVariables>;
export const MarkTranscriptionFollowupActedUponDocument = gql`
    mutation MarkTranscriptionFollowupActedUpon($input: MarkTranscriptionFollowupActedUponInput!) {
  markTranscriptionFollowupActedUpon(input: $input) {
    id
    followups {
      ...TranscriptionFollowups
    }
  }
}
    ${TranscriptionFollowupsFragmentDoc}`;
export type MarkTranscriptionFollowupActedUponMutationFn = Apollo.MutationFunction<MarkTranscriptionFollowupActedUponMutation, MarkTranscriptionFollowupActedUponMutationVariables>;

/**
 * __useMarkTranscriptionFollowupActedUponMutation__
 *
 * To run a mutation, you first call `useMarkTranscriptionFollowupActedUponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkTranscriptionFollowupActedUponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markTranscriptionFollowupActedUponMutation, { data, loading, error }] = useMarkTranscriptionFollowupActedUponMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkTranscriptionFollowupActedUponMutation(baseOptions?: Apollo.MutationHookOptions<MarkTranscriptionFollowupActedUponMutation, MarkTranscriptionFollowupActedUponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkTranscriptionFollowupActedUponMutation, MarkTranscriptionFollowupActedUponMutationVariables>(MarkTranscriptionFollowupActedUponDocument, options);
      }
export type MarkTranscriptionFollowupActedUponMutationHookResult = ReturnType<typeof useMarkTranscriptionFollowupActedUponMutation>;
export type MarkTranscriptionFollowupActedUponMutationResult = Apollo.MutationResult<MarkTranscriptionFollowupActedUponMutation>;
export type MarkTranscriptionFollowupActedUponMutationOptions = Apollo.BaseMutationOptions<MarkTranscriptionFollowupActedUponMutation, MarkTranscriptionFollowupActedUponMutationVariables>;
export const MarkTranscriptionUploadAsFailedDocument = gql`
    mutation MarkTranscriptionUploadAsFailed($input: MarkTranscriptionUploadAsFailedInput!) {
  markTranscriptionUploadAsFailed(input: $input) {
    transcriptionID
  }
}
    `;
export type MarkTranscriptionUploadAsFailedMutationFn = Apollo.MutationFunction<MarkTranscriptionUploadAsFailedMutation, MarkTranscriptionUploadAsFailedMutationVariables>;

/**
 * __useMarkTranscriptionUploadAsFailedMutation__
 *
 * To run a mutation, you first call `useMarkTranscriptionUploadAsFailedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkTranscriptionUploadAsFailedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markTranscriptionUploadAsFailedMutation, { data, loading, error }] = useMarkTranscriptionUploadAsFailedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkTranscriptionUploadAsFailedMutation(baseOptions?: Apollo.MutationHookOptions<MarkTranscriptionUploadAsFailedMutation, MarkTranscriptionUploadAsFailedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkTranscriptionUploadAsFailedMutation, MarkTranscriptionUploadAsFailedMutationVariables>(MarkTranscriptionUploadAsFailedDocument, options);
      }
export type MarkTranscriptionUploadAsFailedMutationHookResult = ReturnType<typeof useMarkTranscriptionUploadAsFailedMutation>;
export type MarkTranscriptionUploadAsFailedMutationResult = Apollo.MutationResult<MarkTranscriptionUploadAsFailedMutation>;
export type MarkTranscriptionUploadAsFailedMutationOptions = Apollo.BaseMutationOptions<MarkTranscriptionUploadAsFailedMutation, MarkTranscriptionUploadAsFailedMutationVariables>;
export const PrepareTranscriptionUploadRetryDocument = gql`
    mutation PrepareTranscriptionUploadRetry($input: PrepareTranscriptionUploadRetryInput!) {
  prepareTranscriptionUploadRetry(input: $input) {
    transcriptionID
    uploadURL
    uploadHeaders {
      name
      values
    }
  }
}
    `;
export type PrepareTranscriptionUploadRetryMutationFn = Apollo.MutationFunction<PrepareTranscriptionUploadRetryMutation, PrepareTranscriptionUploadRetryMutationVariables>;

/**
 * __usePrepareTranscriptionUploadRetryMutation__
 *
 * To run a mutation, you first call `usePrepareTranscriptionUploadRetryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepareTranscriptionUploadRetryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepareTranscriptionUploadRetryMutation, { data, loading, error }] = usePrepareTranscriptionUploadRetryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrepareTranscriptionUploadRetryMutation(baseOptions?: Apollo.MutationHookOptions<PrepareTranscriptionUploadRetryMutation, PrepareTranscriptionUploadRetryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrepareTranscriptionUploadRetryMutation, PrepareTranscriptionUploadRetryMutationVariables>(PrepareTranscriptionUploadRetryDocument, options);
      }
export type PrepareTranscriptionUploadRetryMutationHookResult = ReturnType<typeof usePrepareTranscriptionUploadRetryMutation>;
export type PrepareTranscriptionUploadRetryMutationResult = Apollo.MutationResult<PrepareTranscriptionUploadRetryMutation>;
export type PrepareTranscriptionUploadRetryMutationOptions = Apollo.BaseMutationOptions<PrepareTranscriptionUploadRetryMutation, PrepareTranscriptionUploadRetryMutationVariables>;
export const RegenerateTranscriptionSummaryDocument = gql`
    mutation RegenerateTranscriptionSummary($input: RegenerateTranscriptionSummaryInput!) {
  regenerateTranscriptionSummary(input: $input) {
    transcription {
      id
      status
      summary
      editableSummary
      speakers {
        speakerNumber
        segmentIndex
        user {
          id
          firstName
          lastName
        }
      }
      followups {
        ...TranscriptionFollowups
      }
    }
  }
}
    ${TranscriptionFollowupsFragmentDoc}`;
export type RegenerateTranscriptionSummaryMutationFn = Apollo.MutationFunction<RegenerateTranscriptionSummaryMutation, RegenerateTranscriptionSummaryMutationVariables>;

/**
 * __useRegenerateTranscriptionSummaryMutation__
 *
 * To run a mutation, you first call `useRegenerateTranscriptionSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateTranscriptionSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateTranscriptionSummaryMutation, { data, loading, error }] = useRegenerateTranscriptionSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegenerateTranscriptionSummaryMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateTranscriptionSummaryMutation, RegenerateTranscriptionSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateTranscriptionSummaryMutation, RegenerateTranscriptionSummaryMutationVariables>(RegenerateTranscriptionSummaryDocument, options);
      }
export type RegenerateTranscriptionSummaryMutationHookResult = ReturnType<typeof useRegenerateTranscriptionSummaryMutation>;
export type RegenerateTranscriptionSummaryMutationResult = Apollo.MutationResult<RegenerateTranscriptionSummaryMutation>;
export type RegenerateTranscriptionSummaryMutationOptions = Apollo.BaseMutationOptions<RegenerateTranscriptionSummaryMutation, RegenerateTranscriptionSummaryMutationVariables>;
export const StartStreamingTranscriptionDocument = gql`
    mutation StartStreamingTranscription($input: StartStreamingTranscriptionInput!) {
  startStreamingTranscription(input: $input) {
    transcription {
      id
      status
      uploadStatus
      transcript
      summary
      editableSummary
      audioUrl
      speakers {
        speakerNumber
        segmentIndex
        user {
          id
          firstName
          lastName
        }
      }
      followups {
        ...TranscriptionFollowups
      }
    }
    token
    transcriptLength
    prompt
    keyterms
  }
}
    ${TranscriptionFollowupsFragmentDoc}`;
export type StartStreamingTranscriptionMutationFn = Apollo.MutationFunction<StartStreamingTranscriptionMutation, StartStreamingTranscriptionMutationVariables>;

/**
 * __useStartStreamingTranscriptionMutation__
 *
 * To run a mutation, you first call `useStartStreamingTranscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartStreamingTranscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startStreamingTranscriptionMutation, { data, loading, error }] = useStartStreamingTranscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartStreamingTranscriptionMutation(baseOptions?: Apollo.MutationHookOptions<StartStreamingTranscriptionMutation, StartStreamingTranscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartStreamingTranscriptionMutation, StartStreamingTranscriptionMutationVariables>(StartStreamingTranscriptionDocument, options);
      }
export type StartStreamingTranscriptionMutationHookResult = ReturnType<typeof useStartStreamingTranscriptionMutation>;
export type StartStreamingTranscriptionMutationResult = Apollo.MutationResult<StartStreamingTranscriptionMutation>;
export type StartStreamingTranscriptionMutationOptions = Apollo.BaseMutationOptions<StartStreamingTranscriptionMutation, StartStreamingTranscriptionMutationVariables>;
export const UnlinkTranscriptionFromEvaluationSubmissionDocument = gql`
    mutation UnlinkTranscriptionFromEvaluationSubmission($input: UnlinkTranscriptionFromEvaluationSubmissionInput!) {
  unlinkTranscriptionFromEvaluationSubmission(input: $input) {
    success
  }
}
    `;
export type UnlinkTranscriptionFromEvaluationSubmissionMutationFn = Apollo.MutationFunction<UnlinkTranscriptionFromEvaluationSubmissionMutation, UnlinkTranscriptionFromEvaluationSubmissionMutationVariables>;

/**
 * __useUnlinkTranscriptionFromEvaluationSubmissionMutation__
 *
 * To run a mutation, you first call `useUnlinkTranscriptionFromEvaluationSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkTranscriptionFromEvaluationSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkTranscriptionFromEvaluationSubmissionMutation, { data, loading, error }] = useUnlinkTranscriptionFromEvaluationSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkTranscriptionFromEvaluationSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkTranscriptionFromEvaluationSubmissionMutation, UnlinkTranscriptionFromEvaluationSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkTranscriptionFromEvaluationSubmissionMutation, UnlinkTranscriptionFromEvaluationSubmissionMutationVariables>(UnlinkTranscriptionFromEvaluationSubmissionDocument, options);
      }
export type UnlinkTranscriptionFromEvaluationSubmissionMutationHookResult = ReturnType<typeof useUnlinkTranscriptionFromEvaluationSubmissionMutation>;
export type UnlinkTranscriptionFromEvaluationSubmissionMutationResult = Apollo.MutationResult<UnlinkTranscriptionFromEvaluationSubmissionMutation>;
export type UnlinkTranscriptionFromEvaluationSubmissionMutationOptions = Apollo.BaseMutationOptions<UnlinkTranscriptionFromEvaluationSubmissionMutation, UnlinkTranscriptionFromEvaluationSubmissionMutationVariables>;
export const UpdateTranscriptionSummaryDocument = gql`
    mutation UpdateTranscriptionSummary($input: UpdateTranscriptionSummaryInput!) {
  updateTranscriptionSummary(input: $input) {
    transcription {
      id
      summary
      editableSummary
    }
  }
}
    `;
export type UpdateTranscriptionSummaryMutationFn = Apollo.MutationFunction<UpdateTranscriptionSummaryMutation, UpdateTranscriptionSummaryMutationVariables>;

/**
 * __useUpdateTranscriptionSummaryMutation__
 *
 * To run a mutation, you first call `useUpdateTranscriptionSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranscriptionSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranscriptionSummaryMutation, { data, loading, error }] = useUpdateTranscriptionSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTranscriptionSummaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTranscriptionSummaryMutation, UpdateTranscriptionSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTranscriptionSummaryMutation, UpdateTranscriptionSummaryMutationVariables>(UpdateTranscriptionSummaryDocument, options);
      }
export type UpdateTranscriptionSummaryMutationHookResult = ReturnType<typeof useUpdateTranscriptionSummaryMutation>;
export type UpdateTranscriptionSummaryMutationResult = Apollo.MutationResult<UpdateTranscriptionSummaryMutation>;
export type UpdateTranscriptionSummaryMutationOptions = Apollo.BaseMutationOptions<UpdateTranscriptionSummaryMutation, UpdateTranscriptionSummaryMutationVariables>;
export const ArchiveEvaluationSubmissionDocument = gql`
    mutation ArchiveEvaluationSubmission($input: ArchiveEvaluationSubmissionInput!) {
  archiveEvaluationSubmission(input: $input) {
    evaluationSubmission {
      ...EvaluationSubmission
    }
  }
}
    ${EvaluationSubmissionFragmentDoc}`;
export type ArchiveEvaluationSubmissionMutationFn = Apollo.MutationFunction<ArchiveEvaluationSubmissionMutation, ArchiveEvaluationSubmissionMutationVariables>;

/**
 * __useArchiveEvaluationSubmissionMutation__
 *
 * To run a mutation, you first call `useArchiveEvaluationSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveEvaluationSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveEvaluationSubmissionMutation, { data, loading, error }] = useArchiveEvaluationSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveEvaluationSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveEvaluationSubmissionMutation, ArchiveEvaluationSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveEvaluationSubmissionMutation, ArchiveEvaluationSubmissionMutationVariables>(ArchiveEvaluationSubmissionDocument, options);
      }
export type ArchiveEvaluationSubmissionMutationHookResult = ReturnType<typeof useArchiveEvaluationSubmissionMutation>;
export type ArchiveEvaluationSubmissionMutationResult = Apollo.MutationResult<ArchiveEvaluationSubmissionMutation>;
export type ArchiveEvaluationSubmissionMutationOptions = Apollo.BaseMutationOptions<ArchiveEvaluationSubmissionMutation, ArchiveEvaluationSubmissionMutationVariables>;
export const ArchiveUserDocument = gql`
    mutation ArchiveUser($input: ArchiveUserInput!) {
  archiveUser(input: $input) {
    user {
      id
      isArchived
    }
  }
}
    `;
export type ArchiveUserMutationFn = Apollo.MutationFunction<ArchiveUserMutation, ArchiveUserMutationVariables>;

/**
 * __useArchiveUserMutation__
 *
 * To run a mutation, you first call `useArchiveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveUserMutation, { data, loading, error }] = useArchiveUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveUserMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveUserMutation, ArchiveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveUserMutation, ArchiveUserMutationVariables>(ArchiveUserDocument, options);
      }
export type ArchiveUserMutationHookResult = ReturnType<typeof useArchiveUserMutation>;
export type ArchiveUserMutationResult = Apollo.MutationResult<ArchiveUserMutation>;
export type ArchiveUserMutationOptions = Apollo.BaseMutationOptions<ArchiveUserMutation, ArchiveUserMutationVariables>;
export const AssociateTotpTokenDocument = gql`
    mutation AssociateTotpToken($input: AssociateTotpTokenInput!) {
  associateTotpToken(input: $input) {
    secretCode
    session
  }
}
    `;
export type AssociateTotpTokenMutationFn = Apollo.MutationFunction<AssociateTotpTokenMutation, AssociateTotpTokenMutationVariables>;

/**
 * __useAssociateTotpTokenMutation__
 *
 * To run a mutation, you first call `useAssociateTotpTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateTotpTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateTotpTokenMutation, { data, loading, error }] = useAssociateTotpTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssociateTotpTokenMutation(baseOptions?: Apollo.MutationHookOptions<AssociateTotpTokenMutation, AssociateTotpTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateTotpTokenMutation, AssociateTotpTokenMutationVariables>(AssociateTotpTokenDocument, options);
      }
export type AssociateTotpTokenMutationHookResult = ReturnType<typeof useAssociateTotpTokenMutation>;
export type AssociateTotpTokenMutationResult = Apollo.MutationResult<AssociateTotpTokenMutation>;
export type AssociateTotpTokenMutationOptions = Apollo.BaseMutationOptions<AssociateTotpTokenMutation, AssociateTotpTokenMutationVariables>;
export const ChangeLearningEventCoverDocument = gql`
    mutation ChangeLearningEventCover($input: ChangeLearningEventCoverInput!) {
  changeLearningEventCover(input: $input) {
    learningEvent {
      id
      cover {
        id
        source {
          url
        }
      }
    }
  }
}
    `;
export type ChangeLearningEventCoverMutationFn = Apollo.MutationFunction<ChangeLearningEventCoverMutation, ChangeLearningEventCoverMutationVariables>;

/**
 * __useChangeLearningEventCoverMutation__
 *
 * To run a mutation, you first call `useChangeLearningEventCoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeLearningEventCoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeLearningEventCoverMutation, { data, loading, error }] = useChangeLearningEventCoverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeLearningEventCoverMutation(baseOptions?: Apollo.MutationHookOptions<ChangeLearningEventCoverMutation, ChangeLearningEventCoverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeLearningEventCoverMutation, ChangeLearningEventCoverMutationVariables>(ChangeLearningEventCoverDocument, options);
      }
export type ChangeLearningEventCoverMutationHookResult = ReturnType<typeof useChangeLearningEventCoverMutation>;
export type ChangeLearningEventCoverMutationResult = Apollo.MutationResult<ChangeLearningEventCoverMutation>;
export type ChangeLearningEventCoverMutationOptions = Apollo.BaseMutationOptions<ChangeLearningEventCoverMutation, ChangeLearningEventCoverMutationVariables>;
export const CreateEvaluationSubmissionDocument = gql`
    mutation CreateEvaluationSubmission($input: CreateEvaluationSubmissionInput!) {
  createEvaluationSubmission(input: $input) {
    evaluationSubmission {
      id
    }
  }
}
    `;
export type CreateEvaluationSubmissionMutationFn = Apollo.MutationFunction<CreateEvaluationSubmissionMutation, CreateEvaluationSubmissionMutationVariables>;

/**
 * __useCreateEvaluationSubmissionMutation__
 *
 * To run a mutation, you first call `useCreateEvaluationSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEvaluationSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEvaluationSubmissionMutation, { data, loading, error }] = useCreateEvaluationSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEvaluationSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<CreateEvaluationSubmissionMutation, CreateEvaluationSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEvaluationSubmissionMutation, CreateEvaluationSubmissionMutationVariables>(CreateEvaluationSubmissionDocument, options);
      }
export type CreateEvaluationSubmissionMutationHookResult = ReturnType<typeof useCreateEvaluationSubmissionMutation>;
export type CreateEvaluationSubmissionMutationResult = Apollo.MutationResult<CreateEvaluationSubmissionMutation>;
export type CreateEvaluationSubmissionMutationOptions = Apollo.BaseMutationOptions<CreateEvaluationSubmissionMutation, CreateEvaluationSubmissionMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    user {
      id
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const CreateUserDocumentDocument = gql`
    mutation CreateUserDocument($input: CreateUserDocumentV2Input!) {
  createUserDocumentV2(input: $input) {
    documentID
    uploadUrl
    uploadHeaders {
      name
      values
    }
  }
}
    `;
export type CreateUserDocumentMutationFn = Apollo.MutationFunction<CreateUserDocumentMutation, CreateUserDocumentMutationVariables>;

/**
 * __useCreateUserDocumentMutation__
 *
 * To run a mutation, you first call `useCreateUserDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserDocumentMutation, { data, loading, error }] = useCreateUserDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserDocumentMutation, CreateUserDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserDocumentMutation, CreateUserDocumentMutationVariables>(CreateUserDocumentDocument, options);
      }
export type CreateUserDocumentMutationHookResult = ReturnType<typeof useCreateUserDocumentMutation>;
export type CreateUserDocumentMutationResult = Apollo.MutationResult<CreateUserDocumentMutation>;
export type CreateUserDocumentMutationOptions = Apollo.BaseMutationOptions<CreateUserDocumentMutation, CreateUserDocumentMutationVariables>;
export const CreateUserDocumentDownloadUrlDocument = gql`
    mutation CreateUserDocumentDownloadURL($input: CreateUserDocumentV2DownloadURLInput!) {
  createUserDocumentV2DownloadURL(input: $input) {
    url
  }
}
    `;
export type CreateUserDocumentDownloadUrlMutationFn = Apollo.MutationFunction<CreateUserDocumentDownloadUrlMutation, CreateUserDocumentDownloadUrlMutationVariables>;

/**
 * __useCreateUserDocumentDownloadUrlMutation__
 *
 * To run a mutation, you first call `useCreateUserDocumentDownloadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserDocumentDownloadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserDocumentDownloadUrlMutation, { data, loading, error }] = useCreateUserDocumentDownloadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserDocumentDownloadUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserDocumentDownloadUrlMutation, CreateUserDocumentDownloadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserDocumentDownloadUrlMutation, CreateUserDocumentDownloadUrlMutationVariables>(CreateUserDocumentDownloadUrlDocument, options);
      }
export type CreateUserDocumentDownloadUrlMutationHookResult = ReturnType<typeof useCreateUserDocumentDownloadUrlMutation>;
export type CreateUserDocumentDownloadUrlMutationResult = Apollo.MutationResult<CreateUserDocumentDownloadUrlMutation>;
export type CreateUserDocumentDownloadUrlMutationOptions = Apollo.BaseMutationOptions<CreateUserDocumentDownloadUrlMutation, CreateUserDocumentDownloadUrlMutationVariables>;
export const DeleteUserDocumentDocument = gql`
    mutation DeleteUserDocument($input: DeleteUserDocumentV2Input!) {
  deleteUserDocumentV2(input: $input) {
    deleted
  }
}
    `;
export type DeleteUserDocumentMutationFn = Apollo.MutationFunction<DeleteUserDocumentMutation, DeleteUserDocumentMutationVariables>;

/**
 * __useDeleteUserDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteUserDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserDocumentMutation, { data, loading, error }] = useDeleteUserDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserDocumentMutation, DeleteUserDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserDocumentMutation, DeleteUserDocumentMutationVariables>(DeleteUserDocumentDocument, options);
      }
export type DeleteUserDocumentMutationHookResult = ReturnType<typeof useDeleteUserDocumentMutation>;
export type DeleteUserDocumentMutationResult = Apollo.MutationResult<DeleteUserDocumentMutation>;
export type DeleteUserDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteUserDocumentMutation, DeleteUserDocumentMutationVariables>;
export const DeleteUserDownloadDocument = gql`
    mutation DeleteUserDownload($input: DeleteUserDownloadInput!) {
  deleteUserDownload(input: $input) {
    user {
      id
      downloads {
        ...UserDownload
      }
    }
  }
}
    ${UserDownloadFragmentDoc}`;
export type DeleteUserDownloadMutationFn = Apollo.MutationFunction<DeleteUserDownloadMutation, DeleteUserDownloadMutationVariables>;

/**
 * __useDeleteUserDownloadMutation__
 *
 * To run a mutation, you first call `useDeleteUserDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserDownloadMutation, { data, loading, error }] = useDeleteUserDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserDownloadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserDownloadMutation, DeleteUserDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserDownloadMutation, DeleteUserDownloadMutationVariables>(DeleteUserDownloadDocument, options);
      }
export type DeleteUserDownloadMutationHookResult = ReturnType<typeof useDeleteUserDownloadMutation>;
export type DeleteUserDownloadMutationResult = Apollo.MutationResult<DeleteUserDownloadMutation>;
export type DeleteUserDownloadMutationOptions = Apollo.BaseMutationOptions<DeleteUserDownloadMutation, DeleteUserDownloadMutationVariables>;
export const DisableMfaMethodDocument = gql`
    mutation DisableMfaMethod($input: DisableMfaMethodInput!) {
  disableMfaMethod(input: $input) {
    mfaUserConfiguration {
      ...MfaUserConfiguration
    }
  }
}
    ${MfaUserConfigurationFragmentDoc}`;
export type DisableMfaMethodMutationFn = Apollo.MutationFunction<DisableMfaMethodMutation, DisableMfaMethodMutationVariables>;

/**
 * __useDisableMfaMethodMutation__
 *
 * To run a mutation, you first call `useDisableMfaMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableMfaMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableMfaMethodMutation, { data, loading, error }] = useDisableMfaMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableMfaMethodMutation(baseOptions?: Apollo.MutationHookOptions<DisableMfaMethodMutation, DisableMfaMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableMfaMethodMutation, DisableMfaMethodMutationVariables>(DisableMfaMethodDocument, options);
      }
export type DisableMfaMethodMutationHookResult = ReturnType<typeof useDisableMfaMethodMutation>;
export type DisableMfaMethodMutationResult = Apollo.MutationResult<DisableMfaMethodMutation>;
export type DisableMfaMethodMutationOptions = Apollo.BaseMutationOptions<DisableMfaMethodMutation, DisableMfaMethodMutationVariables>;
export const ExportUserDataDocument = gql`
    mutation ExportUserData($input: ExportUserDataInput!) {
  exportUserData(input: $input) {
    download {
      id
    }
  }
}
    `;
export type ExportUserDataMutationFn = Apollo.MutationFunction<ExportUserDataMutation, ExportUserDataMutationVariables>;

/**
 * __useExportUserDataMutation__
 *
 * To run a mutation, you first call `useExportUserDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportUserDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportUserDataMutation, { data, loading, error }] = useExportUserDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportUserDataMutation(baseOptions?: Apollo.MutationHookOptions<ExportUserDataMutation, ExportUserDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportUserDataMutation, ExportUserDataMutationVariables>(ExportUserDataDocument, options);
      }
export type ExportUserDataMutationHookResult = ReturnType<typeof useExportUserDataMutation>;
export type ExportUserDataMutationResult = Apollo.MutationResult<ExportUserDataMutation>;
export type ExportUserDataMutationOptions = Apollo.BaseMutationOptions<ExportUserDataMutation, ExportUserDataMutationVariables>;
export const FinalizeUserDocumentUploadDocument = gql`
    mutation FinalizeUserDocumentUpload($input: FinalizeUserDocumentV2UploadInput!) {
  finalizeUserDocumentV2Upload(input: $input) {
    documentID
  }
}
    `;
export type FinalizeUserDocumentUploadMutationFn = Apollo.MutationFunction<FinalizeUserDocumentUploadMutation, FinalizeUserDocumentUploadMutationVariables>;

/**
 * __useFinalizeUserDocumentUploadMutation__
 *
 * To run a mutation, you first call `useFinalizeUserDocumentUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeUserDocumentUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeUserDocumentUploadMutation, { data, loading, error }] = useFinalizeUserDocumentUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinalizeUserDocumentUploadMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeUserDocumentUploadMutation, FinalizeUserDocumentUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeUserDocumentUploadMutation, FinalizeUserDocumentUploadMutationVariables>(FinalizeUserDocumentUploadDocument, options);
      }
export type FinalizeUserDocumentUploadMutationHookResult = ReturnType<typeof useFinalizeUserDocumentUploadMutation>;
export type FinalizeUserDocumentUploadMutationResult = Apollo.MutationResult<FinalizeUserDocumentUploadMutation>;
export type FinalizeUserDocumentUploadMutationOptions = Apollo.BaseMutationOptions<FinalizeUserDocumentUploadMutation, FinalizeUserDocumentUploadMutationVariables>;
export const MarkEvaluationSubmissionSharedDocument = gql`
    mutation MarkEvaluationSubmissionShared($input: MarkEvaluationSubmissionSharedInput!) {
  markEvaluationSubmissionShared(input: $input) {
    evaluationSubmission {
      ...EvaluationSubmission
    }
  }
}
    ${EvaluationSubmissionFragmentDoc}`;
export type MarkEvaluationSubmissionSharedMutationFn = Apollo.MutationFunction<MarkEvaluationSubmissionSharedMutation, MarkEvaluationSubmissionSharedMutationVariables>;

/**
 * __useMarkEvaluationSubmissionSharedMutation__
 *
 * To run a mutation, you first call `useMarkEvaluationSubmissionSharedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkEvaluationSubmissionSharedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markEvaluationSubmissionSharedMutation, { data, loading, error }] = useMarkEvaluationSubmissionSharedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkEvaluationSubmissionSharedMutation(baseOptions?: Apollo.MutationHookOptions<MarkEvaluationSubmissionSharedMutation, MarkEvaluationSubmissionSharedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkEvaluationSubmissionSharedMutation, MarkEvaluationSubmissionSharedMutationVariables>(MarkEvaluationSubmissionSharedDocument, options);
      }
export type MarkEvaluationSubmissionSharedMutationHookResult = ReturnType<typeof useMarkEvaluationSubmissionSharedMutation>;
export type MarkEvaluationSubmissionSharedMutationResult = Apollo.MutationResult<MarkEvaluationSubmissionSharedMutation>;
export type MarkEvaluationSubmissionSharedMutationOptions = Apollo.BaseMutationOptions<MarkEvaluationSubmissionSharedMutation, MarkEvaluationSubmissionSharedMutationVariables>;
export const ObfuscateUserDocument = gql`
    mutation ObfuscateUser($input: ObfuscateUserInput!) {
  obfuscateUser(input: $input) {
    user {
      id
    }
  }
}
    `;
export type ObfuscateUserMutationFn = Apollo.MutationFunction<ObfuscateUserMutation, ObfuscateUserMutationVariables>;

/**
 * __useObfuscateUserMutation__
 *
 * To run a mutation, you first call `useObfuscateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObfuscateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [obfuscateUserMutation, { data, loading, error }] = useObfuscateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useObfuscateUserMutation(baseOptions?: Apollo.MutationHookOptions<ObfuscateUserMutation, ObfuscateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ObfuscateUserMutation, ObfuscateUserMutationVariables>(ObfuscateUserDocument, options);
      }
export type ObfuscateUserMutationHookResult = ReturnType<typeof useObfuscateUserMutation>;
export type ObfuscateUserMutationResult = Apollo.MutationResult<ObfuscateUserMutation>;
export type ObfuscateUserMutationOptions = Apollo.BaseMutationOptions<ObfuscateUserMutation, ObfuscateUserMutationVariables>;
export const OverrideEvaluationSubmissionScoreDocument = gql`
    mutation OverrideEvaluationSubmissionScore($input: OverrideEvaluationSubmissionScoreInput!) {
  overrideEvaluationSubmissionScore(input: $input) {
    evaluationSubmission {
      id
      overrideScore {
        id
        title
      }
      overrideReason
    }
  }
}
    `;
export type OverrideEvaluationSubmissionScoreMutationFn = Apollo.MutationFunction<OverrideEvaluationSubmissionScoreMutation, OverrideEvaluationSubmissionScoreMutationVariables>;

/**
 * __useOverrideEvaluationSubmissionScoreMutation__
 *
 * To run a mutation, you first call `useOverrideEvaluationSubmissionScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideEvaluationSubmissionScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideEvaluationSubmissionScoreMutation, { data, loading, error }] = useOverrideEvaluationSubmissionScoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOverrideEvaluationSubmissionScoreMutation(baseOptions?: Apollo.MutationHookOptions<OverrideEvaluationSubmissionScoreMutation, OverrideEvaluationSubmissionScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideEvaluationSubmissionScoreMutation, OverrideEvaluationSubmissionScoreMutationVariables>(OverrideEvaluationSubmissionScoreDocument, options);
      }
export type OverrideEvaluationSubmissionScoreMutationHookResult = ReturnType<typeof useOverrideEvaluationSubmissionScoreMutation>;
export type OverrideEvaluationSubmissionScoreMutationResult = Apollo.MutationResult<OverrideEvaluationSubmissionScoreMutation>;
export type OverrideEvaluationSubmissionScoreMutationOptions = Apollo.BaseMutationOptions<OverrideEvaluationSubmissionScoreMutation, OverrideEvaluationSubmissionScoreMutationVariables>;
export const RequestEvaluationSubmissionDocument = gql`
    mutation RequestEvaluationSubmission($input: RequestEvaluationSubmissionInput!) {
  requestEvaluationSubmission(input: $input) {
    evaluationSubmission {
      id
    }
  }
}
    `;
export type RequestEvaluationSubmissionMutationFn = Apollo.MutationFunction<RequestEvaluationSubmissionMutation, RequestEvaluationSubmissionMutationVariables>;

/**
 * __useRequestEvaluationSubmissionMutation__
 *
 * To run a mutation, you first call `useRequestEvaluationSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEvaluationSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEvaluationSubmissionMutation, { data, loading, error }] = useRequestEvaluationSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestEvaluationSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<RequestEvaluationSubmissionMutation, RequestEvaluationSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestEvaluationSubmissionMutation, RequestEvaluationSubmissionMutationVariables>(RequestEvaluationSubmissionDocument, options);
      }
export type RequestEvaluationSubmissionMutationHookResult = ReturnType<typeof useRequestEvaluationSubmissionMutation>;
export type RequestEvaluationSubmissionMutationResult = Apollo.MutationResult<RequestEvaluationSubmissionMutation>;
export type RequestEvaluationSubmissionMutationOptions = Apollo.BaseMutationOptions<RequestEvaluationSubmissionMutation, RequestEvaluationSubmissionMutationVariables>;
export const RescheduleEvaluationSubmissionDocument = gql`
    mutation RescheduleEvaluationSubmission($input: RescheduleEvaluationSubmissionInput!) {
  rescheduleEvaluationSubmission(input: $input) {
    evaluationSubmission {
      id
      deadline
      meeting {
        duration
        link
        location
      }
    }
  }
}
    `;
export type RescheduleEvaluationSubmissionMutationFn = Apollo.MutationFunction<RescheduleEvaluationSubmissionMutation, RescheduleEvaluationSubmissionMutationVariables>;

/**
 * __useRescheduleEvaluationSubmissionMutation__
 *
 * To run a mutation, you first call `useRescheduleEvaluationSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleEvaluationSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleEvaluationSubmissionMutation, { data, loading, error }] = useRescheduleEvaluationSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRescheduleEvaluationSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleEvaluationSubmissionMutation, RescheduleEvaluationSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleEvaluationSubmissionMutation, RescheduleEvaluationSubmissionMutationVariables>(RescheduleEvaluationSubmissionDocument, options);
      }
export type RescheduleEvaluationSubmissionMutationHookResult = ReturnType<typeof useRescheduleEvaluationSubmissionMutation>;
export type RescheduleEvaluationSubmissionMutationResult = Apollo.MutationResult<RescheduleEvaluationSubmissionMutation>;
export type RescheduleEvaluationSubmissionMutationOptions = Apollo.BaseMutationOptions<RescheduleEvaluationSubmissionMutation, RescheduleEvaluationSubmissionMutationVariables>;
export const RestoreEvaluationSubmissionDocument = gql`
    mutation RestoreEvaluationSubmission($input: RestoreEvaluationSubmissionInput!) {
  restoreEvaluationSubmission(input: $input) {
    evaluationSubmission {
      ...EvaluationSubmission
    }
  }
}
    ${EvaluationSubmissionFragmentDoc}`;
export type RestoreEvaluationSubmissionMutationFn = Apollo.MutationFunction<RestoreEvaluationSubmissionMutation, RestoreEvaluationSubmissionMutationVariables>;

/**
 * __useRestoreEvaluationSubmissionMutation__
 *
 * To run a mutation, you first call `useRestoreEvaluationSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreEvaluationSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreEvaluationSubmissionMutation, { data, loading, error }] = useRestoreEvaluationSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreEvaluationSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<RestoreEvaluationSubmissionMutation, RestoreEvaluationSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreEvaluationSubmissionMutation, RestoreEvaluationSubmissionMutationVariables>(RestoreEvaluationSubmissionDocument, options);
      }
export type RestoreEvaluationSubmissionMutationHookResult = ReturnType<typeof useRestoreEvaluationSubmissionMutation>;
export type RestoreEvaluationSubmissionMutationResult = Apollo.MutationResult<RestoreEvaluationSubmissionMutation>;
export type RestoreEvaluationSubmissionMutationOptions = Apollo.BaseMutationOptions<RestoreEvaluationSubmissionMutation, RestoreEvaluationSubmissionMutationVariables>;
export const RestoreUserDocument = gql`
    mutation RestoreUser($input: RestoreUserInput!) {
  restoreUser(input: $input) {
    user {
      id
      isArchived
    }
  }
}
    `;
export type RestoreUserMutationFn = Apollo.MutationFunction<RestoreUserMutation, RestoreUserMutationVariables>;

/**
 * __useRestoreUserMutation__
 *
 * To run a mutation, you first call `useRestoreUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreUserMutation, { data, loading, error }] = useRestoreUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreUserMutation(baseOptions?: Apollo.MutationHookOptions<RestoreUserMutation, RestoreUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreUserMutation, RestoreUserMutationVariables>(RestoreUserDocument, options);
      }
export type RestoreUserMutationHookResult = ReturnType<typeof useRestoreUserMutation>;
export type RestoreUserMutationResult = Apollo.MutationResult<RestoreUserMutation>;
export type RestoreUserMutationOptions = Apollo.BaseMutationOptions<RestoreUserMutation, RestoreUserMutationVariables>;
export const RevokeUserRoleDocument = gql`
    mutation RevokeUserRole($input: RevokeRoleInput!) {
  revokeRole(input: $input) {
    user {
      id
    }
  }
}
    `;
export type RevokeUserRoleMutationFn = Apollo.MutationFunction<RevokeUserRoleMutation, RevokeUserRoleMutationVariables>;

/**
 * __useRevokeUserRoleMutation__
 *
 * To run a mutation, you first call `useRevokeUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeUserRoleMutation, { data, loading, error }] = useRevokeUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<RevokeUserRoleMutation, RevokeUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeUserRoleMutation, RevokeUserRoleMutationVariables>(RevokeUserRoleDocument, options);
      }
export type RevokeUserRoleMutationHookResult = ReturnType<typeof useRevokeUserRoleMutation>;
export type RevokeUserRoleMutationResult = Apollo.MutationResult<RevokeUserRoleMutation>;
export type RevokeUserRoleMutationOptions = Apollo.BaseMutationOptions<RevokeUserRoleMutation, RevokeUserRoleMutationVariables>;
export const SignEvaluationSubmissionDocument = gql`
    mutation SignEvaluationSubmission($input: SignEvaluationSubmissionInput!) {
  signEvaluationSubmission(input: $input) {
    evaluationSubmission {
      ...EvaluationSubmission
    }
  }
}
    ${EvaluationSubmissionFragmentDoc}`;
export type SignEvaluationSubmissionMutationFn = Apollo.MutationFunction<SignEvaluationSubmissionMutation, SignEvaluationSubmissionMutationVariables>;

/**
 * __useSignEvaluationSubmissionMutation__
 *
 * To run a mutation, you first call `useSignEvaluationSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignEvaluationSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signEvaluationSubmissionMutation, { data, loading, error }] = useSignEvaluationSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignEvaluationSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<SignEvaluationSubmissionMutation, SignEvaluationSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignEvaluationSubmissionMutation, SignEvaluationSubmissionMutationVariables>(SignEvaluationSubmissionDocument, options);
      }
export type SignEvaluationSubmissionMutationHookResult = ReturnType<typeof useSignEvaluationSubmissionMutation>;
export type SignEvaluationSubmissionMutationResult = Apollo.MutationResult<SignEvaluationSubmissionMutation>;
export type SignEvaluationSubmissionMutationOptions = Apollo.BaseMutationOptions<SignEvaluationSubmissionMutation, SignEvaluationSubmissionMutationVariables>;
export const UnsignEvaluationSubmissionDocument = gql`
    mutation UnsignEvaluationSubmission($input: UnsignEvaluationSubmissionInput!) {
  unsignEvaluationSubmission(input: $input) {
    evaluationSubmission {
      ...EvaluationSubmission
    }
  }
}
    ${EvaluationSubmissionFragmentDoc}`;
export type UnsignEvaluationSubmissionMutationFn = Apollo.MutationFunction<UnsignEvaluationSubmissionMutation, UnsignEvaluationSubmissionMutationVariables>;

/**
 * __useUnsignEvaluationSubmissionMutation__
 *
 * To run a mutation, you first call `useUnsignEvaluationSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsignEvaluationSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsignEvaluationSubmissionMutation, { data, loading, error }] = useUnsignEvaluationSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnsignEvaluationSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<UnsignEvaluationSubmissionMutation, UnsignEvaluationSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsignEvaluationSubmissionMutation, UnsignEvaluationSubmissionMutationVariables>(UnsignEvaluationSubmissionDocument, options);
      }
export type UnsignEvaluationSubmissionMutationHookResult = ReturnType<typeof useUnsignEvaluationSubmissionMutation>;
export type UnsignEvaluationSubmissionMutationResult = Apollo.MutationResult<UnsignEvaluationSubmissionMutation>;
export type UnsignEvaluationSubmissionMutationOptions = Apollo.BaseMutationOptions<UnsignEvaluationSubmissionMutation, UnsignEvaluationSubmissionMutationVariables>;
export const UpdateEvaluationSubmissionDocument = gql`
    mutation UpdateEvaluationSubmission($input: UpdateEvaluationSubmissionInput!) {
  updateEvaluationSubmission(input: $input) {
    evaluationSubmission {
      ...EvaluationSubmission
    }
  }
}
    ${EvaluationSubmissionFragmentDoc}`;
export type UpdateEvaluationSubmissionMutationFn = Apollo.MutationFunction<UpdateEvaluationSubmissionMutation, UpdateEvaluationSubmissionMutationVariables>;

/**
 * __useUpdateEvaluationSubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateEvaluationSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEvaluationSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEvaluationSubmissionMutation, { data, loading, error }] = useUpdateEvaluationSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEvaluationSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEvaluationSubmissionMutation, UpdateEvaluationSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEvaluationSubmissionMutation, UpdateEvaluationSubmissionMutationVariables>(UpdateEvaluationSubmissionDocument, options);
      }
export type UpdateEvaluationSubmissionMutationHookResult = ReturnType<typeof useUpdateEvaluationSubmissionMutation>;
export type UpdateEvaluationSubmissionMutationResult = Apollo.MutationResult<UpdateEvaluationSubmissionMutation>;
export type UpdateEvaluationSubmissionMutationOptions = Apollo.BaseMutationOptions<UpdateEvaluationSubmissionMutation, UpdateEvaluationSubmissionMutationVariables>;
export const UpdateInvoiceUserCountDocument = gql`
    mutation UpdateInvoiceUserCount($input: UpdateInvoiceUserCountInput!) {
  updateInvoiceUserCount(input: $input) {
    success
  }
}
    `;
export type UpdateInvoiceUserCountMutationFn = Apollo.MutationFunction<UpdateInvoiceUserCountMutation, UpdateInvoiceUserCountMutationVariables>;

/**
 * __useUpdateInvoiceUserCountMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceUserCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceUserCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceUserCountMutation, { data, loading, error }] = useUpdateInvoiceUserCountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInvoiceUserCountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceUserCountMutation, UpdateInvoiceUserCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceUserCountMutation, UpdateInvoiceUserCountMutationVariables>(UpdateInvoiceUserCountDocument, options);
      }
export type UpdateInvoiceUserCountMutationHookResult = ReturnType<typeof useUpdateInvoiceUserCountMutation>;
export type UpdateInvoiceUserCountMutationResult = Apollo.MutationResult<UpdateInvoiceUserCountMutation>;
export type UpdateInvoiceUserCountMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceUserCountMutation, UpdateInvoiceUserCountMutationVariables>;
export const UpdatePersonalNotificationSettingDocument = gql`
    mutation UpdatePersonalNotificationSetting($input: UpdateUserNotificationSettingInput!) {
  updateUserNotificationSetting(input: $input) {
    setting {
      id
      type
      channels {
        channel
        frequency
      }
    }
  }
}
    `;
export type UpdatePersonalNotificationSettingMutationFn = Apollo.MutationFunction<UpdatePersonalNotificationSettingMutation, UpdatePersonalNotificationSettingMutationVariables>;

/**
 * __useUpdatePersonalNotificationSettingMutation__
 *
 * To run a mutation, you first call `useUpdatePersonalNotificationSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonalNotificationSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonalNotificationSettingMutation, { data, loading, error }] = useUpdatePersonalNotificationSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePersonalNotificationSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonalNotificationSettingMutation, UpdatePersonalNotificationSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonalNotificationSettingMutation, UpdatePersonalNotificationSettingMutationVariables>(UpdatePersonalNotificationSettingDocument, options);
      }
export type UpdatePersonalNotificationSettingMutationHookResult = ReturnType<typeof useUpdatePersonalNotificationSettingMutation>;
export type UpdatePersonalNotificationSettingMutationResult = Apollo.MutationResult<UpdatePersonalNotificationSettingMutation>;
export type UpdatePersonalNotificationSettingMutationOptions = Apollo.BaseMutationOptions<UpdatePersonalNotificationSettingMutation, UpdatePersonalNotificationSettingMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    user {
      id
      firstName
      lastName
      activatedAt
      locale
      username
      email
      group {
        id
      }
      externalReferenceID
      isExternal
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserActivationDateDocument = gql`
    mutation UpdateUserActivationDate($input: UpdateUserActivationDateInput!) {
  updateUserActivationDate(input: $input) {
    user {
      id
      activatedAt
    }
  }
}
    `;
export type UpdateUserActivationDateMutationFn = Apollo.MutationFunction<UpdateUserActivationDateMutation, UpdateUserActivationDateMutationVariables>;

/**
 * __useUpdateUserActivationDateMutation__
 *
 * To run a mutation, you first call `useUpdateUserActivationDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserActivationDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserActivationDateMutation, { data, loading, error }] = useUpdateUserActivationDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserActivationDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserActivationDateMutation, UpdateUserActivationDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserActivationDateMutation, UpdateUserActivationDateMutationVariables>(UpdateUserActivationDateDocument, options);
      }
export type UpdateUserActivationDateMutationHookResult = ReturnType<typeof useUpdateUserActivationDateMutation>;
export type UpdateUserActivationDateMutationResult = Apollo.MutationResult<UpdateUserActivationDateMutation>;
export type UpdateUserActivationDateMutationOptions = Apollo.BaseMutationOptions<UpdateUserActivationDateMutation, UpdateUserActivationDateMutationVariables>;
export const UpdateUserAvatarDocument = gql`
    mutation UpdateUserAvatar($input: UpdateUserAvatarInput!) {
  updateUserAvatar(input: $input) {
    user {
      id
      avatar {
        id
        source {
          url
        }
      }
    }
  }
}
    `;
export type UpdateUserAvatarMutationFn = Apollo.MutationFunction<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>;

/**
 * __useUpdateUserAvatarMutation__
 *
 * To run a mutation, you first call `useUpdateUserAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAvatarMutation, { data, loading, error }] = useUpdateUserAvatarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserAvatarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>(UpdateUserAvatarDocument, options);
      }
export type UpdateUserAvatarMutationHookResult = ReturnType<typeof useUpdateUserAvatarMutation>;
export type UpdateUserAvatarMutationResult = Apollo.MutationResult<UpdateUserAvatarMutation>;
export type UpdateUserAvatarMutationOptions = Apollo.BaseMutationOptions<UpdateUserAvatarMutation, UpdateUserAvatarMutationVariables>;
export const UpdateUserCoverDocument = gql`
    mutation UpdateUserCover($input: UpdateUserCoverInput!) {
  updateUserCover(input: $input) {
    user {
      id
      cover {
        id
        source {
          url
        }
      }
    }
  }
}
    `;
export type UpdateUserCoverMutationFn = Apollo.MutationFunction<UpdateUserCoverMutation, UpdateUserCoverMutationVariables>;

/**
 * __useUpdateUserCoverMutation__
 *
 * To run a mutation, you first call `useUpdateUserCoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCoverMutation, { data, loading, error }] = useUpdateUserCoverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserCoverMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCoverMutation, UpdateUserCoverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserCoverMutation, UpdateUserCoverMutationVariables>(UpdateUserCoverDocument, options);
      }
export type UpdateUserCoverMutationHookResult = ReturnType<typeof useUpdateUserCoverMutation>;
export type UpdateUserCoverMutationResult = Apollo.MutationResult<UpdateUserCoverMutation>;
export type UpdateUserCoverMutationOptions = Apollo.BaseMutationOptions<UpdateUserCoverMutation, UpdateUserCoverMutationVariables>;
export const UpdateUserLocaleDocument = gql`
    mutation UpdateUserLocale($input: UpdateUserLocaleInput!) {
  updateUserLocale(input: $input) {
    user {
      id
      locale
    }
  }
}
    `;
export type UpdateUserLocaleMutationFn = Apollo.MutationFunction<UpdateUserLocaleMutation, UpdateUserLocaleMutationVariables>;

/**
 * __useUpdateUserLocaleMutation__
 *
 * To run a mutation, you first call `useUpdateUserLocaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLocaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLocaleMutation, { data, loading, error }] = useUpdateUserLocaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserLocaleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserLocaleMutation, UpdateUserLocaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserLocaleMutation, UpdateUserLocaleMutationVariables>(UpdateUserLocaleDocument, options);
      }
export type UpdateUserLocaleMutationHookResult = ReturnType<typeof useUpdateUserLocaleMutation>;
export type UpdateUserLocaleMutationResult = Apollo.MutationResult<UpdateUserLocaleMutation>;
export type UpdateUserLocaleMutationOptions = Apollo.BaseMutationOptions<UpdateUserLocaleMutation, UpdateUserLocaleMutationVariables>;
export const UserUpdateMissionDocument = gql`
    mutation UserUpdateMission($input: UpdateUserMissionInput!) {
  updateUserMission(input: $input) {
    user {
      id
      mission
    }
  }
}
    `;
export type UserUpdateMissionMutationFn = Apollo.MutationFunction<UserUpdateMissionMutation, UserUpdateMissionMutationVariables>;

/**
 * __useUserUpdateMissionMutation__
 *
 * To run a mutation, you first call `useUserUpdateMissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMissionMutation, { data, loading, error }] = useUserUpdateMissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserUpdateMissionMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateMissionMutation, UserUpdateMissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateMissionMutation, UserUpdateMissionMutationVariables>(UserUpdateMissionDocument, options);
      }
export type UserUpdateMissionMutationHookResult = ReturnType<typeof useUserUpdateMissionMutation>;
export type UserUpdateMissionMutationResult = Apollo.MutationResult<UserUpdateMissionMutation>;
export type UserUpdateMissionMutationOptions = Apollo.BaseMutationOptions<UserUpdateMissionMutation, UserUpdateMissionMutationVariables>;
export const VerifyTotpTokenDocument = gql`
    mutation VerifyTotpToken($input: VerifyTotpTokenInput!) {
  verifyTotpToken(input: $input) {
    success
    session
    mfaUserConfiguration {
      ...MfaUserConfiguration
    }
  }
}
    ${MfaUserConfigurationFragmentDoc}`;
export type VerifyTotpTokenMutationFn = Apollo.MutationFunction<VerifyTotpTokenMutation, VerifyTotpTokenMutationVariables>;

/**
 * __useVerifyTotpTokenMutation__
 *
 * To run a mutation, you first call `useVerifyTotpTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTotpTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTotpTokenMutation, { data, loading, error }] = useVerifyTotpTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyTotpTokenMutation(baseOptions?: Apollo.MutationHookOptions<VerifyTotpTokenMutation, VerifyTotpTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyTotpTokenMutation, VerifyTotpTokenMutationVariables>(VerifyTotpTokenDocument, options);
      }
export type VerifyTotpTokenMutationHookResult = ReturnType<typeof useVerifyTotpTokenMutation>;
export type VerifyTotpTokenMutationResult = Apollo.MutationResult<VerifyTotpTokenMutation>;
export type VerifyTotpTokenMutationOptions = Apollo.BaseMutationOptions<VerifyTotpTokenMutation, VerifyTotpTokenMutationVariables>;
export const ConnectorDryRunUsersDocument = gql`
    query ConnectorDryRunUsers($first: Int, $after: ID, $last: Int, $before: ID) {
  viewer {
    workspace {
      connector {
        id
        dryRun {
          users(first: $first, after: $after, last: $last, before: $before) {
            edges {
              node {
                firstName
                lastName
                email
                externalReferenceID
              }
              cursor
            }
            pageInfo {
              startCursor
              endCursor
              hasNextPage
              hasPreviousPage
            }
            totalCount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useConnectorDryRunUsersQuery__
 *
 * To run a query within a React component, call `useConnectorDryRunUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectorDryRunUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectorDryRunUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useConnectorDryRunUsersQuery(baseOptions?: Apollo.QueryHookOptions<ConnectorDryRunUsersQuery, ConnectorDryRunUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectorDryRunUsersQuery, ConnectorDryRunUsersQueryVariables>(ConnectorDryRunUsersDocument, options);
      }
export function useConnectorDryRunUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectorDryRunUsersQuery, ConnectorDryRunUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectorDryRunUsersQuery, ConnectorDryRunUsersQueryVariables>(ConnectorDryRunUsersDocument, options);
        }
// @ts-ignore
export function useConnectorDryRunUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConnectorDryRunUsersQuery, ConnectorDryRunUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorDryRunUsersQuery, ConnectorDryRunUsersQueryVariables>;
export function useConnectorDryRunUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorDryRunUsersQuery, ConnectorDryRunUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ConnectorDryRunUsersQuery | undefined, ConnectorDryRunUsersQueryVariables>;
export function useConnectorDryRunUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectorDryRunUsersQuery, ConnectorDryRunUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectorDryRunUsersQuery, ConnectorDryRunUsersQueryVariables>(ConnectorDryRunUsersDocument, options);
        }
export type ConnectorDryRunUsersQueryHookResult = ReturnType<typeof useConnectorDryRunUsersQuery>;
export type ConnectorDryRunUsersLazyQueryHookResult = ReturnType<typeof useConnectorDryRunUsersLazyQuery>;
export type ConnectorDryRunUsersSuspenseQueryHookResult = ReturnType<typeof useConnectorDryRunUsersSuspenseQuery>;
export type ConnectorDryRunUsersQueryResult = Apollo.QueryResult<ConnectorDryRunUsersQuery, ConnectorDryRunUsersQueryVariables>;
export const EmployeeEvaluationSubmissionsDocument = gql`
    query EmployeeEvaluationSubmissions($userID: ID!) {
  user(id: $userID) {
    id
    archivedEvaluationSubmissions: evaluationSubmissions(
      isArchived: true
      first: 100
    ) {
      edges {
        node {
          id
          evaluationForm {
            title
          }
          employee {
            status
          }
          createdOnDateTimeOffsetUtc: createdAt
        }
      }
    }
    evaluationSubmissions(isArchived: false, first: 100) {
      edges {
        node {
          id
          evaluationForm {
            title
          }
          employee {
            status
          }
          createdOnDateTimeOffsetUtc: createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useEmployeeEvaluationSubmissionsQuery__
 *
 * To run a query within a React component, call `useEmployeeEvaluationSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeEvaluationSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeEvaluationSubmissionsQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useEmployeeEvaluationSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<EmployeeEvaluationSubmissionsQuery, EmployeeEvaluationSubmissionsQueryVariables> & ({ variables: EmployeeEvaluationSubmissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeEvaluationSubmissionsQuery, EmployeeEvaluationSubmissionsQueryVariables>(EmployeeEvaluationSubmissionsDocument, options);
      }
export function useEmployeeEvaluationSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeEvaluationSubmissionsQuery, EmployeeEvaluationSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeEvaluationSubmissionsQuery, EmployeeEvaluationSubmissionsQueryVariables>(EmployeeEvaluationSubmissionsDocument, options);
        }
// @ts-ignore
export function useEmployeeEvaluationSubmissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeEvaluationSubmissionsQuery, EmployeeEvaluationSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeEvaluationSubmissionsQuery, EmployeeEvaluationSubmissionsQueryVariables>;
export function useEmployeeEvaluationSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeEvaluationSubmissionsQuery, EmployeeEvaluationSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeEvaluationSubmissionsQuery | undefined, EmployeeEvaluationSubmissionsQueryVariables>;
export function useEmployeeEvaluationSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeEvaluationSubmissionsQuery, EmployeeEvaluationSubmissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeEvaluationSubmissionsQuery, EmployeeEvaluationSubmissionsQueryVariables>(EmployeeEvaluationSubmissionsDocument, options);
        }
export type EmployeeEvaluationSubmissionsQueryHookResult = ReturnType<typeof useEmployeeEvaluationSubmissionsQuery>;
export type EmployeeEvaluationSubmissionsLazyQueryHookResult = ReturnType<typeof useEmployeeEvaluationSubmissionsLazyQuery>;
export type EmployeeEvaluationSubmissionsSuspenseQueryHookResult = ReturnType<typeof useEmployeeEvaluationSubmissionsSuspenseQuery>;
export type EmployeeEvaluationSubmissionsQueryResult = Apollo.QueryResult<EmployeeEvaluationSubmissionsQuery, EmployeeEvaluationSubmissionsQueryVariables>;
export const EmployeeGoalsDocument = gql`
    query EmployeeGoals($id: ID!, $status: GoalStatus!, $before: ID, $last: Int!) {
  user(id: $id) {
    id
    goalsV2(status: $status, before: $before, last: $last) {
      edges {
        node {
          ...MetaGoal
          ...GoalWithOwner
        }
      }
      pageInfo {
        ...PageInfo
      }
      totalCount
    }
  }
}
    ${MetaGoalFragmentDoc}
${GoalWithOwnerFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useEmployeeGoalsQuery__
 *
 * To run a query within a React component, call `useEmployeeGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeGoalsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useEmployeeGoalsQuery(baseOptions: Apollo.QueryHookOptions<EmployeeGoalsQuery, EmployeeGoalsQueryVariables> & ({ variables: EmployeeGoalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeGoalsQuery, EmployeeGoalsQueryVariables>(EmployeeGoalsDocument, options);
      }
export function useEmployeeGoalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeGoalsQuery, EmployeeGoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeGoalsQuery, EmployeeGoalsQueryVariables>(EmployeeGoalsDocument, options);
        }
// @ts-ignore
export function useEmployeeGoalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeGoalsQuery, EmployeeGoalsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeGoalsQuery, EmployeeGoalsQueryVariables>;
export function useEmployeeGoalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeGoalsQuery, EmployeeGoalsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeGoalsQuery | undefined, EmployeeGoalsQueryVariables>;
export function useEmployeeGoalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeGoalsQuery, EmployeeGoalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeGoalsQuery, EmployeeGoalsQueryVariables>(EmployeeGoalsDocument, options);
        }
export type EmployeeGoalsQueryHookResult = ReturnType<typeof useEmployeeGoalsQuery>;
export type EmployeeGoalsLazyQueryHookResult = ReturnType<typeof useEmployeeGoalsLazyQuery>;
export type EmployeeGoalsSuspenseQueryHookResult = ReturnType<typeof useEmployeeGoalsSuspenseQuery>;
export type EmployeeGoalsQueryResult = Apollo.QueryResult<EmployeeGoalsQuery, EmployeeGoalsQueryVariables>;
export const EmployeeIncomingFeedbackRequestsDocument = gql`
    query EmployeeIncomingFeedbackRequests($userID: ID!, $isArchived: Boolean!, $before: ID, $last: Int!) {
  user(id: $userID) {
    id
    firstName
    viewerCanRequestFeedback
    feedbackRequests(isArchived: $isArchived, before: $before, last: $last) {
      edges {
        node {
          id
          title
          createdAt
          dueDate
          isArchived
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useEmployeeIncomingFeedbackRequestsQuery__
 *
 * To run a query within a React component, call `useEmployeeIncomingFeedbackRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeIncomingFeedbackRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeIncomingFeedbackRequestsQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useEmployeeIncomingFeedbackRequestsQuery(baseOptions: Apollo.QueryHookOptions<EmployeeIncomingFeedbackRequestsQuery, EmployeeIncomingFeedbackRequestsQueryVariables> & ({ variables: EmployeeIncomingFeedbackRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeIncomingFeedbackRequestsQuery, EmployeeIncomingFeedbackRequestsQueryVariables>(EmployeeIncomingFeedbackRequestsDocument, options);
      }
export function useEmployeeIncomingFeedbackRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeIncomingFeedbackRequestsQuery, EmployeeIncomingFeedbackRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeIncomingFeedbackRequestsQuery, EmployeeIncomingFeedbackRequestsQueryVariables>(EmployeeIncomingFeedbackRequestsDocument, options);
        }
// @ts-ignore
export function useEmployeeIncomingFeedbackRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeIncomingFeedbackRequestsQuery, EmployeeIncomingFeedbackRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeIncomingFeedbackRequestsQuery, EmployeeIncomingFeedbackRequestsQueryVariables>;
export function useEmployeeIncomingFeedbackRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeIncomingFeedbackRequestsQuery, EmployeeIncomingFeedbackRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeIncomingFeedbackRequestsQuery | undefined, EmployeeIncomingFeedbackRequestsQueryVariables>;
export function useEmployeeIncomingFeedbackRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeIncomingFeedbackRequestsQuery, EmployeeIncomingFeedbackRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeIncomingFeedbackRequestsQuery, EmployeeIncomingFeedbackRequestsQueryVariables>(EmployeeIncomingFeedbackRequestsDocument, options);
        }
export type EmployeeIncomingFeedbackRequestsQueryHookResult = ReturnType<typeof useEmployeeIncomingFeedbackRequestsQuery>;
export type EmployeeIncomingFeedbackRequestsLazyQueryHookResult = ReturnType<typeof useEmployeeIncomingFeedbackRequestsLazyQuery>;
export type EmployeeIncomingFeedbackRequestsSuspenseQueryHookResult = ReturnType<typeof useEmployeeIncomingFeedbackRequestsSuspenseQuery>;
export type EmployeeIncomingFeedbackRequestsQueryResult = Apollo.QueryResult<EmployeeIncomingFeedbackRequestsQuery, EmployeeIncomingFeedbackRequestsQueryVariables>;
export const EmployeeListExportDocument = gql`
    query EmployeeListExport($ids: [ID!]!) {
  usersByIDs(ids: $ids) {
    id
    firstName
    lastName
    email
    username
    lastLoginAt
    externalReferenceID
    group {
      id
      name
    }
    workspaceRole {
      id
      role {
        id
      }
    }
  }
}
    `;

/**
 * __useEmployeeListExportQuery__
 *
 * To run a query within a React component, call `useEmployeeListExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeListExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeListExportQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useEmployeeListExportQuery(baseOptions: Apollo.QueryHookOptions<EmployeeListExportQuery, EmployeeListExportQueryVariables> & ({ variables: EmployeeListExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeListExportQuery, EmployeeListExportQueryVariables>(EmployeeListExportDocument, options);
      }
export function useEmployeeListExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeListExportQuery, EmployeeListExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeListExportQuery, EmployeeListExportQueryVariables>(EmployeeListExportDocument, options);
        }
// @ts-ignore
export function useEmployeeListExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeListExportQuery, EmployeeListExportQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeListExportQuery, EmployeeListExportQueryVariables>;
export function useEmployeeListExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeListExportQuery, EmployeeListExportQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeListExportQuery | undefined, EmployeeListExportQueryVariables>;
export function useEmployeeListExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeListExportQuery, EmployeeListExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeListExportQuery, EmployeeListExportQueryVariables>(EmployeeListExportDocument, options);
        }
export type EmployeeListExportQueryHookResult = ReturnType<typeof useEmployeeListExportQuery>;
export type EmployeeListExportLazyQueryHookResult = ReturnType<typeof useEmployeeListExportLazyQuery>;
export type EmployeeListExportSuspenseQueryHookResult = ReturnType<typeof useEmployeeListExportSuspenseQuery>;
export type EmployeeListExportQueryResult = Apollo.QueryResult<EmployeeListExportQuery, EmployeeListExportQueryVariables>;
export const EmployeeMomentsDocument = gql`
    query EmployeeMoments($id: ID!) {
  user(id: $id) {
    moments {
      id
      status
      startDate
      endDate
      momentTemplate {
        id
        type
        title
        description
      }
    }
  }
}
    `;

/**
 * __useEmployeeMomentsQuery__
 *
 * To run a query within a React component, call `useEmployeeMomentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeMomentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeMomentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeMomentsQuery(baseOptions: Apollo.QueryHookOptions<EmployeeMomentsQuery, EmployeeMomentsQueryVariables> & ({ variables: EmployeeMomentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeMomentsQuery, EmployeeMomentsQueryVariables>(EmployeeMomentsDocument, options);
      }
export function useEmployeeMomentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeMomentsQuery, EmployeeMomentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeMomentsQuery, EmployeeMomentsQueryVariables>(EmployeeMomentsDocument, options);
        }
// @ts-ignore
export function useEmployeeMomentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeMomentsQuery, EmployeeMomentsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeMomentsQuery, EmployeeMomentsQueryVariables>;
export function useEmployeeMomentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeMomentsQuery, EmployeeMomentsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeMomentsQuery | undefined, EmployeeMomentsQueryVariables>;
export function useEmployeeMomentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeMomentsQuery, EmployeeMomentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeMomentsQuery, EmployeeMomentsQueryVariables>(EmployeeMomentsDocument, options);
        }
export type EmployeeMomentsQueryHookResult = ReturnType<typeof useEmployeeMomentsQuery>;
export type EmployeeMomentsLazyQueryHookResult = ReturnType<typeof useEmployeeMomentsLazyQuery>;
export type EmployeeMomentsSuspenseQueryHookResult = ReturnType<typeof useEmployeeMomentsSuspenseQuery>;
export type EmployeeMomentsQueryResult = Apollo.QueryResult<EmployeeMomentsQuery, EmployeeMomentsQueryVariables>;
export const EmployeeOutgoingFeedbackResponsesDocument = gql`
    query EmployeeOutgoingFeedbackResponses($userID: ID!, $before: ID, $last: Int!) {
  user(id: $userID) {
    id
    firstName
    viewerCanRequestFeedback
    outgoingFeedbackResponses(before: $before, last: $last) {
      edges {
        node {
          id
          title
          dueDate
          sharedAt
          requestor {
            id
            firstName
            lastName
            avatar {
              source {
                url
              }
            }
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useEmployeeOutgoingFeedbackResponsesQuery__
 *
 * To run a query within a React component, call `useEmployeeOutgoingFeedbackResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeOutgoingFeedbackResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeOutgoingFeedbackResponsesQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useEmployeeOutgoingFeedbackResponsesQuery(baseOptions: Apollo.QueryHookOptions<EmployeeOutgoingFeedbackResponsesQuery, EmployeeOutgoingFeedbackResponsesQueryVariables> & ({ variables: EmployeeOutgoingFeedbackResponsesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeOutgoingFeedbackResponsesQuery, EmployeeOutgoingFeedbackResponsesQueryVariables>(EmployeeOutgoingFeedbackResponsesDocument, options);
      }
export function useEmployeeOutgoingFeedbackResponsesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeOutgoingFeedbackResponsesQuery, EmployeeOutgoingFeedbackResponsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeOutgoingFeedbackResponsesQuery, EmployeeOutgoingFeedbackResponsesQueryVariables>(EmployeeOutgoingFeedbackResponsesDocument, options);
        }
// @ts-ignore
export function useEmployeeOutgoingFeedbackResponsesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeOutgoingFeedbackResponsesQuery, EmployeeOutgoingFeedbackResponsesQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeOutgoingFeedbackResponsesQuery, EmployeeOutgoingFeedbackResponsesQueryVariables>;
export function useEmployeeOutgoingFeedbackResponsesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeOutgoingFeedbackResponsesQuery, EmployeeOutgoingFeedbackResponsesQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeOutgoingFeedbackResponsesQuery | undefined, EmployeeOutgoingFeedbackResponsesQueryVariables>;
export function useEmployeeOutgoingFeedbackResponsesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeOutgoingFeedbackResponsesQuery, EmployeeOutgoingFeedbackResponsesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeOutgoingFeedbackResponsesQuery, EmployeeOutgoingFeedbackResponsesQueryVariables>(EmployeeOutgoingFeedbackResponsesDocument, options);
        }
export type EmployeeOutgoingFeedbackResponsesQueryHookResult = ReturnType<typeof useEmployeeOutgoingFeedbackResponsesQuery>;
export type EmployeeOutgoingFeedbackResponsesLazyQueryHookResult = ReturnType<typeof useEmployeeOutgoingFeedbackResponsesLazyQuery>;
export type EmployeeOutgoingFeedbackResponsesSuspenseQueryHookResult = ReturnType<typeof useEmployeeOutgoingFeedbackResponsesSuspenseQuery>;
export type EmployeeOutgoingFeedbackResponsesQueryResult = Apollo.QueryResult<EmployeeOutgoingFeedbackResponsesQuery, EmployeeOutgoingFeedbackResponsesQueryVariables>;
export const EvaluationSubmissionDocument = gql`
    query EvaluationSubmission($id: ID!) {
  evaluationSubmission(id: $id) {
    ...EvaluationSubmission
  }
}
    ${EvaluationSubmissionFragmentDoc}`;

/**
 * __useEvaluationSubmissionQuery__
 *
 * To run a query within a React component, call `useEvaluationSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluationSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluationSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEvaluationSubmissionQuery(baseOptions: Apollo.QueryHookOptions<EvaluationSubmissionQuery, EvaluationSubmissionQueryVariables> & ({ variables: EvaluationSubmissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvaluationSubmissionQuery, EvaluationSubmissionQueryVariables>(EvaluationSubmissionDocument, options);
      }
export function useEvaluationSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EvaluationSubmissionQuery, EvaluationSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvaluationSubmissionQuery, EvaluationSubmissionQueryVariables>(EvaluationSubmissionDocument, options);
        }
// @ts-ignore
export function useEvaluationSubmissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EvaluationSubmissionQuery, EvaluationSubmissionQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationSubmissionQuery, EvaluationSubmissionQueryVariables>;
export function useEvaluationSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationSubmissionQuery, EvaluationSubmissionQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationSubmissionQuery | undefined, EvaluationSubmissionQueryVariables>;
export function useEvaluationSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationSubmissionQuery, EvaluationSubmissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EvaluationSubmissionQuery, EvaluationSubmissionQueryVariables>(EvaluationSubmissionDocument, options);
        }
export type EvaluationSubmissionQueryHookResult = ReturnType<typeof useEvaluationSubmissionQuery>;
export type EvaluationSubmissionLazyQueryHookResult = ReturnType<typeof useEvaluationSubmissionLazyQuery>;
export type EvaluationSubmissionSuspenseQueryHookResult = ReturnType<typeof useEvaluationSubmissionSuspenseQuery>;
export type EvaluationSubmissionQueryResult = Apollo.QueryResult<EvaluationSubmissionQuery, EvaluationSubmissionQueryVariables>;
export const EvaluationSubmissionsDocument = gql`
    query EvaluationSubmissions($userID: ID!, $isArchived: Boolean!, $before: ID, $last: Int) {
  user(id: $userID) {
    id
    evaluationSubmissions(isArchived: $isArchived, before: $before, last: $last) {
      edges {
        node {
          ...EvaluationSubmissionCard
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
}
    ${EvaluationSubmissionCardFragmentDoc}`;

/**
 * __useEvaluationSubmissionsQuery__
 *
 * To run a query within a React component, call `useEvaluationSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluationSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluationSubmissionsQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useEvaluationSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<EvaluationSubmissionsQuery, EvaluationSubmissionsQueryVariables> & ({ variables: EvaluationSubmissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvaluationSubmissionsQuery, EvaluationSubmissionsQueryVariables>(EvaluationSubmissionsDocument, options);
      }
export function useEvaluationSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EvaluationSubmissionsQuery, EvaluationSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvaluationSubmissionsQuery, EvaluationSubmissionsQueryVariables>(EvaluationSubmissionsDocument, options);
        }
// @ts-ignore
export function useEvaluationSubmissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EvaluationSubmissionsQuery, EvaluationSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationSubmissionsQuery, EvaluationSubmissionsQueryVariables>;
export function useEvaluationSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationSubmissionsQuery, EvaluationSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationSubmissionsQuery | undefined, EvaluationSubmissionsQueryVariables>;
export function useEvaluationSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationSubmissionsQuery, EvaluationSubmissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EvaluationSubmissionsQuery, EvaluationSubmissionsQueryVariables>(EvaluationSubmissionsDocument, options);
        }
export type EvaluationSubmissionsQueryHookResult = ReturnType<typeof useEvaluationSubmissionsQuery>;
export type EvaluationSubmissionsLazyQueryHookResult = ReturnType<typeof useEvaluationSubmissionsLazyQuery>;
export type EvaluationSubmissionsSuspenseQueryHookResult = ReturnType<typeof useEvaluationSubmissionsSuspenseQuery>;
export type EvaluationSubmissionsQueryResult = Apollo.QueryResult<EvaluationSubmissionsQuery, EvaluationSubmissionsQueryVariables>;
export const EvaluationSubmissionsForJourneyDocument = gql`
    query EvaluationSubmissionsForJourney($userID: ID!) {
  user(id: $userID) {
    id
    evaluationSubmissions(isArchived: false, first: 100) {
      edges {
        node {
          id
          evaluationForm {
            title
          }
          employee {
            status
          }
          createdOnDateTimeOffsetUtc: createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useEvaluationSubmissionsForJourneyQuery__
 *
 * To run a query within a React component, call `useEvaluationSubmissionsForJourneyQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluationSubmissionsForJourneyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluationSubmissionsForJourneyQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useEvaluationSubmissionsForJourneyQuery(baseOptions: Apollo.QueryHookOptions<EvaluationSubmissionsForJourneyQuery, EvaluationSubmissionsForJourneyQueryVariables> & ({ variables: EvaluationSubmissionsForJourneyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvaluationSubmissionsForJourneyQuery, EvaluationSubmissionsForJourneyQueryVariables>(EvaluationSubmissionsForJourneyDocument, options);
      }
export function useEvaluationSubmissionsForJourneyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EvaluationSubmissionsForJourneyQuery, EvaluationSubmissionsForJourneyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvaluationSubmissionsForJourneyQuery, EvaluationSubmissionsForJourneyQueryVariables>(EvaluationSubmissionsForJourneyDocument, options);
        }
// @ts-ignore
export function useEvaluationSubmissionsForJourneySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EvaluationSubmissionsForJourneyQuery, EvaluationSubmissionsForJourneyQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationSubmissionsForJourneyQuery, EvaluationSubmissionsForJourneyQueryVariables>;
export function useEvaluationSubmissionsForJourneySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationSubmissionsForJourneyQuery, EvaluationSubmissionsForJourneyQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationSubmissionsForJourneyQuery | undefined, EvaluationSubmissionsForJourneyQueryVariables>;
export function useEvaluationSubmissionsForJourneySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationSubmissionsForJourneyQuery, EvaluationSubmissionsForJourneyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EvaluationSubmissionsForJourneyQuery, EvaluationSubmissionsForJourneyQueryVariables>(EvaluationSubmissionsForJourneyDocument, options);
        }
export type EvaluationSubmissionsForJourneyQueryHookResult = ReturnType<typeof useEvaluationSubmissionsForJourneyQuery>;
export type EvaluationSubmissionsForJourneyLazyQueryHookResult = ReturnType<typeof useEvaluationSubmissionsForJourneyLazyQuery>;
export type EvaluationSubmissionsForJourneySuspenseQueryHookResult = ReturnType<typeof useEvaluationSubmissionsForJourneySuspenseQuery>;
export type EvaluationSubmissionsForJourneyQueryResult = Apollo.QueryResult<EvaluationSubmissionsForJourneyQuery, EvaluationSubmissionsForJourneyQueryVariables>;
export const EvaluationSubmissionsFutureForecastDocument = gql`
    query EvaluationSubmissionsFutureForecast($isArchived: Boolean!, $after: DateTime) {
  viewer {
    id
    outgoingEvaluationSubmissions(isArchived: $isArchived, first: 1000) {
      edges {
        node {
          ...EvaluationSubmissionCard
          manager {
            hasShared
          }
          employee {
            status
            requiresInput
            party
            user {
              id
              firstName
              lastName
              currentJobPosition {
                id
                jobTitle {
                  id
                  title
                }
              }
              avatar {
                id
                source {
                  url
                }
              }
            }
          }
        }
      }
    }
    managees(recurse: true) {
      id
      firstName
      lastName
      avatar {
        id
        source {
          url
        }
      }
      currentJobPosition {
        id
        jobTitle {
          id
          title
        }
      }
      moments(status: OPEN, type: EVALUATION, after: $after) {
        id
        momentTemplate {
          id
          evaluation {
            evaluationForm {
              id
              title
            }
          }
        }
        endDate
      }
    }
  }
}
    ${EvaluationSubmissionCardFragmentDoc}`;

/**
 * __useEvaluationSubmissionsFutureForecastQuery__
 *
 * To run a query within a React component, call `useEvaluationSubmissionsFutureForecastQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluationSubmissionsFutureForecastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluationSubmissionsFutureForecastQuery({
 *   variables: {
 *      isArchived: // value for 'isArchived'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useEvaluationSubmissionsFutureForecastQuery(baseOptions: Apollo.QueryHookOptions<EvaluationSubmissionsFutureForecastQuery, EvaluationSubmissionsFutureForecastQueryVariables> & ({ variables: EvaluationSubmissionsFutureForecastQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvaluationSubmissionsFutureForecastQuery, EvaluationSubmissionsFutureForecastQueryVariables>(EvaluationSubmissionsFutureForecastDocument, options);
      }
export function useEvaluationSubmissionsFutureForecastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EvaluationSubmissionsFutureForecastQuery, EvaluationSubmissionsFutureForecastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvaluationSubmissionsFutureForecastQuery, EvaluationSubmissionsFutureForecastQueryVariables>(EvaluationSubmissionsFutureForecastDocument, options);
        }
// @ts-ignore
export function useEvaluationSubmissionsFutureForecastSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EvaluationSubmissionsFutureForecastQuery, EvaluationSubmissionsFutureForecastQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationSubmissionsFutureForecastQuery, EvaluationSubmissionsFutureForecastQueryVariables>;
export function useEvaluationSubmissionsFutureForecastSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationSubmissionsFutureForecastQuery, EvaluationSubmissionsFutureForecastQueryVariables>): Apollo.UseSuspenseQueryResult<EvaluationSubmissionsFutureForecastQuery | undefined, EvaluationSubmissionsFutureForecastQueryVariables>;
export function useEvaluationSubmissionsFutureForecastSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EvaluationSubmissionsFutureForecastQuery, EvaluationSubmissionsFutureForecastQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EvaluationSubmissionsFutureForecastQuery, EvaluationSubmissionsFutureForecastQueryVariables>(EvaluationSubmissionsFutureForecastDocument, options);
        }
export type EvaluationSubmissionsFutureForecastQueryHookResult = ReturnType<typeof useEvaluationSubmissionsFutureForecastQuery>;
export type EvaluationSubmissionsFutureForecastLazyQueryHookResult = ReturnType<typeof useEvaluationSubmissionsFutureForecastLazyQuery>;
export type EvaluationSubmissionsFutureForecastSuspenseQueryHookResult = ReturnType<typeof useEvaluationSubmissionsFutureForecastSuspenseQuery>;
export type EvaluationSubmissionsFutureForecastQueryResult = Apollo.QueryResult<EvaluationSubmissionsFutureForecastQuery, EvaluationSubmissionsFutureForecastQueryVariables>;
export const ExportUsersDocument = gql`
    query ExportUsers($input: ExportUsersInput!) {
  exportUsers(input: $input) {
    url
  }
}
    `;

/**
 * __useExportUsersQuery__
 *
 * To run a query within a React component, call `useExportUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportUsersQuery(baseOptions: Apollo.QueryHookOptions<ExportUsersQuery, ExportUsersQueryVariables> & ({ variables: ExportUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportUsersQuery, ExportUsersQueryVariables>(ExportUsersDocument, options);
      }
export function useExportUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportUsersQuery, ExportUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportUsersQuery, ExportUsersQueryVariables>(ExportUsersDocument, options);
        }
// @ts-ignore
export function useExportUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportUsersQuery, ExportUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ExportUsersQuery, ExportUsersQueryVariables>;
export function useExportUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportUsersQuery, ExportUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ExportUsersQuery | undefined, ExportUsersQueryVariables>;
export function useExportUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportUsersQuery, ExportUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportUsersQuery, ExportUsersQueryVariables>(ExportUsersDocument, options);
        }
export type ExportUsersQueryHookResult = ReturnType<typeof useExportUsersQuery>;
export type ExportUsersLazyQueryHookResult = ReturnType<typeof useExportUsersLazyQuery>;
export type ExportUsersSuspenseQueryHookResult = ReturnType<typeof useExportUsersSuspenseQuery>;
export type ExportUsersQueryResult = Apollo.QueryResult<ExportUsersQuery, ExportUsersQueryVariables>;
export const FeedbackSharedWithUserDocument = gql`
    query FeedbackSharedWithUser($userID: ID!) {
  user(id: $userID) {
    sharedFeedback {
      edges {
        node {
          ...SharedBy
        }
      }
    }
  }
}
    ${SharedByFragmentDoc}`;

/**
 * __useFeedbackSharedWithUserQuery__
 *
 * To run a query within a React component, call `useFeedbackSharedWithUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackSharedWithUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackSharedWithUserQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useFeedbackSharedWithUserQuery(baseOptions: Apollo.QueryHookOptions<FeedbackSharedWithUserQuery, FeedbackSharedWithUserQueryVariables> & ({ variables: FeedbackSharedWithUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackSharedWithUserQuery, FeedbackSharedWithUserQueryVariables>(FeedbackSharedWithUserDocument, options);
      }
export function useFeedbackSharedWithUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackSharedWithUserQuery, FeedbackSharedWithUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackSharedWithUserQuery, FeedbackSharedWithUserQueryVariables>(FeedbackSharedWithUserDocument, options);
        }
// @ts-ignore
export function useFeedbackSharedWithUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeedbackSharedWithUserQuery, FeedbackSharedWithUserQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackSharedWithUserQuery, FeedbackSharedWithUserQueryVariables>;
export function useFeedbackSharedWithUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackSharedWithUserQuery, FeedbackSharedWithUserQueryVariables>): Apollo.UseSuspenseQueryResult<FeedbackSharedWithUserQuery | undefined, FeedbackSharedWithUserQueryVariables>;
export function useFeedbackSharedWithUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedbackSharedWithUserQuery, FeedbackSharedWithUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedbackSharedWithUserQuery, FeedbackSharedWithUserQueryVariables>(FeedbackSharedWithUserDocument, options);
        }
export type FeedbackSharedWithUserQueryHookResult = ReturnType<typeof useFeedbackSharedWithUserQuery>;
export type FeedbackSharedWithUserLazyQueryHookResult = ReturnType<typeof useFeedbackSharedWithUserLazyQuery>;
export type FeedbackSharedWithUserSuspenseQueryHookResult = ReturnType<typeof useFeedbackSharedWithUserSuspenseQuery>;
export type FeedbackSharedWithUserQueryResult = Apollo.QueryResult<FeedbackSharedWithUserQuery, FeedbackSharedWithUserQueryVariables>;
export const InboxPersonalInformationDocument = gql`
    query InboxPersonalInformation {
  viewer {
    id
    firstName
    lastName
    avatar {
      source {
        url
      }
    }
    mission
    currentJobPosition {
      id
      jobTitle {
        id
        title
        description
      }
    }
  }
}
    `;

/**
 * __useInboxPersonalInformationQuery__
 *
 * To run a query within a React component, call `useInboxPersonalInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxPersonalInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxPersonalInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useInboxPersonalInformationQuery(baseOptions?: Apollo.QueryHookOptions<InboxPersonalInformationQuery, InboxPersonalInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxPersonalInformationQuery, InboxPersonalInformationQueryVariables>(InboxPersonalInformationDocument, options);
      }
export function useInboxPersonalInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxPersonalInformationQuery, InboxPersonalInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxPersonalInformationQuery, InboxPersonalInformationQueryVariables>(InboxPersonalInformationDocument, options);
        }
// @ts-ignore
export function useInboxPersonalInformationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InboxPersonalInformationQuery, InboxPersonalInformationQueryVariables>): Apollo.UseSuspenseQueryResult<InboxPersonalInformationQuery, InboxPersonalInformationQueryVariables>;
export function useInboxPersonalInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InboxPersonalInformationQuery, InboxPersonalInformationQueryVariables>): Apollo.UseSuspenseQueryResult<InboxPersonalInformationQuery | undefined, InboxPersonalInformationQueryVariables>;
export function useInboxPersonalInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InboxPersonalInformationQuery, InboxPersonalInformationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InboxPersonalInformationQuery, InboxPersonalInformationQueryVariables>(InboxPersonalInformationDocument, options);
        }
export type InboxPersonalInformationQueryHookResult = ReturnType<typeof useInboxPersonalInformationQuery>;
export type InboxPersonalInformationLazyQueryHookResult = ReturnType<typeof useInboxPersonalInformationLazyQuery>;
export type InboxPersonalInformationSuspenseQueryHookResult = ReturnType<typeof useInboxPersonalInformationSuspenseQuery>;
export type InboxPersonalInformationQueryResult = Apollo.QueryResult<InboxPersonalInformationQuery, InboxPersonalInformationQueryVariables>;
export const ManagerEmployeeConversationsDocument = gql`
    query ManagerEmployeeConversations($userID: ID!, $isArchived: Boolean!, $before: ID, $last: Int) {
  user(id: $userID) {
    id
    evaluationSubmissions(isArchived: $isArchived, before: $before, last: $last) {
      edges {
        node {
          ...EvaluationSubmissionCard
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
}
    ${EvaluationSubmissionCardFragmentDoc}`;

/**
 * __useManagerEmployeeConversationsQuery__
 *
 * To run a query within a React component, call `useManagerEmployeeConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagerEmployeeConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagerEmployeeConversationsQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useManagerEmployeeConversationsQuery(baseOptions: Apollo.QueryHookOptions<ManagerEmployeeConversationsQuery, ManagerEmployeeConversationsQueryVariables> & ({ variables: ManagerEmployeeConversationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagerEmployeeConversationsQuery, ManagerEmployeeConversationsQueryVariables>(ManagerEmployeeConversationsDocument, options);
      }
export function useManagerEmployeeConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagerEmployeeConversationsQuery, ManagerEmployeeConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagerEmployeeConversationsQuery, ManagerEmployeeConversationsQueryVariables>(ManagerEmployeeConversationsDocument, options);
        }
// @ts-ignore
export function useManagerEmployeeConversationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ManagerEmployeeConversationsQuery, ManagerEmployeeConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<ManagerEmployeeConversationsQuery, ManagerEmployeeConversationsQueryVariables>;
export function useManagerEmployeeConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ManagerEmployeeConversationsQuery, ManagerEmployeeConversationsQueryVariables>): Apollo.UseSuspenseQueryResult<ManagerEmployeeConversationsQuery | undefined, ManagerEmployeeConversationsQueryVariables>;
export function useManagerEmployeeConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ManagerEmployeeConversationsQuery, ManagerEmployeeConversationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ManagerEmployeeConversationsQuery, ManagerEmployeeConversationsQueryVariables>(ManagerEmployeeConversationsDocument, options);
        }
export type ManagerEmployeeConversationsQueryHookResult = ReturnType<typeof useManagerEmployeeConversationsQuery>;
export type ManagerEmployeeConversationsLazyQueryHookResult = ReturnType<typeof useManagerEmployeeConversationsLazyQuery>;
export type ManagerEmployeeConversationsSuspenseQueryHookResult = ReturnType<typeof useManagerEmployeeConversationsSuspenseQuery>;
export type ManagerEmployeeConversationsQueryResult = Apollo.QueryResult<ManagerEmployeeConversationsQuery, ManagerEmployeeConversationsQueryVariables>;
export const ManagerEmployeeFeedbackRequestsDocument = gql`
    query ManagerEmployeeFeedbackRequests($userID: ID!, $isArchived: Boolean!, $before: ID, $last: Int!) {
  user(id: $userID) {
    id
    firstName
    viewerCanRequestFeedback
    feedbackRequests(isArchived: $isArchived, before: $before, last: $last) {
      edges {
        node {
          id
          title
          createdAt
          dueDate
          isArchived
          mode
          instruction
          responses(isArchived: false, first: 1000) {
            edges {
              node {
                id
                status
                recipient {
                  ... on User {
                    id
                    firstName
                    lastName
                    avatar {
                      id
                      source {
                        url
                      }
                    }
                  }
                  ... on FeedbackExternal {
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useManagerEmployeeFeedbackRequestsQuery__
 *
 * To run a query within a React component, call `useManagerEmployeeFeedbackRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagerEmployeeFeedbackRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagerEmployeeFeedbackRequestsQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useManagerEmployeeFeedbackRequestsQuery(baseOptions: Apollo.QueryHookOptions<ManagerEmployeeFeedbackRequestsQuery, ManagerEmployeeFeedbackRequestsQueryVariables> & ({ variables: ManagerEmployeeFeedbackRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagerEmployeeFeedbackRequestsQuery, ManagerEmployeeFeedbackRequestsQueryVariables>(ManagerEmployeeFeedbackRequestsDocument, options);
      }
export function useManagerEmployeeFeedbackRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagerEmployeeFeedbackRequestsQuery, ManagerEmployeeFeedbackRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagerEmployeeFeedbackRequestsQuery, ManagerEmployeeFeedbackRequestsQueryVariables>(ManagerEmployeeFeedbackRequestsDocument, options);
        }
// @ts-ignore
export function useManagerEmployeeFeedbackRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ManagerEmployeeFeedbackRequestsQuery, ManagerEmployeeFeedbackRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<ManagerEmployeeFeedbackRequestsQuery, ManagerEmployeeFeedbackRequestsQueryVariables>;
export function useManagerEmployeeFeedbackRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ManagerEmployeeFeedbackRequestsQuery, ManagerEmployeeFeedbackRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<ManagerEmployeeFeedbackRequestsQuery | undefined, ManagerEmployeeFeedbackRequestsQueryVariables>;
export function useManagerEmployeeFeedbackRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ManagerEmployeeFeedbackRequestsQuery, ManagerEmployeeFeedbackRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ManagerEmployeeFeedbackRequestsQuery, ManagerEmployeeFeedbackRequestsQueryVariables>(ManagerEmployeeFeedbackRequestsDocument, options);
        }
export type ManagerEmployeeFeedbackRequestsQueryHookResult = ReturnType<typeof useManagerEmployeeFeedbackRequestsQuery>;
export type ManagerEmployeeFeedbackRequestsLazyQueryHookResult = ReturnType<typeof useManagerEmployeeFeedbackRequestsLazyQuery>;
export type ManagerEmployeeFeedbackRequestsSuspenseQueryHookResult = ReturnType<typeof useManagerEmployeeFeedbackRequestsSuspenseQuery>;
export type ManagerEmployeeFeedbackRequestsQueryResult = Apollo.QueryResult<ManagerEmployeeFeedbackRequestsQuery, ManagerEmployeeFeedbackRequestsQueryVariables>;
export const ManagerEmployeeGoalsDocument = gql`
    query ManagerEmployeeGoals($id: ID!, $status: GoalStatus!, $before: ID, $last: Int!) {
  user(id: $id) {
    id
    goalsV2(status: $status, before: $before, last: $last) {
      edges {
        node {
          ...MetaGoal
          ...GoalWithOwner
        }
      }
      pageInfo {
        ...PageInfo
      }
      totalCount
    }
  }
}
    ${MetaGoalFragmentDoc}
${GoalWithOwnerFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useManagerEmployeeGoalsQuery__
 *
 * To run a query within a React component, call `useManagerEmployeeGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagerEmployeeGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagerEmployeeGoalsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useManagerEmployeeGoalsQuery(baseOptions: Apollo.QueryHookOptions<ManagerEmployeeGoalsQuery, ManagerEmployeeGoalsQueryVariables> & ({ variables: ManagerEmployeeGoalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagerEmployeeGoalsQuery, ManagerEmployeeGoalsQueryVariables>(ManagerEmployeeGoalsDocument, options);
      }
export function useManagerEmployeeGoalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagerEmployeeGoalsQuery, ManagerEmployeeGoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagerEmployeeGoalsQuery, ManagerEmployeeGoalsQueryVariables>(ManagerEmployeeGoalsDocument, options);
        }
// @ts-ignore
export function useManagerEmployeeGoalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ManagerEmployeeGoalsQuery, ManagerEmployeeGoalsQueryVariables>): Apollo.UseSuspenseQueryResult<ManagerEmployeeGoalsQuery, ManagerEmployeeGoalsQueryVariables>;
export function useManagerEmployeeGoalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ManagerEmployeeGoalsQuery, ManagerEmployeeGoalsQueryVariables>): Apollo.UseSuspenseQueryResult<ManagerEmployeeGoalsQuery | undefined, ManagerEmployeeGoalsQueryVariables>;
export function useManagerEmployeeGoalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ManagerEmployeeGoalsQuery, ManagerEmployeeGoalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ManagerEmployeeGoalsQuery, ManagerEmployeeGoalsQueryVariables>(ManagerEmployeeGoalsDocument, options);
        }
export type ManagerEmployeeGoalsQueryHookResult = ReturnType<typeof useManagerEmployeeGoalsQuery>;
export type ManagerEmployeeGoalsLazyQueryHookResult = ReturnType<typeof useManagerEmployeeGoalsLazyQuery>;
export type ManagerEmployeeGoalsSuspenseQueryHookResult = ReturnType<typeof useManagerEmployeeGoalsSuspenseQuery>;
export type ManagerEmployeeGoalsQueryResult = Apollo.QueryResult<ManagerEmployeeGoalsQuery, ManagerEmployeeGoalsQueryVariables>;
export const MigrationEmployeesDocument = gql`
    query MigrationEmployees($status: UserStatus, $first: Int) {
  users(status: $status, first: $first) {
    edges {
      node {
        id
        firstName
        lastName
        email
        username
        locale
        externalReferenceID
        group {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useMigrationEmployeesQuery__
 *
 * To run a query within a React component, call `useMigrationEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMigrationEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMigrationEmployeesQuery({
 *   variables: {
 *      status: // value for 'status'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useMigrationEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<MigrationEmployeesQuery, MigrationEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MigrationEmployeesQuery, MigrationEmployeesQueryVariables>(MigrationEmployeesDocument, options);
      }
export function useMigrationEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MigrationEmployeesQuery, MigrationEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MigrationEmployeesQuery, MigrationEmployeesQueryVariables>(MigrationEmployeesDocument, options);
        }
// @ts-ignore
export function useMigrationEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MigrationEmployeesQuery, MigrationEmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<MigrationEmployeesQuery, MigrationEmployeesQueryVariables>;
export function useMigrationEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MigrationEmployeesQuery, MigrationEmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<MigrationEmployeesQuery | undefined, MigrationEmployeesQueryVariables>;
export function useMigrationEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MigrationEmployeesQuery, MigrationEmployeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MigrationEmployeesQuery, MigrationEmployeesQueryVariables>(MigrationEmployeesDocument, options);
        }
export type MigrationEmployeesQueryHookResult = ReturnType<typeof useMigrationEmployeesQuery>;
export type MigrationEmployeesLazyQueryHookResult = ReturnType<typeof useMigrationEmployeesLazyQuery>;
export type MigrationEmployeesSuspenseQueryHookResult = ReturnType<typeof useMigrationEmployeesSuspenseQuery>;
export type MigrationEmployeesQueryResult = Apollo.QueryResult<MigrationEmployeesQuery, MigrationEmployeesQueryVariables>;
export const OrganizationEmployeesDocument = gql`
    query OrganizationEmployees($status: UserStatus, $before: ID, $after: ID, $first: Int, $last: Int) {
  users(
    status: $status
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        id
        firstName
        lastName
        normalizedName
        username
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useOrganizationEmployeesQuery__
 *
 * To run a query within a React component, call `useOrganizationEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationEmployeesQuery({
 *   variables: {
 *      status: // value for 'status'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useOrganizationEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationEmployeesQuery, OrganizationEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationEmployeesQuery, OrganizationEmployeesQueryVariables>(OrganizationEmployeesDocument, options);
      }
export function useOrganizationEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationEmployeesQuery, OrganizationEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationEmployeesQuery, OrganizationEmployeesQueryVariables>(OrganizationEmployeesDocument, options);
        }
// @ts-ignore
export function useOrganizationEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationEmployeesQuery, OrganizationEmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationEmployeesQuery, OrganizationEmployeesQueryVariables>;
export function useOrganizationEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationEmployeesQuery, OrganizationEmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationEmployeesQuery | undefined, OrganizationEmployeesQueryVariables>;
export function useOrganizationEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationEmployeesQuery, OrganizationEmployeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationEmployeesQuery, OrganizationEmployeesQueryVariables>(OrganizationEmployeesDocument, options);
        }
export type OrganizationEmployeesQueryHookResult = ReturnType<typeof useOrganizationEmployeesQuery>;
export type OrganizationEmployeesLazyQueryHookResult = ReturnType<typeof useOrganizationEmployeesLazyQuery>;
export type OrganizationEmployeesSuspenseQueryHookResult = ReturnType<typeof useOrganizationEmployeesSuspenseQuery>;
export type OrganizationEmployeesQueryResult = Apollo.QueryResult<OrganizationEmployeesQuery, OrganizationEmployeesQueryVariables>;
export const OutgoingEvaluationSubmissionsDocument = gql`
    query OutgoingEvaluationSubmissions($userID: ID!, $isArchived: Boolean!, $before: ID, $last: Int) {
  user(id: $userID) {
    id
    outgoingEvaluationSubmissions(
      isArchived: $isArchived
      before: $before
      last: $last
    ) {
      edges {
        node {
          ...EvaluationSubmissionCard
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
}
    ${EvaluationSubmissionCardFragmentDoc}`;

/**
 * __useOutgoingEvaluationSubmissionsQuery__
 *
 * To run a query within a React component, call `useOutgoingEvaluationSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutgoingEvaluationSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutgoingEvaluationSubmissionsQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *      isArchived: // value for 'isArchived'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useOutgoingEvaluationSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<OutgoingEvaluationSubmissionsQuery, OutgoingEvaluationSubmissionsQueryVariables> & ({ variables: OutgoingEvaluationSubmissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutgoingEvaluationSubmissionsQuery, OutgoingEvaluationSubmissionsQueryVariables>(OutgoingEvaluationSubmissionsDocument, options);
      }
export function useOutgoingEvaluationSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutgoingEvaluationSubmissionsQuery, OutgoingEvaluationSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutgoingEvaluationSubmissionsQuery, OutgoingEvaluationSubmissionsQueryVariables>(OutgoingEvaluationSubmissionsDocument, options);
        }
// @ts-ignore
export function useOutgoingEvaluationSubmissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OutgoingEvaluationSubmissionsQuery, OutgoingEvaluationSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<OutgoingEvaluationSubmissionsQuery, OutgoingEvaluationSubmissionsQueryVariables>;
export function useOutgoingEvaluationSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OutgoingEvaluationSubmissionsQuery, OutgoingEvaluationSubmissionsQueryVariables>): Apollo.UseSuspenseQueryResult<OutgoingEvaluationSubmissionsQuery | undefined, OutgoingEvaluationSubmissionsQueryVariables>;
export function useOutgoingEvaluationSubmissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OutgoingEvaluationSubmissionsQuery, OutgoingEvaluationSubmissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OutgoingEvaluationSubmissionsQuery, OutgoingEvaluationSubmissionsQueryVariables>(OutgoingEvaluationSubmissionsDocument, options);
        }
export type OutgoingEvaluationSubmissionsQueryHookResult = ReturnType<typeof useOutgoingEvaluationSubmissionsQuery>;
export type OutgoingEvaluationSubmissionsLazyQueryHookResult = ReturnType<typeof useOutgoingEvaluationSubmissionsLazyQuery>;
export type OutgoingEvaluationSubmissionsSuspenseQueryHookResult = ReturnType<typeof useOutgoingEvaluationSubmissionsSuspenseQuery>;
export type OutgoingEvaluationSubmissionsQueryResult = Apollo.QueryResult<OutgoingEvaluationSubmissionsQuery, OutgoingEvaluationSubmissionsQueryVariables>;
export const PersonalNotificationSettingsDocument = gql`
    query PersonalNotificationSettings {
  viewer {
    id
    notificationSettings {
      id
      type
      channels {
        channel
        frequency
      }
    }
  }
}
    `;

/**
 * __usePersonalNotificationSettingsQuery__
 *
 * To run a query within a React component, call `usePersonalNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalNotificationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePersonalNotificationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<PersonalNotificationSettingsQuery, PersonalNotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonalNotificationSettingsQuery, PersonalNotificationSettingsQueryVariables>(PersonalNotificationSettingsDocument, options);
      }
export function usePersonalNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonalNotificationSettingsQuery, PersonalNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonalNotificationSettingsQuery, PersonalNotificationSettingsQueryVariables>(PersonalNotificationSettingsDocument, options);
        }
// @ts-ignore
export function usePersonalNotificationSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PersonalNotificationSettingsQuery, PersonalNotificationSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<PersonalNotificationSettingsQuery, PersonalNotificationSettingsQueryVariables>;
export function usePersonalNotificationSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonalNotificationSettingsQuery, PersonalNotificationSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<PersonalNotificationSettingsQuery | undefined, PersonalNotificationSettingsQueryVariables>;
export function usePersonalNotificationSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PersonalNotificationSettingsQuery, PersonalNotificationSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PersonalNotificationSettingsQuery, PersonalNotificationSettingsQueryVariables>(PersonalNotificationSettingsDocument, options);
        }
export type PersonalNotificationSettingsQueryHookResult = ReturnType<typeof usePersonalNotificationSettingsQuery>;
export type PersonalNotificationSettingsLazyQueryHookResult = ReturnType<typeof usePersonalNotificationSettingsLazyQuery>;
export type PersonalNotificationSettingsSuspenseQueryHookResult = ReturnType<typeof usePersonalNotificationSettingsSuspenseQuery>;
export type PersonalNotificationSettingsQueryResult = Apollo.QueryResult<PersonalNotificationSettingsQuery, PersonalNotificationSettingsQueryVariables>;
export const UserDocument = gql`
    query User($id: ID!) {
  user(id: $id) {
    id
    firstName
    lastName
    normalizedName
    username
    email
    mission
    locale
    activatedAt
    archivedAt
    lastLoginAt
    isArchived
    isExternal
    group {
      id
      name
    }
    avatar {
      id
      source {
        url
      }
    }
    cover {
      id
      source {
        url
      }
    }
    associatedIdentities {
      identityProvider {
        id
      }
      name
    }
    jobPositions(status: ACTIVE) {
      id
      jobTitle {
        id
        title
      }
      jobLevel {
        id
        title
      }
      startDate
      endDate
    }
    currentJobPosition {
      id
      jobTitle {
        id
        title
      }
    }
    roles {
      id
      role {
        id
        type
      }
    }
    externalReferenceID
    createdAt
    updatedAt
    isViewer
    isEmailSuppressed
    viewerCanCreateDocuments
    viewerCanRequestFeedback
    viewerCanUpdate
    viewerCanViewDocuments
    viewerCanViewEvaluations
    viewerCanViewFeedback
    viewerCanViewGoals
    viewerCanCreateGoal
    viewerCanViewJourney
    conversationAiInsightsApproved
    localDeactivatedAt
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables> & ({ variables: UserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
// @ts-ignore
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): Apollo.UseSuspenseQueryResult<UserQuery, UserQueryVariables>;
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): Apollo.UseSuspenseQueryResult<UserQuery | undefined, UserQueryVariables>;
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UserCompetenciesDocument = gql`
    query UserCompetencies($id: ID!) {
  user(id: $id) {
    ...UserCompetenciesPartial
  }
}
    ${UserCompetenciesPartialFragmentDoc}`;

/**
 * __useUserCompetenciesQuery__
 *
 * To run a query within a React component, call `useUserCompetenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCompetenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCompetenciesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserCompetenciesQuery(baseOptions: Apollo.QueryHookOptions<UserCompetenciesQuery, UserCompetenciesQueryVariables> & ({ variables: UserCompetenciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCompetenciesQuery, UserCompetenciesQueryVariables>(UserCompetenciesDocument, options);
      }
export function useUserCompetenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCompetenciesQuery, UserCompetenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCompetenciesQuery, UserCompetenciesQueryVariables>(UserCompetenciesDocument, options);
        }
// @ts-ignore
export function useUserCompetenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserCompetenciesQuery, UserCompetenciesQueryVariables>): Apollo.UseSuspenseQueryResult<UserCompetenciesQuery, UserCompetenciesQueryVariables>;
export function useUserCompetenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserCompetenciesQuery, UserCompetenciesQueryVariables>): Apollo.UseSuspenseQueryResult<UserCompetenciesQuery | undefined, UserCompetenciesQueryVariables>;
export function useUserCompetenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserCompetenciesQuery, UserCompetenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserCompetenciesQuery, UserCompetenciesQueryVariables>(UserCompetenciesDocument, options);
        }
export type UserCompetenciesQueryHookResult = ReturnType<typeof useUserCompetenciesQuery>;
export type UserCompetenciesLazyQueryHookResult = ReturnType<typeof useUserCompetenciesLazyQuery>;
export type UserCompetenciesSuspenseQueryHookResult = ReturnType<typeof useUserCompetenciesSuspenseQuery>;
export type UserCompetenciesQueryResult = Apollo.QueryResult<UserCompetenciesQuery, UserCompetenciesQueryVariables>;
export const UserComplimentsDocument = gql`
    query UserCompliments($id: ID!, $last: Int, $before: ID) {
  user(id: $id) {
    id
    firstName
    compliments(last: $last, before: $before) {
      edges {
        node {
          ...ComplimentSummary
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
}
    ${ComplimentSummaryFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useUserComplimentsQuery__
 *
 * To run a query within a React component, call `useUserComplimentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserComplimentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserComplimentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useUserComplimentsQuery(baseOptions: Apollo.QueryHookOptions<UserComplimentsQuery, UserComplimentsQueryVariables> & ({ variables: UserComplimentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserComplimentsQuery, UserComplimentsQueryVariables>(UserComplimentsDocument, options);
      }
export function useUserComplimentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserComplimentsQuery, UserComplimentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserComplimentsQuery, UserComplimentsQueryVariables>(UserComplimentsDocument, options);
        }
// @ts-ignore
export function useUserComplimentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserComplimentsQuery, UserComplimentsQueryVariables>): Apollo.UseSuspenseQueryResult<UserComplimentsQuery, UserComplimentsQueryVariables>;
export function useUserComplimentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserComplimentsQuery, UserComplimentsQueryVariables>): Apollo.UseSuspenseQueryResult<UserComplimentsQuery | undefined, UserComplimentsQueryVariables>;
export function useUserComplimentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserComplimentsQuery, UserComplimentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserComplimentsQuery, UserComplimentsQueryVariables>(UserComplimentsDocument, options);
        }
export type UserComplimentsQueryHookResult = ReturnType<typeof useUserComplimentsQuery>;
export type UserComplimentsLazyQueryHookResult = ReturnType<typeof useUserComplimentsLazyQuery>;
export type UserComplimentsSuspenseQueryHookResult = ReturnType<typeof useUserComplimentsSuspenseQuery>;
export type UserComplimentsQueryResult = Apollo.QueryResult<UserComplimentsQuery, UserComplimentsQueryVariables>;
export const UserCycleWithMomentsDocument = gql`
    query UserCycleWithMoments($id: ID!) {
  cycleInstance(id: $id) {
    id
    moments {
      status
      momentTemplate {
        type
      }
    }
  }
}
    `;

/**
 * __useUserCycleWithMomentsQuery__
 *
 * To run a query within a React component, call `useUserCycleWithMomentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCycleWithMomentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCycleWithMomentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserCycleWithMomentsQuery(baseOptions: Apollo.QueryHookOptions<UserCycleWithMomentsQuery, UserCycleWithMomentsQueryVariables> & ({ variables: UserCycleWithMomentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCycleWithMomentsQuery, UserCycleWithMomentsQueryVariables>(UserCycleWithMomentsDocument, options);
      }
export function useUserCycleWithMomentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCycleWithMomentsQuery, UserCycleWithMomentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCycleWithMomentsQuery, UserCycleWithMomentsQueryVariables>(UserCycleWithMomentsDocument, options);
        }
// @ts-ignore
export function useUserCycleWithMomentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserCycleWithMomentsQuery, UserCycleWithMomentsQueryVariables>): Apollo.UseSuspenseQueryResult<UserCycleWithMomentsQuery, UserCycleWithMomentsQueryVariables>;
export function useUserCycleWithMomentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserCycleWithMomentsQuery, UserCycleWithMomentsQueryVariables>): Apollo.UseSuspenseQueryResult<UserCycleWithMomentsQuery | undefined, UserCycleWithMomentsQueryVariables>;
export function useUserCycleWithMomentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserCycleWithMomentsQuery, UserCycleWithMomentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserCycleWithMomentsQuery, UserCycleWithMomentsQueryVariables>(UserCycleWithMomentsDocument, options);
        }
export type UserCycleWithMomentsQueryHookResult = ReturnType<typeof useUserCycleWithMomentsQuery>;
export type UserCycleWithMomentsLazyQueryHookResult = ReturnType<typeof useUserCycleWithMomentsLazyQuery>;
export type UserCycleWithMomentsSuspenseQueryHookResult = ReturnType<typeof useUserCycleWithMomentsSuspenseQuery>;
export type UserCycleWithMomentsQueryResult = Apollo.QueryResult<UserCycleWithMomentsQuery, UserCycleWithMomentsQueryVariables>;
export const UserCyclesDocument = gql`
    query UserCycles($id: ID!, $status: [CycleStatus!]) {
  user(id: $id) {
    id
    firstName
    cycles(status: $status, first: 1000) {
      edges {
        node {
          id
          startDate
          activatesAt
          deactivatesAt
          status
          cycleTemplate {
            id
            title
          }
          createdByUser {
            id
            firstName
            lastName
          }
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useUserCyclesQuery__
 *
 * To run a query within a React component, call `useUserCyclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCyclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCyclesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUserCyclesQuery(baseOptions: Apollo.QueryHookOptions<UserCyclesQuery, UserCyclesQueryVariables> & ({ variables: UserCyclesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCyclesQuery, UserCyclesQueryVariables>(UserCyclesDocument, options);
      }
export function useUserCyclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCyclesQuery, UserCyclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCyclesQuery, UserCyclesQueryVariables>(UserCyclesDocument, options);
        }
// @ts-ignore
export function useUserCyclesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserCyclesQuery, UserCyclesQueryVariables>): Apollo.UseSuspenseQueryResult<UserCyclesQuery, UserCyclesQueryVariables>;
export function useUserCyclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserCyclesQuery, UserCyclesQueryVariables>): Apollo.UseSuspenseQueryResult<UserCyclesQuery | undefined, UserCyclesQueryVariables>;
export function useUserCyclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserCyclesQuery, UserCyclesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserCyclesQuery, UserCyclesQueryVariables>(UserCyclesDocument, options);
        }
export type UserCyclesQueryHookResult = ReturnType<typeof useUserCyclesQuery>;
export type UserCyclesLazyQueryHookResult = ReturnType<typeof useUserCyclesLazyQuery>;
export type UserCyclesSuspenseQueryHookResult = ReturnType<typeof useUserCyclesSuspenseQuery>;
export type UserCyclesQueryResult = Apollo.QueryResult<UserCyclesQuery, UserCyclesQueryVariables>;
export const UserDocumentsDocument = gql`
    query UserDocuments($id: ID!) {
  user(id: $id) {
    id
    documentsV2 {
      ...UserDocumentV2
    }
  }
}
    ${UserDocumentV2FragmentDoc}`;

/**
 * __useUserDocumentsQuery__
 *
 * To run a query within a React component, call `useUserDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDocumentsQuery(baseOptions: Apollo.QueryHookOptions<UserDocumentsQuery, UserDocumentsQueryVariables> & ({ variables: UserDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDocumentsQuery, UserDocumentsQueryVariables>(UserDocumentsDocument, options);
      }
export function useUserDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDocumentsQuery, UserDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDocumentsQuery, UserDocumentsQueryVariables>(UserDocumentsDocument, options);
        }
// @ts-ignore
export function useUserDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserDocumentsQuery, UserDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<UserDocumentsQuery, UserDocumentsQueryVariables>;
export function useUserDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDocumentsQuery, UserDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<UserDocumentsQuery | undefined, UserDocumentsQueryVariables>;
export function useUserDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDocumentsQuery, UserDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserDocumentsQuery, UserDocumentsQueryVariables>(UserDocumentsDocument, options);
        }
export type UserDocumentsQueryHookResult = ReturnType<typeof useUserDocumentsQuery>;
export type UserDocumentsLazyQueryHookResult = ReturnType<typeof useUserDocumentsLazyQuery>;
export type UserDocumentsSuspenseQueryHookResult = ReturnType<typeof useUserDocumentsSuspenseQuery>;
export type UserDocumentsQueryResult = Apollo.QueryResult<UserDocumentsQuery, UserDocumentsQueryVariables>;
export const UserDownloadsDocument = gql`
    query UserDownloads($id: ID!) {
  user(id: $id) {
    id
    downloads {
      ...UserDownload
    }
  }
}
    ${UserDownloadFragmentDoc}`;

/**
 * __useUserDownloadsQuery__
 *
 * To run a query within a React component, call `useUserDownloadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDownloadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDownloadsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDownloadsQuery(baseOptions: Apollo.QueryHookOptions<UserDownloadsQuery, UserDownloadsQueryVariables> & ({ variables: UserDownloadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDownloadsQuery, UserDownloadsQueryVariables>(UserDownloadsDocument, options);
      }
export function useUserDownloadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDownloadsQuery, UserDownloadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDownloadsQuery, UserDownloadsQueryVariables>(UserDownloadsDocument, options);
        }
// @ts-ignore
export function useUserDownloadsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserDownloadsQuery, UserDownloadsQueryVariables>): Apollo.UseSuspenseQueryResult<UserDownloadsQuery, UserDownloadsQueryVariables>;
export function useUserDownloadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDownloadsQuery, UserDownloadsQueryVariables>): Apollo.UseSuspenseQueryResult<UserDownloadsQuery | undefined, UserDownloadsQueryVariables>;
export function useUserDownloadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDownloadsQuery, UserDownloadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserDownloadsQuery, UserDownloadsQueryVariables>(UserDownloadsDocument, options);
        }
export type UserDownloadsQueryHookResult = ReturnType<typeof useUserDownloadsQuery>;
export type UserDownloadsLazyQueryHookResult = ReturnType<typeof useUserDownloadsLazyQuery>;
export type UserDownloadsSuspenseQueryHookResult = ReturnType<typeof useUserDownloadsSuspenseQuery>;
export type UserDownloadsQueryResult = Apollo.QueryResult<UserDownloadsQuery, UserDownloadsQueryVariables>;
export const UserGivenComplimentsDocument = gql`
    query UserGivenCompliments($id: ID!, $last: Int, $before: ID) {
  user(id: $id) {
    id
    firstName
    givenCompliments(last: $last, before: $before) {
      edges {
        node {
          ...ComplimentSummary
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
}
    ${ComplimentSummaryFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useUserGivenComplimentsQuery__
 *
 * To run a query within a React component, call `useUserGivenComplimentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGivenComplimentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGivenComplimentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useUserGivenComplimentsQuery(baseOptions: Apollo.QueryHookOptions<UserGivenComplimentsQuery, UserGivenComplimentsQueryVariables> & ({ variables: UserGivenComplimentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGivenComplimentsQuery, UserGivenComplimentsQueryVariables>(UserGivenComplimentsDocument, options);
      }
export function useUserGivenComplimentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGivenComplimentsQuery, UserGivenComplimentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGivenComplimentsQuery, UserGivenComplimentsQueryVariables>(UserGivenComplimentsDocument, options);
        }
// @ts-ignore
export function useUserGivenComplimentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserGivenComplimentsQuery, UserGivenComplimentsQueryVariables>): Apollo.UseSuspenseQueryResult<UserGivenComplimentsQuery, UserGivenComplimentsQueryVariables>;
export function useUserGivenComplimentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserGivenComplimentsQuery, UserGivenComplimentsQueryVariables>): Apollo.UseSuspenseQueryResult<UserGivenComplimentsQuery | undefined, UserGivenComplimentsQueryVariables>;
export function useUserGivenComplimentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserGivenComplimentsQuery, UserGivenComplimentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserGivenComplimentsQuery, UserGivenComplimentsQueryVariables>(UserGivenComplimentsDocument, options);
        }
export type UserGivenComplimentsQueryHookResult = ReturnType<typeof useUserGivenComplimentsQuery>;
export type UserGivenComplimentsLazyQueryHookResult = ReturnType<typeof useUserGivenComplimentsLazyQuery>;
export type UserGivenComplimentsSuspenseQueryHookResult = ReturnType<typeof useUserGivenComplimentsSuspenseQuery>;
export type UserGivenComplimentsQueryResult = Apollo.QueryResult<UserGivenComplimentsQuery, UserGivenComplimentsQueryVariables>;
export const UserGoalTemplatesDocument = gql`
    query UserGoalTemplates($id: ID!) {
  user(id: $id) {
    id
    jobPositions(status: ACTIVE) {
      id
      jobLevel {
        id
        title
      }
      jobTitle {
        id
        title
        goalTemplates(first: 100) {
          edges {
            cursor
            node {
              ...GoalTemplate
            }
          }
        }
      }
    }
  }
}
    ${GoalTemplateFragmentDoc}`;

/**
 * __useUserGoalTemplatesQuery__
 *
 * To run a query within a React component, call `useUserGoalTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGoalTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGoalTemplatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserGoalTemplatesQuery(baseOptions: Apollo.QueryHookOptions<UserGoalTemplatesQuery, UserGoalTemplatesQueryVariables> & ({ variables: UserGoalTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGoalTemplatesQuery, UserGoalTemplatesQueryVariables>(UserGoalTemplatesDocument, options);
      }
export function useUserGoalTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGoalTemplatesQuery, UserGoalTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGoalTemplatesQuery, UserGoalTemplatesQueryVariables>(UserGoalTemplatesDocument, options);
        }
// @ts-ignore
export function useUserGoalTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserGoalTemplatesQuery, UserGoalTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<UserGoalTemplatesQuery, UserGoalTemplatesQueryVariables>;
export function useUserGoalTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserGoalTemplatesQuery, UserGoalTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<UserGoalTemplatesQuery | undefined, UserGoalTemplatesQueryVariables>;
export function useUserGoalTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserGoalTemplatesQuery, UserGoalTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserGoalTemplatesQuery, UserGoalTemplatesQueryVariables>(UserGoalTemplatesDocument, options);
        }
export type UserGoalTemplatesQueryHookResult = ReturnType<typeof useUserGoalTemplatesQuery>;
export type UserGoalTemplatesLazyQueryHookResult = ReturnType<typeof useUserGoalTemplatesLazyQuery>;
export type UserGoalTemplatesSuspenseQueryHookResult = ReturnType<typeof useUserGoalTemplatesSuspenseQuery>;
export type UserGoalTemplatesQueryResult = Apollo.QueryResult<UserGoalTemplatesQuery, UserGoalTemplatesQueryVariables>;
export const UserGroupsDocument = gql`
    query UserGroups($id: ID!) {
  user(id: $id) {
    id
    groups {
      id
      name
      type
      parent {
        id
      }
      isArchived
    }
  }
}
    `;

/**
 * __useUserGroupsQuery__
 *
 * To run a query within a React component, call `useUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserGroupsQuery(baseOptions: Apollo.QueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables> & ({ variables: UserGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, options);
      }
export function useUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, options);
        }
// @ts-ignore
export function useUserGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<UserGroupsQuery, UserGroupsQueryVariables>;
export function useUserGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<UserGroupsQuery | undefined, UserGroupsQueryVariables>;
export function useUserGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserGroupsQuery, UserGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserGroupsQuery, UserGroupsQueryVariables>(UserGroupsDocument, options);
        }
export type UserGroupsQueryHookResult = ReturnType<typeof useUserGroupsQuery>;
export type UserGroupsLazyQueryHookResult = ReturnType<typeof useUserGroupsLazyQuery>;
export type UserGroupsSuspenseQueryHookResult = ReturnType<typeof useUserGroupsSuspenseQuery>;
export type UserGroupsQueryResult = Apollo.QueryResult<UserGroupsQuery, UserGroupsQueryVariables>;
export const UserManagersManageesDocument = gql`
    query UserManagersManagees($id: ID!) {
  user(id: $id) {
    id
    firstName
    lastName
    avatar {
      id
      source {
        url
      }
    }
    currentJobPosition {
      id
      jobTitle {
        id
        title
      }
    }
    individualManagers {
      id
      role {
        id
        type
      }
      externalReferenceID
      source {
        id
        firstName
        lastName
      }
    }
    group {
      id
      managers(first: 1000) {
        edges {
          role {
            id
            type
            externalReferenceID
          }
          node {
            id
            firstName
            lastName
          }
        }
      }
    }
    roles {
      id
      role {
        id
        type
      }
      externalReferenceID
      targetV2 {
        ... on Group {
          id
          name
          type
        }
        ... on User {
          id
          firstName
          lastName
        }
      }
      isIndirect
    }
  }
}
    `;

/**
 * __useUserManagersManageesQuery__
 *
 * To run a query within a React component, call `useUserManagersManageesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserManagersManageesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserManagersManageesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserManagersManageesQuery(baseOptions: Apollo.QueryHookOptions<UserManagersManageesQuery, UserManagersManageesQueryVariables> & ({ variables: UserManagersManageesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserManagersManageesQuery, UserManagersManageesQueryVariables>(UserManagersManageesDocument, options);
      }
export function useUserManagersManageesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserManagersManageesQuery, UserManagersManageesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserManagersManageesQuery, UserManagersManageesQueryVariables>(UserManagersManageesDocument, options);
        }
// @ts-ignore
export function useUserManagersManageesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserManagersManageesQuery, UserManagersManageesQueryVariables>): Apollo.UseSuspenseQueryResult<UserManagersManageesQuery, UserManagersManageesQueryVariables>;
export function useUserManagersManageesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserManagersManageesQuery, UserManagersManageesQueryVariables>): Apollo.UseSuspenseQueryResult<UserManagersManageesQuery | undefined, UserManagersManageesQueryVariables>;
export function useUserManagersManageesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserManagersManageesQuery, UserManagersManageesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserManagersManageesQuery, UserManagersManageesQueryVariables>(UserManagersManageesDocument, options);
        }
export type UserManagersManageesQueryHookResult = ReturnType<typeof useUserManagersManageesQuery>;
export type UserManagersManageesLazyQueryHookResult = ReturnType<typeof useUserManagersManageesLazyQuery>;
export type UserManagersManageesSuspenseQueryHookResult = ReturnType<typeof useUserManagersManageesSuspenseQuery>;
export type UserManagersManageesQueryResult = Apollo.QueryResult<UserManagersManageesQuery, UserManagersManageesQueryVariables>;
export const UserMfaConfigurationDocument = gql`
    query UserMfaConfiguration {
  viewer {
    ...UserMfaConfiguration
  }
}
    ${UserMfaConfigurationFragmentDoc}`;

/**
 * __useUserMfaConfigurationQuery__
 *
 * To run a query within a React component, call `useUserMfaConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMfaConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMfaConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserMfaConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<UserMfaConfigurationQuery, UserMfaConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserMfaConfigurationQuery, UserMfaConfigurationQueryVariables>(UserMfaConfigurationDocument, options);
      }
export function useUserMfaConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserMfaConfigurationQuery, UserMfaConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserMfaConfigurationQuery, UserMfaConfigurationQueryVariables>(UserMfaConfigurationDocument, options);
        }
// @ts-ignore
export function useUserMfaConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserMfaConfigurationQuery, UserMfaConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<UserMfaConfigurationQuery, UserMfaConfigurationQueryVariables>;
export function useUserMfaConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserMfaConfigurationQuery, UserMfaConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<UserMfaConfigurationQuery | undefined, UserMfaConfigurationQueryVariables>;
export function useUserMfaConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserMfaConfigurationQuery, UserMfaConfigurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserMfaConfigurationQuery, UserMfaConfigurationQueryVariables>(UserMfaConfigurationDocument, options);
        }
export type UserMfaConfigurationQueryHookResult = ReturnType<typeof useUserMfaConfigurationQuery>;
export type UserMfaConfigurationLazyQueryHookResult = ReturnType<typeof useUserMfaConfigurationLazyQuery>;
export type UserMfaConfigurationSuspenseQueryHookResult = ReturnType<typeof useUserMfaConfigurationSuspenseQuery>;
export type UserMfaConfigurationQueryResult = Apollo.QueryResult<UserMfaConfigurationQuery, UserMfaConfigurationQueryVariables>;
export const UserRolesDocument = gql`
    query UserRoles($first: Int, $last: Int, $before: ID, $after: ID) {
  userRoles(first: $first, last: $last, before: $before, after: $after) {
    edges {
      node {
        id
        role {
          id
          type
        }
        source {
          id
          firstName
          lastName
          avatar {
            id
            source {
              url
            }
          }
        }
        target {
          targetID
          type
        }
        targetV2 {
          ... on User {
            id
            firstName
            lastName
            avatar {
              id
              source {
                url
              }
            }
          }
          ... on Group {
            id
            name
          }
        }
        isIndirect
        externalReferenceID
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useUserRolesQuery__
 *
 * To run a query within a React component, call `useUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRolesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
      }
export function useUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
        }
// @ts-ignore
export function useUserRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserRolesQuery, UserRolesQueryVariables>): Apollo.UseSuspenseQueryResult<UserRolesQuery, UserRolesQueryVariables>;
export function useUserRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserRolesQuery, UserRolesQueryVariables>): Apollo.UseSuspenseQueryResult<UserRolesQuery | undefined, UserRolesQueryVariables>;
export function useUserRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
        }
export type UserRolesQueryHookResult = ReturnType<typeof useUserRolesQuery>;
export type UserRolesLazyQueryHookResult = ReturnType<typeof useUserRolesLazyQuery>;
export type UserRolesSuspenseQueryHookResult = ReturnType<typeof useUserRolesSuspenseQuery>;
export type UserRolesQueryResult = Apollo.QueryResult<UserRolesQuery, UserRolesQueryVariables>;
export const UserWithCyclesDocument = gql`
    query UserWithCycles($id: ID!, $status: [CycleStatus!]) {
  user(id: $id) {
    id
    cycles(status: $status) {
      edges {
        node {
          id
          startDate
          activatesAt
          deactivatesAt
          cycleTemplate {
            id
            title
            repeats
            duration
            successor {
              id
            }
            moments {
              id
              title
              startOffset
              type
              duration
              showToUser
            }
          }
          precededBy {
            id
          }
          succeededBy {
            id
          }
          skippedFutureMoments {
            momentTemplateID
            skipReason
            skipReasonOther
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUserWithCyclesQuery__
 *
 * To run a query within a React component, call `useUserWithCyclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserWithCyclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserWithCyclesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUserWithCyclesQuery(baseOptions: Apollo.QueryHookOptions<UserWithCyclesQuery, UserWithCyclesQueryVariables> & ({ variables: UserWithCyclesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserWithCyclesQuery, UserWithCyclesQueryVariables>(UserWithCyclesDocument, options);
      }
export function useUserWithCyclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserWithCyclesQuery, UserWithCyclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserWithCyclesQuery, UserWithCyclesQueryVariables>(UserWithCyclesDocument, options);
        }
// @ts-ignore
export function useUserWithCyclesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserWithCyclesQuery, UserWithCyclesQueryVariables>): Apollo.UseSuspenseQueryResult<UserWithCyclesQuery, UserWithCyclesQueryVariables>;
export function useUserWithCyclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserWithCyclesQuery, UserWithCyclesQueryVariables>): Apollo.UseSuspenseQueryResult<UserWithCyclesQuery | undefined, UserWithCyclesQueryVariables>;
export function useUserWithCyclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserWithCyclesQuery, UserWithCyclesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserWithCyclesQuery, UserWithCyclesQueryVariables>(UserWithCyclesDocument, options);
        }
export type UserWithCyclesQueryHookResult = ReturnType<typeof useUserWithCyclesQuery>;
export type UserWithCyclesLazyQueryHookResult = ReturnType<typeof useUserWithCyclesLazyQuery>;
export type UserWithCyclesSuspenseQueryHookResult = ReturnType<typeof useUserWithCyclesSuspenseQuery>;
export type UserWithCyclesQueryResult = Apollo.QueryResult<UserWithCyclesQuery, UserWithCyclesQueryVariables>;
export const UserWithMomentsDocument = gql`
    query UserWithMoments($id: ID!, $after: DateTime, $before: DateTime) {
  user(id: $id) {
    id
    moments(after: $after, before: $before) {
      id
      user {
        id
      }
      status
      startDate
      endDate
      skipReason
      skipReasonOther
      cycleInstance {
        id
      }
      cycleTemplate {
        id
        title
      }
      momentTemplate {
        id
        title
        description
        type
        duration
        original {
          id
        }
        showToUser
        talentReview {
          template {
            id
          }
          group {
            id
          }
        }
      }
      evaluation {
        id
        viewer {
          status
          requiresSignature
        }
      }
    }
  }
}
    `;

/**
 * __useUserWithMomentsQuery__
 *
 * To run a query within a React component, call `useUserWithMomentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserWithMomentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserWithMomentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useUserWithMomentsQuery(baseOptions: Apollo.QueryHookOptions<UserWithMomentsQuery, UserWithMomentsQueryVariables> & ({ variables: UserWithMomentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserWithMomentsQuery, UserWithMomentsQueryVariables>(UserWithMomentsDocument, options);
      }
export function useUserWithMomentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserWithMomentsQuery, UserWithMomentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserWithMomentsQuery, UserWithMomentsQueryVariables>(UserWithMomentsDocument, options);
        }
// @ts-ignore
export function useUserWithMomentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserWithMomentsQuery, UserWithMomentsQueryVariables>): Apollo.UseSuspenseQueryResult<UserWithMomentsQuery, UserWithMomentsQueryVariables>;
export function useUserWithMomentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserWithMomentsQuery, UserWithMomentsQueryVariables>): Apollo.UseSuspenseQueryResult<UserWithMomentsQuery | undefined, UserWithMomentsQueryVariables>;
export function useUserWithMomentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserWithMomentsQuery, UserWithMomentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserWithMomentsQuery, UserWithMomentsQueryVariables>(UserWithMomentsDocument, options);
        }
export type UserWithMomentsQueryHookResult = ReturnType<typeof useUserWithMomentsQuery>;
export type UserWithMomentsLazyQueryHookResult = ReturnType<typeof useUserWithMomentsLazyQuery>;
export type UserWithMomentsSuspenseQueryHookResult = ReturnType<typeof useUserWithMomentsSuspenseQuery>;
export type UserWithMomentsQueryResult = Apollo.QueryResult<UserWithMomentsQuery, UserWithMomentsQueryVariables>;
export const UserWithRolesDocument = gql`
    query UserWithRoles($id: ID!) {
  user(id: $id) {
    id
    roles {
      id
      role {
        id
        type
      }
      target {
        type
        targetID
      }
      targetV2 {
        ... on User {
          id
          firstName
          lastName
        }
        ... on Group {
          id
          name
        }
      }
      isIndirect
    }
  }
}
    `;

/**
 * __useUserWithRolesQuery__
 *
 * To run a query within a React component, call `useUserWithRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserWithRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserWithRolesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserWithRolesQuery(baseOptions: Apollo.QueryHookOptions<UserWithRolesQuery, UserWithRolesQueryVariables> & ({ variables: UserWithRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserWithRolesQuery, UserWithRolesQueryVariables>(UserWithRolesDocument, options);
      }
export function useUserWithRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserWithRolesQuery, UserWithRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserWithRolesQuery, UserWithRolesQueryVariables>(UserWithRolesDocument, options);
        }
// @ts-ignore
export function useUserWithRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserWithRolesQuery, UserWithRolesQueryVariables>): Apollo.UseSuspenseQueryResult<UserWithRolesQuery, UserWithRolesQueryVariables>;
export function useUserWithRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserWithRolesQuery, UserWithRolesQueryVariables>): Apollo.UseSuspenseQueryResult<UserWithRolesQuery | undefined, UserWithRolesQueryVariables>;
export function useUserWithRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserWithRolesQuery, UserWithRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserWithRolesQuery, UserWithRolesQueryVariables>(UserWithRolesDocument, options);
        }
export type UserWithRolesQueryHookResult = ReturnType<typeof useUserWithRolesQuery>;
export type UserWithRolesLazyQueryHookResult = ReturnType<typeof useUserWithRolesLazyQuery>;
export type UserWithRolesSuspenseQueryHookResult = ReturnType<typeof useUserWithRolesSuspenseQuery>;
export type UserWithRolesQueryResult = Apollo.QueryResult<UserWithRolesQuery, UserWithRolesQueryVariables>;
export const UserWithSentEmailsDocument = gql`
    query UserWithSentEmails($id: ID!, $last: Int, $before: ID) {
  user(id: $id) {
    id
    sentEmails(last: $last, before: $before) {
      edges {
        node {
          id
          recipientName
          recipientEmail
          subject
          sentAt
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
    `;

/**
 * __useUserWithSentEmailsQuery__
 *
 * To run a query within a React component, call `useUserWithSentEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserWithSentEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserWithSentEmailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useUserWithSentEmailsQuery(baseOptions: Apollo.QueryHookOptions<UserWithSentEmailsQuery, UserWithSentEmailsQueryVariables> & ({ variables: UserWithSentEmailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserWithSentEmailsQuery, UserWithSentEmailsQueryVariables>(UserWithSentEmailsDocument, options);
      }
export function useUserWithSentEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserWithSentEmailsQuery, UserWithSentEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserWithSentEmailsQuery, UserWithSentEmailsQueryVariables>(UserWithSentEmailsDocument, options);
        }
// @ts-ignore
export function useUserWithSentEmailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserWithSentEmailsQuery, UserWithSentEmailsQueryVariables>): Apollo.UseSuspenseQueryResult<UserWithSentEmailsQuery, UserWithSentEmailsQueryVariables>;
export function useUserWithSentEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserWithSentEmailsQuery, UserWithSentEmailsQueryVariables>): Apollo.UseSuspenseQueryResult<UserWithSentEmailsQuery | undefined, UserWithSentEmailsQueryVariables>;
export function useUserWithSentEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserWithSentEmailsQuery, UserWithSentEmailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserWithSentEmailsQuery, UserWithSentEmailsQueryVariables>(UserWithSentEmailsDocument, options);
        }
export type UserWithSentEmailsQueryHookResult = ReturnType<typeof useUserWithSentEmailsQuery>;
export type UserWithSentEmailsLazyQueryHookResult = ReturnType<typeof useUserWithSentEmailsLazyQuery>;
export type UserWithSentEmailsSuspenseQueryHookResult = ReturnType<typeof useUserWithSentEmailsSuspenseQuery>;
export type UserWithSentEmailsQueryResult = Apollo.QueryResult<UserWithSentEmailsQuery, UserWithSentEmailsQueryVariables>;
export const ViewerRolesDocument = gql`
    query ViewerRoles {
  viewer {
    id
    roles {
      target {
        targetID
        type
      }
      targetV2 {
        ... on User {
          id
        }
        ... on Group {
          id
          type
        }
      }
      role {
        id
        type
      }
    }
  }
}
    `;

/**
 * __useViewerRolesQuery__
 *
 * To run a query within a React component, call `useViewerRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerRolesQuery(baseOptions?: Apollo.QueryHookOptions<ViewerRolesQuery, ViewerRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerRolesQuery, ViewerRolesQueryVariables>(ViewerRolesDocument, options);
      }
export function useViewerRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerRolesQuery, ViewerRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerRolesQuery, ViewerRolesQueryVariables>(ViewerRolesDocument, options);
        }
// @ts-ignore
export function useViewerRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerRolesQuery, ViewerRolesQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerRolesQuery, ViewerRolesQueryVariables>;
export function useViewerRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerRolesQuery, ViewerRolesQueryVariables>): Apollo.UseSuspenseQueryResult<ViewerRolesQuery | undefined, ViewerRolesQueryVariables>;
export function useViewerRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewerRolesQuery, ViewerRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewerRolesQuery, ViewerRolesQueryVariables>(ViewerRolesDocument, options);
        }
export type ViewerRolesQueryHookResult = ReturnType<typeof useViewerRolesQuery>;
export type ViewerRolesLazyQueryHookResult = ReturnType<typeof useViewerRolesLazyQuery>;
export type ViewerRolesSuspenseQueryHookResult = ReturnType<typeof useViewerRolesSuspenseQuery>;
export type ViewerRolesQueryResult = Apollo.QueryResult<ViewerRolesQuery, ViewerRolesQueryVariables>;
export const WorkspaceUserCountDocument = gql`
    query WorkspaceUserCount {
  workspaceUserCount
}
    `;

/**
 * __useWorkspaceUserCountQuery__
 *
 * To run a query within a React component, call `useWorkspaceUserCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceUserCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceUserCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceUserCountQuery(baseOptions?: Apollo.QueryHookOptions<WorkspaceUserCountQuery, WorkspaceUserCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceUserCountQuery, WorkspaceUserCountQueryVariables>(WorkspaceUserCountDocument, options);
      }
export function useWorkspaceUserCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceUserCountQuery, WorkspaceUserCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceUserCountQuery, WorkspaceUserCountQueryVariables>(WorkspaceUserCountDocument, options);
        }
// @ts-ignore
export function useWorkspaceUserCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceUserCountQuery, WorkspaceUserCountQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceUserCountQuery, WorkspaceUserCountQueryVariables>;
export function useWorkspaceUserCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceUserCountQuery, WorkspaceUserCountQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceUserCountQuery | undefined, WorkspaceUserCountQueryVariables>;
export function useWorkspaceUserCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceUserCountQuery, WorkspaceUserCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceUserCountQuery, WorkspaceUserCountQueryVariables>(WorkspaceUserCountDocument, options);
        }
export type WorkspaceUserCountQueryHookResult = ReturnType<typeof useWorkspaceUserCountQuery>;
export type WorkspaceUserCountLazyQueryHookResult = ReturnType<typeof useWorkspaceUserCountLazyQuery>;
export type WorkspaceUserCountSuspenseQueryHookResult = ReturnType<typeof useWorkspaceUserCountSuspenseQuery>;
export type WorkspaceUserCountQueryResult = Apollo.QueryResult<WorkspaceUserCountQuery, WorkspaceUserCountQueryVariables>;
export const CompleteWorkspaceCheckpointDocument = gql`
    mutation CompleteWorkspaceCheckpoint($input: CompleteWorkspaceCheckpointInput!) {
  completeWorkspaceCheckpoint(input: $input) {
    workspace {
      id
      checkpoints {
        id
        key
        completedAt
      }
    }
  }
}
    `;
export type CompleteWorkspaceCheckpointMutationFn = Apollo.MutationFunction<CompleteWorkspaceCheckpointMutation, CompleteWorkspaceCheckpointMutationVariables>;

/**
 * __useCompleteWorkspaceCheckpointMutation__
 *
 * To run a mutation, you first call `useCompleteWorkspaceCheckpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteWorkspaceCheckpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeWorkspaceCheckpointMutation, { data, loading, error }] = useCompleteWorkspaceCheckpointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteWorkspaceCheckpointMutation(baseOptions?: Apollo.MutationHookOptions<CompleteWorkspaceCheckpointMutation, CompleteWorkspaceCheckpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteWorkspaceCheckpointMutation, CompleteWorkspaceCheckpointMutationVariables>(CompleteWorkspaceCheckpointDocument, options);
      }
export type CompleteWorkspaceCheckpointMutationHookResult = ReturnType<typeof useCompleteWorkspaceCheckpointMutation>;
export type CompleteWorkspaceCheckpointMutationResult = Apollo.MutationResult<CompleteWorkspaceCheckpointMutation>;
export type CompleteWorkspaceCheckpointMutationOptions = Apollo.BaseMutationOptions<CompleteWorkspaceCheckpointMutation, CompleteWorkspaceCheckpointMutationVariables>;
export const FeaturesDocument = gql`
    query Features($id: ID!) {
  workspace(id: $id) {
    id
    displayName
    features {
      id
      feature {
        id
        stability
      }
      status
      inPlan
      needsViewerApproval
      requiredConditions {
        currentVersion
        linkToConditions
      }
    }
  }
}
    `;

/**
 * __useFeaturesQuery__
 *
 * To run a query within a React component, call `useFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeaturesQuery(baseOptions: Apollo.QueryHookOptions<FeaturesQuery, FeaturesQueryVariables> & ({ variables: FeaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturesQuery, FeaturesQueryVariables>(FeaturesDocument, options);
      }
export function useFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturesQuery, FeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturesQuery, FeaturesQueryVariables>(FeaturesDocument, options);
        }
// @ts-ignore
export function useFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FeaturesQuery, FeaturesQueryVariables>): Apollo.UseSuspenseQueryResult<FeaturesQuery, FeaturesQueryVariables>;
export function useFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeaturesQuery, FeaturesQueryVariables>): Apollo.UseSuspenseQueryResult<FeaturesQuery | undefined, FeaturesQueryVariables>;
export function useFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeaturesQuery, FeaturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeaturesQuery, FeaturesQueryVariables>(FeaturesDocument, options);
        }
export type FeaturesQueryHookResult = ReturnType<typeof useFeaturesQuery>;
export type FeaturesLazyQueryHookResult = ReturnType<typeof useFeaturesLazyQuery>;
export type FeaturesSuspenseQueryHookResult = ReturnType<typeof useFeaturesSuspenseQuery>;
export type FeaturesQueryResult = Apollo.QueryResult<FeaturesQuery, FeaturesQueryVariables>;
export const SupportedLanguageIDsDocument = gql`
    query SupportedLanguageIDs {
  viewer {
    workspace {
      supportedLanguageIDs
    }
  }
}
    `;

/**
 * __useSupportedLanguageIDsQuery__
 *
 * To run a query within a React component, call `useSupportedLanguageIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportedLanguageIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportedLanguageIDsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupportedLanguageIDsQuery(baseOptions?: Apollo.QueryHookOptions<SupportedLanguageIDsQuery, SupportedLanguageIDsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportedLanguageIDsQuery, SupportedLanguageIDsQueryVariables>(SupportedLanguageIDsDocument, options);
      }
export function useSupportedLanguageIDsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportedLanguageIDsQuery, SupportedLanguageIDsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportedLanguageIDsQuery, SupportedLanguageIDsQueryVariables>(SupportedLanguageIDsDocument, options);
        }
// @ts-ignore
export function useSupportedLanguageIDsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupportedLanguageIDsQuery, SupportedLanguageIDsQueryVariables>): Apollo.UseSuspenseQueryResult<SupportedLanguageIDsQuery, SupportedLanguageIDsQueryVariables>;
export function useSupportedLanguageIDsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupportedLanguageIDsQuery, SupportedLanguageIDsQueryVariables>): Apollo.UseSuspenseQueryResult<SupportedLanguageIDsQuery | undefined, SupportedLanguageIDsQueryVariables>;
export function useSupportedLanguageIDsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupportedLanguageIDsQuery, SupportedLanguageIDsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupportedLanguageIDsQuery, SupportedLanguageIDsQueryVariables>(SupportedLanguageIDsDocument, options);
        }
export type SupportedLanguageIDsQueryHookResult = ReturnType<typeof useSupportedLanguageIDsQuery>;
export type SupportedLanguageIDsLazyQueryHookResult = ReturnType<typeof useSupportedLanguageIDsLazyQuery>;
export type SupportedLanguageIDsSuspenseQueryHookResult = ReturnType<typeof useSupportedLanguageIDsSuspenseQuery>;
export type SupportedLanguageIDsQueryResult = Apollo.QueryResult<SupportedLanguageIDsQuery, SupportedLanguageIDsQueryVariables>;
export const SupportedLanguagesDocument = gql`
    query SupportedLanguages($id: ID!) {
  workspace(id: $id) {
    id
    supportedLanguageIDs
  }
}
    `;

/**
 * __useSupportedLanguagesQuery__
 *
 * To run a query within a React component, call `useSupportedLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportedLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportedLanguagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSupportedLanguagesQuery(baseOptions: Apollo.QueryHookOptions<SupportedLanguagesQuery, SupportedLanguagesQueryVariables> & ({ variables: SupportedLanguagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>(SupportedLanguagesDocument, options);
      }
export function useSupportedLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>(SupportedLanguagesDocument, options);
        }
// @ts-ignore
export function useSupportedLanguagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>): Apollo.UseSuspenseQueryResult<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>;
export function useSupportedLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>): Apollo.UseSuspenseQueryResult<SupportedLanguagesQuery | undefined, SupportedLanguagesQueryVariables>;
export function useSupportedLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>(SupportedLanguagesDocument, options);
        }
export type SupportedLanguagesQueryHookResult = ReturnType<typeof useSupportedLanguagesQuery>;
export type SupportedLanguagesLazyQueryHookResult = ReturnType<typeof useSupportedLanguagesLazyQuery>;
export type SupportedLanguagesSuspenseQueryHookResult = ReturnType<typeof useSupportedLanguagesSuspenseQuery>;
export type SupportedLanguagesQueryResult = Apollo.QueryResult<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>;
export const WorkspaceConfigurationDocument = gql`
    query WorkspaceConfiguration($id: ID!) {
  workspace(id: $id) {
    id
    redirect
    startDate
    supportedLanguageIDs
    plans {
      ...WorkspacePlan
    }
  }
  singleSignOns {
    url
  }
}
    ${WorkspacePlanFragmentDoc}`;

/**
 * __useWorkspaceConfigurationQuery__
 *
 * To run a query within a React component, call `useWorkspaceConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceConfigurationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkspaceConfigurationQuery(baseOptions: Apollo.QueryHookOptions<WorkspaceConfigurationQuery, WorkspaceConfigurationQueryVariables> & ({ variables: WorkspaceConfigurationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceConfigurationQuery, WorkspaceConfigurationQueryVariables>(WorkspaceConfigurationDocument, options);
      }
export function useWorkspaceConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceConfigurationQuery, WorkspaceConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceConfigurationQuery, WorkspaceConfigurationQueryVariables>(WorkspaceConfigurationDocument, options);
        }
// @ts-ignore
export function useWorkspaceConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkspaceConfigurationQuery, WorkspaceConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceConfigurationQuery, WorkspaceConfigurationQueryVariables>;
export function useWorkspaceConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceConfigurationQuery, WorkspaceConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<WorkspaceConfigurationQuery | undefined, WorkspaceConfigurationQueryVariables>;
export function useWorkspaceConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkspaceConfigurationQuery, WorkspaceConfigurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkspaceConfigurationQuery, WorkspaceConfigurationQueryVariables>(WorkspaceConfigurationDocument, options);
        }
export type WorkspaceConfigurationQueryHookResult = ReturnType<typeof useWorkspaceConfigurationQuery>;
export type WorkspaceConfigurationLazyQueryHookResult = ReturnType<typeof useWorkspaceConfigurationLazyQuery>;
export type WorkspaceConfigurationSuspenseQueryHookResult = ReturnType<typeof useWorkspaceConfigurationSuspenseQuery>;
export type WorkspaceConfigurationQueryResult = Apollo.QueryResult<WorkspaceConfigurationQuery, WorkspaceConfigurationQueryVariables>;
export const NoteTemplateCategoriesDocument = gql`
    query NoteTemplateCategories {
  noteTemplateCategories {
    ...NoteTemplateCategoryPartial
  }
}
    ${NoteTemplateCategoryPartialFragmentDoc}`;

/**
 * __useNoteTemplateCategoriesQuery__
 *
 * To run a query within a React component, call `useNoteTemplateCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoteTemplateCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoteTemplateCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useNoteTemplateCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<NoteTemplateCategoriesQuery, NoteTemplateCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoteTemplateCategoriesQuery, NoteTemplateCategoriesQueryVariables>(NoteTemplateCategoriesDocument, options);
      }
export function useNoteTemplateCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoteTemplateCategoriesQuery, NoteTemplateCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoteTemplateCategoriesQuery, NoteTemplateCategoriesQueryVariables>(NoteTemplateCategoriesDocument, options);
        }
// @ts-ignore
export function useNoteTemplateCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NoteTemplateCategoriesQuery, NoteTemplateCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<NoteTemplateCategoriesQuery, NoteTemplateCategoriesQueryVariables>;
export function useNoteTemplateCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NoteTemplateCategoriesQuery, NoteTemplateCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<NoteTemplateCategoriesQuery | undefined, NoteTemplateCategoriesQueryVariables>;
export function useNoteTemplateCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NoteTemplateCategoriesQuery, NoteTemplateCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NoteTemplateCategoriesQuery, NoteTemplateCategoriesQueryVariables>(NoteTemplateCategoriesDocument, options);
        }
export type NoteTemplateCategoriesQueryHookResult = ReturnType<typeof useNoteTemplateCategoriesQuery>;
export type NoteTemplateCategoriesLazyQueryHookResult = ReturnType<typeof useNoteTemplateCategoriesLazyQuery>;
export type NoteTemplateCategoriesSuspenseQueryHookResult = ReturnType<typeof useNoteTemplateCategoriesSuspenseQuery>;
export type NoteTemplateCategoriesQueryResult = Apollo.QueryResult<NoteTemplateCategoriesQuery, NoteTemplateCategoriesQueryVariables>;
export const CreateNoteTemplateCategoryDocument = gql`
    mutation CreateNoteTemplateCategory($input: NoteTemplateCategoryCreateInput!) {
  createNoteTemplateCategory(input: $input) {
    ...NoteTemplateCategoryPartial
  }
}
    ${NoteTemplateCategoryPartialFragmentDoc}`;
export type CreateNoteTemplateCategoryMutationFn = Apollo.MutationFunction<CreateNoteTemplateCategoryMutation, CreateNoteTemplateCategoryMutationVariables>;

/**
 * __useCreateNoteTemplateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateNoteTemplateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteTemplateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteTemplateCategoryMutation, { data, loading, error }] = useCreateNoteTemplateCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteTemplateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteTemplateCategoryMutation, CreateNoteTemplateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteTemplateCategoryMutation, CreateNoteTemplateCategoryMutationVariables>(CreateNoteTemplateCategoryDocument, options);
      }
export type CreateNoteTemplateCategoryMutationHookResult = ReturnType<typeof useCreateNoteTemplateCategoryMutation>;
export type CreateNoteTemplateCategoryMutationResult = Apollo.MutationResult<CreateNoteTemplateCategoryMutation>;
export type CreateNoteTemplateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateNoteTemplateCategoryMutation, CreateNoteTemplateCategoryMutationVariables>;
export const ArchiveNoteTemplateCategoryDocument = gql`
    mutation ArchiveNoteTemplateCategory($input: NoteTemplateCategoryArchiveInput!) {
  archiveNoteTemplateCategory(input: $input) {
    id
  }
}
    `;
export type ArchiveNoteTemplateCategoryMutationFn = Apollo.MutationFunction<ArchiveNoteTemplateCategoryMutation, ArchiveNoteTemplateCategoryMutationVariables>;

/**
 * __useArchiveNoteTemplateCategoryMutation__
 *
 * To run a mutation, you first call `useArchiveNoteTemplateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveNoteTemplateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveNoteTemplateCategoryMutation, { data, loading, error }] = useArchiveNoteTemplateCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveNoteTemplateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveNoteTemplateCategoryMutation, ArchiveNoteTemplateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveNoteTemplateCategoryMutation, ArchiveNoteTemplateCategoryMutationVariables>(ArchiveNoteTemplateCategoryDocument, options);
      }
export type ArchiveNoteTemplateCategoryMutationHookResult = ReturnType<typeof useArchiveNoteTemplateCategoryMutation>;
export type ArchiveNoteTemplateCategoryMutationResult = Apollo.MutationResult<ArchiveNoteTemplateCategoryMutation>;
export type ArchiveNoteTemplateCategoryMutationOptions = Apollo.BaseMutationOptions<ArchiveNoteTemplateCategoryMutation, ArchiveNoteTemplateCategoryMutationVariables>;
export const RestoreNoteTemplateCategoryDocument = gql`
    mutation RestoreNoteTemplateCategory($input: NoteTemplateRestoreCategoryInput!) {
  restoreNoteTemplateCategory(input: $input) {
    ...NoteTemplateCategoryPartial
  }
}
    ${NoteTemplateCategoryPartialFragmentDoc}`;
export type RestoreNoteTemplateCategoryMutationFn = Apollo.MutationFunction<RestoreNoteTemplateCategoryMutation, RestoreNoteTemplateCategoryMutationVariables>;

/**
 * __useRestoreNoteTemplateCategoryMutation__
 *
 * To run a mutation, you first call `useRestoreNoteTemplateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreNoteTemplateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreNoteTemplateCategoryMutation, { data, loading, error }] = useRestoreNoteTemplateCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreNoteTemplateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<RestoreNoteTemplateCategoryMutation, RestoreNoteTemplateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreNoteTemplateCategoryMutation, RestoreNoteTemplateCategoryMutationVariables>(RestoreNoteTemplateCategoryDocument, options);
      }
export type RestoreNoteTemplateCategoryMutationHookResult = ReturnType<typeof useRestoreNoteTemplateCategoryMutation>;
export type RestoreNoteTemplateCategoryMutationResult = Apollo.MutationResult<RestoreNoteTemplateCategoryMutation>;
export type RestoreNoteTemplateCategoryMutationOptions = Apollo.BaseMutationOptions<RestoreNoteTemplateCategoryMutation, RestoreNoteTemplateCategoryMutationVariables>;